var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production;
function requireReactJsxRuntime_production() {
  if (hasRequiredReactJsxRuntime_production) return reactJsxRuntime_production;
  hasRequiredReactJsxRuntime_production = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
  function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
      maybeKey = {};
      for (var propName in config)
        "key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== config ? config : null,
      props: maybeKey
    };
  }
  reactJsxRuntime_production.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_production.jsx = jsxProd;
  reactJsxRuntime_production.jsxs = jsxProd;
  return reactJsxRuntime_production;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  {
    jsxRuntime.exports = requireReactJsxRuntime_production();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
var react = { exports: {} };
var react_production = {};
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReact_production;
function requireReact_production() {
  if (hasRequiredReact_production) return react_production;
  hasRequiredReact_production = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
  function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
  }
  var ReactNoopUpdateQueue = {
    isMounted: function() {
      return false;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, assign = Object.assign, emptyObject = {};
  function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
  }
  Component.prototype.isReactComponent = {};
  Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, partialState, callback, "setState");
  };
  Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
  };
  function ComponentDummy() {
  }
  ComponentDummy.prototype = Component.prototype;
  function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
  }
  var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
  pureComponentPrototype.constructor = PureComponent;
  assign(pureComponentPrototype, Component.prototype);
  pureComponentPrototype.isPureReactComponent = true;
  var isArrayImpl = Array.isArray, ReactSharedInternals = { H: null, A: null, T: null, S: null, V: null }, hasOwnProperty = Object.prototype.hasOwnProperty;
  function ReactElement(type, key, self2, source, owner, props) {
    self2 = props.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== self2 ? self2 : null,
      props
    };
  }
  function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(
      oldElement.type,
      newKey,
      void 0,
      void 0,
      void 0,
      oldElement.props
    );
  }
  function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
  }
  function escape(key) {
    var escaperLookup = { "=": "=0", ":": "=2" };
    return "$" + key.replace(/[=:]/g, function(match) {
      return escaperLookup[match];
    });
  }
  var userProvidedKeyEscapeRegex = /\/+/g;
  function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
  }
  function noop$1() {
  }
  function resolveThenable(thenable) {
    switch (thenable.status) {
      case "fulfilled":
        return thenable.value;
      case "rejected":
        throw thenable.reason;
      default:
        switch ("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(
          function(fulfilledValue) {
            "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
          },
          function(error) {
            "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
          }
        )), thenable.status) {
          case "fulfilled":
            return thenable.value;
          case "rejected":
            throw thenable.reason;
        }
    }
    throw thenable;
  }
  function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = false;
    if (null === children) invokeCallback = true;
    else
      switch (type) {
        case "bigint":
        case "string":
        case "number":
          invokeCallback = true;
          break;
        case "object":
          switch (children.$$typeof) {
            case REACT_ELEMENT_TYPE:
            case REACT_PORTAL_TYPE:
              invokeCallback = true;
              break;
            case REACT_LAZY_TYPE:
              return invokeCallback = children._init, mapIntoArray(
                invokeCallback(children._payload),
                array,
                escapedPrefix,
                nameSoFar,
                callback
              );
          }
      }
    if (invokeCallback)
      return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
      })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(
        callback,
        escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(
          userProvidedKeyEscapeRegex,
          "$&/"
        ) + "/") + invokeCallback
      )), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children))
      for (var i = 0; i < children.length; i++)
        nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(
          nameSoFar,
          array,
          escapedPrefix,
          type,
          callback
        );
    else if (i = getIteratorFn(children), "function" === typeof i)
      for (children = i.call(children), i = 0; !(nameSoFar = children.next()).done; )
        nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(
          nameSoFar,
          array,
          escapedPrefix,
          type,
          callback
        );
    else if ("object" === type) {
      if ("function" === typeof children.then)
        return mapIntoArray(
          resolveThenable(children),
          array,
          escapedPrefix,
          nameSoFar,
          callback
        );
      array = String(children);
      throw Error(
        "Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return invokeCallback;
  }
  function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
      return func.call(context, child, count++);
    });
    return result;
  }
  function lazyInitializer(payload) {
    if (-1 === payload._status) {
      var ctor = payload._result;
      ctor = ctor();
      ctor.then(
        function(moduleObject) {
          if (0 === payload._status || -1 === payload._status)
            payload._status = 1, payload._result = moduleObject;
        },
        function(error) {
          if (0 === payload._status || -1 === payload._status)
            payload._status = 2, payload._result = error;
        }
      );
      -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
  }
  var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
      var event = new window.ErrorEvent("error", {
        bubbles: true,
        cancelable: true,
        message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
        error
      });
      if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof process && "function" === typeof process.emit) {
      process.emit("uncaughtException", error);
      return;
    }
    console.error(error);
  };
  function noop() {
  }
  react_production.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
      mapChildren(
        children,
        function() {
          forEachFunc.apply(this, arguments);
        },
        forEachContext
      );
    },
    count: function(children) {
      var n = 0;
      mapChildren(children, function() {
        n++;
      });
      return n;
    },
    toArray: function(children) {
      return mapChildren(children, function(child) {
        return child;
      }) || [];
    },
    only: function(children) {
      if (!isValidElement(children))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return children;
    }
  };
  react_production.Component = Component;
  react_production.Fragment = REACT_FRAGMENT_TYPE;
  react_production.Profiler = REACT_PROFILER_TYPE;
  react_production.PureComponent = PureComponent;
  react_production.StrictMode = REACT_STRICT_MODE_TYPE;
  react_production.Suspense = REACT_SUSPENSE_TYPE;
  react_production.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
  react_production.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
      return ReactSharedInternals.H.useMemoCache(size);
    }
  };
  react_production.cache = function(fn) {
    return function() {
      return fn.apply(null, arguments);
    };
  };
  react_production.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element)
      throw Error(
        "The argument must be a React element, but you passed " + element + "."
      );
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config)
      for (propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)
        !hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
      for (var childArray = Array(propName), i = 0; i < propName; i++)
        childArray[i] = arguments[i + 2];
      props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
  };
  react_production.createContext = function(defaultValue) {
    defaultValue = {
      $$typeof: REACT_CONTEXT_TYPE,
      _currentValue: defaultValue,
      _currentValue2: defaultValue,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
      $$typeof: REACT_CONSUMER_TYPE,
      _context: defaultValue
    };
    return defaultValue;
  };
  react_production.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config)
      for (propName in void 0 !== config.key && (key = "" + config.key), config)
        hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
      for (var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)
        childArray[i] = arguments[i + 2];
      props.children = childArray;
    }
    if (type && type.defaultProps)
      for (propName in childrenLength = type.defaultProps, childrenLength)
        void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
  };
  react_production.createRef = function() {
    return { current: null };
  };
  react_production.forwardRef = function(render) {
    return { $$typeof: REACT_FORWARD_REF_TYPE, render };
  };
  react_production.isValidElement = isValidElement;
  react_production.lazy = function(ctor) {
    return {
      $$typeof: REACT_LAZY_TYPE,
      _payload: { _status: -1, _result: ctor },
      _init: lazyInitializer
    };
  };
  react_production.memo = function(type, compare) {
    return {
      $$typeof: REACT_MEMO_TYPE,
      type,
      compare: void 0 === compare ? null : compare
    };
  };
  react_production.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
      var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
      null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
      "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
      reportGlobalError(error);
    } finally {
      ReactSharedInternals.T = prevTransition;
    }
  };
  react_production.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
  };
  react_production.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
  };
  react_production.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
  };
  react_production.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
  };
  react_production.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
  };
  react_production.useDebugValue = function() {
  };
  react_production.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
  };
  react_production.useEffect = function(create, createDeps, update) {
    var dispatcher = ReactSharedInternals.H;
    if ("function" === typeof update)
      throw Error(
        "useEffect CRUD overload is not enabled in this build of React."
      );
    return dispatcher.useEffect(create, createDeps);
  };
  react_production.useId = function() {
    return ReactSharedInternals.H.useId();
  };
  react_production.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
  };
  react_production.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
  };
  react_production.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
  };
  react_production.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
  };
  react_production.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
  };
  react_production.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
  };
  react_production.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
  };
  react_production.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
  };
  react_production.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(
      subscribe,
      getSnapshot,
      getServerSnapshot
    );
  };
  react_production.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
  };
  react_production.version = "19.1.0";
  return react_production;
}
var hasRequiredReact;
function requireReact() {
  if (hasRequiredReact) return react.exports;
  hasRequiredReact = 1;
  {
    react.exports = requireReact_production();
  }
  return react.exports;
}
var reactExports = requireReact();
const React = /* @__PURE__ */ getDefaultExportFromCjs(reactExports);
var client = { exports: {} };
var reactDomClient_production = {};
var scheduler = { exports: {} };
var scheduler_production = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredScheduler_production;
function requireScheduler_production() {
  if (hasRequiredScheduler_production) return scheduler_production;
  hasRequiredScheduler_production = 1;
  (function(exports) {
    function push(heap, node) {
      var index = heap.length;
      heap.push(node);
      a: for (; 0 < index; ) {
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node))
          heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
      }
    }
    function peek(heap) {
      return 0 === heap.length ? null : heap[0];
    }
    function pop(heap) {
      if (0 === heap.length) return null;
      var first = heap[0], last = heap.pop();
      if (last !== first) {
        heap[0] = last;
        a: for (var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength; ) {
          var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
          if (0 > compare(left, last))
            rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
          else if (rightIndex < length && 0 > compare(right, last))
            heap[index] = right, heap[rightIndex] = last, index = rightIndex;
          else break a;
        }
      }
      return first;
    }
    function compare(a, b) {
      var diff = a.sortIndex - b.sortIndex;
      return 0 !== diff ? diff : a.id - b.id;
    }
    exports.unstable_now = void 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var localPerformance = performance;
      exports.unstable_now = function() {
        return localPerformance.now();
      };
    } else {
      var localDate = Date, initialTime = localDate.now();
      exports.unstable_now = function() {
        return localDate.now() - initialTime;
      };
    }
    var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = false, isHostCallbackScheduled = false, isHostTimeoutScheduled = false, needsPaint = false, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
    function advanceTimers(currentTime) {
      for (var timer = peek(timerQueue); null !== timer; ) {
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime)
          pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek(timerQueue);
      }
    }
    function handleTimeout(currentTime) {
      isHostTimeoutScheduled = false;
      advanceTimers(currentTime);
      if (!isHostCallbackScheduled)
        if (null !== peek(taskQueue))
          isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline());
        else {
          var firstTimer = peek(timerQueue);
          null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
    var isMessageLoopRunning = false, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
    function shouldYieldToHost() {
      return needsPaint ? true : exports.unstable_now() - startTime < frameInterval ? false : true;
    }
    function performWorkUntilDeadline() {
      needsPaint = false;
      if (isMessageLoopRunning) {
        var currentTime = exports.unstable_now();
        startTime = currentTime;
        var hasMoreWork = true;
        try {
          a: {
            isHostCallbackScheduled = false;
            isHostTimeoutScheduled && (isHostTimeoutScheduled = false, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
            isPerformingWork = true;
            var previousPriorityLevel = currentPriorityLevel;
            try {
              b: {
                advanceTimers(currentTime);
                for (currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost()); ) {
                  var callback = currentTask.callback;
                  if ("function" === typeof callback) {
                    currentTask.callback = null;
                    currentPriorityLevel = currentTask.priorityLevel;
                    var continuationCallback = callback(
                      currentTask.expirationTime <= currentTime
                    );
                    currentTime = exports.unstable_now();
                    if ("function" === typeof continuationCallback) {
                      currentTask.callback = continuationCallback;
                      advanceTimers(currentTime);
                      hasMoreWork = true;
                      break b;
                    }
                    currentTask === peek(taskQueue) && pop(taskQueue);
                    advanceTimers(currentTime);
                  } else pop(taskQueue);
                  currentTask = peek(taskQueue);
                }
                if (null !== currentTask) hasMoreWork = true;
                else {
                  var firstTimer = peek(timerQueue);
                  null !== firstTimer && requestHostTimeout(
                    handleTimeout,
                    firstTimer.startTime - currentTime
                  );
                  hasMoreWork = false;
                }
              }
              break a;
            } finally {
              currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = false;
            }
            hasMoreWork = void 0;
          }
        } finally {
          hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = false;
        }
      }
    }
    var schedulePerformWorkUntilDeadline;
    if ("function" === typeof localSetImmediate)
      schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
      };
    else if ("undefined" !== typeof MessageChannel) {
      var channel = new MessageChannel(), port = channel.port2;
      channel.port1.onmessage = performWorkUntilDeadline;
      schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
      };
    } else
      schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
      };
    function requestHostTimeout(callback, ms) {
      taskTimeoutID = localSetTimeout(function() {
        callback(exports.unstable_now());
      }, ms);
    }
    exports.unstable_IdlePriority = 5;
    exports.unstable_ImmediatePriority = 1;
    exports.unstable_LowPriority = 4;
    exports.unstable_NormalPriority = 3;
    exports.unstable_Profiling = null;
    exports.unstable_UserBlockingPriority = 2;
    exports.unstable_cancelCallback = function(task) {
      task.callback = null;
    };
    exports.unstable_forceFrameRate = function(fps) {
      0 > fps || 125 < fps ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
    };
    exports.unstable_getCurrentPriorityLevel = function() {
      return currentPriorityLevel;
    };
    exports.unstable_next = function(eventHandler) {
      switch (currentPriorityLevel) {
        case 1:
        case 2:
        case 3:
          var priorityLevel = 3;
          break;
        default:
          priorityLevel = currentPriorityLevel;
      }
      var previousPriorityLevel = currentPriorityLevel;
      currentPriorityLevel = priorityLevel;
      try {
        return eventHandler();
      } finally {
        currentPriorityLevel = previousPriorityLevel;
      }
    };
    exports.unstable_requestPaint = function() {
      needsPaint = true;
    };
    exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
      switch (priorityLevel) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          priorityLevel = 3;
      }
      var previousPriorityLevel = currentPriorityLevel;
      currentPriorityLevel = priorityLevel;
      try {
        return eventHandler();
      } finally {
        currentPriorityLevel = previousPriorityLevel;
      }
    };
    exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
      var currentTime = exports.unstable_now();
      "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
      switch (priorityLevel) {
        case 1:
          var timeout = -1;
          break;
        case 2:
          timeout = 250;
          break;
        case 5:
          timeout = 1073741823;
          break;
        case 4:
          timeout = 1e4;
          break;
        default:
          timeout = 5e3;
      }
      timeout = options + timeout;
      priorityLevel = {
        id: taskIdCounter++,
        callback,
        priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
      };
      options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = true, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline())));
      return priorityLevel;
    };
    exports.unstable_shouldYield = shouldYieldToHost;
    exports.unstable_wrapCallback = function(callback) {
      var parentPriorityLevel = currentPriorityLevel;
      return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
          return callback.apply(this, arguments);
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      };
    };
  })(scheduler_production);
  return scheduler_production;
}
var hasRequiredScheduler;
function requireScheduler() {
  if (hasRequiredScheduler) return scheduler.exports;
  hasRequiredScheduler = 1;
  {
    scheduler.exports = requireScheduler_production();
  }
  return scheduler.exports;
}
var reactDom = { exports: {} };
var reactDom_production = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDom_production;
function requireReactDom_production() {
  if (hasRequiredReactDom_production) return reactDom_production;
  hasRequiredReactDom_production = 1;
  var React2 = requireReact();
  function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
      url += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var i = 2; i < arguments.length; i++)
        url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function noop() {
  }
  var Internals = {
    d: {
      f: noop,
      r: function() {
        throw Error(formatProdErrorMessage(522));
      },
      D: noop,
      C: noop,
      L: noop,
      m: noop,
      X: noop,
      S: noop,
      M: noop
    },
    p: 0,
    findDOMNode: null
  }, REACT_PORTAL_TYPE = Symbol.for("react.portal");
  function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
      $$typeof: REACT_PORTAL_TYPE,
      key: null == key ? null : "" + key,
      children,
      containerInfo,
      implementation
    };
  }
  var ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input)
      return "use-credentials" === input ? input : "";
  }
  reactDom_production.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
  reactDom_production.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType)
      throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
  };
  reactDom_production.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
      if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally {
      ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
  };
  reactDom_production.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
  };
  reactDom_production.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
  };
  reactDom_production.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
      var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
      "style" === as ? Internals.d.S(
        href,
        "string" === typeof options.precedence ? options.precedence : void 0,
        {
          crossOrigin,
          integrity,
          fetchPriority
        }
      ) : "script" === as && Internals.d.X(href, {
        crossOrigin,
        integrity,
        fetchPriority,
        nonce: "string" === typeof options.nonce ? options.nonce : void 0
      });
    }
  };
  reactDom_production.preinitModule = function(href, options) {
    if ("string" === typeof href)
      if ("object" === typeof options && null !== options) {
        if (null == options.as || "script" === options.as) {
          var crossOrigin = getCrossOriginStringAs(
            options.as,
            options.crossOrigin
          );
          Internals.d.M(href, {
            crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
          });
        }
      } else null == options && Internals.d.M(href);
  };
  reactDom_production.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
      var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
      Internals.d.L(href, as, {
        crossOrigin,
        integrity: "string" === typeof options.integrity ? options.integrity : void 0,
        nonce: "string" === typeof options.nonce ? options.nonce : void 0,
        type: "string" === typeof options.type ? options.type : void 0,
        fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
        referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
        imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
        imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
        media: "string" === typeof options.media ? options.media : void 0
      });
    }
  };
  reactDom_production.preloadModule = function(href, options) {
    if ("string" === typeof href)
      if (options) {
        var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
        Internals.d.m(href, {
          as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
          crossOrigin,
          integrity: "string" === typeof options.integrity ? options.integrity : void 0
        });
      } else Internals.d.m(href);
  };
  reactDom_production.requestFormReset = function(form) {
    Internals.d.r(form);
  };
  reactDom_production.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
  };
  reactDom_production.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
  };
  reactDom_production.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
  };
  reactDom_production.version = "19.1.0";
  return reactDom_production;
}
var hasRequiredReactDom;
function requireReactDom() {
  if (hasRequiredReactDom) return reactDom.exports;
  hasRequiredReactDom = 1;
  function checkDCE() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
      return;
    }
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      console.error(err);
    }
  }
  {
    checkDCE();
    reactDom.exports = requireReactDom_production();
  }
  return reactDom.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDomClient_production;
function requireReactDomClient_production() {
  if (hasRequiredReactDomClient_production) return reactDomClient_production;
  hasRequiredReactDomClient_production = 1;
  var Scheduler = requireScheduler(), React2 = requireReact(), ReactDOM = requireReactDom();
  function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
      url += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var i = 2; i < arguments.length; i++)
        url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
  }
  function getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for (; node.return; ) node = node.return;
    else {
      fiber = node;
      do
        node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
      while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
  }
  function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
      var suspenseState = fiber.memoizedState;
      null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
      if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
  }
  function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber)
      throw Error(formatProdErrorMessage(188));
  }
  function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
      alternate = getNearestMountedFiber(fiber);
      if (null === alternate) throw Error(formatProdErrorMessage(188));
      return alternate !== fiber ? null : fiber;
    }
    for (var a = fiber, b = alternate; ; ) {
      var parentA = a.return;
      if (null === parentA) break;
      var parentB = parentA.alternate;
      if (null === parentB) {
        b = parentA.return;
        if (null !== b) {
          a = b;
          continue;
        }
        break;
      }
      if (parentA.child === parentB.child) {
        for (parentB = parentA.child; parentB; ) {
          if (parentB === a) return assertIsMounted(parentA), fiber;
          if (parentB === b) return assertIsMounted(parentA), alternate;
          parentB = parentB.sibling;
        }
        throw Error(formatProdErrorMessage(188));
      }
      if (a.return !== b.return) a = parentA, b = parentB;
      else {
        for (var didFindChild = false, child$0 = parentA.child; child$0; ) {
          if (child$0 === a) {
            didFindChild = true;
            a = parentA;
            b = parentB;
            break;
          }
          if (child$0 === b) {
            didFindChild = true;
            b = parentA;
            a = parentB;
            break;
          }
          child$0 = child$0.sibling;
        }
        if (!didFindChild) {
          for (child$0 = parentB.child; child$0; ) {
            if (child$0 === a) {
              didFindChild = true;
              a = parentB;
              b = parentA;
              break;
            }
            if (child$0 === b) {
              didFindChild = true;
              b = parentB;
              a = parentA;
              break;
            }
            child$0 = child$0.sibling;
          }
          if (!didFindChild) throw Error(formatProdErrorMessage(189));
        }
      }
      if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
  }
  function findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for (node = node.child; null !== node; ) {
      tag = findCurrentHostFiberImpl(node);
      if (null !== tag) return tag;
      node = node.sibling;
    }
    return null;
  }
  var assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
  var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
  var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
  var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
  function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
  }
  var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
  function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type)
      return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch (type) {
      case REACT_FRAGMENT_TYPE:
        return "Fragment";
      case REACT_PROFILER_TYPE:
        return "Profiler";
      case REACT_STRICT_MODE_TYPE:
        return "StrictMode";
      case REACT_SUSPENSE_TYPE:
        return "Suspense";
      case REACT_SUSPENSE_LIST_TYPE:
        return "SuspenseList";
      case REACT_ACTIVITY_TYPE:
        return "Activity";
    }
    if ("object" === typeof type)
      switch (type.$$typeof) {
        case REACT_PORTAL_TYPE:
          return "Portal";
        case REACT_CONTEXT_TYPE:
          return (type.displayName || "Context") + ".Provider";
        case REACT_CONSUMER_TYPE:
          return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
          var innerType = type.render;
          type = type.displayName;
          type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
          return type;
        case REACT_MEMO_TYPE:
          return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
          innerType = type._payload;
          type = type._init;
          try {
            return getComponentNameFromType(type(innerType));
          } catch (x) {
          }
      }
    return null;
  }
  var isArrayImpl = Array.isArray, ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: false,
    data: null,
    method: null,
    action: null
  }, valueStack = [], index = -1;
  function createCursor(defaultValue) {
    return { current: defaultValue };
  }
  function pop(cursor) {
    0 > index || (cursor.current = valueStack[index], valueStack[index] = null, index--);
  }
  function push(cursor, value) {
    index++;
    valueStack[index] = cursor.current;
    cursor.current = value;
  }
  var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
  function pushHostContainer(fiber, nextRootInstance) {
    push(rootInstanceStackCursor, nextRootInstance);
    push(contextFiberStackCursor, fiber);
    push(contextStackCursor, null);
    switch (nextRootInstance.nodeType) {
      case 9:
      case 11:
        fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
        break;
      default:
        if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI)
          nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
        else
          switch (fiber) {
            case "svg":
              fiber = 1;
              break;
            case "math":
              fiber = 2;
              break;
            default:
              fiber = 0;
          }
    }
    pop(contextStackCursor);
    push(contextStackCursor, fiber);
  }
  function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
  }
  function pushHostContext(fiber) {
    null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
    var context = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && (push(contextFiberStackCursor, fiber), push(contextStackCursor, JSCompiler_inline_result));
  }
  function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
  }
  var hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
  function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode)
      try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
      } catch (err) {
      }
  }
  var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
  function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
  }
  var nextTransitionLane = 256, nextRetryLane = 4194304;
  function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch (lanes & -lanes) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return lanes & 4194048;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return lanes & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return lanes;
    }
  }
  function getNextLanes(root2, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root2.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root2.suspendedLanes, pingedLanes = root2.pingedLanes;
    root2 = root2.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root2, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root2, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
  }
  function checkIfRootIsPrerendering(root2, renderLanes2) {
    return 0 === (root2.pendingLanes & ~(root2.suspendedLanes & ~root2.pingedLanes) & renderLanes2);
  }
  function computeExpirationTime(lane, currentTime) {
    switch (lane) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return currentTime + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return currentTime + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function claimNextTransitionLane() {
    var lane = nextTransitionLane;
    nextTransitionLane <<= 1;
    0 === (nextTransitionLane & 4194048) && (nextTransitionLane = 256);
    return lane;
  }
  function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
  }
  function createLaneMap(initial) {
    for (var laneMap = [], i = 0; 31 > i; i++) laneMap.push(initial);
    return laneMap;
  }
  function markRootUpdated$1(root2, updateLane) {
    root2.pendingLanes |= updateLane;
    268435456 !== updateLane && (root2.suspendedLanes = 0, root2.pingedLanes = 0, root2.warmLanes = 0);
  }
  function markRootFinished(root2, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root2.pendingLanes;
    root2.pendingLanes = remainingLanes;
    root2.suspendedLanes = 0;
    root2.pingedLanes = 0;
    root2.warmLanes = 0;
    root2.expiredLanes &= remainingLanes;
    root2.entangledLanes &= remainingLanes;
    root2.errorRecoveryDisabledLanes &= remainingLanes;
    root2.shellSuspendCounter = 0;
    var entanglements = root2.entanglements, expirationTimes = root2.expirationTimes, hiddenUpdates = root2.hiddenUpdates;
    for (remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes; ) {
      var index$5 = 31 - clz32(remainingLanes), lane = 1 << index$5;
      entanglements[index$5] = 0;
      expirationTimes[index$5] = -1;
      var hiddenUpdatesForLane = hiddenUpdates[index$5];
      if (null !== hiddenUpdatesForLane)
        for (hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++) {
          var update = hiddenUpdatesForLane[index$5];
          null !== update && (update.lane &= -536870913);
        }
      remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root2, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root2.tag && (root2.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
  }
  function markSpawnedDeferredLane(root2, spawnedLane, entangledLanes) {
    root2.pendingLanes |= spawnedLane;
    root2.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root2.entangledLanes |= spawnedLane;
    root2.entanglements[spawnedLaneIndex] = root2.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
  }
  function markRootEntangled(root2, entangledLanes) {
    var rootEntangledLanes = root2.entangledLanes |= entangledLanes;
    for (root2 = root2.entanglements; rootEntangledLanes; ) {
      var index$6 = 31 - clz32(rootEntangledLanes), lane = 1 << index$6;
      lane & entangledLanes | root2[index$6] & entangledLanes && (root2[index$6] |= entangledLanes);
      rootEntangledLanes &= ~lane;
    }
  }
  function getBumpedLaneForHydrationByLane(lane) {
    switch (lane) {
      case 2:
        lane = 1;
        break;
      case 8:
        lane = 4;
        break;
      case 32:
        lane = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        lane = 128;
        break;
      case 268435456:
        lane = 134217728;
        break;
      default:
        lane = 0;
    }
    return lane;
  }
  function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
  }
  function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
  }
  function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
      return ReactDOMSharedInternals.p = priority, fn();
    } finally {
      ReactDOMSharedInternals.p = previousPriority;
    }
  }
  var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
  function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlersKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
  }
  function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for (var parentNode = targetNode.parentNode; parentNode; ) {
      if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
        parentNode = targetInst.alternate;
        if (null !== targetInst.child || null !== parentNode && null !== parentNode.child)
          for (targetNode = getParentSuspenseInstance(targetNode); null !== targetNode; ) {
            if (parentNode = targetNode[internalInstanceKey]) return parentNode;
            targetNode = getParentSuspenseInstance(targetNode);
          }
        return targetInst;
      }
      targetNode = parentNode;
      parentNode = targetNode.parentNode;
    }
    return null;
  }
  function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
      var tag = node.tag;
      if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag)
        return node;
    }
    return null;
  }
  function getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error(formatProdErrorMessage(33));
  }
  function getResourcesFromRoot(root2) {
    var resources = root2[internalRootNodeResourcesKey];
    resources || (resources = root2[internalRootNodeResourcesKey] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() });
    return resources;
  }
  function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = true;
  }
  var allNativeEvents = /* @__PURE__ */ new Set(), registrationNameDependencies = {};
  function registerTwoPhaseEvent(registrationName, dependencies) {
    registerDirectEvent(registrationName, dependencies);
    registerDirectEvent(registrationName + "Capture", dependencies);
  }
  function registerDirectEvent(registrationName, dependencies) {
    registrationNameDependencies[registrationName] = dependencies;
    for (registrationName = 0; registrationName < dependencies.length; registrationName++)
      allNativeEvents.add(dependencies[registrationName]);
  }
  var VALID_ATTRIBUTE_NAME_REGEX = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
  function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName))
      return true;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName))
      return validatedAttributeNameCache[attributeName] = true;
    illegalAttributeNameCache[attributeName] = true;
    return false;
  }
  function setValueForAttribute(node, name, value) {
    if (isAttributeNameSafe(name))
      if (null === value) node.removeAttribute(name);
      else {
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
            node.removeAttribute(name);
            return;
          case "boolean":
            var prefix$8 = name.toLowerCase().slice(0, 5);
            if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
              node.removeAttribute(name);
              return;
            }
        }
        node.setAttribute(name, "" + value);
      }
  }
  function setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
      switch (typeof value) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          node.removeAttribute(name);
          return;
      }
      node.setAttribute(name, "" + value);
    }
  }
  function setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
      switch (typeof value) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          node.removeAttribute(name);
          return;
      }
      node.setAttributeNS(namespace, name, "" + value);
    }
  }
  var prefix, suffix;
  function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix)
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return "\n" + prefix + name + suffix;
  }
  var reentry = false;
  function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = true;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var RunInRootFrame = {
        DetermineComponentFrameRoot: function() {
          try {
            if (construct) {
              var Fake = function() {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function() {
                  throw Error();
                }
              });
              if ("object" === typeof Reflect && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x) {
                  var control = x;
                }
                Reflect.construct(fn, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x$9) {
                  control = x$9;
                }
                fn.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x$10) {
                control = x$10;
              }
              (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {
              });
            }
          } catch (sample) {
            if (sample && control && "string" === typeof sample.stack)
              return [sample.stack, control.stack];
          }
          return [null, null];
        }
      };
      RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var namePropDescriptor = Object.getOwnPropertyDescriptor(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name"
      );
      namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
      if (sampleStack && controlStack) {
        var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
        for (namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot"); )
          RunInRootFrame++;
        for (; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes(
          "DetermineComponentFrameRoot"
        ); )
          namePropDescriptor++;
        if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length)
          for (RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]; )
            namePropDescriptor--;
        for (; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)
          if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
            if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
              do
                if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                  var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                  fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                  return frame;
                }
              while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
            }
            break;
          }
      }
    } finally {
      reentry = false, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
  }
  function describeFiber(fiber) {
    switch (fiber.tag) {
      case 26:
      case 27:
      case 5:
        return describeBuiltInComponentFrame(fiber.type);
      case 16:
        return describeBuiltInComponentFrame("Lazy");
      case 13:
        return describeBuiltInComponentFrame("Suspense");
      case 19:
        return describeBuiltInComponentFrame("SuspenseList");
      case 0:
      case 15:
        return describeNativeComponentFrame(fiber.type, false);
      case 11:
        return describeNativeComponentFrame(fiber.type.render, false);
      case 1:
        return describeNativeComponentFrame(fiber.type, true);
      case 31:
        return describeBuiltInComponentFrame("Activity");
      default:
        return "";
    }
  }
  function getStackByFiberInDevAndProd(workInProgress2) {
    try {
      var info = "";
      do
        info += describeFiber(workInProgress2), workInProgress2 = workInProgress2.return;
      while (workInProgress2);
      return info;
    } catch (x) {
      return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
  }
  function getToStringValue(value) {
    switch (typeof value) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return value;
      case "object":
        return value;
      default:
        return "";
    }
  }
  function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
  }
  function trackValueOnNode(node) {
    var valueField = isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(
      node.constructor.prototype,
      valueField
    ), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
      var get = descriptor.get, set = descriptor.set;
      Object.defineProperty(node, valueField, {
        configurable: true,
        get: function() {
          return get.call(this);
        },
        set: function(value) {
          currentValue = "" + value;
          set.call(this, value);
        }
      });
      Object.defineProperty(node, valueField, {
        enumerable: descriptor.enumerable
      });
      return {
        getValue: function() {
          return currentValue;
        },
        setValue: function(value) {
          currentValue = "" + value;
        },
        stopTracking: function() {
          node._valueTracker = null;
          delete node[valueField];
        }
      };
    }
  }
  function track(node) {
    node._valueTracker || (node._valueTracker = trackValueOnNode(node));
  }
  function updateValueIfChanged(node) {
    if (!node) return false;
    var tracker = node._valueTracker;
    if (!tracker) return true;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), true) : false;
  }
  function getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
      return doc.activeElement || doc.body;
    } catch (e) {
      return doc.body;
    }
  }
  var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
  function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(
      escapeSelectorAttributeValueInsideDoubleQuotesRegex,
      function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value)
      if ("number" === type) {
        if (0 === value && "" === element.value || element.value != value)
          element.value = "" + getToStringValue(value);
      } else
        element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
    else
      "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + getToStringValue(name) : element.removeAttribute("name");
  }
  function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating2) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
      if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value))
        return;
      defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
      value = null != value ? "" + getToStringValue(value) : defaultValue;
      isHydrating2 || value === element.value || (element.value = value);
      element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating2 ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
  }
  function setDefaultValue(node, type, value) {
    "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
  }
  function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
      multiple = {};
      for (var i = 0; i < propValue.length; i++)
        multiple["$" + propValue[i]] = true;
      for (propValue = 0; propValue < node.length; propValue++)
        i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = true);
    } else {
      propValue = "" + getToStringValue(propValue);
      multiple = null;
      for (i = 0; i < node.length; i++) {
        if (node[i].value === propValue) {
          node[i].selected = true;
          setDefaultSelected && (node[i].defaultSelected = true);
          return;
        }
        null !== multiple || node[i].disabled || (multiple = node[i]);
      }
      null !== multiple && (multiple.selected = true);
    }
  }
  function updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
      element.defaultValue !== value && (element.defaultValue = value);
      return;
    }
    element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
  }
  function initTextarea(element, value, defaultValue, children) {
    if (null == value) {
      if (null != children) {
        if (null != defaultValue) throw Error(formatProdErrorMessage(92));
        if (isArrayImpl(children)) {
          if (1 < children.length) throw Error(formatProdErrorMessage(93));
          children = children[0];
        }
        defaultValue = children;
      }
      null == defaultValue && (defaultValue = "");
      value = defaultValue;
    }
    defaultValue = getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
  }
  function setTextContent(node, text) {
    if (text) {
      var firstChild = node.firstChild;
      if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
        firstChild.nodeValue = text;
        return;
      }
    }
    node.textContent = text;
  }
  var unitlessNumbers = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function setValueForStyle(style2, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style2.setProperty(styleName, "") : "float" === styleName ? style2.cssFloat = "" : style2[styleName] = "" : isCustomProperty ? style2.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style2.cssFloat = value : style2[styleName] = ("" + value).trim() : style2[styleName] = value + "px";
  }
  function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles)
      throw Error(formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
      for (var styleName in prevStyles)
        !prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
      for (var styleName$16 in styles)
        styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node, styleName$16, styleName);
    } else
      for (var styleName$17 in styles)
        styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
  }
  function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return false;
    switch (tagName) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return false;
      default:
        return true;
    }
  }
  var aliases = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
  }
  var currentReplayingEvent = null;
  function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
  }
  var restoreTarget = null, restoreQueue = null;
  function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
      var props = target[internalPropsKey] || null;
      a: switch (target = internalInstance.stateNode, internalInstance.type) {
        case "input":
          updateInput(
            target,
            props.value,
            props.defaultValue,
            props.defaultValue,
            props.checked,
            props.defaultChecked,
            props.type,
            props.name
          );
          internalInstance = props.name;
          if ("radio" === props.type && null != internalInstance) {
            for (props = target; props.parentNode; ) props = props.parentNode;
            props = props.querySelectorAll(
              'input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes(
                "" + internalInstance
              ) + '"][type="radio"]'
            );
            for (internalInstance = 0; internalInstance < props.length; internalInstance++) {
              var otherNode = props[internalInstance];
              if (otherNode !== target && otherNode.form === target.form) {
                var otherProps = otherNode[internalPropsKey] || null;
                if (!otherProps) throw Error(formatProdErrorMessage(90));
                updateInput(
                  otherNode,
                  otherProps.value,
                  otherProps.defaultValue,
                  otherProps.defaultValue,
                  otherProps.checked,
                  otherProps.defaultChecked,
                  otherProps.type,
                  otherProps.name
                );
              }
            }
            for (internalInstance = 0; internalInstance < props.length; internalInstance++)
              otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
          }
          break a;
        case "textarea":
          updateTextarea(target, props.value, props.defaultValue);
          break a;
        case "select":
          internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, false);
      }
    }
  }
  var isInsideEventHandler = false;
  function batchedUpdates$1(fn, a, b) {
    if (isInsideEventHandler) return fn(a, b);
    isInsideEventHandler = true;
    try {
      var JSCompiler_inline_result = fn(a);
      return JSCompiler_inline_result;
    } finally {
      if (isInsideEventHandler = false, null !== restoreTarget || null !== restoreQueue) {
        if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn))
          for (a = 0; a < fn.length; a++) restoreStateOfTarget(fn[a]);
      }
    }
  }
  function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch (registrationName) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
        inst = !props;
        break a;
      default:
        inst = false;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode)
      throw Error(
        formatProdErrorMessage(231, registrationName, typeof stateNode)
      );
    return stateNode;
  }
  var canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = false;
  if (canUseDOM)
    try {
      var options = {};
      Object.defineProperty(options, "passive", {
        get: function() {
          passiveBrowserEventsSupported = true;
        }
      });
      window.addEventListener("test", options, options);
      window.removeEventListener("test", options, options);
    } catch (e) {
      passiveBrowserEventsSupported = false;
    }
  var root = null, startText = null, fallbackText = null;
  function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
    for (start = 0; start < startLength && startValue[start] === endValue[start]; start++) ;
    var minEnd = startLength - start;
    for (end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++) ;
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
  }
  function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
  }
  function functionThatReturnsTrue() {
    return true;
  }
  function functionThatReturnsFalse() {
    return false;
  }
  function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
      this._reactName = reactName;
      this._targetInst = targetInst;
      this.type = reactEventType;
      this.nativeEvent = nativeEvent;
      this.target = nativeEventTarget;
      this.currentTarget = null;
      for (var propName in Interface)
        Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
      this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : false === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
      this.isPropagationStopped = functionThatReturnsFalse;
      return this;
    }
    assign(SyntheticBaseEvent.prototype, {
      preventDefault: function() {
        this.defaultPrevented = true;
        var event = this.nativeEvent;
        event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = false), this.isDefaultPrevented = functionThatReturnsTrue);
      },
      stopPropagation: function() {
        var event = this.nativeEvent;
        event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = true), this.isPropagationStopped = functionThatReturnsTrue);
      },
      persist: function() {
      },
      isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
  }
  var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
      return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, { view: 0, detail: 0 }), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
      return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
      if ("movementX" in event) return event.movementX;
      event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
      return lastMovementX;
    },
    movementY: function(event) {
      return "movementY" in event ? event.movementY : lastMovementY;
    }
  }), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, { dataTransfer: 0 }), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, { relatedTarget: 0 }), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
    clipboardData: function(event) {
      return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
  }), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, { data: 0 }), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : false;
  }
  function getEventModifierState() {
    return modifierStateGetter;
  }
  var KeyboardEventInterface = assign({}, UIEventInterface, {
    key: function(nativeEvent) {
      if (nativeEvent.key) {
        var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
        if ("Unidentified" !== key) return key;
      }
      return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
      return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
      return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
      return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
  }), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
  }), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
    deltaX: function(event) {
      return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
      return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
    newState: 0,
    oldState: 0
  }), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [9, 13, 27, 32], canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
  canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
  var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = false;
  function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch (domEventName) {
      case "keyup":
        return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
      case "keydown":
        return 229 !== nativeEvent.keyCode;
      case "keypress":
      case "mousedown":
      case "focusout":
        return true;
      default:
        return false;
    }
  }
  function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
  }
  var isComposing = false;
  function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch (domEventName) {
      case "compositionend":
        return getDataFromCustomEvent(nativeEvent);
      case "keypress":
        if (32 !== nativeEvent.which) return null;
        hasSpaceKeypress = true;
        return SPACEBAR_CHAR;
      case "textInput":
        return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
      default:
        return null;
    }
  }
  function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing)
      return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = false, domEventName) : null;
    switch (domEventName) {
      case "paste":
        return null;
      case "keypress":
        if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
          if (nativeEvent.char && 1 < nativeEvent.char.length)
            return nativeEvent.char;
          if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
        }
        return null;
      case "compositionend":
        return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
      default:
        return null;
    }
  }
  var supportedInputTypes = {
    color: true,
    date: true,
    datetime: true,
    "datetime-local": true,
    email: true,
    month: true,
    number: true,
    password: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true
  };
  function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? true : false;
  }
  function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [target] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent(
      "onChange",
      "change",
      null,
      nativeEvent,
      target
    ), dispatchQueue.push({ event: nativeEvent, listeners: inst }));
  }
  var activeElement$1 = null, activeElementInst$1 = null;
  function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
  }
  function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
  }
  function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
  }
  var isInputEventSupported = false;
  if (canUseDOM) {
    var JSCompiler_inline_result$jscomp$282;
    if (canUseDOM) {
      var isSupported$jscomp$inline_417 = "oninput" in document;
      if (!isSupported$jscomp$inline_417) {
        var element$jscomp$inline_418 = document.createElement("div");
        element$jscomp$inline_418.setAttribute("oninput", "return;");
        isSupported$jscomp$inline_417 = "function" === typeof element$jscomp$inline_418.oninput;
      }
      JSCompiler_inline_result$jscomp$282 = isSupported$jscomp$inline_417;
    } else JSCompiler_inline_result$jscomp$282 = false;
    isInputEventSupported = JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
  }
  function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
  }
  function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
      var dispatchQueue = [];
      createAndAccumulateChangeEvent(
        dispatchQueue,
        activeElementInst$1,
        nativeEvent,
        getEventTarget(nativeEvent)
      );
      batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
  }
  function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
  }
  function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName)
      return getInstIfValueChanged(activeElementInst$1);
  }
  function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
  }
  function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName)
      return getInstIfValueChanged(targetInst);
  }
  function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is;
  function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return true;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB)
      return false;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (keysB = 0; keysB < keysA.length; keysB++) {
      var currentKey = keysA[keysB];
      if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey]))
        return false;
    }
    return true;
  }
  function getLeafNode(node) {
    for (; node && node.firstChild; ) node = node.firstChild;
    return node;
  }
  function getNodeForCharacterOffset(root2, offset) {
    var node = getLeafNode(root2);
    root2 = 0;
    for (var nodeEnd; node; ) {
      if (3 === node.nodeType) {
        nodeEnd = root2 + node.textContent.length;
        if (root2 <= offset && nodeEnd >= offset)
          return { node, offset: offset - root2 };
        root2 = nodeEnd;
      }
      a: {
        for (; node; ) {
          if (node.nextSibling) {
            node = node.nextSibling;
            break a;
          }
          node = node.parentNode;
        }
        node = void 0;
      }
      node = getLeafNode(node);
    }
  }
  function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? true : outerNode && 3 === outerNode.nodeType ? false : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : false : false;
  }
  function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for (var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement; ) {
      try {
        var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
      } catch (err) {
        JSCompiler_inline_result = false;
      }
      if (JSCompiler_inline_result) containerInfo = element.contentWindow;
      else break;
      element = getActiveElement(containerInfo.document);
    }
    return element;
  }
  function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
  }
  var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = false;
  function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = { start: doc.selectionStart, end: doc.selectionEnd } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
      anchorNode: doc.anchorNode,
      anchorOffset: doc.anchorOffset,
      focusNode: doc.focusNode,
      focusOffset: doc.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent(
      "onSelect",
      "select",
      null,
      nativeEvent,
      nativeEventTarget
    ), dispatchQueue.push({ event: nativeEvent, listeners: doc }), nativeEvent.target = activeElement)));
  }
  function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
  }
  var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  }, prefixedEventNames = {}, style = {};
  canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
  function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for (styleProp in prefixMap)
      if (prefixMap.hasOwnProperty(styleProp) && styleProp in style)
        return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
  }
  var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = /* @__PURE__ */ new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  simpleEventPluginEvents.push("scrollEnd");
  function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [domEventName]);
  }
  var CapturedStacks = /* @__PURE__ */ new WeakMap();
  function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
      var existing = CapturedStacks.get(value);
      if (void 0 !== existing) return existing;
      source = {
        value,
        source,
        stack: getStackByFiberInDevAndProd(source)
      };
      CapturedStacks.set(value, source);
      return source;
    }
    return {
      value,
      source,
      stack: getStackByFiberInDevAndProd(source)
    };
  }
  var concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
  function finishQueueingConcurrentUpdates() {
    for (var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex; ) {
      var fiber = concurrentQueues[i];
      concurrentQueues[i++] = null;
      var queue = concurrentQueues[i];
      concurrentQueues[i++] = null;
      var update = concurrentQueues[i];
      concurrentQueues[i++] = null;
      var lane = concurrentQueues[i];
      concurrentQueues[i++] = null;
      if (null !== queue && null !== update) {
        var pending = queue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        queue.pending = update;
      }
      0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
  }
  function enqueueUpdate$1(fiber, queue, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
  }
  function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    enqueueUpdate$1(fiber, queue, update, lane);
    return getRootForUpdatedFiber(fiber);
  }
  function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
  }
  function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for (var isHidden = false, parent = sourceFiber.return; null !== parent; )
      parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = true)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [update] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
  }
  function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount)
      throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
    for (var parent = sourceFiber.return; null !== parent; )
      sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
  }
  var emptyContextObject = {};
  function FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
  }
  function createFiberImplClass(tag, pendingProps, key, mode) {
    return new FiberNode(tag, pendingProps, key, mode);
  }
  function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
  }
  function createWorkInProgress(current, pendingProps) {
    var workInProgress2 = current.alternate;
    null === workInProgress2 ? (workInProgress2 = createFiberImplClass(
      current.tag,
      pendingProps,
      current.key,
      current.mode
    ), workInProgress2.elementType = current.elementType, workInProgress2.type = current.type, workInProgress2.stateNode = current.stateNode, workInProgress2.alternate = current, current.alternate = workInProgress2) : (workInProgress2.pendingProps = pendingProps, workInProgress2.type = current.type, workInProgress2.flags = 0, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null);
    workInProgress2.flags = current.flags & 65011712;
    workInProgress2.childLanes = current.childLanes;
    workInProgress2.lanes = current.lanes;
    workInProgress2.child = current.child;
    workInProgress2.memoizedProps = current.memoizedProps;
    workInProgress2.memoizedState = current.memoizedState;
    workInProgress2.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress2.dependencies = null === pendingProps ? null : { lanes: pendingProps.lanes, firstContext: pendingProps.firstContext };
    workInProgress2.sibling = current.sibling;
    workInProgress2.index = current.index;
    workInProgress2.ref = current.ref;
    workInProgress2.refCleanup = current.refCleanup;
    return workInProgress2;
  }
  function resetWorkInProgress(workInProgress2, renderLanes2) {
    workInProgress2.flags &= 65011714;
    var current = workInProgress2.alternate;
    null === current ? (workInProgress2.childLanes = 0, workInProgress2.lanes = renderLanes2, workInProgress2.child = null, workInProgress2.subtreeFlags = 0, workInProgress2.memoizedProps = null, workInProgress2.memoizedState = null, workInProgress2.updateQueue = null, workInProgress2.dependencies = null, workInProgress2.stateNode = null) : (workInProgress2.childLanes = current.childLanes, workInProgress2.lanes = current.lanes, workInProgress2.child = current.child, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null, workInProgress2.memoizedProps = current.memoizedProps, workInProgress2.memoizedState = current.memoizedState, workInProgress2.updateQueue = current.updateQueue, workInProgress2.type = current.type, renderLanes2 = current.dependencies, workInProgress2.dependencies = null === renderLanes2 ? null : {
      lanes: renderLanes2.lanes,
      firstContext: renderLanes2.firstContext
    });
    return workInProgress2;
  }
  function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type)
      fiberTag = isHostHoistableType(
        type,
        pendingProps,
        contextStackCursor.current
      ) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else
      a: switch (type) {
        case REACT_ACTIVITY_TYPE:
          return type = createFiberImplClass(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case REACT_FRAGMENT_TYPE:
          return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
          fiberTag = 8;
          mode |= 24;
          break;
        case REACT_PROFILER_TYPE:
          return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
          return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
          return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
          if ("object" === typeof type && null !== type)
            switch (type.$$typeof) {
              case REACT_PROVIDER_TYPE:
              case REACT_CONTEXT_TYPE:
                fiberTag = 10;
                break a;
              case REACT_CONSUMER_TYPE:
                fiberTag = 9;
                break a;
              case REACT_FORWARD_REF_TYPE:
                fiberTag = 11;
                break a;
              case REACT_MEMO_TYPE:
                fiberTag = 14;
                break a;
              case REACT_LAZY_TYPE:
                fiberTag = 16;
                owner = null;
                break a;
            }
          fiberTag = 29;
          pendingProps = Error(
            formatProdErrorMessage(130, null === type ? "null" : typeof type, "")
          );
          owner = null;
      }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
  }
  function createFiberFromFragment(elements, mode, lanes, key) {
    elements = createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
  }
  function createFiberFromText(content, mode, lanes) {
    content = createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
  }
  function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(
      4,
      null !== portal.children ? portal.children : [],
      portal.key,
      mode
    );
    mode.lanes = lanes;
    mode.stateNode = {
      containerInfo: portal.containerInfo,
      pendingChildren: null,
      implementation: portal.implementation
    };
    return mode;
  }
  var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
  function pushTreeFork(workInProgress2, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress2;
    treeForkCount = totalChildren;
  }
  function pushTreeId(workInProgress2, totalChildren, index2) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress2;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress2 = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index2 += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
      var numberOfOverflowBits = baseLength - baseLength % 5;
      length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
      baseIdWithLeadingBit >>= numberOfOverflowBits;
      baseLength -= numberOfOverflowBits;
      treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index2 << baseLength | baseIdWithLeadingBit;
      treeContextOverflow = length + workInProgress2;
    } else
      treeContextId = 1 << length | index2 << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress2;
  }
  function pushMaterializedTreeId(workInProgress2) {
    null !== workInProgress2.return && (pushTreeFork(workInProgress2, 1), pushTreeId(workInProgress2, 1, 0));
  }
  function popTreeContext(workInProgress2) {
    for (; workInProgress2 === treeForkProvider; )
      treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for (; workInProgress2 === treeContextProvider; )
      treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
  }
  var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = false, hydrationErrors = null, rootOrSingletonContext = false, HydrationMismatchException = Error(formatProdErrorMessage(519));
  function throwOnHydrationMismatch(fiber) {
    var error = Error(formatProdErrorMessage(418, ""));
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
  }
  function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props;
    switch (type) {
      case "dialog":
        listenToNonDelegatedEvent("cancel", instance);
        listenToNonDelegatedEvent("close", instance);
        break;
      case "iframe":
      case "object":
      case "embed":
        listenToNonDelegatedEvent("load", instance);
        break;
      case "video":
      case "audio":
        for (type = 0; type < mediaEventTypes.length; type++)
          listenToNonDelegatedEvent(mediaEventTypes[type], instance);
        break;
      case "source":
        listenToNonDelegatedEvent("error", instance);
        break;
      case "img":
      case "image":
      case "link":
        listenToNonDelegatedEvent("error", instance);
        listenToNonDelegatedEvent("load", instance);
        break;
      case "details":
        listenToNonDelegatedEvent("toggle", instance);
        break;
      case "input":
        listenToNonDelegatedEvent("invalid", instance);
        initInput(
          instance,
          props.value,
          props.defaultValue,
          props.checked,
          props.defaultChecked,
          props.type,
          props.name,
          true
        );
        track(instance);
        break;
      case "select":
        listenToNonDelegatedEvent("invalid", instance);
        break;
      case "textarea":
        listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props.value, props.defaultValue, props.children), track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || true === props.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = noop$1), instance = true) : instance = false;
    instance || throwOnHydrationMismatch(fiber);
  }
  function popToNextHostParent(fiber) {
    for (hydrationParentFiber = fiber.return; hydrationParentFiber; )
      switch (hydrationParentFiber.tag) {
        case 5:
        case 13:
          rootOrSingletonContext = false;
          return;
        case 27:
        case 3:
          rootOrSingletonContext = true;
          return;
        default:
          hydrationParentFiber = hydrationParentFiber.return;
      }
  }
  function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return false;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = true, false;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
      if (JSCompiler_temp = 5 === tag)
        JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
      JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag) {
      fiber = fiber.memoizedState;
      fiber = null !== fiber ? fiber.dehydrated : null;
      if (!fiber) throw Error(formatProdErrorMessage(317));
      a: {
        fiber = fiber.nextSibling;
        for (tag = 0; fiber; ) {
          if (8 === fiber.nodeType)
            if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
              if (0 === tag) {
                nextHydratableInstance = getNextHydratable(fiber.nextSibling);
                break a;
              }
              tag--;
            } else
              "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
          fiber = fiber.nextSibling;
        }
        nextHydratableInstance = null;
      }
    } else
      27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return true;
  }
  function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = false;
  }
  function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(
      workInProgressRootRecoverableErrors,
      queuedErrors
    ), hydrationErrors = null);
    return queuedErrors;
  }
  function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [error] : hydrationErrors.push(error);
  }
  var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
  function pushProvider(providerFiber, context, nextValue) {
    push(valueCursor, context._currentValue);
    context._currentValue = nextValue;
  }
  function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
  }
  function scheduleContextWorkOnParentPath(parent, renderLanes2, propagationRoot) {
    for (; null !== parent; ) {
      var alternate = parent.alternate;
      (parent.childLanes & renderLanes2) !== renderLanes2 ? (parent.childLanes |= renderLanes2, null !== alternate && (alternate.childLanes |= renderLanes2)) : null !== alternate && (alternate.childLanes & renderLanes2) !== renderLanes2 && (alternate.childLanes |= renderLanes2);
      if (parent === propagationRoot) break;
      parent = parent.return;
    }
  }
  function propagateContextChanges(workInProgress2, contexts, renderLanes2, forcePropagateEntireTree) {
    var fiber = workInProgress2.child;
    null !== fiber && (fiber.return = workInProgress2);
    for (; null !== fiber; ) {
      var list = fiber.dependencies;
      if (null !== list) {
        var nextFiber = fiber.child;
        list = list.firstContext;
        a: for (; null !== list; ) {
          var dependency = list;
          list = fiber;
          for (var i = 0; i < contexts.length; i++)
            if (dependency.context === contexts[i]) {
              list.lanes |= renderLanes2;
              dependency = list.alternate;
              null !== dependency && (dependency.lanes |= renderLanes2);
              scheduleContextWorkOnParentPath(
                list.return,
                renderLanes2,
                workInProgress2
              );
              forcePropagateEntireTree || (nextFiber = null);
              break a;
            }
          list = dependency.next;
        }
      } else if (18 === fiber.tag) {
        nextFiber = fiber.return;
        if (null === nextFiber) throw Error(formatProdErrorMessage(341));
        nextFiber.lanes |= renderLanes2;
        list = nextFiber.alternate;
        null !== list && (list.lanes |= renderLanes2);
        scheduleContextWorkOnParentPath(nextFiber, renderLanes2, workInProgress2);
        nextFiber = null;
      } else nextFiber = fiber.child;
      if (null !== nextFiber) nextFiber.return = fiber;
      else
        for (nextFiber = fiber; null !== nextFiber; ) {
          if (nextFiber === workInProgress2) {
            nextFiber = null;
            break;
          }
          fiber = nextFiber.sibling;
          if (null !== fiber) {
            fiber.return = nextFiber.return;
            nextFiber = fiber;
            break;
          }
          nextFiber = nextFiber.return;
        }
      fiber = nextFiber;
    }
  }
  function propagateParentContextChanges(current, workInProgress2, renderLanes2, forcePropagateEntireTree) {
    current = null;
    for (var parent = workInProgress2, isInsidePropagationBailout = false; null !== parent; ) {
      if (!isInsidePropagationBailout) {
        if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = true;
        else if (0 !== (parent.flags & 262144)) break;
      }
      if (10 === parent.tag) {
        var currentParent = parent.alternate;
        if (null === currentParent) throw Error(formatProdErrorMessage(387));
        currentParent = currentParent.memoizedProps;
        if (null !== currentParent) {
          var context = parent.type;
          objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [context]);
        }
      } else if (parent === hostTransitionProviderCursor.current) {
        currentParent = parent.alternate;
        if (null === currentParent) throw Error(formatProdErrorMessage(387));
        currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [HostTransitionContext]);
      }
      parent = parent.return;
    }
    null !== current && propagateContextChanges(
      workInProgress2,
      current,
      renderLanes2,
      forcePropagateEntireTree
    );
    workInProgress2.flags |= 262144;
  }
  function checkIfContextChanged(currentDependencies) {
    for (currentDependencies = currentDependencies.firstContext; null !== currentDependencies; ) {
      if (!objectIs(
        currentDependencies.context._currentValue,
        currentDependencies.memoizedValue
      ))
        return true;
      currentDependencies = currentDependencies.next;
    }
    return false;
  }
  function prepareToReadContext(workInProgress2) {
    currentlyRenderingFiber$1 = workInProgress2;
    lastContextDependency = null;
    workInProgress2 = workInProgress2.dependencies;
    null !== workInProgress2 && (workInProgress2.firstContext = null);
  }
  function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber$1, context);
  }
  function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
  }
  function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = { context, memoizedValue: value, next: null };
    if (null === lastContextDependency) {
      if (null === consumer) throw Error(formatProdErrorMessage(308));
      lastContextDependency = context;
      consumer.dependencies = { lanes: 0, firstContext: context };
      consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
  }
  var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
      aborted: false,
      addEventListener: function(type, listener) {
        listeners.push(listener);
      }
    };
    this.abort = function() {
      signal.aborted = true;
      listeners.forEach(function(listener) {
        return listener();
      });
    };
  }, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function createCache() {
    return {
      controller: new AbortControllerLocal(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
      cache.controller.abort();
    });
  }
  var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
  function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
      var entangledListeners = currentEntangledListeners = [];
      currentEntangledPendingCount = 0;
      currentEntangledLane = requestTransitionLane();
      currentEntangledActionThenable = {
        status: "pending",
        value: void 0,
        then: function(resolve) {
          entangledListeners.push(resolve);
        }
      };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
  }
  function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
      null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
      var listeners = currentEntangledListeners;
      currentEntangledListeners = null;
      currentEntangledLane = 0;
      currentEntangledActionThenable = null;
      for (var i = 0; i < listeners.length; i++) (0, listeners[i])();
    }
  }
  function chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
      status: "pending",
      value: null,
      reason: null,
      then: function(resolve) {
        listeners.push(resolve);
      }
    };
    thenable.then(
      function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for (var i = 0; i < listeners.length; i++) (0, listeners[i])(result);
      },
      function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for (error = 0; error < listeners.length; error++)
          (0, listeners[error])(void 0);
      }
    );
    return thenableWithOverride;
  }
  var prevOnStartTransitionFinish = ReactSharedInternals.S;
  ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
  };
  var resumedCache = createCursor(null);
  function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
  }
  function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
  }
  function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : { parent: CacheContext._currentValue, pool: cacheFromPool };
  }
  var SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), SuspenseActionException = Error(formatProdErrorMessage(542)), noopSuspenseyCommitThenable = { then: function() {
  } };
  function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
  }
  function noop$3() {
  }
  function trackUsedThenable(thenableState2, thenable, index2) {
    index2 = thenableState2[index2];
    void 0 === index2 ? thenableState2.push(thenable) : index2 !== thenable && (thenable.then(noop$3, noop$3), thenable = index2);
    switch (thenable.status) {
      case "fulfilled":
        return thenable.value;
      case "rejected":
        throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
      default:
        if ("string" === typeof thenable.status) thenable.then(noop$3, noop$3);
        else {
          thenableState2 = workInProgressRoot;
          if (null !== thenableState2 && 100 < thenableState2.shellSuspendCounter)
            throw Error(formatProdErrorMessage(482));
          thenableState2 = thenable;
          thenableState2.status = "pending";
          thenableState2.then(
            function(fulfilledValue) {
              if ("pending" === thenable.status) {
                var fulfilledThenable = thenable;
                fulfilledThenable.status = "fulfilled";
                fulfilledThenable.value = fulfilledValue;
              }
            },
            function(error) {
              if ("pending" === thenable.status) {
                var rejectedThenable = thenable;
                rejectedThenable.status = "rejected";
                rejectedThenable.reason = error;
              }
            }
          );
        }
        switch (thenable.status) {
          case "fulfilled":
            return thenable.value;
          case "rejected":
            throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
        }
        suspendedThenable = thenable;
        throw SuspenseException;
    }
  }
  var suspendedThenable = null;
  function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
  }
  function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException)
      throw Error(formatProdErrorMessage(483));
  }
  var hasForceUpdate = false;
  function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
      baseState: fiber.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function cloneUpdateQueue(current, workInProgress2) {
    current = current.updateQueue;
    workInProgress2.updateQueue === current && (workInProgress2.updateQueue = {
      baseState: current.baseState,
      firstBaseUpdate: current.firstBaseUpdate,
      lastBaseUpdate: current.lastBaseUpdate,
      shared: current.shared,
      callbacks: null
    });
  }
  function createUpdate(lane) {
    return { lane, tag: 0, payload: null, callback: null, next: null };
  }
  function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
      var pending = updateQueue.pending;
      null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
      updateQueue.pending = update;
      update = getRootForUpdatedFiber(fiber);
      markUpdateLaneFromFiberToRoot(fiber, null, lane);
      return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
  }
  function entangleTransitions(root2, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
      var queueLanes = fiber.lanes;
      queueLanes &= root2.pendingLanes;
      lane |= queueLanes;
      fiber.lanes = lane;
      markRootEntangled(root2, lane);
    }
  }
  function enqueueCapturedUpdate(workInProgress2, capturedUpdate) {
    var queue = workInProgress2.updateQueue, current = workInProgress2.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
      var newFirst = null, newLast = null;
      queue = queue.firstBaseUpdate;
      if (null !== queue) {
        do {
          var clone = {
            lane: queue.lane,
            tag: queue.tag,
            payload: queue.payload,
            callback: null,
            next: null
          };
          null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
          queue = queue.next;
        } while (null !== queue);
        null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
      } else newFirst = newLast = capturedUpdate;
      queue = {
        baseState: current.baseState,
        firstBaseUpdate: newFirst,
        lastBaseUpdate: newLast,
        shared: current.shared,
        callbacks: current.callbacks
      };
      workInProgress2.updateQueue = queue;
      return;
    }
    workInProgress2 = queue.lastBaseUpdate;
    null === workInProgress2 ? queue.firstBaseUpdate = capturedUpdate : workInProgress2.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
  }
  var didReadFromEntangledAsyncAction = false;
  function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
      var entangledActionThenable = currentEntangledActionThenable;
      if (null !== entangledActionThenable) throw entangledActionThenable;
    }
  }
  function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes2) {
    didReadFromEntangledAsyncAction = false;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = false;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
      queue.shared.pending = null;
      var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
      lastPendingUpdate.next = null;
      null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
      lastBaseUpdate = lastPendingUpdate;
      var current = workInProgress$jscomp$0.alternate;
      null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
      var newState = queue.baseState;
      lastBaseUpdate = 0;
      current = firstPendingUpdate = lastPendingUpdate = null;
      pendingQueue = firstBaseUpdate;
      do {
        var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
        if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes2 & updateLane) === updateLane) {
          0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = true);
          null !== current && (current = current.next = {
            lane: 0,
            tag: pendingQueue.tag,
            payload: pendingQueue.payload,
            callback: null,
            next: null
          });
          a: {
            var workInProgress2 = workInProgress$jscomp$0, update = pendingQueue;
            updateLane = props;
            var instance = instance$jscomp$0;
            switch (update.tag) {
              case 1:
                workInProgress2 = update.payload;
                if ("function" === typeof workInProgress2) {
                  newState = workInProgress2.call(instance, newState, updateLane);
                  break a;
                }
                newState = workInProgress2;
                break a;
              case 3:
                workInProgress2.flags = workInProgress2.flags & -65537 | 128;
              case 0:
                workInProgress2 = update.payload;
                updateLane = "function" === typeof workInProgress2 ? workInProgress2.call(instance, newState, updateLane) : workInProgress2;
                if (null === updateLane || void 0 === updateLane) break a;
                newState = assign({}, newState, updateLane);
                break a;
              case 2:
                hasForceUpdate = true;
            }
          }
          updateLane = pendingQueue.callback;
          null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [updateLane] : isHiddenUpdate.push(updateLane));
        } else
          isHiddenUpdate = {
            lane: updateLane,
            tag: pendingQueue.tag,
            payload: pendingQueue.payload,
            callback: pendingQueue.callback,
            next: null
          }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
        pendingQueue = pendingQueue.next;
        if (null === pendingQueue)
          if (pendingQueue = queue.shared.pending, null === pendingQueue)
            break;
          else
            isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
      } while (1);
      null === current && (lastPendingUpdate = newState);
      queue.baseState = lastPendingUpdate;
      queue.firstBaseUpdate = firstPendingUpdate;
      queue.lastBaseUpdate = current;
      null === firstBaseUpdate && (queue.shared.lanes = 0);
      workInProgressRootSkippedLanes |= lastBaseUpdate;
      workInProgress$jscomp$0.lanes = lastBaseUpdate;
      workInProgress$jscomp$0.memoizedState = newState;
    }
  }
  function callCallback(callback, context) {
    if ("function" !== typeof callback)
      throw Error(formatProdErrorMessage(191, callback));
    callback.call(context);
  }
  function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks)
      for (updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)
        callCallback(callbacks[updateQueue], context);
  }
  var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
  function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push(prevEntangledRenderLanesCursor, fiber);
    push(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
  }
  function reuseHiddenContextOnStack() {
    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
  }
  function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
  }
  var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = false, didScheduleRenderPhaseUpdateDuringThisPass = false, shouldDoubleInvokeUserFnsInHooksDEV = false, localIdCounter = 0, thenableIndexCounter$1 = 0, thenableState$1 = null, globalClientIdCounter = 0;
  function throwInvalidHookError() {
    throw Error(formatProdErrorMessage(321));
  }
  function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return false;
    for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++)
      if (!objectIs(nextDeps[i], prevDeps[i])) return false;
    return true;
  }
  function renderWithHooks(current, workInProgress2, Component, props, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress2;
    workInProgress2.memoizedState = null;
    workInProgress2.updateQueue = null;
    workInProgress2.lanes = 0;
    ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = false;
    nextRenderLanes = Component(props, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = false;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(
      workInProgress2,
      Component,
      props,
      secondArg
    ));
    finishRenderingHooks(current);
    return nextRenderLanes;
  }
  function finishRenderingHooks(current) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = false;
    thenableIndexCounter$1 = 0;
    thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
    null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = true));
  }
  function renderWithHooksAgain(workInProgress2, Component, props, secondArg) {
    currentlyRenderingFiber = workInProgress2;
    var numberOfReRenders = 0;
    do {
      didScheduleRenderPhaseUpdateDuringThisPass && (thenableState$1 = null);
      thenableIndexCounter$1 = 0;
      didScheduleRenderPhaseUpdateDuringThisPass = false;
      if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
      numberOfReRenders += 1;
      workInProgressHook = currentHook = null;
      if (null != workInProgress2.updateQueue) {
        var children = workInProgress2.updateQueue;
        children.lastEffect = null;
        children.events = null;
        children.stores = null;
        null != children.memoCache && (children.memoCache.index = 0);
      }
      ReactSharedInternals.H = HooksDispatcherOnRerender;
      children = Component(props, secondArg);
    } while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
  }
  function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
  }
  function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
  }
  function bailoutHooks(current, workInProgress2, lanes) {
    workInProgress2.updateQueue = current.updateQueue;
    workInProgress2.flags &= -2053;
    current.lanes &= ~lanes;
  }
  function resetHooksOnUnwind(workInProgress2) {
    if (didScheduleRenderPhaseUpdate) {
      for (workInProgress2 = workInProgress2.memoizedState; null !== workInProgress2; ) {
        var queue = workInProgress2.queue;
        null !== queue && (queue.pending = null);
        workInProgress2 = workInProgress2.next;
      }
      didScheduleRenderPhaseUpdate = false;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = false;
    thenableIndexCounter$1 = localIdCounter = 0;
    thenableState$1 = null;
  }
  function mountWorkInProgressHook() {
    var hook = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
  }
  function updateWorkInProgressHook() {
    if (null === currentHook) {
      var nextCurrentHook = currentlyRenderingFiber.alternate;
      nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook)
      workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
      if (null === nextCurrentHook) {
        if (null === currentlyRenderingFiber.alternate)
          throw Error(formatProdErrorMessage(467));
        throw Error(formatProdErrorMessage(310));
      }
      currentHook = nextCurrentHook;
      nextCurrentHook = {
        memoizedState: currentHook.memoizedState,
        baseState: currentHook.baseState,
        baseQueue: currentHook.baseQueue,
        queue: currentHook.queue,
        next: null
      };
      null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
  }
  function createFunctionComponentUpdateQueue() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function useThenable(thenable) {
    var index2 = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    thenable = trackUsedThenable(thenableState$1, thenable, index2);
    index2 = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index2.memoizedState : workInProgressHook.next) && (index2 = index2.alternate, ReactSharedInternals.H = null === index2 || null === index2.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
  }
  function use(usable) {
    if (null !== usable && "object" === typeof usable) {
      if ("function" === typeof usable.then) return useThenable(usable);
      if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage(438, String(usable)));
  }
  function useMemoCache(size) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
      var current = currentlyRenderingFiber.alternate;
      null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
        data: current.data.map(function(array) {
          return array.slice();
        }),
        index: 0
      })));
    }
    null == memoCache && (memoCache = { data: [], index: 0 });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue)
      for (updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)
        updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
  }
  function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
  }
  function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
  }
  function updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
      if (null !== baseQueue) {
        var baseFirst = baseQueue.next;
        baseQueue.next = pendingQueue.next;
        pendingQueue.next = baseFirst;
      }
      current.baseQueue = baseQueue = pendingQueue;
      queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
      current = baseQueue.next;
      var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = false;
      do {
        var updateLane = update.lane & -536870913;
        if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
          var revertLane = update.revertLane;
          if (0 === revertLane)
            null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
              lane: 0,
              revertLane: 0,
              action: update.action,
              hasEagerState: update.hasEagerState,
              eagerState: update.eagerState,
              next: null
            }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$32 = true);
          else if ((renderLanes & revertLane) === revertLane) {
            update = update.next;
            revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$32 = true);
            continue;
          } else
            updateLane = {
              lane: 0,
              revertLane: update.revertLane,
              action: update.action,
              hasEagerState: update.hasEagerState,
              eagerState: update.eagerState,
              next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
          updateLane = update.action;
          shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
          pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
        } else
          revertLane = {
            lane: updateLane,
            revertLane: update.revertLane,
            action: update.action,
            hasEagerState: update.hasEagerState,
            eagerState: update.eagerState,
            next: null
          }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
        update = update.next;
      } while (null !== update && update !== current);
      null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
      if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = true, didReadFromEntangledAsyncAction$32 && (reducer = currentEntangledActionThenable, null !== reducer)))
        throw reducer;
      hook.memoizedState = pendingQueue;
      hook.baseState = baseFirst;
      hook.baseQueue = newBaseQueueLast;
      queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [hook.memoizedState, queue.dispatch];
  }
  function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
      queue.pending = null;
      var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
      do
        newState = reducer(newState, update.action), update = update.next;
      while (update !== lastRenderPhaseUpdate);
      objectIs(newState, hook.memoizedState) || (didReceiveUpdate = true);
      hook.memoizedState = newState;
      null === hook.baseQueue && (hook.baseState = newState);
      queue.lastRenderedState = newState;
    }
    return [newState, dispatch];
  }
  function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
      if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
      getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs(
      (currentHook || hook).memoizedState,
      getServerSnapshot
    );
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = true);
    hook = hook.queue;
    var create = subscribeToStore.bind(null, fiber, hook, subscribe);
    updateEffectImpl(2048, 8, create, [subscribe]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
      fiber.flags |= 2048;
      pushSimpleEffect(
        9,
        createEffectInstance(),
        updateStoreInstance.bind(
          null,
          fiber,
          hook,
          getServerSnapshot,
          getSnapshot
        ),
        null
      );
      if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
      isHydrating$jscomp$0 || 0 !== (renderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
  }
  function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = { getSnapshot, value: renderedSnapshot };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [fiber]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [fiber] : renderedSnapshot.push(fiber));
  }
  function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
  }
  function subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
      checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
  }
  function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
      var nextValue = latestGetSnapshot();
      return !objectIs(inst, nextValue);
    } catch (error) {
      return true;
    }
  }
  function forceStoreRerender(fiber) {
    var root2 = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root2 && scheduleUpdateOnFiber(root2, fiber, 2);
  }
  function mountStateImpl(initialState) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState) {
      var initialStateInitializer = initialState;
      initialState = initialStateInitializer();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          initialStateInitializer();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: basicStateReducer,
      lastRenderedState: initialState
    };
    return hook;
  }
  function updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(
      hook,
      currentHook,
      "function" === typeof reducer ? reducer : basicStateReducer
    );
  }
  function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
      var actionNode = {
        payload,
        action: fiber,
        next: null,
        isTransition: true,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(listener) {
          actionNode.listeners.push(listener);
        }
      };
      null !== ReactSharedInternals.T ? setPendingState(true) : actionNode.isTransition = false;
      setState(actionNode);
      setPendingState = actionQueue.pending;
      null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
  }
  function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
      var prevTransition = ReactSharedInternals.T, currentTransition = {};
      ReactSharedInternals.T = currentTransition;
      try {
        var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        handleActionReturnValue(actionQueue, node, returnValue);
      } catch (error) {
        onActionError(actionQueue, node, error);
      } finally {
        ReactSharedInternals.T = prevTransition;
      }
    } else
      try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
      } catch (error$38) {
        onActionError(actionQueue, node, error$38);
      }
  }
  function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(
      function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
      },
      function(error) {
        return onActionError(actionQueue, node, error);
      }
    ) : onActionSuccess(actionQueue, node, returnValue);
  }
  function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
  }
  function onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
      last = last.next;
      do
        actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
      while (actionNode !== last);
    }
    actionQueue.action = null;
  }
  function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for (var i = 0; i < actionNode.length; i++) (0, actionNode[i])();
  }
  function actionStateReducer(oldState, newState) {
    return newState;
  }
  function mountActionState(action, initialStateProp) {
    if (isHydrating) {
      var ssrFormState = workInProgressRoot.formState;
      if (null !== ssrFormState) {
        a: {
          var JSCompiler_inline_result = currentlyRenderingFiber;
          if (isHydrating) {
            if (nextHydratableInstance) {
              b: {
                var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                for (var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType; ) {
                  if (!inRootOrSingleton) {
                    JSCompiler_inline_result$jscomp$0 = null;
                    break b;
                  }
                  JSCompiler_inline_result$jscomp$0 = getNextHydratable(
                    JSCompiler_inline_result$jscomp$0.nextSibling
                  );
                  if (null === JSCompiler_inline_result$jscomp$0) {
                    JSCompiler_inline_result$jscomp$0 = null;
                    break b;
                  }
                }
                inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
              }
              if (JSCompiler_inline_result$jscomp$0) {
                nextHydratableInstance = getNextHydratable(
                  JSCompiler_inline_result$jscomp$0.nextSibling
                );
                JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                break a;
              }
            }
            throwOnHydrationMismatch(JSCompiler_inline_result);
          }
          JSCompiler_inline_result = false;
        }
        JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
      }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: actionStateReducer,
      lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(
      null,
      currentlyRenderingFiber,
      JSCompiler_inline_result
    );
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(false);
    inRootOrSingleton = dispatchOptimisticSetState.bind(
      null,
      currentlyRenderingFiber,
      false,
      JSCompiler_inline_result.queue
    );
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
      state: initialStateProp,
      dispatch: null,
      action,
      pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(
      null,
      currentlyRenderingFiber,
      JSCompiler_inline_result$jscomp$0,
      inRootOrSingleton,
      ssrFormState
    );
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [initialStateProp, ssrFormState, false];
  }
  function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
  }
  function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(
      stateHook,
      currentStateHook,
      actionStateReducer
    )[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then)
      try {
        var state = useThenable(currentStateHook);
      } catch (x) {
        if (x === SuspenseException) throw SuspenseActionException;
        throw x;
      }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(
      9,
      createEffectInstance(),
      actionStateActionEffect.bind(null, actionQueue, action),
      null
    ));
    return [state, dispatch, stateHook];
  }
  function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
  }
  function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook)
      return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [stateHook, dispatch, false];
  }
  function pushSimpleEffect(tag, inst, create, createDeps) {
    tag = { tag, create, deps: createDeps, inst, next: null };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
  }
  function createEffectInstance() {
    return { destroy: void 0, resource: void 0 };
  }
  function updateRef() {
    return updateWorkInProgressHook().memoizedState;
  }
  function mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(
      1 | hookFlags,
      createEffectInstance(),
      create,
      createDeps
    );
  }
  function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(
      1 | hookFlags,
      inst,
      create,
      deps
    ));
  }
  function mountEffect(create, createDeps) {
    mountEffectImpl(8390656, 8, create, createDeps);
  }
  function updateEffect(create, createDeps) {
    updateEffectImpl(2048, 8, create, createDeps);
  }
  function updateInsertionEffect(create, deps) {
    return updateEffectImpl(4, 2, create, deps);
  }
  function updateLayoutEffect(create, deps) {
    return updateEffectImpl(4, 4, create, deps);
  }
  function imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
      create = create();
      var refCleanup = ref(create);
      return function() {
        "function" === typeof refCleanup ? refCleanup() : ref(null);
      };
    }
    if (null !== ref && void 0 !== ref)
      return create = create(), ref.current = create, function() {
        ref.current = null;
      };
  }
  function updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
  }
  function mountDebugValue() {
  }
  function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1]))
      return prevState[0];
    hook.memoizedState = [callback, deps];
    return callback;
  }
  function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1]))
      return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
      setIsStrictModeForDevtools(true);
      try {
        nextCreate();
      } finally {
        setIsStrictModeForDevtools(false);
      }
    }
    hook.memoizedState = [prevState, deps];
    return prevState;
  }
  function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824))
      return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
  }
  function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current)
      return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = true), hook;
    if (0 === (renderLanes & 42))
      return didReceiveUpdate = true, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
  }
  function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, false, queue, pendingState);
    try {
      var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
      null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
      if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
        var thenableForFinishedState = chainThenableValue(
          returnValue,
          finishedState
        );
        dispatchSetStateInternal(
          fiber,
          queue,
          thenableForFinishedState,
          requestUpdateLane(fiber)
        );
      } else
        dispatchSetStateInternal(
          fiber,
          queue,
          finishedState,
          requestUpdateLane(fiber)
        );
    } catch (error) {
      dispatchSetStateInternal(
        fiber,
        queue,
        { then: function() {
        }, status: "rejected", reason: error },
        requestUpdateLane()
      );
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
  }
  function noop$2() {
  }
  function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(
      formFiber,
      queue,
      pendingState,
      sharedNotPendingObject,
      null === action ? noop$2 : function() {
        requestFormReset$1(formFiber);
        return action(formData);
      }
    );
  }
  function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
      memoizedState: sharedNotPendingObject,
      baseState: sharedNotPendingObject,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: sharedNotPendingObject
      },
      next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
      memoizedState: initialResetState,
      baseState: initialResetState,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialResetState
      },
      next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
  }
  function requestFormReset$1(formFiber) {
    var resetStateQueue = ensureFormComponentIsStateful(formFiber).next.queue;
    dispatchSetStateInternal(formFiber, resetStateQueue, {}, requestUpdateLane());
  }
  function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
  }
  function updateId() {
    return updateWorkInProgressHook().memoizedState;
  }
  function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
  }
  function refreshCache(fiber) {
    for (var provider = fiber.return; null !== provider; ) {
      switch (provider.tag) {
        case 24:
        case 3:
          var lane = requestUpdateLane();
          fiber = createUpdate(lane);
          var root$41 = enqueueUpdate(provider, fiber, lane);
          null !== root$41 && (scheduleUpdateOnFiber(root$41, provider, lane), entangleTransitions(root$41, provider, lane));
          provider = { cache: createCache() };
          fiber.payload = provider;
          return;
      }
      provider = provider.return;
    }
  }
  function dispatchReducerAction(fiber, queue, action) {
    var lane = requestUpdateLane();
    action = {
      lane,
      revertLane: 0,
      action,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
  }
  function dispatchSetState(fiber, queue, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action, lane);
  }
  function dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
      lane,
      revertLane: 0,
      action,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
    else {
      var alternate = fiber.alternate;
      if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate))
        try {
          var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
          update.hasEagerState = true;
          update.eagerState = eagerState;
          if (objectIs(eagerState, currentState))
            return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), false;
        } catch (error) {
        } finally {
        }
      action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
      if (null !== action)
        return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), true;
    }
    return false;
  }
  function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
      lane: 2,
      revertLane: requestTransitionLane(),
      action,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
      if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
    } else
      throwIfDuringRender = enqueueConcurrentHookUpdate(
        fiber,
        queue,
        action,
        2
      ), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
  }
  function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
  }
  function enqueueRenderPhaseUpdate(queue, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
  }
  function entangleTransitionUpdate(root2, queue, lane) {
    if (0 !== (lane & 4194048)) {
      var queueLanes = queue.lanes;
      queueLanes &= root2.pendingLanes;
      lane |= queueLanes;
      queue.lanes = lane;
      markRootEntangled(root2, lane);
    }
  }
  var ContextOnlyDispatcher = {
    readContext,
    use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
  }, HooksDispatcherOnMount = {
    readContext,
    use,
    useCallback: function(callback, deps) {
      mountWorkInProgressHook().memoizedState = [
        callback,
        void 0 === deps ? null : deps
      ];
      return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create, deps) {
      deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
      mountEffectImpl(
        4194308,
        4,
        imperativeHandleEffect.bind(null, create, ref),
        deps
      );
    },
    useLayoutEffect: function(create, deps) {
      return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
      mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
      var hook = mountWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var nextValue = nextCreate();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          nextCreate();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      hook.memoizedState = [nextValue, deps];
      return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
      var hook = mountWorkInProgressHook();
      if (void 0 !== init) {
        var initialState = init(initialArg);
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
          setIsStrictModeForDevtools(true);
          try {
            init(initialArg);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
      } else initialState = initialArg;
      hook.memoizedState = hook.baseState = initialState;
      reducer = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: reducer,
        lastRenderedState: initialState
      };
      hook.queue = reducer;
      reducer = reducer.dispatch = dispatchReducerAction.bind(
        null,
        currentlyRenderingFiber,
        reducer
      );
      return [hook.memoizedState, reducer];
    },
    useRef: function(initialValue) {
      var hook = mountWorkInProgressHook();
      initialValue = { current: initialValue };
      return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
      initialState = mountStateImpl(initialState);
      var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
      queue.dispatch = dispatch;
      return [initialState.memoizedState, dispatch];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
      var hook = mountWorkInProgressHook();
      return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
      var stateHook = mountStateImpl(false);
      stateHook = startTransition.bind(
        null,
        currentlyRenderingFiber,
        stateHook.queue,
        true,
        false
      );
      mountWorkInProgressHook().memoizedState = stateHook;
      return [false, stateHook];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
      var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
      if (isHydrating) {
        if (void 0 === getServerSnapshot)
          throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
      } else {
        getServerSnapshot = getSnapshot();
        if (null === workInProgressRoot)
          throw Error(formatProdErrorMessage(349));
        0 !== (workInProgressRootRenderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
      }
      hook.memoizedState = getServerSnapshot;
      var inst = { value: getServerSnapshot, getSnapshot };
      hook.queue = inst;
      mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
        subscribe
      ]);
      fiber.flags |= 2048;
      pushSimpleEffect(
        9,
        createEffectInstance(),
        updateStoreInstance.bind(
          null,
          fiber,
          inst,
          getServerSnapshot,
          getSnapshot
        ),
        null
      );
      return getServerSnapshot;
    },
    useId: function() {
      var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
      if (isHydrating) {
        var JSCompiler_inline_result = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
        identifierPrefix = "«" + identifierPrefix + "R" + JSCompiler_inline_result;
        JSCompiler_inline_result = localIdCounter++;
        0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
        identifierPrefix += "»";
      } else
        JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "«" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "»";
      return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
      var hook = mountWorkInProgressHook();
      hook.memoizedState = hook.baseState = passthrough;
      var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      hook.queue = queue;
      hook = dispatchOptimisticSetState.bind(
        null,
        currentlyRenderingFiber,
        true,
        queue
      );
      queue.dispatch = hook;
      return [passthrough, hook];
    },
    useMemoCache,
    useCacheRefresh: function() {
      return mountWorkInProgressHook().memoizedState = refreshCache.bind(
        null,
        currentlyRenderingFiber
      );
    }
  }, HooksDispatcherOnUpdate = {
    readContext,
    use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
      return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    },
    useTransition: function() {
      var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start
      ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer) {
      var hook = updateWorkInProgressHook();
      return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache,
    useCacheRefresh: updateRefresh
  }, HooksDispatcherOnRerender = {
    readContext,
    use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
      return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    },
    useTransition: function() {
      var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start
      ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
      var hook = updateWorkInProgressHook();
      if (null !== currentHook)
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
      hook.baseState = passthrough;
      return [passthrough, hook.queue.dispatch];
    },
    useMemoCache,
    useCacheRefresh: updateRefresh
  }, thenableState = null, thenableIndexCounter = 0;
  function unwrapThenable(thenable) {
    var index2 = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    return trackUsedThenable(thenableState, thenable, index2);
  }
  function coerceRef(workInProgress2, element) {
    element = element.props.ref;
    workInProgress2.ref = void 0 !== element ? element : null;
  }
  function throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE)
      throw Error(formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(
      formatProdErrorMessage(
        31,
        "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber
      )
    );
  }
  function resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
  }
  function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
      if (shouldTrackSideEffects) {
        var deletions = returnFiber.deletions;
        null === deletions ? (returnFiber.deletions = [childToDelete], returnFiber.flags |= 16) : deletions.push(childToDelete);
      }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
      if (!shouldTrackSideEffects) return null;
      for (; null !== currentFirstChild; )
        deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
      return null;
    }
    function mapRemainingChildren(currentFirstChild) {
      for (var existingChildren = /* @__PURE__ */ new Map(); null !== currentFirstChild; )
        null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
      return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
      fiber = createWorkInProgress(fiber, pendingProps);
      fiber.index = 0;
      fiber.sibling = null;
      return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
      newFiber.index = newIndex;
      if (!shouldTrackSideEffects)
        return newFiber.flags |= 1048576, lastPlacedIndex;
      newIndex = newFiber.alternate;
      if (null !== newIndex)
        return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
      newFiber.flags |= 67108866;
      return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
      shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
      return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
      if (null === current || 6 !== current.tag)
        return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
      current = useFiber(current, textContent);
      current.return = returnFiber;
      return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
      var elementType = element.type;
      if (elementType === REACT_FRAGMENT_TYPE)
        return updateFragment(
          returnFiber,
          current,
          element.props.children,
          lanes,
          element.key
        );
      if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type))
        return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
      current = createFiberFromTypeAndProps(
        element.type,
        element.key,
        element.props,
        null,
        returnFiber.mode,
        lanes
      );
      coerceRef(current, element);
      current.return = returnFiber;
      return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
      if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation)
        return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
      current = useFiber(current, portal.children || []);
      current.return = returnFiber;
      return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
      if (null === current || 7 !== current.tag)
        return current = createFiberFromFragment(
          fragment,
          returnFiber.mode,
          lanes,
          key
        ), current.return = returnFiber, current;
      current = useFiber(current, fragment);
      current.return = returnFiber;
      return current;
    }
    function createChild(returnFiber, newChild, lanes) {
      if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
        return newChild = createFiberFromText(
          "" + newChild,
          returnFiber.mode,
          lanes
        ), newChild.return = returnFiber, newChild;
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            return lanes = createFiberFromTypeAndProps(
              newChild.type,
              newChild.key,
              newChild.props,
              null,
              returnFiber.mode,
              lanes
            ), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
          case REACT_PORTAL_TYPE:
            return newChild = createFiberFromPortal(
              newChild,
              returnFiber.mode,
              lanes
            ), newChild.return = returnFiber, newChild;
          case REACT_LAZY_TYPE:
            var init = newChild._init;
            newChild = init(newChild._payload);
            return createChild(returnFiber, newChild, lanes);
        }
        if (isArrayImpl(newChild) || getIteratorFn(newChild))
          return newChild = createFiberFromFragment(
            newChild,
            returnFiber.mode,
            lanes,
            null
          ), newChild.return = returnFiber, newChild;
        if ("function" === typeof newChild.then)
          return createChild(returnFiber, unwrapThenable(newChild), lanes);
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return createChild(
            returnFiber,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectType(returnFiber, newChild);
      }
      return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
      var key = null !== oldFiber ? oldFiber.key : null;
      if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
        return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
          case REACT_PORTAL_TYPE:
            return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
          case REACT_LAZY_TYPE:
            return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
        }
        if (isArrayImpl(newChild) || getIteratorFn(newChild))
          return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
        if ("function" === typeof newChild.then)
          return updateSlot(
            returnFiber,
            oldFiber,
            unwrapThenable(newChild),
            lanes
          );
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return updateSlot(
            returnFiber,
            oldFiber,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectType(returnFiber, newChild);
      }
      return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
      if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
        return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            return existingChildren = existingChildren.get(
              null === newChild.key ? newIdx : newChild.key
            ) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
          case REACT_PORTAL_TYPE:
            return existingChildren = existingChildren.get(
              null === newChild.key ? newIdx : newChild.key
            ) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
          case REACT_LAZY_TYPE:
            var init = newChild._init;
            newChild = init(newChild._payload);
            return updateFromMap(
              existingChildren,
              returnFiber,
              newIdx,
              newChild,
              lanes
            );
        }
        if (isArrayImpl(newChild) || getIteratorFn(newChild))
          return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
        if ("function" === typeof newChild.then)
          return updateFromMap(
            existingChildren,
            returnFiber,
            newIdx,
            unwrapThenable(newChild),
            lanes
          );
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return updateFromMap(
            existingChildren,
            returnFiber,
            newIdx,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectType(returnFiber, newChild);
      }
      return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
      for (var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++) {
        oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
        var newFiber = updateSlot(
          returnFiber,
          oldFiber,
          newChildren[newIdx],
          lanes
        );
        if (null === newFiber) {
          null === oldFiber && (oldFiber = nextOldFiber);
          break;
        }
        shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
        currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
        null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
        previousNewFiber = newFiber;
        oldFiber = nextOldFiber;
      }
      if (newIdx === newChildren.length)
        return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
      if (null === oldFiber) {
        for (; newIdx < newChildren.length; newIdx++)
          oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(
            oldFiber,
            currentFirstChild,
            newIdx
          ), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      for (oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)
        nextOldFiber = updateFromMap(
          oldFiber,
          returnFiber,
          newIdx,
          newChildren[newIdx],
          lanes
        ), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(
          null === nextOldFiber.key ? newIdx : nextOldFiber.key
        ), currentFirstChild = placeChild(
          nextOldFiber,
          currentFirstChild,
          newIdx
        ), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
      shouldTrackSideEffects && oldFiber.forEach(function(child) {
        return deleteChild(returnFiber, child);
      });
      isHydrating && pushTreeFork(returnFiber, newIdx);
      return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
      if (null == newChildren) throw Error(formatProdErrorMessage(151));
      for (var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()) {
        oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
        var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
        if (null === newFiber) {
          null === oldFiber && (oldFiber = nextOldFiber);
          break;
        }
        shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
        currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
        null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
        previousNewFiber = newFiber;
        oldFiber = nextOldFiber;
      }
      if (step.done)
        return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
      if (null === oldFiber) {
        for (; !step.done; newIdx++, step = newChildren.next())
          step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      for (oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())
        step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
      shouldTrackSideEffects && oldFiber.forEach(function(child) {
        return deleteChild(returnFiber, child);
      });
      isHydrating && pushTreeFork(returnFiber, newIdx);
      return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
      "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            a: {
              for (var key = newChild.key; null !== currentFirstChild; ) {
                if (currentFirstChild.key === key) {
                  key = newChild.type;
                  if (key === REACT_FRAGMENT_TYPE) {
                    if (7 === currentFirstChild.tag) {
                      deleteRemainingChildren(
                        returnFiber,
                        currentFirstChild.sibling
                      );
                      lanes = useFiber(
                        currentFirstChild,
                        newChild.props.children
                      );
                      lanes.return = returnFiber;
                      returnFiber = lanes;
                      break a;
                    }
                  } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                    deleteRemainingChildren(
                      returnFiber,
                      currentFirstChild.sibling
                    );
                    lanes = useFiber(currentFirstChild, newChild.props);
                    coerceRef(lanes, newChild);
                    lanes.return = returnFiber;
                    returnFiber = lanes;
                    break a;
                  }
                  deleteRemainingChildren(returnFiber, currentFirstChild);
                  break;
                } else deleteChild(returnFiber, currentFirstChild);
                currentFirstChild = currentFirstChild.sibling;
              }
              newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(
                newChild.props.children,
                returnFiber.mode,
                lanes,
                newChild.key
              ), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(
                newChild.type,
                newChild.key,
                newChild.props,
                null,
                returnFiber.mode,
                lanes
              ), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
            }
            return placeSingleChild(returnFiber);
          case REACT_PORTAL_TYPE:
            a: {
              for (key = newChild.key; null !== currentFirstChild; ) {
                if (currentFirstChild.key === key)
                  if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                    deleteRemainingChildren(
                      returnFiber,
                      currentFirstChild.sibling
                    );
                    lanes = useFiber(currentFirstChild, newChild.children || []);
                    lanes.return = returnFiber;
                    returnFiber = lanes;
                    break a;
                  } else {
                    deleteRemainingChildren(returnFiber, currentFirstChild);
                    break;
                  }
                else deleteChild(returnFiber, currentFirstChild);
                currentFirstChild = currentFirstChild.sibling;
              }
              lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
              lanes.return = returnFiber;
              returnFiber = lanes;
            }
            return placeSingleChild(returnFiber);
          case REACT_LAZY_TYPE:
            return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(
              returnFiber,
              currentFirstChild,
              newChild,
              lanes
            );
        }
        if (isArrayImpl(newChild))
          return reconcileChildrenArray(
            returnFiber,
            currentFirstChild,
            newChild,
            lanes
          );
        if (getIteratorFn(newChild)) {
          key = getIteratorFn(newChild);
          if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
          newChild = key.call(newChild);
          return reconcileChildrenIterator(
            returnFiber,
            currentFirstChild,
            newChild,
            lanes
          );
        }
        if ("function" === typeof newChild.then)
          return reconcileChildFibersImpl(
            returnFiber,
            currentFirstChild,
            unwrapThenable(newChild),
            lanes
          );
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return reconcileChildFibersImpl(
            returnFiber,
            currentFirstChild,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectType(returnFiber, newChild);
      }
      return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
      try {
        thenableIndexCounter = 0;
        var firstChildFiber = reconcileChildFibersImpl(
          returnFiber,
          currentFirstChild,
          newChild,
          lanes
        );
        thenableState = null;
        return firstChildFiber;
      } catch (x) {
        if (x === SuspenseException || x === SuspenseActionException) throw x;
        var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
        fiber.lanes = lanes;
        fiber.return = returnFiber;
        return fiber;
      } finally {
      }
    };
  }
  var reconcileChildFibers = createChildReconciler(true), mountChildFibers = createChildReconciler(false), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
  function pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    push(suspenseStackCursor, suspenseStackCursor.current & 1);
    push(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
  }
  function pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
      if (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary) {
        var current = fiber.alternate;
        null !== current && null !== current.memoizedState && (shellBoundary = fiber);
      }
    } else reuseSuspenseHandlerOnStack();
  }
  function reuseSuspenseHandlerOnStack() {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
  }
  function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
  }
  var suspenseStackCursor = createCursor(0);
  function findFirstSuspended(row) {
    for (var node = row; null !== node; ) {
      if (13 === node.tag) {
        var state = node.memoizedState;
        if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || isSuspenseInstanceFallback(state)))
          return node;
      } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
        if (0 !== (node.flags & 128)) return node;
      } else if (null !== node.child) {
        node.child.return = node;
        node = node.child;
        continue;
      }
      if (node === row) break;
      for (; null === node.sibling; ) {
        if (null === node.return || node.return === row) return null;
        node = node.return;
      }
      node.sibling.return = node.return;
      node = node.sibling;
    }
    return null;
  }
  function applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress2.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
    workInProgress2.memoizedState = getDerivedStateFromProps;
    0 === workInProgress2.lanes && (workInProgress2.updateQueue.baseState = getDerivedStateFromProps);
  }
  var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
      inst = inst._reactInternals;
      var lane = requestUpdateLane(), update = createUpdate(lane);
      update.payload = payload;
      void 0 !== callback && null !== callback && (update.callback = callback);
      payload = enqueueUpdate(inst, update, lane);
      null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
      inst = inst._reactInternals;
      var lane = requestUpdateLane(), update = createUpdate(lane);
      update.tag = 1;
      update.payload = payload;
      void 0 !== callback && null !== callback && (update.callback = callback);
      payload = enqueueUpdate(inst, update, lane);
      null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
      inst = inst._reactInternals;
      var lane = requestUpdateLane(), update = createUpdate(lane);
      update.tag = 2;
      void 0 !== callback && null !== callback && (update.callback = callback);
      callback = enqueueUpdate(inst, update, lane);
      null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
  };
  function checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress2 = workInProgress2.stateNode;
    return "function" === typeof workInProgress2.shouldComponentUpdate ? workInProgress2.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : true;
  }
  function callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext) {
    workInProgress2 = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress2 && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
  }
  function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
      newProps = {};
      for (var propName in baseProps)
        "ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
      newProps === baseProps && (newProps = assign({}, newProps));
      for (var propName$73 in Component)
        void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
  }
  var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
      var event = new window.ErrorEvent("error", {
        bubbles: true,
        cancelable: true,
        message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
        error
      });
      if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof process && "function" === typeof process.emit) {
      process.emit("uncaughtException", error);
      return;
    }
    console.error(error);
  };
  function defaultOnUncaughtError(error) {
    reportGlobalError(error);
  }
  function defaultOnCaughtError(error) {
    console.error(error);
  }
  function defaultOnRecoverableError(error) {
    reportGlobalError(error);
  }
  function logUncaughtError(root2, errorInfo) {
    try {
      var onUncaughtError = root2.onUncaughtError;
      onUncaughtError(errorInfo.value, { componentStack: errorInfo.stack });
    } catch (e$74) {
      setTimeout(function() {
        throw e$74;
      });
    }
  }
  function logCaughtError(root2, boundary, errorInfo) {
    try {
      var onCaughtError = root2.onCaughtError;
      onCaughtError(errorInfo.value, {
        componentStack: errorInfo.stack,
        errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
      });
    } catch (e$75) {
      setTimeout(function() {
        throw e$75;
      });
    }
  }
  function createRootErrorUpdate(root2, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = { element: null };
    lane.callback = function() {
      logUncaughtError(root2, errorInfo);
    };
    return lane;
  }
  function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
  }
  function initializeClassErrorUpdate(update, root2, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
      var error = errorInfo.value;
      update.payload = function() {
        return getDerivedStateFromError(error);
      };
      update.callback = function() {
        logCaughtError(root2, fiber, errorInfo);
      };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
      logCaughtError(root2, fiber, errorInfo);
      "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = /* @__PURE__ */ new Set([this]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
      var stack = errorInfo.stack;
      this.componentDidCatch(errorInfo.value, {
        componentStack: null !== stack ? stack : ""
      });
    });
  }
  function throwException(root2, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
      returnFiber = sourceFiber.alternate;
      null !== returnFiber && propagateParentContextChanges(
        returnFiber,
        sourceFiber,
        rootRenderLanes,
        true
      );
      sourceFiber = suspenseHandlerStackCursor.current;
      if (null !== sourceFiber) {
        switch (sourceFiber.tag) {
          case 13:
            return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = /* @__PURE__ */ new Set([value]) : returnFiber.add(value), attachPingListener(root2, value, rootRenderLanes)), false;
          case 22:
            return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([value])
            }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = /* @__PURE__ */ new Set([value]) : sourceFiber.add(value)), attachPingListener(root2, value, rootRenderLanes)), false;
        }
        throw Error(formatProdErrorMessage(435, sourceFiber.tag));
      }
      attachPingListener(root2, value, rootRenderLanes);
      renderDidSuspendDelayIfPossible();
      return false;
    }
    if (isHydrating)
      return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root2 = Error(formatProdErrorMessage(422), { cause: value }), queueHydrationError(createCapturedValueAtFiber(root2, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
        cause: value
      }), queueHydrationError(
        createCapturedValueAtFiber(returnFiber, sourceFiber)
      )), root2 = root2.current.alternate, root2.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root2.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(
        root2.stateNode,
        value,
        rootRenderLanes
      ), enqueueCapturedUpdate(root2, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), false;
    var wrapperError = Error(formatProdErrorMessage(520), { cause: value });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [wrapperError] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return true;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
      switch (sourceFiber.tag) {
        case 3:
          return sourceFiber.flags |= 65536, root2 = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root2, root2 = createRootErrorUpdate(sourceFiber.stateNode, value, root2), enqueueCapturedUpdate(sourceFiber, root2), false;
        case 1:
          if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError))))
            return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(
              rootRenderLanes,
              root2,
              sourceFiber,
              value
            ), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), false;
      }
      sourceFiber = sourceFiber.return;
    } while (null !== sourceFiber);
    return false;
  }
  var SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = false;
  function reconcileChildren(current, workInProgress2, nextChildren, renderLanes2) {
    workInProgress2.child = null === current ? mountChildFibers(workInProgress2, null, nextChildren, renderLanes2) : reconcileChildFibers(
      workInProgress2,
      current.child,
      nextChildren,
      renderLanes2
    );
  }
  function updateForwardRef(current, workInProgress2, Component, nextProps, renderLanes2) {
    Component = Component.render;
    var ref = workInProgress2.ref;
    if ("ref" in nextProps) {
      var propsWithoutRef = {};
      for (var key in nextProps)
        "ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress2);
    nextProps = renderWithHooks(
      current,
      workInProgress2,
      Component,
      propsWithoutRef,
      ref,
      renderLanes2
    );
    key = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate)
      return bailoutHooks(current, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2);
    isHydrating && key && pushMaterializedTreeId(workInProgress2);
    workInProgress2.flags |= 1;
    reconcileChildren(current, workInProgress2, nextProps, renderLanes2);
    return workInProgress2.child;
  }
  function updateMemoComponent(current, workInProgress2, Component, nextProps, renderLanes2) {
    if (null === current) {
      var type = Component.type;
      if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare)
        return workInProgress2.tag = 15, workInProgress2.type = type, updateSimpleMemoComponent(
          current,
          workInProgress2,
          type,
          nextProps,
          renderLanes2
        );
      current = createFiberFromTypeAndProps(
        Component.type,
        null,
        nextProps,
        workInProgress2,
        workInProgress2.mode,
        renderLanes2
      );
      current.ref = workInProgress2.ref;
      current.return = workInProgress2;
      return workInProgress2.child = current;
    }
    type = current.child;
    if (!checkScheduledUpdateOrContext(current, renderLanes2)) {
      var prevProps = type.memoizedProps;
      Component = Component.compare;
      Component = null !== Component ? Component : shallowEqual;
      if (Component(prevProps, nextProps) && current.ref === workInProgress2.ref)
        return bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2);
    }
    workInProgress2.flags |= 1;
    current = createWorkInProgress(type, nextProps);
    current.ref = workInProgress2.ref;
    current.return = workInProgress2;
    return workInProgress2.child = current;
  }
  function updateSimpleMemoComponent(current, workInProgress2, Component, nextProps, renderLanes2) {
    if (null !== current) {
      var prevProps = current.memoizedProps;
      if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress2.ref)
        if (didReceiveUpdate = false, workInProgress2.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes2))
          0 !== (current.flags & 131072) && (didReceiveUpdate = true);
        else
          return workInProgress2.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2);
    }
    return updateFunctionComponent(
      current,
      workInProgress2,
      Component,
      nextProps,
      renderLanes2
    );
  }
  function updateOffscreenComponent(current, workInProgress2, renderLanes2) {
    var nextProps = workInProgress2.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
      if (0 !== (workInProgress2.flags & 128)) {
        nextProps = null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2;
        if (null !== current) {
          nextChildren = workInProgress2.child = current.child;
          for (prevState = 0; null !== nextChildren; )
            prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
          workInProgress2.childLanes = prevState & ~nextProps;
        } else workInProgress2.childLanes = 0, workInProgress2.child = null;
        return deferHiddenOffscreenComponent(
          current,
          workInProgress2,
          nextProps,
          renderLanes2
        );
      }
      if (0 !== (renderLanes2 & 536870912))
        workInProgress2.memoizedState = { baseLanes: 0, cachePool: null }, null !== current && pushTransition(
          workInProgress2,
          null !== prevState ? prevState.cachePool : null
        ), null !== prevState ? pushHiddenContext(workInProgress2, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress2);
      else
        return workInProgress2.lanes = workInProgress2.childLanes = 536870912, deferHiddenOffscreenComponent(
          current,
          workInProgress2,
          null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2,
          renderLanes2
        );
    } else
      null !== prevState ? (pushTransition(workInProgress2, prevState.cachePool), pushHiddenContext(workInProgress2, prevState), reuseSuspenseHandlerOnStack(), workInProgress2.memoizedState = null) : (null !== current && pushTransition(workInProgress2, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack());
    reconcileChildren(current, workInProgress2, nextChildren, renderLanes2);
    return workInProgress2.child;
  }
  function deferHiddenOffscreenComponent(current, workInProgress2, nextBaseLanes, renderLanes2) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : { parent: CacheContext._currentValue, pool: JSCompiler_inline_result };
    workInProgress2.memoizedState = {
      baseLanes: nextBaseLanes,
      cachePool: JSCompiler_inline_result
    };
    null !== current && pushTransition(workInProgress2, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress2);
    null !== current && propagateParentContextChanges(current, workInProgress2, renderLanes2, true);
    return null;
  }
  function markRef(current, workInProgress2) {
    var ref = workInProgress2.ref;
    if (null === ref)
      null !== current && null !== current.ref && (workInProgress2.flags |= 4194816);
    else {
      if ("function" !== typeof ref && "object" !== typeof ref)
        throw Error(formatProdErrorMessage(284));
      if (null === current || current.ref !== ref)
        workInProgress2.flags |= 4194816;
    }
  }
  function updateFunctionComponent(current, workInProgress2, Component, nextProps, renderLanes2) {
    prepareToReadContext(workInProgress2);
    Component = renderWithHooks(
      current,
      workInProgress2,
      Component,
      nextProps,
      void 0,
      renderLanes2
    );
    nextProps = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate)
      return bailoutHooks(current, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress2);
    workInProgress2.flags |= 1;
    reconcileChildren(current, workInProgress2, Component, renderLanes2);
    return workInProgress2.child;
  }
  function replayFunctionComponent(current, workInProgress2, nextProps, Component, secondArg, renderLanes2) {
    prepareToReadContext(workInProgress2);
    workInProgress2.updateQueue = null;
    nextProps = renderWithHooksAgain(
      workInProgress2,
      Component,
      nextProps,
      secondArg
    );
    finishRenderingHooks(current);
    Component = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate)
      return bailoutHooks(current, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2);
    isHydrating && Component && pushMaterializedTreeId(workInProgress2);
    workInProgress2.flags |= 1;
    reconcileChildren(current, workInProgress2, nextProps, renderLanes2);
    return workInProgress2.child;
  }
  function updateClassComponent(current, workInProgress2, Component, nextProps, renderLanes2) {
    prepareToReadContext(workInProgress2);
    if (null === workInProgress2.stateNode) {
      var context = emptyContextObject, contextType = Component.contextType;
      "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
      context = new Component(nextProps, context);
      workInProgress2.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
      context.updater = classComponentUpdater;
      workInProgress2.stateNode = context;
      context._reactInternals = workInProgress2;
      context = workInProgress2.stateNode;
      context.props = nextProps;
      context.state = workInProgress2.memoizedState;
      context.refs = {};
      initializeUpdateQueue(workInProgress2);
      contextType = Component.contextType;
      context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
      context.state = workInProgress2.memoizedState;
      contextType = Component.getDerivedStateFromProps;
      "function" === typeof contextType && (applyDerivedStateFromProps(
        workInProgress2,
        Component,
        contextType,
        nextProps
      ), context.state = workInProgress2.memoizedState);
      "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress2, nextProps, context, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress2.memoizedState);
      "function" === typeof context.componentDidMount && (workInProgress2.flags |= 4194308);
      nextProps = true;
    } else if (null === current) {
      context = workInProgress2.stateNode;
      var unresolvedOldProps = workInProgress2.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
      context.props = oldProps;
      var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
      contextType = emptyContextObject;
      "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
      var getDerivedStateFromProps = Component.getDerivedStateFromProps;
      contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
      unresolvedOldProps = workInProgress2.pendingProps !== unresolvedOldProps;
      contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(
        workInProgress2,
        context,
        nextProps,
        contextType
      );
      hasForceUpdate = false;
      var oldState = workInProgress2.memoizedState;
      context.state = oldState;
      processUpdateQueue(workInProgress2, nextProps, context, renderLanes2);
      suspendIfUpdateReadFromEntangledAsyncAction();
      oldContext = workInProgress2.memoizedState;
      unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(
        workInProgress2,
        Component,
        getDerivedStateFromProps,
        nextProps
      ), oldContext = workInProgress2.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(
        workInProgress2,
        Component,
        oldProps,
        nextProps,
        oldState,
        oldContext,
        contextType
      )) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress2.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress2.flags |= 4194308), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress2.flags |= 4194308), nextProps = false);
    } else {
      context = workInProgress2.stateNode;
      cloneUpdateQueue(current, workInProgress2);
      contextType = workInProgress2.memoizedProps;
      contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
      context.props = contextType$jscomp$0;
      getDerivedStateFromProps = workInProgress2.pendingProps;
      oldState = context.context;
      oldContext = Component.contextType;
      oldProps = emptyContextObject;
      "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
      unresolvedOldProps = Component.getDerivedStateFromProps;
      (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(
        workInProgress2,
        context,
        nextProps,
        oldProps
      );
      hasForceUpdate = false;
      oldState = workInProgress2.memoizedState;
      context.state = oldState;
      processUpdateQueue(workInProgress2, nextProps, context, renderLanes2);
      suspendIfUpdateReadFromEntangledAsyncAction();
      var newState = workInProgress2.memoizedState;
      contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(
        workInProgress2,
        Component,
        unresolvedOldProps,
        nextProps
      ), newState = workInProgress2.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(
        workInProgress2,
        Component,
        contextType$jscomp$0,
        nextProps,
        oldState,
        newState,
        oldProps
      ) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(
        nextProps,
        newState,
        oldProps
      )), "function" === typeof context.componentDidUpdate && (workInProgress2.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress2.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress2.flags |= 1024), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress2.flags |= 1024), nextProps = false);
    }
    context = nextProps;
    markRef(current, workInProgress2);
    nextProps = 0 !== (workInProgress2.flags & 128);
    context || nextProps ? (context = workInProgress2.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress2.flags |= 1, null !== current && nextProps ? (workInProgress2.child = reconcileChildFibers(
      workInProgress2,
      current.child,
      null,
      renderLanes2
    ), workInProgress2.child = reconcileChildFibers(
      workInProgress2,
      null,
      Component,
      renderLanes2
    )) : reconcileChildren(current, workInProgress2, Component, renderLanes2), workInProgress2.memoizedState = context.state, current = workInProgress2.child) : current = bailoutOnAlreadyFinishedWork(
      current,
      workInProgress2,
      renderLanes2
    );
    return current;
  }
  function mountHostRootWithoutHydrating(current, workInProgress2, nextChildren, renderLanes2) {
    resetHydrationState();
    workInProgress2.flags |= 256;
    reconcileChildren(current, workInProgress2, nextChildren, renderLanes2);
    return workInProgress2.child;
  }
  var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function mountSuspenseOffscreenState(renderLanes2) {
    return { baseLanes: renderLanes2, cachePool: getSuspendedCache() };
  }
  function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes2) {
    current = null !== current ? current.childLanes & ~renderLanes2 : 0;
    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
    return current;
  }
  function updateSuspenseComponent(current, workInProgress2, renderLanes2) {
    var nextProps = workInProgress2.pendingProps, showFallback = false, didSuspend = 0 !== (workInProgress2.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? false : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = true, workInProgress2.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress2.flags & 32);
    workInProgress2.flags &= -33;
    if (null === current) {
      if (isHydrating) {
        showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress2) : reuseSuspenseHandlerOnStack();
        if (isHydrating) {
          var nextInstance = nextHydratableInstance, JSCompiler_temp$jscomp$0;
          if (JSCompiler_temp$jscomp$0 = nextInstance) {
            c: {
              JSCompiler_temp$jscomp$0 = nextInstance;
              for (nextInstance = rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType; ) {
                if (!nextInstance) {
                  nextInstance = null;
                  break c;
                }
                JSCompiler_temp$jscomp$0 = getNextHydratable(
                  JSCompiler_temp$jscomp$0.nextSibling
                );
                if (null === JSCompiler_temp$jscomp$0) {
                  nextInstance = null;
                  break c;
                }
              }
              nextInstance = JSCompiler_temp$jscomp$0;
            }
            null !== nextInstance ? (workInProgress2.memoizedState = {
              dehydrated: nextInstance,
              treeContext: null !== treeContextProvider ? { id: treeContextId, overflow: treeContextOverflow } : null,
              retryLane: 536870912,
              hydrationErrors: null
            }, JSCompiler_temp$jscomp$0 = createFiberImplClass(
              18,
              null,
              null,
              0
            ), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress2, workInProgress2.child = JSCompiler_temp$jscomp$0, hydrationParentFiber = workInProgress2, nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = true) : JSCompiler_temp$jscomp$0 = false;
          }
          JSCompiler_temp$jscomp$0 || throwOnHydrationMismatch(workInProgress2);
        }
        nextInstance = workInProgress2.memoizedState;
        if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance))
          return isSuspenseInstanceFallback(nextInstance) ? workInProgress2.lanes = 32 : workInProgress2.lanes = 536870912, null;
        popSuspenseHandler(workInProgress2);
      }
      nextInstance = nextProps.children;
      nextProps = nextProps.fallback;
      if (showFallback)
        return reuseSuspenseHandlerOnStack(), showFallback = workInProgress2.mode, nextInstance = mountWorkInProgressOffscreenFiber(
          { mode: "hidden", children: nextInstance },
          showFallback
        ), nextProps = createFiberFromFragment(
          nextProps,
          showFallback,
          renderLanes2,
          null
        ), nextInstance.return = workInProgress2, nextProps.return = workInProgress2, nextInstance.sibling = nextProps, workInProgress2.child = nextInstance, showFallback = workInProgress2.child, showFallback.memoizedState = mountSuspenseOffscreenState(renderLanes2), showFallback.childLanes = getRemainingWorkInPrimaryTree(
          current,
          JSCompiler_temp,
          renderLanes2
        ), workInProgress2.memoizedState = SUSPENDED_MARKER, nextProps;
      pushPrimaryTreeSuspenseHandler(workInProgress2);
      return mountSuspensePrimaryChildren(workInProgress2, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
      if (didSuspend)
        workInProgress2.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags &= -257, workInProgress2 = retrySuspenseComponentWithoutHydrating(
          current,
          workInProgress2,
          renderLanes2
        )) : null !== workInProgress2.memoizedState ? (reuseSuspenseHandlerOnStack(), workInProgress2.child = current.child, workInProgress2.flags |= 128, workInProgress2 = null) : (reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, nextInstance = workInProgress2.mode, nextProps = mountWorkInProgressOffscreenFiber(
          { mode: "visible", children: nextProps.children },
          nextInstance
        ), showFallback = createFiberFromFragment(
          showFallback,
          nextInstance,
          renderLanes2,
          null
        ), showFallback.flags |= 2, nextProps.return = workInProgress2, showFallback.return = workInProgress2, nextProps.sibling = showFallback, workInProgress2.child = nextProps, reconcileChildFibers(
          workInProgress2,
          current.child,
          null,
          renderLanes2
        ), nextProps = workInProgress2.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes2), nextProps.childLanes = getRemainingWorkInPrimaryTree(
          current,
          JSCompiler_temp,
          renderLanes2
        ), workInProgress2.memoizedState = SUSPENDED_MARKER, workInProgress2 = showFallback);
      else if (pushPrimaryTreeSuspenseHandler(workInProgress2), isSuspenseInstanceFallback(nextInstance)) {
        JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
        if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
        JSCompiler_temp = digest;
        nextProps = Error(formatProdErrorMessage(419));
        nextProps.stack = "";
        nextProps.digest = JSCompiler_temp;
        queueHydrationError({ value: nextProps, source: null, stack: null });
        workInProgress2 = retrySuspenseComponentWithoutHydrating(
          current,
          workInProgress2,
          renderLanes2
        );
      } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress2, renderLanes2, false), JSCompiler_temp = 0 !== (renderLanes2 & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
        JSCompiler_temp = workInProgressRoot;
        if (null !== JSCompiler_temp && (nextProps = renderLanes2 & -renderLanes2, nextProps = 0 !== (nextProps & 42) ? 1 : getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes2)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane))
          throw JSCompiler_temp$jscomp$0.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
        "$?" === nextInstance.data || renderDidSuspendDelayIfPossible();
        workInProgress2 = retrySuspenseComponentWithoutHydrating(
          current,
          workInProgress2,
          renderLanes2
        );
      } else
        "$?" === nextInstance.data ? (workInProgress2.flags |= 192, workInProgress2.child = current.child, workInProgress2 = null) : (current = JSCompiler_temp$jscomp$0.treeContext, nextHydratableInstance = getNextHydratable(
          nextInstance.nextSibling
        ), hydrationParentFiber = workInProgress2, isHydrating = true, hydrationErrors = null, rootOrSingletonContext = false, null !== current && (idStack[idStackIndex++] = treeContextId, idStack[idStackIndex++] = treeContextOverflow, idStack[idStackIndex++] = treeContextProvider, treeContextId = current.id, treeContextOverflow = current.overflow, treeContextProvider = workInProgress2), workInProgress2 = mountSuspensePrimaryChildren(
          workInProgress2,
          nextProps.children
        ), workInProgress2.flags |= 4096);
      return workInProgress2;
    }
    if (showFallback)
      return reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, nextInstance = workInProgress2.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
      }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = createWorkInProgress(digest, showFallback) : (showFallback = createFiberFromFragment(
        showFallback,
        nextInstance,
        renderLanes2,
        null
      ), showFallback.flags |= 2), showFallback.return = workInProgress2, nextProps.return = workInProgress2, nextProps.sibling = showFallback, workInProgress2.child = nextProps, nextProps = showFallback, showFallback = workInProgress2.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = mountSuspenseOffscreenState(renderLanes2) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? { parent: digest, pool: digest } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes2,
        cachePool: JSCompiler_temp$jscomp$0
      }), showFallback.memoizedState = nextInstance, showFallback.childLanes = getRemainingWorkInPrimaryTree(
        current,
        JSCompiler_temp,
        renderLanes2
      ), workInProgress2.memoizedState = SUSPENDED_MARKER, nextProps;
    pushPrimaryTreeSuspenseHandler(workInProgress2);
    renderLanes2 = current.child;
    current = renderLanes2.sibling;
    renderLanes2 = createWorkInProgress(renderLanes2, {
      mode: "visible",
      children: nextProps.children
    });
    renderLanes2.return = workInProgress2;
    renderLanes2.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress2.deletions, null === JSCompiler_temp ? (workInProgress2.deletions = [current], workInProgress2.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress2.child = renderLanes2;
    workInProgress2.memoizedState = null;
    return renderLanes2;
  }
  function mountSuspensePrimaryChildren(workInProgress2, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber(
      { mode: "visible", children: primaryChildren },
      workInProgress2.mode
    );
    primaryChildren.return = workInProgress2;
    return workInProgress2.child = primaryChildren;
  }
  function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    };
    return offscreenProps;
  }
  function retrySuspenseComponentWithoutHydrating(current, workInProgress2, renderLanes2) {
    reconcileChildFibers(workInProgress2, current.child, null, renderLanes2);
    current = mountSuspensePrimaryChildren(
      workInProgress2,
      workInProgress2.pendingProps.children
    );
    current.flags |= 2;
    workInProgress2.memoizedState = null;
    return current;
  }
  function scheduleSuspenseWorkOnFiber(fiber, renderLanes2, propagationRoot) {
    fiber.lanes |= renderLanes2;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes2);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes2, propagationRoot);
  }
  function initSuspenseListRenderState(workInProgress2, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress2.memoizedState;
    null === renderState ? workInProgress2.memoizedState = {
      isBackwards,
      rendering: null,
      renderingStartTime: 0,
      last: lastContentRow,
      tail,
      tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
  }
  function updateSuspenseListComponent(current, workInProgress2, renderLanes2) {
    var nextProps = workInProgress2.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    reconcileChildren(current, workInProgress2, nextProps.children, renderLanes2);
    nextProps = suspenseStackCursor.current;
    if (0 !== (nextProps & 2))
      nextProps = nextProps & 1 | 2, workInProgress2.flags |= 128;
    else {
      if (null !== current && 0 !== (current.flags & 128))
        a: for (current = workInProgress2.child; null !== current; ) {
          if (13 === current.tag)
            null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes2, workInProgress2);
          else if (19 === current.tag)
            scheduleSuspenseWorkOnFiber(current, renderLanes2, workInProgress2);
          else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
          }
          if (current === workInProgress2) break a;
          for (; null === current.sibling; ) {
            if (null === current.return || current.return === workInProgress2)
              break a;
            current = current.return;
          }
          current.sibling.return = current.return;
          current = current.sibling;
        }
      nextProps &= 1;
    }
    push(suspenseStackCursor, nextProps);
    switch (revealOrder) {
      case "forwards":
        renderLanes2 = workInProgress2.child;
        for (revealOrder = null; null !== renderLanes2; )
          current = renderLanes2.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes2), renderLanes2 = renderLanes2.sibling;
        renderLanes2 = revealOrder;
        null === renderLanes2 ? (revealOrder = workInProgress2.child, workInProgress2.child = null) : (revealOrder = renderLanes2.sibling, renderLanes2.sibling = null);
        initSuspenseListRenderState(
          workInProgress2,
          false,
          revealOrder,
          renderLanes2,
          tailMode
        );
        break;
      case "backwards":
        renderLanes2 = null;
        revealOrder = workInProgress2.child;
        for (workInProgress2.child = null; null !== revealOrder; ) {
          current = revealOrder.alternate;
          if (null !== current && null === findFirstSuspended(current)) {
            workInProgress2.child = revealOrder;
            break;
          }
          current = revealOrder.sibling;
          revealOrder.sibling = renderLanes2;
          renderLanes2 = revealOrder;
          revealOrder = current;
        }
        initSuspenseListRenderState(
          workInProgress2,
          true,
          renderLanes2,
          null,
          tailMode
        );
        break;
      case "together":
        initSuspenseListRenderState(workInProgress2, false, null, null, void 0);
        break;
      default:
        workInProgress2.memoizedState = null;
    }
    return workInProgress2.child;
  }
  function bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2) {
    null !== current && (workInProgress2.dependencies = current.dependencies);
    workInProgressRootSkippedLanes |= workInProgress2.lanes;
    if (0 === (renderLanes2 & workInProgress2.childLanes))
      if (null !== current) {
        if (propagateParentContextChanges(
          current,
          workInProgress2,
          renderLanes2,
          false
        ), 0 === (renderLanes2 & workInProgress2.childLanes))
          return null;
      } else return null;
    if (null !== current && workInProgress2.child !== current.child)
      throw Error(formatProdErrorMessage(153));
    if (null !== workInProgress2.child) {
      current = workInProgress2.child;
      renderLanes2 = createWorkInProgress(current, current.pendingProps);
      workInProgress2.child = renderLanes2;
      for (renderLanes2.return = workInProgress2; null !== current.sibling; )
        current = current.sibling, renderLanes2 = renderLanes2.sibling = createWorkInProgress(current, current.pendingProps), renderLanes2.return = workInProgress2;
      renderLanes2.sibling = null;
    }
    return workInProgress2.child;
  }
  function checkScheduledUpdateOrContext(current, renderLanes2) {
    if (0 !== (current.lanes & renderLanes2)) return true;
    current = current.dependencies;
    return null !== current && checkIfContextChanged(current) ? true : false;
  }
  function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress2, renderLanes2) {
    switch (workInProgress2.tag) {
      case 3:
        pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
        pushProvider(workInProgress2, CacheContext, current.memoizedState.cache);
        resetHydrationState();
        break;
      case 27:
      case 5:
        pushHostContext(workInProgress2);
        break;
      case 4:
        pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
        break;
      case 10:
        pushProvider(
          workInProgress2,
          workInProgress2.type,
          workInProgress2.memoizedProps.value
        );
        break;
      case 13:
        var state = workInProgress2.memoizedState;
        if (null !== state) {
          if (null !== state.dehydrated)
            return pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags |= 128, null;
          if (0 !== (renderLanes2 & workInProgress2.child.childLanes))
            return updateSuspenseComponent(current, workInProgress2, renderLanes2);
          pushPrimaryTreeSuspenseHandler(workInProgress2);
          current = bailoutOnAlreadyFinishedWork(
            current,
            workInProgress2,
            renderLanes2
          );
          return null !== current ? current.sibling : null;
        }
        pushPrimaryTreeSuspenseHandler(workInProgress2);
        break;
      case 19:
        var didSuspendBefore = 0 !== (current.flags & 128);
        state = 0 !== (renderLanes2 & workInProgress2.childLanes);
        state || (propagateParentContextChanges(
          current,
          workInProgress2,
          renderLanes2,
          false
        ), state = 0 !== (renderLanes2 & workInProgress2.childLanes));
        if (didSuspendBefore) {
          if (state)
            return updateSuspenseListComponent(
              current,
              workInProgress2,
              renderLanes2
            );
          workInProgress2.flags |= 128;
        }
        didSuspendBefore = workInProgress2.memoizedState;
        null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
        push(suspenseStackCursor, suspenseStackCursor.current);
        if (state) break;
        else return null;
      case 22:
      case 23:
        return workInProgress2.lanes = 0, updateOffscreenComponent(current, workInProgress2, renderLanes2);
      case 24:
        pushProvider(workInProgress2, CacheContext, current.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current, workInProgress2, renderLanes2);
  }
  function beginWork(current, workInProgress2, renderLanes2) {
    if (null !== current)
      if (current.memoizedProps !== workInProgress2.pendingProps)
        didReceiveUpdate = true;
      else {
        if (!checkScheduledUpdateOrContext(current, renderLanes2) && 0 === (workInProgress2.flags & 128))
          return didReceiveUpdate = false, attemptEarlyBailoutIfNoScheduledUpdate(
            current,
            workInProgress2,
            renderLanes2
          );
        didReceiveUpdate = 0 !== (current.flags & 131072) ? true : false;
      }
    else
      didReceiveUpdate = false, isHydrating && 0 !== (workInProgress2.flags & 1048576) && pushTreeId(workInProgress2, treeForkCount, workInProgress2.index);
    workInProgress2.lanes = 0;
    switch (workInProgress2.tag) {
      case 16:
        a: {
          current = workInProgress2.pendingProps;
          var lazyComponent = workInProgress2.elementType, init = lazyComponent._init;
          lazyComponent = init(lazyComponent._payload);
          workInProgress2.type = lazyComponent;
          if ("function" === typeof lazyComponent)
            shouldConstruct(lazyComponent) ? (current = resolveClassComponentProps(lazyComponent, current), workInProgress2.tag = 1, workInProgress2 = updateClassComponent(
              null,
              workInProgress2,
              lazyComponent,
              current,
              renderLanes2
            )) : (workInProgress2.tag = 0, workInProgress2 = updateFunctionComponent(
              null,
              workInProgress2,
              lazyComponent,
              current,
              renderLanes2
            ));
          else {
            if (void 0 !== lazyComponent && null !== lazyComponent) {
              if (init = lazyComponent.$$typeof, init === REACT_FORWARD_REF_TYPE) {
                workInProgress2.tag = 11;
                workInProgress2 = updateForwardRef(
                  null,
                  workInProgress2,
                  lazyComponent,
                  current,
                  renderLanes2
                );
                break a;
              } else if (init === REACT_MEMO_TYPE) {
                workInProgress2.tag = 14;
                workInProgress2 = updateMemoComponent(
                  null,
                  workInProgress2,
                  lazyComponent,
                  current,
                  renderLanes2
                );
                break a;
              }
            }
            workInProgress2 = getComponentNameFromType(lazyComponent) || lazyComponent;
            throw Error(formatProdErrorMessage(306, workInProgress2, ""));
          }
        }
        return workInProgress2;
      case 0:
        return updateFunctionComponent(
          current,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 1:
        return lazyComponent = workInProgress2.type, init = resolveClassComponentProps(
          lazyComponent,
          workInProgress2.pendingProps
        ), updateClassComponent(
          current,
          workInProgress2,
          lazyComponent,
          init,
          renderLanes2
        );
      case 3:
        a: {
          pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          );
          if (null === current) throw Error(formatProdErrorMessage(387));
          lazyComponent = workInProgress2.pendingProps;
          var prevState = workInProgress2.memoizedState;
          init = prevState.element;
          cloneUpdateQueue(current, workInProgress2);
          processUpdateQueue(workInProgress2, lazyComponent, null, renderLanes2);
          var nextState = workInProgress2.memoizedState;
          lazyComponent = nextState.cache;
          pushProvider(workInProgress2, CacheContext, lazyComponent);
          lazyComponent !== prevState.cache && propagateContextChanges(
            workInProgress2,
            [CacheContext],
            renderLanes2,
            true
          );
          suspendIfUpdateReadFromEntangledAsyncAction();
          lazyComponent = nextState.element;
          if (prevState.isDehydrated)
            if (prevState = {
              element: lazyComponent,
              isDehydrated: false,
              cache: nextState.cache
            }, workInProgress2.updateQueue.baseState = prevState, workInProgress2.memoizedState = prevState, workInProgress2.flags & 256) {
              workInProgress2 = mountHostRootWithoutHydrating(
                current,
                workInProgress2,
                lazyComponent,
                renderLanes2
              );
              break a;
            } else if (lazyComponent !== init) {
              init = createCapturedValueAtFiber(
                Error(formatProdErrorMessage(424)),
                workInProgress2
              );
              queueHydrationError(init);
              workInProgress2 = mountHostRootWithoutHydrating(
                current,
                workInProgress2,
                lazyComponent,
                renderLanes2
              );
              break a;
            } else {
              current = workInProgress2.stateNode.containerInfo;
              switch (current.nodeType) {
                case 9:
                  current = current.body;
                  break;
                default:
                  current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
              }
              nextHydratableInstance = getNextHydratable(current.firstChild);
              hydrationParentFiber = workInProgress2;
              isHydrating = true;
              hydrationErrors = null;
              rootOrSingletonContext = true;
              renderLanes2 = mountChildFibers(
                workInProgress2,
                null,
                lazyComponent,
                renderLanes2
              );
              for (workInProgress2.child = renderLanes2; renderLanes2; )
                renderLanes2.flags = renderLanes2.flags & -3 | 4096, renderLanes2 = renderLanes2.sibling;
            }
          else {
            resetHydrationState();
            if (lazyComponent === init) {
              workInProgress2 = bailoutOnAlreadyFinishedWork(
                current,
                workInProgress2,
                renderLanes2
              );
              break a;
            }
            reconcileChildren(
              current,
              workInProgress2,
              lazyComponent,
              renderLanes2
            );
          }
          workInProgress2 = workInProgress2.child;
        }
        return workInProgress2;
      case 26:
        return markRef(current, workInProgress2), null === current ? (renderLanes2 = getResource(
          workInProgress2.type,
          null,
          workInProgress2.pendingProps,
          null
        )) ? workInProgress2.memoizedState = renderLanes2 : isHydrating || (renderLanes2 = workInProgress2.type, current = workInProgress2.pendingProps, lazyComponent = getOwnerDocumentFromRootContainer(
          rootInstanceStackCursor.current
        ).createElement(renderLanes2), lazyComponent[internalInstanceKey] = workInProgress2, lazyComponent[internalPropsKey] = current, setInitialProperties(lazyComponent, renderLanes2, current), markNodeAsHoistable(lazyComponent), workInProgress2.stateNode = lazyComponent) : workInProgress2.memoizedState = getResource(
          workInProgress2.type,
          current.memoizedProps,
          workInProgress2.pendingProps,
          current.memoizedState
        ), null;
      case 27:
        return pushHostContext(workInProgress2), null === current && isHydrating && (lazyComponent = workInProgress2.stateNode = resolveSingletonInstance(
          workInProgress2.type,
          workInProgress2.pendingProps,
          rootInstanceStackCursor.current
        ), hydrationParentFiber = workInProgress2, rootOrSingletonContext = true, init = nextHydratableInstance, isSingletonScope(workInProgress2.type) ? (previousHydratableOnEnteringScopedSingleton = init, nextHydratableInstance = getNextHydratable(
          lazyComponent.firstChild
        )) : nextHydratableInstance = init), reconcileChildren(
          current,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), markRef(current, workInProgress2), null === current && (workInProgress2.flags |= 4194304), workInProgress2.child;
      case 5:
        if (null === current && isHydrating) {
          if (init = lazyComponent = nextHydratableInstance)
            lazyComponent = canHydrateInstance(
              lazyComponent,
              workInProgress2.type,
              workInProgress2.pendingProps,
              rootOrSingletonContext
            ), null !== lazyComponent ? (workInProgress2.stateNode = lazyComponent, hydrationParentFiber = workInProgress2, nextHydratableInstance = getNextHydratable(
              lazyComponent.firstChild
            ), rootOrSingletonContext = false, init = true) : init = false;
          init || throwOnHydrationMismatch(workInProgress2);
        }
        pushHostContext(workInProgress2);
        init = workInProgress2.type;
        prevState = workInProgress2.pendingProps;
        nextState = null !== current ? current.memoizedProps : null;
        lazyComponent = prevState.children;
        shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && shouldSetTextContent(init, nextState) && (workInProgress2.flags |= 32);
        null !== workInProgress2.memoizedState && (init = renderWithHooks(
          current,
          workInProgress2,
          TransitionAwareHostComponent,
          null,
          null,
          renderLanes2
        ), HostTransitionContext._currentValue = init);
        markRef(current, workInProgress2);
        reconcileChildren(current, workInProgress2, lazyComponent, renderLanes2);
        return workInProgress2.child;
      case 6:
        if (null === current && isHydrating) {
          if (current = renderLanes2 = nextHydratableInstance)
            renderLanes2 = canHydrateTextInstance(
              renderLanes2,
              workInProgress2.pendingProps,
              rootOrSingletonContext
            ), null !== renderLanes2 ? (workInProgress2.stateNode = renderLanes2, hydrationParentFiber = workInProgress2, nextHydratableInstance = null, current = true) : current = false;
          current || throwOnHydrationMismatch(workInProgress2);
        }
        return null;
      case 13:
        return updateSuspenseComponent(current, workInProgress2, renderLanes2);
      case 4:
        return pushHostContainer(
          workInProgress2,
          workInProgress2.stateNode.containerInfo
        ), lazyComponent = workInProgress2.pendingProps, null === current ? workInProgress2.child = reconcileChildFibers(
          workInProgress2,
          null,
          lazyComponent,
          renderLanes2
        ) : reconcileChildren(
          current,
          workInProgress2,
          lazyComponent,
          renderLanes2
        ), workInProgress2.child;
      case 11:
        return updateForwardRef(
          current,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 7:
        return reconcileChildren(
          current,
          workInProgress2,
          workInProgress2.pendingProps,
          renderLanes2
        ), workInProgress2.child;
      case 8:
        return reconcileChildren(
          current,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), workInProgress2.child;
      case 12:
        return reconcileChildren(
          current,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), workInProgress2.child;
      case 10:
        return lazyComponent = workInProgress2.pendingProps, pushProvider(workInProgress2, workInProgress2.type, lazyComponent.value), reconcileChildren(
          current,
          workInProgress2,
          lazyComponent.children,
          renderLanes2
        ), workInProgress2.child;
      case 9:
        return init = workInProgress2.type._context, lazyComponent = workInProgress2.pendingProps.children, prepareToReadContext(workInProgress2), init = readContext(init), lazyComponent = lazyComponent(init), workInProgress2.flags |= 1, reconcileChildren(current, workInProgress2, lazyComponent, renderLanes2), workInProgress2.child;
      case 14:
        return updateMemoComponent(
          current,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 15:
        return updateSimpleMemoComponent(
          current,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 19:
        return updateSuspenseListComponent(current, workInProgress2, renderLanes2);
      case 31:
        return lazyComponent = workInProgress2.pendingProps, renderLanes2 = workInProgress2.mode, lazyComponent = {
          mode: lazyComponent.mode,
          children: lazyComponent.children
        }, null === current ? (renderLanes2 = mountWorkInProgressOffscreenFiber(
          lazyComponent,
          renderLanes2
        ), renderLanes2.ref = workInProgress2.ref, workInProgress2.child = renderLanes2, renderLanes2.return = workInProgress2, workInProgress2 = renderLanes2) : (renderLanes2 = createWorkInProgress(current.child, lazyComponent), renderLanes2.ref = workInProgress2.ref, workInProgress2.child = renderLanes2, renderLanes2.return = workInProgress2, workInProgress2 = renderLanes2), workInProgress2;
      case 22:
        return updateOffscreenComponent(current, workInProgress2, renderLanes2);
      case 24:
        return prepareToReadContext(workInProgress2), lazyComponent = readContext(CacheContext), null === current ? (init = peekCacheFromPool(), null === init && (init = workInProgressRoot, prevState = createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes2), init = prevState), workInProgress2.memoizedState = {
          parent: lazyComponent,
          cache: init
        }, initializeUpdateQueue(workInProgress2), pushProvider(workInProgress2, CacheContext, init)) : (0 !== (current.lanes & renderLanes2) && (cloneUpdateQueue(current, workInProgress2), processUpdateQueue(workInProgress2, null, null, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress2.memoizedState, init.parent !== lazyComponent ? (init = { parent: lazyComponent, cache: lazyComponent }, workInProgress2.memoizedState = init, 0 === workInProgress2.lanes && (workInProgress2.memoizedState = workInProgress2.updateQueue.baseState = init), pushProvider(workInProgress2, CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, pushProvider(workInProgress2, CacheContext, lazyComponent), lazyComponent !== init.cache && propagateContextChanges(
          workInProgress2,
          [CacheContext],
          renderLanes2,
          true
        ))), reconcileChildren(
          current,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), workInProgress2.child;
      case 29:
        throw workInProgress2.pendingProps;
    }
    throw Error(formatProdErrorMessage(156, workInProgress2.tag));
  }
  function markUpdate(workInProgress2) {
    workInProgress2.flags |= 4;
  }
  function preloadResourceAndSuspendIfNeeded(workInProgress2, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4))
      workInProgress2.flags &= -16777217;
    else if (workInProgress2.flags |= 16777216, !preloadResource(resource)) {
      resource = suspenseHandlerStackCursor.current;
      if (null !== resource && ((workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null !== shellBoundary : (workInProgressRootRenderLanes & 62914560) !== workInProgressRootRenderLanes && 0 === (workInProgressRootRenderLanes & 536870912) || resource !== shellBoundary))
        throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
      workInProgress2.flags |= 8192;
    }
  }
  function scheduleRetryEffect(workInProgress2, retryQueue) {
    null !== retryQueue && (workInProgress2.flags |= 4);
    workInProgress2.flags & 16384 && (retryQueue = 22 !== workInProgress2.tag ? claimNextRetryLane() : 536870912, workInProgress2.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
  }
  function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating)
      switch (renderState.tailMode) {
        case "hidden":
          hasRenderedATailFallback = renderState.tail;
          for (var lastTailNode = null; null !== hasRenderedATailFallback; )
            null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
          null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
          break;
        case "collapsed":
          lastTailNode = renderState.tail;
          for (var lastTailNode$113 = null; null !== lastTailNode; )
            null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
          null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
      }
  }
  function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout)
      for (var child$114 = completedWork.child; null !== child$114; )
        newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else
      for (child$114 = completedWork.child; null !== child$114; )
        newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
  }
  function completeWork(current, workInProgress2, renderLanes2) {
    var newProps = workInProgress2.pendingProps;
    popTreeContext(workInProgress2);
    switch (workInProgress2.tag) {
      case 31:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return bubbleProperties(workInProgress2), null;
      case 1:
        return bubbleProperties(workInProgress2), null;
      case 3:
        renderLanes2 = workInProgress2.stateNode;
        newProps = null;
        null !== current && (newProps = current.memoizedState.cache);
        workInProgress2.memoizedState.cache !== newProps && (workInProgress2.flags |= 2048);
        popProvider(CacheContext);
        popHostContainer();
        renderLanes2.pendingContext && (renderLanes2.context = renderLanes2.pendingContext, renderLanes2.pendingContext = null);
        if (null === current || null === current.child)
          popHydrationState(workInProgress2) ? markUpdate(workInProgress2) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress2.flags & 256) || (workInProgress2.flags |= 1024, upgradeHydrationErrorsToRecoverable());
        bubbleProperties(workInProgress2);
        return null;
      case 26:
        return renderLanes2 = workInProgress2.memoizedState, null === current ? (markUpdate(workInProgress2), null !== renderLanes2 ? (bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(workInProgress2, renderLanes2)) : (bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217)) : renderLanes2 ? renderLanes2 !== current.memoizedState ? (markUpdate(workInProgress2), bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(workInProgress2, renderLanes2)) : (bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217) : (current.memoizedProps !== newProps && markUpdate(workInProgress2), bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217), null;
      case 27:
        popHostContext(workInProgress2);
        renderLanes2 = rootInstanceStackCursor.current;
        var type = workInProgress2.type;
        if (null !== current && null != workInProgress2.stateNode)
          current.memoizedProps !== newProps && markUpdate(workInProgress2);
        else {
          if (!newProps) {
            if (null === workInProgress2.stateNode)
              throw Error(formatProdErrorMessage(166));
            bubbleProperties(workInProgress2);
            return null;
          }
          current = contextStackCursor.current;
          popHydrationState(workInProgress2) ? prepareToHydrateHostInstance(workInProgress2) : (current = resolveSingletonInstance(type, newProps, renderLanes2), workInProgress2.stateNode = current, markUpdate(workInProgress2));
        }
        bubbleProperties(workInProgress2);
        return null;
      case 5:
        popHostContext(workInProgress2);
        renderLanes2 = workInProgress2.type;
        if (null !== current && null != workInProgress2.stateNode)
          current.memoizedProps !== newProps && markUpdate(workInProgress2);
        else {
          if (!newProps) {
            if (null === workInProgress2.stateNode)
              throw Error(formatProdErrorMessage(166));
            bubbleProperties(workInProgress2);
            return null;
          }
          current = contextStackCursor.current;
          if (popHydrationState(workInProgress2))
            prepareToHydrateHostInstance(workInProgress2);
          else {
            type = getOwnerDocumentFromRootContainer(
              rootInstanceStackCursor.current
            );
            switch (current) {
              case 1:
                current = type.createElementNS(
                  "http://www.w3.org/2000/svg",
                  renderLanes2
                );
                break;
              case 2:
                current = type.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  renderLanes2
                );
                break;
              default:
                switch (renderLanes2) {
                  case "svg":
                    current = type.createElementNS(
                      "http://www.w3.org/2000/svg",
                      renderLanes2
                    );
                    break;
                  case "math":
                    current = type.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      renderLanes2
                    );
                    break;
                  case "script":
                    current = type.createElement("div");
                    current.innerHTML = "<script><\/script>";
                    current = current.removeChild(current.firstChild);
                    break;
                  case "select":
                    current = "string" === typeof newProps.is ? type.createElement("select", { is: newProps.is }) : type.createElement("select");
                    newProps.multiple ? current.multiple = true : newProps.size && (current.size = newProps.size);
                    break;
                  default:
                    current = "string" === typeof newProps.is ? type.createElement(renderLanes2, { is: newProps.is }) : type.createElement(renderLanes2);
                }
            }
            current[internalInstanceKey] = workInProgress2;
            current[internalPropsKey] = newProps;
            a: for (type = workInProgress2.child; null !== type; ) {
              if (5 === type.tag || 6 === type.tag)
                current.appendChild(type.stateNode);
              else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                type.child.return = type;
                type = type.child;
                continue;
              }
              if (type === workInProgress2) break a;
              for (; null === type.sibling; ) {
                if (null === type.return || type.return === workInProgress2)
                  break a;
                type = type.return;
              }
              type.sibling.return = type.return;
              type = type.sibling;
            }
            workInProgress2.stateNode = current;
            a: switch (setInitialProperties(current, renderLanes2, newProps), renderLanes2) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                current = !!newProps.autoFocus;
                break a;
              case "img":
                current = true;
                break a;
              default:
                current = false;
            }
            current && markUpdate(workInProgress2);
          }
        }
        bubbleProperties(workInProgress2);
        workInProgress2.flags &= -16777217;
        return null;
      case 6:
        if (current && null != workInProgress2.stateNode)
          current.memoizedProps !== newProps && markUpdate(workInProgress2);
        else {
          if ("string" !== typeof newProps && null === workInProgress2.stateNode)
            throw Error(formatProdErrorMessage(166));
          current = rootInstanceStackCursor.current;
          if (popHydrationState(workInProgress2)) {
            current = workInProgress2.stateNode;
            renderLanes2 = workInProgress2.memoizedProps;
            newProps = null;
            type = hydrationParentFiber;
            if (null !== type)
              switch (type.tag) {
                case 27:
                case 5:
                  newProps = type.memoizedProps;
              }
            current[internalInstanceKey] = workInProgress2;
            current = current.nodeValue === renderLanes2 || null !== newProps && true === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes2) ? true : false;
            current || throwOnHydrationMismatch(workInProgress2);
          } else
            current = getOwnerDocumentFromRootContainer(current).createTextNode(
              newProps
            ), current[internalInstanceKey] = workInProgress2, workInProgress2.stateNode = current;
        }
        bubbleProperties(workInProgress2);
        return null;
      case 13:
        newProps = workInProgress2.memoizedState;
        if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
          type = popHydrationState(workInProgress2);
          if (null !== newProps && null !== newProps.dehydrated) {
            if (null === current) {
              if (!type) throw Error(formatProdErrorMessage(318));
              type = workInProgress2.memoizedState;
              type = null !== type ? type.dehydrated : null;
              if (!type) throw Error(formatProdErrorMessage(317));
              type[internalInstanceKey] = workInProgress2;
            } else
              resetHydrationState(), 0 === (workInProgress2.flags & 128) && (workInProgress2.memoizedState = null), workInProgress2.flags |= 4;
            bubbleProperties(workInProgress2);
            type = false;
          } else
            type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = true;
          if (!type) {
            if (workInProgress2.flags & 256)
              return popSuspenseHandler(workInProgress2), workInProgress2;
            popSuspenseHandler(workInProgress2);
            return null;
          }
        }
        popSuspenseHandler(workInProgress2);
        if (0 !== (workInProgress2.flags & 128))
          return workInProgress2.lanes = renderLanes2, workInProgress2;
        renderLanes2 = null !== newProps;
        current = null !== current && null !== current.memoizedState;
        if (renderLanes2) {
          newProps = workInProgress2.child;
          type = null;
          null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
          var cache$127 = null;
          null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
          cache$127 !== type && (newProps.flags |= 2048);
        }
        renderLanes2 !== current && renderLanes2 && (workInProgress2.child.flags |= 8192);
        scheduleRetryEffect(workInProgress2, workInProgress2.updateQueue);
        bubbleProperties(workInProgress2);
        return null;
      case 4:
        return popHostContainer(), null === current && listenToAllSupportedEvents(workInProgress2.stateNode.containerInfo), bubbleProperties(workInProgress2), null;
      case 10:
        return popProvider(workInProgress2.type), bubbleProperties(workInProgress2), null;
      case 19:
        pop(suspenseStackCursor);
        type = workInProgress2.memoizedState;
        if (null === type) return bubbleProperties(workInProgress2), null;
        newProps = 0 !== (workInProgress2.flags & 128);
        cache$127 = type.rendering;
        if (null === cache$127)
          if (newProps) cutOffTailIfNeeded(type, false);
          else {
            if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128))
              for (current = workInProgress2.child; null !== current; ) {
                cache$127 = findFirstSuspended(current);
                if (null !== cache$127) {
                  workInProgress2.flags |= 128;
                  cutOffTailIfNeeded(type, false);
                  current = cache$127.updateQueue;
                  workInProgress2.updateQueue = current;
                  scheduleRetryEffect(workInProgress2, current);
                  workInProgress2.subtreeFlags = 0;
                  current = renderLanes2;
                  for (renderLanes2 = workInProgress2.child; null !== renderLanes2; )
                    resetWorkInProgress(renderLanes2, current), renderLanes2 = renderLanes2.sibling;
                  push(
                    suspenseStackCursor,
                    suspenseStackCursor.current & 1 | 2
                  );
                  return workInProgress2.child;
                }
                current = current.sibling;
              }
            null !== type.tail && now() > workInProgressRootRenderTargetTime && (workInProgress2.flags |= 128, newProps = true, cutOffTailIfNeeded(type, false), workInProgress2.lanes = 4194304);
          }
        else {
          if (!newProps)
            if (current = findFirstSuspended(cache$127), null !== current) {
              if (workInProgress2.flags |= 128, newProps = true, current = current.updateQueue, workInProgress2.updateQueue = current, scheduleRetryEffect(workInProgress2, current), cutOffTailIfNeeded(type, true), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !isHydrating)
                return bubbleProperties(workInProgress2), null;
            } else
              2 * now() - type.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes2 && (workInProgress2.flags |= 128, newProps = true, cutOffTailIfNeeded(type, false), workInProgress2.lanes = 4194304);
          type.isBackwards ? (cache$127.sibling = workInProgress2.child, workInProgress2.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress2.child = cache$127, type.last = cache$127);
        }
        if (null !== type.tail)
          return workInProgress2 = type.tail, type.rendering = workInProgress2, type.tail = workInProgress2.sibling, type.renderingStartTime = now(), workInProgress2.sibling = null, current = suspenseStackCursor.current, push(suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress2;
        bubbleProperties(workInProgress2);
        return null;
      case 22:
      case 23:
        return popSuspenseHandler(workInProgress2), popHiddenContext(), newProps = null !== workInProgress2.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress2.flags |= 8192) : newProps && (workInProgress2.flags |= 8192), newProps ? 0 !== (renderLanes2 & 536870912) && 0 === (workInProgress2.flags & 128) && (bubbleProperties(workInProgress2), workInProgress2.subtreeFlags & 6 && (workInProgress2.flags |= 8192)) : bubbleProperties(workInProgress2), renderLanes2 = workInProgress2.updateQueue, null !== renderLanes2 && scheduleRetryEffect(workInProgress2, renderLanes2.retryQueue), renderLanes2 = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes2 = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress2.memoizedState && null !== workInProgress2.memoizedState.cachePool && (newProps = workInProgress2.memoizedState.cachePool.pool), newProps !== renderLanes2 && (workInProgress2.flags |= 2048), null !== current && pop(resumedCache), null;
      case 24:
        return renderLanes2 = null, null !== current && (renderLanes2 = current.memoizedState.cache), workInProgress2.memoizedState.cache !== renderLanes2 && (workInProgress2.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress2), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(formatProdErrorMessage(156, workInProgress2.tag));
  }
  function unwindWork(current, workInProgress2) {
    popTreeContext(workInProgress2);
    switch (workInProgress2.tag) {
      case 1:
        return current = workInProgress2.flags, current & 65536 ? (workInProgress2.flags = current & -65537 | 128, workInProgress2) : null;
      case 3:
        return popProvider(CacheContext), popHostContainer(), current = workInProgress2.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress2.flags = current & -65537 | 128, workInProgress2) : null;
      case 26:
      case 27:
      case 5:
        return popHostContext(workInProgress2), null;
      case 13:
        popSuspenseHandler(workInProgress2);
        current = workInProgress2.memoizedState;
        if (null !== current && null !== current.dehydrated) {
          if (null === workInProgress2.alternate)
            throw Error(formatProdErrorMessage(340));
          resetHydrationState();
        }
        current = workInProgress2.flags;
        return current & 65536 ? (workInProgress2.flags = current & -65537 | 128, workInProgress2) : null;
      case 19:
        return pop(suspenseStackCursor), null;
      case 4:
        return popHostContainer(), null;
      case 10:
        return popProvider(workInProgress2.type), null;
      case 22:
      case 23:
        return popSuspenseHandler(workInProgress2), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress2.flags, current & 65536 ? (workInProgress2.flags = current & -65537 | 128, workInProgress2) : null;
      case 24:
        return popProvider(CacheContext), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function unwindInterruptedWork(current, interruptedWork) {
    popTreeContext(interruptedWork);
    switch (interruptedWork.tag) {
      case 3:
        popProvider(CacheContext);
        popHostContainer();
        break;
      case 26:
      case 27:
      case 5:
        popHostContext(interruptedWork);
        break;
      case 4:
        popHostContainer();
        break;
      case 13:
        popSuspenseHandler(interruptedWork);
        break;
      case 19:
        pop(suspenseStackCursor);
        break;
      case 10:
        popProvider(interruptedWork.type);
        break;
      case 22:
      case 23:
        popSuspenseHandler(interruptedWork);
        popHiddenContext();
        null !== current && pop(resumedCache);
        break;
      case 24:
        popProvider(CacheContext);
    }
  }
  function commitHookEffectListMount(flags, finishedWork) {
    try {
      var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
      if (null !== lastEffect) {
        var firstEffect = lastEffect.next;
        updateQueue = firstEffect;
        do {
          if ((updateQueue.tag & flags) === flags) {
            lastEffect = void 0;
            var create = updateQueue.create, inst = updateQueue.inst;
            lastEffect = create();
            inst.destroy = lastEffect;
          }
          updateQueue = updateQueue.next;
        } while (updateQueue !== firstEffect);
      }
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
      var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
      if (null !== lastEffect) {
        var firstEffect = lastEffect.next;
        updateQueue = firstEffect;
        do {
          if ((updateQueue.tag & flags) === flags) {
            var inst = updateQueue.inst, destroy = inst.destroy;
            if (void 0 !== destroy) {
              inst.destroy = void 0;
              lastEffect = finishedWork;
              var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
              try {
                destroy_();
              } catch (error) {
                captureCommitPhaseError(
                  lastEffect,
                  nearestMountedAncestor,
                  error
                );
              }
            }
          }
          updateQueue = updateQueue.next;
        } while (updateQueue !== firstEffect);
      }
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
      var instance = finishedWork.stateNode;
      try {
        commitCallbacks(updateQueue, instance);
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
  }
  function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(
      current.type,
      current.memoizedProps
    );
    instance.state = current.memoizedState;
    try {
      instance.componentWillUnmount();
    } catch (error) {
      captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
  }
  function safelyAttachRef(current, nearestMountedAncestor) {
    try {
      var ref = current.ref;
      if (null !== ref) {
        switch (current.tag) {
          case 26:
          case 27:
          case 5:
            var instanceToUse = current.stateNode;
            break;
          case 30:
            instanceToUse = current.stateNode;
            break;
          default:
            instanceToUse = current.stateNode;
        }
        "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
      }
    } catch (error) {
      captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
  }
  function safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref)
      if ("function" === typeof refCleanup)
        try {
          refCleanup();
        } catch (error) {
          captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally {
          current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
      else if ("function" === typeof ref)
        try {
          ref(null);
        } catch (error$143) {
          captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
      else ref.current = null;
  }
  function commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
      a: switch (type) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          props.autoFocus && instance.focus();
          break a;
        case "img":
          props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
      }
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
      var domElement = finishedWork.stateNode;
      updateProperties(domElement, finishedWork.type, oldProps, newProps);
      domElement[internalPropsKey] = newProps;
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
  }
  function getHostSibling(fiber) {
    a: for (; ; ) {
      for (; null === fiber.sibling; ) {
        if (null === fiber.return || isHostParent(fiber.return)) return null;
        fiber = fiber.return;
      }
      fiber.sibling.return = fiber.return;
      for (fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag; ) {
        if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
        if (fiber.flags & 2) continue a;
        if (null === fiber.child || 4 === fiber.tag) continue a;
        else fiber.child.return = fiber, fiber = fiber.child;
      }
      if (!(fiber.flags & 2)) return fiber.stateNode;
    }
  }
  function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag)
      node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node))
      for (insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node; )
        insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
  }
  function insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag)
      node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node))
      for (insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node; )
        insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
  }
  function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
      for (var type = finishedWork.type, attributes = singleton.attributes; attributes.length; )
        singleton.removeAttributeNode(attributes[0]);
      setInitialProperties(singleton, type, props);
      singleton[internalInstanceKey] = finishedWork;
      singleton[internalPropsKey] = props;
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  var offscreenSubtreeIsHidden = false, offscreenSubtreeWasHidden = false, needsFormReset = false, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null;
  function commitBeforeMutationEffects(root2, firstChild) {
    root2 = root2.containerInfo;
    eventsEnabled = _enabled;
    root2 = getActiveElementDeep(root2);
    if (hasSelectionCapabilities(root2)) {
      if ("selectionStart" in root2)
        var JSCompiler_temp = {
          start: root2.selectionStart,
          end: root2.selectionEnd
        };
      else
        a: {
          JSCompiler_temp = (JSCompiler_temp = root2.ownerDocument) && JSCompiler_temp.defaultView || window;
          var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
          if (selection && 0 !== selection.rangeCount) {
            JSCompiler_temp = selection.anchorNode;
            var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
            selection = selection.focusOffset;
            try {
              JSCompiler_temp.nodeType, focusNode.nodeType;
            } catch (e$20) {
              JSCompiler_temp = null;
              break a;
            }
            var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root2, parentNode = null;
            b: for (; ; ) {
              for (var next; ; ) {
                node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                3 === node.nodeType && (length += node.nodeValue.length);
                if (null === (next = node.firstChild)) break;
                parentNode = node;
                node = next;
              }
              for (; ; ) {
                if (node === root2) break b;
                parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                if (null !== (next = node.nextSibling)) break;
                node = parentNode;
                parentNode = node.parentNode;
              }
              node = next;
            }
            JSCompiler_temp = -1 === start || -1 === end ? null : { start, end };
          } else JSCompiler_temp = null;
        }
      JSCompiler_temp = JSCompiler_temp || { start: 0, end: 0 };
    } else JSCompiler_temp = null;
    selectionInformation = { focusedElem: root2, selectionRange: JSCompiler_temp };
    _enabled = false;
    for (nextEffect = firstChild; null !== nextEffect; )
      if (firstChild = nextEffect, root2 = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root2)
        root2.return = firstChild, nextEffect = root2;
      else
        for (; null !== nextEffect; ) {
          firstChild = nextEffect;
          focusNode = firstChild.alternate;
          root2 = firstChild.flags;
          switch (firstChild.tag) {
            case 0:
              break;
            case 11:
            case 15:
              break;
            case 1:
              if (0 !== (root2 & 1024) && null !== focusNode) {
                root2 = void 0;
                JSCompiler_temp = firstChild;
                anchorOffset = focusNode.memoizedProps;
                focusNode = focusNode.memoizedState;
                selection = JSCompiler_temp.stateNode;
                try {
                  var resolvedPrevProps = resolveClassComponentProps(
                    JSCompiler_temp.type,
                    anchorOffset,
                    JSCompiler_temp.elementType === JSCompiler_temp.type
                  );
                  root2 = selection.getSnapshotBeforeUpdate(
                    resolvedPrevProps,
                    focusNode
                  );
                  selection.__reactInternalSnapshotBeforeUpdate = root2;
                } catch (error) {
                  captureCommitPhaseError(
                    JSCompiler_temp,
                    JSCompiler_temp.return,
                    error
                  );
                }
              }
              break;
            case 3:
              if (0 !== (root2 & 1024)) {
                if (root2 = firstChild.stateNode.containerInfo, JSCompiler_temp = root2.nodeType, 9 === JSCompiler_temp)
                  clearContainerSparingly(root2);
                else if (1 === JSCompiler_temp)
                  switch (root2.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      clearContainerSparingly(root2);
                      break;
                    default:
                      root2.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if (0 !== (root2 & 1024)) throw Error(formatProdErrorMessage(163));
          }
          root2 = firstChild.sibling;
          if (null !== root2) {
            root2.return = firstChild.return;
            nextEffect = root2;
            break;
          }
          nextEffect = firstChild.return;
        }
  }
  function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        flags & 4 && commitHookEffectListMount(5, finishedWork);
        break;
      case 1:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        if (flags & 4)
          if (finishedRoot = finishedWork.stateNode, null === current)
            try {
              finishedRoot.componentDidMount();
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          else {
            var prevProps = resolveClassComponentProps(
              finishedWork.type,
              current.memoizedProps
            );
            current = current.memoizedState;
            try {
              finishedRoot.componentDidUpdate(
                prevProps,
                current,
                finishedRoot.__reactInternalSnapshotBeforeUpdate
              );
            } catch (error$142) {
              captureCommitPhaseError(
                finishedWork,
                finishedWork.return,
                error$142
              );
            }
          }
        flags & 64 && commitClassCallbacks(finishedWork);
        flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
        break;
      case 3:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
          current = null;
          if (null !== finishedWork.child)
            switch (finishedWork.child.tag) {
              case 27:
              case 5:
                current = finishedWork.child.stateNode;
                break;
              case 1:
                current = finishedWork.child.stateNode;
            }
          try {
            commitCallbacks(finishedRoot, current);
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        }
        break;
      case 27:
        null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
      case 26:
      case 5:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        null === current && flags & 4 && commitHostMount(finishedWork);
        flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
        break;
      case 12:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        break;
      case 13:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
        flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(
          null,
          finishedWork
        ), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
        break;
      case 22:
        flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
        if (!flags) {
          current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
          prevProps = offscreenSubtreeIsHidden;
          var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
          offscreenSubtreeIsHidden = flags;
          (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            0 !== (finishedWork.subtreeFlags & 8772)
          ) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          offscreenSubtreeIsHidden = prevProps;
          offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
        }
        break;
      case 30:
        break;
      default:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
  }
  function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
  }
  var hostParent = null, hostParentIsContainer = false;
  function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for (parent = parent.child; null !== parent; )
      commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
  }
  function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount)
      try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
      } catch (err) {
      }
    switch (deletedFiber.tag) {
      case 26:
        offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
        break;
      case 27:
        offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
        isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = false);
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        releaseSingletonInstance(deletedFiber.stateNode);
        hostParent = prevHostParent;
        hostParentIsContainer = prevHostParentIsContainer;
        break;
      case 5:
        offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
      case 6:
        prevHostParent = hostParent;
        prevHostParentIsContainer = hostParentIsContainer;
        hostParent = null;
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        hostParent = prevHostParent;
        hostParentIsContainer = prevHostParentIsContainer;
        if (null !== hostParent)
          if (hostParentIsContainer)
            try {
              (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode);
            } catch (error) {
              captureCommitPhaseError(
                deletedFiber,
                nearestMountedAncestor,
                error
              );
            }
          else
            try {
              hostParent.removeChild(deletedFiber.stateNode);
            } catch (error) {
              captureCommitPhaseError(
                deletedFiber,
                nearestMountedAncestor,
                error
              );
            }
        break;
      case 18:
        null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearSuspenseBoundary(
          9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot,
          deletedFiber.stateNode
        ), retryIfBlockedOn(finishedRoot)) : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
        break;
      case 4:
        prevHostParent = hostParent;
        prevHostParentIsContainer = hostParentIsContainer;
        hostParent = deletedFiber.stateNode.containerInfo;
        hostParentIsContainer = true;
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        hostParent = prevHostParent;
        hostParentIsContainer = prevHostParentIsContainer;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        offscreenSubtreeWasHidden || commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
        offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        break;
      case 1:
        offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(
          deletedFiber,
          nearestMountedAncestor,
          prevHostParent
        ));
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        break;
      case 21:
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        break;
      case 22:
        offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        offscreenSubtreeWasHidden = prevHostParent;
        break;
      default:
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
    }
  }
  function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot))))
      try {
        retryIfBlockedOn(finishedRoot);
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
  }
  function getRetryCache(finishedWork) {
    switch (finishedWork.tag) {
      case 13:
      case 19:
        var retryCache = finishedWork.stateNode;
        null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
        return retryCache;
      case 22:
        return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
      default:
        throw Error(formatProdErrorMessage(435, finishedWork.tag));
    }
  }
  function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
      var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
      retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
  }
  function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions)
      for (var i = 0; i < deletions.length; i++) {
        var childToDelete = deletions[i], root2 = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for (; null !== parent; ) {
          switch (parent.tag) {
            case 27:
              if (isSingletonScope(parent.type)) {
                hostParent = parent.stateNode;
                hostParentIsContainer = false;
                break a;
              }
              break;
            case 5:
              hostParent = parent.stateNode;
              hostParentIsContainer = false;
              break a;
            case 3:
            case 4:
              hostParent = parent.stateNode.containerInfo;
              hostParentIsContainer = true;
              break a;
          }
          parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage(160));
        commitDeletionEffectsOnFiber(root2, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = false;
        root2 = childToDelete.alternate;
        null !== root2 && (root2.return = null);
        childToDelete.return = null;
      }
    if (parentFiber.subtreeFlags & 13878)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
  }
  var currentHoistableRoot = null;
  function commitMutationEffectsOnFiber(finishedWork, root2) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
        break;
      case 1:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
        flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
        break;
      case 26:
        var hoistableRoot = currentHoistableRoot;
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
        if (flags & 4) {
          var currentResource = null !== current ? current.memoizedState : null;
          flags = finishedWork.memoizedState;
          if (null === current)
            if (null === flags)
              if (null === finishedWork.stateNode) {
                a: {
                  flags = finishedWork.type;
                  current = finishedWork.memoizedProps;
                  hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                  b: switch (flags) {
                    case "title":
                      currentResource = hoistableRoot.getElementsByTagName("title")[0];
                      if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop"))
                        currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(
                          currentResource,
                          hoistableRoot.querySelector("head > title")
                        );
                      setInitialProperties(currentResource, flags, current);
                      currentResource[internalInstanceKey] = finishedWork;
                      markNodeAsHoistable(currentResource);
                      flags = currentResource;
                      break a;
                    case "link":
                      var maybeNodes = getHydratableHoistableCache(
                        "link",
                        "href",
                        hoistableRoot
                      ).get(flags + (current.href || ""));
                      if (maybeNodes) {
                        for (var i = 0; i < maybeNodes.length; i++)
                          if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                            maybeNodes.splice(i, 1);
                            break b;
                          }
                      }
                      currentResource = hoistableRoot.createElement(flags);
                      setInitialProperties(currentResource, flags, current);
                      hoistableRoot.head.appendChild(currentResource);
                      break;
                    case "meta":
                      if (maybeNodes = getHydratableHoistableCache(
                        "meta",
                        "content",
                        hoistableRoot
                      ).get(flags + (current.content || ""))) {
                        for (i = 0; i < maybeNodes.length; i++)
                          if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                            maybeNodes.splice(i, 1);
                            break b;
                          }
                      }
                      currentResource = hoistableRoot.createElement(flags);
                      setInitialProperties(currentResource, flags, current);
                      hoistableRoot.head.appendChild(currentResource);
                      break;
                    default:
                      throw Error(formatProdErrorMessage(468, flags));
                  }
                  currentResource[internalInstanceKey] = finishedWork;
                  markNodeAsHoistable(currentResource);
                  flags = currentResource;
                }
                finishedWork.stateNode = flags;
              } else
                mountHoistable(
                  hoistableRoot,
                  finishedWork.type,
                  finishedWork.stateNode
                );
            else
              finishedWork.stateNode = acquireResource(
                hoistableRoot,
                flags,
                finishedWork.memoizedProps
              );
          else
            currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(
              hoistableRoot,
              finishedWork.type,
              finishedWork.stateNode
            ) : acquireResource(
              hoistableRoot,
              flags,
              finishedWork.memoizedProps
            )) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(
              finishedWork,
              finishedWork.memoizedProps,
              current.memoizedProps
            );
        }
        break;
      case 27:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
        null !== current && flags & 4 && commitHostUpdate(
          finishedWork,
          finishedWork.memoizedProps,
          current.memoizedProps
        );
        break;
      case 5:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
        if (finishedWork.flags & 32) {
          hoistableRoot = finishedWork.stateNode;
          try {
            setTextContent(hoistableRoot, "");
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        }
        flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(
          finishedWork,
          hoistableRoot,
          null !== current ? current.memoizedProps : hoistableRoot
        ));
        flags & 1024 && (needsFormReset = true);
        break;
      case 6:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        if (flags & 4) {
          if (null === finishedWork.stateNode)
            throw Error(formatProdErrorMessage(162));
          flags = finishedWork.memoizedProps;
          current = finishedWork.stateNode;
          try {
            current.nodeValue = flags;
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        }
        break;
      case 3:
        tagCaches = null;
        hoistableRoot = currentHoistableRoot;
        currentHoistableRoot = getHoistableRoot(root2.containerInfo);
        recursivelyTraverseMutationEffects(root2, finishedWork);
        currentHoistableRoot = hoistableRoot;
        commitReconciliationEffects(finishedWork);
        if (flags & 4 && null !== current && current.memoizedState.isDehydrated)
          try {
            retryIfBlockedOn(root2.containerInfo);
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        needsFormReset && (needsFormReset = false, recursivelyResetForms(finishedWork));
        break;
      case 4:
        flags = currentHoistableRoot;
        currentHoistableRoot = getHoistableRoot(
          finishedWork.stateNode.containerInfo
        );
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        currentHoistableRoot = flags;
        break;
      case 12:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        break;
      case 13:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
        flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
        break;
      case 22:
        hoistableRoot = null !== finishedWork.memoizedState;
        var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
        offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
        offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
        recursivelyTraverseMutationEffects(root2, finishedWork);
        offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
        offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
        commitReconciliationEffects(finishedWork);
        if (flags & 8192)
          a: for (root2 = finishedWork.stateNode, root2._visibility = hoistableRoot ? root2._visibility & -2 : root2._visibility | 1, hoistableRoot && (null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root2 = finishedWork; ; ) {
            if (5 === root2.tag || 26 === root2.tag) {
              if (null === current) {
                wasHidden = current = root2;
                try {
                  if (currentResource = wasHidden.stateNode, hoistableRoot)
                    maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                  else {
                    i = wasHidden.stateNode;
                    var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                  }
                } catch (error) {
                  captureCommitPhaseError(wasHidden, wasHidden.return, error);
                }
              }
            } else if (6 === root2.tag) {
              if (null === current) {
                wasHidden = root2;
                try {
                  wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                } catch (error) {
                  captureCommitPhaseError(wasHidden, wasHidden.return, error);
                }
              }
            } else if ((22 !== root2.tag && 23 !== root2.tag || null === root2.memoizedState || root2 === finishedWork) && null !== root2.child) {
              root2.child.return = root2;
              root2 = root2.child;
              continue;
            }
            if (root2 === finishedWork) break a;
            for (; null === root2.sibling; ) {
              if (null === root2.return || root2.return === finishedWork) break a;
              current === root2 && (current = null);
              root2 = root2.return;
            }
            current === root2 && (current = null);
            root2.sibling.return = root2.return;
            root2 = root2.sibling;
          }
        flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
        break;
      case 19:
        recursivelyTraverseMutationEffects(root2, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        recursivelyTraverseMutationEffects(root2, finishedWork), commitReconciliationEffects(finishedWork);
    }
  }
  function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
      try {
        for (var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber; ) {
          if (isHostParent(parentFiber)) {
            hostParentFiber = parentFiber;
            break;
          }
          parentFiber = parentFiber.return;
        }
        if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
        switch (hostParentFiber.tag) {
          case 27:
            var parent = hostParentFiber.stateNode, before = getHostSibling(finishedWork);
            insertOrAppendPlacementNode(finishedWork, before, parent);
            break;
          case 5:
            var parent$144 = hostParentFiber.stateNode;
            hostParentFiber.flags & 32 && (setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
            var before$145 = getHostSibling(finishedWork);
            insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
            break;
          case 3:
          case 4:
            var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = getHostSibling(finishedWork);
            insertOrAppendPlacementNodeIntoContainer(
              finishedWork,
              before$147,
              parent$146
            );
            break;
          default:
            throw Error(formatProdErrorMessage(161));
        }
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
      finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
  }
  function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024)
      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
      }
  }
  function recursivelyTraverseLayoutEffects(root2, parentFiber) {
    if (parentFiber.subtreeFlags & 8772)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitLayoutEffectOnFiber(root2, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
  }
  function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var finishedWork = parentFiber;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 1:
          safelyDetachRef(finishedWork, finishedWork.return);
          var instance = finishedWork.stateNode;
          "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(
            finishedWork,
            finishedWork.return,
            instance
          );
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 27:
          releaseSingletonInstance(finishedWork.stateNode);
        case 26:
        case 5:
          safelyDetachRef(finishedWork, finishedWork.return);
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 30:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        default:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          commitHookEffectListMount(4, finishedWork);
          break;
        case 1:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          current = finishedWork;
          finishedRoot = current.stateNode;
          if ("function" === typeof finishedRoot.componentDidMount)
            try {
              finishedRoot.componentDidMount();
            } catch (error) {
              captureCommitPhaseError(current, current.return, error);
            }
          current = finishedWork;
          finishedRoot = current.updateQueue;
          if (null !== finishedRoot) {
            var instance = current.stateNode;
            try {
              var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
              if (null !== hiddenCallbacks)
                for (finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)
                  callCallback(hiddenCallbacks[finishedRoot], instance);
            } catch (error) {
              captureCommitPhaseError(current, current.return, error);
            }
          }
          includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 27:
          commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 12:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          break;
        case 13:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 30:
          break;
        default:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
  }
  function commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
  }
  function recursivelyTraversePassiveMountEffects(root2, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitPassiveMountOnFiber(
          root2,
          parentFiber,
          committedLanes,
          committedTransitions
        ), parentFiber = parentFiber.sibling;
  }
  function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        flags & 2048 && commitHookEffectListMount(9, finishedWork);
        break;
      case 1:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        break;
      case 3:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
        break;
      case 12:
        if (flags & 2048) {
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
          finishedRoot = finishedWork.stateNode;
          try {
            var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
            "function" === typeof onPostCommit && onPostCommit(
              id,
              null === finishedWork.alternate ? "mount" : "update",
              finishedRoot.passiveEffectDuration,
              -0
            );
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        } else
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
        break;
      case 13:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        break;
      case 23:
        break;
      case 22:
        _finishedWork$memoize2 = finishedWork.stateNode;
        id = finishedWork.alternate;
        null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        ) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        ) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions,
          0 !== (finishedWork.subtreeFlags & 10256)
        ));
        flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
        break;
      case 24:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
        break;
      default:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
    }
  }
  function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
          commitHookEffectListMount(8, finishedWork);
          break;
        case 23:
          break;
        case 22:
          var instance = finishedWork.stateNode;
          null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          ) : recursivelyTraverseAtomicPassiveEffects(
            finishedRoot,
            finishedWork
          ) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          ));
          includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(
            finishedWork.alternate,
            finishedWork
          );
          break;
        case 24:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
          break;
        default:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256)
      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch (finishedWork.tag) {
          case 22:
            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
            flags & 2048 && commitOffscreenPassiveMountEffects(
              finishedWork.alternate,
              finishedWork
            );
            break;
          case 24:
            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
          default:
            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
      }
  }
  var suspenseyCommitFlag = 8192;
  function recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
  }
  function accumulateSuspenseyCommitOnFiber(fiber) {
    switch (fiber.tag) {
      case 26:
        recursivelyAccumulateSuspenseyCommit(fiber);
        fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(
          currentHoistableRoot,
          fiber.memoizedState,
          fiber.memoizedProps
        );
        break;
      case 5:
        recursivelyAccumulateSuspenseyCommit(fiber);
        break;
      case 3:
      case 4:
        var previousHoistableRoot = currentHoistableRoot;
        currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
        recursivelyAccumulateSuspenseyCommit(fiber);
        currentHoistableRoot = previousHoistableRoot;
        break;
      case 22:
        null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber));
        break;
      default:
        recursivelyAccumulateSuspenseyCommit(fiber);
    }
  }
  function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
      previousFiber.child = null;
      do
        previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
      while (null !== parentFiber);
    }
  }
  function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
      if (null !== deletions)
        for (var i = 0; i < deletions.length; i++) {
          var childToDelete = deletions[i];
          nextEffect = childToDelete;
          commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
            childToDelete,
            parentFiber
          );
        }
      detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
  }
  function commitPassiveUnmountOnFiber(finishedWork) {
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
        finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
        break;
      case 3:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
        break;
      case 12:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
        break;
      case 22:
        var instance = finishedWork.stateNode;
        null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
        break;
      default:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
  }
  function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
      if (null !== deletions)
        for (var i = 0; i < deletions.length; i++) {
          var childToDelete = deletions[i];
          nextEffect = childToDelete;
          commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
            childToDelete,
            parentFiber
          );
        }
      detachAlternateSiblings(parentFiber);
    }
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      deletions = parentFiber;
      switch (deletions.tag) {
        case 0:
        case 11:
        case 15:
          commitHookEffectListUnmount(8, deletions, deletions.return);
          recursivelyTraverseDisconnectPassiveEffects(deletions);
          break;
        case 22:
          i = deletions.stateNode;
          i._visibility & 2 && (i._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
          break;
        default:
          recursivelyTraverseDisconnectPassiveEffects(deletions);
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for (; null !== nextEffect; ) {
      var fiber = nextEffect;
      switch (fiber.tag) {
        case 0:
        case 11:
        case 15:
          commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
          break;
        case 23:
        case 22:
          if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
            var cache = fiber.memoizedState.cachePool.pool;
            null != cache && cache.refCount++;
          }
          break;
        case 24:
          releaseCache(fiber.memoizedState.cache);
      }
      cache = fiber.child;
      if (null !== cache) cache.return = fiber, nextEffect = cache;
      else
        a: for (fiber = deletedSubtreeRoot; null !== nextEffect; ) {
          cache = nextEffect;
          var sibling = cache.sibling, returnFiber = cache.return;
          detachFiberAfterEffects(cache);
          if (cache === fiber) {
            nextEffect = null;
            break a;
          }
          if (null !== sibling) {
            sibling.return = returnFiber;
            nextEffect = sibling;
            break a;
          }
          nextEffect = returnFiber;
        }
    }
  }
  var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
      var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
      void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
      return cacheForType;
    }
  }, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = false, workInProgressRootIsPrerendering = false, workInProgressRootDidAttachPingListener = false, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = false, globalMostRecentFallbackTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
  function requestUpdateLane() {
    if (0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes)
      return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
    if (null !== ReactSharedInternals.T) {
      var actionScopeLane = currentEntangledLane;
      return 0 !== actionScopeLane ? actionScopeLane : requestTransitionLane();
    }
    return resolveUpdatePriority();
  }
  function requestDeferredLane() {
    0 === workInProgressDeferredLane && (workInProgressDeferredLane = 0 === (workInProgressRootRenderLanes & 536870912) || isHydrating ? claimNextTransitionLane() : 536870912);
    var suspenseHandler = suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return workInProgressDeferredLane;
  }
  function scheduleUpdateOnFiber(root2, fiber, lane) {
    if (root2 === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root2.cancelPendingCommit)
      prepareFreshStack(root2, 0), markRootSuspended(
        root2,
        workInProgressRootRenderLanes,
        workInProgressDeferredLane,
        false
      );
    markRootUpdated$1(root2, lane);
    if (0 === (executionContext & 2) || root2 !== workInProgressRoot)
      root2 === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(
        root2,
        workInProgressRootRenderLanes,
        workInProgressDeferredLane,
        false
      )), ensureRootIsScheduled(root2);
  }
  function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, true), renderWasConcurrent = shouldTimeSlice;
    do {
      if (0 === exitStatus) {
        workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, false);
        break;
      } else {
        forceSync = root$jscomp$0.current.alternate;
        if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
          exitStatus = renderRootSync(root$jscomp$0, lanes, false);
          renderWasConcurrent = false;
          continue;
        }
        if (2 === exitStatus) {
          renderWasConcurrent = lanes;
          if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent)
            var JSCompiler_inline_result = 0;
          else
            JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
          if (0 !== JSCompiler_inline_result) {
            lanes = JSCompiler_inline_result;
            a: {
              var root2 = root$jscomp$0;
              exitStatus = workInProgressRootConcurrentErrors;
              var wasRootDehydrated = root2.current.memoizedState.isDehydrated;
              wasRootDehydrated && (prepareFreshStack(root2, JSCompiler_inline_result).flags |= 256);
              JSCompiler_inline_result = renderRootSync(
                root2,
                JSCompiler_inline_result,
                false
              );
              if (2 !== JSCompiler_inline_result) {
                if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                  root2.errorRecoveryDisabledLanes |= renderWasConcurrent;
                  workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                  exitStatus = 4;
                  break a;
                }
                renderWasConcurrent = workInProgressRootRecoverableErrors;
                workInProgressRootRecoverableErrors = exitStatus;
                null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(
                  workInProgressRootRecoverableErrors,
                  renderWasConcurrent
                ));
              }
              exitStatus = JSCompiler_inline_result;
            }
            renderWasConcurrent = false;
            if (2 !== exitStatus) continue;
          }
        }
        if (1 === exitStatus) {
          prepareFreshStack(root$jscomp$0, 0);
          markRootSuspended(root$jscomp$0, lanes, 0, true);
          break;
        }
        a: {
          shouldTimeSlice = root$jscomp$0;
          renderWasConcurrent = exitStatus;
          switch (renderWasConcurrent) {
            case 0:
            case 1:
              throw Error(formatProdErrorMessage(345));
            case 4:
              if ((lanes & 4194048) !== lanes) break;
            case 6:
              markRootSuspended(
                shouldTimeSlice,
                lanes,
                workInProgressDeferredLane,
                !workInProgressRootDidSkipSuspendedSiblings
              );
              break a;
            case 2:
              workInProgressRootRecoverableErrors = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(formatProdErrorMessage(329));
          }
          if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
            markRootSuspended(
              shouldTimeSlice,
              lanes,
              workInProgressDeferredLane,
              !workInProgressRootDidSkipSuspendedSiblings
            );
            if (0 !== getNextLanes(shouldTimeSlice, 0, true)) break a;
            shouldTimeSlice.timeoutHandle = scheduleTimeout(
              commitRootWhenReady.bind(
                null,
                shouldTimeSlice,
                forceSync,
                workInProgressRootRecoverableErrors,
                workInProgressTransitions,
                workInProgressRootDidIncludeRecursiveRenderUpdate,
                lanes,
                workInProgressDeferredLane,
                workInProgressRootInterleavedUpdatedLanes,
                workInProgressSuspendedRetryLanes,
                workInProgressRootDidSkipSuspendedSiblings,
                renderWasConcurrent,
                2,
                -0,
                0
              ),
              exitStatus
            );
            break a;
          }
          commitRootWhenReady(
            shouldTimeSlice,
            forceSync,
            workInProgressRootRecoverableErrors,
            workInProgressTransitions,
            workInProgressRootDidIncludeRecursiveRenderUpdate,
            lanes,
            workInProgressDeferredLane,
            workInProgressRootInterleavedUpdatedLanes,
            workInProgressSuspendedRetryLanes,
            workInProgressRootDidSkipSuspendedSiblings,
            renderWasConcurrent,
            0,
            -0,
            0
          );
        }
      }
      break;
    } while (1);
    ensureRootIsScheduled(root$jscomp$0);
  }
  function commitRootWhenReady(root2, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root2.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
      if (suspendedState = { stylesheets: null, count: 0, unsuspend: noop }, accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = waitForCommitToBeReady(), null !== suspendedCommitReason) {
        root2.cancelPendingCommit = suspendedCommitReason(
          commitRoot.bind(
            null,
            root2,
            finishedWork,
            lanes,
            recoverableErrors,
            transitions,
            didIncludeRenderPhaseUpdate,
            spawnedLane,
            updatedLanes,
            suspendedRetryLanes,
            exitStatus,
            1,
            completedRenderStartTime,
            completedRenderEndTime
          )
        );
        markRootSuspended(root2, lanes, spawnedLane, !didSkipSuspendedSiblings);
        return;
      }
    }
    commitRoot(
      root2,
      finishedWork,
      lanes,
      recoverableErrors,
      transitions,
      didIncludeRenderPhaseUpdate,
      spawnedLane,
      updatedLanes,
      suspendedRetryLanes
    );
  }
  function isRenderConsistentWithExternalStores(finishedWork) {
    for (var node = finishedWork; ; ) {
      var tag = node.tag;
      if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag)))
        for (var i = 0; i < tag.length; i++) {
          var check = tag[i], getSnapshot = check.getSnapshot;
          check = check.value;
          try {
            if (!objectIs(getSnapshot(), check)) return false;
          } catch (error) {
            return false;
          }
        }
      tag = node.child;
      if (node.subtreeFlags & 16384 && null !== tag)
        tag.return = node, node = tag;
      else {
        if (node === finishedWork) break;
        for (; null === node.sibling; ) {
          if (null === node.return || node.return === finishedWork) return true;
          node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
      }
    }
    return true;
  }
  function markRootSuspended(root2, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root2.suspendedLanes |= suspendedLanes;
    root2.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root2.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root2.expirationTimes;
    for (var lanes = suspendedLanes; 0 < lanes; ) {
      var index$4 = 31 - clz32(lanes), lane = 1 << index$4;
      didAttemptEntireTree[index$4] = -1;
      lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root2, spawnedLane, suspendedLanes);
  }
  function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0), false) : true;
  }
  function resetWorkInProgressStack() {
    if (null !== workInProgress) {
      if (0 === workInProgressSuspendedReason)
        var interruptedWork = workInProgress.return;
      else
        interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState = null, thenableIndexCounter = 0, interruptedWork = workInProgress;
      for (; null !== interruptedWork; )
        unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
      workInProgress = null;
    }
  }
  function prepareFreshStack(root2, lanes) {
    var timeoutHandle = root2.timeoutHandle;
    -1 !== timeoutHandle && (root2.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root2.cancelPendingCommit;
    null !== timeoutHandle && (root2.cancelPendingCommit = null, timeoutHandle());
    resetWorkInProgressStack();
    workInProgressRoot = root2;
    workInProgress = timeoutHandle = createWorkInProgress(root2.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = false;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root2, lanes);
    workInProgressRootDidAttachPingListener = false;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = false;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root2.entangledLanes;
    if (0 !== allEntangledLanes)
      for (root2 = root2.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes; ) {
        var index$2 = 31 - clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root2[index$2];
        allEntangledLanes &= ~lane;
      }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
  }
  function handleThrow(root2, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(
      root2,
      createCapturedValueAtFiber(thrownValue, root2.current)
    ));
  }
  function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
  }
  function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
  }
  function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = true);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(
      workInProgressRoot,
      workInProgressRootRenderLanes,
      workInProgressDeferredLane,
      false
    );
  }
  function renderRootSync(root2, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root2 || workInProgressRootRenderLanes !== lanes)
      workInProgressTransitions = null, prepareFreshStack(root2, lanes);
    lanes = false;
    var exitStatus = workInProgressRootExitStatus;
    a: do
      try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
          var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
          switch (workInProgressSuspendedReason) {
            case 8:
              resetWorkInProgressStack();
              exitStatus = 6;
              break a;
            case 3:
            case 2:
            case 9:
            case 6:
              null === suspenseHandlerStackCursor.current && (lanes = true);
              var reason = workInProgressSuspendedReason;
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root2, unitOfWork, thrownValue, reason);
              if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                exitStatus = 0;
                break a;
              }
              break;
            default:
              reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root2, unitOfWork, thrownValue, reason);
          }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
      } catch (thrownValue$167) {
        handleThrow(root2, thrownValue$167);
      }
    while (1);
    lanes && root2.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
  }
  function workLoopSync() {
    for (; null !== workInProgress; ) performUnitOfWork(workInProgress);
  }
  function renderRootConcurrent(root2, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root2 || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root2, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(
      root2,
      lanes
    );
    a: do
      try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
          lanes = workInProgress;
          var thrownValue = workInProgressThrownValue;
          b: switch (workInProgressSuspendedReason) {
            case 1:
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root2, lanes, thrownValue, 1);
              break;
            case 2:
            case 9:
              if (isThenableResolved(thrownValue)) {
                workInProgressSuspendedReason = 0;
                workInProgressThrownValue = null;
                replaySuspendedUnitOfWork(lanes);
                break;
              }
              lanes = function() {
                2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root2 || (workInProgressSuspendedReason = 7);
                ensureRootIsScheduled(root2);
              };
              thrownValue.then(lanes, lanes);
              break a;
            case 3:
              workInProgressSuspendedReason = 7;
              break a;
            case 4:
              workInProgressSuspendedReason = 5;
              break a;
            case 7:
              isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root2, lanes, thrownValue, 7));
              break;
            case 5:
              var resource = null;
              switch (workInProgress.tag) {
                case 26:
                  resource = workInProgress.memoizedState;
                case 5:
                case 27:
                  var hostFiber = workInProgress;
                  if (resource ? preloadResource(resource) : 1) {
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    var sibling = hostFiber.sibling;
                    if (null !== sibling) workInProgress = sibling;
                    else {
                      var returnFiber = hostFiber.return;
                      null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                    }
                    break b;
                  }
              }
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root2, lanes, thrownValue, 5);
              break;
            case 6:
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root2, lanes, thrownValue, 6);
              break;
            case 8:
              resetWorkInProgressStack();
              workInProgressRootExitStatus = 6;
              break a;
            default:
              throw Error(formatProdErrorMessage(462));
          }
        }
        workLoopConcurrentByScheduler();
        break;
      } catch (thrownValue$169) {
        handleThrow(root2, thrownValue$169);
      }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
  }
  function workLoopConcurrentByScheduler() {
    for (; null !== workInProgress && !shouldYield(); )
      performUnitOfWork(workInProgress);
  }
  function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
  }
  function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch (next.tag) {
      case 15:
      case 0:
        next = replayFunctionComponent(
          current,
          next,
          next.pendingProps,
          next.type,
          void 0,
          workInProgressRootRenderLanes
        );
        break;
      case 11:
        next = replayFunctionComponent(
          current,
          next,
          next.pendingProps,
          next.type.render,
          next.ref,
          workInProgressRootRenderLanes
        );
        break;
      case 5:
        resetHooksOnUnwind(next);
      default:
        unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
  }
  function throwAndUnwindWorkLoop(root2, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState = null;
    thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
      if (throwException(
        root2,
        returnFiber,
        unitOfWork,
        thrownValue,
        workInProgressRootRenderLanes
      )) {
        workInProgressRootExitStatus = 1;
        logUncaughtError(
          root2,
          createCapturedValueAtFiber(thrownValue, root2.current)
        );
        workInProgress = null;
        return;
      }
    } catch (error) {
      if (null !== returnFiber) throw workInProgress = returnFiber, error;
      workInProgressRootExitStatus = 1;
      logUncaughtError(
        root2,
        createCapturedValueAtFiber(thrownValue, root2.current)
      );
      workInProgress = null;
      return;
    }
    if (unitOfWork.flags & 32768) {
      if (isHydrating || 1 === suspendedReason) root2 = true;
      else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912))
        root2 = false;
      else if (workInProgressRootDidSkipSuspendedSiblings = root2 = true, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason)
        suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
      unwindUnitOfWork(unitOfWork, root2);
    } else completeUnitOfWork(unitOfWork);
  }
  function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
      if (0 !== (completedWork.flags & 32768)) {
        unwindUnitOfWork(
          completedWork,
          workInProgressRootDidSkipSuspendedSiblings
        );
        return;
      }
      unitOfWork = completedWork.return;
      var next = completeWork(
        completedWork.alternate,
        completedWork,
        entangledRenderLanes
      );
      if (null !== next) {
        workInProgress = next;
        return;
      }
      completedWork = completedWork.sibling;
      if (null !== completedWork) {
        workInProgress = completedWork;
        return;
      }
      workInProgress = completedWork = unitOfWork;
    } while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
  }
  function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
      var next = unwindWork(unitOfWork.alternate, unitOfWork);
      if (null !== next) {
        next.flags &= 32767;
        workInProgress = next;
        return;
      }
      next = unitOfWork.return;
      null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
      if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
        workInProgress = unitOfWork;
        return;
      }
      workInProgress = unitOfWork = next;
    } while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
  }
  function commitRoot(root2, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root2.cancelPendingCommit = null;
    do
      flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    if (null !== finishedWork) {
      if (finishedWork === root2.current) throw Error(formatProdErrorMessage(177));
      didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
      didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
      markRootFinished(
        root2,
        lanes,
        didIncludeRenderPhaseUpdate,
        spawnedLane,
        updatedLanes,
        suspendedRetryLanes
      );
      root2 === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
      pendingFinishedWork = finishedWork;
      pendingEffectsRoot = root2;
      pendingEffectsLanes = lanes;
      pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
      pendingPassiveTransitions = transitions;
      pendingRecoverableErrors = recoverableErrors;
      0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root2.callbackNode = null, root2.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
        flushPassiveEffects();
        return null;
      })) : (root2.callbackNode = null, root2.callbackPriority = 0);
      recoverableErrors = 0 !== (finishedWork.flags & 13878);
      if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
        recoverableErrors = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        transitions = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        spawnedLane = executionContext;
        executionContext |= 4;
        try {
          commitBeforeMutationEffects(root2, finishedWork, lanes);
        } finally {
          executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
        }
      }
      pendingEffectsStatus = 1;
      flushMutationEffects();
      flushLayoutEffects();
      flushSpawnedWork();
    }
  }
  function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
      pendingEffectsStatus = 0;
      var root2 = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
      if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
        rootMutationHasEffect = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        try {
          commitMutationEffectsOnFiber(finishedWork, root2);
          var priorSelectionInformation = selectionInformation, curFocusedElem = getActiveElementDeep(root2.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
          if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(
            priorFocusedElem.ownerDocument.documentElement,
            priorFocusedElem
          )) {
            if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
              var start = priorSelectionRange.start, end = priorSelectionRange.end;
              void 0 === end && (end = start);
              if ("selectionStart" in priorFocusedElem)
                priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(
                  end,
                  priorFocusedElem.value.length
                );
              else {
                var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                if (win.getSelection) {
                  var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                  !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                  var startMarker = getNodeForCharacterOffset(
                    priorFocusedElem,
                    start$jscomp$0
                  ), endMarker = getNodeForCharacterOffset(
                    priorFocusedElem,
                    end$jscomp$0
                  );
                  if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                    var range = doc.createRange();
                    range.setStart(startMarker.node, startMarker.offset);
                    selection.removeAllRanges();
                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                  }
                }
              }
            }
            doc = [];
            for (selection = priorFocusedElem; selection = selection.parentNode; )
              1 === selection.nodeType && doc.push({
                element: selection,
                left: selection.scrollLeft,
                top: selection.scrollTop
              });
            "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
            for (priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++) {
              var info = doc[priorFocusedElem];
              info.element.scrollLeft = info.left;
              info.element.scrollTop = info.top;
            }
          }
          _enabled = !!eventsEnabled;
          selectionInformation = eventsEnabled = null;
        } finally {
          executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
        }
      }
      root2.current = finishedWork;
      pendingEffectsStatus = 2;
    }
  }
  function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
      pendingEffectsStatus = 0;
      var root2 = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
      if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
        rootHasLayoutEffect = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        try {
          commitLayoutEffectOnFiber(root2, finishedWork.alternate, finishedWork);
        } finally {
          executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
        }
      }
      pendingEffectsStatus = 3;
    }
  }
  function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
      pendingEffectsStatus = 0;
      requestPaint();
      var root2 = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
      0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root2, root2.pendingLanes));
      var remainingLanes = root2.pendingLanes;
      0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
      lanesToEventPriority(lanes);
      finishedWork = finishedWork.stateNode;
      if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot)
        try {
          injectedHook.onCommitFiberRoot(
            rendererID,
            finishedWork,
            void 0,
            128 === (finishedWork.current.flags & 128)
          );
        } catch (err) {
        }
      if (null !== recoverableErrors) {
        finishedWork = ReactSharedInternals.T;
        remainingLanes = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        ReactSharedInternals.T = null;
        try {
          for (var onRecoverableError = root2.onRecoverableError, i = 0; i < recoverableErrors.length; i++) {
            var recoverableError = recoverableErrors[i];
            onRecoverableError(recoverableError.value, {
              componentStack: recoverableError.stack
            });
          }
        } finally {
          ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = remainingLanes;
        }
      }
      0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
      ensureRootIsScheduled(root2);
      remainingLanes = root2.pendingLanes;
      0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root2 === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root2) : nestedUpdateCount = 0;
      flushSyncWorkAcrossRoots_impl(0);
    }
  }
  function releaseRootPooledCache(root2, remainingLanes) {
    0 === (root2.pooledCacheLanes &= remainingLanes) && (remainingLanes = root2.pooledCache, null != remainingLanes && (root2.pooledCache = null, releaseCache(remainingLanes)));
  }
  function flushPendingEffects(wasDelayedCommit) {
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects();
  }
  function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return false;
    var root2 = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
      ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
      ReactSharedInternals.T = null;
      renderPriority = pendingPassiveTransitions;
      pendingPassiveTransitions = null;
      var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
      pendingEffectsStatus = 0;
      pendingFinishedWork = pendingEffectsRoot = null;
      pendingEffectsLanes = 0;
      if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
      var prevExecutionContext = executionContext;
      executionContext |= 4;
      commitPassiveUnmountOnFiber(root$jscomp$0.current);
      commitPassiveMountOnFiber(
        root$jscomp$0,
        root$jscomp$0.current,
        lanes,
        renderPriority
      );
      executionContext = prevExecutionContext;
      flushSyncWorkAcrossRoots_impl(0, false);
      if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot)
        try {
          injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {
        }
      return true;
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root2, remainingLanes);
    }
  }
  function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
  }
  function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag)
      captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else
      for (; null !== nearestMountedAncestor; ) {
        if (3 === nearestMountedAncestor.tag) {
          captureCommitPhaseErrorOnRoot(
            nearestMountedAncestor,
            sourceFiber,
            error
          );
          break;
        } else if (1 === nearestMountedAncestor.tag) {
          var instance = nearestMountedAncestor.stateNode;
          if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
            sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
            error = createClassErrorUpdate(2);
            instance = enqueueUpdate(nearestMountedAncestor, error, 2);
            null !== instance && (initializeClassErrorUpdate(
              error,
              instance,
              nearestMountedAncestor,
              sourceFiber
            ), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
            break;
          }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
      }
  }
  function attachPingListener(root2, wakeable, lanes) {
    var pingCache = root2.pingCache;
    if (null === pingCache) {
      pingCache = root2.pingCache = new PossiblyWeakMap();
      var threadIDs = /* @__PURE__ */ new Set();
      pingCache.set(wakeable, threadIDs);
    } else
      threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = /* @__PURE__ */ new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = true, threadIDs.add(lanes), root2 = pingSuspendedRoot.bind(null, root2, wakeable, lanes), wakeable.then(root2, root2));
  }
  function pingSuspendedRoot(root2, wakeable, pingedLanes) {
    var pingCache = root2.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root2.pingedLanes |= root2.suspendedLanes & pingedLanes;
    root2.warmLanes &= ~pingedLanes;
    workInProgressRoot === root2 && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root2, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root2);
  }
  function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
  }
  function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
  }
  function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch (boundaryFiber.tag) {
      case 13:
        var retryCache = boundaryFiber.stateNode;
        var suspenseState = boundaryFiber.memoizedState;
        null !== suspenseState && (retryLane = suspenseState.retryLane);
        break;
      case 19:
        retryCache = boundaryFiber.stateNode;
        break;
      case 22:
        retryCache = boundaryFiber.stateNode._retryCache;
        break;
      default:
        throw Error(formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
  }
  function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
  }
  var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = false, mightHavePendingSyncWork = false, isFlushingWork = false, currentEventTransitionLane = 0;
  function ensureRootIsScheduled(root2) {
    root2 !== lastScheduledRoot && null === root2.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root2 : lastScheduledRoot = lastScheduledRoot.next = root2);
    mightHavePendingSyncWork = true;
    didScheduleMicrotask || (didScheduleMicrotask = true, scheduleImmediateRootScheduleTask());
  }
  function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
      isFlushingWork = true;
      do {
        var didPerformSomeWork = false;
        for (var root$174 = firstScheduledRoot; null !== root$174; ) {
          if (0 !== syncTransitionLanes) {
            var pendingLanes = root$174.pendingLanes;
            if (0 === pendingLanes) var JSCompiler_inline_result = 0;
            else {
              var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
              JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
              JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
              JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
            }
            0 !== JSCompiler_inline_result && (didPerformSomeWork = true, performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
          } else
            JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(
              root$174,
              root$174 === workInProgressRoot ? JSCompiler_inline_result : 0,
              null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle
            ), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = true, performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
          root$174 = root$174.next;
        }
      } while (didPerformSomeWork);
      isFlushingWork = false;
    }
  }
  function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
  }
  function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = false;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && (shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane), currentEventTransitionLane = 0);
    for (var currentTime = now(), prev = null, root2 = firstScheduledRoot; null !== root2; ) {
      var next = root2.next, nextLanes = scheduleTaskForRootDuringMicrotask(root2, currentTime);
      if (0 === nextLanes)
        root2.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
      else if (prev = root2, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3))
        mightHavePendingSyncWork = true;
      root2 = next;
    }
    flushSyncWorkAcrossRoots_impl(syncTransitionLanes);
  }
  function scheduleTaskForRootDuringMicrotask(root2, currentTime) {
    for (var suspendedLanes = root2.suspendedLanes, pingedLanes = root2.pingedLanes, expirationTimes = root2.expirationTimes, lanes = root2.pendingLanes & -62914561; 0 < lanes; ) {
      var index$3 = 31 - clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
      if (-1 === expirationTime) {
        if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes))
          expirationTimes[index$3] = computeExpirationTime(lane, currentTime);
      } else expirationTime <= currentTime && (root2.expiredLanes |= lane);
      lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(
      root2,
      root2 === currentTime ? suspendedLanes : 0,
      null !== root2.cancelPendingCommit || -1 !== root2.timeoutHandle
    );
    pingedLanes = root2.callbackNode;
    if (0 === suspendedLanes || root2 === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root2.cancelPendingCommit)
      return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root2.callbackNode = null, root2.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root2, suspendedLanes)) {
      currentTime = suspendedLanes & -suspendedLanes;
      if (currentTime === root2.callbackPriority) return currentTime;
      null !== pingedLanes && cancelCallback$1(pingedLanes);
      switch (lanesToEventPriority(suspendedLanes)) {
        case 2:
        case 8:
          suspendedLanes = UserBlockingPriority;
          break;
        case 32:
          suspendedLanes = NormalPriority$1;
          break;
        case 268435456:
          suspendedLanes = IdlePriority;
          break;
        default:
          suspendedLanes = NormalPriority$1;
      }
      pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root2);
      suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
      root2.callbackPriority = currentTime;
      root2.callbackNode = suspendedLanes;
      return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root2.callbackPriority = 2;
    root2.callbackNode = null;
    return 2;
  }
  function performWorkOnRootViaSchedulerTask(root2, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus)
      return root2.callbackNode = null, root2.callbackPriority = 0, null;
    var originalCallbackNode = root2.callbackNode;
    if (flushPendingEffects() && root2.callbackNode !== originalCallbackNode)
      return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(
      root2,
      root2 === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0,
      null !== root2.cancelPendingCommit || -1 !== root2.timeoutHandle
    );
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root2, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root2, now());
    return null != root2.callbackNode && root2.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root2) : null;
  }
  function performSyncWorkOnRoot(root2, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root2, lanes, true);
  }
  function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
      0 !== (executionContext & 6) ? scheduleCallback$3(
        ImmediatePriority,
        processRootScheduleInImmediateTask
      ) : processRootScheduleInMicrotask();
    });
  }
  function requestTransitionLane() {
    0 === currentEventTransitionLane && (currentEventTransitionLane = claimNextTransitionLane());
    return currentEventTransitionLane;
  }
  function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
  }
  function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
  }
  function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
      var action = coerceFormActionProp(
        (nativeEventTarget[internalPropsKey] || null).action
      ), submitter = nativeEvent.submitter;
      submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
      var event = new SyntheticEvent(
        "action",
        "action",
        null,
        nativeEvent,
        nativeEventTarget
      );
      dispatchQueue.push({
        event,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (nativeEvent.defaultPrevented) {
                if (0 !== currentEventTransitionLane) {
                  var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                  startHostTransition(
                    maybeTargetInst,
                    {
                      pending: true,
                      data: formData,
                      method: nativeEventTarget.method,
                      action
                    },
                    null,
                    formData
                  );
                }
              } else
                "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(
                  maybeTargetInst,
                  {
                    pending: true,
                    data: formData,
                    method: nativeEventTarget.method,
                    action
                  },
                  action,
                  formData
                ));
            },
            currentTarget: nativeEventTarget
          }
        ]
      });
    }
  }
  for (var i$jscomp$inline_1528 = 0; i$jscomp$inline_1528 < simpleEventPluginEvents.length; i$jscomp$inline_1528++) {
    var eventName$jscomp$inline_1529 = simpleEventPluginEvents[i$jscomp$inline_1528], domEventName$jscomp$inline_1530 = eventName$jscomp$inline_1529.toLowerCase(), capitalizedEvent$jscomp$inline_1531 = eventName$jscomp$inline_1529[0].toUpperCase() + eventName$jscomp$inline_1529.slice(1);
    registerSimpleEvent(
      domEventName$jscomp$inline_1530,
      "on" + capitalizedEvent$jscomp$inline_1531
    );
  }
  registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
  registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
  registerSimpleEvent(ANIMATION_START, "onAnimationStart");
  registerSimpleEvent("dblclick", "onDoubleClick");
  registerSimpleEvent("focusin", "onFocus");
  registerSimpleEvent("focusout", "onBlur");
  registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
  registerSimpleEvent(TRANSITION_START, "onTransitionStart");
  registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
  registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
  registerDirectEvent("onMouseEnter", ["mouseout", "mouseover"]);
  registerDirectEvent("onMouseLeave", ["mouseout", "mouseover"]);
  registerDirectEvent("onPointerEnter", ["pointerout", "pointerover"]);
  registerDirectEvent("onPointerLeave", ["pointerout", "pointerover"]);
  registerTwoPhaseEvent(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  );
  registerTwoPhaseEvent(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  );
  registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]);
  registerTwoPhaseEvent(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  );
  registerTwoPhaseEvent(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  );
  registerTwoPhaseEvent(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), nonDelegatedEvents = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes)
  );
  function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for (var i = 0; i < dispatchQueue.length; i++) {
      var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
      _dispatchQueue$i = _dispatchQueue$i.listeners;
      a: {
        var previousInstance = void 0;
        if (eventSystemFlags)
          for (var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--) {
            var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
            _dispatchListeners$i = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped())
              break a;
            previousInstance = _dispatchListeners$i;
            event.currentTarget = currentTarget;
            try {
              previousInstance(event);
            } catch (error) {
              reportGlobalError(error);
            }
            event.currentTarget = null;
            previousInstance = instance;
          }
        else
          for (i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++) {
            _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
            instance = _dispatchListeners$i.instance;
            currentTarget = _dispatchListeners$i.currentTarget;
            _dispatchListeners$i = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped())
              break a;
            previousInstance = _dispatchListeners$i;
            event.currentTarget = currentTarget;
            try {
              previousInstance(event);
            } catch (error) {
              reportGlobalError(error);
            }
            event.currentTarget = null;
            previousInstance = instance;
          }
      }
    }
  }
  function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = /* @__PURE__ */ new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, false), JSCompiler_inline_result.add(listenerSetKey));
  }
  function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(
      target,
      domEventName,
      eventSystemFlags,
      isCapturePhaseListener
    );
  }
  var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
  function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
      rootContainerElement[listeningMarker] = true;
      allNativeEvents.forEach(function(domEventName) {
        "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, false, rootContainerElement), listenToNativeEvent(domEventName, true, rootContainerElement));
      });
      var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
      null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = true, listenToNativeEvent("selectionchange", false, ownerDocument));
    }
  }
  function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch (getEventPriority(domEventName)) {
      case 2:
        var listenerWrapper = dispatchDiscreteEvent;
        break;
      case 8:
        listenerWrapper = dispatchContinuousEvent;
        break;
      default:
        listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(
      null,
      domEventName,
      eventSystemFlags,
      targetContainer
    );
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = true);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
      capture: true,
      passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, true) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
      passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, false);
  }
  function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0)
      a: for (; ; ) {
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
          var container = targetInst$jscomp$0.stateNode.containerInfo;
          if (container === targetContainer) break;
          if (4 === nodeTag)
            for (nodeTag = targetInst$jscomp$0.return; null !== nodeTag; ) {
              var grandTag = nodeTag.tag;
              if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer)
                return;
              nodeTag = nodeTag.return;
            }
          for (; null !== container; ) {
            nodeTag = getClosestInstanceFromNode(container);
            if (null === nodeTag) return;
            grandTag = nodeTag.tag;
            if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
              targetInst$jscomp$0 = ancestorInst = nodeTag;
              continue a;
            }
            container = container.parentNode;
          }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
      }
    batchedUpdates$1(function() {
      var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
      a: {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (void 0 !== reactName) {
          var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
          switch (domEventName) {
            case "keypress":
              if (0 === getEventCharCode(nativeEvent)) break a;
            case "keydown":
            case "keyup":
              SyntheticEventCtor = SyntheticKeyboardEvent;
              break;
            case "focusin":
              reactEventType = "focus";
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "focusout":
              reactEventType = "blur";
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "beforeblur":
            case "afterblur":
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "click":
              if (2 === nativeEvent.button) break a;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              SyntheticEventCtor = SyntheticMouseEvent;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              SyntheticEventCtor = SyntheticDragEvent;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              SyntheticEventCtor = SyntheticTouchEvent;
              break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
              SyntheticEventCtor = SyntheticAnimationEvent;
              break;
            case TRANSITION_END:
              SyntheticEventCtor = SyntheticTransitionEvent;
              break;
            case "scroll":
            case "scrollend":
              SyntheticEventCtor = SyntheticUIEvent;
              break;
            case "wheel":
              SyntheticEventCtor = SyntheticWheelEvent;
              break;
            case "copy":
            case "cut":
            case "paste":
              SyntheticEventCtor = SyntheticClipboardEvent;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              SyntheticEventCtor = SyntheticPointerEvent;
              break;
            case "toggle":
            case "beforetoggle":
              SyntheticEventCtor = SyntheticToggleEvent;
          }
          var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
          inCapturePhase = [];
          for (var instance = targetInst, lastHostComponent; null !== instance; ) {
            var _instance = instance;
            lastHostComponent = _instance.stateNode;
            _instance = _instance.tag;
            5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(
              createDispatchListener(instance, _instance, lastHostComponent)
            ));
            if (accumulateTargetOnly) break;
            instance = instance.return;
          }
          0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(
            reactName,
            reactEventType,
            null,
            nativeEvent,
            nativeEventTarget
          ), dispatchQueue.push({ event: reactName, listeners: inCapturePhase }));
        }
      }
      if (0 === (eventSystemFlags & 7)) {
        a: {
          reactName = "mouseover" === domEventName || "pointerover" === domEventName;
          SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
          if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey]))
            break a;
          if (SyntheticEventCtor || reactName) {
            reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
            if (SyntheticEventCtor) {
              if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase))
                reactEventType = null;
            } else SyntheticEventCtor = null, reactEventType = targetInst;
            if (SyntheticEventCtor !== reactEventType) {
              inCapturePhase = SyntheticMouseEvent;
              _instance = "onMouseLeave";
              reactEventName = "onMouseEnter";
              instance = "mouse";
              if ("pointerout" === domEventName || "pointerover" === domEventName)
                inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
              accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
              lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
              reactName = new inCapturePhase(
                _instance,
                instance + "leave",
                SyntheticEventCtor,
                nativeEvent,
                nativeEventTarget
              );
              reactName.target = accumulateTargetOnly;
              reactName.relatedTarget = lastHostComponent;
              _instance = null;
              getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(
                reactEventName,
                instance + "enter",
                reactEventType,
                nativeEvent,
                nativeEventTarget
              ), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
              accumulateTargetOnly = _instance;
              if (SyntheticEventCtor && reactEventType)
                b: {
                  inCapturePhase = SyntheticEventCtor;
                  reactEventName = reactEventType;
                  instance = 0;
                  for (lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = getParent(lastHostComponent))
                    instance++;
                  lastHostComponent = 0;
                  for (_instance = reactEventName; _instance; _instance = getParent(_instance))
                    lastHostComponent++;
                  for (; 0 < instance - lastHostComponent; )
                    inCapturePhase = getParent(inCapturePhase), instance--;
                  for (; 0 < lastHostComponent - instance; )
                    reactEventName = getParent(reactEventName), lastHostComponent--;
                  for (; instance--; ) {
                    if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate)
                      break b;
                    inCapturePhase = getParent(inCapturePhase);
                    reactEventName = getParent(reactEventName);
                  }
                  inCapturePhase = null;
                }
              else inCapturePhase = null;
              null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(
                dispatchQueue,
                reactName,
                SyntheticEventCtor,
                inCapturePhase,
                false
              );
              null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(
                dispatchQueue,
                accumulateTargetOnly,
                reactEventType,
                inCapturePhase,
                true
              );
            }
          }
        }
        a: {
          reactName = targetInst ? getNodeFromInstance(targetInst) : window;
          SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
          if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type)
            var getTargetInstFunc = getTargetInstForChangeEvent;
          else if (isTextInputElement(reactName))
            if (isInputEventSupported)
              getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
              getTargetInstFunc = getTargetInstForInputEventPolyfill;
              var handleEventFunc = handleEventsForInputEventPolyfill;
            }
          else
            SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
          if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
            createAndAccumulateChangeEvent(
              dispatchQueue,
              getTargetInstFunc,
              nativeEvent,
              nativeEventTarget
            );
            break a;
          }
          handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
          "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
        }
        handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
        switch (domEventName) {
          case "focusin":
            if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable)
              activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
            break;
          case "focusout":
            lastSelection = activeElementInst = activeElement = null;
            break;
          case "mousedown":
            mouseDown = true;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            mouseDown = false;
            constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            break;
          case "selectionchange":
            if (skipSelectionChangeEvent) break;
          case "keydown":
          case "keyup":
            constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
        var fallbackData;
        if (canUseCompositionEvent)
          b: {
            switch (domEventName) {
              case "compositionstart":
                var eventType = "onCompositionStart";
                break b;
              case "compositionend":
                eventType = "onCompositionEnd";
                break b;
              case "compositionupdate":
                eventType = "onCompositionUpdate";
                break b;
            }
            eventType = void 0;
          }
        else
          isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
        eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = true)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(
          eventType,
          domEventName,
          null,
          nativeEvent,
          nativeEventTarget
        ), dispatchQueue.push({ event: eventType, listeners: handleEventFunc }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
        if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent))
          eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent(
            "onBeforeInput",
            "beforeinput",
            null,
            nativeEvent,
            nativeEventTarget
          ), dispatchQueue.push({
            event: handleEventFunc,
            listeners: eventType
          }), handleEventFunc.data = fallbackData);
        extractEvents$1(
          dispatchQueue,
          domEventName,
          targetInst,
          nativeEvent,
          nativeEventTarget
        );
      }
      processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
  }
  function createDispatchListener(instance, listener, currentTarget) {
    return {
      instance,
      listener,
      currentTarget
    };
  }
  function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for (var captureName = reactName + "Capture", listeners = []; null !== targetFiber; ) {
      var _instance2 = targetFiber, stateNode = _instance2.stateNode;
      _instance2 = _instance2.tag;
      5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(
        createDispatchListener(targetFiber, _instance2, stateNode)
      ), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(
        createDispatchListener(targetFiber, _instance2, stateNode)
      ));
      if (3 === targetFiber.tag) return listeners;
      targetFiber = targetFiber.return;
    }
    return [];
  }
  function getParent(inst) {
    if (null === inst) return null;
    do
      inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
  }
  function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for (var registrationName = event._reactName, listeners = []; null !== target && target !== common; ) {
      var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
      _instance3 = _instance3.tag;
      if (null !== alternate && alternate === common) break;
      5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(
        createDispatchListener(target, stateNode, alternate)
      )) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(
        createDispatchListener(target, stateNode, alternate)
      )));
      target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({ event, listeners });
  }
  var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
  function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
  }
  function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? true : false;
  }
  function noop$1() {
  }
  function setProp(domElement, tag, key, value, props, prevValue) {
    switch (key) {
      case "children":
        "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && setTextContent(domElement, "" + value);
        break;
      case "className":
        setValueForKnownAttribute(domElement, "class", value);
        break;
      case "tabIndex":
        setValueForKnownAttribute(domElement, "tabindex", value);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        setValueForKnownAttribute(domElement, key, value);
        break;
      case "style":
        setValueForStyles(domElement, value, prevValue);
        break;
      case "data":
        if ("object" !== tag) {
          setValueForKnownAttribute(domElement, "data", value);
          break;
        }
      case "src":
      case "href":
        if ("" === value && ("a" !== tag || "href" !== key)) {
          domElement.removeAttribute(key);
          break;
        }
        if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
          domElement.removeAttribute(key);
          break;
        }
        value = sanitizeURL("" + value);
        domElement.setAttribute(key, value);
        break;
      case "action":
      case "formAction":
        if ("function" === typeof value) {
          domElement.setAttribute(
            key,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(
            domElement,
            tag,
            "formEncType",
            props.formEncType,
            props,
            null
          ), setProp(
            domElement,
            tag,
            "formMethod",
            props.formMethod,
            props,
            null
          ), setProp(
            domElement,
            tag,
            "formTarget",
            props.formTarget,
            props,
            null
          )) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
        if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
          domElement.removeAttribute(key);
          break;
        }
        value = sanitizeURL("" + value);
        domElement.setAttribute(key, value);
        break;
      case "onClick":
        null != value && (domElement.onclick = noop$1);
        break;
      case "onScroll":
        null != value && listenToNonDelegatedEvent("scroll", domElement);
        break;
      case "onScrollEnd":
        null != value && listenToNonDelegatedEvent("scrollend", domElement);
        break;
      case "dangerouslySetInnerHTML":
        if (null != value) {
          if ("object" !== typeof value || !("__html" in value))
            throw Error(formatProdErrorMessage(61));
          key = value.__html;
          if (null != key) {
            if (null != props.children) throw Error(formatProdErrorMessage(60));
            domElement.innerHTML = key;
          }
        }
        break;
      case "multiple":
        domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
        break;
      case "muted":
        domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
          domElement.removeAttribute("xlink:href");
          break;
        }
        key = sanitizeURL("" + value);
        domElement.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          key
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
        break;
      case "capture":
      case "download":
        true === value ? domElement.setAttribute(key, "") : false !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
        break;
      case "rowSpan":
      case "start":
        null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
        break;
      case "popover":
        listenToNonDelegatedEvent("beforetoggle", domElement);
        listenToNonDelegatedEvent("toggle", domElement);
        setValueForAttribute(domElement, "popover", value);
        break;
      case "xlinkActuate":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          value
        );
        break;
      case "xlinkArcrole":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          value
        );
        break;
      case "xlinkRole":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          value
        );
        break;
      case "xlinkShow":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          value
        );
        break;
      case "xlinkTitle":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          value
        );
        break;
      case "xlinkType":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          value
        );
        break;
      case "xmlBase":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          value
        );
        break;
      case "xmlLang":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          value
        );
        break;
      case "xmlSpace":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          value
        );
        break;
      case "is":
        setValueForAttribute(domElement, "is", value);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1])
          key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
    }
  }
  function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch (key) {
      case "style":
        setValueForStyles(domElement, value, prevValue);
        break;
      case "dangerouslySetInnerHTML":
        if (null != value) {
          if ("object" !== typeof value || !("__html" in value))
            throw Error(formatProdErrorMessage(61));
          key = value.__html;
          if (null != key) {
            if (null != props.children) throw Error(formatProdErrorMessage(60));
            domElement.innerHTML = key;
          }
        }
        break;
      case "children":
        "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
        break;
      case "onScroll":
        null != value && listenToNonDelegatedEvent("scroll", domElement);
        break;
      case "onScrollEnd":
        null != value && listenToNonDelegatedEvent("scrollend", domElement);
        break;
      case "onClick":
        null != value && (domElement.onclick = noop$1);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!registrationNameDependencies.hasOwnProperty(key))
          a: {
            if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
              "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
              domElement.addEventListener(tag, value, props);
              break a;
            }
            key in domElement ? domElement[key] = value : true === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
          }
    }
  }
  function setInitialProperties(domElement, tag, props) {
    switch (tag) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        listenToNonDelegatedEvent("error", domElement);
        listenToNonDelegatedEvent("load", domElement);
        var hasSrc = false, hasSrcSet = false, propKey;
        for (propKey in props)
          if (props.hasOwnProperty(propKey)) {
            var propValue = props[propKey];
            if (null != propValue)
              switch (propKey) {
                case "src":
                  hasSrc = true;
                  break;
                case "srcSet":
                  hasSrcSet = true;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(formatProdErrorMessage(137, tag));
                default:
                  setProp(domElement, tag, propKey, propValue, props, null);
              }
          }
        hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
        hasSrc && setProp(domElement, tag, "src", props.src, props, null);
        return;
      case "input":
        listenToNonDelegatedEvent("invalid", domElement);
        var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
        for (hasSrc in props)
          if (props.hasOwnProperty(hasSrc)) {
            var propValue$188 = props[hasSrc];
            if (null != propValue$188)
              switch (hasSrc) {
                case "name":
                  hasSrcSet = propValue$188;
                  break;
                case "type":
                  propValue = propValue$188;
                  break;
                case "checked":
                  checked = propValue$188;
                  break;
                case "defaultChecked":
                  defaultChecked = propValue$188;
                  break;
                case "value":
                  propKey = propValue$188;
                  break;
                case "defaultValue":
                  defaultValue = propValue$188;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (null != propValue$188)
                    throw Error(formatProdErrorMessage(137, tag));
                  break;
                default:
                  setProp(domElement, tag, hasSrc, propValue$188, props, null);
              }
          }
        initInput(
          domElement,
          propKey,
          defaultValue,
          checked,
          defaultChecked,
          propValue,
          hasSrcSet,
          false
        );
        track(domElement);
        return;
      case "select":
        listenToNonDelegatedEvent("invalid", domElement);
        hasSrc = propValue = propKey = null;
        for (hasSrcSet in props)
          if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue))
            switch (hasSrcSet) {
              case "value":
                propKey = defaultValue;
                break;
              case "defaultValue":
                propValue = defaultValue;
                break;
              case "multiple":
                hasSrc = defaultValue;
              default:
                setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
        tag = propKey;
        props = propValue;
        domElement.multiple = !!hasSrc;
        null != tag ? updateOptions(domElement, !!hasSrc, tag, false) : null != props && updateOptions(domElement, !!hasSrc, props, true);
        return;
      case "textarea":
        listenToNonDelegatedEvent("invalid", domElement);
        propKey = hasSrcSet = hasSrc = null;
        for (propValue in props)
          if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue))
            switch (propValue) {
              case "value":
                hasSrc = defaultValue;
                break;
              case "defaultValue":
                hasSrcSet = defaultValue;
                break;
              case "children":
                propKey = defaultValue;
                break;
              case "dangerouslySetInnerHTML":
                if (null != defaultValue) throw Error(formatProdErrorMessage(91));
                break;
              default:
                setProp(domElement, tag, propValue, defaultValue, props, null);
            }
        initTextarea(domElement, hasSrc, hasSrcSet, propKey);
        track(domElement);
        return;
      case "option":
        for (checked in props)
          if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc))
            switch (checked) {
              case "selected":
                domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                break;
              default:
                setProp(domElement, tag, checked, hasSrc, props, null);
            }
        return;
      case "dialog":
        listenToNonDelegatedEvent("beforetoggle", domElement);
        listenToNonDelegatedEvent("toggle", domElement);
        listenToNonDelegatedEvent("cancel", domElement);
        listenToNonDelegatedEvent("close", domElement);
        break;
      case "iframe":
      case "object":
        listenToNonDelegatedEvent("load", domElement);
        break;
      case "video":
      case "audio":
        for (hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)
          listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
        break;
      case "image":
        listenToNonDelegatedEvent("error", domElement);
        listenToNonDelegatedEvent("load", domElement);
        break;
      case "details":
        listenToNonDelegatedEvent("toggle", domElement);
        break;
      case "embed":
      case "source":
      case "link":
        listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (defaultChecked in props)
          if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc))
            switch (defaultChecked) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(formatProdErrorMessage(137, tag));
              default:
                setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
        return;
      default:
        if (isCustomElement(tag)) {
          for (propValue$188 in props)
            props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && setPropOnCustomElement(
              domElement,
              tag,
              propValue$188,
              hasSrc,
              props,
              void 0
            ));
          return;
        }
    }
    for (defaultValue in props)
      props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
  }
  function updateProperties(domElement, tag, lastProps, nextProps) {
    switch (tag) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
        for (propKey in lastProps) {
          var lastProp = lastProps[propKey];
          if (lastProps.hasOwnProperty(propKey) && null != lastProp)
            switch (propKey) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                lastDefaultValue = lastProp;
              default:
                nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
            }
        }
        for (var propKey$205 in nextProps) {
          var propKey = nextProps[propKey$205];
          lastProp = lastProps[propKey$205];
          if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp))
            switch (propKey$205) {
              case "type":
                type = propKey;
                break;
              case "name":
                name = propKey;
                break;
              case "checked":
                checked = propKey;
                break;
              case "defaultChecked":
                defaultChecked = propKey;
                break;
              case "value":
                value = propKey;
                break;
              case "defaultValue":
                defaultValue = propKey;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (null != propKey)
                  throw Error(formatProdErrorMessage(137, tag));
                break;
              default:
                propKey !== lastProp && setProp(
                  domElement,
                  tag,
                  propKey$205,
                  propKey,
                  nextProps,
                  lastProp
                );
            }
        }
        updateInput(
          domElement,
          value,
          defaultValue,
          lastDefaultValue,
          checked,
          defaultChecked,
          type,
          name
        );
        return;
      case "select":
        propKey = value = defaultValue = propKey$205 = null;
        for (type in lastProps)
          if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue)
            switch (type) {
              case "value":
                break;
              case "multiple":
                propKey = lastDefaultValue;
              default:
                nextProps.hasOwnProperty(type) || setProp(
                  domElement,
                  tag,
                  type,
                  null,
                  nextProps,
                  lastDefaultValue
                );
            }
        for (name in nextProps)
          if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue))
            switch (name) {
              case "value":
                propKey$205 = type;
                break;
              case "defaultValue":
                defaultValue = type;
                break;
              case "multiple":
                value = type;
              default:
                type !== lastDefaultValue && setProp(
                  domElement,
                  tag,
                  name,
                  type,
                  nextProps,
                  lastDefaultValue
                );
            }
        tag = defaultValue;
        lastProps = value;
        nextProps = propKey;
        null != propKey$205 ? updateOptions(domElement, !!lastProps, propKey$205, false) : !!nextProps !== !!lastProps && (null != tag ? updateOptions(domElement, !!lastProps, tag, true) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", false));
        return;
      case "textarea":
        propKey = propKey$205 = null;
        for (defaultValue in lastProps)
          if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue))
            switch (defaultValue) {
              case "value":
                break;
              case "children":
                break;
              default:
                setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
        for (value in nextProps)
          if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type))
            switch (value) {
              case "value":
                propKey$205 = name;
                break;
              case "defaultValue":
                propKey = name;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (null != name) throw Error(formatProdErrorMessage(91));
                break;
              default:
                name !== type && setProp(domElement, tag, value, name, nextProps, type);
            }
        updateTextarea(domElement, propKey$205, propKey);
        return;
      case "option":
        for (var propKey$221 in lastProps)
          if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221))
            switch (propKey$221) {
              case "selected":
                domElement.selected = false;
                break;
              default:
                setProp(
                  domElement,
                  tag,
                  propKey$221,
                  null,
                  nextProps,
                  propKey$205
                );
            }
        for (lastDefaultValue in nextProps)
          if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey))
            switch (lastDefaultValue) {
              case "selected":
                domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                break;
              default:
                setProp(
                  domElement,
                  tag,
                  lastDefaultValue,
                  propKey$205,
                  nextProps,
                  propKey
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var propKey$226 in lastProps)
          propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
        for (checked in nextProps)
          if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey))
            switch (checked) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (null != propKey$205)
                  throw Error(formatProdErrorMessage(137, tag));
                break;
              default:
                setProp(
                  domElement,
                  tag,
                  checked,
                  propKey$205,
                  nextProps,
                  propKey
                );
            }
        return;
      default:
        if (isCustomElement(tag)) {
          for (var propKey$231 in lastProps)
            propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && setPropOnCustomElement(
              domElement,
              tag,
              propKey$231,
              void 0,
              nextProps,
              propKey$205
            );
          for (defaultChecked in nextProps)
            propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || setPropOnCustomElement(
              domElement,
              tag,
              defaultChecked,
              propKey$205,
              nextProps,
              propKey
            );
          return;
        }
    }
    for (var propKey$236 in lastProps)
      propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for (lastProp in nextProps)
      propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
  }
  var eventsEnabled = null, selectionInformation = null;
  function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
  }
  function getOwnHostContext(namespaceURI) {
    switch (namespaceURI) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace)
      switch (type) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
  }
  function shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
  }
  var currentPopstateTransitionEvent = null;
  function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
      if (event === currentPopstateTransitionEvent) return false;
      currentPopstateTransitionEvent = event;
      return true;
    }
    currentPopstateTransitionEvent = null;
    return false;
  }
  var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
  } : scheduleTimeout;
  function handleErrorInNextTick(error) {
    setTimeout(function() {
      throw error;
    });
  }
  function isSingletonScope(type) {
    return "head" === type;
  }
  function clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
      var nextNode = node.nextSibling;
      parentInstance.removeChild(node);
      if (nextNode && 8 === nextNode.nodeType)
        if (node = nextNode.data, "/$" === node) {
          if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
            node = possiblePreambleContribution;
            var ownerDocument = parentInstance.ownerDocument;
            node & 1 && releaseSingletonInstance(ownerDocument.documentElement);
            node & 2 && releaseSingletonInstance(ownerDocument.body);
            if (node & 4)
              for (node = ownerDocument.head, releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument; ) {
                var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                ownerDocument[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                ownerDocument = nextNode$jscomp$0;
              }
          }
          if (0 === depth) {
            parentInstance.removeChild(nextNode);
            retryIfBlockedOn(suspenseInstance);
            return;
          }
          depth--;
        } else
          "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
      else possiblePreambleContribution = 0;
      node = nextNode;
    } while (node);
    retryIfBlockedOn(suspenseInstance);
  }
  function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for (; nextNode; ) {
      var node = nextNode;
      nextNode = nextNode.nextSibling;
      switch (node.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          clearContainerSparingly(node);
          detachDeletedInstance(node);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if ("stylesheet" === node.rel.toLowerCase()) continue;
      }
      container.removeChild(node);
    }
  }
  function canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for (; 1 === instance.nodeType; ) {
      var anyProps = props;
      if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
        if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type))
          break;
      } else if (!inRootOrSingleton)
        if ("input" === type && "hidden" === instance.type) {
          var name = null == anyProps.name ? null : "" + anyProps.name;
          if ("hidden" === anyProps.type && instance.getAttribute("name") === name)
            return instance;
        } else return instance;
      else if (!instance[internalHoistableMarker])
        switch (type) {
          case "meta":
            if (!instance.hasAttribute("itemprop")) break;
            return instance;
          case "link":
            name = instance.getAttribute("rel");
            if ("stylesheet" === name && instance.hasAttribute("data-precedence"))
              break;
            else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title))
              break;
            return instance;
          case "style":
            if (instance.hasAttribute("data-precedence")) break;
            return instance;
          case "script":
            name = instance.getAttribute("src");
            if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop"))
              break;
            return instance;
          default:
            return instance;
        }
      instance = getNextHydratable(instance.nextSibling);
      if (null === instance) break;
    }
    return null;
  }
  function canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for (; 3 !== instance.nodeType; ) {
      if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton)
        return null;
      instance = getNextHydratable(instance.nextSibling);
      if (null === instance) return null;
    }
    return instance;
  }
  function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
  }
  function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState)
      callback();
    else {
      var listener = function() {
        callback();
        ownerDocument.removeEventListener("DOMContentLoaded", listener);
      };
      ownerDocument.addEventListener("DOMContentLoaded", listener);
      instance._reactRetry = listener;
    }
  }
  function getNextHydratable(node) {
    for (; null != node; node = node.nextSibling) {
      var nodeType = node.nodeType;
      if (1 === nodeType || 3 === nodeType) break;
      if (8 === nodeType) {
        nodeType = node.data;
        if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType)
          break;
        if ("/$" === nodeType) return null;
      }
    }
    return node;
  }
  var previousHydratableOnEnteringScopedSingleton = null;
  function getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for (var depth = 0; targetInstance; ) {
      if (8 === targetInstance.nodeType) {
        var data = targetInstance.data;
        if ("$" === data || "$!" === data || "$?" === data) {
          if (0 === depth) return targetInstance;
          depth--;
        } else "/$" === data && depth++;
      }
      targetInstance = targetInstance.previousSibling;
    }
    return null;
  }
  function resolveSingletonInstance(type, props, rootContainerInstance) {
    props = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch (type) {
      case "html":
        type = props.documentElement;
        if (!type) throw Error(formatProdErrorMessage(452));
        return type;
      case "head":
        type = props.head;
        if (!type) throw Error(formatProdErrorMessage(453));
        return type;
      case "body":
        type = props.body;
        if (!type) throw Error(formatProdErrorMessage(454));
        return type;
      default:
        throw Error(formatProdErrorMessage(451));
    }
  }
  function releaseSingletonInstance(instance) {
    for (var attributes = instance.attributes; attributes.length; )
      instance.removeAttributeNode(attributes[0]);
    detachDeletedInstance(instance);
  }
  var preloadPropsMap = /* @__PURE__ */ new Map(), preconnectsSet = /* @__PURE__ */ new Set();
  function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
  }
  var previousDispatcher = ReactDOMSharedInternals.d;
  ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
  };
  function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
  }
  function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
  }
  var globalDocument = "undefined" === typeof document ? null : document;
  function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
      var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
      limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
      "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
      preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = { rel, crossOrigin, href }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
  }
  function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
  }
  function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
  }
  function preload(href, as, options2) {
    previousDispatcher.L(href, as, options2);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
      var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
      "image" === as ? options2 && options2.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(
        options2.imageSrcSet
      ) + '"]', "string" === typeof options2.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(
        options2.imageSizes
      ) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
      var key = preloadSelector;
      switch (as) {
        case "style":
          key = getStyleKey(href);
          break;
        case "script":
          key = getScriptKey(href);
      }
      preloadPropsMap.has(key) || (href = assign(
        {
          rel: "preload",
          href: "image" === as && options2 && options2.imageSrcSet ? void 0 : href,
          as
        },
        options2
      ), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
  }
  function preloadModule(href, options2) {
    previousDispatcher.m(href, options2);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
      var as = options2 && "string" === typeof options2.as ? options2.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
      switch (as) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          key = getScriptKey(href);
      }
      if (!preloadPropsMap.has(key) && (href = assign({ rel: "modulepreload", href }, options2), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
        switch (as) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (ownerDocument.querySelector(getScriptSelectorFromKey(key)))
              return;
        }
        as = ownerDocument.createElement("link");
        setInitialProperties(as, "link", href);
        markNodeAsHoistable(as);
        ownerDocument.head.appendChild(as);
      }
    }
  }
  function preinitStyle(href, precedence, options2) {
    previousDispatcher.S(href, precedence, options2);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
      var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
      precedence = precedence || "default";
      var resource = styles.get(key);
      if (!resource) {
        var state = { loading: 0, preload: null };
        if (resource = ownerDocument.querySelector(
          getStylesheetSelectorFromKey(key)
        ))
          state.loading = 5;
        else {
          href = assign(
            { rel: "stylesheet", href, "data-precedence": precedence },
            options2
          );
          (options2 = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options2);
          var link = resource = ownerDocument.createElement("link");
          markNodeAsHoistable(link);
          setInitialProperties(link, "link", href);
          link._p = new Promise(function(resolve, reject) {
            link.onload = resolve;
            link.onerror = reject;
          });
          link.addEventListener("load", function() {
            state.loading |= 1;
          });
          link.addEventListener("error", function() {
            state.loading |= 2;
          });
          state.loading |= 4;
          insertStylesheet(resource, precedence, ownerDocument);
        }
        resource = {
          type: "stylesheet",
          instance: resource,
          count: 1,
          state
        };
        styles.set(key, resource);
      }
    }
  }
  function preinitScript(src, options2) {
    previousDispatcher.X(src, options2);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
      var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
      resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({ src, async: true }, options2), (options2 = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options2), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
        type: "script",
        instance: resource,
        count: 1,
        state: null
      }, scripts.set(key, resource));
    }
  }
  function preinitModuleScript(src, options2) {
    previousDispatcher.M(src, options2);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
      var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
      resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({ src, async: true, type: "module" }, options2), (options2 = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options2), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
        type: "script",
        instance: resource,
        count: 1,
        state: null
      }, scripts.set(key, resource));
    }
  }
  function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
    switch (type) {
      case "meta":
      case "title":
        return null;
      case "style":
        return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(
          JSCompiler_inline_result
        ).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, pendingProps.set(currentProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
          type = getStyleKey(pendingProps.href);
          var styles$244 = getResourcesFromRoot(
            JSCompiler_inline_result
          ).hoistableStyles, resource$245 = styles$244.get(type);
          resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector(
            getStylesheetSelectorFromKey(type)
          )) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), preloadPropsMap.has(type) || (pendingProps = {
            rel: "preload",
            as: "style",
            href: pendingProps.href,
            crossOrigin: pendingProps.crossOrigin,
            integrity: pendingProps.integrity,
            media: pendingProps.media,
            hrefLang: pendingProps.hrefLang,
            referrerPolicy: pendingProps.referrerPolicy
          }, preloadPropsMap.set(type, pendingProps), styles$244 || preloadStylesheet(
            JSCompiler_inline_result,
            type,
            pendingProps,
            resource$245.state
          )));
          if (currentProps && null === currentResource)
            throw Error(formatProdErrorMessage(528, ""));
          return resource$245;
        }
        if (currentProps && null !== currentResource)
          throw Error(formatProdErrorMessage(529, ""));
        return null;
      case "script":
        return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(
          JSCompiler_inline_result
        ).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, pendingProps.set(currentProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(formatProdErrorMessage(444, type));
    }
  }
  function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
  }
  function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
  }
  function stylesheetPropsFromRawProps(rawProps) {
    return assign({}, rawProps, {
      "data-precedence": rawProps.precedence,
      precedence: null
    });
  }
  function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
      return state.loading |= 1;
    }), key.addEventListener("error", function() {
      return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
  }
  function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
  }
  function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
  }
  function acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance)
      switch (resource.type) {
        case "style":
          var instance = hoistableRoot.querySelector(
            'style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]'
          );
          if (instance)
            return resource.instance = instance, markNodeAsHoistable(instance), instance;
          var styleProps = assign({}, props, {
            "data-href": props.href,
            "data-precedence": props.precedence,
            href: null,
            precedence: null
          });
          instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement(
            "style"
          );
          markNodeAsHoistable(instance);
          setInitialProperties(instance, "style", styleProps);
          insertStylesheet(instance, props.precedence, hoistableRoot);
          return resource.instance = instance;
        case "stylesheet":
          styleProps = getStyleKey(props.href);
          var instance$250 = hoistableRoot.querySelector(
            getStylesheetSelectorFromKey(styleProps)
          );
          if (instance$250)
            return resource.state.loading |= 4, resource.instance = instance$250, markNodeAsHoistable(instance$250), instance$250;
          instance = stylesheetPropsFromRawProps(props);
          (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
          instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
          markNodeAsHoistable(instance$250);
          var linkInstance = instance$250;
          linkInstance._p = new Promise(function(resolve, reject) {
            linkInstance.onload = resolve;
            linkInstance.onerror = reject;
          });
          setInitialProperties(instance$250, "link", instance);
          resource.state.loading |= 4;
          insertStylesheet(instance$250, props.precedence, hoistableRoot);
          return resource.instance = instance$250;
        case "script":
          instance$250 = getScriptKey(props.src);
          if (styleProps = hoistableRoot.querySelector(
            getScriptSelectorFromKey(instance$250)
          ))
            return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
          instance = props;
          if (styleProps = preloadPropsMap.get(instance$250))
            instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
          hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
          styleProps = hoistableRoot.createElement("script");
          markNodeAsHoistable(styleProps);
          setInitialProperties(styleProps, "link", instance);
          hoistableRoot.head.appendChild(styleProps);
          return resource.instance = styleProps;
        case "void":
          return null;
        default:
          throw Error(formatProdErrorMessage(443, resource.type));
      }
    else
      "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
  }
  function insertStylesheet(instance, precedence, root2) {
    for (var nodes = root2.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.dataset.precedence === precedence) prior = node;
      else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root2.nodeType ? root2.head : root2, precedence.insertBefore(instance, precedence.firstChild));
  }
  function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
  }
  function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
  }
  var tagCaches = null;
  function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
      var cache = /* @__PURE__ */ new Map();
      var caches = tagCaches = /* @__PURE__ */ new Map();
      caches.set(ownerDocument, cache);
    } else
      caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = /* @__PURE__ */ new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for (caches = 0; caches < ownerDocument.length; caches++) {
      var node = ownerDocument[caches];
      if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
        var nodeKey = node.getAttribute(keyAttribute) || "";
        nodeKey = type + nodeKey;
        var existing = cache.get(nodeKey);
        existing ? existing.push(node) : cache.set(nodeKey, [node]);
      }
    }
    return cache;
  }
  function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(
      instance,
      "title" === type ? hoistableRoot.querySelector("head > title") : null
    );
  }
  function isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return false;
    switch (type) {
      case "meta":
      case "title":
        return true;
      case "style":
        if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href)
          break;
        return true;
      case "link":
        if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError)
          break;
        switch (props.rel) {
          case "stylesheet":
            return type = props.disabled, "string" === typeof props.precedence && null == type;
          default:
            return true;
        }
      case "script":
        if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src)
          return true;
    }
    return false;
  }
  function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? false : true;
  }
  var suspendedState = null;
  function noop() {
  }
  function suspendResource(hoistableRoot, resource, props) {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || false !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
      if (null === resource.instance) {
        var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(
          getStylesheetSelectorFromKey(key)
        );
        if (instance) {
          hoistableRoot = instance._p;
          null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
          resource.state.loading |= 4;
          resource.instance = instance;
          markNodeAsHoistable(instance);
          return;
        }
        instance = hoistableRoot.ownerDocument || hoistableRoot;
        props = stylesheetPropsFromRawProps(props);
        (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
        instance = instance.createElement("link");
        markNodeAsHoistable(instance);
        var linkInstance = instance;
        linkInstance._p = new Promise(function(resolve, reject) {
          linkInstance.onload = resolve;
          linkInstance.onerror = reject;
        });
        setInitialProperties(instance, "link", props);
        resource.instance = instance;
      }
      null === state.stylesheets && (state.stylesheets = /* @__PURE__ */ new Map());
      state.stylesheets.set(resource, hoistableRoot);
      (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
  }
  function waitForCommitToBeReady() {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
      var stylesheetTimer = setTimeout(function() {
        state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
        if (state.unsuspend) {
          var unsuspend = state.unsuspend;
          state.unsuspend = null;
          unsuspend();
        }
      }, 6e4);
      state.unsuspend = commit;
      return function() {
        state.unsuspend = null;
        clearTimeout(stylesheetTimer);
      };
    } : null;
  }
  function onUnsuspend() {
    this.count--;
    if (0 === this.count) {
      if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
      else if (this.unsuspend) {
        var unsuspend = this.unsuspend;
        this.unsuspend = null;
        unsuspend();
      }
    }
  }
  var precedencesByRoot = null;
  function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = /* @__PURE__ */ new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
  }
  function insertStylesheetIntoRoot(root2, resource) {
    if (!(resource.state.loading & 4)) {
      var precedences = precedencesByRoot.get(root2);
      if (precedences) var last = precedences.get(null);
      else {
        precedences = /* @__PURE__ */ new Map();
        precedencesByRoot.set(root2, precedences);
        for (var nodes = root2.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), i = 0; i < nodes.length; i++) {
          var node = nodes[i];
          if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media"))
            precedences.set(node.dataset.precedence, node), last = node;
        }
        last && precedences.set(null, last);
      }
      nodes = resource.instance;
      node = nodes.getAttribute("data-precedence");
      i = precedences.get(node) || last;
      i === last && precedences.set(null, nodes);
      precedences.set(node, nodes);
      this.count++;
      last = onUnsuspend.bind(this);
      nodes.addEventListener("load", last);
      nodes.addEventListener("error", last);
      i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root2 = 9 === root2.nodeType ? root2.head : root2, root2.insertBefore(nodes, root2.firstChild));
      resource.state.loading |= 4;
    }
  }
  var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
  };
  function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new FiberRootNode(
      containerInfo,
      tag,
      hydrate,
      identifierPrefix,
      onUncaughtError,
      onCaughtError,
      onRecoverableError,
      formState
    );
    tag = 1;
    true === isStrictMode && (tag |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
      element: initialChildren,
      isDehydrated: hydrate,
      cache: tag
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
  }
  function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
  }
  function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = { element };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = enqueueUpdate(rootFiber, container, lane);
    null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
  }
  function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
      var a = fiber.retryLane;
      fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
  }
  function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
  }
  function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
      var root2 = enqueueConcurrentRenderForLane(fiber, 67108864);
      null !== root2 && scheduleUpdateOnFiber(root2, fiber, 67108864);
      markRetryLaneIfNotHydrated(fiber, 67108864);
    }
  }
  var _enabled = true;
  function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
      ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
  }
  function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
      ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
  }
  function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
      var blockedOn = findInstanceBlockingEvent(nativeEvent);
      if (null === blockedOn)
        dispatchEventForPluginEventSystem(
          domEventName,
          eventSystemFlags,
          nativeEvent,
          return_targetInst,
          targetContainer
        ), clearIfContinuousEvent(domEventName, nativeEvent);
      else if (queueIfContinuousEvent(
        blockedOn,
        domEventName,
        eventSystemFlags,
        targetContainer,
        nativeEvent
      ))
        nativeEvent.stopPropagation();
      else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
        for (; null !== blockedOn; ) {
          var fiber = getInstanceFromNode(blockedOn);
          if (null !== fiber)
            switch (fiber.tag) {
              case 3:
                fiber = fiber.stateNode;
                if (fiber.current.memoizedState.isDehydrated) {
                  var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                  if (0 !== lanes) {
                    var root2 = fiber;
                    root2.pendingLanes |= 2;
                    for (root2.entangledLanes |= 2; lanes; ) {
                      var lane = 1 << 31 - clz32(lanes);
                      root2.entanglements[1] |= lane;
                      lanes &= ~lane;
                    }
                    ensureRootIsScheduled(fiber);
                    0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0));
                  }
                }
                break;
              case 13:
                root2 = enqueueConcurrentRenderForLane(fiber, 2), null !== root2 && scheduleUpdateOnFiber(root2, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
            }
          fiber = findInstanceBlockingEvent(nativeEvent);
          null === fiber && dispatchEventForPluginEventSystem(
            domEventName,
            eventSystemFlags,
            nativeEvent,
            return_targetInst,
            targetContainer
          );
          if (fiber === blockedOn) break;
          blockedOn = fiber;
        }
        null !== blockedOn && nativeEvent.stopPropagation();
      } else
        dispatchEventForPluginEventSystem(
          domEventName,
          eventSystemFlags,
          nativeEvent,
          null,
          targetContainer
        );
    }
  }
  function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
  }
  var return_targetInst = null;
  function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
      var nearestMounted = getNearestMountedFiber(targetNode);
      if (null === nearestMounted) targetNode = null;
      else {
        var tag = nearestMounted.tag;
        if (13 === tag) {
          targetNode = getSuspenseInstanceFromFiber(nearestMounted);
          if (null !== targetNode) return targetNode;
          targetNode = null;
        } else if (3 === tag) {
          if (nearestMounted.stateNode.current.memoizedState.isDehydrated)
            return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
          targetNode = null;
        } else nearestMounted !== targetNode && (targetNode = null);
      }
    }
    return_targetInst = targetNode;
    return null;
  }
  function getEventPriority(domEventName) {
    switch (domEventName) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (getCurrentPriorityLevel()) {
          case ImmediatePriority:
            return 2;
          case UserBlockingPriority:
            return 8;
          case NormalPriority$1:
          case LowPriority:
            return 32;
          case IdlePriority:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var hasScheduledReplayAttempt = false, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = /* @__PURE__ */ new Map(), queuedPointerCaptures = /* @__PURE__ */ new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch (domEventName) {
      case "focusin":
      case "focusout":
        queuedFocus = null;
        break;
      case "dragenter":
      case "dragleave":
        queuedDrag = null;
        break;
      case "mouseover":
      case "mouseout":
        queuedMouse = null;
        break;
      case "pointerover":
      case "pointerout":
        queuedPointers.delete(nativeEvent.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
  }
  function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent)
      return existingQueuedEvent = {
        blockedOn,
        domEventName,
        eventSystemFlags,
        nativeEvent,
        targetContainers: [targetContainer]
      }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
  }
  function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch (domEventName) {
      case "focusin":
        return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedFocus,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ), true;
      case "dragenter":
        return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedDrag,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ), true;
      case "mouseover":
        return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedMouse,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ), true;
      case "pointerover":
        var pointerId = nativeEvent.pointerId;
        queuedPointers.set(
          pointerId,
          accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedPointers.get(pointerId) || null,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          )
        );
        return true;
      case "gotpointercapture":
        return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(
          pointerId,
          accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedPointerCaptures.get(pointerId) || null,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          )
        ), true;
    }
    return false;
  }
  function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
      var nearestMounted = getNearestMountedFiber(targetInst);
      if (null !== nearestMounted) {
        if (targetInst = nearestMounted.tag, 13 === targetInst) {
          if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
            queuedTarget.blockedOn = targetInst;
            runWithPriority(queuedTarget.priority, function() {
              if (13 === nearestMounted.tag) {
                var lane = requestUpdateLane();
                lane = getBumpedLaneForHydrationByLane(lane);
                var root2 = enqueueConcurrentRenderForLane(nearestMounted, lane);
                null !== root2 && scheduleUpdateOnFiber(root2, nearestMounted, lane);
                markRetryLaneIfNotHydrated(nearestMounted, lane);
              }
            });
            return;
          }
        } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
          queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
          return;
        }
      }
    }
    queuedTarget.blockedOn = null;
  }
  function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return false;
    for (var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length; ) {
      var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
      if (null === nextBlockedOn) {
        nextBlockedOn = queuedEvent.nativeEvent;
        var nativeEventClone = new nextBlockedOn.constructor(
          nextBlockedOn.type,
          nextBlockedOn
        );
        currentReplayingEvent = nativeEventClone;
        nextBlockedOn.target.dispatchEvent(nativeEventClone);
        currentReplayingEvent = null;
      } else
        return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, false;
      targetContainers.shift();
    }
    return true;
  }
  function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
  }
  function replayUnblockedEvents() {
    hasScheduledReplayAttempt = false;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
  }
  function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = true, Scheduler.unstable_scheduleCallback(
      Scheduler.unstable_NormalPriority,
      replayUnblockedEvents
    )));
  }
  var lastScheduledReplayQueue = null;
  function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(
      Scheduler.unstable_NormalPriority,
      function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for (var i = 0; i < formReplayingQueue.length; i += 3) {
          var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
          if ("function" !== typeof submitterOrAction)
            if (null === findInstanceBlockingTarget(submitterOrAction || form))
              continue;
            else break;
          var formInst = getInstanceFromNode(form);
          null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, startHostTransition(
            formInst,
            {
              pending: true,
              data: formData,
              method: form.method,
              action: submitterOrAction
            },
            submitterOrAction,
            formData
          ));
        }
      }
    ));
  }
  function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
      return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for (var i = 0; i < queuedExplicitHydrationTargets.length; i++) {
      var queuedTarget = queuedExplicitHydrationTargets[i];
      queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for (; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn); )
      attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i)
      for (queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3) {
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction)
          formProps || scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
          var action = null;
          if (submitterOrAction && submitterOrAction.hasAttribute("formAction"))
            if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null)
              action = formProps.formAction;
            else {
              if (null !== findInstanceBlockingTarget(form)) continue;
            }
          else action = formProps.action;
          "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
          scheduleReplayQueueIfNeeded(i);
        }
      }
  }
  function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
  }
  ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root2 = this._internalRoot;
    if (null === root2) throw Error(formatProdErrorMessage(409));
    var current = root2.current, lane = requestUpdateLane();
    updateContainerImpl(current, lane, children, root2, null, null);
  };
  ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root2 = this._internalRoot;
    if (null !== root2) {
      this._internalRoot = null;
      var container = root2.containerInfo;
      updateContainerImpl(root2.current, 2, null, root2, null, null);
      flushSyncWork$1();
      container[internalContainerInstanceKey] = null;
    }
  };
  function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
  }
  ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
      var updatePriority = resolveUpdatePriority();
      target = { blockedOn: null, target, priority: updatePriority };
      for (var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++) ;
      queuedExplicitHydrationTargets.splice(i, 0, target);
      0 === i && attemptExplicitHydrationTarget(target);
    }
  };
  var isomorphicReactPackageVersion$jscomp$inline_1785 = React2.version;
  if ("19.1.0" !== isomorphicReactPackageVersion$jscomp$inline_1785)
    throw Error(
      formatProdErrorMessage(
        527,
        isomorphicReactPackageVersion$jscomp$inline_1785,
        "19.1.0"
      )
    );
  ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
      if ("function" === typeof componentOrElement.render)
        throw Error(formatProdErrorMessage(188));
      componentOrElement = Object.keys(componentOrElement).join(",");
      throw Error(formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
  };
  var internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.1.0"
  };
  if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2257.isDisabled && hook$jscomp$inline_2257.supportsFiber)
      try {
        rendererID = hook$jscomp$inline_2257.inject(
          internals$jscomp$inline_2256
        ), injectedHook = hook$jscomp$inline_2257;
      } catch (err) {
      }
  }
  reactDomClient_production.createRoot = function(container, options2) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null;
    null !== options2 && void 0 !== options2 && (true === options2.unstable_strictMode && (isStrictMode = true), void 0 !== options2.identifierPrefix && (identifierPrefix = options2.identifierPrefix), void 0 !== options2.onUncaughtError && (onUncaughtError = options2.onUncaughtError), void 0 !== options2.onCaughtError && (onCaughtError = options2.onCaughtError), void 0 !== options2.onRecoverableError && (onRecoverableError = options2.onRecoverableError), void 0 !== options2.unstable_transitionCallbacks && (transitionCallbacks = options2.unstable_transitionCallbacks));
    options2 = createFiberRoot(
      container,
      1,
      false,
      null,
      null,
      isStrictMode,
      identifierPrefix,
      onUncaughtError,
      onCaughtError,
      onRecoverableError,
      transitionCallbacks,
      null
    );
    container[internalContainerInstanceKey] = options2.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options2);
  };
  reactDomClient_production.hydrateRoot = function(container, initialChildren, options2) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options2 && void 0 !== options2 && (true === options2.unstable_strictMode && (isStrictMode = true), void 0 !== options2.identifierPrefix && (identifierPrefix = options2.identifierPrefix), void 0 !== options2.onUncaughtError && (onUncaughtError = options2.onUncaughtError), void 0 !== options2.onCaughtError && (onCaughtError = options2.onCaughtError), void 0 !== options2.onRecoverableError && (onRecoverableError = options2.onRecoverableError), void 0 !== options2.unstable_transitionCallbacks && (transitionCallbacks = options2.unstable_transitionCallbacks), void 0 !== options2.formState && (formState = options2.formState));
    initialChildren = createFiberRoot(
      container,
      1,
      true,
      initialChildren,
      null != options2 ? options2 : null,
      isStrictMode,
      identifierPrefix,
      onUncaughtError,
      onCaughtError,
      onRecoverableError,
      transitionCallbacks,
      formState
    );
    initialChildren.context = getContextForSubtree(null);
    options2 = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options2, identifierPrefix, isStrictMode);
    options2 = isStrictMode;
    initialChildren.current.lanes = options2;
    markRootUpdated$1(initialChildren, options2);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
  };
  reactDomClient_production.version = "19.1.0";
  return reactDomClient_production;
}
var hasRequiredClient;
function requireClient() {
  if (hasRequiredClient) return client.exports;
  hasRequiredClient = 1;
  function checkDCE() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
      return;
    }
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      console.error(err);
    }
  }
  {
    checkDCE();
    client.exports = requireReactDomClient_production();
  }
  return client.exports;
}
var clientExports = requireClient();
function useAttribution(map, attribution) {
  const attributionRef = reactExports.useRef(attribution);
  reactExports.useEffect(function updateAttribution() {
    if (attribution !== attributionRef.current && map.attributionControl != null) {
      if (attributionRef.current != null) {
        map.attributionControl.removeAttribution(attributionRef.current);
      }
      if (attribution != null) {
        map.attributionControl.addAttribution(attribution);
      }
    }
    attributionRef.current = attribution;
  }, [
    map,
    attribution
  ]);
}
requireReactDom();
const CONTEXT_VERSION = 1;
function createLeafletContext(map) {
  return Object.freeze({
    __version: CONTEXT_VERSION,
    map
  });
}
const LeafletContext = reactExports.createContext(null);
function useLeafletContext() {
  const context = reactExports.use(LeafletContext);
  if (context == null) {
    throw new Error("No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>");
  }
  return context;
}
function createLeafComponent(useElement) {
  function LeafComponent(props, forwardedRef) {
    const { instance } = useElement(props).current;
    reactExports.useImperativeHandle(forwardedRef, () => instance);
    return null;
  }
  return /* @__PURE__ */ reactExports.forwardRef(LeafComponent);
}
function createControlHook(useElement) {
  return function useLeafletControl(props) {
    const context = useLeafletContext();
    const elementRef = useElement(props, context);
    const { instance } = elementRef.current;
    const positionRef = reactExports.useRef(props.position);
    const { position } = props;
    reactExports.useEffect(function addControl() {
      instance.addTo(context.map);
      return function removeControl() {
        instance.remove();
      };
    }, [
      context.map,
      instance
    ]);
    reactExports.useEffect(function updateControl() {
      if (position != null && position !== positionRef.current) {
        instance.setPosition(position);
        positionRef.current = position;
      }
    }, [
      instance,
      position
    ]);
    return elementRef;
  };
}
function useEventHandlers(element, eventHandlers) {
  const eventHandlersRef = reactExports.useRef(void 0);
  reactExports.useEffect(function addEventHandlers() {
    if (eventHandlers != null) {
      element.instance.on(eventHandlers);
    }
    eventHandlersRef.current = eventHandlers;
    return function removeEventHandlers() {
      if (eventHandlersRef.current != null) {
        element.instance.off(eventHandlersRef.current);
      }
      eventHandlersRef.current = null;
    };
  }, [
    element,
    eventHandlers
  ]);
}
function withPane(props, context) {
  const pane = props.pane ?? context.pane;
  return pane ? {
    ...props,
    pane
  } : props;
}
var leafletSrc$1 = { exports: {} };
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
var leafletSrc = leafletSrc$1.exports;
var hasRequiredLeafletSrc;
function requireLeafletSrc() {
  if (hasRequiredLeafletSrc) return leafletSrc$1.exports;
  hasRequiredLeafletSrc = 1;
  (function(module, exports) {
    (function(global, factory) {
      factory(exports);
    })(leafletSrc, function(exports2) {
      var version = "1.9.4";
      function extend(dest) {
        var i, j, len, src;
        for (j = 1, len = arguments.length; j < len; j++) {
          src = arguments[j];
          for (i in src) {
            dest[i] = src[i];
          }
        }
        return dest;
      }
      var create$2 = Object.create || /* @__PURE__ */ function() {
        function F() {
        }
        return function(proto) {
          F.prototype = proto;
          return new F();
        };
      }();
      function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) {
          return fn.bind.apply(fn, slice.call(arguments, 1));
        }
        var args = slice.call(arguments, 2);
        return function() {
          return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
      }
      var lastId = 0;
      function stamp(obj) {
        if (!("_leaflet_id" in obj)) {
          obj["_leaflet_id"] = ++lastId;
        }
        return obj._leaflet_id;
      }
      function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
          lock = false;
          if (args) {
            wrapperFn.apply(context, args);
            args = false;
          }
        };
        wrapperFn = function() {
          if (lock) {
            args = arguments;
          } else {
            fn.apply(context, arguments);
            setTimeout(later, time);
            lock = true;
          }
        };
        return wrapperFn;
      }
      function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
      }
      function falseFn() {
        return false;
      }
      function formatNum(num, precision) {
        if (precision === false) {
          return num;
        }
        var pow = Math.pow(10, precision === void 0 ? 6 : precision);
        return Math.round(num * pow) / pow;
      }
      function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
      }
      function splitWords(str) {
        return trim(str).split(/\s+/);
      }
      function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) {
          obj.options = obj.options ? create$2(obj.options) : {};
        }
        for (var i in options) {
          obj.options[i] = options[i];
        }
        return obj.options;
      }
      function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for (var i in obj) {
          params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        }
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
      }
      var templateRe = /\{ *([\w_ -]+) *\}/g;
      function template(str, data) {
        return str.replace(templateRe, function(str2, key) {
          var value = data[key];
          if (value === void 0) {
            throw new Error("No value provided for variable " + str2);
          } else if (typeof value === "function") {
            value = value(data);
          }
          return value;
        });
      }
      var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
      };
      function indexOf(array, el) {
        for (var i = 0; i < array.length; i++) {
          if (array[i] === el) {
            return i;
          }
        }
        return -1;
      }
      var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
      function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
      }
      var lastTime = 0;
      function timeoutDefer(fn) {
        var time = +/* @__PURE__ */ new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
      }
      var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
      var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
      };
      function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) {
          fn.call(context);
        } else {
          return requestFn.call(window, bind(fn, context));
        }
      }
      function cancelAnimFrame(id) {
        if (id) {
          cancelFn.call(window, id);
        }
      }
      var Util = {
        __proto__: null,
        extend,
        create: create$2,
        bind,
        get lastId() {
          return lastId;
        },
        stamp,
        throttle,
        wrapNum,
        falseFn,
        formatNum,
        trim,
        splitWords,
        setOptions,
        getParamString,
        template,
        isArray,
        indexOf,
        emptyImageUrl,
        requestFn,
        cancelFn,
        requestAnimFrame,
        cancelAnimFrame
      };
      function Class() {
      }
      Class.extend = function(props) {
        var NewClass = function() {
          setOptions(this);
          if (this.initialize) {
            this.initialize.apply(this, arguments);
          }
          this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        for (var i in this) {
          if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") {
            NewClass[i] = this[i];
          }
        }
        if (props.statics) {
          extend(NewClass, props.statics);
        }
        if (props.includes) {
          checkDeprecatedMixinEvents(props.includes);
          extend.apply(null, [proto].concat(props.includes));
        }
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        if (proto.options) {
          proto.options = parentProto.options ? create$2(parentProto.options) : {};
          extend(proto.options, props.options);
        }
        proto._initHooks = [];
        proto.callInitHooks = function() {
          if (this._initHooksCalled) {
            return;
          }
          if (parentProto.callInitHooks) {
            parentProto.callInitHooks.call(this);
          }
          this._initHooksCalled = true;
          for (var i2 = 0, len = proto._initHooks.length; i2 < len; i2++) {
            proto._initHooks[i2].call(this);
          }
        };
        return NewClass;
      };
      Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
          this.prototype.options = parentOptions;
          this.mergeOptions(props.options);
        }
        return this;
      };
      Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
      };
      Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
          this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
      };
      function checkDeprecatedMixinEvents(includes) {
        if (typeof L === "undefined" || !L || !L.Mixin) {
          return;
        }
        includes = isArray(includes) ? includes : [includes];
        for (var i = 0; i < includes.length; i++) {
          if (includes[i] === L.Mixin.Events) {
            console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
          }
        }
      }
      var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
         * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
         *
         * @alternative
         * @method on(eventMap: Object): this
         * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
         */
        on: function(types, fn, context) {
          if (typeof types === "object") {
            for (var type in types) {
              this._on(type, types[type], fn);
            }
          } else {
            types = splitWords(types);
            for (var i = 0, len = types.length; i < len; i++) {
              this._on(types[i], fn, context);
            }
          }
          return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
         * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
         *
         * @alternative
         * @method off(eventMap: Object): this
         * Removes a set of type/listener pairs.
         *
         * @alternative
         * @method off: this
         * Removes all listeners to all events on the object. This includes implicitly attached events.
         */
        off: function(types, fn, context) {
          if (!arguments.length) {
            delete this._events;
          } else if (typeof types === "object") {
            for (var type in types) {
              this._off(type, types[type], fn);
            }
          } else {
            types = splitWords(types);
            var removeAll = arguments.length === 1;
            for (var i = 0, len = types.length; i < len; i++) {
              if (removeAll) {
                this._off(types[i]);
              } else {
                this._off(types[i], fn, context);
              }
            }
          }
          return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
          if (typeof fn !== "function") {
            console.warn("wrong listener type: " + typeof fn);
            return;
          }
          if (this._listens(type, fn, context) !== false) {
            return;
          }
          if (context === this) {
            context = void 0;
          }
          var newListener = { fn, ctx: context };
          if (_once) {
            newListener.once = true;
          }
          this._events = this._events || {};
          this._events[type] = this._events[type] || [];
          this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
          var listeners, i, len;
          if (!this._events) {
            return;
          }
          listeners = this._events[type];
          if (!listeners) {
            return;
          }
          if (arguments.length === 1) {
            if (this._firingCount) {
              for (i = 0, len = listeners.length; i < len; i++) {
                listeners[i].fn = falseFn;
              }
            }
            delete this._events[type];
            return;
          }
          if (typeof fn !== "function") {
            console.warn("wrong listener type: " + typeof fn);
            return;
          }
          var index2 = this._listens(type, fn, context);
          if (index2 !== false) {
            var listener = listeners[index2];
            if (this._firingCount) {
              listener.fn = falseFn;
              this._events[type] = listeners = listeners.slice();
            }
            listeners.splice(index2, 1);
          }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
          if (!this.listens(type, propagate)) {
            return this;
          }
          var event = extend({}, data, {
            type,
            target: this,
            sourceTarget: data && data.sourceTarget || this
          });
          if (this._events) {
            var listeners = this._events[type];
            if (listeners) {
              this._firingCount = this._firingCount + 1 || 1;
              for (var i = 0, len = listeners.length; i < len; i++) {
                var l = listeners[i];
                var fn = l.fn;
                if (l.once) {
                  this.off(type, fn, l.ctx);
                }
                fn.call(l.ctx || this, event);
              }
              this._firingCount--;
            }
          }
          if (propagate) {
            this._propagateEvent(event);
          }
          return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
          if (typeof type !== "string") {
            console.warn('"string" type argument expected');
          }
          var _fn = fn;
          if (typeof fn !== "function") {
            propagate = !!fn;
            _fn = void 0;
            context = void 0;
          }
          var listeners = this._events && this._events[type];
          if (listeners && listeners.length) {
            if (this._listens(type, _fn, context) !== false) {
              return true;
            }
          }
          if (propagate) {
            for (var id in this._eventParents) {
              if (this._eventParents[id].listens(type, fn, context, propagate)) {
                return true;
              }
            }
          }
          return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
          if (!this._events) {
            return false;
          }
          var listeners = this._events[type] || [];
          if (!fn) {
            return !!listeners.length;
          }
          if (context === this) {
            context = void 0;
          }
          for (var i = 0, len = listeners.length; i < len; i++) {
            if (listeners[i].fn === fn && listeners[i].ctx === context) {
              return i;
            }
          }
          return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
          if (typeof types === "object") {
            for (var type in types) {
              this._on(type, types[type], fn, true);
            }
          } else {
            types = splitWords(types);
            for (var i = 0, len = types.length; i < len; i++) {
              this._on(types[i], fn, context, true);
            }
          }
          return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
          this._eventParents = this._eventParents || {};
          this._eventParents[stamp(obj)] = obj;
          return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
          if (this._eventParents) {
            delete this._eventParents[stamp(obj)];
          }
          return this;
        },
        _propagateEvent: function(e) {
          for (var id in this._eventParents) {
            this._eventParents[id].fire(e.type, extend({
              layer: e.target,
              propagatedFrom: e.target
            }, e), true);
          }
        }
      };
      Events.addEventListener = Events.on;
      Events.removeEventListener = Events.clearAllEventListeners = Events.off;
      Events.addOneTimeEventListener = Events.once;
      Events.fireEvent = Events.fire;
      Events.hasEventListeners = Events.listens;
      var Evented = Class.extend(Events);
      function Point(x, y, round) {
        this.x = round ? Math.round(x) : x;
        this.y = round ? Math.round(y) : y;
      }
      var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
      };
      Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
          return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
          return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
          this.x += point.x;
          this.y += point.y;
          return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
          return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
          this.x -= point.x;
          this.y -= point.y;
          return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
          return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
          this.x /= num;
          this.y /= num;
          return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
          return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
          this.x *= num;
          this.y *= num;
          return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
          return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
          return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
          return this.clone()._round();
        },
        _round: function() {
          this.x = Math.round(this.x);
          this.y = Math.round(this.y);
          return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
          return this.clone()._floor();
        },
        _floor: function() {
          this.x = Math.floor(this.x);
          this.y = Math.floor(this.y);
          return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
          return this.clone()._ceil();
        },
        _ceil: function() {
          this.x = Math.ceil(this.x);
          this.y = Math.ceil(this.y);
          return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
          return this.clone()._trunc();
        },
        _trunc: function() {
          this.x = trunc(this.x);
          this.y = trunc(this.y);
          return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
          point = toPoint(point);
          var x = point.x - this.x, y = point.y - this.y;
          return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
          point = toPoint(point);
          return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
          point = toPoint(point);
          return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
          return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
      };
      function toPoint(x, y, round) {
        if (x instanceof Point) {
          return x;
        }
        if (isArray(x)) {
          return new Point(x[0], x[1]);
        }
        if (x === void 0 || x === null) {
          return x;
        }
        if (typeof x === "object" && "x" in x && "y" in x) {
          return new Point(x.x, x.y);
        }
        return new Point(x, y, round);
      }
      function Bounds(a, b) {
        if (!a) {
          return;
        }
        var points = b ? [a, b] : a;
        for (var i = 0, len = points.length; i < len; i++) {
          this.extend(points[i]);
        }
      }
      Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
          var min2, max2;
          if (!obj) {
            return this;
          }
          if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) {
            min2 = max2 = toPoint(obj);
          } else {
            obj = toBounds(obj);
            min2 = obj.min;
            max2 = obj.max;
            if (!min2 || !max2) {
              return this;
            }
          }
          if (!this.min && !this.max) {
            this.min = min2.clone();
            this.max = max2.clone();
          } else {
            this.min.x = Math.min(min2.x, this.min.x);
            this.max.x = Math.max(max2.x, this.max.x);
            this.min.y = Math.min(min2.y, this.min.y);
            this.max.y = Math.max(max2.y, this.max.y);
          }
          return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
          return toPoint(
            (this.min.x + this.max.x) / 2,
            (this.min.y + this.max.y) / 2,
            round
          );
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
          return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
          return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
          return this.min;
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
          return this.max;
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
          return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
          var min, max;
          if (typeof obj[0] === "number" || obj instanceof Point) {
            obj = toPoint(obj);
          } else {
            obj = toBounds(obj);
          }
          if (obj instanceof Bounds) {
            min = obj.min;
            max = obj.max;
          } else {
            min = max = obj;
          }
          return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
          bounds = toBounds(bounds);
          var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
          return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
          bounds = toBounds(bounds);
          var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
          return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
          return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
          var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
          return toBounds(
            toPoint(min.x - heightBuffer, min.y - widthBuffer),
            toPoint(max.x + heightBuffer, max.y + widthBuffer)
          );
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
          if (!bounds) {
            return false;
          }
          bounds = toBounds(bounds);
          return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
      };
      function toBounds(a, b) {
        if (!a || a instanceof Bounds) {
          return a;
        }
        return new Bounds(a, b);
      }
      function LatLngBounds(corner1, corner2) {
        if (!corner1) {
          return;
        }
        var latlngs = corner2 ? [corner1, corner2] : corner1;
        for (var i = 0, len = latlngs.length; i < len; i++) {
          this.extend(latlngs[i]);
        }
      }
      LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
          var sw = this._southWest, ne = this._northEast, sw2, ne2;
          if (obj instanceof LatLng) {
            sw2 = obj;
            ne2 = obj;
          } else if (obj instanceof LatLngBounds) {
            sw2 = obj._southWest;
            ne2 = obj._northEast;
            if (!sw2 || !ne2) {
              return this;
            }
          } else {
            return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
          }
          if (!sw && !ne) {
            this._southWest = new LatLng(sw2.lat, sw2.lng);
            this._northEast = new LatLng(ne2.lat, ne2.lng);
          } else {
            sw.lat = Math.min(sw2.lat, sw.lat);
            sw.lng = Math.min(sw2.lng, sw.lng);
            ne.lat = Math.max(ne2.lat, ne.lat);
            ne.lng = Math.max(ne2.lng, ne.lng);
          }
          return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
          var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
          return new LatLngBounds(
            new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
            new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer)
          );
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
          return new LatLng(
            (this._southWest.lat + this._northEast.lat) / 2,
            (this._southWest.lng + this._northEast.lng) / 2
          );
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
          return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
          return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
          return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
          return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
          return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
          return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
          return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
          return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
          if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) {
            obj = toLatLng(obj);
          } else {
            obj = toLatLngBounds(obj);
          }
          var sw = this._southWest, ne = this._northEast, sw2, ne2;
          if (obj instanceof LatLngBounds) {
            sw2 = obj.getSouthWest();
            ne2 = obj.getNorthEast();
          } else {
            sw2 = ne2 = obj;
          }
          return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
          bounds = toLatLngBounds(bounds);
          var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
          return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
          bounds = toLatLngBounds(bounds);
          var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
          return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
          return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
          if (!bounds) {
            return false;
          }
          bounds = toLatLngBounds(bounds);
          return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
          return !!(this._southWest && this._northEast);
        }
      };
      function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) {
          return a;
        }
        return new LatLngBounds(a, b);
      }
      function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) {
          throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        }
        this.lat = +lat;
        this.lng = +lng;
        if (alt !== void 0) {
          this.alt = +alt;
        }
      }
      LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
          if (!obj) {
            return false;
          }
          obj = toLatLng(obj);
          var margin = Math.max(
            Math.abs(this.lat - obj.lat),
            Math.abs(this.lng - obj.lng)
          );
          return margin <= (maxMargin === void 0 ? 1e-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
          return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
          return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
          return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
          var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
          return toLatLngBounds(
            [this.lat - latAccuracy, this.lng - lngAccuracy],
            [this.lat + latAccuracy, this.lng + lngAccuracy]
          );
        },
        clone: function() {
          return new LatLng(this.lat, this.lng, this.alt);
        }
      };
      function toLatLng(a, b, c) {
        if (a instanceof LatLng) {
          return a;
        }
        if (isArray(a) && typeof a[0] !== "object") {
          if (a.length === 3) {
            return new LatLng(a[0], a[1], a[2]);
          }
          if (a.length === 2) {
            return new LatLng(a[0], a[1]);
          }
          return null;
        }
        if (a === void 0 || a === null) {
          return a;
        }
        if (typeof a === "object" && "lat" in a) {
          return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        }
        if (b === void 0) {
          return null;
        }
        return new LatLng(a, b, c);
      }
      var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom2) {
          var projectedPoint = this.projection.project(latlng), scale2 = this.scale(zoom2);
          return this.transformation._transform(projectedPoint, scale2);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom2) {
          var scale2 = this.scale(zoom2), untransformedPoint = this.transformation.untransform(point, scale2);
          return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
          return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
          return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom2) {
          return 256 * Math.pow(2, zoom2);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale2) {
          return Math.log(scale2 / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom2) {
          if (this.infinite) {
            return null;
          }
          var b = this.projection.bounds, s = this.scale(zoom2), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
          return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
          var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
          return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
          var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
          if (latShift === 0 && lngShift === 0) {
            return bounds;
          }
          var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
          return new LatLngBounds(newSw, newNe);
        }
      };
      var Earth = extend({}, CRS, {
        wrapLng: [-180, 180],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371e3,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
          var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          return this.R * c;
        }
      });
      var earthRadius = 6378137;
      var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
          var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
          return new Point(
            this.R * latlng.lng * d,
            this.R * Math.log((1 + sin) / (1 - sin)) / 2
          );
        },
        unproject: function(point) {
          var d = 180 / Math.PI;
          return new LatLng(
            (2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d,
            point.x * d / this.R
          );
        },
        bounds: function() {
          var d = earthRadius * Math.PI;
          return new Bounds([-d, -d], [d, d]);
        }()
      };
      function Transformation(a, b, c, d) {
        if (isArray(a)) {
          this._a = a[0];
          this._b = a[1];
          this._c = a[2];
          this._d = a[3];
          return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
      }
      Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale2) {
          return this._transform(point.clone(), scale2);
        },
        // destructive transform (faster)
        _transform: function(point, scale2) {
          scale2 = scale2 || 1;
          point.x = scale2 * (this._a * point.x + this._b);
          point.y = scale2 * (this._c * point.y + this._d);
          return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale2) {
          scale2 = scale2 || 1;
          return new Point(
            (point.x / scale2 - this._b) / this._a,
            (point.y / scale2 - this._d) / this._c
          );
        }
      };
      function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
      }
      var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
          var scale2 = 0.5 / (Math.PI * SphericalMercator.R);
          return toTransformation(scale2, 0.5, -scale2, 0.5);
        }()
      });
      var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
      });
      function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
      }
      function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for (i = 0, len = rings.length; i < len; i++) {
          points = rings[i];
          for (j = 0, len2 = points.length; j < len2; j++) {
            p = points[j];
            str += (j ? "L" : "M") + p.x + " " + p.y;
          }
          str += closed ? Browser.svg ? "z" : "x" : "";
        }
        return str || "M0 0";
      }
      var style = document.documentElement.style;
      var ie = "ActiveXObject" in window;
      var ielt9 = ie && !document.addEventListener;
      var edge = "msLaunchUri" in navigator && !("documentMode" in document);
      var webkit = userAgentContains("webkit");
      var android = userAgentContains("android");
      var android23 = userAgentContains("android 2") || userAgentContains("android 3");
      var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10);
      var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
      var opera = !!window.opera;
      var chrome = !edge && userAgentContains("chrome");
      var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
      var safari = !chrome && userAgentContains("safari");
      var phantom = userAgentContains("phantom");
      var opera12 = "OTransition" in style;
      var win = navigator.platform.indexOf("Win") === 0;
      var ie3d = ie && "transition" in style;
      var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
      var gecko3d = "MozPerspective" in style;
      var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
      var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
      var mobileWebkit = mobile && webkit;
      var mobileWebkit3d = mobile && webkit3d;
      var msPointer = !window.PointerEvent && window.MSPointerEvent;
      var pointer = !!(window.PointerEvent || msPointer);
      var touchNative = "ontouchstart" in window || !!window.TouchEvent;
      var touch = !window.L_NO_TOUCH && (touchNative || pointer);
      var mobileOpera = mobile && opera;
      var mobileGecko = mobile && gecko;
      var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
      var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
          var opts = Object.defineProperty({}, "passive", {
            get: function() {
              supportsPassiveOption = true;
            }
          });
          window.addEventListener("testPassiveEventSupport", falseFn, opts);
          window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        }
        return supportsPassiveOption;
      }();
      var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
      }();
      var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
      var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
      }();
      var vml = !svg$1 && function() {
        try {
          var div = document.createElement("div");
          div.innerHTML = '<v:shape adj="1"/>';
          var shape = div.firstChild;
          shape.style.behavior = "url(#default#VML)";
          return shape && typeof shape.adj === "object";
        } catch (e) {
          return false;
        }
      }();
      var mac = navigator.platform.indexOf("Mac") === 0;
      var linux = navigator.platform.indexOf("Linux") === 0;
      function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
      }
      var Browser = {
        ie,
        ielt9,
        edge,
        webkit,
        android,
        android23,
        androidStock,
        opera,
        chrome,
        gecko,
        safari,
        phantom,
        opera12,
        win,
        ie3d,
        webkit3d,
        gecko3d,
        any3d,
        mobile,
        mobileWebkit,
        mobileWebkit3d,
        msPointer,
        pointer,
        touch,
        touchNative,
        mobileOpera,
        mobileGecko,
        retina,
        passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml,
        inlineSvg,
        mac,
        linux
      };
      var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
      var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
      var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
      var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
      var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
      };
      var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
      };
      var _pointers = {};
      var _pointerDocListener = false;
      function addPointerListener(obj, type, handler) {
        if (type === "touchstart") {
          _addPointerDocListener();
        }
        if (!handle[type]) {
          console.warn("wrong event specified:", type);
          return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
      }
      function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
          console.warn("wrong event specified:", type);
          return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
      }
      function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
      }
      function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) {
          _pointers[e.pointerId] = e;
        }
      }
      function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
      }
      function _addPointerDocListener() {
        if (!_pointerDocListener) {
          document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
          document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
          document.addEventListener(POINTER_UP, _globalPointerUp, true);
          document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
          _pointerDocListener = true;
        }
      }
      function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) {
          return;
        }
        e.touches = [];
        for (var i in _pointers) {
          e.touches.push(_pointers[i]);
        }
        e.changedTouches = [e];
        handler(e);
      }
      function _onPointerStart(handler, e) {
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) {
          preventDefault(e);
        }
        _handlePointer(handler, e);
      }
      function makeDblclick(event) {
        var newEvent = {}, prop, i;
        for (i in event) {
          prop = event[i];
          newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true;
        return newEvent;
      }
      var delay = 200;
      function addDoubleTapListener(obj, handler) {
        obj.addEventListener("dblclick", handler);
        var last = 0, detail;
        function simDblclick(e) {
          if (e.detail !== 1) {
            detail = e.detail;
            return;
          }
          if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) {
            return;
          }
          var path = getPropagationPath(e);
          if (path.some(function(el) {
            return el instanceof HTMLLabelElement && el.attributes.for;
          }) && !path.some(function(el) {
            return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
          })) {
            return;
          }
          var now = Date.now();
          if (now - last <= delay) {
            detail++;
            if (detail === 2) {
              handler(makeDblclick(e));
            }
          } else {
            detail = 1;
          }
          last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
          dblclick: handler,
          simDblclick
        };
      }
      function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
      }
      var TRANSFORM = testProp(
        ["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]
      );
      var TRANSITION = testProp(
        ["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]
      );
      var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
      function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
      }
      function getStyle(el, style2) {
        var value = el.style[style2] || el.currentStyle && el.currentStyle[style2];
        if ((!value || value === "auto") && document.defaultView) {
          var css = document.defaultView.getComputedStyle(el, null);
          value = css ? css[style2] : null;
        }
        return value === "auto" ? null : value;
      }
      function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) {
          container.appendChild(el);
        }
        return el;
      }
      function remove(el) {
        var parent = el.parentNode;
        if (parent) {
          parent.removeChild(el);
        }
      }
      function empty(el) {
        while (el.firstChild) {
          el.removeChild(el.firstChild);
        }
      }
      function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) {
          parent.appendChild(el);
        }
      }
      function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) {
          parent.insertBefore(el, parent.firstChild);
        }
      }
      function hasClass(el, name) {
        if (el.classList !== void 0) {
          return el.classList.contains(name);
        }
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
      }
      function addClass(el, name) {
        if (el.classList !== void 0) {
          var classes = splitWords(name);
          for (var i = 0, len = classes.length; i < len; i++) {
            el.classList.add(classes[i]);
          }
        } else if (!hasClass(el, name)) {
          var className = getClass(el);
          setClass(el, (className ? className + " " : "") + name);
        }
      }
      function removeClass(el, name) {
        if (el.classList !== void 0) {
          el.classList.remove(name);
        } else {
          setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
        }
      }
      function setClass(el, name) {
        if (el.className.baseVal === void 0) {
          el.className = name;
        } else {
          el.className.baseVal = name;
        }
      }
      function getClass(el) {
        if (el.correspondingElement) {
          el = el.correspondingElement;
        }
        return el.className.baseVal === void 0 ? el.className : el.className.baseVal;
      }
      function setOpacity(el, value) {
        if ("opacity" in el.style) {
          el.style.opacity = value;
        } else if ("filter" in el.style) {
          _setOpacityIE(el, value);
        }
      }
      function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        try {
          filter = el.filters.item(filterName);
        } catch (e) {
          if (value === 1) {
            return;
          }
        }
        value = Math.round(value * 100);
        if (filter) {
          filter.Enabled = value !== 100;
          filter.Opacity = value;
        } else {
          el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
        }
      }
      function testProp(props) {
        var style2 = document.documentElement.style;
        for (var i = 0; i < props.length; i++) {
          if (props[i] in style2) {
            return props[i];
          }
        }
        return false;
      }
      function setTransform(el, offset, scale2) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale2 ? " scale(" + scale2 + ")" : "");
      }
      function setPosition(el, point) {
        el._leaflet_pos = point;
        if (Browser.any3d) {
          setTransform(el, point);
        } else {
          el.style.left = point.x + "px";
          el.style.top = point.y + "px";
        }
      }
      function getPosition(el) {
        return el._leaflet_pos || new Point(0, 0);
      }
      var disableTextSelection;
      var enableTextSelection;
      var _userSelect;
      if ("onselectstart" in document) {
        disableTextSelection = function() {
          on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
          off(window, "selectstart", preventDefault);
        };
      } else {
        var userSelectProperty = testProp(
          ["userSelect", "WebkitUserSelect", "OUserSelect", "MozUserSelect", "msUserSelect"]
        );
        disableTextSelection = function() {
          if (userSelectProperty) {
            var style2 = document.documentElement.style;
            _userSelect = style2[userSelectProperty];
            style2[userSelectProperty] = "none";
          }
        };
        enableTextSelection = function() {
          if (userSelectProperty) {
            document.documentElement.style[userSelectProperty] = _userSelect;
            _userSelect = void 0;
          }
        };
      }
      function disableImageDrag() {
        on(window, "dragstart", preventDefault);
      }
      function enableImageDrag() {
        off(window, "dragstart", preventDefault);
      }
      var _outlineElement, _outlineStyle;
      function preventOutline(element) {
        while (element.tabIndex === -1) {
          element = element.parentNode;
        }
        if (!element.style) {
          return;
        }
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
      }
      function restoreOutline() {
        if (!_outlineElement) {
          return;
        }
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = void 0;
        _outlineStyle = void 0;
        off(window, "keydown", restoreOutline);
      }
      function getSizedParentNode(element) {
        do {
          element = element.parentNode;
        } while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
      }
      function getScale(element) {
        var rect = element.getBoundingClientRect();
        return {
          x: rect.width / element.offsetWidth || 1,
          y: rect.height / element.offsetHeight || 1,
          boundingClientRect: rect
        };
      }
      var DomUtil = {
        __proto__: null,
        TRANSFORM,
        TRANSITION,
        TRANSITION_END,
        get,
        getStyle,
        create: create$1,
        remove,
        empty,
        toFront,
        toBack,
        hasClass,
        addClass,
        removeClass,
        setClass,
        getClass,
        setOpacity,
        testProp,
        setTransform,
        setPosition,
        getPosition,
        get disableTextSelection() {
          return disableTextSelection;
        },
        get enableTextSelection() {
          return enableTextSelection;
        },
        disableImageDrag,
        enableImageDrag,
        preventOutline,
        restoreOutline,
        getSizedParentNode,
        getScale
      };
      function on(obj, types, fn, context) {
        if (types && typeof types === "object") {
          for (var type in types) {
            addOne(obj, type, types[type], fn);
          }
        } else {
          types = splitWords(types);
          for (var i = 0, len = types.length; i < len; i++) {
            addOne(obj, types[i], fn, context);
          }
        }
        return this;
      }
      var eventsKey = "_leaflet_events";
      function off(obj, types, fn, context) {
        if (arguments.length === 1) {
          batchRemove(obj);
          delete obj[eventsKey];
        } else if (types && typeof types === "object") {
          for (var type in types) {
            removeOne(obj, type, types[type], fn);
          }
        } else {
          types = splitWords(types);
          if (arguments.length === 2) {
            batchRemove(obj, function(type2) {
              return indexOf(types, type2) !== -1;
            });
          } else {
            for (var i = 0, len = types.length; i < len; i++) {
              removeOne(obj, types[i], fn, context);
            }
          }
        }
        return this;
      }
      function batchRemove(obj, filterFn) {
        for (var id in obj[eventsKey]) {
          var type = id.split(/\d/)[0];
          if (!filterFn || filterFn(type)) {
            removeOne(obj, type, null, null, id);
          }
        }
      }
      var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
      };
      function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) {
          return this;
        }
        var handler = function(e) {
          return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) {
          handler = addPointerListener(obj, type, handler);
        } else if (Browser.touch && type === "dblclick") {
          handler = addDoubleTapListener(obj, handler);
        } else if ("addEventListener" in obj) {
          if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") {
            obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? { passive: false } : false);
          } else if (type === "mouseenter" || type === "mouseleave") {
            handler = function(e) {
              e = e || window.event;
              if (isExternalTarget(obj, e)) {
                originalHandler(e);
              }
            };
            obj.addEventListener(mouseSubst[type], handler, false);
          } else {
            obj.addEventListener(type, originalHandler, false);
          }
        } else {
          obj.attachEvent("on" + type, handler);
        }
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
      }
      function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) {
          return this;
        }
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) {
          removePointerListener(obj, type, handler);
        } else if (Browser.touch && type === "dblclick") {
          removeDoubleTapListener(obj, handler);
        } else if ("removeEventListener" in obj) {
          obj.removeEventListener(mouseSubst[type] || type, handler, false);
        } else {
          obj.detachEvent("on" + type, handler);
        }
        obj[eventsKey][id] = null;
      }
      function stopPropagation(e) {
        if (e.stopPropagation) {
          e.stopPropagation();
        } else if (e.originalEvent) {
          e.originalEvent._stopped = true;
        } else {
          e.cancelBubble = true;
        }
        return this;
      }
      function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
      }
      function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
      }
      function preventDefault(e) {
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }
        return this;
      }
      function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
      }
      function getPropagationPath(ev) {
        if (ev.composedPath) {
          return ev.composedPath();
        }
        var path = [];
        var el = ev.target;
        while (el) {
          path.push(el);
          el = el.parentNode;
        }
        return path;
      }
      function getMousePosition(e, container) {
        if (!container) {
          return new Point(e.clientX, e.clientY);
        }
        var scale2 = getScale(container), offset = scale2.boundingClientRect;
        return new Point(
          // offset.left/top values are in page scale (like clientX/Y),
          // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
          (e.clientX - offset.left) / scale2.x - container.clientLeft,
          (e.clientY - offset.top) / scale2.y - container.clientTop
        );
      }
      var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
      function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : (
          // Don't trust window-geometry-based delta
          e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : (
            // Pixels
            e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : (
              // Lines
              e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : (
                // Pages
                e.deltaX || e.deltaZ ? 0 : (
                  // Skip horizontal/depth wheel events
                  e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : (
                    // Legacy IE pixels
                    e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : (
                      // Legacy Moz lines
                      e.detail ? e.detail / -32765 * 60 : (
                        // Legacy Moz pages
                        0
                      )
                    )
                  )
                )
              )
            )
          )
        );
      }
      function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) {
          return true;
        }
        try {
          while (related && related !== el) {
            related = related.parentNode;
          }
        } catch (err) {
          return false;
        }
        return related !== el;
      }
      var DomEvent = {
        __proto__: null,
        on,
        off,
        stopPropagation,
        disableScrollPropagation,
        disableClickPropagation,
        preventDefault,
        stop,
        getPropagationPath,
        getMousePosition,
        getWheelDelta,
        isExternalTarget,
        addListener: on,
        removeListener: off
      };
      var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
          this.stop();
          this._el = el;
          this._inProgress = true;
          this._duration = duration || 0.25;
          this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
          this._startPos = getPosition(el);
          this._offset = newPos.subtract(this._startPos);
          this._startTime = +/* @__PURE__ */ new Date();
          this.fire("start");
          this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
          if (!this._inProgress) {
            return;
          }
          this._step(true);
          this._complete();
        },
        _animate: function() {
          this._animId = requestAnimFrame(this._animate, this);
          this._step();
        },
        _step: function(round) {
          var elapsed = +/* @__PURE__ */ new Date() - this._startTime, duration = this._duration * 1e3;
          if (elapsed < duration) {
            this._runFrame(this._easeOut(elapsed / duration), round);
          } else {
            this._runFrame(1);
            this._complete();
          }
        },
        _runFrame: function(progress, round) {
          var pos = this._startPos.add(this._offset.multiplyBy(progress));
          if (round) {
            pos._round();
          }
          setPosition(this._el, pos);
          this.fire("step");
        },
        _complete: function() {
          cancelAnimFrame(this._animId);
          this._inProgress = false;
          this.fire("end");
        },
        _easeOut: function(t) {
          return 1 - Math.pow(1 - t, this._easeOutPower);
        }
      });
      var Map2 = Evented.extend({
        options: {
          // @section Map State Options
          // @option crs: CRS = L.CRS.EPSG3857
          // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
          // sure what it means.
          crs: EPSG3857,
          // @option center: LatLng = undefined
          // Initial geographic center of the map
          center: void 0,
          // @option zoom: Number = undefined
          // Initial map zoom level
          zoom: void 0,
          // @option minZoom: Number = *
          // Minimum zoom level of the map.
          // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
          // the lowest of their `minZoom` options will be used instead.
          minZoom: void 0,
          // @option maxZoom: Number = *
          // Maximum zoom level of the map.
          // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
          // the highest of their `maxZoom` options will be used instead.
          maxZoom: void 0,
          // @option layers: Layer[] = []
          // Array of layers that will be added to the map initially
          layers: [],
          // @option maxBounds: LatLngBounds = null
          // When this option is set, the map restricts the view to the given
          // geographical bounds, bouncing the user back if the user tries to pan
          // outside the view. To set the restriction dynamically, use
          // [`setMaxBounds`](#map-setmaxbounds) method.
          maxBounds: void 0,
          // @option renderer: Renderer = *
          // The default method for drawing vector layers on the map. `L.SVG`
          // or `L.Canvas` by default depending on browser support.
          renderer: void 0,
          // @section Animation Options
          // @option zoomAnimation: Boolean = true
          // Whether the map zoom animation is enabled. By default it's enabled
          // in all browsers that support CSS3 Transitions except Android.
          zoomAnimation: true,
          // @option zoomAnimationThreshold: Number = 4
          // Won't animate zoom if the zoom difference exceeds this value.
          zoomAnimationThreshold: 4,
          // @option fadeAnimation: Boolean = true
          // Whether the tile fade animation is enabled. By default it's enabled
          // in all browsers that support CSS3 Transitions except Android.
          fadeAnimation: true,
          // @option markerZoomAnimation: Boolean = true
          // Whether markers animate their zoom with the zoom animation, if disabled
          // they will disappear for the length of the animation. By default it's
          // enabled in all browsers that support CSS3 Transitions except Android.
          markerZoomAnimation: true,
          // @option transform3DLimit: Number = 2^23
          // Defines the maximum size of a CSS translation transform. The default
          // value should not be changed unless a web browser positions layers in
          // the wrong place after doing a large `panBy`.
          transform3DLimit: 8388608,
          // Precision limit of a 32-bit float
          // @section Interaction Options
          // @option zoomSnap: Number = 1
          // Forces the map's zoom level to always be a multiple of this, particularly
          // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
          // By default, the zoom level snaps to the nearest integer; lower values
          // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
          // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
          zoomSnap: 1,
          // @option zoomDelta: Number = 1
          // Controls how much the map's zoom level will change after a
          // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
          // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
          // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
          zoomDelta: 1,
          // @option trackResize: Boolean = true
          // Whether the map automatically handles browser window resize to update itself.
          trackResize: true
        },
        initialize: function(id, options) {
          options = setOptions(this, options);
          this._handlers = [];
          this._layers = {};
          this._zoomBoundLayers = {};
          this._sizeChanged = true;
          this._initContainer(id);
          this._initLayout();
          this._onResize = bind(this._onResize, this);
          this._initEvents();
          if (options.maxBounds) {
            this.setMaxBounds(options.maxBounds);
          }
          if (options.zoom !== void 0) {
            this._zoom = this._limitZoom(options.zoom);
          }
          if (options.center && options.zoom !== void 0) {
            this.setView(toLatLng(options.center), options.zoom, { reset: true });
          }
          this.callInitHooks();
          this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
          if (this._zoomAnimated) {
            this._createAnimProxy();
            on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
          }
          this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom2, options) {
          zoom2 = zoom2 === void 0 ? this._zoom : this._limitZoom(zoom2);
          center = this._limitCenter(toLatLng(center), zoom2, this.options.maxBounds);
          options = options || {};
          this._stop();
          if (this._loaded && !options.reset && options !== true) {
            if (options.animate !== void 0) {
              options.zoom = extend({ animate: options.animate }, options.zoom);
              options.pan = extend({ animate: options.animate, duration: options.duration }, options.pan);
            }
            var moved = this._zoom !== zoom2 ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom2, options.zoom) : this._tryAnimatedPan(center, options.pan);
            if (moved) {
              clearTimeout(this._sizeTimer);
              return this;
            }
          }
          this._resetView(center, zoom2, options.pan && options.pan.noMoveStart);
          return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom2, options) {
          if (!this._loaded) {
            this._zoom = zoom2;
            return this;
          }
          return this.setView(this.getCenter(), zoom2, { zoom: options });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
          delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
          return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
          delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
          return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom2, options) {
          var scale2 = this.getZoomScale(zoom2), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale2), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
          return this.setView(newCenter, zoom2, { zoom: options });
        },
        _getBoundsCenterZoom: function(bounds, options) {
          options = options || {};
          bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
          var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]), zoom2 = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
          zoom2 = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom2) : zoom2;
          if (zoom2 === Infinity) {
            return {
              center: bounds.getCenter(),
              zoom: zoom2
            };
          }
          var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom2), nePoint = this.project(bounds.getNorthEast(), zoom2), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom2);
          return {
            center,
            zoom: zoom2
          };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
          bounds = toLatLngBounds(bounds);
          if (!bounds.isValid()) {
            throw new Error("Bounds are not valid.");
          }
          var target = this._getBoundsCenterZoom(bounds, options);
          return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
          return this.fitBounds([[-90, -180], [90, 180]], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
          return this.setView(center, this._zoom, { pan: options });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
          offset = toPoint(offset).round();
          options = options || {};
          if (!offset.x && !offset.y) {
            return this.fire("moveend");
          }
          if (options.animate !== true && !this.getSize().contains(offset)) {
            this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
            return this;
          }
          if (!this._panAnim) {
            this._panAnim = new PosAnimation();
            this._panAnim.on({
              "step": this._onPanTransitionStep,
              "end": this._onPanTransitionEnd
            }, this);
          }
          if (!options.noMoveStart) {
            this.fire("movestart");
          }
          if (options.animate !== false) {
            addClass(this._mapPane, "leaflet-pan-anim");
            var newPos = this._getMapPanePos().subtract(offset).round();
            this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
          } else {
            this._rawPanBy(offset);
            this.fire("move").fire("moveend");
          }
          return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
          options = options || {};
          if (options.animate === false || !Browser.any3d) {
            return this.setView(targetCenter, targetZoom, options);
          }
          this._stop();
          var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
          targetCenter = toLatLng(targetCenter);
          targetZoom = targetZoom === void 0 ? startZoom : targetZoom;
          var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
          function r(i) {
            var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
            var log = sq < 1e-9 ? -18 : Math.log(sq);
            return log;
          }
          function sinh(n) {
            return (Math.exp(n) - Math.exp(-n)) / 2;
          }
          function cosh(n) {
            return (Math.exp(n) + Math.exp(-n)) / 2;
          }
          function tanh(n) {
            return sinh(n) / cosh(n);
          }
          var r0 = r(0);
          function w(s) {
            return w0 * (cosh(r0) / cosh(r0 + rho * s));
          }
          function u(s) {
            return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
          }
          function easeOut(t) {
            return 1 - Math.pow(1 - t, 1.5);
          }
          var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1e3 * options.duration : 1e3 * S * 0.8;
          function frame() {
            var t = (Date.now() - start) / duration, s = easeOut(t) * S;
            if (t <= 1) {
              this._flyToFrame = requestAnimFrame(frame, this);
              this._move(
                this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
                this.getScaleZoom(w0 / w(s), startZoom),
                { flyTo: true }
              );
            } else {
              this._move(targetCenter, targetZoom)._moveEnd(true);
            }
          }
          this._moveStart(true, options.noMoveStart);
          frame.call(this);
          return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
          var target = this._getBoundsCenterZoom(bounds, options);
          return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
          bounds = toLatLngBounds(bounds);
          if (this.listens("moveend", this._panInsideMaxBounds)) {
            this.off("moveend", this._panInsideMaxBounds);
          }
          if (!bounds.isValid()) {
            this.options.maxBounds = null;
            return this;
          }
          this.options.maxBounds = bounds;
          if (this._loaded) {
            this._panInsideMaxBounds();
          }
          return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom2) {
          var oldZoom = this.options.minZoom;
          this.options.minZoom = zoom2;
          if (this._loaded && oldZoom !== zoom2) {
            this.fire("zoomlevelschange");
            if (this.getZoom() < this.options.minZoom) {
              return this.setZoom(zoom2);
            }
          }
          return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom2) {
          var oldZoom = this.options.maxZoom;
          this.options.maxZoom = zoom2;
          if (this._loaded && oldZoom !== zoom2) {
            this.fire("zoomlevelschange");
            if (this.getZoom() > this.options.maxZoom) {
              return this.setZoom(zoom2);
            }
          }
          return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
          this._enforcingBounds = true;
          var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
          if (!center.equals(newCenter)) {
            this.panTo(newCenter, options);
          }
          this._enforcingBounds = false;
          return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
          options = options || {};
          var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([pixelBounds.min.add(paddingTL), pixelBounds.max.subtract(paddingBR)]), paddedSize = paddedBounds.getSize();
          if (!paddedBounds.contains(pixelPoint)) {
            this._enforcingBounds = true;
            var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
            var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
            pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
            pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
            this.panTo(this.unproject(pixelCenter), options);
            this._enforcingBounds = false;
          }
          return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
          if (!this._loaded) {
            return this;
          }
          options = extend({
            animate: false,
            pan: true
          }, options === true ? { animate: true } : options);
          var oldSize = this.getSize();
          this._sizeChanged = true;
          this._lastCenter = null;
          var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
          if (!offset.x && !offset.y) {
            return this;
          }
          if (options.animate && options.pan) {
            this.panBy(offset);
          } else {
            if (options.pan) {
              this._rawPanBy(offset);
            }
            this.fire("move");
            if (options.debounceMoveend) {
              clearTimeout(this._sizeTimer);
              this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
            } else {
              this.fire("moveend");
            }
          }
          return this.fire("resize", {
            oldSize,
            newSize
          });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
          this.setZoom(this._limitZoom(this._zoom));
          if (!this.options.zoomSnap) {
            this.fire("viewreset");
          }
          return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
          options = this._locateOptions = extend({
            timeout: 1e4,
            watch: false
            // setView: false
            // maxZoom: <Number>
            // maximumAge: 0
            // enableHighAccuracy: false
          }, options);
          if (!("geolocation" in navigator)) {
            this._handleGeolocationError({
              code: 0,
              message: "Geolocation not supported."
            });
            return this;
          }
          var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
          if (options.watch) {
            this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
          } else {
            navigator.geolocation.getCurrentPosition(onResponse, onError, options);
          }
          return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
          if (navigator.geolocation && navigator.geolocation.clearWatch) {
            navigator.geolocation.clearWatch(this._locationWatchId);
          }
          if (this._locateOptions) {
            this._locateOptions.setView = false;
          }
          return this;
        },
        _handleGeolocationError: function(error) {
          if (!this._container._leaflet_id) {
            return;
          }
          var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
          if (this._locateOptions.setView && !this._loaded) {
            this.fitWorld();
          }
          this.fire("locationerror", {
            code: c,
            message: "Geolocation error: " + message + "."
          });
        },
        _handleGeolocationResponse: function(pos) {
          if (!this._container._leaflet_id) {
            return;
          }
          var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
          if (options.setView) {
            var zoom2 = this.getBoundsZoom(bounds);
            this.setView(latlng, options.maxZoom ? Math.min(zoom2, options.maxZoom) : zoom2);
          }
          var data = {
            latlng,
            bounds,
            timestamp: pos.timestamp
          };
          for (var i in pos.coords) {
            if (typeof pos.coords[i] === "number") {
              data[i] = pos.coords[i];
            }
          }
          this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
          if (!HandlerClass) {
            return this;
          }
          var handler = this[name] = new HandlerClass(this);
          this._handlers.push(handler);
          if (this.options[name]) {
            handler.enable();
          }
          return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
          this._initEvents(true);
          if (this.options.maxBounds) {
            this.off("moveend", this._panInsideMaxBounds);
          }
          if (this._containerId !== this._container._leaflet_id) {
            throw new Error("Map container is being reused by another instance");
          }
          try {
            delete this._container._leaflet_id;
            delete this._containerId;
          } catch (e) {
            this._container._leaflet_id = void 0;
            this._containerId = void 0;
          }
          if (this._locationWatchId !== void 0) {
            this.stopLocate();
          }
          this._stop();
          remove(this._mapPane);
          if (this._clearControlPos) {
            this._clearControlPos();
          }
          if (this._resizeRequest) {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = null;
          }
          this._clearHandlers();
          if (this._loaded) {
            this.fire("unload");
          }
          var i;
          for (i in this._layers) {
            this._layers[i].remove();
          }
          for (i in this._panes) {
            remove(this._panes[i]);
          }
          this._layers = [];
          this._panes = [];
          delete this._mapPane;
          delete this._renderer;
          return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
          var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
          if (name) {
            this._panes[name] = pane;
          }
          return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
          this._checkIfLoaded();
          if (this._lastCenter && !this._moved()) {
            return this._lastCenter.clone();
          }
          return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
          return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
          var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
          return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
          return this.options.minZoom === void 0 ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
          return this.options.maxZoom === void 0 ? this._layersMaxZoom === void 0 ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
          bounds = toLatLngBounds(bounds);
          padding = toPoint(padding || [0, 0]);
          var zoom2 = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom2), this.project(nw, zoom2)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale2 = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
          zoom2 = this.getScaleZoom(scale2, zoom2);
          if (snap) {
            zoom2 = Math.round(zoom2 / (snap / 100)) * (snap / 100);
            zoom2 = inside ? Math.ceil(zoom2 / snap) * snap : Math.floor(zoom2 / snap) * snap;
          }
          return Math.max(min, Math.min(max, zoom2));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
          if (!this._size || this._sizeChanged) {
            this._size = new Point(
              this._container.clientWidth || 0,
              this._container.clientHeight || 0
            );
            this._sizeChanged = false;
          }
          return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom2) {
          var topLeftPoint = this._getTopLeftPoint(center, zoom2);
          return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
          this._checkIfLoaded();
          return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom2) {
          return this.options.crs.getProjectedBounds(zoom2 === void 0 ? this.getZoom() : zoom2);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
          return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
          return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
          return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
          var crs = this.options.crs;
          fromZoom = fromZoom === void 0 ? this._zoom : fromZoom;
          return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale2, fromZoom) {
          var crs = this.options.crs;
          fromZoom = fromZoom === void 0 ? this._zoom : fromZoom;
          var zoom2 = crs.zoom(scale2 * crs.scale(fromZoom));
          return isNaN(zoom2) ? Infinity : zoom2;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom2) {
          zoom2 = zoom2 === void 0 ? this._zoom : zoom2;
          return this.options.crs.latLngToPoint(toLatLng(latlng), zoom2);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom2) {
          zoom2 = zoom2 === void 0 ? this._zoom : zoom2;
          return this.options.crs.pointToLatLng(toPoint(point), zoom2);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
          var projectedPoint = toPoint(point).add(this.getPixelOrigin());
          return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
          var projectedPoint = this.project(toLatLng(latlng))._round();
          return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
          return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
          return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
          return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
          return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
          return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
          var layerPoint = this.containerPointToLayerPoint(toPoint(point));
          return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
          return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
          return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
          return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
          return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
          var container = this._container = get(id);
          if (!container) {
            throw new Error("Map container not found.");
          } else if (container._leaflet_id) {
            throw new Error("Map container is already initialized.");
          }
          on(container, "scroll", this._onScroll, this);
          this._containerId = stamp(container);
        },
        _initLayout: function() {
          var container = this._container;
          this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
          addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
          var position = getStyle(container, "position");
          if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") {
            container.style.position = "relative";
          }
          this._initPanes();
          if (this._initControlPos) {
            this._initControlPos();
          }
        },
        _initPanes: function() {
          var panes = this._panes = {};
          this._paneRenderers = {};
          this._mapPane = this.createPane("mapPane", this._container);
          setPosition(this._mapPane, new Point(0, 0));
          this.createPane("tilePane");
          this.createPane("overlayPane");
          this.createPane("shadowPane");
          this.createPane("markerPane");
          this.createPane("tooltipPane");
          this.createPane("popupPane");
          if (!this.options.markerZoomAnimation) {
            addClass(panes.markerPane, "leaflet-zoom-hide");
            addClass(panes.shadowPane, "leaflet-zoom-hide");
          }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom2, noMoveStart) {
          setPosition(this._mapPane, new Point(0, 0));
          var loading = !this._loaded;
          this._loaded = true;
          zoom2 = this._limitZoom(zoom2);
          this.fire("viewprereset");
          var zoomChanged = this._zoom !== zoom2;
          this._moveStart(zoomChanged, noMoveStart)._move(center, zoom2)._moveEnd(zoomChanged);
          this.fire("viewreset");
          if (loading) {
            this.fire("load");
          }
        },
        _moveStart: function(zoomChanged, noMoveStart) {
          if (zoomChanged) {
            this.fire("zoomstart");
          }
          if (!noMoveStart) {
            this.fire("movestart");
          }
          return this;
        },
        _move: function(center, zoom2, data, supressEvent) {
          if (zoom2 === void 0) {
            zoom2 = this._zoom;
          }
          var zoomChanged = this._zoom !== zoom2;
          this._zoom = zoom2;
          this._lastCenter = center;
          this._pixelOrigin = this._getNewPixelOrigin(center);
          if (!supressEvent) {
            if (zoomChanged || data && data.pinch) {
              this.fire("zoom", data);
            }
            this.fire("move", data);
          } else if (data && data.pinch) {
            this.fire("zoom", data);
          }
          return this;
        },
        _moveEnd: function(zoomChanged) {
          if (zoomChanged) {
            this.fire("zoomend");
          }
          return this.fire("moveend");
        },
        _stop: function() {
          cancelAnimFrame(this._flyToFrame);
          if (this._panAnim) {
            this._panAnim.stop();
          }
          return this;
        },
        _rawPanBy: function(offset) {
          setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
          return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
          if (!this._enforcingBounds) {
            this.panInsideBounds(this.options.maxBounds);
          }
        },
        _checkIfLoaded: function() {
          if (!this._loaded) {
            throw new Error("Set map center and zoom first.");
          }
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove2) {
          this._targets = {};
          this._targets[stamp(this._container)] = this;
          var onOff = remove2 ? off : on;
          onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
          if (this.options.trackResize) {
            onOff(window, "resize", this._onResize, this);
          }
          if (Browser.any3d && this.options.transform3DLimit) {
            (remove2 ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
          }
        },
        _onResize: function() {
          cancelAnimFrame(this._resizeRequest);
          this._resizeRequest = requestAnimFrame(
            function() {
              this.invalidateSize({ debounceMoveend: true });
            },
            this
          );
        },
        _onScroll: function() {
          this._container.scrollTop = 0;
          this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
          var pos = this._getMapPanePos();
          if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
            this._resetView(this.getCenter(), this.getZoom());
          }
        },
        _findEventTargets: function(e, type) {
          var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
          while (src) {
            target = this._targets[stamp(src)];
            if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
              dragging = true;
              break;
            }
            if (target && target.listens(type, true)) {
              if (isHover && !isExternalTarget(src, e)) {
                break;
              }
              targets.push(target);
              if (isHover) {
                break;
              }
            }
            if (src === this._container) {
              break;
            }
            src = src.parentNode;
          }
          if (!targets.length && !dragging && !isHover && this.listens(type, true)) {
            targets = [this];
          }
          return targets;
        },
        _isClickDisabled: function(el) {
          while (el && el !== this._container) {
            if (el["_leaflet_disable_click"]) {
              return true;
            }
            el = el.parentNode;
          }
        },
        _handleDOMEvent: function(e) {
          var el = e.target || e.srcElement;
          if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) {
            return;
          }
          var type = e.type;
          if (type === "mousedown") {
            preventOutline(el);
          }
          this._fireDOMEvent(e, type);
        },
        _mouseEvents: ["click", "dblclick", "mouseover", "mouseout", "contextmenu"],
        _fireDOMEvent: function(e, type, canvasTargets) {
          if (e.type === "click") {
            var synth = extend({}, e);
            synth.type = "preclick";
            this._fireDOMEvent(synth, synth.type, canvasTargets);
          }
          var targets = this._findEventTargets(e, type);
          if (canvasTargets) {
            var filtered = [];
            for (var i = 0; i < canvasTargets.length; i++) {
              if (canvasTargets[i].listens(type, true)) {
                filtered.push(canvasTargets[i]);
              }
            }
            targets = filtered.concat(targets);
          }
          if (!targets.length) {
            return;
          }
          if (type === "contextmenu") {
            preventDefault(e);
          }
          var target = targets[0];
          var data = {
            originalEvent: e
          };
          if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
            var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
            data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
            data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
            data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
          }
          for (i = 0; i < targets.length; i++) {
            targets[i].fire(type, data, true);
            if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) {
              return;
            }
          }
        },
        _draggableMoved: function(obj) {
          obj = obj.dragging && obj.dragging.enabled() ? obj : this;
          return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
          for (var i = 0, len = this._handlers.length; i < len; i++) {
            this._handlers[i].disable();
          }
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
          if (this._loaded) {
            callback.call(context || this, { target: this });
          } else {
            this.on("load", callback, context);
          }
          return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
          return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
          var pos = this._getMapPanePos();
          return pos && !pos.equals([0, 0]);
        },
        _getTopLeftPoint: function(center, zoom2) {
          var pixelOrigin = center && zoom2 !== void 0 ? this._getNewPixelOrigin(center, zoom2) : this.getPixelOrigin();
          return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom2) {
          var viewHalf = this.getSize()._divideBy(2);
          return this.project(center, zoom2)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom2, center) {
          var topLeft = this._getNewPixelOrigin(center, zoom2);
          return this.project(latlng, zoom2)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom2, center) {
          var topLeft = this._getNewPixelOrigin(center, zoom2);
          return toBounds([
            this.project(latLngBounds.getSouthWest(), zoom2)._subtract(topLeft),
            this.project(latLngBounds.getNorthWest(), zoom2)._subtract(topLeft),
            this.project(latLngBounds.getSouthEast(), zoom2)._subtract(topLeft),
            this.project(latLngBounds.getNorthEast(), zoom2)._subtract(topLeft)
          ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
          return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
          return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom2, bounds) {
          if (!bounds) {
            return center;
          }
          var centerPoint = this.project(center, zoom2), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom2);
          if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) {
            return center;
          }
          return this.unproject(centerPoint.add(offset), zoom2);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
          if (!bounds) {
            return offset;
          }
          var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
          return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom2) {
          var projectedMaxBounds = toBounds(
            this.project(maxBounds.getNorthEast(), zoom2),
            this.project(maxBounds.getSouthWest(), zoom2)
          ), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
          return new Point(dx, dy);
        },
        _rebound: function(left, right) {
          return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom2) {
          var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
          if (snap) {
            zoom2 = Math.round(zoom2 / snap) * snap;
          }
          return Math.max(min, Math.min(max, zoom2));
        },
        _onPanTransitionStep: function() {
          this.fire("move");
        },
        _onPanTransitionEnd: function() {
          removeClass(this._mapPane, "leaflet-pan-anim");
          this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
          var offset = this._getCenterOffset(center)._trunc();
          if ((options && options.animate) !== true && !this.getSize().contains(offset)) {
            return false;
          }
          this.panBy(offset, options);
          return true;
        },
        _createAnimProxy: function() {
          var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
          this._panes.mapPane.appendChild(proxy);
          this.on("zoomanim", function(e) {
            var prop = TRANSFORM, transform = this._proxy.style[prop];
            setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
            if (transform === this._proxy.style[prop] && this._animatingZoom) {
              this._onZoomTransitionEnd();
            }
          }, this);
          this.on("load moveend", this._animMoveEnd, this);
          this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
          remove(this._proxy);
          this.off("load moveend", this._animMoveEnd, this);
          delete this._proxy;
        },
        _animMoveEnd: function() {
          var c = this.getCenter(), z = this.getZoom();
          setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
          if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) {
            this._onZoomTransitionEnd();
          }
        },
        _nothingToAnimate: function() {
          return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom2, options) {
          if (this._animatingZoom) {
            return true;
          }
          options = options || {};
          if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom2 - this._zoom) > this.options.zoomAnimationThreshold) {
            return false;
          }
          var scale2 = this.getZoomScale(zoom2), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale2);
          if (options.animate !== true && !this.getSize().contains(offset)) {
            return false;
          }
          requestAnimFrame(function() {
            this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom2, true);
          }, this);
          return true;
        },
        _animateZoom: function(center, zoom2, startAnim, noUpdate) {
          if (!this._mapPane) {
            return;
          }
          if (startAnim) {
            this._animatingZoom = true;
            this._animateToCenter = center;
            this._animateToZoom = zoom2;
            addClass(this._mapPane, "leaflet-zoom-anim");
          }
          this.fire("zoomanim", {
            center,
            zoom: zoom2,
            noUpdate
          });
          if (!this._tempFireZoomEvent) {
            this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
          }
          this._move(this._animateToCenter, this._animateToZoom, void 0, true);
          setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
          if (!this._animatingZoom) {
            return;
          }
          if (this._mapPane) {
            removeClass(this._mapPane, "leaflet-zoom-anim");
          }
          this._animatingZoom = false;
          this._move(this._animateToCenter, this._animateToZoom, void 0, true);
          if (this._tempFireZoomEvent) {
            this.fire("zoom");
          }
          delete this._tempFireZoomEvent;
          this.fire("move");
          this._moveEnd(true);
        }
      });
      function createMap(id, options) {
        return new Map2(id, options);
      }
      var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
          // @option position: String = 'topright'
          // The position of the control (one of the map corners). Possible values are `'topleft'`,
          // `'topright'`, `'bottomleft'` or `'bottomright'`
          position: "topright"
        },
        initialize: function(options) {
          setOptions(this, options);
        },
        /* @section
         * Classes extending L.Control will inherit the following methods:
         *
         * @method getPosition: string
         * Returns the position of the control.
         */
        getPosition: function() {
          return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
          var map = this._map;
          if (map) {
            map.removeControl(this);
          }
          this.options.position = position;
          if (map) {
            map.addControl(this);
          }
          return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
          return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
          this.remove();
          this._map = map;
          var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
          addClass(container, "leaflet-control");
          if (pos.indexOf("bottom") !== -1) {
            corner.insertBefore(container, corner.firstChild);
          } else {
            corner.appendChild(container);
          }
          this._map.on("unload", this.remove, this);
          return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
          if (!this._map) {
            return this;
          }
          remove(this._container);
          if (this.onRemove) {
            this.onRemove(this._map);
          }
          this._map.off("unload", this.remove, this);
          this._map = null;
          return this;
        },
        _refocusOnMap: function(e) {
          if (this._map && e && e.screenX > 0 && e.screenY > 0) {
            this._map.getContainer().focus();
          }
        }
      });
      var control = function(options) {
        return new Control(options);
      };
      Map2.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control2) {
          control2.addTo(this);
          return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control2) {
          control2.remove();
          return this;
        },
        _initControlPos: function() {
          var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
          function createCorner(vSide, hSide) {
            var className = l + vSide + " " + l + hSide;
            corners[vSide + hSide] = create$1("div", className, container);
          }
          createCorner("top", "left");
          createCorner("top", "right");
          createCorner("bottom", "left");
          createCorner("bottom", "right");
        },
        _clearControlPos: function() {
          for (var i in this._controlCorners) {
            remove(this._controlCorners[i]);
          }
          remove(this._controlContainer);
          delete this._controlCorners;
          delete this._controlContainer;
        }
      });
      var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
          // @option collapsed: Boolean = true
          // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
          collapsed: true,
          position: "topright",
          // @option autoZIndex: Boolean = true
          // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
          autoZIndex: true,
          // @option hideSingleBase: Boolean = false
          // If `true`, the base layers in the control will be hidden when there is only one.
          hideSingleBase: false,
          // @option sortLayers: Boolean = false
          // Whether to sort the layers. When `false`, layers will keep the order
          // in which they were added to the control.
          sortLayers: false,
          // @option sortFunction: Function = *
          // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
          // that will be used for sorting the layers, when `sortLayers` is `true`.
          // The function receives both the `L.Layer` instances and their names, as in
          // `sortFunction(layerA, layerB, nameA, nameB)`.
          // By default, it sorts layers alphabetically by their name.
          sortFunction: function(layerA, layerB, nameA, nameB) {
            return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
          }
        },
        initialize: function(baseLayers, overlays, options) {
          setOptions(this, options);
          this._layerControlInputs = [];
          this._layers = [];
          this._lastZIndex = 0;
          this._handlingClick = false;
          this._preventClick = false;
          for (var i in baseLayers) {
            this._addLayer(baseLayers[i], i);
          }
          for (i in overlays) {
            this._addLayer(overlays[i], i, true);
          }
        },
        onAdd: function(map) {
          this._initLayout();
          this._update();
          this._map = map;
          map.on("zoomend", this._checkDisabledLayers, this);
          for (var i = 0; i < this._layers.length; i++) {
            this._layers[i].layer.on("add remove", this._onLayerChange, this);
          }
          return this._container;
        },
        addTo: function(map) {
          Control.prototype.addTo.call(this, map);
          return this._expandIfNotCollapsed();
        },
        onRemove: function() {
          this._map.off("zoomend", this._checkDisabledLayers, this);
          for (var i = 0; i < this._layers.length; i++) {
            this._layers[i].layer.off("add remove", this._onLayerChange, this);
          }
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
          this._addLayer(layer, name);
          return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
          this._addLayer(layer, name, true);
          return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
          layer.off("add remove", this._onLayerChange, this);
          var obj = this._getLayer(stamp(layer));
          if (obj) {
            this._layers.splice(this._layers.indexOf(obj), 1);
          }
          return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
          addClass(this._container, "leaflet-control-layers-expanded");
          this._section.style.height = null;
          var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
          if (acceptableHeight < this._section.clientHeight) {
            addClass(this._section, "leaflet-control-layers-scrollbar");
            this._section.style.height = acceptableHeight + "px";
          } else {
            removeClass(this._section, "leaflet-control-layers-scrollbar");
          }
          this._checkDisabledLayers();
          return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
          removeClass(this._container, "leaflet-control-layers-expanded");
          return this;
        },
        _initLayout: function() {
          var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
          container.setAttribute("aria-haspopup", true);
          disableClickPropagation(container);
          disableScrollPropagation(container);
          var section = this._section = create$1("section", className + "-list");
          if (collapsed) {
            this._map.on("click", this.collapse, this);
            on(container, {
              mouseenter: this._expandSafely,
              mouseleave: this.collapse
            }, this);
          }
          var link = this._layersLink = create$1("a", className + "-toggle", container);
          link.href = "#";
          link.title = "Layers";
          link.setAttribute("role", "button");
          on(link, {
            keydown: function(e) {
              if (e.keyCode === 13) {
                this._expandSafely();
              }
            },
            // Certain screen readers intercept the key event and instead send a click event
            click: function(e) {
              preventDefault(e);
              this._expandSafely();
            }
          }, this);
          if (!collapsed) {
            this.expand();
          }
          this._baseLayersList = create$1("div", className + "-base", section);
          this._separator = create$1("div", className + "-separator", section);
          this._overlaysList = create$1("div", className + "-overlays", section);
          container.appendChild(section);
        },
        _getLayer: function(id) {
          for (var i = 0; i < this._layers.length; i++) {
            if (this._layers[i] && stamp(this._layers[i].layer) === id) {
              return this._layers[i];
            }
          }
        },
        _addLayer: function(layer, name, overlay) {
          if (this._map) {
            layer.on("add remove", this._onLayerChange, this);
          }
          this._layers.push({
            layer,
            name,
            overlay
          });
          if (this.options.sortLayers) {
            this._layers.sort(bind(function(a, b) {
              return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
          }
          if (this.options.autoZIndex && layer.setZIndex) {
            this._lastZIndex++;
            layer.setZIndex(this._lastZIndex);
          }
          this._expandIfNotCollapsed();
        },
        _update: function() {
          if (!this._container) {
            return this;
          }
          empty(this._baseLayersList);
          empty(this._overlaysList);
          this._layerControlInputs = [];
          var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
          for (i = 0; i < this._layers.length; i++) {
            obj = this._layers[i];
            this._addItem(obj);
            overlaysPresent = overlaysPresent || obj.overlay;
            baseLayersPresent = baseLayersPresent || !obj.overlay;
            baseLayersCount += !obj.overlay ? 1 : 0;
          }
          if (this.options.hideSingleBase) {
            baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
            this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
          }
          this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
          return this;
        },
        _onLayerChange: function(e) {
          if (!this._handlingClick) {
            this._update();
          }
          var obj = this._getLayer(stamp(e.target));
          var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
          if (type) {
            this._map.fire(type, obj);
          }
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
          var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
          var radioFragment = document.createElement("div");
          radioFragment.innerHTML = radioHtml;
          return radioFragment.firstChild;
        },
        _addItem: function(obj) {
          var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
          if (obj.overlay) {
            input = document.createElement("input");
            input.type = "checkbox";
            input.className = "leaflet-control-layers-selector";
            input.defaultChecked = checked;
          } else {
            input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
          }
          this._layerControlInputs.push(input);
          input.layerId = stamp(obj.layer);
          on(input, "click", this._onInputClick, this);
          var name = document.createElement("span");
          name.innerHTML = " " + obj.name;
          var holder = document.createElement("span");
          label.appendChild(holder);
          holder.appendChild(input);
          holder.appendChild(name);
          var container = obj.overlay ? this._overlaysList : this._baseLayersList;
          container.appendChild(label);
          this._checkDisabledLayers();
          return label;
        },
        _onInputClick: function() {
          if (this._preventClick) {
            return;
          }
          var inputs = this._layerControlInputs, input, layer;
          var addedLayers = [], removedLayers = [];
          this._handlingClick = true;
          for (var i = inputs.length - 1; i >= 0; i--) {
            input = inputs[i];
            layer = this._getLayer(input.layerId).layer;
            if (input.checked) {
              addedLayers.push(layer);
            } else if (!input.checked) {
              removedLayers.push(layer);
            }
          }
          for (i = 0; i < removedLayers.length; i++) {
            if (this._map.hasLayer(removedLayers[i])) {
              this._map.removeLayer(removedLayers[i]);
            }
          }
          for (i = 0; i < addedLayers.length; i++) {
            if (!this._map.hasLayer(addedLayers[i])) {
              this._map.addLayer(addedLayers[i]);
            }
          }
          this._handlingClick = false;
          this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
          var inputs = this._layerControlInputs, input, layer, zoom2 = this._map.getZoom();
          for (var i = inputs.length - 1; i >= 0; i--) {
            input = inputs[i];
            layer = this._getLayer(input.layerId).layer;
            input.disabled = layer.options.minZoom !== void 0 && zoom2 < layer.options.minZoom || layer.options.maxZoom !== void 0 && zoom2 > layer.options.maxZoom;
          }
        },
        _expandIfNotCollapsed: function() {
          if (this._map && !this.options.collapsed) {
            this.expand();
          }
          return this;
        },
        _expandSafely: function() {
          var section = this._section;
          this._preventClick = true;
          on(section, "click", preventDefault);
          this.expand();
          var that = this;
          setTimeout(function() {
            off(section, "click", preventDefault);
            that._preventClick = false;
          });
        }
      });
      var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
      };
      var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
          position: "topleft",
          // @option zoomInText: String = '<span aria-hidden="true">+</span>'
          // The text set on the 'zoom in' button.
          zoomInText: '<span aria-hidden="true">+</span>',
          // @option zoomInTitle: String = 'Zoom in'
          // The title set on the 'zoom in' button.
          zoomInTitle: "Zoom in",
          // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
          // The text set on the 'zoom out' button.
          zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
          // @option zoomOutTitle: String = 'Zoom out'
          // The title set on the 'zoom out' button.
          zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
          var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
          this._zoomInButton = this._createButton(
            options.zoomInText,
            options.zoomInTitle,
            zoomName + "-in",
            container,
            this._zoomIn
          );
          this._zoomOutButton = this._createButton(
            options.zoomOutText,
            options.zoomOutTitle,
            zoomName + "-out",
            container,
            this._zoomOut
          );
          this._updateDisabled();
          map.on("zoomend zoomlevelschange", this._updateDisabled, this);
          return container;
        },
        onRemove: function(map) {
          map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
          this._disabled = true;
          this._updateDisabled();
          return this;
        },
        enable: function() {
          this._disabled = false;
          this._updateDisabled();
          return this;
        },
        _zoomIn: function(e) {
          if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
            this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
          }
        },
        _zoomOut: function(e) {
          if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
            this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
          }
        },
        _createButton: function(html, title, className, container, fn) {
          var link = create$1("a", className, container);
          link.innerHTML = html;
          link.href = "#";
          link.title = title;
          link.setAttribute("role", "button");
          link.setAttribute("aria-label", title);
          disableClickPropagation(link);
          on(link, "click", stop);
          on(link, "click", fn, this);
          on(link, "click", this._refocusOnMap, this);
          return link;
        },
        _updateDisabled: function() {
          var map = this._map, className = "leaflet-disabled";
          removeClass(this._zoomInButton, className);
          removeClass(this._zoomOutButton, className);
          this._zoomInButton.setAttribute("aria-disabled", "false");
          this._zoomOutButton.setAttribute("aria-disabled", "false");
          if (this._disabled || map._zoom === map.getMinZoom()) {
            addClass(this._zoomOutButton, className);
            this._zoomOutButton.setAttribute("aria-disabled", "true");
          }
          if (this._disabled || map._zoom === map.getMaxZoom()) {
            addClass(this._zoomInButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "true");
          }
        }
      });
      Map2.mergeOptions({
        zoomControl: true
      });
      Map2.addInitHook(function() {
        if (this.options.zoomControl) {
          this.zoomControl = new Zoom();
          this.addControl(this.zoomControl);
        }
      });
      var zoom = function(options) {
        return new Zoom(options);
      };
      var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
          position: "bottomleft",
          // @option maxWidth: Number = 100
          // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
          maxWidth: 100,
          // @option metric: Boolean = True
          // Whether to show the metric scale line (m/km).
          metric: true,
          // @option imperial: Boolean = True
          // Whether to show the imperial scale line (mi/ft).
          imperial: true
          // @option updateWhenIdle: Boolean = false
          // If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
        },
        onAdd: function(map) {
          var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
          this._addScales(options, className + "-line", container);
          map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
          map.whenReady(this._update, this);
          return container;
        },
        onRemove: function(map) {
          map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
          if (options.metric) {
            this._mScale = create$1("div", className, container);
          }
          if (options.imperial) {
            this._iScale = create$1("div", className, container);
          }
        },
        _update: function() {
          var map = this._map, y = map.getSize().y / 2;
          var maxMeters = map.distance(
            map.containerPointToLatLng([0, y]),
            map.containerPointToLatLng([this.options.maxWidth, y])
          );
          this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
          if (this.options.metric && maxMeters) {
            this._updateMetric(maxMeters);
          }
          if (this.options.imperial && maxMeters) {
            this._updateImperial(maxMeters);
          }
        },
        _updateMetric: function(maxMeters) {
          var meters = this._getRoundNum(maxMeters), label = meters < 1e3 ? meters + " m" : meters / 1e3 + " km";
          this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
          var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
          if (maxFeet > 5280) {
            maxMiles = maxFeet / 5280;
            miles = this._getRoundNum(maxMiles);
            this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
          } else {
            feet = this._getRoundNum(maxFeet);
            this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
          }
        },
        _updateScale: function(scale2, text, ratio) {
          scale2.style.width = Math.round(this.options.maxWidth * ratio) + "px";
          scale2.innerHTML = text;
        },
        _getRoundNum: function(num) {
          var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
          d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
          return pow10 * d;
        }
      });
      var scale = function(options) {
        return new Scale(options);
      };
      var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
      var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
          position: "bottomright",
          // @option prefix: String|false = 'Leaflet'
          // The HTML text shown before the attributions. Pass `false` to disable.
          prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
          setOptions(this, options);
          this._attributions = {};
        },
        onAdd: function(map) {
          map.attributionControl = this;
          this._container = create$1("div", "leaflet-control-attribution");
          disableClickPropagation(this._container);
          for (var i in map._layers) {
            if (map._layers[i].getAttribution) {
              this.addAttribution(map._layers[i].getAttribution());
            }
          }
          this._update();
          map.on("layeradd", this._addAttribution, this);
          return this._container;
        },
        onRemove: function(map) {
          map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
          if (ev.layer.getAttribution) {
            this.addAttribution(ev.layer.getAttribution());
            ev.layer.once("remove", function() {
              this.removeAttribution(ev.layer.getAttribution());
            }, this);
          }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
          this.options.prefix = prefix;
          this._update();
          return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
          if (!text) {
            return this;
          }
          if (!this._attributions[text]) {
            this._attributions[text] = 0;
          }
          this._attributions[text]++;
          this._update();
          return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
          if (!text) {
            return this;
          }
          if (this._attributions[text]) {
            this._attributions[text]--;
            this._update();
          }
          return this;
        },
        _update: function() {
          if (!this._map) {
            return;
          }
          var attribs = [];
          for (var i in this._attributions) {
            if (this._attributions[i]) {
              attribs.push(i);
            }
          }
          var prefixAndAttribs = [];
          if (this.options.prefix) {
            prefixAndAttribs.push(this.options.prefix);
          }
          if (attribs.length) {
            prefixAndAttribs.push(attribs.join(", "));
          }
          this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
      });
      Map2.mergeOptions({
        attributionControl: true
      });
      Map2.addInitHook(function() {
        if (this.options.attributionControl) {
          new Attribution().addTo(this);
        }
      });
      var attribution = function(options) {
        return new Attribution(options);
      };
      Control.Layers = Layers;
      Control.Zoom = Zoom;
      Control.Scale = Scale;
      Control.Attribution = Attribution;
      control.layers = layers;
      control.zoom = zoom;
      control.scale = scale;
      control.attribution = attribution;
      var Handler = Class.extend({
        initialize: function(map) {
          this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
          if (this._enabled) {
            return this;
          }
          this._enabled = true;
          this.addHooks();
          return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
          if (!this._enabled) {
            return this;
          }
          this._enabled = false;
          this.removeHooks();
          return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
          return !!this._enabled;
        }
        // @section Extension methods
        // Classes inheriting from `Handler` must implement the two following methods:
        // @method addHooks()
        // Called when the handler is enabled, should add event hooks.
        // @method removeHooks()
        // Called when the handler is disabled, should remove the event hooks added previously.
      });
      Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
      };
      var Mixin = { Events };
      var START = Browser.touch ? "touchstart mousedown" : "mousedown";
      var Draggable = Evented.extend({
        options: {
          // @section
          // @aka Draggable options
          // @option clickTolerance: Number = 3
          // The max number of pixels a user can shift the mouse pointer during a click
          // for it to be considered a valid click (as opposed to a mouse drag).
          clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline2, options) {
          setOptions(this, options);
          this._element = element;
          this._dragStartTarget = dragStartTarget || element;
          this._preventOutline = preventOutline2;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
          if (this._enabled) {
            return;
          }
          on(this._dragStartTarget, START, this._onDown, this);
          this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
          if (!this._enabled) {
            return;
          }
          if (Draggable._dragging === this) {
            this.finishDrag(true);
          }
          off(this._dragStartTarget, START, this._onDown, this);
          this._enabled = false;
          this._moved = false;
        },
        _onDown: function(e) {
          if (!this._enabled) {
            return;
          }
          this._moved = false;
          if (hasClass(this._element, "leaflet-zoom-anim")) {
            return;
          }
          if (e.touches && e.touches.length !== 1) {
            if (Draggable._dragging === this) {
              this.finishDrag();
            }
            return;
          }
          if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) {
            return;
          }
          Draggable._dragging = this;
          if (this._preventOutline) {
            preventOutline(this._element);
          }
          disableImageDrag();
          disableTextSelection();
          if (this._moving) {
            return;
          }
          this.fire("down");
          var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
          this._startPoint = new Point(first.clientX, first.clientY);
          this._startPos = getPosition(this._element);
          this._parentScale = getScale(sizedParent);
          var mouseevent = e.type === "mousedown";
          on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
          on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
          if (!this._enabled) {
            return;
          }
          if (e.touches && e.touches.length > 1) {
            this._moved = true;
            return;
          }
          var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
          if (!offset.x && !offset.y) {
            return;
          }
          if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) {
            return;
          }
          offset.x /= this._parentScale.x;
          offset.y /= this._parentScale.y;
          preventDefault(e);
          if (!this._moved) {
            this.fire("dragstart");
            this._moved = true;
            addClass(document.body, "leaflet-dragging");
            this._lastTarget = e.target || e.srcElement;
            if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) {
              this._lastTarget = this._lastTarget.correspondingUseElement;
            }
            addClass(this._lastTarget, "leaflet-drag-target");
          }
          this._newPos = this._startPos.add(offset);
          this._moving = true;
          this._lastEvent = e;
          this._updatePosition();
        },
        _updatePosition: function() {
          var e = { originalEvent: this._lastEvent };
          this.fire("predrag", e);
          setPosition(this._element, this._newPos);
          this.fire("drag", e);
        },
        _onUp: function() {
          if (!this._enabled) {
            return;
          }
          this.finishDrag();
        },
        finishDrag: function(noInertia) {
          removeClass(document.body, "leaflet-dragging");
          if (this._lastTarget) {
            removeClass(this._lastTarget, "leaflet-drag-target");
            this._lastTarget = null;
          }
          off(document, "mousemove touchmove", this._onMove, this);
          off(document, "mouseup touchend touchcancel", this._onUp, this);
          enableImageDrag();
          enableTextSelection();
          var fireDragend = this._moved && this._moving;
          this._moving = false;
          Draggable._dragging = false;
          if (fireDragend) {
            this.fire("dragend", {
              noInertia,
              distance: this._newPos.distanceTo(this._startPos)
            });
          }
        }
      });
      function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [1, 4, 2, 8], i, j, k, a, b, len, edge2, p;
        for (i = 0, len = points.length; i < len; i++) {
          points[i]._code = _getBitCode(points[i], bounds);
        }
        for (k = 0; k < 4; k++) {
          edge2 = edges[k];
          clippedPoints = [];
          for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
            a = points[i];
            b = points[j];
            if (!(a._code & edge2)) {
              if (b._code & edge2) {
                p = _getEdgeIntersection(b, a, edge2, bounds, round);
                p._code = _getBitCode(p, bounds);
                clippedPoints.push(p);
              }
              clippedPoints.push(a);
            } else if (!(b._code & edge2)) {
              p = _getEdgeIntersection(b, a, edge2, bounds, round);
              p._code = _getBitCode(p, bounds);
              clippedPoints.push(p);
            }
          }
          points = clippedPoints;
        }
        return points;
      }
      function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) {
          throw new Error("latlngs not passed");
        }
        if (!isFlat(latlngs)) {
          console.warn("latlngs are not flat! Only the first ring will be used");
          latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([0, 0]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        if (areaBounds < 1700) {
          centroidLatLng = centroid(latlngs);
        }
        var len = latlngs.length;
        var points = [];
        for (i = 0; i < len; i++) {
          var latlng = toLatLng(latlngs[i]);
          points.push(crs.project(toLatLng([latlng.lat - centroidLatLng.lat, latlng.lng - centroidLatLng.lng])));
        }
        area = x = y = 0;
        for (i = 0, j = len - 1; i < len; j = i++) {
          p1 = points[i];
          p2 = points[j];
          f = p1.y * p2.x - p2.y * p1.x;
          x += (p1.x + p2.x) * f;
          y += (p1.y + p2.y) * f;
          area += f * 3;
        }
        if (area === 0) {
          center = points[0];
        } else {
          center = [x / area, y / area];
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([latlngCenter.lat + centroidLatLng.lat, latlngCenter.lng + centroidLatLng.lng]);
      }
      function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for (var i = 0; i < coords.length; i++) {
          var latlng = toLatLng(coords[i]);
          latSum += latlng.lat;
          lngSum += latlng.lng;
          len++;
        }
        return toLatLng([latSum / len, lngSum / len]);
      }
      var PolyUtil = {
        __proto__: null,
        clipPolygon,
        polygonCenter,
        centroid
      };
      function simplify(points, tolerance) {
        if (!tolerance || !points.length) {
          return points.slice();
        }
        var sqTolerance = tolerance * tolerance;
        points = _reducePoints(points, sqTolerance);
        points = _simplifyDP(points, sqTolerance);
        return points;
      }
      function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
      }
      function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
      }
      function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for (i = 0; i < len; i++) {
          if (markers[i]) {
            newPoints.push(points[i]);
          }
        }
        return newPoints;
      }
      function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index2, i, sqDist;
        for (i = first + 1; i <= last - 1; i++) {
          sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
          if (sqDist > maxSqDist) {
            index2 = i;
            maxSqDist = sqDist;
          }
        }
        if (maxSqDist > sqTolerance) {
          markers[index2] = 1;
          _simplifyDPStep(points, markers, sqTolerance, first, index2);
          _simplifyDPStep(points, markers, sqTolerance, index2, last);
        }
      }
      function _reducePoints(points, sqTolerance) {
        var reducedPoints = [points[0]];
        for (var i = 1, prev = 0, len = points.length; i < len; i++) {
          if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
          }
        }
        if (prev < len - 1) {
          reducedPoints.push(points[len - 1]);
        }
        return reducedPoints;
      }
      var _lastCode;
      function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        _lastCode = codeB;
        while (true) {
          if (!(codeA | codeB)) {
            return [a, b];
          }
          if (codeA & codeB) {
            return false;
          }
          codeOut = codeA || codeB;
          p = _getEdgeIntersection(a, b, codeOut, bounds, round);
          newCode = _getBitCode(p, bounds);
          if (codeOut === codeA) {
            a = p;
            codeA = newCode;
          } else {
            b = p;
            codeB = newCode;
          }
        }
      }
      function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
          x = a.x + dx * (max.y - a.y) / dy;
          y = max.y;
        } else if (code & 4) {
          x = a.x + dx * (min.y - a.y) / dy;
          y = min.y;
        } else if (code & 2) {
          x = max.x;
          y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
          x = min.x;
          y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
      }
      function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) {
          code |= 1;
        } else if (p.x > bounds.max.x) {
          code |= 2;
        }
        if (p.y < bounds.min.y) {
          code |= 4;
        } else if (p.y > bounds.max.y) {
          code |= 8;
        }
        return code;
      }
      function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
      }
      function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
          t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
          if (t > 1) {
            x = p2.x;
            y = p2.y;
          } else if (t > 0) {
            x += dx * t;
            y += dy * t;
          }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
      }
      function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
      }
      function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
      }
      function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) {
          throw new Error("latlngs not passed");
        }
        if (!isFlat(latlngs)) {
          console.warn("latlngs are not flat! Only the first ring will be used");
          latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([0, 0]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        if (areaBounds < 1700) {
          centroidLatLng = centroid(latlngs);
        }
        var len = latlngs.length;
        var points = [];
        for (i = 0; i < len; i++) {
          var latlng = toLatLng(latlngs[i]);
          points.push(crs.project(toLatLng([latlng.lat - centroidLatLng.lat, latlng.lng - centroidLatLng.lng])));
        }
        for (i = 0, halfDist = 0; i < len - 1; i++) {
          halfDist += points[i].distanceTo(points[i + 1]) / 2;
        }
        if (halfDist === 0) {
          center = points[0];
        } else {
          for (i = 0, dist = 0; i < len - 1; i++) {
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
              ratio = (dist - halfDist) / segDist;
              center = [
                p2.x - ratio * (p2.x - p1.x),
                p2.y - ratio * (p2.y - p1.y)
              ];
              break;
            }
          }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([latlngCenter.lat + centroidLatLng.lat, latlngCenter.lng + centroidLatLng.lng]);
      }
      var LineUtil = {
        __proto__: null,
        simplify,
        pointToSegmentDistance,
        closestPointOnSegment,
        clipSegment,
        _getEdgeIntersection,
        _getBitCode,
        _sqClosestPointOnSegment,
        isFlat,
        _flat,
        polylineCenter
      };
      var LonLat = {
        project: function(latlng) {
          return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
          return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([-180, -90], [180, 90])
      };
      var Mercator = {
        R: 6378137,
        R_MINOR: 6356752314245179e-9,
        bounds: new Bounds([-2003750834279e-5, -1549657073972e-5], [2003750834279e-5, 1876465623138e-5]),
        project: function(latlng) {
          var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
          var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
          y = -r * Math.log(Math.max(ts, 1e-10));
          return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
          var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
          for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
            con = e * Math.sin(phi);
            con = Math.pow((1 - con) / (1 + con), e / 2);
            dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
            phi += dphi;
          }
          return new LatLng(phi * d, point.x * d / r);
        }
      };
      var index = {
        __proto__: null,
        LonLat,
        Mercator,
        SphericalMercator
      };
      var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
          var scale2 = 0.5 / (Math.PI * Mercator.R);
          return toTransformation(scale2, 0.5, -scale2, 0.5);
        }()
      });
      var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
      });
      var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom2) {
          return Math.pow(2, zoom2);
        },
        zoom: function(scale2) {
          return Math.log(scale2) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
          var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
          return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
      });
      CRS.Earth = Earth;
      CRS.EPSG3395 = EPSG3395;
      CRS.EPSG3857 = EPSG3857;
      CRS.EPSG900913 = EPSG900913;
      CRS.EPSG4326 = EPSG4326;
      CRS.Simple = Simple;
      var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
          // @option pane: String = 'overlayPane'
          // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
          pane: "overlayPane",
          // @option attribution: String = null
          // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
          attribution: null,
          bubblingMouseEvents: true
        },
        /* @section
         * Classes extending `L.Layer` will inherit the following methods:
         *
         * @method addTo(map: Map|LayerGroup): this
         * Adds the layer to the given map or layer group.
         */
        addTo: function(map) {
          map.addLayer(this);
          return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
          return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
          if (obj) {
            obj.removeLayer(this);
          }
          return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
          return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
          this._map._targets[stamp(targetEl)] = this;
          return this;
        },
        removeInteractiveTarget: function(targetEl) {
          delete this._map._targets[stamp(targetEl)];
          return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
          return this.options.attribution;
        },
        _layerAdd: function(e) {
          var map = e.target;
          if (!map.hasLayer(this)) {
            return;
          }
          this._map = map;
          this._zoomAnimated = map._zoomAnimated;
          if (this.getEvents) {
            var events = this.getEvents();
            map.on(events, this);
            this.once("remove", function() {
              map.off(events, this);
            }, this);
          }
          this.onAdd(map);
          this.fire("add");
          map.fire("layeradd", { layer: this });
        }
      });
      Map2.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
          if (!layer._layerAdd) {
            throw new Error("The provided object is not a Layer.");
          }
          var id = stamp(layer);
          if (this._layers[id]) {
            return this;
          }
          this._layers[id] = layer;
          layer._mapToAdd = this;
          if (layer.beforeAdd) {
            layer.beforeAdd(this);
          }
          this.whenReady(layer._layerAdd, layer);
          return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
          var id = stamp(layer);
          if (!this._layers[id]) {
            return this;
          }
          if (this._loaded) {
            layer.onRemove(this);
          }
          delete this._layers[id];
          if (this._loaded) {
            this.fire("layerremove", { layer });
            layer.fire("remove");
          }
          layer._map = layer._mapToAdd = null;
          return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
          return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
         * Iterates over the layers of the map, optionally specifying context of the iterator function.
         * ```
         * map.eachLayer(function(layer){
         *     layer.bindPopup('Hello');
         * });
         * ```
         */
        eachLayer: function(method, context) {
          for (var i in this._layers) {
            method.call(context, this._layers[i]);
          }
          return this;
        },
        _addLayers: function(layers2) {
          layers2 = layers2 ? isArray(layers2) ? layers2 : [layers2] : [];
          for (var i = 0, len = layers2.length; i < len; i++) {
            this.addLayer(layers2[i]);
          }
        },
        _addZoomLimit: function(layer) {
          if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
            this._zoomBoundLayers[stamp(layer)] = layer;
            this._updateZoomLevels();
          }
        },
        _removeZoomLimit: function(layer) {
          var id = stamp(layer);
          if (this._zoomBoundLayers[id]) {
            delete this._zoomBoundLayers[id];
            this._updateZoomLevels();
          }
        },
        _updateZoomLevels: function() {
          var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
          for (var i in this._zoomBoundLayers) {
            var options = this._zoomBoundLayers[i].options;
            minZoom = options.minZoom === void 0 ? minZoom : Math.min(minZoom, options.minZoom);
            maxZoom = options.maxZoom === void 0 ? maxZoom : Math.max(maxZoom, options.maxZoom);
          }
          this._layersMaxZoom = maxZoom === -Infinity ? void 0 : maxZoom;
          this._layersMinZoom = minZoom === Infinity ? void 0 : minZoom;
          if (oldZoomSpan !== this._getZoomSpan()) {
            this.fire("zoomlevelschange");
          }
          if (this.options.maxZoom === void 0 && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
            this.setZoom(this._layersMaxZoom);
          }
          if (this.options.minZoom === void 0 && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
            this.setZoom(this._layersMinZoom);
          }
        }
      });
      var LayerGroup = Layer.extend({
        initialize: function(layers2, options) {
          setOptions(this, options);
          this._layers = {};
          var i, len;
          if (layers2) {
            for (i = 0, len = layers2.length; i < len; i++) {
              this.addLayer(layers2[i]);
            }
          }
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
          var id = this.getLayerId(layer);
          this._layers[id] = layer;
          if (this._map) {
            this._map.addLayer(layer);
          }
          return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
          var id = layer in this._layers ? layer : this.getLayerId(layer);
          if (this._map && this._layers[id]) {
            this._map.removeLayer(this._layers[id]);
          }
          delete this._layers[id];
          return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
          var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
          return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
          return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
          var args = Array.prototype.slice.call(arguments, 1), i, layer;
          for (i in this._layers) {
            layer = this._layers[i];
            if (layer[methodName]) {
              layer[methodName].apply(layer, args);
            }
          }
          return this;
        },
        onAdd: function(map) {
          this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
          this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
          for (var i in this._layers) {
            method.call(context, this._layers[i]);
          }
          return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
          return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
          var layers2 = [];
          this.eachLayer(layers2.push, layers2);
          return layers2;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
          return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
          return stamp(layer);
        }
      });
      var layerGroup = function(layers2, options) {
        return new LayerGroup(layers2, options);
      };
      var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
          if (this.hasLayer(layer)) {
            return this;
          }
          layer.addEventParent(this);
          LayerGroup.prototype.addLayer.call(this, layer);
          return this.fire("layeradd", { layer });
        },
        removeLayer: function(layer) {
          if (!this.hasLayer(layer)) {
            return this;
          }
          if (layer in this._layers) {
            layer = this._layers[layer];
          }
          layer.removeEventParent(this);
          LayerGroup.prototype.removeLayer.call(this, layer);
          return this.fire("layerremove", { layer });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style2) {
          return this.invoke("setStyle", style2);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
          return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
          return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
          var bounds = new LatLngBounds();
          for (var id in this._layers) {
            var layer = this._layers[id];
            bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
          }
          return bounds;
        }
      });
      var featureGroup = function(layers2, options) {
        return new FeatureGroup(layers2, options);
      };
      var Icon = Class.extend({
        /* @section
         * @aka Icon options
         *
         * @option iconUrl: String = null
         * **(required)** The URL to the icon image (absolute or relative to your script path).
         *
         * @option iconRetinaUrl: String = null
         * The URL to a retina sized version of the icon image (absolute or relative to your
         * script path). Used for Retina screen devices.
         *
         * @option iconSize: Point = null
         * Size of the icon image in pixels.
         *
         * @option iconAnchor: Point = null
         * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
         * will be aligned so that this point is at the marker's geographical location. Centered
         * by default if size is specified, also can be set in CSS with negative margins.
         *
         * @option popupAnchor: Point = [0, 0]
         * The coordinates of the point from which popups will "open", relative to the icon anchor.
         *
         * @option tooltipAnchor: Point = [0, 0]
         * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
         *
         * @option shadowUrl: String = null
         * The URL to the icon shadow image. If not specified, no shadow image will be created.
         *
         * @option shadowRetinaUrl: String = null
         *
         * @option shadowSize: Point = null
         * Size of the shadow image in pixels.
         *
         * @option shadowAnchor: Point = null
         * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
         * as iconAnchor if not specified).
         *
         * @option className: String = ''
         * A custom class name to assign to both icon and shadow images. Empty by default.
         */
        options: {
          popupAnchor: [0, 0],
          tooltipAnchor: [0, 0],
          // @option crossOrigin: Boolean|String = false
          // Whether the crossOrigin attribute will be added to the tiles.
          // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
          // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
          crossOrigin: false
        },
        initialize: function(options) {
          setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
          return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
          return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
          var src = this._getIconUrl(name);
          if (!src) {
            if (name === "icon") {
              throw new Error("iconUrl not set in Icon options (see the docs).");
            }
            return null;
          }
          var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
          this._setIconStyles(img, name);
          if (this.options.crossOrigin || this.options.crossOrigin === "") {
            img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
          }
          return img;
        },
        _setIconStyles: function(img, name) {
          var options = this.options;
          var sizeOption = options[name + "Size"];
          if (typeof sizeOption === "number") {
            sizeOption = [sizeOption, sizeOption];
          }
          var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
          img.className = "leaflet-marker-" + name + " " + (options.className || "");
          if (anchor) {
            img.style.marginLeft = -anchor.x + "px";
            img.style.marginTop = -anchor.y + "px";
          }
          if (size) {
            img.style.width = size.x + "px";
            img.style.height = size.y + "px";
          }
        },
        _createImg: function(src, el) {
          el = el || document.createElement("img");
          el.src = src;
          return el;
        },
        _getIconUrl: function(name) {
          return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
      });
      function icon(options) {
        return new Icon(options);
      }
      var IconDefault = Icon.extend({
        options: {
          iconUrl: "marker-icon.png",
          iconRetinaUrl: "marker-icon-2x.png",
          shadowUrl: "marker-shadow.png",
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          tooltipAnchor: [16, -28],
          shadowSize: [41, 41]
        },
        _getIconUrl: function(name) {
          if (typeof IconDefault.imagePath !== "string") {
            IconDefault.imagePath = this._detectIconPath();
          }
          return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
          var strip = function(str, re, idx) {
            var match = re.exec(str);
            return match && match[idx];
          };
          path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
          return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
          var el = create$1("div", "leaflet-default-icon-path", document.body);
          var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage");
          document.body.removeChild(el);
          path = this._stripUrl(path);
          if (path) {
            return path;
          }
          var link = document.querySelector('link[href$="leaflet.css"]');
          if (!link) {
            return "";
          }
          return link.href.substring(0, link.href.length - "leaflet.css".length - 1);
        }
      });
      var MarkerDrag = Handler.extend({
        initialize: function(marker2) {
          this._marker = marker2;
        },
        addHooks: function() {
          var icon2 = this._marker._icon;
          if (!this._draggable) {
            this._draggable = new Draggable(icon2, icon2, true);
          }
          this._draggable.on({
            dragstart: this._onDragStart,
            predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this).enable();
          addClass(icon2, "leaflet-marker-draggable");
        },
        removeHooks: function() {
          this._draggable.off({
            dragstart: this._onDragStart,
            predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this).disable();
          if (this._marker._icon) {
            removeClass(this._marker._icon, "leaflet-marker-draggable");
          }
        },
        moved: function() {
          return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
          var marker2 = this._marker, map = marker2._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker2._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
          var panBounds = toBounds(
            bounds.min._subtract(origin).add(padding),
            bounds.max._subtract(origin).subtract(padding)
          );
          if (!panBounds.contains(iconPos)) {
            var movement = toPoint(
              (Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x),
              (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)
            ).multiplyBy(speed);
            map.panBy(movement, { animate: false });
            this._draggable._newPos._add(movement);
            this._draggable._startPos._add(movement);
            setPosition(marker2._icon, this._draggable._newPos);
            this._onDrag(e);
            this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
          }
        },
        _onDragStart: function() {
          this._oldLatLng = this._marker.getLatLng();
          this._marker.closePopup && this._marker.closePopup();
          this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
          if (this._marker.options.autoPan) {
            cancelAnimFrame(this._panRequest);
            this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
          }
        },
        _onDrag: function(e) {
          var marker2 = this._marker, shadow = marker2._shadow, iconPos = getPosition(marker2._icon), latlng = marker2._map.layerPointToLatLng(iconPos);
          if (shadow) {
            setPosition(shadow, iconPos);
          }
          marker2._latlng = latlng;
          e.latlng = latlng;
          e.oldLatLng = this._oldLatLng;
          marker2.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
          cancelAnimFrame(this._panRequest);
          delete this._oldLatLng;
          this._marker.fire("moveend").fire("dragend", e);
        }
      });
      var Marker2 = Layer.extend({
        // @section
        // @aka Marker options
        options: {
          // @option icon: Icon = *
          // Icon instance to use for rendering the marker.
          // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
          // If not specified, a common instance of `L.Icon.Default` is used.
          icon: new IconDefault(),
          // Option inherited from "Interactive layer" abstract class
          interactive: true,
          // @option keyboard: Boolean = true
          // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
          keyboard: true,
          // @option title: String = ''
          // Text for the browser tooltip that appear on marker hover (no tooltip by default).
          // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
          title: "",
          // @option alt: String = 'Marker'
          // Text for the `alt` attribute of the icon image.
          // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
          alt: "Marker",
          // @option zIndexOffset: Number = 0
          // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
          zIndexOffset: 0,
          // @option opacity: Number = 1.0
          // The opacity of the marker.
          opacity: 1,
          // @option riseOnHover: Boolean = false
          // If `true`, the marker will get on top of others when you hover the mouse over it.
          riseOnHover: false,
          // @option riseOffset: Number = 250
          // The z-index offset used for the `riseOnHover` feature.
          riseOffset: 250,
          // @option pane: String = 'markerPane'
          // `Map pane` where the markers icon will be added.
          pane: "markerPane",
          // @option shadowPane: String = 'shadowPane'
          // `Map pane` where the markers shadow will be added.
          shadowPane: "shadowPane",
          // @option bubblingMouseEvents: Boolean = false
          // When `true`, a mouse event on this marker will trigger the same event on the map
          // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
          bubblingMouseEvents: false,
          // @option autoPanOnFocus: Boolean = true
          // When `true`, the map will pan whenever the marker is focused (via
          // e.g. pressing `tab` on the keyboard) to ensure the marker is
          // visible within the map's bounds
          autoPanOnFocus: true,
          // @section Draggable marker options
          // @option draggable: Boolean = false
          // Whether the marker is draggable with mouse/touch or not.
          draggable: false,
          // @option autoPan: Boolean = false
          // Whether to pan the map when dragging this marker near its edge or not.
          autoPan: false,
          // @option autoPanPadding: Point = Point(50, 50)
          // Distance (in pixels to the left/right and to the top/bottom) of the
          // map edge to start panning the map.
          autoPanPadding: [50, 50],
          // @option autoPanSpeed: Number = 10
          // Number of pixels the map should pan by.
          autoPanSpeed: 10
        },
        /* @section
         *
         * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
         */
        initialize: function(latlng, options) {
          setOptions(this, options);
          this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
          this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
          if (this._zoomAnimated) {
            map.on("zoomanim", this._animateZoom, this);
          }
          this._initIcon();
          this.update();
        },
        onRemove: function(map) {
          if (this.dragging && this.dragging.enabled()) {
            this.options.draggable = true;
            this.dragging.removeHooks();
          }
          delete this.dragging;
          if (this._zoomAnimated) {
            map.off("zoomanim", this._animateZoom, this);
          }
          this._removeIcon();
          this._removeShadow();
        },
        getEvents: function() {
          return {
            zoom: this.update,
            viewreset: this.update
          };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
          return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
          var oldLatLng = this._latlng;
          this._latlng = toLatLng(latlng);
          this.update();
          return this.fire("move", { oldLatLng, latlng: this._latlng });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
          this.options.zIndexOffset = offset;
          return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
          return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon2) {
          this.options.icon = icon2;
          if (this._map) {
            this._initIcon();
            this.update();
          }
          if (this._popup) {
            this.bindPopup(this._popup, this._popup.options);
          }
          return this;
        },
        getElement: function() {
          return this._icon;
        },
        update: function() {
          if (this._icon && this._map) {
            var pos = this._map.latLngToLayerPoint(this._latlng).round();
            this._setPos(pos);
          }
          return this;
        },
        _initIcon: function() {
          var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
          var icon2 = options.icon.createIcon(this._icon), addIcon = false;
          if (icon2 !== this._icon) {
            if (this._icon) {
              this._removeIcon();
            }
            addIcon = true;
            if (options.title) {
              icon2.title = options.title;
            }
            if (icon2.tagName === "IMG") {
              icon2.alt = options.alt || "";
            }
          }
          addClass(icon2, classToAdd);
          if (options.keyboard) {
            icon2.tabIndex = "0";
            icon2.setAttribute("role", "button");
          }
          this._icon = icon2;
          if (options.riseOnHover) {
            this.on({
              mouseover: this._bringToFront,
              mouseout: this._resetZIndex
            });
          }
          if (this.options.autoPanOnFocus) {
            on(icon2, "focus", this._panOnFocus, this);
          }
          var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
          if (newShadow !== this._shadow) {
            this._removeShadow();
            addShadow = true;
          }
          if (newShadow) {
            addClass(newShadow, classToAdd);
            newShadow.alt = "";
          }
          this._shadow = newShadow;
          if (options.opacity < 1) {
            this._updateOpacity();
          }
          if (addIcon) {
            this.getPane().appendChild(this._icon);
          }
          this._initInteraction();
          if (newShadow && addShadow) {
            this.getPane(options.shadowPane).appendChild(this._shadow);
          }
        },
        _removeIcon: function() {
          if (this.options.riseOnHover) {
            this.off({
              mouseover: this._bringToFront,
              mouseout: this._resetZIndex
            });
          }
          if (this.options.autoPanOnFocus) {
            off(this._icon, "focus", this._panOnFocus, this);
          }
          remove(this._icon);
          this.removeInteractiveTarget(this._icon);
          this._icon = null;
        },
        _removeShadow: function() {
          if (this._shadow) {
            remove(this._shadow);
          }
          this._shadow = null;
        },
        _setPos: function(pos) {
          if (this._icon) {
            setPosition(this._icon, pos);
          }
          if (this._shadow) {
            setPosition(this._shadow, pos);
          }
          this._zIndex = pos.y + this.options.zIndexOffset;
          this._resetZIndex();
        },
        _updateZIndex: function(offset) {
          if (this._icon) {
            this._icon.style.zIndex = this._zIndex + offset;
          }
        },
        _animateZoom: function(opt) {
          var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
          this._setPos(pos);
        },
        _initInteraction: function() {
          if (!this.options.interactive) {
            return;
          }
          addClass(this._icon, "leaflet-interactive");
          this.addInteractiveTarget(this._icon);
          if (MarkerDrag) {
            var draggable = this.options.draggable;
            if (this.dragging) {
              draggable = this.dragging.enabled();
              this.dragging.disable();
            }
            this.dragging = new MarkerDrag(this);
            if (draggable) {
              this.dragging.enable();
            }
          }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
          this.options.opacity = opacity;
          if (this._map) {
            this._updateOpacity();
          }
          return this;
        },
        _updateOpacity: function() {
          var opacity = this.options.opacity;
          if (this._icon) {
            setOpacity(this._icon, opacity);
          }
          if (this._shadow) {
            setOpacity(this._shadow, opacity);
          }
        },
        _bringToFront: function() {
          this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
          this._updateZIndex(0);
        },
        _panOnFocus: function() {
          var map = this._map;
          if (!map) {
            return;
          }
          var iconOpts = this.options.icon.options;
          var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
          var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
          map.panInside(this._latlng, {
            paddingTopLeft: anchor,
            paddingBottomRight: size.subtract(anchor)
          });
        },
        _getPopupAnchor: function() {
          return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
          return this.options.icon.options.tooltipAnchor;
        }
      });
      function marker(latlng, options) {
        return new Marker2(latlng, options);
      }
      var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
          // @option stroke: Boolean = true
          // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
          stroke: true,
          // @option color: String = '#3388ff'
          // Stroke color
          color: "#3388ff",
          // @option weight: Number = 3
          // Stroke width in pixels
          weight: 3,
          // @option opacity: Number = 1.0
          // Stroke opacity
          opacity: 1,
          // @option lineCap: String= 'round'
          // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
          lineCap: "round",
          // @option lineJoin: String = 'round'
          // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
          lineJoin: "round",
          // @option dashArray: String = null
          // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
          dashArray: null,
          // @option dashOffset: String = null
          // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
          dashOffset: null,
          // @option fill: Boolean = depends
          // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
          fill: false,
          // @option fillColor: String = *
          // Fill color. Defaults to the value of the [`color`](#path-color) option
          fillColor: null,
          // @option fillOpacity: Number = 0.2
          // Fill opacity.
          fillOpacity: 0.2,
          // @option fillRule: String = 'evenodd'
          // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
          fillRule: "evenodd",
          // className: '',
          // Option inherited from "Interactive layer" abstract class
          interactive: true,
          // @option bubblingMouseEvents: Boolean = true
          // When `true`, a mouse event on this path will trigger the same event on the map
          // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
          bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
          this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
          this._renderer._initPath(this);
          this._reset();
          this._renderer._addPath(this);
        },
        onRemove: function() {
          this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
          if (this._map) {
            this._renderer._updatePath(this);
          }
          return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style2) {
          setOptions(this, style2);
          if (this._renderer) {
            this._renderer._updateStyle(this);
            if (this.options.stroke && style2 && Object.prototype.hasOwnProperty.call(style2, "weight")) {
              this._updateBounds();
            }
          }
          return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
          if (this._renderer) {
            this._renderer._bringToFront(this);
          }
          return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
          if (this._renderer) {
            this._renderer._bringToBack(this);
          }
          return this;
        },
        getElement: function() {
          return this._path;
        },
        _reset: function() {
          this._project();
          this._update();
        },
        _clickTolerance: function() {
          return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
      });
      var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
          fill: true,
          // @option radius: Number = 10
          // Radius of the circle marker, in pixels
          radius: 10
        },
        initialize: function(latlng, options) {
          setOptions(this, options);
          this._latlng = toLatLng(latlng);
          this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
          var oldLatLng = this._latlng;
          this._latlng = toLatLng(latlng);
          this.redraw();
          return this.fire("move", { oldLatLng, latlng: this._latlng });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
          return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
          this.options.radius = this._radius = radius;
          return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
          return this._radius;
        },
        setStyle: function(options) {
          var radius = options && options.radius || this._radius;
          Path.prototype.setStyle.call(this, options);
          this.setRadius(radius);
          return this;
        },
        _project: function() {
          this._point = this._map.latLngToLayerPoint(this._latlng);
          this._updateBounds();
        },
        _updateBounds: function() {
          var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [r + w, r2 + w];
          this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
          if (this._map) {
            this._updatePath();
          }
        },
        _updatePath: function() {
          this._renderer._updateCircle(this);
        },
        _empty: function() {
          return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
          return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
      });
      function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
      }
      var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
          if (typeof options === "number") {
            options = extend({}, legacyOptions, { radius: options });
          }
          setOptions(this, options);
          this._latlng = toLatLng(latlng);
          if (isNaN(this.options.radius)) {
            throw new Error("Circle radius cannot be NaN");
          }
          this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
          this._mRadius = radius;
          return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
          return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
          var half = [this._radius, this._radiusY || this._radius];
          return new LatLngBounds(
            this._map.layerPointToLatLng(this._point.subtract(half)),
            this._map.layerPointToLatLng(this._point.add(half))
          );
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
          var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
          if (crs.distance === Earth.distance) {
            var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([lat + latR, lng]), bottom = map.project([lat - latR, lng]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
            if (isNaN(lngR) || lngR === 0) {
              lngR = latR / Math.cos(Math.PI / 180 * lat);
            }
            this._point = p.subtract(map.getPixelOrigin());
            this._radius = isNaN(lngR) ? 0 : p.x - map.project([lat2, lng - lngR]).x;
            this._radiusY = p.y - top.y;
          } else {
            var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
            this._point = map.latLngToLayerPoint(this._latlng);
            this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
          }
          this._updateBounds();
        }
      });
      function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
      }
      var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
          // @option smoothFactor: Number = 1.0
          // How much to simplify the polyline on each zoom level. More means
          // better performance and smoother look, and less means more accurate representation.
          smoothFactor: 1,
          // @option noClip: Boolean = false
          // Disable polyline clipping.
          noClip: false
        },
        initialize: function(latlngs, options) {
          setOptions(this, options);
          this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
          return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
          this._setLatLngs(latlngs);
          return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
          return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
          var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
          for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
            var points = this._parts[j];
            for (var i = 1, len = points.length; i < len; i++) {
              p1 = points[i - 1];
              p2 = points[i];
              var sqDist = closest(p, p1, p2, true);
              if (sqDist < minDistance) {
                minDistance = sqDist;
                minPoint = closest(p, p1, p2);
              }
            }
          }
          if (minPoint) {
            minPoint.distance = Math.sqrt(minDistance);
          }
          return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
          if (!this._map) {
            throw new Error("Must add layer to map before using getCenter()");
          }
          return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
          return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
          latlngs = latlngs || this._defaultShape();
          latlng = toLatLng(latlng);
          latlngs.push(latlng);
          this._bounds.extend(latlng);
          return this.redraw();
        },
        _setLatLngs: function(latlngs) {
          this._bounds = new LatLngBounds();
          this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
          return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
          var result = [], flat = isFlat(latlngs);
          for (var i = 0, len = latlngs.length; i < len; i++) {
            if (flat) {
              result[i] = toLatLng(latlngs[i]);
              this._bounds.extend(result[i]);
            } else {
              result[i] = this._convertLatLngs(latlngs[i]);
            }
          }
          return result;
        },
        _project: function() {
          var pxBounds = new Bounds();
          this._rings = [];
          this._projectLatlngs(this._latlngs, this._rings, pxBounds);
          if (this._bounds.isValid() && pxBounds.isValid()) {
            this._rawPxBounds = pxBounds;
            this._updateBounds();
          }
        },
        _updateBounds: function() {
          var w = this._clickTolerance(), p = new Point(w, w);
          if (!this._rawPxBounds) {
            return;
          }
          this._pxBounds = new Bounds([
            this._rawPxBounds.min.subtract(p),
            this._rawPxBounds.max.add(p)
          ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
          var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
          if (flat) {
            ring = [];
            for (i = 0; i < len; i++) {
              ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
              projectedBounds.extend(ring[i]);
            }
            result.push(ring);
          } else {
            for (i = 0; i < len; i++) {
              this._projectLatlngs(latlngs[i], result, projectedBounds);
            }
          }
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
          var bounds = this._renderer._bounds;
          this._parts = [];
          if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
            return;
          }
          if (this.options.noClip) {
            this._parts = this._rings;
            return;
          }
          var parts = this._parts, i, j, k, len, len2, segment, points;
          for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
            points = this._rings[i];
            for (j = 0, len2 = points.length; j < len2 - 1; j++) {
              segment = clipSegment(points[j], points[j + 1], bounds, j, true);
              if (!segment) {
                continue;
              }
              parts[k] = parts[k] || [];
              parts[k].push(segment[0]);
              if (segment[1] !== points[j + 1] || j === len2 - 2) {
                parts[k].push(segment[1]);
                k++;
              }
            }
          }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
          var parts = this._parts, tolerance = this.options.smoothFactor;
          for (var i = 0, len = parts.length; i < len; i++) {
            parts[i] = simplify(parts[i], tolerance);
          }
        },
        _update: function() {
          if (!this._map) {
            return;
          }
          this._clipPoints();
          this._simplifyPoints();
          this._updatePath();
        },
        _updatePath: function() {
          this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
          var i, j, k, len, len2, part, w = this._clickTolerance();
          if (!this._pxBounds || !this._pxBounds.contains(p)) {
            return false;
          }
          for (i = 0, len = this._parts.length; i < len; i++) {
            part = this._parts[i];
            for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
              if (!closed && j === 0) {
                continue;
              }
              if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
                return true;
              }
            }
          }
          return false;
        }
      });
      function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
      }
      Polyline._flat = _flat;
      var Polygon = Polyline.extend({
        options: {
          fill: true
        },
        isEmpty: function() {
          return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
          if (!this._map) {
            throw new Error("Must add layer to map before using getCenter()");
          }
          return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
          var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
          if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
            result.pop();
          }
          return result;
        },
        _setLatLngs: function(latlngs) {
          Polyline.prototype._setLatLngs.call(this, latlngs);
          if (isFlat(this._latlngs)) {
            this._latlngs = [this._latlngs];
          }
        },
        _defaultShape: function() {
          return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
          var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
          bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
          this._parts = [];
          if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
            return;
          }
          if (this.options.noClip) {
            this._parts = this._rings;
            return;
          }
          for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
            clipped = clipPolygon(this._rings[i], bounds, true);
            if (clipped.length) {
              this._parts.push(clipped);
            }
          }
        },
        _updatePath: function() {
          this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
          var inside = false, part, p1, p2, i, j, k, len, len2;
          if (!this._pxBounds || !this._pxBounds.contains(p)) {
            return false;
          }
          for (i = 0, len = this._parts.length; i < len; i++) {
            part = this._parts[i];
            for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
              p1 = part[j];
              p2 = part[k];
              if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) {
                inside = !inside;
              }
            }
          }
          return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
      });
      function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
      }
      var GeoJSON = FeatureGroup.extend({
        /* @section
         * @aka GeoJSON options
         *
         * @option pointToLayer: Function = *
         * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
         * called when data is added, passing the GeoJSON point feature and its `LatLng`.
         * The default is to spawn a default `Marker`:
         * ```js
         * function(geoJsonPoint, latlng) {
         * 	return L.marker(latlng);
         * }
         * ```
         *
         * @option style: Function = *
         * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
         * called internally when data is added.
         * The default value is to not override any defaults:
         * ```js
         * function (geoJsonFeature) {
         * 	return {}
         * }
         * ```
         *
         * @option onEachFeature: Function = *
         * A `Function` that will be called once for each created `Feature`, after it has
         * been created and styled. Useful for attaching events and popups to features.
         * The default is to do nothing with the newly created layers:
         * ```js
         * function (feature, layer) {}
         * ```
         *
         * @option filter: Function = *
         * A `Function` that will be used to decide whether to include a feature or not.
         * The default is to include all features:
         * ```js
         * function (geoJsonFeature) {
         * 	return true;
         * }
         * ```
         * Note: dynamically changing the `filter` option will have effect only on newly
         * added data. It will _not_ re-evaluate already included features.
         *
         * @option coordsToLatLng: Function = *
         * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
         * The default is the `coordsToLatLng` static method.
         *
         * @option markersInheritOptions: Boolean = false
         * Whether default Markers for "Point" type Features inherit from group options.
         */
        initialize: function(geojson, options) {
          setOptions(this, options);
          this._layers = {};
          if (geojson) {
            this.addData(geojson);
          }
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
          var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
          if (features) {
            for (i = 0, len = features.length; i < len; i++) {
              feature = features[i];
              if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
                this.addData(feature);
              }
            }
            return this;
          }
          var options = this.options;
          if (options.filter && !options.filter(geojson)) {
            return this;
          }
          var layer = geometryToLayer(geojson, options);
          if (!layer) {
            return this;
          }
          layer.feature = asFeature(geojson);
          layer.defaultOptions = layer.options;
          this.resetStyle(layer);
          if (options.onEachFeature) {
            options.onEachFeature(geojson, layer);
          }
          return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
          if (layer === void 0) {
            return this.eachLayer(this.resetStyle, this);
          }
          layer.options = extend({}, layer.defaultOptions);
          this._setLayerStyle(layer, this.options.style);
          return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style2) {
          return this.eachLayer(function(layer) {
            this._setLayerStyle(layer, style2);
          }, this);
        },
        _setLayerStyle: function(layer, style2) {
          if (layer.setStyle) {
            if (typeof style2 === "function") {
              style2 = style2(layer.feature);
            }
            layer.setStyle(style2);
          }
        }
      });
      function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers2 = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) {
          return null;
        }
        switch (geometry.type) {
          case "Point":
            latlng = _coordsToLatLng(coords);
            return _pointToLayer(pointToLayer, geojson, latlng, options);
          case "MultiPoint":
            for (i = 0, len = coords.length; i < len; i++) {
              latlng = _coordsToLatLng(coords[i]);
              layers2.push(_pointToLayer(pointToLayer, geojson, latlng, options));
            }
            return new FeatureGroup(layers2);
          case "LineString":
          case "MultiLineString":
            latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
            return new Polyline(latlngs, options);
          case "Polygon":
          case "MultiPolygon":
            latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
            return new Polygon(latlngs, options);
          case "GeometryCollection":
            for (i = 0, len = geometry.geometries.length; i < len; i++) {
              var geoLayer = geometryToLayer({
                geometry: geometry.geometries[i],
                type: "Feature",
                properties: geojson.properties
              }, options);
              if (geoLayer) {
                layers2.push(geoLayer);
              }
            }
            return new FeatureGroup(layers2);
          case "FeatureCollection":
            for (i = 0, len = geometry.features.length; i < len; i++) {
              var featureLayer = geometryToLayer(geometry.features[i], options);
              if (featureLayer) {
                layers2.push(featureLayer);
              }
            }
            return new FeatureGroup(layers2);
          default:
            throw new Error("Invalid GeoJSON object.");
        }
      }
      function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker2(latlng, options && options.markersInheritOptions && options);
      }
      function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
      }
      function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for (var i = 0, len = coords.length, latlng; i < len; i++) {
          latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
          latlngs.push(latlng);
        }
        return latlngs;
      }
      function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== void 0 ? [formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] : [formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
      }
      function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for (var i = 0, len = latlngs.length; i < len; i++) {
          coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        }
        if (!levelsDeep && closed && coords.length > 0) {
          coords.push(coords[0].slice());
        }
        return coords;
      }
      function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, { geometry: newGeometry }) : asFeature(newGeometry);
      }
      function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") {
          return geojson;
        }
        return {
          type: "Feature",
          properties: {},
          geometry: geojson
        };
      }
      var PointToGeoJSON = {
        toGeoJSON: function(precision) {
          return getFeature(this, {
            type: "Point",
            coordinates: latLngToCoords(this.getLatLng(), precision)
          });
        }
      };
      Marker2.include(PointToGeoJSON);
      Circle.include(PointToGeoJSON);
      CircleMarker.include(PointToGeoJSON);
      Polyline.include({
        toGeoJSON: function(precision) {
          var multi = !isFlat(this._latlngs);
          var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
          return getFeature(this, {
            type: (multi ? "Multi" : "") + "LineString",
            coordinates: coords
          });
        }
      });
      Polygon.include({
        toGeoJSON: function(precision) {
          var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
          var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
          if (!holes) {
            coords = [coords];
          }
          return getFeature(this, {
            type: (multi ? "Multi" : "") + "Polygon",
            coordinates: coords
          });
        }
      });
      LayerGroup.include({
        toMultiPoint: function(precision) {
          var coords = [];
          this.eachLayer(function(layer) {
            coords.push(layer.toGeoJSON(precision).geometry.coordinates);
          });
          return getFeature(this, {
            type: "MultiPoint",
            coordinates: coords
          });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
          var type = this.feature && this.feature.geometry && this.feature.geometry.type;
          if (type === "MultiPoint") {
            return this.toMultiPoint(precision);
          }
          var isGeometryCollection = type === "GeometryCollection", jsons = [];
          this.eachLayer(function(layer) {
            if (layer.toGeoJSON) {
              var json = layer.toGeoJSON(precision);
              if (isGeometryCollection) {
                jsons.push(json.geometry);
              } else {
                var feature = asFeature(json);
                if (feature.type === "FeatureCollection") {
                  jsons.push.apply(jsons, feature.features);
                } else {
                  jsons.push(feature);
                }
              }
            }
          });
          if (isGeometryCollection) {
            return getFeature(this, {
              geometries: jsons,
              type: "GeometryCollection"
            });
          }
          return {
            type: "FeatureCollection",
            features: jsons
          };
        }
      });
      function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
      }
      var geoJson = geoJSON;
      var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
          // @option opacity: Number = 1.0
          // The opacity of the image overlay.
          opacity: 1,
          // @option alt: String = ''
          // Text for the `alt` attribute of the image (useful for accessibility).
          alt: "",
          // @option interactive: Boolean = false
          // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
          interactive: false,
          // @option crossOrigin: Boolean|String = false
          // Whether the crossOrigin attribute will be added to the image.
          // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
          // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
          crossOrigin: false,
          // @option errorOverlayUrl: String = ''
          // URL to the overlay image to show in place of the overlay that failed to load.
          errorOverlayUrl: "",
          // @option zIndex: Number = 1
          // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
          zIndex: 1,
          // @option className: String = ''
          // A custom class name to assign to the image. Empty by default.
          className: ""
        },
        initialize: function(url, bounds, options) {
          this._url = url;
          this._bounds = toLatLngBounds(bounds);
          setOptions(this, options);
        },
        onAdd: function() {
          if (!this._image) {
            this._initImage();
            if (this.options.opacity < 1) {
              this._updateOpacity();
            }
          }
          if (this.options.interactive) {
            addClass(this._image, "leaflet-interactive");
            this.addInteractiveTarget(this._image);
          }
          this.getPane().appendChild(this._image);
          this._reset();
        },
        onRemove: function() {
          remove(this._image);
          if (this.options.interactive) {
            this.removeInteractiveTarget(this._image);
          }
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
          this.options.opacity = opacity;
          if (this._image) {
            this._updateOpacity();
          }
          return this;
        },
        setStyle: function(styleOpts) {
          if (styleOpts.opacity) {
            this.setOpacity(styleOpts.opacity);
          }
          return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
          if (this._map) {
            toFront(this._image);
          }
          return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
          if (this._map) {
            toBack(this._image);
          }
          return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
          this._url = url;
          if (this._image) {
            this._image.src = url;
          }
          return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
          this._bounds = toLatLngBounds(bounds);
          if (this._map) {
            this._reset();
          }
          return this;
        },
        getEvents: function() {
          var events = {
            zoom: this._reset,
            viewreset: this._reset
          };
          if (this._zoomAnimated) {
            events.zoomanim = this._animateZoom;
          }
          return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
          this.options.zIndex = value;
          this._updateZIndex();
          return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
          return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
          return this._image;
        },
        _initImage: function() {
          var wasElementSupplied = this._url.tagName === "IMG";
          var img = this._image = wasElementSupplied ? this._url : create$1("img");
          addClass(img, "leaflet-image-layer");
          if (this._zoomAnimated) {
            addClass(img, "leaflet-zoom-animated");
          }
          if (this.options.className) {
            addClass(img, this.options.className);
          }
          img.onselectstart = falseFn;
          img.onmousemove = falseFn;
          img.onload = bind(this.fire, this, "load");
          img.onerror = bind(this._overlayOnError, this, "error");
          if (this.options.crossOrigin || this.options.crossOrigin === "") {
            img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
          }
          if (this.options.zIndex) {
            this._updateZIndex();
          }
          if (wasElementSupplied) {
            this._url = img.src;
            return;
          }
          img.src = this._url;
          img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
          var scale2 = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
          setTransform(this._image, offset, scale2);
        },
        _reset: function() {
          var image = this._image, bounds = new Bounds(
            this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
            this._map.latLngToLayerPoint(this._bounds.getSouthEast())
          ), size = bounds.getSize();
          setPosition(image, bounds.min);
          image.style.width = size.x + "px";
          image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
          setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
          if (this._image && this.options.zIndex !== void 0 && this.options.zIndex !== null) {
            this._image.style.zIndex = this.options.zIndex;
          }
        },
        _overlayOnError: function() {
          this.fire("error");
          var errorUrl = this.options.errorOverlayUrl;
          if (errorUrl && this._url !== errorUrl) {
            this._url = errorUrl;
            this._image.src = errorUrl;
          }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
          return this._bounds.getCenter();
        }
      });
      var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
      };
      var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
          // @option autoplay: Boolean = true
          // Whether the video starts playing automatically when loaded.
          // On some browsers autoplay will only work with `muted: true`
          autoplay: true,
          // @option loop: Boolean = true
          // Whether the video will loop back to the beginning when played.
          loop: true,
          // @option keepAspectRatio: Boolean = true
          // Whether the video will save aspect ratio after the projection.
          // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
          keepAspectRatio: true,
          // @option muted: Boolean = false
          // Whether the video starts on mute when loaded.
          muted: false,
          // @option playsInline: Boolean = true
          // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
          playsInline: true
        },
        _initImage: function() {
          var wasElementSupplied = this._url.tagName === "VIDEO";
          var vid = this._image = wasElementSupplied ? this._url : create$1("video");
          addClass(vid, "leaflet-image-layer");
          if (this._zoomAnimated) {
            addClass(vid, "leaflet-zoom-animated");
          }
          if (this.options.className) {
            addClass(vid, this.options.className);
          }
          vid.onselectstart = falseFn;
          vid.onmousemove = falseFn;
          vid.onloadeddata = bind(this.fire, this, "load");
          if (wasElementSupplied) {
            var sourceElements = vid.getElementsByTagName("source");
            var sources = [];
            for (var j = 0; j < sourceElements.length; j++) {
              sources.push(sourceElements[j].src);
            }
            this._url = sourceElements.length > 0 ? sources : [vid.src];
            return;
          }
          if (!isArray(this._url)) {
            this._url = [this._url];
          }
          if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) {
            vid.style["objectFit"] = "fill";
          }
          vid.autoplay = !!this.options.autoplay;
          vid.loop = !!this.options.loop;
          vid.muted = !!this.options.muted;
          vid.playsInline = !!this.options.playsInline;
          for (var i = 0; i < this._url.length; i++) {
            var source = create$1("source");
            source.src = this._url[i];
            vid.appendChild(source);
          }
        }
        // @method getElement(): HTMLVideoElement
        // Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
        // used by this overlay.
      });
      function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
      }
      var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
          var el = this._image = this._url;
          addClass(el, "leaflet-image-layer");
          if (this._zoomAnimated) {
            addClass(el, "leaflet-zoom-animated");
          }
          if (this.options.className) {
            addClass(el, this.options.className);
          }
          el.onselectstart = falseFn;
          el.onmousemove = falseFn;
        }
        // @method getElement(): SVGElement
        // Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
        // used by this overlay.
      });
      function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
      }
      var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
          // @option interactive: Boolean = false
          // If true, the popup/tooltip will listen to the mouse events.
          interactive: false,
          // @option offset: Point = Point(0, 0)
          // The offset of the overlay position.
          offset: [0, 0],
          // @option className: String = ''
          // A custom CSS class name to assign to the overlay.
          className: "",
          // @option pane: String = undefined
          // `Map pane` where the overlay will be added.
          pane: void 0,
          // @option content: String|HTMLElement|Function = ''
          // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
          // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
          content: ""
        },
        initialize: function(options, source) {
          if (options && (options instanceof LatLng || isArray(options))) {
            this._latlng = toLatLng(options);
            setOptions(this, source);
          } else {
            setOptions(this, options);
            this._source = source;
          }
          if (this.options.content) {
            this._content = this.options.content;
          }
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
          map = arguments.length ? map : this._source._map;
          if (!map.hasLayer(this)) {
            map.addLayer(this);
          }
          return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
          if (this._map) {
            this._map.removeLayer(this);
          }
          return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
          if (this._map) {
            this.close();
          } else {
            if (arguments.length) {
              this._source = layer;
            } else {
              layer = this._source;
            }
            this._prepareOpen();
            this.openOn(layer._map);
          }
          return this;
        },
        onAdd: function(map) {
          this._zoomAnimated = map._zoomAnimated;
          if (!this._container) {
            this._initLayout();
          }
          if (map._fadeAnimated) {
            setOpacity(this._container, 0);
          }
          clearTimeout(this._removeTimeout);
          this.getPane().appendChild(this._container);
          this.update();
          if (map._fadeAnimated) {
            setOpacity(this._container, 1);
          }
          this.bringToFront();
          if (this.options.interactive) {
            addClass(this._container, "leaflet-interactive");
            this.addInteractiveTarget(this._container);
          }
        },
        onRemove: function(map) {
          if (map._fadeAnimated) {
            setOpacity(this._container, 0);
            this._removeTimeout = setTimeout(bind(remove, void 0, this._container), 200);
          } else {
            remove(this._container);
          }
          if (this.options.interactive) {
            removeClass(this._container, "leaflet-interactive");
            this.removeInteractiveTarget(this._container);
          }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
          return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
          this._latlng = toLatLng(latlng);
          if (this._map) {
            this._updatePosition();
            this._adjustPan();
          }
          return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
          return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
          this._content = content;
          this.update();
          return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
          return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
          if (!this._map) {
            return;
          }
          this._container.style.visibility = "hidden";
          this._updateContent();
          this._updateLayout();
          this._updatePosition();
          this._container.style.visibility = "";
          this._adjustPan();
        },
        getEvents: function() {
          var events = {
            zoom: this._updatePosition,
            viewreset: this._updatePosition
          };
          if (this._zoomAnimated) {
            events.zoomanim = this._animateZoom;
          }
          return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
          return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
          if (this._map) {
            toFront(this._container);
          }
          return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
          if (this._map) {
            toBack(this._container);
          }
          return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
          var source = this._source;
          if (!source._map) {
            return false;
          }
          if (source instanceof FeatureGroup) {
            source = null;
            var layers2 = this._source._layers;
            for (var id in layers2) {
              if (layers2[id]._map) {
                source = layers2[id];
                break;
              }
            }
            if (!source) {
              return false;
            }
            this._source = source;
          }
          if (!latlng) {
            if (source.getCenter) {
              latlng = source.getCenter();
            } else if (source.getLatLng) {
              latlng = source.getLatLng();
            } else if (source.getBounds) {
              latlng = source.getBounds().getCenter();
            } else {
              throw new Error("Unable to get source layer LatLng.");
            }
          }
          this.setLatLng(latlng);
          if (this._map) {
            this.update();
          }
          return true;
        },
        _updateContent: function() {
          if (!this._content) {
            return;
          }
          var node = this._contentNode;
          var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
          if (typeof content === "string") {
            node.innerHTML = content;
          } else {
            while (node.hasChildNodes()) {
              node.removeChild(node.firstChild);
            }
            node.appendChild(content);
          }
          this.fire("contentupdate");
        },
        _updatePosition: function() {
          if (!this._map) {
            return;
          }
          var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
          if (this._zoomAnimated) {
            setPosition(this._container, pos.add(anchor));
          } else {
            offset = offset.add(pos).add(anchor);
          }
          var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
          this._container.style.bottom = bottom + "px";
          this._container.style.left = left + "px";
        },
        _getAnchor: function() {
          return [0, 0];
        }
      });
      Map2.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
          var overlay = content;
          if (!(overlay instanceof OverlayClass)) {
            overlay = new OverlayClass(options).setContent(content);
          }
          if (latlng) {
            overlay.setLatLng(latlng);
          }
          return overlay;
        }
      });
      Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
          var overlay = content;
          if (overlay instanceof OverlayClass) {
            setOptions(overlay, options);
            overlay._source = this;
          } else {
            overlay = old && !options ? old : new OverlayClass(options, this);
            overlay.setContent(content);
          }
          return overlay;
        }
      });
      var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
          // @option pane: String = 'popupPane'
          // `Map pane` where the popup will be added.
          pane: "popupPane",
          // @option offset: Point = Point(0, 7)
          // The offset of the popup position.
          offset: [0, 7],
          // @option maxWidth: Number = 300
          // Max width of the popup, in pixels.
          maxWidth: 300,
          // @option minWidth: Number = 50
          // Min width of the popup, in pixels.
          minWidth: 50,
          // @option maxHeight: Number = null
          // If set, creates a scrollable container of the given height
          // inside a popup if its content exceeds it.
          // The scrollable container can be styled using the
          // `leaflet-popup-scrolled` CSS class selector.
          maxHeight: null,
          // @option autoPan: Boolean = true
          // Set it to `false` if you don't want the map to do panning animation
          // to fit the opened popup.
          autoPan: true,
          // @option autoPanPaddingTopLeft: Point = null
          // The margin between the popup and the top left corner of the map
          // view after autopanning was performed.
          autoPanPaddingTopLeft: null,
          // @option autoPanPaddingBottomRight: Point = null
          // The margin between the popup and the bottom right corner of the map
          // view after autopanning was performed.
          autoPanPaddingBottomRight: null,
          // @option autoPanPadding: Point = Point(5, 5)
          // Equivalent of setting both top left and bottom right autopan padding to the same value.
          autoPanPadding: [5, 5],
          // @option keepInView: Boolean = false
          // Set it to `true` if you want to prevent users from panning the popup
          // off of the screen while it is open.
          keepInView: false,
          // @option closeButton: Boolean = true
          // Controls the presence of a close button in the popup.
          closeButton: true,
          // @option autoClose: Boolean = true
          // Set it to `false` if you want to override the default behavior of
          // the popup closing when another popup is opened.
          autoClose: true,
          // @option closeOnEscapeKey: Boolean = true
          // Set it to `false` if you want to override the default behavior of
          // the ESC key for closing of the popup.
          closeOnEscapeKey: true,
          // @option closeOnClick: Boolean = *
          // Set it if you want to override the default behavior of the popup closing when user clicks
          // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
          // @option className: String = ''
          // A custom CSS class name to assign to the popup.
          className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
          map = arguments.length ? map : this._source._map;
          if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) {
            map.removeLayer(map._popup);
          }
          map._popup = this;
          return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
          DivOverlay.prototype.onAdd.call(this, map);
          map.fire("popupopen", { popup: this });
          if (this._source) {
            this._source.fire("popupopen", { popup: this }, true);
            if (!(this._source instanceof Path)) {
              this._source.on("preclick", stopPropagation);
            }
          }
        },
        onRemove: function(map) {
          DivOverlay.prototype.onRemove.call(this, map);
          map.fire("popupclose", { popup: this });
          if (this._source) {
            this._source.fire("popupclose", { popup: this }, true);
            if (!(this._source instanceof Path)) {
              this._source.off("preclick", stopPropagation);
            }
          }
        },
        getEvents: function() {
          var events = DivOverlay.prototype.getEvents.call(this);
          if (this.options.closeOnClick !== void 0 ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
            events.preclick = this.close;
          }
          if (this.options.keepInView) {
            events.moveend = this._adjustPan;
          }
          return events;
        },
        _initLayout: function() {
          var prefix = "leaflet-popup", container = this._container = create$1(
            "div",
            prefix + " " + (this.options.className || "") + " leaflet-zoom-animated"
          );
          var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
          this._contentNode = create$1("div", prefix + "-content", wrapper);
          disableClickPropagation(container);
          disableScrollPropagation(this._contentNode);
          on(container, "contextmenu", stopPropagation);
          this._tipContainer = create$1("div", prefix + "-tip-container", container);
          this._tip = create$1("div", prefix + "-tip", this._tipContainer);
          if (this.options.closeButton) {
            var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
            closeButton.setAttribute("role", "button");
            closeButton.setAttribute("aria-label", "Close popup");
            closeButton.href = "#close";
            closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
            on(closeButton, "click", function(ev) {
              preventDefault(ev);
              this.close();
            }, this);
          }
        },
        _updateLayout: function() {
          var container = this._contentNode, style2 = container.style;
          style2.width = "";
          style2.whiteSpace = "nowrap";
          var width = container.offsetWidth;
          width = Math.min(width, this.options.maxWidth);
          width = Math.max(width, this.options.minWidth);
          style2.width = width + 1 + "px";
          style2.whiteSpace = "";
          style2.height = "";
          var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
          if (maxHeight && height > maxHeight) {
            style2.height = maxHeight + "px";
            addClass(container, scrolledClass);
          } else {
            removeClass(container, scrolledClass);
          }
          this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
          var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
          setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
          if (!this.options.autoPan) {
            return;
          }
          if (this._map._panAnim) {
            this._map._panAnim.stop();
          }
          if (this._autopanning) {
            this._autopanning = false;
            return;
          }
          var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
          layerPos._add(getPosition(this._container));
          var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
          if (containerPos.x + containerWidth + paddingBR.x > size.x) {
            dx = containerPos.x + containerWidth - size.x + paddingBR.x;
          }
          if (containerPos.x - dx - paddingTL.x < 0) {
            dx = containerPos.x - paddingTL.x;
          }
          if (containerPos.y + containerHeight + paddingBR.y > size.y) {
            dy = containerPos.y + containerHeight - size.y + paddingBR.y;
          }
          if (containerPos.y - dy - paddingTL.y < 0) {
            dy = containerPos.y - paddingTL.y;
          }
          if (dx || dy) {
            if (this.options.keepInView) {
              this._autopanning = true;
            }
            map.fire("autopanstart").panBy([dx, dy]);
          }
        },
        _getAnchor: function() {
          return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
        }
      });
      var popup = function(options, source) {
        return new Popup(options, source);
      };
      Map2.mergeOptions({
        closePopupOnClick: true
      });
      Map2.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup2, latlng, options) {
          this._initOverlay(Popup, popup2, latlng, options).openOn(this);
          return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup2) {
          popup2 = arguments.length ? popup2 : this._popup;
          if (popup2) {
            popup2.close();
          }
          return this;
        }
      });
      Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
          this._popup = this._initOverlay(Popup, this._popup, content, options);
          if (!this._popupHandlersAdded) {
            this.on({
              click: this._openPopup,
              keypress: this._onKeyPress,
              remove: this.closePopup,
              move: this._movePopup
            });
            this._popupHandlersAdded = true;
          }
          return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
          if (this._popup) {
            this.off({
              click: this._openPopup,
              keypress: this._onKeyPress,
              remove: this.closePopup,
              move: this._movePopup
            });
            this._popupHandlersAdded = false;
            this._popup = null;
          }
          return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
          if (this._popup) {
            if (!(this instanceof FeatureGroup)) {
              this._popup._source = this;
            }
            if (this._popup._prepareOpen(latlng || this._latlng)) {
              this._popup.openOn(this._map);
            }
          }
          return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
          if (this._popup) {
            this._popup.close();
          }
          return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
          if (this._popup) {
            this._popup.toggle(this);
          }
          return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
          return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
          if (this._popup) {
            this._popup.setContent(content);
          }
          return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
          return this._popup;
        },
        _openPopup: function(e) {
          if (!this._popup || !this._map) {
            return;
          }
          stop(e);
          var target = e.layer || e.target;
          if (this._popup._source === target && !(target instanceof Path)) {
            if (this._map.hasLayer(this._popup)) {
              this.closePopup();
            } else {
              this.openPopup(e.latlng);
            }
            return;
          }
          this._popup._source = target;
          this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
          this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
          if (e.originalEvent.keyCode === 13) {
            this._openPopup(e);
          }
        }
      });
      var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
          // @option pane: String = 'tooltipPane'
          // `Map pane` where the tooltip will be added.
          pane: "tooltipPane",
          // @option offset: Point = Point(0, 0)
          // Optional offset of the tooltip position.
          offset: [0, 0],
          // @option direction: String = 'auto'
          // Direction where to open the tooltip. Possible values are: `right`, `left`,
          // `top`, `bottom`, `center`, `auto`.
          // `auto` will dynamically switch between `right` and `left` according to the tooltip
          // position on the map.
          direction: "auto",
          // @option permanent: Boolean = false
          // Whether to open the tooltip permanently or only on mouseover.
          permanent: false,
          // @option sticky: Boolean = false
          // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
          sticky: false,
          // @option opacity: Number = 0.9
          // Tooltip container opacity.
          opacity: 0.9
        },
        onAdd: function(map) {
          DivOverlay.prototype.onAdd.call(this, map);
          this.setOpacity(this.options.opacity);
          map.fire("tooltipopen", { tooltip: this });
          if (this._source) {
            this.addEventParent(this._source);
            this._source.fire("tooltipopen", { tooltip: this }, true);
          }
        },
        onRemove: function(map) {
          DivOverlay.prototype.onRemove.call(this, map);
          map.fire("tooltipclose", { tooltip: this });
          if (this._source) {
            this.removeEventParent(this._source);
            this._source.fire("tooltipclose", { tooltip: this }, true);
          }
        },
        getEvents: function() {
          var events = DivOverlay.prototype.getEvents.call(this);
          if (!this.options.permanent) {
            events.preclick = this.close;
          }
          return events;
        },
        _initLayout: function() {
          var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
          this._contentNode = this._container = create$1("div", className);
          this._container.setAttribute("role", "tooltip");
          this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {
        },
        _adjustPan: function() {
        },
        _setPosition: function(pos) {
          var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
          if (direction === "top") {
            subX = tooltipWidth / 2;
            subY = tooltipHeight;
          } else if (direction === "bottom") {
            subX = tooltipWidth / 2;
            subY = 0;
          } else if (direction === "center") {
            subX = tooltipWidth / 2;
            subY = tooltipHeight / 2;
          } else if (direction === "right") {
            subX = 0;
            subY = tooltipHeight / 2;
          } else if (direction === "left") {
            subX = tooltipWidth;
            subY = tooltipHeight / 2;
          } else if (tooltipPoint.x < centerPoint.x) {
            direction = "right";
            subX = 0;
            subY = tooltipHeight / 2;
          } else {
            direction = "left";
            subX = tooltipWidth + (offset.x + anchor.x) * 2;
            subY = tooltipHeight / 2;
          }
          pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
          removeClass(container, "leaflet-tooltip-right");
          removeClass(container, "leaflet-tooltip-left");
          removeClass(container, "leaflet-tooltip-top");
          removeClass(container, "leaflet-tooltip-bottom");
          addClass(container, "leaflet-tooltip-" + direction);
          setPosition(container, pos);
        },
        _updatePosition: function() {
          var pos = this._map.latLngToLayerPoint(this._latlng);
          this._setPosition(pos);
        },
        setOpacity: function(opacity) {
          this.options.opacity = opacity;
          if (this._container) {
            setOpacity(this._container, opacity);
          }
        },
        _animateZoom: function(e) {
          var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
          this._setPosition(pos);
        },
        _getAnchor: function() {
          return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
        }
      });
      var tooltip = function(options, source) {
        return new Tooltip(options, source);
      };
      Map2.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip2, latlng, options) {
          this._initOverlay(Tooltip, tooltip2, latlng, options).openOn(this);
          return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip2) {
          tooltip2.close();
          return this;
        }
      });
      Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
          if (this._tooltip && this.isTooltipOpen()) {
            this.unbindTooltip();
          }
          this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
          this._initTooltipInteractions();
          if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
            this.openTooltip();
          }
          return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
          if (this._tooltip) {
            this._initTooltipInteractions(true);
            this.closeTooltip();
            this._tooltip = null;
          }
          return this;
        },
        _initTooltipInteractions: function(remove2) {
          if (!remove2 && this._tooltipHandlersAdded) {
            return;
          }
          var onOff = remove2 ? "off" : "on", events = {
            remove: this.closeTooltip,
            move: this._moveTooltip
          };
          if (!this._tooltip.options.permanent) {
            events.mouseover = this._openTooltip;
            events.mouseout = this.closeTooltip;
            events.click = this._openTooltip;
            if (this._map) {
              this._addFocusListeners();
            } else {
              events.add = this._addFocusListeners;
            }
          } else {
            events.add = this._openTooltip;
          }
          if (this._tooltip.options.sticky) {
            events.mousemove = this._moveTooltip;
          }
          this[onOff](events);
          this._tooltipHandlersAdded = !remove2;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
          if (this._tooltip) {
            if (!(this instanceof FeatureGroup)) {
              this._tooltip._source = this;
            }
            if (this._tooltip._prepareOpen(latlng)) {
              this._tooltip.openOn(this._map);
              if (this.getElement) {
                this._setAriaDescribedByOnLayer(this);
              } else if (this.eachLayer) {
                this.eachLayer(this._setAriaDescribedByOnLayer, this);
              }
            }
          }
          return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
          if (this._tooltip) {
            return this._tooltip.close();
          }
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
          if (this._tooltip) {
            this._tooltip.toggle(this);
          }
          return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
          return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
          if (this._tooltip) {
            this._tooltip.setContent(content);
          }
          return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
          return this._tooltip;
        },
        _addFocusListeners: function() {
          if (this.getElement) {
            this._addFocusListenersOnLayer(this);
          } else if (this.eachLayer) {
            this.eachLayer(this._addFocusListenersOnLayer, this);
          }
        },
        _addFocusListenersOnLayer: function(layer) {
          var el = typeof layer.getElement === "function" && layer.getElement();
          if (el) {
            on(el, "focus", function() {
              this._tooltip._source = layer;
              this.openTooltip();
            }, this);
            on(el, "blur", this.closeTooltip, this);
          }
        },
        _setAriaDescribedByOnLayer: function(layer) {
          var el = typeof layer.getElement === "function" && layer.getElement();
          if (el) {
            el.setAttribute("aria-describedby", this._tooltip._container.id);
          }
        },
        _openTooltip: function(e) {
          if (!this._tooltip || !this._map) {
            return;
          }
          if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
            this._openOnceFlag = true;
            var that = this;
            this._map.once("moveend", function() {
              that._openOnceFlag = false;
              that._openTooltip(e);
            });
            return;
          }
          this._tooltip._source = e.layer || e.target;
          this.openTooltip(this._tooltip.options.sticky ? e.latlng : void 0);
        },
        _moveTooltip: function(e) {
          var latlng = e.latlng, containerPoint, layerPoint;
          if (this._tooltip.options.sticky && e.originalEvent) {
            containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
            layerPoint = this._map.containerPointToLayerPoint(containerPoint);
            latlng = this._map.layerPointToLatLng(layerPoint);
          }
          this._tooltip.setLatLng(latlng);
        }
      });
      var DivIcon = Icon.extend({
        options: {
          // @section
          // @aka DivIcon options
          iconSize: [12, 12],
          // also can be set through CSS
          // iconAnchor: (Point),
          // popupAnchor: (Point),
          // @option html: String|HTMLElement = ''
          // Custom HTML code to put inside the div element, empty by default. Alternatively,
          // an instance of `HTMLElement`.
          html: false,
          // @option bgPos: Point = [0, 0]
          // Optional relative position of the background, in pixels
          bgPos: null,
          className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
          var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
          if (options.html instanceof Element) {
            empty(div);
            div.appendChild(options.html);
          } else {
            div.innerHTML = options.html !== false ? options.html : "";
          }
          if (options.bgPos) {
            var bgPos = toPoint(options.bgPos);
            div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
          }
          this._setIconStyles(div, "icon");
          return div;
        },
        createShadow: function() {
          return null;
        }
      });
      function divIcon(options) {
        return new DivIcon(options);
      }
      Icon.Default = IconDefault;
      var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
          // @option tileSize: Number|Point = 256
          // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
          tileSize: 256,
          // @option opacity: Number = 1.0
          // Opacity of the tiles. Can be used in the `createTile()` function.
          opacity: 1,
          // @option updateWhenIdle: Boolean = (depends)
          // Load new tiles only when panning ends.
          // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
          // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
          // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
          updateWhenIdle: Browser.mobile,
          // @option updateWhenZooming: Boolean = true
          // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
          updateWhenZooming: true,
          // @option updateInterval: Number = 200
          // Tiles will not update more than once every `updateInterval` milliseconds when panning.
          updateInterval: 200,
          // @option zIndex: Number = 1
          // The explicit zIndex of the tile layer.
          zIndex: 1,
          // @option bounds: LatLngBounds = undefined
          // If set, tiles will only be loaded inside the set `LatLngBounds`.
          bounds: null,
          // @option minZoom: Number = 0
          // The minimum zoom level down to which this layer will be displayed (inclusive).
          minZoom: 0,
          // @option maxZoom: Number = undefined
          // The maximum zoom level up to which this layer will be displayed (inclusive).
          maxZoom: void 0,
          // @option maxNativeZoom: Number = undefined
          // Maximum zoom number the tile source has available. If it is specified,
          // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
          // from `maxNativeZoom` level and auto-scaled.
          maxNativeZoom: void 0,
          // @option minNativeZoom: Number = undefined
          // Minimum zoom number the tile source has available. If it is specified,
          // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
          // from `minNativeZoom` level and auto-scaled.
          minNativeZoom: void 0,
          // @option noWrap: Boolean = false
          // Whether the layer is wrapped around the antimeridian. If `true`, the
          // GridLayer will only be displayed once at low zoom levels. Has no
          // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
          // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
          // tiles outside the CRS limits.
          noWrap: false,
          // @option pane: String = 'tilePane'
          // `Map pane` where the grid layer will be added.
          pane: "tilePane",
          // @option className: String = ''
          // A custom class name to assign to the tile layer. Empty by default.
          className: "",
          // @option keepBuffer: Number = 2
          // When panning the map, keep this many rows and columns of tiles before unloading them.
          keepBuffer: 2
        },
        initialize: function(options) {
          setOptions(this, options);
        },
        onAdd: function() {
          this._initContainer();
          this._levels = {};
          this._tiles = {};
          this._resetView();
        },
        beforeAdd: function(map) {
          map._addZoomLimit(this);
        },
        onRemove: function(map) {
          this._removeAllTiles();
          remove(this._container);
          map._removeZoomLimit(this);
          this._container = null;
          this._tileZoom = void 0;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
          if (this._map) {
            toFront(this._container);
            this._setAutoZIndex(Math.max);
          }
          return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
          if (this._map) {
            toBack(this._container);
            this._setAutoZIndex(Math.min);
          }
          return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
          return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
          this.options.opacity = opacity;
          this._updateOpacity();
          return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
          this.options.zIndex = zIndex;
          this._updateZIndex();
          return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
          return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
          if (this._map) {
            this._removeAllTiles();
            var tileZoom = this._clampZoom(this._map.getZoom());
            if (tileZoom !== this._tileZoom) {
              this._tileZoom = tileZoom;
              this._updateLevels();
            }
            this._update();
          }
          return this;
        },
        getEvents: function() {
          var events = {
            viewprereset: this._invalidateAll,
            viewreset: this._resetView,
            zoom: this._resetView,
            moveend: this._onMoveEnd
          };
          if (!this.options.updateWhenIdle) {
            if (!this._onMove) {
              this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
            }
            events.move = this._onMove;
          }
          if (this._zoomAnimated) {
            events.zoomanim = this._animateZoom;
          }
          return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
          return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
          var s = this.options.tileSize;
          return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
          if (this._container && this.options.zIndex !== void 0 && this.options.zIndex !== null) {
            this._container.style.zIndex = this.options.zIndex;
          }
        },
        _setAutoZIndex: function(compare) {
          var layers2 = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity);
          for (var i = 0, len = layers2.length, zIndex; i < len; i++) {
            zIndex = layers2[i].style.zIndex;
            if (layers2[i] !== this._container && zIndex) {
              edgeZIndex = compare(edgeZIndex, +zIndex);
            }
          }
          if (isFinite(edgeZIndex)) {
            this.options.zIndex = edgeZIndex + compare(-1, 1);
            this._updateZIndex();
          }
        },
        _updateOpacity: function() {
          if (!this._map) {
            return;
          }
          if (Browser.ielt9) {
            return;
          }
          setOpacity(this._container, this.options.opacity);
          var now = +/* @__PURE__ */ new Date(), nextFrame = false, willPrune = false;
          for (var key in this._tiles) {
            var tile = this._tiles[key];
            if (!tile.current || !tile.loaded) {
              continue;
            }
            var fade = Math.min(1, (now - tile.loaded) / 200);
            setOpacity(tile.el, fade);
            if (fade < 1) {
              nextFrame = true;
            } else {
              if (tile.active) {
                willPrune = true;
              } else {
                this._onOpaqueTile(tile);
              }
              tile.active = true;
            }
          }
          if (willPrune && !this._noPrune) {
            this._pruneTiles();
          }
          if (nextFrame) {
            cancelAnimFrame(this._fadeFrame);
            this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
          }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
          if (this._container) {
            return;
          }
          this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
          this._updateZIndex();
          if (this.options.opacity < 1) {
            this._updateOpacity();
          }
          this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
          var zoom2 = this._tileZoom, maxZoom = this.options.maxZoom;
          if (zoom2 === void 0) {
            return void 0;
          }
          for (var z in this._levels) {
            z = Number(z);
            if (this._levels[z].el.children.length || z === zoom2) {
              this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom2 - z);
              this._onUpdateLevel(z);
            } else {
              remove(this._levels[z].el);
              this._removeTilesAtZoom(z);
              this._onRemoveLevel(z);
              delete this._levels[z];
            }
          }
          var level = this._levels[zoom2], map = this._map;
          if (!level) {
            level = this._levels[zoom2] = {};
            level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
            level.el.style.zIndex = maxZoom;
            level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom2).round();
            level.zoom = zoom2;
            this._setZoomTransform(level, map.getCenter(), map.getZoom());
            falseFn(level.el.offsetWidth);
            this._onCreateLevel(level);
          }
          this._level = level;
          return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
          if (!this._map) {
            return;
          }
          var key, tile;
          var zoom2 = this._map.getZoom();
          if (zoom2 > this.options.maxZoom || zoom2 < this.options.minZoom) {
            this._removeAllTiles();
            return;
          }
          for (key in this._tiles) {
            tile = this._tiles[key];
            tile.retain = tile.current;
          }
          for (key in this._tiles) {
            tile = this._tiles[key];
            if (tile.current && !tile.active) {
              var coords = tile.coords;
              if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
                this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
              }
            }
          }
          for (key in this._tiles) {
            if (!this._tiles[key].retain) {
              this._removeTile(key);
            }
          }
        },
        _removeTilesAtZoom: function(zoom2) {
          for (var key in this._tiles) {
            if (this._tiles[key].coords.z !== zoom2) {
              continue;
            }
            this._removeTile(key);
          }
        },
        _removeAllTiles: function() {
          for (var key in this._tiles) {
            this._removeTile(key);
          }
        },
        _invalidateAll: function() {
          for (var z in this._levels) {
            remove(this._levels[z].el);
            this._onRemoveLevel(Number(z));
            delete this._levels[z];
          }
          this._removeAllTiles();
          this._tileZoom = void 0;
        },
        _retainParent: function(x, y, z, minZoom) {
          var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
          coords2.z = +z2;
          var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
          if (tile && tile.active) {
            tile.retain = true;
            return true;
          } else if (tile && tile.loaded) {
            tile.retain = true;
          }
          if (z2 > minZoom) {
            return this._retainParent(x2, y2, z2, minZoom);
          }
          return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
          for (var i = 2 * x; i < 2 * x + 2; i++) {
            for (var j = 2 * y; j < 2 * y + 2; j++) {
              var coords = new Point(i, j);
              coords.z = z + 1;
              var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
              if (tile && tile.active) {
                tile.retain = true;
                continue;
              } else if (tile && tile.loaded) {
                tile.retain = true;
              }
              if (z + 1 < maxZoom) {
                this._retainChildren(i, j, z + 1, maxZoom);
              }
            }
          }
        },
        _resetView: function(e) {
          var animating = e && (e.pinch || e.flyTo);
          this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
          this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom2) {
          var options = this.options;
          if (void 0 !== options.minNativeZoom && zoom2 < options.minNativeZoom) {
            return options.minNativeZoom;
          }
          if (void 0 !== options.maxNativeZoom && options.maxNativeZoom < zoom2) {
            return options.maxNativeZoom;
          }
          return zoom2;
        },
        _setView: function(center, zoom2, noPrune, noUpdate) {
          var tileZoom = Math.round(zoom2);
          if (this.options.maxZoom !== void 0 && tileZoom > this.options.maxZoom || this.options.minZoom !== void 0 && tileZoom < this.options.minZoom) {
            tileZoom = void 0;
          } else {
            tileZoom = this._clampZoom(tileZoom);
          }
          var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
          if (!noUpdate || tileZoomChanged) {
            this._tileZoom = tileZoom;
            if (this._abortLoading) {
              this._abortLoading();
            }
            this._updateLevels();
            this._resetGrid();
            if (tileZoom !== void 0) {
              this._update(center);
            }
            if (!noPrune) {
              this._pruneTiles();
            }
            this._noPrune = !!noPrune;
          }
          this._setZoomTransforms(center, zoom2);
        },
        _setZoomTransforms: function(center, zoom2) {
          for (var i in this._levels) {
            this._setZoomTransform(this._levels[i], center, zoom2);
          }
        },
        _setZoomTransform: function(level, center, zoom2) {
          var scale2 = this._map.getZoomScale(zoom2, level.zoom), translate = level.origin.multiplyBy(scale2).subtract(this._map._getNewPixelOrigin(center, zoom2)).round();
          if (Browser.any3d) {
            setTransform(level.el, translate, scale2);
          } else {
            setPosition(level.el, translate);
          }
        },
        _resetGrid: function() {
          var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
          var bounds = this._map.getPixelWorldBounds(this._tileZoom);
          if (bounds) {
            this._globalTileRange = this._pxBoundsToTileRange(bounds);
          }
          this._wrapX = crs.wrapLng && !this.options.noWrap && [
            Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
            Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
          ];
          this._wrapY = crs.wrapLat && !this.options.noWrap && [
            Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
            Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
          ];
        },
        _onMoveEnd: function() {
          if (!this._map || this._map._animatingZoom) {
            return;
          }
          this._update();
        },
        _getTiledPixelBounds: function(center) {
          var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale2 = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale2 * 2);
          return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
          var map = this._map;
          if (!map) {
            return;
          }
          var zoom2 = this._clampZoom(map.getZoom());
          if (center === void 0) {
            center = map.getCenter();
          }
          if (this._tileZoom === void 0) {
            return;
          }
          var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(
            tileRange.getBottomLeft().subtract([margin, -margin]),
            tileRange.getTopRight().add([margin, -margin])
          );
          if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) {
            throw new Error("Attempted to load an infinite number of tiles");
          }
          for (var key in this._tiles) {
            var c = this._tiles[key].coords;
            if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
              this._tiles[key].current = false;
            }
          }
          if (Math.abs(zoom2 - this._tileZoom) > 1) {
            this._setView(center, zoom2);
            return;
          }
          for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
            for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
              var coords = new Point(i, j);
              coords.z = this._tileZoom;
              if (!this._isValidTile(coords)) {
                continue;
              }
              var tile = this._tiles[this._tileCoordsToKey(coords)];
              if (tile) {
                tile.current = true;
              } else {
                queue.push(coords);
              }
            }
          }
          queue.sort(function(a, b) {
            return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
          });
          if (queue.length !== 0) {
            if (!this._loading) {
              this._loading = true;
              this.fire("loading");
            }
            var fragment = document.createDocumentFragment();
            for (i = 0; i < queue.length; i++) {
              this._addTile(queue[i], fragment);
            }
            this._level.el.appendChild(fragment);
          }
        },
        _isValidTile: function(coords) {
          var crs = this._map.options.crs;
          if (!crs.infinite) {
            var bounds = this._globalTileRange;
            if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) {
              return false;
            }
          }
          if (!this.options.bounds) {
            return true;
          }
          var tileBounds = this._tileCoordsToBounds(coords);
          return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
          return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
          var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
          return [nw, se];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
          var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
          if (!this.options.noWrap) {
            bounds = this._map.wrapLatLngBounds(bounds);
          }
          return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
          return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
          var k = key.split(":"), coords = new Point(+k[0], +k[1]);
          coords.z = +k[2];
          return coords;
        },
        _removeTile: function(key) {
          var tile = this._tiles[key];
          if (!tile) {
            return;
          }
          remove(tile.el);
          delete this._tiles[key];
          this.fire("tileunload", {
            tile: tile.el,
            coords: this._keyToTileCoords(key)
          });
        },
        _initTile: function(tile) {
          addClass(tile, "leaflet-tile");
          var tileSize = this.getTileSize();
          tile.style.width = tileSize.x + "px";
          tile.style.height = tileSize.y + "px";
          tile.onselectstart = falseFn;
          tile.onmousemove = falseFn;
          if (Browser.ielt9 && this.options.opacity < 1) {
            setOpacity(tile, this.options.opacity);
          }
        },
        _addTile: function(coords, container) {
          var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
          var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
          this._initTile(tile);
          if (this.createTile.length < 2) {
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
          }
          setPosition(tile, tilePos);
          this._tiles[key] = {
            el: tile,
            coords,
            current: true
          };
          container.appendChild(tile);
          this.fire("tileloadstart", {
            tile,
            coords
          });
        },
        _tileReady: function(coords, err, tile) {
          if (err) {
            this.fire("tileerror", {
              error: err,
              tile,
              coords
            });
          }
          var key = this._tileCoordsToKey(coords);
          tile = this._tiles[key];
          if (!tile) {
            return;
          }
          tile.loaded = +/* @__PURE__ */ new Date();
          if (this._map._fadeAnimated) {
            setOpacity(tile.el, 0);
            cancelAnimFrame(this._fadeFrame);
            this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
          } else {
            tile.active = true;
            this._pruneTiles();
          }
          if (!err) {
            addClass(tile.el, "leaflet-tile-loaded");
            this.fire("tileload", {
              tile: tile.el,
              coords
            });
          }
          if (this._noTilesToLoad()) {
            this._loading = false;
            this.fire("load");
            if (Browser.ielt9 || !this._map._fadeAnimated) {
              requestAnimFrame(this._pruneTiles, this);
            } else {
              setTimeout(bind(this._pruneTiles, this), 250);
            }
          }
        },
        _getTilePos: function(coords) {
          return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
          var newCoords = new Point(
            this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x,
            this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y
          );
          newCoords.z = coords.z;
          return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
          var tileSize = this.getTileSize();
          return new Bounds(
            bounds.min.unscaleBy(tileSize).floor(),
            bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1])
          );
        },
        _noTilesToLoad: function() {
          for (var key in this._tiles) {
            if (!this._tiles[key].loaded) {
              return false;
            }
          }
          return true;
        }
      });
      function gridLayer(options) {
        return new GridLayer(options);
      }
      var TileLayer2 = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
          // @option minZoom: Number = 0
          // The minimum zoom level down to which this layer will be displayed (inclusive).
          minZoom: 0,
          // @option maxZoom: Number = 18
          // The maximum zoom level up to which this layer will be displayed (inclusive).
          maxZoom: 18,
          // @option subdomains: String|String[] = 'abc'
          // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
          subdomains: "abc",
          // @option errorTileUrl: String = ''
          // URL to the tile image to show in place of the tile that failed to load.
          errorTileUrl: "",
          // @option zoomOffset: Number = 0
          // The zoom number used in tile URLs will be offset with this value.
          zoomOffset: 0,
          // @option tms: Boolean = false
          // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
          tms: false,
          // @option zoomReverse: Boolean = false
          // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
          zoomReverse: false,
          // @option detectRetina: Boolean = false
          // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
          detectRetina: false,
          // @option crossOrigin: Boolean|String = false
          // Whether the crossOrigin attribute will be added to the tiles.
          // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
          // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
          crossOrigin: false,
          // @option referrerPolicy: Boolean|String = false
          // Whether the referrerPolicy attribute will be added to the tiles.
          // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
          // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
          // (e.g. to validate an API token).
          // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
          referrerPolicy: false
        },
        initialize: function(url, options) {
          this._url = url;
          options = setOptions(this, options);
          if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
            options.tileSize = Math.floor(options.tileSize / 2);
            if (!options.zoomReverse) {
              options.zoomOffset++;
              options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
            } else {
              options.zoomOffset--;
              options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
            }
            options.minZoom = Math.max(0, options.minZoom);
          } else if (!options.zoomReverse) {
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
          } else {
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
          }
          if (typeof options.subdomains === "string") {
            options.subdomains = options.subdomains.split("");
          }
          this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
          if (this._url === url && noRedraw === void 0) {
            noRedraw = true;
          }
          this._url = url;
          if (!noRedraw) {
            this.redraw();
          }
          return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
          var tile = document.createElement("img");
          on(tile, "load", bind(this._tileOnLoad, this, done, tile));
          on(tile, "error", bind(this._tileOnError, this, done, tile));
          if (this.options.crossOrigin || this.options.crossOrigin === "") {
            tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
          }
          if (typeof this.options.referrerPolicy === "string") {
            tile.referrerPolicy = this.options.referrerPolicy;
          }
          tile.alt = "";
          tile.src = this.getTileUrl(coords);
          return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
          var data = {
            r: Browser.retina ? "@2x" : "",
            s: this._getSubdomain(coords),
            x: coords.x,
            y: coords.y,
            z: this._getZoomForUrl()
          };
          if (this._map && !this._map.options.crs.infinite) {
            var invertedY = this._globalTileRange.max.y - coords.y;
            if (this.options.tms) {
              data["y"] = invertedY;
            }
            data["-y"] = invertedY;
          }
          return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
          if (Browser.ielt9) {
            setTimeout(bind(done, this, null, tile), 0);
          } else {
            done(null, tile);
          }
        },
        _tileOnError: function(done, tile, e) {
          var errorUrl = this.options.errorTileUrl;
          if (errorUrl && tile.getAttribute("src") !== errorUrl) {
            tile.src = errorUrl;
          }
          done(e, tile);
        },
        _onTileRemove: function(e) {
          e.tile.onload = null;
        },
        _getZoomForUrl: function() {
          var zoom2 = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
          if (zoomReverse) {
            zoom2 = maxZoom - zoom2;
          }
          return zoom2 + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
          var index2 = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
          return this.options.subdomains[index2];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
          var i, tile;
          for (i in this._tiles) {
            if (this._tiles[i].coords.z !== this._tileZoom) {
              tile = this._tiles[i].el;
              tile.onload = falseFn;
              tile.onerror = falseFn;
              if (!tile.complete) {
                tile.src = emptyImageUrl;
                var coords = this._tiles[i].coords;
                remove(tile);
                delete this._tiles[i];
                this.fire("tileabort", {
                  tile,
                  coords
                });
              }
            }
          }
        },
        _removeTile: function(key) {
          var tile = this._tiles[key];
          if (!tile) {
            return;
          }
          tile.el.setAttribute("src", emptyImageUrl);
          return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
          if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) {
            return;
          }
          return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
      });
      function tileLayer(url, options) {
        return new TileLayer2(url, options);
      }
      var TileLayerWMS = TileLayer2.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
          service: "WMS",
          request: "GetMap",
          // @option layers: String = ''
          // **(required)** Comma-separated list of WMS layers to show.
          layers: "",
          // @option styles: String = ''
          // Comma-separated list of WMS styles.
          styles: "",
          // @option format: String = 'image/jpeg'
          // WMS image format (use `'image/png'` for layers with transparency).
          format: "image/jpeg",
          // @option transparent: Boolean = false
          // If `true`, the WMS service will return images with transparency.
          transparent: false,
          // @option version: String = '1.1.1'
          // Version of the WMS service to use
          version: "1.1.1"
        },
        options: {
          // @option crs: CRS = null
          // Coordinate Reference System to use for the WMS requests, defaults to
          // map CRS. Don't change this if you're not sure what it means.
          crs: null,
          // @option uppercase: Boolean = false
          // If `true`, WMS request parameter keys will be uppercase.
          uppercase: false
        },
        initialize: function(url, options) {
          this._url = url;
          var wmsParams = extend({}, this.defaultWmsParams);
          for (var i in options) {
            if (!(i in this.options)) {
              wmsParams[i] = options[i];
            }
          }
          options = setOptions(this, options);
          var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
          var tileSize = this.getTileSize();
          wmsParams.width = tileSize.x * realRetina;
          wmsParams.height = tileSize.y * realRetina;
          this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
          this._crs = this.options.crs || map.options.crs;
          this._wmsVersion = parseFloat(this.wmsParams.version);
          var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
          this.wmsParams[projectionKey] = this._crs.code;
          TileLayer2.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
          var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [min.y, min.x, max.y, max.x] : [min.x, min.y, max.x, max.y]).join(","), url = TileLayer2.prototype.getTileUrl.call(this, coords);
          return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
          extend(this.wmsParams, params);
          if (!noRedraw) {
            this.redraw();
          }
          return this;
        }
      });
      function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
      }
      TileLayer2.WMS = TileLayerWMS;
      tileLayer.wms = tileLayerWMS;
      var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
          // @option padding: Number = 0.1
          // How much to extend the clip area around the map view (relative to its size)
          // e.g. 0.1 would be 10% of map view in each direction
          padding: 0.1
        },
        initialize: function(options) {
          setOptions(this, options);
          stamp(this);
          this._layers = this._layers || {};
        },
        onAdd: function() {
          if (!this._container) {
            this._initContainer();
            addClass(this._container, "leaflet-zoom-animated");
          }
          this.getPane().appendChild(this._container);
          this._update();
          this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
          this.off("update", this._updatePaths, this);
          this._destroyContainer();
        },
        getEvents: function() {
          var events = {
            viewreset: this._reset,
            zoom: this._onZoom,
            moveend: this._update,
            zoomend: this._onZoomEnd
          };
          if (this._zoomAnimated) {
            events.zoomanim = this._onAnimZoom;
          }
          return events;
        },
        _onAnimZoom: function(ev) {
          this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
          this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom2) {
          var scale2 = this._map.getZoomScale(zoom2, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom2), topLeftOffset = viewHalf.multiplyBy(-scale2).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom2));
          if (Browser.any3d) {
            setTransform(this._container, topLeftOffset, scale2);
          } else {
            setPosition(this._container, topLeftOffset);
          }
        },
        _reset: function() {
          this._update();
          this._updateTransform(this._center, this._zoom);
          for (var id in this._layers) {
            this._layers[id]._reset();
          }
        },
        _onZoomEnd: function() {
          for (var id in this._layers) {
            this._layers[id]._project();
          }
        },
        _updatePaths: function() {
          for (var id in this._layers) {
            this._layers[id]._update();
          }
        },
        _update: function() {
          var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
          this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
          this._center = this._map.getCenter();
          this._zoom = this._map.getZoom();
        }
      });
      var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
          // @option tolerance: Number = 0
          // How much to extend the click tolerance around a path/object on the map.
          tolerance: 0
        },
        getEvents: function() {
          var events = Renderer.prototype.getEvents.call(this);
          events.viewprereset = this._onViewPreReset;
          return events;
        },
        _onViewPreReset: function() {
          this._postponeUpdatePaths = true;
        },
        onAdd: function() {
          Renderer.prototype.onAdd.call(this);
          this._draw();
        },
        _initContainer: function() {
          var container = this._container = document.createElement("canvas");
          on(container, "mousemove", this._onMouseMove, this);
          on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
          on(container, "mouseout", this._handleMouseOut, this);
          container["_leaflet_disable_events"] = true;
          this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
          cancelAnimFrame(this._redrawRequest);
          delete this._ctx;
          remove(this._container);
          off(this._container);
          delete this._container;
        },
        _updatePaths: function() {
          if (this._postponeUpdatePaths) {
            return;
          }
          var layer;
          this._redrawBounds = null;
          for (var id in this._layers) {
            layer = this._layers[id];
            layer._update();
          }
          this._redraw();
        },
        _update: function() {
          if (this._map._animatingZoom && this._bounds) {
            return;
          }
          Renderer.prototype._update.call(this);
          var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
          setPosition(container, b.min);
          container.width = m * size.x;
          container.height = m * size.y;
          container.style.width = size.x + "px";
          container.style.height = size.y + "px";
          if (Browser.retina) {
            this._ctx.scale(2, 2);
          }
          this._ctx.translate(-b.min.x, -b.min.y);
          this.fire("update");
        },
        _reset: function() {
          Renderer.prototype._reset.call(this);
          if (this._postponeUpdatePaths) {
            this._postponeUpdatePaths = false;
            this._updatePaths();
          }
        },
        _initPath: function(layer) {
          this._updateDashArray(layer);
          this._layers[stamp(layer)] = layer;
          var order = layer._order = {
            layer,
            prev: this._drawLast,
            next: null
          };
          if (this._drawLast) {
            this._drawLast.next = order;
          }
          this._drawLast = order;
          this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
          this._requestRedraw(layer);
        },
        _removePath: function(layer) {
          var order = layer._order;
          var next = order.next;
          var prev = order.prev;
          if (next) {
            next.prev = prev;
          } else {
            this._drawLast = prev;
          }
          if (prev) {
            prev.next = next;
          } else {
            this._drawFirst = next;
          }
          delete layer._order;
          delete this._layers[stamp(layer)];
          this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
          this._extendRedrawBounds(layer);
          layer._project();
          layer._update();
          this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
          this._updateDashArray(layer);
          this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
          if (typeof layer.options.dashArray === "string") {
            var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
            for (i = 0; i < parts.length; i++) {
              dashValue = Number(parts[i]);
              if (isNaN(dashValue)) {
                return;
              }
              dashArray.push(dashValue);
            }
            layer.options._dashArray = dashArray;
          } else {
            layer.options._dashArray = layer.options.dashArray;
          }
        },
        _requestRedraw: function(layer) {
          if (!this._map) {
            return;
          }
          this._extendRedrawBounds(layer);
          this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
          if (layer._pxBounds) {
            var padding = (layer.options.weight || 0) + 1;
            this._redrawBounds = this._redrawBounds || new Bounds();
            this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
            this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
          }
        },
        _redraw: function() {
          this._redrawRequest = null;
          if (this._redrawBounds) {
            this._redrawBounds.min._floor();
            this._redrawBounds.max._ceil();
          }
          this._clear();
          this._draw();
          this._redrawBounds = null;
        },
        _clear: function() {
          var bounds = this._redrawBounds;
          if (bounds) {
            var size = bounds.getSize();
            this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
          } else {
            this._ctx.save();
            this._ctx.setTransform(1, 0, 0, 1, 0, 0);
            this._ctx.clearRect(0, 0, this._container.width, this._container.height);
            this._ctx.restore();
          }
        },
        _draw: function() {
          var layer, bounds = this._redrawBounds;
          this._ctx.save();
          if (bounds) {
            var size = bounds.getSize();
            this._ctx.beginPath();
            this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
            this._ctx.clip();
          }
          this._drawing = true;
          for (var order = this._drawFirst; order; order = order.next) {
            layer = order.layer;
            if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) {
              layer._updatePath();
            }
          }
          this._drawing = false;
          this._ctx.restore();
        },
        _updatePoly: function(layer, closed) {
          if (!this._drawing) {
            return;
          }
          var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
          if (!len) {
            return;
          }
          ctx.beginPath();
          for (i = 0; i < len; i++) {
            for (j = 0, len2 = parts[i].length; j < len2; j++) {
              p = parts[i][j];
              ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
            }
            if (closed) {
              ctx.closePath();
            }
          }
          this._fillStroke(ctx, layer);
        },
        _updateCircle: function(layer) {
          if (!this._drawing || layer._empty()) {
            return;
          }
          var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
          if (s !== 1) {
            ctx.save();
            ctx.scale(1, s);
          }
          ctx.beginPath();
          ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
          if (s !== 1) {
            ctx.restore();
          }
          this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
          var options = layer.options;
          if (options.fill) {
            ctx.globalAlpha = options.fillOpacity;
            ctx.fillStyle = options.fillColor || options.color;
            ctx.fill(options.fillRule || "evenodd");
          }
          if (options.stroke && options.weight !== 0) {
            if (ctx.setLineDash) {
              ctx.setLineDash(layer.options && layer.options._dashArray || []);
            }
            ctx.globalAlpha = options.opacity;
            ctx.lineWidth = options.weight;
            ctx.strokeStyle = options.color;
            ctx.lineCap = options.lineCap;
            ctx.lineJoin = options.lineJoin;
            ctx.stroke();
          }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
          var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
          for (var order = this._drawFirst; order; order = order.next) {
            layer = order.layer;
            if (layer.options.interactive && layer._containsPoint(point)) {
              if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) {
                clickedLayer = layer;
              }
            }
          }
          this._fireEvent(clickedLayer ? [clickedLayer] : false, e);
        },
        _onMouseMove: function(e) {
          if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) {
            return;
          }
          var point = this._map.mouseEventToLayerPoint(e);
          this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
          var layer = this._hoveredLayer;
          if (layer) {
            removeClass(this._container, "leaflet-interactive");
            this._fireEvent([layer], e, "mouseout");
            this._hoveredLayer = null;
            this._mouseHoverThrottled = false;
          }
        },
        _handleMouseHover: function(e, point) {
          if (this._mouseHoverThrottled) {
            return;
          }
          var layer, candidateHoveredLayer;
          for (var order = this._drawFirst; order; order = order.next) {
            layer = order.layer;
            if (layer.options.interactive && layer._containsPoint(point)) {
              candidateHoveredLayer = layer;
            }
          }
          if (candidateHoveredLayer !== this._hoveredLayer) {
            this._handleMouseOut(e);
            if (candidateHoveredLayer) {
              addClass(this._container, "leaflet-interactive");
              this._fireEvent([candidateHoveredLayer], e, "mouseover");
              this._hoveredLayer = candidateHoveredLayer;
            }
          }
          this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : false, e);
          this._mouseHoverThrottled = true;
          setTimeout(bind(function() {
            this._mouseHoverThrottled = false;
          }, this), 32);
        },
        _fireEvent: function(layers2, e, type) {
          this._map._fireDOMEvent(e, type || e.type, layers2);
        },
        _bringToFront: function(layer) {
          var order = layer._order;
          if (!order) {
            return;
          }
          var next = order.next;
          var prev = order.prev;
          if (next) {
            next.prev = prev;
          } else {
            return;
          }
          if (prev) {
            prev.next = next;
          } else if (next) {
            this._drawFirst = next;
          }
          order.prev = this._drawLast;
          this._drawLast.next = order;
          order.next = null;
          this._drawLast = order;
          this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
          var order = layer._order;
          if (!order) {
            return;
          }
          var next = order.next;
          var prev = order.prev;
          if (prev) {
            prev.next = next;
          } else {
            return;
          }
          if (next) {
            next.prev = prev;
          } else if (prev) {
            this._drawLast = prev;
          }
          order.prev = null;
          order.next = this._drawFirst;
          this._drawFirst.prev = order;
          this._drawFirst = order;
          this._requestRedraw(layer);
        }
      });
      function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
      }
      var vmlCreate = function() {
        try {
          document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
          return function(name) {
            return document.createElement("<lvml:" + name + ' class="lvml">');
          };
        } catch (e) {
        }
        return function(name) {
          return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
      }();
      var vmlMixin = {
        _initContainer: function() {
          this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
          if (this._map._animatingZoom) {
            return;
          }
          Renderer.prototype._update.call(this);
          this.fire("update");
        },
        _initPath: function(layer) {
          var container = layer._container = vmlCreate("shape");
          addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
          container.coordsize = "1 1";
          layer._path = vmlCreate("path");
          container.appendChild(layer._path);
          this._updateStyle(layer);
          this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
          var container = layer._container;
          this._container.appendChild(container);
          if (layer.options.interactive) {
            layer.addInteractiveTarget(container);
          }
        },
        _removePath: function(layer) {
          var container = layer._container;
          remove(container);
          layer.removeInteractiveTarget(container);
          delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
          var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
          container.stroked = !!options.stroke;
          container.filled = !!options.fill;
          if (options.stroke) {
            if (!stroke) {
              stroke = layer._stroke = vmlCreate("stroke");
            }
            container.appendChild(stroke);
            stroke.weight = options.weight + "px";
            stroke.color = options.color;
            stroke.opacity = options.opacity;
            if (options.dashArray) {
              stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
            } else {
              stroke.dashStyle = "";
            }
            stroke.endcap = options.lineCap.replace("butt", "flat");
            stroke.joinstyle = options.lineJoin;
          } else if (stroke) {
            container.removeChild(stroke);
            layer._stroke = null;
          }
          if (options.fill) {
            if (!fill) {
              fill = layer._fill = vmlCreate("fill");
            }
            container.appendChild(fill);
            fill.color = options.fillColor || options.color;
            fill.opacity = options.fillOpacity;
          } else if (fill) {
            container.removeChild(fill);
            layer._fill = null;
          }
        },
        _updateCircle: function(layer) {
          var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
          this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 65535 * 360);
        },
        _setPath: function(layer, path) {
          layer._path.v = path;
        },
        _bringToFront: function(layer) {
          toFront(layer._container);
        },
        _bringToBack: function(layer) {
          toBack(layer._container);
        }
      };
      var create = Browser.vml ? vmlCreate : svgCreate;
      var SVG = Renderer.extend({
        _initContainer: function() {
          this._container = create("svg");
          this._container.setAttribute("pointer-events", "none");
          this._rootGroup = create("g");
          this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
          remove(this._container);
          off(this._container);
          delete this._container;
          delete this._rootGroup;
          delete this._svgSize;
        },
        _update: function() {
          if (this._map._animatingZoom && this._bounds) {
            return;
          }
          Renderer.prototype._update.call(this);
          var b = this._bounds, size = b.getSize(), container = this._container;
          if (!this._svgSize || !this._svgSize.equals(size)) {
            this._svgSize = size;
            container.setAttribute("width", size.x);
            container.setAttribute("height", size.y);
          }
          setPosition(container, b.min);
          container.setAttribute("viewBox", [b.min.x, b.min.y, size.x, size.y].join(" "));
          this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
          var path = layer._path = create("path");
          if (layer.options.className) {
            addClass(path, layer.options.className);
          }
          if (layer.options.interactive) {
            addClass(path, "leaflet-interactive");
          }
          this._updateStyle(layer);
          this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
          if (!this._rootGroup) {
            this._initContainer();
          }
          this._rootGroup.appendChild(layer._path);
          layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
          remove(layer._path);
          layer.removeInteractiveTarget(layer._path);
          delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
          layer._project();
          layer._update();
        },
        _updateStyle: function(layer) {
          var path = layer._path, options = layer.options;
          if (!path) {
            return;
          }
          if (options.stroke) {
            path.setAttribute("stroke", options.color);
            path.setAttribute("stroke-opacity", options.opacity);
            path.setAttribute("stroke-width", options.weight);
            path.setAttribute("stroke-linecap", options.lineCap);
            path.setAttribute("stroke-linejoin", options.lineJoin);
            if (options.dashArray) {
              path.setAttribute("stroke-dasharray", options.dashArray);
            } else {
              path.removeAttribute("stroke-dasharray");
            }
            if (options.dashOffset) {
              path.setAttribute("stroke-dashoffset", options.dashOffset);
            } else {
              path.removeAttribute("stroke-dashoffset");
            }
          } else {
            path.setAttribute("stroke", "none");
          }
          if (options.fill) {
            path.setAttribute("fill", options.fillColor || options.color);
            path.setAttribute("fill-opacity", options.fillOpacity);
            path.setAttribute("fill-rule", options.fillRule || "evenodd");
          } else {
            path.setAttribute("fill", "none");
          }
        },
        _updatePoly: function(layer, closed) {
          this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
          var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
          var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
          this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
          layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
          toFront(layer._path);
        },
        _bringToBack: function(layer) {
          toBack(layer._path);
        }
      });
      if (Browser.vml) {
        SVG.include(vmlMixin);
      }
      function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
      }
      Map2.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
          var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
          if (!renderer) {
            renderer = this._renderer = this._createRenderer();
          }
          if (!this.hasLayer(renderer)) {
            this.addLayer(renderer);
          }
          return renderer;
        },
        _getPaneRenderer: function(name) {
          if (name === "overlayPane" || name === void 0) {
            return false;
          }
          var renderer = this._paneRenderers[name];
          if (renderer === void 0) {
            renderer = this._createRenderer({ pane: name });
            this._paneRenderers[name] = renderer;
          }
          return renderer;
        },
        _createRenderer: function(options) {
          return this.options.preferCanvas && canvas(options) || svg(options);
        }
      });
      var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
          Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
          return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
          latLngBounds = toLatLngBounds(latLngBounds);
          return [
            latLngBounds.getSouthWest(),
            latLngBounds.getNorthWest(),
            latLngBounds.getNorthEast(),
            latLngBounds.getSouthEast()
          ];
        }
      });
      function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
      }
      SVG.create = create;
      SVG.pointsToPath = pointsToPath;
      GeoJSON.geometryToLayer = geometryToLayer;
      GeoJSON.coordsToLatLng = coordsToLatLng;
      GeoJSON.coordsToLatLngs = coordsToLatLngs;
      GeoJSON.latLngToCoords = latLngToCoords;
      GeoJSON.latLngsToCoords = latLngsToCoords;
      GeoJSON.getFeature = getFeature;
      GeoJSON.asFeature = asFeature;
      Map2.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
      });
      var BoxZoom = Handler.extend({
        initialize: function(map) {
          this._map = map;
          this._container = map._container;
          this._pane = map._panes.overlayPane;
          this._resetStateTimeout = 0;
          map.on("unload", this._destroy, this);
        },
        addHooks: function() {
          on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
          off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
          return this._moved;
        },
        _destroy: function() {
          remove(this._pane);
          delete this._pane;
        },
        _resetState: function() {
          this._resetStateTimeout = 0;
          this._moved = false;
        },
        _clearDeferredResetState: function() {
          if (this._resetStateTimeout !== 0) {
            clearTimeout(this._resetStateTimeout);
            this._resetStateTimeout = 0;
          }
        },
        _onMouseDown: function(e) {
          if (!e.shiftKey || e.which !== 1 && e.button !== 1) {
            return false;
          }
          this._clearDeferredResetState();
          this._resetState();
          disableTextSelection();
          disableImageDrag();
          this._startPoint = this._map.mouseEventToContainerPoint(e);
          on(document, {
            contextmenu: stop,
            mousemove: this._onMouseMove,
            mouseup: this._onMouseUp,
            keydown: this._onKeyDown
          }, this);
        },
        _onMouseMove: function(e) {
          if (!this._moved) {
            this._moved = true;
            this._box = create$1("div", "leaflet-zoom-box", this._container);
            addClass(this._container, "leaflet-crosshair");
            this._map.fire("boxzoomstart");
          }
          this._point = this._map.mouseEventToContainerPoint(e);
          var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
          setPosition(this._box, bounds.min);
          this._box.style.width = size.x + "px";
          this._box.style.height = size.y + "px";
        },
        _finish: function() {
          if (this._moved) {
            remove(this._box);
            removeClass(this._container, "leaflet-crosshair");
          }
          enableTextSelection();
          enableImageDrag();
          off(document, {
            contextmenu: stop,
            mousemove: this._onMouseMove,
            mouseup: this._onMouseUp,
            keydown: this._onKeyDown
          }, this);
        },
        _onMouseUp: function(e) {
          if (e.which !== 1 && e.button !== 1) {
            return;
          }
          this._finish();
          if (!this._moved) {
            return;
          }
          this._clearDeferredResetState();
          this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
          var bounds = new LatLngBounds(
            this._map.containerPointToLatLng(this._startPoint),
            this._map.containerPointToLatLng(this._point)
          );
          this._map.fitBounds(bounds).fire("boxzoomend", { boxZoomBounds: bounds });
        },
        _onKeyDown: function(e) {
          if (e.keyCode === 27) {
            this._finish();
            this._clearDeferredResetState();
            this._resetState();
          }
        }
      });
      Map2.addInitHook("addHandler", "boxZoom", BoxZoom);
      Map2.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
      });
      var DoubleClickZoom = Handler.extend({
        addHooks: function() {
          this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
          this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
          var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom2 = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
          if (map.options.doubleClickZoom === "center") {
            map.setZoom(zoom2);
          } else {
            map.setZoomAround(e.containerPoint, zoom2);
          }
        }
      });
      Map2.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
      Map2.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // px/s^2
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // px/s
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0
      });
      var Drag = Handler.extend({
        addHooks: function() {
          if (!this._draggable) {
            var map = this._map;
            this._draggable = new Draggable(map._mapPane, map._container);
            this._draggable.on({
              dragstart: this._onDragStart,
              drag: this._onDrag,
              dragend: this._onDragEnd
            }, this);
            this._draggable.on("predrag", this._onPreDragLimit, this);
            if (map.options.worldCopyJump) {
              this._draggable.on("predrag", this._onPreDragWrap, this);
              map.on("zoomend", this._onZoomEnd, this);
              map.whenReady(this._onZoomEnd, this);
            }
          }
          addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
          this._draggable.enable();
          this._positions = [];
          this._times = [];
        },
        removeHooks: function() {
          removeClass(this._map._container, "leaflet-grab");
          removeClass(this._map._container, "leaflet-touch-drag");
          this._draggable.disable();
        },
        moved: function() {
          return this._draggable && this._draggable._moved;
        },
        moving: function() {
          return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
          var map = this._map;
          map._stop();
          if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
            var bounds = toLatLngBounds(this._map.options.maxBounds);
            this._offsetLimit = toBounds(
              this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
              this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize())
            );
            this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity));
          } else {
            this._offsetLimit = null;
          }
          map.fire("movestart").fire("dragstart");
          if (map.options.inertia) {
            this._positions = [];
            this._times = [];
          }
        },
        _onDrag: function(e) {
          if (this._map.options.inertia) {
            var time = this._lastTime = +/* @__PURE__ */ new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
            this._positions.push(pos);
            this._times.push(time);
            this._prunePositions(time);
          }
          this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
          while (this._positions.length > 1 && time - this._times[0] > 50) {
            this._positions.shift();
            this._times.shift();
          }
        },
        _onZoomEnd: function() {
          var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
          this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
          this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
          return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
          if (!this._viscosity || !this._offsetLimit) {
            return;
          }
          var offset = this._draggable._newPos.subtract(this._draggable._startPos);
          var limit = this._offsetLimit;
          if (offset.x < limit.min.x) {
            offset.x = this._viscousLimit(offset.x, limit.min.x);
          }
          if (offset.y < limit.min.y) {
            offset.y = this._viscousLimit(offset.y, limit.min.y);
          }
          if (offset.x > limit.max.x) {
            offset.x = this._viscousLimit(offset.x, limit.max.x);
          }
          if (offset.y > limit.max.y) {
            offset.y = this._viscousLimit(offset.y, limit.max.y);
          }
          this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
          var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
          this._draggable._absPos = this._draggable._newPos.clone();
          this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
          var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
          map.fire("dragend", e);
          if (noInertia) {
            map.fire("moveend");
          } else {
            this._prunePositions(+/* @__PURE__ */ new Date());
            var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1e3, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([0, 0]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
            if (!offset.x && !offset.y) {
              map.fire("moveend");
            } else {
              offset = map._limitOffset(offset, map.options.maxBounds);
              requestAnimFrame(function() {
                map.panBy(offset, {
                  duration: decelerationDuration,
                  easeLinearity: ease,
                  noMoveStart: true,
                  animate: true
                });
              });
            }
          }
        }
      });
      Map2.addInitHook("addHandler", "dragging", Drag);
      Map2.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
      });
      var Keyboard = Handler.extend({
        keyCodes: {
          left: [37],
          right: [39],
          down: [40],
          up: [38],
          zoomIn: [187, 107, 61, 171],
          zoomOut: [189, 109, 54, 173]
        },
        initialize: function(map) {
          this._map = map;
          this._setPanDelta(map.options.keyboardPanDelta);
          this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
          var container = this._map._container;
          if (container.tabIndex <= 0) {
            container.tabIndex = "0";
          }
          on(container, {
            focus: this._onFocus,
            blur: this._onBlur,
            mousedown: this._onMouseDown
          }, this);
          this._map.on({
            focus: this._addHooks,
            blur: this._removeHooks
          }, this);
        },
        removeHooks: function() {
          this._removeHooks();
          off(this._map._container, {
            focus: this._onFocus,
            blur: this._onBlur,
            mousedown: this._onMouseDown
          }, this);
          this._map.off({
            focus: this._addHooks,
            blur: this._removeHooks
          }, this);
        },
        _onMouseDown: function() {
          if (this._focused) {
            return;
          }
          var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
          this._map._container.focus();
          window.scrollTo(left, top);
        },
        _onFocus: function() {
          this._focused = true;
          this._map.fire("focus");
        },
        _onBlur: function() {
          this._focused = false;
          this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
          var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
          for (i = 0, len = codes.left.length; i < len; i++) {
            keys[codes.left[i]] = [-1 * panDelta, 0];
          }
          for (i = 0, len = codes.right.length; i < len; i++) {
            keys[codes.right[i]] = [panDelta, 0];
          }
          for (i = 0, len = codes.down.length; i < len; i++) {
            keys[codes.down[i]] = [0, panDelta];
          }
          for (i = 0, len = codes.up.length; i < len; i++) {
            keys[codes.up[i]] = [0, -1 * panDelta];
          }
        },
        _setZoomDelta: function(zoomDelta) {
          var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
          for (i = 0, len = codes.zoomIn.length; i < len; i++) {
            keys[codes.zoomIn[i]] = zoomDelta;
          }
          for (i = 0, len = codes.zoomOut.length; i < len; i++) {
            keys[codes.zoomOut[i]] = -zoomDelta;
          }
        },
        _addHooks: function() {
          on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
          off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
          if (e.altKey || e.ctrlKey || e.metaKey) {
            return;
          }
          var key = e.keyCode, map = this._map, offset;
          if (key in this._panKeys) {
            if (!map._panAnim || !map._panAnim._inProgress) {
              offset = this._panKeys[key];
              if (e.shiftKey) {
                offset = toPoint(offset).multiplyBy(3);
              }
              if (map.options.maxBounds) {
                offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
              }
              if (map.options.worldCopyJump) {
                var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                map.panTo(newLatLng);
              } else {
                map.panBy(offset);
              }
            }
          } else if (key in this._zoomKeys) {
            map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
          } else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) {
            map.closePopup();
          } else {
            return;
          }
          stop(e);
        }
      });
      Map2.addInitHook("addHandler", "keyboard", Keyboard);
      Map2.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
      });
      var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
          on(this._map._container, "wheel", this._onWheelScroll, this);
          this._delta = 0;
        },
        removeHooks: function() {
          off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
          var delta = getWheelDelta(e);
          var debounce = this._map.options.wheelDebounceTime;
          this._delta += delta;
          this._lastMousePos = this._map.mouseEventToContainerPoint(e);
          if (!this._startTime) {
            this._startTime = +/* @__PURE__ */ new Date();
          }
          var left = Math.max(debounce - (+/* @__PURE__ */ new Date() - this._startTime), 0);
          clearTimeout(this._timer);
          this._timer = setTimeout(bind(this._performZoom, this), left);
          stop(e);
        },
        _performZoom: function() {
          var map = this._map, zoom2 = map.getZoom(), snap = this._map.options.zoomSnap || 0;
          map._stop();
          var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom2 + (this._delta > 0 ? d4 : -d4)) - zoom2;
          this._delta = 0;
          this._startTime = null;
          if (!delta) {
            return;
          }
          if (map.options.scrollWheelZoom === "center") {
            map.setZoom(zoom2 + delta);
          } else {
            map.setZoomAround(this._lastMousePos, zoom2 + delta);
          }
        }
      });
      Map2.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
      var tapHoldDelay = 600;
      Map2.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
      });
      var TapHold = Handler.extend({
        addHooks: function() {
          on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
          off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
          clearTimeout(this._holdTimeout);
          if (e.touches.length !== 1) {
            return;
          }
          var first = e.touches[0];
          this._startPos = this._newPos = new Point(first.clientX, first.clientY);
          this._holdTimeout = setTimeout(bind(function() {
            this._cancel();
            if (!this._isTapValid()) {
              return;
            }
            on(document, "touchend", preventDefault);
            on(document, "touchend touchcancel", this._cancelClickPrevent);
            this._simulateEvent("contextmenu", first);
          }, this), tapHoldDelay);
          on(document, "touchend touchcancel contextmenu", this._cancel, this);
          on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
          off(document, "touchend", preventDefault);
          off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
          clearTimeout(this._holdTimeout);
          off(document, "touchend touchcancel contextmenu", this._cancel, this);
          off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
          var first = e.touches[0];
          this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
          return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
          var simulatedEvent = new MouseEvent(type, {
            bubbles: true,
            cancelable: true,
            view: window,
            // detail: 1,
            screenX: e.screenX,
            screenY: e.screenY,
            clientX: e.clientX,
            clientY: e.clientY
            // button: 2,
            // buttons: 2
          });
          simulatedEvent._simulated = true;
          e.target.dispatchEvent(simulatedEvent);
        }
      });
      Map2.addInitHook("addHandler", "tapHold", TapHold);
      Map2.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
      });
      var TouchZoom = Handler.extend({
        addHooks: function() {
          addClass(this._map._container, "leaflet-touch-zoom");
          on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
          removeClass(this._map._container, "leaflet-touch-zoom");
          off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
          var map = this._map;
          if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) {
            return;
          }
          var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
          this._centerPoint = map.getSize()._divideBy(2);
          this._startLatLng = map.containerPointToLatLng(this._centerPoint);
          if (map.options.touchZoom !== "center") {
            this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
          }
          this._startDist = p1.distanceTo(p2);
          this._startZoom = map.getZoom();
          this._moved = false;
          this._zooming = true;
          map._stop();
          on(document, "touchmove", this._onTouchMove, this);
          on(document, "touchend touchcancel", this._onTouchEnd, this);
          preventDefault(e);
        },
        _onTouchMove: function(e) {
          if (!e.touches || e.touches.length !== 2 || !this._zooming) {
            return;
          }
          var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale2 = p1.distanceTo(p2) / this._startDist;
          this._zoom = map.getScaleZoom(scale2, this._startZoom);
          if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale2 < 1 || this._zoom > map.getMaxZoom() && scale2 > 1)) {
            this._zoom = map._limitZoom(this._zoom);
          }
          if (map.options.touchZoom === "center") {
            this._center = this._startLatLng;
            if (scale2 === 1) {
              return;
            }
          } else {
            var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
            if (scale2 === 1 && delta.x === 0 && delta.y === 0) {
              return;
            }
            this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
          }
          if (!this._moved) {
            map._moveStart(true, false);
            this._moved = true;
          }
          cancelAnimFrame(this._animRequest);
          var moveFn = bind(map._move, map, this._center, this._zoom, { pinch: true, round: false }, void 0);
          this._animRequest = requestAnimFrame(moveFn, this, true);
          preventDefault(e);
        },
        _onTouchEnd: function() {
          if (!this._moved || !this._zooming) {
            this._zooming = false;
            return;
          }
          this._zooming = false;
          cancelAnimFrame(this._animRequest);
          off(document, "touchmove", this._onTouchMove, this);
          off(document, "touchend touchcancel", this._onTouchEnd, this);
          if (this._map.options.zoomAnimation) {
            this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
          } else {
            this._map._resetView(this._center, this._map._limitZoom(this._zoom));
          }
        }
      });
      Map2.addInitHook("addHandler", "touchZoom", TouchZoom);
      Map2.BoxZoom = BoxZoom;
      Map2.DoubleClickZoom = DoubleClickZoom;
      Map2.Drag = Drag;
      Map2.Keyboard = Keyboard;
      Map2.ScrollWheelZoom = ScrollWheelZoom;
      Map2.TapHold = TapHold;
      Map2.TouchZoom = TouchZoom;
      exports2.Bounds = Bounds;
      exports2.Browser = Browser;
      exports2.CRS = CRS;
      exports2.Canvas = Canvas;
      exports2.Circle = Circle;
      exports2.CircleMarker = CircleMarker;
      exports2.Class = Class;
      exports2.Control = Control;
      exports2.DivIcon = DivIcon;
      exports2.DivOverlay = DivOverlay;
      exports2.DomEvent = DomEvent;
      exports2.DomUtil = DomUtil;
      exports2.Draggable = Draggable;
      exports2.Evented = Evented;
      exports2.FeatureGroup = FeatureGroup;
      exports2.GeoJSON = GeoJSON;
      exports2.GridLayer = GridLayer;
      exports2.Handler = Handler;
      exports2.Icon = Icon;
      exports2.ImageOverlay = ImageOverlay;
      exports2.LatLng = LatLng;
      exports2.LatLngBounds = LatLngBounds;
      exports2.Layer = Layer;
      exports2.LayerGroup = LayerGroup;
      exports2.LineUtil = LineUtil;
      exports2.Map = Map2;
      exports2.Marker = Marker2;
      exports2.Mixin = Mixin;
      exports2.Path = Path;
      exports2.Point = Point;
      exports2.PolyUtil = PolyUtil;
      exports2.Polygon = Polygon;
      exports2.Polyline = Polyline;
      exports2.Popup = Popup;
      exports2.PosAnimation = PosAnimation;
      exports2.Projection = index;
      exports2.Rectangle = Rectangle;
      exports2.Renderer = Renderer;
      exports2.SVG = SVG;
      exports2.SVGOverlay = SVGOverlay;
      exports2.TileLayer = TileLayer2;
      exports2.Tooltip = Tooltip;
      exports2.Transformation = Transformation;
      exports2.Util = Util;
      exports2.VideoOverlay = VideoOverlay;
      exports2.bind = bind;
      exports2.bounds = toBounds;
      exports2.canvas = canvas;
      exports2.circle = circle;
      exports2.circleMarker = circleMarker;
      exports2.control = control;
      exports2.divIcon = divIcon;
      exports2.extend = extend;
      exports2.featureGroup = featureGroup;
      exports2.geoJSON = geoJSON;
      exports2.geoJson = geoJson;
      exports2.gridLayer = gridLayer;
      exports2.icon = icon;
      exports2.imageOverlay = imageOverlay;
      exports2.latLng = toLatLng;
      exports2.latLngBounds = toLatLngBounds;
      exports2.layerGroup = layerGroup;
      exports2.map = createMap;
      exports2.marker = marker;
      exports2.point = toPoint;
      exports2.polygon = polygon;
      exports2.polyline = polyline;
      exports2.popup = popup;
      exports2.rectangle = rectangle;
      exports2.setOptions = setOptions;
      exports2.stamp = stamp;
      exports2.svg = svg;
      exports2.svgOverlay = svgOverlay;
      exports2.tileLayer = tileLayer;
      exports2.tooltip = tooltip;
      exports2.transformation = toTransformation;
      exports2.version = version;
      exports2.videoOverlay = videoOverlay;
      var oldL = window.L;
      exports2.noConflict = function() {
        window.L = oldL;
        return this;
      };
      window.L = exports2;
    });
  })(leafletSrc$1, leafletSrc$1.exports);
  return leafletSrc$1.exports;
}
var leafletSrcExports = requireLeafletSrc();
const L$1 = /* @__PURE__ */ getDefaultExportFromCjs(leafletSrcExports);
function createElementObject(instance, context, container) {
  return Object.freeze({
    instance,
    context,
    container
  });
}
function createElementHook(createElement, updateElement) {
  if (updateElement == null) {
    return function useImmutableLeafletElement(props, context) {
      const elementRef = reactExports.useRef(void 0);
      if (!elementRef.current) elementRef.current = createElement(props, context);
      return elementRef;
    };
  }
  return function useMutableLeafletElement(props, context) {
    const elementRef = reactExports.useRef(void 0);
    if (!elementRef.current) elementRef.current = createElement(props, context);
    const propsRef = reactExports.useRef(props);
    const { instance } = elementRef.current;
    reactExports.useEffect(function updateElementProps() {
      if (propsRef.current !== props) {
        updateElement(instance, props, propsRef.current);
        propsRef.current = props;
      }
    }, [
      instance,
      props,
      updateElement
    ]);
    return elementRef;
  };
}
function useLayerLifecycle(element, context) {
  reactExports.useEffect(function addLayer() {
    const container = context.layerContainer ?? context.map;
    container.addLayer(element.instance);
    return function removeLayer() {
      var _a;
      (_a = context.layerContainer) == null ? void 0 : _a.removeLayer(element.instance);
      context.map.removeLayer(element.instance);
    };
  }, [
    context,
    element
  ]);
}
function createLayerHook(useElement) {
  return function useLayer(props) {
    const context = useLeafletContext();
    const elementRef = useElement(withPane(props, context), context);
    useAttribution(context.map, props.attribution);
    useEventHandlers(elementRef.current, props.eventHandlers);
    useLayerLifecycle(elementRef.current, context);
    return elementRef;
  };
}
function createControlComponent(createInstance) {
  function createElement(props, context) {
    return createElementObject(createInstance(props), context);
  }
  const useElement = createElementHook(createElement);
  const useControl = createControlHook(useElement);
  return createLeafComponent(useControl);
}
function createTileLayerComponent(createElement, updateElement) {
  const useElement = createElementHook(createElement, updateElement);
  const useLayer = createLayerHook(useElement);
  return createLeafComponent(useLayer);
}
function updateGridLayer(layer, props, prevProps) {
  const { opacity, zIndex } = props;
  if (opacity != null && opacity !== prevProps.opacity) {
    layer.setOpacity(opacity);
  }
  if (zIndex != null && zIndex !== prevProps.zIndex) {
    layer.setZIndex(zIndex);
  }
}
function useMap() {
  return useLeafletContext().map;
}
function MapContainerComponent({ bounds, boundsOptions, center, children, className, id, placeholder, style, whenReady, zoom, ...options }, forwardedRef) {
  const [props] = reactExports.useState({
    className,
    id,
    style
  });
  const [context, setContext] = reactExports.useState(null);
  const mapInstanceRef = reactExports.useRef(void 0);
  reactExports.useImperativeHandle(forwardedRef, () => (context == null ? void 0 : context.map) ?? null, [
    context
  ]);
  const mapRef = reactExports.useCallback((node) => {
    if (node !== null && !mapInstanceRef.current) {
      const map = new leafletSrcExports.Map(node, options);
      mapInstanceRef.current = map;
      if (center != null && zoom != null) {
        map.setView(center, zoom);
      } else if (bounds != null) {
        map.fitBounds(bounds, boundsOptions);
      }
      if (whenReady != null) {
        map.whenReady(whenReady);
      }
      setContext(createLeafletContext(map));
    }
  }, []);
  reactExports.useEffect(() => {
    return () => {
      context == null ? void 0 : context.map.remove();
    };
  }, [
    context
  ]);
  const contents = context ? /* @__PURE__ */ React.createElement(LeafletContext, {
    value: context
  }, children) : placeholder ?? null;
  return /* @__PURE__ */ React.createElement("div", {
    ...props,
    ref: mapRef
  }, contents);
}
const MapContainer = /* @__PURE__ */ reactExports.forwardRef(MapContainerComponent);
const TileLayer = createTileLayerComponent(function createTileLayer({ url, ...options }, context) {
  const layer = new leafletSrcExports.TileLayer(url, withPane(options, context));
  return createElementObject(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
  updateGridLayer(layer, props, prevProps);
  const { url } = props;
  if (url != null && url !== prevProps.url) {
    layer.setUrl(url);
  }
});
const ZoomControl = createControlComponent(function createZoomControl(props) {
  return new leafletSrcExports.Control.Zoom(props);
});
leafletSrcExports.Icon.Default.mergeOptions({
  // Erase default options, so that they can be overridden by _initializeOptions if not supplied.
  iconUrl: null,
  iconRetinaUrl: null,
  shadowUrl: null,
  iconSize: null,
  iconAnchor: null,
  popupAnchor: null,
  tooltipAnchor: null,
  shadowSize: null,
  // @option classNamePrefix: String = 'leaflet-default-icon-'
  // Prefix for the classes defined in CSS that contain the Icon options.
  // See the leaflet-defaulticon-compatibility.css file as a starter.
  // Expected suffixes are "icon", "shadow", "popup" and "tooltip".
  classNamePrefix: "leaflet-default-icon-"
});
leafletSrcExports.Icon.Default.include({
  _needsInit: true,
  // Override to make sure options are retrieved from CSS.
  _getIconUrl: function(name) {
    var imagePath = this.options.imagePath || leafletSrcExports.Icon.Default.imagePath || "";
    if (this._needsInit) {
      this._initializeOptions(imagePath);
    }
    return imagePath + leafletSrcExports.Icon.prototype._getIconUrl.call(this, name);
  },
  // Initialize all necessary options for this instance.
  _initializeOptions: function(imagePath) {
    this._setOptions("icon", _detectIconOptions, imagePath);
    this._setOptions("shadow", _detectIconOptions, imagePath);
    this._setOptions("popup", _detectDivOverlayOptions);
    this._setOptions("tooltip", _detectDivOverlayOptions);
    this._needsInit = false;
  },
  // Retrieve values from CSS and assign to this instance options.
  _setOptions: function(name, detectorFn, imagePath) {
    var options = this.options, prefix = options.classNamePrefix, optionValues = detectorFn(prefix + name, imagePath);
    for (var optionName in optionValues) {
      options[name + optionName] = options[name + optionName] || optionValues[optionName];
    }
  }
});
function _detectIconOptions(className, imagePath) {
  var el = leafletSrcExports.DomUtil.create("div", className, document.body), urlsContainer = _getBkgImageOrCursor(el), urls = _extractUrls(urlsContainer, imagePath), iconX = _getStyleInt(el, "width"), iconY = _getStyleInt(el, "height"), anchorNX = _getStyleInt(el, "margin-left"), anchorNY = _getStyleInt(el, "margin-top");
  el.parentNode.removeChild(el);
  return {
    Url: urls[0],
    RetinaUrl: urls[1],
    Size: [iconX, iconY],
    Anchor: [-anchorNX, -anchorNY]
  };
}
function _detectDivOverlayOptions(className) {
  var el = leafletSrcExports.DomUtil.create("div", className, document.body), anchorX = _getStyleInt(el, "margin-left"), anchorY = _getStyleInt(el, "margin-top");
  el.parentNode.removeChild(el);
  return {
    Anchor: [anchorX, anchorY]
  };
}
function _extractUrls(urlsContainer, imagePath) {
  var re = /url\(['"]?([^"']*?)['"]?\)/gi, urls = [], m = re.exec(urlsContainer);
  while (m) {
    urls.push(imagePath ? _stripPath(m[1]) : m[1]);
    m = re.exec(urlsContainer);
  }
  return urls;
}
function _stripPath(url) {
  return url.substr(url.lastIndexOf("/") + 1);
}
function _getStyleInt(el, style) {
  return parseInt(_getStyle(el, style), 10);
}
function _getStyle(el, style) {
  return leafletSrcExports.DomUtil.getStyle(el, style) || leafletSrcExports.DomUtil.getStyle(el, _kebabToCamelCase(style));
}
function _getBkgImageOrCursor(el) {
  var bkgImage = _getStyle(el, "background-image");
  return bkgImage && bkgImage !== "none" ? bkgImage : _getStyle(el, "cursor");
}
function _kebabToCamelCase(prop) {
  return prop.replace(/-(\w)/g, function(str, w) {
    return w.toUpperCase();
  });
}
var maplibreGl$1 = { exports: {} };
/**
 * MapLibre GL JS
 * @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v5.14.0/LICENSE.txt
 */
var maplibreGl = maplibreGl$1.exports;
var hasRequiredMaplibreGl;
function requireMaplibreGl() {
  if (hasRequiredMaplibreGl) return maplibreGl$1.exports;
  hasRequiredMaplibreGl = 1;
  (function(module, exports) {
    (function(global, factory) {
      module.exports = factory();
    })(maplibreGl, function() {
      var maplibregl = {};
      var modules = {};
      function define(moduleName, _dependencies, moduleFactory) {
        modules[moduleName] = moduleFactory;
        if (moduleName !== "index") {
          return;
        }
        var workerBundleString = "var sharedModule = {}; (" + modules.shared + ")(sharedModule); (" + modules.worker + ")(sharedModule);";
        var sharedModule = {};
        modules.shared(sharedModule);
        modules.index(maplibregl, sharedModule);
        if (typeof window !== "undefined") {
          maplibregl.setWorkerUrl(window.URL.createObjectURL(new Blob([workerBundleString], { type: "text/javascript" })));
        }
        return maplibregl;
      }
      define("shared", ["exports"], function(t) {
        function e(t2, e2, r2, n2) {
          return new (r2 || (r2 = Promise))(function(i2, s2) {
            function o2(t3) {
              try {
                l2(n2.next(t3));
              } catch (t4) {
                s2(t4);
              }
            }
            function a2(t3) {
              try {
                l2(n2.throw(t3));
              } catch (t4) {
                s2(t4);
              }
            }
            function l2(t3) {
              var e3;
              t3.done ? i2(t3.value) : (e3 = t3.value, e3 instanceof r2 ? e3 : new r2(function(t4) {
                t4(e3);
              })).then(o2, a2);
            }
            l2((n2 = n2.apply(t2, e2 || [])).next());
          });
        }
        function r(t2, e2) {
          this.x = t2, this.y = e2;
        }
        function n(t2) {
          return t2 && t2.__esModule && Object.prototype.hasOwnProperty.call(t2, "default") ? t2.default : t2;
        }
        var i, s;
        "function" == typeof SuppressedError && SuppressedError, r.prototype = { clone() {
          return new r(this.x, this.y);
        }, add(t2) {
          return this.clone()._add(t2);
        }, sub(t2) {
          return this.clone()._sub(t2);
        }, multByPoint(t2) {
          return this.clone()._multByPoint(t2);
        }, divByPoint(t2) {
          return this.clone()._divByPoint(t2);
        }, mult(t2) {
          return this.clone()._mult(t2);
        }, div(t2) {
          return this.clone()._div(t2);
        }, rotate(t2) {
          return this.clone()._rotate(t2);
        }, rotateAround(t2, e2) {
          return this.clone()._rotateAround(t2, e2);
        }, matMult(t2) {
          return this.clone()._matMult(t2);
        }, unit() {
          return this.clone()._unit();
        }, perp() {
          return this.clone()._perp();
        }, round() {
          return this.clone()._round();
        }, mag() {
          return Math.sqrt(this.x * this.x + this.y * this.y);
        }, equals(t2) {
          return this.x === t2.x && this.y === t2.y;
        }, dist(t2) {
          return Math.sqrt(this.distSqr(t2));
        }, distSqr(t2) {
          const e2 = t2.x - this.x, r2 = t2.y - this.y;
          return e2 * e2 + r2 * r2;
        }, angle() {
          return Math.atan2(this.y, this.x);
        }, angleTo(t2) {
          return Math.atan2(this.y - t2.y, this.x - t2.x);
        }, angleWith(t2) {
          return this.angleWithSep(t2.x, t2.y);
        }, angleWithSep(t2, e2) {
          return Math.atan2(this.x * e2 - this.y * t2, this.x * t2 + this.y * e2);
        }, _matMult(t2) {
          const e2 = t2[2] * this.x + t2[3] * this.y;
          return this.x = t2[0] * this.x + t2[1] * this.y, this.y = e2, this;
        }, _add(t2) {
          return this.x += t2.x, this.y += t2.y, this;
        }, _sub(t2) {
          return this.x -= t2.x, this.y -= t2.y, this;
        }, _mult(t2) {
          return this.x *= t2, this.y *= t2, this;
        }, _div(t2) {
          return this.x /= t2, this.y /= t2, this;
        }, _multByPoint(t2) {
          return this.x *= t2.x, this.y *= t2.y, this;
        }, _divByPoint(t2) {
          return this.x /= t2.x, this.y /= t2.y, this;
        }, _unit() {
          return this._div(this.mag()), this;
        }, _perp() {
          const t2 = this.y;
          return this.y = this.x, this.x = -t2, this;
        }, _rotate(t2) {
          const e2 = Math.cos(t2), r2 = Math.sin(t2), n2 = r2 * this.x + e2 * this.y;
          return this.x = e2 * this.x - r2 * this.y, this.y = n2, this;
        }, _rotateAround(t2, e2) {
          const r2 = Math.cos(t2), n2 = Math.sin(t2), i2 = e2.y + n2 * (this.x - e2.x) + r2 * (this.y - e2.y);
          return this.x = e2.x + r2 * (this.x - e2.x) - n2 * (this.y - e2.y), this.y = i2, this;
        }, _round() {
          return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
        }, constructor: r }, r.convert = function(t2) {
          if (t2 instanceof r) return t2;
          if (Array.isArray(t2)) return new r(+t2[0], +t2[1]);
          if (void 0 !== t2.x && void 0 !== t2.y) return new r(+t2.x, +t2.y);
          throw new Error("Expected [x, y] or {x, y} point format");
        };
        var o = function() {
          if (s) return i;
          function t2(t3, e2, r2, n2) {
            this.cx = 3 * t3, this.bx = 3 * (r2 - t3) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e2, this.by = 3 * (n2 - e2) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t3, this.p1y = e2, this.p2x = r2, this.p2y = n2;
          }
          return s = 1, i = t2, t2.prototype = { sampleCurveX: function(t3) {
            return ((this.ax * t3 + this.bx) * t3 + this.cx) * t3;
          }, sampleCurveY: function(t3) {
            return ((this.ay * t3 + this.by) * t3 + this.cy) * t3;
          }, sampleCurveDerivativeX: function(t3) {
            return (3 * this.ax * t3 + 2 * this.bx) * t3 + this.cx;
          }, solveCurveX: function(t3, e2) {
            if (void 0 === e2 && (e2 = 1e-6), t3 < 0) return 0;
            if (t3 > 1) return 1;
            for (var r2 = t3, n2 = 0; n2 < 8; n2++) {
              var i2 = this.sampleCurveX(r2) - t3;
              if (Math.abs(i2) < e2) return r2;
              var s2 = this.sampleCurveDerivativeX(r2);
              if (Math.abs(s2) < 1e-6) break;
              r2 -= i2 / s2;
            }
            var o2 = 0, a2 = 1;
            for (r2 = t3, n2 = 0; n2 < 20 && (i2 = this.sampleCurveX(r2), !(Math.abs(i2 - t3) < e2)); n2++) t3 > i2 ? o2 = r2 : a2 = r2, r2 = 0.5 * (a2 - o2) + o2;
            return r2;
          }, solve: function(t3, e2) {
            return this.sampleCurveY(this.solveCurveX(t3, e2));
          } }, i;
        }(), a = n(o);
        let l, u;
        function c() {
          return null == l && (l = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), l;
        }
        function h() {
          if (null == u && (u = false, c())) {
            const t2 = 5, e2 = new OffscreenCanvas(t2, t2).getContext("2d", { willReadFrequently: true });
            if (e2) {
              for (let r3 = 0; r3 < t2 * t2; r3++) {
                const n2 = 4 * r3;
                e2.fillStyle = `rgb(${n2},${n2 + 1},${n2 + 2})`, e2.fillRect(r3 % t2, Math.floor(r3 / t2), 1, 1);
              }
              const r2 = e2.getImageData(0, 0, t2, t2).data;
              for (let e3 = 0; e3 < t2 * t2 * 4; e3++) if (e3 % 4 != 3 && r2[e3] !== e3) {
                u = true;
                break;
              }
            }
          }
          return u || false;
        }
        var p = 1e-6, f = "undefined" != typeof Float32Array ? Float32Array : Array;
        function d() {
          var t2 = new f(9);
          return f != Float32Array && (t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[5] = 0, t2[6] = 0, t2[7] = 0), t2[0] = 1, t2[4] = 1, t2[8] = 1, t2;
        }
        function y(t2) {
          return t2[0] = 1, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = 1, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = 1, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
        }
        function m() {
          var t2 = new f(3);
          return f != Float32Array && (t2[0] = 0, t2[1] = 0, t2[2] = 0), t2;
        }
        function g(t2) {
          var e2 = t2[0], r2 = t2[1], n2 = t2[2];
          return Math.sqrt(e2 * e2 + r2 * r2 + n2 * n2);
        }
        function x(t2, e2, r2) {
          var n2 = new f(3);
          return n2[0] = t2, n2[1] = e2, n2[2] = r2, n2;
        }
        function v(t2, e2, r2) {
          return t2[0] = e2[0] + r2[0], t2[1] = e2[1] + r2[1], t2[2] = e2[2] + r2[2], t2;
        }
        function b(t2, e2, r2) {
          return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2;
        }
        function w(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = r2[0], a2 = r2[1], l2 = r2[2];
          return t2[0] = i2 * l2 - s2 * a2, t2[1] = s2 * o2 - n2 * l2, t2[2] = n2 * a2 - i2 * o2, t2;
        }
        var _, A = g;
        function S(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = e2[3];
          return t2[0] = r2[0] * n2 + r2[4] * i2 + r2[8] * s2 + r2[12] * o2, t2[1] = r2[1] * n2 + r2[5] * i2 + r2[9] * s2 + r2[13] * o2, t2[2] = r2[2] * n2 + r2[6] * i2 + r2[10] * s2 + r2[14] * o2, t2[3] = r2[3] * n2 + r2[7] * i2 + r2[11] * s2 + r2[15] * o2, t2;
        }
        function k() {
          var t2 = new f(4);
          return f != Float32Array && (t2[0] = 0, t2[1] = 0, t2[2] = 0), t2[3] = 1, t2;
        }
        function E(t2, e2, r2, n2) {
          var i2 = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "zyx", s2 = Math.PI / 360;
          e2 *= s2, n2 *= s2, r2 *= s2;
          var o2 = Math.sin(e2), a2 = Math.cos(e2), l2 = Math.sin(r2), u2 = Math.cos(r2), c2 = Math.sin(n2), h2 = Math.cos(n2);
          switch (i2) {
            case "xyz":
              t2[0] = o2 * u2 * h2 + a2 * l2 * c2, t2[1] = a2 * l2 * h2 - o2 * u2 * c2, t2[2] = a2 * u2 * c2 + o2 * l2 * h2, t2[3] = a2 * u2 * h2 - o2 * l2 * c2;
              break;
            case "xzy":
              t2[0] = o2 * u2 * h2 - a2 * l2 * c2, t2[1] = a2 * l2 * h2 - o2 * u2 * c2, t2[2] = a2 * u2 * c2 + o2 * l2 * h2, t2[3] = a2 * u2 * h2 + o2 * l2 * c2;
              break;
            case "yxz":
              t2[0] = o2 * u2 * h2 + a2 * l2 * c2, t2[1] = a2 * l2 * h2 - o2 * u2 * c2, t2[2] = a2 * u2 * c2 - o2 * l2 * h2, t2[3] = a2 * u2 * h2 + o2 * l2 * c2;
              break;
            case "yzx":
              t2[0] = o2 * u2 * h2 + a2 * l2 * c2, t2[1] = a2 * l2 * h2 + o2 * u2 * c2, t2[2] = a2 * u2 * c2 - o2 * l2 * h2, t2[3] = a2 * u2 * h2 - o2 * l2 * c2;
              break;
            case "zxy":
              t2[0] = o2 * u2 * h2 - a2 * l2 * c2, t2[1] = a2 * l2 * h2 + o2 * u2 * c2, t2[2] = a2 * u2 * c2 + o2 * l2 * h2, t2[3] = a2 * u2 * h2 - o2 * l2 * c2;
              break;
            case "zyx":
              t2[0] = o2 * u2 * h2 - a2 * l2 * c2, t2[1] = a2 * l2 * h2 + o2 * u2 * c2, t2[2] = a2 * u2 * c2 - o2 * l2 * h2, t2[3] = a2 * u2 * h2 + o2 * l2 * c2;
              break;
            default:
              throw new Error("Unknown angle order " + i2);
          }
          return t2;
        }
        function T() {
          var t2 = new f(2);
          return f != Float32Array && (t2[0] = 0, t2[1] = 0), t2;
        }
        function I(t2, e2) {
          var r2 = new f(2);
          return r2[0] = t2, r2[1] = e2, r2;
        }
        m(), _ = new f(4), f != Float32Array && (_[0] = 0, _[1] = 0, _[2] = 0, _[3] = 0), m(), x(1, 0, 0), x(0, 1, 0), k(), k(), d(), T();
        const M = 8192;
        function F(t2, e2, r2) {
          return e2 * (M / (t2.tileSize * Math.pow(2, r2 - t2.tileID.overscaledZ)));
        }
        function D(t2, e2) {
          return (t2 % e2 + e2) % e2;
        }
        function P(t2, e2, r2) {
          return t2 * (1 - r2) + e2 * r2;
        }
        function z(t2) {
          if (t2 <= 0) return 0;
          if (t2 >= 1) return 1;
          const e2 = t2 * t2, r2 = e2 * t2;
          return 4 * (t2 < 0.5 ? r2 : 3 * (t2 - e2) + r2 - 0.75);
        }
        function B(t2, e2, r2, n2) {
          const i2 = new a(t2, e2, r2, n2);
          return (t3) => i2.solve(t3);
        }
        const V = B(0.25, 0.1, 0.25, 1);
        function C(t2, e2, r2) {
          return Math.min(r2, Math.max(e2, t2));
        }
        function L2(t2, e2, r2) {
          const n2 = r2 - e2, i2 = ((t2 - e2) % n2 + n2) % n2 + e2;
          return i2 === e2 ? r2 : i2;
        }
        function O(t2, ...e2) {
          for (const r2 of e2) for (const e3 in r2) t2[e3] = r2[e3];
          return t2;
        }
        let R = 1;
        function N(t2, e2, r2) {
          const n2 = {};
          for (const r3 in t2) n2[r3] = e2.call(this, t2[r3], r3, t2);
          return n2;
        }
        function $(t2, e2, r2) {
          const n2 = {};
          for (const r3 in t2) e2.call(this, t2[r3], r3, t2) && (n2[r3] = t2[r3]);
          return n2;
        }
        function U(t2) {
          return Array.isArray(t2) ? t2.map(U) : "object" == typeof t2 && t2 ? N(t2, U) : t2;
        }
        const q = {};
        function j(t2) {
          q[t2] || ("undefined" != typeof console && console.warn(t2), q[t2] = true);
        }
        function G(t2, e2, r2) {
          return (r2.y - t2.y) * (e2.x - t2.x) > (e2.y - t2.y) * (r2.x - t2.x);
        }
        function X(t2) {
          return "undefined" != typeof WorkerGlobalScope && void 0 !== t2 && t2 instanceof WorkerGlobalScope;
        }
        let Y = null;
        function Z(t2) {
          return "undefined" != typeof ImageBitmap && t2 instanceof ImageBitmap;
        }
        const H = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        function K(t2, r2, n2, i2, s2) {
          return e(this, void 0, void 0, function* () {
            if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
            const e2 = new VideoFrame(t2, { timestamp: 0 });
            try {
              const o2 = null == e2 ? void 0 : e2.format;
              if (!o2 || !o2.startsWith("BGR") && !o2.startsWith("RGB")) throw new Error(`Unrecognized format ${o2}`);
              const a2 = o2.startsWith("BGR"), l2 = new Uint8ClampedArray(i2 * s2 * 4);
              if (yield e2.copyTo(l2, function(t3, e3, r3, n3, i3) {
                const s3 = 4 * Math.max(-e3, 0), o3 = (Math.max(0, r3) - r3) * n3 * 4 + s3, a3 = 4 * n3, l3 = Math.max(0, e3), u2 = Math.max(0, r3);
                return { rect: { x: l3, y: u2, width: Math.min(t3.width, e3 + n3) - l3, height: Math.min(t3.height, r3 + i3) - u2 }, layout: [{ offset: o3, stride: a3 }] };
              }(t2, r2, n2, i2, s2)), a2) for (let t3 = 0; t3 < l2.length; t3 += 4) {
                const e3 = l2[t3];
                l2[t3] = l2[t3 + 2], l2[t3 + 2] = e3;
              }
              return l2;
            } finally {
              e2.close();
            }
          });
        }
        let W, J;
        function Q(t2, e2, r2, n2) {
          return t2.addEventListener(e2, r2, n2), { unsubscribe: () => {
            t2.removeEventListener(e2, r2, n2);
          } };
        }
        function tt(t2) {
          return t2 * Math.PI / 180;
        }
        function et(t2) {
          return t2 / Math.PI * 180;
        }
        const rt = { touchstart: true, touchmove: true, touchmoveWindow: true, touchend: true, touchcancel: true }, nt = { dblclick: true, click: true, mouseover: true, mouseout: true, mousedown: true, mousemove: true, mousemoveWindow: true, mouseup: true, mouseupWindow: true, contextmenu: true, wheel: true }, it = "AbortError";
        class st extends Error {
          constructor(t2 = it) {
            super(t2 instanceof Error ? t2.message : t2), this.name = it, t2 instanceof Error && t2.stack && (this.stack = t2.stack);
          }
        }
        function ot(t2) {
          return t2.name === it;
        }
        const at = { MAX_PARALLEL_IMAGE_REQUESTS: 16, MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8, MAX_TILE_CACHE_ZOOM_LEVELS: 5, REGISTERED_PROTOCOLS: {}, WORKER_URL: "" };
        function lt(t2) {
          return at.REGISTERED_PROTOCOLS[t2.substring(0, t2.indexOf("://"))];
        }
        const ut = "global-dispatcher";
        class ct extends Error {
          constructor(t2, e2, r2, n2) {
            super(`AJAXError: ${e2} (${t2}): ${r2}`), this.status = t2, this.statusText = e2, this.url = r2, this.body = n2;
          }
        }
        const ht = () => X(self) ? self.worker && self.worker.referrer : ("blob:" === window.location.protocol ? window.parent : window).location.href, pt = function(t2, r2) {
          if (/:\/\//.test(t2.url) && !/^https?:|^file:/.test(t2.url)) {
            const e2 = lt(t2.url);
            if (e2) return e2(t2, r2);
            if (X(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({ type: "GR", data: t2, targetMapId: ut }, r2);
          }
          if (!(/^file:/.test(n2 = t2.url) || /^file:/.test(ht()) && !/^\w+:/.test(n2))) {
            if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return function(t3, r3) {
              return e(this, void 0, void 0, function* () {
                const e2 = new Request(t3.url, { method: t3.method || "GET", body: t3.body, credentials: t3.credentials, headers: t3.headers, cache: t3.cache, referrer: ht(), signal: r3.signal });
                let n3, i2;
                "json" !== t3.type || e2.headers.has("Accept") || e2.headers.set("Accept", "application/json");
                try {
                  n3 = yield fetch(e2);
                } catch (e3) {
                  if (ot(e3)) throw e3;
                  throw new ct(0, e3.message, t3.url, new Blob());
                }
                if (!n3.ok) {
                  const e3 = yield n3.blob();
                  throw new ct(n3.status, n3.statusText, t3.url, e3);
                }
                i2 = "arrayBuffer" === t3.type || "image" === t3.type ? n3.arrayBuffer() : "json" === t3.type ? n3.json() : n3.text();
                const s2 = yield i2;
                return r3.signal.throwIfAborted(), { data: s2, cacheControl: n3.headers.get("Cache-Control"), expires: n3.headers.get("Expires") };
              });
            }(t2, r2);
            if (X(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({ type: "GR", data: t2, mustQueue: true, targetMapId: ut }, r2);
          }
          var n2;
          return function(t3, e2) {
            return new Promise((r3, n3) => {
              var i2;
              const s2 = new XMLHttpRequest();
              s2.open(t3.method || "GET", t3.url, true), "arrayBuffer" !== t3.type && "image" !== t3.type || (s2.responseType = "arraybuffer");
              for (const e3 in t3.headers) s2.setRequestHeader(e3, t3.headers[e3]);
              "json" === t3.type && (s2.responseType = "text", (null === (i2 = t3.headers) || void 0 === i2 ? void 0 : i2.Accept) || s2.setRequestHeader("Accept", "application/json")), s2.withCredentials = "include" === t3.credentials, s2.onerror = () => {
                n3(new Error(s2.statusText));
              }, s2.onload = () => {
                if (!e2.signal.aborted) if ((s2.status >= 200 && s2.status < 300 || 0 === s2.status) && null !== s2.response) {
                  let e3 = s2.response;
                  if ("json" === t3.type) try {
                    e3 = JSON.parse(s2.response);
                  } catch (t4) {
                    return void n3(t4);
                  }
                  r3({ data: e3, cacheControl: s2.getResponseHeader("Cache-Control"), expires: s2.getResponseHeader("Expires") });
                } else {
                  const e3 = new Blob([s2.response], { type: s2.getResponseHeader("Content-Type") });
                  n3(new ct(s2.status, s2.statusText, t3.url, e3));
                }
              }, e2.signal.addEventListener("abort", () => {
                s2.abort(), n3(new st(e2.signal.reason));
              }), s2.send(t3.body);
            });
          }(t2, r2);
        };
        function ft(t2) {
          if (!t2 || t2.indexOf("://") <= 0 || 0 === t2.indexOf("data:image/") || 0 === t2.indexOf("blob:")) return true;
          const e2 = new URL(t2), r2 = window.location;
          return e2.protocol === r2.protocol && e2.host === r2.host;
        }
        function dt(t2, e2, r2) {
          r2[t2] && -1 !== r2[t2].indexOf(e2) || (r2[t2] = r2[t2] || [], r2[t2].push(e2));
        }
        function yt(t2, e2, r2) {
          if (r2 && r2[t2]) {
            const n2 = r2[t2].indexOf(e2);
            -1 !== n2 && r2[t2].splice(n2, 1);
          }
        }
        class mt {
          constructor(t2, e2 = {}) {
            O(this, e2), this.type = t2;
          }
        }
        class gt extends mt {
          constructor(t2, e2 = {}) {
            super("error", O({ error: t2 }, e2));
          }
        }
        class xt {
          on(t2, e2) {
            return this._listeners = this._listeners || {}, dt(t2, e2, this._listeners), { unsubscribe: () => {
              this.off(t2, e2);
            } };
          }
          off(t2, e2) {
            return yt(t2, e2, this._listeners), yt(t2, e2, this._oneTimeListeners), this;
          }
          once(t2, e2) {
            return e2 ? (this._oneTimeListeners = this._oneTimeListeners || {}, dt(t2, e2, this._oneTimeListeners), this) : new Promise((e3) => this.once(t2, e3));
          }
          fire(t2, e2) {
            "string" == typeof t2 && (t2 = new mt(t2, e2 || {}));
            const r2 = t2.type;
            if (this.listens(r2)) {
              t2.target = this;
              const e3 = this._listeners && this._listeners[r2] ? this._listeners[r2].slice() : [];
              for (const r3 of e3) r3.call(this, t2);
              const n2 = this._oneTimeListeners && this._oneTimeListeners[r2] ? this._oneTimeListeners[r2].slice() : [];
              for (const e4 of n2) yt(r2, e4, this._oneTimeListeners), e4.call(this, t2);
              const i2 = this._eventedParent;
              i2 && (O(t2, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i2.fire(t2));
            } else t2 instanceof gt && console.error(t2.error);
            return this;
          }
          listens(t2) {
            return this._listeners && this._listeners[t2] && this._listeners[t2].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t2] && this._oneTimeListeners[t2].length > 0 || this._eventedParent && this._eventedParent.listens(t2);
          }
          setEventedParent(t2, e2) {
            return this._eventedParent = t2, this._eventedParentData = e2, this;
          }
        }
        var vt = { $version: 8, $root: { version: { required: true, type: "enum", values: [8] }, name: { type: "string" }, metadata: { type: "*" }, center: { type: "array", value: "number" }, centerAltitude: { type: "number" }, zoom: { type: "number" }, bearing: { type: "number", default: 0, period: 360, units: "degrees" }, pitch: { type: "number", default: 0, units: "degrees" }, roll: { type: "number", default: 0, units: "degrees" }, state: { type: "state", default: {} }, light: { type: "light" }, sky: { type: "sky" }, projection: { type: "projection" }, terrain: { type: "terrain" }, sources: { required: true, type: "sources" }, sprite: { type: "sprite" }, glyphs: { type: "string" }, "font-faces": { type: "array", value: "fontFaces" }, transition: { type: "transition" }, layers: { required: true, type: "array", value: "layer" } }, sources: { "*": { type: "source" } }, source: ["source_vector", "source_raster", "source_raster_dem", "source_geojson", "source_video", "source_image"], source_vector: { type: { required: true, type: "enum", values: { vector: {} } }, url: { type: "string" }, tiles: { type: "array", value: "string" }, bounds: { type: "array", value: "number", length: 4, default: [-180, -85.051129, 180, 85.051129] }, scheme: { type: "enum", values: { xyz: {}, tms: {} }, default: "xyz" }, minzoom: { type: "number", default: 0 }, maxzoom: { type: "number", default: 22 }, attribution: { type: "string" }, promoteId: { type: "promoteId" }, volatile: { type: "boolean", default: false }, encoding: { type: "enum", values: { mvt: {}, mlt: {} }, default: "mvt" }, "*": { type: "*" } }, source_raster: { type: { required: true, type: "enum", values: { raster: {} } }, url: { type: "string" }, tiles: { type: "array", value: "string" }, bounds: { type: "array", value: "number", length: 4, default: [-180, -85.051129, 180, 85.051129] }, minzoom: { type: "number", default: 0 }, maxzoom: { type: "number", default: 22 }, tileSize: { type: "number", default: 512, units: "pixels" }, scheme: { type: "enum", values: { xyz: {}, tms: {} }, default: "xyz" }, attribution: { type: "string" }, volatile: { type: "boolean", default: false }, "*": { type: "*" } }, source_raster_dem: { type: { required: true, type: "enum", values: { "raster-dem": {} } }, url: { type: "string" }, tiles: { type: "array", value: "string" }, bounds: { type: "array", value: "number", length: 4, default: [-180, -85.051129, 180, 85.051129] }, minzoom: { type: "number", default: 0 }, maxzoom: { type: "number", default: 22 }, tileSize: { type: "number", default: 512, units: "pixels" }, attribution: { type: "string" }, encoding: { type: "enum", values: { terrarium: {}, mapbox: {}, custom: {} }, default: "mapbox" }, redFactor: { type: "number", default: 1 }, blueFactor: { type: "number", default: 1 }, greenFactor: { type: "number", default: 1 }, baseShift: { type: "number", default: 0 }, volatile: { type: "boolean", default: false }, "*": { type: "*" } }, source_geojson: { type: { required: true, type: "enum", values: { geojson: {} } }, data: { required: true, type: "*" }, maxzoom: { type: "number", default: 18 }, attribution: { type: "string" }, buffer: { type: "number", default: 128, maximum: 512, minimum: 0 }, filter: { type: "*" }, tolerance: { type: "number", default: 0.375 }, cluster: { type: "boolean", default: false }, clusterRadius: { type: "number", default: 50, minimum: 0 }, clusterMaxZoom: { type: "number" }, clusterMinPoints: { type: "number" }, clusterProperties: { type: "*" }, lineMetrics: { type: "boolean", default: false }, generateId: { type: "boolean", default: false }, promoteId: { type: "promoteId" } }, source_video: { type: { required: true, type: "enum", values: { video: {} } }, urls: { required: true, type: "array", value: "string" }, coordinates: { required: true, type: "array", length: 4, value: { type: "array", length: 2, value: "number" } } }, source_image: { type: { required: true, type: "enum", values: { image: {} } }, url: { required: true, type: "string" }, coordinates: { required: true, type: "array", length: 4, value: { type: "array", length: 2, value: "number" } } }, layer: { id: { type: "string", required: true }, type: { type: "enum", values: { fill: {}, line: {}, symbol: {}, circle: {}, heatmap: {}, "fill-extrusion": {}, raster: {}, hillshade: {}, "color-relief": {}, background: {} }, required: true }, metadata: { type: "*" }, source: { type: "string" }, "source-layer": { type: "string" }, minzoom: { type: "number", minimum: 0, maximum: 24 }, maxzoom: { type: "number", minimum: 0, maximum: 24 }, filter: { type: "filter" }, layout: { type: "layout" }, paint: { type: "paint" } }, layout: ["layout_fill", "layout_line", "layout_circle", "layout_heatmap", "layout_fill-extrusion", "layout_symbol", "layout_raster", "layout_hillshade", "layout_color-relief", "layout_background"], layout_background: { visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_fill: { "fill-sort-key": { type: "number", expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_circle: { "circle-sort-key": { type: "number", expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_heatmap: { visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, "layout_fill-extrusion": { visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_line: { "line-cap": { type: "enum", values: { butt: {}, round: {}, square: {} }, default: "butt", expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "line-join": { type: "enum", values: { bevel: {}, round: {}, miter: {} }, default: "miter", expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "line-miter-limit": { type: "number", default: 2, requires: [{ "line-join": "miter" }], expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "line-round-limit": { type: "number", default: 1.05, requires: [{ "line-join": "round" }], expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "line-sort-key": { type: "number", expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_symbol: { "symbol-placement": { type: "enum", values: { point: {}, line: {}, "line-center": {} }, default: "point", expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "symbol-spacing": { type: "number", default: 250, minimum: 1, units: "pixels", requires: [{ "symbol-placement": "line" }], expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "symbol-avoid-edges": { type: "boolean", default: false, expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "symbol-sort-key": { type: "number", expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "symbol-z-order": { type: "enum", values: { auto: {}, "viewport-y": {}, source: {} }, default: "auto", expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-allow-overlap": { type: "boolean", default: false, requires: ["icon-image", { "!": "icon-overlap" }], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-overlap": { type: "enum", values: { never: {}, always: {}, cooperative: {} }, requires: ["icon-image"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-ignore-placement": { type: "boolean", default: false, requires: ["icon-image"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-optional": { type: "boolean", default: false, requires: ["icon-image", "text-field"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-rotation-alignment": { type: "enum", values: { map: {}, viewport: {}, auto: {} }, default: "auto", requires: ["icon-image"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-size": { type: "number", default: 1, minimum: 0, units: "factor of the original icon size", requires: ["icon-image"], expression: { interpolated: true, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "icon-text-fit": { type: "enum", values: { none: {}, width: {}, height: {}, both: {} }, default: "none", requires: ["icon-image", "text-field"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-text-fit-padding": { type: "array", value: "number", length: 4, default: [0, 0, 0, 0], units: "pixels", requires: ["icon-image", "text-field", { "icon-text-fit": ["both", "width", "height"] }], expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-image": { type: "resolvedImage", tokens: true, expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "icon-rotate": { type: "number", default: 0, period: 360, units: "degrees", requires: ["icon-image"], expression: { interpolated: true, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "icon-padding": { type: "padding", default: [2], units: "pixels", requires: ["icon-image"], expression: { interpolated: true, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "icon-keep-upright": { type: "boolean", default: false, requires: ["icon-image", { "icon-rotation-alignment": "map" }, { "symbol-placement": ["line", "line-center"] }], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-offset": { type: "array", value: "number", length: 2, default: [0, 0], requires: ["icon-image"], expression: { interpolated: true, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "icon-anchor": { type: "enum", values: { center: {}, left: {}, right: {}, top: {}, bottom: {}, "top-left": {}, "top-right": {}, "bottom-left": {}, "bottom-right": {} }, default: "center", requires: ["icon-image"], expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "icon-pitch-alignment": { type: "enum", values: { map: {}, viewport: {}, auto: {} }, default: "auto", requires: ["icon-image"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-pitch-alignment": { type: "enum", values: { map: {}, viewport: {}, auto: {} }, default: "auto", requires: ["text-field"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-rotation-alignment": { type: "enum", values: { map: {}, viewport: {}, "viewport-glyph": {}, auto: {} }, default: "auto", requires: ["text-field"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-field": { type: "formatted", default: "", tokens: true, expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-font": { type: "array", value: "string", default: ["Open Sans Regular", "Arial Unicode MS Regular"], requires: ["text-field"], expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-size": { type: "number", default: 16, minimum: 0, units: "pixels", requires: ["text-field"], expression: { interpolated: true, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-max-width": { type: "number", default: 10, minimum: 0, units: "ems", requires: ["text-field"], expression: { interpolated: true, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-line-height": { type: "number", default: 1.2, units: "ems", requires: ["text-field"], expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-letter-spacing": { type: "number", default: 0, units: "ems", requires: ["text-field"], expression: { interpolated: true, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-justify": { type: "enum", values: { auto: {}, left: {}, center: {}, right: {} }, default: "center", requires: ["text-field"], expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-radial-offset": { type: "number", units: "ems", default: 0, requires: ["text-field"], "property-type": "data-driven", expression: { interpolated: true, parameters: ["zoom", "feature"] } }, "text-variable-anchor": { type: "array", value: "enum", values: { center: {}, left: {}, right: {}, top: {}, bottom: {}, "top-left": {}, "top-right": {}, "bottom-left": {}, "bottom-right": {} }, requires: ["text-field", { "symbol-placement": ["point"] }], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-variable-anchor-offset": { type: "variableAnchorOffsetCollection", requires: ["text-field", { "symbol-placement": ["point"] }], expression: { interpolated: true, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-anchor": { type: "enum", values: { center: {}, left: {}, right: {}, top: {}, bottom: {}, "top-left": {}, "top-right": {}, "bottom-left": {}, "bottom-right": {} }, default: "center", requires: ["text-field", { "!": "text-variable-anchor" }], expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-max-angle": { type: "number", default: 45, units: "degrees", requires: ["text-field", { "symbol-placement": ["line", "line-center"] }], expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-writing-mode": { type: "array", value: "enum", values: { horizontal: {}, vertical: {} }, requires: ["text-field", { "symbol-placement": ["point"] }], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-rotate": { type: "number", default: 0, period: 360, units: "degrees", requires: ["text-field"], expression: { interpolated: true, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-padding": { type: "number", default: 2, minimum: 0, units: "pixels", requires: ["text-field"], expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-keep-upright": { type: "boolean", default: true, requires: ["text-field", { "text-rotation-alignment": "map" }, { "symbol-placement": ["line", "line-center"] }], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-transform": { type: "enum", values: { none: {}, uppercase: {}, lowercase: {} }, default: "none", requires: ["text-field"], expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-offset": { type: "array", value: "number", units: "ems", length: 2, default: [0, 0], requires: ["text-field", { "!": "text-radial-offset" }], expression: { interpolated: true, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-allow-overlap": { type: "boolean", default: false, requires: ["text-field", { "!": "text-overlap" }], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-overlap": { type: "enum", values: { never: {}, always: {}, cooperative: {} }, requires: ["text-field"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-ignore-placement": { type: "boolean", default: false, requires: ["text-field"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-optional": { type: "boolean", default: false, requires: ["text-field", "icon-image"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_raster: { visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_hillshade: { visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, "layout_color-relief": { visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, filter: { type: "array", value: "*" }, filter_operator: { type: "enum", values: { "==": {}, "!=": {}, ">": {}, ">=": {}, "<": {}, "<=": {}, in: {}, "!in": {}, all: {}, any: {}, none: {}, has: {}, "!has": {} } }, geometry_type: { type: "enum", values: { Point: {}, LineString: {}, Polygon: {} } }, function: { expression: { type: "expression" }, stops: { type: "array", value: "function_stop" }, base: { type: "number", default: 1, minimum: 0 }, property: { type: "string", default: "$zoom" }, type: { type: "enum", values: { identity: {}, exponential: {}, interval: {}, categorical: {} }, default: "exponential" }, colorSpace: { type: "enum", values: { rgb: {}, lab: {}, hcl: {} }, default: "rgb" }, default: { type: "*", required: false } }, function_stop: { type: "array", minimum: 0, maximum: 24, value: ["number", "color"], length: 2 }, expression: { type: "array", value: "*", minimum: 1 }, light: { anchor: { type: "enum", default: "viewport", values: { map: {}, viewport: {} }, "property-type": "data-constant", transition: false, expression: { interpolated: false, parameters: ["zoom"] } }, position: { type: "array", default: [1.15, 210, 30], length: 3, value: "number", "property-type": "data-constant", transition: true, expression: { interpolated: true, parameters: ["zoom"] } }, color: { type: "color", "property-type": "data-constant", default: "#ffffff", expression: { interpolated: true, parameters: ["zoom"] }, transition: true }, intensity: { type: "number", "property-type": "data-constant", default: 0.5, minimum: 0, maximum: 1, expression: { interpolated: true, parameters: ["zoom"] }, transition: true } }, sky: { "sky-color": { type: "color", "property-type": "data-constant", default: "#88C6FC", expression: { interpolated: true, parameters: ["zoom"] }, transition: true }, "horizon-color": { type: "color", "property-type": "data-constant", default: "#ffffff", expression: { interpolated: true, parameters: ["zoom"] }, transition: true }, "fog-color": { type: "color", "property-type": "data-constant", default: "#ffffff", expression: { interpolated: true, parameters: ["zoom"] }, transition: true }, "fog-ground-blend": { type: "number", "property-type": "data-constant", default: 0.5, minimum: 0, maximum: 1, expression: { interpolated: true, parameters: ["zoom"] }, transition: true }, "horizon-fog-blend": { type: "number", "property-type": "data-constant", default: 0.8, minimum: 0, maximum: 1, expression: { interpolated: true, parameters: ["zoom"] }, transition: true }, "sky-horizon-blend": { type: "number", "property-type": "data-constant", default: 0.8, minimum: 0, maximum: 1, expression: { interpolated: true, parameters: ["zoom"] }, transition: true }, "atmosphere-blend": { type: "number", "property-type": "data-constant", default: 0.8, minimum: 0, maximum: 1, expression: { interpolated: true, parameters: ["zoom"] }, transition: true } }, terrain: { source: { type: "string", required: true }, exaggeration: { type: "number", minimum: 0, default: 1 } }, projection: { type: { type: "projectionDefinition", default: "mercator", "property-type": "data-constant", transition: false, expression: { interpolated: true, parameters: ["zoom"] } } }, paint: ["paint_fill", "paint_line", "paint_circle", "paint_heatmap", "paint_fill-extrusion", "paint_symbol", "paint_raster", "paint_hillshade", "paint_color-relief", "paint_background"], paint_fill: { "fill-antialias": { type: "boolean", default: true, expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "fill-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "fill-color": { type: "color", default: "#000000", transition: true, requires: [{ "!": "fill-pattern" }], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "fill-outline-color": { type: "color", transition: true, requires: [{ "!": "fill-pattern" }, { "fill-antialias": true }], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "fill-translate": { type: "array", value: "number", length: 2, default: [0, 0], transition: true, units: "pixels", expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "fill-translate-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "map", requires: ["fill-translate"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "fill-pattern": { type: "resolvedImage", transition: true, expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "cross-faded-data-driven" } }, "paint_fill-extrusion": { "fill-extrusion-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "fill-extrusion-color": { type: "color", default: "#000000", transition: true, requires: [{ "!": "fill-extrusion-pattern" }], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "fill-extrusion-translate": { type: "array", value: "number", length: 2, default: [0, 0], transition: true, units: "pixels", expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "fill-extrusion-translate-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "map", requires: ["fill-extrusion-translate"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "fill-extrusion-pattern": { type: "resolvedImage", transition: true, expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "cross-faded-data-driven" }, "fill-extrusion-height": { type: "number", default: 0, minimum: 0, units: "meters", transition: true, expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "fill-extrusion-base": { type: "number", default: 0, minimum: 0, units: "meters", transition: true, requires: ["fill-extrusion-height"], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "fill-extrusion-vertical-gradient": { type: "boolean", default: true, transition: false, expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" } }, paint_line: { "line-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "line-color": { type: "color", default: "#000000", transition: true, requires: [{ "!": "line-pattern" }], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "line-translate": { type: "array", value: "number", length: 2, default: [0, 0], transition: true, units: "pixels", expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "line-translate-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "map", requires: ["line-translate"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "line-width": { type: "number", default: 1, minimum: 0, transition: true, units: "pixels", expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "line-gap-width": { type: "number", default: 0, minimum: 0, transition: true, units: "pixels", expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "line-offset": { type: "number", default: 0, transition: true, units: "pixels", expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "line-blur": { type: "number", default: 0, minimum: 0, transition: true, units: "pixels", expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "line-dasharray": { type: "array", value: "number", minimum: 0, transition: true, units: "line widths", requires: [{ "!": "line-pattern" }], expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "cross-faded-data-driven" }, "line-pattern": { type: "resolvedImage", transition: true, expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "cross-faded-data-driven" }, "line-gradient": { type: "color", transition: false, requires: [{ "!": "line-dasharray" }, { "!": "line-pattern" }, { source: "geojson", has: { lineMetrics: true } }], expression: { interpolated: true, parameters: ["line-progress"] }, "property-type": "color-ramp" } }, paint_circle: { "circle-radius": { type: "number", default: 5, minimum: 0, transition: true, units: "pixels", expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "circle-color": { type: "color", default: "#000000", transition: true, expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "circle-blur": { type: "number", default: 0, transition: true, expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "circle-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "circle-translate": { type: "array", value: "number", length: 2, default: [0, 0], transition: true, units: "pixels", expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "circle-translate-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "map", requires: ["circle-translate"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "circle-pitch-scale": { type: "enum", values: { map: {}, viewport: {} }, default: "map", expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "circle-pitch-alignment": { type: "enum", values: { map: {}, viewport: {} }, default: "viewport", expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "circle-stroke-width": { type: "number", default: 0, minimum: 0, transition: true, units: "pixels", expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "circle-stroke-color": { type: "color", default: "#000000", transition: true, expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "circle-stroke-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" } }, paint_heatmap: { "heatmap-radius": { type: "number", default: 30, minimum: 1, transition: true, units: "pixels", expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "heatmap-weight": { type: "number", default: 1, minimum: 0, transition: false, expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "heatmap-intensity": { type: "number", default: 1, minimum: 0, transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "heatmap-color": { type: "color", default: ["interpolate", ["linear"], ["heatmap-density"], 0, "rgba(0, 0, 255, 0)", 0.1, "royalblue", 0.3, "cyan", 0.5, "lime", 0.7, "yellow", 1, "red"], transition: false, expression: { interpolated: true, parameters: ["heatmap-density"] }, "property-type": "color-ramp" }, "heatmap-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" } }, paint_symbol: { "icon-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: true, requires: ["icon-image"], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "icon-color": { type: "color", default: "#000000", transition: true, requires: ["icon-image"], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "icon-halo-color": { type: "color", default: "rgba(0, 0, 0, 0)", transition: true, requires: ["icon-image"], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "icon-halo-width": { type: "number", default: 0, minimum: 0, transition: true, units: "pixels", requires: ["icon-image"], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "icon-halo-blur": { type: "number", default: 0, minimum: 0, transition: true, units: "pixels", requires: ["icon-image"], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "icon-translate": { type: "array", value: "number", length: 2, default: [0, 0], transition: true, units: "pixels", requires: ["icon-image"], expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-translate-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "map", requires: ["icon-image", "icon-translate"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: true, requires: ["text-field"], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "text-color": { type: "color", default: "#000000", transition: true, overridable: true, requires: ["text-field"], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "text-halo-color": { type: "color", default: "rgba(0, 0, 0, 0)", transition: true, requires: ["text-field"], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "text-halo-width": { type: "number", default: 0, minimum: 0, transition: true, units: "pixels", requires: ["text-field"], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "text-halo-blur": { type: "number", default: 0, minimum: 0, transition: true, units: "pixels", requires: ["text-field"], expression: { interpolated: true, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "text-translate": { type: "array", value: "number", length: 2, default: [0, 0], transition: true, units: "pixels", requires: ["text-field"], expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-translate-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "map", requires: ["text-field", "text-translate"], expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" } }, paint_raster: { "raster-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-hue-rotate": { type: "number", default: 0, period: 360, transition: true, units: "degrees", expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-brightness-min": { type: "number", default: 0, minimum: 0, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-brightness-max": { type: "number", default: 1, minimum: 0, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-saturation": { type: "number", default: 0, minimum: -1, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-contrast": { type: "number", default: 0, minimum: -1, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-resampling": { type: "enum", values: { linear: {}, nearest: {} }, default: "linear", expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-fade-duration": { type: "number", default: 300, minimum: 0, transition: false, units: "milliseconds", expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" } }, paint_hillshade: { "hillshade-illumination-direction": { type: "numberArray", default: 335, minimum: 0, maximum: 359, transition: false, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "hillshade-illumination-altitude": { type: "numberArray", default: 45, minimum: 0, maximum: 90, transition: false, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "hillshade-illumination-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "viewport", expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" }, "hillshade-exaggeration": { type: "number", default: 0.5, minimum: 0, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "hillshade-shadow-color": { type: "colorArray", default: "#000000", transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "hillshade-highlight-color": { type: "colorArray", default: "#FFFFFF", transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "hillshade-accent-color": { type: "color", default: "#000000", transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "hillshade-method": { type: "enum", values: { standard: {}, basic: {}, combined: {}, igor: {}, multidirectional: {} }, default: "standard", expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "data-constant" } }, "paint_color-relief": { "color-relief-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "color-relief-color": { type: "color", transition: false, expression: { interpolated: true, parameters: ["elevation"] }, "property-type": "color-ramp" } }, paint_background: { "background-color": { type: "color", default: "#000000", transition: true, requires: [{ "!": "background-pattern" }], expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" }, "background-pattern": { type: "resolvedImage", transition: true, expression: { interpolated: false, parameters: ["zoom"] }, "property-type": "cross-faded" }, "background-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: true, expression: { interpolated: true, parameters: ["zoom"] }, "property-type": "data-constant" } }, transition: { duration: { type: "number", default: 300, minimum: 0, units: "milliseconds" }, delay: { type: "number", default: 0, minimum: 0, units: "milliseconds" } }, "property-type": { "data-driven": { type: "property-type" }, "cross-faded": { type: "property-type" }, "cross-faded-data-driven": { type: "property-type" }, "color-ramp": { type: "property-type" }, "data-constant": { type: "property-type" }, constant: { type: "property-type" } }, promoteId: { "*": { type: "string" } } };
        const bt = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"];
        function wt(t2, e2) {
          const r2 = {};
          for (const e3 in t2) "ref" !== e3 && (r2[e3] = t2[e3]);
          return bt.forEach((t3) => {
            t3 in e2 && (r2[t3] = e2[t3]);
          }), r2;
        }
        function _t(t2, e2) {
          if (Array.isArray(t2)) {
            if (!Array.isArray(e2) || t2.length !== e2.length) return false;
            for (let r2 = 0; r2 < t2.length; r2++) if (!_t(t2[r2], e2[r2])) return false;
            return true;
          }
          if ("object" == typeof t2 && null !== t2 && null !== e2) {
            if ("object" != typeof e2) return false;
            if (Object.keys(t2).length !== Object.keys(e2).length) return false;
            for (const r2 in t2) if (!_t(t2[r2], e2[r2])) return false;
            return true;
          }
          return t2 === e2;
        }
        function At(t2, e2) {
          t2.push(e2);
        }
        function St(t2, e2, r2) {
          At(r2, { command: "addSource", args: [t2, e2[t2]] });
        }
        function kt(t2, e2, r2) {
          At(e2, { command: "removeSource", args: [t2] }), r2[t2] = true;
        }
        function Et(t2, e2, r2, n2) {
          kt(t2, r2, n2), St(t2, e2, r2);
        }
        function Tt(t2, e2, r2) {
          let n2;
          for (n2 in t2[r2]) if (Object.prototype.hasOwnProperty.call(t2[r2], n2) && "data" !== n2 && !_t(t2[r2][n2], e2[r2][n2])) return false;
          for (n2 in e2[r2]) if (Object.prototype.hasOwnProperty.call(e2[r2], n2) && "data" !== n2 && !_t(t2[r2][n2], e2[r2][n2])) return false;
          return true;
        }
        function It(t2, e2, r2, n2, i2, s2) {
          t2 = t2 || {}, e2 = e2 || {};
          for (const o2 in t2) Object.prototype.hasOwnProperty.call(t2, o2) && (_t(t2[o2], e2[o2]) || r2.push({ command: s2, args: [n2, o2, e2[o2], i2] }));
          for (const o2 in e2) Object.prototype.hasOwnProperty.call(e2, o2) && !Object.prototype.hasOwnProperty.call(t2, o2) && (_t(t2[o2], e2[o2]) || r2.push({ command: s2, args: [n2, o2, e2[o2], i2] }));
        }
        function Mt(t2) {
          return t2.id;
        }
        function Ft(t2, e2) {
          return t2[e2.id] = e2, t2;
        }
        class Dt {
          constructor(t2, e2, r2, n2) {
            this.message = (t2 ? `${t2}: ` : "") + r2, n2 && (this.identifier = n2), null != e2 && e2.__line__ && (this.line = e2.__line__);
          }
        }
        function Pt(t2, ...e2) {
          for (const r2 of e2) for (const e3 in r2) t2[e3] = r2[e3];
          return t2;
        }
        class zt extends Error {
          constructor(t2, e2) {
            super(e2), this.message = e2, this.key = t2;
          }
        }
        class Bt {
          constructor(t2, e2 = []) {
            this.parent = t2, this.bindings = {};
            for (const [t3, r2] of e2) this.bindings[t3] = r2;
          }
          concat(t2) {
            return new Bt(this, t2);
          }
          get(t2) {
            if (this.bindings[t2]) return this.bindings[t2];
            if (this.parent) return this.parent.get(t2);
            throw new Error(`${t2} not found in scope.`);
          }
          has(t2) {
            return !!this.bindings[t2] || !!this.parent && this.parent.has(t2);
          }
        }
        const Vt = { kind: "null" }, Ct = { kind: "number" }, Lt = { kind: "string" }, Ot = { kind: "boolean" }, Rt = { kind: "color" }, Nt = { kind: "projectionDefinition" }, $t = { kind: "object" }, Ut = { kind: "value" }, qt = { kind: "collator" }, jt = { kind: "formatted" }, Gt = { kind: "padding" }, Xt = { kind: "colorArray" }, Yt = { kind: "numberArray" }, Zt = { kind: "resolvedImage" }, Ht = { kind: "variableAnchorOffsetCollection" };
        function Kt(t2, e2) {
          return { kind: "array", itemType: t2, N: e2 };
        }
        function Wt(t2) {
          if ("array" === t2.kind) {
            const e2 = Wt(t2.itemType);
            return "number" == typeof t2.N ? `array<${e2}, ${t2.N}>` : "value" === t2.itemType.kind ? "array" : `array<${e2}>`;
          }
          return t2.kind;
        }
        const Jt = [Vt, Ct, Lt, Ot, Rt, Nt, jt, $t, Kt(Ut), Gt, Yt, Xt, Zt, Ht];
        function Qt(t2, e2) {
          if ("error" === e2.kind) return null;
          if ("array" === t2.kind) {
            if ("array" === e2.kind && (0 === e2.N && "value" === e2.itemType.kind || !Qt(t2.itemType, e2.itemType)) && ("number" != typeof t2.N || t2.N === e2.N)) return null;
          } else {
            if (t2.kind === e2.kind) return null;
            if ("value" === t2.kind) {
              for (const t3 of Jt) if (!Qt(t3, e2)) return null;
            }
          }
          return `Expected ${Wt(t2)} but found ${Wt(e2)} instead.`;
        }
        function te(t2, e2) {
          return e2.some((e3) => e3.kind === t2.kind);
        }
        function ee(t2, e2) {
          return e2.some((e3) => "null" === e3 ? null === t2 : "array" === e3 ? Array.isArray(t2) : "object" === e3 ? t2 && !Array.isArray(t2) && "object" == typeof t2 : e3 === typeof t2);
        }
        function re(t2, e2) {
          return "array" === t2.kind && "array" === e2.kind ? t2.itemType.kind === e2.itemType.kind && "number" == typeof t2.N : t2.kind === e2.kind;
        }
        const ne = 0.96422, ie = 0.82521, se = 4 / 29, oe = 6 / 29, ae = 3 * oe * oe, le = oe * oe * oe, ue = Math.PI / 180, ce = 180 / Math.PI;
        function he(t2) {
          return (t2 %= 360) < 0 && (t2 += 360), t2;
        }
        function pe([t2, e2, r2, n2]) {
          let i2, s2;
          const o2 = de((0.2225045 * (t2 = fe(t2)) + 0.7168786 * (e2 = fe(e2)) + 0.0606169 * (r2 = fe(r2))) / 1);
          t2 === e2 && e2 === r2 ? i2 = s2 = o2 : (i2 = de((0.4360747 * t2 + 0.3850649 * e2 + 0.1430804 * r2) / ne), s2 = de((0.0139322 * t2 + 0.0971045 * e2 + 0.7141733 * r2) / ie));
          const a2 = 116 * o2 - 16;
          return [a2 < 0 ? 0 : a2, 500 * (i2 - o2), 200 * (o2 - s2), n2];
        }
        function fe(t2) {
          return t2 <= 0.04045 ? t2 / 12.92 : Math.pow((t2 + 0.055) / 1.055, 2.4);
        }
        function de(t2) {
          return t2 > le ? Math.pow(t2, 1 / 3) : t2 / ae + se;
        }
        function ye([t2, e2, r2, n2]) {
          let i2 = (t2 + 16) / 116, s2 = isNaN(e2) ? i2 : i2 + e2 / 500, o2 = isNaN(r2) ? i2 : i2 - r2 / 200;
          return i2 = 1 * ge(i2), s2 = ne * ge(s2), o2 = ie * ge(o2), [me(3.1338561 * s2 - 1.6168667 * i2 - 0.4906146 * o2), me(-0.9787684 * s2 + 1.9161415 * i2 + 0.033454 * o2), me(0.0719453 * s2 - 0.2289914 * i2 + 1.4052427 * o2), n2];
        }
        function me(t2) {
          return (t2 = t2 <= 304e-5 ? 12.92 * t2 : 1.055 * Math.pow(t2, 1 / 2.4) - 0.055) < 0 ? 0 : t2 > 1 ? 1 : t2;
        }
        function ge(t2) {
          return t2 > oe ? t2 * t2 * t2 : ae * (t2 - se);
        }
        const xe = Object.hasOwn || function(t2, e2) {
          return Object.prototype.hasOwnProperty.call(t2, e2);
        };
        function ve(t2, e2) {
          return xe(t2, e2) ? t2[e2] : void 0;
        }
        function be(t2) {
          return parseInt(t2.padEnd(2, t2), 16) / 255;
        }
        function we(t2, e2) {
          return _e(e2 ? t2 / 100 : t2, 0, 1);
        }
        function _e(t2, e2, r2) {
          return Math.min(Math.max(e2, t2), r2);
        }
        function Ae(t2) {
          return !t2.some(Number.isNaN);
        }
        const Se = { aliceblue: [240, 248, 255], antiquewhite: [250, 235, 215], aqua: [0, 255, 255], aquamarine: [127, 255, 212], azure: [240, 255, 255], beige: [245, 245, 220], bisque: [255, 228, 196], black: [0, 0, 0], blanchedalmond: [255, 235, 205], blue: [0, 0, 255], blueviolet: [138, 43, 226], brown: [165, 42, 42], burlywood: [222, 184, 135], cadetblue: [95, 158, 160], chartreuse: [127, 255, 0], chocolate: [210, 105, 30], coral: [255, 127, 80], cornflowerblue: [100, 149, 237], cornsilk: [255, 248, 220], crimson: [220, 20, 60], cyan: [0, 255, 255], darkblue: [0, 0, 139], darkcyan: [0, 139, 139], darkgoldenrod: [184, 134, 11], darkgray: [169, 169, 169], darkgreen: [0, 100, 0], darkgrey: [169, 169, 169], darkkhaki: [189, 183, 107], darkmagenta: [139, 0, 139], darkolivegreen: [85, 107, 47], darkorange: [255, 140, 0], darkorchid: [153, 50, 204], darkred: [139, 0, 0], darksalmon: [233, 150, 122], darkseagreen: [143, 188, 143], darkslateblue: [72, 61, 139], darkslategray: [47, 79, 79], darkslategrey: [47, 79, 79], darkturquoise: [0, 206, 209], darkviolet: [148, 0, 211], deeppink: [255, 20, 147], deepskyblue: [0, 191, 255], dimgray: [105, 105, 105], dimgrey: [105, 105, 105], dodgerblue: [30, 144, 255], firebrick: [178, 34, 34], floralwhite: [255, 250, 240], forestgreen: [34, 139, 34], fuchsia: [255, 0, 255], gainsboro: [220, 220, 220], ghostwhite: [248, 248, 255], gold: [255, 215, 0], goldenrod: [218, 165, 32], gray: [128, 128, 128], green: [0, 128, 0], greenyellow: [173, 255, 47], grey: [128, 128, 128], honeydew: [240, 255, 240], hotpink: [255, 105, 180], indianred: [205, 92, 92], indigo: [75, 0, 130], ivory: [255, 255, 240], khaki: [240, 230, 140], lavender: [230, 230, 250], lavenderblush: [255, 240, 245], lawngreen: [124, 252, 0], lemonchiffon: [255, 250, 205], lightblue: [173, 216, 230], lightcoral: [240, 128, 128], lightcyan: [224, 255, 255], lightgoldenrodyellow: [250, 250, 210], lightgray: [211, 211, 211], lightgreen: [144, 238, 144], lightgrey: [211, 211, 211], lightpink: [255, 182, 193], lightsalmon: [255, 160, 122], lightseagreen: [32, 178, 170], lightskyblue: [135, 206, 250], lightslategray: [119, 136, 153], lightslategrey: [119, 136, 153], lightsteelblue: [176, 196, 222], lightyellow: [255, 255, 224], lime: [0, 255, 0], limegreen: [50, 205, 50], linen: [250, 240, 230], magenta: [255, 0, 255], maroon: [128, 0, 0], mediumaquamarine: [102, 205, 170], mediumblue: [0, 0, 205], mediumorchid: [186, 85, 211], mediumpurple: [147, 112, 219], mediumseagreen: [60, 179, 113], mediumslateblue: [123, 104, 238], mediumspringgreen: [0, 250, 154], mediumturquoise: [72, 209, 204], mediumvioletred: [199, 21, 133], midnightblue: [25, 25, 112], mintcream: [245, 255, 250], mistyrose: [255, 228, 225], moccasin: [255, 228, 181], navajowhite: [255, 222, 173], navy: [0, 0, 128], oldlace: [253, 245, 230], olive: [128, 128, 0], olivedrab: [107, 142, 35], orange: [255, 165, 0], orangered: [255, 69, 0], orchid: [218, 112, 214], palegoldenrod: [238, 232, 170], palegreen: [152, 251, 152], paleturquoise: [175, 238, 238], palevioletred: [219, 112, 147], papayawhip: [255, 239, 213], peachpuff: [255, 218, 185], peru: [205, 133, 63], pink: [255, 192, 203], plum: [221, 160, 221], powderblue: [176, 224, 230], purple: [128, 0, 128], rebeccapurple: [102, 51, 153], red: [255, 0, 0], rosybrown: [188, 143, 143], royalblue: [65, 105, 225], saddlebrown: [139, 69, 19], salmon: [250, 128, 114], sandybrown: [244, 164, 96], seagreen: [46, 139, 87], seashell: [255, 245, 238], sienna: [160, 82, 45], silver: [192, 192, 192], skyblue: [135, 206, 235], slateblue: [106, 90, 205], slategray: [112, 128, 144], slategrey: [112, 128, 144], snow: [255, 250, 250], springgreen: [0, 255, 127], steelblue: [70, 130, 180], tan: [210, 180, 140], teal: [0, 128, 128], thistle: [216, 191, 216], tomato: [255, 99, 71], turquoise: [64, 224, 208], violet: [238, 130, 238], wheat: [245, 222, 179], white: [255, 255, 255], whitesmoke: [245, 245, 245], yellow: [255, 255, 0], yellowgreen: [154, 205, 50] };
        function ke(t2, e2, r2) {
          return t2 + r2 * (e2 - t2);
        }
        function Ee(t2, e2, r2) {
          return t2.map((t3, n2) => ke(t3, e2[n2], r2));
        }
        class Te {
          constructor(t2, e2, r2, n2 = 1, i2 = true) {
            this.r = t2, this.g = e2, this.b = r2, this.a = n2, i2 || (this.r *= n2, this.g *= n2, this.b *= n2, n2 || this.overwriteGetter("rgb", [t2, e2, r2, n2]));
          }
          static parse(t2) {
            if (t2 instanceof Te) return t2;
            if ("string" != typeof t2) return;
            const e2 = function(t3) {
              if ("transparent" === (t3 = t3.toLowerCase().trim())) return [0, 0, 0, 0];
              const e3 = ve(Se, t3);
              if (e3) {
                const [t4, r3, n2] = e3;
                return [t4 / 255, r3 / 255, n2 / 255, 1];
              }
              if (t3.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(t3)) {
                const e4 = t3.length < 6 ? 1 : 2;
                let r3 = 1;
                return [be(t3.slice(r3, r3 += e4)), be(t3.slice(r3, r3 += e4)), be(t3.slice(r3, r3 += e4)), be(t3.slice(r3, r3 + e4) || "ff")];
              }
              if (t3.startsWith("rgb")) {
                const e4 = t3.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                if (e4) {
                  const [t4, r3, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2] = e4, f2 = [i2 || " ", a2 || " ", c2].join("");
                  if ("  " === f2 || "  /" === f2 || ",," === f2 || ",,," === f2) {
                    const t5 = [n2, o2, u2].join(""), e5 = "%%%" === t5 ? 100 : "" === t5 ? 255 : 0;
                    if (e5) {
                      const t6 = [_e(+r3 / e5, 0, 1), _e(+s2 / e5, 0, 1), _e(+l2 / e5, 0, 1), h2 ? we(+h2, p2) : 1];
                      if (Ae(t6)) return t6;
                    }
                  }
                  return;
                }
              }
              const r2 = t3.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
              if (r2) {
                const [t4, e4, n2, i2, s2, o2, a2, l2, u2] = r2, c2 = [n2 || " ", s2 || " ", a2].join("");
                if ("  " === c2 || "  /" === c2 || ",," === c2 || ",,," === c2) {
                  const t5 = [+e4, _e(+i2, 0, 100), _e(+o2, 0, 100), l2 ? we(+l2, u2) : 1];
                  if (Ae(t5)) return function([t6, e5, r3, n3]) {
                    function i3(n4) {
                      const i4 = (n4 + t6 / 30) % 12, s3 = e5 * Math.min(r3, 1 - r3);
                      return r3 - s3 * Math.max(-1, Math.min(i4 - 3, 9 - i4, 1));
                    }
                    return t6 = he(t6), e5 /= 100, r3 /= 100, [i3(0), i3(8), i3(4), n3];
                  }(t5);
                }
              }
            }(t2);
            return e2 ? new Te(...e2, false) : void 0;
          }
          get rgb() {
            const { r: t2, g: e2, b: r2, a: n2 } = this, i2 = n2 || 1 / 0;
            return this.overwriteGetter("rgb", [t2 / i2, e2 / i2, r2 / i2, n2]);
          }
          get hcl() {
            return this.overwriteGetter("hcl", function(t2) {
              const [e2, r2, n2, i2] = pe(t2), s2 = Math.sqrt(r2 * r2 + n2 * n2);
              return [Math.round(1e4 * s2) ? he(Math.atan2(n2, r2) * ce) : NaN, s2, e2, i2];
            }(this.rgb));
          }
          get lab() {
            return this.overwriteGetter("lab", pe(this.rgb));
          }
          overwriteGetter(t2, e2) {
            return Object.defineProperty(this, t2, { value: e2 }), e2;
          }
          toString() {
            const [t2, e2, r2, n2] = this.rgb;
            return `rgba(${[t2, e2, r2].map((t3) => Math.round(255 * t3)).join(",")},${n2})`;
          }
          static interpolate(t2, e2, r2, n2 = "rgb") {
            switch (n2) {
              case "rgb": {
                const [n3, i2, s2, o2] = Ee(t2.rgb, e2.rgb, r2);
                return new Te(n3, i2, s2, o2, false);
              }
              case "hcl": {
                const [n3, i2, s2, o2] = t2.hcl, [a2, l2, u2, c2] = e2.hcl;
                let h2, p2;
                if (isNaN(n3) || isNaN(a2)) isNaN(n3) ? isNaN(a2) ? h2 = NaN : (h2 = a2, 1 !== s2 && 0 !== s2 || (p2 = l2)) : (h2 = n3, 1 !== u2 && 0 !== u2 || (p2 = i2));
                else {
                  let t3 = a2 - n3;
                  a2 > n3 && t3 > 180 ? t3 -= 360 : a2 < n3 && n3 - a2 > 180 && (t3 += 360), h2 = n3 + r2 * t3;
                }
                const [f2, d2, y2, m2] = function([t3, e3, r3, n4]) {
                  return t3 = isNaN(t3) ? 0 : t3 * ue, ye([r3, Math.cos(t3) * e3, Math.sin(t3) * e3, n4]);
                }([h2, null != p2 ? p2 : ke(i2, l2, r2), ke(s2, u2, r2), ke(o2, c2, r2)]);
                return new Te(f2, d2, y2, m2, false);
              }
              case "lab": {
                const [n3, i2, s2, o2] = ye(Ee(t2.lab, e2.lab, r2));
                return new Te(n3, i2, s2, o2, false);
              }
            }
          }
        }
        Te.black = new Te(0, 0, 0, 1), Te.white = new Te(1, 1, 1, 1), Te.transparent = new Te(0, 0, 0, 0), Te.red = new Te(1, 0, 0, 1);
        class Ie {
          constructor(t2, e2, r2) {
            this.sensitivity = t2 ? e2 ? "variant" : "case" : e2 ? "accent" : "base", this.locale = r2, this.collator = new Intl.Collator(this.locale ? this.locale : [], { sensitivity: this.sensitivity, usage: "search" });
          }
          compare(t2, e2) {
            return this.collator.compare(t2, e2);
          }
          resolvedLocale() {
            return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
          }
        }
        const Me = ["bottom", "center", "top"];
        class Fe {
          constructor(t2, e2, r2, n2, i2, s2) {
            this.text = t2, this.image = e2, this.scale = r2, this.fontStack = n2, this.textColor = i2, this.verticalAlign = s2;
          }
        }
        class De {
          constructor(t2) {
            this.sections = t2;
          }
          static fromString(t2) {
            return new De([new Fe(t2, null, null, null, null, null)]);
          }
          isEmpty() {
            return 0 === this.sections.length || !this.sections.some((t2) => 0 !== t2.text.length || t2.image && 0 !== t2.image.name.length);
          }
          static factory(t2) {
            return t2 instanceof De ? t2 : De.fromString(t2);
          }
          toString() {
            return 0 === this.sections.length ? "" : this.sections.map((t2) => t2.text).join("");
          }
        }
        class Pe {
          constructor(t2) {
            this.values = t2.slice();
          }
          static parse(t2) {
            if (t2 instanceof Pe) return t2;
            if ("number" == typeof t2) return new Pe([t2, t2, t2, t2]);
            if (Array.isArray(t2) && !(t2.length < 1 || t2.length > 4)) {
              for (const e2 of t2) if ("number" != typeof e2) return;
              switch (t2.length) {
                case 1:
                  t2 = [t2[0], t2[0], t2[0], t2[0]];
                  break;
                case 2:
                  t2 = [t2[0], t2[1], t2[0], t2[1]];
                  break;
                case 3:
                  t2 = [t2[0], t2[1], t2[2], t2[1]];
              }
              return new Pe(t2);
            }
          }
          toString() {
            return JSON.stringify(this.values);
          }
          static interpolate(t2, e2, r2) {
            return new Pe(Ee(t2.values, e2.values, r2));
          }
        }
        class ze {
          constructor(t2) {
            this.values = t2.slice();
          }
          static parse(t2) {
            if (t2 instanceof ze) return t2;
            if ("number" == typeof t2) return new ze([t2]);
            if (Array.isArray(t2)) {
              for (const e2 of t2) if ("number" != typeof e2) return;
              return new ze(t2);
            }
          }
          toString() {
            return JSON.stringify(this.values);
          }
          static interpolate(t2, e2, r2) {
            return new ze(Ee(t2.values, e2.values, r2));
          }
        }
        class Be {
          constructor(t2) {
            this.values = t2.slice();
          }
          static parse(t2) {
            if (t2 instanceof Be) return t2;
            if ("string" == typeof t2) {
              const e3 = Te.parse(t2);
              if (!e3) return;
              return new Be([e3]);
            }
            if (!Array.isArray(t2)) return;
            const e2 = [];
            for (const r2 of t2) {
              if ("string" != typeof r2) return;
              const t3 = Te.parse(r2);
              if (!t3) return;
              e2.push(t3);
            }
            return new Be(e2);
          }
          toString() {
            return JSON.stringify(this.values);
          }
          static interpolate(t2, e2, r2, n2 = "rgb") {
            const i2 = [];
            if (t2.values.length != e2.values.length) throw new Error(`colorArray: Arrays have mismatched length (${t2.values.length} vs. ${e2.values.length}), cannot interpolate.`);
            for (let s2 = 0; s2 < t2.values.length; s2++) i2.push(Te.interpolate(t2.values[s2], e2.values[s2], r2, n2));
            return new Be(i2);
          }
        }
        class Ve extends Error {
          constructor(t2) {
            super(t2), this.name = "RuntimeError";
          }
          toJSON() {
            return this.message;
          }
        }
        const Ce = /* @__PURE__ */ new Set(["center", "left", "right", "top", "bottom", "top-left", "top-right", "bottom-left", "bottom-right"]);
        class Le {
          constructor(t2) {
            this.values = t2.slice();
          }
          static parse(t2) {
            if (t2 instanceof Le) return t2;
            if (Array.isArray(t2) && !(t2.length < 1) && t2.length % 2 == 0) {
              for (let e2 = 0; e2 < t2.length; e2 += 2) {
                const r2 = t2[e2], n2 = t2[e2 + 1];
                if ("string" != typeof r2 || !Ce.has(r2)) return;
                if (!Array.isArray(n2) || 2 !== n2.length || "number" != typeof n2[0] || "number" != typeof n2[1]) return;
              }
              return new Le(t2);
            }
          }
          toString() {
            return JSON.stringify(this.values);
          }
          static interpolate(t2, e2, r2) {
            const n2 = t2.values, i2 = e2.values;
            if (n2.length !== i2.length) throw new Ve(`Cannot interpolate values of different length. from: ${t2.toString()}, to: ${e2.toString()}`);
            const s2 = [];
            for (let t3 = 0; t3 < n2.length; t3 += 2) {
              if (n2[t3] !== i2[t3]) throw new Ve(`Cannot interpolate values containing mismatched anchors. from[${t3}]: ${n2[t3]}, to[${t3}]: ${i2[t3]}`);
              s2.push(n2[t3]);
              const [e3, o2] = n2[t3 + 1], [a2, l2] = i2[t3 + 1];
              s2.push([ke(e3, a2, r2), ke(o2, l2, r2)]);
            }
            return new Le(s2);
          }
        }
        class Oe {
          constructor(t2) {
            this.name = t2.name, this.available = t2.available;
          }
          toString() {
            return this.name;
          }
          static fromString(t2) {
            return t2 ? new Oe({ name: t2, available: false }) : null;
          }
        }
        class Re {
          constructor(t2, e2, r2) {
            this.from = t2, this.to = e2, this.transition = r2;
          }
          static interpolate(t2, e2, r2) {
            return new Re(t2, e2, r2);
          }
          static parse(t2) {
            return t2 instanceof Re ? t2 : Array.isArray(t2) && 3 === t2.length && "string" == typeof t2[0] && "string" == typeof t2[1] && "number" == typeof t2[2] ? new Re(t2[0], t2[1], t2[2]) : "object" == typeof t2 && "string" == typeof t2.from && "string" == typeof t2.to && "number" == typeof t2.transition ? new Re(t2.from, t2.to, t2.transition) : "string" == typeof t2 ? new Re(t2, t2, 1) : void 0;
          }
        }
        function Ne(t2, e2, r2, n2) {
          return "number" == typeof t2 && t2 >= 0 && t2 <= 255 && "number" == typeof e2 && e2 >= 0 && e2 <= 255 && "number" == typeof r2 && r2 >= 0 && r2 <= 255 ? void 0 === n2 || "number" == typeof n2 && n2 >= 0 && n2 <= 1 ? null : `Invalid rgba value [${[t2, e2, r2, n2].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n2 ? [t2, e2, r2, n2] : [t2, e2, r2]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function $e(t2) {
          if (null === t2 || "string" == typeof t2 || "boolean" == typeof t2 || "number" == typeof t2 || t2 instanceof Re || t2 instanceof Te || t2 instanceof Ie || t2 instanceof De || t2 instanceof Pe || t2 instanceof ze || t2 instanceof Be || t2 instanceof Le || t2 instanceof Oe) return true;
          if (Array.isArray(t2)) {
            for (const e2 of t2) if (!$e(e2)) return false;
            return true;
          }
          if ("object" == typeof t2) {
            for (const e2 in t2) if (!$e(t2[e2])) return false;
            return true;
          }
          return false;
        }
        function Ue(t2) {
          if (null === t2) return Vt;
          if ("string" == typeof t2) return Lt;
          if ("boolean" == typeof t2) return Ot;
          if ("number" == typeof t2) return Ct;
          if (t2 instanceof Te) return Rt;
          if (t2 instanceof Re) return Nt;
          if (t2 instanceof Ie) return qt;
          if (t2 instanceof De) return jt;
          if (t2 instanceof Pe) return Gt;
          if (t2 instanceof ze) return Yt;
          if (t2 instanceof Be) return Xt;
          if (t2 instanceof Le) return Ht;
          if (t2 instanceof Oe) return Zt;
          if (Array.isArray(t2)) {
            const e2 = t2.length;
            let r2;
            for (const e3 of t2) {
              const t3 = Ue(e3);
              if (r2) {
                if (r2 === t3) continue;
                r2 = Ut;
                break;
              }
              r2 = t3;
            }
            return Kt(r2 || Ut, e2);
          }
          return $t;
        }
        function qe(t2) {
          const e2 = typeof t2;
          return null === t2 ? "" : "string" === e2 || "number" === e2 || "boolean" === e2 ? String(t2) : t2 instanceof Te || t2 instanceof Re || t2 instanceof De || t2 instanceof Pe || t2 instanceof ze || t2 instanceof Be || t2 instanceof Le || t2 instanceof Oe ? t2.toString() : JSON.stringify(t2);
        }
        class je {
          constructor(t2, e2) {
            this.type = t2, this.value = e2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length) return e2.error(`'literal' expression requires exactly one argument, but found ${t2.length - 1} instead.`);
            if (!$e(t2[1])) return e2.error("invalid value");
            const r2 = t2[1];
            let n2 = Ue(r2);
            const i2 = e2.expectedType;
            return "array" !== n2.kind || 0 !== n2.N || !i2 || "array" !== i2.kind || "number" == typeof i2.N && 0 !== i2.N || (n2 = i2), new je(n2, r2);
          }
          evaluate() {
            return this.value;
          }
          eachChild() {
          }
          outputDefined() {
            return true;
          }
        }
        const Ge = { string: Lt, number: Ct, boolean: Ot, object: $t };
        class Xe {
          constructor(t2, e2) {
            this.type = t2, this.args = e2;
          }
          static parse(t2, e2) {
            if (t2.length < 2) return e2.error("Expected at least one argument.");
            let r2, n2 = 1;
            const i2 = t2[0];
            if ("array" === i2) {
              let i3, s3;
              if (t2.length > 2) {
                const r3 = t2[1];
                if ("string" != typeof r3 || !(r3 in Ge) || "object" === r3) return e2.error('The item type argument of "array" must be one of string, number, boolean', 1);
                i3 = Ge[r3], n2++;
              } else i3 = Ut;
              if (t2.length > 3) {
                if (null !== t2[2] && ("number" != typeof t2[2] || t2[2] < 0 || t2[2] !== Math.floor(t2[2]))) return e2.error('The length argument to "array" must be a positive integer literal', 2);
                s3 = t2[2], n2++;
              }
              r2 = Kt(i3, s3);
            } else {
              if (!Ge[i2]) throw new Error(`Types doesn't contain name = ${i2}`);
              r2 = Ge[i2];
            }
            const s2 = [];
            for (; n2 < t2.length; n2++) {
              const r3 = e2.parse(t2[n2], n2, Ut);
              if (!r3) return null;
              s2.push(r3);
            }
            return new Xe(r2, s2);
          }
          evaluate(t2) {
            for (let e2 = 0; e2 < this.args.length; e2++) {
              const r2 = this.args[e2].evaluate(t2);
              if (!Qt(this.type, Ue(r2))) return r2;
              if (e2 === this.args.length - 1) throw new Ve(`Expected value to be of type ${Wt(this.type)}, but found ${Wt(Ue(r2))} instead.`);
            }
            throw new Error();
          }
          eachChild(t2) {
            this.args.forEach(t2);
          }
          outputDefined() {
            return this.args.every((t2) => t2.outputDefined());
          }
        }
        const Ye = { "to-boolean": Ot, "to-color": Rt, "to-number": Ct, "to-string": Lt };
        class Ze {
          constructor(t2, e2) {
            this.type = t2, this.args = e2;
          }
          static parse(t2, e2) {
            if (t2.length < 2) return e2.error("Expected at least one argument.");
            const r2 = t2[0];
            if (!Ye[r2]) throw new Error(`Can't parse ${r2} as it is not part of the known types`);
            if (("to-boolean" === r2 || "to-string" === r2) && 2 !== t2.length) return e2.error("Expected one argument.");
            const n2 = Ye[r2], i2 = [];
            for (let r3 = 1; r3 < t2.length; r3++) {
              const n3 = e2.parse(t2[r3], r3, Ut);
              if (!n3) return null;
              i2.push(n3);
            }
            return new Ze(n2, i2);
          }
          evaluate(t2) {
            switch (this.type.kind) {
              case "boolean":
                return Boolean(this.args[0].evaluate(t2));
              case "color": {
                let e2, r2;
                for (const n2 of this.args) {
                  if (e2 = n2.evaluate(t2), r2 = null, e2 instanceof Te) return e2;
                  if ("string" == typeof e2) {
                    const r3 = t2.parseColor(e2);
                    if (r3) return r3;
                  } else if (Array.isArray(e2) && (r2 = e2.length < 3 || e2.length > 4 ? `Invalid rgba value ${JSON.stringify(e2)}: expected an array containing either three or four numeric values.` : Ne(e2[0], e2[1], e2[2], e2[3]), !r2)) return new Te(e2[0] / 255, e2[1] / 255, e2[2] / 255, e2[3]);
                }
                throw new Ve(r2 || `Could not parse color from value '${"string" == typeof e2 ? e2 : JSON.stringify(e2)}'`);
              }
              case "padding": {
                let e2;
                for (const r2 of this.args) {
                  e2 = r2.evaluate(t2);
                  const n2 = Pe.parse(e2);
                  if (n2) return n2;
                }
                throw new Ve(`Could not parse padding from value '${"string" == typeof e2 ? e2 : JSON.stringify(e2)}'`);
              }
              case "numberArray": {
                let e2;
                for (const r2 of this.args) {
                  e2 = r2.evaluate(t2);
                  const n2 = ze.parse(e2);
                  if (n2) return n2;
                }
                throw new Ve(`Could not parse numberArray from value '${"string" == typeof e2 ? e2 : JSON.stringify(e2)}'`);
              }
              case "colorArray": {
                let e2;
                for (const r2 of this.args) {
                  e2 = r2.evaluate(t2);
                  const n2 = Be.parse(e2);
                  if (n2) return n2;
                }
                throw new Ve(`Could not parse colorArray from value '${"string" == typeof e2 ? e2 : JSON.stringify(e2)}'`);
              }
              case "variableAnchorOffsetCollection": {
                let e2;
                for (const r2 of this.args) {
                  e2 = r2.evaluate(t2);
                  const n2 = Le.parse(e2);
                  if (n2) return n2;
                }
                throw new Ve(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof e2 ? e2 : JSON.stringify(e2)}'`);
              }
              case "number": {
                let e2 = null;
                for (const r2 of this.args) {
                  if (e2 = r2.evaluate(t2), null === e2) return 0;
                  const n2 = Number(e2);
                  if (!isNaN(n2)) return n2;
                }
                throw new Ve(`Could not convert ${JSON.stringify(e2)} to number.`);
              }
              case "formatted":
                return De.fromString(qe(this.args[0].evaluate(t2)));
              case "resolvedImage":
                return Oe.fromString(qe(this.args[0].evaluate(t2)));
              case "projectionDefinition":
                return this.args[0].evaluate(t2);
              default:
                return qe(this.args[0].evaluate(t2));
            }
          }
          eachChild(t2) {
            this.args.forEach(t2);
          }
          outputDefined() {
            return this.args.every((t2) => t2.outputDefined());
          }
        }
        const He = ["Unknown", "Point", "LineString", "Polygon"];
        class Ke {
          constructor() {
            this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = /* @__PURE__ */ new Map(), this.availableImages = null, this.canonical = null;
          }
          id() {
            return this.feature && "id" in this.feature ? this.feature.id : null;
          }
          geometryType() {
            return this.feature ? "number" == typeof this.feature.type ? He[this.feature.type] : this.feature.type : null;
          }
          geometry() {
            return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
          }
          canonicalID() {
            return this.canonical;
          }
          properties() {
            return this.feature && this.feature.properties || {};
          }
          parseColor(t2) {
            let e2 = this._parseColorCache.get(t2);
            return e2 || (e2 = Te.parse(t2), this._parseColorCache.set(t2, e2)), e2;
          }
        }
        class We {
          constructor(t2, e2, r2 = [], n2, i2 = new Bt(), s2 = []) {
            this.registry = t2, this.path = r2, this.key = r2.map((t3) => `[${t3}]`).join(""), this.scope = i2, this.errors = s2, this.expectedType = n2, this._isConstant = e2;
          }
          parse(t2, e2, r2, n2, i2 = {}) {
            return e2 ? this.concat(e2, r2, n2)._parse(t2, i2) : this._parse(t2, i2);
          }
          _parse(t2, e2) {
            function r2(t3, e3, r3) {
              return "assert" === r3 ? new Xe(e3, [t3]) : "coerce" === r3 ? new Ze(e3, [t3]) : t3;
            }
            if (null !== t2 && "string" != typeof t2 && "boolean" != typeof t2 && "number" != typeof t2 || (t2 = ["literal", t2]), Array.isArray(t2)) {
              if (0 === t2.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
              const n2 = t2[0];
              if ("string" != typeof n2) return this.error(`Expression name must be a string, but found ${typeof n2} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
              const i2 = this.registry[n2];
              if (i2) {
                let n3 = i2.parse(t2, this);
                if (!n3) return null;
                if (this.expectedType) {
                  const t3 = this.expectedType, i3 = n3.type;
                  if ("string" !== t3.kind && "number" !== t3.kind && "boolean" !== t3.kind && "object" !== t3.kind && "array" !== t3.kind || "value" !== i3.kind) {
                    if ("projectionDefinition" === t3.kind && ["string", "array"].includes(i3.kind) || ["color", "formatted", "resolvedImage"].includes(t3.kind) && ["value", "string"].includes(i3.kind) || ["padding", "numberArray"].includes(t3.kind) && ["value", "number", "array"].includes(i3.kind) || "colorArray" === t3.kind && ["value", "string", "array"].includes(i3.kind) || "variableAnchorOffsetCollection" === t3.kind && ["value", "array"].includes(i3.kind)) n3 = r2(n3, t3, e2.typeAnnotation || "coerce");
                    else if (this.checkSubtype(t3, i3)) return null;
                  } else n3 = r2(n3, t3, e2.typeAnnotation || "assert");
                }
                if (!(n3 instanceof je) && "resolvedImage" !== n3.type.kind && this._isConstant(n3)) {
                  const t3 = new Ke();
                  try {
                    n3 = new je(n3.type, n3.evaluate(t3));
                  } catch (t4) {
                    return this.error(t4.message), null;
                  }
                }
                return n3;
              }
              return this.error(`Unknown expression "${n2}". If you wanted a literal array, use ["literal", [...]].`, 0);
            }
            return this.error(void 0 === t2 ? "'undefined' value invalid. Use null instead." : "object" == typeof t2 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t2} instead.`);
          }
          concat(t2, e2, r2) {
            const n2 = "number" == typeof t2 ? this.path.concat(t2) : this.path, i2 = r2 ? this.scope.concat(r2) : this.scope;
            return new We(this.registry, this._isConstant, n2, e2 || null, i2, this.errors);
          }
          error(t2, ...e2) {
            const r2 = `${this.key}${e2.map((t3) => `[${t3}]`).join("")}`;
            this.errors.push(new zt(r2, t2));
          }
          checkSubtype(t2, e2) {
            const r2 = Qt(t2, e2);
            return r2 && this.error(r2), r2;
          }
        }
        class Je {
          constructor(t2, e2) {
            this.type = e2.type, this.bindings = [].concat(t2), this.result = e2;
          }
          evaluate(t2) {
            return this.result.evaluate(t2);
          }
          eachChild(t2) {
            for (const e2 of this.bindings) t2(e2[1]);
            t2(this.result);
          }
          static parse(t2, e2) {
            if (t2.length < 4) return e2.error(`Expected at least 3 arguments, but found ${t2.length - 1} instead.`);
            const r2 = [];
            for (let n3 = 1; n3 < t2.length - 1; n3 += 2) {
              const i2 = t2[n3];
              if ("string" != typeof i2) return e2.error(`Expected string, but found ${typeof i2} instead.`, n3);
              if (/[^a-zA-Z0-9_]/.test(i2)) return e2.error("Variable names must contain only alphanumeric characters or '_'.", n3);
              const s2 = e2.parse(t2[n3 + 1], n3 + 1);
              if (!s2) return null;
              r2.push([i2, s2]);
            }
            const n2 = e2.parse(t2[t2.length - 1], t2.length - 1, e2.expectedType, r2);
            return n2 ? new Je(r2, n2) : null;
          }
          outputDefined() {
            return this.result.outputDefined();
          }
        }
        class Qe {
          constructor(t2, e2) {
            this.type = e2.type, this.name = t2, this.boundExpression = e2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length || "string" != typeof t2[1]) return e2.error("'var' expression requires exactly one string literal argument.");
            const r2 = t2[1];
            return e2.scope.has(r2) ? new Qe(r2, e2.scope.get(r2)) : e2.error(`Unknown variable "${r2}". Make sure "${r2}" has been bound in an enclosing "let" expression before using it.`, 1);
          }
          evaluate(t2) {
            return this.boundExpression.evaluate(t2);
          }
          eachChild() {
          }
          outputDefined() {
            return false;
          }
        }
        class tr {
          constructor(t2, e2, r2) {
            this.type = t2, this.index = e2, this.input = r2;
          }
          static parse(t2, e2) {
            if (3 !== t2.length) return e2.error(`Expected 2 arguments, but found ${t2.length - 1} instead.`);
            const r2 = e2.parse(t2[1], 1, Ct), n2 = e2.parse(t2[2], 2, Kt(e2.expectedType || Ut));
            return r2 && n2 ? new tr(n2.type.itemType, r2, n2) : null;
          }
          evaluate(t2) {
            const e2 = this.index.evaluate(t2), r2 = this.input.evaluate(t2);
            if (e2 < 0) throw new Ve(`Array index out of bounds: ${e2} < 0.`);
            if (e2 >= r2.length) throw new Ve(`Array index out of bounds: ${e2} > ${r2.length - 1}.`);
            if (e2 !== Math.floor(e2)) throw new Ve(`Array index must be an integer, but found ${e2} instead.`);
            return r2[e2];
          }
          eachChild(t2) {
            t2(this.index), t2(this.input);
          }
          outputDefined() {
            return false;
          }
        }
        class er {
          constructor(t2, e2) {
            this.type = Ot, this.needle = t2, this.haystack = e2;
          }
          static parse(t2, e2) {
            if (3 !== t2.length) return e2.error(`Expected 2 arguments, but found ${t2.length - 1} instead.`);
            const r2 = e2.parse(t2[1], 1, Ut), n2 = e2.parse(t2[2], 2, Ut);
            return r2 && n2 ? te(r2.type, [Ot, Lt, Ct, Vt, Ut]) ? new er(r2, n2) : e2.error(`Expected first argument to be of type boolean, string, number or null, but found ${Wt(r2.type)} instead`) : null;
          }
          evaluate(t2) {
            const e2 = this.needle.evaluate(t2), r2 = this.haystack.evaluate(t2);
            if (!r2) return false;
            if (!ee(e2, ["boolean", "string", "number", "null"])) throw new Ve(`Expected first argument to be of type boolean, string, number or null, but found ${Wt(Ue(e2))} instead.`);
            if (!ee(r2, ["string", "array"])) throw new Ve(`Expected second argument to be of type array or string, but found ${Wt(Ue(r2))} instead.`);
            return r2.indexOf(e2) >= 0;
          }
          eachChild(t2) {
            t2(this.needle), t2(this.haystack);
          }
          outputDefined() {
            return true;
          }
        }
        class rr {
          constructor(t2, e2, r2) {
            this.type = Ct, this.needle = t2, this.haystack = e2, this.fromIndex = r2;
          }
          static parse(t2, e2) {
            if (t2.length <= 2 || t2.length >= 5) return e2.error(`Expected 2 or 3 arguments, but found ${t2.length - 1} instead.`);
            const r2 = e2.parse(t2[1], 1, Ut), n2 = e2.parse(t2[2], 2, Ut);
            if (!r2 || !n2) return null;
            if (!te(r2.type, [Ot, Lt, Ct, Vt, Ut])) return e2.error(`Expected first argument to be of type boolean, string, number or null, but found ${Wt(r2.type)} instead`);
            if (4 === t2.length) {
              const i2 = e2.parse(t2[3], 3, Ct);
              return i2 ? new rr(r2, n2, i2) : null;
            }
            return new rr(r2, n2);
          }
          evaluate(t2) {
            const e2 = this.needle.evaluate(t2), r2 = this.haystack.evaluate(t2);
            if (!ee(e2, ["boolean", "string", "number", "null"])) throw new Ve(`Expected first argument to be of type boolean, string, number or null, but found ${Wt(Ue(e2))} instead.`);
            let n2;
            if (this.fromIndex && (n2 = this.fromIndex.evaluate(t2)), ee(r2, ["string"])) {
              const t3 = r2.indexOf(e2, n2);
              return -1 === t3 ? -1 : [...r2.slice(0, t3)].length;
            }
            if (ee(r2, ["array"])) return r2.indexOf(e2, n2);
            throw new Ve(`Expected second argument to be of type array or string, but found ${Wt(Ue(r2))} instead.`);
          }
          eachChild(t2) {
            t2(this.needle), t2(this.haystack), this.fromIndex && t2(this.fromIndex);
          }
          outputDefined() {
            return false;
          }
        }
        class nr {
          constructor(t2, e2, r2, n2, i2, s2) {
            this.inputType = t2, this.type = e2, this.input = r2, this.cases = n2, this.outputs = i2, this.otherwise = s2;
          }
          static parse(t2, e2) {
            if (t2.length < 5) return e2.error(`Expected at least 4 arguments, but found only ${t2.length - 1}.`);
            if (t2.length % 2 != 1) return e2.error("Expected an even number of arguments.");
            let r2, n2;
            e2.expectedType && "value" !== e2.expectedType.kind && (n2 = e2.expectedType);
            const i2 = {}, s2 = [];
            for (let o3 = 2; o3 < t2.length - 1; o3 += 2) {
              let a3 = t2[o3];
              const l2 = t2[o3 + 1];
              Array.isArray(a3) || (a3 = [a3]);
              const u2 = e2.concat(o3);
              if (0 === a3.length) return u2.error("Expected at least one branch label.");
              for (const t3 of a3) {
                if ("number" != typeof t3 && "string" != typeof t3) return u2.error("Branch labels must be numbers or strings.");
                if ("number" == typeof t3 && Math.abs(t3) > Number.MAX_SAFE_INTEGER) return u2.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                if ("number" == typeof t3 && Math.floor(t3) !== t3) return u2.error("Numeric branch labels must be integer values.");
                if (r2) {
                  if (u2.checkSubtype(r2, Ue(t3))) return null;
                } else r2 = Ue(t3);
                if (void 0 !== i2[String(t3)]) return u2.error("Branch labels must be unique.");
                i2[String(t3)] = s2.length;
              }
              const c2 = e2.parse(l2, o3, n2);
              if (!c2) return null;
              n2 = n2 || c2.type, s2.push(c2);
            }
            const o2 = e2.parse(t2[1], 1, Ut);
            if (!o2) return null;
            const a2 = e2.parse(t2[t2.length - 1], t2.length - 1, n2);
            return a2 ? "value" !== o2.type.kind && e2.concat(1).checkSubtype(r2, o2.type) ? null : new nr(r2, n2, o2, i2, s2, a2) : null;
          }
          evaluate(t2) {
            const e2 = this.input.evaluate(t2);
            return (Ue(e2) === this.inputType && this.outputs[this.cases[e2]] || this.otherwise).evaluate(t2);
          }
          eachChild(t2) {
            t2(this.input), this.outputs.forEach(t2), t2(this.otherwise);
          }
          outputDefined() {
            return this.outputs.every((t2) => t2.outputDefined()) && this.otherwise.outputDefined();
          }
        }
        class ir {
          constructor(t2, e2, r2) {
            this.type = t2, this.branches = e2, this.otherwise = r2;
          }
          static parse(t2, e2) {
            if (t2.length < 4) return e2.error(`Expected at least 3 arguments, but found only ${t2.length - 1}.`);
            if (t2.length % 2 != 0) return e2.error("Expected an odd number of arguments.");
            let r2;
            e2.expectedType && "value" !== e2.expectedType.kind && (r2 = e2.expectedType);
            const n2 = [];
            for (let i3 = 1; i3 < t2.length - 1; i3 += 2) {
              const s2 = e2.parse(t2[i3], i3, Ot);
              if (!s2) return null;
              const o2 = e2.parse(t2[i3 + 1], i3 + 1, r2);
              if (!o2) return null;
              n2.push([s2, o2]), r2 = r2 || o2.type;
            }
            const i2 = e2.parse(t2[t2.length - 1], t2.length - 1, r2);
            if (!i2) return null;
            if (!r2) throw new Error("Can't infer output type");
            return new ir(r2, n2, i2);
          }
          evaluate(t2) {
            for (const [e2, r2] of this.branches) if (e2.evaluate(t2)) return r2.evaluate(t2);
            return this.otherwise.evaluate(t2);
          }
          eachChild(t2) {
            for (const [e2, r2] of this.branches) t2(e2), t2(r2);
            t2(this.otherwise);
          }
          outputDefined() {
            return this.branches.every(([t2, e2]) => e2.outputDefined()) && this.otherwise.outputDefined();
          }
        }
        class sr {
          constructor(t2, e2, r2, n2) {
            this.type = t2, this.input = e2, this.beginIndex = r2, this.endIndex = n2;
          }
          static parse(t2, e2) {
            if (t2.length <= 2 || t2.length >= 5) return e2.error(`Expected 2 or 3 arguments, but found ${t2.length - 1} instead.`);
            const r2 = e2.parse(t2[1], 1, Ut), n2 = e2.parse(t2[2], 2, Ct);
            if (!r2 || !n2) return null;
            if (!te(r2.type, [Kt(Ut), Lt, Ut])) return e2.error(`Expected first argument to be of type array or string, but found ${Wt(r2.type)} instead`);
            if (4 === t2.length) {
              const i2 = e2.parse(t2[3], 3, Ct);
              return i2 ? new sr(r2.type, r2, n2, i2) : null;
            }
            return new sr(r2.type, r2, n2);
          }
          evaluate(t2) {
            const e2 = this.input.evaluate(t2), r2 = this.beginIndex.evaluate(t2);
            let n2;
            if (this.endIndex && (n2 = this.endIndex.evaluate(t2)), ee(e2, ["string"])) return [...e2].slice(r2, n2).join("");
            if (ee(e2, ["array"])) return e2.slice(r2, n2);
            throw new Ve(`Expected first argument to be of type array or string, but found ${Wt(Ue(e2))} instead.`);
          }
          eachChild(t2) {
            t2(this.input), t2(this.beginIndex), this.endIndex && t2(this.endIndex);
          }
          outputDefined() {
            return false;
          }
        }
        function or(t2, e2) {
          const r2 = t2.length - 1;
          let n2, i2, s2 = 0, o2 = r2, a2 = 0;
          for (; s2 <= o2; ) if (a2 = Math.floor((s2 + o2) / 2), n2 = t2[a2], i2 = t2[a2 + 1], n2 <= e2) {
            if (a2 === r2 || e2 < i2) return a2;
            s2 = a2 + 1;
          } else {
            if (!(n2 > e2)) throw new Ve("Input is not a number.");
            o2 = a2 - 1;
          }
          return 0;
        }
        class ar {
          constructor(t2, e2, r2) {
            this.type = t2, this.input = e2, this.labels = [], this.outputs = [];
            for (const [t3, e3] of r2) this.labels.push(t3), this.outputs.push(e3);
          }
          static parse(t2, e2) {
            if (t2.length - 1 < 4) return e2.error(`Expected at least 4 arguments, but found only ${t2.length - 1}.`);
            if ((t2.length - 1) % 2 != 0) return e2.error("Expected an even number of arguments.");
            const r2 = e2.parse(t2[1], 1, Ct);
            if (!r2) return null;
            const n2 = [];
            let i2 = null;
            e2.expectedType && "value" !== e2.expectedType.kind && (i2 = e2.expectedType);
            for (let r3 = 1; r3 < t2.length; r3 += 2) {
              const s2 = 1 === r3 ? -1 / 0 : t2[r3], o2 = t2[r3 + 1], a2 = r3, l2 = r3 + 1;
              if ("number" != typeof s2) return e2.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', a2);
              if (n2.length && n2[n2.length - 1][0] >= s2) return e2.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', a2);
              const u2 = e2.parse(o2, l2, i2);
              if (!u2) return null;
              i2 = i2 || u2.type, n2.push([s2, u2]);
            }
            return new ar(i2, r2, n2);
          }
          evaluate(t2) {
            const e2 = this.labels, r2 = this.outputs;
            if (1 === e2.length) return r2[0].evaluate(t2);
            const n2 = this.input.evaluate(t2);
            if (n2 <= e2[0]) return r2[0].evaluate(t2);
            const i2 = e2.length;
            return n2 >= e2[i2 - 1] ? r2[i2 - 1].evaluate(t2) : r2[or(e2, n2)].evaluate(t2);
          }
          eachChild(t2) {
            t2(this.input);
            for (const e2 of this.outputs) t2(e2);
          }
          outputDefined() {
            return this.outputs.every((t2) => t2.outputDefined());
          }
        }
        function lr(t2) {
          return t2 && t2.__esModule && Object.prototype.hasOwnProperty.call(t2, "default") ? t2.default : t2;
        }
        var ur, cr, hr = function() {
          if (cr) return ur;
          function t2(t3, e2, r2, n2) {
            this.cx = 3 * t3, this.bx = 3 * (r2 - t3) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e2, this.by = 3 * (n2 - e2) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t3, this.p1y = e2, this.p2x = r2, this.p2y = n2;
          }
          return cr = 1, ur = t2, t2.prototype = { sampleCurveX: function(t3) {
            return ((this.ax * t3 + this.bx) * t3 + this.cx) * t3;
          }, sampleCurveY: function(t3) {
            return ((this.ay * t3 + this.by) * t3 + this.cy) * t3;
          }, sampleCurveDerivativeX: function(t3) {
            return (3 * this.ax * t3 + 2 * this.bx) * t3 + this.cx;
          }, solveCurveX: function(t3, e2) {
            if (void 0 === e2 && (e2 = 1e-6), t3 < 0) return 0;
            if (t3 > 1) return 1;
            for (var r2 = t3, n2 = 0; n2 < 8; n2++) {
              var i2 = this.sampleCurveX(r2) - t3;
              if (Math.abs(i2) < e2) return r2;
              var s2 = this.sampleCurveDerivativeX(r2);
              if (Math.abs(s2) < 1e-6) break;
              r2 -= i2 / s2;
            }
            var o2 = 0, a2 = 1;
            for (r2 = t3, n2 = 0; n2 < 20 && (i2 = this.sampleCurveX(r2), !(Math.abs(i2 - t3) < e2)); n2++) t3 > i2 ? o2 = r2 : a2 = r2, r2 = 0.5 * (a2 - o2) + o2;
            return r2;
          }, solve: function(t3, e2) {
            return this.sampleCurveY(this.solveCurveX(t3, e2));
          } }, ur;
        }(), pr = lr(hr);
        class fr {
          constructor(t2, e2, r2, n2, i2) {
            this.type = t2, this.operator = e2, this.interpolation = r2, this.input = n2, this.labels = [], this.outputs = [];
            for (const [t3, e3] of i2) this.labels.push(t3), this.outputs.push(e3);
          }
          static interpolationFactor(t2, e2, r2, n2) {
            let i2 = 0;
            if ("exponential" === t2.name) i2 = dr(e2, t2.base, r2, n2);
            else if ("linear" === t2.name) i2 = dr(e2, 1, r2, n2);
            else if ("cubic-bezier" === t2.name) {
              const s2 = t2.controlPoints;
              i2 = new pr(s2[0], s2[1], s2[2], s2[3]).solve(dr(e2, 1, r2, n2));
            }
            return i2;
          }
          static parse(t2, e2) {
            let [r2, n2, i2, ...s2] = t2;
            if (!Array.isArray(n2) || 0 === n2.length) return e2.error("Expected an interpolation type expression.", 1);
            if ("linear" === n2[0]) n2 = { name: "linear" };
            else if ("exponential" === n2[0]) {
              const t3 = n2[1];
              if ("number" != typeof t3) return e2.error("Exponential interpolation requires a numeric base.", 1, 1);
              n2 = { name: "exponential", base: t3 };
            } else {
              if ("cubic-bezier" !== n2[0]) return e2.error(`Unknown interpolation type ${String(n2[0])}`, 1, 0);
              {
                const t3 = n2.slice(1);
                if (4 !== t3.length || t3.some((t4) => "number" != typeof t4 || t4 < 0 || t4 > 1)) return e2.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                n2 = { name: "cubic-bezier", controlPoints: t3 };
              }
            }
            if (t2.length - 1 < 4) return e2.error(`Expected at least 4 arguments, but found only ${t2.length - 1}.`);
            if ((t2.length - 1) % 2 != 0) return e2.error("Expected an even number of arguments.");
            if (i2 = e2.parse(i2, 2, Ct), !i2) return null;
            const o2 = [];
            let a2 = null;
            "interpolate-hcl" !== r2 && "interpolate-lab" !== r2 || e2.expectedType == Xt ? e2.expectedType && "value" !== e2.expectedType.kind && (a2 = e2.expectedType) : a2 = Rt;
            for (let t3 = 0; t3 < s2.length; t3 += 2) {
              const r3 = s2[t3], n3 = s2[t3 + 1], i3 = t3 + 3, l2 = t3 + 4;
              if ("number" != typeof r3) return e2.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i3);
              if (o2.length && o2[o2.length - 1][0] >= r3) return e2.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i3);
              const u2 = e2.parse(n3, l2, a2);
              if (!u2) return null;
              a2 = a2 || u2.type, o2.push([r3, u2]);
            }
            return re(a2, Ct) || re(a2, Nt) || re(a2, Rt) || re(a2, Gt) || re(a2, Yt) || re(a2, Xt) || re(a2, Ht) || re(a2, Kt(Ct)) ? new fr(a2, r2, n2, i2, o2) : e2.error(`Type ${Wt(a2)} is not interpolatable.`);
          }
          evaluate(t2) {
            const e2 = this.labels, r2 = this.outputs;
            if (1 === e2.length) return r2[0].evaluate(t2);
            const n2 = this.input.evaluate(t2);
            if (n2 <= e2[0]) return r2[0].evaluate(t2);
            const i2 = e2.length;
            if (n2 >= e2[i2 - 1]) return r2[i2 - 1].evaluate(t2);
            const s2 = or(e2, n2), o2 = fr.interpolationFactor(this.interpolation, n2, e2[s2], e2[s2 + 1]), a2 = r2[s2].evaluate(t2), l2 = r2[s2 + 1].evaluate(t2);
            switch (this.operator) {
              case "interpolate":
                switch (this.type.kind) {
                  case "number":
                    return ke(a2, l2, o2);
                  case "color":
                    return Te.interpolate(a2, l2, o2);
                  case "padding":
                    return Pe.interpolate(a2, l2, o2);
                  case "colorArray":
                    return Be.interpolate(a2, l2, o2);
                  case "numberArray":
                    return ze.interpolate(a2, l2, o2);
                  case "variableAnchorOffsetCollection":
                    return Le.interpolate(a2, l2, o2);
                  case "array":
                    return Ee(a2, l2, o2);
                  case "projectionDefinition":
                    return Re.interpolate(a2, l2, o2);
                }
              case "interpolate-hcl":
                switch (this.type.kind) {
                  case "color":
                    return Te.interpolate(a2, l2, o2, "hcl");
                  case "colorArray":
                    return Be.interpolate(a2, l2, o2, "hcl");
                }
              case "interpolate-lab":
                switch (this.type.kind) {
                  case "color":
                    return Te.interpolate(a2, l2, o2, "lab");
                  case "colorArray":
                    return Be.interpolate(a2, l2, o2, "lab");
                }
            }
          }
          eachChild(t2) {
            t2(this.input);
            for (const e2 of this.outputs) t2(e2);
          }
          outputDefined() {
            return this.outputs.every((t2) => t2.outputDefined());
          }
        }
        function dr(t2, e2, r2, n2) {
          const i2 = n2 - r2, s2 = t2 - r2;
          return 0 === i2 ? 0 : 1 === e2 ? s2 / i2 : (Math.pow(e2, s2) - 1) / (Math.pow(e2, i2) - 1);
        }
        const yr = { color: Te.interpolate, number: ke, padding: Pe.interpolate, numberArray: ze.interpolate, colorArray: Be.interpolate, variableAnchorOffsetCollection: Le.interpolate, array: Ee };
        class mr {
          constructor(t2, e2) {
            this.type = t2, this.args = e2;
          }
          static parse(t2, e2) {
            if (t2.length < 2) return e2.error("Expected at least one argument.");
            let r2 = null;
            const n2 = e2.expectedType;
            n2 && "value" !== n2.kind && (r2 = n2);
            const i2 = [];
            for (const n3 of t2.slice(1)) {
              const t3 = e2.parse(n3, 1 + i2.length, r2, void 0, { typeAnnotation: "omit" });
              if (!t3) return null;
              r2 = r2 || t3.type, i2.push(t3);
            }
            if (!r2) throw new Error("No output type");
            const s2 = n2 && i2.some((t3) => Qt(n2, t3.type));
            return new mr(s2 ? Ut : r2, i2);
          }
          evaluate(t2) {
            let e2, r2 = null, n2 = 0;
            for (const i2 of this.args) if (n2++, r2 = i2.evaluate(t2), r2 && r2 instanceof Oe && !r2.available && (e2 || (e2 = r2.name), r2 = null, n2 === this.args.length && (r2 = e2)), null !== r2) break;
            return r2;
          }
          eachChild(t2) {
            this.args.forEach(t2);
          }
          outputDefined() {
            return this.args.every((t2) => t2.outputDefined());
          }
        }
        function gr(t2, e2) {
          return "==" === t2 || "!=" === t2 ? "boolean" === e2.kind || "string" === e2.kind || "number" === e2.kind || "null" === e2.kind || "value" === e2.kind : "string" === e2.kind || "number" === e2.kind || "value" === e2.kind;
        }
        function xr(t2, e2, r2, n2) {
          return 0 === n2.compare(e2, r2);
        }
        function vr(t2, e2, r2) {
          const n2 = "==" !== t2 && "!=" !== t2;
          return class i2 {
            constructor(t3, e3, r3) {
              this.type = Ot, this.lhs = t3, this.rhs = e3, this.collator = r3, this.hasUntypedArgument = "value" === t3.type.kind || "value" === e3.type.kind;
            }
            static parse(t3, e3) {
              if (3 !== t3.length && 4 !== t3.length) return e3.error("Expected two or three arguments.");
              const r3 = t3[0];
              let s2 = e3.parse(t3[1], 1, Ut);
              if (!s2) return null;
              if (!gr(r3, s2.type)) return e3.concat(1).error(`"${r3}" comparisons are not supported for type '${Wt(s2.type)}'.`);
              let o2 = e3.parse(t3[2], 2, Ut);
              if (!o2) return null;
              if (!gr(r3, o2.type)) return e3.concat(2).error(`"${r3}" comparisons are not supported for type '${Wt(o2.type)}'.`);
              if (s2.type.kind !== o2.type.kind && "value" !== s2.type.kind && "value" !== o2.type.kind) return e3.error(`Cannot compare types '${Wt(s2.type)}' and '${Wt(o2.type)}'.`);
              n2 && ("value" === s2.type.kind && "value" !== o2.type.kind ? s2 = new Xe(o2.type, [s2]) : "value" !== s2.type.kind && "value" === o2.type.kind && (o2 = new Xe(s2.type, [o2])));
              let a2 = null;
              if (4 === t3.length) {
                if ("string" !== s2.type.kind && "string" !== o2.type.kind && "value" !== s2.type.kind && "value" !== o2.type.kind) return e3.error("Cannot use collator to compare non-string types.");
                if (a2 = e3.parse(t3[3], 3, qt), !a2) return null;
              }
              return new i2(s2, o2, a2);
            }
            evaluate(i3) {
              const s2 = this.lhs.evaluate(i3), o2 = this.rhs.evaluate(i3);
              if (n2 && this.hasUntypedArgument) {
                const e3 = Ue(s2), r3 = Ue(o2);
                if (e3.kind !== r3.kind || "string" !== e3.kind && "number" !== e3.kind) throw new Ve(`Expected arguments for "${t2}" to be (string, string) or (number, number), but found (${e3.kind}, ${r3.kind}) instead.`);
              }
              if (this.collator && !n2 && this.hasUntypedArgument) {
                const t3 = Ue(s2), r3 = Ue(o2);
                if ("string" !== t3.kind || "string" !== r3.kind) return e2(i3, s2, o2);
              }
              return this.collator ? r2(i3, s2, o2, this.collator.evaluate(i3)) : e2(i3, s2, o2);
            }
            eachChild(t3) {
              t3(this.lhs), t3(this.rhs), this.collator && t3(this.collator);
            }
            outputDefined() {
              return true;
            }
          };
        }
        const br = vr("==", function(t2, e2, r2) {
          return e2 === r2;
        }, xr), wr = vr("!=", function(t2, e2, r2) {
          return e2 !== r2;
        }, function(t2, e2, r2, n2) {
          return !xr(0, e2, r2, n2);
        }), _r = vr("<", function(t2, e2, r2) {
          return e2 < r2;
        }, function(t2, e2, r2, n2) {
          return n2.compare(e2, r2) < 0;
        }), Ar = vr(">", function(t2, e2, r2) {
          return e2 > r2;
        }, function(t2, e2, r2, n2) {
          return n2.compare(e2, r2) > 0;
        }), Sr = vr("<=", function(t2, e2, r2) {
          return e2 <= r2;
        }, function(t2, e2, r2, n2) {
          return n2.compare(e2, r2) <= 0;
        }), kr = vr(">=", function(t2, e2, r2) {
          return e2 >= r2;
        }, function(t2, e2, r2, n2) {
          return n2.compare(e2, r2) >= 0;
        });
        class Er {
          constructor(t2, e2, r2) {
            this.type = qt, this.locale = r2, this.caseSensitive = t2, this.diacriticSensitive = e2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length) return e2.error("Expected one argument.");
            const r2 = t2[1];
            if ("object" != typeof r2 || Array.isArray(r2)) return e2.error("Collator options argument must be an object.");
            const n2 = e2.parse(void 0 !== r2["case-sensitive"] && r2["case-sensitive"], 1, Ot);
            if (!n2) return null;
            const i2 = e2.parse(void 0 !== r2["diacritic-sensitive"] && r2["diacritic-sensitive"], 1, Ot);
            if (!i2) return null;
            let s2 = null;
            return r2.locale && (s2 = e2.parse(r2.locale, 1, Lt), !s2) ? null : new Er(n2, i2, s2);
          }
          evaluate(t2) {
            return new Ie(this.caseSensitive.evaluate(t2), this.diacriticSensitive.evaluate(t2), this.locale ? this.locale.evaluate(t2) : null);
          }
          eachChild(t2) {
            t2(this.caseSensitive), t2(this.diacriticSensitive), this.locale && t2(this.locale);
          }
          outputDefined() {
            return false;
          }
        }
        class Tr {
          constructor(t2, e2, r2, n2, i2) {
            this.type = Lt, this.number = t2, this.locale = e2, this.currency = r2, this.minFractionDigits = n2, this.maxFractionDigits = i2;
          }
          static parse(t2, e2) {
            if (3 !== t2.length) return e2.error("Expected two arguments.");
            const r2 = e2.parse(t2[1], 1, Ct);
            if (!r2) return null;
            const n2 = t2[2];
            if ("object" != typeof n2 || Array.isArray(n2)) return e2.error("NumberFormat options argument must be an object.");
            let i2 = null;
            if (n2.locale && (i2 = e2.parse(n2.locale, 1, Lt), !i2)) return null;
            let s2 = null;
            if (n2.currency && (s2 = e2.parse(n2.currency, 1, Lt), !s2)) return null;
            let o2 = null;
            if (n2["min-fraction-digits"] && (o2 = e2.parse(n2["min-fraction-digits"], 1, Ct), !o2)) return null;
            let a2 = null;
            return n2["max-fraction-digits"] && (a2 = e2.parse(n2["max-fraction-digits"], 1, Ct), !a2) ? null : new Tr(r2, i2, s2, o2, a2);
          }
          evaluate(t2) {
            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t2) : [], { style: this.currency ? "currency" : "decimal", currency: this.currency ? this.currency.evaluate(t2) : void 0, minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t2) : void 0, maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t2) : void 0 }).format(this.number.evaluate(t2));
          }
          eachChild(t2) {
            t2(this.number), this.locale && t2(this.locale), this.currency && t2(this.currency), this.minFractionDigits && t2(this.minFractionDigits), this.maxFractionDigits && t2(this.maxFractionDigits);
          }
          outputDefined() {
            return false;
          }
        }
        class Ir {
          constructor(t2) {
            this.type = jt, this.sections = t2;
          }
          static parse(t2, e2) {
            if (t2.length < 2) return e2.error("Expected at least one argument.");
            const r2 = t2[1];
            if (!Array.isArray(r2) && "object" == typeof r2) return e2.error("First argument must be an image or text section.");
            const n2 = [];
            let i2 = false;
            for (let r3 = 1; r3 <= t2.length - 1; ++r3) {
              const s2 = t2[r3];
              if (i2 && "object" == typeof s2 && !Array.isArray(s2)) {
                i2 = false;
                let t3 = null;
                if (s2["font-scale"] && (t3 = e2.parse(s2["font-scale"], 1, Ct), !t3)) return null;
                let r4 = null;
                if (s2["text-font"] && (r4 = e2.parse(s2["text-font"], 1, Kt(Lt)), !r4)) return null;
                let o2 = null;
                if (s2["text-color"] && (o2 = e2.parse(s2["text-color"], 1, Rt), !o2)) return null;
                let a2 = null;
                if (s2["vertical-align"]) {
                  if ("string" == typeof s2["vertical-align"] && !Me.includes(s2["vertical-align"])) return e2.error(`'vertical-align' must be one of: 'bottom', 'center', 'top' but found '${s2["vertical-align"]}' instead.`);
                  if (a2 = e2.parse(s2["vertical-align"], 1, Lt), !a2) return null;
                }
                const l2 = n2[n2.length - 1];
                l2.scale = t3, l2.font = r4, l2.textColor = o2, l2.verticalAlign = a2;
              } else {
                const s3 = e2.parse(t2[r3], 1, Ut);
                if (!s3) return null;
                const o2 = s3.type.kind;
                if ("string" !== o2 && "value" !== o2 && "null" !== o2 && "resolvedImage" !== o2) return e2.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                i2 = true, n2.push({ content: s3, scale: null, font: null, textColor: null, verticalAlign: null });
              }
            }
            return new Ir(n2);
          }
          evaluate(t2) {
            return new De(this.sections.map((e2) => {
              const r2 = e2.content.evaluate(t2);
              return Ue(r2) === Zt ? new Fe("", r2, null, null, null, e2.verticalAlign ? e2.verticalAlign.evaluate(t2) : null) : new Fe(qe(r2), null, e2.scale ? e2.scale.evaluate(t2) : null, e2.font ? e2.font.evaluate(t2).join(",") : null, e2.textColor ? e2.textColor.evaluate(t2) : null, e2.verticalAlign ? e2.verticalAlign.evaluate(t2) : null);
            }));
          }
          eachChild(t2) {
            for (const e2 of this.sections) t2(e2.content), e2.scale && t2(e2.scale), e2.font && t2(e2.font), e2.textColor && t2(e2.textColor), e2.verticalAlign && t2(e2.verticalAlign);
          }
          outputDefined() {
            return false;
          }
        }
        class Mr {
          constructor(t2) {
            this.type = Zt, this.input = t2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length) return e2.error("Expected two arguments.");
            const r2 = e2.parse(t2[1], 1, Lt);
            return r2 ? new Mr(r2) : e2.error("No image name provided.");
          }
          evaluate(t2) {
            const e2 = this.input.evaluate(t2), r2 = Oe.fromString(e2);
            return r2 && t2.availableImages && (r2.available = t2.availableImages.indexOf(e2) > -1), r2;
          }
          eachChild(t2) {
            t2(this.input);
          }
          outputDefined() {
            return false;
          }
        }
        class Fr {
          constructor(t2) {
            this.type = Ct, this.input = t2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length) return e2.error(`Expected 1 argument, but found ${t2.length - 1} instead.`);
            const r2 = e2.parse(t2[1], 1);
            return r2 ? "array" !== r2.type.kind && "string" !== r2.type.kind && "value" !== r2.type.kind ? e2.error(`Expected argument of type string or array, but found ${Wt(r2.type)} instead.`) : new Fr(r2) : null;
          }
          evaluate(t2) {
            const e2 = this.input.evaluate(t2);
            if ("string" == typeof e2) return [...e2].length;
            if (Array.isArray(e2)) return e2.length;
            throw new Ve(`Expected value to be of type string or array, but found ${Wt(Ue(e2))} instead.`);
          }
          eachChild(t2) {
            t2(this.input);
          }
          outputDefined() {
            return false;
          }
        }
        const Dr = 8192;
        function Pr(t2, e2) {
          const r2 = (180 + t2[0]) / 360, n2 = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t2[1] * Math.PI / 360))) / 360, i2 = Math.pow(2, e2.z);
          return [Math.round(r2 * i2 * Dr), Math.round(n2 * i2 * Dr)];
        }
        function zr(t2, e2) {
          const r2 = Math.pow(2, e2.z);
          return [(i2 = (t2[0] / Dr + e2.x) / r2, 360 * i2 - 180), (n2 = (t2[1] / Dr + e2.y) / r2, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * n2) * Math.PI / 180)) - 90)];
          var n2, i2;
        }
        function Br(t2, e2) {
          t2[0] = Math.min(t2[0], e2[0]), t2[1] = Math.min(t2[1], e2[1]), t2[2] = Math.max(t2[2], e2[0]), t2[3] = Math.max(t2[3], e2[1]);
        }
        function Vr(t2, e2) {
          return !(t2[0] <= e2[0] || t2[2] >= e2[2] || t2[1] <= e2[1] || t2[3] >= e2[3]);
        }
        function Cr(t2, e2, r2) {
          const n2 = t2[0] - e2[0], i2 = t2[1] - e2[1], s2 = t2[0] - r2[0], o2 = t2[1] - r2[1];
          return n2 * o2 - s2 * i2 == 0 && n2 * s2 <= 0 && i2 * o2 <= 0;
        }
        function Lr(t2, e2, r2, n2) {
          return 0 != (i2 = [n2[0] - r2[0], n2[1] - r2[1]])[0] * (s2 = [e2[0] - t2[0], e2[1] - t2[1]])[1] - i2[1] * s2[0] && !(!qr(t2, e2, r2, n2) || !qr(r2, n2, t2, e2));
          var i2, s2;
        }
        function Or(t2, e2, r2) {
          for (const n2 of r2) for (let r3 = 0; r3 < n2.length - 1; ++r3) if (Lr(t2, e2, n2[r3], n2[r3 + 1])) return true;
          return false;
        }
        function Rr(t2, e2, r2 = false) {
          let n2 = false;
          for (const a2 of e2) for (let e3 = 0; e3 < a2.length - 1; e3++) {
            if (Cr(t2, a2[e3], a2[e3 + 1])) return r2;
            (s2 = a2[e3])[1] > (i2 = t2)[1] != (o2 = a2[e3 + 1])[1] > i2[1] && i2[0] < (o2[0] - s2[0]) * (i2[1] - s2[1]) / (o2[1] - s2[1]) + s2[0] && (n2 = !n2);
          }
          var i2, s2, o2;
          return n2;
        }
        function Nr(t2, e2) {
          for (const r2 of e2) if (Rr(t2, r2)) return true;
          return false;
        }
        function $r(t2, e2) {
          for (const r2 of t2) if (!Rr(r2, e2)) return false;
          for (let r2 = 0; r2 < t2.length - 1; ++r2) if (Or(t2[r2], t2[r2 + 1], e2)) return false;
          return true;
        }
        function Ur(t2, e2) {
          for (const r2 of e2) if ($r(t2, r2)) return true;
          return false;
        }
        function qr(t2, e2, r2, n2) {
          const i2 = n2[0] - r2[0], s2 = n2[1] - r2[1], o2 = (t2[0] - r2[0]) * s2 - i2 * (t2[1] - r2[1]), a2 = (e2[0] - r2[0]) * s2 - i2 * (e2[1] - r2[1]);
          return o2 > 0 && a2 < 0 || o2 < 0 && a2 > 0;
        }
        function jr(t2, e2, r2) {
          const n2 = [];
          for (let i2 = 0; i2 < t2.length; i2++) {
            const s2 = [];
            for (let n3 = 0; n3 < t2[i2].length; n3++) {
              const o2 = Pr(t2[i2][n3], r2);
              Br(e2, o2), s2.push(o2);
            }
            n2.push(s2);
          }
          return n2;
        }
        function Gr(t2, e2, r2) {
          const n2 = [];
          for (let i2 = 0; i2 < t2.length; i2++) {
            const s2 = jr(t2[i2], e2, r2);
            n2.push(s2);
          }
          return n2;
        }
        function Xr(t2, e2, r2, n2) {
          if (t2[0] < r2[0] || t2[0] > r2[2]) {
            const e3 = 0.5 * n2;
            let i2 = t2[0] - r2[0] > e3 ? -n2 : r2[0] - t2[0] > e3 ? n2 : 0;
            0 === i2 && (i2 = t2[0] - r2[2] > e3 ? -n2 : r2[2] - t2[0] > e3 ? n2 : 0), t2[0] += i2;
          }
          Br(e2, t2);
        }
        function Yr(t2, e2, r2, n2) {
          const i2 = Math.pow(2, n2.z) * Dr, s2 = [n2.x * Dr, n2.y * Dr], o2 = [];
          for (const n3 of t2) for (const t3 of n3) {
            const n4 = [t3.x + s2[0], t3.y + s2[1]];
            Xr(n4, e2, r2, i2), o2.push(n4);
          }
          return o2;
        }
        function Zr(t2, e2, r2, n2) {
          const i2 = Math.pow(2, n2.z) * Dr, s2 = [n2.x * Dr, n2.y * Dr], o2 = [];
          for (const r3 of t2) {
            const t3 = [];
            for (const n3 of r3) {
              const r4 = [n3.x + s2[0], n3.y + s2[1]];
              Br(e2, r4), t3.push(r4);
            }
            o2.push(t3);
          }
          if (e2[2] - e2[0] <= i2 / 2) {
            (a2 = e2)[0] = a2[1] = 1 / 0, a2[2] = a2[3] = -1 / 0;
            for (const t3 of o2) for (const n3 of t3) Xr(n3, e2, r2, i2);
          }
          var a2;
          return o2;
        }
        class Hr {
          constructor(t2, e2) {
            this.type = Ot, this.geojson = t2, this.geometries = e2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length) return e2.error(`'within' expression requires exactly one argument, but found ${t2.length - 1} instead.`);
            if ($e(t2[1])) {
              const e3 = t2[1];
              if ("FeatureCollection" === e3.type) {
                const t3 = [];
                for (const r2 of e3.features) {
                  const { type: e4, coordinates: n2 } = r2.geometry;
                  "Polygon" === e4 && t3.push(n2), "MultiPolygon" === e4 && t3.push(...n2);
                }
                if (t3.length) return new Hr(e3, { type: "MultiPolygon", coordinates: t3 });
              } else if ("Feature" === e3.type) {
                const t3 = e3.geometry.type;
                if ("Polygon" === t3 || "MultiPolygon" === t3) return new Hr(e3, e3.geometry);
              } else if ("Polygon" === e3.type || "MultiPolygon" === e3.type) return new Hr(e3, e3);
            }
            return e2.error("'within' expression requires valid geojson object that contains polygon geometry type.");
          }
          evaluate(t2) {
            if (null != t2.geometry() && null != t2.canonicalID()) {
              if ("Point" === t2.geometryType()) return function(t3, e2) {
                const r2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], n2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], i2 = t3.canonicalID();
                if ("Polygon" === e2.type) {
                  const s2 = jr(e2.coordinates, n2, i2), o2 = Yr(t3.geometry(), r2, n2, i2);
                  if (!Vr(r2, n2)) return false;
                  for (const t4 of o2) if (!Rr(t4, s2)) return false;
                }
                if ("MultiPolygon" === e2.type) {
                  const s2 = Gr(e2.coordinates, n2, i2), o2 = Yr(t3.geometry(), r2, n2, i2);
                  if (!Vr(r2, n2)) return false;
                  for (const t4 of o2) if (!Nr(t4, s2)) return false;
                }
                return true;
              }(t2, this.geometries);
              if ("LineString" === t2.geometryType()) return function(t3, e2) {
                const r2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], n2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], i2 = t3.canonicalID();
                if ("Polygon" === e2.type) {
                  const s2 = jr(e2.coordinates, n2, i2), o2 = Zr(t3.geometry(), r2, n2, i2);
                  if (!Vr(r2, n2)) return false;
                  for (const t4 of o2) if (!$r(t4, s2)) return false;
                }
                if ("MultiPolygon" === e2.type) {
                  const s2 = Gr(e2.coordinates, n2, i2), o2 = Zr(t3.geometry(), r2, n2, i2);
                  if (!Vr(r2, n2)) return false;
                  for (const t4 of o2) if (!Ur(t4, s2)) return false;
                }
                return true;
              }(t2, this.geometries);
            }
            return false;
          }
          eachChild() {
          }
          outputDefined() {
            return true;
          }
        }
        let Kr = class {
          constructor(t2 = [], e2 = (t3, e3) => t3 < e3 ? -1 : t3 > e3 ? 1 : 0) {
            if (this.data = t2, this.length = this.data.length, this.compare = e2, this.length > 0) for (let t3 = (this.length >> 1) - 1; t3 >= 0; t3--) this._down(t3);
          }
          push(t2) {
            this.data.push(t2), this._up(this.length++);
          }
          pop() {
            if (0 === this.length) return;
            const t2 = this.data[0], e2 = this.data.pop();
            return --this.length > 0 && (this.data[0] = e2, this._down(0)), t2;
          }
          peek() {
            return this.data[0];
          }
          _up(t2) {
            const { data: e2, compare: r2 } = this, n2 = e2[t2];
            for (; t2 > 0; ) {
              const i2 = t2 - 1 >> 1, s2 = e2[i2];
              if (r2(n2, s2) >= 0) break;
              e2[t2] = s2, t2 = i2;
            }
            e2[t2] = n2;
          }
          _down(t2) {
            const { data: e2, compare: r2 } = this, n2 = this.length >> 1, i2 = e2[t2];
            for (; t2 < n2; ) {
              let n3 = 1 + (t2 << 1);
              const s2 = n3 + 1;
              if (s2 < this.length && r2(e2[s2], e2[n3]) < 0 && (n3 = s2), r2(e2[n3], i2) >= 0) break;
              e2[t2] = e2[n3], t2 = n3;
            }
            e2[t2] = i2;
          }
        };
        function Wr(t2, e2, r2 = 0, n2 = t2.length - 1, i2 = Qr) {
          for (; n2 > r2; ) {
            if (n2 - r2 > 600) {
              const s3 = n2 - r2 + 1, o3 = e2 - r2 + 1, a3 = Math.log(s3), l2 = 0.5 * Math.exp(2 * a3 / 3), u2 = 0.5 * Math.sqrt(a3 * l2 * (s3 - l2) / s3) * (o3 - s3 / 2 < 0 ? -1 : 1);
              Wr(t2, e2, Math.max(r2, Math.floor(e2 - o3 * l2 / s3 + u2)), Math.min(n2, Math.floor(e2 + (s3 - o3) * l2 / s3 + u2)), i2);
            }
            const s2 = t2[e2];
            let o2 = r2, a2 = n2;
            for (Jr(t2, r2, e2), i2(t2[n2], s2) > 0 && Jr(t2, r2, n2); o2 < a2; ) {
              for (Jr(t2, o2, a2), o2++, a2--; i2(t2[o2], s2) < 0; ) o2++;
              for (; i2(t2[a2], s2) > 0; ) a2--;
            }
            0 === i2(t2[r2], s2) ? Jr(t2, r2, a2) : (a2++, Jr(t2, a2, n2)), a2 <= e2 && (r2 = a2 + 1), e2 <= a2 && (n2 = a2 - 1);
          }
        }
        function Jr(t2, e2, r2) {
          const n2 = t2[e2];
          t2[e2] = t2[r2], t2[r2] = n2;
        }
        function Qr(t2, e2) {
          return t2 < e2 ? -1 : t2 > e2 ? 1 : 0;
        }
        function tn(t2, e2) {
          if (t2.length <= 1) return [t2];
          const r2 = [];
          let n2, i2;
          for (const e3 of t2) {
            const t3 = rn(e3);
            0 !== t3 && (e3.area = Math.abs(t3), void 0 === i2 && (i2 = t3 < 0), i2 === t3 < 0 ? (n2 && r2.push(n2), n2 = [e3]) : n2.push(e3));
          }
          if (n2 && r2.push(n2), e2 > 1) for (let t3 = 0; t3 < r2.length; t3++) r2[t3].length <= e2 || (Wr(r2[t3], e2, 1, r2[t3].length - 1, en), r2[t3] = r2[t3].slice(0, e2));
          return r2;
        }
        function en(t2, e2) {
          return e2.area - t2.area;
        }
        function rn(t2) {
          let e2 = 0;
          for (let r2, n2, i2 = 0, s2 = t2.length, o2 = s2 - 1; i2 < s2; o2 = i2++) r2 = t2[i2], n2 = t2[o2], e2 += (n2.x - r2.x) * (r2.y + n2.y);
          return e2;
        }
        const nn = 1 / 298.257223563, sn = nn * (2 - nn), on = Math.PI / 180;
        class an {
          constructor(t2) {
            const e2 = 6378.137 * on * 1e3, r2 = Math.cos(t2 * on), n2 = 1 / (1 - sn * (1 - r2 * r2)), i2 = Math.sqrt(n2);
            this.kx = e2 * i2 * r2, this.ky = e2 * i2 * n2 * (1 - sn);
          }
          distance(t2, e2) {
            const r2 = this.wrap(t2[0] - e2[0]) * this.kx, n2 = (t2[1] - e2[1]) * this.ky;
            return Math.sqrt(r2 * r2 + n2 * n2);
          }
          pointOnLine(t2, e2) {
            let r2, n2, i2, s2, o2 = 1 / 0;
            for (let a2 = 0; a2 < t2.length - 1; a2++) {
              let l2 = t2[a2][0], u2 = t2[a2][1], c2 = this.wrap(t2[a2 + 1][0] - l2) * this.kx, h2 = (t2[a2 + 1][1] - u2) * this.ky, p2 = 0;
              0 === c2 && 0 === h2 || (p2 = (this.wrap(e2[0] - l2) * this.kx * c2 + (e2[1] - u2) * this.ky * h2) / (c2 * c2 + h2 * h2), p2 > 1 ? (l2 = t2[a2 + 1][0], u2 = t2[a2 + 1][1]) : p2 > 0 && (l2 += c2 / this.kx * p2, u2 += h2 / this.ky * p2)), c2 = this.wrap(e2[0] - l2) * this.kx, h2 = (e2[1] - u2) * this.ky;
              const f2 = c2 * c2 + h2 * h2;
              f2 < o2 && (o2 = f2, r2 = l2, n2 = u2, i2 = a2, s2 = p2);
            }
            return { point: [r2, n2], index: i2, t: Math.max(0, Math.min(1, s2)) };
          }
          wrap(t2) {
            for (; t2 < -180; ) t2 += 360;
            for (; t2 > 180; ) t2 -= 360;
            return t2;
          }
        }
        function ln(t2, e2) {
          return e2[0] - t2[0];
        }
        function un(t2) {
          return t2[1] - t2[0] + 1;
        }
        function cn(t2, e2) {
          return t2[1] >= t2[0] && t2[1] < e2;
        }
        function hn(t2, e2) {
          if (t2[0] > t2[1]) return [null, null];
          const r2 = un(t2);
          if (e2) {
            if (2 === r2) return [t2, null];
            const e3 = Math.floor(r2 / 2);
            return [[t2[0], t2[0] + e3], [t2[0] + e3, t2[1]]];
          }
          if (1 === r2) return [t2, null];
          const n2 = Math.floor(r2 / 2) - 1;
          return [[t2[0], t2[0] + n2], [t2[0] + n2 + 1, t2[1]]];
        }
        function pn(t2, e2) {
          if (!cn(e2, t2.length)) return [1 / 0, 1 / 0, -1 / 0, -1 / 0];
          const r2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
          for (let n2 = e2[0]; n2 <= e2[1]; ++n2) Br(r2, t2[n2]);
          return r2;
        }
        function fn(t2) {
          const e2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
          for (const r2 of t2) for (const t3 of r2) Br(e2, t3);
          return e2;
        }
        function dn(t2) {
          return t2[0] !== -1 / 0 && t2[1] !== -1 / 0 && t2[2] !== 1 / 0 && t2[3] !== 1 / 0;
        }
        function yn(t2, e2, r2) {
          if (!dn(t2) || !dn(e2)) return NaN;
          let n2 = 0, i2 = 0;
          return t2[2] < e2[0] && (n2 = e2[0] - t2[2]), t2[0] > e2[2] && (n2 = t2[0] - e2[2]), t2[1] > e2[3] && (i2 = t2[1] - e2[3]), t2[3] < e2[1] && (i2 = e2[1] - t2[3]), r2.distance([0, 0], [n2, i2]);
        }
        function mn(t2, e2, r2) {
          const n2 = r2.pointOnLine(e2, t2);
          return r2.distance(t2, n2.point);
        }
        function gn(t2, e2, r2, n2, i2) {
          const s2 = Math.min(mn(t2, [r2, n2], i2), mn(e2, [r2, n2], i2)), o2 = Math.min(mn(r2, [t2, e2], i2), mn(n2, [t2, e2], i2));
          return Math.min(s2, o2);
        }
        function xn(t2, e2, r2, n2, i2) {
          if (!cn(e2, t2.length) || !cn(n2, r2.length)) return 1 / 0;
          let s2 = 1 / 0;
          for (let o2 = e2[0]; o2 < e2[1]; ++o2) {
            const e3 = t2[o2], a2 = t2[o2 + 1];
            for (let t3 = n2[0]; t3 < n2[1]; ++t3) {
              const n3 = r2[t3], o3 = r2[t3 + 1];
              if (Lr(e3, a2, n3, o3)) return 0;
              s2 = Math.min(s2, gn(e3, a2, n3, o3, i2));
            }
          }
          return s2;
        }
        function vn(t2, e2, r2, n2, i2) {
          if (!cn(e2, t2.length) || !cn(n2, r2.length)) return NaN;
          let s2 = 1 / 0;
          for (let o2 = e2[0]; o2 <= e2[1]; ++o2) for (let e3 = n2[0]; e3 <= n2[1]; ++e3) if (s2 = Math.min(s2, i2.distance(t2[o2], r2[e3])), 0 === s2) return s2;
          return s2;
        }
        function bn(t2, e2, r2) {
          if (Rr(t2, e2, true)) return 0;
          let n2 = 1 / 0;
          for (const i2 of e2) {
            const e3 = i2[0], s2 = i2[i2.length - 1];
            if (e3 !== s2 && (n2 = Math.min(n2, mn(t2, [s2, e3], r2)), 0 === n2)) return n2;
            const o2 = r2.pointOnLine(i2, t2);
            if (n2 = Math.min(n2, r2.distance(t2, o2.point)), 0 === n2) return n2;
          }
          return n2;
        }
        function wn(t2, e2, r2, n2) {
          if (!cn(e2, t2.length)) return NaN;
          for (let n3 = e2[0]; n3 <= e2[1]; ++n3) if (Rr(t2[n3], r2, true)) return 0;
          let i2 = 1 / 0;
          for (let s2 = e2[0]; s2 < e2[1]; ++s2) {
            const e3 = t2[s2], o2 = t2[s2 + 1];
            for (const t3 of r2) for (let r3 = 0, s3 = t3.length, a2 = s3 - 1; r3 < s3; a2 = r3++) {
              const s4 = t3[a2], l2 = t3[r3];
              if (Lr(e3, o2, s4, l2)) return 0;
              i2 = Math.min(i2, gn(e3, o2, s4, l2, n2));
            }
          }
          return i2;
        }
        function _n(t2, e2) {
          for (const r2 of t2) for (const t3 of r2) if (Rr(t3, e2, true)) return true;
          return false;
        }
        function An(t2, e2, r2, n2 = 1 / 0) {
          const i2 = fn(t2), s2 = fn(e2);
          if (n2 !== 1 / 0 && yn(i2, s2, r2) >= n2) return n2;
          if (Vr(i2, s2)) {
            if (_n(t2, e2)) return 0;
          } else if (_n(e2, t2)) return 0;
          let o2 = 1 / 0;
          for (const n3 of t2) for (let t3 = 0, i3 = n3.length, s3 = i3 - 1; t3 < i3; s3 = t3++) {
            const i4 = n3[s3], a2 = n3[t3];
            for (const t4 of e2) for (let e3 = 0, n4 = t4.length, s4 = n4 - 1; e3 < n4; s4 = e3++) {
              const n5 = t4[s4], l2 = t4[e3];
              if (Lr(i4, a2, n5, l2)) return 0;
              o2 = Math.min(o2, gn(i4, a2, n5, l2, r2));
            }
          }
          return o2;
        }
        function Sn(t2, e2, r2, n2, i2, s2) {
          if (!s2) return;
          const o2 = yn(pn(n2, s2), i2, r2);
          o2 < e2 && t2.push([o2, s2, [0, 0]]);
        }
        function kn(t2, e2, r2, n2, i2, s2, o2) {
          if (!s2 || !o2) return;
          const a2 = yn(pn(n2, s2), pn(i2, o2), r2);
          a2 < e2 && t2.push([a2, s2, o2]);
        }
        function En(t2, e2, r2, n2, i2 = 1 / 0) {
          let s2 = Math.min(n2.distance(t2[0], r2[0][0]), i2);
          if (0 === s2) return s2;
          const o2 = new Kr([[0, [0, t2.length - 1], [0, 0]]], ln), a2 = fn(r2);
          for (; o2.length > 0; ) {
            const i3 = o2.pop();
            if (i3[0] >= s2) continue;
            const l2 = i3[1], u2 = e2 ? 50 : 100;
            if (un(l2) <= u2) {
              if (!cn(l2, t2.length)) return NaN;
              if (e2) {
                const e3 = wn(t2, l2, r2, n2);
                if (isNaN(e3) || 0 === e3) return e3;
                s2 = Math.min(s2, e3);
              } else for (let e3 = l2[0]; e3 <= l2[1]; ++e3) {
                const i4 = bn(t2[e3], r2, n2);
                if (s2 = Math.min(s2, i4), 0 === s2) return 0;
              }
            } else {
              const r3 = hn(l2, e2);
              Sn(o2, s2, n2, t2, a2, r3[0]), Sn(o2, s2, n2, t2, a2, r3[1]);
            }
          }
          return s2;
        }
        function Tn(t2, e2, r2, n2, i2, s2 = 1 / 0) {
          let o2 = Math.min(s2, i2.distance(t2[0], r2[0]));
          if (0 === o2) return o2;
          const a2 = new Kr([[0, [0, t2.length - 1], [0, r2.length - 1]]], ln);
          for (; a2.length > 0; ) {
            const s3 = a2.pop();
            if (s3[0] >= o2) continue;
            const l2 = s3[1], u2 = s3[2], c2 = e2 ? 50 : 100, h2 = n2 ? 50 : 100;
            if (un(l2) <= c2 && un(u2) <= h2) {
              if (!cn(l2, t2.length) && cn(u2, r2.length)) return NaN;
              let s4;
              if (e2 && n2) s4 = xn(t2, l2, r2, u2, i2), o2 = Math.min(o2, s4);
              else if (e2 && !n2) {
                const e3 = t2.slice(l2[0], l2[1] + 1);
                for (let t3 = u2[0]; t3 <= u2[1]; ++t3) if (s4 = mn(r2[t3], e3, i2), o2 = Math.min(o2, s4), 0 === o2) return o2;
              } else if (!e2 && n2) {
                const e3 = r2.slice(u2[0], u2[1] + 1);
                for (let r3 = l2[0]; r3 <= l2[1]; ++r3) if (s4 = mn(t2[r3], e3, i2), o2 = Math.min(o2, s4), 0 === o2) return o2;
              } else s4 = vn(t2, l2, r2, u2, i2), o2 = Math.min(o2, s4);
            } else {
              const s4 = hn(l2, e2), c3 = hn(u2, n2);
              kn(a2, o2, i2, t2, r2, s4[0], c3[0]), kn(a2, o2, i2, t2, r2, s4[0], c3[1]), kn(a2, o2, i2, t2, r2, s4[1], c3[0]), kn(a2, o2, i2, t2, r2, s4[1], c3[1]);
            }
          }
          return o2;
        }
        function In(t2) {
          return "MultiPolygon" === t2.type ? t2.coordinates.map((t3) => ({ type: "Polygon", coordinates: t3 })) : "MultiLineString" === t2.type ? t2.coordinates.map((t3) => ({ type: "LineString", coordinates: t3 })) : "MultiPoint" === t2.type ? t2.coordinates.map((t3) => ({ type: "Point", coordinates: t3 })) : [t2];
        }
        class Mn {
          constructor(t2, e2) {
            this.type = Ct, this.geojson = t2, this.geometries = e2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length) return e2.error(`'distance' expression requires exactly one argument, but found ${t2.length - 1} instead.`);
            if ($e(t2[1])) {
              const e3 = t2[1];
              if ("FeatureCollection" === e3.type) return new Mn(e3, e3.features.map((t3) => In(t3.geometry)).flat());
              if ("Feature" === e3.type) return new Mn(e3, In(e3.geometry));
              if ("type" in e3 && "coordinates" in e3) return new Mn(e3, In(e3));
            }
            return e2.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
          }
          evaluate(t2) {
            if (null != t2.geometry() && null != t2.canonicalID()) {
              if ("Point" === t2.geometryType()) return function(t3, e2) {
                const r2 = t3.geometry(), n2 = r2.flat().map((e3) => zr([e3.x, e3.y], t3.canonical));
                if (0 === r2.length) return NaN;
                const i2 = new an(n2[0][1]);
                let s2 = 1 / 0;
                for (const t4 of e2) {
                  switch (t4.type) {
                    case "Point":
                      s2 = Math.min(s2, Tn(n2, false, [t4.coordinates], false, i2, s2));
                      break;
                    case "LineString":
                      s2 = Math.min(s2, Tn(n2, false, t4.coordinates, true, i2, s2));
                      break;
                    case "Polygon":
                      s2 = Math.min(s2, En(n2, false, t4.coordinates, i2, s2));
                  }
                  if (0 === s2) return s2;
                }
                return s2;
              }(t2, this.geometries);
              if ("LineString" === t2.geometryType()) return function(t3, e2) {
                const r2 = t3.geometry(), n2 = r2.flat().map((e3) => zr([e3.x, e3.y], t3.canonical));
                if (0 === r2.length) return NaN;
                const i2 = new an(n2[0][1]);
                let s2 = 1 / 0;
                for (const t4 of e2) {
                  switch (t4.type) {
                    case "Point":
                      s2 = Math.min(s2, Tn(n2, true, [t4.coordinates], false, i2, s2));
                      break;
                    case "LineString":
                      s2 = Math.min(s2, Tn(n2, true, t4.coordinates, true, i2, s2));
                      break;
                    case "Polygon":
                      s2 = Math.min(s2, En(n2, true, t4.coordinates, i2, s2));
                  }
                  if (0 === s2) return s2;
                }
                return s2;
              }(t2, this.geometries);
              if ("Polygon" === t2.geometryType()) return function(t3, e2) {
                const r2 = t3.geometry();
                if (0 === r2.length || 0 === r2[0].length) return NaN;
                const n2 = tn(r2, 0).map((e3) => e3.map((e4) => e4.map((e5) => zr([e5.x, e5.y], t3.canonical)))), i2 = new an(n2[0][0][0][1]);
                let s2 = 1 / 0;
                for (const t4 of e2) for (const e3 of n2) {
                  switch (t4.type) {
                    case "Point":
                      s2 = Math.min(s2, En([t4.coordinates], false, e3, i2, s2));
                      break;
                    case "LineString":
                      s2 = Math.min(s2, En(t4.coordinates, true, e3, i2, s2));
                      break;
                    case "Polygon":
                      s2 = Math.min(s2, An(e3, t4.coordinates, i2, s2));
                  }
                  if (0 === s2) return s2;
                }
                return s2;
              }(t2, this.geometries);
            }
            return NaN;
          }
          eachChild() {
          }
          outputDefined() {
            return true;
          }
        }
        class Fn {
          constructor(t2) {
            this.type = Ut, this.key = t2;
          }
          static parse(t2, e2) {
            if (2 !== t2.length) return e2.error(`Expected 1 argument, but found ${t2.length - 1} instead.`);
            const r2 = t2[1];
            return null == r2 ? e2.error("Global state property must be defined.") : "string" != typeof r2 ? e2.error(`Global state property must be string, but found ${typeof t2[1]} instead.`) : new Fn(r2);
          }
          evaluate(t2) {
            var e2;
            const r2 = null === (e2 = t2.globals) || void 0 === e2 ? void 0 : e2.globalState;
            return r2 && 0 !== Object.keys(r2).length ? ve(r2, this.key) : null;
          }
          eachChild() {
          }
          outputDefined() {
            return false;
          }
        }
        const Dn = { "==": br, "!=": wr, ">": Ar, "<": _r, ">=": kr, "<=": Sr, array: Xe, at: tr, boolean: Xe, case: ir, coalesce: mr, collator: Er, format: Ir, image: Mr, in: er, "index-of": rr, interpolate: fr, "interpolate-hcl": fr, "interpolate-lab": fr, length: Fr, let: Je, literal: je, match: nr, number: Xe, "number-format": Tr, object: Xe, slice: sr, step: ar, string: Xe, "to-boolean": Ze, "to-color": Ze, "to-number": Ze, "to-string": Ze, var: Qe, within: Hr, distance: Mn, "global-state": Fn };
        class Pn {
          constructor(t2, e2, r2, n2) {
            this.name = t2, this.type = e2, this._evaluate = r2, this.args = n2;
          }
          evaluate(t2) {
            return this._evaluate(t2, this.args);
          }
          eachChild(t2) {
            this.args.forEach(t2);
          }
          outputDefined() {
            return false;
          }
          static parse(t2, e2) {
            const r2 = t2[0], n2 = Pn.definitions[r2];
            if (!n2) return e2.error(`Unknown expression "${r2}". If you wanted a literal array, use ["literal", [...]].`, 0);
            const i2 = Array.isArray(n2) ? n2[0] : n2.type, s2 = Array.isArray(n2) ? [[n2[1], n2[2]]] : n2.overloads, o2 = s2.filter(([e3]) => !Array.isArray(e3) || e3.length === t2.length - 1);
            let a2 = null;
            for (const [n3, s3] of o2) {
              a2 = new We(e2.registry, Ln, e2.path, null, e2.scope);
              const o3 = [];
              let l2 = false;
              for (let e3 = 1; e3 < t2.length; e3++) {
                const r3 = t2[e3], i3 = Array.isArray(n3) ? n3[e3 - 1] : n3.type, s4 = a2.parse(r3, 1 + o3.length, i3);
                if (!s4) {
                  l2 = true;
                  break;
                }
                o3.push(s4);
              }
              if (!l2) if (Array.isArray(n3) && n3.length !== o3.length) a2.error(`Expected ${n3.length} arguments, but found ${o3.length} instead.`);
              else {
                for (let t3 = 0; t3 < o3.length; t3++) {
                  const e3 = Array.isArray(n3) ? n3[t3] : n3.type, r3 = o3[t3];
                  a2.concat(t3 + 1).checkSubtype(e3, r3.type);
                }
                if (0 === a2.errors.length) return new Pn(r2, i2, s3, o3);
              }
            }
            if (1 === o2.length) e2.errors.push(...a2.errors);
            else {
              const r3 = (o2.length ? o2 : s2).map(([t3]) => {
                return e3 = t3, Array.isArray(e3) ? `(${e3.map(Wt).join(", ")})` : `(${Wt(e3.type)}...)`;
                var e3;
              }).join(" | "), n3 = [];
              for (let r4 = 1; r4 < t2.length; r4++) {
                const i3 = e2.parse(t2[r4], 1 + n3.length);
                if (!i3) return null;
                n3.push(Wt(i3.type));
              }
              e2.error(`Expected arguments of type ${r3}, but found (${n3.join(", ")}) instead.`);
            }
            return null;
          }
          static register(t2, e2) {
            Pn.definitions = e2;
            for (const r2 in e2) t2[r2] = Pn;
          }
        }
        function zn(t2, [e2, r2, n2, i2]) {
          e2 = e2.evaluate(t2), r2 = r2.evaluate(t2), n2 = n2.evaluate(t2);
          const s2 = i2 ? i2.evaluate(t2) : 1, o2 = Ne(e2, r2, n2, s2);
          if (o2) throw new Ve(o2);
          return new Te(e2 / 255, r2 / 255, n2 / 255, s2, false);
        }
        function Bn(t2, e2) {
          return t2 in e2;
        }
        function Vn(t2, e2) {
          const r2 = e2[t2];
          return void 0 === r2 ? null : r2;
        }
        function Cn(t2) {
          return { type: t2 };
        }
        function Ln(t2) {
          if (t2 instanceof Qe) return Ln(t2.boundExpression);
          if (t2 instanceof Pn && "error" === t2.name) return false;
          if (t2 instanceof Er) return false;
          if (t2 instanceof Hr) return false;
          if (t2 instanceof Mn) return false;
          if (t2 instanceof Fn) return false;
          const e2 = t2 instanceof Ze || t2 instanceof Xe;
          let r2 = true;
          return t2.eachChild((t3) => {
            r2 = e2 ? r2 && Ln(t3) : r2 && t3 instanceof je;
          }), !!r2 && On(t2) && Nn(t2, ["zoom", "heatmap-density", "elevation", "line-progress", "accumulated", "is-supported-script"]);
        }
        function On(t2) {
          if (t2 instanceof Pn) {
            if ("get" === t2.name && 1 === t2.args.length) return false;
            if ("feature-state" === t2.name) return false;
            if ("has" === t2.name && 1 === t2.args.length) return false;
            if ("properties" === t2.name || "geometry-type" === t2.name || "id" === t2.name) return false;
            if (/^filter-/.test(t2.name)) return false;
          }
          if (t2 instanceof Hr) return false;
          if (t2 instanceof Mn) return false;
          let e2 = true;
          return t2.eachChild((t3) => {
            e2 && !On(t3) && (e2 = false);
          }), e2;
        }
        function Rn(t2) {
          if (t2 instanceof Pn && "feature-state" === t2.name) return false;
          let e2 = true;
          return t2.eachChild((t3) => {
            e2 && !Rn(t3) && (e2 = false);
          }), e2;
        }
        function Nn(t2, e2) {
          if (t2 instanceof Pn && e2.indexOf(t2.name) >= 0) return false;
          let r2 = true;
          return t2.eachChild((t3) => {
            r2 && !Nn(t3, e2) && (r2 = false);
          }), r2;
        }
        function $n(t2) {
          return { result: "success", value: t2 };
        }
        function Un(t2) {
          return { result: "error", value: t2 };
        }
        function qn(t2) {
          return "data-driven" === t2["property-type"] || "cross-faded-data-driven" === t2["property-type"];
        }
        function jn(t2) {
          return !!t2.expression && t2.expression.parameters.indexOf("zoom") > -1;
        }
        function Gn(t2) {
          return !!t2.expression && t2.expression.interpolated;
        }
        function Xn(t2) {
          return t2 instanceof Number ? "number" : t2 instanceof String ? "string" : t2 instanceof Boolean ? "boolean" : Array.isArray(t2) ? "array" : null === t2 ? "null" : typeof t2;
        }
        function Yn(t2) {
          return "object" == typeof t2 && null !== t2 && !Array.isArray(t2) && Ue(t2) === $t;
        }
        function Zn(t2) {
          return t2;
        }
        function Hn(t2, e2) {
          const r2 = t2.stops && "object" == typeof t2.stops[0][0], n2 = r2 || !(r2 || void 0 !== t2.property), i2 = t2.type || (Gn(e2) ? "exponential" : "interval"), s2 = function(t3) {
            switch (t3.type) {
              case "color":
                return Te.parse;
              case "padding":
                return Pe.parse;
              case "numberArray":
                return ze.parse;
              case "colorArray":
                return Be.parse;
              default:
                return null;
            }
          }(e2);
          if (s2 && ((t2 = Pt({}, t2)).stops && (t2.stops = t2.stops.map((t3) => [t3[0], s2(t3[1])])), t2.default = s2(t2.default ? t2.default : e2.default)), t2.colorSpace && "rgb" !== (o2 = t2.colorSpace) && "hcl" !== o2 && "lab" !== o2) throw new Error(`Unknown color space: "${t2.colorSpace}"`);
          var o2;
          const a2 = function(t3) {
            switch (t3) {
              case "exponential":
                return Qn;
              case "interval":
                return Jn;
              case "categorical":
                return Wn;
              case "identity":
                return ti;
              default:
                throw new Error(`Unknown function type "${t3}"`);
            }
          }(i2);
          let l2, u2;
          if ("categorical" === i2) {
            l2 = /* @__PURE__ */ Object.create(null);
            for (const e3 of t2.stops) l2[e3[0]] = e3[1];
            u2 = typeof t2.stops[0][0];
          }
          if (r2) {
            const r3 = {}, n3 = [];
            for (let e3 = 0; e3 < t2.stops.length; e3++) {
              const i4 = t2.stops[e3], s4 = i4[0].zoom;
              void 0 === r3[s4] && (r3[s4] = { zoom: s4, type: t2.type, property: t2.property, default: t2.default, stops: [] }, n3.push(s4)), r3[s4].stops.push([i4[0].value, i4[1]]);
            }
            const i3 = [];
            for (const t3 of n3) i3.push([r3[t3].zoom, Hn(r3[t3], e2)]);
            const s3 = { name: "linear" };
            return { kind: "composite", interpolationType: s3, interpolationFactor: fr.interpolationFactor.bind(void 0, s3), zoomStops: i3.map((t3) => t3[0]), evaluate: ({ zoom: r4 }, n4) => Qn({ stops: i3, base: t2.base }, e2, r4).evaluate(r4, n4) };
          }
          if (n2) {
            const r3 = "exponential" === i2 ? { name: "exponential", base: void 0 !== t2.base ? t2.base : 1 } : null;
            return { kind: "camera", interpolationType: r3, interpolationFactor: fr.interpolationFactor.bind(void 0, r3), zoomStops: t2.stops.map((t3) => t3[0]), evaluate: ({ zoom: r4 }) => a2(t2, e2, r4, l2, u2) };
          }
          return { kind: "source", evaluate(r3, n3) {
            const i3 = n3 && n3.properties ? n3.properties[t2.property] : void 0;
            return void 0 === i3 ? Kn(t2.default, e2.default) : a2(t2, e2, i3, l2, u2);
          } };
        }
        function Kn(t2, e2, r2) {
          return void 0 !== t2 ? t2 : void 0 !== e2 ? e2 : void 0 !== r2 ? r2 : void 0;
        }
        function Wn(t2, e2, r2, n2, i2) {
          return Kn(typeof r2 === i2 ? n2[r2] : void 0, t2.default, e2.default);
        }
        function Jn(t2, e2, r2) {
          if ("number" !== Xn(r2)) return Kn(t2.default, e2.default);
          const n2 = t2.stops.length;
          if (1 === n2) return t2.stops[0][1];
          if (r2 <= t2.stops[0][0]) return t2.stops[0][1];
          if (r2 >= t2.stops[n2 - 1][0]) return t2.stops[n2 - 1][1];
          const i2 = or(t2.stops.map((t3) => t3[0]), r2);
          return t2.stops[i2][1];
        }
        function Qn(t2, e2, r2) {
          const n2 = void 0 !== t2.base ? t2.base : 1;
          if ("number" !== Xn(r2)) return Kn(t2.default, e2.default);
          const i2 = t2.stops.length;
          if (1 === i2) return t2.stops[0][1];
          if (r2 <= t2.stops[0][0]) return t2.stops[0][1];
          if (r2 >= t2.stops[i2 - 1][0]) return t2.stops[i2 - 1][1];
          const s2 = or(t2.stops.map((t3) => t3[0]), r2), o2 = function(t3, e3, r3, n3) {
            const i3 = n3 - r3, s3 = t3 - r3;
            return 0 === i3 ? 0 : 1 === e3 ? s3 / i3 : (Math.pow(e3, s3) - 1) / (Math.pow(e3, i3) - 1);
          }(r2, n2, t2.stops[s2][0], t2.stops[s2 + 1][0]), a2 = t2.stops[s2][1], l2 = t2.stops[s2 + 1][1], u2 = yr[e2.type] || Zn;
          return "function" == typeof a2.evaluate ? { evaluate(...e3) {
            const r3 = a2.evaluate.apply(void 0, e3), n3 = l2.evaluate.apply(void 0, e3);
            if (void 0 !== r3 && void 0 !== n3) return u2(r3, n3, o2, t2.colorSpace);
          } } : u2(a2, l2, o2, t2.colorSpace);
        }
        function ti(t2, e2, r2) {
          switch (e2.type) {
            case "color":
              r2 = Te.parse(r2);
              break;
            case "formatted":
              r2 = De.fromString(r2.toString());
              break;
            case "resolvedImage":
              r2 = Oe.fromString(r2.toString());
              break;
            case "padding":
              r2 = Pe.parse(r2);
              break;
            case "colorArray":
              r2 = Be.parse(r2);
              break;
            case "numberArray":
              r2 = ze.parse(r2);
              break;
            default:
              Xn(r2) === e2.type || "enum" === e2.type && e2.values[r2] || (r2 = void 0);
          }
          return Kn(r2, t2.default, e2.default);
        }
        Pn.register(Dn, { error: [{ kind: "error" }, [Lt], (t2, [e2]) => {
          throw new Ve(e2.evaluate(t2));
        }], typeof: [Lt, [Ut], (t2, [e2]) => Wt(Ue(e2.evaluate(t2)))], "to-rgba": [Kt(Ct, 4), [Rt], (t2, [e2]) => {
          const [r2, n2, i2, s2] = e2.evaluate(t2).rgb;
          return [255 * r2, 255 * n2, 255 * i2, s2];
        }], rgb: [Rt, [Ct, Ct, Ct], zn], rgba: [Rt, [Ct, Ct, Ct, Ct], zn], has: { type: Ot, overloads: [[[Lt], (t2, [e2]) => Bn(e2.evaluate(t2), t2.properties())], [[Lt, $t], (t2, [e2, r2]) => Bn(e2.evaluate(t2), r2.evaluate(t2))]] }, get: { type: Ut, overloads: [[[Lt], (t2, [e2]) => Vn(e2.evaluate(t2), t2.properties())], [[Lt, $t], (t2, [e2, r2]) => Vn(e2.evaluate(t2), r2.evaluate(t2))]] }, "feature-state": [Ut, [Lt], (t2, [e2]) => Vn(e2.evaluate(t2), t2.featureState || {})], properties: [$t, [], (t2) => t2.properties()], "geometry-type": [Lt, [], (t2) => t2.geometryType()], id: [Ut, [], (t2) => t2.id()], zoom: [Ct, [], (t2) => t2.globals.zoom], "heatmap-density": [Ct, [], (t2) => t2.globals.heatmapDensity || 0], elevation: [Ct, [], (t2) => t2.globals.elevation || 0], "line-progress": [Ct, [], (t2) => t2.globals.lineProgress || 0], accumulated: [Ut, [], (t2) => void 0 === t2.globals.accumulated ? null : t2.globals.accumulated], "+": [Ct, Cn(Ct), (t2, e2) => {
          let r2 = 0;
          for (const n2 of e2) r2 += n2.evaluate(t2);
          return r2;
        }], "*": [Ct, Cn(Ct), (t2, e2) => {
          let r2 = 1;
          for (const n2 of e2) r2 *= n2.evaluate(t2);
          return r2;
        }], "-": { type: Ct, overloads: [[[Ct, Ct], (t2, [e2, r2]) => e2.evaluate(t2) - r2.evaluate(t2)], [[Ct], (t2, [e2]) => -e2.evaluate(t2)]] }, "/": [Ct, [Ct, Ct], (t2, [e2, r2]) => e2.evaluate(t2) / r2.evaluate(t2)], "%": [Ct, [Ct, Ct], (t2, [e2, r2]) => e2.evaluate(t2) % r2.evaluate(t2)], ln2: [Ct, [], () => Math.LN2], pi: [Ct, [], () => Math.PI], e: [Ct, [], () => Math.E], "^": [Ct, [Ct, Ct], (t2, [e2, r2]) => Math.pow(e2.evaluate(t2), r2.evaluate(t2))], sqrt: [Ct, [Ct], (t2, [e2]) => Math.sqrt(e2.evaluate(t2))], log10: [Ct, [Ct], (t2, [e2]) => Math.log(e2.evaluate(t2)) / Math.LN10], ln: [Ct, [Ct], (t2, [e2]) => Math.log(e2.evaluate(t2))], log2: [Ct, [Ct], (t2, [e2]) => Math.log(e2.evaluate(t2)) / Math.LN2], sin: [Ct, [Ct], (t2, [e2]) => Math.sin(e2.evaluate(t2))], cos: [Ct, [Ct], (t2, [e2]) => Math.cos(e2.evaluate(t2))], tan: [Ct, [Ct], (t2, [e2]) => Math.tan(e2.evaluate(t2))], asin: [Ct, [Ct], (t2, [e2]) => Math.asin(e2.evaluate(t2))], acos: [Ct, [Ct], (t2, [e2]) => Math.acos(e2.evaluate(t2))], atan: [Ct, [Ct], (t2, [e2]) => Math.atan(e2.evaluate(t2))], min: [Ct, Cn(Ct), (t2, e2) => Math.min(...e2.map((e3) => e3.evaluate(t2)))], max: [Ct, Cn(Ct), (t2, e2) => Math.max(...e2.map((e3) => e3.evaluate(t2)))], abs: [Ct, [Ct], (t2, [e2]) => Math.abs(e2.evaluate(t2))], round: [Ct, [Ct], (t2, [e2]) => {
          const r2 = e2.evaluate(t2);
          return r2 < 0 ? -Math.round(-r2) : Math.round(r2);
        }], floor: [Ct, [Ct], (t2, [e2]) => Math.floor(e2.evaluate(t2))], ceil: [Ct, [Ct], (t2, [e2]) => Math.ceil(e2.evaluate(t2))], "filter-==": [Ot, [Lt, Ut], (t2, [e2, r2]) => t2.properties()[e2.value] === r2.value], "filter-id-==": [Ot, [Ut], (t2, [e2]) => t2.id() === e2.value], "filter-type-==": [Ot, [Lt], (t2, [e2]) => t2.geometryType() === e2.value], "filter-<": [Ot, [Lt, Ut], (t2, [e2, r2]) => {
          const n2 = t2.properties()[e2.value], i2 = r2.value;
          return typeof n2 == typeof i2 && n2 < i2;
        }], "filter-id-<": [Ot, [Ut], (t2, [e2]) => {
          const r2 = t2.id(), n2 = e2.value;
          return typeof r2 == typeof n2 && r2 < n2;
        }], "filter->": [Ot, [Lt, Ut], (t2, [e2, r2]) => {
          const n2 = t2.properties()[e2.value], i2 = r2.value;
          return typeof n2 == typeof i2 && n2 > i2;
        }], "filter-id->": [Ot, [Ut], (t2, [e2]) => {
          const r2 = t2.id(), n2 = e2.value;
          return typeof r2 == typeof n2 && r2 > n2;
        }], "filter-<=": [Ot, [Lt, Ut], (t2, [e2, r2]) => {
          const n2 = t2.properties()[e2.value], i2 = r2.value;
          return typeof n2 == typeof i2 && n2 <= i2;
        }], "filter-id-<=": [Ot, [Ut], (t2, [e2]) => {
          const r2 = t2.id(), n2 = e2.value;
          return typeof r2 == typeof n2 && r2 <= n2;
        }], "filter->=": [Ot, [Lt, Ut], (t2, [e2, r2]) => {
          const n2 = t2.properties()[e2.value], i2 = r2.value;
          return typeof n2 == typeof i2 && n2 >= i2;
        }], "filter-id->=": [Ot, [Ut], (t2, [e2]) => {
          const r2 = t2.id(), n2 = e2.value;
          return typeof r2 == typeof n2 && r2 >= n2;
        }], "filter-has": [Ot, [Ut], (t2, [e2]) => e2.value in t2.properties()], "filter-has-id": [Ot, [], (t2) => null !== t2.id() && void 0 !== t2.id()], "filter-type-in": [Ot, [Kt(Lt)], (t2, [e2]) => e2.value.indexOf(t2.geometryType()) >= 0], "filter-id-in": [Ot, [Kt(Ut)], (t2, [e2]) => e2.value.indexOf(t2.id()) >= 0], "filter-in-small": [Ot, [Lt, Kt(Ut)], (t2, [e2, r2]) => r2.value.indexOf(t2.properties()[e2.value]) >= 0], "filter-in-large": [Ot, [Lt, Kt(Ut)], (t2, [e2, r2]) => function(t3, e3, r3, n2) {
          for (; r3 <= n2; ) {
            const i2 = r3 + n2 >> 1;
            if (e3[i2] === t3) return true;
            e3[i2] > t3 ? n2 = i2 - 1 : r3 = i2 + 1;
          }
          return false;
        }(t2.properties()[e2.value], r2.value, 0, r2.value.length - 1)], all: { type: Ot, overloads: [[[Ot, Ot], (t2, [e2, r2]) => e2.evaluate(t2) && r2.evaluate(t2)], [Cn(Ot), (t2, e2) => {
          for (const r2 of e2) if (!r2.evaluate(t2)) return false;
          return true;
        }]] }, any: { type: Ot, overloads: [[[Ot, Ot], (t2, [e2, r2]) => e2.evaluate(t2) || r2.evaluate(t2)], [Cn(Ot), (t2, e2) => {
          for (const r2 of e2) if (r2.evaluate(t2)) return true;
          return false;
        }]] }, "!": [Ot, [Ot], (t2, [e2]) => !e2.evaluate(t2)], "is-supported-script": [Ot, [Lt], (t2, [e2]) => {
          const r2 = t2.globals && t2.globals.isSupportedScript;
          return !r2 || r2(e2.evaluate(t2));
        }], upcase: [Lt, [Lt], (t2, [e2]) => e2.evaluate(t2).toUpperCase()], downcase: [Lt, [Lt], (t2, [e2]) => e2.evaluate(t2).toLowerCase()], concat: [Lt, Cn(Ut), (t2, e2) => e2.map((e3) => qe(e3.evaluate(t2))).join("")], "resolved-locale": [Lt, [qt], (t2, [e2]) => e2.evaluate(t2).resolvedLocale()] });
        class ei {
          constructor(t2, e2, r2) {
            this.expression = t2, this._warningHistory = {}, this._evaluator = new Ke(), this._defaultValue = e2 ? function(t3) {
              if ("color" === t3.type && Yn(t3.default)) return new Te(0, 0, 0, 0);
              switch (t3.type) {
                case "color":
                  return Te.parse(t3.default) || null;
                case "padding":
                  return Pe.parse(t3.default) || null;
                case "numberArray":
                  return ze.parse(t3.default) || null;
                case "colorArray":
                  return Be.parse(t3.default) || null;
                case "variableAnchorOffsetCollection":
                  return Le.parse(t3.default) || null;
                case "projectionDefinition":
                  return Re.parse(t3.default) || null;
                default:
                  return void 0 === t3.default ? null : t3.default;
              }
            }(e2) : null, this._enumValues = e2 && "enum" === e2.type ? e2.values : null, this._globalState = r2;
          }
          evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2) {
            return this._globalState && (t2 = ci(t2, this._globalState)), this._evaluator.globals = t2, this._evaluator.feature = e2, this._evaluator.featureState = r2, this._evaluator.canonical = n2, this._evaluator.availableImages = i2 || null, this._evaluator.formattedSection = s2, this.expression.evaluate(this._evaluator);
          }
          evaluate(t2, e2, r2, n2, i2, s2) {
            this._globalState && (t2 = ci(t2, this._globalState)), this._evaluator.globals = t2, this._evaluator.feature = e2 || null, this._evaluator.featureState = r2 || null, this._evaluator.canonical = n2, this._evaluator.availableImages = i2 || null, this._evaluator.formattedSection = s2 || null;
            try {
              const t3 = this.expression.evaluate(this._evaluator);
              if (null == t3 || "number" == typeof t3 && t3 != t3) return this._defaultValue;
              if (this._enumValues && !(t3 in this._enumValues)) throw new Ve(`Expected value to be one of ${Object.keys(this._enumValues).map((t4) => JSON.stringify(t4)).join(", ")}, but found ${JSON.stringify(t3)} instead.`);
              return t3;
            } catch (t3) {
              return this._warningHistory[t3.message] || (this._warningHistory[t3.message] = true, "undefined" != typeof console && console.warn(t3.message)), this._defaultValue;
            }
          }
        }
        function ri(t2) {
          return Array.isArray(t2) && t2.length > 0 && "string" == typeof t2[0] && t2[0] in Dn;
        }
        function ni(t2, e2, r2) {
          const n2 = new We(Dn, Ln, [], e2 ? function(t3) {
            const e3 = { color: Rt, string: Lt, number: Ct, enum: Lt, boolean: Ot, formatted: jt, padding: Gt, numberArray: Yt, colorArray: Xt, projectionDefinition: Nt, resolvedImage: Zt, variableAnchorOffsetCollection: Ht };
            return "array" === t3.type ? Kt(e3[t3.value] || Ut, t3.length) : e3[t3.type];
          }(e2) : void 0), i2 = n2.parse(t2, void 0, void 0, void 0, e2 && "string" === e2.type ? { typeAnnotation: "coerce" } : void 0);
          return i2 ? $n(new ei(i2, e2, r2)) : Un(n2.errors);
        }
        class ii {
          constructor(t2, e2, r2) {
            this.kind = t2, this._styleExpression = e2, this.isStateDependent = "constant" !== t2 && !Rn(e2.expression), this.globalStateRefs = ui(e2.expression), this._globalState = r2;
          }
          evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2) {
            return this._globalState && (t2 = ci(t2, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2);
          }
          evaluate(t2, e2, r2, n2, i2, s2) {
            return this._globalState && (t2 = ci(t2, this._globalState)), this._styleExpression.evaluate(t2, e2, r2, n2, i2, s2);
          }
        }
        class si {
          constructor(t2, e2, r2, n2, i2) {
            this.kind = t2, this.zoomStops = r2, this._styleExpression = e2, this.isStateDependent = "camera" !== t2 && !Rn(e2.expression), this.globalStateRefs = ui(e2.expression), this.interpolationType = n2, this._globalState = i2;
          }
          evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2) {
            return this._globalState && (t2 = ci(t2, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2);
          }
          evaluate(t2, e2, r2, n2, i2, s2) {
            return this._globalState && (t2 = ci(t2, this._globalState)), this._styleExpression.evaluate(t2, e2, r2, n2, i2, s2);
          }
          interpolationFactor(t2, e2, r2) {
            return this.interpolationType ? fr.interpolationFactor(this.interpolationType, t2, e2, r2) : 0;
          }
        }
        function oi(t2, e2, r2) {
          const n2 = ni(t2, e2, r2);
          if ("error" === n2.result) return n2;
          const i2 = n2.value.expression, s2 = On(i2);
          if (!s2 && !qn(e2)) return Un([new zt("", "data expressions not supported")]);
          const o2 = Nn(i2, ["zoom"]);
          if (!o2 && !jn(e2)) return Un([new zt("", "zoom expressions not supported")]);
          const a2 = li(i2);
          return a2 || o2 ? a2 instanceof zt ? Un([a2]) : a2 instanceof fr && !Gn(e2) ? Un([new zt("", '"interpolate" expressions cannot be used with this property')]) : $n(a2 ? new si(s2 ? "camera" : "composite", n2.value, a2.labels, a2 instanceof fr ? a2.interpolation : void 0, r2) : new ii(s2 ? "constant" : "source", n2.value, r2)) : Un([new zt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')]);
        }
        class ai {
          constructor(t2, e2) {
            this._parameters = t2, this._specification = e2, Pt(this, Hn(this._parameters, this._specification));
          }
          static deserialize(t2) {
            return new ai(t2._parameters, t2._specification);
          }
          static serialize(t2) {
            return { _parameters: t2._parameters, _specification: t2._specification };
          }
        }
        function li(t2) {
          let e2 = null;
          if (t2 instanceof Je) e2 = li(t2.result);
          else if (t2 instanceof mr) {
            for (const r2 of t2.args) if (e2 = li(r2), e2) break;
          } else (t2 instanceof ar || t2 instanceof fr) && t2.input instanceof Pn && "zoom" === t2.input.name && (e2 = t2);
          return e2 instanceof zt || t2.eachChild((t3) => {
            const r2 = li(t3);
            r2 instanceof zt ? e2 = r2 : !e2 && r2 ? e2 = new zt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e2 && r2 && e2 !== r2 && (e2 = new zt("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
          }), e2;
        }
        function ui(t2, e2 = /* @__PURE__ */ new Set()) {
          return t2 instanceof Fn && e2.add(t2.key), t2.eachChild((t3) => {
            ui(t3, e2);
          }), e2;
        }
        function ci(t2, e2) {
          const { zoom: r2, heatmapDensity: n2, elevation: i2, lineProgress: s2, isSupportedScript: o2, accumulated: a2 } = null != t2 ? t2 : {};
          return { zoom: r2, heatmapDensity: n2, elevation: i2, lineProgress: s2, isSupportedScript: o2, accumulated: a2, globalState: e2 };
        }
        function hi(t2) {
          if (true === t2 || false === t2) return true;
          if (!Array.isArray(t2) || 0 === t2.length) return false;
          switch (t2[0]) {
            case "has":
              return t2.length >= 2 && "$id" !== t2[1] && "$type" !== t2[1];
            case "in":
              return t2.length >= 3 && ("string" != typeof t2[1] || Array.isArray(t2[2]));
            case "!in":
            case "!has":
            case "none":
              return false;
            case "==":
            case "!=":
            case ">":
            case ">=":
            case "<":
            case "<=":
              return 3 !== t2.length || Array.isArray(t2[1]) || Array.isArray(t2[2]);
            case "any":
            case "all":
              for (const e2 of t2.slice(1)) if (!hi(e2) && "boolean" != typeof e2) return false;
              return true;
            default:
              return true;
          }
        }
        const pi = { type: "boolean", default: false, transition: false, "property-type": "data-driven", expression: { interpolated: false, parameters: ["zoom", "feature"] } };
        function fi(t2, e2) {
          if (null == t2) return { filter: () => true, needGeometry: false, getGlobalStateRefs: () => /* @__PURE__ */ new Set() };
          hi(t2) || (t2 = mi(t2));
          const r2 = ni(t2, pi, e2);
          if ("error" === r2.result) throw new Error(r2.value.map((t3) => `${t3.key}: ${t3.message}`).join(", "));
          return { filter: (t3, e3, n2) => r2.value.evaluate(t3, e3, {}, n2), needGeometry: yi(t2), getGlobalStateRefs: () => ui(r2.value.expression) };
        }
        function di(t2, e2) {
          return t2 < e2 ? -1 : t2 > e2 ? 1 : 0;
        }
        function yi(t2) {
          if (!Array.isArray(t2)) return false;
          if ("within" === t2[0] || "distance" === t2[0]) return true;
          for (let e2 = 1; e2 < t2.length; e2++) if (yi(t2[e2])) return true;
          return false;
        }
        function mi(t2) {
          if (!t2) return true;
          const e2 = t2[0];
          return t2.length <= 1 ? "any" !== e2 : "==" === e2 ? gi(t2[1], t2[2], "==") : "!=" === e2 ? bi(gi(t2[1], t2[2], "==")) : "<" === e2 || ">" === e2 || "<=" === e2 || ">=" === e2 ? gi(t2[1], t2[2], e2) : "any" === e2 ? (r2 = t2.slice(1), ["any"].concat(r2.map(mi))) : "all" === e2 ? ["all"].concat(t2.slice(1).map(mi)) : "none" === e2 ? ["all"].concat(t2.slice(1).map(mi).map(bi)) : "in" === e2 ? xi(t2[1], t2.slice(2)) : "!in" === e2 ? bi(xi(t2[1], t2.slice(2))) : "has" === e2 ? vi(t2[1]) : "!has" !== e2 || bi(vi(t2[1]));
          var r2;
        }
        function gi(t2, e2, r2) {
          switch (t2) {
            case "$type":
              return [`filter-type-${r2}`, e2];
            case "$id":
              return [`filter-id-${r2}`, e2];
            default:
              return [`filter-${r2}`, t2, e2];
          }
        }
        function xi(t2, e2) {
          if (0 === e2.length) return false;
          switch (t2) {
            case "$type":
              return ["filter-type-in", ["literal", e2]];
            case "$id":
              return ["filter-id-in", ["literal", e2]];
            default:
              return e2.length > 200 && !e2.some((t3) => typeof t3 != typeof e2[0]) ? ["filter-in-large", t2, ["literal", e2.sort(di)]] : ["filter-in-small", t2, ["literal", e2]];
          }
        }
        function vi(t2) {
          switch (t2) {
            case "$type":
              return true;
            case "$id":
              return ["filter-has-id"];
            default:
              return ["filter-has", t2];
          }
        }
        function bi(t2) {
          return ["!", t2];
        }
        function wi(t2) {
          const e2 = typeof t2;
          if ("number" === e2 || "boolean" === e2 || "string" === e2 || null == t2) return JSON.stringify(t2);
          if (Array.isArray(t2)) {
            let e3 = "[";
            for (const r3 of t2) e3 += `${wi(r3)},`;
            return `${e3}]`;
          }
          const r2 = Object.keys(t2).sort();
          let n2 = "{";
          for (let e3 = 0; e3 < r2.length; e3++) n2 += `${JSON.stringify(r2[e3])}:${wi(t2[r2[e3]])},`;
          return `${n2}}`;
        }
        function _i(t2) {
          let e2 = "";
          for (const r2 of bt) e2 += `/${wi(t2[r2])}`;
          return e2;
        }
        function Ai(t2) {
          const e2 = t2.value;
          return e2 ? [new Dt(t2.key, e2, "constants have been deprecated as of v8")] : [];
        }
        function Si(t2) {
          return t2 instanceof Number || t2 instanceof String || t2 instanceof Boolean ? t2.valueOf() : t2;
        }
        function ki(t2) {
          if (Array.isArray(t2)) return t2.map(ki);
          if (t2 instanceof Object && !(t2 instanceof Number || t2 instanceof String || t2 instanceof Boolean)) {
            const e2 = {};
            for (const r2 in t2) e2[r2] = ki(t2[r2]);
            return e2;
          }
          return Si(t2);
        }
        function Ei(t2) {
          const e2 = t2.key, r2 = t2.value, n2 = t2.valueSpec || {}, i2 = t2.objectElementValidators || {}, s2 = t2.style, o2 = t2.styleSpec, a2 = t2.validateSpec;
          let l2 = [];
          const u2 = Xn(r2);
          if ("object" !== u2) return [new Dt(e2, r2, `object expected, ${u2} found`)];
          for (const t3 in r2) {
            const u3 = t3.split(".")[0], c2 = ve(n2, u3) || n2["*"];
            let h2;
            if (ve(i2, u3)) h2 = i2[u3];
            else if (ve(n2, u3)) h2 = a2;
            else if (i2["*"]) h2 = i2["*"];
            else {
              if (!n2["*"]) {
                l2.push(new Dt(e2, r2[t3], `unknown property "${t3}"`));
                continue;
              }
              h2 = a2;
            }
            l2 = l2.concat(h2({ key: (e2 ? `${e2}.` : e2) + t3, value: r2[t3], valueSpec: c2, style: s2, styleSpec: o2, object: r2, objectKey: t3, validateSpec: a2 }, r2));
          }
          for (const t3 in n2) i2[t3] || n2[t3].required && void 0 === n2[t3].default && void 0 === r2[t3] && l2.push(new Dt(e2, r2, `missing required property "${t3}"`));
          return l2;
        }
        function Ti(t2) {
          const e2 = t2.value, r2 = t2.valueSpec, n2 = t2.style, i2 = t2.styleSpec, s2 = t2.key, o2 = t2.arrayElementValidator || t2.validateSpec;
          if ("array" !== Xn(e2)) return [new Dt(s2, e2, `array expected, ${Xn(e2)} found`)];
          if (r2.length && e2.length !== r2.length) return [new Dt(s2, e2, `array length ${r2.length} expected, length ${e2.length} found`)];
          if (r2["min-length"] && e2.length < r2["min-length"]) return [new Dt(s2, e2, `array length at least ${r2["min-length"]} expected, length ${e2.length} found`)];
          let a2 = { type: r2.value, values: r2.values };
          i2.$version < 7 && (a2.function = r2.function), "object" === Xn(r2.value) && (a2 = r2.value);
          let l2 = [];
          for (let r3 = 0; r3 < e2.length; r3++) l2 = l2.concat(o2({ array: e2, arrayIndex: r3, value: e2[r3], valueSpec: a2, validateSpec: t2.validateSpec, style: n2, styleSpec: i2, key: `${s2}[${r3}]` }));
          return l2;
        }
        function Ii(t2) {
          const e2 = t2.key, r2 = t2.value, n2 = t2.valueSpec;
          let i2 = Xn(r2);
          return "number" === i2 && r2 != r2 && (i2 = "NaN"), "number" !== i2 ? [new Dt(e2, r2, `number expected, ${i2} found`)] : "minimum" in n2 && r2 < n2.minimum ? [new Dt(e2, r2, `${r2} is less than the minimum value ${n2.minimum}`)] : "maximum" in n2 && r2 > n2.maximum ? [new Dt(e2, r2, `${r2} is greater than the maximum value ${n2.maximum}`)] : [];
        }
        function Mi(t2) {
          const e2 = t2.valueSpec, r2 = Si(t2.value.type);
          let n2, i2, s2, o2 = {};
          const a2 = "categorical" !== r2 && void 0 === t2.value.property, l2 = !a2, u2 = "array" === Xn(t2.value.stops) && "array" === Xn(t2.value.stops[0]) && "object" === Xn(t2.value.stops[0][0]), c2 = Ei({ key: t2.key, value: t2.value, valueSpec: t2.styleSpec.function, validateSpec: t2.validateSpec, style: t2.style, styleSpec: t2.styleSpec, objectElementValidators: { stops: function(t3) {
            if ("identity" === r2) return [new Dt(t3.key, t3.value, 'identity function may not have a "stops" property')];
            let e3 = [];
            const n3 = t3.value;
            return e3 = e3.concat(Ti({ key: t3.key, value: n3, valueSpec: t3.valueSpec, validateSpec: t3.validateSpec, style: t3.style, styleSpec: t3.styleSpec, arrayElementValidator: h2 })), "array" === Xn(n3) && 0 === n3.length && e3.push(new Dt(t3.key, n3, "array must have at least one stop")), e3;
          }, default: function(t3) {
            return t3.validateSpec({ key: t3.key, value: t3.value, valueSpec: e2, validateSpec: t3.validateSpec, style: t3.style, styleSpec: t3.styleSpec });
          } } });
          return "identity" === r2 && a2 && c2.push(new Dt(t2.key, t2.value, 'missing required property "property"')), "identity" === r2 || t2.value.stops || c2.push(new Dt(t2.key, t2.value, 'missing required property "stops"')), "exponential" === r2 && t2.valueSpec.expression && !Gn(t2.valueSpec) && c2.push(new Dt(t2.key, t2.value, "exponential functions not supported")), t2.styleSpec.$version >= 8 && (l2 && !qn(t2.valueSpec) ? c2.push(new Dt(t2.key, t2.value, "property functions not supported")) : a2 && !jn(t2.valueSpec) && c2.push(new Dt(t2.key, t2.value, "zoom functions not supported"))), "categorical" !== r2 && !u2 || void 0 !== t2.value.property || c2.push(new Dt(t2.key, t2.value, '"property" property is required')), c2;
          function h2(t3) {
            let r3 = [];
            const n3 = t3.value, a3 = t3.key;
            if ("array" !== Xn(n3)) return [new Dt(a3, n3, `array expected, ${Xn(n3)} found`)];
            if (2 !== n3.length) return [new Dt(a3, n3, `array length 2 expected, length ${n3.length} found`)];
            if (u2) {
              if ("object" !== Xn(n3[0])) return [new Dt(a3, n3, `object expected, ${Xn(n3[0])} found`)];
              if (void 0 === n3[0].zoom) return [new Dt(a3, n3, "object stop key must have zoom")];
              if (void 0 === n3[0].value) return [new Dt(a3, n3, "object stop key must have value")];
              if (s2 && s2 > Si(n3[0].zoom)) return [new Dt(a3, n3[0].zoom, "stop zoom values must appear in ascending order")];
              Si(n3[0].zoom) !== s2 && (s2 = Si(n3[0].zoom), i2 = void 0, o2 = {}), r3 = r3.concat(Ei({ key: `${a3}[0]`, value: n3[0], valueSpec: { zoom: {} }, validateSpec: t3.validateSpec, style: t3.style, styleSpec: t3.styleSpec, objectElementValidators: { zoom: Ii, value: p2 } }));
            } else r3 = r3.concat(p2({ key: `${a3}[0]`, value: n3[0], validateSpec: t3.validateSpec, style: t3.style, styleSpec: t3.styleSpec }, n3));
            return ri(ki(n3[1])) ? r3.concat([new Dt(`${a3}[1]`, n3[1], "expressions are not allowed in function stops.")]) : r3.concat(t3.validateSpec({ key: `${a3}[1]`, value: n3[1], valueSpec: e2, validateSpec: t3.validateSpec, style: t3.style, styleSpec: t3.styleSpec }));
          }
          function p2(t3, s3) {
            const a3 = Xn(t3.value), l3 = Si(t3.value), u3 = null !== t3.value ? t3.value : s3;
            if (n2) {
              if (a3 !== n2) return [new Dt(t3.key, u3, `${a3} stop domain type must match previous stop domain type ${n2}`)];
            } else n2 = a3;
            if ("number" !== a3 && "string" !== a3 && "boolean" !== a3) return [new Dt(t3.key, u3, "stop domain value must be a number, string, or boolean")];
            if ("number" !== a3 && "categorical" !== r2) {
              let n3 = `number expected, ${a3} found`;
              return qn(e2) && void 0 === r2 && (n3 += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [new Dt(t3.key, u3, n3)];
            }
            return "categorical" !== r2 || "number" !== a3 || isFinite(l3) && Math.floor(l3) === l3 ? "categorical" !== r2 && "number" === a3 && void 0 !== i2 && l3 < i2 ? [new Dt(t3.key, u3, "stop domain values must appear in ascending order")] : (i2 = l3, "categorical" === r2 && l3 in o2 ? [new Dt(t3.key, u3, "stop domain values must be unique")] : (o2[l3] = true, [])) : [new Dt(t3.key, u3, `integer expected, found ${l3}`)];
          }
        }
        function Fi(t2) {
          const e2 = ("property" === t2.expressionContext ? oi : ni)(ki(t2.value), t2.valueSpec);
          if ("error" === e2.result) return e2.value.map((e3) => new Dt(`${t2.key}${e3.key}`, t2.value, e3.message));
          const r2 = e2.value.expression || e2.value._styleExpression.expression;
          if ("property" === t2.expressionContext && "text-font" === t2.propertyKey && !r2.outputDefined()) return [new Dt(t2.key, t2.value, `Invalid data expression for "${t2.propertyKey}". Output values must be contained as literals within the expression.`)];
          if ("property" === t2.expressionContext && "layout" === t2.propertyType && !Rn(r2)) return [new Dt(t2.key, t2.value, '"feature-state" data expressions are not supported with layout properties.')];
          if ("filter" === t2.expressionContext && !Rn(r2)) return [new Dt(t2.key, t2.value, '"feature-state" data expressions are not supported with filters.')];
          if (t2.expressionContext && 0 === t2.expressionContext.indexOf("cluster")) {
            if (!Nn(r2, ["zoom", "feature-state"])) return [new Dt(t2.key, t2.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
            if ("cluster-initial" === t2.expressionContext && !On(r2)) return [new Dt(t2.key, t2.value, "Feature data expressions are not supported with initial expression part of cluster properties.")];
          }
          return [];
        }
        function Di(t2) {
          const e2 = t2.key, r2 = t2.value, n2 = Xn(r2);
          return "string" !== n2 ? [new Dt(e2, r2, `color expected, ${n2} found`)] : Te.parse(String(r2)) ? [] : [new Dt(e2, r2, `color expected, "${r2}" found`)];
        }
        function Pi(t2) {
          const e2 = t2.key, r2 = t2.value, n2 = t2.valueSpec, i2 = [];
          return Array.isArray(n2.values) ? -1 === n2.values.indexOf(Si(r2)) && i2.push(new Dt(e2, r2, `expected one of [${n2.values.join(", ")}], ${JSON.stringify(r2)} found`)) : -1 === Object.keys(n2.values).indexOf(Si(r2)) && i2.push(new Dt(e2, r2, `expected one of [${Object.keys(n2.values).join(", ")}], ${JSON.stringify(r2)} found`)), i2;
        }
        function zi(t2) {
          return hi(ki(t2.value)) ? Fi(Pt({}, t2, { expressionContext: "filter", valueSpec: { value: "boolean" } })) : Bi(t2);
        }
        function Bi(t2) {
          const e2 = t2.value, r2 = t2.key;
          if ("array" !== Xn(e2)) return [new Dt(r2, e2, `array expected, ${Xn(e2)} found`)];
          const n2 = t2.styleSpec;
          let i2, s2 = [];
          if (e2.length < 1) return [new Dt(r2, e2, "filter array must have at least 1 element")];
          switch (s2 = s2.concat(Pi({ key: `${r2}[0]`, value: e2[0], valueSpec: n2.filter_operator, style: t2.style, styleSpec: t2.styleSpec })), Si(e2[0])) {
            case "<":
            case "<=":
            case ">":
            case ">=":
              e2.length >= 2 && "$type" === Si(e2[1]) && s2.push(new Dt(r2, e2, `"$type" cannot be use with operator "${e2[0]}"`));
            case "==":
            case "!=":
              3 !== e2.length && s2.push(new Dt(r2, e2, `filter array for operator "${e2[0]}" must have 3 elements`));
            case "in":
            case "!in":
              e2.length >= 2 && (i2 = Xn(e2[1]), "string" !== i2 && s2.push(new Dt(`${r2}[1]`, e2[1], `string expected, ${i2} found`)));
              for (let o2 = 2; o2 < e2.length; o2++) i2 = Xn(e2[o2]), "$type" === Si(e2[1]) ? s2 = s2.concat(Pi({ key: `${r2}[${o2}]`, value: e2[o2], valueSpec: n2.geometry_type, style: t2.style, styleSpec: t2.styleSpec })) : "string" !== i2 && "number" !== i2 && "boolean" !== i2 && s2.push(new Dt(`${r2}[${o2}]`, e2[o2], `string, number, or boolean expected, ${i2} found`));
              break;
            case "any":
            case "all":
            case "none":
              for (let n3 = 1; n3 < e2.length; n3++) s2 = s2.concat(Bi({ key: `${r2}[${n3}]`, value: e2[n3], style: t2.style, styleSpec: t2.styleSpec }));
              break;
            case "has":
            case "!has":
              i2 = Xn(e2[1]), 2 !== e2.length ? s2.push(new Dt(r2, e2, `filter array for "${e2[0]}" operator must have 2 elements`)) : "string" !== i2 && s2.push(new Dt(`${r2}[1]`, e2[1], `string expected, ${i2} found`));
          }
          return s2;
        }
        function Vi(t2, e2) {
          const r2 = t2.key, n2 = t2.validateSpec, i2 = t2.style, s2 = t2.styleSpec, o2 = t2.value, a2 = t2.objectKey, l2 = s2[`${e2}_${t2.layerType}`];
          if (!l2) return [];
          const u2 = a2.match(/^(.*)-transition$/);
          if ("paint" === e2 && u2 && l2[u2[1]] && l2[u2[1]].transition) return n2({ key: r2, value: o2, valueSpec: s2.transition, style: i2, styleSpec: s2 });
          const c2 = t2.valueSpec || l2[a2];
          if (!c2) return [new Dt(r2, o2, `unknown property "${a2}"`)];
          let h2;
          if ("string" === Xn(o2) && qn(c2) && !c2.tokens && (h2 = /^{([^}]+)}$/.exec(o2))) return [new Dt(r2, o2, `"${a2}" does not support interpolation syntax
Use an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(h2[1])} }\`.`)];
          const p2 = [];
          return "symbol" === t2.layerType && "text-font" === a2 && Yn(ki(o2)) && "identity" === Si(o2.type) && p2.push(new Dt(r2, o2, '"text-font" does not support identity functions')), p2.concat(n2({ key: t2.key, value: o2, valueSpec: c2, style: i2, styleSpec: s2, expressionContext: "property", propertyType: e2, propertyKey: a2 }));
        }
        function Ci(t2) {
          return Vi(t2, "paint");
        }
        function Li(t2) {
          return Vi(t2, "layout");
        }
        function Oi(t2) {
          let e2 = [];
          const r2 = t2.value, n2 = t2.key, i2 = t2.style, s2 = t2.styleSpec;
          if ("object" !== Xn(r2)) return [new Dt(n2, r2, `object expected, ${Xn(r2)} found`)];
          r2.type || r2.ref || e2.push(new Dt(n2, r2, 'either "type" or "ref" is required'));
          let o2 = Si(r2.type);
          const a2 = Si(r2.ref);
          if (r2.id) {
            const s3 = Si(r2.id);
            for (let o3 = 0; o3 < t2.arrayIndex; o3++) {
              const t3 = i2.layers[o3];
              Si(t3.id) === s3 && e2.push(new Dt(n2, r2.id, `duplicate layer id "${r2.id}", previously used at line ${t3.id.__line__}`));
            }
          }
          if ("ref" in r2) {
            let t3;
            ["type", "source", "source-layer", "filter", "layout"].forEach((t4) => {
              t4 in r2 && e2.push(new Dt(n2, r2[t4], `"${t4}" is prohibited for ref layers`));
            }), i2.layers.forEach((e3) => {
              Si(e3.id) === a2 && (t3 = e3);
            }), t3 ? t3.ref ? e2.push(new Dt(n2, r2.ref, "ref cannot reference another ref layer")) : o2 = Si(t3.type) : e2.push(new Dt(n2, r2.ref, `ref layer "${a2}" not found`));
          } else if ("background" !== o2) if (r2.source) {
            const t3 = i2.sources && i2.sources[r2.source], s3 = t3 && Si(t3.type);
            t3 ? "vector" === s3 && "raster" === o2 ? e2.push(new Dt(n2, r2.source, `layer "${r2.id}" requires a raster source`)) : "raster-dem" !== s3 && "hillshade" === o2 || "raster-dem" !== s3 && "color-relief" === o2 ? e2.push(new Dt(n2, r2.source, `layer "${r2.id}" requires a raster-dem source`)) : "raster" === s3 && "raster" !== o2 ? e2.push(new Dt(n2, r2.source, `layer "${r2.id}" requires a vector source`)) : "vector" !== s3 || r2["source-layer"] ? "raster-dem" === s3 && "hillshade" !== o2 && "color-relief" !== o2 ? e2.push(new Dt(n2, r2.source, "raster-dem source can only be used with layer type 'hillshade' or 'color-relief'.")) : "line" !== o2 || !r2.paint || !r2.paint["line-gradient"] || "geojson" === s3 && t3.lineMetrics || e2.push(new Dt(n2, r2, `layer "${r2.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : e2.push(new Dt(n2, r2, `layer "${r2.id}" must specify a "source-layer"`)) : e2.push(new Dt(n2, r2.source, `source "${r2.source}" not found`));
          } else e2.push(new Dt(n2, r2, 'missing required property "source"'));
          return e2 = e2.concat(Ei({ key: n2, value: r2, valueSpec: s2.layer, style: t2.style, styleSpec: t2.styleSpec, validateSpec: t2.validateSpec, objectElementValidators: { "*": () => [], type: () => t2.validateSpec({ key: `${n2}.type`, value: r2.type, valueSpec: s2.layer.type, style: t2.style, styleSpec: t2.styleSpec, validateSpec: t2.validateSpec, object: r2, objectKey: "type" }), filter: zi, layout: (t3) => Ei({ layer: r2, key: t3.key, value: t3.value, style: t3.style, styleSpec: t3.styleSpec, validateSpec: t3.validateSpec, objectElementValidators: { "*": (t4) => Li(Pt({ layerType: o2 }, t4)) } }), paint: (t3) => Ei({ layer: r2, key: t3.key, value: t3.value, style: t3.style, styleSpec: t3.styleSpec, validateSpec: t3.validateSpec, objectElementValidators: { "*": (t4) => Ci(Pt({ layerType: o2 }, t4)) } }) } })), e2;
        }
        function Ri(t2) {
          const e2 = t2.value, r2 = t2.key, n2 = Xn(e2);
          return "string" !== n2 ? [new Dt(r2, e2, `string expected, ${n2} found`)] : [];
        }
        const Ni = { promoteId: function({ key: t2, value: e2 }) {
          if ("string" === Xn(e2)) return Ri({ key: t2, value: e2 });
          {
            const r2 = [];
            for (const n2 in e2) r2.push(...Ri({ key: `${t2}.${n2}`, value: e2[n2] }));
            return r2;
          }
        } };
        function $i(t2) {
          const e2 = t2.value, r2 = t2.key, n2 = t2.styleSpec, i2 = t2.style, s2 = t2.validateSpec;
          if (!e2.type) return [new Dt(r2, e2, '"type" is required')];
          const o2 = Si(e2.type);
          let a2;
          switch (o2) {
            case "vector":
            case "raster":
              return a2 = Ei({ key: r2, value: e2, valueSpec: n2[`source_${o2.replace("-", "_")}`], style: t2.style, styleSpec: n2, objectElementValidators: Ni, validateSpec: s2 }), a2;
            case "raster-dem":
              return a2 = function(t3) {
                var e3;
                const r3 = null !== (e3 = t3.sourceName) && void 0 !== e3 ? e3 : "", n3 = t3.value, i3 = t3.styleSpec, s3 = i3.source_raster_dem, o3 = t3.style;
                let a3 = [];
                const l2 = Xn(n3);
                if (void 0 === n3) return a3;
                if ("object" !== l2) return a3.push(new Dt("source_raster_dem", n3, `object expected, ${l2} found`)), a3;
                const u2 = "custom" === Si(n3.encoding), c2 = ["redFactor", "greenFactor", "blueFactor", "baseShift"], h2 = t3.value.encoding ? `"${t3.value.encoding}"` : "Default";
                for (const e4 in n3) !u2 && c2.includes(e4) ? a3.push(new Dt(e4, n3[e4], `In "${r3}": "${e4}" is only valid when "encoding" is set to "custom". ${h2} encoding found`)) : s3[e4] ? a3 = a3.concat(t3.validateSpec({ key: e4, value: n3[e4], valueSpec: s3[e4], validateSpec: t3.validateSpec, style: o3, styleSpec: i3 })) : a3.push(new Dt(e4, n3[e4], `unknown property "${e4}"`));
                return a3;
              }({ sourceName: r2, value: e2, style: t2.style, styleSpec: n2, validateSpec: s2 }), a2;
            case "geojson":
              if (a2 = Ei({ key: r2, value: e2, valueSpec: n2.source_geojson, style: i2, styleSpec: n2, validateSpec: s2, objectElementValidators: Ni }), e2.cluster) for (const t3 in e2.clusterProperties) {
                const [n3, i3] = e2.clusterProperties[t3], s3 = "string" == typeof n3 ? [n3, ["accumulated"], ["get", t3]] : n3;
                a2.push(...Fi({ key: `${r2}.${t3}.map`, value: i3, expressionContext: "cluster-map" })), a2.push(...Fi({ key: `${r2}.${t3}.reduce`, value: s3, expressionContext: "cluster-reduce" }));
              }
              return a2;
            case "video":
              return Ei({ key: r2, value: e2, valueSpec: n2.source_video, style: i2, validateSpec: s2, styleSpec: n2 });
            case "image":
              return Ei({ key: r2, value: e2, valueSpec: n2.source_image, style: i2, validateSpec: s2, styleSpec: n2 });
            case "canvas":
              return [new Dt(r2, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")];
            default:
              return Pi({ key: `${r2}.type`, value: e2.type, valueSpec: { values: ["vector", "raster", "raster-dem", "geojson", "video", "image"] } });
          }
        }
        function Ui(t2) {
          const e2 = t2.value, r2 = t2.styleSpec, n2 = r2.light, i2 = t2.style;
          let s2 = [];
          const o2 = Xn(e2);
          if (void 0 === e2) return s2;
          if ("object" !== o2) return s2 = s2.concat([new Dt("light", e2, `object expected, ${o2} found`)]), s2;
          for (const o3 in e2) {
            const a2 = o3.match(/^(.*)-transition$/);
            s2 = s2.concat(a2 && n2[a2[1]] && n2[a2[1]].transition ? t2.validateSpec({ key: o3, value: e2[o3], valueSpec: r2.transition, validateSpec: t2.validateSpec, style: i2, styleSpec: r2 }) : n2[o3] ? t2.validateSpec({ key: o3, value: e2[o3], valueSpec: n2[o3], validateSpec: t2.validateSpec, style: i2, styleSpec: r2 }) : [new Dt(o3, e2[o3], `unknown property "${o3}"`)]);
          }
          return s2;
        }
        function qi(t2) {
          const e2 = t2.value, r2 = t2.styleSpec, n2 = r2.sky, i2 = t2.style, s2 = Xn(e2);
          if (void 0 === e2) return [];
          if ("object" !== s2) return [new Dt("sky", e2, `object expected, ${s2} found`)];
          let o2 = [];
          for (const s3 in e2) o2 = o2.concat(n2[s3] ? t2.validateSpec({ key: s3, value: e2[s3], valueSpec: n2[s3], style: i2, styleSpec: r2 }) : [new Dt(s3, e2[s3], `unknown property "${s3}"`)]);
          return o2;
        }
        function ji(t2) {
          const e2 = t2.value, r2 = t2.styleSpec, n2 = r2.terrain, i2 = t2.style;
          let s2 = [];
          const o2 = Xn(e2);
          if (void 0 === e2) return s2;
          if ("object" !== o2) return s2 = s2.concat([new Dt("terrain", e2, `object expected, ${o2} found`)]), s2;
          for (const o3 in e2) s2 = s2.concat(n2[o3] ? t2.validateSpec({ key: o3, value: e2[o3], valueSpec: n2[o3], validateSpec: t2.validateSpec, style: i2, styleSpec: r2 }) : [new Dt(o3, e2[o3], `unknown property "${o3}"`)]);
          return s2;
        }
        function Gi(t2) {
          let e2 = [];
          const r2 = t2.value, n2 = t2.key;
          if (Array.isArray(r2)) {
            const i2 = [], s2 = [];
            for (const o2 in r2) r2[o2].id && i2.includes(r2[o2].id) && e2.push(new Dt(n2, r2, `all the sprites' ids must be unique, but ${r2[o2].id} is duplicated`)), i2.push(r2[o2].id), r2[o2].url && s2.includes(r2[o2].url) && e2.push(new Dt(n2, r2, `all the sprites' URLs must be unique, but ${r2[o2].url} is duplicated`)), s2.push(r2[o2].url), e2 = e2.concat(Ei({ key: `${n2}[${o2}]`, value: r2[o2], valueSpec: { id: { type: "string", required: true }, url: { type: "string", required: true } }, validateSpec: t2.validateSpec }));
            return e2;
          }
          return Ri({ key: n2, value: r2 });
        }
        function Xi(t2) {
          return e2 = t2.value, Boolean(e2) && e2.constructor === Object ? [] : [new Dt(t2.key, t2.value, `object expected, ${Xn(t2.value)} found`)];
          var e2;
        }
        const Yi = { "*": () => [], array: Ti, boolean: function(t2) {
          const e2 = t2.value, r2 = t2.key, n2 = Xn(e2);
          return "boolean" !== n2 ? [new Dt(r2, e2, `boolean expected, ${n2} found`)] : [];
        }, number: Ii, color: Di, constants: Ai, enum: Pi, filter: zi, function: Mi, layer: Oi, object: Ei, source: $i, light: Ui, sky: qi, terrain: ji, projection: function(t2) {
          const e2 = t2.value, r2 = t2.styleSpec, n2 = r2.projection, i2 = t2.style, s2 = Xn(e2);
          if (void 0 === e2) return [];
          if ("object" !== s2) return [new Dt("projection", e2, `object expected, ${s2} found`)];
          let o2 = [];
          for (const s3 in e2) o2 = o2.concat(n2[s3] ? t2.validateSpec({ key: s3, value: e2[s3], valueSpec: n2[s3], style: i2, styleSpec: r2 }) : [new Dt(s3, e2[s3], `unknown property "${s3}"`)]);
          return o2;
        }, projectionDefinition: function(t2) {
          const e2 = t2.key;
          let r2 = t2.value;
          r2 = r2 instanceof String ? r2.valueOf() : r2;
          const n2 = Xn(r2);
          return "array" !== n2 || function(t3) {
            return Array.isArray(t3) && 3 === t3.length && "string" == typeof t3[0] && "string" == typeof t3[1] && "number" == typeof t3[2];
          }(r2) || function(t3) {
            return !!["interpolate", "step", "literal"].includes(t3[0]);
          }(r2) ? ["array", "string"].includes(n2) ? [] : [new Dt(e2, r2, `projection expected, invalid type "${n2}" found`)] : [new Dt(e2, r2, `projection expected, invalid array ${JSON.stringify(r2)} found`)];
        }, string: Ri, formatted: function(t2) {
          return 0 === Ri(t2).length ? [] : Fi(t2);
        }, resolvedImage: function(t2) {
          return 0 === Ri(t2).length ? [] : Fi(t2);
        }, padding: function(t2) {
          const e2 = t2.key, r2 = t2.value;
          if ("array" === Xn(r2)) {
            if (r2.length < 1 || r2.length > 4) return [new Dt(e2, r2, `padding requires 1 to 4 values; ${r2.length} values found`)];
            const n2 = { type: "number" };
            let i2 = [];
            for (let s2 = 0; s2 < r2.length; s2++) i2 = i2.concat(t2.validateSpec({ key: `${e2}[${s2}]`, value: r2[s2], validateSpec: t2.validateSpec, valueSpec: n2 }));
            return i2;
          }
          return Ii({ key: e2, value: r2, valueSpec: {} });
        }, numberArray: function(t2) {
          const e2 = t2.key, r2 = t2.value;
          if ("array" === Xn(r2)) {
            const n2 = { type: "number" };
            if (r2.length < 1) return [new Dt(e2, r2, "array length at least 1 expected, length 0 found")];
            let i2 = [];
            for (let s2 = 0; s2 < r2.length; s2++) i2 = i2.concat(t2.validateSpec({ key: `${e2}[${s2}]`, value: r2[s2], validateSpec: t2.validateSpec, valueSpec: n2 }));
            return i2;
          }
          return Ii({ key: e2, value: r2, valueSpec: {} });
        }, colorArray: function(t2) {
          const e2 = t2.key, r2 = t2.value;
          if ("array" === Xn(r2)) {
            if (r2.length < 1) return [new Dt(e2, r2, "array length at least 1 expected, length 0 found")];
            let t3 = [];
            for (let n2 = 0; n2 < r2.length; n2++) t3 = t3.concat(Di({ key: `${e2}[${n2}]`, value: r2[n2] }));
            return t3;
          }
          return Di({ key: e2, value: r2 });
        }, variableAnchorOffsetCollection: function(t2) {
          const e2 = t2.key, r2 = t2.value, n2 = Xn(r2), i2 = t2.styleSpec;
          if ("array" !== n2 || r2.length < 1 || r2.length % 2 != 0) return [new Dt(e2, r2, "variableAnchorOffsetCollection requires a non-empty array of even length")];
          let s2 = [];
          for (let n3 = 0; n3 < r2.length; n3 += 2) s2 = s2.concat(Pi({ key: `${e2}[${n3}]`, value: r2[n3], valueSpec: i2.layout_symbol["text-anchor"] })), s2 = s2.concat(Ti({ key: `${e2}[${n3 + 1}]`, value: r2[n3 + 1], valueSpec: { length: 2, value: "number" }, validateSpec: t2.validateSpec, style: t2.style, styleSpec: i2 }));
          return s2;
        }, sprite: Gi, state: Xi };
        function Zi(t2) {
          const e2 = t2.value, r2 = t2.valueSpec, n2 = t2.styleSpec;
          return t2.validateSpec = Zi, r2.expression && Yn(Si(e2)) ? Mi(t2) : r2.expression && ri(ki(e2)) ? Fi(t2) : r2.type && Yi[r2.type] ? Yi[r2.type](t2) : Ei(Pt({}, t2, { valueSpec: r2.type ? n2[r2.type] : r2 }));
        }
        function Hi(t2) {
          const e2 = t2.value, r2 = t2.key, n2 = Ri(t2);
          return n2.length || (-1 === e2.indexOf("{fontstack}") && n2.push(new Dt(r2, e2, '"glyphs" url must include a "{fontstack}" token')), -1 === e2.indexOf("{range}") && n2.push(new Dt(r2, e2, '"glyphs" url must include a "{range}" token'))), n2;
        }
        function Ki(t2, e2 = vt) {
          let r2 = [];
          return r2 = r2.concat(Zi({ key: "", value: t2, valueSpec: e2.$root, styleSpec: e2, style: t2, validateSpec: Zi, objectElementValidators: { glyphs: Hi, "*": () => [] } })), t2.constants && (r2 = r2.concat(Ai({ key: "constants", value: t2.constants }))), Ji(r2);
        }
        function Wi(t2) {
          return function(e2) {
            return t2(Object.assign({}, e2, { validateSpec: Zi }));
          };
        }
        function Ji(t2) {
          return [].concat(t2).sort((t3, e2) => t3.line - e2.line);
        }
        function Qi(t2) {
          return function(...e2) {
            return Ji(t2.apply(this, e2));
          };
        }
        Ki.source = Qi(Wi($i)), Ki.sprite = Qi(Wi(Gi)), Ki.glyphs = Qi(Wi(Hi)), Ki.light = Qi(Wi(Ui)), Ki.sky = Qi(Wi(qi)), Ki.terrain = Qi(Wi(ji)), Ki.state = Qi(Wi(Xi)), Ki.layer = Qi(Wi(Oi)), Ki.filter = Qi(Wi(zi)), Ki.paintProperty = Qi(Wi(Ci)), Ki.layoutProperty = Qi(Wi(Li));
        const ts = vt, es = Ki, rs = es.light, ns = es.sky, is = es.paintProperty, ss = es.layoutProperty;
        function os(t2, e2) {
          let r2 = false;
          if (e2 && e2.length) for (const n2 of e2) t2.fire(new gt(new Error(n2.message))), r2 = true;
          return r2;
        }
        class as {
          constructor(t2, e2, r2) {
            const n2 = this.cells = [];
            if (t2 instanceof ArrayBuffer) {
              this.arrayBuffer = t2;
              const i3 = new Int32Array(this.arrayBuffer);
              t2 = i3[0], this.d = (e2 = i3[1]) + 2 * (r2 = i3[2]);
              for (let t3 = 0; t3 < this.d * this.d; t3++) {
                const e3 = i3[3 + t3], r3 = i3[3 + t3 + 1];
                n2.push(e3 === r3 ? null : i3.subarray(e3, r3));
              }
              const s2 = i3[3 + n2.length + 1];
              this.keys = i3.subarray(i3[3 + n2.length], s2), this.bboxes = i3.subarray(s2), this.insert = this._insertReadonly;
            } else {
              this.d = e2 + 2 * r2;
              for (let t3 = 0; t3 < this.d * this.d; t3++) n2.push([]);
              this.keys = [], this.bboxes = [];
            }
            this.n = e2, this.extent = t2, this.padding = r2, this.scale = e2 / t2, this.uid = 0;
            const i2 = r2 / e2 * t2;
            this.min = -i2, this.max = t2 + i2;
          }
          insert(t2, e2, r2, n2, i2) {
            this._forEachCell(e2, r2, n2, i2, this._insertCell, this.uid++, void 0, void 0), this.keys.push(t2), this.bboxes.push(e2), this.bboxes.push(r2), this.bboxes.push(n2), this.bboxes.push(i2);
          }
          _insertReadonly() {
            throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
          }
          _insertCell(t2, e2, r2, n2, i2, s2) {
            this.cells[i2].push(s2);
          }
          query(t2, e2, r2, n2, i2) {
            const s2 = this.min, o2 = this.max;
            if (t2 <= s2 && e2 <= s2 && o2 <= r2 && o2 <= n2 && !i2) return Array.prototype.slice.call(this.keys);
            {
              const s3 = [];
              return this._forEachCell(t2, e2, r2, n2, this._queryCell, s3, {}, i2), s3;
            }
          }
          _queryCell(t2, e2, r2, n2, i2, s2, o2, a2) {
            const l2 = this.cells[i2];
            if (null !== l2) {
              const i3 = this.keys, u2 = this.bboxes;
              for (let c2 = 0; c2 < l2.length; c2++) {
                const h2 = l2[c2];
                if (void 0 === o2[h2]) {
                  const l3 = 4 * h2;
                  (a2 ? a2(u2[l3 + 0], u2[l3 + 1], u2[l3 + 2], u2[l3 + 3]) : t2 <= u2[l3 + 2] && e2 <= u2[l3 + 3] && r2 >= u2[l3 + 0] && n2 >= u2[l3 + 1]) ? (o2[h2] = true, s2.push(i3[h2])) : o2[h2] = false;
                }
              }
            }
          }
          _forEachCell(t2, e2, r2, n2, i2, s2, o2, a2) {
            const l2 = this._convertToCellCoord(t2), u2 = this._convertToCellCoord(e2), c2 = this._convertToCellCoord(r2), h2 = this._convertToCellCoord(n2);
            for (let p2 = l2; p2 <= c2; p2++) for (let l3 = u2; l3 <= h2; l3++) {
              const u3 = this.d * l3 + p2;
              if ((!a2 || a2(this._convertFromCellCoord(p2), this._convertFromCellCoord(l3), this._convertFromCellCoord(p2 + 1), this._convertFromCellCoord(l3 + 1))) && i2.call(this, t2, e2, r2, n2, u3, s2, o2, a2)) return;
            }
          }
          _convertFromCellCoord(t2) {
            return (t2 - this.padding) / this.scale;
          }
          _convertToCellCoord(t2) {
            return Math.max(0, Math.min(this.d - 1, Math.floor(t2 * this.scale) + this.padding));
          }
          toArrayBuffer() {
            if (this.arrayBuffer) return this.arrayBuffer;
            const t2 = this.cells, e2 = 3 + this.cells.length + 1 + 1;
            let r2 = 0;
            for (let t3 = 0; t3 < this.cells.length; t3++) r2 += this.cells[t3].length;
            const n2 = new Int32Array(e2 + r2 + this.keys.length + this.bboxes.length);
            n2[0] = this.extent, n2[1] = this.n, n2[2] = this.padding;
            let i2 = e2;
            for (let e3 = 0; e3 < t2.length; e3++) {
              const r3 = t2[e3];
              n2[3 + e3] = i2, n2.set(r3, i2), i2 += r3.length;
            }
            return n2[3 + t2.length] = i2, n2.set(this.keys, i2), i2 += this.keys.length, n2[3 + t2.length + 1] = i2, n2.set(this.bboxes, i2), i2 += this.bboxes.length, n2.buffer;
          }
          static serialize(t2, e2) {
            const r2 = t2.toArrayBuffer();
            return e2 && e2.push(r2), { buffer: r2 };
          }
          static deserialize(t2) {
            return new as(t2.buffer);
          }
        }
        const ls = {};
        function us(t2, e2, r2 = {}) {
          if (ls[t2]) throw new Error(`${t2} is already registered.`);
          Object.defineProperty(e2, "_classRegistryKey", { value: t2, writeable: false }), ls[t2] = { klass: e2, omit: r2.omit || [], shallow: r2.shallow || [] };
        }
        us("Object", Object), us("Set", Set), us("TransferableGridIndex", as), us("Color", Te), us("Error", Error), us("AJAXError", ct), us("ResolvedImage", Oe), us("StylePropertyFunction", ai), us("StyleExpression", ei, { omit: ["_evaluator"] }), us("ZoomDependentExpression", si), us("ZoomConstantExpression", ii), us("CompoundExpression", Pn, { omit: ["_evaluate"] });
        for (const t2 in Dn) Dn[t2]._classRegistryKey || us(`Expression_${t2}`, Dn[t2]);
        function cs(t2) {
          return t2 && "undefined" != typeof ArrayBuffer && (t2 instanceof ArrayBuffer || t2.constructor && "ArrayBuffer" === t2.constructor.name);
        }
        function hs(t2) {
          return t2.$name || t2.constructor._classRegistryKey;
        }
        function ps(t2) {
          return !function(t3) {
            if (null === t3 || "object" != typeof t3) return false;
            const e2 = hs(t3);
            return !(!e2 || "Object" === e2);
          }(t2) && (null == t2 || "boolean" == typeof t2 || "number" == typeof t2 || "string" == typeof t2 || t2 instanceof Boolean || t2 instanceof Number || t2 instanceof String || t2 instanceof Date || t2 instanceof RegExp || t2 instanceof Blob || t2 instanceof Error || cs(t2) || Z(t2) || ArrayBuffer.isView(t2) || t2 instanceof ImageData);
        }
        function fs(t2, e2) {
          if (ps(t2)) return (cs(t2) || Z(t2)) && e2 && e2.push(t2), ArrayBuffer.isView(t2) && e2 && e2.push(t2.buffer), t2 instanceof ImageData && e2 && e2.push(t2.data.buffer), t2;
          if (Array.isArray(t2)) {
            const r3 = [];
            for (const n3 of t2) r3.push(fs(n3, e2));
            return r3;
          }
          if ("object" != typeof t2) throw new Error("can't serialize object of type " + typeof t2);
          const r2 = hs(t2);
          if (!r2) throw new Error(`can't serialize object of unregistered class ${t2.constructor.name}`);
          if (!ls[r2]) throw new Error(`${r2} is not registered.`);
          const { klass: n2 } = ls[r2], i2 = n2.serialize ? n2.serialize(t2, e2) : {};
          if (n2.serialize) {
            if (e2 && i2 === e2[e2.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
          } else {
            for (const n3 in t2) {
              if (!t2.hasOwnProperty(n3)) continue;
              if (ls[r2].omit.indexOf(n3) >= 0) continue;
              const s2 = t2[n3];
              i2[n3] = ls[r2].shallow.indexOf(n3) >= 0 ? s2 : fs(s2, e2);
            }
            t2 instanceof Error && (i2.message = t2.message);
          }
          if (i2.$name) throw new Error("$name property is reserved for worker serialization logic.");
          return "Object" !== r2 && (i2.$name = r2), i2;
        }
        function ds(t2) {
          if (ps(t2)) return t2;
          if (Array.isArray(t2)) return t2.map(ds);
          if ("object" != typeof t2) throw new Error("can't deserialize object of type " + typeof t2);
          const e2 = hs(t2) || "Object";
          if (!ls[e2]) throw new Error(`can't deserialize unregistered class ${e2}`);
          const { klass: r2 } = ls[e2];
          if (!r2) throw new Error(`can't deserialize unregistered class ${e2}`);
          if (r2.deserialize) return r2.deserialize(t2);
          const n2 = Object.create(r2.prototype);
          for (const r3 of Object.keys(t2)) {
            if ("$name" === r3) continue;
            const i2 = t2[r3];
            n2[r3] = ls[e2].shallow.indexOf(r3) >= 0 ? i2 : ds(i2);
          }
          return n2;
        }
        class ys {
          constructor() {
            this.first = true;
          }
          update(t2, e2) {
            const r2 = Math.floor(t2);
            return this.first ? (this.first = false, this.lastIntegerZoom = r2, this.lastIntegerZoomTime = 0, this.lastZoom = t2, this.lastFloorZoom = r2, true) : (this.lastFloorZoom > r2 ? (this.lastIntegerZoom = r2 + 1, this.lastIntegerZoomTime = e2) : this.lastFloorZoom < r2 && (this.lastIntegerZoom = r2, this.lastIntegerZoomTime = e2), t2 !== this.lastZoom && (this.lastZoom = t2, this.lastFloorZoom = r2, true));
          }
        }
        function ms(t2) {
          return /[\u02EA\u02EB\u2E80-\u2FDF\u2FF0-\u303F\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FD-\u30FF\u3105-\u312F\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(t2));
        }
        function gs(t2) {
          return /[\u02EA\u02EB\u1100-\u11FF\u1400-\u167F\u18B0-\u18F5\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u3007\u3012\u3013\u3020-\u302F\u3031-\u303F\u3041-\u3096\u309D-\u30FB\u30FD-\u30FF\u3105-\u312F\u3131-\u318E\u3190-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE48\uFE50-\uFE57\uFE5F-\uFE62\uFE67-\uFE6F\uFF00-\uFF07\uFF0A-\uFF0C\uFF0E-\uFF19\uFF1F-\uFF3A\uFF3C\uFF3E\uFF40-\uFF5A\uFFE0-\uFFE2\uFFE4-\uFFE7]|\uD802[\uDD80-\uDD9F]|\uD805[\uDD80-\uDDFF]|\uD806[\uDE00-\uDEBF]|\uD811[\uDC00-\uDE7F]|\uD81B[\uDFE0-\uDFE4\uDFF0-\uDFF6]|[\uD81C-\uD822\uD83D\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD30-\uDEFB]|\uD833[\uDEC0-\uDFCF]|\uD834[\uDC00-\uDDFF\uDEE0-\uDF7F]|\uD836[\uDC00-\uDEAF]|\uD83C[\uDC00-\uDE00\uDF00-\uDFFF]|\uD83E[\uDD00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(t2));
        }
        function xs(t2) {
          return /\s/u.test(String.fromCodePoint(t2));
        }
        function vs(t2) {
          for (const e2 of t2) if (gs(e2.codePointAt(0))) return true;
          return false;
        }
        function bs(t2) {
          for (const e2 of t2) if (!As(e2.codePointAt(0))) return false;
          return true;
        }
        function ws(t2) {
          const e2 = t2.map((t3) => {
            try {
              return new RegExp(`\\p{sc=${t3}}`, "u").source;
            } catch (t4) {
              return null;
            }
          }).filter((t3) => t3);
          return new RegExp(e2.join("|"), "u");
        }
        const _s = ws(["Arab", "Dupl", "Mong", "Ougr", "Syrc"]);
        function As(t2) {
          return !_s.test(String.fromCodePoint(t2));
        }
        function Ss(t2) {
          return !(gs(t2) || (e2 = t2, /[\xA7\xA9\xAE\xB1\xBC-\xBE\xD7\xF7\u2016\u2020\u2021\u2030\u2031\u203B\u203C\u2042\u2047-\u2049\u2051\u2100-\u218F\u221E\u2234\u2235\u2300-\u2307\u230C-\u231F\u2324-\u2328\u232B\u237D-\u239A\u23BE-\u23CD\u23CF\u23D1-\u23DB\u23E2-\u2422\u2424-\u24FF\u25A0-\u2619\u2620-\u2767\u2776-\u2793\u2B12-\u2B2F\u2B50-\u2B59\u2BB8-\u2BEB\u3000-\u303F\u30A0-\u30FF\uE000-\uF8FF\uFE30-\uFE6F\uFF00-\uFFEF\uFFFC\uFFFD]|[\uDB80-\uDBFF][\uDC00-\uDFFF]/gim.test(String.fromCodePoint(e2))));
          var e2;
        }
        const ks = ws(["Adlm", "Arab", "Armi", "Avst", "Chrs", "Cprt", "Egyp", "Elym", "Gara", "Hatr", "Hebr", "Hung", "Khar", "Lydi", "Mand", "Mani", "Mend", "Merc", "Mero", "Narb", "Nbat", "Nkoo", "Orkh", "Palm", "Phli", "Phlp", "Phnx", "Prti", "Rohg", "Samr", "Sarb", "Sogo", "Syrc", "Thaa", "Todr", "Yezi"]);
        function Es(t2) {
          return ks.test(String.fromCodePoint(t2));
        }
        function Ts(t2, e2) {
          return !(!e2 && Es(t2) || /[\u0900-\u0DFF\u0F00-\u109F\u1780-\u17FF]/gim.test(String.fromCodePoint(t2)));
        }
        function Is(t2) {
          for (const e2 of t2) if (Es(e2.codePointAt(0))) return true;
          return false;
        }
        const Ms = new class {
          constructor() {
            this.TIMEOUT = 5e3, this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null, this.loadScriptResolve = () => {
            };
          }
          setState(t2) {
            this.pluginStatus = t2.pluginStatus, this.pluginURL = t2.pluginURL;
          }
          getState() {
            return { pluginStatus: this.pluginStatus, pluginURL: this.pluginURL };
          }
          setMethods(t2) {
            if (Ms.isParsed()) throw new Error("RTL text plugin already registered.");
            this.applyArabicShaping = t2.applyArabicShaping, this.processBidirectionalText = t2.processBidirectionalText, this.processStyledBidirectionalText = t2.processStyledBidirectionalText, this.loadScriptResolve();
          }
          isParsed() {
            return null != this.applyArabicShaping && null != this.processBidirectionalText && null != this.processStyledBidirectionalText;
          }
          getRTLTextPluginStatus() {
            return this.pluginStatus;
          }
          syncState(t2, r2) {
            return e(this, void 0, void 0, function* () {
              if (this.isParsed()) return this.getState();
              if ("loading" !== t2.pluginStatus) return this.setState(t2), t2;
              const e2 = t2.pluginURL, n2 = new Promise((t3) => {
                this.loadScriptResolve = t3;
              });
              r2(e2);
              const i2 = new Promise((t3) => setTimeout(() => t3(), this.TIMEOUT));
              if (yield Promise.race([n2, i2]), this.isParsed()) {
                const t3 = { pluginStatus: "loaded", pluginURL: e2 };
                return this.setState(t3), t3;
              }
              throw this.setState({ pluginStatus: "error", pluginURL: "" }), new Error(`RTL Text Plugin failed to import scripts from ${e2}`);
            });
          }
        }();
        class Fs {
          constructor(t2, e2) {
            this.isSupportedScript = Ds, this.zoom = t2, e2 ? (this.now = e2.now || 0, this.fadeDuration = e2.fadeDuration || 0, this.zoomHistory = e2.zoomHistory || new ys(), this.transition = e2.transition || {}) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new ys(), this.transition = {});
          }
          crossFadingFactor() {
            return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
          }
          getCrossfadeParameters() {
            const t2 = this.zoom, e2 = t2 - Math.floor(t2), r2 = this.crossFadingFactor();
            return t2 > this.zoomHistory.lastIntegerZoom ? { fromScale: 2, toScale: 1, t: e2 + (1 - e2) * r2 } : { fromScale: 0.5, toScale: 1, t: 1 - (1 - r2) * e2 };
          }
        }
        function Ds(t2) {
          return function(t3, e2) {
            for (const r2 of t3) if (!Ts(r2.codePointAt(0), e2)) return false;
            return true;
          }(t2, "loaded" === Ms.getRTLTextPluginStatus());
        }
        const Ps = "-transition";
        class zs {
          constructor(t2, e2, r2) {
            this.property = t2, this.value = e2, this.expression = function(t3, e3, r3) {
              if (Yn(t3)) return new ai(t3, e3);
              if (ri(t3)) {
                const n2 = oi(t3, e3, r3);
                if ("error" === n2.result) throw new Error(n2.value.map((t4) => `${t4.key}: ${t4.message}`).join(", "));
                return n2.value;
              }
              {
                let r4 = t3;
                return "color" === e3.type && "string" == typeof t3 ? r4 = Te.parse(t3) : "padding" !== e3.type || "number" != typeof t3 && !Array.isArray(t3) ? "numberArray" !== e3.type || "number" != typeof t3 && !Array.isArray(t3) ? "colorArray" !== e3.type || "string" != typeof t3 && !Array.isArray(t3) ? "variableAnchorOffsetCollection" === e3.type && Array.isArray(t3) ? r4 = Le.parse(t3) : "projectionDefinition" === e3.type && "string" == typeof t3 && (r4 = Re.parse(t3)) : r4 = Be.parse(t3) : r4 = ze.parse(t3) : r4 = Pe.parse(t3), { globalStateRefs: /* @__PURE__ */ new Set(), _globalState: null, kind: "constant", evaluate: () => r4 };
              }
            }(void 0 === e2 ? t2.specification.default : e2, t2.specification, r2);
          }
          isDataDriven() {
            return "source" === this.expression.kind || "composite" === this.expression.kind;
          }
          getGlobalStateRefs() {
            return this.expression.globalStateRefs || /* @__PURE__ */ new Set();
          }
          possiblyEvaluate(t2, e2, r2) {
            return this.property.possiblyEvaluate(this, t2, e2, r2);
          }
        }
        class Bs {
          constructor(t2, e2) {
            this.property = t2, this.value = new zs(t2, void 0, e2);
          }
          transitioned(t2, e2) {
            return new Cs(this.property, this.value, e2, O({}, t2.transition, this.transition), t2.now);
          }
          untransitioned() {
            return new Cs(this.property, this.value, null, {}, 0);
          }
        }
        class Vs {
          constructor(t2, e2) {
            this._properties = t2, this._values = Object.create(t2.defaultTransitionablePropertyValues), this._globalState = e2;
          }
          getValue(t2) {
            return U(this._values[t2].value.value);
          }
          setValue(t2, e2) {
            Object.prototype.hasOwnProperty.call(this._values, t2) || (this._values[t2] = new Bs(this._values[t2].property, this._globalState)), this._values[t2].value = new zs(this._values[t2].property, null === e2 ? void 0 : U(e2), this._globalState);
          }
          getTransition(t2) {
            return U(this._values[t2].transition);
          }
          setTransition(t2, e2) {
            Object.prototype.hasOwnProperty.call(this._values, t2) || (this._values[t2] = new Bs(this._values[t2].property, this._globalState)), this._values[t2].transition = U(e2) || void 0;
          }
          serialize() {
            const t2 = {};
            for (const e2 of Object.keys(this._values)) {
              const r2 = this.getValue(e2);
              void 0 !== r2 && (t2[e2] = r2);
              const n2 = this.getTransition(e2);
              void 0 !== n2 && (t2[`${e2}${Ps}`] = n2);
            }
            return t2;
          }
          transitioned(t2, e2) {
            const r2 = new Ls(this._properties);
            for (const n2 of Object.keys(this._values)) r2._values[n2] = this._values[n2].transitioned(t2, e2._values[n2]);
            return r2;
          }
          untransitioned() {
            const t2 = new Ls(this._properties);
            for (const e2 of Object.keys(this._values)) t2._values[e2] = this._values[e2].untransitioned();
            return t2;
          }
        }
        class Cs {
          constructor(t2, e2, r2, n2, i2) {
            this.property = t2, this.value = e2, this.begin = i2 + n2.delay || 0, this.end = this.begin + n2.duration || 0, t2.specification.transition && (n2.delay || n2.duration) && (this.prior = r2);
          }
          possiblyEvaluate(t2, e2, r2) {
            const n2 = t2.now || 0, i2 = this.value.possiblyEvaluate(t2, e2, r2), s2 = this.prior;
            if (s2) {
              if (n2 > this.end) return this.prior = null, i2;
              if (this.value.isDataDriven()) return this.prior = null, i2;
              if (n2 < this.begin) return s2.possiblyEvaluate(t2, e2, r2);
              {
                const o2 = (n2 - this.begin) / (this.end - this.begin);
                return this.property.interpolate(s2.possiblyEvaluate(t2, e2, r2), i2, z(o2));
              }
            }
            return i2;
          }
        }
        class Ls {
          constructor(t2) {
            this._properties = t2, this._values = Object.create(t2.defaultTransitioningPropertyValues);
          }
          possiblyEvaluate(t2, e2, r2) {
            const n2 = new Ns(this._properties);
            for (const i2 of Object.keys(this._values)) n2._values[i2] = this._values[i2].possiblyEvaluate(t2, e2, r2);
            return n2;
          }
          hasTransition() {
            for (const t2 of Object.keys(this._values)) if (this._values[t2].prior) return true;
            return false;
          }
        }
        class Os {
          constructor(t2, e2) {
            this._properties = t2, this._values = Object.create(t2.defaultPropertyValues), this._globalState = e2;
          }
          hasValue(t2) {
            return void 0 !== this._values[t2].value;
          }
          getValue(t2) {
            return U(this._values[t2].value);
          }
          setValue(t2, e2) {
            this._values[t2] = new zs(this._values[t2].property, null === e2 ? void 0 : U(e2), this._globalState);
          }
          serialize() {
            const t2 = {};
            for (const e2 of Object.keys(this._values)) {
              const r2 = this.getValue(e2);
              void 0 !== r2 && (t2[e2] = r2);
            }
            return t2;
          }
          possiblyEvaluate(t2, e2, r2) {
            const n2 = new Ns(this._properties);
            for (const i2 of Object.keys(this._values)) n2._values[i2] = this._values[i2].possiblyEvaluate(t2, e2, r2);
            return n2;
          }
        }
        class Rs {
          constructor(t2, e2, r2) {
            this.property = t2, this.value = e2, this.parameters = r2;
          }
          isConstant() {
            return "constant" === this.value.kind;
          }
          constantOr(t2) {
            return "constant" === this.value.kind ? this.value.value : t2;
          }
          evaluate(t2, e2, r2, n2) {
            return this.property.evaluate(this.value, this.parameters, t2, e2, r2, n2);
          }
        }
        class Ns {
          constructor(t2) {
            this._properties = t2, this._values = Object.create(t2.defaultPossiblyEvaluatedValues);
          }
          get(t2) {
            return this._values[t2];
          }
        }
        class $s {
          constructor(t2) {
            this.specification = t2;
          }
          possiblyEvaluate(t2, e2) {
            if (t2.isDataDriven()) throw new Error("Value should not be data driven");
            return t2.expression.evaluate(e2);
          }
          interpolate(t2, e2, r2) {
            const n2 = yr[this.specification.type];
            return n2 ? n2(t2, e2, r2) : t2;
          }
        }
        class Us {
          constructor(t2, e2) {
            this.specification = t2, this.overrides = e2;
          }
          possiblyEvaluate(t2, e2, r2, n2) {
            return new Rs(this, "constant" === t2.expression.kind || "camera" === t2.expression.kind ? { kind: "constant", value: t2.expression.evaluate(e2, null, {}, r2, n2) } : t2.expression, e2);
          }
          interpolate(t2, e2, r2) {
            if ("constant" !== t2.value.kind || "constant" !== e2.value.kind) return t2;
            if (void 0 === t2.value.value || void 0 === e2.value.value) return new Rs(this, { kind: "constant", value: void 0 }, t2.parameters);
            const n2 = yr[this.specification.type];
            if (n2) {
              const i2 = n2(t2.value.value, e2.value.value, r2);
              return new Rs(this, { kind: "constant", value: i2 }, t2.parameters);
            }
            return t2;
          }
          evaluate(t2, e2, r2, n2, i2, s2) {
            return "constant" === t2.kind ? t2.value : t2.evaluate(e2, r2, n2, i2, s2);
          }
        }
        class qs extends Us {
          possiblyEvaluate(t2, e2, r2, n2) {
            if (void 0 === t2.value) return new Rs(this, { kind: "constant", value: void 0 }, e2);
            if ("constant" === t2.expression.kind) {
              const i2 = t2.expression.evaluate(e2, null, {}, r2, n2), s2 = "resolvedImage" === t2.property.specification.type && "string" != typeof i2 ? i2.name : i2, o2 = this._calculate(s2, s2, s2, e2);
              return new Rs(this, { kind: "constant", value: o2 }, e2);
            }
            if ("camera" === t2.expression.kind) {
              const r3 = this._calculate(t2.expression.evaluate({ zoom: e2.zoom - 1 }), t2.expression.evaluate({ zoom: e2.zoom }), t2.expression.evaluate({ zoom: e2.zoom + 1 }), e2);
              return new Rs(this, { kind: "constant", value: r3 }, e2);
            }
            return new Rs(this, t2.expression, e2);
          }
          evaluate(t2, e2, r2, n2, i2, s2) {
            if ("source" === t2.kind) {
              const o2 = t2.evaluate(e2, r2, n2, i2, s2);
              return this._calculate(o2, o2, o2, e2);
            }
            return "composite" === t2.kind ? this._calculate(t2.evaluate({ zoom: Math.floor(e2.zoom) - 1 }, r2, n2), t2.evaluate({ zoom: Math.floor(e2.zoom) }, r2, n2), t2.evaluate({ zoom: Math.floor(e2.zoom) + 1 }, r2, n2), e2) : t2.value;
          }
          _calculate(t2, e2, r2, n2) {
            return n2.zoom > n2.zoomHistory.lastIntegerZoom ? { from: t2, to: e2 } : { from: r2, to: e2 };
          }
          interpolate(t2) {
            return t2;
          }
        }
        class js {
          constructor(t2) {
            this.specification = t2;
          }
          possiblyEvaluate(t2, e2, r2, n2) {
            if (void 0 !== t2.value) {
              if ("constant" === t2.expression.kind) {
                const i2 = t2.expression.evaluate(e2, null, {}, r2, n2);
                return this._calculate(i2, i2, i2, e2);
              }
              return this._calculate(t2.expression.evaluate(new Fs(Math.floor(e2.zoom - 1), e2)), t2.expression.evaluate(new Fs(Math.floor(e2.zoom), e2)), t2.expression.evaluate(new Fs(Math.floor(e2.zoom + 1), e2)), e2);
            }
          }
          _calculate(t2, e2, r2, n2) {
            return n2.zoom > n2.zoomHistory.lastIntegerZoom ? { from: t2, to: e2 } : { from: r2, to: e2 };
          }
          interpolate(t2) {
            return t2;
          }
        }
        class Gs {
          constructor(t2) {
            this.specification = t2;
          }
          possiblyEvaluate(t2, e2, r2, n2) {
            return !!t2.expression.evaluate(e2, null, {}, r2, n2);
          }
          interpolate() {
            return false;
          }
        }
        class Xs {
          constructor(t2) {
            this.properties = t2, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
            for (const e2 in t2) {
              const r2 = t2[e2];
              r2.specification.overridable && this.overridableProperties.push(e2);
              const n2 = this.defaultPropertyValues[e2] = new zs(r2, void 0, void 0), i2 = this.defaultTransitionablePropertyValues[e2] = new Bs(r2, void 0);
              this.defaultTransitioningPropertyValues[e2] = i2.untransitioned(), this.defaultPossiblyEvaluatedValues[e2] = n2.possiblyEvaluate({});
            }
          }
        }
        us("DataDrivenProperty", Us), us("DataConstantProperty", $s), us("CrossFadedDataDrivenProperty", qs), us("CrossFadedProperty", js), us("ColorRampProperty", Gs);
        class Ys extends xt {
          constructor(t2, e2, r2) {
            if (super(), this.id = t2.id, this.type = t2.type, this._globalState = r2, this._featureFilter = { filter: () => true, needGeometry: false, getGlobalStateRefs: () => /* @__PURE__ */ new Set() }, "custom" !== t2.type && (this.metadata = t2.metadata, this.minzoom = t2.minzoom, this.maxzoom = t2.maxzoom, "background" !== t2.type && (this.source = t2.source, this.sourceLayer = t2["source-layer"], this.filter = t2.filter, this._featureFilter = fi(t2.filter, r2)), e2.layout && (this._unevaluatedLayout = new Os(e2.layout, r2)), e2.paint)) {
              this._transitionablePaint = new Vs(e2.paint, r2);
              for (const e3 in t2.paint) this.setPaintProperty(e3, t2.paint[e3], { validate: false });
              for (const e3 in t2.layout) this.setLayoutProperty(e3, t2.layout[e3], { validate: false });
              this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Ns(e2.paint);
            }
          }
          setFilter(t2) {
            this.filter = t2, this._featureFilter = fi(t2, this._globalState);
          }
          getCrossfadeParameters() {
            return this._crossfadeParameters;
          }
          getLayoutProperty(t2) {
            return "visibility" === t2 ? this.visibility : this._unevaluatedLayout.getValue(t2);
          }
          getLayoutAffectingGlobalStateRefs() {
            const t2 = /* @__PURE__ */ new Set();
            if (this._unevaluatedLayout) for (const e2 in this._unevaluatedLayout._values) {
              const r2 = this._unevaluatedLayout._values[e2];
              for (const e3 of r2.getGlobalStateRefs()) t2.add(e3);
            }
            for (const e2 of this._featureFilter.getGlobalStateRefs()) t2.add(e2);
            return t2;
          }
          getPaintAffectingGlobalStateRefs() {
            var t2;
            const e2 = new globalThis.Map();
            if (this._transitionablePaint) for (const r2 in this._transitionablePaint._values) {
              const n2 = this._transitionablePaint._values[r2].value;
              for (const i2 of n2.getGlobalStateRefs()) {
                const s2 = null !== (t2 = e2.get(i2)) && void 0 !== t2 ? t2 : [];
                s2.push({ name: r2, value: n2.value }), e2.set(i2, s2);
              }
            }
            return e2;
          }
          setLayoutProperty(t2, e2, r2 = {}) {
            null != e2 && this._validate(ss, `layers.${this.id}.layout.${t2}`, t2, e2, r2) || ("visibility" !== t2 ? this._unevaluatedLayout.setValue(t2, e2) : this.visibility = e2);
          }
          getPaintProperty(t2) {
            return t2.endsWith(Ps) ? this._transitionablePaint.getTransition(t2.slice(0, -11)) : this._transitionablePaint.getValue(t2);
          }
          setPaintProperty(t2, e2, r2 = {}) {
            if (null != e2 && this._validate(is, `layers.${this.id}.paint.${t2}`, t2, e2, r2)) return false;
            if (t2.endsWith(Ps)) return this._transitionablePaint.setTransition(t2.slice(0, -11), e2 || void 0), false;
            {
              const r3 = this._transitionablePaint._values[t2], n2 = "cross-faded-data-driven" === r3.property.specification["property-type"], i2 = r3.value.isDataDriven(), s2 = r3.value;
              this._transitionablePaint.setValue(t2, e2), this._handleSpecialPaintPropertyUpdate(t2);
              const o2 = this._transitionablePaint._values[t2].value;
              return o2.isDataDriven() || i2 || n2 || this._handleOverridablePaintPropertyUpdate(t2, s2, o2);
            }
          }
          _handleSpecialPaintPropertyUpdate(t2) {
          }
          _handleOverridablePaintPropertyUpdate(t2, e2, r2) {
            return false;
          }
          isHidden(t2, e2 = false) {
            return !!(this.minzoom && t2 < (e2 ? Math.floor(this.minzoom) : this.minzoom)) || !!(this.maxzoom && t2 >= this.maxzoom) || "none" === this.visibility;
          }
          updateTransitions(t2) {
            this._transitioningPaint = this._transitionablePaint.transitioned(t2, this._transitioningPaint);
          }
          hasTransition() {
            return this._transitioningPaint.hasTransition();
          }
          recalculate(t2, e2) {
            t2.getCrossfadeParameters && (this._crossfadeParameters = t2.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t2, void 0, e2)), this.paint = this._transitioningPaint.possiblyEvaluate(t2, void 0, e2);
          }
          serialize() {
            const t2 = { id: this.id, type: this.type, source: this.source, "source-layer": this.sourceLayer, metadata: this.metadata, minzoom: this.minzoom, maxzoom: this.maxzoom, filter: this.filter, layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(), paint: this._transitionablePaint && this._transitionablePaint.serialize() };
            return this.visibility && (t2.layout = t2.layout || {}, t2.layout.visibility = this.visibility), $(t2, (t3, e2) => !(void 0 === t3 || "layout" === e2 && !Object.keys(t3).length || "paint" === e2 && !Object.keys(t3).length));
          }
          _validate(t2, e2, r2, n2, i2 = {}) {
            return (!i2 || false !== i2.validate) && os(this, t2.call(es, { key: e2, layerType: this.type, objectKey: r2, value: n2, styleSpec: vt, style: { glyphs: true, sprite: true } }));
          }
          is3D() {
            return false;
          }
          isTileClipped() {
            return false;
          }
          hasOffscreenPass() {
            return false;
          }
          resize() {
          }
          isStateDependent() {
            for (const t2 in this.paint._values) {
              const e2 = this.paint.get(t2);
              if (e2 instanceof Rs && qn(e2.property.specification) && ("source" === e2.value.kind || "composite" === e2.value.kind) && e2.value.isStateDependent) return true;
            }
            return false;
          }
        }
        let Zs;
        var Hs = { get paint() {
          return Zs = Zs || new Xs({ "raster-opacity": new $s(vt.paint_raster["raster-opacity"]), "raster-hue-rotate": new $s(vt.paint_raster["raster-hue-rotate"]), "raster-brightness-min": new $s(vt.paint_raster["raster-brightness-min"]), "raster-brightness-max": new $s(vt.paint_raster["raster-brightness-max"]), "raster-saturation": new $s(vt.paint_raster["raster-saturation"]), "raster-contrast": new $s(vt.paint_raster["raster-contrast"]), "raster-resampling": new $s(vt.paint_raster["raster-resampling"]), "raster-fade-duration": new $s(vt.paint_raster["raster-fade-duration"]) });
        } };
        class Ks extends Ys {
          constructor(t2, e2) {
            super(t2, Hs, e2);
          }
        }
        const Ws = { Int8: Int8Array, Uint8: Uint8Array, Int16: Int16Array, Uint16: Uint16Array, Int32: Int32Array, Uint32: Uint32Array, Float32: Float32Array };
        class Js {
          constructor(t2, e2) {
            this._structArray = t2, this._pos1 = e2 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
          }
        }
        class Qs {
          constructor() {
            this.isTransferred = false, this.capacity = -1, this.resize(0);
          }
          static serialize(t2, e2) {
            return t2._trim(), e2 && (t2.isTransferred = true, e2.push(t2.arrayBuffer)), { length: t2.length, arrayBuffer: t2.arrayBuffer };
          }
          static deserialize(t2) {
            const e2 = Object.create(this.prototype);
            return e2.arrayBuffer = t2.arrayBuffer, e2.length = t2.length, e2.capacity = t2.arrayBuffer.byteLength / e2.bytesPerElement, e2._refreshViews(), e2;
          }
          _trim() {
            this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
          }
          clear() {
            this.length = 0;
          }
          resize(t2) {
            this.reserve(t2), this.length = t2;
          }
          reserve(t2) {
            if (t2 > this.capacity) {
              this.capacity = Math.max(t2, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
              const e2 = this.uint8;
              this._refreshViews(), e2 && this.uint8.set(e2);
            }
          }
          _refreshViews() {
            throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
          }
        }
        function to(t2, e2 = 1) {
          let r2 = 0, n2 = 0;
          return { members: t2.map((t3) => {
            const i2 = Ws[t3.type].BYTES_PER_ELEMENT, s2 = r2 = eo(r2, Math.max(e2, i2)), o2 = t3.components || 1;
            return n2 = Math.max(n2, i2), r2 += i2 * o2, { name: t3.name, type: t3.type, components: o2, offset: s2 };
          }), size: eo(r2, Math.max(n2, e2)), alignment: e2 };
        }
        function eo(t2, e2) {
          return Math.ceil(t2 / e2) * e2;
        }
        class ro extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2) {
            const r2 = this.length;
            return this.resize(r2 + 1), this.emplace(r2, t2, e2);
          }
          emplace(t2, e2, r2) {
            const n2 = 2 * t2;
            return this.int16[n2 + 0] = e2, this.int16[n2 + 1] = r2, t2;
          }
        }
        ro.prototype.bytesPerElement = 4, us("StructArrayLayout2i4", ro);
        class no extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2) {
            const n2 = this.length;
            return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
          }
          emplace(t2, e2, r2, n2) {
            const i2 = 3 * t2;
            return this.int16[i2 + 0] = e2, this.int16[i2 + 1] = r2, this.int16[i2 + 2] = n2, t2;
          }
        }
        no.prototype.bytesPerElement = 6, us("StructArrayLayout3i6", no);
        class io extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2) {
            const i2 = this.length;
            return this.resize(i2 + 1), this.emplace(i2, t2, e2, r2, n2);
          }
          emplace(t2, e2, r2, n2, i2) {
            const s2 = 4 * t2;
            return this.int16[s2 + 0] = e2, this.int16[s2 + 1] = r2, this.int16[s2 + 2] = n2, this.int16[s2 + 3] = i2, t2;
          }
        }
        io.prototype.bytesPerElement = 8, us("StructArrayLayout4i8", io);
        class so extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2) {
            const o2 = this.length;
            return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i2, s2);
          }
          emplace(t2, e2, r2, n2, i2, s2, o2) {
            const a2 = 6 * t2;
            return this.int16[a2 + 0] = e2, this.int16[a2 + 1] = r2, this.int16[a2 + 2] = n2, this.int16[a2 + 3] = i2, this.int16[a2 + 4] = s2, this.int16[a2 + 5] = o2, t2;
          }
        }
        so.prototype.bytesPerElement = 12, us("StructArrayLayout2i4i12", so);
        class oo extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2) {
            const o2 = this.length;
            return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i2, s2);
          }
          emplace(t2, e2, r2, n2, i2, s2, o2) {
            const a2 = 4 * t2, l2 = 8 * t2;
            return this.int16[a2 + 0] = e2, this.int16[a2 + 1] = r2, this.uint8[l2 + 4] = n2, this.uint8[l2 + 5] = i2, this.uint8[l2 + 6] = s2, this.uint8[l2 + 7] = o2, t2;
          }
        }
        oo.prototype.bytesPerElement = 8, us("StructArrayLayout2i4ub8", oo);
        class ao extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2) {
            const r2 = this.length;
            return this.resize(r2 + 1), this.emplace(r2, t2, e2);
          }
          emplace(t2, e2, r2) {
            const n2 = 2 * t2;
            return this.float32[n2 + 0] = e2, this.float32[n2 + 1] = r2, t2;
          }
        }
        ao.prototype.bytesPerElement = 8, us("StructArrayLayout2f8", ao);
        class lo extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2) {
            const c2 = this.length;
            return this.resize(c2 + 1), this.emplace(c2, t2, e2, r2, n2, i2, s2, o2, a2, l2, u2);
          }
          emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2) {
            const h2 = 10 * t2;
            return this.uint16[h2 + 0] = e2, this.uint16[h2 + 1] = r2, this.uint16[h2 + 2] = n2, this.uint16[h2 + 3] = i2, this.uint16[h2 + 4] = s2, this.uint16[h2 + 5] = o2, this.uint16[h2 + 6] = a2, this.uint16[h2 + 7] = l2, this.uint16[h2 + 8] = u2, this.uint16[h2 + 9] = c2, t2;
          }
        }
        lo.prototype.bytesPerElement = 20, us("StructArrayLayout10ui20", lo);
        class uo extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2) {
            const l2 = this.length;
            return this.resize(l2 + 1), this.emplace(l2, t2, e2, r2, n2, i2, s2, o2, a2);
          }
          emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            const u2 = 8 * t2;
            return this.uint16[u2 + 0] = e2, this.uint16[u2 + 1] = r2, this.uint16[u2 + 2] = n2, this.uint16[u2 + 3] = i2, this.uint16[u2 + 4] = s2, this.uint16[u2 + 5] = o2, this.uint16[u2 + 6] = a2, this.uint16[u2 + 7] = l2, t2;
          }
        }
        uo.prototype.bytesPerElement = 16, us("StructArrayLayout8ui16", uo);
        class co extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2) {
            const p2 = this.length;
            return this.resize(p2 + 1), this.emplace(p2, t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2);
          }
          emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2) {
            const f2 = 12 * t2;
            return this.int16[f2 + 0] = e2, this.int16[f2 + 1] = r2, this.int16[f2 + 2] = n2, this.int16[f2 + 3] = i2, this.uint16[f2 + 4] = s2, this.uint16[f2 + 5] = o2, this.uint16[f2 + 6] = a2, this.uint16[f2 + 7] = l2, this.int16[f2 + 8] = u2, this.int16[f2 + 9] = c2, this.int16[f2 + 10] = h2, this.int16[f2 + 11] = p2, t2;
          }
        }
        co.prototype.bytesPerElement = 24, us("StructArrayLayout4i4ui4i24", co);
        class ho extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2) {
            const n2 = this.length;
            return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
          }
          emplace(t2, e2, r2, n2) {
            const i2 = 3 * t2;
            return this.float32[i2 + 0] = e2, this.float32[i2 + 1] = r2, this.float32[i2 + 2] = n2, t2;
          }
        }
        ho.prototype.bytesPerElement = 12, us("StructArrayLayout3f12", ho);
        class po extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
          }
          emplaceBack(t2) {
            const e2 = this.length;
            return this.resize(e2 + 1), this.emplace(e2, t2);
          }
          emplace(t2, e2) {
            return this.uint32[1 * t2 + 0] = e2, t2;
          }
        }
        po.prototype.bytesPerElement = 4, us("StructArrayLayout1ul4", po);
        class fo extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            const u2 = this.length;
            return this.resize(u2 + 1), this.emplace(u2, t2, e2, r2, n2, i2, s2, o2, a2, l2);
          }
          emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2) {
            const c2 = 10 * t2, h2 = 5 * t2;
            return this.int16[c2 + 0] = e2, this.int16[c2 + 1] = r2, this.int16[c2 + 2] = n2, this.int16[c2 + 3] = i2, this.int16[c2 + 4] = s2, this.int16[c2 + 5] = o2, this.uint32[h2 + 3] = a2, this.uint16[c2 + 8] = l2, this.uint16[c2 + 9] = u2, t2;
          }
        }
        fo.prototype.bytesPerElement = 20, us("StructArrayLayout6i1ul2ui20", fo);
        class yo extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2) {
            const o2 = this.length;
            return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i2, s2);
          }
          emplace(t2, e2, r2, n2, i2, s2, o2) {
            const a2 = 6 * t2;
            return this.int16[a2 + 0] = e2, this.int16[a2 + 1] = r2, this.int16[a2 + 2] = n2, this.int16[a2 + 3] = i2, this.int16[a2 + 4] = s2, this.int16[a2 + 5] = o2, t2;
          }
        }
        yo.prototype.bytesPerElement = 12, us("StructArrayLayout2i2i2i12", yo);
        class mo extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2) {
            const s2 = this.length;
            return this.resize(s2 + 1), this.emplace(s2, t2, e2, r2, n2, i2);
          }
          emplace(t2, e2, r2, n2, i2, s2) {
            const o2 = 4 * t2, a2 = 8 * t2;
            return this.float32[o2 + 0] = e2, this.float32[o2 + 1] = r2, this.float32[o2 + 2] = n2, this.int16[a2 + 6] = i2, this.int16[a2 + 7] = s2, t2;
          }
        }
        mo.prototype.bytesPerElement = 16, us("StructArrayLayout2f1f2i16", mo);
        class go extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2) {
            const o2 = this.length;
            return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i2, s2);
          }
          emplace(t2, e2, r2, n2, i2, s2, o2) {
            const a2 = 16 * t2, l2 = 4 * t2, u2 = 8 * t2;
            return this.uint8[a2 + 0] = e2, this.uint8[a2 + 1] = r2, this.float32[l2 + 1] = n2, this.float32[l2 + 2] = i2, this.int16[u2 + 6] = s2, this.int16[u2 + 7] = o2, t2;
          }
        }
        go.prototype.bytesPerElement = 16, us("StructArrayLayout2ub2f2i16", go);
        class xo extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2) {
            const n2 = this.length;
            return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
          }
          emplace(t2, e2, r2, n2) {
            const i2 = 3 * t2;
            return this.uint16[i2 + 0] = e2, this.uint16[i2 + 1] = r2, this.uint16[i2 + 2] = n2, t2;
          }
        }
        xo.prototype.bytesPerElement = 6, us("StructArrayLayout3ui6", xo);
        class vo extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2, f2, d2, y2, m2) {
            const g2 = this.length;
            return this.resize(g2 + 1), this.emplace(g2, t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2, f2, d2, y2, m2);
          }
          emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2, f2, d2, y2, m2, g2) {
            const x2 = 24 * t2, v2 = 12 * t2, b2 = 48 * t2;
            return this.int16[x2 + 0] = e2, this.int16[x2 + 1] = r2, this.uint16[x2 + 2] = n2, this.uint16[x2 + 3] = i2, this.uint32[v2 + 2] = s2, this.uint32[v2 + 3] = o2, this.uint32[v2 + 4] = a2, this.uint16[x2 + 10] = l2, this.uint16[x2 + 11] = u2, this.uint16[x2 + 12] = c2, this.float32[v2 + 7] = h2, this.float32[v2 + 8] = p2, this.uint8[b2 + 36] = f2, this.uint8[b2 + 37] = d2, this.uint8[b2 + 38] = y2, this.uint32[v2 + 10] = m2, this.int16[x2 + 22] = g2, t2;
          }
        }
        vo.prototype.bytesPerElement = 48, us("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", vo);
        class bo extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2, f2, d2, y2, m2, g2, x2, v2, b2, w2, _2, A2, S2, k2, E2, T2) {
            const I2 = this.length;
            return this.resize(I2 + 1), this.emplace(I2, t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2, f2, d2, y2, m2, g2, x2, v2, b2, w2, _2, A2, S2, k2, E2, T2);
          }
          emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2, f2, d2, y2, m2, g2, x2, v2, b2, w2, _2, A2, S2, k2, E2, T2, I2) {
            const M2 = 32 * t2, F2 = 16 * t2;
            return this.int16[M2 + 0] = e2, this.int16[M2 + 1] = r2, this.int16[M2 + 2] = n2, this.int16[M2 + 3] = i2, this.int16[M2 + 4] = s2, this.int16[M2 + 5] = o2, this.int16[M2 + 6] = a2, this.int16[M2 + 7] = l2, this.uint16[M2 + 8] = u2, this.uint16[M2 + 9] = c2, this.uint16[M2 + 10] = h2, this.uint16[M2 + 11] = p2, this.uint16[M2 + 12] = f2, this.uint16[M2 + 13] = d2, this.uint16[M2 + 14] = y2, this.uint16[M2 + 15] = m2, this.uint16[M2 + 16] = g2, this.uint16[M2 + 17] = x2, this.uint16[M2 + 18] = v2, this.uint16[M2 + 19] = b2, this.uint16[M2 + 20] = w2, this.uint16[M2 + 21] = _2, this.uint16[M2 + 22] = A2, this.uint32[F2 + 12] = S2, this.float32[F2 + 13] = k2, this.float32[F2 + 14] = E2, this.uint16[M2 + 30] = T2, this.uint16[M2 + 31] = I2, t2;
          }
        }
        bo.prototype.bytesPerElement = 64, us("StructArrayLayout8i15ui1ul2f2ui64", bo);
        class wo extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2) {
            const e2 = this.length;
            return this.resize(e2 + 1), this.emplace(e2, t2);
          }
          emplace(t2, e2) {
            return this.float32[1 * t2 + 0] = e2, t2;
          }
        }
        wo.prototype.bytesPerElement = 4, us("StructArrayLayout1f4", wo);
        class _o extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2) {
            const n2 = this.length;
            return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
          }
          emplace(t2, e2, r2, n2) {
            const i2 = 3 * t2;
            return this.uint16[6 * t2 + 0] = e2, this.float32[i2 + 1] = r2, this.float32[i2 + 2] = n2, t2;
          }
        }
        _o.prototype.bytesPerElement = 12, us("StructArrayLayout1ui2f12", _o);
        class Ao extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2) {
            const n2 = this.length;
            return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
          }
          emplace(t2, e2, r2, n2) {
            const i2 = 4 * t2;
            return this.uint32[2 * t2 + 0] = e2, this.uint16[i2 + 2] = r2, this.uint16[i2 + 3] = n2, t2;
          }
        }
        Ao.prototype.bytesPerElement = 8, us("StructArrayLayout1ul2ui8", Ao);
        class So extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2) {
            const r2 = this.length;
            return this.resize(r2 + 1), this.emplace(r2, t2, e2);
          }
          emplace(t2, e2, r2) {
            const n2 = 2 * t2;
            return this.uint16[n2 + 0] = e2, this.uint16[n2 + 1] = r2, t2;
          }
        }
        So.prototype.bytesPerElement = 4, us("StructArrayLayout2ui4", So);
        class ko extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
          }
          emplaceBack(t2) {
            const e2 = this.length;
            return this.resize(e2 + 1), this.emplace(e2, t2);
          }
          emplace(t2, e2) {
            return this.uint16[1 * t2 + 0] = e2, t2;
          }
        }
        ko.prototype.bytesPerElement = 2, us("StructArrayLayout1ui2", ko);
        class Eo extends Qs {
          _refreshViews() {
            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
          }
          emplaceBack(t2, e2, r2, n2) {
            const i2 = this.length;
            return this.resize(i2 + 1), this.emplace(i2, t2, e2, r2, n2);
          }
          emplace(t2, e2, r2, n2, i2) {
            const s2 = 4 * t2;
            return this.float32[s2 + 0] = e2, this.float32[s2 + 1] = r2, this.float32[s2 + 2] = n2, this.float32[s2 + 3] = i2, t2;
          }
        }
        Eo.prototype.bytesPerElement = 16, us("StructArrayLayout4f16", Eo);
        class To extends Js {
          get anchorPointX() {
            return this._structArray.int16[this._pos2 + 0];
          }
          get anchorPointY() {
            return this._structArray.int16[this._pos2 + 1];
          }
          get x1() {
            return this._structArray.int16[this._pos2 + 2];
          }
          get y1() {
            return this._structArray.int16[this._pos2 + 3];
          }
          get x2() {
            return this._structArray.int16[this._pos2 + 4];
          }
          get y2() {
            return this._structArray.int16[this._pos2 + 5];
          }
          get featureIndex() {
            return this._structArray.uint32[this._pos4 + 3];
          }
          get sourceLayerIndex() {
            return this._structArray.uint16[this._pos2 + 8];
          }
          get bucketIndex() {
            return this._structArray.uint16[this._pos2 + 9];
          }
          get anchorPoint() {
            return new r(this.anchorPointX, this.anchorPointY);
          }
        }
        To.prototype.size = 20;
        class Io extends fo {
          get(t2) {
            return new To(this, t2);
          }
        }
        us("CollisionBoxArray", Io);
        class Mo extends Js {
          get anchorX() {
            return this._structArray.int16[this._pos2 + 0];
          }
          get anchorY() {
            return this._structArray.int16[this._pos2 + 1];
          }
          get glyphStartIndex() {
            return this._structArray.uint16[this._pos2 + 2];
          }
          get numGlyphs() {
            return this._structArray.uint16[this._pos2 + 3];
          }
          get vertexStartIndex() {
            return this._structArray.uint32[this._pos4 + 2];
          }
          get lineStartIndex() {
            return this._structArray.uint32[this._pos4 + 3];
          }
          get lineLength() {
            return this._structArray.uint32[this._pos4 + 4];
          }
          get segment() {
            return this._structArray.uint16[this._pos2 + 10];
          }
          get lowerSize() {
            return this._structArray.uint16[this._pos2 + 11];
          }
          get upperSize() {
            return this._structArray.uint16[this._pos2 + 12];
          }
          get lineOffsetX() {
            return this._structArray.float32[this._pos4 + 7];
          }
          get lineOffsetY() {
            return this._structArray.float32[this._pos4 + 8];
          }
          get writingMode() {
            return this._structArray.uint8[this._pos1 + 36];
          }
          get placedOrientation() {
            return this._structArray.uint8[this._pos1 + 37];
          }
          set placedOrientation(t2) {
            this._structArray.uint8[this._pos1 + 37] = t2;
          }
          get hidden() {
            return this._structArray.uint8[this._pos1 + 38];
          }
          set hidden(t2) {
            this._structArray.uint8[this._pos1 + 38] = t2;
          }
          get crossTileID() {
            return this._structArray.uint32[this._pos4 + 10];
          }
          set crossTileID(t2) {
            this._structArray.uint32[this._pos4 + 10] = t2;
          }
          get associatedIconIndex() {
            return this._structArray.int16[this._pos2 + 22];
          }
        }
        Mo.prototype.size = 48;
        class Fo extends vo {
          get(t2) {
            return new Mo(this, t2);
          }
        }
        us("PlacedSymbolArray", Fo);
        class Do extends Js {
          get anchorX() {
            return this._structArray.int16[this._pos2 + 0];
          }
          get anchorY() {
            return this._structArray.int16[this._pos2 + 1];
          }
          get rightJustifiedTextSymbolIndex() {
            return this._structArray.int16[this._pos2 + 2];
          }
          get centerJustifiedTextSymbolIndex() {
            return this._structArray.int16[this._pos2 + 3];
          }
          get leftJustifiedTextSymbolIndex() {
            return this._structArray.int16[this._pos2 + 4];
          }
          get verticalPlacedTextSymbolIndex() {
            return this._structArray.int16[this._pos2 + 5];
          }
          get placedIconSymbolIndex() {
            return this._structArray.int16[this._pos2 + 6];
          }
          get verticalPlacedIconSymbolIndex() {
            return this._structArray.int16[this._pos2 + 7];
          }
          get key() {
            return this._structArray.uint16[this._pos2 + 8];
          }
          get textBoxStartIndex() {
            return this._structArray.uint16[this._pos2 + 9];
          }
          get textBoxEndIndex() {
            return this._structArray.uint16[this._pos2 + 10];
          }
          get verticalTextBoxStartIndex() {
            return this._structArray.uint16[this._pos2 + 11];
          }
          get verticalTextBoxEndIndex() {
            return this._structArray.uint16[this._pos2 + 12];
          }
          get iconBoxStartIndex() {
            return this._structArray.uint16[this._pos2 + 13];
          }
          get iconBoxEndIndex() {
            return this._structArray.uint16[this._pos2 + 14];
          }
          get verticalIconBoxStartIndex() {
            return this._structArray.uint16[this._pos2 + 15];
          }
          get verticalIconBoxEndIndex() {
            return this._structArray.uint16[this._pos2 + 16];
          }
          get featureIndex() {
            return this._structArray.uint16[this._pos2 + 17];
          }
          get numHorizontalGlyphVertices() {
            return this._structArray.uint16[this._pos2 + 18];
          }
          get numVerticalGlyphVertices() {
            return this._structArray.uint16[this._pos2 + 19];
          }
          get numIconVertices() {
            return this._structArray.uint16[this._pos2 + 20];
          }
          get numVerticalIconVertices() {
            return this._structArray.uint16[this._pos2 + 21];
          }
          get useRuntimeCollisionCircles() {
            return this._structArray.uint16[this._pos2 + 22];
          }
          get crossTileID() {
            return this._structArray.uint32[this._pos4 + 12];
          }
          set crossTileID(t2) {
            this._structArray.uint32[this._pos4 + 12] = t2;
          }
          get textBoxScale() {
            return this._structArray.float32[this._pos4 + 13];
          }
          get collisionCircleDiameter() {
            return this._structArray.float32[this._pos4 + 14];
          }
          get textAnchorOffsetStartIndex() {
            return this._structArray.uint16[this._pos2 + 30];
          }
          get textAnchorOffsetEndIndex() {
            return this._structArray.uint16[this._pos2 + 31];
          }
        }
        Do.prototype.size = 64;
        class Po extends bo {
          get(t2) {
            return new Do(this, t2);
          }
        }
        us("SymbolInstanceArray", Po);
        class zo extends wo {
          getoffsetX(t2) {
            return this.float32[1 * t2 + 0];
          }
        }
        us("GlyphOffsetArray", zo);
        class Bo extends no {
          getx(t2) {
            return this.int16[3 * t2 + 0];
          }
          gety(t2) {
            return this.int16[3 * t2 + 1];
          }
          gettileUnitDistanceFromAnchor(t2) {
            return this.int16[3 * t2 + 2];
          }
        }
        us("SymbolLineVertexArray", Bo);
        class Vo extends Js {
          get textAnchor() {
            return this._structArray.uint16[this._pos2 + 0];
          }
          get textOffset0() {
            return this._structArray.float32[this._pos4 + 1];
          }
          get textOffset1() {
            return this._structArray.float32[this._pos4 + 2];
          }
        }
        Vo.prototype.size = 12;
        class Co extends _o {
          get(t2) {
            return new Vo(this, t2);
          }
        }
        us("TextAnchorOffsetArray", Co);
        class Lo extends Js {
          get featureIndex() {
            return this._structArray.uint32[this._pos4 + 0];
          }
          get sourceLayerIndex() {
            return this._structArray.uint16[this._pos2 + 2];
          }
          get bucketIndex() {
            return this._structArray.uint16[this._pos2 + 3];
          }
        }
        Lo.prototype.size = 8;
        class Oo extends Ao {
          get(t2) {
            return new Lo(this, t2);
          }
        }
        us("FeatureIndexArray", Oo);
        class Ro extends ro {
        }
        class No extends ro {
        }
        class $o extends ro {
        }
        class Uo extends so {
        }
        class qo extends oo {
        }
        class jo extends ao {
        }
        class Go extends lo {
        }
        class Xo extends uo {
        }
        class Yo extends co {
        }
        class Zo extends ho {
        }
        class Ho extends po {
        }
        class Ko extends yo {
        }
        class Wo extends go {
        }
        class Jo extends xo {
        }
        class Qo extends So {
        }
        const ta = to([{ name: "a_pos", components: 2, type: "Int16" }], 4), { members: ea } = ta;
        class ra {
          constructor(t2 = []) {
            this._forceNewSegmentOnNextPrepare = false, this.segments = t2;
          }
          prepareSegment(t2, e2, r2, n2) {
            const i2 = this.segments[this.segments.length - 1];
            return t2 > ra.MAX_VERTEX_ARRAY_LENGTH && j(`Max vertices per segment is ${ra.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t2}. Consider using the \`fillLargeMeshArrays\` function if you require meshes with more than ${ra.MAX_VERTEX_ARRAY_LENGTH} vertices.`), this._forceNewSegmentOnNextPrepare || !i2 || i2.vertexLength + t2 > ra.MAX_VERTEX_ARRAY_LENGTH || i2.sortKey !== n2 ? this.createNewSegment(e2, r2, n2) : i2;
          }
          createNewSegment(t2, e2, r2) {
            const n2 = { vertexOffset: t2.length, primitiveOffset: e2.length, vertexLength: 0, primitiveLength: 0, vaos: {} };
            return void 0 !== r2 && (n2.sortKey = r2), this._forceNewSegmentOnNextPrepare = false, this.segments.push(n2), n2;
          }
          getOrCreateLatestSegment(t2, e2, r2) {
            return this.prepareSegment(0, t2, e2, r2);
          }
          forceNewSegmentOnNextPrepare() {
            this._forceNewSegmentOnNextPrepare = true;
          }
          get() {
            return this.segments;
          }
          destroy() {
            for (const t2 of this.segments) for (const e2 in t2.vaos) t2.vaos[e2].destroy();
          }
          static simpleSegment(t2, e2, r2, n2) {
            return new ra([{ vertexOffset: t2, primitiveOffset: e2, vertexLength: r2, primitiveLength: n2, vaos: {}, sortKey: 0 }]);
          }
        }
        function na(t2, e2) {
          return 256 * (t2 = C(Math.floor(t2), 0, 255)) + C(Math.floor(e2), 0, 255);
        }
        ra.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, us("SegmentVector", ra);
        const ia = to([{ name: "a_pattern_from", components: 4, type: "Uint16" }, { name: "a_pattern_to", components: 4, type: "Uint16" }, { name: "a_pixel_ratio_from", components: 1, type: "Uint16" }, { name: "a_pixel_ratio_to", components: 1, type: "Uint16" }]), sa = to([{ name: "a_dasharray_from", components: 4, type: "Uint16" }, { name: "a_dasharray_to", components: 4, type: "Uint16" }]);
        var oa, aa, la, ua = { exports: {} }, ca = { exports: {} }, ha = { exports: {} }, pa = function() {
          if (la) return ua.exports;
          la = 1;
          var t2 = (oa || (oa = 1, ca.exports = function(t3, e3) {
            var r2, n2, i2, s2, o2, a2, l2, u2;
            for (n2 = t3.length - (r2 = 3 & t3.length), i2 = e3, o2 = 3432918353, a2 = 461845907, u2 = 0; u2 < n2; ) l2 = 255 & t3.charCodeAt(u2) | (255 & t3.charCodeAt(++u2)) << 8 | (255 & t3.charCodeAt(++u2)) << 16 | (255 & t3.charCodeAt(++u2)) << 24, ++u2, i2 = 27492 + (65535 & (s2 = 5 * (65535 & (i2 = (i2 ^= l2 = (65535 & (l2 = (l2 = (65535 & l2) * o2 + (((l2 >>> 16) * o2 & 65535) << 16) & 4294967295) << 15 | l2 >>> 17)) * a2 + (((l2 >>> 16) * a2 & 65535) << 16) & 4294967295) << 13 | i2 >>> 19)) + ((5 * (i2 >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s2 >>> 16) & 65535) << 16);
            switch (l2 = 0, r2) {
              case 3:
                l2 ^= (255 & t3.charCodeAt(u2 + 2)) << 16;
              case 2:
                l2 ^= (255 & t3.charCodeAt(u2 + 1)) << 8;
              case 1:
                i2 ^= l2 = (65535 & (l2 = (l2 = (65535 & (l2 ^= 255 & t3.charCodeAt(u2))) * o2 + (((l2 >>> 16) * o2 & 65535) << 16) & 4294967295) << 15 | l2 >>> 17)) * a2 + (((l2 >>> 16) * a2 & 65535) << 16) & 4294967295;
            }
            return i2 ^= t3.length, i2 = 2246822507 * (65535 & (i2 ^= i2 >>> 16)) + ((2246822507 * (i2 >>> 16) & 65535) << 16) & 4294967295, i2 = 3266489909 * (65535 & (i2 ^= i2 >>> 13)) + ((3266489909 * (i2 >>> 16) & 65535) << 16) & 4294967295, (i2 ^= i2 >>> 16) >>> 0;
          }), ca.exports), e2 = (aa || (aa = 1, ha.exports = function(t3, e3) {
            for (var r2, n2 = t3.length, i2 = e3 ^ n2, s2 = 0; n2 >= 4; ) r2 = 1540483477 * (65535 & (r2 = 255 & t3.charCodeAt(s2) | (255 & t3.charCodeAt(++s2)) << 8 | (255 & t3.charCodeAt(++s2)) << 16 | (255 & t3.charCodeAt(++s2)) << 24)) + ((1540483477 * (r2 >>> 16) & 65535) << 16), i2 = 1540483477 * (65535 & i2) + ((1540483477 * (i2 >>> 16) & 65535) << 16) ^ (r2 = 1540483477 * (65535 & (r2 ^= r2 >>> 24)) + ((1540483477 * (r2 >>> 16) & 65535) << 16)), n2 -= 4, ++s2;
            switch (n2) {
              case 3:
                i2 ^= (255 & t3.charCodeAt(s2 + 2)) << 16;
              case 2:
                i2 ^= (255 & t3.charCodeAt(s2 + 1)) << 8;
              case 1:
                i2 = 1540483477 * (65535 & (i2 ^= 255 & t3.charCodeAt(s2))) + ((1540483477 * (i2 >>> 16) & 65535) << 16);
            }
            return i2 = 1540483477 * (65535 & (i2 ^= i2 >>> 13)) + ((1540483477 * (i2 >>> 16) & 65535) << 16), (i2 ^= i2 >>> 15) >>> 0;
          }), ha.exports);
          return ua.exports = t2, ua.exports.murmur3 = t2, ua.exports.murmur2 = e2, ua.exports;
        }(), fa = n(pa);
        class da {
          constructor() {
            this.ids = [], this.positions = [], this.indexed = false;
          }
          add(t2, e2, r2, n2) {
            this.ids.push(ya(t2)), this.positions.push(e2, r2, n2);
          }
          getPositions(t2) {
            if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
            const e2 = ya(t2);
            let r2 = 0, n2 = this.ids.length - 1;
            for (; r2 < n2; ) {
              const t3 = r2 + n2 >> 1;
              this.ids[t3] >= e2 ? n2 = t3 : r2 = t3 + 1;
            }
            const i2 = [];
            for (; this.ids[r2] === e2; ) i2.push({ index: this.positions[3 * r2], start: this.positions[3 * r2 + 1], end: this.positions[3 * r2 + 2] }), r2++;
            return i2;
          }
          static serialize(t2, e2) {
            const r2 = new Float64Array(t2.ids), n2 = new Uint32Array(t2.positions);
            return ma(r2, n2, 0, r2.length - 1), e2 && e2.push(r2.buffer, n2.buffer), { ids: r2, positions: n2 };
          }
          static deserialize(t2) {
            const e2 = new da();
            return e2.ids = t2.ids, e2.positions = t2.positions, e2.indexed = true, e2;
          }
        }
        function ya(t2) {
          const e2 = +t2;
          return !isNaN(e2) && e2 <= Number.MAX_SAFE_INTEGER ? e2 : fa(String(t2));
        }
        function ma(t2, e2, r2, n2) {
          for (; r2 < n2; ) {
            const i2 = t2[r2 + n2 >> 1];
            let s2 = r2 - 1, o2 = n2 + 1;
            for (; ; ) {
              do {
                s2++;
              } while (t2[s2] < i2);
              do {
                o2--;
              } while (t2[o2] > i2);
              if (s2 >= o2) break;
              ga(t2, s2, o2), ga(e2, 3 * s2, 3 * o2), ga(e2, 3 * s2 + 1, 3 * o2 + 1), ga(e2, 3 * s2 + 2, 3 * o2 + 2);
            }
            o2 - r2 < n2 - o2 ? (ma(t2, e2, r2, o2), r2 = o2 + 1) : (ma(t2, e2, o2 + 1, n2), n2 = o2);
          }
        }
        function ga(t2, e2, r2) {
          const n2 = t2[e2];
          t2[e2] = t2[r2], t2[r2] = n2;
        }
        us("FeaturePositionMap", da);
        class xa {
          constructor(t2, e2) {
            this.gl = t2.gl, this.location = e2;
          }
        }
        class va extends xa {
          constructor(t2, e2) {
            super(t2, e2), this.current = 0;
          }
          set(t2) {
            this.current !== t2 && (this.current = t2, this.gl.uniform1f(this.location, t2));
          }
        }
        class ba extends xa {
          constructor(t2, e2) {
            super(t2, e2), this.current = [0, 0, 0, 0];
          }
          set(t2) {
            t2[0] === this.current[0] && t2[1] === this.current[1] && t2[2] === this.current[2] && t2[3] === this.current[3] || (this.current = t2, this.gl.uniform4f(this.location, t2[0], t2[1], t2[2], t2[3]));
          }
        }
        class wa extends xa {
          constructor(t2, e2) {
            super(t2, e2), this.current = Te.transparent;
          }
          set(t2) {
            t2.r === this.current.r && t2.g === this.current.g && t2.b === this.current.b && t2.a === this.current.a || (this.current = t2, this.gl.uniform4f(this.location, t2.r, t2.g, t2.b, t2.a));
          }
        }
        const _a = new Float32Array(16);
        function Aa(t2) {
          return [na(255 * t2.r, 255 * t2.g), na(255 * t2.b, 255 * t2.a)];
        }
        class Sa {
          constructor(t2, e2, r2) {
            this.value = t2, this.uniformNames = e2.map((t3) => `u_${t3}`), this.type = r2;
          }
          setUniform(t2, e2, r2) {
            t2.set(r2.constantOr(this.value));
          }
          getBinding(t2, e2, r2) {
            return "color" === this.type ? new wa(t2, e2) : new va(t2, e2);
          }
        }
        class ka {
          constructor(t2, e2) {
            this.uniformNames = e2.map((t3) => `u_${t3}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
          }
          setConstantPatternPositions(t2, e2) {
            this.pixelRatioFrom = e2.pixelRatio, this.pixelRatioTo = t2.pixelRatio, this.patternFrom = e2.tlbr, this.patternTo = t2.tlbr;
          }
          setConstantDashPositions(t2, e2) {
            this.dashTo = [0, t2.y, t2.height, t2.width], this.dashFrom = [0, e2.y, e2.height, e2.width];
          }
          setUniform(t2, e2, r2, n2) {
            let i2 = null;
            "u_pattern_to" === n2 ? i2 = this.patternTo : "u_pattern_from" === n2 ? i2 = this.patternFrom : "u_dasharray_to" === n2 ? i2 = this.dashTo : "u_dasharray_from" === n2 ? i2 = this.dashFrom : "u_pixel_ratio_to" === n2 ? i2 = this.pixelRatioTo : "u_pixel_ratio_from" === n2 && (i2 = this.pixelRatioFrom), null !== i2 && t2.set(i2);
          }
          getBinding(t2, e2, r2) {
            return "u_pattern" === r2.substr(0, 9) || "u_dasharray_" === r2.substr(0, 12) ? new ba(t2, e2) : new va(t2, e2);
          }
        }
        class Ea {
          constructor(t2, e2, r2, n2) {
            this.expression = t2, this.type = r2, this.maxValue = 0, this.paintVertexAttributes = e2.map((t3) => ({ name: `a_${t3}`, type: "Float32", components: "color" === r2 ? 2 : 1, offset: 0 })), this.paintVertexArray = new n2();
          }
          populatePaintArray(t2, e2, r2) {
            const n2 = this.paintVertexArray.length, i2 = this.expression.evaluate(new Fs(0, r2), e2, {}, r2.canonical, [], r2.formattedSection);
            this.paintVertexArray.resize(t2), this._setPaintValue(n2, t2, i2);
          }
          updatePaintArray(t2, e2, r2, n2, i2) {
            const s2 = this.expression.evaluate(new Fs(0, i2), r2, n2);
            this._setPaintValue(t2, e2, s2);
          }
          _setPaintValue(t2, e2, r2) {
            if ("color" === this.type) {
              const n2 = Aa(r2);
              for (let r3 = t2; r3 < e2; r3++) this.paintVertexArray.emplace(r3, n2[0], n2[1]);
            } else {
              for (let n2 = t2; n2 < e2; n2++) this.paintVertexArray.emplace(n2, r2);
              this.maxValue = Math.max(this.maxValue, Math.abs(r2));
            }
          }
          upload(t2) {
            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t2.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
          }
          destroy() {
            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
          }
        }
        class Ta {
          constructor(t2, e2, r2, n2, i2, s2) {
            this.expression = t2, this.uniformNames = e2.map((t3) => `u_${t3}_t`), this.type = r2, this.useIntegerZoom = n2, this.zoom = i2, this.maxValue = 0, this.paintVertexAttributes = e2.map((t3) => ({ name: `a_${t3}`, type: "Float32", components: "color" === r2 ? 4 : 2, offset: 0 })), this.paintVertexArray = new s2();
          }
          populatePaintArray(t2, e2, r2) {
            const n2 = this.expression.evaluate(new Fs(this.zoom, r2), e2, {}, r2.canonical, [], r2.formattedSection), i2 = this.expression.evaluate(new Fs(this.zoom + 1, r2), e2, {}, r2.canonical, [], r2.formattedSection), s2 = this.paintVertexArray.length;
            this.paintVertexArray.resize(t2), this._setPaintValue(s2, t2, n2, i2);
          }
          updatePaintArray(t2, e2, r2, n2, i2) {
            const s2 = this.expression.evaluate(new Fs(this.zoom, i2), r2, n2), o2 = this.expression.evaluate(new Fs(this.zoom + 1, i2), r2, n2);
            this._setPaintValue(t2, e2, s2, o2);
          }
          _setPaintValue(t2, e2, r2, n2) {
            if ("color" === this.type) {
              const i2 = Aa(r2), s2 = Aa(n2);
              for (let r3 = t2; r3 < e2; r3++) this.paintVertexArray.emplace(r3, i2[0], i2[1], s2[0], s2[1]);
            } else {
              for (let i2 = t2; i2 < e2; i2++) this.paintVertexArray.emplace(i2, r2, n2);
              this.maxValue = Math.max(this.maxValue, Math.abs(r2), Math.abs(n2));
            }
          }
          upload(t2) {
            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t2.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
          }
          destroy() {
            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
          }
          setUniform(t2, e2) {
            const r2 = this.useIntegerZoom ? Math.floor(e2.zoom) : e2.zoom, n2 = C(this.expression.interpolationFactor(r2, this.zoom, this.zoom + 1), 0, 1);
            t2.set(n2);
          }
          getBinding(t2, e2, r2) {
            return new va(t2, e2);
          }
        }
        class Ia {
          constructor(t2, e2, r2, n2, i2, s2) {
            this.expression = t2, this.type = e2, this.useIntegerZoom = r2, this.zoom = n2, this.layerId = s2, this.zoomInPaintVertexArray = new i2(), this.zoomOutPaintVertexArray = new i2();
          }
          populatePaintArray(t2, e2, r2) {
            const n2 = this.zoomInPaintVertexArray.length;
            this.zoomInPaintVertexArray.resize(t2), this.zoomOutPaintVertexArray.resize(t2), this._setPaintValues(n2, t2, this.getPositionIds(e2), r2);
          }
          updatePaintArray(t2, e2, r2, n2, i2) {
            this._setPaintValues(t2, e2, this.getPositionIds(r2), i2);
          }
          _setPaintValues(t2, e2, r2, n2) {
            const i2 = this.getPositions(n2);
            if (!i2 || !r2) return;
            const s2 = i2[r2.min], o2 = i2[r2.mid], a2 = i2[r2.max];
            if (s2 && o2 && a2) for (let r3 = t2; r3 < e2; r3++) this.emplace(this.zoomInPaintVertexArray, r3, o2, s2), this.emplace(this.zoomOutPaintVertexArray, r3, o2, a2);
          }
          upload(t2) {
            if (this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer) {
              const e2 = this.getVertexAttributes();
              this.zoomInPaintVertexBuffer = t2.createVertexBuffer(this.zoomInPaintVertexArray, e2, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t2.createVertexBuffer(this.zoomOutPaintVertexArray, e2, this.expression.isStateDependent);
            }
          }
          destroy() {
            this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
          }
        }
        class Ma extends Ia {
          getPositions(t2) {
            return t2.imagePositions;
          }
          getPositionIds(t2) {
            return t2.patterns && t2.patterns[this.layerId];
          }
          getVertexAttributes() {
            return ia.members;
          }
          emplace(t2, e2, r2, n2) {
            t2.emplace(e2, r2.tlbr[0], r2.tlbr[1], r2.tlbr[2], r2.tlbr[3], n2.tlbr[0], n2.tlbr[1], n2.tlbr[2], n2.tlbr[3], r2.pixelRatio, n2.pixelRatio);
          }
        }
        class Fa extends Ia {
          getPositions(t2) {
            return t2.dashPositions;
          }
          getPositionIds(t2) {
            return t2.dashes && t2.dashes[this.layerId];
          }
          getVertexAttributes() {
            return sa.members;
          }
          emplace(t2, e2, r2, n2) {
            t2.emplace(e2, 0, r2.y, r2.height, r2.width, 0, n2.y, n2.height, n2.width);
          }
        }
        class Da {
          constructor(t2, e2, r2) {
            this.binders = {}, this._buffers = [];
            const n2 = [];
            for (const i2 in t2.paint._values) {
              if (!r2(i2)) continue;
              const s2 = t2.paint.get(i2);
              if (!(s2 instanceof Rs && qn(s2.property.specification))) continue;
              const o2 = za(i2, t2.type), a2 = s2.value, l2 = s2.property.specification.type, u2 = s2.property.useIntegerZoom, c2 = s2.property.specification["property-type"], h2 = "cross-faded" === c2 || "cross-faded-data-driven" === c2;
              if ("constant" === a2.kind) this.binders[i2] = h2 ? new ka(a2.value, o2) : new Sa(a2.value, o2, l2), n2.push(`/u_${i2}`);
              else if ("source" === a2.kind || h2) {
                const r3 = Ba(i2, l2, "source");
                this.binders[i2] = h2 ? "line-dasharray" === i2 ? new Fa(a2, l2, u2, e2, r3, t2.id) : new Ma(a2, l2, u2, e2, r3, t2.id) : new Ea(a2, o2, l2, r3), n2.push(`/a_${i2}`);
              } else {
                const t3 = Ba(i2, l2, "composite");
                this.binders[i2] = new Ta(a2, o2, l2, u2, e2, t3), n2.push(`/z_${i2}`);
              }
            }
            this.cacheKey = n2.sort().join("");
          }
          getMaxValue(t2) {
            const e2 = this.binders[t2];
            return e2 instanceof Ea || e2 instanceof Ta ? e2.maxValue : 0;
          }
          populatePaintArrays(t2, e2, r2) {
            for (const n2 in this.binders) {
              const i2 = this.binders[n2];
              (i2 instanceof Ea || i2 instanceof Ta || i2 instanceof Ia) && i2.populatePaintArray(t2, e2, r2);
            }
          }
          setConstantPatternPositions(t2, e2) {
            for (const r2 in this.binders) {
              const n2 = this.binders[r2];
              n2 instanceof ka && n2.setConstantPatternPositions(t2, e2);
            }
          }
          setConstantDashPositions(t2, e2) {
            for (const r2 in this.binders) {
              const n2 = this.binders[r2];
              n2 instanceof ka && n2.setConstantDashPositions(t2, e2);
            }
          }
          updatePaintArrays(t2, e2, r2, n2, i2) {
            let s2 = false;
            for (const o2 in t2) {
              const a2 = e2.getPositions(o2);
              for (const e3 of a2) {
                const a3 = r2.feature(e3.index);
                for (const r3 in this.binders) {
                  const l2 = this.binders[r3];
                  if ((l2 instanceof Ea || l2 instanceof Ta || l2 instanceof Ia) && true === l2.expression.isStateDependent) {
                    const u2 = n2.paint.get(r3);
                    l2.expression = u2.value, l2.updatePaintArray(e3.start, e3.end, a3, t2[o2], i2), s2 = true;
                  }
                }
              }
            }
            return s2;
          }
          defines() {
            const t2 = [];
            for (const e2 in this.binders) {
              const r2 = this.binders[e2];
              (r2 instanceof Sa || r2 instanceof ka) && t2.push(...r2.uniformNames.map((t3) => `#define HAS_UNIFORM_${t3}`));
            }
            return t2;
          }
          getBinderAttributes() {
            const t2 = [];
            for (const e2 in this.binders) {
              const r2 = this.binders[e2];
              if (r2 instanceof Ea || r2 instanceof Ta) for (let e3 = 0; e3 < r2.paintVertexAttributes.length; e3++) t2.push(r2.paintVertexAttributes[e3].name);
              else if (r2 instanceof Ia) {
                const e3 = r2.getVertexAttributes();
                for (const r3 of e3) t2.push(r3.name);
              }
            }
            return t2;
          }
          getBinderUniforms() {
            const t2 = [];
            for (const e2 in this.binders) {
              const r2 = this.binders[e2];
              if (r2 instanceof Sa || r2 instanceof ka || r2 instanceof Ta) for (const e3 of r2.uniformNames) t2.push(e3);
            }
            return t2;
          }
          getPaintVertexBuffers() {
            return this._buffers;
          }
          getUniforms(t2, e2) {
            const r2 = [];
            for (const n2 in this.binders) {
              const i2 = this.binders[n2];
              if (i2 instanceof Sa || i2 instanceof ka || i2 instanceof Ta) {
                for (const s2 of i2.uniformNames) if (e2[s2]) {
                  const o2 = i2.getBinding(t2, e2[s2], s2);
                  r2.push({ name: s2, property: n2, binding: o2 });
                }
              }
            }
            return r2;
          }
          setUniforms(t2, e2, r2, n2) {
            for (const { name: t3, property: i2, binding: s2 } of e2) this.binders[i2].setUniform(s2, n2, r2.get(i2), t3);
          }
          updatePaintBuffers(t2) {
            this._buffers = [];
            for (const e2 in this.binders) {
              const r2 = this.binders[e2];
              if (t2 && r2 instanceof Ia) {
                const e3 = 2 === t2.fromScale ? r2.zoomInPaintVertexBuffer : r2.zoomOutPaintVertexBuffer;
                e3 && this._buffers.push(e3);
              } else (r2 instanceof Ea || r2 instanceof Ta) && r2.paintVertexBuffer && this._buffers.push(r2.paintVertexBuffer);
            }
          }
          upload(t2) {
            for (const e2 in this.binders) {
              const r2 = this.binders[e2];
              (r2 instanceof Ea || r2 instanceof Ta || r2 instanceof Ia) && r2.upload(t2);
            }
            this.updatePaintBuffers();
          }
          destroy() {
            for (const t2 in this.binders) {
              const e2 = this.binders[t2];
              (e2 instanceof Ea || e2 instanceof Ta || e2 instanceof Ia) && e2.destroy();
            }
          }
        }
        class Pa {
          constructor(t2, e2, r2 = () => true) {
            this.programConfigurations = {};
            for (const n2 of t2) this.programConfigurations[n2.id] = new Da(n2, e2, r2);
            this.needsUpload = false, this._featureMap = new da(), this._bufferOffset = 0;
          }
          populatePaintArrays(t2, e2, r2, n2) {
            for (const r3 in this.programConfigurations) this.programConfigurations[r3].populatePaintArrays(t2, e2, n2);
            void 0 !== e2.id && this._featureMap.add(e2.id, r2, this._bufferOffset, t2), this._bufferOffset = t2, this.needsUpload = true;
          }
          updatePaintArrays(t2, e2, r2, n2) {
            for (const i2 of r2) this.needsUpload = this.programConfigurations[i2.id].updatePaintArrays(t2, this._featureMap, e2, i2, n2) || this.needsUpload;
          }
          get(t2) {
            return this.programConfigurations[t2];
          }
          upload(t2) {
            if (this.needsUpload) {
              for (const e2 in this.programConfigurations) this.programConfigurations[e2].upload(t2);
              this.needsUpload = false;
            }
          }
          destroy() {
            for (const t2 in this.programConfigurations) this.programConfigurations[t2].destroy();
          }
        }
        function za(t2, e2) {
          return { "text-opacity": ["opacity"], "icon-opacity": ["opacity"], "text-color": ["fill_color"], "icon-color": ["fill_color"], "text-halo-color": ["halo_color"], "icon-halo-color": ["halo_color"], "text-halo-blur": ["halo_blur"], "icon-halo-blur": ["halo_blur"], "text-halo-width": ["halo_width"], "icon-halo-width": ["halo_width"], "line-gap-width": ["gapwidth"], "line-dasharray": ["dasharray_to", "dasharray_from"], "line-pattern": ["pattern_to", "pattern_from", "pixel_ratio_to", "pixel_ratio_from"], "fill-pattern": ["pattern_to", "pattern_from", "pixel_ratio_to", "pixel_ratio_from"], "fill-extrusion-pattern": ["pattern_to", "pattern_from", "pixel_ratio_to", "pixel_ratio_from"] }[t2] || [t2.replace(`${e2}-`, "").replace(/-/g, "_")];
        }
        function Ba(t2, e2, r2) {
          const n2 = { color: { source: ao, composite: Eo }, number: { source: wo, composite: ao } }, i2 = function(t3) {
            return { "line-pattern": { source: Go, composite: Go }, "fill-pattern": { source: Go, composite: Go }, "fill-extrusion-pattern": { source: Go, composite: Go }, "line-dasharray": { source: Xo, composite: Xo } }[t3];
          }(t2);
          return i2 && i2[r2] || n2[e2][r2];
        }
        us("ConstantBinder", Sa), us("CrossFadedConstantBinder", ka), us("SourceExpressionBinder", Ea), us("CrossFadedPatternBinder", Ma), us("CrossFadedDasharrayBinder", Fa), us("CompositeExpressionBinder", Ta), us("ProgramConfiguration", Da, { omit: ["_buffers"] }), us("ProgramConfigurationSet", Pa);
        const Va = Math.pow(2, 14) - 1, Ca = -Va - 1;
        function La(t2) {
          const e2 = M / t2.extent, r2 = t2.loadGeometry();
          for (let t3 = 0; t3 < r2.length; t3++) {
            const n2 = r2[t3];
            for (let t4 = 0; t4 < n2.length; t4++) {
              const r3 = n2[t4], i2 = Math.round(r3.x * e2), s2 = Math.round(r3.y * e2);
              r3.x = C(i2, Ca, Va), r3.y = C(s2, Ca, Va), (i2 < r3.x || i2 > r3.x + 1 || s2 < r3.y || s2 > r3.y + 1) && j("Geometry exceeds allowed extent, reduce your vector tile buffer size");
            }
          }
          return r2;
        }
        function Oa(t2, e2) {
          return { type: t2.type, id: t2.id, properties: t2.properties, geometry: e2 ? La(t2) : [] };
        }
        const Ra = -32768;
        function Na(t2, e2, r2, n2, i2) {
          t2.emplaceBack(Ra + 8 * e2 + n2, Ra + 8 * r2 + i2);
        }
        class $a {
          constructor(t2) {
            this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.id), this.index = t2.index, this.hasDependencies = false, this.layoutVertexArray = new No(), this.indexArray = new Jo(), this.segments = new ra(), this.programConfigurations = new Pa(t2.layers, t2.zoom), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id);
          }
          populate(t2, e2, r2) {
            const n2 = this.layers[0], i2 = [];
            let s2 = null, o2 = false, a2 = "heatmap" === n2.type;
            if ("circle" === n2.type) {
              const t3 = n2;
              s2 = t3.layout.get("circle-sort-key"), o2 = !s2.isConstant(), a2 = a2 || "map" === t3.paint.get("circle-pitch-alignment");
            }
            const l2 = a2 ? e2.subdivisionGranularity.circle : 1;
            for (const { feature: e3, id: n3, index: a3, sourceLayerIndex: l3 } of t2) {
              const t3 = this.layers[0]._featureFilter.needGeometry, u2 = Oa(e3, t3);
              if (!this.layers[0]._featureFilter.filter(new Fs(this.zoom), u2, r2)) continue;
              const c2 = o2 ? s2.evaluate(u2, {}, r2) : void 0, h2 = { id: n3, properties: e3.properties, type: e3.type, sourceLayerIndex: l3, index: a3, geometry: t3 ? u2.geometry : La(e3), patterns: {}, sortKey: c2 };
              i2.push(h2);
            }
            o2 && i2.sort((t3, e3) => t3.sortKey - e3.sortKey);
            for (const n3 of i2) {
              const { geometry: i3, index: s3, sourceLayerIndex: o3 } = n3, a3 = t2[s3].feature;
              this.addFeature(n3, i3, s3, r2, l2), e2.featureIndex.insert(a3, i3, s3, o3, this.index);
            }
          }
          update(t2, e2, r2) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t2, e2, this.stateDependentLayers, { imagePositions: r2 });
          }
          isEmpty() {
            return 0 === this.layoutVertexArray.length;
          }
          uploadPending() {
            return !this.uploaded || this.programConfigurations.needsUpload;
          }
          upload(t2) {
            this.uploaded || (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, ea), this.indexBuffer = t2.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t2), this.uploaded = true;
          }
          destroy() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
          }
          addFeature(t2, e2, r2, n2, i2 = 1) {
            let s2;
            switch (i2) {
              case 1:
                s2 = [0, 7];
                break;
              case 3:
                s2 = [0, 2, 5, 7];
                break;
              case 5:
                s2 = [0, 1, 3, 4, 6, 7];
                break;
              case 7:
                s2 = [0, 1, 2, 3, 4, 5, 6, 7];
                break;
              default:
                throw new Error(`Invalid circle bucket granularity: ${i2}; valid values are 1, 3, 5, 7.`);
            }
            const o2 = s2.length;
            for (const r3 of e2) for (const e3 of r3) {
              const r4 = e3.x, n3 = e3.y;
              if (r4 < 0 || r4 >= M || n3 < 0 || n3 >= M) continue;
              const i3 = this.segments.prepareSegment(o2 * o2, this.layoutVertexArray, this.indexArray, t2.sortKey), a2 = i3.vertexLength;
              for (let t3 = 0; t3 < o2; t3++) for (let e4 = 0; e4 < o2; e4++) Na(this.layoutVertexArray, r4, n3, s2[e4], s2[t3]);
              for (let t3 = 0; t3 < o2 - 1; t3++) for (let e4 = 0; e4 < o2 - 1; e4++) {
                const r5 = a2 + t3 * o2 + e4, n4 = a2 + (t3 + 1) * o2 + e4;
                this.indexArray.emplaceBack(r5, n4 + 1, r5 + 1), this.indexArray.emplaceBack(r5, n4, n4 + 1);
              }
              i3.vertexLength += o2 * o2, i3.primitiveLength += (o2 - 1) * (o2 - 1) * 2;
            }
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, { imagePositions: {}, canonical: n2 });
          }
        }
        function Ua(t2, e2) {
          for (let r2 = 0; r2 < t2.length; r2++) if (Wa(e2, t2[r2])) return true;
          for (let r2 = 0; r2 < e2.length; r2++) if (Wa(t2, e2[r2])) return true;
          return !!Xa(t2, e2);
        }
        function qa(t2, e2, r2) {
          return !!Wa(t2, e2) || !!Za(e2, t2, r2);
        }
        function ja(t2, e2) {
          if (1 === t2.length) return Ka(e2, t2[0]);
          for (let r2 = 0; r2 < e2.length; r2++) {
            const n2 = e2[r2];
            for (let e3 = 0; e3 < n2.length; e3++) if (Wa(t2, n2[e3])) return true;
          }
          for (let r2 = 0; r2 < t2.length; r2++) if (Ka(e2, t2[r2])) return true;
          for (let r2 = 0; r2 < e2.length; r2++) if (Xa(t2, e2[r2])) return true;
          return false;
        }
        function Ga(t2, e2, r2) {
          if (t2.length > 1) {
            if (Xa(t2, e2)) return true;
            for (let n2 = 0; n2 < e2.length; n2++) if (Za(e2[n2], t2, r2)) return true;
          }
          for (let n2 = 0; n2 < t2.length; n2++) if (Za(t2[n2], e2, r2)) return true;
          return false;
        }
        function Xa(t2, e2) {
          if (0 === t2.length || 0 === e2.length) return false;
          for (let r2 = 0; r2 < t2.length - 1; r2++) {
            const n2 = t2[r2], i2 = t2[r2 + 1];
            for (let t3 = 0; t3 < e2.length - 1; t3++) if (Ya(n2, i2, e2[t3], e2[t3 + 1])) return true;
          }
          return false;
        }
        function Ya(t2, e2, r2, n2) {
          return G(t2, r2, n2) !== G(e2, r2, n2) && G(t2, e2, r2) !== G(t2, e2, n2);
        }
        function Za(t2, e2, r2) {
          const n2 = r2 * r2;
          if (1 === e2.length) return t2.distSqr(e2[0]) < n2;
          for (let r3 = 1; r3 < e2.length; r3++) if (Ha(t2, e2[r3 - 1], e2[r3]) < n2) return true;
          return false;
        }
        function Ha(t2, e2, r2) {
          const n2 = e2.distSqr(r2);
          if (0 === n2) return t2.distSqr(e2);
          const i2 = ((t2.x - e2.x) * (r2.x - e2.x) + (t2.y - e2.y) * (r2.y - e2.y)) / n2;
          return t2.distSqr(i2 < 0 ? e2 : i2 > 1 ? r2 : r2.sub(e2)._mult(i2)._add(e2));
        }
        function Ka(t2, e2) {
          let r2, n2, i2, s2 = false;
          for (let o2 = 0; o2 < t2.length; o2++) {
            r2 = t2[o2];
            for (let t3 = 0, o3 = r2.length - 1; t3 < r2.length; o3 = t3++) n2 = r2[t3], i2 = r2[o3], n2.y > e2.y != i2.y > e2.y && e2.x < (i2.x - n2.x) * (e2.y - n2.y) / (i2.y - n2.y) + n2.x && (s2 = !s2);
          }
          return s2;
        }
        function Wa(t2, e2) {
          let r2 = false;
          for (let n2 = 0, i2 = t2.length - 1; n2 < t2.length; i2 = n2++) {
            const s2 = t2[n2], o2 = t2[i2];
            s2.y > e2.y != o2.y > e2.y && e2.x < (o2.x - s2.x) * (e2.y - s2.y) / (o2.y - s2.y) + s2.x && (r2 = !r2);
          }
          return r2;
        }
        function Ja(t2, e2, r2) {
          const n2 = r2[0], i2 = r2[2];
          if (t2.x < n2.x && e2.x < n2.x || t2.x > i2.x && e2.x > i2.x || t2.y < n2.y && e2.y < n2.y || t2.y > i2.y && e2.y > i2.y) return false;
          const s2 = G(t2, e2, r2[0]);
          return s2 !== G(t2, e2, r2[1]) || s2 !== G(t2, e2, r2[2]) || s2 !== G(t2, e2, r2[3]);
        }
        function Qa(t2, e2, r2) {
          const n2 = e2.paint.get(t2).value;
          return "constant" === n2.kind ? n2.value : r2.programConfigurations.get(e2.id).getMaxValue(t2);
        }
        function tl(t2) {
          return Math.sqrt(t2[0] * t2[0] + t2[1] * t2[1]);
        }
        function el(t2, e2, n2, i2, s2) {
          if (!e2[0] && !e2[1]) return t2;
          const o2 = r.convert(e2)._mult(s2);
          "viewport" === n2 && o2._rotate(-i2);
          const a2 = [];
          for (let e3 = 0; e3 < t2.length; e3++) a2.push(t2[e3].sub(o2));
          return a2;
        }
        function rl(t2) {
          const e2 = [];
          for (let r2 = 0; r2 < t2.length; r2++) {
            const n2 = t2[r2], i2 = e2.at(-1);
            (0 === r2 || i2 && !n2.equals(i2)) && e2.push(n2);
          }
          return e2;
        }
        function nl({ queryGeometry: t2, size: e2 }, r2) {
          return qa(t2, r2, e2);
        }
        function il({ queryGeometry: t2, size: e2, transform: r2, unwrappedTileID: n2, getElevation: i2 }, s2) {
          return qa(t2, s2, e2 * (r2.projectTileCoordinates(s2.x, s2.y, n2, i2).signedDistanceFromCamera / r2.cameraToCenterDistance));
        }
        function sl({ queryGeometry: t2, size: e2, transform: r2, unwrappedTileID: n2, getElevation: i2 }, s2) {
          const o2 = r2.projectTileCoordinates(s2.x, s2.y, n2, i2).signedDistanceFromCamera, a2 = e2 * (r2.cameraToCenterDistance / o2);
          return qa(t2, ll(s2, r2, n2, i2), a2);
        }
        function ol({ queryGeometry: t2, size: e2, transform: r2, unwrappedTileID: n2, getElevation: i2 }, s2) {
          return qa(t2, ll(s2, r2, n2, i2), e2);
        }
        function al({ queryGeometry: t2, size: e2, transform: r2, unwrappedTileID: n2, getElevation: i2, pitchAlignment: s2 = "map", pitchScale: o2 = "map" }, a2) {
          const l2 = "map" === s2 ? "map" === o2 ? nl : il : "map" === o2 ? sl : ol, u2 = { queryGeometry: t2, size: e2, transform: r2, unwrappedTileID: n2, getElevation: i2 };
          for (const t3 of a2) for (const e3 of t3) if (l2(u2, e3)) return true;
          return false;
        }
        function ll(t2, e2, n2, i2) {
          const s2 = e2.projectTileCoordinates(t2.x, t2.y, n2, i2).point;
          return new r((0.5 * s2.x + 0.5) * e2.width, (0.5 * -s2.y + 0.5) * e2.height);
        }
        let ul, cl;
        us("CircleBucket", $a, { omit: ["layers"] });
        var hl = { get paint() {
          return cl = cl || new Xs({ "circle-radius": new Us(vt.paint_circle["circle-radius"]), "circle-color": new Us(vt.paint_circle["circle-color"]), "circle-blur": new Us(vt.paint_circle["circle-blur"]), "circle-opacity": new Us(vt.paint_circle["circle-opacity"]), "circle-translate": new $s(vt.paint_circle["circle-translate"]), "circle-translate-anchor": new $s(vt.paint_circle["circle-translate-anchor"]), "circle-pitch-scale": new $s(vt.paint_circle["circle-pitch-scale"]), "circle-pitch-alignment": new $s(vt.paint_circle["circle-pitch-alignment"]), "circle-stroke-width": new Us(vt.paint_circle["circle-stroke-width"]), "circle-stroke-color": new Us(vt.paint_circle["circle-stroke-color"]), "circle-stroke-opacity": new Us(vt.paint_circle["circle-stroke-opacity"]) });
        }, get layout() {
          return ul = ul || new Xs({ "circle-sort-key": new Us(vt.layout_circle["circle-sort-key"]) });
        } };
        class pl extends Ys {
          constructor(t2, e2) {
            super(t2, hl, e2);
          }
          createBucket(t2) {
            return new $a(t2);
          }
          queryRadius(t2) {
            const e2 = t2;
            return Qa("circle-radius", this, e2) + Qa("circle-stroke-width", this, e2) + tl(this.paint.get("circle-translate"));
          }
          queryIntersectsFeature({ queryGeometry: t2, feature: e2, featureState: r2, geometry: n2, transform: i2, pixelsToTileUnits: s2, unwrappedTileID: o2, getElevation: a2 }) {
            const l2 = el(t2, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), -i2.bearingInRadians, s2), u2 = this.paint.get("circle-radius").evaluate(e2, r2) + this.paint.get("circle-stroke-width").evaluate(e2, r2), c2 = this.paint.get("circle-pitch-scale"), h2 = this.paint.get("circle-pitch-alignment");
            let p2, f2;
            return "map" === h2 ? (p2 = l2, f2 = u2 * s2) : (p2 = function(t3, e3, r3, n3) {
              return t3.map((t4) => ll(t4, e3, r3, n3));
            }(l2, i2, o2, a2), f2 = u2), al({ queryGeometry: p2, size: f2, transform: i2, unwrappedTileID: o2, getElevation: a2, pitchAlignment: h2, pitchScale: c2 }, n2);
          }
        }
        class fl extends $a {
        }
        let dl;
        us("HeatmapBucket", fl, { omit: ["layers"] });
        var yl = { get paint() {
          return dl = dl || new Xs({ "heatmap-radius": new Us(vt.paint_heatmap["heatmap-radius"]), "heatmap-weight": new Us(vt.paint_heatmap["heatmap-weight"]), "heatmap-intensity": new $s(vt.paint_heatmap["heatmap-intensity"]), "heatmap-color": new Gs(vt.paint_heatmap["heatmap-color"]), "heatmap-opacity": new $s(vt.paint_heatmap["heatmap-opacity"]) });
        } };
        function ml(t2, { width: e2, height: r2 }, n2, i2) {
          if (i2) {
            if (i2 instanceof Uint8ClampedArray) i2 = new Uint8Array(i2.buffer);
            else if (i2.length !== e2 * r2 * n2) throw new RangeError(`mismatched image size. expected: ${i2.length} but got: ${e2 * r2 * n2}`);
          } else i2 = new Uint8Array(e2 * r2 * n2);
          return t2.width = e2, t2.height = r2, t2.data = i2, t2;
        }
        function gl(t2, { width: e2, height: r2 }, n2) {
          if (e2 === t2.width && r2 === t2.height) return;
          const i2 = ml({}, { width: e2, height: r2 }, n2);
          xl(t2, i2, { x: 0, y: 0 }, { x: 0, y: 0 }, { width: Math.min(t2.width, e2), height: Math.min(t2.height, r2) }, n2), t2.width = e2, t2.height = r2, t2.data = i2.data;
        }
        function xl(t2, e2, r2, n2, i2, s2) {
          if (0 === i2.width || 0 === i2.height) return e2;
          if (i2.width > t2.width || i2.height > t2.height || r2.x > t2.width - i2.width || r2.y > t2.height - i2.height) throw new RangeError("out of range source coordinates for image copy");
          if (i2.width > e2.width || i2.height > e2.height || n2.x > e2.width - i2.width || n2.y > e2.height - i2.height) throw new RangeError("out of range destination coordinates for image copy");
          const o2 = t2.data, a2 = e2.data;
          if (o2 === a2) throw new Error("srcData equals dstData, so image is already copied");
          for (let l2 = 0; l2 < i2.height; l2++) {
            const u2 = ((r2.y + l2) * t2.width + r2.x) * s2, c2 = ((n2.y + l2) * e2.width + n2.x) * s2;
            for (let t3 = 0; t3 < i2.width * s2; t3++) a2[c2 + t3] = o2[u2 + t3];
          }
          return e2;
        }
        class vl {
          constructor(t2, e2) {
            ml(this, t2, 1, e2);
          }
          resize(t2) {
            gl(this, t2, 1);
          }
          clone() {
            return new vl({ width: this.width, height: this.height }, new Uint8Array(this.data));
          }
          static copy(t2, e2, r2, n2, i2) {
            xl(t2, e2, r2, n2, i2, 1);
          }
        }
        class bl {
          constructor(t2, e2) {
            ml(this, t2, 4, e2);
          }
          resize(t2) {
            gl(this, t2, 4);
          }
          replace(t2, e2) {
            e2 ? this.data.set(t2) : this.data = t2 instanceof Uint8ClampedArray ? new Uint8Array(t2.buffer) : t2;
          }
          clone() {
            return new bl({ width: this.width, height: this.height }, new Uint8Array(this.data));
          }
          static copy(t2, e2, r2, n2, i2) {
            xl(t2, e2, r2, n2, i2, 4);
          }
          setPixel(t2, e2, r2) {
            const n2 = 4 * (t2 * this.width + e2);
            this.data[n2 + 0] = Math.round(255 * r2.r / r2.a), this.data[n2 + 1] = Math.round(255 * r2.g / r2.a), this.data[n2 + 2] = Math.round(255 * r2.b / r2.a), this.data[n2 + 3] = Math.round(255 * r2.a);
          }
        }
        function wl(t2) {
          const e2 = {}, r2 = t2.resolution || 256, n2 = t2.clips ? t2.clips.length : 1, i2 = t2.image || new bl({ width: r2, height: n2 });
          if (Math.log(r2) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${r2}`);
          const s2 = (n3, s3, o2) => {
            e2[t2.evaluationKey] = o2;
            const a2 = t2.expression.evaluate(e2);
            i2.setPixel(n3 / 4 / r2, s3 / 4, a2);
          };
          if (t2.clips) for (let e3 = 0, i3 = 0; e3 < n2; ++e3, i3 += 4 * r2) for (let n3 = 0, o2 = 0; n3 < r2; n3++, o2 += 4) {
            const a2 = n3 / (r2 - 1), { start: l2, end: u2 } = t2.clips[e3];
            s2(i3, o2, l2 * (1 - a2) + u2 * a2);
          }
          else for (let t3 = 0, e3 = 0; t3 < r2; t3++, e3 += 4) s2(0, e3, t3 / (r2 - 1));
          return i2;
        }
        us("AlphaImage", vl), us("RGBAImage", bl);
        const _l = "big-fb";
        class Al extends Ys {
          createBucket(t2) {
            return new fl(t2);
          }
          constructor(t2, e2) {
            super(t2, yl, e2), this.heatmapFbos = /* @__PURE__ */ new Map(), this._updateColorRamp();
          }
          _handleSpecialPaintPropertyUpdate(t2) {
            "heatmap-color" === t2 && this._updateColorRamp();
          }
          _updateColorRamp() {
            this.colorRamp = wl({ expression: this._transitionablePaint._values["heatmap-color"].value.expression, evaluationKey: "heatmapDensity", image: this.colorRamp }), this.colorRampTexture = null;
          }
          resize() {
            this.heatmapFbos.has(_l) && this.heatmapFbos.delete(_l);
          }
          queryRadius(t2) {
            return Qa("heatmap-radius", this, t2);
          }
          queryIntersectsFeature({ queryGeometry: t2, feature: e2, featureState: r2, geometry: n2, transform: i2, pixelsToTileUnits: s2, unwrappedTileID: o2, getElevation: a2 }) {
            return al({ queryGeometry: t2, size: this.paint.get("heatmap-radius").evaluate(e2, r2) * s2, transform: i2, unwrappedTileID: o2, getElevation: a2 }, n2);
          }
          hasOffscreenPass() {
            return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
          }
        }
        let Sl;
        var kl = { get paint() {
          return Sl = Sl || new Xs({ "hillshade-illumination-direction": new $s(vt.paint_hillshade["hillshade-illumination-direction"]), "hillshade-illumination-altitude": new $s(vt.paint_hillshade["hillshade-illumination-altitude"]), "hillshade-illumination-anchor": new $s(vt.paint_hillshade["hillshade-illumination-anchor"]), "hillshade-exaggeration": new $s(vt.paint_hillshade["hillshade-exaggeration"]), "hillshade-shadow-color": new $s(vt.paint_hillshade["hillshade-shadow-color"]), "hillshade-highlight-color": new $s(vt.paint_hillshade["hillshade-highlight-color"]), "hillshade-accent-color": new $s(vt.paint_hillshade["hillshade-accent-color"]), "hillshade-method": new $s(vt.paint_hillshade["hillshade-method"]) });
        } };
        class El extends Ys {
          constructor(t2, e2) {
            super(t2, kl, e2), this.recalculate({ zoom: 0, zoomHistory: {} }, void 0);
          }
          getIlluminationProperties() {
            let t2 = this.paint.get("hillshade-illumination-direction").values, e2 = this.paint.get("hillshade-illumination-altitude").values, r2 = this.paint.get("hillshade-highlight-color").values, n2 = this.paint.get("hillshade-shadow-color").values;
            const i2 = Math.max(t2.length, e2.length, r2.length, n2.length);
            t2 = t2.concat(Array(i2 - t2.length).fill(t2.at(-1))), e2 = e2.concat(Array(i2 - e2.length).fill(e2.at(-1))), r2 = r2.concat(Array(i2 - r2.length).fill(r2.at(-1))), n2 = n2.concat(Array(i2 - n2.length).fill(n2.at(-1)));
            const s2 = e2.map(tt);
            return { directionRadians: t2.map(tt), altitudeRadians: s2, shadowColor: n2, highlightColor: r2 };
          }
          hasOffscreenPass() {
            return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
          }
        }
        let Tl;
        var Il = { get paint() {
          return Tl = Tl || new Xs({ "color-relief-opacity": new $s(vt["paint_color-relief"]["color-relief-opacity"]), "color-relief-color": new Gs(vt["paint_color-relief"]["color-relief-color"]) });
        } };
        class Ml {
          constructor(t2, e2, r2, n2) {
            this.context = t2, this.format = r2, this.texture = t2.gl.createTexture(), this.update(e2, n2);
          }
          update(t2, e2, r2) {
            const { width: n2, height: i2 } = t2, s2 = !(this.size && this.size[0] === n2 && this.size[1] === i2 || r2), { context: o2 } = this, { gl: a2 } = o2;
            if (this.useMipmap = Boolean(e2 && e2.useMipmap), a2.bindTexture(a2.TEXTURE_2D, this.texture), o2.pixelStoreUnpackFlipY.set(false), o2.pixelStoreUnpack.set(1), o2.pixelStoreUnpackPremultiplyAlpha.set(this.format === a2.RGBA && (!e2 || false !== e2.premultiply)), s2) this.size = [n2, i2], t2 instanceof HTMLImageElement || t2 instanceof HTMLCanvasElement || t2 instanceof HTMLVideoElement || t2 instanceof ImageData || Z(t2) ? a2.texImage2D(a2.TEXTURE_2D, 0, this.format, this.format, a2.UNSIGNED_BYTE, t2) : a2.texImage2D(a2.TEXTURE_2D, 0, this.format, n2, i2, 0, this.format, a2.UNSIGNED_BYTE, t2.data);
            else {
              const { x: e3, y: s3 } = r2 || { x: 0, y: 0 };
              t2 instanceof HTMLImageElement || t2 instanceof HTMLCanvasElement || t2 instanceof HTMLVideoElement || t2 instanceof ImageData || Z(t2) ? a2.texSubImage2D(a2.TEXTURE_2D, 0, e3, s3, a2.RGBA, a2.UNSIGNED_BYTE, t2) : a2.texSubImage2D(a2.TEXTURE_2D, 0, e3, s3, n2, i2, a2.RGBA, a2.UNSIGNED_BYTE, t2.data);
            }
            this.useMipmap && this.isSizePowerOfTwo() && a2.generateMipmap(a2.TEXTURE_2D), o2.pixelStoreUnpackFlipY.setDefault(), o2.pixelStoreUnpack.setDefault(), o2.pixelStoreUnpackPremultiplyAlpha.setDefault();
          }
          bind(t2, e2, r2) {
            const { context: n2 } = this, { gl: i2 } = n2;
            i2.bindTexture(i2.TEXTURE_2D, this.texture), r2 !== i2.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (r2 = i2.LINEAR), t2 !== this.filter && (i2.texParameteri(i2.TEXTURE_2D, i2.TEXTURE_MAG_FILTER, t2), i2.texParameteri(i2.TEXTURE_2D, i2.TEXTURE_MIN_FILTER, r2 || t2), this.filter = t2), e2 !== this.wrap && (i2.texParameteri(i2.TEXTURE_2D, i2.TEXTURE_WRAP_S, e2), i2.texParameteri(i2.TEXTURE_2D, i2.TEXTURE_WRAP_T, e2), this.wrap = e2);
          }
          isSizePowerOfTwo() {
            return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
          }
          destroy() {
            const { gl: t2 } = this.context;
            t2.deleteTexture(this.texture), this.texture = null;
          }
        }
        class Fl {
          constructor(t2, e2, r2, n2 = 1, i2 = 1, s2 = 1, o2 = 0) {
            if (this.uid = t2, e2.height !== e2.width) throw new RangeError("DEM tiles must be square");
            if (r2 && !["mapbox", "terrarium", "custom"].includes(r2)) return void j(`"${r2}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
            this.stride = e2.height;
            const a2 = this.dim = e2.height - 2;
            switch (this.data = new Uint32Array(e2.data.buffer), r2) {
              case "terrarium":
                this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                break;
              case "custom":
                this.redFactor = n2, this.greenFactor = i2, this.blueFactor = s2, this.baseShift = o2;
                break;
              default:
                this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = 0.1, this.baseShift = 1e4;
            }
            for (let t3 = 0; t3 < a2; t3++) this.data[this._idx(-1, t3)] = this.data[this._idx(0, t3)], this.data[this._idx(a2, t3)] = this.data[this._idx(a2 - 1, t3)], this.data[this._idx(t3, -1)] = this.data[this._idx(t3, 0)], this.data[this._idx(t3, a2)] = this.data[this._idx(t3, a2 - 1)];
            this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(a2, -1)] = this.data[this._idx(a2 - 1, 0)], this.data[this._idx(-1, a2)] = this.data[this._idx(0, a2 - 1)], this.data[this._idx(a2, a2)] = this.data[this._idx(a2 - 1, a2 - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
            for (let t3 = 0; t3 < a2; t3++) for (let e3 = 0; e3 < a2; e3++) {
              const r3 = this.get(t3, e3);
              r3 > this.max && (this.max = r3), r3 < this.min && (this.min = r3);
            }
          }
          get(t2, e2) {
            const r2 = new Uint8Array(this.data.buffer), n2 = 4 * this._idx(t2, e2);
            return this.unpack(r2[n2], r2[n2 + 1], r2[n2 + 2]);
          }
          getUnpackVector() {
            return [this.redFactor, this.greenFactor, this.blueFactor, this.baseShift];
          }
          _idx(t2, e2) {
            if (t2 < -1 || t2 >= this.dim + 1 || e2 < -1 || e2 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
            return (e2 + 1) * this.stride + (t2 + 1);
          }
          unpack(t2, e2, r2) {
            return t2 * this.redFactor + e2 * this.greenFactor + r2 * this.blueFactor - this.baseShift;
          }
          pack(t2) {
            return Dl(t2, this.getUnpackVector());
          }
          getPixels() {
            return new bl({ width: this.stride, height: this.stride }, new Uint8Array(this.data.buffer));
          }
          backfillBorder(t2, e2, r2) {
            if (this.dim !== t2.dim) throw new Error("dem dimension mismatch");
            let n2 = e2 * this.dim, i2 = e2 * this.dim + this.dim, s2 = r2 * this.dim, o2 = r2 * this.dim + this.dim;
            switch (e2) {
              case -1:
                n2 = i2 - 1;
                break;
              case 1:
                i2 = n2 + 1;
            }
            switch (r2) {
              case -1:
                s2 = o2 - 1;
                break;
              case 1:
                o2 = s2 + 1;
            }
            const a2 = -e2 * this.dim, l2 = -r2 * this.dim;
            for (let e3 = s2; e3 < o2; e3++) for (let r3 = n2; r3 < i2; r3++) this.data[this._idx(r3, e3)] = t2.data[this._idx(r3 + a2, e3 + l2)];
          }
        }
        function Dl(t2, e2) {
          const r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], o2 = Math.min(r2, n2, i2), a2 = Math.round((t2 + s2) / o2);
          return { r: Math.floor(a2 * o2 / r2) % 256, g: Math.floor(a2 * o2 / n2) % 256, b: Math.floor(a2 * o2 / i2) % 256 };
        }
        us("DEMData", Fl);
        class Pl extends Ys {
          constructor(t2, e2) {
            super(t2, Il, e2);
          }
          _createColorRamp(t2) {
            const e2 = { elevationStops: [], colorStops: [] }, r2 = this._transitionablePaint._values["color-relief-color"].value.expression;
            if (r2 instanceof ii && r2._styleExpression.expression instanceof fr) {
              this.colorRampExpression = r2;
              const t3 = r2._styleExpression.expression;
              e2.elevationStops = t3.labels, e2.colorStops = [];
              for (const r3 of e2.elevationStops) e2.colorStops.push(t3.evaluate({ globals: { elevation: r3 } }));
            }
            if (e2.elevationStops.length < 1 && (e2.elevationStops = [0], e2.colorStops = [Te.transparent]), e2.elevationStops.length < 2 && (e2.elevationStops.push(e2.elevationStops[0] + 1), e2.colorStops.push(e2.colorStops[0])), e2.elevationStops.length <= t2) return e2;
            const n2 = { elevationStops: [], colorStops: [] }, i2 = (e2.elevationStops.length - 1) / (t2 - 1);
            for (let t3 = 0; t3 < e2.elevationStops.length - 0.5; t3 += i2) n2.elevationStops.push(e2.elevationStops[Math.round(t3)]), n2.colorStops.push(e2.colorStops[Math.round(t3)]);
            return j(`Too many colors in specification of ${this.id} color-relief layer, may not render properly. Max possible colors: ${t2}, provided: ${e2.elevationStops.length}`), n2;
          }
          _colorRampChanged() {
            return this.colorRampExpression != this._transitionablePaint._values["color-relief-color"].value.expression;
          }
          getColorRampTextures(t2, e2, r2) {
            if (this.colorRampTextures && !this._colorRampChanged()) return this.colorRampTextures;
            const n2 = this._createColorRamp(e2), i2 = new bl({ width: n2.colorStops.length, height: 1 }), s2 = new bl({ width: n2.colorStops.length, height: 1 });
            for (let t3 = 0; t3 < n2.elevationStops.length; t3++) {
              const e3 = Dl(n2.elevationStops[t3], r2);
              s2.setPixel(0, t3, new Te(e3.r / 255, e3.g / 255, e3.b / 255, 1)), i2.setPixel(0, t3, n2.colorStops[t3]);
            }
            return this.colorRampTextures = { elevationTexture: new Ml(t2, s2, t2.gl.RGBA), colorTexture: new Ml(t2, i2, t2.gl.RGBA) }, this.colorRampTextures;
          }
          hasOffscreenPass() {
            return "none" !== this.visibility && !!this.colorRampTextures;
          }
        }
        const zl = to([{ name: "a_pos", components: 2, type: "Int16" }], 4), { members: Bl } = zl;
        function Vl(t2, e2, r2) {
          const n2 = r2.patternDependencies;
          let i2 = false;
          for (const r3 of e2) {
            const e3 = r3.paint.get(`${t2}-pattern`);
            e3.isConstant() || (i2 = true);
            const s2 = e3.constantOr(null);
            s2 && (i2 = true, n2[s2.to] = true, n2[s2.from] = true);
          }
          return i2;
        }
        function Cl(t2, e2, r2, n2, i2) {
          const { zoom: s2 } = n2, o2 = i2.patternDependencies;
          for (const n3 of e2) {
            const e3 = n3.paint.get(`${t2}-pattern`).value;
            if ("constant" !== e3.kind) {
              let t3 = e3.evaluate({ zoom: s2 - 1 }, r2, {}, i2.availableImages), a2 = e3.evaluate({ zoom: s2 }, r2, {}, i2.availableImages), l2 = e3.evaluate({ zoom: s2 + 1 }, r2, {}, i2.availableImages);
              t3 = t3 && t3.name ? t3.name : t3, a2 = a2 && a2.name ? a2.name : a2, l2 = l2 && l2.name ? l2.name : l2, o2[t3] = true, o2[a2] = true, o2[l2] = true, r2.patterns[n3.id] = { min: t3, mid: a2, max: l2 };
            }
          }
          return r2;
        }
        function Ll(t2, e2, r2, n2, i2) {
          let s2;
          if (i2 === function(t3, e3, r3, n3) {
            let i3 = 0;
            for (let s3 = e3, o2 = r3 - n3; s3 < r3; s3 += n3) i3 += (t3[o2] - t3[s3]) * (t3[s3 + 1] + t3[o2 + 1]), o2 = s3;
            return i3;
          }(t2, e2, r2, n2) > 0) for (let i3 = e2; i3 < r2; i3 += n2) s2 = su(i3 / n2 | 0, t2[i3], t2[i3 + 1], s2);
          else for (let i3 = r2 - n2; i3 >= e2; i3 -= n2) s2 = su(i3 / n2 | 0, t2[i3], t2[i3 + 1], s2);
          return s2 && Ql(s2, s2.next) && (ou(s2), s2 = s2.next), s2;
        }
        function Ol(t2, e2) {
          if (!t2) return t2;
          e2 || (e2 = t2);
          let r2, n2 = t2;
          do {
            if (r2 = false, n2.steiner || !Ql(n2, n2.next) && 0 !== Jl(n2.prev, n2, n2.next)) n2 = n2.next;
            else {
              if (ou(n2), n2 = e2 = n2.prev, n2 === n2.next) break;
              r2 = true;
            }
          } while (r2 || n2 !== e2);
          return e2;
        }
        function Rl(t2, e2, r2, n2, i2, s2, o2) {
          if (!t2) return;
          !o2 && s2 && function(t3, e3, r3, n3) {
            let i3 = t3;
            do {
              0 === i3.z && (i3.z = Yl(i3.x, i3.y, e3, r3, n3)), i3.prevZ = i3.prev, i3.nextZ = i3.next, i3 = i3.next;
            } while (i3 !== t3);
            i3.prevZ.nextZ = null, i3.prevZ = null, function(t4) {
              let e4, r4 = 1;
              do {
                let n4, i4 = t4;
                t4 = null;
                let s3 = null;
                for (e4 = 0; i4; ) {
                  e4++;
                  let o3 = i4, a3 = 0;
                  for (let t5 = 0; t5 < r4 && (a3++, o3 = o3.nextZ, o3); t5++) ;
                  let l2 = r4;
                  for (; a3 > 0 || l2 > 0 && o3; ) 0 !== a3 && (0 === l2 || !o3 || i4.z <= o3.z) ? (n4 = i4, i4 = i4.nextZ, a3--) : (n4 = o3, o3 = o3.nextZ, l2--), s3 ? s3.nextZ = n4 : t4 = n4, n4.prevZ = s3, s3 = n4;
                  i4 = o3;
                }
                s3.nextZ = null, r4 *= 2;
              } while (e4 > 1);
            }(i3);
          }(t2, n2, i2, s2);
          let a2 = t2;
          for (; t2.prev !== t2.next; ) {
            const l2 = t2.prev, u2 = t2.next;
            if (s2 ? $l(t2, n2, i2, s2) : Nl(t2)) e2.push(l2.i, t2.i, u2.i), ou(t2), t2 = u2.next, a2 = u2.next;
            else if ((t2 = u2) === a2) {
              o2 ? 1 === o2 ? Rl(t2 = Ul(Ol(t2), e2), e2, r2, n2, i2, s2, 2) : 2 === o2 && ql(t2, e2, r2, n2, i2, s2) : Rl(Ol(t2), e2, r2, n2, i2, s2, 1);
              break;
            }
          }
        }
        function Nl(t2) {
          const e2 = t2.prev, r2 = t2, n2 = t2.next;
          if (Jl(e2, r2, n2) >= 0) return false;
          const i2 = e2.x, s2 = r2.x, o2 = n2.x, a2 = e2.y, l2 = r2.y, u2 = n2.y, c2 = Math.min(i2, s2, o2), h2 = Math.min(a2, l2, u2), p2 = Math.max(i2, s2, o2), f2 = Math.max(a2, l2, u2);
          let d2 = n2.next;
          for (; d2 !== e2; ) {
            if (d2.x >= c2 && d2.x <= p2 && d2.y >= h2 && d2.y <= f2 && Kl(i2, a2, s2, l2, o2, u2, d2.x, d2.y) && Jl(d2.prev, d2, d2.next) >= 0) return false;
            d2 = d2.next;
          }
          return true;
        }
        function $l(t2, e2, r2, n2) {
          const i2 = t2.prev, s2 = t2, o2 = t2.next;
          if (Jl(i2, s2, o2) >= 0) return false;
          const a2 = i2.x, l2 = s2.x, u2 = o2.x, c2 = i2.y, h2 = s2.y, p2 = o2.y, f2 = Math.min(a2, l2, u2), d2 = Math.min(c2, h2, p2), y2 = Math.max(a2, l2, u2), m2 = Math.max(c2, h2, p2), g2 = Yl(f2, d2, e2, r2, n2), x2 = Yl(y2, m2, e2, r2, n2);
          let v2 = t2.prevZ, b2 = t2.nextZ;
          for (; v2 && v2.z >= g2 && b2 && b2.z <= x2; ) {
            if (v2.x >= f2 && v2.x <= y2 && v2.y >= d2 && v2.y <= m2 && v2 !== i2 && v2 !== o2 && Kl(a2, c2, l2, h2, u2, p2, v2.x, v2.y) && Jl(v2.prev, v2, v2.next) >= 0) return false;
            if (v2 = v2.prevZ, b2.x >= f2 && b2.x <= y2 && b2.y >= d2 && b2.y <= m2 && b2 !== i2 && b2 !== o2 && Kl(a2, c2, l2, h2, u2, p2, b2.x, b2.y) && Jl(b2.prev, b2, b2.next) >= 0) return false;
            b2 = b2.nextZ;
          }
          for (; v2 && v2.z >= g2; ) {
            if (v2.x >= f2 && v2.x <= y2 && v2.y >= d2 && v2.y <= m2 && v2 !== i2 && v2 !== o2 && Kl(a2, c2, l2, h2, u2, p2, v2.x, v2.y) && Jl(v2.prev, v2, v2.next) >= 0) return false;
            v2 = v2.prevZ;
          }
          for (; b2 && b2.z <= x2; ) {
            if (b2.x >= f2 && b2.x <= y2 && b2.y >= d2 && b2.y <= m2 && b2 !== i2 && b2 !== o2 && Kl(a2, c2, l2, h2, u2, p2, b2.x, b2.y) && Jl(b2.prev, b2, b2.next) >= 0) return false;
            b2 = b2.nextZ;
          }
          return true;
        }
        function Ul(t2, e2) {
          let r2 = t2;
          do {
            const n2 = r2.prev, i2 = r2.next.next;
            !Ql(n2, i2) && tu(n2, r2, r2.next, i2) && nu(n2, i2) && nu(i2, n2) && (e2.push(n2.i, r2.i, i2.i), ou(r2), ou(r2.next), r2 = t2 = i2), r2 = r2.next;
          } while (r2 !== t2);
          return Ol(r2);
        }
        function ql(t2, e2, r2, n2, i2, s2) {
          let o2 = t2;
          do {
            let t3 = o2.next.next;
            for (; t3 !== o2.prev; ) {
              if (o2.i !== t3.i && Wl(o2, t3)) {
                let a2 = iu(o2, t3);
                return o2 = Ol(o2, o2.next), a2 = Ol(a2, a2.next), Rl(o2, e2, r2, n2, i2, s2, 0), void Rl(a2, e2, r2, n2, i2, s2, 0);
              }
              t3 = t3.next;
            }
            o2 = o2.next;
          } while (o2 !== t2);
        }
        function jl(t2, e2) {
          let r2 = t2.x - e2.x;
          return 0 === r2 && (r2 = t2.y - e2.y, 0 === r2) && (r2 = (t2.next.y - t2.y) / (t2.next.x - t2.x) - (e2.next.y - e2.y) / (e2.next.x - e2.x)), r2;
        }
        function Gl(t2, e2) {
          const r2 = function(t3, e3) {
            let r3 = e3;
            const n3 = t3.x, i2 = t3.y;
            let s2, o2 = -1 / 0;
            if (Ql(t3, r3)) return r3;
            do {
              if (Ql(t3, r3.next)) return r3.next;
              if (i2 <= r3.y && i2 >= r3.next.y && r3.next.y !== r3.y) {
                const t4 = r3.x + (i2 - r3.y) * (r3.next.x - r3.x) / (r3.next.y - r3.y);
                if (t4 <= n3 && t4 > o2 && (o2 = t4, s2 = r3.x < r3.next.x ? r3 : r3.next, t4 === n3)) return s2;
              }
              r3 = r3.next;
            } while (r3 !== e3);
            if (!s2) return null;
            const a2 = s2, l2 = s2.x, u2 = s2.y;
            let c2 = 1 / 0;
            r3 = s2;
            do {
              if (n3 >= r3.x && r3.x >= l2 && n3 !== r3.x && Hl(i2 < u2 ? n3 : o2, i2, l2, u2, i2 < u2 ? o2 : n3, i2, r3.x, r3.y)) {
                const e4 = Math.abs(i2 - r3.y) / (n3 - r3.x);
                nu(r3, t3) && (e4 < c2 || e4 === c2 && (r3.x > s2.x || r3.x === s2.x && Xl(s2, r3))) && (s2 = r3, c2 = e4);
              }
              r3 = r3.next;
            } while (r3 !== a2);
            return s2;
          }(t2, e2);
          if (!r2) return e2;
          const n2 = iu(r2, t2);
          return Ol(n2, n2.next), Ol(r2, r2.next);
        }
        function Xl(t2, e2) {
          return Jl(t2.prev, t2, e2.prev) < 0 && Jl(e2.next, t2, t2.next) < 0;
        }
        function Yl(t2, e2, r2, n2, i2) {
          return (t2 = 1431655765 & ((t2 = 858993459 & ((t2 = 252645135 & ((t2 = 16711935 & ((t2 = (t2 - r2) * i2 | 0) | t2 << 8)) | t2 << 4)) | t2 << 2)) | t2 << 1)) | (e2 = 1431655765 & ((e2 = 858993459 & ((e2 = 252645135 & ((e2 = 16711935 & ((e2 = (e2 - n2) * i2 | 0) | e2 << 8)) | e2 << 4)) | e2 << 2)) | e2 << 1)) << 1;
        }
        function Zl(t2) {
          let e2 = t2, r2 = t2;
          do {
            (e2.x < r2.x || e2.x === r2.x && e2.y < r2.y) && (r2 = e2), e2 = e2.next;
          } while (e2 !== t2);
          return r2;
        }
        function Hl(t2, e2, r2, n2, i2, s2, o2, a2) {
          return (i2 - o2) * (e2 - a2) >= (t2 - o2) * (s2 - a2) && (t2 - o2) * (n2 - a2) >= (r2 - o2) * (e2 - a2) && (r2 - o2) * (s2 - a2) >= (i2 - o2) * (n2 - a2);
        }
        function Kl(t2, e2, r2, n2, i2, s2, o2, a2) {
          return !(t2 === o2 && e2 === a2) && Hl(t2, e2, r2, n2, i2, s2, o2, a2);
        }
        function Wl(t2, e2) {
          return t2.next.i !== e2.i && t2.prev.i !== e2.i && !function(t3, e3) {
            let r2 = t3;
            do {
              if (r2.i !== t3.i && r2.next.i !== t3.i && r2.i !== e3.i && r2.next.i !== e3.i && tu(r2, r2.next, t3, e3)) return true;
              r2 = r2.next;
            } while (r2 !== t3);
            return false;
          }(t2, e2) && (nu(t2, e2) && nu(e2, t2) && function(t3, e3) {
            let r2 = t3, n2 = false;
            const i2 = (t3.x + e3.x) / 2, s2 = (t3.y + e3.y) / 2;
            do {
              r2.y > s2 != r2.next.y > s2 && r2.next.y !== r2.y && i2 < (r2.next.x - r2.x) * (s2 - r2.y) / (r2.next.y - r2.y) + r2.x && (n2 = !n2), r2 = r2.next;
            } while (r2 !== t3);
            return n2;
          }(t2, e2) && (Jl(t2.prev, t2, e2.prev) || Jl(t2, e2.prev, e2)) || Ql(t2, e2) && Jl(t2.prev, t2, t2.next) > 0 && Jl(e2.prev, e2, e2.next) > 0);
        }
        function Jl(t2, e2, r2) {
          return (e2.y - t2.y) * (r2.x - e2.x) - (e2.x - t2.x) * (r2.y - e2.y);
        }
        function Ql(t2, e2) {
          return t2.x === e2.x && t2.y === e2.y;
        }
        function tu(t2, e2, r2, n2) {
          const i2 = ru(Jl(t2, e2, r2)), s2 = ru(Jl(t2, e2, n2)), o2 = ru(Jl(r2, n2, t2)), a2 = ru(Jl(r2, n2, e2));
          return i2 !== s2 && o2 !== a2 || !(0 !== i2 || !eu(t2, r2, e2)) || !(0 !== s2 || !eu(t2, n2, e2)) || !(0 !== o2 || !eu(r2, t2, n2)) || !(0 !== a2 || !eu(r2, e2, n2));
        }
        function eu(t2, e2, r2) {
          return e2.x <= Math.max(t2.x, r2.x) && e2.x >= Math.min(t2.x, r2.x) && e2.y <= Math.max(t2.y, r2.y) && e2.y >= Math.min(t2.y, r2.y);
        }
        function ru(t2) {
          return t2 > 0 ? 1 : t2 < 0 ? -1 : 0;
        }
        function nu(t2, e2) {
          return Jl(t2.prev, t2, t2.next) < 0 ? Jl(t2, e2, t2.next) >= 0 && Jl(t2, t2.prev, e2) >= 0 : Jl(t2, e2, t2.prev) < 0 || Jl(t2, t2.next, e2) < 0;
        }
        function iu(t2, e2) {
          const r2 = au(t2.i, t2.x, t2.y), n2 = au(e2.i, e2.x, e2.y), i2 = t2.next, s2 = e2.prev;
          return t2.next = e2, e2.prev = t2, r2.next = i2, i2.prev = r2, n2.next = r2, r2.prev = n2, s2.next = n2, n2.prev = s2, n2;
        }
        function su(t2, e2, r2, n2) {
          const i2 = au(t2, e2, r2);
          return n2 ? (i2.next = n2.next, i2.prev = n2, n2.next.prev = i2, n2.next = i2) : (i2.prev = i2, i2.next = i2), i2;
        }
        function ou(t2) {
          t2.next.prev = t2.prev, t2.prev.next = t2.next, t2.prevZ && (t2.prevZ.nextZ = t2.nextZ), t2.nextZ && (t2.nextZ.prevZ = t2.prevZ);
        }
        function au(t2, e2, r2) {
          return { i: t2, x: e2, y: r2, prev: null, next: null, z: 0, prevZ: null, nextZ: null, steiner: false };
        }
        class lu {
          constructor(t2, e2) {
            if (e2 > t2) throw new Error("Min granularity must not be greater than base granularity.");
            this._baseZoomGranularity = t2, this._minGranularity = e2;
          }
          getGranularityForZoomLevel(t2) {
            return Math.max(Math.floor(this._baseZoomGranularity / (1 << t2)), this._minGranularity, 1);
          }
        }
        class uu {
          constructor(t2) {
            this.fill = t2.fill, this.line = t2.line, this.tile = t2.tile, this.stencil = t2.stencil, this.circle = t2.circle;
          }
        }
        uu.noSubdivision = new uu({ fill: new lu(0, 0), line: new lu(0, 0), tile: new lu(0, 0), stencil: new lu(0, 0), circle: 1 }), us("SubdivisionGranularityExpression", lu), us("SubdivisionGranularitySetting", uu);
        const cu = -32768, hu = 32767;
        class pu {
          constructor(t2, e2) {
            this._vertexBuffer = [], this._vertexDictionary = /* @__PURE__ */ new Map(), this._used = false, this._granularity = t2, this._granularityCellSize = M / t2, this._canonical = e2;
          }
          _getKey(t2, e2) {
            return (t2 += 32768) << 16 | e2 + 32768;
          }
          _vertexToIndex(t2, e2) {
            if (t2 < -32768 || e2 < -32768 || t2 > 32767 || e2 > 32767) throw new Error("Vertex coordinates are out of signed 16 bit integer range.");
            const r2 = 0 | Math.round(t2), n2 = 0 | Math.round(e2), i2 = this._getKey(r2, n2);
            if (this._vertexDictionary.has(i2)) return this._vertexDictionary.get(i2);
            const s2 = this._vertexBuffer.length / 2;
            return this._vertexDictionary.set(i2, s2), this._vertexBuffer.push(r2, n2), s2;
          }
          _subdivideTrianglesScanline(t2) {
            if (this._granularity < 2) return function(t3, e3) {
              const r3 = [];
              for (let n2 = 0; n2 < e3.length; n2 += 3) {
                const i2 = e3[n2], s2 = e3[n2 + 1], o2 = e3[n2 + 2], a2 = t3[2 * i2], l2 = t3[2 * i2 + 1];
                (t3[2 * s2] - a2) * (t3[2 * o2 + 1] - l2) - (t3[2 * s2 + 1] - l2) * (t3[2 * o2] - a2) > 0 ? (r3.push(i2), r3.push(o2), r3.push(s2)) : (r3.push(i2), r3.push(s2), r3.push(o2));
              }
              return r3;
            }(this._vertexBuffer, t2);
            const e2 = [], r2 = t2.length;
            for (let n2 = 0; n2 < r2; n2 += 3) {
              const r3 = [t2[n2 + 0], t2[n2 + 1], t2[n2 + 2]], i2 = [this._vertexBuffer[2 * t2[n2 + 0] + 0], this._vertexBuffer[2 * t2[n2 + 0] + 1], this._vertexBuffer[2 * t2[n2 + 1] + 0], this._vertexBuffer[2 * t2[n2 + 1] + 1], this._vertexBuffer[2 * t2[n2 + 2] + 0], this._vertexBuffer[2 * t2[n2 + 2] + 1]];
              let s2 = 1 / 0, o2 = 1 / 0, a2 = -1 / 0, l2 = -1 / 0;
              for (let t3 = 0; t3 < 3; t3++) {
                const e3 = i2[2 * t3], r4 = i2[2 * t3 + 1];
                s2 = Math.min(s2, e3), a2 = Math.max(a2, e3), o2 = Math.min(o2, r4), l2 = Math.max(l2, r4);
              }
              if (s2 === a2 || o2 === l2) continue;
              const u2 = Math.floor(s2 / this._granularityCellSize), c2 = Math.ceil(a2 / this._granularityCellSize), h2 = Math.floor(o2 / this._granularityCellSize), p2 = Math.ceil(l2 / this._granularityCellSize);
              if (u2 !== c2 || h2 !== p2) for (let t3 = h2; t3 < p2; t3++) {
                const n3 = this._scanlineGenerateVertexRingForCellRow(t3, i2, r3);
                yu(this._vertexBuffer, n3, e2);
              }
              else e2.push(...r3);
            }
            return e2;
          }
          _scanlineGenerateVertexRingForCellRow(t2, e2, r2) {
            const n2 = t2 * this._granularityCellSize, i2 = n2 + this._granularityCellSize, s2 = [];
            for (let t3 = 0; t3 < 3; t3++) {
              const o2 = e2[2 * t3], a2 = e2[2 * t3 + 1], l2 = e2[2 * (t3 + 1) % 6], u2 = e2[(2 * (t3 + 1) + 1) % 6], c2 = e2[2 * (t3 + 2) % 6], h2 = e2[(2 * (t3 + 2) + 1) % 6], p2 = l2 - o2, f2 = u2 - a2, d2 = 0 === p2, y2 = 0 === f2, m2 = (n2 - a2) / f2, g2 = (i2 - a2) / f2, x2 = Math.min(m2, g2), v2 = Math.max(m2, g2);
              if (!y2 && (x2 >= 1 || v2 <= 0) || y2 && (a2 < n2 || a2 > i2)) {
                u2 >= n2 && u2 <= i2 && s2.push(r2[(t3 + 1) % 3]);
                continue;
              }
              !y2 && x2 > 0 && s2.push(this._vertexToIndex(o2 + p2 * x2, a2 + f2 * x2));
              const b2 = o2 + p2 * Math.max(x2, 0), w2 = o2 + p2 * Math.min(v2, 1);
              d2 || this._generateIntraEdgeVertices(s2, o2, a2, l2, u2, b2, w2), !y2 && v2 < 1 && s2.push(this._vertexToIndex(o2 + p2 * v2, a2 + f2 * v2)), (y2 || u2 >= n2 && u2 <= i2) && s2.push(r2[(t3 + 1) % 3]), !y2 && (u2 <= n2 || u2 >= i2) && this._generateInterEdgeVertices(s2, o2, a2, l2, u2, c2, h2, w2, n2, i2);
            }
            return s2;
          }
          _generateIntraEdgeVertices(t2, e2, r2, n2, i2, s2, o2) {
            const a2 = n2 - e2, l2 = i2 - r2, u2 = 0 === l2, c2 = u2 ? Math.min(e2, n2) : Math.min(s2, o2), h2 = u2 ? Math.max(e2, n2) : Math.max(s2, o2), p2 = Math.floor(c2 / this._granularityCellSize) + 1, f2 = Math.ceil(h2 / this._granularityCellSize) - 1;
            if (u2 ? e2 < n2 : s2 < o2) for (let n3 = p2; n3 <= f2; n3++) {
              const i3 = n3 * this._granularityCellSize;
              t2.push(this._vertexToIndex(i3, r2 + l2 * (i3 - e2) / a2));
            }
            else for (let n3 = f2; n3 >= p2; n3--) {
              const i3 = n3 * this._granularityCellSize;
              t2.push(this._vertexToIndex(i3, r2 + l2 * (i3 - e2) / a2));
            }
          }
          _generateInterEdgeVertices(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2) {
            const c2 = i2 - r2, h2 = s2 - n2, p2 = o2 - i2, f2 = (l2 - i2) / p2, d2 = (u2 - i2) / p2, y2 = Math.min(f2, d2), m2 = Math.max(f2, d2), g2 = n2 + h2 * y2;
            let x2 = Math.floor(Math.min(g2, a2) / this._granularityCellSize) + 1, v2 = Math.ceil(Math.max(g2, a2) / this._granularityCellSize) - 1, b2 = a2 < g2;
            const w2 = 0 === p2;
            if (w2 && (o2 === l2 || o2 === u2)) return;
            if (w2 || y2 >= 1 || m2 <= 0) {
              const t3 = r2 - o2, n3 = s2 + (e2 - s2) * Math.min((l2 - o2) / t3, (u2 - o2) / t3);
              x2 = Math.floor(Math.min(n3, a2) / this._granularityCellSize) + 1, v2 = Math.ceil(Math.max(n3, a2) / this._granularityCellSize) - 1, b2 = a2 < n3;
            }
            const _2 = c2 > 0 ? u2 : l2;
            if (b2) for (let e3 = x2; e3 <= v2; e3++) t2.push(this._vertexToIndex(e3 * this._granularityCellSize, _2));
            else for (let e3 = v2; e3 >= x2; e3--) t2.push(this._vertexToIndex(e3 * this._granularityCellSize, _2));
          }
          _generateOutline(t2) {
            const e2 = [];
            for (const r2 of t2) {
              const t3 = du(r2, this._granularity, true), n2 = this._pointArrayToIndices(t3), i2 = [];
              for (let t4 = 1; t4 < n2.length; t4++) i2.push(n2[t4 - 1]), i2.push(n2[t4]);
              e2.push(i2);
            }
            return e2;
          }
          _handlePoles(t2) {
            let e2 = false, r2 = false;
            this._canonical && (0 === this._canonical.y && (e2 = true), this._canonical.y === (1 << this._canonical.z) - 1 && (r2 = true)), (e2 || r2) && this._fillPoles(t2, e2, r2);
          }
          _ensureNoPoleVertices() {
            const t2 = this._vertexBuffer;
            for (let e2 = 0; e2 < t2.length; e2 += 2) {
              const r2 = t2[e2 + 1];
              r2 === cu && (t2[e2 + 1] = -32767), r2 === hu && (t2[e2 + 1] = 32766);
            }
          }
          _generatePoleQuad(t2, e2, r2, n2, i2, s2) {
            n2 > i2 != (s2 === cu) ? (t2.push(e2), t2.push(r2), t2.push(this._vertexToIndex(n2, s2)), t2.push(r2), t2.push(this._vertexToIndex(i2, s2)), t2.push(this._vertexToIndex(n2, s2))) : (t2.push(r2), t2.push(e2), t2.push(this._vertexToIndex(n2, s2)), t2.push(this._vertexToIndex(i2, s2)), t2.push(r2), t2.push(this._vertexToIndex(n2, s2)));
          }
          _fillPoles(t2, e2, r2) {
            const n2 = this._vertexBuffer, i2 = M, s2 = t2.length;
            for (let o2 = 2; o2 < s2; o2 += 3) {
              const s3 = t2[o2 - 2], a2 = t2[o2 - 1], l2 = t2[o2], u2 = n2[2 * s3], c2 = n2[2 * s3 + 1], h2 = n2[2 * a2], p2 = n2[2 * a2 + 1], f2 = n2[2 * l2], d2 = n2[2 * l2 + 1];
              e2 && (0 === c2 && 0 === p2 && this._generatePoleQuad(t2, s3, a2, u2, h2, cu), 0 === p2 && 0 === d2 && this._generatePoleQuad(t2, a2, l2, h2, f2, cu), 0 === d2 && 0 === c2 && this._generatePoleQuad(t2, l2, s3, f2, u2, cu)), r2 && (c2 === i2 && p2 === i2 && this._generatePoleQuad(t2, s3, a2, u2, h2, hu), p2 === i2 && d2 === i2 && this._generatePoleQuad(t2, a2, l2, h2, f2, hu), d2 === i2 && c2 === i2 && this._generatePoleQuad(t2, l2, s3, f2, u2, hu));
            }
          }
          _initializeVertices(t2) {
            for (let e2 = 0; e2 < t2.length; e2 += 2) this._vertexToIndex(t2[e2], t2[e2 + 1]);
          }
          subdividePolygonInternal(t2, e2) {
            if (this._used) throw new Error("Subdivision: multiple use not allowed.");
            this._used = true;
            const { flattened: r2, holeIndices: n2 } = function(t3) {
              const e3 = [], r3 = [];
              for (const n3 of t3) if (0 !== n3.length) {
                n3 !== t3[0] && e3.push(r3.length / 2);
                for (let t4 = 0; t4 < n3.length; t4++) r3.push(n3[t4].x), r3.push(n3[t4].y);
              }
              return { flattened: r3, holeIndices: e3 };
            }(t2);
            let i2;
            this._initializeVertices(r2);
            try {
              const t3 = function(t4, e4, r3 = 2) {
                const n3 = e4 && e4.length, i3 = n3 ? e4[0] * r3 : t4.length;
                let s3 = Ll(t4, 0, i3, r3, true);
                const o2 = [];
                if (!s3 || s3.next === s3.prev) return o2;
                let a2, l2, u2;
                if (n3 && (s3 = function(t5, e5, r4, n4) {
                  const i4 = [];
                  for (let r5 = 0, s4 = e5.length; r5 < s4; r5++) {
                    const o3 = Ll(t5, e5[r5] * n4, r5 < s4 - 1 ? e5[r5 + 1] * n4 : t5.length, n4, false);
                    o3 === o3.next && (o3.steiner = true), i4.push(Zl(o3));
                  }
                  i4.sort(jl);
                  for (let t6 = 0; t6 < i4.length; t6++) r4 = Gl(i4[t6], r4);
                  return r4;
                }(t4, e4, s3, r3)), t4.length > 80 * r3) {
                  a2 = t4[0], l2 = t4[1];
                  let e5 = a2, n4 = l2;
                  for (let s4 = r3; s4 < i3; s4 += r3) {
                    const r4 = t4[s4], i4 = t4[s4 + 1];
                    r4 < a2 && (a2 = r4), i4 < l2 && (l2 = i4), r4 > e5 && (e5 = r4), i4 > n4 && (n4 = i4);
                  }
                  u2 = Math.max(e5 - a2, n4 - l2), u2 = 0 !== u2 ? 32767 / u2 : 0;
                }
                return Rl(s3, o2, r3, a2, l2, u2, 0), o2;
              }(r2, n2), e3 = this._convertIndices(r2, t3);
              i2 = this._subdivideTrianglesScanline(e3);
            } catch (t3) {
              console.error(t3);
            }
            let s2 = [];
            return e2 && (s2 = this._generateOutline(t2)), this._ensureNoPoleVertices(), this._handlePoles(i2), { verticesFlattened: this._vertexBuffer, indicesTriangles: i2, indicesLineList: s2 };
          }
          _convertIndices(t2, e2) {
            const r2 = [];
            for (let n2 = 0; n2 < e2.length; n2++) r2.push(this._vertexToIndex(t2[2 * e2[n2]], t2[2 * e2[n2] + 1]));
            return r2;
          }
          _pointArrayToIndices(t2) {
            const e2 = [];
            for (let r2 = 0; r2 < t2.length; r2++) {
              const n2 = t2[r2];
              e2.push(this._vertexToIndex(n2.x, n2.y));
            }
            return e2;
          }
        }
        function fu(t2, e2, r2, n2 = true) {
          return new pu(r2, e2).subdividePolygonInternal(t2, n2);
        }
        function du(t2, e2, n2 = false) {
          if (!t2 || t2.length < 1) return [];
          if (t2.length < 2) return [];
          const i2 = t2[0], s2 = t2[t2.length - 1], o2 = n2 && (i2.x !== s2.x || i2.y !== s2.y);
          if (e2 < 2) return o2 ? [...t2, t2[0]] : [...t2];
          const a2 = Math.floor(M / e2), l2 = [];
          l2.push(new r(t2[0].x, t2[0].y));
          const u2 = t2.length, c2 = o2 ? u2 : u2 - 1;
          for (let e3 = 0; e3 < c2; e3++) {
            const n3 = t2[e3], i3 = e3 < u2 - 1 ? t2[e3 + 1] : t2[0], s3 = n3.x, o3 = n3.y, c3 = i3.x, h2 = i3.y, p2 = s3 !== c3, f2 = o3 !== h2;
            if (!p2 && !f2) continue;
            const d2 = c3 - s3, y2 = h2 - o3, m2 = Math.abs(d2), g2 = Math.abs(y2);
            let x2 = s3, v2 = o3;
            for (; ; ) {
              const t3 = d2 > 0 ? (Math.floor(x2 / a2) + 1) * a2 : (Math.ceil(x2 / a2) - 1) * a2, e4 = y2 > 0 ? (Math.floor(v2 / a2) + 1) * a2 : (Math.ceil(v2 / a2) - 1) * a2, n4 = Math.abs(x2 - t3), i4 = Math.abs(v2 - e4), s4 = Math.abs(x2 - c3), o4 = Math.abs(v2 - h2), u3 = p2 ? n4 / m2 : Number.POSITIVE_INFINITY, b3 = f2 ? i4 / g2 : Number.POSITIVE_INFINITY;
              if ((s4 <= n4 || !p2) && (o4 <= i4 || !f2)) break;
              if (u3 < b3 && p2 || !f2) {
                x2 = t3, v2 += y2 * u3;
                const e5 = new r(x2, Math.round(v2));
                l2[l2.length - 1].x === e5.x && l2[l2.length - 1].y === e5.y || l2.push(e5);
              } else {
                x2 += d2 * b3, v2 = e4;
                const t4 = new r(Math.round(x2), v2);
                l2[l2.length - 1].x === t4.x && l2[l2.length - 1].y === t4.y || l2.push(t4);
              }
            }
            const b2 = new r(c3, h2);
            l2[l2.length - 1].x === b2.x && l2[l2.length - 1].y === b2.y || l2.push(b2);
          }
          return l2;
        }
        function yu(t2, e2, r2) {
          if (0 === e2.length) throw new Error("Subdivision vertex ring is empty.");
          let n2 = 0, i2 = t2[2 * e2[0]];
          for (let r3 = 1; r3 < e2.length; r3++) {
            const s3 = t2[2 * e2[r3]];
            s3 < i2 && (i2 = s3, n2 = r3);
          }
          const s2 = e2.length;
          let o2 = n2, a2 = (o2 + 1) % s2;
          for (; ; ) {
            const n3 = o2 - 1 >= 0 ? o2 - 1 : s2 - 1, i3 = (a2 + 1) % s2, l2 = t2[2 * e2[n3]], u2 = t2[2 * e2[i3]], c2 = t2[2 * e2[o2]], h2 = t2[2 * e2[o2] + 1], p2 = t2[2 * e2[a2] + 1];
            let f2 = false;
            if (l2 < u2) f2 = true;
            else if (l2 > u2) f2 = false;
            else {
              const r3 = p2 - h2, s3 = -(t2[2 * e2[a2]] - c2), o3 = h2 < p2 ? 1 : -1;
              ((l2 - c2) * r3 + (t2[2 * e2[n3] + 1] - h2) * s3) * o3 > ((u2 - c2) * r3 + (t2[2 * e2[i3] + 1] - h2) * s3) * o3 && (f2 = true);
            }
            if (f2) {
              const t3 = e2[n3], i4 = e2[o2], l3 = e2[a2];
              t3 !== i4 && t3 !== l3 && i4 !== l3 && r2.push(l3, i4, t3), o2--, o2 < 0 && (o2 = s2 - 1);
            } else {
              const t3 = e2[i3], n4 = e2[o2], l3 = e2[a2];
              t3 !== n4 && t3 !== l3 && n4 !== l3 && r2.push(l3, n4, t3), a2++, a2 >= s2 && (a2 = 0);
            }
            if (n3 === i3) break;
          }
        }
        function mu(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
          const u2 = i2.length / 2, c2 = o2 && a2 && l2;
          if (u2 < ra.MAX_VERTEX_ARRAY_LENGTH) {
            const h2 = e2.prepareSegment(u2, r2, n2), p2 = h2.vertexLength;
            for (let t3 = 0; t3 < s2.length; t3 += 3) n2.emplaceBack(p2 + s2[t3], p2 + s2[t3 + 1], p2 + s2[t3 + 2]);
            let f2, d2;
            h2.vertexLength += u2, h2.primitiveLength += s2.length / 3, c2 && (d2 = o2.prepareSegment(u2, r2, a2), f2 = d2.vertexLength, d2.vertexLength += u2);
            for (let e3 = 0; e3 < i2.length; e3 += 2) t2(i2[e3], i2[e3 + 1]);
            if (c2) for (let t3 = 0; t3 < l2.length; t3++) {
              const e3 = l2[t3];
              for (let t4 = 1; t4 < e3.length; t4 += 2) a2.emplaceBack(f2 + e3[t4 - 1], f2 + e3[t4]);
              d2.primitiveLength += e3.length / 2;
            }
          } else !function(t3, e3, r3, n3, i3, s3) {
            const o3 = [];
            for (let t4 = 0; t4 < n3.length / 2; t4++) o3.push(-1);
            const a3 = { count: 0 };
            let l3 = 0, u3 = t3.getOrCreateLatestSegment(e3, r3), c3 = u3.vertexLength;
            for (let h2 = 2; h2 < i3.length; h2 += 3) {
              const p2 = i3[h2 - 2], f2 = i3[h2 - 1], d2 = i3[h2];
              let y2 = o3[p2] < l3, m2 = o3[f2] < l3, g2 = o3[d2] < l3;
              u3.vertexLength + ((y2 ? 1 : 0) + (m2 ? 1 : 0) + (g2 ? 1 : 0)) > ra.MAX_VERTEX_ARRAY_LENGTH && (u3 = t3.createNewSegment(e3, r3), l3 = a3.count, y2 = true, m2 = true, g2 = true, c3 = 0);
              const x2 = gu(o3, n3, s3, a3, p2, y2, u3), v2 = gu(o3, n3, s3, a3, f2, m2, u3), b2 = gu(o3, n3, s3, a3, d2, g2, u3);
              r3.emplaceBack(c3 + x2 - l3, c3 + v2 - l3, c3 + b2 - l3), u3.primitiveLength++;
            }
          }(e2, r2, n2, i2, s2, t2), c2 && function(t3, e3, r3, n3, i3, s3) {
            const o3 = [];
            for (let t4 = 0; t4 < n3.length / 2; t4++) o3.push(-1);
            const a3 = { count: 0 };
            let l3 = 0, u3 = t3.getOrCreateLatestSegment(e3, r3), c3 = u3.vertexLength;
            for (let h2 = 0; h2 < i3.length; h2++) {
              const p2 = i3[h2];
              for (let f2 = 1; f2 < i3[h2].length; f2 += 2) {
                const i4 = p2[f2 - 1], h3 = p2[f2];
                let d2 = o3[i4] < l3, y2 = o3[h3] < l3;
                u3.vertexLength + ((d2 ? 1 : 0) + (y2 ? 1 : 0)) > ra.MAX_VERTEX_ARRAY_LENGTH && (u3 = t3.createNewSegment(e3, r3), l3 = a3.count, d2 = true, y2 = true, c3 = 0);
                const m2 = gu(o3, n3, s3, a3, i4, d2, u3), g2 = gu(o3, n3, s3, a3, h3, y2, u3);
                r3.emplaceBack(c3 + m2 - l3, c3 + g2 - l3), u3.primitiveLength++;
              }
            }
          }(o2, r2, a2, i2, l2, t2), e2.forceNewSegmentOnNextPrepare(), null == o2 || o2.forceNewSegmentOnNextPrepare();
        }
        function gu(t2, e2, r2, n2, i2, s2, o2) {
          if (s2) {
            const s3 = n2.count;
            return r2(e2[2 * i2], e2[2 * i2 + 1]), t2[i2] = n2.count, n2.count++, o2.vertexLength++, s3;
          }
          return t2[i2];
        }
        class xu {
          constructor(t2) {
            this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.id), this.index = t2.index, this.hasDependencies = false, this.patternFeatures = [], this.layoutVertexArray = new $o(), this.indexArray = new Jo(), this.indexArray2 = new Qo(), this.programConfigurations = new Pa(t2.layers, t2.zoom), this.segments = new ra(), this.segments2 = new ra(), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id);
          }
          populate(t2, e2, r2) {
            this.hasDependencies = Vl("fill", this.layers, e2);
            const n2 = this.layers[0].layout.get("fill-sort-key"), i2 = !n2.isConstant(), s2 = [];
            for (const { feature: o2, id: a2, index: l2, sourceLayerIndex: u2 } of t2) {
              const t3 = this.layers[0]._featureFilter.needGeometry, c2 = Oa(o2, t3);
              if (!this.layers[0]._featureFilter.filter(new Fs(this.zoom), c2, r2)) continue;
              const h2 = i2 ? n2.evaluate(c2, {}, r2, e2.availableImages) : void 0, p2 = { id: a2, properties: o2.properties, type: o2.type, sourceLayerIndex: u2, index: l2, geometry: t3 ? c2.geometry : La(o2), patterns: {}, sortKey: h2 };
              s2.push(p2);
            }
            i2 && s2.sort((t3, e3) => t3.sortKey - e3.sortKey);
            for (const n3 of s2) {
              const { geometry: i3, index: s3, sourceLayerIndex: o2 } = n3;
              if (this.hasDependencies) {
                const t3 = Cl("fill", this.layers, n3, { zoom: this.zoom }, e2);
                this.patternFeatures.push(t3);
              } else this.addFeature(n3, i3, s3, r2, {}, e2.subdivisionGranularity);
              e2.featureIndex.insert(t2[s3].feature, i3, s3, o2, this.index);
            }
          }
          update(t2, e2, r2) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t2, e2, this.stateDependentLayers, { imagePositions: r2 });
          }
          addFeatures(t2, e2, r2) {
            for (const n2 of this.patternFeatures) this.addFeature(n2, n2.geometry, n2.index, e2, r2, t2.subdivisionGranularity);
          }
          isEmpty() {
            return 0 === this.layoutVertexArray.length;
          }
          uploadPending() {
            return !this.uploaded || this.programConfigurations.needsUpload;
          }
          upload(t2) {
            this.uploaded || (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, Bl), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.indexBuffer2 = t2.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t2), this.uploaded = true;
          }
          destroy() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
          }
          addFeature(t2, e2, r2, n2, i2, s2) {
            for (const t3 of tn(e2, 500)) {
              const e3 = fu(t3, n2, s2.fill.getGranularityForZoomLevel(n2.z)), r3 = this.layoutVertexArray;
              mu((t4, e4) => {
                r3.emplaceBack(t4, e4);
              }, this.segments, this.layoutVertexArray, this.indexArray, e3.verticesFlattened, e3.indicesTriangles, this.segments2, this.indexArray2, e3.indicesLineList);
            }
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, { imagePositions: i2, canonical: n2 });
          }
        }
        let vu, bu;
        us("FillBucket", xu, { omit: ["layers", "patternFeatures"] });
        var wu = { get paint() {
          return bu = bu || new Xs({ "fill-antialias": new $s(vt.paint_fill["fill-antialias"]), "fill-opacity": new Us(vt.paint_fill["fill-opacity"]), "fill-color": new Us(vt.paint_fill["fill-color"]), "fill-outline-color": new Us(vt.paint_fill["fill-outline-color"]), "fill-translate": new $s(vt.paint_fill["fill-translate"]), "fill-translate-anchor": new $s(vt.paint_fill["fill-translate-anchor"]), "fill-pattern": new qs(vt.paint_fill["fill-pattern"]) });
        }, get layout() {
          return vu = vu || new Xs({ "fill-sort-key": new Us(vt.layout_fill["fill-sort-key"]) });
        } };
        class _u extends Ys {
          constructor(t2, e2) {
            super(t2, wu, e2);
          }
          recalculate(t2, e2) {
            super.recalculate(t2, e2);
            const r2 = this.paint._values["fill-outline-color"];
            "constant" === r2.value.kind && void 0 === r2.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
          }
          createBucket(t2) {
            return new xu(t2);
          }
          queryRadius() {
            return tl(this.paint.get("fill-translate"));
          }
          queryIntersectsFeature({ queryGeometry: t2, geometry: e2, transform: r2, pixelsToTileUnits: n2 }) {
            return ja(el(t2, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), -r2.bearingInRadians, n2), e2);
          }
          isTileClipped() {
            return true;
          }
        }
        const Au = to([{ name: "a_pos", components: 2, type: "Int16" }, { name: "a_normal_ed", components: 4, type: "Int16" }], 4), Su = to([{ name: "a_centroid", components: 2, type: "Int16" }], 4), { members: ku } = Au;
        class Eu {
          constructor(t2, e2, r2, n2, i2) {
            this.properties = {}, this.extent = r2, this.type = 0, this.id = void 0, this._pbf = t2, this._geometry = -1, this._keys = n2, this._values = i2, t2.readFields(Tu, this, e2);
          }
          loadGeometry() {
            const t2 = this._pbf;
            t2.pos = this._geometry;
            const e2 = t2.readVarint() + t2.pos, n2 = [];
            let i2, s2 = 1, o2 = 0, a2 = 0, l2 = 0;
            for (; t2.pos < e2; ) {
              if (o2 <= 0) {
                const e3 = t2.readVarint();
                s2 = 7 & e3, o2 = e3 >> 3;
              }
              if (o2--, 1 === s2 || 2 === s2) a2 += t2.readSVarint(), l2 += t2.readSVarint(), 1 === s2 && (i2 && n2.push(i2), i2 = []), i2 && i2.push(new r(a2, l2));
              else {
                if (7 !== s2) throw new Error(`unknown command ${s2}`);
                i2 && i2.push(i2[0].clone());
              }
            }
            return i2 && n2.push(i2), n2;
          }
          bbox() {
            const t2 = this._pbf;
            t2.pos = this._geometry;
            const e2 = t2.readVarint() + t2.pos;
            let r2 = 1, n2 = 0, i2 = 0, s2 = 0, o2 = 1 / 0, a2 = -1 / 0, l2 = 1 / 0, u2 = -1 / 0;
            for (; t2.pos < e2; ) {
              if (n2 <= 0) {
                const e3 = t2.readVarint();
                r2 = 7 & e3, n2 = e3 >> 3;
              }
              if (n2--, 1 === r2 || 2 === r2) i2 += t2.readSVarint(), s2 += t2.readSVarint(), i2 < o2 && (o2 = i2), i2 > a2 && (a2 = i2), s2 < l2 && (l2 = s2), s2 > u2 && (u2 = s2);
              else if (7 !== r2) throw new Error(`unknown command ${r2}`);
            }
            return [o2, l2, a2, u2];
          }
          toGeoJSON(t2, e2, r2) {
            const n2 = this.extent * Math.pow(2, r2), i2 = this.extent * t2, s2 = this.extent * e2, o2 = this.loadGeometry();
            function a2(t3) {
              return [360 * (t3.x + i2) / n2 - 180, 360 / Math.PI * Math.atan(Math.exp((1 - 2 * (t3.y + s2) / n2) * Math.PI)) - 90];
            }
            function l2(t3) {
              return t3.map(a2);
            }
            let u2;
            if (1 === this.type) {
              const t3 = [];
              for (const e4 of o2) t3.push(e4[0]);
              const e3 = l2(t3);
              u2 = 1 === t3.length ? { type: "Point", coordinates: e3[0] } : { type: "MultiPoint", coordinates: e3 };
            } else if (2 === this.type) {
              const t3 = o2.map(l2);
              u2 = 1 === t3.length ? { type: "LineString", coordinates: t3[0] } : { type: "MultiLineString", coordinates: t3 };
            } else {
              if (3 !== this.type) throw new Error("unknown feature type");
              {
                const t3 = Iu(o2), e3 = [];
                for (const r3 of t3) e3.push(r3.map(l2));
                u2 = 1 === e3.length ? { type: "Polygon", coordinates: e3[0] } : { type: "MultiPolygon", coordinates: e3 };
              }
            }
            const c2 = { type: "Feature", geometry: u2, properties: this.properties };
            return null != this.id && (c2.id = this.id), c2;
          }
        }
        function Tu(t2, e2, r2) {
          1 === t2 ? e2.id = r2.readVarint() : 2 === t2 ? function(t3, e3) {
            const r3 = t3.readVarint() + t3.pos;
            for (; t3.pos < r3; ) {
              const r4 = e3._keys[t3.readVarint()], n2 = e3._values[t3.readVarint()];
              e3.properties[r4] = n2;
            }
          }(r2, e2) : 3 === t2 ? e2.type = r2.readVarint() : 4 === t2 && (e2._geometry = r2.pos);
        }
        function Iu(t2) {
          const e2 = t2.length;
          if (e2 <= 1) return [t2];
          const r2 = [];
          let n2, i2;
          for (let s2 = 0; s2 < e2; s2++) {
            const e3 = Mu(t2[s2]);
            0 !== e3 && (void 0 === i2 && (i2 = e3 < 0), i2 === e3 < 0 ? (n2 && r2.push(n2), n2 = [t2[s2]]) : n2 && n2.push(t2[s2]));
          }
          return n2 && r2.push(n2), r2;
        }
        function Mu(t2) {
          let e2 = 0;
          for (let r2, n2, i2 = 0, s2 = t2.length, o2 = s2 - 1; i2 < s2; o2 = i2++) r2 = t2[i2], n2 = t2[o2], e2 += (n2.x - r2.x) * (r2.y + n2.y);
          return e2;
        }
        Eu.types = ["Unknown", "Point", "LineString", "Polygon"];
        class Fu {
          constructor(t2, e2) {
            this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = t2, this._keys = [], this._values = [], this._features = [], t2.readFields(Du, this, e2), this.length = this._features.length;
          }
          feature(t2) {
            if (t2 < 0 || t2 >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[t2];
            const e2 = this._pbf.readVarint() + this._pbf.pos;
            return new Eu(this._pbf, e2, this.extent, this._keys, this._values);
          }
        }
        function Du(t2, e2, r2) {
          15 === t2 ? e2.version = r2.readVarint() : 1 === t2 ? e2.name = r2.readString() : 5 === t2 ? e2.extent = r2.readVarint() : 2 === t2 ? e2._features.push(r2.pos) : 3 === t2 ? e2._keys.push(r2.readString()) : 4 === t2 && e2._values.push(function(t3) {
            let e3 = null;
            const r3 = t3.readVarint() + t3.pos;
            for (; t3.pos < r3; ) {
              const r4 = t3.readVarint() >> 3;
              e3 = 1 === r4 ? t3.readString() : 2 === r4 ? t3.readFloat() : 3 === r4 ? t3.readDouble() : 4 === r4 ? t3.readVarint64() : 5 === r4 ? t3.readVarint() : 6 === r4 ? t3.readSVarint() : 7 === r4 ? t3.readBoolean() : null;
            }
            if (null == e3) throw new Error("unknown feature value");
            return e3;
          }(r2));
        }
        class Pu {
          constructor(t2, e2) {
            this.layers = t2.readFields(zu, {}, e2);
          }
        }
        function zu(t2, e2, r2) {
          if (3 === t2) {
            const t3 = new Fu(r2, r2.readVarint() + r2.pos);
            t3.length && (e2[t3.name] = t3);
          }
        }
        const Bu = Math.pow(2, 13);
        function Vu(t2, e2, r2, n2, i2, s2, o2, a2) {
          t2.emplaceBack(e2, r2, 2 * Math.floor(n2 * Bu) + o2, i2 * Bu * 2, s2 * Bu * 2, Math.round(a2));
        }
        class Cu {
          constructor(t2) {
            this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.id), this.index = t2.index, this.hasDependencies = false, this.layoutVertexArray = new Uo(), this.centroidVertexArray = new Ro(), this.indexArray = new Jo(), this.programConfigurations = new Pa(t2.layers, t2.zoom), this.segments = new ra(), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id);
          }
          populate(t2, e2, r2) {
            this.features = [], this.hasDependencies = Vl("fill-extrusion", this.layers, e2);
            for (const { feature: n2, id: i2, index: s2, sourceLayerIndex: o2 } of t2) {
              const t3 = this.layers[0]._featureFilter.needGeometry, a2 = Oa(n2, t3);
              if (!this.layers[0]._featureFilter.filter(new Fs(this.zoom), a2, r2)) continue;
              const l2 = { id: i2, sourceLayerIndex: o2, index: s2, geometry: t3 ? a2.geometry : La(n2), properties: n2.properties, type: n2.type, patterns: {} };
              this.hasDependencies ? this.features.push(Cl("fill-extrusion", this.layers, l2, { zoom: this.zoom }, e2)) : this.addFeature(l2, l2.geometry, s2, r2, {}, e2.subdivisionGranularity), e2.featureIndex.insert(n2, l2.geometry, s2, o2, this.index, true);
            }
          }
          addFeatures(t2, e2, r2) {
            for (const n2 of this.features) {
              const { geometry: i2 } = n2;
              this.addFeature(n2, i2, n2.index, e2, r2, t2.subdivisionGranularity);
            }
          }
          update(t2, e2, r2) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t2, e2, this.stateDependentLayers, { imagePositions: r2 });
          }
          isEmpty() {
            return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
          }
          uploadPending() {
            return !this.uploaded || this.programConfigurations.needsUpload;
          }
          upload(t2) {
            this.uploaded || (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, ku), this.centroidVertexBuffer = t2.createVertexBuffer(this.centroidVertexArray, Su.members, true), this.indexBuffer = t2.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t2), this.uploaded = true;
          }
          destroy() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
          }
          addFeature(t2, e2, r2, n2, i2, s2) {
            for (const r3 of tn(e2, 500)) {
              const e3 = { x: 0, y: 0, sampleCount: 0 }, i3 = this.layoutVertexArray.length;
              this.processPolygon(e3, n2, t2, r3, s2);
              const o2 = this.layoutVertexArray.length - i3, a2 = Math.floor(e3.x / e3.sampleCount), l2 = Math.floor(e3.y / e3.sampleCount);
              for (let t3 = 0; t3 < o2; t3++) this.centroidVertexArray.emplaceBack(a2, l2);
            }
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, { imagePositions: i2, canonical: n2 });
          }
          processPolygon(t2, e2, r2, n2, i2) {
            if (n2.length < 1) return;
            if (Ru(n2[0])) return;
            for (const e3 of n2) 0 !== e3.length && Lu(t2, e3);
            const s2 = { segment: this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray) }, o2 = i2.fill.getGranularityForZoomLevel(e2.z), a2 = "Polygon" === Eu.types[r2.type];
            for (const t3 of n2) {
              if (0 === t3.length) continue;
              if (Ru(t3)) continue;
              const e3 = du(t3, o2, a2);
              this._generateSideFaces(e3, s2);
            }
            if (!a2) return;
            const l2 = fu(n2, e2, o2, false), u2 = this.layoutVertexArray;
            mu((t3, e3) => {
              Vu(u2, t3, e3, 0, 0, 1, 1, 0);
            }, this.segments, this.layoutVertexArray, this.indexArray, l2.verticesFlattened, l2.indicesTriangles);
          }
          _generateSideFaces(t2, e2) {
            let r2 = 0;
            for (let n2 = 1; n2 < t2.length; n2++) {
              const i2 = t2[n2], s2 = t2[n2 - 1];
              if (Ou(i2, s2)) continue;
              e2.segment.vertexLength + 4 > ra.MAX_VERTEX_ARRAY_LENGTH && (e2.segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
              const o2 = i2.sub(s2)._perp()._unit(), a2 = s2.dist(i2);
              r2 + a2 > 32768 && (r2 = 0), Vu(this.layoutVertexArray, i2.x, i2.y, o2.x, o2.y, 0, 0, r2), Vu(this.layoutVertexArray, i2.x, i2.y, o2.x, o2.y, 0, 1, r2), r2 += a2, Vu(this.layoutVertexArray, s2.x, s2.y, o2.x, o2.y, 0, 0, r2), Vu(this.layoutVertexArray, s2.x, s2.y, o2.x, o2.y, 0, 1, r2);
              const l2 = e2.segment.vertexLength;
              this.indexArray.emplaceBack(l2, l2 + 2, l2 + 1), this.indexArray.emplaceBack(l2 + 1, l2 + 2, l2 + 3), e2.segment.vertexLength += 4, e2.segment.primitiveLength += 2;
            }
          }
        }
        function Lu(t2, e2) {
          for (let r2 = 0; r2 < e2.length; r2++) {
            const n2 = e2[r2];
            r2 === e2.length - 1 && e2[0].x === n2.x && e2[0].y === n2.y || (t2.x += n2.x, t2.y += n2.y, t2.sampleCount++);
          }
        }
        function Ou(t2, e2) {
          return t2.x === e2.x && (t2.x < 0 || t2.x > M) || t2.y === e2.y && (t2.y < 0 || t2.y > M);
        }
        function Ru(t2) {
          return t2.every((t3) => t3.x < 0) || t2.every((t3) => t3.x > M) || t2.every((t3) => t3.y < 0) || t2.every((t3) => t3.y > M);
        }
        let Nu;
        us("FillExtrusionBucket", Cu, { omit: ["layers", "features"] });
        var $u = { get paint() {
          return Nu = Nu || new Xs({ "fill-extrusion-opacity": new $s(vt["paint_fill-extrusion"]["fill-extrusion-opacity"]), "fill-extrusion-color": new Us(vt["paint_fill-extrusion"]["fill-extrusion-color"]), "fill-extrusion-translate": new $s(vt["paint_fill-extrusion"]["fill-extrusion-translate"]), "fill-extrusion-translate-anchor": new $s(vt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]), "fill-extrusion-pattern": new qs(vt["paint_fill-extrusion"]["fill-extrusion-pattern"]), "fill-extrusion-height": new Us(vt["paint_fill-extrusion"]["fill-extrusion-height"]), "fill-extrusion-base": new Us(vt["paint_fill-extrusion"]["fill-extrusion-base"]), "fill-extrusion-vertical-gradient": new $s(vt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]) });
        } };
        class Uu extends Ys {
          constructor(t2, e2) {
            super(t2, $u, e2);
          }
          createBucket(t2) {
            return new Cu(t2);
          }
          queryRadius() {
            return tl(this.paint.get("fill-extrusion-translate"));
          }
          is3D() {
            return true;
          }
          queryIntersectsFeature({ queryGeometry: t2, feature: e2, featureState: n2, geometry: i2, transform: s2, pixelsToTileUnits: o2, pixelPosMatrix: a2 }) {
            const l2 = el(t2, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), -s2.bearingInRadians, o2), u2 = this.paint.get("fill-extrusion-height").evaluate(e2, n2), c2 = this.paint.get("fill-extrusion-base").evaluate(e2, n2), h2 = function(t3, e3) {
              const n3 = [];
              for (const i3 of t3) {
                const t4 = [i3.x, i3.y, 0, 1];
                S(t4, t4, e3), n3.push(new r(t4[0] / t4[3], t4[1] / t4[3]));
              }
              return n3;
            }(l2, a2), p2 = function(t3, e3, n3, i3) {
              const s3 = [], o3 = [], a3 = i3[8] * e3, l3 = i3[9] * e3, u3 = i3[10] * e3, c3 = i3[11] * e3, h3 = i3[8] * n3, p3 = i3[9] * n3, f2 = i3[10] * n3, d2 = i3[11] * n3;
              for (const e4 of t3) {
                const t4 = [], n4 = [];
                for (const s4 of e4) {
                  const e5 = s4.x, o4 = s4.y, y2 = i3[0] * e5 + i3[4] * o4 + i3[12], m2 = i3[1] * e5 + i3[5] * o4 + i3[13], g2 = i3[2] * e5 + i3[6] * o4 + i3[14], x2 = i3[3] * e5 + i3[7] * o4 + i3[15], v2 = g2 + u3, b2 = x2 + c3, w2 = y2 + h3, _2 = m2 + p3, A2 = g2 + f2, S2 = x2 + d2, k2 = new r((y2 + a3) / b2, (m2 + l3) / b2);
                  k2.z = v2 / b2, t4.push(k2);
                  const E2 = new r(w2 / S2, _2 / S2);
                  E2.z = A2 / S2, n4.push(E2);
                }
                s3.push(t4), o3.push(n4);
              }
              return [s3, o3];
            }(i2, c2, u2, a2);
            return function(t3, e3, r2) {
              let n3 = 1 / 0;
              ja(r2, e3) && (n3 = ju(r2, e3[0]));
              for (let i3 = 0; i3 < e3.length; i3++) {
                const s3 = e3[i3], o3 = t3[i3];
                for (let t4 = 0; t4 < s3.length - 1; t4++) {
                  const e4 = s3[t4], i4 = [e4, s3[t4 + 1], o3[t4 + 1], o3[t4], e4];
                  Ua(r2, i4) && (n3 = Math.min(n3, ju(r2, i4)));
                }
              }
              return n3 !== 1 / 0 && n3;
            }(p2[0], p2[1], h2);
          }
        }
        function qu(t2, e2) {
          return t2.x * e2.x + t2.y * e2.y;
        }
        function ju(t2, e2) {
          if (1 === t2.length) {
            let r2 = 0;
            const n2 = e2[r2++];
            let i2;
            for (; !i2 || n2.equals(i2); ) if (i2 = e2[r2++], !i2) return 1 / 0;
            for (; r2 < e2.length; r2++) {
              const s2 = e2[r2], o2 = t2[0], a2 = i2.sub(n2), l2 = s2.sub(n2), u2 = o2.sub(n2), c2 = qu(a2, a2), h2 = qu(a2, l2), p2 = qu(l2, l2), f2 = qu(u2, a2), d2 = qu(u2, l2), y2 = c2 * p2 - h2 * h2, m2 = (p2 * f2 - h2 * d2) / y2, g2 = (c2 * d2 - h2 * f2) / y2, x2 = n2.z * (1 - m2 - g2) + i2.z * m2 + s2.z * g2;
              if (isFinite(x2)) return x2;
            }
            return 1 / 0;
          }
          {
            let t3 = 1 / 0;
            for (const r2 of e2) t3 = Math.min(t3, r2.z);
            return t3;
          }
        }
        const Gu = to([{ name: "a_pos_normal", components: 2, type: "Int16" }, { name: "a_data", components: 4, type: "Uint8" }], 4), { members: Xu } = Gu, Yu = to([{ name: "a_uv_x", components: 1, type: "Float32" }, { name: "a_split_index", components: 1, type: "Float32" }]), { members: Zu } = Yu, Hu = Math.cos(Math.PI / 180 * 37.5), Ku = Math.pow(2, 14) / 0.5;
        class Wu {
          constructor(t2) {
            this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.id), this.index = t2.index, this.hasDependencies = false, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t3) => {
              this.gradients[t3.id] = {};
            }), this.layoutVertexArray = new qo(), this.layoutVertexArray2 = new jo(), this.indexArray = new Jo(), this.programConfigurations = new Pa(t2.layers, t2.zoom), this.segments = new ra(), this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id);
          }
          populate(t2, e2, r2) {
            this.hasDependencies = Vl("line", this.layers, e2) || this.hasLineDasharray(this.layers);
            const n2 = this.layers[0].layout.get("line-sort-key"), i2 = !n2.isConstant(), s2 = [];
            for (const { feature: e3, id: o2, index: a2, sourceLayerIndex: l2 } of t2) {
              const t3 = this.layers[0]._featureFilter.needGeometry, u2 = Oa(e3, t3);
              if (!this.layers[0]._featureFilter.filter(new Fs(this.zoom), u2, r2)) continue;
              const c2 = i2 ? n2.evaluate(u2, {}, r2) : void 0, h2 = { id: o2, properties: e3.properties, type: e3.type, sourceLayerIndex: l2, index: a2, geometry: t3 ? u2.geometry : La(e3), patterns: {}, dashes: {}, sortKey: c2 };
              s2.push(h2);
            }
            i2 && s2.sort((t3, e3) => t3.sortKey - e3.sortKey);
            for (const n3 of s2) {
              const { geometry: i3, index: s3, sourceLayerIndex: o2 } = n3;
              this.hasDependencies ? (Vl("line", this.layers, e2) ? Cl("line", this.layers, n3, { zoom: this.zoom }, e2) : this.hasLineDasharray(this.layers) && this.addLineDashDependencies(this.layers, n3, this.zoom, e2), this.patternFeatures.push(n3)) : this.addFeature(n3, i3, s3, r2, {}, {}, e2.subdivisionGranularity), e2.featureIndex.insert(t2[s3].feature, i3, s3, o2, this.index);
            }
          }
          update(t2, e2, r2, n2) {
            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t2, e2, this.stateDependentLayers, { imagePositions: r2, dashPositions: n2 });
          }
          addFeatures(t2, e2, r2, n2) {
            for (const i2 of this.patternFeatures) this.addFeature(i2, i2.geometry, i2.index, e2, r2, n2, t2.subdivisionGranularity);
          }
          isEmpty() {
            return 0 === this.layoutVertexArray.length;
          }
          uploadPending() {
            return !this.uploaded || this.programConfigurations.needsUpload;
          }
          upload(t2) {
            this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t2.createVertexBuffer(this.layoutVertexArray2, Zu)), this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, Xu), this.indexBuffer = t2.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t2), this.uploaded = true;
          }
          destroy() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
          }
          lineFeatureClips(t2) {
            if (t2.properties && Object.prototype.hasOwnProperty.call(t2.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(t2.properties, "mapbox_clip_end")) return { start: +t2.properties.mapbox_clip_start, end: +t2.properties.mapbox_clip_end };
          }
          addFeature(t2, e2, r2, n2, i2, s2, o2) {
            const a2 = this.layers[0].layout, l2 = a2.get("line-join").evaluate(t2, {}), u2 = a2.get("line-cap"), c2 = a2.get("line-miter-limit"), h2 = a2.get("line-round-limit");
            this.lineClips = this.lineFeatureClips(t2);
            for (const r3 of e2) this.addLine(r3, t2, l2, u2, c2, h2, n2, o2);
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, { imagePositions: i2, dashPositions: s2, canonical: n2 });
          }
          addLine(t2, e2, r2, n2, i2, s2, o2, a2) {
            if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, t2 = du(t2, o2 ? a2.line.getGranularityForZoomLevel(o2.z) : 1), this.lineClips) {
              this.lineClipsArray.push(this.lineClips);
              for (let e3 = 0; e3 < t2.length - 1; e3++) this.totalDistance += t2[e3].dist(t2[e3 + 1]);
              this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
            }
            const l2 = "Polygon" === Eu.types[e2.type];
            let u2 = t2.length;
            for (; u2 >= 2 && t2[u2 - 1].equals(t2[u2 - 2]); ) u2--;
            let c2 = 0;
            for (; c2 < u2 - 1 && t2[c2].equals(t2[c2 + 1]); ) c2++;
            if (u2 < (l2 ? 3 : 2)) return;
            "bevel" === r2 && (i2 = 1.05);
            const h2 = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, p2 = this.segments.prepareSegment(10 * u2, this.layoutVertexArray, this.indexArray);
            let f2, d2, y2, m2, g2;
            this.e1 = this.e2 = -1, l2 && (f2 = t2[u2 - 2], g2 = t2[c2].sub(f2)._unit()._perp());
            for (let e3 = c2; e3 < u2; e3++) {
              if (y2 = e3 === u2 - 1 ? l2 ? t2[c2 + 1] : void 0 : t2[e3 + 1], y2 && t2[e3].equals(y2)) continue;
              g2 && (m2 = g2), f2 && (d2 = f2), f2 = t2[e3], g2 = y2 ? y2.sub(f2)._unit()._perp() : m2, m2 = m2 || g2;
              let o3 = m2.add(g2);
              0 === o3.x && 0 === o3.y || o3._unit();
              const a3 = m2.x * g2.x + m2.y * g2.y, x2 = o3.x * g2.x + o3.y * g2.y, v2 = 0 !== x2 ? 1 / x2 : 1 / 0, b2 = 2 * Math.sqrt(2 - 2 * x2), w2 = x2 < Hu && d2 && y2, _2 = m2.x * g2.y - m2.y * g2.x > 0;
              if (w2 && e3 > c2) {
                const t3 = f2.dist(d2);
                if (t3 > 2 * h2) {
                  const e4 = f2.sub(f2.sub(d2)._mult(h2 / t3)._round());
                  this.updateDistance(d2, e4), this.addCurrentVertex(e4, m2, 0, 0, p2), d2 = e4;
                }
              }
              const A2 = d2 && y2;
              let S2 = A2 ? r2 : l2 ? "butt" : n2;
              if (A2 && "round" === S2 && (v2 < s2 ? S2 = "miter" : v2 <= 2 && (S2 = "fakeround")), "miter" === S2 && v2 > i2 && (S2 = "bevel"), "bevel" === S2 && (v2 > 2 && (S2 = "flipbevel"), v2 < i2 && (S2 = "miter")), d2 && this.updateDistance(d2, f2), "miter" === S2) o3._mult(v2), this.addCurrentVertex(f2, o3, 0, 0, p2);
              else if ("flipbevel" === S2) {
                if (v2 > 100) o3 = g2.mult(-1);
                else {
                  const t3 = v2 * m2.add(g2).mag() / m2.sub(g2).mag();
                  o3._perp()._mult(t3 * (_2 ? -1 : 1));
                }
                this.addCurrentVertex(f2, o3, 0, 0, p2), this.addCurrentVertex(f2, o3.mult(-1), 0, 0, p2);
              } else if ("bevel" === S2 || "fakeround" === S2) {
                const t3 = -Math.sqrt(v2 * v2 - 1), e4 = _2 ? t3 : 0, r3 = _2 ? 0 : t3;
                if (d2 && this.addCurrentVertex(f2, m2, e4, r3, p2), "fakeround" === S2) {
                  const t4 = Math.round(180 * b2 / Math.PI / 20);
                  for (let e5 = 1; e5 < t4; e5++) {
                    let r4 = e5 / t4;
                    if (0.5 !== r4) {
                      const t5 = r4 - 0.5;
                      r4 += r4 * t5 * (r4 - 1) * ((1.0904 + a3 * (a3 * (3.55645 - 1.43519 * a3) - 3.2452)) * t5 * t5 + (0.848013 + a3 * (0.215638 * a3 - 1.06021)));
                    }
                    const n3 = g2.sub(m2)._mult(r4)._add(m2)._unit()._mult(_2 ? -1 : 1);
                    this.addHalfVertex(f2, n3.x, n3.y, false, _2, 0, p2);
                  }
                }
                y2 && this.addCurrentVertex(f2, g2, -e4, -r3, p2);
              } else if ("butt" === S2) this.addCurrentVertex(f2, o3, 0, 0, p2);
              else if ("square" === S2) {
                const t3 = d2 ? 1 : -1;
                this.addCurrentVertex(f2, o3, t3, t3, p2);
              } else "round" === S2 && (d2 && (this.addCurrentVertex(f2, m2, 0, 0, p2), this.addCurrentVertex(f2, m2, 1, 1, p2, true)), y2 && (this.addCurrentVertex(f2, g2, -1, -1, p2, true), this.addCurrentVertex(f2, g2, 0, 0, p2)));
              if (w2 && e3 < u2 - 1) {
                const t3 = f2.dist(y2);
                if (t3 > 2 * h2) {
                  const e4 = f2.add(y2.sub(f2)._mult(h2 / t3)._round());
                  this.updateDistance(f2, e4), this.addCurrentVertex(e4, g2, 0, 0, p2), f2 = e4;
                }
              }
            }
          }
          addCurrentVertex(t2, e2, r2, n2, i2, s2 = false) {
            const o2 = e2.y * n2 - e2.x, a2 = -e2.y - e2.x * n2;
            this.addHalfVertex(t2, e2.x + e2.y * r2, e2.y - e2.x * r2, s2, false, r2, i2), this.addHalfVertex(t2, o2, a2, s2, true, -n2, i2), this.distance > Ku / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(t2, e2, r2, n2, i2, s2));
          }
          addHalfVertex({ x: t2, y: e2 }, r2, n2, i2, s2, o2, a2) {
            const l2 = 0.5 * (this.lineClips ? this.scaledDistance * (Ku - 1) : this.scaledDistance);
            this.layoutVertexArray.emplaceBack((t2 << 1) + (i2 ? 1 : 0), (e2 << 1) + (s2 ? 1 : 0), Math.round(63 * r2) + 128, Math.round(63 * n2) + 128, 1 + (0 === o2 ? 0 : o2 < 0 ? -1 : 1) | (63 & l2) << 2, l2 >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
            const u2 = a2.vertexLength++;
            this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, u2, this.e2), a2.primitiveLength++), s2 ? this.e2 = u2 : this.e1 = u2;
          }
          updateScaledDistance() {
            this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
          }
          updateDistance(t2, e2) {
            this.distance += t2.dist(e2), this.updateScaledDistance();
          }
          hasLineDasharray(t2) {
            for (const e2 of t2) {
              const t3 = e2.paint.get("line-dasharray");
              if (t3 && !t3.isConstant()) return true;
            }
            return false;
          }
          addLineDashDependencies(t2, e2, r2, n2) {
            for (const i2 of t2) {
              const t3 = i2.paint.get("line-dasharray");
              if (!t3 || "constant" === t3.value.kind) continue;
              const s2 = "round" === i2.layout.get("line-cap"), o2 = { dasharray: t3.value.evaluate({ zoom: r2 - 1 }, e2, {}), round: s2 }, a2 = { dasharray: t3.value.evaluate({ zoom: r2 }, e2, {}), round: s2 }, l2 = { dasharray: t3.value.evaluate({ zoom: r2 + 1 }, e2, {}), round: s2 }, u2 = `${o2.dasharray.join(",")},${o2.round}`, c2 = `${a2.dasharray.join(",")},${a2.round}`, h2 = `${l2.dasharray.join(",")},${l2.round}`;
              n2.dashDependencies[u2] = o2, n2.dashDependencies[c2] = a2, n2.dashDependencies[h2] = l2, e2.dashes[i2.id] = { min: u2, mid: c2, max: h2 };
            }
          }
        }
        let Ju, Qu;
        us("LineBucket", Wu, { omit: ["layers", "patternFeatures"] });
        var tc = { get paint() {
          return Qu = Qu || new Xs({ "line-opacity": new Us(vt.paint_line["line-opacity"]), "line-color": new Us(vt.paint_line["line-color"]), "line-translate": new $s(vt.paint_line["line-translate"]), "line-translate-anchor": new $s(vt.paint_line["line-translate-anchor"]), "line-width": new Us(vt.paint_line["line-width"]), "line-gap-width": new Us(vt.paint_line["line-gap-width"]), "line-offset": new Us(vt.paint_line["line-offset"]), "line-blur": new Us(vt.paint_line["line-blur"]), "line-dasharray": new qs(vt.paint_line["line-dasharray"]), "line-pattern": new qs(vt.paint_line["line-pattern"]), "line-gradient": new Gs(vt.paint_line["line-gradient"]) });
        }, get layout() {
          return Ju = Ju || new Xs({ "line-cap": new $s(vt.layout_line["line-cap"]), "line-join": new Us(vt.layout_line["line-join"]), "line-miter-limit": new $s(vt.layout_line["line-miter-limit"]), "line-round-limit": new $s(vt.layout_line["line-round-limit"]), "line-sort-key": new Us(vt.layout_line["line-sort-key"]) });
        } };
        class ec extends Us {
          possiblyEvaluate(t2, e2) {
            return e2 = new Fs(Math.floor(e2.zoom), { now: e2.now, fadeDuration: e2.fadeDuration, zoomHistory: e2.zoomHistory, transition: e2.transition }), super.possiblyEvaluate(t2, e2);
          }
          evaluate(t2, e2, r2, n2) {
            return e2 = O({}, e2, { zoom: Math.floor(e2.zoom) }), super.evaluate(t2, e2, r2, n2);
          }
        }
        let rc;
        class nc extends Ys {
          constructor(t2, e2) {
            super(t2, tc, e2), this.gradientVersion = 0, rc || (rc = new ec(tc.paint.properties["line-width"].specification), rc.useIntegerZoom = true);
          }
          _handleSpecialPaintPropertyUpdate(t2) {
            if ("line-gradient" === t2) {
              const t3 = this.gradientExpression();
              this.stepInterpolant = !!function(t4) {
                return void 0 !== t4._styleExpression;
              }(t3) && t3._styleExpression.expression instanceof ar, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
            }
          }
          gradientExpression() {
            return this._transitionablePaint._values["line-gradient"].value.expression;
          }
          recalculate(t2, e2) {
            super.recalculate(t2, e2), this.paint._values["line-floorwidth"] = rc.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t2);
          }
          createBucket(t2) {
            return new Wu(t2);
          }
          queryRadius(t2) {
            const e2 = t2, r2 = ic(Qa("line-width", this, e2), Qa("line-gap-width", this, e2)), n2 = Qa("line-offset", this, e2);
            return r2 / 2 + Math.abs(n2) + tl(this.paint.get("line-translate"));
          }
          queryIntersectsFeature({ queryGeometry: t2, feature: e2, featureState: n2, geometry: i2, transform: s2, pixelsToTileUnits: o2 }) {
            const a2 = el(t2, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), -s2.bearingInRadians, o2), l2 = o2 / 2 * ic(this.paint.get("line-width").evaluate(e2, n2), this.paint.get("line-gap-width").evaluate(e2, n2)), u2 = this.paint.get("line-offset").evaluate(e2, n2);
            return u2 && (i2 = function(t3, e3) {
              const n3 = [];
              for (let i3 = 0; i3 < t3.length; i3++) {
                const s3 = rl(t3[i3]), o3 = [];
                for (let t4 = 0; t4 < s3.length; t4++) {
                  const n4 = s3[t4], i4 = s3[t4 - 1], a3 = s3[t4 + 1], l3 = 0 === t4 ? new r(0, 0) : n4.sub(i4)._unit()._perp(), u3 = t4 === s3.length - 1 ? new r(0, 0) : a3.sub(n4)._unit()._perp(), c2 = l3._add(u3)._unit(), h2 = c2.x * u3.x + c2.y * u3.y;
                  0 !== h2 && c2._mult(1 / h2), o3.push(c2._mult(e3)._add(n4));
                }
                n3.push(o3);
              }
              return n3;
            }(i2, u2 * o2)), function(t3, e3, r2) {
              for (let n3 = 0; n3 < e3.length; n3++) {
                const i3 = e3[n3];
                if (t3.length >= 3) {
                  for (let e4 = 0; e4 < i3.length; e4++) if (Wa(t3, i3[e4])) return true;
                }
                if (Ga(t3, i3, r2)) return true;
              }
              return false;
            }(a2, i2, l2);
          }
          isTileClipped() {
            return true;
          }
        }
        function ic(t2, e2) {
          return e2 > 0 ? e2 + 2 * t2 : t2;
        }
        const sc = to([{ name: "a_pos_offset", components: 4, type: "Int16" }, { name: "a_data", components: 4, type: "Uint16" }, { name: "a_pixeloffset", components: 4, type: "Int16" }], 4), oc = to([{ name: "a_projected_pos", components: 3, type: "Float32" }], 4);
        to([{ name: "a_fade_opacity", components: 1, type: "Uint32" }], 4);
        const ac = to([{ name: "a_placed", components: 2, type: "Uint8" }, { name: "a_shift", components: 2, type: "Float32" }, { name: "a_box_real", components: 2, type: "Int16" }]);
        to([{ type: "Int16", name: "anchorPointX" }, { type: "Int16", name: "anchorPointY" }, { type: "Int16", name: "x1" }, { type: "Int16", name: "y1" }, { type: "Int16", name: "x2" }, { type: "Int16", name: "y2" }, { type: "Uint32", name: "featureIndex" }, { type: "Uint16", name: "sourceLayerIndex" }, { type: "Uint16", name: "bucketIndex" }]);
        const lc = to([{ name: "a_pos", components: 2, type: "Int16" }, { name: "a_anchor_pos", components: 2, type: "Int16" }, { name: "a_extrude", components: 2, type: "Int16" }], 4), uc = to([{ name: "a_pos", components: 2, type: "Float32" }, { name: "a_radius", components: 1, type: "Float32" }, { name: "a_flags", components: 2, type: "Int16" }], 4);
        function cc(t2, e2, r2) {
          return t2.sections.forEach((t3) => {
            t3.text = function(t4, e3, r3) {
              const n2 = e3.layout.get("text-transform").evaluate(r3, {});
              return "uppercase" === n2 ? t4 = t4.toLocaleUpperCase() : "lowercase" === n2 && (t4 = t4.toLocaleLowerCase()), Ms.applyArabicShaping && (t4 = Ms.applyArabicShaping(t4)), t4;
            }(t3.text, e2, r2);
          }), t2;
        }
        to([{ name: "triangle", components: 3, type: "Uint16" }]), to([{ type: "Int16", name: "anchorX" }, { type: "Int16", name: "anchorY" }, { type: "Uint16", name: "glyphStartIndex" }, { type: "Uint16", name: "numGlyphs" }, { type: "Uint32", name: "vertexStartIndex" }, { type: "Uint32", name: "lineStartIndex" }, { type: "Uint32", name: "lineLength" }, { type: "Uint16", name: "segment" }, { type: "Uint16", name: "lowerSize" }, { type: "Uint16", name: "upperSize" }, { type: "Float32", name: "lineOffsetX" }, { type: "Float32", name: "lineOffsetY" }, { type: "Uint8", name: "writingMode" }, { type: "Uint8", name: "placedOrientation" }, { type: "Uint8", name: "hidden" }, { type: "Uint32", name: "crossTileID" }, { type: "Int16", name: "associatedIconIndex" }]), to([{ type: "Int16", name: "anchorX" }, { type: "Int16", name: "anchorY" }, { type: "Int16", name: "rightJustifiedTextSymbolIndex" }, { type: "Int16", name: "centerJustifiedTextSymbolIndex" }, { type: "Int16", name: "leftJustifiedTextSymbolIndex" }, { type: "Int16", name: "verticalPlacedTextSymbolIndex" }, { type: "Int16", name: "placedIconSymbolIndex" }, { type: "Int16", name: "verticalPlacedIconSymbolIndex" }, { type: "Uint16", name: "key" }, { type: "Uint16", name: "textBoxStartIndex" }, { type: "Uint16", name: "textBoxEndIndex" }, { type: "Uint16", name: "verticalTextBoxStartIndex" }, { type: "Uint16", name: "verticalTextBoxEndIndex" }, { type: "Uint16", name: "iconBoxStartIndex" }, { type: "Uint16", name: "iconBoxEndIndex" }, { type: "Uint16", name: "verticalIconBoxStartIndex" }, { type: "Uint16", name: "verticalIconBoxEndIndex" }, { type: "Uint16", name: "featureIndex" }, { type: "Uint16", name: "numHorizontalGlyphVertices" }, { type: "Uint16", name: "numVerticalGlyphVertices" }, { type: "Uint16", name: "numIconVertices" }, { type: "Uint16", name: "numVerticalIconVertices" }, { type: "Uint16", name: "useRuntimeCollisionCircles" }, { type: "Uint32", name: "crossTileID" }, { type: "Float32", name: "textBoxScale" }, { type: "Float32", name: "collisionCircleDiameter" }, { type: "Uint16", name: "textAnchorOffsetStartIndex" }, { type: "Uint16", name: "textAnchorOffsetEndIndex" }]), to([{ type: "Float32", name: "offsetX" }]), to([{ type: "Int16", name: "x" }, { type: "Int16", name: "y" }, { type: "Int16", name: "tileUnitDistanceFromAnchor" }]), to([{ type: "Uint16", name: "textAnchor" }, { type: "Float32", components: 2, name: "textOffset" }]);
        var hc = 24;
        const pc = { "!": "︕", "#": "＃", $: "＄", "%": "％", "&": "＆", "(": "︵", ")": "︶", "*": "＊", "+": "＋", ",": "︐", "-": "︲", ".": "・", "/": "／", ":": "︓", ";": "︔", "<": "︿", "=": "＝", ">": "﹀", "?": "︖", "@": "＠", "[": "﹇", "\\": "＼", "]": "﹈", "^": "＾", _: "︳", "`": "｀", "{": "︷", "|": "―", "}": "︸", "~": "～", "¢": "￠", "£": "￡", "¥": "￥", "¦": "￤", "¬": "￢", "¯": "￣", "–": "︲", "—": "︱", "‘": "﹃", "’": "﹄", "“": "﹁", "”": "﹂", "…": "︙", "⋯": "︙", "‧": "・", "₩": "￦", "、": "︑", "。": "︒", "〈": "︿", "〉": "﹀", "《": "︽", "》": "︾", "「": "﹁", "」": "﹂", "『": "﹃", "』": "﹄", "【": "︻", "】": "︼", "〔": "︹", "〕": "︺", "〖": "︗", "〗": "︘", "！": "︕", "（": "︵", "）": "︶", "，": "︐", "－": "︲", "．": "・", "：": "︓", "；": "︔", "＜": "︿", "＞": "﹀", "？": "︖", "［": "﹇", "］": "﹈", "＿": "︳", "｛": "︷", "｜": "―", "｝": "︸", "｟": "︵", "｠": "︶", "｡": "︒", "｢": "﹁", "｣": "﹂" }, fc = { 10: true, 32: true, 38: true, 41: true, 43: true, 45: true, 47: true, 173: true, 183: true, 8203: true, 8208: true, 8211: true, 8231: true }, dc = { 40: true };
        function yc(t2, e2, r2, n2, i2, s2) {
          if ("fontStack" in e2) {
            const n3 = r2[e2.fontStack], s3 = n3 && n3[t2];
            return s3 ? s3.metrics.advance * e2.scale + i2 : 0;
          }
          {
            const t3 = n2[e2.imageName];
            return t3 ? t3.displaySize[0] * e2.scale * hc / s2 + i2 : 0;
          }
        }
        function mc(t2, e2, r2, n2) {
          const i2 = Math.pow(t2 - e2, 2);
          return n2 ? t2 < e2 ? i2 / 2 : 2 * i2 : i2 + Math.abs(r2) * r2;
        }
        function gc(t2, e2, r2) {
          let n2 = 0;
          return 10 === t2 && (n2 -= 1e4), r2 && (n2 += 150), 40 !== t2 && 65288 !== t2 || (n2 += 50), 41 !== e2 && 65289 !== e2 || (n2 += 50), n2;
        }
        function xc(t2, e2, r2, n2, i2, s2) {
          let o2 = null, a2 = mc(e2, r2, i2, s2);
          for (const t3 of n2) {
            const n3 = mc(e2 - t3.x, r2, i2, s2) + t3.badness;
            n3 <= a2 && (o2 = t3, a2 = n3);
          }
          return { index: t2, x: e2, priorBreak: o2, badness: a2 };
        }
        function vc(t2) {
          return t2 ? vc(t2.priorBreak).concat(t2.index) : [];
        }
        class bc {
          constructor(t2 = "", e2 = [], r2 = []) {
            this.text = t2, this.sections = e2, this.sectionIndex = r2, this.imageSectionID = null;
          }
          static fromFeature(t2, e2) {
            const r2 = new bc();
            for (let n2 = 0; n2 < t2.sections.length; n2++) {
              const i2 = t2.sections[n2];
              i2.image ? r2.addImageSection(i2) : r2.addTextSection(i2, e2);
            }
            return r2;
          }
          length() {
            return [...this.text].length;
          }
          getSection(t2) {
            return this.sections[this.sectionIndex[t2]];
          }
          getSectionIndex(t2) {
            return this.sectionIndex[t2];
          }
          verticalizePunctuation() {
            this.text = function(t2) {
              let e2 = "", r2 = { premature: true, value: void 0 };
              const n2 = t2[Symbol.iterator]();
              let i2 = n2.next();
              const s2 = t2[Symbol.iterator]();
              s2.next();
              let o2 = s2.next();
              for (; !i2.done; ) e2 += !o2.done && Ss(o2.value.codePointAt(0)) && !pc[o2.value] || !r2.premature && Ss(r2.value.codePointAt(0)) && !pc[r2.value] || !pc[i2.value] ? i2.value : pc[i2.value], r2 = { value: i2.value, premature: false }, i2 = n2.next(), o2 = s2.next();
              return e2;
            }(this.text);
          }
          hasZeroWidthSpaces() {
            return this.text.includes("​");
          }
          trim() {
            const t2 = this.text.match(/^\s*/), e2 = t2 ? t2[0].length : 0, r2 = this.text.match(/\S\s*$/), n2 = r2 ? r2[0].length - 1 : 0;
            this.text = this.text.substring(e2, this.text.length - n2), this.sectionIndex = this.sectionIndex.slice(e2, this.sectionIndex.length - n2);
          }
          substring(t2, e2) {
            const r2 = [...this.text].slice(t2, e2).join(""), n2 = this.sectionIndex.slice(t2, e2);
            return new bc(r2, this.sections, n2);
          }
          toCodeUnitIndex(t2) {
            return [...this.text].slice(0, t2).join("").length;
          }
          toString() {
            return this.text;
          }
          getMaxScale() {
            return this.sectionIndex.reduce((t2, e2) => Math.max(t2, this.sections[e2].scale), 0);
          }
          getMaxImageSize(t2) {
            let e2 = 0, r2 = 0;
            for (let n2 = 0; n2 < this.length(); n2++) {
              const i2 = this.getSection(n2);
              if ("imageName" in i2) {
                const n3 = t2[i2.imageName];
                if (!n3) continue;
                const s2 = n3.displaySize;
                e2 = Math.max(e2, s2[0]), r2 = Math.max(r2, s2[1]);
              }
            }
            return { maxImageWidth: e2, maxImageHeight: r2 };
          }
          addTextSection(t2, e2) {
            this.text += t2.text, this.sections.push({ scale: t2.scale || 1, verticalAlign: t2.verticalAlign || "bottom", fontStack: t2.fontStack || e2 });
            const r2 = this.sections.length - 1;
            this.sectionIndex.push(...[...t2.text].map(() => r2));
          }
          addImageSection(t2) {
            const e2 = t2.image ? t2.image.name : "";
            if (0 === e2.length) return void j("Can't add FormattedSection with an empty image.");
            const r2 = this.getNextImageSectionCharCode();
            r2 ? (this.text += String.fromCharCode(r2), this.sections.push({ scale: 1, verticalAlign: t2.verticalAlign || "bottom", imageName: e2 }), this.sectionIndex.push(this.sections.length - 1)) : j("Reached maximum number of images 6401");
          }
          getNextImageSectionCharCode() {
            return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
          }
          determineLineBreaks(t2, e2, r2, n2, i2) {
            const s2 = [], o2 = this.determineAverageLineWidth(t2, e2, r2, n2, i2), a2 = this.hasZeroWidthSpaces();
            let l2 = 0, u2 = 0;
            const c2 = this.text[Symbol.iterator]();
            let h2 = c2.next();
            const p2 = this.text[Symbol.iterator]();
            p2.next();
            let f2 = p2.next();
            const d2 = this.text[Symbol.iterator]();
            d2.next(), d2.next();
            let y2 = d2.next();
            for (; !h2.done; ) {
              const e3 = this.getSection(u2), m2 = h2.value.codePointAt(0);
              if (xs(m2) || (l2 += yc(m2, e3, r2, n2, t2, i2)), !f2.done) {
                const t3 = ms(m2), r3 = f2.value.codePointAt(0);
                (fc[m2] || t3 || "imageName" in e3 || !y2.done && dc[r3]) && s2.push(xc(u2 + 1, l2, o2, s2, gc(m2, r3, t3 && a2), false));
              }
              u2++, h2 = c2.next(), f2 = p2.next(), y2 = d2.next();
            }
            return vc(xc(this.length(), l2, o2, s2, 0, true));
          }
          determineAverageLineWidth(t2, e2, r2, n2, i2) {
            let s2 = 0, o2 = 0;
            for (const e3 of this.text) {
              const a2 = this.getSection(o2);
              s2 += yc(e3.codePointAt(0), a2, r2, n2, t2, i2), o2++;
            }
            return s2 / Math.max(1, Math.ceil(s2 / e2));
          }
        }
        const wc = 4294967296, _c = 1 / wc, Ac = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
        class Sc {
          constructor(t2 = new Uint8Array(16)) {
            this.buf = ArrayBuffer.isView(t2) ? t2 : new Uint8Array(t2), this.dataView = new DataView(this.buf.buffer), this.pos = 0, this.type = 0, this.length = this.buf.length;
          }
          readFields(t2, e2, r2 = this.length) {
            for (; this.pos < r2; ) {
              const r3 = this.readVarint(), n2 = r3 >> 3, i2 = this.pos;
              this.type = 7 & r3, t2(n2, e2, this), this.pos === i2 && this.skip(r3);
            }
            return e2;
          }
          readMessage(t2, e2) {
            return this.readFields(t2, e2, this.readVarint() + this.pos);
          }
          readFixed32() {
            const t2 = this.dataView.getUint32(this.pos, true);
            return this.pos += 4, t2;
          }
          readSFixed32() {
            const t2 = this.dataView.getInt32(this.pos, true);
            return this.pos += 4, t2;
          }
          readFixed64() {
            const t2 = this.dataView.getUint32(this.pos, true) + this.dataView.getUint32(this.pos + 4, true) * wc;
            return this.pos += 8, t2;
          }
          readSFixed64() {
            const t2 = this.dataView.getUint32(this.pos, true) + this.dataView.getInt32(this.pos + 4, true) * wc;
            return this.pos += 8, t2;
          }
          readFloat() {
            const t2 = this.dataView.getFloat32(this.pos, true);
            return this.pos += 4, t2;
          }
          readDouble() {
            const t2 = this.dataView.getFloat64(this.pos, true);
            return this.pos += 8, t2;
          }
          readVarint(t2) {
            const e2 = this.buf;
            let r2, n2;
            return n2 = e2[this.pos++], r2 = 127 & n2, n2 < 128 ? r2 : (n2 = e2[this.pos++], r2 |= (127 & n2) << 7, n2 < 128 ? r2 : (n2 = e2[this.pos++], r2 |= (127 & n2) << 14, n2 < 128 ? r2 : (n2 = e2[this.pos++], r2 |= (127 & n2) << 21, n2 < 128 ? r2 : (n2 = e2[this.pos], r2 |= (15 & n2) << 28, function(t3, e3, r3) {
              const n3 = r3.buf;
              let i2, s2;
              if (s2 = n3[r3.pos++], i2 = (112 & s2) >> 4, s2 < 128) return kc(t3, i2, e3);
              if (s2 = n3[r3.pos++], i2 |= (127 & s2) << 3, s2 < 128) return kc(t3, i2, e3);
              if (s2 = n3[r3.pos++], i2 |= (127 & s2) << 10, s2 < 128) return kc(t3, i2, e3);
              if (s2 = n3[r3.pos++], i2 |= (127 & s2) << 17, s2 < 128) return kc(t3, i2, e3);
              if (s2 = n3[r3.pos++], i2 |= (127 & s2) << 24, s2 < 128) return kc(t3, i2, e3);
              if (s2 = n3[r3.pos++], i2 |= (1 & s2) << 31, s2 < 128) return kc(t3, i2, e3);
              throw new Error("Expected varint not more than 10 bytes");
            }(r2, t2, this)))));
          }
          readVarint64() {
            return this.readVarint(true);
          }
          readSVarint() {
            const t2 = this.readVarint();
            return t2 % 2 == 1 ? (t2 + 1) / -2 : t2 / 2;
          }
          readBoolean() {
            return Boolean(this.readVarint());
          }
          readString() {
            const t2 = this.readVarint() + this.pos, e2 = this.pos;
            return this.pos = t2, t2 - e2 >= 12 && Ac ? Ac.decode(this.buf.subarray(e2, t2)) : function(t3, e3, r2) {
              let n2 = "", i2 = e3;
              for (; i2 < r2; ) {
                const e4 = t3[i2];
                let s2, o2, a2, l2 = null, u2 = e4 > 239 ? 4 : e4 > 223 ? 3 : e4 > 191 ? 2 : 1;
                if (i2 + u2 > r2) break;
                1 === u2 ? e4 < 128 && (l2 = e4) : 2 === u2 ? (s2 = t3[i2 + 1], 128 == (192 & s2) && (l2 = (31 & e4) << 6 | 63 & s2, l2 <= 127 && (l2 = null))) : 3 === u2 ? (s2 = t3[i2 + 1], o2 = t3[i2 + 2], 128 == (192 & s2) && 128 == (192 & o2) && (l2 = (15 & e4) << 12 | (63 & s2) << 6 | 63 & o2, (l2 <= 2047 || l2 >= 55296 && l2 <= 57343) && (l2 = null))) : 4 === u2 && (s2 = t3[i2 + 1], o2 = t3[i2 + 2], a2 = t3[i2 + 3], 128 == (192 & s2) && 128 == (192 & o2) && 128 == (192 & a2) && (l2 = (15 & e4) << 18 | (63 & s2) << 12 | (63 & o2) << 6 | 63 & a2, (l2 <= 65535 || l2 >= 1114112) && (l2 = null))), null === l2 ? (l2 = 65533, u2 = 1) : l2 > 65535 && (l2 -= 65536, n2 += String.fromCharCode(l2 >>> 10 & 1023 | 55296), l2 = 56320 | 1023 & l2), n2 += String.fromCharCode(l2), i2 += u2;
              }
              return n2;
            }(this.buf, e2, t2);
          }
          readBytes() {
            const t2 = this.readVarint() + this.pos, e2 = this.buf.subarray(this.pos, t2);
            return this.pos = t2, e2;
          }
          readPackedVarint(t2 = [], e2) {
            const r2 = this.readPackedEnd();
            for (; this.pos < r2; ) t2.push(this.readVarint(e2));
            return t2;
          }
          readPackedSVarint(t2 = []) {
            const e2 = this.readPackedEnd();
            for (; this.pos < e2; ) t2.push(this.readSVarint());
            return t2;
          }
          readPackedBoolean(t2 = []) {
            const e2 = this.readPackedEnd();
            for (; this.pos < e2; ) t2.push(this.readBoolean());
            return t2;
          }
          readPackedFloat(t2 = []) {
            const e2 = this.readPackedEnd();
            for (; this.pos < e2; ) t2.push(this.readFloat());
            return t2;
          }
          readPackedDouble(t2 = []) {
            const e2 = this.readPackedEnd();
            for (; this.pos < e2; ) t2.push(this.readDouble());
            return t2;
          }
          readPackedFixed32(t2 = []) {
            const e2 = this.readPackedEnd();
            for (; this.pos < e2; ) t2.push(this.readFixed32());
            return t2;
          }
          readPackedSFixed32(t2 = []) {
            const e2 = this.readPackedEnd();
            for (; this.pos < e2; ) t2.push(this.readSFixed32());
            return t2;
          }
          readPackedFixed64(t2 = []) {
            const e2 = this.readPackedEnd();
            for (; this.pos < e2; ) t2.push(this.readFixed64());
            return t2;
          }
          readPackedSFixed64(t2 = []) {
            const e2 = this.readPackedEnd();
            for (; this.pos < e2; ) t2.push(this.readSFixed64());
            return t2;
          }
          readPackedEnd() {
            return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
          }
          skip(t2) {
            const e2 = 7 & t2;
            if (0 === e2) for (; this.buf[this.pos++] > 127; ) ;
            else if (2 === e2) this.pos = this.readVarint() + this.pos;
            else if (5 === e2) this.pos += 4;
            else {
              if (1 !== e2) throw new Error(`Unimplemented type: ${e2}`);
              this.pos += 8;
            }
          }
          writeTag(t2, e2) {
            this.writeVarint(t2 << 3 | e2);
          }
          realloc(t2) {
            let e2 = this.length || 16;
            for (; e2 < this.pos + t2; ) e2 *= 2;
            if (e2 !== this.length) {
              const t3 = new Uint8Array(e2);
              t3.set(this.buf), this.buf = t3, this.dataView = new DataView(t3.buffer), this.length = e2;
            }
          }
          finish() {
            return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
          }
          writeFixed32(t2) {
            this.realloc(4), this.dataView.setInt32(this.pos, t2, true), this.pos += 4;
          }
          writeSFixed32(t2) {
            this.realloc(4), this.dataView.setInt32(this.pos, t2, true), this.pos += 4;
          }
          writeFixed64(t2) {
            this.realloc(8), this.dataView.setInt32(this.pos, -1 & t2, true), this.dataView.setInt32(this.pos + 4, Math.floor(t2 * _c), true), this.pos += 8;
          }
          writeSFixed64(t2) {
            this.realloc(8), this.dataView.setInt32(this.pos, -1 & t2, true), this.dataView.setInt32(this.pos + 4, Math.floor(t2 * _c), true), this.pos += 8;
          }
          writeVarint(t2) {
            (t2 = +t2 || 0) > 268435455 || t2 < 0 ? function(t3, e2) {
              let r2, n2;
              if (t3 >= 0 ? (r2 = t3 % 4294967296 | 0, n2 = t3 / 4294967296 | 0) : (r2 = ~(-t3 % 4294967296), n2 = ~(-t3 / 4294967296), 4294967295 ^ r2 ? r2 = r2 + 1 | 0 : (r2 = 0, n2 = n2 + 1 | 0)), t3 >= 18446744073709552e3 || t3 < -18446744073709552e3) throw new Error("Given varint doesn't fit into 10 bytes");
              e2.realloc(10), function(t4, e3, r3) {
                r3.buf[r3.pos++] = 127 & t4 | 128, t4 >>>= 7, r3.buf[r3.pos++] = 127 & t4 | 128, t4 >>>= 7, r3.buf[r3.pos++] = 127 & t4 | 128, t4 >>>= 7, r3.buf[r3.pos++] = 127 & t4 | 128, r3.buf[r3.pos] = 127 & (t4 >>>= 7);
              }(r2, 0, e2), function(t4, e3) {
                const r3 = (7 & t4) << 4;
                e3.buf[e3.pos++] |= r3 | ((t4 >>>= 3) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4 | ((t4 >>>= 7) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4 | ((t4 >>>= 7) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4 | ((t4 >>>= 7) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4 | ((t4 >>>= 7) ? 128 : 0), t4 && (e3.buf[e3.pos++] = 127 & t4)))));
              }(n2, e2);
            }(t2, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t2 | (t2 > 127 ? 128 : 0), t2 <= 127 || (this.buf[this.pos++] = 127 & (t2 >>>= 7) | (t2 > 127 ? 128 : 0), t2 <= 127 || (this.buf[this.pos++] = 127 & (t2 >>>= 7) | (t2 > 127 ? 128 : 0), t2 <= 127 || (this.buf[this.pos++] = t2 >>> 7 & 127))));
          }
          writeSVarint(t2) {
            this.writeVarint(t2 < 0 ? 2 * -t2 - 1 : 2 * t2);
          }
          writeBoolean(t2) {
            this.writeVarint(+t2);
          }
          writeString(t2) {
            t2 = String(t2), this.realloc(4 * t2.length), this.pos++;
            const e2 = this.pos;
            this.pos = function(t3, e3, r3) {
              for (let n2, i2, s2 = 0; s2 < e3.length; s2++) {
                if (n2 = e3.charCodeAt(s2), n2 > 55295 && n2 < 57344) {
                  if (!i2) {
                    n2 > 56319 || s2 + 1 === e3.length ? (t3[r3++] = 239, t3[r3++] = 191, t3[r3++] = 189) : i2 = n2;
                    continue;
                  }
                  if (n2 < 56320) {
                    t3[r3++] = 239, t3[r3++] = 191, t3[r3++] = 189, i2 = n2;
                    continue;
                  }
                  n2 = i2 - 55296 << 10 | n2 - 56320 | 65536, i2 = null;
                } else i2 && (t3[r3++] = 239, t3[r3++] = 191, t3[r3++] = 189, i2 = null);
                n2 < 128 ? t3[r3++] = n2 : (n2 < 2048 ? t3[r3++] = n2 >> 6 | 192 : (n2 < 65536 ? t3[r3++] = n2 >> 12 | 224 : (t3[r3++] = n2 >> 18 | 240, t3[r3++] = n2 >> 12 & 63 | 128), t3[r3++] = n2 >> 6 & 63 | 128), t3[r3++] = 63 & n2 | 128);
              }
              return r3;
            }(this.buf, t2, this.pos);
            const r2 = this.pos - e2;
            r2 >= 128 && Ec(e2, r2, this), this.pos = e2 - 1, this.writeVarint(r2), this.pos += r2;
          }
          writeFloat(t2) {
            this.realloc(4), this.dataView.setFloat32(this.pos, t2, true), this.pos += 4;
          }
          writeDouble(t2) {
            this.realloc(8), this.dataView.setFloat64(this.pos, t2, true), this.pos += 8;
          }
          writeBytes(t2) {
            const e2 = t2.length;
            this.writeVarint(e2), this.realloc(e2);
            for (let r2 = 0; r2 < e2; r2++) this.buf[this.pos++] = t2[r2];
          }
          writeRawMessage(t2, e2) {
            this.pos++;
            const r2 = this.pos;
            t2(e2, this);
            const n2 = this.pos - r2;
            n2 >= 128 && Ec(r2, n2, this), this.pos = r2 - 1, this.writeVarint(n2), this.pos += n2;
          }
          writeMessage(t2, e2, r2) {
            this.writeTag(t2, 2), this.writeRawMessage(e2, r2);
          }
          writePackedVarint(t2, e2) {
            e2.length && this.writeMessage(t2, Tc, e2);
          }
          writePackedSVarint(t2, e2) {
            e2.length && this.writeMessage(t2, Ic, e2);
          }
          writePackedBoolean(t2, e2) {
            e2.length && this.writeMessage(t2, Dc, e2);
          }
          writePackedFloat(t2, e2) {
            e2.length && this.writeMessage(t2, Mc, e2);
          }
          writePackedDouble(t2, e2) {
            e2.length && this.writeMessage(t2, Fc, e2);
          }
          writePackedFixed32(t2, e2) {
            e2.length && this.writeMessage(t2, Pc, e2);
          }
          writePackedSFixed32(t2, e2) {
            e2.length && this.writeMessage(t2, zc, e2);
          }
          writePackedFixed64(t2, e2) {
            e2.length && this.writeMessage(t2, Bc, e2);
          }
          writePackedSFixed64(t2, e2) {
            e2.length && this.writeMessage(t2, Vc, e2);
          }
          writeBytesField(t2, e2) {
            this.writeTag(t2, 2), this.writeBytes(e2);
          }
          writeFixed32Field(t2, e2) {
            this.writeTag(t2, 5), this.writeFixed32(e2);
          }
          writeSFixed32Field(t2, e2) {
            this.writeTag(t2, 5), this.writeSFixed32(e2);
          }
          writeFixed64Field(t2, e2) {
            this.writeTag(t2, 1), this.writeFixed64(e2);
          }
          writeSFixed64Field(t2, e2) {
            this.writeTag(t2, 1), this.writeSFixed64(e2);
          }
          writeVarintField(t2, e2) {
            this.writeTag(t2, 0), this.writeVarint(e2);
          }
          writeSVarintField(t2, e2) {
            this.writeTag(t2, 0), this.writeSVarint(e2);
          }
          writeStringField(t2, e2) {
            this.writeTag(t2, 2), this.writeString(e2);
          }
          writeFloatField(t2, e2) {
            this.writeTag(t2, 5), this.writeFloat(e2);
          }
          writeDoubleField(t2, e2) {
            this.writeTag(t2, 1), this.writeDouble(e2);
          }
          writeBooleanField(t2, e2) {
            this.writeVarintField(t2, +e2);
          }
        }
        function kc(t2, e2, r2) {
          return r2 ? 4294967296 * e2 + (t2 >>> 0) : 4294967296 * (e2 >>> 0) + (t2 >>> 0);
        }
        function Ec(t2, e2, r2) {
          const n2 = e2 <= 16383 ? 1 : e2 <= 2097151 ? 2 : e2 <= 268435455 ? 3 : Math.floor(Math.log(e2) / (7 * Math.LN2));
          r2.realloc(n2);
          for (let e3 = r2.pos - 1; e3 >= t2; e3--) r2.buf[e3 + n2] = r2.buf[e3];
        }
        function Tc(t2, e2) {
          for (let r2 = 0; r2 < t2.length; r2++) e2.writeVarint(t2[r2]);
        }
        function Ic(t2, e2) {
          for (let r2 = 0; r2 < t2.length; r2++) e2.writeSVarint(t2[r2]);
        }
        function Mc(t2, e2) {
          for (let r2 = 0; r2 < t2.length; r2++) e2.writeFloat(t2[r2]);
        }
        function Fc(t2, e2) {
          for (let r2 = 0; r2 < t2.length; r2++) e2.writeDouble(t2[r2]);
        }
        function Dc(t2, e2) {
          for (let r2 = 0; r2 < t2.length; r2++) e2.writeBoolean(t2[r2]);
        }
        function Pc(t2, e2) {
          for (let r2 = 0; r2 < t2.length; r2++) e2.writeFixed32(t2[r2]);
        }
        function zc(t2, e2) {
          for (let r2 = 0; r2 < t2.length; r2++) e2.writeSFixed32(t2[r2]);
        }
        function Bc(t2, e2) {
          for (let r2 = 0; r2 < t2.length; r2++) e2.writeFixed64(t2[r2]);
        }
        function Vc(t2, e2) {
          for (let r2 = 0; r2 < t2.length; r2++) e2.writeSFixed64(t2[r2]);
        }
        function Cc(t2, e2, r2) {
          1 === t2 && r2.readMessage(Lc, e2);
        }
        function Lc(t2, e2, r2) {
          if (3 === t2) {
            const { id: t3, bitmap: n2, width: i2, height: s2, left: o2, top: a2, advance: l2 } = r2.readMessage(Oc, {});
            e2.push({ id: t3, bitmap: new vl({ width: i2 + 6, height: s2 + 6 }, n2), metrics: { width: i2, height: s2, left: o2, top: a2, advance: l2 } });
          }
        }
        function Oc(t2, e2, r2) {
          1 === t2 ? e2.id = r2.readVarint() : 2 === t2 ? e2.bitmap = r2.readBytes() : 3 === t2 ? e2.width = r2.readVarint() : 4 === t2 ? e2.height = r2.readVarint() : 5 === t2 ? e2.left = r2.readSVarint() : 6 === t2 ? e2.top = r2.readSVarint() : 7 === t2 && (e2.advance = r2.readVarint());
        }
        function Rc(t2) {
          let e2 = 0, r2 = 0;
          for (const n3 of t2) e2 += n3.w * n3.h, r2 = Math.max(r2, n3.w);
          t2.sort((t3, e3) => e3.h - t3.h);
          const n2 = [{ x: 0, y: 0, w: Math.max(Math.ceil(Math.sqrt(e2 / 0.95)), r2), h: 1 / 0 }];
          let i2 = 0, s2 = 0;
          for (const e3 of t2) for (let t3 = n2.length - 1; t3 >= 0; t3--) {
            const r3 = n2[t3];
            if (!(e3.w > r3.w || e3.h > r3.h)) {
              if (e3.x = r3.x, e3.y = r3.y, s2 = Math.max(s2, e3.y + e3.h), i2 = Math.max(i2, e3.x + e3.w), e3.w === r3.w && e3.h === r3.h) {
                const e4 = n2.pop();
                e4 && t3 < n2.length && (n2[t3] = e4);
              } else e3.h === r3.h ? (r3.x += e3.w, r3.w -= e3.w) : e3.w === r3.w ? (r3.y += e3.h, r3.h -= e3.h) : (n2.push({ x: r3.x + e3.w, y: r3.y, w: r3.w - e3.w, h: e3.h }), r3.y += e3.h, r3.h -= e3.h);
              break;
            }
          }
          return { w: i2, h: s2, fill: e2 / (i2 * s2) || 0 };
        }
        class Nc {
          constructor(t2, { pixelRatio: e2, version: r2, stretchX: n2, stretchY: i2, content: s2, textFitWidth: o2, textFitHeight: a2 }) {
            this.paddedRect = t2, this.pixelRatio = e2, this.stretchX = n2, this.stretchY = i2, this.content = s2, this.version = r2, this.textFitWidth = o2, this.textFitHeight = a2;
          }
          get tl() {
            return [this.paddedRect.x + 1, this.paddedRect.y + 1];
          }
          get br() {
            return [this.paddedRect.x + this.paddedRect.w - 1, this.paddedRect.y + this.paddedRect.h - 1];
          }
          get tlbr() {
            return this.tl.concat(this.br);
          }
          get displaySize() {
            return [(this.paddedRect.w - 2) / this.pixelRatio, (this.paddedRect.h - 2) / this.pixelRatio];
          }
        }
        class $c {
          constructor(t2, e2) {
            const r2 = {}, n2 = {};
            this.haveRenderCallbacks = [];
            const i2 = [];
            this.addImages(t2, r2, i2), this.addImages(e2, n2, i2);
            const { w: s2, h: o2 } = Rc(i2), a2 = new bl({ width: s2 || 1, height: o2 || 1 });
            for (const e3 in t2) {
              const n3 = t2[e3], i3 = r2[e3].paddedRect;
              bl.copy(n3.data, a2, { x: 0, y: 0 }, { x: i3.x + 1, y: i3.y + 1 }, n3.data);
            }
            for (const t3 in e2) {
              const r3 = e2[t3], i3 = n2[t3].paddedRect, s3 = i3.x + 1, o3 = i3.y + 1, l2 = r3.data.width, u2 = r3.data.height;
              bl.copy(r3.data, a2, { x: 0, y: 0 }, { x: s3, y: o3 }, r3.data), bl.copy(r3.data, a2, { x: 0, y: u2 - 1 }, { x: s3, y: o3 - 1 }, { width: l2, height: 1 }), bl.copy(r3.data, a2, { x: 0, y: 0 }, { x: s3, y: o3 + u2 }, { width: l2, height: 1 }), bl.copy(r3.data, a2, { x: l2 - 1, y: 0 }, { x: s3 - 1, y: o3 }, { width: 1, height: u2 }), bl.copy(r3.data, a2, { x: 0, y: 0 }, { x: s3 + l2, y: o3 }, { width: 1, height: u2 });
            }
            this.image = a2, this.iconPositions = r2, this.patternPositions = n2;
          }
          addImages(t2, e2, r2) {
            for (const n2 in t2) {
              const i2 = t2[n2], s2 = { x: 0, y: 0, w: i2.data.width + 2, h: i2.data.height + 2 };
              r2.push(s2), e2[n2] = new Nc(s2, i2), i2.hasRenderCallback && this.haveRenderCallbacks.push(n2);
            }
          }
          patchUpdatedImages(t2, e2) {
            t2.dispatchRenderCallbacks(this.haveRenderCallbacks);
            for (const r2 in t2.updatedImages) this.patchUpdatedImage(this.iconPositions[r2], t2.getImage(r2), e2), this.patchUpdatedImage(this.patternPositions[r2], t2.getImage(r2), e2);
          }
          patchUpdatedImage(t2, e2, r2) {
            if (!t2 || !e2) return;
            if (t2.version === e2.version) return;
            t2.version = e2.version;
            const [n2, i2] = t2.tl;
            r2.update(e2.data, void 0, { x: n2, y: i2 });
          }
        }
        var Uc;
        function qc(e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2, f2, d2, y2) {
          const m2 = bc.fromFeature(e2, s2);
          let g2;
          p2 === t.aA.vertical && m2.verticalizePunctuation();
          let x2 = m2.determineLineBreaks(c2, o2, r2, i2, d2);
          const { processBidirectionalText: v2, processStyledBidirectionalText: b2 } = Ms;
          if (v2 && 1 === m2.sections.length) {
            g2 = [], x2 = x2.map((t3) => m2.toCodeUnitIndex(t3));
            const t2 = v2(m2.toString(), x2);
            for (const e3 of t2) {
              const t3 = [...e3].map(() => 0);
              g2.push(new bc(e3, m2.sections, t3));
            }
          } else if (b2) {
            g2 = [], x2 = x2.map((t3) => m2.toCodeUnitIndex(t3));
            let t2 = 0;
            const e3 = [];
            for (const r4 of m2.text) e3.push(...Array(r4.length).fill(m2.sectionIndex[t2])), t2++;
            const r3 = b2(m2.text, e3, x2);
            for (const t3 of r3) {
              const e4 = [];
              let r4 = "";
              for (const n3 of t3[0]) e4.push(t3[1][r4.length]), r4 += n3;
              g2.push(new bc(t3[0], m2.sections, e4));
            }
          } else g2 = function(t2, e3) {
            const r3 = [];
            let n3 = 0;
            for (const i3 of e3) r3.push(t2.substring(n3, i3)), n3 = i3;
            return n3 < t2.length() && r3.push(t2.substring(n3, t2.length())), r3;
          }(m2, x2);
          const w2 = [], _2 = { positionedLines: w2, text: m2.toString(), top: h2[1], bottom: h2[1], left: h2[0], right: h2[0], writingMode: p2, iconsInText: false, verticalizable: false };
          return function(t2, e3, r3, n3, i3, s3, o3, a3, l3, u3, c3, h3) {
            let p3 = 0, f3 = 0, d3 = 0, y3 = 0;
            const m3 = "right" === a3 ? 1 : "left" === a3 ? 0 : 0.5, g3 = hc / h3;
            let x3 = 0;
            for (const o4 of i3) {
              o4.trim();
              const i4 = o4.getMaxScale(), a4 = { positionedGlyphs: [], lineOffset: 0 };
              t2.positionedLines[x3] = a4;
              const h4 = a4.positionedGlyphs;
              let v4 = 0;
              if (!o4.length()) {
                f3 += s3, ++x3;
                continue;
              }
              const b4 = Gc(n3, o4, g3);
              let w3 = 0;
              for (const s4 of o4.text) {
                const a5 = o4.getSection(w3), d4 = s4.codePointAt(0), y4 = Yc(l3, c3, d4), m4 = { glyph: d4, imageName: null, x: p3, y: f3 + -17, vertical: y4, scale: 1, fontStack: "", sectionIndex: o4.getSectionIndex(w3), metrics: null, rect: null };
                let x4;
                if ("fontStack" in a5) {
                  if (x4 = Zc(a5, d4, y4, b4, e3, r3), !x4) continue;
                  m4.fontStack = a5.fontStack;
                } else {
                  if (t2.iconsInText = true, a5.scale *= g3, x4 = Hc(a5, y4, i4, b4, n3), !x4) continue;
                  v4 = Math.max(v4, x4.imageOffset), m4.imageName = a5.imageName;
                }
                const { rect: _4, metrics: A2, baselineOffset: S2 } = x4;
                m4.y += S2, m4.scale = a5.scale, m4.metrics = A2, m4.rect = _4, h4.push(m4), y4 ? (t2.verticalizable = true, p3 += ("imageName" in a5 ? A2.advance : hc) * a5.scale + u3) : p3 += A2.advance * a5.scale + u3, w3++;
              }
              0 !== h4.length && (d3 = Math.max(p3 - u3, d3), Kc(h4, 0, h4.length - 1, m3)), p3 = 0, a4.lineOffset = Math.max(v4, (i4 - 1) * hc);
              const _3 = s3 * i4 + v4;
              f3 += _3, y3 = Math.max(_3, y3), ++x3;
            }
            const { horizontalAlign: v3, verticalAlign: b3 } = jc(o3);
            (function(t3, e4, r4, n4, i4, s4, o4, a4, l4) {
              const u4 = (e4 - r4) * i4;
              let c4 = 0;
              c4 = s4 !== o4 ? -a4 * n4 - -17 : -n4 * l4 * o4 + 0.5 * o4;
              for (const e5 of t3) for (const t4 of e5.positionedGlyphs) t4.x += u4, t4.y += c4;
            })(t2.positionedLines, m3, v3, b3, d3, y3, s3, f3, i3.length), t2.top += -b3 * f3, t2.bottom = t2.top + f3, t2.left += -v3 * d3, t2.right = t2.left + d3;
          }(_2, r2, n2, i2, g2, a2, l2, u2, p2, c2, f2, y2), !function(t2) {
            for (const e3 of t2) if (0 !== e3.positionedGlyphs.length) return false;
            return true;
          }(w2) && _2;
        }
        function jc(t2) {
          let e2 = 0.5, r2 = 0.5;
          switch (t2) {
            case "right":
            case "top-right":
            case "bottom-right":
              e2 = 1;
              break;
            case "left":
            case "top-left":
            case "bottom-left":
              e2 = 0;
          }
          switch (t2) {
            case "bottom":
            case "bottom-right":
            case "bottom-left":
              r2 = 1;
              break;
            case "top":
            case "top-right":
            case "top-left":
              r2 = 0;
          }
          return { horizontalAlign: e2, verticalAlign: r2 };
        }
        function Gc(t2, e2, r2) {
          const n2 = e2.getMaxScale() * hc, { maxImageWidth: i2, maxImageHeight: s2 } = e2.getMaxImageSize(t2), o2 = Math.max(n2, s2 * r2);
          return { verticalLineContentWidth: Math.max(n2, i2 * r2), horizontalLineContentHeight: o2 };
        }
        function Xc(t2) {
          switch (t2) {
            case "top":
              return 0;
            case "center":
              return 0.5;
            default:
              return 1;
          }
        }
        function Yc(e2, r2, n2) {
          return !(e2 === t.aA.horizontal || !r2 && !gs(n2) || r2 && (xs(n2) || (i2 = n2, new RegExp("\\p{sc=Arab}", "u").test(String.fromCodePoint(i2)))));
          var i2;
        }
        function Zc(t2, e2, r2, n2, i2, s2) {
          const o2 = s2[t2.fontStack], a2 = function(t3, e3, r3, n3) {
            if (t3 && t3.rect) return t3;
            const i3 = e3[r3.fontStack], s3 = i3 && i3[n3];
            return s3 ? { rect: null, metrics: s3.metrics } : null;
          }(o2 && o2[e2], i2, t2, e2);
          if (null === a2) return null;
          let l2;
          if (r2) l2 = n2.verticalLineContentWidth - t2.scale * hc;
          else {
            const e3 = Xc(t2.verticalAlign);
            l2 = (n2.horizontalLineContentHeight - t2.scale * hc) * e3;
          }
          return { rect: a2.rect, metrics: a2.metrics, baselineOffset: l2 };
        }
        function Hc(t2, e2, r2, n2, i2) {
          const s2 = i2[t2.imageName];
          if (!s2) return null;
          const o2 = s2.paddedRect, a2 = s2.displaySize, l2 = { width: a2[0], height: a2[1], left: 1, top: -3, advance: e2 ? a2[1] : a2[0] };
          let u2;
          if (e2) u2 = n2.verticalLineContentWidth - a2[1] * t2.scale;
          else {
            const e3 = Xc(t2.verticalAlign);
            u2 = (n2.horizontalLineContentHeight - a2[1] * t2.scale) * e3;
          }
          return { rect: o2, metrics: l2, baselineOffset: u2, imageOffset: (e2 ? a2[0] : a2[1]) * t2.scale - hc * r2 };
        }
        function Kc(t2, e2, r2, n2) {
          if (0 === n2) return;
          const i2 = t2[r2], s2 = (t2[r2].x + i2.metrics.advance * i2.scale) * n2;
          for (let n3 = e2; n3 <= r2; n3++) t2[n3].x -= s2;
        }
        function Wc(t2, e2, r2) {
          const { horizontalAlign: n2, verticalAlign: i2 } = jc(r2), s2 = e2[0] - t2.displaySize[0] * n2, o2 = e2[1] - t2.displaySize[1] * i2;
          return { image: t2, top: o2, bottom: o2 + t2.displaySize[1], left: s2, right: s2 + t2.displaySize[0] };
        }
        function Jc(t2) {
          var e2, r2;
          let n2 = t2.left, i2 = t2.top, s2 = t2.right - n2, o2 = t2.bottom - i2;
          const a2 = null !== (e2 = t2.image.textFitWidth) && void 0 !== e2 ? e2 : "stretchOrShrink", l2 = null !== (r2 = t2.image.textFitHeight) && void 0 !== r2 ? r2 : "stretchOrShrink", u2 = (t2.image.content[2] - t2.image.content[0]) / (t2.image.content[3] - t2.image.content[1]);
          if ("proportional" === l2) {
            if ("stretchOnly" === a2 && s2 / o2 < u2 || "proportional" === a2) {
              const t3 = Math.ceil(o2 * u2);
              n2 *= t3 / s2, s2 = t3;
            }
          } else if ("proportional" === a2 && "stretchOnly" === l2 && 0 !== u2 && s2 / o2 > u2) {
            const t3 = Math.ceil(s2 / u2);
            i2 *= t3 / o2, o2 = t3;
          }
          return { x1: n2, y1: i2, x2: n2 + s2, y2: i2 + o2 };
        }
        function Qc(t2, e2, r2, n2, i2, s2) {
          const o2 = t2.image;
          let a2;
          if (o2.content) {
            const t3 = o2.content, e3 = o2.pixelRatio || 1;
            a2 = [t3[0] / e3, t3[1] / e3, o2.displaySize[0] - t3[2] / e3, o2.displaySize[1] - t3[3] / e3];
          }
          const l2 = e2.left * s2, u2 = e2.right * s2;
          let c2, h2, p2, f2;
          "width" === r2 || "both" === r2 ? (f2 = i2[0] + l2 - n2[3], h2 = i2[0] + u2 + n2[1]) : (f2 = i2[0] + (l2 + u2 - o2.displaySize[0]) / 2, h2 = f2 + o2.displaySize[0]);
          const d2 = e2.top * s2, y2 = e2.bottom * s2;
          return "height" === r2 || "both" === r2 ? (c2 = i2[1] + d2 - n2[0], p2 = i2[1] + y2 + n2[2]) : (c2 = i2[1] + (d2 + y2 - o2.displaySize[1]) / 2, p2 = c2 + o2.displaySize[1]), { image: o2, top: c2, right: h2, bottom: p2, left: f2, collisionPadding: a2 };
        }
        us("ImagePosition", Nc), us("ImageAtlas", $c), t.aA = void 0, (Uc = t.aA || (t.aA = {}))[Uc.none = 0] = "none", Uc[Uc.horizontal = 1] = "horizontal", Uc[Uc.vertical = 2] = "vertical", Uc[Uc.horizontalOnly = 3] = "horizontalOnly";
        const th = 128, eh = 32640;
        function rh(t2, e2) {
          const { expression: r2 } = e2;
          if ("constant" === r2.kind) return { kind: "constant", layoutSize: r2.evaluate(new Fs(t2 + 1)) };
          if ("source" === r2.kind) return { kind: "source" };
          {
            const { zoomStops: e3, interpolationType: n2 } = r2;
            let i2 = 0;
            for (; i2 < e3.length && e3[i2] <= t2; ) i2++;
            i2 = Math.max(0, i2 - 1);
            let s2 = i2;
            for (; s2 < e3.length && e3[s2] < t2 + 1; ) s2++;
            s2 = Math.min(e3.length - 1, s2);
            const o2 = e3[i2], a2 = e3[s2];
            return "composite" === r2.kind ? { kind: "composite", minZoom: o2, maxZoom: a2, interpolationType: n2 } : { kind: "camera", minZoom: o2, maxZoom: a2, minSize: r2.evaluate(new Fs(o2)), maxSize: r2.evaluate(new Fs(a2)), interpolationType: n2 };
          }
        }
        function nh(t2, e2, r2) {
          let n2 = "never";
          const i2 = t2.get(e2);
          return i2 ? n2 = i2 : t2.get(r2) && (n2 = "always"), n2;
        }
        const ih = [{ name: "a_fade_opacity", components: 1, type: "Uint8", offset: 0 }];
        function sh(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2) {
          const f2 = a2 ? Math.min(eh, Math.round(a2[0])) : 0, d2 = a2 ? Math.min(eh, Math.round(a2[1])) : 0;
          t2.emplaceBack(e2, r2, Math.round(32 * n2), Math.round(32 * i2), s2, o2, (f2 << 1) + (l2 ? 1 : 0), d2, 16 * u2, 16 * c2, 256 * h2, 256 * p2);
        }
        function oh(t2, e2, r2) {
          t2.emplaceBack(e2.x, e2.y, r2), t2.emplaceBack(e2.x, e2.y, r2), t2.emplaceBack(e2.x, e2.y, r2), t2.emplaceBack(e2.x, e2.y, r2);
        }
        function ah(t2) {
          for (const e2 of t2.sections) if (Is(e2.text)) return true;
          return false;
        }
        class lh {
          constructor(t2) {
            this.layoutVertexArray = new Yo(), this.indexArray = new Jo(), this.programConfigurations = t2, this.segments = new ra(), this.dynamicLayoutVertexArray = new Zo(), this.opacityVertexArray = new Ho(), this.hasVisibleVertices = false, this.placedSymbolArray = new Fo();
          }
          isEmpty() {
            return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
          }
          upload(t2, e2, r2, n2) {
            this.isEmpty() || (r2 && (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, sc.members), this.indexBuffer = t2.createIndexBuffer(this.indexArray, e2), this.dynamicLayoutVertexBuffer = t2.createVertexBuffer(this.dynamicLayoutVertexArray, oc.members, true), this.opacityVertexBuffer = t2.createVertexBuffer(this.opacityVertexArray, ih, true), this.opacityVertexBuffer.itemSize = 1), (r2 || n2) && this.programConfigurations.upload(t2));
          }
          destroy() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
          }
        }
        us("SymbolBuffers", lh);
        class uh {
          constructor(t2, e2, r2) {
            this.layoutVertexArray = new t2(), this.layoutAttributes = e2, this.indexArray = new r2(), this.segments = new ra(), this.collisionVertexArray = new Wo();
          }
          upload(t2) {
            this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t2.createVertexBuffer(this.collisionVertexArray, ac.members, true);
          }
          destroy() {
            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
          }
        }
        us("CollisionBuffers", uh);
        class ch {
          constructor(e2) {
            this.collisionBoxArray = e2.collisionBoxArray, this.zoom = e2.zoom, this.overscaling = e2.overscaling, this.layers = e2.layers, this.layerIds = this.layers.map((t2) => t2.id), this.index = e2.index, this.pixelRatio = e2.pixelRatio, this.sourceLayerIndex = e2.sourceLayerIndex, this.hasDependencies = false, this.hasRTLText = false, this.sortKeyRanges = [], this.collisionCircleArray = [];
            const r2 = this.layers[0]._unevaluatedLayout._values;
            this.textSizeData = rh(this.zoom, r2["text-size"]), this.iconSizeData = rh(this.zoom, r2["icon-size"]);
            const n2 = this.layers[0].layout, i2 = n2.get("symbol-sort-key"), s2 = n2.get("symbol-z-order");
            this.canOverlap = "never" !== nh(n2, "text-overlap", "text-allow-overlap") || "never" !== nh(n2, "icon-overlap", "icon-allow-overlap") || n2.get("text-ignore-placement") || n2.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== s2 && !i2.isConstant(), this.sortFeaturesByY = ("viewport-y" === s2 || "auto" === s2 && !this.sortFeaturesByKey) && this.canOverlap, "point" === n2.get("symbol-placement") && (this.writingModes = n2.get("text-writing-mode").map((e3) => t.aA[e3])), this.stateDependentLayerIds = this.layers.filter((t2) => t2.isStateDependent()).map((t2) => t2.id), this.sourceID = e2.sourceID;
          }
          createArrays() {
            this.text = new lh(new Pa(this.layers, this.zoom, (t2) => /^text/.test(t2))), this.icon = new lh(new Pa(this.layers, this.zoom, (t2) => /^icon/.test(t2))), this.glyphOffsetArray = new zo(), this.lineVertexArray = new Bo(), this.symbolInstances = new Po(), this.textAnchorOffsets = new Co();
          }
          calculateGlyphDependencies(t2, e2, r2, n2, i2) {
            for (const s2 of t2) if (e2[s2.codePointAt(0)] = true, (r2 || n2) && i2) {
              const t3 = pc[s2];
              t3 && (e2[t3.codePointAt(0)] = true);
            }
          }
          populate(e2, r2, n2) {
            const i2 = this.layers[0], s2 = i2.layout, o2 = s2.get("text-font"), a2 = s2.get("text-field"), l2 = s2.get("icon-image"), u2 = ("constant" !== a2.value.kind || a2.value.value instanceof De && !a2.value.value.isEmpty() || a2.value.value.toString().length > 0) && ("constant" !== o2.value.kind || o2.value.value.length > 0), c2 = "constant" !== l2.value.kind || !!l2.value.value || Object.keys(l2.parameters).length > 0, h2 = s2.get("symbol-sort-key");
            if (this.features = [], !u2 && !c2) return;
            const p2 = r2.iconDependencies, f2 = r2.glyphDependencies, d2 = r2.availableImages, y2 = new Fs(this.zoom);
            for (const { feature: r3, id: a3, index: l3, sourceLayerIndex: m2 } of e2) {
              const e3 = i2._featureFilter.needGeometry, g2 = Oa(r3, e3);
              if (!i2._featureFilter.filter(y2, g2, n2)) continue;
              let x2, v2;
              if (e3 || (g2.geometry = La(r3)), u2) {
                const t2 = i2.getValueAndResolveTokens("text-field", g2, n2, d2), e4 = De.factory(t2), r4 = this.hasRTLText = this.hasRTLText || ah(e4);
                (!r4 || "unavailable" === Ms.getRTLTextPluginStatus() || r4 && Ms.isParsed()) && (x2 = cc(e4, i2, g2));
              }
              if (c2) {
                const t2 = i2.getValueAndResolveTokens("icon-image", g2, n2, d2);
                v2 = t2 instanceof Oe ? t2 : Oe.fromString(t2);
              }
              if (!x2 && !v2) continue;
              const b2 = this.sortFeaturesByKey ? h2.evaluate(g2, {}, n2) : void 0;
              if (this.features.push({ id: a3, text: x2, icon: v2, index: l3, sourceLayerIndex: m2, geometry: g2.geometry, properties: r3.properties, type: Eu.types[r3.type], sortKey: b2 }), v2 && (p2[v2.name] = true), x2) {
                const e4 = o2.evaluate(g2, {}, n2).join(","), r4 = "viewport" !== s2.get("text-rotation-alignment") && "point" !== s2.get("symbol-placement");
                this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(t.aA.vertical) >= 0;
                for (const t2 of x2.sections) if (t2.image) p2[t2.image.name] = true;
                else {
                  const n3 = vs(x2.toString()), i3 = t2.fontStack || e4, s3 = f2[i3] = f2[i3] || {};
                  this.calculateGlyphDependencies(t2.text, s3, r4, this.allowVerticalPlacement, n3);
                }
              }
            }
            "line" === s2.get("symbol-placement") && (this.features = function(t2) {
              const e3 = {}, r3 = {}, n3 = [];
              let i3 = 0;
              function s3(e4) {
                n3.push(t2[e4]), i3++;
              }
              function o3(t3, e4, i4) {
                const s4 = r3[t3];
                return delete r3[t3], r3[e4] = s4, n3[s4].geometry[0].pop(), n3[s4].geometry[0] = n3[s4].geometry[0].concat(i4[0]), s4;
              }
              function a3(t3, r4, i4) {
                const s4 = e3[r4];
                return delete e3[r4], e3[t3] = s4, n3[s4].geometry[0].shift(), n3[s4].geometry[0] = i4[0].concat(n3[s4].geometry[0]), s4;
              }
              function l3(t3, e4, r4) {
                const n4 = r4 ? e4[0][e4[0].length - 1] : e4[0][0];
                return `${t3}:${n4.x}:${n4.y}`;
              }
              for (let u3 = 0; u3 < t2.length; u3++) {
                const c3 = t2[u3], h3 = c3.geometry, p3 = c3.text ? c3.text.toString() : null;
                if (!p3) {
                  s3(u3);
                  continue;
                }
                const f3 = l3(p3, h3), d3 = l3(p3, h3, true);
                if (f3 in r3 && d3 in e3 && r3[f3] !== e3[d3]) {
                  const t3 = a3(f3, d3, h3), i4 = o3(f3, d3, n3[t3].geometry);
                  delete e3[f3], delete r3[d3], r3[l3(p3, n3[i4].geometry, true)] = i4, n3[t3].geometry = null;
                } else f3 in r3 ? o3(f3, d3, h3) : d3 in e3 ? a3(f3, d3, h3) : (s3(u3), e3[f3] = i3 - 1, r3[d3] = i3 - 1);
              }
              return n3.filter((t3) => t3.geometry);
            }(this.features)), this.sortFeaturesByKey && this.features.sort((t2, e3) => t2.sortKey - e3.sortKey);
          }
          update(t2, e2, r2) {
            this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t2, e2, this.layers, { imagePositions: r2 }), this.icon.programConfigurations.updatePaintArrays(t2, e2, this.layers, { imagePositions: r2 }));
          }
          isEmpty() {
            return 0 === this.symbolInstances.length && !this.hasRTLText;
          }
          uploadPending() {
            return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
          }
          upload(t2) {
            !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t2), this.iconCollisionBox.upload(t2)), this.text.upload(t2, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t2, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = true;
          }
          destroyDebugData() {
            this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
          }
          destroy() {
            this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
          }
          addToLineVertexArray(t2, e2) {
            const r2 = this.lineVertexArray.length;
            if (void 0 !== t2.segment) {
              let r3 = t2.dist(e2[t2.segment + 1]), n2 = t2.dist(e2[t2.segment]);
              const i2 = {};
              for (let n3 = t2.segment + 1; n3 < e2.length; n3++) i2[n3] = { x: e2[n3].x, y: e2[n3].y, tileUnitDistanceFromAnchor: r3 }, n3 < e2.length - 1 && (r3 += e2[n3 + 1].dist(e2[n3]));
              for (let r4 = t2.segment || 0; r4 >= 0; r4--) i2[r4] = { x: e2[r4].x, y: e2[r4].y, tileUnitDistanceFromAnchor: n2 }, r4 > 0 && (n2 += e2[r4 - 1].dist(e2[r4]));
              for (let t3 = 0; t3 < e2.length; t3++) {
                const e3 = i2[t3];
                this.lineVertexArray.emplaceBack(e3.x, e3.y, e3.tileUnitDistanceFromAnchor);
              }
            }
            return { lineStartIndex: r2, lineLength: this.lineVertexArray.length - r2 };
          }
          addSymbols(e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2) {
            const f2 = e2.indexArray, d2 = e2.layoutVertexArray, y2 = e2.segments.prepareSegment(4 * r2.length, d2, f2, this.canOverlap ? o2.sortKey : void 0), m2 = this.glyphOffsetArray.length, g2 = y2.vertexLength, x2 = this.allowVerticalPlacement && a2 === t.aA.vertical ? Math.PI / 2 : 0, v2 = o2.text && o2.text.sections;
            for (let t2 = 0; t2 < r2.length; t2++) {
              const { tl: i3, tr: s3, bl: a3, br: u3, tex: c3, pixelOffsetTL: h3, pixelOffsetBR: m3, minFontScaleX: g3, minFontScaleY: b2, glyphOffset: w2, isSDF: _2, sectionIndex: A2 } = r2[t2], S2 = y2.vertexLength, k2 = w2[1];
              sh(d2, l2.x, l2.y, i3.x, k2 + i3.y, c3.x, c3.y, n2, _2, h3.x, h3.y, g3, b2), sh(d2, l2.x, l2.y, s3.x, k2 + s3.y, c3.x + c3.w, c3.y, n2, _2, m3.x, h3.y, g3, b2), sh(d2, l2.x, l2.y, a3.x, k2 + a3.y, c3.x, c3.y + c3.h, n2, _2, h3.x, m3.y, g3, b2), sh(d2, l2.x, l2.y, u3.x, k2 + u3.y, c3.x + c3.w, c3.y + c3.h, n2, _2, m3.x, m3.y, g3, b2), oh(e2.dynamicLayoutVertexArray, l2, x2), f2.emplaceBack(S2, S2 + 2, S2 + 1), f2.emplaceBack(S2 + 1, S2 + 2, S2 + 3), y2.vertexLength += 4, y2.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(w2[0]), t2 !== r2.length - 1 && A2 === r2[t2 + 1].sectionIndex || e2.programConfigurations.populatePaintArrays(d2.length, o2, o2.index, { imagePositions: {}, canonical: p2, formattedSection: v2 && v2[A2] });
            }
            e2.placedSymbolArray.emplaceBack(l2.x, l2.y, m2, this.glyphOffsetArray.length - m2, g2, u2, c2, l2.segment, n2 ? n2[0] : 0, n2 ? n2[1] : 0, i2[0], i2[1], a2, 0, false, 0, h2);
          }
          _addCollisionDebugVertex(t2, e2, r2, n2, i2, s2) {
            return e2.emplaceBack(0, 0), t2.emplaceBack(r2.x, r2.y, n2, i2, Math.round(s2.x), Math.round(s2.y));
          }
          addCollisionDebugVertices(t2, e2, n2, i2, s2, o2, a2) {
            const l2 = s2.segments.prepareSegment(4, s2.layoutVertexArray, s2.indexArray), u2 = l2.vertexLength, c2 = s2.layoutVertexArray, h2 = s2.collisionVertexArray, p2 = a2.anchorX, f2 = a2.anchorY;
            this._addCollisionDebugVertex(c2, h2, o2, p2, f2, new r(t2, e2)), this._addCollisionDebugVertex(c2, h2, o2, p2, f2, new r(n2, e2)), this._addCollisionDebugVertex(c2, h2, o2, p2, f2, new r(n2, i2)), this._addCollisionDebugVertex(c2, h2, o2, p2, f2, new r(t2, i2)), l2.vertexLength += 4;
            const d2 = s2.indexArray;
            d2.emplaceBack(u2, u2 + 1), d2.emplaceBack(u2 + 1, u2 + 2), d2.emplaceBack(u2 + 2, u2 + 3), d2.emplaceBack(u2 + 3, u2), l2.primitiveLength += 4;
          }
          addDebugCollisionBoxes(t2, e2, r2, n2) {
            for (let i2 = t2; i2 < e2; i2++) {
              const t3 = this.collisionBoxArray.get(i2);
              this.addCollisionDebugVertices(t3.x1, t3.y1, t3.x2, t3.y2, n2 ? this.textCollisionBox : this.iconCollisionBox, t3.anchorPoint, r2);
            }
          }
          generateCollisionDebugBuffers() {
            this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new uh(Ko, lc.members, Qo), this.iconCollisionBox = new uh(Ko, lc.members, Qo);
            for (let t2 = 0; t2 < this.symbolInstances.length; t2++) {
              const e2 = this.symbolInstances.get(t2);
              this.addDebugCollisionBoxes(e2.textBoxStartIndex, e2.textBoxEndIndex, e2, true), this.addDebugCollisionBoxes(e2.verticalTextBoxStartIndex, e2.verticalTextBoxEndIndex, e2, true), this.addDebugCollisionBoxes(e2.iconBoxStartIndex, e2.iconBoxEndIndex, e2, false), this.addDebugCollisionBoxes(e2.verticalIconBoxStartIndex, e2.verticalIconBoxEndIndex, e2, false);
            }
          }
          _deserializeCollisionBoxesForSymbol(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            const u2 = {};
            for (let n3 = e2; n3 < r2; n3++) {
              const e3 = t2.get(n3);
              u2.textBox = { x1: e3.x1, y1: e3.y1, x2: e3.x2, y2: e3.y2, anchorPointX: e3.anchorPointX, anchorPointY: e3.anchorPointY }, u2.textFeatureIndex = e3.featureIndex;
              break;
            }
            for (let e3 = n2; e3 < i2; e3++) {
              const r3 = t2.get(e3);
              u2.verticalTextBox = { x1: r3.x1, y1: r3.y1, x2: r3.x2, y2: r3.y2, anchorPointX: r3.anchorPointX, anchorPointY: r3.anchorPointY }, u2.verticalTextFeatureIndex = r3.featureIndex;
              break;
            }
            for (let e3 = s2; e3 < o2; e3++) {
              const r3 = t2.get(e3);
              u2.iconBox = { x1: r3.x1, y1: r3.y1, x2: r3.x2, y2: r3.y2, anchorPointX: r3.anchorPointX, anchorPointY: r3.anchorPointY }, u2.iconFeatureIndex = r3.featureIndex;
              break;
            }
            for (let e3 = a2; e3 < l2; e3++) {
              const r3 = t2.get(e3);
              u2.verticalIconBox = { x1: r3.x1, y1: r3.y1, x2: r3.x2, y2: r3.y2, anchorPointX: r3.anchorPointX, anchorPointY: r3.anchorPointY }, u2.verticalIconFeatureIndex = r3.featureIndex;
              break;
            }
            return u2;
          }
          deserializeCollisionBoxes(t2) {
            this.collisionArrays = [];
            for (let e2 = 0; e2 < this.symbolInstances.length; e2++) {
              const r2 = this.symbolInstances.get(e2);
              this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t2, r2.textBoxStartIndex, r2.textBoxEndIndex, r2.verticalTextBoxStartIndex, r2.verticalTextBoxEndIndex, r2.iconBoxStartIndex, r2.iconBoxEndIndex, r2.verticalIconBoxStartIndex, r2.verticalIconBoxEndIndex));
            }
          }
          hasTextData() {
            return this.text.segments.get().length > 0;
          }
          hasIconData() {
            return this.icon.segments.get().length > 0;
          }
          hasDebugData() {
            return this.textCollisionBox && this.iconCollisionBox;
          }
          hasTextCollisionBoxData() {
            return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
          }
          hasIconCollisionBoxData() {
            return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
          }
          addIndicesForPlacedSymbol(t2, e2) {
            const r2 = t2.placedSymbolArray.get(e2), n2 = r2.vertexStartIndex + 4 * r2.numGlyphs;
            for (let e3 = r2.vertexStartIndex; e3 < n2; e3 += 4) t2.indexArray.emplaceBack(e3, e3 + 2, e3 + 1), t2.indexArray.emplaceBack(e3 + 1, e3 + 2, e3 + 3);
          }
          getSortedSymbolIndexes(t2) {
            if (this.sortedAngle === t2 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
            const e2 = Math.sin(t2), r2 = Math.cos(t2), n2 = [], i2 = [], s2 = [];
            for (let t3 = 0; t3 < this.symbolInstances.length; ++t3) {
              s2.push(t3);
              const o2 = this.symbolInstances.get(t3);
              n2.push(0 | Math.round(e2 * o2.anchorX + r2 * o2.anchorY)), i2.push(o2.featureIndex);
            }
            return s2.sort((t3, e3) => n2[t3] - n2[e3] || i2[e3] - i2[t3]), s2;
          }
          addToSortKeyRanges(t2, e2) {
            const r2 = this.sortKeyRanges[this.sortKeyRanges.length - 1];
            r2 && r2.sortKey === e2 ? r2.symbolInstanceEnd = t2 + 1 : this.sortKeyRanges.push({ sortKey: e2, symbolInstanceStart: t2, symbolInstanceEnd: t2 + 1 });
          }
          sortFeatures(t2) {
            if (this.sortFeaturesByY && this.sortedAngle !== t2 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
              this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t2), this.sortedAngle = t2, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
              for (const t3 of this.symbolInstanceIndexes) {
                const e2 = this.symbolInstances.get(t3);
                this.featureSortOrder.push(e2.featureIndex), [e2.rightJustifiedTextSymbolIndex, e2.centerJustifiedTextSymbolIndex, e2.leftJustifiedTextSymbolIndex].forEach((t4, e3, r2) => {
                  t4 >= 0 && r2.indexOf(t4) === e3 && this.addIndicesForPlacedSymbol(this.text, t4);
                }), e2.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, e2.verticalPlacedTextSymbolIndex), e2.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e2.placedIconSymbolIndex), e2.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e2.verticalPlacedIconSymbolIndex);
              }
              this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
            }
          }
        }
        let hh, ph;
        us("SymbolBucket", ch, { omit: ["layers", "collisionBoxArray", "features", "compareText"] }), ch.MAX_GLYPHS = 65535, ch.addDynamicAttributes = oh;
        var fh = { get paint() {
          return ph = ph || new Xs({ "icon-opacity": new Us(vt.paint_symbol["icon-opacity"]), "icon-color": new Us(vt.paint_symbol["icon-color"]), "icon-halo-color": new Us(vt.paint_symbol["icon-halo-color"]), "icon-halo-width": new Us(vt.paint_symbol["icon-halo-width"]), "icon-halo-blur": new Us(vt.paint_symbol["icon-halo-blur"]), "icon-translate": new $s(vt.paint_symbol["icon-translate"]), "icon-translate-anchor": new $s(vt.paint_symbol["icon-translate-anchor"]), "text-opacity": new Us(vt.paint_symbol["text-opacity"]), "text-color": new Us(vt.paint_symbol["text-color"], { runtimeType: Rt, getOverride: (t2) => t2.textColor, hasOverride: (t2) => !!t2.textColor }), "text-halo-color": new Us(vt.paint_symbol["text-halo-color"]), "text-halo-width": new Us(vt.paint_symbol["text-halo-width"]), "text-halo-blur": new Us(vt.paint_symbol["text-halo-blur"]), "text-translate": new $s(vt.paint_symbol["text-translate"]), "text-translate-anchor": new $s(vt.paint_symbol["text-translate-anchor"]) });
        }, get layout() {
          return hh = hh || new Xs({ "symbol-placement": new $s(vt.layout_symbol["symbol-placement"]), "symbol-spacing": new $s(vt.layout_symbol["symbol-spacing"]), "symbol-avoid-edges": new $s(vt.layout_symbol["symbol-avoid-edges"]), "symbol-sort-key": new Us(vt.layout_symbol["symbol-sort-key"]), "symbol-z-order": new $s(vt.layout_symbol["symbol-z-order"]), "icon-allow-overlap": new $s(vt.layout_symbol["icon-allow-overlap"]), "icon-overlap": new $s(vt.layout_symbol["icon-overlap"]), "icon-ignore-placement": new $s(vt.layout_symbol["icon-ignore-placement"]), "icon-optional": new $s(vt.layout_symbol["icon-optional"]), "icon-rotation-alignment": new $s(vt.layout_symbol["icon-rotation-alignment"]), "icon-size": new Us(vt.layout_symbol["icon-size"]), "icon-text-fit": new $s(vt.layout_symbol["icon-text-fit"]), "icon-text-fit-padding": new $s(vt.layout_symbol["icon-text-fit-padding"]), "icon-image": new Us(vt.layout_symbol["icon-image"]), "icon-rotate": new Us(vt.layout_symbol["icon-rotate"]), "icon-padding": new Us(vt.layout_symbol["icon-padding"]), "icon-keep-upright": new $s(vt.layout_symbol["icon-keep-upright"]), "icon-offset": new Us(vt.layout_symbol["icon-offset"]), "icon-anchor": new Us(vt.layout_symbol["icon-anchor"]), "icon-pitch-alignment": new $s(vt.layout_symbol["icon-pitch-alignment"]), "text-pitch-alignment": new $s(vt.layout_symbol["text-pitch-alignment"]), "text-rotation-alignment": new $s(vt.layout_symbol["text-rotation-alignment"]), "text-field": new Us(vt.layout_symbol["text-field"]), "text-font": new Us(vt.layout_symbol["text-font"]), "text-size": new Us(vt.layout_symbol["text-size"]), "text-max-width": new Us(vt.layout_symbol["text-max-width"]), "text-line-height": new $s(vt.layout_symbol["text-line-height"]), "text-letter-spacing": new Us(vt.layout_symbol["text-letter-spacing"]), "text-justify": new Us(vt.layout_symbol["text-justify"]), "text-radial-offset": new Us(vt.layout_symbol["text-radial-offset"]), "text-variable-anchor": new $s(vt.layout_symbol["text-variable-anchor"]), "text-variable-anchor-offset": new Us(vt.layout_symbol["text-variable-anchor-offset"]), "text-anchor": new Us(vt.layout_symbol["text-anchor"]), "text-max-angle": new $s(vt.layout_symbol["text-max-angle"]), "text-writing-mode": new $s(vt.layout_symbol["text-writing-mode"]), "text-rotate": new Us(vt.layout_symbol["text-rotate"]), "text-padding": new $s(vt.layout_symbol["text-padding"]), "text-keep-upright": new $s(vt.layout_symbol["text-keep-upright"]), "text-transform": new Us(vt.layout_symbol["text-transform"]), "text-offset": new Us(vt.layout_symbol["text-offset"]), "text-allow-overlap": new $s(vt.layout_symbol["text-allow-overlap"]), "text-overlap": new $s(vt.layout_symbol["text-overlap"]), "text-ignore-placement": new $s(vt.layout_symbol["text-ignore-placement"]), "text-optional": new $s(vt.layout_symbol["text-optional"]) });
        } };
        class dh {
          constructor(t2) {
            if (void 0 === t2.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
            this.type = t2.property.overrides ? t2.property.overrides.runtimeType : Vt, this.defaultValue = t2;
          }
          evaluate(t2) {
            if (t2.formattedSection) {
              const e2 = this.defaultValue.property.overrides;
              if (e2 && e2.hasOverride(t2.formattedSection)) return e2.getOverride(t2.formattedSection);
            }
            return t2.feature && t2.featureState ? this.defaultValue.evaluate(t2.feature, t2.featureState) : this.defaultValue.property.specification.default;
          }
          eachChild(t2) {
            this.defaultValue.isConstant() || t2(this.defaultValue.value._styleExpression.expression);
          }
          outputDefined() {
            return false;
          }
          serialize() {
            return null;
          }
        }
        us("FormatSectionOverride", dh, { omit: ["defaultValue"] });
        class yh extends Ys {
          constructor(t2, e2) {
            super(t2, fh, e2);
          }
          recalculate(t2, e2) {
            if (super.recalculate(t2, e2), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
              const t3 = this.layout.get("text-writing-mode");
              if (t3) {
                const e3 = [];
                for (const r2 of t3) e3.indexOf(r2) < 0 && e3.push(r2);
                this.layout._values["text-writing-mode"] = e3;
              } else this.layout._values["text-writing-mode"] = ["horizontal"];
            }
            this._setPaintOverrides();
          }
          getValueAndResolveTokens(t2, e2, r2, n2) {
            const i2 = this.layout.get(t2).evaluate(e2, {}, r2, n2), s2 = this._unevaluatedLayout._values[t2];
            return s2.isDataDriven() || ri(s2.value) || !i2 ? i2 : function(t3, e3) {
              return e3.replace(/{([^{}]+)}/g, (e4, r3) => t3 && r3 in t3 ? String(t3[r3]) : "");
            }(e2.properties, i2);
          }
          createBucket(t2) {
            return new ch(t2);
          }
          queryRadius() {
            return 0;
          }
          queryIntersectsFeature() {
            throw new Error("Should take a different path in FeatureIndex");
          }
          _setPaintOverrides() {
            for (const t2 of fh.paint.overridableProperties) {
              if (!yh.hasPaintOverride(this.layout, t2)) continue;
              const e2 = this.paint.get(t2), r2 = new dh(e2), n2 = new ei(r2, e2.property.specification);
              let i2 = null;
              i2 = "constant" === e2.value.kind || "source" === e2.value.kind ? new ii("source", n2) : new si("composite", n2, e2.value.zoomStops), this.paint._values[t2] = new Rs(e2.property, i2, e2.parameters);
            }
          }
          _handleOverridablePaintPropertyUpdate(t2, e2, r2) {
            return !(!this.layout || e2.isDataDriven() || r2.isDataDriven()) && yh.hasPaintOverride(this.layout, t2);
          }
          static hasPaintOverride(t2, e2) {
            const r2 = t2.get("text-field"), n2 = fh.paint.properties[e2];
            let i2 = false;
            const s2 = (t3) => {
              for (const e3 of t3) if (n2.overrides && n2.overrides.hasOverride(e3)) return void (i2 = true);
            };
            if ("constant" === r2.value.kind && r2.value.value instanceof De) s2(r2.value.value.sections);
            else if ("source" === r2.value.kind || "composite" === r2.value.kind) {
              const t3 = (e4) => {
                i2 || (e4 instanceof je && Ue(e4.value) === jt ? s2(e4.value.sections) : e4 instanceof Ir ? s2(e4.sections) : e4.eachChild(t3));
              }, e3 = r2.value;
              e3._styleExpression && t3(e3._styleExpression.expression);
            }
            return i2;
          }
        }
        let mh;
        var gh = { get paint() {
          return mh = mh || new Xs({ "background-color": new $s(vt.paint_background["background-color"]), "background-pattern": new js(vt.paint_background["background-pattern"]), "background-opacity": new $s(vt.paint_background["background-opacity"]) });
        } };
        class xh extends Ys {
          constructor(t2, e2) {
            super(t2, gh, e2);
          }
        }
        class vh extends Ys {
          constructor(t2, e2) {
            super(t2, {}, e2), this.onAdd = (t3) => {
              this.implementation.onAdd && this.implementation.onAdd(t3, t3.painter.context.gl);
            }, this.onRemove = (t3) => {
              this.implementation.onRemove && this.implementation.onRemove(t3, t3.painter.context.gl);
            }, this.implementation = t2;
          }
          is3D() {
            return "3d" === this.implementation.renderingMode;
          }
          hasOffscreenPass() {
            return void 0 !== this.implementation.prerender;
          }
          recalculate() {
          }
          updateTransitions() {
          }
          hasTransition() {
            return false;
          }
          serialize() {
            throw new Error("Custom layers cannot be serialized");
          }
        }
        class bh {
          constructor(t2) {
            this._methodToThrottle = t2, this._triggered = false, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel(), this._channel.port2.onmessage = () => {
              this._triggered = false, this._methodToThrottle();
            });
          }
          trigger() {
            this._triggered || (this._triggered = true, this._channel ? this._channel.port1.postMessage(true) : setTimeout(() => {
              this._triggered = false, this._methodToThrottle();
            }, 0));
          }
          remove() {
            delete this._channel, this._methodToThrottle = () => {
            };
          }
        }
        const wh = { once: true }, _h = 63710088e-1;
        class Ah {
          constructor(t2, e2) {
            if (isNaN(t2) || isNaN(e2)) throw new Error(`Invalid LngLat object: (${t2}, ${e2})`);
            if (this.lng = +t2, this.lat = +e2, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
          }
          wrap() {
            return new Ah(L2(this.lng, -180, 180), this.lat);
          }
          toArray() {
            return [this.lng, this.lat];
          }
          toString() {
            return `LngLat(${this.lng}, ${this.lat})`;
          }
          distanceTo(t2) {
            const e2 = Math.PI / 180, r2 = this.lat * e2, n2 = t2.lat * e2, i2 = Math.sin(r2) * Math.sin(n2) + Math.cos(r2) * Math.cos(n2) * Math.cos((t2.lng - this.lng) * e2);
            return _h * Math.acos(Math.min(i2, 1));
          }
          static convert(t2) {
            if (t2 instanceof Ah) return t2;
            if (Array.isArray(t2) && (2 === t2.length || 3 === t2.length)) return new Ah(Number(t2[0]), Number(t2[1]));
            if (!Array.isArray(t2) && "object" == typeof t2 && null !== t2) return new Ah(Number("lng" in t2 ? t2.lng : t2.lon), Number(t2.lat));
            throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
          }
        }
        const Sh = 2 * Math.PI * _h;
        function kh(t2) {
          return Sh * Math.cos(t2 * Math.PI / 180);
        }
        function Eh(t2) {
          return (180 + t2) / 360;
        }
        function Th(t2) {
          return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t2 * Math.PI / 360))) / 360;
        }
        function Ih(t2, e2) {
          return t2 / kh(e2);
        }
        function Mh(t2) {
          return 360 * t2 - 180;
        }
        function Fh(t2) {
          return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t2) * Math.PI / 180)) - 90;
        }
        function Dh(t2, e2) {
          return t2 * kh(Fh(e2));
        }
        class Ph {
          constructor(t2, e2, r2 = 0) {
            this.x = +t2, this.y = +e2, this.z = +r2;
          }
          static fromLngLat(t2, e2 = 0) {
            const r2 = Ah.convert(t2);
            return new Ph(Eh(r2.lng), Th(r2.lat), Ih(e2, r2.lat));
          }
          toLngLat() {
            return new Ah(Mh(this.x), Fh(this.y));
          }
          toAltitude() {
            return Dh(this.z, this.y);
          }
          meterInMercatorCoordinateUnits() {
            return 1 / Sh * (t2 = Fh(this.y), 1 / Math.cos(t2 * Math.PI / 180));
            var t2;
          }
        }
        function zh(t2, e2, r2) {
          var n2 = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r2);
          return [t2 * n2 - 2 * Math.PI * 6378137 / 2, e2 * n2 - 2 * Math.PI * 6378137 / 2];
        }
        class Bh {
          constructor(t2, e2, r2) {
            if (!function(t3, e3, r3) {
              return !(t3 < 0 || t3 > 25 || r3 < 0 || r3 >= Math.pow(2, t3) || e3 < 0 || e3 >= Math.pow(2, t3));
            }(t2, e2, r2)) throw new Error(`x=${e2}, y=${r2}, z=${t2} outside of bounds. 0<=x<${Math.pow(2, t2)}, 0<=y<${Math.pow(2, t2)} 0<=z<=25 `);
            this.z = t2, this.x = e2, this.y = r2, this.key = Lh(0, t2, t2, e2, r2);
          }
          equals(t2) {
            return this.z === t2.z && this.x === t2.x && this.y === t2.y;
          }
          url(t2, e2, r2) {
            const n2 = function(t3, e3, r3) {
              var n3 = zh(256 * t3, 256 * (e3 = Math.pow(2, r3) - e3 - 1), r3), i3 = zh(256 * (t3 + 1), 256 * (e3 + 1), r3);
              return n3[0] + "," + n3[1] + "," + i3[0] + "," + i3[1];
            }(this.x, this.y, this.z), i2 = function(t3, e3, r3) {
              let n3, i3 = "";
              for (let s2 = t3; s2 > 0; s2--) n3 = 1 << s2 - 1, i3 += (e3 & n3 ? 1 : 0) + (r3 & n3 ? 2 : 0);
              return i3;
            }(this.z, this.x, this.y);
            return t2[(this.x + this.y) % t2.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === r2 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, e2 > 1 ? "@2x" : "").replace(/{quadkey}/g, i2).replace(/{bbox-epsg-3857}/g, n2);
          }
          isChildOf(t2) {
            const e2 = this.z - t2.z;
            return e2 > 0 && t2.x === this.x >> e2 && t2.y === this.y >> e2;
          }
          getTilePoint(t2) {
            const e2 = Math.pow(2, this.z);
            return new r((t2.x * e2 - this.x) * M, (t2.y * e2 - this.y) * M);
          }
          toString() {
            return `${this.z}/${this.x}/${this.y}`;
          }
        }
        class Vh {
          constructor(t2, e2) {
            this.wrap = t2, this.canonical = e2, this.key = Lh(t2, e2.z, e2.z, e2.x, e2.y);
          }
        }
        class Ch {
          constructor(t2, e2, r2, n2, i2) {
            if (this.terrainRttPosMatrix32f = null, t2 < r2) throw new Error(`overscaledZ should be >= z; overscaledZ = ${t2}; z = ${r2}`);
            this.overscaledZ = t2, this.wrap = e2, this.canonical = new Bh(r2, +n2, +i2), this.key = Lh(e2, t2, r2, n2, i2);
          }
          clone() {
            return new Ch(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
          }
          equals(t2) {
            return this.overscaledZ === t2.overscaledZ && this.wrap === t2.wrap && this.canonical.equals(t2.canonical);
          }
          scaledTo(t2) {
            if (t2 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t2}; overscaledZ = ${this.overscaledZ}`);
            const e2 = this.canonical.z - t2;
            return t2 > this.canonical.z ? new Ch(t2, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Ch(t2, this.wrap, t2, this.canonical.x >> e2, this.canonical.y >> e2);
          }
          isOverscaled() {
            return this.overscaledZ > this.canonical.z;
          }
          calculateScaledKey(t2, e2) {
            if (t2 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t2}; overscaledZ = ${this.overscaledZ}`);
            const r2 = this.canonical.z - t2;
            return t2 > this.canonical.z ? Lh(this.wrap * +e2, t2, this.canonical.z, this.canonical.x, this.canonical.y) : Lh(this.wrap * +e2, t2, t2, this.canonical.x >> r2, this.canonical.y >> r2);
          }
          isChildOf(t2) {
            if (t2.wrap !== this.wrap) return false;
            if (this.overscaledZ - t2.overscaledZ <= 0) return false;
            if (0 === t2.overscaledZ) return this.overscaledZ > 0;
            const e2 = this.canonical.z - t2.canonical.z;
            return !(e2 < 0) && t2.canonical.x === this.canonical.x >> e2 && t2.canonical.y === this.canonical.y >> e2;
          }
          children(t2) {
            if (this.overscaledZ >= t2) return [new Ch(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)];
            const e2 = this.canonical.z + 1, r2 = 2 * this.canonical.x, n2 = 2 * this.canonical.y;
            return [new Ch(e2, this.wrap, e2, r2, n2), new Ch(e2, this.wrap, e2, r2 + 1, n2), new Ch(e2, this.wrap, e2, r2, n2 + 1), new Ch(e2, this.wrap, e2, r2 + 1, n2 + 1)];
          }
          isLessThan(t2) {
            return this.wrap < t2.wrap || !(this.wrap > t2.wrap) && (this.overscaledZ < t2.overscaledZ || !(this.overscaledZ > t2.overscaledZ) && (this.canonical.x < t2.canonical.x || !(this.canonical.x > t2.canonical.x) && this.canonical.y < t2.canonical.y));
          }
          wrapped() {
            return new Ch(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
          }
          unwrapTo(t2) {
            return new Ch(this.overscaledZ, t2, this.canonical.z, this.canonical.x, this.canonical.y);
          }
          overscaleFactor() {
            return Math.pow(2, this.overscaledZ - this.canonical.z);
          }
          toUnwrapped() {
            return new Vh(this.wrap, this.canonical);
          }
          toString() {
            return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
          }
          getTilePoint(t2) {
            return this.canonical.getTilePoint(new Ph(t2.x - this.wrap, t2.y));
          }
        }
        function Lh(t2, e2, r2, n2, i2) {
          (t2 *= 2) < 0 && (t2 = -1 * t2 - 1);
          const s2 = 1 << r2;
          return (s2 * s2 * t2 + s2 * i2 + n2).toString(36) + r2.toString(36) + e2.toString(36);
        }
        function Oh(t2, e2) {
          return e2 ? t2.properties[e2] : t2.id;
        }
        function Rh(t2, e2) {
          const r2 = { id: t2.id };
          if (e2.removeAllProperties && (delete t2.removeProperties, delete t2.addOrUpdateProperties, delete e2.removeProperties), e2.removeProperties) for (const r3 of e2.removeProperties) {
            const e3 = t2.addOrUpdateProperties.findIndex((t3) => t3.key === r3);
            e3 > -1 && t2.addOrUpdateProperties.splice(e3, 1);
          }
          return (t2.removeAllProperties || e2.removeAllProperties) && (r2.removeAllProperties = true), (t2.removeProperties || e2.removeProperties) && (r2.removeProperties = [...t2.removeProperties || [], ...e2.removeProperties || []]), (t2.addOrUpdateProperties || e2.addOrUpdateProperties) && (r2.addOrUpdateProperties = [...t2.addOrUpdateProperties || [], ...e2.addOrUpdateProperties || []]), (t2.newGeometry || e2.newGeometry) && (r2.newGeometry = e2.newGeometry || t2.newGeometry), r2;
        }
        function Nh(t2) {
          var e2, r2;
          if (!t2) return {};
          const n2 = {};
          return n2.removeAll = t2.removeAll, n2.remove = new Set(t2.remove || []), n2.add = new Map(null === (e2 = t2.add) || void 0 === e2 ? void 0 : e2.map((t3) => [t3.id, t3])), n2.update = new Map(null === (r2 = t2.update) || void 0 === r2 ? void 0 : r2.map((t3) => [t3.id, t3])), n2;
        }
        us("CanonicalTileID", Bh), us("OverscaledTileID", Ch, { omit: ["terrainRttPosMatrix32f"] });
        class $h {
          constructor(t2) {
            this._stringToNumber = {}, this._numberToString = [];
            for (let e2 = 0; e2 < t2.length; e2++) {
              const r2 = t2[e2];
              this._stringToNumber[r2] = e2, this._numberToString[e2] = r2;
            }
          }
          encode(t2) {
            return this._stringToNumber[t2];
          }
          decode(t2) {
            if (t2 >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${t2} can't be >= this._numberToString.length ${this._numberToString.length}`);
            return this._numberToString[t2];
          }
        }
        class Uh {
          constructor(t2, e2, r2, n2, i2) {
            this.type = "Feature", this._vectorTileFeature = t2, this._x = r2, this._y = n2, this._z = e2, this.properties = t2.properties, this.id = i2;
          }
          projectPoint(t2, e2, r2, n2) {
            return [360 * (t2.x + e2) / n2 - 180, 360 / Math.PI * Math.atan(Math.exp((1 - 2 * (t2.y + r2) / n2) * Math.PI)) - 90];
          }
          projectLine(t2, e2, r2, n2) {
            return t2.map((t3) => this.projectPoint(t3, e2, r2, n2));
          }
          get geometry() {
            if (this._geometry) return this._geometry;
            const t2 = this._vectorTileFeature, e2 = t2.extent * Math.pow(2, this._z), r2 = t2.extent * this._x, n2 = t2.extent * this._y, i2 = t2.loadGeometry();
            switch (t2.type) {
              case 1: {
                const t3 = [];
                for (const e3 of i2) t3.push(e3[0]);
                const s2 = this.projectLine(t3, r2, n2, e2);
                this._geometry = 1 === t3.length ? { type: "Point", coordinates: s2[0] } : { type: "MultiPoint", coordinates: s2 };
                break;
              }
              case 2: {
                const t3 = i2.map((t4) => this.projectLine(t4, r2, n2, e2));
                this._geometry = 1 === t3.length ? { type: "LineString", coordinates: t3[0] } : { type: "MultiLineString", coordinates: t3 };
                break;
              }
              case 3: {
                const t3 = Iu(i2), s2 = [];
                for (const i3 of t3) s2.push(i3.map((t4) => this.projectLine(t4, r2, n2, e2)));
                this._geometry = 1 === s2.length ? { type: "Polygon", coordinates: s2[0] } : { type: "MultiPolygon", coordinates: s2 };
                break;
              }
              default:
                throw new Error(`unknown feature type: ${t2.type}`);
            }
            return this._geometry;
          }
          set geometry(t2) {
            this._geometry = t2;
          }
          toJSON() {
            const t2 = { geometry: this.geometry };
            for (const e2 in this) "_geometry" !== e2 && "_vectorTileFeature" !== e2 && "_x" !== e2 && "_y" !== e2 && "_z" !== e2 && (t2[e2] = this[e2]);
            return t2;
          }
        }
        class qh {
          constructor(t2, e2, r2) {
            __publicField(this, "_name");
            __publicField(this, "dataBuffer");
            __publicField(this, "nullabilityBuffer");
            __publicField(this, "_size");
            this._name = t2, this.dataBuffer = e2, "number" == typeof r2 ? this._size = r2 : (this.nullabilityBuffer = r2, this._size = r2.size());
          }
          getValue(t2) {
            return this.nullabilityBuffer && !this.nullabilityBuffer.get(t2) ? null : this.getValueFromBuffer(t2);
          }
          has(t2) {
            return this.nullabilityBuffer && this.nullabilityBuffer.get(t2) || !this.nullabilityBuffer;
          }
          get name() {
            return this._name;
          }
          get size() {
            return this._size;
          }
        }
        class jh extends qh {
        }
        class Gh extends jh {
          getValueFromBuffer(t2) {
            return this.dataBuffer[t2];
          }
        }
        class Xh extends jh {
          getValueFromBuffer(t2) {
            return this.dataBuffer[t2];
          }
        }
        class Yh extends qh {
          constructor(t2, e2, r2, n2) {
            super(t2, e2, n2);
            __publicField(this, "delta");
            this.delta = r2;
          }
        }
        class Zh extends Yh {
          constructor(t2, e2, r2, n2) {
            super(t2, Int32Array.of(e2), r2, n2);
          }
          getValueFromBuffer(t2) {
            return this.dataBuffer[0] + t2 * this.delta;
          }
        }
        class Hh extends qh {
          constructor(t2, e2, r2) {
            super(t2, Int32Array.of(e2), r2);
          }
          getValueFromBuffer(t2) {
            return this.dataBuffer[0];
          }
        }
        class Kh {
          constructor(t2, e2, r2, n2, i2 = 4096) {
            __publicField(this, "_name");
            __publicField(this, "_geometryVector");
            __publicField(this, "_idVector");
            __publicField(this, "_propertyVectors");
            __publicField(this, "_extent");
            __publicField(this, "propertyVectorsMap");
            this._name = t2, this._geometryVector = e2, this._idVector = r2, this._propertyVectors = n2, this._extent = i2;
          }
          get name() {
            return this._name;
          }
          get idVector() {
            return this._idVector;
          }
          get geometryVector() {
            return this._geometryVector;
          }
          get propertyVectors() {
            return this._propertyVectors;
          }
          getPropertyVector(t2) {
            return this.propertyVectorsMap || (this.propertyVectorsMap = new Map(this._propertyVectors.map((t3) => [t3.name, t3]))), this.propertyVectorsMap.get(t2);
          }
          *[Symbol.iterator]() {
            const t2 = this.geometryVector[Symbol.iterator]();
            let e2 = 0;
            for (; e2 < this.numFeatures; ) {
              let r2;
              this.idVector && (r2 = this.containsMaxSaveIntegerValues(this.idVector) ? Number(this.idVector.getValue(e2)) : this.idVector.getValue(e2));
              const n2 = t2 == null ? void 0 : t2.next().value, i2 = {};
              for (const t3 of this.propertyVectors) {
                if (!t3) continue;
                const r3 = t3.name, n3 = t3.getValue(e2);
                null !== n3 && (i2[r3] = n3);
              }
              e2++, yield { id: r2, geometry: n2, properties: i2 };
            }
          }
          get numFeatures() {
            return this.geometryVector.numGeometries;
          }
          get extent() {
            return this._extent;
          }
          getFeatures() {
            const t2 = [], e2 = this.geometryVector.getGeometries();
            for (let r2 = 0; r2 < this.numFeatures; r2++) {
              let n2;
              this.idVector && (n2 = this.containsMaxSaveIntegerValues(this.idVector) ? Number(this.idVector.getValue(r2)) : this.idVector.getValue(r2));
              const i2 = { coordinates: e2[r2], type: this.geometryVector.geometryType(r2) }, s2 = {};
              for (const t3 of this.propertyVectors) {
                if (!t3) continue;
                const e3 = t3.name, n3 = t3.getValue(r2);
                null !== n3 && (s2[e3] = n3);
              }
              t2.push({ id: n2, geometry: i2, properties: s2 });
            }
            return t2;
          }
          containsMaxSaveIntegerValues(t2) {
            return t2 instanceof Gh || t2 instanceof Hh && t2 instanceof Zh || t2 instanceof Xh;
          }
        }
        class Wh {
          constructor(t2) {
            __publicField(this, "value");
            this.value = t2;
          }
          get() {
            return this.value;
          }
          set(t2) {
            this.value = t2;
          }
          increment() {
            return this.value++;
          }
          add(t2) {
            this.value += t2;
          }
        }
        var Jh, Qh, tp, ep, rp, np, ip, sp, op, ap;
        function lp(t2, e2, r2) {
          const n2 = new Int32Array(r2);
          let i2 = 0, s2 = e2.get();
          for (let e3 = 0; e3 < n2.length; e3++) {
            let e4 = t2[s2++], r3 = 127 & e4;
            e4 < 128 || (e4 = t2[s2++], r3 |= (127 & e4) << 7, e4 < 128 || (e4 = t2[s2++], r3 |= (127 & e4) << 14, e4 < 128 || (e4 = t2[s2++], r3 |= (127 & e4) << 21, e4 < 128 || (e4 = t2[s2++], r3 |= (15 & e4) << 28)))), n2[i2++] = r3;
          }
          return e2.set(s2), n2;
        }
        function up(t2, e2, r2) {
          const n2 = new BigInt64Array(r2);
          for (let r3 = 0; r3 < n2.length; r3++) n2[r3] = dp(t2, e2);
          return n2;
        }
        function cp(t2, e2) {
          let r2, n2;
          return n2 = t2[e2.get()], e2.increment(), r2 = 127 & n2, n2 < 128 ? r2 : (n2 = t2[e2.get()], e2.increment(), r2 |= (127 & n2) << 7, n2 < 128 ? r2 : (n2 = t2[e2.get()], e2.increment(), r2 |= (127 & n2) << 14, n2 < 128 ? r2 : (n2 = t2[e2.get()], e2.increment(), r2 |= (127 & n2) << 21, n2 < 128 ? r2 : (n2 = t2[e2.get()], r2 |= (15 & n2) << 28, function(t3, e3, r3) {
            let n3, i2;
            if (i2 = e3[r3.get()], r3.increment(), n3 = (112 & i2) >> 4, i2 < 128) return 4294967296 * n3 + (t3 >>> 0);
            if (i2 = e3[r3.get()], r3.increment(), n3 |= (127 & i2) << 3, i2 < 128) return 4294967296 * n3 + (t3 >>> 0);
            if (i2 = e3[r3.get()], r3.increment(), n3 |= (127 & i2) << 10, i2 < 128) return 4294967296 * n3 + (t3 >>> 0);
            if (i2 = e3[r3.get()], r3.increment(), n3 |= (127 & i2) << 17, i2 < 128) return 4294967296 * n3 + (t3 >>> 0);
            if (i2 = e3[r3.get()], r3.increment(), n3 |= (127 & i2) << 24, i2 < 128) return 4294967296 * n3 + (t3 >>> 0);
            if (i2 = e3[r3.get()], r3.increment(), n3 |= (1 & i2) << 31, i2 < 128) return 4294967296 * n3 + (t3 >>> 0);
            throw new Error("Expected varint not more than 10 bytes");
          }(r2, t2, e2)))));
        }
        function hp(t2, e2, r2, n2) {
          throw new Error("FastPFor is not implemented yet.");
        }
        function pp(t2) {
          return t2 >>> 1 ^ -(1 & t2);
        }
        function fp(t2) {
          return t2 >> 1n ^ -(1n & t2);
        }
        function dp(t2, e2) {
          let r2 = 0n, n2 = 0, i2 = e2.get();
          for (; i2 < t2.length; ) {
            const e3 = t2[i2++];
            if (r2 |= BigInt(127 & e3) << BigInt(n2), !(128 & e3)) break;
            if (n2 += 7, n2 >= 64) throw new Error("Varint too long");
          }
          return e2.set(i2), r2;
        }
        function yp(t2, e2, r2) {
          const n2 = new Int32Array(r2);
          let i2 = 0;
          for (let r3 = 0; r3 < e2; r3++) {
            const s2 = t2[r3];
            n2.fill(t2[r3 + e2], i2, i2 + s2), i2 += s2;
          }
          return n2;
        }
        function mp(t2, e2, r2) {
          const n2 = new BigInt64Array(r2);
          let i2 = 0;
          for (let r3 = 0; r3 < e2; r3++) {
            const s2 = Number(t2[r3]);
            n2.fill(t2[r3 + e2], i2, i2 + s2), i2 += s2;
          }
          return n2;
        }
        function gp(t2, e2, r2) {
          const n2 = new Float64Array(r2);
          let i2 = 0;
          for (let r3 = 0; r3 < e2; r3++) {
            const s2 = t2[r3];
            n2.fill(t2[r3 + e2], i2, i2 + s2), i2 += s2;
          }
          return n2;
        }
        function xp(t2) {
          const e2 = t2.length / 4 * 4;
          let r2 = 1;
          if (e2 >= 4) for (let n2 = t2[0]; r2 < e2 - 4; r2 += 4) n2 = t2[r2] += n2, n2 = t2[r2 + 1] += n2, n2 = t2[r2 + 2] += n2, n2 = t2[r2 + 3] += n2;
          for (; r2 != t2.length; ) t2[r2] += t2[r2 - 1], ++r2;
        }
        function vp(t2) {
          t2[0] = t2[0] >>> 1 ^ -(1 & t2[0]), t2[1] = t2[1] >>> 1 ^ -(1 & t2[1]);
          const e2 = t2.length / 4 * 4;
          let r2 = 2;
          if (e2 >= 4) for (; r2 < e2 - 4; r2 += 4) {
            const e3 = t2[r2], n2 = t2[r2 + 1], i2 = t2[r2 + 2], s2 = t2[r2 + 3];
            t2[r2] = (e3 >>> 1 ^ -(1 & e3)) + t2[r2 - 2], t2[r2 + 1] = (n2 >>> 1 ^ -(1 & n2)) + t2[r2 - 1], t2[r2 + 2] = (i2 >>> 1 ^ -(1 & i2)) + t2[r2], t2[r2 + 3] = (s2 >>> 1 ^ -(1 & s2)) + t2[r2 + 1];
          }
          for (; r2 != t2.length; r2 += 2) t2[r2] = (t2[r2] >>> 1 ^ -(1 & t2[r2])) + t2[r2 - 2], t2[r2 + 1] = (t2[r2 + 1] >>> 1 ^ -(1 & t2[r2 + 1])) + t2[r2 - 1];
        }
        !function(t2) {
          t2.NONE = "NONE", t2.DELTA = "DELTA", t2.COMPONENTWISE_DELTA = "COMPONENTWISE_DELTA", t2.RLE = "RLE", t2.MORTON = "MORTON", t2.PDE = "PDE";
        }(Jh || (Jh = {})), function(t2) {
          t2.NONE = "NONE", t2.FAST_PFOR = "FAST_PFOR", t2.VARINT = "VARINT", t2.ALP = "ALP";
        }(Qh || (Qh = {})), function(t2) {
          t2.PRESENT = "PRESENT", t2.DATA = "DATA", t2.OFFSET = "OFFSET", t2.LENGTH = "LENGTH";
        }(tp || (tp = {}));
        class bp {
          constructor(t2, e2, r2) {
            __publicField(this, "_dictionaryType");
            __publicField(this, "_offsetType");
            __publicField(this, "_lengthType");
            this._dictionaryType = t2, this._offsetType = e2, this._lengthType = r2;
          }
          get dictionaryType() {
            return this._dictionaryType;
          }
          get offsetType() {
            return this._offsetType;
          }
          get lengthType() {
            return this._lengthType;
          }
        }
        function wp(t2, e2) {
          const r2 = function(t3, e3) {
            const r3 = t3[e3.get()], n2 = Object.values(tp)[r3 >> 4];
            let i2 = null;
            switch (n2) {
              case tp.DATA:
                i2 = new bp(Object.values(ep)[15 & r3]);
                break;
              case tp.OFFSET:
                i2 = new bp(null, Object.values(rp)[15 & r3]);
                break;
              case tp.LENGTH:
                i2 = new bp(null, null, Object.values(np)[15 & r3]);
            }
            e3.increment();
            const s2 = t3[e3.get()], o2 = Object.values(Jh)[s2 >> 5], a2 = Object.values(Jh)[s2 >> 2 & 7], l2 = Object.values(Qh)[3 & s2];
            e3.increment();
            const u2 = lp(t3, e3, 2), c2 = u2[0];
            return { physicalStreamType: n2, logicalStreamType: i2, logicalLevelTechnique1: o2, logicalLevelTechnique2: a2, physicalLevelTechnique: l2, numValues: c2, byteLength: u2[1], decompressedCount: c2 };
          }(t2, e2);
          return r2.logicalLevelTechnique1 === Jh.MORTON ? function(t3, e3, r3) {
            const n2 = lp(e3, r3, 2);
            return { physicalStreamType: t3.physicalStreamType, logicalStreamType: t3.logicalStreamType, logicalLevelTechnique1: t3.logicalLevelTechnique1, logicalLevelTechnique2: t3.logicalLevelTechnique2, physicalLevelTechnique: t3.physicalLevelTechnique, numValues: t3.numValues, byteLength: t3.byteLength, decompressedCount: t3.decompressedCount, numBits: n2[0], coordinateShift: n2[1] };
          }(r2, t2, e2) : Jh.RLE !== r2.logicalLevelTechnique1 && Jh.RLE !== r2.logicalLevelTechnique2 || Qh.NONE === r2.physicalLevelTechnique ? r2 : function(t3, e3, r3) {
            const n2 = lp(e3, r3, 2);
            return { physicalStreamType: t3.physicalStreamType, logicalStreamType: t3.logicalStreamType, logicalLevelTechnique1: t3.logicalLevelTechnique1, logicalLevelTechnique2: t3.logicalLevelTechnique2, physicalLevelTechnique: t3.physicalLevelTechnique, numValues: t3.numValues, byteLength: t3.byteLength, decompressedCount: n2[1], runs: n2[0], numRleValues: n2[1] };
          }(r2, t2, e2);
        }
        !function(t2) {
          t2.NONE = "NONE", t2.SINGLE = "SINGLE", t2.SHARED = "SHARED", t2.VERTEX = "VERTEX", t2.MORTON = "MORTON", t2.FSST = "FSST";
        }(ep || (ep = {})), function(t2) {
          t2.VERTEX = "VERTEX", t2.INDEX = "INDEX", t2.STRING = "STRING", t2.KEY = "KEY";
        }(rp || (rp = {})), function(t2) {
          t2.VAR_BINARY = "VAR_BINARY", t2.GEOMETRIES = "GEOMETRIES", t2.PARTS = "PARTS", t2.RINGS = "RINGS", t2.TRIANGLES = "TRIANGLES", t2.SYMBOL = "SYMBOL", t2.DICTIONARY = "DICTIONARY";
        }(np || (np = {})), function(t2) {
          t2[t2.FLAT = 0] = "FLAT", t2[t2.CONST = 1] = "CONST", t2[t2.SEQUENCE = 2] = "SEQUENCE", t2[t2.DICTIONARY = 3] = "DICTIONARY", t2[t2.FSST_DICTIONARY = 4] = "FSST_DICTIONARY";
        }(ip || (ip = {}));
        class _p {
          constructor(t2, e2) {
            __publicField(this, "values");
            __publicField(this, "_size");
            this.values = t2, this._size = e2;
          }
          get(t2) {
            const e2 = Math.floor(t2 / 8);
            return 1 == (this.values[e2] >> t2 % 8 & 1);
          }
          set(t2, e2) {
            const r2 = Math.floor(t2 / 8);
            this.values[r2] = this.values[r2] | (e2 ? 1 : 0) << t2 % 8;
          }
          getInt(t2) {
            const e2 = Math.floor(t2 / 8);
            return this.values[e2] >> t2 % 8 & 1;
          }
          size() {
            return this._size;
          }
          getBuffer() {
            return this.values;
          }
        }
        function Ap(t2, e2, r2, n2, i2) {
          return function(t3, e3, r3) {
            switch (e3.logicalLevelTechnique1) {
              case Jh.DELTA:
                return e3.logicalLevelTechnique2 === Jh.RLE ? function(t4, e4, r4) {
                  const n3 = new Int32Array(r4);
                  let i3 = 0, s2 = 0;
                  for (let r5 = 0; r5 < e4; r5++) {
                    const o2 = t4[r5], a2 = pp(t4[r5 + e4]);
                    for (let t5 = 0; t5 < o2; t5++) s2 += a2, n3[i3++] = s2;
                  }
                  return n3;
                }(t3, e3.runs, e3.numRleValues) : (function(t4) {
                  t4[0] = t4[0] >>> 1 ^ -(1 & t4[0]);
                  const e4 = t4.length / 4 * 4;
                  let r4 = 1;
                  if (e4 >= 4) for (; r4 < e4 - 4; r4 += 4) {
                    const e5 = t4[r4], n3 = t4[r4 + 1], i3 = t4[r4 + 2], s2 = t4[r4 + 3];
                    t4[r4] = (e5 >>> 1 ^ -(1 & e5)) + t4[r4 - 1], t4[r4 + 1] = (n3 >>> 1 ^ -(1 & n3)) + t4[r4], t4[r4 + 2] = (i3 >>> 1 ^ -(1 & i3)) + t4[r4 + 1], t4[r4 + 3] = (s2 >>> 1 ^ -(1 & s2)) + t4[r4 + 2];
                  }
                  for (; r4 != t4.length; ++r4) t4[r4] = (t4[r4] >>> 1 ^ -(1 & t4[r4])) + t4[r4 - 1];
                }(t3), t3);
              case Jh.RLE:
                return function(t4, e4, r4) {
                  return r4 ? function(t5, e5, r5) {
                    const n3 = new Int32Array(r5);
                    let i3 = 0;
                    for (let r6 = 0; r6 < e5; r6++) {
                      const s2 = t5[r6];
                      let o2 = t5[r6 + e5];
                      o2 = o2 >>> 1 ^ -(1 & o2), n3.fill(o2, i3, i3 + s2), i3 += s2;
                    }
                    return n3;
                  }(t4, e4.runs, e4.numRleValues) : yp(t4, e4.runs, e4.numRleValues);
                }(t3, e3, r3);
              case Jh.MORTON:
                return xp(t3), t3;
              case Jh.COMPONENTWISE_DELTA:
                return vp(t3), t3;
              case Jh.NONE:
                return r3 && function(t4) {
                  for (let e4 = 0; e4 < t4.length; e4++) {
                    const r4 = t4[e4];
                    t4[e4] = r4 >>> 1 ^ -(1 & r4);
                  }
                }(t3), t3;
              default:
                throw new Error(`The specified Logical level technique is not supported: ${e3.logicalLevelTechnique1}`);
            }
          }(kp(t2, e2, r2), r2, n2);
        }
        function Sp(t2, e2, r2) {
          return function(t3, e3) {
            if (e3.logicalLevelTechnique1 === Jh.DELTA && e3.logicalLevelTechnique2 === Jh.NONE) {
              const e4 = function(t4) {
                const e5 = new Int32Array(t4.length + 1);
                e5[0] = 0, e5[1] = pp(t4[0]);
                let r3 = e5[1], n2 = 2;
                for (; n2 != e5.length; ++n2) {
                  const i2 = t4[n2 - 1];
                  r3 += i2 >>> 1 ^ -(1 & i2), e5[n2] = e5[n2 - 1] + r3;
                }
                return e5;
              }(t3);
              return e4;
            }
            if (e3.logicalLevelTechnique1 === Jh.RLE && e3.logicalLevelTechnique2 === Jh.NONE) {
              const r3 = function(t4, e4, r4) {
                const n2 = new Int32Array(r4 + 1);
                n2[0] = 0;
                let i2 = 1, s2 = n2[0];
                for (let r5 = 0; r5 < e4; r5++) {
                  const o2 = t4[r5], a2 = t4[r5 + e4];
                  for (let t5 = i2; t5 < i2 + o2; t5++) n2[t5] = a2 + s2, s2 = n2[t5];
                  i2 += o2;
                }
                return n2;
              }(t3, e3.runs, e3.numRleValues);
              return r3;
            }
            if (e3.logicalLevelTechnique1 === Jh.NONE && e3.logicalLevelTechnique2 === Jh.NONE) {
              !function(t4) {
                let e4 = 0;
                for (let r4 = 0; r4 < t4.length; r4++) t4[r4] += e4, e4 = t4[r4];
              }(t3);
              const r3 = new Int32Array(e3.numValues + 1);
              return r3[0] = 0, r3.set(t3, 1), r3;
            }
            if (e3.logicalLevelTechnique1 === Jh.DELTA && e3.logicalLevelTechnique2 === Jh.RLE) {
              const r3 = function(t4, e4, r4) {
                const n2 = new Int32Array(r4 + 1);
                n2[0] = 0;
                let i2 = 1, s2 = n2[0];
                for (let r5 = 0; r5 < e4; r5++) {
                  const o2 = t4[r5];
                  let a2 = t4[r5 + e4];
                  a2 = a2 >>> 1 ^ -(1 & a2);
                  for (let t5 = i2; t5 < i2 + o2; t5++) n2[t5] = a2 + s2, s2 = n2[t5];
                  i2 += o2;
                }
                return n2;
              }(t3, e3.runs, e3.numRleValues);
              return xp(r3), r3;
            }
            throw new Error("Only delta encoding is supported for transforming length to offset streams yet.");
          }(kp(t2, e2, r2), r2);
        }
        function kp(t2, e2, r2) {
          const n2 = r2.physicalLevelTechnique;
          if (n2 === Qh.FAST_PFOR) return hp();
          if (n2 === Qh.VARINT) return lp(t2, e2, r2.numValues);
          if (n2 === Qh.NONE) {
            const n3 = e2.get();
            e2.add(r2.byteLength);
            const i2 = t2.subarray(n3, e2.get());
            return new Int32Array(i2);
          }
          throw new Error("Specified physicalLevelTechnique is not supported (yet).");
        }
        function Ep(t2, e2, r2, n2) {
          const i2 = kp(t2, e2, r2);
          if (1 === i2.length) {
            const t3 = i2[0];
            return n2 ? pp(t3) : t3;
          }
          return n2 ? function(t3) {
            return pp(t3[1]);
          }(i2) : function(t3) {
            return t3[1];
          }(i2);
        }
        function Tp(t2, e2, r2) {
          return function(t3) {
            if (2 == t3.length) {
              const e3 = pp(t3[1]);
              return [e3, e3];
            }
            return [pp(t3[2]), pp(t3[3])];
          }(kp(t2, e2, r2));
        }
        function Ip(t2, e2, r2) {
          return function(t3) {
            if (2 == t3.length) {
              const e3 = fp(t3[1]);
              return [e3, e3];
            }
            return [fp(t3[2]), fp(t3[3])];
          }(up(t2, e2, r2.numValues));
        }
        function Mp(t2, e2, r2, n2) {
          return function(t3, e3, r3) {
            switch (e3.logicalLevelTechnique1) {
              case Jh.DELTA:
                return e3.logicalLevelTechnique2 === Jh.RLE ? function(t4, e4, r4) {
                  const n3 = new BigInt64Array(r4);
                  let i2 = 0, s2 = 0n;
                  for (let r5 = 0; r5 < e4; r5++) {
                    const o2 = Number(t4[r5]), a2 = fp(t4[r5 + e4]);
                    for (let t5 = 0; t5 < o2; t5++) s2 += a2, n3[i2++] = s2;
                  }
                  return n3;
                }(t3, e3.runs, e3.numRleValues) : (function(t4) {
                  t4[0] = t4[0] >> 1n ^ -(1n & t4[0]);
                  const e4 = t4.length / 4 * 4;
                  let r4 = 1;
                  if (e4 >= 4) for (; r4 < e4 - 4; r4 += 4) {
                    const e5 = t4[r4], n3 = t4[r4 + 1], i2 = t4[r4 + 2], s2 = t4[r4 + 3];
                    t4[r4] = (e5 >> 1n ^ -(1n & e5)) + t4[r4 - 1], t4[r4 + 1] = (n3 >> 1n ^ -(1n & n3)) + t4[r4], t4[r4 + 2] = (i2 >> 1n ^ -(1n & i2)) + t4[r4 + 1], t4[r4 + 3] = (s2 >> 1n ^ -(1n & s2)) + t4[r4 + 2];
                  }
                  for (; r4 != t4.length; ++r4) t4[r4] = (t4[r4] >> 1n ^ -(1n & t4[r4])) + t4[r4 - 1];
                }(t3), t3);
              case Jh.RLE:
                return function(t4, e4, r4) {
                  return r4 ? function(t5, e5, r5) {
                    const n3 = new BigInt64Array(r5);
                    let i2 = 0;
                    for (let r6 = 0; r6 < e5; r6++) {
                      const s2 = Number(t5[r6]);
                      let o2 = t5[r6 + e5];
                      o2 = o2 >> 1n ^ -(1n & o2), n3.fill(o2, i2, i2 + s2), i2 += s2;
                    }
                    return n3;
                  }(t4, e4.runs, e4.numRleValues) : mp(t4, e4.runs, e4.numRleValues);
                }(t3, e3, r3);
              case Jh.NONE:
                return r3 && function(t4) {
                  for (let e4 = 0; e4 < t4.length; e4++) {
                    const r4 = t4[e4];
                    t4[e4] = r4 >> 1n ^ -(1n & r4);
                  }
                }(t3), t3;
              default:
                throw new Error(`The specified Logical level technique is not supported: ${e3.logicalLevelTechnique1}`);
            }
          }(up(t2, e2, r2.numValues), r2, n2);
        }
        function Fp(t2, e2, r2, n2) {
          const i2 = up(t2, e2, r2.numValues);
          if (1 === i2.length) {
            const t3 = i2[0];
            return n2 ? fp(t3) : t3;
          }
          return n2 ? function(t3) {
            return fp(t3[1]);
          }(i2) : function(t3) {
            return t3[1];
          }(i2);
        }
        function Dp(t2, e2, r2, n2, i2) {
          return function(t3, e3, r3, n3) {
            switch (e3.logicalLevelTechnique1) {
              case Jh.DELTA:
                return e3.logicalLevelTechnique2 === Jh.RLE && (t3 = yp(t3, e3.runs, e3.numRleValues)), function(t4, e4) {
                  const r4 = new Int32Array(t4.size());
                  let n4 = 0;
                  t4.get(0) ? (r4[0] = t4.get(0) ? e4[0] >>> 1 ^ -(1 & e4[0]) : 0, n4 = 1) : r4[0] = 0;
                  let i3 = 1;
                  for (; i3 != r4.length; ++i3) r4[i3] = t4.get(i3) ? r4[i3 - 1] + (e4[n4] >>> 1 ^ -(1 & e4[n4++])) : r4[i3 - 1];
                  return r4;
                }(n3, t3);
              case Jh.RLE:
                return function(t4, e4, r4, n4) {
                  const i3 = e4;
                  return r4 ? function(t5, e5, r5) {
                    const n5 = new Int32Array(t5.size());
                    let i4 = 0;
                    for (let s2 = 0; s2 < r5; s2++) {
                      const o2 = e5[s2];
                      let a2 = e5[s2 + r5];
                      a2 = a2 >>> 1 ^ -(1 & a2);
                      for (let e6 = i4; e6 < i4 + o2; e6++) t5.get(e6) ? n5[e6] = a2 : (n5[e6] = 0, i4++);
                      i4 += o2;
                    }
                    return n5;
                  }(n4, t4, i3.runs) : function(t5, e5, r5) {
                    const n5 = new Int32Array(t5.size());
                    let i4 = 0;
                    for (let s2 = 0; s2 < r5; s2++) {
                      const o2 = e5[s2], a2 = e5[s2 + r5];
                      for (let e6 = i4; e6 < i4 + o2; e6++) t5.get(e6) ? n5[e6] = a2 : (n5[e6] = 0, i4++);
                      i4 += o2;
                    }
                    return n5;
                  }(n4, t4, i3.runs);
                }(t3, e3, r3, n3);
              case Jh.MORTON:
                return xp(t3), t3;
              case Jh.COMPONENTWISE_DELTA:
                return vp(t3), t3;
              case Jh.NONE:
                return t3 = r3 ? function(t4, e4) {
                  const r4 = new Int32Array(t4.size());
                  let n4 = 0, i3 = 0;
                  for (; i3 != r4.length; ++i3) if (t4.get(i3)) {
                    const t5 = e4[n4++];
                    r4[i3] = t5 >>> 1 ^ -(1 & t5);
                  } else r4[i3] = 0;
                  return r4;
                }(n3, t3) : function(t4, e4) {
                  const r4 = new Int32Array(t4.size());
                  let n4 = 0, i3 = 0;
                  for (; i3 != r4.length; ++i3) r4[i3] = t4.get(i3) ? e4[n4++] : 0;
                  return r4;
                }(n3, t3), t3;
              default:
                throw new Error("The specified Logical level technique is not supported");
            }
          }(r2.physicalLevelTechnique === Qh.FAST_PFOR ? hp() : lp(t2, e2, r2.numValues), r2, n2, i2);
        }
        function Pp(t2, e2, r2, n2) {
          const i2 = t2.logicalLevelTechnique1;
          if (i2 === Jh.RLE) return 1 === t2.runs ? ip.CONST : ip.FLAT;
          const s2 = e2 instanceof _p ? e2.size() : e2;
          if (i2 === Jh.DELTA && t2.logicalLevelTechnique2 === Jh.RLE) {
            const e3 = t2.runs, i3 = 2;
            if (t2.numRleValues !== s2) return ip.FLAT;
            if (1 === e3) return ip.SEQUENCE;
            if (2 === e3) {
              const e4 = n2.get();
              let s3;
              if (t2.physicalLevelTechnique === Qh.VARINT) s3 = lp(r2, n2, 4);
              else {
                const t3 = n2.get();
                s3 = new Int32Array(r2.buffer, r2.byteOffset + t3, 4);
              }
              if (n2.set(e4), s3[2] === i3 && s3[3] === i3) return ip.SEQUENCE;
            }
          }
          return 1 === t2.numValues ? ip.CONST : ip.FLAT;
        }
        class zp extends jh {
          getValueFromBuffer(t2) {
            return this.dataBuffer[t2];
          }
        }
        class Bp extends Yh {
          constructor(t2, e2, r2, n2) {
            super(t2, BigInt64Array.of(e2), r2, n2);
          }
          getValueFromBuffer(t2) {
            return this.dataBuffer[0] + BigInt(t2) * this.delta;
          }
        }
        class Vp {
          constructor(t2, e2, r2) {
            __publicField(this, "_geometryOffsets");
            __publicField(this, "_partOffsets");
            __publicField(this, "_ringOffsets");
            this._geometryOffsets = t2, this._partOffsets = e2, this._ringOffsets = r2;
          }
          get geometryOffsets() {
            return this._geometryOffsets;
          }
          get partOffsets() {
            return this._partOffsets;
          }
          get ringOffsets() {
            return this._ringOffsets;
          }
        }
        function Cp(t2, e2, r2) {
          return { x: Lp(t2, e2) - r2, y: Lp(t2 >> 1, e2) - r2 };
        }
        function Lp(t2, e2) {
          let r2 = 0;
          for (let n2 = 0; n2 < e2; n2++) r2 |= (t2 & 1 << 2 * n2) >> n2;
          return r2;
        }
        !function(t2) {
          t2[t2.POINT = 0] = "POINT", t2[t2.LINESTRING = 1] = "LINESTRING", t2[t2.POLYGON = 2] = "POLYGON", t2[t2.MULTIPOINT = 3] = "MULTIPOINT", t2[t2.MULTILINESTRING = 4] = "MULTILINESTRING", t2[t2.MULTIPOLYGON = 5] = "MULTIPOLYGON";
        }(sp || (sp = {})), function(t2) {
          t2[t2.POINT = 0] = "POINT", t2[t2.LINESTRING = 1] = "LINESTRING", t2[t2.POLYGON = 2] = "POLYGON";
        }(op || (op = {})), function(t2) {
          t2[t2.MORTON = 0] = "MORTON", t2[t2.VEC_2 = 1] = "VEC_2", t2[t2.VEC_3 = 2] = "VEC_3";
        }(ap || (ap = {}));
        class Op {
          createPoint(t2) {
            return [[t2]];
          }
          createMultiPoint(t2) {
            return t2.map((t3) => [t3]);
          }
          createLineString(t2) {
            return [t2];
          }
          createMultiLineString(t2) {
            return t2;
          }
          createPolygon(t2, e2) {
            return [t2].concat(e2);
          }
          createMultiPolygon(t2) {
            return t2.flat();
          }
        }
        function Rp(t2) {
          const e2 = new Array(t2.numGeometries);
          let n2 = 1, i2 = 1, s2 = 1, o2 = 0;
          const a2 = new Op();
          let l2 = 0, u2 = 0;
          const c2 = t2.mortonSettings, h2 = t2.topologyVector, p2 = h2.geometryOffsets, f2 = h2.partOffsets, d2 = h2.ringOffsets, y2 = t2.vertexOffsets, m2 = t2.containsPolygonGeometry(), g2 = t2.vertexBuffer;
          for (let h3 = 0; h3 < t2.numGeometries; h3++) {
            const x2 = t2.geometryType(h3);
            if (x2 === sp.POINT) {
              if (y2 && 0 !== y2.length) if (t2.vertexBufferType === ap.VEC_2) {
                const t3 = 2 * y2[u2++], n3 = new r(g2[t3], g2[t3 + 1]);
                e2[o2++] = a2.createPoint(n3);
              } else {
                const t3 = Cp(g2[y2[u2++]], c2.numBits, c2.coordinateShift), n3 = new r(t3.x, t3.y);
                e2[o2++] = a2.createPoint(n3);
              }
              else {
                const t3 = new r(g2[l2++], g2[l2++]);
                e2[o2++] = a2.createPoint(t3);
              }
              p2 && s2++, f2 && n2++, d2 && i2++;
            } else if (x2 === sp.MULTIPOINT) {
              const t3 = p2[s2] - p2[s2 - 1];
              s2++;
              const n3 = new Array(t3);
              if (y2 && 0 !== y2.length) {
                for (let e3 = 0; e3 < t3; e3++) {
                  const t4 = 2 * y2[u2++];
                  n3[e3] = new r(g2[t4], g2[t4 + 1]);
                }
                e2[o2++] = a2.createMultiPoint(n3);
              } else {
                for (let e3 = 0; e3 < t3; e3++) {
                  const t4 = g2[l2++], i3 = g2[l2++];
                  n3[e3] = new r(t4, i3);
                }
                e2[o2++] = a2.createMultiPoint(n3);
              }
            } else if (x2 === sp.LINESTRING) {
              let r2, h4 = 0;
              m2 ? (h4 = d2[i2] - d2[i2 - 1], i2++) : h4 = f2[n2] - f2[n2 - 1], n2++, y2 && 0 !== y2.length ? (r2 = t2.vertexBufferType === ap.VEC_2 ? jp(g2, y2, u2, h4, false) : Gp(g2, y2, u2, h4, false, c2), u2 += h4) : (r2 = qp(g2, l2, h4, false), l2 += 2 * h4), e2[o2++] = a2.createLineString(r2), p2 && s2++;
            } else if (x2 === sp.POLYGON) {
              const r2 = f2[n2] - f2[n2 - 1];
              n2++;
              const h4 = new Array(r2 - 1);
              let m3 = d2[i2] - d2[i2 - 1];
              if (i2++, y2 && 0 !== y2.length) {
                const r3 = t2.vertexBufferType === ap.VEC_2 ? $p(g2, y2, u2, m3) : Up(g2, y2, u2, m3, 0, c2);
                u2 += m3;
                for (let e3 = 0; e3 < h4.length; e3++) m3 = d2[i2] - d2[i2 - 1], i2++, h4[e3] = t2.vertexBufferType === ap.VEC_2 ? $p(g2, y2, u2, m3) : Up(g2, y2, u2, m3, 0, c2), u2 += m3;
                e2[o2++] = a2.createPolygon(r3, h4);
              } else {
                const t3 = Np(g2, l2, m3);
                l2 += 2 * m3;
                for (let t4 = 0; t4 < h4.length; t4++) m3 = d2[i2] - d2[i2 - 1], i2++, h4[t4] = Np(g2, l2, m3), l2 += 2 * m3;
                e2[o2++] = a2.createPolygon(t3, h4);
              }
              p2 && s2++;
            } else if (x2 === sp.MULTILINESTRING) {
              const r2 = p2[s2] - p2[s2 - 1];
              s2++;
              const h4 = new Array(r2);
              if (y2 && 0 !== y2.length) {
                for (let e3 = 0; e3 < r2; e3++) {
                  let r3 = 0;
                  m2 ? (r3 = d2[i2] - d2[i2 - 1], i2++) : r3 = f2[n2] - f2[n2 - 1], n2++;
                  const s3 = t2.vertexBufferType === ap.VEC_2 ? jp(g2, y2, u2, r3, false) : Gp(g2, y2, u2, r3, false, c2);
                  h4[e3] = s3, u2 += r3;
                }
                e2[o2++] = a2.createMultiLineString(h4);
              } else {
                for (let t3 = 0; t3 < r2; t3++) {
                  let e3 = 0;
                  m2 ? (e3 = d2[i2] - d2[i2 - 1], i2++) : e3 = f2[n2] - f2[n2 - 1], n2++, h4[t3] = qp(g2, l2, e3, false), l2 += 2 * e3;
                }
                e2[o2++] = a2.createMultiLineString(h4);
              }
            } else {
              if (x2 !== sp.MULTIPOLYGON) throw new Error("The specified geometry type is currently not supported.");
              {
                const r2 = p2[s2] - p2[s2 - 1];
                s2++;
                const h4 = new Array(r2);
                let m3 = 0;
                if (y2 && 0 !== y2.length) {
                  for (let e3 = 0; e3 < r2; e3++) {
                    const r3 = f2[n2] - f2[n2 - 1];
                    n2++;
                    const s3 = new Array(r3 - 1);
                    m3 = d2[i2] - d2[i2 - 1], i2++;
                    const o3 = t2.vertexBufferType === ap.VEC_2 ? $p(g2, y2, u2, m3) : Up(g2, y2, u2, m3, 0, c2);
                    u2 += m3;
                    for (let e4 = 0; e4 < s3.length; e4++) m3 = d2[i2] - d2[i2 - 1], i2++, s3[e4] = t2.vertexBufferType === ap.VEC_2 ? $p(g2, y2, u2, m3) : Up(g2, y2, u2, m3, 0, c2), u2 += m3;
                    h4[e3] = a2.createPolygon(o3, s3);
                  }
                  e2[o2++] = a2.createMultiPolygon(h4);
                } else {
                  for (let t3 = 0; t3 < r2; t3++) {
                    const e3 = f2[n2] - f2[n2 - 1];
                    n2++;
                    const r3 = new Array(e3 - 1);
                    m3 = d2[i2] - d2[i2 - 1], i2++;
                    const s3 = Np(g2, l2, m3);
                    l2 += 2 * m3;
                    for (let t4 = 0; t4 < r3.length; t4++) {
                      const e4 = d2[i2] - d2[i2 - 1];
                      i2++, r3[t4] = Np(g2, l2, e4), l2 += 2 * e4;
                    }
                    h4[t3] = a2.createPolygon(s3, r3);
                  }
                  e2[o2++] = a2.createMultiPolygon(h4);
                }
              }
            }
          }
          return e2;
        }
        function Np(t2, e2, r2) {
          return qp(t2, e2, r2, true);
        }
        function $p(t2, e2, r2, n2) {
          return jp(t2, e2, r2, n2, true);
        }
        function Up(t2, e2, r2, n2, i2, s2) {
          return Gp(t2, e2, r2, n2, true, s2);
        }
        function qp(t2, e2, n2, i2) {
          const s2 = new Array(i2 ? n2 + 1 : n2);
          for (let i3 = 0; i3 < 2 * n2; i3 += 2) s2[i3 / 2] = new r(t2[e2 + i3], t2[e2 + i3 + 1]);
          return i2 && (s2[s2.length - 1] = s2[0]), s2;
        }
        function jp(t2, e2, n2, i2, s2) {
          const o2 = new Array(s2 ? i2 + 1 : i2);
          for (let s3 = 0; s3 < 2 * i2; s3 += 2) {
            const i3 = 2 * e2[n2 + s3 / 2];
            o2[s3 / 2] = new r(t2[i3], t2[i3 + 1]);
          }
          return s2 && (o2[o2.length - 1] = o2[0]), o2;
        }
        function Gp(t2, e2, n2, i2, s2, o2) {
          const a2 = new Array(s2 ? i2 + 1 : i2);
          for (let s3 = 0; s3 < i2; s3++) {
            const i3 = Cp(t2[e2[n2 + s3]], o2.numBits, o2.coordinateShift);
            a2[s3] = new r(i3.x, i3.y);
          }
          return s2 && (a2[a2.length - 1] = a2[0]), a2;
        }
        class Xp {
          constructor(t2, e2, r2, n2, i2) {
            __publicField(this, "_vertexBufferType");
            __publicField(this, "_topologyVector");
            __publicField(this, "_vertexOffsets");
            __publicField(this, "_vertexBuffer");
            __publicField(this, "_mortonSettings");
            this._vertexBufferType = t2, this._topologyVector = e2, this._vertexOffsets = r2, this._vertexBuffer = n2, this._mortonSettings = i2;
          }
          get vertexBufferType() {
            return this._vertexBufferType;
          }
          get topologyVector() {
            return this._topologyVector;
          }
          get vertexOffsets() {
            return this._vertexOffsets;
          }
          get vertexBuffer() {
            return this._vertexBuffer;
          }
          *[Symbol.iterator]() {
            const t2 = Rp(this);
            let e2 = 0;
            for (; e2 < this.numGeometries; ) yield { coordinates: t2[e2], type: this.geometryType(e2) }, e2++;
          }
          getSimpleEncodedVertex(t2) {
            const e2 = this.vertexOffsets ? 2 * this.vertexOffsets[t2] : 2 * t2;
            return [this.vertexBuffer[e2], this.vertexBuffer[e2 + 1]];
          }
          getVertex(t2) {
            if (this.vertexOffsets && this.mortonSettings) {
              const e3 = Cp(this.vertexBuffer[this.vertexOffsets[t2]], this.mortonSettings.numBits, this.mortonSettings.coordinateShift);
              return [e3.x, e3.y];
            }
            const e2 = this.vertexOffsets ? 2 * this.vertexOffsets[t2] : 2 * t2;
            return [this.vertexBuffer[e2], this.vertexBuffer[e2 + 1]];
          }
          getGeometries() {
            return Rp(this);
          }
          get mortonSettings() {
            return this._mortonSettings;
          }
        }
        class Yp extends Xp {
          constructor(t2, e2, r2, n2, i2, s2, o2) {
            super(r2, n2, i2, s2, o2);
            __publicField(this, "_numGeometries");
            __publicField(this, "_geometryType");
            this._numGeometries = t2, this._geometryType = e2;
          }
          geometryType(t2) {
            return this._geometryType;
          }
          get numGeometries() {
            return this._numGeometries;
          }
          containsPolygonGeometry() {
            return this._geometryType === sp.POLYGON || this._geometryType === sp.MULTIPOLYGON;
          }
          containsSingleGeometryType() {
            return true;
          }
        }
        class Zp extends Xp {
          constructor(t2, e2, r2, n2, i2, s2) {
            super(t2, r2, n2, i2, s2);
            __publicField(this, "_geometryTypes");
            this._geometryTypes = e2;
          }
          geometryType(t2) {
            return this._geometryTypes[t2];
          }
          get numGeometries() {
            return this._geometryTypes.length;
          }
          containsPolygonGeometry() {
            for (let t2 = 0; t2 < this.numGeometries; t2++) if (this.geometryType(t2) === sp.POLYGON || this.geometryType(t2) === sp.MULTIPOLYGON) return true;
            return false;
          }
          containsSingleGeometryType() {
            return false;
          }
        }
        class Hp {
          constructor(t2, e2, r2, n2) {
            __publicField(this, "_triangleOffsets");
            __publicField(this, "_indexBuffer");
            __publicField(this, "_vertexBuffer");
            __publicField(this, "_topologyVector");
            this._triangleOffsets = t2, this._indexBuffer = e2, this._vertexBuffer = r2, this._topologyVector = n2;
          }
          get triangleOffsets() {
            return this._triangleOffsets;
          }
          get indexBuffer() {
            return this._indexBuffer;
          }
          get vertexBuffer() {
            return this._vertexBuffer;
          }
          get topologyVector() {
            return this._topologyVector;
          }
          getGeometries() {
            if (!this._topologyVector) throw new Error("Cannot convert GpuVector to coordinates without topology information");
            const t2 = new Array(this.numGeometries), e2 = this._topologyVector, n2 = e2.partOffsets, i2 = e2.ringOffsets, s2 = e2.geometryOffsets;
            let o2 = 0, a2 = 1, l2 = 1, u2 = 1;
            for (let e3 = 0; e3 < this.numGeometries; e3++) switch (this.geometryType(e3)) {
              case sp.POLYGON:
                {
                  const c2 = n2[a2] - n2[a2 - 1];
                  a2++;
                  const h2 = [];
                  for (let t3 = 0; t3 < c2; t3++) {
                    const t4 = i2[l2] - i2[l2 - 1];
                    l2++;
                    const e4 = [];
                    for (let n3 = 0; n3 < t4; n3++) {
                      const t5 = this._vertexBuffer[o2++], n4 = this._vertexBuffer[o2++];
                      e4.push(new r(t5, n4));
                    }
                    e4.length > 0 && e4.push(e4[0]), h2.push(e4);
                  }
                  t2[e3] = h2, s2 && u2++;
                }
                break;
              case sp.MULTIPOLYGON: {
                const c2 = s2[u2] - s2[u2 - 1];
                u2++;
                const h2 = [];
                for (let t3 = 0; t3 < c2; t3++) {
                  const t4 = n2[a2] - n2[a2 - 1];
                  a2++;
                  for (let e4 = 0; e4 < t4; e4++) {
                    const t5 = i2[l2] - i2[l2 - 1];
                    l2++;
                    const e5 = [];
                    for (let n3 = 0; n3 < t5; n3++) {
                      const t6 = this._vertexBuffer[o2++], n4 = this._vertexBuffer[o2++];
                      e5.push(new r(t6, n4));
                    }
                    e5.length > 0 && e5.push(e5[0]), h2.push(e5);
                  }
                }
                t2[e3] = h2;
              }
            }
            return t2;
          }
          [Symbol.iterator]() {
            return null;
          }
        }
        function Kp(t2, e2, r2, n2, i2, s2) {
          return new Wp(t2, e2, r2, n2, i2, s2);
        }
        class Wp extends Hp {
          constructor(t2, e2, r2, n2, i2, s2) {
            super(r2, n2, i2, s2);
            __publicField(this, "_numGeometries");
            __publicField(this, "_geometryType");
            this._numGeometries = t2, this._geometryType = e2;
          }
          geometryType(t2) {
            return this._geometryType;
          }
          get numGeometries() {
            return this._numGeometries;
          }
          containsSingleGeometryType() {
            return true;
          }
        }
        function Jp(t2, e2, r2, n2, i2) {
          return new Qp(t2, e2, r2, n2, i2);
        }
        class Qp extends Hp {
          constructor(t2, e2, r2, n2, i2) {
            super(e2, r2, n2, i2);
            __publicField(this, "_geometryTypes");
            this._geometryTypes = t2;
          }
          geometryType(t2) {
            return this._geometryTypes[t2];
          }
          get numGeometries() {
            return this._geometryTypes.length;
          }
          containsSingleGeometryType() {
            return false;
          }
        }
        function tf(t2, e2, r2, n2, i2) {
          const s2 = wp(t2, r2);
          let o2 = null, a2 = null, l2 = null, u2 = null, c2 = null, h2 = null, p2 = null, f2 = null;
          if (Pp(s2, n2, t2, r2) === ip.CONST) {
            const i3 = Ep(t2, r2, s2, false);
            for (let n3 = 0; n3 < e2 - 1; n3++) {
              const e3 = wp(t2, r2);
              switch (e3.physicalStreamType) {
                case tp.LENGTH:
                  switch (e3.logicalStreamType.lengthType) {
                    case np.GEOMETRIES:
                      o2 = Sp(t2, r2, e3);
                      break;
                    case np.PARTS:
                      a2 = Sp(t2, r2, e3);
                      break;
                    case np.RINGS:
                      l2 = Sp(t2, r2, e3);
                      break;
                    case np.TRIANGLES:
                      p2 = Sp(t2, r2, e3);
                  }
                  break;
                case tp.OFFSET:
                  switch (e3.logicalStreamType.offsetType) {
                    case rp.VERTEX:
                      u2 = Ap(t2, r2, e3, false);
                      break;
                    case rp.INDEX:
                      f2 = Ap(t2, r2, e3, false);
                  }
                  break;
                case tp.DATA:
                  ep.VERTEX === e3.logicalStreamType.dictionaryType ? c2 = Ap(t2, r2, e3, true) : (h2 = { numBits: e3.numBits, coordinateShift: e3.coordinateShift }, c2 = Ap(t2, r2, e3, false));
              }
            }
            return null !== f2 ? null != o2 || null != a2 ? Kp(n2, i3, p2, f2, c2, new Vp(o2, a2, l2)) : Kp(n2, i3, p2, f2, c2) : null === h2 ? function(t3, e3, r3, n3, i4) {
              return new Yp(t3, e3, ap.VEC_2, r3, n3, i4);
            }(n2, i3, new Vp(o2, a2, l2), u2, c2) : function(t3, e3, r3, n3, i4, s3) {
              return new Yp(t3, e3, ap.MORTON, r3, n3, i4, s3);
            }(n2, i3, new Vp(o2, a2, l2), u2, c2, h2);
          }
          const d2 = Ap(t2, r2, s2, false);
          for (let n3 = 0; n3 < e2 - 1; n3++) {
            const e3 = wp(t2, r2);
            switch (e3.physicalStreamType) {
              case tp.LENGTH:
                switch (e3.logicalStreamType.lengthType) {
                  case np.GEOMETRIES:
                    o2 = Ap(t2, r2, e3, false);
                    break;
                  case np.PARTS:
                    a2 = Ap(t2, r2, e3, false);
                    break;
                  case np.RINGS:
                    l2 = Ap(t2, r2, e3, false);
                    break;
                  case np.TRIANGLES:
                    p2 = Sp(t2, r2, e3);
                }
                break;
              case tp.OFFSET:
                switch (e3.logicalStreamType.offsetType) {
                  case rp.VERTEX:
                    u2 = Ap(t2, r2, e3, false);
                    break;
                  case rp.INDEX:
                    f2 = Ap(t2, r2, e3, false);
                }
                break;
              case tp.DATA:
                ep.VERTEX === e3.logicalStreamType.dictionaryType ? c2 = Ap(t2, r2, e3, true) : (h2 = { numBits: e3.numBits, coordinateShift: e3.coordinateShift }, c2 = Ap(t2, r2, e3, false));
            }
          }
          return null !== f2 && null === a2 ? Jp(d2, p2, f2, c2) : (null !== o2 ? (o2 = ef(d2, o2, 2), null !== a2 && null !== l2 ? (a2 = rf(d2, o2, a2, false), l2 = function(t3, e3, r3, n3) {
            const i3 = new Int32Array(r3[r3.length - 1] + 1);
            let s3 = 0;
            i3[0] = s3;
            let o3 = 1, a3 = 1, l3 = 0;
            for (let u3 = 0; u3 < t3.length; u3++) {
              const c3 = t3[u3], h3 = e3[u3 + 1] - e3[u3];
              if (0 !== c3 && 3 !== c3) for (let t4 = 0; t4 < h3; t4++) {
                const t5 = r3[o3] - r3[o3 - 1];
                o3++;
                for (let e4 = 0; e4 < t5; e4++) s3 = i3[a3++] = s3 + n3[l3++];
              }
              else for (let t4 = 0; t4 < h3; t4++) i3[a3++] = ++s3, o3++;
            }
            return i3;
          }(d2, o2, a2, l2)) : null !== a2 && (a2 = function(t3, e3, r3) {
            const n3 = new Int32Array(e3[e3.length - 1] + 1);
            let i3 = 0;
            n3[0] = i3;
            let s3 = 1, o3 = 0;
            for (let a3 = 0; a3 < t3.length; a3++) {
              const l3 = t3[a3], u3 = e3[a3 + 1] - e3[a3];
              if (4 === l3 || 1 === l3) for (let t4 = 0; t4 < u3; t4++) i3 = n3[s3++] = i3 + r3[o3++];
              else for (let t4 = 0; t4 < u3; t4++) n3[s3++] = ++i3;
            }
            return n3;
          }(d2, o2, a2))) : null !== a2 && null !== l2 ? (a2 = ef(d2, a2, 1), l2 = rf(d2, a2, l2, true)) : null !== a2 && (a2 = ef(d2, a2, 0)), null !== f2 ? Jp(d2, p2, f2, c2, new Vp(o2, a2, l2)) : null === h2 ? function(t3, e3, r3, n3) {
            return new Zp(ap.VEC_2, t3, e3, r3, n3);
          }(d2, new Vp(o2, a2, l2), u2, c2) : function(t3, e3, r3, n3, i3) {
            return new Zp(ap.MORTON, t3, e3, r3, n3, i3);
          }(d2, new Vp(o2, a2, l2), u2, c2, h2));
        }
        function ef(t2, e2, r2) {
          const n2 = new Int32Array(t2.length + 1);
          let i2 = 0;
          n2[0] = i2;
          let s2 = 0;
          for (let o2 = 0; o2 < t2.length; o2++) i2 = n2[o2 + 1] = i2 + (t2[o2] > r2 ? e2[s2++] : 1);
          return n2;
        }
        function rf(t2, e2, r2, n2) {
          const i2 = new Int32Array(e2[e2.length - 1] + 1);
          let s2 = 0;
          i2[0] = s2;
          let o2 = 1, a2 = 0;
          for (let l2 = 0; l2 < t2.length; l2++) {
            const u2 = t2[l2], c2 = e2[l2 + 1] - e2[l2];
            if (5 === u2 || 2 === u2 || n2 && (4 === u2 || 1 === u2)) for (let t3 = 0; t3 < c2; t3++) s2 = i2[o2++] = s2 + r2[a2++];
            else for (let t3 = 0; t3 < c2; t3++) i2[o2++] = ++s2;
          }
          return i2;
        }
        class nf extends qh {
          constructor(t2, e2, r2) {
            super(t2, e2.getBuffer(), r2);
            __publicField(this, "dataVector");
            this.dataVector = e2;
          }
          getValueFromBuffer(t2) {
            return this.dataVector.get(t2);
          }
        }
        class sf extends jh {
          getValueFromBuffer(t2) {
            return this.dataBuffer[t2];
          }
        }
        class of extends qh {
          constructor(t2, e2, r2) {
            super(t2, BigInt64Array.of(e2), r2);
          }
          getValueFromBuffer(t2) {
            return this.dataBuffer[0];
          }
        }
        function af(t2, e2, r2) {
          return lf(t2, Math.ceil(e2 / 8), r2);
        }
        function lf(t2, e2, r2) {
          const n2 = new Uint8Array(e2);
          let i2 = 0;
          for (; i2 < e2; ) {
            const e3 = t2[r2.increment()];
            if (e3 <= 127) {
              const s2 = e3 + 3, o2 = t2[r2.increment()], a2 = i2 + s2;
              n2.fill(o2, i2, a2), i2 = a2;
            } else {
              const s2 = 256 - e3;
              for (let e4 = 0; e4 < s2; e4++) n2[i2++] = t2[r2.increment()];
            }
          }
          return n2;
        }
        const uf = new TextDecoder();
        function cf(t2, e2, r2) {
          return r2 - e2 >= 12 ? uf.decode(t2.subarray(e2, r2)) : function(t3, e3, r3) {
            let n2 = "", i2 = e3;
            for (; i2 < r3; ) {
              const e4 = t3[i2];
              let s2, o2, a2, l2 = null, u2 = e4 > 239 ? 4 : e4 > 223 ? 3 : e4 > 191 ? 2 : 1;
              if (i2 + u2 > r3) break;
              1 === u2 ? e4 < 128 && (l2 = e4) : 2 === u2 ? (s2 = t3[i2 + 1], 128 == (192 & s2) && (l2 = (31 & e4) << 6 | 63 & s2, l2 <= 127 && (l2 = null))) : 3 === u2 ? (s2 = t3[i2 + 1], o2 = t3[i2 + 2], 128 == (192 & s2) && 128 == (192 & o2) && (l2 = (15 & e4) << 12 | (63 & s2) << 6 | 63 & o2, (l2 <= 2047 || l2 >= 55296 && l2 <= 57343) && (l2 = null))) : 4 === u2 && (s2 = t3[i2 + 1], o2 = t3[i2 + 2], a2 = t3[i2 + 3], 128 == (192 & s2) && 128 == (192 & o2) && 128 == (192 & a2) && (l2 = (15 & e4) << 18 | (63 & s2) << 12 | (63 & o2) << 6 | 63 & a2, (l2 <= 65535 || l2 >= 1114112) && (l2 = null))), null === l2 ? (l2 = 65533, u2 = 1) : l2 > 65535 && (l2 -= 65536, n2 += String.fromCharCode(l2 >>> 10 & 1023 | 55296), l2 = 56320 | 1023 & l2), n2 += String.fromCharCode(l2), i2 += u2;
            }
            return n2;
          }(t2, e2, r2);
        }
        class hf extends qh {
          constructor(t2, e2, r2, n2) {
            super(t2, r2, n2);
            __publicField(this, "offsetBuffer");
            this.offsetBuffer = e2;
          }
        }
        class pf extends hf {
          constructor(t2, e2, r2, n2) {
            super(t2, e2, r2, n2 ?? e2.length - 1);
            __publicField(this, "textEncoder");
            this.textEncoder = new TextEncoder();
          }
          getValueFromBuffer(t2) {
            return cf(this.dataBuffer, this.offsetBuffer[t2], this.offsetBuffer[t2 + 1]);
          }
        }
        class ff extends hf {
          constructor(t2, e2, r2, n2, i2) {
            super(t2, r2, n2, i2 ?? e2.length);
            __publicField(this, "indexBuffer");
            __publicField(this, "textEncoder");
            this.indexBuffer = e2, this.indexBuffer = e2, this.textEncoder = new TextEncoder();
          }
          getValueFromBuffer(t2) {
            const e2 = this.indexBuffer[t2];
            return cf(this.dataBuffer, this.offsetBuffer[e2], this.offsetBuffer[e2 + 1]);
          }
        }
        class df extends hf {
          constructor(t2, e2, r2, n2, i2, s2, o2) {
            super(t2, r2, n2, o2);
            __publicField(this, "indexBuffer");
            __publicField(this, "symbolOffsetBuffer");
            __publicField(this, "symbolTableBuffer");
            __publicField(this, "textEncoder");
            __publicField(this, "symbolLengthBuffer");
            __publicField(this, "lengthBuffer");
            __publicField(this, "decodedDictionary");
            this.indexBuffer = e2, this.symbolOffsetBuffer = i2, this.symbolTableBuffer = s2, this.textEncoder = new TextEncoder();
          }
          getValueFromBuffer(t2) {
            null == this.decodedDictionary && (null == this.symbolLengthBuffer && (this.symbolLengthBuffer = this.offsetToLengthBuffer(this.symbolOffsetBuffer), this.lengthBuffer = this.offsetToLengthBuffer(this.offsetBuffer)), this.decodedDictionary = function(t3, e3, r2) {
              const n2 = [], i2 = new Array(e3.length).fill(0);
              for (let t4 = 1; t4 < e3.length; t4++) i2[t4] = i2[t4 - 1] + e3[t4 - 1];
              for (let s2 = 0; s2 < r2.length; s2++) if (255 === r2[s2]) n2.push(r2[++s2]);
              else {
                const o2 = e3[r2[s2]], a2 = i2[r2[s2]];
                for (let e4 = 0; e4 < o2; e4++) n2.push(t3[a2 + e4]);
              }
              return new Uint8Array(n2);
            }(this.symbolTableBuffer, this.symbolLengthBuffer, this.dataBuffer));
            const e2 = this.indexBuffer[t2];
            return cf(this.decodedDictionary, this.offsetBuffer[e2], this.offsetBuffer[e2 + 1]);
          }
          offsetToLengthBuffer(t2) {
            const e2 = new Uint32Array(t2.length - 1);
            let r2 = t2[0];
            for (let n2 = 1; n2 < t2.length; n2++) {
              const i2 = t2[n2];
              e2[n2 - 1] = i2 - r2, r2 = i2;
            }
            return e2;
          }
        }
        function yf(t2, e2, r2, n2, i2, s2) {
          return "scalarType" === r2.type ? function(t3, e3, r3, n3, i3, s3) {
            let o2 = null, a2 = 0;
            if (0 === t3) return null;
            if (s3.nullable) {
              const t4 = wp(e3, r3);
              a2 = t4.numValues;
              const n4 = r3.get(), i4 = af(e3, a2, r3);
              r3.set(n4 + t4.byteLength), o2 = new _p(i4, t4.numValues);
            }
            const l2 = o2 ?? n3;
            switch (i3.physicalType) {
              case 4:
              case 3:
                return function(t4, e4, r4, n4, i4) {
                  const s4 = wp(t4, e4), o3 = Pp(s4, i4, t4, e4), a3 = 3 === n4.physicalType;
                  if (o3 === ip.FLAT) {
                    const n5 = mf(i4) ? Dp(t4, e4, s4, a3, i4) : Ap(t4, e4, s4, a3);
                    return new Gh(r4.name, n5, i4);
                  }
                  if (o3 === ip.SEQUENCE) {
                    const n5 = Tp(t4, e4, s4);
                    return new Zh(r4.name, n5[0], n5[1], s4.numRleValues);
                  }
                  {
                    const n5 = Ep(t4, e4, s4, a3);
                    return new Hh(r4.name, n5, i4);
                  }
                }(e3, r3, s3, i3, l2);
              case 9:
                return function(t4, e4, r4, n4, i4) {
                  let s4 = null, o3 = null, a3 = null, l3 = null, u2 = null, c2 = null, h2 = null, p2 = null;
                  for (let t5 = 0; t5 < n4; t5++) {
                    const t6 = wp(e4, r4);
                    if (0 !== t6.byteLength) switch (t6.physicalStreamType) {
                      case tp.PRESENT: {
                        const n5 = af(e4, t6.numValues, r4);
                        c2 = new _p(n5, t6.numValues);
                        break;
                      }
                      case tp.OFFSET:
                        o3 = null != i4 || null != c2 ? Dp(e4, r4, t6, false, i4 ?? c2) : Ap(e4, r4, t6, false);
                        break;
                      case tp.LENGTH: {
                        const n5 = Sp(e4, r4, t6);
                        np.DICTIONARY === t6.logicalStreamType.lengthType ? s4 = n5 : np.SYMBOL === t6.logicalStreamType.lengthType ? l3 = n5 : h2 = n5;
                        break;
                      }
                      case tp.DATA: {
                        const n5 = e4.subarray(r4.get(), r4.get() + t6.byteLength);
                        r4.add(t6.byteLength);
                        const i5 = t6.logicalStreamType.dictionaryType;
                        ep.FSST === i5 ? u2 = n5 : ep.SINGLE === i5 || ep.SHARED === i5 ? a3 = n5 : ep.NONE === i5 && (p2 = n5);
                        break;
                      }
                    }
                  }
                  return function(t5, e5, r5, n5, i5, s5, o4) {
                    return e5 ? new df(t5, r5, n5, i5, s5, e5, o4) : null;
                  }(t4, u2, o3, s4, a3, l3, i4 ?? c2) ?? function(t5, e5, r5, n5, i5) {
                    return e5 ? i5 ? new ff(t5, r5, n5, e5, i5) : new ff(t5, r5, n5, e5) : null;
                  }(t4, a3, o3, s4, i4 ?? c2) ?? function(t5, e5, r5, n5, i5) {
                    if (!e5 || !r5) return null;
                    if (n5) return i5 ? new ff(t5, n5, e5, r5, i5) : new ff(t5, n5, e5, r5);
                    if (i5 && i5.size() !== e5.length - 1) {
                      const n6 = new Int32Array(i5.size());
                      let s5 = 0;
                      for (let t6 = 0; t6 < i5.size(); t6++) n6[t6] = i5.get(t6) ? s5++ : 0;
                      return new ff(t5, n6, e5, r5, i5);
                    }
                    return i5 ? new pf(t5, e5, r5, i5) : new pf(t5, e5, r5);
                  }(t4, h2, p2, o3, i4 ?? c2);
                }(s3.name, e3, r3, s3.nullable ? t3 - 1 : t3, o2);
              case 0:
                return function(t4, e4, r4, n4, i4) {
                  const s4 = wp(t4, e4), o3 = s4.numValues, a3 = e4.get(), l3 = mf(i4) ? function(t5, e5, r5, n5) {
                    const i5 = lf(t5, Math.ceil(e5 / 8), r5), s5 = new _p(i5, e5), o4 = n5.size(), a4 = new _p(new Uint8Array(o4), o4);
                    let l4 = 0;
                    for (let t6 = 0; t6 < n5.size(); t6++) {
                      const e6 = !!n5.get(t6) && s5.get(l4++);
                      a4.set(t6, e6);
                    }
                    return a4.getBuffer();
                  }(t4, o3, e4, i4) : af(t4, o3, e4);
                  e4.set(a3 + s4.byteLength);
                  const u2 = new _p(l3, o3);
                  return new nf(r4.name, u2, i4);
                }(e3, r3, s3, 0, l2);
              case 6:
              case 5:
                return function(t4, e4, r4, n4, i4) {
                  const s4 = wp(t4, e4), o3 = Pp(s4, n4, t4, e4), a3 = 5 === i4.physicalType;
                  if (o3 === ip.FLAT) {
                    const i5 = mf(n4) ? function(t5, e5, r5, n5, i6) {
                      return function(t6, e6, r6, n6) {
                        switch (e6.logicalLevelTechnique1) {
                          case Jh.DELTA:
                            return e6.logicalLevelTechnique2 === Jh.RLE && (t6 = mp(t6, e6.runs, e6.numRleValues)), function(t7, e7) {
                              const r7 = new BigInt64Array(t7.size());
                              let n7 = 0;
                              t7.get(0) ? (r7[0] = t7.get(0) ? e7[0] >> 1n ^ -(1n & e7[0]) : 0n, n7 = 1) : r7[0] = 0n;
                              let i7 = 1;
                              for (; i7 != r7.length; ++i7) r7[i7] = t7.get(i7) ? r7[i7 - 1] + (e7[n7] >> 1n ^ -(1n & e7[n7++])) : r7[i7 - 1];
                              return r7;
                            }(n6, t6);
                          case Jh.RLE:
                            return function(t7, e7, r7, n7) {
                              const i7 = e7;
                              return r7 ? function(t8, e8, r8) {
                                const n8 = new BigInt64Array(t8.size());
                                let i8 = 0;
                                for (let s5 = 0; s5 < r8; s5++) {
                                  const o4 = Number(e8[s5]);
                                  let a4 = e8[s5 + r8];
                                  a4 = a4 >> 1n ^ -(1n & a4);
                                  for (let e9 = i8; e9 < i8 + o4; e9++) t8.get(e9) ? n8[e9] = a4 : (n8[e9] = 0n, i8++);
                                  i8 += o4;
                                }
                                return n8;
                              }(n7, t7, i7.runs) : function(t8, e8, r8) {
                                const n8 = new BigInt64Array(t8.size());
                                let i8 = 0;
                                for (let s5 = 0; s5 < r8; s5++) {
                                  const o4 = Number(e8[s5]), a4 = e8[s5 + r8];
                                  for (let e9 = i8; e9 < i8 + o4; e9++) t8.get(e9) ? n8[e9] = a4 : (n8[e9] = 0n, i8++);
                                  i8 += o4;
                                }
                                return n8;
                              }(n7, t7, i7.runs);
                            }(t6, e6, r6, n6);
                          case Jh.NONE:
                            return t6 = r6 ? function(t7, e7) {
                              const r7 = new BigInt64Array(t7.size());
                              let n7 = 0, i7 = 0;
                              for (; i7 != r7.length; ++i7) if (t7.get(i7)) {
                                const t8 = e7[n7++];
                                r7[i7] = t8 >> 1n ^ -(1n & t8);
                              } else r7[i7] = 0n;
                              return r7;
                            }(n6, t6) : function(t7, e7) {
                              const r7 = new BigInt64Array(t7.size());
                              let n7 = 0, i7 = 0;
                              for (; i7 != r7.length; ++i7) r7[i7] = t7.get(i7) ? e7[n7++] : 0n;
                              return r7;
                            }(n6, t6), t6;
                          default:
                            throw new Error("The specified Logical level technique is not supported");
                        }
                      }(up(t5, e5, r5.numValues), r5, n5, i6);
                    }(t4, e4, s4, a3, n4) : Mp(t4, e4, s4, a3);
                    return new zp(r4.name, i5, n4);
                  }
                  if (o3 === ip.SEQUENCE) {
                    const n5 = Ip(t4, e4, s4);
                    return new Bp(r4.name, n5[0], n5[1], s4.numRleValues);
                  }
                  {
                    const i5 = Fp(t4, e4, s4, a3);
                    return new of(r4.name, i5, n4);
                  }
                }(e3, r3, s3, l2, i3);
              case 7:
                return function(t4, e4, r4, n4) {
                  const i4 = wp(t4, e4), s4 = mf(n4) ? function(t5, e5, r5, n5) {
                    const i5 = e5.get(), s5 = i5 + n5 * Float32Array.BYTES_PER_ELEMENT, o3 = new Uint8Array(t5.subarray(i5, s5)).buffer, a3 = new Float32Array(o3);
                    e5.set(s5);
                    const l3 = r5.size(), u2 = new Float32Array(l3);
                    let c2 = 0;
                    for (let t6 = 0; t6 < l3; t6++) u2[t6] = r5.get(t6) ? a3[c2++] : 0;
                    return u2;
                  }(t4, e4, n4, i4.numValues) : function(t5, e5, r5) {
                    const n5 = e5.get(), i5 = n5 + r5 * Float32Array.BYTES_PER_ELEMENT, s5 = new Uint8Array(t5.subarray(n5, i5)).buffer, o3 = new Float32Array(s5);
                    return e5.set(i5), o3;
                  }(t4, e4, i4.numValues);
                  return new sf(r4.name, s4, n4);
                }(e3, r3, s3, l2);
              case 8:
                return function(t4, e4, r4, n4) {
                  const i4 = wp(t4, e4), s4 = mf(n4) ? function(t5, e5, r5, n5) {
                    const i5 = e5.get(), s5 = i5 + n5 * Float64Array.BYTES_PER_ELEMENT, o3 = new Uint8Array(t5.subarray(i5, s5)).buffer, a3 = new Float64Array(o3);
                    e5.set(s5);
                    const l3 = r5.size(), u2 = new Float64Array(l3);
                    let c2 = 0;
                    for (let t6 = 0; t6 < l3; t6++) u2[t6] = r5.get(t6) ? a3[c2++] : 0;
                    return u2;
                  }(t4, e4, n4, i4.numValues) : function(t5, e5, r5) {
                    const n5 = e5.get(), i5 = n5 + r5 * Float64Array.BYTES_PER_ELEMENT, s5 = new Uint8Array(t5.subarray(n5, i5)).buffer, o3 = new Float64Array(s5);
                    return e5.set(i5), o3;
                  }(t4, e4, i4.numValues);
                  return new Xh(r4.name, s4, n4);
                }(e3, r3, s3, l2);
              default:
                throw new Error(`The specified data type for the field is currently not supported: ${i3}`);
            }
          }(n2, t2, e2, i2, r2.scalarType, r2) : 1 != n2 ? null : function(t3, e3, r3, n3) {
            let i3 = null, s3 = null, o2 = null, a2 = null, l2 = false;
            for (; !l2; ) {
              const r4 = wp(t3, e3);
              switch (r4.physicalStreamType) {
                case tp.LENGTH:
                  np.DICTIONARY === r4.logicalStreamType.lengthType ? i3 = Sp(t3, e3, r4) : o2 = Sp(t3, e3, r4);
                  break;
                case tp.DATA:
                  ep.SINGLE === r4.logicalStreamType.dictionaryType || ep.SHARED === r4.logicalStreamType.dictionaryType ? (s3 = t3.subarray(e3.get(), e3.get() + r4.byteLength), l2 = true) : a2 = t3.subarray(e3.get(), e3.get() + r4.byteLength), e3.add(r4.byteLength);
              }
            }
            const u2 = r3.complexType.children, c2 = [];
            let h2 = 0;
            for (const l3 of u2) {
              const u3 = lp(t3, e3, 1)[0];
              if (0 == u3) continue;
              const p2 = `${r3.name}${"default" === l3.name ? "" : ":" + l3.name}`;
              if (2 !== u3 || "scalarField" !== l3.type || 9 !== l3.scalarField.physicalType) throw new Error("Currently only optional string fields are implemented for a struct.");
              const f2 = wp(t3, e3), d2 = af(t3, f2.numValues, e3), y2 = wp(t3, e3), m2 = y2.decompressedCount !== n3 ? Dp(t3, e3, y2, false, new _p(d2, f2.numValues)) : Ap(t3, e3, y2, false);
              c2[h2++] = a2 ? new df(p2, m2, i3, s3, o2, a2, new _p(d2, f2.numValues)) : new ff(p2, m2, i3, s3, new _p(d2, f2.numValues));
            }
            return c2;
          }(t2, e2, r2, i2);
        }
        function mf(t2) {
          return t2 instanceof _p;
        }
        function gf(t2) {
          if ("id" === t2.name) return false;
          if ("scalarType" === t2.type) {
            const e2 = t2.scalarType;
            if ("physicalType" === e2.type) switch (e2.physicalType) {
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
              case 7:
              case 8:
              default:
                return false;
              case 9:
                return true;
            }
            else if ("logicalType" === e2.type) return false;
          } else if ("complexType" === t2.type) {
            const e2 = t2.complexType;
            if ("physicalType" === e2.type) switch (e2.physicalType) {
              case 0:
              case 1:
                return true;
              default:
                return false;
            }
          }
          return console.warn("Unexpected column type in hasStreamCount", t2), false;
        }
        const xf = new TextDecoder();
        function vf(t2, e2) {
          const r2 = lp(t2, e2, 1)[0];
          if (0 === r2) return "";
          const n2 = e2.get(), i2 = t2.subarray(n2, n2 + r2);
          return e2.add(r2), xf.decode(i2);
        }
        function bf(t2, e2) {
          const r2 = lp(t2, e2, 1)[0] >>> 0, n2 = !!(4 & r2), i2 = !!(2 & r2), s2 = lp(t2, e2, 1)[0] >>> 0, o2 = {};
          if (1 & r2 && (o2.nullable = true), i2) {
            const i3 = {};
            if (n2 ? (i3.type = "logicalType", i3.logicalType = s2) : (i3.type = "physicalType", i3.physicalType = s2), 8 & r2) {
              const r3 = lp(t2, e2, 1)[0] >>> 0;
              i3.children = new Array(r3);
              for (let n3 = 0; n3 < r3; n3++) i3.children[n3] = bf(t2, e2);
            }
            o2.type = "complexField", o2.complexField = i3;
          } else {
            const t3 = {};
            n2 ? (t3.type = "logicalType", t3.logicalType = s2) : (t3.type = "physicalType", t3.physicalType = s2), o2.type = "scalarField", o2.scalarField = t3;
          }
          return o2;
        }
        function wf(t2, e2) {
          const r2 = lp(t2, e2, 1)[0] >>> 0, n2 = function(t3) {
            switch (t3) {
              case 0:
              case 1:
              case 2:
              case 3: {
                const e3 = {};
                e3.nullable = !!(1 & t3), e3.columnScope = 0;
                const r3 = {};
                return r3.physicalType = t3 > 1 ? 6 : 4, r3.type = "physicalType", e3.scalarType = r3, e3.type = "scalarType", e3;
              }
              case 4: {
                const t4 = { nullable: false, columnScope: 0 }, e3 = { type: "physicalType", physicalType: 0 };
                return t4.type = "complexType", t4.complexType = e3, t4;
              }
              case 30: {
                const t4 = { nullable: false, columnScope: 0 }, e3 = { type: "physicalType", physicalType: 1 };
                return t4.type = "complexType", t4.complexType = e3, t4;
              }
              default:
                return function(t4) {
                  let e3 = null;
                  switch (t4) {
                    case 10:
                    case 11:
                      e3 = 0;
                      break;
                    case 12:
                    case 13:
                      e3 = 1;
                      break;
                    case 14:
                    case 15:
                      e3 = 2;
                      break;
                    case 16:
                    case 17:
                      e3 = 3;
                      break;
                    case 18:
                    case 19:
                      e3 = 4;
                      break;
                    case 20:
                    case 21:
                      e3 = 5;
                      break;
                    case 22:
                    case 23:
                      e3 = 6;
                      break;
                    case 24:
                    case 25:
                      e3 = 7;
                      break;
                    case 26:
                    case 27:
                      e3 = 8;
                      break;
                    case 28:
                    case 29:
                      e3 = 9;
                      break;
                    default:
                      return null;
                  }
                  const r3 = {};
                  r3.nullable = !!(1 & t4), r3.columnScope = 0;
                  const n3 = { type: "physicalType" };
                  return n3.physicalType = e3, r3.type = "scalarType", r3.scalarType = n3, r3;
                }(t3);
            }
          }(r2);
          if (!n2) throw new Error(`Unsupported column type code: ${r2}`);
          if (function(t3) {
            return t3 >= 10;
          }(r2) ? n2.name = vf(t2, e2) : r2 >= 0 && r2 <= 3 ? n2.name = "id" : 4 === r2 && (n2.name = "geometry"), /* @__PURE__ */ function(t3) {
            return 30 === t3;
          }(r2)) {
            const r3 = lp(t2, e2, 1)[0] >>> 0, i2 = n2.complexType;
            i2.children = new Array(r3);
            for (let n3 = 0; n3 < r3; n3++) i2.children[n3] = bf(t2, e2);
          }
          return n2;
        }
        function _f(t2, e2) {
          const r2 = { featureTables: [] }, n2 = {};
          n2.name = vf(t2, e2);
          const i2 = lp(t2, e2, 1)[0] >>> 0, s2 = lp(t2, e2, 1)[0] >>> 0;
          n2.columns = new Array(s2);
          for (let r3 = 0; r3 < s2; r3++) n2.columns[r3] = wf(t2, e2);
          return r2.featureTables.push(n2), [r2, i2];
        }
        function Af(t2, e2, r2, n2, i2, s2, o2 = false) {
          const a2 = e2.scalarType.physicalType, l2 = Pp(i2, s2, t2, r2);
          if (4 === a2) switch (l2) {
            case ip.FLAT: {
              const e3 = Ap(t2, r2, i2, false);
              return new Gh(n2, e3, s2);
            }
            case ip.SEQUENCE: {
              const e3 = Tp(t2, r2, i2);
              return new Zh(n2, e3[0], e3[1], i2.numRleValues);
            }
            case ip.CONST: {
              const e3 = Ep(t2, r2, i2, false);
              return new Hh(n2, e3, s2);
            }
          }
          else switch (l2) {
            case ip.FLAT: {
              if (o2) {
                const e4 = function(t3, e5, r3, n3) {
                  const i3 = function(t4, e6, r4) {
                    const n4 = new Float64Array(e6);
                    for (let i4 = 0; i4 < e6; i4++) n4[i4] = cp(t4, r4);
                    return n4;
                  }(t3, r3.numValues, e5);
                  return function(t4, e6, r4) {
                    switch (e6.logicalLevelTechnique1) {
                      case Jh.DELTA:
                        return e6.logicalLevelTechnique2 === Jh.RLE && (t4 = gp(t4, e6.runs, e6.numRleValues)), function(t5) {
                          t5[0] = t5[0] % 2 == 1 ? (t5[0] + 1) / -2 : t5[0] / 2;
                          const e7 = t5.length / 4 * 4;
                          let r5 = 1;
                          if (e7 >= 4) for (; r5 < e7 - 4; r5 += 4) {
                            const e8 = t5[r5], n4 = t5[r5 + 1], i4 = t5[r5 + 2], s3 = t5[r5 + 3];
                            t5[r5] = (e8 % 2 == 1 ? (e8 + 1) / -2 : e8 / 2) + t5[r5 - 1], t5[r5 + 1] = (n4 % 2 == 1 ? (n4 + 1) / -2 : n4 / 2) + t5[r5], t5[r5 + 2] = (i4 % 2 == 1 ? (i4 + 1) / -2 : i4 / 2) + t5[r5 + 1], t5[r5 + 3] = (s3 % 2 == 1 ? (s3 + 1) / -2 : s3 / 2) + t5[r5 + 2];
                          }
                          for (; r5 != t5.length; ++r5) t5[r5] = (t5[r5] % 2 == 1 ? (t5[r5] + 1) / -2 : t5[r5] / 2) + t5[r5 - 1];
                        }(t4), t4;
                      case Jh.RLE:
                        return function(t5, e7, r5) {
                          return gp(t5, e7.runs, e7.numRleValues);
                        }(t4, e6);
                      case Jh.NONE:
                        return t4;
                      default:
                        throw new Error(`The specified Logical level technique is not supported: ${e6.logicalLevelTechnique1}`);
                    }
                  }(i3, r3);
                }(t2, r2, i2);
                return new Xh(n2, e4, s2);
              }
              const e3 = Mp(t2, r2, i2, false);
              return new zp(n2, e3, s2);
            }
            case ip.SEQUENCE: {
              const e3 = Ip(t2, r2, i2);
              return new Bp(n2, e3[0], e3[1], i2.numRleValues);
            }
            case ip.CONST: {
              const e3 = Fp(t2, r2, i2, false);
              return new of(n2, e3, s2);
            }
          }
          throw new Error("Vector type not supported for id column.");
        }
        class Sf {
          constructor(t2, e2) {
            var r2;
            switch (this._featureData = t2, this.properties = this._featureData.properties || {}, null === (r2 = this._featureData.geometry) || void 0 === r2 ? void 0 : r2.type) {
              case sp.POINT:
              case sp.MULTIPOINT:
                this.type = 1;
                break;
              case sp.LINESTRING:
              case sp.MULTILINESTRING:
                this.type = 2;
                break;
              case sp.POLYGON:
              case sp.MULTIPOLYGON:
                this.type = 3;
                break;
              default:
                this.type = 0;
            }
            this.extent = e2, this.id = Number(this._featureData.id);
          }
          loadGeometry() {
            const t2 = [];
            for (const e2 of this._featureData.geometry.coordinates) {
              const n2 = [];
              for (const t3 of e2) n2.push(new r(t3.x, t3.y));
              t2.push(n2);
            }
            return t2;
          }
        }
        class kf {
          constructor(t2) {
            this.features = [], this.featureTable = t2, this.name = t2.name, this.extent = t2.extent, this.version = 2, this.features = t2.getFeatures(), this.length = this.features.length;
          }
          feature(t2) {
            return new Sf(this.features[t2], this.extent);
          }
        }
        class Ef {
          constructor(t2) {
            this.layers = {};
            const e2 = function(t3, e3, r2 = true) {
              const n2 = new Wh(0), i2 = [];
              for (; n2.get() < t3.length; ) {
                const e4 = lp(t3, n2, 1)[0] >>> 0, s2 = n2.get() + e4;
                if (s2 > t3.length) throw new Error(`Block overruns tile: ${s2} > ${t3.length}`);
                if (1 != lp(t3, n2, 1)[0] >>> 0) {
                  n2.set(s2);
                  continue;
                }
                const o2 = _f(t3, n2), a2 = o2[1], l2 = o2[0].featureTables[0];
                let u2 = null, c2 = null;
                const h2 = [];
                let p2 = 0;
                for (const e5 of l2.columns) {
                  const i3 = e5.name;
                  if ("id" === i3) {
                    let s3 = null;
                    if (e5.nullable) {
                      const e6 = wp(t3, n2), r3 = n2.get(), i4 = af(t3, e6.numValues, n2);
                      n2.set(r3 + e6.byteLength), s3 = new _p(i4, e6.numValues);
                    }
                    const o3 = wp(t3, n2);
                    p2 = o3.decompressedCount, u2 = Af(t3, e5, n2, i3, o3, s3 ?? p2, r2);
                  } else if ("geometry" === i3) {
                    const e6 = lp(t3, n2, 1)[0];
                    if (0 === p2) {
                      const e7 = n2.get();
                      p2 = wp(t3, n2).decompressedCount, n2.set(e7);
                    }
                    c2 = tf(t3, e6, n2, p2);
                  } else {
                    const r3 = gf(e5) ? lp(t3, n2, 1)[0] : 1;
                    if (0 === r3 && "scalarType" === e5.type) continue;
                    const i4 = yf(t3, n2, e5, r3, p2);
                    if (i4) if (Array.isArray(i4)) for (const t4 of i4) h2.push(t4);
                    else h2.push(i4);
                  }
                }
                const f2 = new Kh(l2.name, c2, u2, h2, a2);
                i2.push(f2), n2.set(s2);
              }
              return i2;
            }(new Uint8Array(t2));
            this.layers = e2.reduce((t3, e3) => Object.assign(Object.assign({}, t3), { [e3.name]: new kf(e3) }), {});
          }
        }
        class Tf {
          constructor() {
            this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0;
          }
          extend(t2) {
            return this.minX = Math.min(this.minX, t2.x), this.minY = Math.min(this.minY, t2.y), this.maxX = Math.max(this.maxX, t2.x), this.maxY = Math.max(this.maxY, t2.y), this;
          }
          expandBy(t2) {
            return this.minX -= t2, this.minY -= t2, this.maxX += t2, this.maxY += t2, (this.minX > this.maxX || this.minY > this.maxY) && (this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0), this;
          }
          shrinkBy(t2) {
            return this.expandBy(-t2);
          }
          map(t2) {
            const e2 = new Tf();
            return e2.extend(t2(new r(this.minX, this.minY))), e2.extend(t2(new r(this.maxX, this.minY))), e2.extend(t2(new r(this.minX, this.maxY))), e2.extend(t2(new r(this.maxX, this.maxY))), e2;
          }
          static fromPoints(t2) {
            const e2 = new Tf();
            for (const r2 of t2) e2.extend(r2);
            return e2;
          }
          contains(t2) {
            return t2.x >= this.minX && t2.x <= this.maxX && t2.y >= this.minY && t2.y <= this.maxY;
          }
          empty() {
            return this.minX > this.maxX;
          }
          width() {
            return this.maxX - this.minX;
          }
          height() {
            return this.maxY - this.minY;
          }
          covers(t2) {
            return !this.empty() && !t2.empty() && t2.minX >= this.minX && t2.maxX <= this.maxX && t2.minY >= this.minY && t2.maxY <= this.maxY;
          }
          intersects(t2) {
            return !this.empty() && !t2.empty() && t2.minX <= this.maxX && t2.maxX >= this.minX && t2.minY <= this.maxY && t2.maxY >= this.minY;
          }
        }
        class If {
          constructor(t2, e2) {
            this.feature = t2, this.type = t2.type, this.properties = t2.tags ? t2.tags : {}, this.extent = e2, "id" in t2 && ("string" == typeof t2.id ? this.id = parseInt(t2.id, 10) : "number" != typeof t2.id || isNaN(t2.id) || (this.id = t2.id));
          }
          loadGeometry() {
            const t2 = [], e2 = 1 === this.feature.type ? [this.feature.geometry] : this.feature.geometry;
            for (const n2 of e2) {
              const e3 = [];
              for (const t3 of n2) e3.push(new r(t3[0], t3[1]));
              t2.push(e3);
            }
            return t2;
          }
        }
        const Mf = "_geojsonTileLayer";
        function Ff(t2, e2) {
          e2.writeVarintField(15, t2.version || 1), e2.writeStringField(1, t2.name || ""), e2.writeVarintField(5, t2.extent || 4096);
          const r2 = { keys: [], values: [], keycache: {}, valuecache: {} };
          for (let n3 = 0; n3 < t2.length; n3++) r2.feature = t2.feature(n3), e2.writeMessage(2, Df, r2);
          const n2 = r2.keys;
          for (const t3 of n2) e2.writeStringField(3, t3);
          const i2 = r2.values;
          for (const t3 of i2) e2.writeMessage(4, Cf, t3);
        }
        function Df(t2, e2) {
          if (!t2.feature) return;
          const r2 = t2.feature;
          void 0 !== r2.id && e2.writeVarintField(1, r2.id), e2.writeMessage(2, Pf, t2), e2.writeVarintField(3, r2.type), e2.writeMessage(4, Vf, r2);
        }
        function Pf(t2, e2) {
          var _a2;
          for (const r2 in (_a2 = t2.feature) == null ? void 0 : _a2.properties) {
            let n2 = t2.feature.properties[r2], i2 = t2.keycache[r2];
            if (null === n2) continue;
            void 0 === i2 && (t2.keys.push(r2), i2 = t2.keys.length - 1, t2.keycache[r2] = i2), e2.writeVarint(i2), "string" != typeof n2 && "boolean" != typeof n2 && "number" != typeof n2 && (n2 = JSON.stringify(n2));
            const s2 = typeof n2 + ":" + n2;
            let o2 = t2.valuecache[s2];
            void 0 === o2 && (t2.values.push(n2), o2 = t2.values.length - 1, t2.valuecache[s2] = o2), e2.writeVarint(o2);
          }
        }
        function zf(t2, e2) {
          return (e2 << 3) + (7 & t2);
        }
        function Bf(t2) {
          return t2 << 1 ^ t2 >> 31;
        }
        function Vf(t2, e2) {
          const r2 = t2.loadGeometry(), n2 = t2.type;
          let i2 = 0, s2 = 0;
          for (const o2 of r2) {
            let r3 = 1;
            1 === n2 && (r3 = o2.length), e2.writeVarint(zf(1, r3));
            const a2 = 3 === n2 ? o2.length - 1 : o2.length;
            for (let t3 = 0; t3 < a2; t3++) {
              1 === t3 && 1 !== n2 && e2.writeVarint(zf(2, a2 - 1));
              const r4 = o2[t3].x - i2, l2 = o2[t3].y - s2;
              e2.writeVarint(Bf(r4)), e2.writeVarint(Bf(l2)), i2 += r4, s2 += l2;
            }
            3 === t2.type && e2.writeVarint(zf(7, 1));
          }
        }
        function Cf(t2, e2) {
          const r2 = typeof t2;
          "string" === r2 ? e2.writeStringField(1, t2) : "boolean" === r2 ? e2.writeBooleanField(7, t2) : "number" === r2 && (t2 % 1 != 0 ? e2.writeDoubleField(3, t2) : t2 < 0 ? e2.writeSVarintField(6, t2) : e2.writeVarintField(5, t2));
        }
        class Lf {
          constructor(t2, e2) {
            this.tileID = t2, this.x = t2.canonical.x, this.y = t2.canonical.y, this.z = t2.canonical.z, this.grid = new as(M, 16, 0), this.grid3D = new as(M, 16, 0), this.featureIndexArray = new Oo(), this.promoteId = e2;
          }
          insert(t2, e2, r2, n2, i2, s2) {
            const o2 = this.featureIndexArray.length;
            this.featureIndexArray.emplaceBack(r2, n2, i2);
            const a2 = s2 ? this.grid3D : this.grid;
            for (let t3 = 0; t3 < e2.length; t3++) {
              const r3 = e2[t3], n3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
              for (let t4 = 0; t4 < r3.length; t4++) {
                const e3 = r3[t4];
                n3[0] = Math.min(n3[0], e3.x), n3[1] = Math.min(n3[1], e3.y), n3[2] = Math.max(n3[2], e3.x), n3[3] = Math.max(n3[3], e3.y);
              }
              n3[0] < M && n3[1] < M && n3[2] >= 0 && n3[3] >= 0 && a2.insert(o2, n3[0], n3[1], n3[2], n3[3]);
            }
          }
          loadVTLayers() {
            return this.vtLayers || (this.vtLayers = "mlt" !== this.encoding ? new Pu(new Sc(this.rawTileData)).layers : new Ef(this.rawTileData).layers, this.sourceLayerCoder = new $h(this.vtLayers ? Object.keys(this.vtLayers).sort() : [Mf])), this.vtLayers;
          }
          query(t2, e2, n2, i2) {
            this.loadVTLayers();
            const s2 = t2.params, o2 = M / t2.tileSize / t2.scale, a2 = fi(s2.filter, s2.globalState), l2 = t2.queryGeometry, u2 = t2.queryPadding * o2, c2 = Tf.fromPoints(l2), h2 = this.grid.query(c2.minX - u2, c2.minY - u2, c2.maxX + u2, c2.maxY + u2), p2 = Tf.fromPoints(t2.cameraQueryGeometry).expandBy(u2), f2 = this.grid3D.query(p2.minX, p2.minY, p2.maxX, p2.maxY, (e3, n3, i3, s3) => function(t3, e4, n4, i4, s4) {
              for (const r2 of t3) if (e4 <= r2.x && n4 <= r2.y && i4 >= r2.x && s4 >= r2.y) return true;
              const o3 = [new r(e4, n4), new r(e4, s4), new r(i4, s4), new r(i4, n4)];
              if (t3.length > 2) {
                for (const e5 of o3) if (Wa(t3, e5)) return true;
              }
              for (let e5 = 0; e5 < t3.length - 1; e5++) if (Ja(t3[e5], t3[e5 + 1], o3)) return true;
              return false;
            }(t2.cameraQueryGeometry, e3 - u2, n3 - u2, i3 + u2, s3 + u2));
            for (const t3 of f2) h2.push(t3);
            h2.sort(Rf);
            const d2 = {};
            let y2;
            for (let r2 = 0; r2 < h2.length; r2++) {
              const u3 = h2[r2];
              if (u3 === y2) continue;
              y2 = u3;
              const c3 = this.featureIndexArray.get(u3);
              let p3 = null;
              this.loadMatchingFeature(d2, c3.bucketIndex, c3.sourceLayerIndex, c3.featureIndex, a2, s2.layers, s2.availableImages, e2, n2, i2, (e3, r3, n3) => (p3 || (p3 = La(e3)), r3.queryIntersectsFeature({ queryGeometry: l2, feature: e3, featureState: n3, geometry: p3, zoom: this.z, transform: t2.transform, pixelsToTileUnits: o2, pixelPosMatrix: t2.pixelPosMatrix, unwrappedTileID: this.tileID.toUnwrapped(), getElevation: t2.getElevation })));
            }
            return d2;
          }
          loadMatchingFeature(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2) {
            const h2 = this.bucketLayerIDs[e2];
            if (s2 && !h2.some((t3) => s2.has(t3))) return;
            const p2 = this.sourceLayerCoder.decode(r2), f2 = this.vtLayers[p2].feature(n2);
            if (i2.needGeometry) {
              const t3 = Oa(f2, true);
              if (!i2.filter(new Fs(this.tileID.overscaledZ), t3, this.tileID.canonical)) return;
            } else if (!i2.filter(new Fs(this.tileID.overscaledZ), f2)) return;
            const d2 = this.getId(f2, p2);
            for (let e3 = 0; e3 < h2.length; e3++) {
              const r3 = h2[e3];
              if (s2 && !s2.has(r3)) continue;
              const i3 = a2[r3];
              if (!i3) continue;
              let p3 = {};
              d2 && u2 && (p3 = u2.getState(i3.sourceLayer || Mf, d2));
              const y2 = O({}, l2[r3]);
              y2.paint = Of(y2.paint, i3.paint, f2, p3, o2), y2.layout = Of(y2.layout, i3.layout, f2, p3, o2);
              const m2 = !c2 || c2(f2, i3, p3);
              if (!m2) continue;
              const g2 = new Uh(f2, this.z, this.x, this.y, d2);
              g2.layer = y2;
              let x2 = t2[r3];
              void 0 === x2 && (x2 = t2[r3] = []), x2.push({ featureIndex: n2, feature: g2, intersectionZ: m2 });
            }
          }
          lookupSymbolFeatures(t2, e2, r2, n2, i2, s2, o2, a2) {
            const l2 = {};
            this.loadVTLayers();
            const u2 = fi(i2.filterSpec, i2.globalState);
            for (const i3 of t2) this.loadMatchingFeature(l2, r2, n2, i3, u2, s2, o2, a2, e2);
            return l2;
          }
          hasLayer(t2) {
            for (const e2 of this.bucketLayerIDs) for (const r2 of e2) if (t2 === r2) return true;
            return false;
          }
          getId(t2, e2) {
            var r2;
            let n2 = t2.id;
            return this.promoteId && (n2 = t2.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[e2]], "boolean" == typeof n2 && (n2 = Number(n2)), void 0 === n2 && (null === (r2 = t2.properties) || void 0 === r2 ? void 0 : r2.cluster) && this.promoteId && (n2 = Number(t2.properties.cluster_id))), n2;
          }
        }
        function Of(t2, e2, r2, n2, i2) {
          return N(t2, (t3, s2) => {
            const o2 = e2 instanceof Ns ? e2.get(s2) : null;
            return o2 && o2.evaluate ? o2.evaluate(r2, n2, i2) : o2;
          });
        }
        function Rf(t2, e2) {
          return e2 - t2;
        }
        function Nf(t2, e2, n2, i2, s2) {
          const o2 = [];
          for (let a2 = 0; a2 < t2.length; a2++) {
            const l2 = t2[a2];
            let u2;
            for (let t3 = 0; t3 < l2.length - 1; t3++) {
              let a3 = l2[t3], c2 = l2[t3 + 1];
              a3.x < e2 && c2.x < e2 || (a3.x < e2 ? a3 = new r(e2, a3.y + (e2 - a3.x) / (c2.x - a3.x) * (c2.y - a3.y))._round() : c2.x < e2 && (c2 = new r(e2, a3.y + (e2 - a3.x) / (c2.x - a3.x) * (c2.y - a3.y))._round()), a3.y < n2 && c2.y < n2 || (a3.y < n2 ? a3 = new r(a3.x + (n2 - a3.y) / (c2.y - a3.y) * (c2.x - a3.x), n2)._round() : c2.y < n2 && (c2 = new r(a3.x + (n2 - a3.y) / (c2.y - a3.y) * (c2.x - a3.x), n2)._round()), a3.x >= i2 && c2.x >= i2 || (a3.x >= i2 ? a3 = new r(i2, a3.y + (i2 - a3.x) / (c2.x - a3.x) * (c2.y - a3.y))._round() : c2.x >= i2 && (c2 = new r(i2, a3.y + (i2 - a3.x) / (c2.x - a3.x) * (c2.y - a3.y))._round()), a3.y >= s2 && c2.y >= s2 || (a3.y >= s2 ? a3 = new r(a3.x + (s2 - a3.y) / (c2.y - a3.y) * (c2.x - a3.x), s2)._round() : c2.y >= s2 && (c2 = new r(a3.x + (s2 - a3.y) / (c2.y - a3.y) * (c2.x - a3.x), s2)._round()), u2 && a3.equals(u2[u2.length - 1]) || (u2 = [a3], o2.push(u2)), u2.push(c2)))));
            }
          }
          return o2;
        }
        function $f(t2, e2, r2, n2, i2) {
          switch (e2) {
            case 1:
              return function(t3, e3, r3, n3) {
                const i3 = [];
                for (const s2 of t3) for (const t4 of s2) {
                  const s3 = 0 === n3 ? t4.x : t4.y;
                  s3 >= e3 && s3 <= r3 && i3.push([t4]);
                }
                return i3;
              }(t2, r2, n2, i2);
            case 2:
              return qf(t2, r2, n2, i2, false);
            case 3:
              return qf(t2, r2, n2, i2, true);
          }
          return [];
        }
        function Uf(t2, e2, n2, i2, s2) {
          const o2 = 0 === i2 ? jf : Gf;
          let a2 = [];
          const l2 = [];
          for (let r2 = 0; r2 < t2.length - 1; r2++) {
            const u3 = t2[r2], c3 = t2[r2 + 1], h2 = 0 === i2 ? u3.x : u3.y, p2 = 0 === i2 ? c3.x : c3.y;
            let f2 = false;
            h2 < e2 ? p2 > e2 && a2.push(o2(u3, c3, e2)) : h2 > n2 ? p2 < n2 && a2.push(o2(u3, c3, n2)) : a2.push(u3), p2 < e2 && h2 >= e2 && (a2.push(o2(u3, c3, e2)), f2 = true), p2 > n2 && h2 <= n2 && (a2.push(o2(u3, c3, n2)), f2 = true), !s2 && f2 && (l2.push(a2), a2 = []);
          }
          const u2 = t2.length - 1, c2 = 0 === i2 ? t2[u2].x : t2[u2].y;
          return c2 >= e2 && c2 <= n2 && a2.push(t2[u2]), s2 && a2.length > 0 && !a2[0].equals(a2[a2.length - 1]) && a2.push(new r(a2[0].x, a2[0].y)), a2.length > 0 && l2.push(a2), l2;
        }
        function qf(t2, e2, r2, n2, i2) {
          const s2 = [];
          for (const o2 of t2) {
            const t3 = Uf(o2, e2, r2, n2, i2);
            t3.length > 0 && s2.push(...t3);
          }
          return s2;
        }
        function jf(t2, e2, n2) {
          return new r(n2, t2.y + (n2 - t2.x) / (e2.x - t2.x) * (e2.y - t2.y));
        }
        function Gf(t2, e2, n2) {
          return new r(t2.x + (n2 - t2.y) / (e2.y - t2.y) * (e2.x - t2.x), n2);
        }
        us("FeatureIndex", Lf, { omit: ["rawTileData", "sourceLayerCoder"] });
        class Xf extends r {
          constructor(t2, e2, r2, n2) {
            super(t2, e2), this.angle = r2, void 0 !== n2 && (this.segment = n2);
          }
          clone() {
            return new Xf(this.x, this.y, this.angle, this.segment);
          }
        }
        function Yf(t2, e2, r2, n2, i2) {
          if (void 0 === e2.segment || 0 === r2) return true;
          let s2 = e2, o2 = e2.segment + 1, a2 = 0;
          for (; a2 > -r2 / 2; ) {
            if (o2--, o2 < 0) return false;
            a2 -= t2[o2].dist(s2), s2 = t2[o2];
          }
          a2 += t2[o2].dist(t2[o2 + 1]), o2++;
          const l2 = [];
          let u2 = 0;
          for (; a2 < r2 / 2; ) {
            const e3 = t2[o2], r3 = t2[o2 + 1];
            if (!r3) return false;
            let s3 = t2[o2 - 1].angleTo(e3) - e3.angleTo(r3);
            for (s3 = Math.abs((s3 + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l2.push({ distance: a2, angleDelta: s3 }), u2 += s3; a2 - l2[0].distance > n2; ) u2 -= l2.shift().angleDelta;
            if (u2 > i2) return false;
            o2++, a2 += e3.dist(r3);
          }
          return true;
        }
        function Zf(t2) {
          let e2 = 0;
          for (let r2 = 0; r2 < t2.length - 1; r2++) e2 += t2[r2].dist(t2[r2 + 1]);
          return e2;
        }
        function Hf(t2, e2, r2) {
          return t2 ? 0.6 * e2 * r2 : 0;
        }
        function Kf(t2, e2) {
          return Math.max(t2 ? t2.right - t2.left : 0, e2 ? e2.right - e2.left : 0);
        }
        function Wf(t2, e2, r2, n2, i2, s2) {
          const o2 = Hf(r2, i2, s2), a2 = Kf(r2, n2) * s2;
          let l2 = 0;
          const u2 = Zf(t2) / 2;
          for (let r3 = 0; r3 < t2.length - 1; r3++) {
            const n3 = t2[r3], i3 = t2[r3 + 1], s3 = n3.dist(i3);
            if (l2 + s3 > u2) {
              const c2 = (u2 - l2) / s3, h2 = yr.number(n3.x, i3.x, c2), p2 = yr.number(n3.y, i3.y, c2), f2 = new Xf(h2, p2, i3.angleTo(n3), r3);
              return f2._round(), !o2 || Yf(t2, f2, a2, o2, e2) ? f2 : void 0;
            }
            l2 += s3;
          }
        }
        function Jf(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
          const u2 = Hf(n2, s2, o2), c2 = Kf(n2, i2), h2 = c2 * o2, p2 = 0 === t2[0].x || t2[0].x === l2 || 0 === t2[0].y || t2[0].y === l2;
          return e2 - h2 < e2 / 4 && (e2 = h2 + e2 / 4), Qf(t2, p2 ? e2 / 2 * a2 % e2 : (c2 / 2 + 2 * s2) * o2 * a2 % e2, e2, u2, r2, h2, p2, false, l2);
        }
        function Qf(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
          const u2 = s2 / 2, c2 = Zf(t2);
          let h2 = 0, p2 = e2 - r2, f2 = [];
          for (let e3 = 0; e3 < t2.length - 1; e3++) {
            const o3 = t2[e3], a3 = t2[e3 + 1], d2 = o3.dist(a3), y2 = a3.angleTo(o3);
            for (; p2 + r2 < h2 + d2; ) {
              p2 += r2;
              const m2 = (p2 - h2) / d2, g2 = yr.number(o3.x, a3.x, m2), x2 = yr.number(o3.y, a3.y, m2);
              if (g2 >= 0 && g2 < l2 && x2 >= 0 && x2 < l2 && p2 - u2 >= 0 && p2 + u2 <= c2) {
                const r3 = new Xf(g2, x2, y2, e3);
                r3._round(), n2 && !Yf(t2, r3, s2, n2, i2) || f2.push(r3);
              }
            }
            h2 += d2;
          }
          return a2 || f2.length || o2 || (f2 = Qf(t2, h2 / 2, r2, n2, i2, s2, o2, true, l2)), f2;
        }
        function td(t2, e2, n2, i2) {
          const s2 = [], o2 = t2.image, a2 = o2.pixelRatio, l2 = o2.paddedRect.w - 2, u2 = o2.paddedRect.h - 2;
          let c2 = { x1: t2.left, y1: t2.top, x2: t2.right, y2: t2.bottom };
          const h2 = o2.stretchX || [[0, l2]], p2 = o2.stretchY || [[0, u2]], f2 = (t3, e3) => t3 + e3[1] - e3[0], d2 = h2.reduce(f2, 0), y2 = p2.reduce(f2, 0), m2 = l2 - d2, g2 = u2 - y2;
          let x2 = 0, v2 = d2, b2 = 0, w2 = y2, _2 = 0, A2 = m2, S2 = 0, k2 = g2;
          if (o2.content && i2) {
            const e3 = o2.content, r2 = e3[2] - e3[0], n3 = e3[3] - e3[1];
            (o2.textFitWidth || o2.textFitHeight) && (c2 = Jc(t2)), x2 = ed(h2, 0, e3[0]), b2 = ed(p2, 0, e3[1]), v2 = ed(h2, e3[0], e3[2]), w2 = ed(p2, e3[1], e3[3]), _2 = e3[0] - x2, S2 = e3[1] - b2, A2 = r2 - v2, k2 = n3 - w2;
          }
          const E2 = c2.x1, T2 = c2.y1, I2 = c2.x2 - E2, M2 = c2.y2 - T2, F2 = (t3, i3, s3, l3) => {
            const u3 = nd(t3.stretch - x2, v2, I2, E2), c3 = id(t3.fixed - _2, A2, t3.stretch, d2), h3 = nd(i3.stretch - b2, w2, M2, T2), p3 = id(i3.fixed - S2, k2, i3.stretch, y2), f3 = nd(s3.stretch - x2, v2, I2, E2), m3 = id(s3.fixed - _2, A2, s3.stretch, d2), g3 = nd(l3.stretch - b2, w2, M2, T2), F3 = id(l3.fixed - S2, k2, l3.stretch, y2), D2 = new r(u3, h3), P2 = new r(f3, h3), z2 = new r(f3, g3), B2 = new r(u3, g3), V2 = new r(c3 / a2, p3 / a2), C2 = new r(m3 / a2, F3 / a2), L3 = e2 * Math.PI / 180;
            if (L3) {
              const t4 = Math.sin(L3), e3 = Math.cos(L3), r2 = [e3, -t4, t4, e3];
              D2._matMult(r2), P2._matMult(r2), B2._matMult(r2), z2._matMult(r2);
            }
            const O2 = t3.stretch + t3.fixed, R2 = i3.stretch + i3.fixed;
            return { tl: D2, tr: P2, bl: B2, br: z2, tex: { x: o2.paddedRect.x + 1 + O2, y: o2.paddedRect.y + 1 + R2, w: s3.stretch + s3.fixed - O2, h: l3.stretch + l3.fixed - R2 }, writingMode: void 0, glyphOffset: [0, 0], sectionIndex: 0, pixelOffsetTL: V2, pixelOffsetBR: C2, minFontScaleX: A2 / a2 / I2, minFontScaleY: k2 / a2 / M2, isSDF: n2 };
          };
          if (i2 && (o2.stretchX || o2.stretchY)) {
            const t3 = rd(h2, m2, d2), e3 = rd(p2, g2, y2);
            for (let r2 = 0; r2 < t3.length - 1; r2++) {
              const n3 = t3[r2], i3 = t3[r2 + 1];
              for (let t4 = 0; t4 < e3.length - 1; t4++) s2.push(F2(n3, e3[t4], i3, e3[t4 + 1]));
            }
          } else s2.push(F2({ fixed: 0, stretch: -1 }, { fixed: 0, stretch: -1 }, { fixed: 0, stretch: l2 + 1 }, { fixed: 0, stretch: u2 + 1 }));
          return s2;
        }
        function ed(t2, e2, r2) {
          let n2 = 0;
          for (const i2 of t2) n2 += Math.max(e2, Math.min(r2, i2[1])) - Math.max(e2, Math.min(r2, i2[0]));
          return n2;
        }
        function rd(t2, e2, r2) {
          const n2 = [{ fixed: -1, stretch: 0 }];
          for (const [e3, r3] of t2) {
            const t3 = n2[n2.length - 1];
            n2.push({ fixed: e3 - t3.stretch, stretch: t3.stretch }), n2.push({ fixed: e3 - t3.stretch, stretch: t3.stretch + (r3 - e3) });
          }
          return n2.push({ fixed: e2 + 1, stretch: r2 }), n2;
        }
        function nd(t2, e2, r2, n2) {
          return t2 / e2 * r2 + n2;
        }
        function id(t2, e2, r2, n2) {
          return t2 - e2 * r2 / n2;
        }
        us("Anchor", Xf);
        class sd {
          constructor(t2, e2, n2, i2, s2, o2, a2, l2, u2, c2) {
            var h2;
            if (this.boxStartIndex = t2.length, u2) {
              let t3 = o2.top, e3 = o2.bottom;
              const r2 = o2.collisionPadding;
              r2 && (t3 -= r2[1], e3 += r2[3]);
              let n3 = e3 - t3;
              n3 > 0 && (n3 = Math.max(10, n3), this.circleDiameter = n3);
            } else {
              const u3 = (null === (h2 = o2.image) || void 0 === h2 ? void 0 : h2.content) && (o2.image.textFitWidth || o2.image.textFitHeight) ? Jc(o2) : { x1: o2.left, y1: o2.top, x2: o2.right, y2: o2.bottom };
              u3.y1 = u3.y1 * a2 - l2[0], u3.y2 = u3.y2 * a2 + l2[2], u3.x1 = u3.x1 * a2 - l2[3], u3.x2 = u3.x2 * a2 + l2[1];
              const p2 = o2.collisionPadding;
              if (p2 && (u3.x1 -= p2[0] * a2, u3.y1 -= p2[1] * a2, u3.x2 += p2[2] * a2, u3.y2 += p2[3] * a2), c2) {
                const t3 = new r(u3.x1, u3.y1), e3 = new r(u3.x2, u3.y1), n3 = new r(u3.x1, u3.y2), i3 = new r(u3.x2, u3.y2), s3 = c2 * Math.PI / 180;
                t3._rotate(s3), e3._rotate(s3), n3._rotate(s3), i3._rotate(s3), u3.x1 = Math.min(t3.x, e3.x, n3.x, i3.x), u3.x2 = Math.max(t3.x, e3.x, n3.x, i3.x), u3.y1 = Math.min(t3.y, e3.y, n3.y, i3.y), u3.y2 = Math.max(t3.y, e3.y, n3.y, i3.y);
              }
              t2.emplaceBack(e2.x, e2.y, u3.x1, u3.y1, u3.x2, u3.y2, n2, i2, s2);
            }
            this.boxEndIndex = t2.length;
          }
        }
        class od {
          constructor(t2 = [], e2 = (t3, e3) => t3 < e3 ? -1 : t3 > e3 ? 1 : 0) {
            if (this.data = t2, this.length = this.data.length, this.compare = e2, this.length > 0) for (let t3 = (this.length >> 1) - 1; t3 >= 0; t3--) this._down(t3);
          }
          push(t2) {
            this.data.push(t2), this._up(this.length++);
          }
          pop() {
            if (0 === this.length) return;
            const t2 = this.data[0], e2 = this.data.pop();
            return --this.length > 0 && (this.data[0] = e2, this._down(0)), t2;
          }
          peek() {
            return this.data[0];
          }
          _up(t2) {
            const { data: e2, compare: r2 } = this, n2 = e2[t2];
            for (; t2 > 0; ) {
              const i2 = t2 - 1 >> 1, s2 = e2[i2];
              if (r2(n2, s2) >= 0) break;
              e2[t2] = s2, t2 = i2;
            }
            e2[t2] = n2;
          }
          _down(t2) {
            const { data: e2, compare: r2 } = this, n2 = this.length >> 1, i2 = e2[t2];
            for (; t2 < n2; ) {
              let n3 = 1 + (t2 << 1);
              const s2 = n3 + 1;
              if (s2 < this.length && r2(e2[s2], e2[n3]) < 0 && (n3 = s2), r2(e2[n3], i2) >= 0) break;
              e2[t2] = e2[n3], t2 = n3;
            }
            e2[t2] = i2;
          }
        }
        function ad(t2, e2 = 1, n2 = false) {
          const i2 = Tf.fromPoints(t2[0]), s2 = Math.min(i2.width(), i2.height());
          let o2 = s2 / 2;
          const a2 = new od([], ld), { minX: l2, minY: u2, maxX: c2, maxY: h2 } = i2;
          if (0 === s2) return new r(l2, u2);
          for (let e3 = l2; e3 < c2; e3 += s2) for (let r2 = u2; r2 < h2; r2 += s2) a2.push(new ud(e3 + o2, r2 + o2, o2, t2));
          let p2 = function(t3) {
            let e3 = 0, r2 = 0, n3 = 0;
            const i3 = t3[0];
            for (let t4 = 0, s3 = i3.length, o3 = s3 - 1; t4 < s3; o3 = t4++) {
              const s4 = i3[t4], a3 = i3[o3], l3 = s4.x * a3.y - a3.x * s4.y;
              r2 += (s4.x + a3.x) * l3, n3 += (s4.y + a3.y) * l3, e3 += 3 * l3;
            }
            return new ud(r2 / e3, n3 / e3, 0, t3);
          }(t2), f2 = a2.length;
          for (; a2.length; ) {
            const r2 = a2.pop();
            (r2.d > p2.d || !p2.d) && (p2 = r2, n2 && console.log("found best %d after %d probes", Math.round(1e4 * r2.d) / 1e4, f2)), r2.max - p2.d <= e2 || (o2 = r2.h / 2, a2.push(new ud(r2.p.x - o2, r2.p.y - o2, o2, t2)), a2.push(new ud(r2.p.x + o2, r2.p.y - o2, o2, t2)), a2.push(new ud(r2.p.x - o2, r2.p.y + o2, o2, t2)), a2.push(new ud(r2.p.x + o2, r2.p.y + o2, o2, t2)), f2 += 4);
          }
          return n2 && (console.log(`num probes: ${f2}`), console.log(`best distance: ${p2.d}`)), p2.p;
        }
        function ld(t2, e2) {
          return e2.max - t2.max;
        }
        function ud(t2, e2, n2, i2) {
          this.p = new r(t2, e2), this.h = n2, this.d = function(t3, e3) {
            let r2 = false, n3 = 1 / 0;
            for (let i3 = 0; i3 < e3.length; i3++) {
              const s2 = e3[i3];
              for (let e4 = 0, i4 = s2.length, o2 = i4 - 1; e4 < i4; o2 = e4++) {
                const i5 = s2[e4], a2 = s2[o2];
                i5.y > t3.y != a2.y > t3.y && t3.x < (a2.x - i5.x) * (t3.y - i5.y) / (a2.y - i5.y) + i5.x && (r2 = !r2), n3 = Math.min(n3, Ha(t3, i5, a2));
              }
            }
            return (r2 ? 1 : -1) * Math.sqrt(n3);
          }(this.p, i2), this.max = this.d + this.h * Math.SQRT2;
        }
        var cd;
        t.aQ = void 0, (cd = t.aQ || (t.aQ = {}))[cd.center = 1] = "center", cd[cd.left = 2] = "left", cd[cd.right = 3] = "right", cd[cd.top = 4] = "top", cd[cd.bottom = 5] = "bottom", cd[cd["top-left"] = 6] = "top-left", cd[cd["top-right"] = 7] = "top-right", cd[cd["bottom-left"] = 8] = "bottom-left", cd[cd["bottom-right"] = 9] = "bottom-right";
        const hd = Number.POSITIVE_INFINITY;
        function pd(t2, e2) {
          return e2[1] !== hd ? function(t3, e3, r2) {
            let n2 = 0, i2 = 0;
            switch (e3 = Math.abs(e3), r2 = Math.abs(r2), t3) {
              case "top-right":
              case "top-left":
              case "top":
                i2 = r2 - 7;
                break;
              case "bottom-right":
              case "bottom-left":
              case "bottom":
                i2 = 7 - r2;
            }
            switch (t3) {
              case "top-right":
              case "bottom-right":
              case "right":
                n2 = -e3;
                break;
              case "top-left":
              case "bottom-left":
              case "left":
                n2 = e3;
            }
            return [n2, i2];
          }(t2, e2[0], e2[1]) : function(t3, e3) {
            let r2 = 0, n2 = 0;
            e3 < 0 && (e3 = 0);
            const i2 = e3 / Math.SQRT2;
            switch (t3) {
              case "top-right":
              case "top-left":
                n2 = i2 - 7;
                break;
              case "bottom-right":
              case "bottom-left":
                n2 = 7 - i2;
                break;
              case "bottom":
                n2 = 7 - e3;
                break;
              case "top":
                n2 = e3 - 7;
            }
            switch (t3) {
              case "top-right":
              case "bottom-right":
                r2 = -i2;
                break;
              case "top-left":
              case "bottom-left":
                r2 = i2;
                break;
              case "left":
                r2 = e3;
                break;
              case "right":
                r2 = -e3;
            }
            return [r2, n2];
          }(t2, e2[0]);
        }
        function fd(t2, e2, r2) {
          var n2;
          const i2 = t2.layout, s2 = null === (n2 = i2.get("text-variable-anchor-offset")) || void 0 === n2 ? void 0 : n2.evaluate(e2, {}, r2);
          if (s2) {
            const t3 = s2.values, e3 = [];
            for (let r3 = 0; r3 < t3.length; r3 += 2) {
              const n3 = e3[r3] = t3[r3], i3 = t3[r3 + 1].map((t4) => t4 * hc);
              n3.startsWith("top") ? i3[1] -= 7 : n3.startsWith("bottom") && (i3[1] += 7), e3[r3 + 1] = i3;
            }
            return new Le(e3);
          }
          const o2 = i2.get("text-variable-anchor");
          if (o2) {
            let n3;
            n3 = void 0 !== t2._unevaluatedLayout.getValue("text-radial-offset") ? [i2.get("text-radial-offset").evaluate(e2, {}, r2) * hc, hd] : i2.get("text-offset").evaluate(e2, {}, r2).map((t3) => t3 * hc);
            const s3 = [];
            for (const t3 of o2) s3.push(t3, pd(t3, n3));
            return new Le(s3);
          }
          return null;
        }
        function dd(t2) {
          switch (t2) {
            case "right":
            case "top-right":
            case "bottom-right":
              return "right";
            case "left":
            case "top-left":
            case "bottom-left":
              return "left";
          }
          return "center";
        }
        function yd(e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2) {
          let f2 = o2.textMaxSize.evaluate(r2, {});
          void 0 === f2 && (f2 = a2);
          const d2 = e2.layers[0].layout, y2 = d2.get("icon-offset").evaluate(r2, {}, h2), m2 = gd(n2.horizontal), g2 = a2 / 24, x2 = e2.tilePixelRatio * g2, v2 = e2.tilePixelRatio * f2 / 24, b2 = e2.tilePixelRatio * l2, w2 = e2.tilePixelRatio * d2.get("symbol-spacing"), _2 = d2.get("text-padding") * e2.tilePixelRatio, A2 = function(t2, e3, r3, n3 = 1) {
            const i3 = t2.get("icon-padding").evaluate(e3, {}, r3), s3 = i3 && i3.values;
            return [s3[0] * n3, s3[1] * n3, s3[2] * n3, s3[3] * n3];
          }(d2, r2, h2, e2.tilePixelRatio), S2 = d2.get("text-max-angle") / 180 * Math.PI, k2 = "viewport" !== d2.get("text-rotation-alignment") && "point" !== d2.get("symbol-placement"), E2 = "map" === d2.get("icon-rotation-alignment") && "point" !== d2.get("symbol-placement"), T2 = d2.get("symbol-placement"), I2 = w2 / 2, F2 = d2.get("icon-text-fit");
          let D2;
          i2 && "none" !== F2 && (e2.allowVerticalPlacement && n2.vertical && (D2 = Qc(i2, n2.vertical, F2, d2.get("icon-text-fit-padding"), y2, g2)), m2 && (i2 = Qc(i2, m2, F2, d2.get("icon-text-fit-padding"), y2, g2)));
          const P2 = h2 ? p2.line.getGranularityForZoomLevel(h2.z) : 1, z2 = (l3, p3) => {
            p3.x < 0 || p3.x >= M || p3.y < 0 || p3.y >= M || function(e3, r3, n3, i3, s3, o3, a3, l4, u3, c3, h3, p4, f3, d3, y3, m3, g3, x3, v3, b3, w3, _3, A3, S3, k3) {
              const E3 = e3.addToLineVertexArray(r3, n3);
              let T3, I3, M2, F3, D3 = 0, P3 = 0, z3 = 0, B2 = 0, V2 = -1, C2 = -1;
              const L3 = {};
              let O2 = fa("");
              if (e3.allowVerticalPlacement && i3.vertical) {
                const t2 = l4.layout.get("text-rotate").evaluate(w3, {}, S3) + 90;
                M2 = new sd(u3, r3, c3, h3, p4, i3.vertical, f3, d3, y3, t2), a3 && (F3 = new sd(u3, r3, c3, h3, p4, a3, g3, x3, y3, t2));
              }
              if (s3) {
                const n4 = l4.layout.get("icon-rotate").evaluate(w3, {}), i4 = "none" !== l4.layout.get("icon-text-fit"), o4 = td(s3, n4, A3, i4), f4 = a3 ? td(a3, n4, A3, i4) : void 0;
                I3 = new sd(u3, r3, c3, h3, p4, s3, g3, x3, false, n4), D3 = 4 * o4.length;
                const d4 = e3.iconSizeData;
                let y4 = null;
                "source" === d4.kind ? (y4 = [th * l4.layout.get("icon-size").evaluate(w3, {})], y4[0] > eh && j(`${e3.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)) : "composite" === d4.kind && (y4 = [th * _3.compositeIconSizes[0].evaluate(w3, {}, S3), th * _3.compositeIconSizes[1].evaluate(w3, {}, S3)], (y4[0] > eh || y4[1] > eh) && j(`${e3.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)), e3.addSymbols(e3.icon, o4, y4, b3, v3, w3, t.aA.none, r3, E3.lineStartIndex, E3.lineLength, -1, S3), V2 = e3.icon.placedSymbolArray.length - 1, f4 && (P3 = 4 * f4.length, e3.addSymbols(e3.icon, f4, y4, b3, v3, w3, t.aA.vertical, r3, E3.lineStartIndex, E3.lineLength, -1, S3), C2 = e3.icon.placedSymbolArray.length - 1);
              }
              const R2 = Object.keys(i3.horizontal);
              for (const n4 of R2) {
                const s4 = i3.horizontal[n4];
                if (!T3) {
                  O2 = fa(s4.text);
                  const t2 = l4.layout.get("text-rotate").evaluate(w3, {}, S3);
                  T3 = new sd(u3, r3, c3, h3, p4, s4, f3, d3, y3, t2);
                }
                const a4 = 1 === s4.positionedLines.length;
                if (z3 += md(e3, r3, s4, o3, l4, y3, w3, m3, E3, i3.vertical ? t.aA.horizontal : t.aA.horizontalOnly, a4 ? R2 : [n4], L3, V2, _3, S3), a4) break;
              }
              i3.vertical && (B2 += md(e3, r3, i3.vertical, o3, l4, y3, w3, m3, E3, t.aA.vertical, ["vertical"], L3, C2, _3, S3));
              const N2 = T3 ? T3.boxStartIndex : e3.collisionBoxArray.length, $2 = T3 ? T3.boxEndIndex : e3.collisionBoxArray.length, U2 = M2 ? M2.boxStartIndex : e3.collisionBoxArray.length, q2 = M2 ? M2.boxEndIndex : e3.collisionBoxArray.length, G2 = I3 ? I3.boxStartIndex : e3.collisionBoxArray.length, X2 = I3 ? I3.boxEndIndex : e3.collisionBoxArray.length, Y2 = F3 ? F3.boxStartIndex : e3.collisionBoxArray.length, Z2 = F3 ? F3.boxEndIndex : e3.collisionBoxArray.length;
              let H2 = -1;
              const K2 = (t2, e4) => t2 && t2.circleDiameter ? Math.max(t2.circleDiameter, e4) : e4;
              H2 = K2(T3, H2), H2 = K2(M2, H2), H2 = K2(I3, H2), H2 = K2(F3, H2);
              const W2 = H2 > -1 ? 1 : 0;
              W2 && (H2 *= k3 / hc), e3.glyphOffsetArray.length >= ch.MAX_GLYPHS && j("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== w3.sortKey && e3.addToSortKeyRanges(e3.symbolInstances.length, w3.sortKey);
              const J2 = fd(l4, w3, S3), [Q2, tt2] = function(e4, r4) {
                const n4 = e4.length, i4 = null == r4 ? void 0 : r4.values;
                if ((null == i4 ? void 0 : i4.length) > 0) for (let r5 = 0; r5 < i4.length; r5 += 2) {
                  const n5 = i4[r5 + 1];
                  e4.emplaceBack(t.aQ[i4[r5]], n5[0], n5[1]);
                }
                return [n4, e4.length];
              }(e3.textAnchorOffsets, J2);
              e3.symbolInstances.emplaceBack(r3.x, r3.y, L3.right >= 0 ? L3.right : -1, L3.center >= 0 ? L3.center : -1, L3.left >= 0 ? L3.left : -1, L3.vertical || -1, V2, C2, O2, N2, $2, U2, q2, G2, X2, Y2, Z2, c3, z3, B2, D3, P3, W2, 0, f3, H2, Q2, tt2);
            }(e2, p3, l3, n2, i2, s2, D2, e2.layers[0], e2.collisionBoxArray, r2.index, r2.sourceLayerIndex, e2.index, x2, [_2, _2, _2, _2], k2, u2, b2, A2, E2, y2, r2, o2, c2, h2, a2);
          };
          if ("line" === T2) for (const t2 of Nf(r2.geometry, 0, 0, M, M)) {
            const r3 = du(t2, P2), s3 = Jf(r3, w2, S2, n2.vertical || m2, i2, 24, v2, e2.overscaling, M);
            for (const t3 of s3) m2 && xd(e2, m2.text, I2, t3) || z2(r3, t3);
          }
          else if ("line-center" === T2) {
            for (const t2 of r2.geometry) if (t2.length > 1) {
              const e3 = du(t2, P2), r3 = Wf(e3, S2, n2.vertical || m2, i2, 24, v2);
              r3 && z2(e3, r3);
            }
          } else if ("Polygon" === r2.type) for (const t2 of tn(r2.geometry, 0)) {
            const e3 = ad(t2, 16);
            z2(du(t2[0], P2, true), new Xf(e3.x, e3.y, 0));
          }
          else if ("LineString" === r2.type) for (const t2 of r2.geometry) {
            const e3 = du(t2, P2);
            z2(e3, new Xf(e3[0].x, e3[0].y, 0));
          }
          else if ("Point" === r2.type) for (const t2 of r2.geometry) for (const e3 of t2) z2([e3], new Xf(e3.x, e3.y, 0));
        }
        function md(t2, e2, n2, i2, s2, o2, a2, l2, u2, c2, h2, p2, f2, d2, y2) {
          const m2 = function(t3, e3, n3, i3, s3, o3, a3, l3) {
            const u3 = i3.layout.get("text-rotate").evaluate(o3, {}) * Math.PI / 180, c3 = [];
            for (const t4 of e3.positionedLines) for (const i4 of t4.positionedGlyphs) {
              if (!i4.rect) continue;
              const o4 = i4.rect || {};
              let h3 = 4, p3 = true, f3 = 1, d3 = 0;
              const y3 = (s3 || l3) && i4.vertical, m3 = i4.metrics.advance * i4.scale / 2;
              if (l3 && e3.verticalizable && (d3 = t4.lineOffset / 2 - (i4.imageName ? -(hc - i4.metrics.width * i4.scale) / 2 : (i4.scale - 1) * hc)), i4.imageName) {
                const t5 = a3[i4.imageName];
                p3 = t5.sdf, f3 = t5.pixelRatio, h3 = 1 / f3;
              }
              const g3 = s3 ? [i4.x + m3, i4.y] : [0, 0];
              let x3 = s3 ? [0, 0] : [i4.x + m3 + n3[0], i4.y + n3[1] - d3], v2 = [0, 0];
              y3 && (v2 = x3, x3 = [0, 0]);
              const b2 = i4.metrics.isDoubleResolution ? 2 : 1, w2 = (i4.metrics.left - h3) * i4.scale - m3 + x3[0], _2 = (-i4.metrics.top - h3) * i4.scale + x3[1], A2 = w2 + o4.w / b2 * i4.scale / f3, S2 = _2 + o4.h / b2 * i4.scale / f3, k2 = new r(w2, _2), E2 = new r(A2, _2), T2 = new r(w2, S2), I2 = new r(A2, S2);
              if (y3) {
                const t5 = new r(-m3, m3 - -17), e4 = -Math.PI / 2, n4 = 12 - m3, s4 = new r(22 - n4, -(i4.imageName ? n4 : 0)), o5 = new r(...v2);
                k2._rotateAround(e4, t5)._add(s4)._add(o5), E2._rotateAround(e4, t5)._add(s4)._add(o5), T2._rotateAround(e4, t5)._add(s4)._add(o5), I2._rotateAround(e4, t5)._add(s4)._add(o5);
              }
              if (u3) {
                const t5 = Math.sin(u3), e4 = Math.cos(u3), r2 = [e4, -t5, t5, e4];
                k2._matMult(r2), E2._matMult(r2), T2._matMult(r2), I2._matMult(r2);
              }
              const M2 = new r(0, 0), F2 = new r(0, 0);
              c3.push({ tl: k2, tr: E2, bl: T2, br: I2, tex: o4, writingMode: e3.writingMode, glyphOffset: g3, sectionIndex: i4.sectionIndex, isSDF: p3, pixelOffsetTL: M2, pixelOffsetBR: F2, minFontScaleX: 0, minFontScaleY: 0 });
            }
            return c3;
          }(0, n2, l2, s2, o2, a2, i2, t2.allowVerticalPlacement), g2 = t2.textSizeData;
          let x2 = null;
          "source" === g2.kind ? (x2 = [th * s2.layout.get("text-size").evaluate(a2, {})], x2[0] > eh && j(`${t2.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)) : "composite" === g2.kind && (x2 = [th * d2.compositeTextSizes[0].evaluate(a2, {}, y2), th * d2.compositeTextSizes[1].evaluate(a2, {}, y2)], (x2[0] > eh || x2[1] > eh) && j(`${t2.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)), t2.addSymbols(t2.text, m2, x2, l2, o2, a2, c2, e2, u2.lineStartIndex, u2.lineLength, f2, y2);
          for (const e3 of h2) p2[e3] = t2.text.placedSymbolArray.length - 1;
          return 4 * m2.length;
        }
        function gd(t2) {
          for (const e2 in t2) return t2[e2];
          return null;
        }
        function xd(t2, e2, r2, n2) {
          const i2 = t2.compareText;
          if (e2 in i2) {
            const t3 = i2[e2];
            for (let e3 = t3.length - 1; e3 >= 0; e3--) if (n2.dist(t3[e3]) < r2) return true;
          } else i2[e2] = [];
          return i2[e2].push(n2), false;
        }
        const vd = [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
        class bd {
          static from(t2) {
            if (!(t2 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
            const [e2, r2] = new Uint8Array(t2, 0, 2);
            if (219 !== e2) throw new Error("Data does not appear to be in a KDBush format.");
            const n2 = r2 >> 4;
            if (1 !== n2) throw new Error(`Got v${n2} data when expected v1.`);
            const i2 = vd[15 & r2];
            if (!i2) throw new Error("Unrecognized array type.");
            const [s2] = new Uint16Array(t2, 2, 1), [o2] = new Uint32Array(t2, 4, 1);
            return new bd(o2, s2, i2, t2);
          }
          constructor(t2, e2 = 64, r2 = Float64Array, n2) {
            if (isNaN(t2) || t2 < 0) throw new Error(`Unpexpected numItems value: ${t2}.`);
            this.numItems = +t2, this.nodeSize = Math.min(Math.max(+e2, 2), 65535), this.ArrayType = r2, this.IndexArrayType = t2 < 65536 ? Uint16Array : Uint32Array;
            const i2 = vd.indexOf(this.ArrayType), s2 = 2 * t2 * this.ArrayType.BYTES_PER_ELEMENT, o2 = t2 * this.IndexArrayType.BYTES_PER_ELEMENT, a2 = (8 - o2 % 8) % 8;
            if (i2 < 0) throw new Error(`Unexpected typed array class: ${r2}.`);
            n2 && n2 instanceof ArrayBuffer ? (this.data = n2, this.ids = new this.IndexArrayType(this.data, 8, t2), this.coords = new this.ArrayType(this.data, 8 + o2 + a2, 2 * t2), this._pos = 2 * t2, this._finished = true) : (this.data = new ArrayBuffer(8 + s2 + o2 + a2), this.ids = new this.IndexArrayType(this.data, 8, t2), this.coords = new this.ArrayType(this.data, 8 + o2 + a2, 2 * t2), this._pos = 0, this._finished = false, new Uint8Array(this.data, 0, 2).set([219, 16 + i2]), new Uint16Array(this.data, 2, 1)[0] = e2, new Uint32Array(this.data, 4, 1)[0] = t2);
          }
          add(t2, e2) {
            const r2 = this._pos >> 1;
            return this.ids[r2] = r2, this.coords[this._pos++] = t2, this.coords[this._pos++] = e2, r2;
          }
          finish() {
            const t2 = this._pos >> 1;
            if (t2 !== this.numItems) throw new Error(`Added ${t2} items when expected ${this.numItems}.`);
            return wd(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = true, this;
          }
          range(t2, e2, r2, n2) {
            if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
            const { ids: i2, coords: s2, nodeSize: o2 } = this, a2 = [0, i2.length - 1, 0], l2 = [];
            for (; a2.length; ) {
              const u2 = a2.pop() || 0, c2 = a2.pop() || 0, h2 = a2.pop() || 0;
              if (c2 - h2 <= o2) {
                for (let o3 = h2; o3 <= c2; o3++) {
                  const a3 = s2[2 * o3], u3 = s2[2 * o3 + 1];
                  a3 >= t2 && a3 <= r2 && u3 >= e2 && u3 <= n2 && l2.push(i2[o3]);
                }
                continue;
              }
              const p2 = h2 + c2 >> 1, f2 = s2[2 * p2], d2 = s2[2 * p2 + 1];
              f2 >= t2 && f2 <= r2 && d2 >= e2 && d2 <= n2 && l2.push(i2[p2]), (0 === u2 ? t2 <= f2 : e2 <= d2) && (a2.push(h2), a2.push(p2 - 1), a2.push(1 - u2)), (0 === u2 ? r2 >= f2 : n2 >= d2) && (a2.push(p2 + 1), a2.push(c2), a2.push(1 - u2));
            }
            return l2;
          }
          within(t2, e2, r2) {
            if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
            const { ids: n2, coords: i2, nodeSize: s2 } = this, o2 = [0, n2.length - 1, 0], a2 = [], l2 = r2 * r2;
            for (; o2.length; ) {
              const u2 = o2.pop() || 0, c2 = o2.pop() || 0, h2 = o2.pop() || 0;
              if (c2 - h2 <= s2) {
                for (let r3 = h2; r3 <= c2; r3++) kd(i2[2 * r3], i2[2 * r3 + 1], t2, e2) <= l2 && a2.push(n2[r3]);
                continue;
              }
              const p2 = h2 + c2 >> 1, f2 = i2[2 * p2], d2 = i2[2 * p2 + 1];
              kd(f2, d2, t2, e2) <= l2 && a2.push(n2[p2]), (0 === u2 ? t2 - r2 <= f2 : e2 - r2 <= d2) && (o2.push(h2), o2.push(p2 - 1), o2.push(1 - u2)), (0 === u2 ? t2 + r2 >= f2 : e2 + r2 >= d2) && (o2.push(p2 + 1), o2.push(c2), o2.push(1 - u2));
            }
            return a2;
          }
        }
        function wd(t2, e2, r2, n2, i2, s2) {
          if (i2 - n2 <= r2) return;
          const o2 = n2 + i2 >> 1;
          _d(t2, e2, o2, n2, i2, s2), wd(t2, e2, r2, n2, o2 - 1, 1 - s2), wd(t2, e2, r2, o2 + 1, i2, 1 - s2);
        }
        function _d(t2, e2, r2, n2, i2, s2) {
          for (; i2 > n2; ) {
            if (i2 - n2 > 600) {
              const o3 = i2 - n2 + 1, a3 = r2 - n2 + 1, l3 = Math.log(o3), u2 = 0.5 * Math.exp(2 * l3 / 3), c2 = 0.5 * Math.sqrt(l3 * u2 * (o3 - u2) / o3) * (a3 - o3 / 2 < 0 ? -1 : 1);
              _d(t2, e2, r2, Math.max(n2, Math.floor(r2 - a3 * u2 / o3 + c2)), Math.min(i2, Math.floor(r2 + (o3 - a3) * u2 / o3 + c2)), s2);
            }
            const o2 = e2[2 * r2 + s2];
            let a2 = n2, l2 = i2;
            for (Ad(t2, e2, n2, r2), e2[2 * i2 + s2] > o2 && Ad(t2, e2, n2, i2); a2 < l2; ) {
              for (Ad(t2, e2, a2, l2), a2++, l2--; e2[2 * a2 + s2] < o2; ) a2++;
              for (; e2[2 * l2 + s2] > o2; ) l2--;
            }
            e2[2 * n2 + s2] === o2 ? Ad(t2, e2, n2, l2) : (l2++, Ad(t2, e2, l2, i2)), l2 <= r2 && (n2 = l2 + 1), r2 <= l2 && (i2 = l2 - 1);
          }
        }
        function Ad(t2, e2, r2, n2) {
          Sd(t2, r2, n2), Sd(e2, 2 * r2, 2 * n2), Sd(e2, 2 * r2 + 1, 2 * n2 + 1);
        }
        function Sd(t2, e2, r2) {
          const n2 = t2[e2];
          t2[e2] = t2[r2], t2[r2] = n2;
        }
        function kd(t2, e2, r2, n2) {
          const i2 = t2 - r2, s2 = e2 - n2;
          return i2 * i2 + s2 * s2;
        }
        var Ed;
        t.cI = void 0, (Ed = t.cI || (t.cI = {})).create = "create", Ed.load = "load", Ed.fullLoad = "fullLoad";
        let Td = null, Id = [];
        const Md = 1e3 / 60, Fd = "loadTime", Dd = "fullLoadTime", Pd = { mark(t2) {
          performance.mark(t2);
        }, frame(t2) {
          const e2 = t2;
          null != Td && Id.push(e2 - Td), Td = e2;
        }, clearMetrics() {
          Td = null, Id = [], performance.clearMeasures(Fd), performance.clearMeasures(Dd);
          for (const e2 in t.cI) performance.clearMarks(t.cI[e2]);
        }, getPerformanceMetrics() {
          performance.measure(Fd, t.cI.create, t.cI.load), performance.measure(Dd, t.cI.create, t.cI.fullLoad);
          const e2 = performance.getEntriesByName(Fd)[0].duration, r2 = performance.getEntriesByName(Dd)[0].duration, n2 = Id.length, i2 = 1 / (Id.reduce((t2, e3) => t2 + e3, 0) / n2 / 1e3), s2 = Id.filter((t2) => t2 > Md).reduce((t2, e3) => t2 + (e3 - Md) / Md, 0);
          return { loadTime: e2, fullLoadTime: r2, fps: i2, percentDroppedFrames: s2 / (n2 + s2) * 100, totalFrames: n2 };
        } };
        t.$ = c, t.A = f, t.B = os, t.C = es, t.D = $s, t.E = xt, t.F = function([t2, e2, r2]) {
          return e2 += 90, e2 *= Math.PI / 180, r2 *= Math.PI / 180, { x: t2 * Math.cos(e2) * Math.sin(r2), y: t2 * Math.sin(e2) * Math.sin(r2), z: t2 * Math.cos(r2) };
        }, t.G = yr, t.H = Fs, t.I = Nc, t.J = ns, t.K = function(t2) {
          if (null == Y) {
            const e2 = t2.navigator ? t2.navigator.userAgent : null;
            Y = !!t2.safari || !(!e2 || !(/\b(iPad|iPhone|iPod)\b/.test(e2) || e2.match("Safari") && !e2.match("Chrome")));
          }
          return Y;
        }, t.L = class {
          constructor(t2, e2) {
            this.target = t2, this.mapId = e2, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new bh(() => this.process()), this.subscription = Q(this.target, "message", (t3) => this.receive(t3), false), this.globalScope = X(self) ? t2 : window;
          }
          registerMessageHandler(t2, e2) {
            this.messageHandlers[t2] = e2;
          }
          unregisterMessageHandler(t2) {
            delete this.messageHandlers[t2];
          }
          sendAsync(t2, e2) {
            return new Promise((r2, n2) => {
              const i2 = Math.round(1e18 * Math.random()).toString(36).substring(0, 10), s2 = e2 ? Q(e2.signal, "abort", () => {
                null == s2 || s2.unsubscribe(), delete this.resolveRejects[i2];
                const e3 = { id: i2, type: "<cancel>", origin: location.origin, targetMapId: t2.targetMapId, sourceMapId: this.mapId };
                this.target.postMessage(e3);
              }, wh) : null;
              this.resolveRejects[i2] = { resolve: (t3) => {
                null == s2 || s2.unsubscribe(), r2(t3);
              }, reject: (t3) => {
                null == s2 || s2.unsubscribe(), n2(t3);
              } };
              const o2 = [], a2 = Object.assign(Object.assign({}, t2), { id: i2, sourceMapId: this.mapId, origin: location.origin, data: fs(t2.data, o2) });
              this.target.postMessage(a2, { transfer: o2 });
            });
          }
          receive(t2) {
            const e2 = t2.data, r2 = e2.id;
            if (!("file://" !== e2.origin && "file://" !== location.origin && "resource://android" !== e2.origin && "resource://android" !== location.origin && e2.origin !== location.origin || e2.targetMapId && this.mapId !== e2.targetMapId)) {
              if ("<cancel>" === e2.type) {
                delete this.tasks[r2];
                const t3 = this.abortControllers[r2];
                return delete this.abortControllers[r2], void (t3 && t3.abort());
              }
              if (X(self) || e2.mustQueue) return this.tasks[r2] = e2, this.taskQueue.push(r2), void this.invoker.trigger();
              this.processTask(r2, e2);
            }
          }
          process() {
            if (0 === this.taskQueue.length) return;
            const t2 = this.taskQueue.shift(), e2 = this.tasks[t2];
            delete this.tasks[t2], this.taskQueue.length > 0 && this.invoker.trigger(), e2 && this.processTask(t2, e2);
          }
          processTask(t2, r2) {
            return e(this, void 0, void 0, function* () {
              if ("<response>" === r2.type) {
                const e3 = this.resolveRejects[t2];
                if (delete this.resolveRejects[t2], !e3) return;
                return void (r2.error ? e3.reject(ds(r2.error)) : e3.resolve(ds(r2.data)));
              }
              if (!this.messageHandlers[r2.type]) return void this.completeTask(t2, new Error(`Could not find a registered handler for ${r2.type}, map ID: ${this.mapId}, available handlers: ${Object.keys(this.messageHandlers).join(", ")}`));
              const e2 = ds(r2.data), n2 = new AbortController();
              this.abortControllers[t2] = n2;
              try {
                const i2 = yield this.messageHandlers[r2.type](r2.sourceMapId, e2, n2);
                this.completeTask(t2, null, i2);
              } catch (e3) {
                this.completeTask(t2, e3);
              }
            });
          }
          completeTask(t2, e2, r2) {
            const n2 = [];
            delete this.abortControllers[t2];
            const i2 = { id: t2, type: "<response>", sourceMapId: this.mapId, origin: location.origin, error: e2 ? fs(e2) : null, data: fs(r2, n2) };
            this.target.postMessage(i2, { transfer: n2 });
          }
          remove() {
            this.invoker.remove(), this.subscription.unsubscribe();
          }
        }, t.M = ut, t.N = function() {
          var t2 = new f(16);
          return f != Float32Array && (t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0), t2[0] = 1, t2[5] = 1, t2[10] = 1, t2[15] = 1, t2;
        }, t.O = function(t2, e2, r2) {
          var n2, i2, s2, o2, a2, l2, u2, c2, h2, p2, f2, d2, y2 = r2[0], m2 = r2[1], g2 = r2[2];
          return e2 === t2 ? (t2[12] = e2[0] * y2 + e2[4] * m2 + e2[8] * g2 + e2[12], t2[13] = e2[1] * y2 + e2[5] * m2 + e2[9] * g2 + e2[13], t2[14] = e2[2] * y2 + e2[6] * m2 + e2[10] * g2 + e2[14], t2[15] = e2[3] * y2 + e2[7] * m2 + e2[11] * g2 + e2[15]) : (i2 = e2[1], s2 = e2[2], o2 = e2[3], a2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = e2[8], p2 = e2[9], f2 = e2[10], d2 = e2[11], t2[0] = n2 = e2[0], t2[1] = i2, t2[2] = s2, t2[3] = o2, t2[4] = a2, t2[5] = l2, t2[6] = u2, t2[7] = c2, t2[8] = h2, t2[9] = p2, t2[10] = f2, t2[11] = d2, t2[12] = n2 * y2 + a2 * m2 + h2 * g2 + e2[12], t2[13] = i2 * y2 + l2 * m2 + p2 * g2 + e2[13], t2[14] = s2 * y2 + u2 * m2 + f2 * g2 + e2[14], t2[15] = o2 * y2 + c2 * m2 + d2 * g2 + e2[15]), t2;
        }, t.P = r, t.Q = function(t2, e2, r2) {
          var n2 = r2[0], i2 = r2[1], s2 = r2[2];
          return t2[0] = e2[0] * n2, t2[1] = e2[1] * n2, t2[2] = e2[2] * n2, t2[3] = e2[3] * n2, t2[4] = e2[4] * i2, t2[5] = e2[5] * i2, t2[6] = e2[6] * i2, t2[7] = e2[7] * i2, t2[8] = e2[8] * s2, t2[9] = e2[9] * s2, t2[10] = e2[10] * s2, t2[11] = e2[11] * s2, t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15], t2;
        }, t.R = bl, t.S = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = e2[3], a2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h2 = e2[8], p2 = e2[9], f2 = e2[10], d2 = e2[11], y2 = e2[12], m2 = e2[13], g2 = e2[14], x2 = e2[15], v2 = r2[0], b2 = r2[1], w2 = r2[2], _2 = r2[3];
          return t2[0] = v2 * n2 + b2 * a2 + w2 * h2 + _2 * y2, t2[1] = v2 * i2 + b2 * l2 + w2 * p2 + _2 * m2, t2[2] = v2 * s2 + b2 * u2 + w2 * f2 + _2 * g2, t2[3] = v2 * o2 + b2 * c2 + w2 * d2 + _2 * x2, t2[4] = (v2 = r2[4]) * n2 + (b2 = r2[5]) * a2 + (w2 = r2[6]) * h2 + (_2 = r2[7]) * y2, t2[5] = v2 * i2 + b2 * l2 + w2 * p2 + _2 * m2, t2[6] = v2 * s2 + b2 * u2 + w2 * f2 + _2 * g2, t2[7] = v2 * o2 + b2 * c2 + w2 * d2 + _2 * x2, t2[8] = (v2 = r2[8]) * n2 + (b2 = r2[9]) * a2 + (w2 = r2[10]) * h2 + (_2 = r2[11]) * y2, t2[9] = v2 * i2 + b2 * l2 + w2 * p2 + _2 * m2, t2[10] = v2 * s2 + b2 * u2 + w2 * f2 + _2 * g2, t2[11] = v2 * o2 + b2 * c2 + w2 * d2 + _2 * x2, t2[12] = (v2 = r2[12]) * n2 + (b2 = r2[13]) * a2 + (w2 = r2[14]) * h2 + (_2 = r2[15]) * y2, t2[13] = v2 * i2 + b2 * l2 + w2 * p2 + _2 * m2, t2[14] = v2 * s2 + b2 * u2 + w2 * f2 + _2 * g2, t2[15] = v2 * o2 + b2 * c2 + w2 * d2 + _2 * x2, t2;
        }, t.T = Ml, t.U = function(t2, e2) {
          const r2 = {};
          for (let n2 = 0; n2 < e2.length; n2++) {
            const i2 = e2[n2];
            i2 in t2 && (r2[i2] = t2[i2]);
          }
          return r2;
        }, t.V = Ah, t.W = L2, t.X = Th, t.Y = Eh, t.Z = ot, t._ = e, t.a = st, t.a$ = Dh, t.a0 = h, t.a1 = K, t.a2 = Ch, t.a3 = Mh, t.a4 = Fh, t.a5 = M, t.a6 = function(t2, e2, r2) {
          if (!t2) return e2 || {};
          if (!e2) return t2 || {};
          const n2 = Nh(t2), i2 = Nh(e2);
          !function(t3, e3) {
            e3.removeAll && (t3.add.clear(), t3.update.clear(), t3.remove.clear(), e3.remove.clear());
            for (const r3 of e3.remove) t3.add.delete(r3), t3.update.delete(r3);
            for (const [r3, n3] of e3.update) {
              const i3 = t3.update.get(r3);
              i3 && (e3.update.set(r3, Rh(i3, n3)), t3.update.delete(r3));
            }
          }(n2, i2);
          const s2 = {};
          if ((n2.removeAll || i2.removeAll) && (s2.removeAll = true), s2.remove = /* @__PURE__ */ new Set([...n2.remove, ...i2.remove]), s2.add = new Map([...n2.add, ...i2.add]), s2.update = new Map([...n2.update, ...i2.update]), s2.remove.size && s2.add.size) for (const t3 of s2.add.keys()) s2.remove.delete(t3);
          return function(t3) {
            const e3 = {};
            return t3.removeAll && (e3.removeAll = t3.removeAll), t3.remove && (e3.remove = Array.from(t3.remove)), t3.add && (e3.add = Array.from(t3.add.values())), t3.update && (e3.update = Array.from(t3.update.values())), e3;
          }(s2);
        }, t.a7 = function(t2, e2) {
          if (null == t2) return true;
          if (null == t2.type) return true;
          if ("Feature" === t2.type) return null != Oh(t2, e2);
          if ("FeatureCollection" === t2.type) {
            const r2 = /* @__PURE__ */ new Set();
            for (const n2 of t2.features) {
              const t3 = Oh(n2, e2);
              if (null == t3) return false;
              if (r2.has(t3)) return false;
              r2.add(t3);
            }
            return true;
          }
          return false;
        }, t.a8 = function(t2, e2) {
          const r2 = /* @__PURE__ */ new Map();
          if (null == t2 || null == t2.type) ;
          else if ("Feature" === t2.type) r2.set(Oh(t2, e2), t2);
          else for (const n2 of t2.features) r2.set(Oh(n2, e2), n2);
          return r2;
        }, t.a9 = function(t2, e2, r2) {
          var n2, i2;
          if (e2.removeAll) t2.clear();
          else if (e2.remove) for (const r3 of e2.remove) t2.delete(r3);
          if (e2.add) for (const n3 of e2.add) {
            const e3 = Oh(n3, r2);
            null != e3 && t2.set(e3, n3);
          }
          if (e2.update) for (const r3 of e2.update) {
            let e3 = t2.get(r3.id);
            if (!e3) continue;
            const s2 = !!r3.newGeometry, o2 = r3.removeAllProperties || (null === (n2 = r3.removeProperties) || void 0 === n2 ? void 0 : n2.length) > 0 || (null === (i2 = r3.addOrUpdateProperties) || void 0 === i2 ? void 0 : i2.length) > 0;
            if ((s2 || o2) && (e3 = Object.assign({}, e3), t2.set(r3.id, e3), s2 && (e3.geometry = r3.newGeometry), o2)) {
              if (e3.properties = r3.removeAllProperties ? {} : Object.assign({}, e3.properties || {}), r3.removeProperties) for (const t3 of r3.removeProperties) delete e3.properties[t3];
              if (r3.addOrUpdateProperties) for (const { key: t3, value: n3 } of r3.addOrUpdateProperties) e3.properties[t3] = n3;
            }
          }
        }, t.aB = function(t2, { uSize: e2, uSizeT: r2 }, { lowerSize: n2, upperSize: i2 }) {
          return "source" === t2.kind ? n2 / th : "composite" === t2.kind ? yr.number(n2 / th, i2 / th, r2) : e2;
        }, t.aC = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], o2 = e2[4], a2 = e2[5], l2 = e2[6], u2 = e2[7], c2 = e2[8], h2 = e2[9], p2 = e2[10], f2 = e2[11], d2 = e2[12], y2 = e2[13], m2 = e2[14], g2 = e2[15], x2 = r2 * a2 - n2 * o2, v2 = r2 * l2 - i2 * o2, b2 = r2 * u2 - s2 * o2, w2 = n2 * l2 - i2 * a2, _2 = n2 * u2 - s2 * a2, A2 = i2 * u2 - s2 * l2, S2 = c2 * y2 - h2 * d2, k2 = c2 * m2 - p2 * d2, E2 = c2 * g2 - f2 * d2, T2 = h2 * m2 - p2 * y2, I2 = h2 * g2 - f2 * y2, M2 = p2 * g2 - f2 * m2, F2 = x2 * M2 - v2 * I2 + b2 * T2 + w2 * E2 - _2 * k2 + A2 * S2;
          return F2 ? (t2[0] = (a2 * M2 - l2 * I2 + u2 * T2) * (F2 = 1 / F2), t2[1] = (i2 * I2 - n2 * M2 - s2 * T2) * F2, t2[2] = (y2 * A2 - m2 * _2 + g2 * w2) * F2, t2[3] = (p2 * _2 - h2 * A2 - f2 * w2) * F2, t2[4] = (l2 * E2 - o2 * M2 - u2 * k2) * F2, t2[5] = (r2 * M2 - i2 * E2 + s2 * k2) * F2, t2[6] = (m2 * b2 - d2 * A2 - g2 * v2) * F2, t2[7] = (c2 * A2 - p2 * b2 + f2 * v2) * F2, t2[8] = (o2 * I2 - a2 * E2 + u2 * S2) * F2, t2[9] = (n2 * E2 - r2 * I2 - s2 * S2) * F2, t2[10] = (d2 * _2 - y2 * b2 + g2 * x2) * F2, t2[11] = (h2 * b2 - c2 * _2 - f2 * x2) * F2, t2[12] = (a2 * k2 - o2 * T2 - l2 * S2) * F2, t2[13] = (r2 * T2 - n2 * k2 + i2 * S2) * F2, t2[14] = (y2 * v2 - d2 * w2 - m2 * x2) * F2, t2[15] = (c2 * w2 - h2 * v2 + p2 * x2) * F2, t2) : null;
        }, t.aD = T, t.aE = function(t2) {
          var e2 = t2[0], r2 = t2[1];
          return Math.sqrt(e2 * e2 + r2 * r2);
        }, t.aF = function(t2) {
          return t2[0] = 0, t2[1] = 0, t2;
        }, t.aG = function(t2, e2, r2) {
          return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2;
        }, t.aH = oh, t.aI = S, t.aJ = function(t2, e2, n2, i2) {
          const s2 = e2.y - t2.y, o2 = e2.x - t2.x, a2 = i2.y - n2.y, l2 = i2.x - n2.x, u2 = a2 * o2 - l2 * s2;
          if (0 === u2) return null;
          const c2 = (l2 * (t2.y - n2.y) - a2 * (t2.x - n2.x)) / u2;
          return new r(t2.x + c2 * o2, t2.y + c2 * s2);
        }, t.aK = Nf, t.aL = Ua, t.aM = function(t2) {
          let e2 = 1 / 0, r2 = 1 / 0, n2 = -1 / 0, i2 = -1 / 0;
          for (const s2 of t2) e2 = Math.min(e2, s2.x), r2 = Math.min(r2, s2.y), n2 = Math.max(n2, s2.x), i2 = Math.max(i2, s2.y);
          return [e2, r2, n2, i2];
        }, t.aN = hc, t.aO = F, t.aP = function(t2, e2, r2, n2, i2 = false) {
          if (!r2[0] && !r2[1]) return [0, 0];
          const s2 = i2 ? "map" === n2 ? -t2.bearingInRadians : 0 : "viewport" === n2 ? t2.bearingInRadians : 0;
          if (s2) {
            const t3 = Math.sin(s2), e3 = Math.cos(s2);
            r2 = [r2[0] * e3 - r2[1] * t3, r2[0] * t3 + r2[1] * e3];
          }
          return [i2 ? r2[0] : F(e2, r2[0], t2.zoom), i2 ? r2[1] : F(e2, r2[1], t2.zoom)];
        }, t.aR = nh, t.aS = dd, t.aT = jc, t.aU = bd, t.aV = to, t.aW = uu, t.aX = Ro, t.aY = ra, t.aZ = Jo, t.a_ = et, t.aa = Mf, t.ab = Ph, t.ac = Tf, t.ad = 25, t.ae = Bh, t.af = (t2) => {
          const e2 = window.document.createElement("video");
          return e2.muted = true, new Promise((r2) => {
            e2.onloadstart = () => {
              r2(e2);
            };
            for (const r3 of t2) {
              const t3 = window.document.createElement("source");
              ft(r3) || (e2.crossOrigin = "Anonymous"), t3.src = r3, e2.appendChild(t3);
            }
          });
        }, t.ag = Dt, t.ah = function() {
          return R++;
        }, t.ai = Io, t.aj = ch, t.ak = fi, t.al = Oa, t.am = Uh, t.an = function(t2) {
          const e2 = {};
          if (t2.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t3, r2, n2, i2) => {
            const s2 = n2 || i2;
            return e2[r2] = !s2 || s2.toLowerCase(), "";
          }), e2["max-age"]) {
            const t3 = parseInt(e2["max-age"], 10);
            isNaN(t3) ? delete e2["max-age"] : e2["max-age"] = t3;
          }
          return e2;
        }, t.ao = C, t.ap = 85.051129, t.aq = tt, t.ar = function(t2) {
          return Math.pow(2, t2);
        }, t.as = y, t.at = Ih, t.au = function(t2) {
          return Math.log(t2) / Math.LN2;
        }, t.av = function(t2) {
          var e2 = t2[0], r2 = t2[1];
          return e2 * e2 + r2 * r2;
        }, t.aw = function(t2) {
          if (!t2.length) return /* @__PURE__ */ new Set();
          const e2 = Math.max(...t2.map((t3) => t3.canonical.z));
          let r2 = 1 / 0, n2 = -1 / 0, i2 = 1 / 0, s2 = -1 / 0;
          const o2 = [];
          for (const a3 of t2) {
            const { x: t3, y: l2, z: u2 } = a3.canonical, c2 = Math.pow(2, e2 - u2), h2 = t3 * c2, p2 = l2 * c2;
            o2.push({ id: a3, x: h2, y: p2 }), h2 < r2 && (r2 = h2), h2 > n2 && (n2 = h2), p2 < i2 && (i2 = p2), p2 > s2 && (s2 = p2);
          }
          const a2 = /* @__PURE__ */ new Set();
          for (const t3 of o2) t3.x !== r2 && t3.x !== n2 && t3.y !== i2 && t3.y !== s2 || a2.add(t3.id);
          return a2;
        }, t.ax = function(t2, e2) {
          const r2 = Math.abs(2 * t2.wrap) - +(t2.wrap < 0), n2 = Math.abs(2 * e2.wrap) - +(e2.wrap < 0);
          return t2.overscaledZ - e2.overscaledZ || n2 - r2 || e2.canonical.y - t2.canonical.y || e2.canonical.x - t2.canonical.x;
        }, t.ay = class {
          constructor(t2, e2) {
            this.max = t2, this.onRemove = e2, this.reset();
          }
          reset() {
            for (const t2 in this.data) for (const e2 of this.data[t2]) e2.timeout && clearTimeout(e2.timeout), this.onRemove(e2.value);
            return this.data = {}, this.order = [], this;
          }
          add(t2, e2, r2) {
            const n2 = t2.wrapped().key;
            void 0 === this.data[n2] && (this.data[n2] = []);
            const i2 = { value: e2, timeout: void 0 };
            if (void 0 !== r2 && (i2.timeout = setTimeout(() => {
              this.remove(t2, i2);
            }, r2)), this.data[n2].push(i2), this.order.push(n2), this.order.length > this.max) {
              const t3 = this._getAndRemoveByKey(this.order[0]);
              t3 && this.onRemove(t3);
            }
            return this;
          }
          has(t2) {
            return t2.wrapped().key in this.data;
          }
          getAndRemove(t2) {
            return this.has(t2) ? this._getAndRemoveByKey(t2.wrapped().key) : null;
          }
          _getAndRemoveByKey(t2) {
            const e2 = this.data[t2].shift();
            return e2.timeout && clearTimeout(e2.timeout), 0 === this.data[t2].length && delete this.data[t2], this.order.splice(this.order.indexOf(t2), 1), e2.value;
          }
          getByKey(t2) {
            const e2 = this.data[t2];
            return e2 ? e2[0].value : null;
          }
          get(t2) {
            return this.has(t2) ? this.data[t2.wrapped().key][0].value : null;
          }
          remove(t2, e2) {
            if (!this.has(t2)) return this;
            const r2 = t2.wrapped().key, n2 = void 0 === e2 ? 0 : this.data[r2].indexOf(e2), i2 = this.data[r2][n2];
            return this.data[r2].splice(n2, 1), i2.timeout && clearTimeout(i2.timeout), 0 === this.data[r2].length && delete this.data[r2], this.onRemove(i2.value), this.order.splice(this.order.indexOf(r2), 1), this;
          }
          setMaxSize(t2) {
            for (this.max = t2; this.order.length > this.max; ) {
              const t3 = this._getAndRemoveByKey(this.order[0]);
              t3 && this.onRemove(t3);
            }
            return this;
          }
          filter(t2) {
            const e2 = [];
            for (const r2 in this.data) for (const n2 of this.data[r2]) t2(n2.value) || e2.push(n2);
            for (const t3 of e2) this.remove(t3.value.tileID, t3);
          }
        }, t.az = function(t2, e2) {
          let r2 = 0, n2 = 0;
          if ("constant" === t2.kind) n2 = t2.layoutSize;
          else if ("source" !== t2.kind) {
            const { interpolationType: i2, minZoom: s2, maxZoom: o2 } = t2, a2 = i2 ? C(fr.interpolationFactor(i2, e2, s2, o2), 0, 1) : 0;
            "camera" === t2.kind ? n2 = yr.number(t2.minSize, t2.maxSize, a2) : r2 = a2;
          }
          return { uSizeT: r2, uSize: n2 };
        }, t.b = Z, t.b$ = class extends xa {
          constructor(t2, e2) {
            super(t2, e2), this.current = 0;
          }
          set(t2) {
            this.current !== t2 && (this.current = t2, this.gl.uniform1i(this.location, t2));
          }
        }, t.b0 = b, t.b1 = v, t.b2 = function(t2) {
          var e2 = new f(3);
          return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2;
        }, t.b3 = function(t2, e2, r2) {
          return t2[0] = e2[0] - r2[0], t2[1] = e2[1] - r2[1], t2[2] = e2[2] - r2[2], t2;
        }, t.b4 = function(t2, e2) {
          var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = r2 * r2 + n2 * n2 + i2 * i2;
          return s2 > 0 && (s2 = 1 / Math.sqrt(s2)), t2[0] = e2[0] * s2, t2[1] = e2[1] * s2, t2[2] = e2[2] * s2, t2;
        }, t.b5 = w, t.b6 = function(t2, e2) {
          return t2[0] * e2[0] + t2[1] * e2[1] + t2[2] * e2[2];
        }, t.b7 = function(t2, e2, r2) {
          return t2[0] = e2[0] * r2[0], t2[1] = e2[1] * r2[1], t2[2] = e2[2] * r2[2], t2[3] = e2[3] * r2[3], t2;
        }, t.b8 = g, t.b9 = function(t2, e2, r2) {
          const n2 = e2[0] * r2[0] + e2[1] * r2[1] + e2[2] * r2[2];
          return 0 === n2 ? null : (-(t2[0] * r2[0] + t2[1] * r2[1] + t2[2] * r2[2]) - r2[3]) / n2;
        }, t.bA = function() {
          return new Float64Array(3);
        }, t.bB = function(t2, e2, r2, n2) {
          return t2[0] = e2[0] + r2[0] * n2, t2[1] = e2[1] + r2[1] * n2, t2[2] = e2[2] + r2[2] * n2, t2;
        }, t.bC = E, t.bD = function(t2, e2, r2) {
          var n2 = r2[0], i2 = r2[1], s2 = r2[2], o2 = r2[3], a2 = e2[0], l2 = e2[1], u2 = e2[2], c2 = i2 * u2 - s2 * l2, h2 = s2 * a2 - n2 * u2, p2 = n2 * l2 - i2 * a2;
          return t2[0] = a2 + o2 * (c2 += c2) + i2 * (p2 += p2) - s2 * (h2 += h2), t2[1] = l2 + o2 * h2 + s2 * c2 - n2 * p2, t2[2] = u2 + o2 * p2 + n2 * h2 - i2 * c2, t2;
        }, t.bE = function(t2, e2, r2) {
          const n2 = function(t3) {
            var e3 = t3[3], r3 = t3[4], n3 = t3[5], i3 = t3[6], s3 = t3[7], o3 = t3[8];
            return t3[0] * (o3 * r3 - n3 * s3) + t3[1] * (-o3 * e3 + n3 * i3) + t3[2] * (s3 * e3 - r3 * i3);
          }([t2[0], t2[1], t2[2], e2[0], e2[1], e2[2], r2[0], r2[1], r2[2]]);
          if (0 === n2) return null;
          const i2 = w([], [e2[0], e2[1], e2[2]], [r2[0], r2[1], r2[2]]), s2 = w([], [r2[0], r2[1], r2[2]], [t2[0], t2[1], t2[2]]), o2 = w([], [t2[0], t2[1], t2[2]], [e2[0], e2[1], e2[2]]), a2 = b([], i2, -t2[3]);
          return v(a2, a2, b([], s2, -e2[3])), v(a2, a2, b([], o2, -r2[3])), b(a2, a2, 1 / n2), a2;
        }, t.bF = _h, t.bG = function() {
          return new Float64Array(4);
        }, t.bH = function(t2, e2, r2, n2) {
          var i2 = [], s2 = [];
          return i2[0] = e2[0] - r2[0], i2[1] = e2[1] - r2[1], i2[2] = e2[2] - r2[2], s2[0] = i2[0] * Math.cos(n2) - i2[1] * Math.sin(n2), s2[1] = i2[0] * Math.sin(n2) + i2[1] * Math.cos(n2), s2[2] = i2[2], t2[0] = s2[0] + r2[0], t2[1] = s2[1] + r2[1], t2[2] = s2[2] + r2[2], t2;
        }, t.bI = function(t2, e2, r2, n2) {
          var i2 = [], s2 = [];
          return i2[0] = e2[0] - r2[0], i2[1] = e2[1] - r2[1], i2[2] = e2[2] - r2[2], s2[0] = i2[0], s2[1] = i2[1] * Math.cos(n2) - i2[2] * Math.sin(n2), s2[2] = i2[1] * Math.sin(n2) + i2[2] * Math.cos(n2), t2[0] = s2[0] + r2[0], t2[1] = s2[1] + r2[1], t2[2] = s2[2] + r2[2], t2;
        }, t.bJ = function(t2, e2, r2, n2) {
          var i2 = [], s2 = [];
          return i2[0] = e2[0] - r2[0], i2[1] = e2[1] - r2[1], i2[2] = e2[2] - r2[2], s2[0] = i2[2] * Math.sin(n2) + i2[0] * Math.cos(n2), s2[1] = i2[1], s2[2] = i2[2] * Math.cos(n2) - i2[0] * Math.sin(n2), t2[0] = s2[0] + r2[0], t2[1] = s2[1] + r2[1], t2[2] = s2[2] + r2[2], t2;
        }, t.bK = function(t2, e2, r2) {
          var n2 = Math.sin(r2), i2 = Math.cos(r2), s2 = e2[0], o2 = e2[1], a2 = e2[2], l2 = e2[3], u2 = e2[8], c2 = e2[9], h2 = e2[10], p2 = e2[11];
          return e2 !== t2 && (t2[4] = e2[4], t2[5] = e2[5], t2[6] = e2[6], t2[7] = e2[7], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2[0] = s2 * i2 - u2 * n2, t2[1] = o2 * i2 - c2 * n2, t2[2] = a2 * i2 - h2 * n2, t2[3] = l2 * i2 - p2 * n2, t2[8] = s2 * n2 + u2 * i2, t2[9] = o2 * n2 + c2 * i2, t2[10] = a2 * n2 + h2 * i2, t2[11] = l2 * n2 + p2 * i2, t2;
        }, t.bL = function(t2, e2) {
          const r2 = D(t2, 360), n2 = D(e2, 360), i2 = n2 - r2, s2 = n2 > r2 ? i2 - 360 : i2 + 360;
          return Math.abs(i2) < Math.abs(s2) ? i2 : s2;
        }, t.bM = function(t2) {
          return t2[0] = 0, t2[1] = 0, t2[2] = 0, t2;
        }, t.bN = function(t2, e2, r2, n2) {
          const i2 = Math.sqrt(t2 * t2 + e2 * e2), s2 = Math.sqrt(r2 * r2 + n2 * n2);
          t2 /= i2, e2 /= i2, r2 /= s2, n2 /= s2;
          const o2 = Math.acos(t2 * r2 + e2 * n2);
          return -e2 * r2 + t2 * n2 > 0 ? o2 : -o2;
        }, t.bO = function(t2, e2) {
          const r2 = D(t2, 2 * Math.PI), n2 = D(e2, 2 * Math.PI);
          return Math.min(Math.abs(r2 - n2), Math.abs(r2 - n2 + 2 * Math.PI), Math.abs(r2 - n2 - 2 * Math.PI));
        }, t.bP = function() {
          const t2 = {}, e2 = vt.$version;
          for (const r2 in vt.$root) {
            const n2 = vt.$root[r2];
            if (n2.required) {
              let i2 = null;
              i2 = "version" === r2 ? e2 : "array" === n2.type ? [] : {}, null != i2 && (t2[r2] = i2);
            }
          }
          return t2;
        }, t.bQ = ht, t.bR = ys, t.bS = function t2(e2, r2) {
          if (Array.isArray(e2)) {
            if (!Array.isArray(r2) || e2.length !== r2.length) return false;
            for (let n2 = 0; n2 < e2.length; n2++) if (!t2(e2[n2], r2[n2])) return false;
            return true;
          }
          if ("object" == typeof e2 && null !== e2 && null !== r2) {
            if ("object" != typeof r2) return false;
            if (Object.keys(e2).length !== Object.keys(r2).length) return false;
            for (const n2 in e2) if (!t2(e2[n2], r2[n2])) return false;
            return true;
          }
          return e2 === r2;
        }, t.bT = function(t2) {
          t2 = t2.slice();
          const e2 = /* @__PURE__ */ Object.create(null);
          for (let r2 = 0; r2 < t2.length; r2++) e2[t2[r2].id] = t2[r2];
          for (let r2 = 0; r2 < t2.length; r2++) "ref" in t2[r2] && (t2[r2] = wt(t2[r2], e2[t2[r2].ref]));
          return t2;
        }, t.bU = function(t2, e2) {
          if ("custom" === t2.type) return new vh(t2, e2);
          switch (t2.type) {
            case "background":
              return new xh(t2, e2);
            case "circle":
              return new pl(t2, e2);
            case "color-relief":
              return new Pl(t2, e2);
            case "fill":
              return new _u(t2, e2);
            case "fill-extrusion":
              return new Uu(t2, e2);
            case "heatmap":
              return new Al(t2, e2);
            case "hillshade":
              return new El(t2, e2);
            case "line":
              return new nc(t2, e2);
            case "raster":
              return new Ks(t2, e2);
            case "symbol":
              return new yh(t2, e2);
          }
        }, t.bV = (t2) => "raster" === t2.type, t.bW = U, t.bX = function(t2, e2) {
          if (!t2) return [{ command: "setStyle", args: [e2] }];
          let r2 = [];
          try {
            if (!_t(t2.version, e2.version)) return [{ command: "setStyle", args: [e2] }];
            _t(t2.center, e2.center) || r2.push({ command: "setCenter", args: [e2.center] }), _t(t2.state, e2.state) || r2.push({ command: "setGlobalState", args: [e2.state] }), _t(t2.centerAltitude, e2.centerAltitude) || r2.push({ command: "setCenterAltitude", args: [e2.centerAltitude] }), _t(t2.zoom, e2.zoom) || r2.push({ command: "setZoom", args: [e2.zoom] }), _t(t2.bearing, e2.bearing) || r2.push({ command: "setBearing", args: [e2.bearing] }), _t(t2.pitch, e2.pitch) || r2.push({ command: "setPitch", args: [e2.pitch] }), _t(t2.roll, e2.roll) || r2.push({ command: "setRoll", args: [e2.roll] }), _t(t2.sprite, e2.sprite) || r2.push({ command: "setSprite", args: [e2.sprite] }), _t(t2.glyphs, e2.glyphs) || r2.push({ command: "setGlyphs", args: [e2.glyphs] }), _t(t2.transition, e2.transition) || r2.push({ command: "setTransition", args: [e2.transition] }), _t(t2.light, e2.light) || r2.push({ command: "setLight", args: [e2.light] }), _t(t2.terrain, e2.terrain) || r2.push({ command: "setTerrain", args: [e2.terrain] }), _t(t2.sky, e2.sky) || r2.push({ command: "setSky", args: [e2.sky] }), _t(t2.projection, e2.projection) || r2.push({ command: "setProjection", args: [e2.projection] });
            const n2 = {}, i2 = [];
            !function(t3, e3, r3, n3) {
              let i3;
              for (i3 in e3 = e3 || {}, t3 = t3 || {}) Object.prototype.hasOwnProperty.call(t3, i3) && (Object.prototype.hasOwnProperty.call(e3, i3) || kt(i3, r3, n3));
              for (i3 in e3) Object.prototype.hasOwnProperty.call(e3, i3) && (Object.prototype.hasOwnProperty.call(t3, i3) ? _t(t3[i3], e3[i3]) || ("geojson" === t3[i3].type && "geojson" === e3[i3].type && Tt(t3, e3, i3) ? At(r3, { command: "setGeoJSONSourceData", args: [i3, e3[i3].data] }) : Et(i3, e3, r3, n3)) : St(i3, e3, r3));
            }(t2.sources, e2.sources, i2, n2);
            const s2 = [];
            t2.layers && t2.layers.forEach((t3) => {
              "source" in t3 && n2[t3.source] ? r2.push({ command: "removeLayer", args: [t3.id] }) : s2.push(t3);
            }), r2 = r2.concat(i2), function(t3, e3, r3) {
              e3 = e3 || [];
              const n3 = (t3 = t3 || []).map(Mt), i3 = e3.map(Mt), s3 = t3.reduce(Ft, {}), o2 = e3.reduce(Ft, {}), a2 = n3.slice(), l2 = /* @__PURE__ */ Object.create(null);
              let u2, c2, h2, p2, f2;
              for (let t4 = 0, e4 = 0; t4 < n3.length; t4++) u2 = n3[t4], Object.prototype.hasOwnProperty.call(o2, u2) ? e4++ : (At(r3, { command: "removeLayer", args: [u2] }), a2.splice(a2.indexOf(u2, e4), 1));
              for (let t4 = 0, e4 = 0; t4 < i3.length; t4++) u2 = i3[i3.length - 1 - t4], a2[a2.length - 1 - t4] !== u2 && (Object.prototype.hasOwnProperty.call(s3, u2) ? (At(r3, { command: "removeLayer", args: [u2] }), a2.splice(a2.lastIndexOf(u2, a2.length - e4), 1)) : e4++, p2 = a2[a2.length - t4], At(r3, { command: "addLayer", args: [o2[u2], p2] }), a2.splice(a2.length - t4, 0, u2), l2[u2] = true);
              for (let t4 = 0; t4 < i3.length; t4++) if (u2 = i3[t4], c2 = s3[u2], h2 = o2[u2], !l2[u2] && !_t(c2, h2)) if (_t(c2.source, h2.source) && _t(c2["source-layer"], h2["source-layer"]) && _t(c2.type, h2.type)) {
                for (f2 in It(c2.layout, h2.layout, r3, u2, null, "setLayoutProperty"), It(c2.paint, h2.paint, r3, u2, null, "setPaintProperty"), _t(c2.filter, h2.filter) || At(r3, { command: "setFilter", args: [u2, h2.filter] }), _t(c2.minzoom, h2.minzoom) && _t(c2.maxzoom, h2.maxzoom) || At(r3, { command: "setLayerZoomRange", args: [u2, h2.minzoom, h2.maxzoom] }), c2) Object.prototype.hasOwnProperty.call(c2, f2) && "layout" !== f2 && "paint" !== f2 && "filter" !== f2 && "metadata" !== f2 && "minzoom" !== f2 && "maxzoom" !== f2 && (0 === f2.indexOf("paint.") ? It(c2[f2], h2[f2], r3, u2, f2.slice(6), "setPaintProperty") : _t(c2[f2], h2[f2]) || At(r3, { command: "setLayerProperty", args: [u2, f2, h2[f2]] }));
                for (f2 in h2) Object.prototype.hasOwnProperty.call(h2, f2) && !Object.prototype.hasOwnProperty.call(c2, f2) && "layout" !== f2 && "paint" !== f2 && "filter" !== f2 && "metadata" !== f2 && "minzoom" !== f2 && "maxzoom" !== f2 && (0 === f2.indexOf("paint.") ? It(c2[f2], h2[f2], r3, u2, f2.slice(6), "setPaintProperty") : _t(c2[f2], h2[f2]) || At(r3, { command: "setLayerProperty", args: [u2, f2, h2[f2]] }));
              } else At(r3, { command: "removeLayer", args: [u2] }), p2 = a2[a2.lastIndexOf(u2) + 1], At(r3, { command: "addLayer", args: [h2, p2] });
            }(s2, e2.layers, r2);
          } catch (t3) {
            console.warn("Unable to compute style diff:", t3), r2 = [{ command: "setStyle", args: [e2] }];
          }
          return r2;
        }, t.bY = function(t2) {
          const e2 = [], r2 = t2.id;
          return void 0 === r2 && e2.push({ message: `layers.${r2}: missing required property "id"` }), void 0 === t2.render && e2.push({ message: `layers.${r2}: missing required method "render"` }), t2.renderingMode && "2d" !== t2.renderingMode && "3d" !== t2.renderingMode && e2.push({ message: `layers.${r2}: property "renderingMode" must be either "2d" or "3d"` }), e2;
        }, t.bZ = N, t.b_ = $, t.ba = A, t.bb = function(t2, e2, r2) {
          return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2[3] = e2[3] * r2, t2;
        }, t.bc = function(t2, e2) {
          return t2[0] * e2[0] + t2[1] * e2[1] + t2[2] * e2[2] + t2[3];
        }, t.bd = Vh, t.be = Lh, t.bf = function(t2, e2, r2, n2, i2) {
          var s2 = 1 / Math.tan(e2 / 2);
          if (t2[0] = s2 / r2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = s2, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[11] = -1, t2[12] = 0, t2[13] = 0, t2[15] = 0, null != i2 && i2 !== 1 / 0) {
            var o2 = 1 / (n2 - i2);
            t2[10] = (i2 + n2) * o2, t2[14] = 2 * i2 * n2 * o2;
          } else t2[10] = -1, t2[14] = -2 * n2;
          return t2;
        }, t.bg = function(t2) {
          var e2 = new f(16);
          return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2[3] = t2[3], e2[4] = t2[4], e2[5] = t2[5], e2[6] = t2[6], e2[7] = t2[7], e2[8] = t2[8], e2[9] = t2[9], e2[10] = t2[10], e2[11] = t2[11], e2[12] = t2[12], e2[13] = t2[13], e2[14] = t2[14], e2[15] = t2[15], e2;
        }, t.bh = function(t2, e2, r2) {
          var n2 = Math.sin(r2), i2 = Math.cos(r2), s2 = e2[0], o2 = e2[1], a2 = e2[2], l2 = e2[3], u2 = e2[4], c2 = e2[5], h2 = e2[6], p2 = e2[7];
          return e2 !== t2 && (t2[8] = e2[8], t2[9] = e2[9], t2[10] = e2[10], t2[11] = e2[11], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2[0] = s2 * i2 + u2 * n2, t2[1] = o2 * i2 + c2 * n2, t2[2] = a2 * i2 + h2 * n2, t2[3] = l2 * i2 + p2 * n2, t2[4] = u2 * i2 - s2 * n2, t2[5] = c2 * i2 - o2 * n2, t2[6] = h2 * i2 - a2 * n2, t2[7] = p2 * i2 - l2 * n2, t2;
        }, t.bi = function(t2, e2, r2) {
          var n2 = Math.sin(r2), i2 = Math.cos(r2), s2 = e2[4], o2 = e2[5], a2 = e2[6], l2 = e2[7], u2 = e2[8], c2 = e2[9], h2 = e2[10], p2 = e2[11];
          return e2 !== t2 && (t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[3], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2[4] = s2 * i2 + u2 * n2, t2[5] = o2 * i2 + c2 * n2, t2[6] = a2 * i2 + h2 * n2, t2[7] = l2 * i2 + p2 * n2, t2[8] = u2 * i2 - s2 * n2, t2[9] = c2 * i2 - o2 * n2, t2[10] = h2 * i2 - a2 * n2, t2[11] = p2 * i2 - l2 * n2, t2;
        }, t.bj = function() {
          const t2 = new Float32Array(16);
          return y(t2), t2;
        }, t.bk = function() {
          const t2 = new Float64Array(16);
          return y(t2), t2;
        }, t.bl = function() {
          return new Float64Array(16);
        }, t.bm = function(t2, e2, r2) {
          const n2 = new Float64Array(4);
          return E(n2, t2, e2 - 90, r2), n2;
        }, t.bn = function(t2, e2, r2, n2) {
          var i2, s2, o2, a2, l2, u2 = e2[0], c2 = e2[1], h2 = e2[2], f2 = e2[3], d2 = r2[0], y2 = r2[1], m2 = r2[2], g2 = r2[3];
          return (s2 = u2 * d2 + c2 * y2 + h2 * m2 + f2 * g2) < 0 && (s2 = -s2, d2 = -d2, y2 = -y2, m2 = -m2, g2 = -g2), 1 - s2 > p ? (i2 = Math.acos(s2), o2 = Math.sin(i2), a2 = Math.sin((1 - n2) * i2) / o2, l2 = Math.sin(n2 * i2) / o2) : (a2 = 1 - n2, l2 = n2), t2[0] = a2 * u2 + l2 * d2, t2[1] = a2 * c2 + l2 * y2, t2[2] = a2 * h2 + l2 * m2, t2[3] = a2 * f2 + l2 * g2, t2;
        }, t.bo = function(t2) {
          const e2 = new Float64Array(9);
          !function(t3, e3) {
            var r3 = e3[0], n3 = e3[1], i3 = e3[2], s2 = e3[3], o2 = r3 + r3, a2 = n3 + n3, l2 = i3 + i3, u2 = r3 * o2, c2 = n3 * o2, h2 = n3 * a2, p2 = i3 * o2, f2 = i3 * a2, d2 = i3 * l2, y2 = s2 * o2, m2 = s2 * a2, g2 = s2 * l2;
            t3[0] = 1 - h2 - d2, t3[3] = c2 - g2, t3[6] = p2 + m2, t3[1] = c2 + g2, t3[4] = 1 - u2 - d2, t3[7] = f2 - y2, t3[2] = p2 - m2, t3[5] = f2 + y2, t3[8] = 1 - u2 - h2;
          }(e2, t2);
          const r2 = et(-Math.asin(C(e2[2], -1, 1)));
          let n2, i2;
          return Math.hypot(e2[5], e2[8]) < 1e-3 ? (n2 = 0, i2 = -et(Math.atan2(e2[3], e2[4]))) : (n2 = et(0 === e2[5] && 0 === e2[8] ? 0 : Math.atan2(e2[5], e2[8])), i2 = et(0 === e2[1] && 0 === e2[0] ? 0 : Math.atan2(e2[1], e2[0]))), { roll: n2, pitch: r2 + 90, bearing: i2 };
        }, t.bp = function(t2, e2) {
          return t2.roll == e2.roll && t2.pitch == e2.pitch && t2.bearing == e2.bearing;
        }, t.bq = Te, t.br = va, t.bs = cu, t.bt = hu, t.bu = lu, t.bv = P, t.bw = z, t.bx = Re, t.by = function(t2, e2, r2, n2, i2) {
          return P(n2, i2, C((t2 - e2) / (r2 - e2), 0, 1));
        }, t.bz = D, t.c = at, t.c$ = class {
          constructor(t2) {
            this._marks = { start: [t2.url, "start"].join("#"), end: [t2.url, "end"].join("#"), measure: t2.url.toString() }, performance.mark(this._marks.start);
          }
          finish() {
            performance.mark(this._marks.end);
            let t2 = performance.getEntriesByName(this._marks.measure);
            return 0 === t2.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), t2 = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), t2;
          }
        }, t.c0 = wa, t.c1 = class extends xa {
          constructor(t2, e2) {
            super(t2, e2), this.current = _a;
          }
          set(t2) {
            if (t2[12] !== this.current[12] || t2[0] !== this.current[0]) return this.current = t2, void this.gl.uniformMatrix4fv(this.location, false, t2);
            for (let e2 = 1; e2 < 16; e2++) if (t2[e2] !== this.current[e2]) {
              this.current = t2, this.gl.uniformMatrix4fv(this.location, false, t2);
              break;
            }
          }
        }, t.c2 = ba, t.c3 = class extends xa {
          constructor(t2, e2) {
            super(t2, e2), this.current = [0, 0, 0];
          }
          set(t2) {
            t2[0] === this.current[0] && t2[1] === this.current[1] && t2[2] === this.current[2] || (this.current = t2, this.gl.uniform3f(this.location, t2[0], t2[1], t2[2]));
          }
        }, t.c4 = class extends xa {
          constructor(t2, e2) {
            super(t2, e2), this.current = [0, 0];
          }
          set(t2) {
            t2[0] === this.current[0] && t2[1] === this.current[1] || (this.current = t2, this.gl.uniform2f(this.location, t2[0], t2[1]));
          }
        }, t.c5 = d, t.c6 = function(t2, e2) {
          var r2 = Math.sin(e2), n2 = Math.cos(e2);
          return t2[0] = n2, t2[1] = r2, t2[2] = 0, t2[3] = -r2, t2[4] = n2, t2[5] = 0, t2[6] = 0, t2[7] = 0, t2[8] = 1, t2;
        }, t.c7 = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2];
          return t2[0] = n2 * r2[0] + i2 * r2[3] + s2 * r2[6], t2[1] = n2 * r2[1] + i2 * r2[4] + s2 * r2[7], t2[2] = n2 * r2[2] + i2 * r2[5] + s2 * r2[8], t2;
        }, t.c8 = function(t2, e2, r2, n2, i2, s2, o2) {
          var a2 = 1 / (e2 - r2), l2 = 1 / (n2 - i2), u2 = 1 / (s2 - o2);
          return t2[0] = -2 * a2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = -2 * l2, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = 2 * u2, t2[11] = 0, t2[12] = (e2 + r2) * a2, t2[13] = (i2 + n2) * l2, t2[14] = (o2 + s2) * u2, t2[15] = 1, t2;
        }, t.c9 = class extends xa {
          constructor(t2, e2) {
            super(t2, e2), this.current = new Array();
          }
          set(t2) {
            if (t2 != this.current) {
              this.current = t2;
              const e2 = new Float32Array(4 * t2.length);
              for (let r2 = 0; r2 < t2.length; r2++) e2[4 * r2] = t2[r2].r, e2[4 * r2 + 1] = t2[r2].g, e2[4 * r2 + 2] = t2[r2].b, e2[4 * r2 + 3] = t2[r2].a;
              this.gl.uniform4fv(this.location, e2);
            }
          }
        }, t.cA = function(t2, e2) {
          return nt[e2] && (t2 instanceof MouseEvent || t2 instanceof WheelEvent);
        }, t.cB = function(t2, e2) {
          return rt[e2] && "touches" in t2;
        }, t.cC = function(t2) {
          return rt[t2] || nt[t2];
        }, t.cD = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1];
          return t2[0] = r2[0] * n2 + r2[4] * i2 + r2[12], t2[1] = r2[1] * n2 + r2[5] * i2 + r2[13], t2;
        }, t.cE = function(t2, e2) {
          const { x: r2, y: n2 } = Ph.fromLngLat(e2);
          return !(t2 < 0 || t2 > 25 || n2 < 0 || n2 >= 1 || r2 < 0 || r2 >= 1);
        }, t.cF = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = e2[1], t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = e2[2], t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
        }, t.cG = class extends no {
        }, t.cH = Pd, t.cJ = ct, t.cK = function(t2, e2) {
          at.REGISTERED_PROTOCOLS[t2] = e2;
        }, t.cL = function(t2) {
          delete at.REGISTERED_PROTOCOLS[t2];
        }, t.cM = function(t2, e2) {
          const r2 = {};
          for (let n3 = 0; n3 < t2.length; n3++) {
            const i2 = e2 && e2[t2[n3].id] || _i(t2[n3]);
            e2 && (e2[t2[n3].id] = i2);
            let s2 = r2[i2];
            s2 || (s2 = r2[i2] = []), s2.push(t2[n3]);
          }
          const n2 = [];
          for (const t3 in r2) n2.push(r2[t3]);
          return n2;
        }, t.cN = us, t.cO = $h, t.cP = Lf, t.cQ = $c, t.cR = function(e2) {
          e2.bucket.createArrays(), e2.bucket.tilePixelRatio = M / (512 * e2.bucket.overscaling), e2.bucket.compareText = {}, e2.bucket.iconsNeedLinear = false;
          const r2 = e2.bucket.layers[0], n2 = r2.layout, i2 = r2._unevaluatedLayout._values, s2 = { layoutIconSize: i2["icon-size"].possiblyEvaluate(new Fs(e2.bucket.zoom + 1), e2.canonical), layoutTextSize: i2["text-size"].possiblyEvaluate(new Fs(e2.bucket.zoom + 1), e2.canonical), textMaxSize: i2["text-size"].possiblyEvaluate(new Fs(18)) };
          if ("composite" === e2.bucket.textSizeData.kind) {
            const { minZoom: t2, maxZoom: r3 } = e2.bucket.textSizeData;
            s2.compositeTextSizes = [i2["text-size"].possiblyEvaluate(new Fs(t2), e2.canonical), i2["text-size"].possiblyEvaluate(new Fs(r3), e2.canonical)];
          }
          if ("composite" === e2.bucket.iconSizeData.kind) {
            const { minZoom: t2, maxZoom: r3 } = e2.bucket.iconSizeData;
            s2.compositeIconSizes = [i2["icon-size"].possiblyEvaluate(new Fs(t2), e2.canonical), i2["icon-size"].possiblyEvaluate(new Fs(r3), e2.canonical)];
          }
          const o2 = n2.get("text-line-height") * hc, a2 = "viewport" !== n2.get("text-rotation-alignment") && "point" !== n2.get("symbol-placement"), l2 = n2.get("text-keep-upright"), u2 = n2.get("text-size");
          for (const i3 of e2.bucket.features) {
            const c2 = n2.get("text-font").evaluate(i3, {}, e2.canonical).join(","), h2 = u2.evaluate(i3, {}, e2.canonical), p2 = s2.layoutTextSize.evaluate(i3, {}, e2.canonical), f2 = s2.layoutIconSize.evaluate(i3, {}, e2.canonical), d2 = { horizontal: {}, vertical: void 0 }, y2 = i3.text;
            let m2, g2 = [0, 0];
            if (y2) {
              const s3 = y2.toString(), u3 = n2.get("text-letter-spacing").evaluate(i3, {}, e2.canonical) * hc, f3 = bs(s3) ? u3 : 0, m3 = n2.get("text-anchor").evaluate(i3, {}, e2.canonical), x3 = fd(r2, i3, e2.canonical);
              if (!x3) {
                const t2 = n2.get("text-radial-offset").evaluate(i3, {}, e2.canonical);
                g2 = t2 ? pd(m3, [t2 * hc, hd]) : n2.get("text-offset").evaluate(i3, {}, e2.canonical).map((t3) => t3 * hc);
              }
              let v3 = a2 ? "center" : n2.get("text-justify").evaluate(i3, {}, e2.canonical);
              const b2 = "point" === n2.get("symbol-placement") ? n2.get("text-max-width").evaluate(i3, {}, e2.canonical) * hc : 1 / 0, w2 = () => {
                e2.bucket.allowVerticalPlacement && vs(s3) && (d2.vertical = qc(y2, e2.glyphMap, e2.glyphPositions, e2.imagePositions, c2, b2, o2, m3, "left", f3, g2, t.aA.vertical, true, p2, h2));
              };
              if (!a2 && x3) {
                const r3 = /* @__PURE__ */ new Set();
                if ("auto" === v3) for (let t2 = 0; t2 < x3.values.length; t2 += 2) r3.add(dd(x3.values[t2]));
                else r3.add(v3);
                let n3 = false;
                for (const i4 of r3) if (!d2.horizontal[i4]) if (n3) d2.horizontal[i4] = d2.horizontal[0];
                else {
                  const r4 = qc(y2, e2.glyphMap, e2.glyphPositions, e2.imagePositions, c2, b2, o2, "center", i4, f3, g2, t.aA.horizontal, false, p2, h2);
                  r4 && (d2.horizontal[i4] = r4, n3 = 1 === r4.positionedLines.length);
                }
                w2();
              } else {
                "auto" === v3 && (v3 = dd(m3));
                const r3 = qc(y2, e2.glyphMap, e2.glyphPositions, e2.imagePositions, c2, b2, o2, m3, v3, f3, g2, t.aA.horizontal, false, p2, h2);
                r3 && (d2.horizontal[v3] = r3), w2(), vs(s3) && a2 && l2 && (d2.vertical = qc(y2, e2.glyphMap, e2.glyphPositions, e2.imagePositions, c2, b2, o2, m3, v3, f3, g2, t.aA.vertical, false, p2, h2));
              }
            }
            let x2 = false;
            if (i3.icon && i3.icon.name) {
              const t2 = e2.imageMap[i3.icon.name];
              t2 && (m2 = Wc(e2.imagePositions[i3.icon.name], n2.get("icon-offset").evaluate(i3, {}, e2.canonical), n2.get("icon-anchor").evaluate(i3, {}, e2.canonical)), x2 = !!t2.sdf, void 0 === e2.bucket.sdfIcons ? e2.bucket.sdfIcons = x2 : e2.bucket.sdfIcons !== x2 && j("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (t2.pixelRatio !== e2.bucket.pixelRatio || 0 !== n2.get("icon-rotate").constantOr(1)) && (e2.bucket.iconsNeedLinear = true));
            }
            const v2 = gd(d2.horizontal) || d2.vertical;
            e2.bucket.iconsInText = !!v2 && v2.iconsInText, (v2 || m2) && yd(e2.bucket, i3, d2, m2, e2.imageMap, s2, p2, f2, g2, x2, e2.canonical, e2.subdivisionGranularity);
          }
          e2.showCollisionBoxes && e2.bucket.generateCollisionDebugBuffers();
        }, t.cS = xu, t.cT = Cu, t.cU = Wu, t.cV = function(t2) {
          const e2 = new Sc();
          return function(t3, e3) {
            for (const r2 in t3.layers) e3.writeMessage(3, Ff, t3.layers[r2]);
          }(t2, e2), e2.finish();
        }, t.cW = function(t2, e2, r2, n2, i2, s2) {
          let o2 = $f(t2, e2, r2, i2, 0);
          return o2 = $f(o2, e2, n2, s2, 1), o2;
        }, t.cX = class {
          constructor(t2) {
            this.maxEntries = t2, this.map = /* @__PURE__ */ new Map();
          }
          get(t2) {
            const e2 = this.map.get(t2);
            return void 0 !== e2 && (this.map.delete(t2), this.map.set(t2, e2)), e2;
          }
          set(t2, e2) {
            if (this.map.has(t2)) this.map.delete(t2);
            else if (this.map.size >= this.maxEntries) {
              const t3 = this.map.keys().next().value;
              this.map.delete(t3);
            }
            this.map.set(t2, e2);
          }
          clear() {
            this.map.clear();
          }
        }, t.cY = Pu, t.cZ = Sc, t.c_ = Ef, t.ca = class extends xa {
          constructor(t2, e2) {
            super(t2, e2), this.current = new Array();
          }
          set(t2) {
            if (t2 != this.current) {
              this.current = t2;
              const e2 = new Float32Array(t2);
              this.gl.uniform1fv(this.location, e2);
            }
          }
        }, t.cb = class extends mo {
        }, t.cc = uc, t.cd = class extends xo {
        }, t.ce = _l, t.cf = function(t2) {
          return t2 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t2) / Math.LN2));
        }, t.cg = wl, t.ch = function(t2, e2, r2) {
          var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = r2[3] * n2 + r2[7] * i2 + r2[11] * s2 + r2[15];
          return t2[0] = (r2[0] * n2 + r2[4] * i2 + r2[8] * s2 + r2[12]) / (o2 = o2 || 1), t2[1] = (r2[1] * n2 + r2[5] * i2 + r2[9] * s2 + r2[13]) / o2, t2[2] = (r2[2] * n2 + r2[6] * i2 + r2[10] * s2 + r2[14]) / o2, t2;
        }, t.ci = class extends io {
        }, t.cj = class extends ko {
        }, t.ck = function(t2, e2) {
          return t2[0] === e2[0] && t2[1] === e2[1] && t2[2] === e2[2] && t2[3] === e2[3] && t2[4] === e2[4] && t2[5] === e2[5] && t2[6] === e2[6] && t2[7] === e2[7] && t2[8] === e2[8] && t2[9] === e2[9] && t2[10] === e2[10] && t2[11] === e2[11] && t2[12] === e2[12] && t2[13] === e2[13] && t2[14] === e2[14] && t2[15] === e2[15];
        }, t.cl = function(t2, e2) {
          var r2 = t2[0], n2 = t2[1], i2 = t2[2], s2 = t2[3], o2 = t2[4], a2 = t2[5], l2 = t2[6], u2 = t2[7], c2 = t2[8], h2 = t2[9], f2 = t2[10], d2 = t2[11], y2 = t2[12], m2 = t2[13], g2 = t2[14], x2 = t2[15], v2 = e2[0], b2 = e2[1], w2 = e2[2], _2 = e2[3], A2 = e2[4], S2 = e2[5], k2 = e2[6], E2 = e2[7], T2 = e2[8], I2 = e2[9], M2 = e2[10], F2 = e2[11], D2 = e2[12], P2 = e2[13], z2 = e2[14], B2 = e2[15];
          return Math.abs(r2 - v2) <= p * Math.max(1, Math.abs(r2), Math.abs(v2)) && Math.abs(n2 - b2) <= p * Math.max(1, Math.abs(n2), Math.abs(b2)) && Math.abs(i2 - w2) <= p * Math.max(1, Math.abs(i2), Math.abs(w2)) && Math.abs(s2 - _2) <= p * Math.max(1, Math.abs(s2), Math.abs(_2)) && Math.abs(o2 - A2) <= p * Math.max(1, Math.abs(o2), Math.abs(A2)) && Math.abs(a2 - S2) <= p * Math.max(1, Math.abs(a2), Math.abs(S2)) && Math.abs(l2 - k2) <= p * Math.max(1, Math.abs(l2), Math.abs(k2)) && Math.abs(u2 - E2) <= p * Math.max(1, Math.abs(u2), Math.abs(E2)) && Math.abs(c2 - T2) <= p * Math.max(1, Math.abs(c2), Math.abs(T2)) && Math.abs(h2 - I2) <= p * Math.max(1, Math.abs(h2), Math.abs(I2)) && Math.abs(f2 - M2) <= p * Math.max(1, Math.abs(f2), Math.abs(M2)) && Math.abs(d2 - F2) <= p * Math.max(1, Math.abs(d2), Math.abs(F2)) && Math.abs(y2 - D2) <= p * Math.max(1, Math.abs(y2), Math.abs(D2)) && Math.abs(m2 - P2) <= p * Math.max(1, Math.abs(m2), Math.abs(P2)) && Math.abs(g2 - z2) <= p * Math.max(1, Math.abs(g2), Math.abs(z2)) && Math.abs(x2 - B2) <= p * Math.max(1, Math.abs(x2), Math.abs(B2));
        }, t.cm = function(t2, e2) {
          return t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[3], t2[4] = e2[4], t2[5] = e2[5], t2[6] = e2[6], t2[7] = e2[7], t2[8] = e2[8], t2[9] = e2[9], t2[10] = e2[10], t2[11] = e2[11], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15], t2;
        }, t.cn = (t2) => "symbol" === t2.type, t.co = (t2) => "circle" === t2.type, t.cp = (t2) => "heatmap" === t2.type, t.cq = (t2) => "line" === t2.type, t.cr = (t2) => "fill" === t2.type, t.cs = (t2) => "fill-extrusion" === t2.type, t.ct = (t2) => "hillshade" === t2.type, t.cu = (t2) => "color-relief" === t2.type, t.cv = (t2) => "background" === t2.type, t.cw = (t2) => "custom" === t2.type, t.cx = B, t.cy = function(t2, e2, r2) {
          const n2 = I(e2.x - r2.x, e2.y - r2.y), i2 = I(t2.x - r2.x, t2.y - r2.y), s2 = Math.atan2(n2[0] * i2[1] - n2[1] * i2[0], function(t3, e3) {
            return t3[0] * e3[0] + t3[1] * e3[1];
          }(n2, i2));
          return et(s2);
        }, t.cz = V, t.d = ft, t.d0 = function(t2, r2, n2, i2, s2) {
          return e(this, void 0, void 0, function* () {
            if (h()) try {
              return yield K(t2, r2, n2, i2, s2);
            } catch (t3) {
            }
            return function(t3, e2, r3, n3, i3) {
              const s3 = t3.width, o2 = t3.height;
              W && J || (W = new OffscreenCanvas(s3, o2), J = W.getContext("2d", { willReadFrequently: true })), W.width = s3, W.height = o2, J.drawImage(t3, 0, 0, s3, o2);
              const a2 = J.getImageData(e2, r3, n3, i3);
              return J.clearRect(0, 0, s3, o2), a2.data;
            }(t2, r2, n2, i2, s2);
          });
        }, t.d1 = Fl, t.d2 = n, t.d3 = class {
          constructor(t2, e2) {
            this.layers = { [Mf]: this }, this.name = Mf, this.version = e2 ? e2.version : 1, this.extent = e2 ? e2.extent : 4096, this.length = t2.length, this.features = t2;
          }
          feature(t2) {
            return new If(this.features[t2], this.extent);
          }
        }, t.d4 = ni, t.d5 = Ms, t.e = O, t.f = (t2) => e(void 0, void 0, void 0, function* () {
          if (0 === t2.byteLength) return createImageBitmap(new ImageData(1, 1));
          const e2 = new Blob([new Uint8Array(t2)], { type: "image/png" });
          try {
            return createImageBitmap(e2);
          } catch (t3) {
            throw new Error(`Could not load image because of ${t3.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`);
          }
        }), t.g = lt, t.h = (t2) => new Promise((e2, r2) => {
          const n2 = new Image();
          n2.onload = () => {
            e2(n2), URL.revokeObjectURL(n2.src), n2.onload = null, window.requestAnimationFrame(() => {
              n2.src = H;
            });
          }, n2.onerror = () => r2(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
          const i2 = new Blob([new Uint8Array(t2)], { type: "image/png" });
          n2.src = t2.byteLength ? URL.createObjectURL(i2) : H;
        }), t.i = X, t.j = (t2, e2) => pt(O(t2, { type: "json" }), e2), t.k = gt, t.l = mt, t.m = pt, t.n = (t2, e2) => pt(O(t2, { type: "arrayBuffer" }), e2), t.o = function(t2) {
          return new Sc(t2).readFields(Cc, []);
        }, t.p = Rc, t.q = function(t2) {
          return /[\u02EA\u02EB\u1100-\u11FF\u2E80-\u2FDF\u3000-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(t2));
        }, t.r = vl, t.s = Q, t.t = Xs, t.u = vt, t.v = ts, t.w = j, t.x = Vs, t.y = rs, t.z = Ps;
      });
      define("worker", ["./shared"], function(e) {
        class t {
          constructor(e2, t2) {
            this.keyCache = {}, e2 && this.replace(e2, t2);
          }
          replace(e2, t2) {
            this._layerConfigs = {}, this._layers = {}, this.update(e2, [], t2);
          }
          update(t2, o2, i2) {
            for (const o3 of t2) {
              this._layerConfigs[o3.id] = o3;
              const t3 = this._layers[o3.id] = e.bU(o3, i2);
              t3._featureFilter = e.ak(t3.filter, i2), this.keyCache[o3.id] && delete this.keyCache[o3.id];
            }
            for (const e2 of o2) delete this.keyCache[e2], delete this._layerConfigs[e2], delete this._layers[e2];
            this.familiesBySource = {};
            const s2 = e.cM(Object.values(this._layerConfigs), this.keyCache);
            for (const t3 of s2) {
              const o3 = t3.map((e2) => this._layers[e2.id]), i3 = o3[0];
              if ("none" === i3.visibility) continue;
              const s3 = i3.source || "";
              let n2 = this.familiesBySource[s3];
              n2 || (n2 = this.familiesBySource[s3] = {});
              const r2 = i3.sourceLayer || e.aa;
              let a2 = n2[r2];
              a2 || (a2 = n2[r2] = []), a2.push(o3);
            }
          }
        }
        class o {
          constructor(t2) {
            const o2 = {}, i2 = [];
            for (const e2 in t2) {
              const s3 = t2[e2], n3 = o2[e2] = {};
              for (const e3 in s3) {
                const t3 = s3[+e3];
                if (!t3 || 0 === t3.bitmap.width || 0 === t3.bitmap.height) continue;
                const o3 = { x: 0, y: 0, w: t3.bitmap.width + 2, h: t3.bitmap.height + 2 };
                i2.push(o3), n3[e3] = { rect: o3, metrics: t3.metrics };
              }
            }
            const { w: s2, h: n2 } = e.p(i2), r2 = new e.r({ width: s2 || 1, height: n2 || 1 });
            for (const i3 in t2) {
              const s3 = t2[i3];
              for (const t3 in s3) {
                const n3 = s3[+t3];
                if (!n3 || 0 === n3.bitmap.width || 0 === n3.bitmap.height) continue;
                const a2 = o2[i3][t3].rect;
                e.r.copy(n3.bitmap, r2, { x: 0, y: 0 }, { x: a2.x + 1, y: a2.y + 1 }, n3.bitmap);
              }
            }
            this.image = r2, this.positions = o2;
          }
        }
        e.cN("GlyphAtlas", o);
        class i {
          constructor(t2) {
            this.tileID = new e.a2(t2.tileID.overscaledZ, t2.tileID.wrap, t2.tileID.canonical.z, t2.tileID.canonical.x, t2.tileID.canonical.y), this.uid = t2.uid, this.zoom = t2.zoom, this.pixelRatio = t2.pixelRatio, this.tileSize = t2.tileSize, this.source = t2.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t2.showCollisionBoxes, this.collectResourceTiming = !!t2.collectResourceTiming, this.returnDependencies = !!t2.returnDependencies, this.promoteId = t2.promoteId, this.inFlightDependencies = [];
          }
          parse(t2, i2, n2, r2, a2) {
            return e._(this, void 0, void 0, function* () {
              this.status = "parsing", this.data = t2, this.collisionBoxArray = new e.ai();
              const l2 = new e.cO(Object.keys(t2.layers).sort()), c2 = new e.cP(this.tileID, this.promoteId);
              c2.bucketLayerIDs = [];
              const h2 = {}, u2 = { featureIndex: c2, iconDependencies: {}, patternDependencies: {}, glyphDependencies: {}, dashDependencies: {}, availableImages: n2, subdivisionGranularity: a2 }, d2 = i2.familiesBySource[this.source];
              for (const o2 in d2) {
                const i3 = t2.layers[o2];
                if (!i3) continue;
                1 === i3.version && e.w(`Vector tile source "${this.source}" layer "${o2}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                const r3 = l2.encode(o2), a3 = [];
                for (let e2 = 0; e2 < i3.length; e2++) {
                  const t3 = i3.feature(e2), s2 = c2.getId(t3, o2);
                  a3.push({ feature: t3, id: s2, index: e2, sourceLayerIndex: r3 });
                }
                for (const t3 of d2[o2]) {
                  const o3 = t3[0];
                  o3.source !== this.source && e.w(`layer.source = ${o3.source} does not equal this.source = ${this.source}`), o3.isHidden(this.zoom, true) || (s(t3, this.zoom, n2), (h2[o3.id] = o3.createBucket({ index: c2.bucketLayerIDs.length, layers: t3, zoom: this.zoom, pixelRatio: this.pixelRatio, overscaling: this.overscaling, collisionBoxArray: this.collisionBoxArray, sourceLayerIndex: r3, sourceID: this.source })).populate(a3, u2, this.tileID.canonical), c2.bucketLayerIDs.push(t3.map((e2) => e2.id)));
                }
              }
              const g2 = e.bZ(u2.glyphDependencies, (e2) => Object.keys(e2).map(Number));
              this.inFlightDependencies.forEach((e2) => null == e2 ? void 0 : e2.abort()), this.inFlightDependencies = [];
              let f2 = Promise.resolve({});
              if (Object.keys(g2).length) {
                const e2 = new AbortController();
                this.inFlightDependencies.push(e2), f2 = r2.sendAsync({ type: "GG", data: { stacks: g2, source: this.source, tileID: this.tileID, type: "glyphs" } }, e2);
              }
              const p2 = Object.keys(u2.iconDependencies);
              let m2 = Promise.resolve({});
              if (p2.length) {
                const e2 = new AbortController();
                this.inFlightDependencies.push(e2), m2 = r2.sendAsync({ type: "GI", data: { icons: p2, source: this.source, tileID: this.tileID, type: "icons" } }, e2);
              }
              const y2 = Object.keys(u2.patternDependencies);
              let v2 = Promise.resolve({});
              if (y2.length) {
                const e2 = new AbortController();
                this.inFlightDependencies.push(e2), v2 = r2.sendAsync({ type: "GI", data: { icons: y2, source: this.source, tileID: this.tileID, type: "patterns" } }, e2);
              }
              const x2 = u2.dashDependencies;
              let _2 = Promise.resolve({});
              if (Object.keys(x2).length) {
                const e2 = new AbortController();
                this.inFlightDependencies.push(e2), _2 = r2.sendAsync({ type: "GDA", data: { dashes: x2 } }, e2);
              }
              const [w2, S2, b2, M2] = yield Promise.all([f2, m2, v2, _2]), I2 = new o(w2), P2 = new e.cQ(S2, b2);
              for (const t3 in h2) {
                const o2 = h2[t3];
                o2 instanceof e.aj ? (s(o2.layers, this.zoom, n2), e.cR({ bucket: o2, glyphMap: w2, glyphPositions: I2.positions, imageMap: S2, imagePositions: P2.iconPositions, showCollisionBoxes: this.showCollisionBoxes, canonical: this.tileID.canonical, subdivisionGranularity: u2.subdivisionGranularity })) : o2.hasDependencies && (o2 instanceof e.cS || o2 instanceof e.cT || o2 instanceof e.cU) && (s(o2.layers, this.zoom, n2), o2.addFeatures(u2, this.tileID.canonical, P2.patternPositions, M2));
              }
              return this.status = "done", { buckets: Object.values(h2).filter((e2) => !e2.isEmpty()), featureIndex: c2, collisionBoxArray: this.collisionBoxArray, glyphAtlasImage: I2.image, imageAtlas: P2, dashPositions: M2, glyphMap: this.returnDependencies ? w2 : null, iconMap: this.returnDependencies ? S2 : null, glyphPositions: this.returnDependencies ? I2.positions : null };
            });
          }
        }
        function s(t2, o2, i2) {
          const s2 = new e.H(o2);
          for (const e2 of t2) e2.recalculate(s2, i2);
        }
        class n {
          constructor(e2, t2, o2, i2, s2) {
            this.type = e2, this.properties = o2 || {}, this.extent = s2, this.pointsArray = t2, this.id = i2;
          }
          loadGeometry() {
            return this.pointsArray.map((t2) => t2.map((t3) => new e.P(t3.x, t3.y)));
          }
        }
        class r {
          constructor(e2, t2, o2) {
            this.version = 2, this._myFeatures = e2, this.name = t2, this.length = e2.length, this.extent = o2;
          }
          feature(e2) {
            return this._myFeatures[e2];
          }
        }
        class a {
          constructor() {
            this.layers = {};
          }
          addLayer(e2) {
            this.layers[e2.name] = e2;
          }
        }
        function l(t2) {
          let o2 = e.cV(t2);
          return 0 === o2.byteOffset && o2.byteLength === o2.buffer.byteLength || (o2 = new Uint8Array(o2)), { vectorTile: t2, rawData: o2.buffer };
        }
        function c(t2, o2, i2) {
          const { extent: s2 } = t2, a2 = Math.pow(2, i2.z - o2.z), l2 = (i2.x - o2.x * a2) * s2, c2 = (i2.y - o2.y * a2) * s2, h2 = [];
          for (let o3 = 0; o3 < t2.length; o3++) {
            const i3 = t2.feature(o3);
            let r2 = i3.loadGeometry();
            for (const e2 of r2) for (const t3 of e2) t3.x = t3.x * a2 - l2, t3.y = t3.y * a2 - c2;
            const u2 = 128;
            r2 = e.cW(r2, i3.type, -128, -128, s2 + u2, s2 + u2), 0 !== r2.length && h2.push(new n(i3.type, r2, i3.properties, i3.id, s2));
          }
          return new r(h2, t2.name, s2);
        }
        class h {
          constructor(t2, o2, i2) {
            this.actor = t2, this.layerIndex = o2, this.availableImages = i2, this.fetching = {}, this.loading = {}, this.loaded = {}, this.overzoomedTileResultCache = new e.cX(1e3);
          }
          loadVectorTile(t2, o2) {
            return e._(this, void 0, void 0, function* () {
              const i2 = yield e.n(t2.request, o2);
              try {
                return { vectorTile: "mlt" !== t2.encoding ? new e.cY(new e.cZ(i2.data)) : new e.c_(i2.data), rawData: i2.data, cacheControl: i2.cacheControl, expires: i2.expires };
              } catch (e2) {
                const o3 = new Uint8Array(i2.data);
                let s2 = `Unable to parse the tile at ${t2.request.url}, `;
                throw s2 += 31 === o3[0] && 139 === o3[1] ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${e2.message}`, new Error(s2);
              }
            });
          }
          loadTile(t2) {
            return e._(this, void 0, void 0, function* () {
              const { uid: o2, overzoomParameters: s2 } = t2;
              s2 && (t2.request = s2.overzoomRequest);
              const n2 = !!(t2 && t2.request && t2.request.collectResourceTiming) && new e.c$(t2.request), r2 = new i(t2);
              this.loading[o2] = r2;
              const a2 = new AbortController();
              r2.abort = a2;
              try {
                const i2 = yield this.loadVectorTile(t2, a2);
                if (delete this.loading[o2], !i2) return null;
                if (s2) {
                  const e2 = this._getOverzoomTile(t2, i2.vectorTile);
                  i2.rawData = e2.rawData, i2.vectorTile = e2.vectorTile;
                }
                const l2 = i2.rawData, c2 = {};
                i2.expires && (c2.expires = i2.expires), i2.cacheControl && (c2.cacheControl = i2.cacheControl);
                const h2 = {};
                if (n2) {
                  const e2 = n2.finish();
                  e2 && (h2.resourceTiming = JSON.parse(JSON.stringify(e2)));
                }
                r2.vectorTile = i2.vectorTile;
                const u2 = r2.parse(i2.vectorTile, this.layerIndex, this.availableImages, this.actor, t2.subdivisionGranularity);
                this.loaded[o2] = r2, this.fetching[o2] = { rawTileData: l2, cacheControl: c2, resourceTiming: h2 };
                try {
                  const o3 = yield u2;
                  return e.e({ rawTileData: l2.slice(0), encoding: t2.encoding }, o3, c2, h2);
                } finally {
                  delete this.fetching[o2];
                }
              } catch (e2) {
                throw delete this.loading[o2], r2.status = "done", this.loaded[o2] = r2, e2;
              }
            });
          }
          _getOverzoomTile(e2, t2) {
            const { tileID: o2, source: i2, overzoomParameters: s2 } = e2, { maxZoomTileID: n2 } = s2, r2 = `${n2.key}_${o2.key}`, h2 = this.overzoomedTileResultCache.get(r2);
            if (h2) return h2;
            const u2 = new a(), d2 = this.layerIndex.familiesBySource[i2];
            for (const e3 in d2) {
              const i3 = t2.layers[e3];
              if (!i3) continue;
              const s3 = c(i3, n2, o2.canonical);
              s3.length > 0 && u2.addLayer(s3);
            }
            const g2 = l(u2);
            return this.overzoomedTileResultCache.set(r2, g2), g2;
          }
          reloadTile(t2) {
            return e._(this, void 0, void 0, function* () {
              const o2 = t2.uid;
              if (!this.loaded || !this.loaded[o2]) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
              const i2 = this.loaded[o2];
              if (i2.showCollisionBoxes = t2.showCollisionBoxes, "parsing" === i2.status) {
                const s2 = yield i2.parse(i2.vectorTile, this.layerIndex, this.availableImages, this.actor, t2.subdivisionGranularity);
                let n2;
                if (this.fetching[o2]) {
                  const { rawTileData: i3, cacheControl: r2, resourceTiming: a2 } = this.fetching[o2];
                  delete this.fetching[o2], n2 = e.e({ rawTileData: i3.slice(0), encoding: t2.encoding }, s2, r2, a2);
                } else n2 = s2;
                return n2;
              }
              if ("done" === i2.status && i2.vectorTile) return i2.parse(i2.vectorTile, this.layerIndex, this.availableImages, this.actor, t2.subdivisionGranularity);
            });
          }
          abortTile(t2) {
            return e._(this, void 0, void 0, function* () {
              const e2 = this.loading, o2 = t2.uid;
              e2 && e2[o2] && e2[o2].abort && (e2[o2].abort.abort(), delete e2[o2]);
            });
          }
          removeTile(t2) {
            return e._(this, void 0, void 0, function* () {
              this.loaded && this.loaded[t2.uid] && delete this.loaded[t2.uid];
            });
          }
        }
        class u {
          constructor() {
            this.loaded = {};
          }
          loadTile(t2) {
            return e._(this, void 0, void 0, function* () {
              const { uid: o2, encoding: i2, rawImageData: s2, redFactor: n2, greenFactor: r2, blueFactor: a2, baseShift: l2 } = t2, c2 = s2.width + 2, h2 = s2.height + 2, u2 = e.b(s2) ? new e.R({ width: c2, height: h2 }, yield e.d0(s2, -1, -1, c2, h2)) : s2, d2 = new e.d1(o2, u2, i2, n2, r2, a2, l2);
              return this.loaded = this.loaded || {}, this.loaded[o2] = d2, d2;
            });
          }
          removeTile(e2) {
            const t2 = this.loaded, o2 = e2.uid;
            t2 && t2[o2] && delete t2[o2];
          }
        }
        var d, g, f = function() {
          if (g) return d;
          function e2(e3, o2) {
            if (0 !== e3.length) {
              t2(e3[0], o2);
              for (var i2 = 1; i2 < e3.length; i2++) t2(e3[i2], !o2);
            }
          }
          function t2(e3, t3) {
            for (var o2 = 0, i2 = 0, s2 = 0, n2 = e3.length, r2 = n2 - 1; s2 < n2; r2 = s2++) {
              var a2 = (e3[s2][0] - e3[r2][0]) * (e3[r2][1] + e3[s2][1]), l2 = o2 + a2;
              i2 += Math.abs(o2) >= Math.abs(a2) ? o2 - l2 + a2 : a2 - l2 + o2, o2 = l2;
            }
            o2 + i2 >= 0 != !!t3 && e3.reverse();
          }
          return g = 1, d = function t3(o2, i2) {
            var s2, n2 = o2 && o2.type;
            if ("FeatureCollection" === n2) for (s2 = 0; s2 < o2.features.length; s2++) t3(o2.features[s2], i2);
            else if ("GeometryCollection" === n2) for (s2 = 0; s2 < o2.geometries.length; s2++) t3(o2.geometries[s2], i2);
            else if ("Feature" === n2) t3(o2.geometry, i2);
            else if ("Polygon" === n2) e2(o2.coordinates, i2);
            else if ("MultiPolygon" === n2) for (s2 = 0; s2 < o2.coordinates.length; s2++) e2(o2.coordinates[s2], i2);
            return o2;
          };
        }(), p = e.d2(f);
        const m = { minZoom: 0, maxZoom: 16, minPoints: 2, radius: 40, extent: 512, nodeSize: 64, log: false, generateId: false, reduce: null, map: (e2) => e2 }, y = Math.fround || (v = new Float32Array(1), (e2) => (v[0] = +e2, v[0]));
        var v;
        class x {
          constructor(e2) {
            this.options = Object.assign(Object.create(m), e2), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
          }
          load(e2) {
            const { log: t2, minZoom: o2, maxZoom: i2 } = this.options;
            t2 && console.time("total time");
            const s2 = `prepare ${e2.length} points`;
            t2 && console.time(s2), this.points = e2;
            const n2 = [];
            for (let t3 = 0; t3 < e2.length; t3++) {
              const o3 = e2[t3];
              if (!o3.geometry) continue;
              const [i3, s3] = o3.geometry.coordinates, r3 = y(S(i3)), a2 = y(b(s3));
              n2.push(r3, a2, 1 / 0, t3, -1, 1), this.options.reduce && n2.push(0);
            }
            let r2 = this.trees[i2 + 1] = this._createTree(n2);
            t2 && console.timeEnd(s2);
            for (let e3 = i2; e3 >= o2; e3--) {
              const o3 = +Date.now();
              r2 = this.trees[e3] = this._createTree(this._cluster(r2, e3)), t2 && console.log("z%d: %d clusters in %dms", e3, r2.numItems, +Date.now() - o3);
            }
            return t2 && console.timeEnd("total time"), this;
          }
          getClusters(e2, t2) {
            let o2 = ((e2[0] + 180) % 360 + 360) % 360 - 180;
            const i2 = Math.max(-90, Math.min(90, e2[1]));
            let s2 = 180 === e2[2] ? 180 : ((e2[2] + 180) % 360 + 360) % 360 - 180;
            const n2 = Math.max(-90, Math.min(90, e2[3]));
            if (e2[2] - e2[0] >= 360) o2 = -180, s2 = 180;
            else if (o2 > s2) {
              const e3 = this.getClusters([o2, i2, 180, n2], t2), r3 = this.getClusters([-180, i2, s2, n2], t2);
              return e3.concat(r3);
            }
            const r2 = this.trees[this._limitZoom(t2)], a2 = r2.range(S(o2), b(n2), S(s2), b(i2)), l2 = r2.data, c2 = [];
            for (const e3 of a2) {
              const t3 = this.stride * e3;
              c2.push(l2[t3 + 5] > 1 ? _(l2, t3, this.clusterProps) : this.points[l2[t3 + 3]]);
            }
            return c2;
          }
          getChildren(e2) {
            const t2 = this._getOriginId(e2), o2 = this._getOriginZoom(e2), i2 = "No cluster with the specified id.", s2 = this.trees[o2];
            if (!s2) throw new Error(i2);
            const n2 = s2.data;
            if (t2 * this.stride >= n2.length) throw new Error(i2);
            const r2 = this.options.radius / (this.options.extent * Math.pow(2, o2 - 1)), a2 = s2.within(n2[t2 * this.stride], n2[t2 * this.stride + 1], r2), l2 = [];
            for (const t3 of a2) {
              const o3 = t3 * this.stride;
              n2[o3 + 4] === e2 && l2.push(n2[o3 + 5] > 1 ? _(n2, o3, this.clusterProps) : this.points[n2[o3 + 3]]);
            }
            if (0 === l2.length) throw new Error(i2);
            return l2;
          }
          getLeaves(e2, t2, o2) {
            const i2 = [];
            return this._appendLeaves(i2, e2, t2 = t2 || 10, o2 = o2 || 0, 0), i2;
          }
          getTile(e2, t2, o2) {
            const i2 = this.trees[this._limitZoom(e2)], s2 = Math.pow(2, e2), { extent: n2, radius: r2 } = this.options, a2 = r2 / n2, l2 = (o2 - a2) / s2, c2 = (o2 + 1 + a2) / s2, h2 = { features: [] };
            return this._addTileFeatures(i2.range((t2 - a2) / s2, l2, (t2 + 1 + a2) / s2, c2), i2.data, t2, o2, s2, h2), 0 === t2 && this._addTileFeatures(i2.range(1 - a2 / s2, l2, 1, c2), i2.data, s2, o2, s2, h2), t2 === s2 - 1 && this._addTileFeatures(i2.range(0, l2, a2 / s2, c2), i2.data, -1, o2, s2, h2), h2.features.length ? h2 : null;
          }
          getClusterExpansionZoom(e2) {
            let t2 = this._getOriginZoom(e2) - 1;
            for (; t2 <= this.options.maxZoom; ) {
              const o2 = this.getChildren(e2);
              if (t2++, 1 !== o2.length) break;
              e2 = o2[0].properties.cluster_id;
            }
            return t2;
          }
          _appendLeaves(e2, t2, o2, i2, s2) {
            const n2 = this.getChildren(t2);
            for (const t3 of n2) {
              const n3 = t3.properties;
              if (n3 && n3.cluster ? s2 + n3.point_count <= i2 ? s2 += n3.point_count : s2 = this._appendLeaves(e2, n3.cluster_id, o2, i2, s2) : s2 < i2 ? s2++ : e2.push(t3), e2.length === o2) break;
            }
            return s2;
          }
          _createTree(t2) {
            const o2 = new e.aU(t2.length / this.stride | 0, this.options.nodeSize, Float32Array);
            for (let e2 = 0; e2 < t2.length; e2 += this.stride) o2.add(t2[e2], t2[e2 + 1]);
            return o2.finish(), o2.data = t2, o2;
          }
          _addTileFeatures(e2, t2, o2, i2, s2, n2) {
            for (const r2 of e2) {
              const e3 = r2 * this.stride, a2 = t2[e3 + 5] > 1;
              let l2, c2, h2;
              if (a2) l2 = w(t2, e3, this.clusterProps), c2 = t2[e3], h2 = t2[e3 + 1];
              else {
                const o3 = this.points[t2[e3 + 3]];
                l2 = o3.properties;
                const [i3, s3] = o3.geometry.coordinates;
                c2 = S(i3), h2 = b(s3);
              }
              const u2 = { type: 1, geometry: [[Math.round(this.options.extent * (c2 * s2 - o2)), Math.round(this.options.extent * (h2 * s2 - i2))]], tags: l2 };
              let d2;
              d2 = a2 || this.options.generateId ? t2[e3 + 3] : this.points[t2[e3 + 3]].id, void 0 !== d2 && (u2.id = d2), n2.features.push(u2);
            }
          }
          _limitZoom(e2) {
            return Math.max(this.options.minZoom, Math.min(Math.floor(+e2), this.options.maxZoom + 1));
          }
          _cluster(e2, t2) {
            const { radius: o2, extent: i2, reduce: s2, minPoints: n2 } = this.options, r2 = o2 / (i2 * Math.pow(2, t2)), a2 = e2.data, l2 = [], c2 = this.stride;
            for (let o3 = 0; o3 < a2.length; o3 += c2) {
              if (a2[o3 + 2] <= t2) continue;
              a2[o3 + 2] = t2;
              const i3 = a2[o3], h2 = a2[o3 + 1], u2 = e2.within(a2[o3], a2[o3 + 1], r2), d2 = a2[o3 + 5];
              let g2 = d2;
              for (const e3 of u2) {
                const o4 = e3 * c2;
                a2[o4 + 2] > t2 && (g2 += a2[o4 + 5]);
              }
              if (g2 > d2 && g2 >= n2) {
                let e3, n3 = i3 * d2, r3 = h2 * d2, f2 = -1;
                const p2 = (o3 / c2 << 5) + (t2 + 1) + this.points.length;
                for (const i4 of u2) {
                  const l3 = i4 * c2;
                  if (a2[l3 + 2] <= t2) continue;
                  a2[l3 + 2] = t2;
                  const h3 = a2[l3 + 5];
                  n3 += a2[l3] * h3, r3 += a2[l3 + 1] * h3, a2[l3 + 4] = p2, s2 && (e3 || (e3 = this._map(a2, o3, true), f2 = this.clusterProps.length, this.clusterProps.push(e3)), s2(e3, this._map(a2, l3)));
                }
                a2[o3 + 4] = p2, l2.push(n3 / g2, r3 / g2, 1 / 0, p2, -1, g2), s2 && l2.push(f2);
              } else {
                for (let e3 = 0; e3 < c2; e3++) l2.push(a2[o3 + e3]);
                if (g2 > 1) for (const e3 of u2) {
                  const o4 = e3 * c2;
                  if (!(a2[o4 + 2] <= t2)) {
                    a2[o4 + 2] = t2;
                    for (let e4 = 0; e4 < c2; e4++) l2.push(a2[o4 + e4]);
                  }
                }
              }
            }
            return l2;
          }
          _getOriginId(e2) {
            return e2 - this.points.length >> 5;
          }
          _getOriginZoom(e2) {
            return (e2 - this.points.length) % 32;
          }
          _map(e2, t2, o2) {
            if (e2[t2 + 5] > 1) {
              const i3 = this.clusterProps[e2[t2 + 6]];
              return o2 ? Object.assign({}, i3) : i3;
            }
            const i2 = this.points[e2[t2 + 3]].properties, s2 = this.options.map(i2);
            return o2 && s2 === i2 ? Object.assign({}, s2) : s2;
          }
        }
        function _(e2, t2, o2) {
          return { type: "Feature", id: e2[t2 + 3], properties: w(e2, t2, o2), geometry: { type: "Point", coordinates: [(i2 = e2[t2], 360 * (i2 - 0.5)), M(e2[t2 + 1])] } };
          var i2;
        }
        function w(e2, t2, o2) {
          const i2 = e2[t2 + 5], s2 = i2 >= 1e4 ? `${Math.round(i2 / 1e3)}k` : i2 >= 1e3 ? Math.round(i2 / 100) / 10 + "k" : i2, n2 = e2[t2 + 6], r2 = -1 === n2 ? {} : Object.assign({}, o2[n2]);
          return Object.assign(r2, { cluster: true, cluster_id: e2[t2 + 3], point_count: i2, point_count_abbreviated: s2 });
        }
        function S(e2) {
          return e2 / 360 + 0.5;
        }
        function b(e2) {
          const t2 = Math.sin(e2 * Math.PI / 180), o2 = 0.5 - 0.25 * Math.log((1 + t2) / (1 - t2)) / Math.PI;
          return o2 < 0 ? 0 : o2 > 1 ? 1 : o2;
        }
        function M(e2) {
          const t2 = (180 - 360 * e2) * Math.PI / 180;
          return 360 * Math.atan(Math.exp(t2)) / Math.PI - 90;
        }
        function I(e2, t2, o2, i2) {
          let s2 = i2;
          const n2 = t2 + (o2 - t2 >> 1);
          let r2, a2 = o2 - t2;
          const l2 = e2[t2], c2 = e2[t2 + 1], h2 = e2[o2], u2 = e2[o2 + 1];
          for (let i3 = t2 + 3; i3 < o2; i3 += 3) {
            const t3 = P(e2[i3], e2[i3 + 1], l2, c2, h2, u2);
            if (t3 > s2) r2 = i3, s2 = t3;
            else if (t3 === s2) {
              const e3 = Math.abs(i3 - n2);
              e3 < a2 && (r2 = i3, a2 = e3);
            }
          }
          s2 > i2 && (r2 - t2 > 3 && I(e2, t2, r2, i2), e2[r2 + 2] = s2, o2 - r2 > 3 && I(e2, r2, o2, i2));
        }
        function P(e2, t2, o2, i2, s2, n2) {
          let r2 = s2 - o2, a2 = n2 - i2;
          if (0 !== r2 || 0 !== a2) {
            const l2 = ((e2 - o2) * r2 + (t2 - i2) * a2) / (r2 * r2 + a2 * a2);
            l2 > 1 ? (o2 = s2, i2 = n2) : l2 > 0 && (o2 += r2 * l2, i2 += a2 * l2);
          }
          return r2 = e2 - o2, a2 = t2 - i2, r2 * r2 + a2 * a2;
        }
        function D(e2, t2, o2, i2) {
          const s2 = { id: null == e2 ? null : e2, type: t2, geometry: o2, tags: i2, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
          if ("Point" === t2 || "MultiPoint" === t2 || "LineString" === t2) k(s2, o2);
          else if ("Polygon" === t2) k(s2, o2[0]);
          else if ("MultiLineString" === t2) for (const e3 of o2) k(s2, e3);
          else if ("MultiPolygon" === t2) for (const e3 of o2) k(s2, e3[0]);
          return s2;
        }
        function k(e2, t2) {
          for (let o2 = 0; o2 < t2.length; o2 += 3) e2.minX = Math.min(e2.minX, t2[o2]), e2.minY = Math.min(e2.minY, t2[o2 + 1]), e2.maxX = Math.max(e2.maxX, t2[o2]), e2.maxY = Math.max(e2.maxY, t2[o2 + 1]);
        }
        function T(e2, t2, o2, i2) {
          if (!t2.geometry) return;
          const s2 = t2.geometry.coordinates;
          if (s2 && 0 === s2.length) return;
          const n2 = t2.geometry.type, r2 = Math.pow(o2.tolerance / ((1 << o2.maxZoom) * o2.extent), 2);
          let a2 = [], l2 = t2.id;
          if (o2.promoteId ? l2 = t2.properties[o2.promoteId] : o2.generateId && (l2 = i2 || 0), "Point" === n2) C(s2, a2);
          else if ("MultiPoint" === n2) for (const e3 of s2) C(e3, a2);
          else if ("LineString" === n2) O(s2, a2, r2, false);
          else if ("MultiLineString" === n2) {
            if (o2.lineMetrics) {
              for (const o3 of s2) a2 = [], O(o3, a2, r2, false), e2.push(D(l2, "LineString", a2, t2.properties));
              return;
            }
            L2(s2, a2, r2, false);
          } else if ("Polygon" === n2) L2(s2, a2, r2, true);
          else {
            if ("MultiPolygon" !== n2) {
              if ("GeometryCollection" === n2) {
                for (const s3 of t2.geometry.geometries) T(e2, { id: l2, geometry: s3, properties: t2.properties }, o2, i2);
                return;
              }
              throw new Error("Input data is not a valid GeoJSON object.");
            }
            for (const e3 of s2) {
              const t3 = [];
              L2(e3, t3, r2, true), a2.push(t3);
            }
          }
          e2.push(D(l2, n2, a2, t2.properties));
        }
        function C(e2, t2) {
          t2.push(z(e2[0]), F(e2[1]), 0);
        }
        function O(e2, t2, o2, i2) {
          let s2, n2, r2 = 0;
          for (let o3 = 0; o3 < e2.length; o3++) {
            const a3 = z(e2[o3][0]), l2 = F(e2[o3][1]);
            t2.push(a3, l2, 0), o3 > 0 && (r2 += i2 ? (s2 * l2 - a3 * n2) / 2 : Math.sqrt(Math.pow(a3 - s2, 2) + Math.pow(l2 - n2, 2))), s2 = a3, n2 = l2;
          }
          const a2 = t2.length - 3;
          t2[2] = 1, I(t2, 0, a2, o2), t2[a2 + 2] = 1, t2.size = Math.abs(r2), t2.start = 0, t2.end = t2.size;
        }
        function L2(e2, t2, o2, i2) {
          for (let s2 = 0; s2 < e2.length; s2++) {
            const n2 = [];
            O(e2[s2], n2, o2, i2), t2.push(n2);
          }
        }
        function z(e2) {
          return e2 / 360 + 0.5;
        }
        function F(e2) {
          const t2 = Math.sin(e2 * Math.PI / 180), o2 = 0.5 - 0.25 * Math.log((1 + t2) / (1 - t2)) / Math.PI;
          return o2 < 0 ? 0 : o2 > 1 ? 1 : o2;
        }
        function G(e2, t2, o2, i2, s2, n2, r2, a2) {
          if (i2 /= t2, n2 >= (o2 /= t2) && r2 < i2) return e2;
          if (r2 < o2 || n2 >= i2) return null;
          const l2 = [];
          for (const t3 of e2) {
            const e3 = t3.geometry;
            let n3 = t3.type;
            const r3 = 0 === s2 ? t3.minX : t3.minY, c2 = 0 === s2 ? t3.maxX : t3.maxY;
            if (r3 >= o2 && c2 < i2) {
              l2.push(t3);
              continue;
            }
            if (c2 < o2 || r3 >= i2) continue;
            let h2 = [];
            if ("Point" === n3 || "MultiPoint" === n3) A(e3, h2, o2, i2, s2);
            else if ("LineString" === n3) Z(e3, h2, o2, i2, s2, false, a2.lineMetrics);
            else if ("MultiLineString" === n3) E(e3, h2, o2, i2, s2, false);
            else if ("Polygon" === n3) E(e3, h2, o2, i2, s2, true);
            else if ("MultiPolygon" === n3) for (const t4 of e3) {
              const e4 = [];
              E(t4, e4, o2, i2, s2, true), e4.length && h2.push(e4);
            }
            if (h2.length) {
              if (a2.lineMetrics && "LineString" === n3) {
                for (const e4 of h2) l2.push(D(t3.id, n3, e4, t3.tags));
                continue;
              }
              "LineString" !== n3 && "MultiLineString" !== n3 || (1 === h2.length ? (n3 = "LineString", h2 = h2[0]) : n3 = "MultiLineString"), "Point" !== n3 && "MultiPoint" !== n3 || (n3 = 3 === h2.length ? "Point" : "MultiPoint"), l2.push(D(t3.id, n3, h2, t3.tags));
            }
          }
          return l2.length ? l2 : null;
        }
        function A(e2, t2, o2, i2, s2) {
          for (let n2 = 0; n2 < e2.length; n2 += 3) {
            const r2 = e2[n2 + s2];
            r2 >= o2 && r2 <= i2 && j(t2, e2[n2], e2[n2 + 1], e2[n2 + 2]);
          }
        }
        function Z(e2, t2, o2, i2, s2, n2, r2) {
          let a2 = R(e2);
          const l2 = 0 === s2 ? N : W;
          let c2, h2, u2 = e2.start;
          for (let d3 = 0; d3 < e2.length - 3; d3 += 3) {
            const g3 = e2[d3], f3 = e2[d3 + 1], p3 = e2[d3 + 2], m2 = e2[d3 + 3], y2 = e2[d3 + 4], v2 = 0 === s2 ? g3 : f3, x2 = 0 === s2 ? m2 : y2;
            let _2 = false;
            r2 && (c2 = Math.sqrt(Math.pow(g3 - m2, 2) + Math.pow(f3 - y2, 2))), v2 < o2 ? x2 > o2 && (h2 = l2(a2, g3, f3, m2, y2, o2), r2 && (a2.start = u2 + c2 * h2)) : v2 > i2 ? x2 < i2 && (h2 = l2(a2, g3, f3, m2, y2, i2), r2 && (a2.start = u2 + c2 * h2)) : j(a2, g3, f3, p3), x2 < o2 && v2 >= o2 && (h2 = l2(a2, g3, f3, m2, y2, o2), _2 = true), x2 > i2 && v2 <= i2 && (h2 = l2(a2, g3, f3, m2, y2, i2), _2 = true), !n2 && _2 && (r2 && (a2.end = u2 + c2 * h2), t2.push(a2), a2 = R(e2)), r2 && (u2 += c2);
          }
          let d2 = e2.length - 3;
          const g2 = e2[d2], f2 = e2[d2 + 1], p2 = 0 === s2 ? g2 : f2;
          p2 >= o2 && p2 <= i2 && j(a2, g2, f2, e2[d2 + 2]), d2 = a2.length - 3, n2 && d2 >= 3 && (a2[d2] !== a2[0] || a2[d2 + 1] !== a2[1]) && j(a2, a2[0], a2[1], a2[2]), a2.length && t2.push(a2);
        }
        function R(e2) {
          const t2 = [];
          return t2.size = e2.size, t2.start = e2.start, t2.end = e2.end, t2;
        }
        function E(e2, t2, o2, i2, s2, n2) {
          for (const r2 of e2) Z(r2, t2, o2, i2, s2, n2, false);
        }
        function j(e2, t2, o2, i2) {
          e2.push(t2, o2, i2);
        }
        function N(e2, t2, o2, i2, s2, n2) {
          const r2 = (n2 - t2) / (i2 - t2);
          return j(e2, n2, o2 + (s2 - o2) * r2, 1), r2;
        }
        function W(e2, t2, o2, i2, s2, n2) {
          const r2 = (n2 - o2) / (s2 - o2);
          return j(e2, t2 + (i2 - t2) * r2, n2, 1), r2;
        }
        function J(e2, t2) {
          const o2 = [];
          for (let i2 = 0; i2 < e2.length; i2++) {
            const s2 = e2[i2], n2 = s2.type;
            let r2;
            if ("Point" === n2 || "MultiPoint" === n2 || "LineString" === n2) r2 = Y(s2.geometry, t2);
            else if ("MultiLineString" === n2 || "Polygon" === n2) {
              r2 = [];
              for (const e3 of s2.geometry) r2.push(Y(e3, t2));
            } else if ("MultiPolygon" === n2) {
              r2 = [];
              for (const e3 of s2.geometry) {
                const o3 = [];
                for (const i3 of e3) o3.push(Y(i3, t2));
                r2.push(o3);
              }
            }
            o2.push(D(s2.id, n2, r2, s2.tags));
          }
          return o2;
        }
        function Y(e2, t2) {
          const o2 = [];
          o2.size = e2.size, void 0 !== e2.start && (o2.start = e2.start, o2.end = e2.end);
          for (let i2 = 0; i2 < e2.length; i2 += 3) o2.push(e2[i2] + t2, e2[i2 + 1], e2[i2 + 2]);
          return o2;
        }
        function q(e2, t2) {
          if (e2.transformed) return e2;
          const o2 = 1 << e2.z, i2 = e2.x, s2 = e2.y;
          for (const n2 of e2.features) {
            const e3 = n2.geometry, r2 = n2.type;
            if (n2.geometry = [], 1 === r2) for (let r3 = 0; r3 < e3.length; r3 += 2) n2.geometry.push(H(e3[r3], e3[r3 + 1], t2, o2, i2, s2));
            else for (let r3 = 0; r3 < e3.length; r3++) {
              const a2 = [];
              for (let n3 = 0; n3 < e3[r3].length; n3 += 2) a2.push(H(e3[r3][n3], e3[r3][n3 + 1], t2, o2, i2, s2));
              n2.geometry.push(a2);
            }
          }
          return e2.transformed = true, e2;
        }
        function H(e2, t2, o2, i2, s2, n2) {
          return [Math.round(o2 * (e2 * i2 - s2)), Math.round(o2 * (t2 * i2 - n2))];
        }
        function X(e2, t2, o2, i2, s2) {
          const n2 = t2 === s2.maxZoom ? 0 : s2.tolerance / ((1 << t2) * s2.extent), r2 = { features: [], numPoints: 0, numSimplified: 0, numFeatures: e2.length, source: null, x: o2, y: i2, z: t2, transformed: false, minX: 2, minY: 1, maxX: -1, maxY: 0 };
          for (const t3 of e2) $(r2, t3, n2, s2);
          return r2;
        }
        function $(e2, t2, o2, i2) {
          const s2 = t2.geometry, n2 = t2.type, r2 = [];
          if (e2.minX = Math.min(e2.minX, t2.minX), e2.minY = Math.min(e2.minY, t2.minY), e2.maxX = Math.max(e2.maxX, t2.maxX), e2.maxY = Math.max(e2.maxY, t2.maxY), "Point" === n2 || "MultiPoint" === n2) for (let t3 = 0; t3 < s2.length; t3 += 3) r2.push(s2[t3], s2[t3 + 1]), e2.numPoints++, e2.numSimplified++;
          else if ("LineString" === n2) B(r2, s2, e2, o2, false, false);
          else if ("MultiLineString" === n2 || "Polygon" === n2) for (let t3 = 0; t3 < s2.length; t3++) B(r2, s2[t3], e2, o2, "Polygon" === n2, 0 === t3);
          else if ("MultiPolygon" === n2) for (let t3 = 0; t3 < s2.length; t3++) {
            const i3 = s2[t3];
            for (let t4 = 0; t4 < i3.length; t4++) B(r2, i3[t4], e2, o2, true, 0 === t4);
          }
          if (r2.length) {
            let o3 = t2.tags || null;
            if ("LineString" === n2 && i2.lineMetrics) {
              o3 = {};
              for (const e3 in t2.tags) o3[e3] = t2.tags[e3];
              o3.mapbox_clip_start = s2.start / s2.size, o3.mapbox_clip_end = s2.end / s2.size;
            }
            const a2 = { geometry: r2, type: "Polygon" === n2 || "MultiPolygon" === n2 ? 3 : "LineString" === n2 || "MultiLineString" === n2 ? 2 : 1, tags: o3 };
            null !== t2.id && (a2.id = t2.id), e2.features.push(a2);
          }
        }
        function B(e2, t2, o2, i2, s2, n2) {
          const r2 = i2 * i2;
          if (i2 > 0 && t2.size < (s2 ? r2 : i2)) return void (o2.numPoints += t2.length / 3);
          const a2 = [];
          for (let e3 = 0; e3 < t2.length; e3 += 3) (0 === i2 || t2[e3 + 2] > r2) && (o2.numSimplified++, a2.push(t2[e3], t2[e3 + 1])), o2.numPoints++;
          s2 && function(e3, t3) {
            let o3 = 0;
            for (let t4 = 0, i3 = e3.length, s3 = i3 - 2; t4 < i3; s3 = t4, t4 += 2) o3 += (e3[t4] - e3[s3]) * (e3[t4 + 1] + e3[s3 + 1]);
            if (o3 > 0 === t3) for (let t4 = 0, o4 = e3.length; t4 < o4 / 2; t4 += 2) {
              const i3 = e3[t4], s3 = e3[t4 + 1];
              e3[t4] = e3[o4 - 2 - t4], e3[t4 + 1] = e3[o4 - 1 - t4], e3[o4 - 2 - t4] = i3, e3[o4 - 1 - t4] = s3;
            }
          }(a2, n2), e2.push(a2);
        }
        const U = { maxZoom: 14, indexMaxZoom: 5, indexMaxPoints: 1e5, tolerance: 3, extent: 4096, buffer: 64, lineMetrics: false, promoteId: null, generateId: false, debug: 0 };
        class V {
          constructor(e2, t2) {
            const o2 = (t2 = this.options = function(e3, t3) {
              for (const o3 in t3) e3[o3] = t3[o3];
              return e3;
            }(Object.create(U), t2)).debug;
            if (o2 && console.time("preprocess data"), t2.maxZoom < 0 || t2.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
            if (t2.promoteId && t2.generateId) throw new Error("promoteId and generateId cannot be used together.");
            let i2 = function(e3, t3) {
              const o3 = [];
              if ("FeatureCollection" === e3.type) for (let i3 = 0; i3 < e3.features.length; i3++) T(o3, e3.features[i3], t3, i3);
              else T(o3, "Feature" === e3.type ? e3 : { geometry: e3 }, t3);
              return o3;
            }(e2, t2);
            this.tiles = {}, this.tileCoords = [], o2 && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t2.indexMaxZoom, t2.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), i2 = function(e3, t3) {
              const o3 = t3.buffer / t3.extent;
              let i3 = e3;
              const s2 = G(e3, 1, -1 - o3, o3, 0, -1, 2, t3), n2 = G(e3, 1, 1 - o3, 2 + o3, 0, -1, 2, t3);
              return (s2 || n2) && (i3 = G(e3, 1, -o3, 1 + o3, 0, -1, 2, t3) || [], s2 && (i3 = J(s2, 1).concat(i3)), n2 && (i3 = i3.concat(J(n2, -1)))), i3;
            }(i2, t2), i2.length && this.splitTile(i2, 0, 0, 0), o2 && (i2.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
          }
          splitTile(e2, t2, o2, i2, s2, n2, r2) {
            const a2 = [e2, t2, o2, i2], l2 = this.options, c2 = l2.debug;
            for (; a2.length; ) {
              i2 = a2.pop(), o2 = a2.pop(), t2 = a2.pop(), e2 = a2.pop();
              const h2 = 1 << t2, u2 = K(t2, o2, i2);
              let d2 = this.tiles[u2];
              if (!d2 && (c2 > 1 && console.time("creation"), d2 = this.tiles[u2] = X(e2, t2, o2, i2, l2), this.tileCoords.push({ z: t2, x: o2, y: i2 }), c2)) {
                c2 > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t2, o2, i2, d2.numFeatures, d2.numPoints, d2.numSimplified), console.timeEnd("creation"));
                const e3 = `z${t2}`;
                this.stats[e3] = (this.stats[e3] || 0) + 1, this.total++;
              }
              if (d2.source = e2, null == s2) {
                if (t2 === l2.indexMaxZoom || d2.numPoints <= l2.indexMaxPoints) continue;
              } else {
                if (t2 === l2.maxZoom || t2 === s2) continue;
                if (null != s2) {
                  const e3 = s2 - t2;
                  if (o2 !== n2 >> e3 || i2 !== r2 >> e3) continue;
                }
              }
              if (d2.source = null, 0 === e2.length) continue;
              c2 > 1 && console.time("clipping");
              const g2 = 0.5 * l2.buffer / l2.extent, f2 = 0.5 - g2, p2 = 0.5 + g2, m2 = 1 + g2;
              let y2 = null, v2 = null, x2 = null, _2 = null, w2 = G(e2, h2, o2 - g2, o2 + p2, 0, d2.minX, d2.maxX, l2), S2 = G(e2, h2, o2 + f2, o2 + m2, 0, d2.minX, d2.maxX, l2);
              e2 = null, w2 && (y2 = G(w2, h2, i2 - g2, i2 + p2, 1, d2.minY, d2.maxY, l2), v2 = G(w2, h2, i2 + f2, i2 + m2, 1, d2.minY, d2.maxY, l2), w2 = null), S2 && (x2 = G(S2, h2, i2 - g2, i2 + p2, 1, d2.minY, d2.maxY, l2), _2 = G(S2, h2, i2 + f2, i2 + m2, 1, d2.minY, d2.maxY, l2), S2 = null), c2 > 1 && console.timeEnd("clipping"), a2.push(y2 || [], t2 + 1, 2 * o2, 2 * i2), a2.push(v2 || [], t2 + 1, 2 * o2, 2 * i2 + 1), a2.push(x2 || [], t2 + 1, 2 * o2 + 1, 2 * i2), a2.push(_2 || [], t2 + 1, 2 * o2 + 1, 2 * i2 + 1);
            }
          }
          getTile(e2, t2, o2) {
            e2 = +e2, t2 = +t2, o2 = +o2;
            const i2 = this.options, { extent: s2, debug: n2 } = i2;
            if (e2 < 0 || e2 > 24) return null;
            const r2 = 1 << e2, a2 = K(e2, t2 = t2 + r2 & r2 - 1, o2);
            if (this.tiles[a2]) return q(this.tiles[a2], s2);
            n2 > 1 && console.log("drilling down to z%d-%d-%d", e2, t2, o2);
            let l2, c2 = e2, h2 = t2, u2 = o2;
            for (; !l2 && c2 > 0; ) c2--, h2 >>= 1, u2 >>= 1, l2 = this.tiles[K(c2, h2, u2)];
            return l2 && l2.source ? (n2 > 1 && (console.log("found parent tile z%d-%d-%d", c2, h2, u2), console.time("drilling down")), this.splitTile(l2.source, c2, h2, u2, e2, t2, o2), n2 > 1 && console.timeEnd("drilling down"), this.tiles[a2] ? q(this.tiles[a2], s2) : null) : null;
          }
        }
        function K(e2, t2, o2) {
          return 32 * ((1 << e2) * o2 + t2) + e2;
        }
        class Q extends h {
          constructor(e2, t2, o2, i2 = ee) {
            super(e2, t2, o2), this._dataUpdateable = /* @__PURE__ */ new Map(), this._createGeoJSONIndex = i2;
          }
          loadVectorTile(t2, o2) {
            return e._(this, void 0, void 0, function* () {
              const o3 = t2.tileID.canonical;
              if (!this._geoJSONIndex) throw new Error("Unable to parse the data into a cluster or geojson");
              const i2 = this._geoJSONIndex.getTile(o3.z, o3.x, o3.y);
              return i2 ? l(new e.d3(i2.features, { version: 2, extent: e.a5 })) : null;
            });
          }
          loadData(t2) {
            return e._(this, void 0, void 0, function* () {
              var o2;
              null === (o2 = this._pendingRequest) || void 0 === o2 || o2.abort();
              const i2 = this._startPerformance(t2);
              this._pendingRequest = new AbortController();
              try {
                (!this._pendingData || t2.request || t2.data || t2.dataDiff) && (this._pendingData = this.loadAndProcessGeoJSON(t2, this._pendingRequest));
                const e2 = yield this._pendingData;
                this._geoJSONIndex = this._createGeoJSONIndex(e2, t2), this.loaded = {};
                const o3 = {};
                return this._finishPerformance(i2, t2, o3), o3;
              } catch (t3) {
                if (delete this._pendingRequest, e.Z(t3)) return { abandoned: true };
                throw t3;
              }
            });
          }
          _startPerformance(t2) {
            var o2;
            if (null === (o2 = null == t2 ? void 0 : t2.request) || void 0 === o2 ? void 0 : o2.collectResourceTiming) return new e.c$(t2.request);
          }
          _finishPerformance(e2, t2, o2) {
            if (!e2) return;
            const i2 = e2.finish();
            i2 && (o2.resourceTiming = {}, o2.resourceTiming[t2.source] = JSON.parse(JSON.stringify(i2)));
          }
          getData() {
            return e._(this, void 0, void 0, function* () {
              return this._pendingData;
            });
          }
          reloadTile(e2) {
            const t2 = this.loaded;
            return t2 && t2[e2.uid] ? super.reloadTile(e2) : this.loadTile(e2);
          }
          loadAndProcessGeoJSON(t2, o2) {
            return e._(this, void 0, void 0, function* () {
              let e2;
              if (t2.request ? e2 = yield this.loadGeoJSONFromUrl(t2.request, t2.promoteId, o2) : t2.data ? e2 = this._loadGeoJSONFromObject(t2.data, t2.promoteId) : t2.dataDiff && (e2 = this._loadGeoJSONFromDiff(t2.dataDiff, t2.promoteId, t2.source)), delete this._pendingRequest, "object" != typeof e2) throw new Error(`Input data given to '${t2.source}' is not a valid GeoJSON object.`);
              return p(e2, true), t2.filter && (e2 = this._filterGeoJSON(e2, t2.filter)), e2;
            });
          }
          loadGeoJSONFromUrl(t2, o2, i2) {
            return e._(this, void 0, void 0, function* () {
              const s2 = yield e.j(t2, i2);
              return this._dataUpdateable = e.a7(s2.data, o2) ? e.a8(s2.data, o2) : void 0, s2.data;
            });
          }
          _loadGeoJSONFromObject(t2, o2) {
            return this._dataUpdateable = e.a7(t2, o2) ? e.a8(t2, o2) : void 0, t2;
          }
          _loadGeoJSONFromDiff(t2, o2, i2) {
            if (!this._dataUpdateable) throw new Error(`Cannot update existing geojson data in ${i2}`);
            e.a9(this._dataUpdateable, t2, o2);
            const s2 = Array.from(this._dataUpdateable.values());
            return this._toFeatureCollection(s2);
          }
          _filterGeoJSON(t2, o2) {
            const i2 = e.d4(o2, { type: "boolean", "property-type": "data-driven", overridable: false, transition: false });
            if ("error" === i2.result) throw new Error(i2.value.map((e2) => `${e2.key}: ${e2.message}`).join(", "));
            const s2 = t2.features.filter((e2) => i2.value.evaluate({ zoom: 0 }, e2));
            return this._toFeatureCollection(s2);
          }
          _toFeatureCollection(e2) {
            return { type: "FeatureCollection", features: e2 };
          }
          removeSource(t2) {
            return e._(this, void 0, void 0, function* () {
              this._pendingRequest && this._pendingRequest.abort();
            });
          }
          getClusterExpansionZoom(e2) {
            return this._geoJSONIndex.getClusterExpansionZoom(e2.clusterId);
          }
          getClusterChildren(e2) {
            return this._geoJSONIndex.getChildren(e2.clusterId);
          }
          getClusterLeaves(e2) {
            return this._geoJSONIndex.getLeaves(e2.clusterId, e2.limit, e2.offset);
          }
        }
        function ee(t2, o2) {
          return o2.cluster ? new x(function({ superclusterOptions: t3, clusterProperties: o3 }) {
            if (!o3 || !t3) return t3;
            const i2 = {}, s2 = {}, n2 = { accumulated: null, zoom: 0 }, r2 = { properties: null }, a2 = Object.keys(o3);
            for (const t4 of a2) {
              const [n3, r3] = o3[t4], a3 = e.d4(r3), l2 = e.d4("string" == typeof n3 ? [n3, ["accumulated"], ["get", t4]] : n3);
              i2[t4] = a3.value, s2[t4] = l2.value;
            }
            return t3.map = (e2) => {
              r2.properties = e2;
              const t4 = {};
              for (const e3 of a2) t4[e3] = i2[e3].evaluate(n2, r2);
              return t4;
            }, t3.reduce = (e2, t4) => {
              r2.properties = t4;
              for (const t5 of a2) n2.accumulated = e2[t5], e2[t5] = s2[t5].evaluate(n2, r2);
            }, t3;
          }(o2)).load(t2.features) : function(e2, t3) {
            return new V(e2, t3);
          }(t2, o2.geojsonVtOptions);
        }
        class te {
          constructor(t2) {
            this.self = t2, this.actor = new e.L(t2), this.layerIndexes = {}, this.availableImages = {}, this.workerSources = {}, this.demWorkerSources = {}, this.externalWorkerSourceTypes = {}, this.globalStates = /* @__PURE__ */ new Map(), this.self.registerWorkerSource = (e2, t3) => {
              if (this.externalWorkerSourceTypes[e2]) throw new Error(`Worker source with name "${e2}" already registered.`);
              this.externalWorkerSourceTypes[e2] = t3;
            }, this.self.addProtocol = e.cK, this.self.removeProtocol = e.cL, this.self.registerRTLTextPlugin = (t3) => {
              e.d5.setMethods(t3);
            }, this.actor.registerMessageHandler("LDT", (e2, t3) => this._getDEMWorkerSource(e2, t3.source).loadTile(t3)), this.actor.registerMessageHandler("RDT", (t3, o2) => e._(this, void 0, void 0, function* () {
              this._getDEMWorkerSource(t3, o2.source).removeTile(o2);
            })), this.actor.registerMessageHandler("GCEZ", (t3, o2) => e._(this, void 0, void 0, function* () {
              return this._getWorkerSource(t3, o2.type, o2.source).getClusterExpansionZoom(o2);
            })), this.actor.registerMessageHandler("GCC", (t3, o2) => e._(this, void 0, void 0, function* () {
              return this._getWorkerSource(t3, o2.type, o2.source).getClusterChildren(o2);
            })), this.actor.registerMessageHandler("GCL", (t3, o2) => e._(this, void 0, void 0, function* () {
              return this._getWorkerSource(t3, o2.type, o2.source).getClusterLeaves(o2);
            })), this.actor.registerMessageHandler("LD", (e2, t3) => this._getWorkerSource(e2, t3.type, t3.source).loadData(t3)), this.actor.registerMessageHandler("GD", (e2, t3) => this._getWorkerSource(e2, t3.type, t3.source).getData()), this.actor.registerMessageHandler("LT", (e2, t3) => this._getWorkerSource(e2, t3.type, t3.source).loadTile(t3)), this.actor.registerMessageHandler("RT", (e2, t3) => this._getWorkerSource(e2, t3.type, t3.source).reloadTile(t3)), this.actor.registerMessageHandler("AT", (e2, t3) => this._getWorkerSource(e2, t3.type, t3.source).abortTile(t3)), this.actor.registerMessageHandler("RMT", (e2, t3) => this._getWorkerSource(e2, t3.type, t3.source).removeTile(t3)), this.actor.registerMessageHandler("RS", (t3, o2) => e._(this, void 0, void 0, function* () {
              if (!this.workerSources[t3] || !this.workerSources[t3][o2.type] || !this.workerSources[t3][o2.type][o2.source]) return;
              const e2 = this.workerSources[t3][o2.type][o2.source];
              delete this.workerSources[t3][o2.type][o2.source], void 0 !== e2.removeSource && e2.removeSource(o2);
            })), this.actor.registerMessageHandler("RM", (t3) => e._(this, void 0, void 0, function* () {
              delete this.layerIndexes[t3], delete this.availableImages[t3], delete this.workerSources[t3], delete this.demWorkerSources[t3], this.globalStates.delete(t3);
            })), this.actor.registerMessageHandler("SR", (t3, o2) => e._(this, void 0, void 0, function* () {
              this.referrer = o2;
            })), this.actor.registerMessageHandler("SRPS", (e2, t3) => this._syncRTLPluginState(e2, t3)), this.actor.registerMessageHandler("IS", (t3, o2) => e._(this, void 0, void 0, function* () {
              this.self.importScripts(o2);
            })), this.actor.registerMessageHandler("SI", (e2, t3) => this._setImages(e2, t3)), this.actor.registerMessageHandler("UL", (t3, o2) => e._(this, void 0, void 0, function* () {
              this._getLayerIndex(t3).update(o2.layers, o2.removedIds, this._getGlobalState(t3));
            })), this.actor.registerMessageHandler("UGS", (t3, o2) => e._(this, void 0, void 0, function* () {
              const e2 = this._getGlobalState(t3);
              for (const t4 in o2) e2[t4] = o2[t4];
            })), this.actor.registerMessageHandler("SL", (t3, o2) => e._(this, void 0, void 0, function* () {
              this._getLayerIndex(t3).replace(o2, this._getGlobalState(t3));
            }));
          }
          _getGlobalState(e2) {
            let t2 = this.globalStates.get(e2);
            return t2 || (t2 = {}, this.globalStates.set(e2, t2)), t2;
          }
          _setImages(t2, o2) {
            return e._(this, void 0, void 0, function* () {
              this.availableImages[t2] = o2;
              for (const e2 in this.workerSources[t2]) {
                const i2 = this.workerSources[t2][e2];
                for (const e3 in i2) i2[e3].availableImages = o2;
              }
            });
          }
          _syncRTLPluginState(t2, o2) {
            return e._(this, void 0, void 0, function* () {
              return yield e.d5.syncState(o2, this.self.importScripts);
            });
          }
          _getAvailableImages(e2) {
            let t2 = this.availableImages[e2];
            return t2 || (t2 = []), t2;
          }
          _getLayerIndex(e2) {
            let o2 = this.layerIndexes[e2];
            return o2 || (o2 = this.layerIndexes[e2] = new t()), o2;
          }
          _getWorkerSource(e2, t2, o2) {
            if (this.workerSources[e2] || (this.workerSources[e2] = {}), this.workerSources[e2][t2] || (this.workerSources[e2][t2] = {}), !this.workerSources[e2][t2][o2]) {
              const i2 = { sendAsync: (t3, o3) => (t3.targetMapId = e2, this.actor.sendAsync(t3, o3)) };
              switch (t2) {
                case "vector":
                  this.workerSources[e2][t2][o2] = new h(i2, this._getLayerIndex(e2), this._getAvailableImages(e2));
                  break;
                case "geojson":
                  this.workerSources[e2][t2][o2] = new Q(i2, this._getLayerIndex(e2), this._getAvailableImages(e2));
                  break;
                default:
                  this.workerSources[e2][t2][o2] = new this.externalWorkerSourceTypes[t2](i2, this._getLayerIndex(e2), this._getAvailableImages(e2));
              }
            }
            return this.workerSources[e2][t2][o2];
          }
          _getDEMWorkerSource(e2, t2) {
            return this.demWorkerSources[e2] || (this.demWorkerSources[e2] = {}), this.demWorkerSources[e2][t2] || (this.demWorkerSources[e2][t2] = new u()), this.demWorkerSources[e2][t2];
          }
        }
        return e.i(self) && (self.worker = new te(self)), te;
      });
      define("index", ["exports", "./shared"], function(e, t) {
        var i = "5.14.0";
        function a() {
          var e2 = new t.A(4);
          return t.A != Float32Array && (e2[1] = 0, e2[2] = 0), e2[0] = 1, e2[3] = 1, e2;
        }
        let r, o, s;
        const n = { frame(e2, i2, a2) {
          const r2 = requestAnimationFrame((e3) => {
            o2(), i2(e3);
          }), { unsubscribe: o2 } = t.s(e2.signal, "abort", () => {
            o2(), cancelAnimationFrame(r2), a2(new t.a(e2.signal.reason));
          }, false);
        }, frameAsync(e2) {
          return new Promise((t2, i2) => {
            this.frame(e2, t2, i2);
          });
        }, getImageData(e2, t2 = 0) {
          return this.getImageCanvasContext(e2).getImageData(-t2, -t2, e2.width + 2 * t2, e2.height + 2 * t2);
        }, getImageCanvasContext(e2) {
          const t2 = window.document.createElement("canvas"), i2 = t2.getContext("2d", { willReadFrequently: true });
          if (!i2) throw new Error("failed to create canvas 2d context");
          return t2.width = e2.width, t2.height = e2.height, i2.drawImage(e2, 0, 0, e2.width, e2.height), i2;
        }, resolveURL: (e2) => (r || (r = document.createElement("a")), r.href = e2, r.href), hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4, get prefersReducedMotion() {
          return void 0 !== s ? s : !!matchMedia && (null == o && (o = matchMedia("(prefers-reduced-motion: reduce)")), o.matches);
        }, set prefersReducedMotion(e2) {
          s = e2;
        } }, l = new class {
          constructor() {
            this._realTime = "undefined" != typeof performance && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date), this._frozenAt = null;
          }
          getCurrentTime() {
            return null !== this._frozenAt ? this._frozenAt : this._realTime();
          }
          setNow(e2) {
            this._frozenAt = e2;
          }
          restoreNow() {
            this._frozenAt = null;
          }
          isFrozen() {
            return null !== this._frozenAt;
          }
        }();
        function c() {
          return l.getCurrentTime();
        }
        class h {
          static testProp(e2) {
            if (!h.docStyle) return e2[0];
            for (let t2 = 0; t2 < e2.length; t2++) if (e2[t2] in h.docStyle) return e2[t2];
            return e2[0];
          }
          static create(e2, t2, i2) {
            const a2 = window.document.createElement(e2);
            return void 0 !== t2 && (a2.className = t2), i2 && i2.appendChild(a2), a2;
          }
          static createNS(e2, t2) {
            return window.document.createElementNS(e2, t2);
          }
          static disableDrag() {
            h.docStyle && h.selectProp && (h.userSelect = h.docStyle[h.selectProp], h.docStyle[h.selectProp] = "none");
          }
          static enableDrag() {
            h.docStyle && h.selectProp && (h.docStyle[h.selectProp] = h.userSelect);
          }
          static setTransform(e2, t2) {
            e2.style[h.transformProp] = t2;
          }
          static addEventListener(e2, t2, i2, a2 = {}) {
            e2.addEventListener(t2, i2, "passive" in a2 ? a2 : a2.capture);
          }
          static removeEventListener(e2, t2, i2, a2 = {}) {
            e2.removeEventListener(t2, i2, "passive" in a2 ? a2 : a2.capture);
          }
          static suppressClickInternal(e2) {
            e2.preventDefault(), e2.stopPropagation(), window.removeEventListener("click", h.suppressClickInternal, true);
          }
          static suppressClick() {
            window.addEventListener("click", h.suppressClickInternal, true), window.setTimeout(() => {
              window.removeEventListener("click", h.suppressClickInternal, true);
            }, 0);
          }
          static getScale(e2) {
            const t2 = e2.getBoundingClientRect();
            return { x: t2.width / e2.offsetWidth || 1, y: t2.height / e2.offsetHeight || 1, boundingClientRect: t2 };
          }
          static getPoint(e2, i2, a2) {
            const r2 = i2.boundingClientRect;
            return new t.P((a2.clientX - r2.left) / i2.x - e2.clientLeft, (a2.clientY - r2.top) / i2.y - e2.clientTop);
          }
          static mousePos(e2, t2) {
            const i2 = h.getScale(e2);
            return h.getPoint(e2, i2, t2);
          }
          static touchPos(e2, t2) {
            const i2 = [], a2 = h.getScale(e2);
            for (let r2 = 0; r2 < t2.length; r2++) i2.push(h.getPoint(e2, a2, t2[r2]));
            return i2;
          }
          static mouseButton(e2) {
            return e2.button;
          }
          static remove(e2) {
            e2.parentNode && e2.parentNode.removeChild(e2);
          }
          static sanitize(e2) {
            const t2 = new DOMParser().parseFromString(e2, "text/html").body || document.createElement("body"), i2 = t2.querySelectorAll("script");
            for (const e3 of i2) e3.remove();
            return h.clean(t2), t2.innerHTML;
          }
          static isPossiblyDangerous(e2, t2) {
            const i2 = t2.replace(/\s+/g, "").toLowerCase();
            return !(!["src", "href", "xlink:href"].includes(e2) || !i2.includes("javascript:") && !i2.includes("data:")) || !!e2.startsWith("on") || void 0;
          }
          static clean(e2) {
            const t2 = e2.children;
            for (const e3 of t2) h.removeAttributes(e3), h.clean(e3);
          }
          static removeAttributes(e2) {
            for (const { name: t2, value: i2 } of e2.attributes) h.isPossiblyDangerous(t2, i2) && e2.removeAttribute(t2);
          }
        }
        h.docStyle = "undefined" != typeof window && window.document && window.document.documentElement.style, h.selectProp = h.testProp(["userSelect", "MozUserSelect", "WebkitUserSelect", "msUserSelect"]), h.transformProp = h.testProp(["transform", "WebkitTransform"]);
        const u = { supported: false, testSupport: function(e2) {
          !p && _ && (m ? f(e2) : d = e2);
        } };
        let d, _, p = false, m = false;
        function f(e2) {
          const t2 = e2.createTexture();
          e2.bindTexture(e2.TEXTURE_2D, t2);
          try {
            if (e2.texImage2D(e2.TEXTURE_2D, 0, e2.RGBA, e2.RGBA, e2.UNSIGNED_BYTE, _), e2.isContextLost()) return;
            u.supported = true;
          } catch (e3) {
          }
          e2.deleteTexture(t2), p = true;
        }
        var g;
        "undefined" != typeof document && (_ = document.createElement("img"), _.onload = () => {
          d && f(d), d = null, m = true;
        }, _.onerror = () => {
          p = true, d = null;
        }, _.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(e2) {
          let i2, a2, r2, o2;
          e2.resetRequestQueue = () => {
            i2 = [], a2 = 0, r2 = 0, o2 = {};
          }, e2.addThrottleControl = (e3) => {
            const t2 = r2++;
            return o2[t2] = e3, t2;
          }, e2.removeThrottleControl = (e3) => {
            delete o2[e3], n2();
          }, e2.getImage = (e3, a3, r3 = true) => new Promise((o3, s3) => {
            u.supported && (e3.headers || (e3.headers = {}), e3.headers.accept = "image/webp,*/*"), t.e(e3, { type: "image" }), i2.push({ abortController: a3, requestParameters: e3, supportImageRefresh: r3, state: "queued", onError: (e4) => {
              s3(e4);
            }, onSuccess: (e4) => {
              o3(e4);
            } }), n2();
          });
          const s2 = (e3) => t._(this, void 0, void 0, function* () {
            e3.state = "running";
            const { requestParameters: i3, supportImageRefresh: r3, onError: o3, onSuccess: s3, abortController: c2 } = e3, h2 = false === r3 && !t.i(self) && !t.g(i3.url) && (!i3.headers || Object.keys(i3.headers).reduce((e4, t2) => e4 && "accept" === t2, true));
            a2++;
            const u2 = h2 ? l2(i3, c2) : t.m(i3, c2);
            try {
              const i4 = yield u2;
              delete e3.abortController, e3.state = "completed", i4.data instanceof HTMLImageElement || t.b(i4.data) ? s3(i4) : i4.data && s3({ data: yield (d2 = i4.data, "function" == typeof createImageBitmap ? t.f(d2) : t.h(d2)), cacheControl: i4.cacheControl, expires: i4.expires });
            } catch (t2) {
              delete e3.abortController, o3(t2);
            } finally {
              a2--, n2();
            }
            var d2;
          }), n2 = () => {
            const e3 = (() => {
              for (const e4 of Object.keys(o2)) if (o2[e4]()) return true;
              return false;
            })() ? t.c.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : t.c.MAX_PARALLEL_IMAGE_REQUESTS;
            for (let t2 = a2; t2 < e3 && i2.length > 0; t2++) {
              const e4 = i2.shift();
              e4.abortController.signal.aborted ? t2-- : s2(e4);
            }
          }, l2 = (e3, i3) => new Promise((a3, r3) => {
            const o3 = new Image(), s3 = e3.url, n3 = e3.credentials;
            n3 && "include" === n3 ? o3.crossOrigin = "use-credentials" : (n3 && "same-origin" === n3 || !t.d(s3)) && (o3.crossOrigin = "anonymous"), i3.signal.addEventListener("abort", () => {
              o3.src = "", r3(new t.a(i3.signal.reason));
            }), o3.fetchPriority = "high", o3.onload = () => {
              o3.onerror = o3.onload = null, a3({ data: o3 });
            }, o3.onerror = () => {
              o3.onerror = o3.onload = null, i3.signal.aborted || r3(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
            }, o3.src = s3;
          });
        }(g || (g = {})), g.resetRequestQueue();
        class v {
          constructor(e2) {
            this._transformRequestFn = null != e2 ? e2 : null;
          }
          transformRequest(e2, t2) {
            return this._transformRequestFn && this._transformRequestFn(e2, t2) || { url: e2 };
          }
          setTransformRequest(e2) {
            this._transformRequestFn = e2;
          }
        }
        function x(e2) {
          const t2 = [];
          if ("string" == typeof e2) t2.push({ id: "default", url: e2 });
          else if (e2 && e2.length > 0) {
            const i2 = [];
            for (const { id: a2, url: r2 } of e2) {
              const e3 = `${a2}${r2}`;
              -1 === i2.indexOf(e3) && (i2.push(e3), t2.push({ id: a2, url: r2 }));
            }
          }
          return t2;
        }
        function b(e2, t2, i2) {
          try {
            const a2 = new URL(e2);
            return a2.pathname += `${t2}${i2}`, a2.toString();
          } catch (t3) {
            throw new Error(`Invalid sprite URL "${e2}", must be absolute. Modify style specification directly or use TransformStyleFunction to correct the issue dynamically`);
          }
        }
        function y(e2) {
          const { userImage: t2 } = e2;
          return !!(t2 && t2.render && t2.render()) && (e2.data.replace(new Uint8Array(t2.data.buffer)), true);
        }
        class w extends t.E {
          constructor() {
            super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = false, this.requestors = [], this.patterns = {}, this.atlasImage = new t.R({ width: 1, height: 1 }), this.dirty = true;
          }
          destroy() {
            this.atlasTexture && (this.atlasTexture.destroy(), this.atlasTexture = null);
            for (const e2 of Object.keys(this.images)) this.removeImage(e2);
            this.patterns = {}, this.atlasImage = new t.R({ width: 1, height: 1 }), this.dirty = true;
          }
          isLoaded() {
            return this.loaded;
          }
          setLoaded(e2) {
            if (this.loaded !== e2 && (this.loaded = e2, e2)) {
              for (const { ids: e3, promiseResolve: t2 } of this.requestors) t2(this._getImagesForIds(e3));
              this.requestors = [];
            }
          }
          getImage(e2) {
            const i2 = this.images[e2];
            if (i2 && !i2.data && i2.spriteData) {
              const e3 = i2.spriteData;
              i2.data = new t.R({ width: e3.width, height: e3.height }, e3.context.getImageData(e3.x, e3.y, e3.width, e3.height).data), i2.spriteData = null;
            }
            return i2;
          }
          addImage(e2, t2) {
            if (this.images[e2]) throw new Error(`Image id ${e2} already exist, use updateImage instead`);
            this._validate(e2, t2) && (this.images[e2] = t2);
          }
          _validate(e2, i2) {
            let a2 = true;
            const r2 = i2.data || i2.spriteData;
            return this._validateStretch(i2.stretchX, r2 && r2.width) || (this.fire(new t.k(new Error(`Image "${e2}" has invalid "stretchX" value`))), a2 = false), this._validateStretch(i2.stretchY, r2 && r2.height) || (this.fire(new t.k(new Error(`Image "${e2}" has invalid "stretchY" value`))), a2 = false), this._validateContent(i2.content, i2) || (this.fire(new t.k(new Error(`Image "${e2}" has invalid "content" value`))), a2 = false), a2;
          }
          _validateStretch(e2, t2) {
            if (!e2) return true;
            let i2 = 0;
            for (const a2 of e2) {
              if (a2[0] < i2 || a2[1] < a2[0] || t2 < a2[1]) return false;
              i2 = a2[1];
            }
            return true;
          }
          _validateContent(e2, t2) {
            if (!e2) return true;
            if (4 !== e2.length) return false;
            const i2 = t2.spriteData, a2 = i2 && i2.width || t2.data.width, r2 = i2 && i2.height || t2.data.height;
            return !(e2[0] < 0 || a2 < e2[0] || e2[1] < 0 || r2 < e2[1] || e2[2] < 0 || a2 < e2[2] || e2[3] < 0 || r2 < e2[3] || e2[2] < e2[0] || e2[3] < e2[1]);
          }
          updateImage(e2, t2, i2 = true) {
            const a2 = this.getImage(e2);
            if (i2 && (a2.data.width !== t2.data.width || a2.data.height !== t2.data.height)) throw new Error(`size mismatch between old image (${a2.data.width}x${a2.data.height}) and new image (${t2.data.width}x${t2.data.height}).`);
            t2.version = a2.version + 1, this.images[e2] = t2, this.updatedImages[e2] = true;
          }
          removeImage(e2) {
            const t2 = this.images[e2];
            delete this.images[e2], delete this.patterns[e2], t2.userImage && t2.userImage.onRemove && t2.userImage.onRemove();
          }
          listImages() {
            return Object.keys(this.images);
          }
          getImages(e2) {
            return new Promise((t2, i2) => {
              let a2 = true;
              if (!this.isLoaded()) for (const t3 of e2) this.images[t3] || (a2 = false);
              this.isLoaded() || a2 ? t2(this._getImagesForIds(e2)) : this.requestors.push({ ids: e2, promiseResolve: t2 });
            });
          }
          _getImagesForIds(e2) {
            const i2 = {};
            for (const a2 of e2) {
              let e3 = this.getImage(a2);
              e3 || (this.fire(new t.l("styleimagemissing", { id: a2 })), e3 = this.getImage(a2)), e3 ? i2[a2] = { data: e3.data.clone(), pixelRatio: e3.pixelRatio, sdf: e3.sdf, version: e3.version, stretchX: e3.stretchX, stretchY: e3.stretchY, content: e3.content, textFitWidth: e3.textFitWidth, textFitHeight: e3.textFitHeight, hasRenderCallback: Boolean(e3.userImage && e3.userImage.render) } : t.w(`Image "${a2}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
            }
            return i2;
          }
          getPixelSize() {
            const { width: e2, height: t2 } = this.atlasImage;
            return { width: e2, height: t2 };
          }
          getPattern(e2) {
            const i2 = this.patterns[e2], a2 = this.getImage(e2);
            if (!a2) return null;
            if (i2 && i2.position.version === a2.version) return i2.position;
            if (i2) i2.position.version = a2.version;
            else {
              const i3 = { w: a2.data.width + 2, h: a2.data.height + 2, x: 0, y: 0 }, r2 = new t.I(i3, a2);
              this.patterns[e2] = { bin: i3, position: r2 };
            }
            return this._updatePatternAtlas(), this.patterns[e2].position;
          }
          bind(e2) {
            const i2 = e2.gl;
            this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = false) : this.atlasTexture = new t.T(e2, this.atlasImage, i2.RGBA), this.atlasTexture.bind(i2.LINEAR, i2.CLAMP_TO_EDGE);
          }
          _updatePatternAtlas() {
            const e2 = [];
            for (const t2 in this.patterns) e2.push(this.patterns[t2].bin);
            const { w: i2, h: a2 } = t.p(e2), r2 = this.atlasImage;
            r2.resize({ width: i2 || 1, height: a2 || 1 });
            for (const e3 in this.patterns) {
              const { bin: i3 } = this.patterns[e3], a3 = i3.x + 1, o2 = i3.y + 1, s2 = this.getImage(e3).data, n2 = s2.width, l2 = s2.height;
              t.R.copy(s2, r2, { x: 0, y: 0 }, { x: a3, y: o2 }, { width: n2, height: l2 }), t.R.copy(s2, r2, { x: 0, y: l2 - 1 }, { x: a3, y: o2 - 1 }, { width: n2, height: 1 }), t.R.copy(s2, r2, { x: 0, y: 0 }, { x: a3, y: o2 + l2 }, { width: n2, height: 1 }), t.R.copy(s2, r2, { x: n2 - 1, y: 0 }, { x: a3 - 1, y: o2 }, { width: 1, height: l2 }), t.R.copy(s2, r2, { x: 0, y: 0 }, { x: a3 + n2, y: o2 }, { width: 1, height: l2 });
            }
            this.dirty = true;
          }
          beginFrame() {
            this.callbackDispatchedThisFrame = {};
          }
          dispatchRenderCallbacks(e2) {
            for (const i2 of e2) {
              if (this.callbackDispatchedThisFrame[i2]) continue;
              this.callbackDispatchedThisFrame[i2] = true;
              const e3 = this.getImage(i2);
              e3 || t.w(`Image with ID: "${i2}" was not found`), y(e3) && this.updateImage(i2, e3);
            }
          }
          cloneImages() {
            const e2 = {};
            for (const t2 in this.images) {
              const i2 = this.images[t2];
              e2[t2] = Object.assign(Object.assign({}, i2), { data: i2.data ? i2.data.clone() : null });
            }
            return e2;
          }
        }
        const T = 1e20;
        function P(e2, t2, i2, a2, r2, o2, s2, n2, l2) {
          for (let c2 = t2; c2 < t2 + a2; c2++) I(e2, i2 * o2 + c2, o2, r2, s2, n2, l2);
          for (let c2 = i2; c2 < i2 + r2; c2++) I(e2, c2 * o2 + t2, 1, a2, s2, n2, l2);
        }
        function I(e2, t2, i2, a2, r2, o2, s2) {
          o2[0] = 0, s2[0] = -1e20, s2[1] = T, r2[0] = e2[t2];
          for (let n2 = 1, l2 = 0, c2 = 0; n2 < a2; n2++) {
            r2[n2] = e2[t2 + n2 * i2];
            const a3 = n2 * n2;
            do {
              const e3 = o2[l2];
              c2 = (r2[n2] - r2[e3] + a3 - e3 * e3) / (n2 - e3) / 2;
            } while (c2 <= s2[l2] && --l2 > -1);
            l2++, o2[l2] = n2, s2[l2] = c2, s2[l2 + 1] = T;
          }
          for (let n2 = 0, l2 = 0; n2 < a2; n2++) {
            for (; s2[l2 + 1] < n2; ) l2++;
            const a3 = o2[l2], c2 = n2 - a3;
            e2[t2 + n2 * i2] = r2[a3] + c2 * c2;
          }
        }
        const C = t.v.layout_symbol["text-font"].default.join(",");
        class M {
          constructor(e2, t2, i2) {
            this.requestManager = e2, this.localIdeographFontFamily = t2, this.entries = {}, this.lang = i2;
          }
          setURL(e2) {
            this.url = e2;
          }
          getGlyphs(e2) {
            return t._(this, void 0, void 0, function* () {
              const t2 = [];
              for (const i3 in e2) for (const a3 of e2[i3]) t2.push(this._getAndCacheGlyphsPromise(i3, a3));
              const i2 = yield Promise.all(t2), a2 = {};
              for (const { stack: e3, id: t3, glyph: r2 } of i2) a2[e3] || (a2[e3] = {}), a2[e3][t3] = r2 && { id: r2.id, bitmap: r2.bitmap.clone(), metrics: r2.metrics };
              return a2;
            });
          }
          _getAndCacheGlyphsPromise(e2, i2) {
            return t._(this, void 0, void 0, function* () {
              let t2 = this.entries[e2];
              t2 || (t2 = this.entries[e2] = { glyphs: {}, requests: {}, ranges: {} });
              let a2 = t2.glyphs[i2];
              return void 0 !== a2 ? { stack: e2, id: i2, glyph: a2 } : !this.url || this._charUsesLocalIdeographFontFamily(i2) ? (a2 = t2.glyphs[i2] = this._drawGlyph(t2, e2, i2), { stack: e2, id: i2, glyph: a2 }) : yield this._downloadAndCacheRangePromise(e2, i2);
            });
          }
          _downloadAndCacheRangePromise(e2, i2) {
            return t._(this, void 0, void 0, function* () {
              const t2 = this.entries[e2], a2 = Math.floor(i2 / 256);
              if (t2.ranges[a2]) return { stack: e2, id: i2, glyph: null };
              if (!t2.requests[a2]) {
                const i3 = M.loadGlyphRange(e2, a2, this.url, this.requestManager);
                t2.requests[a2] = i3;
              }
              try {
                const r2 = yield t2.requests[a2];
                for (const e3 in r2) t2.glyphs[+e3] = r2[+e3];
                return t2.ranges[a2] = true, { stack: e2, id: i2, glyph: r2[i2] || null };
              } catch (r2) {
                const o2 = t2.glyphs[i2] = this._drawGlyph(t2, e2, i2);
                return this._warnOnMissingGlyphRange(o2, a2, i2, r2), { stack: e2, id: i2, glyph: o2 };
              }
            });
          }
          _warnOnMissingGlyphRange(e2, i2, a2, r2) {
            const o2 = 256 * i2, s2 = o2 + 255, n2 = a2.toString(16).padStart(4, "0").toUpperCase();
            t.w(`Unable to load glyph range ${i2}, ${o2}-${s2}. Rendering codepoint U+${n2} locally instead. ${r2}`);
          }
          _charUsesLocalIdeographFontFamily(e2) {
            return !!this.localIdeographFontFamily && t.q(e2);
          }
          _drawGlyph(e2, i2, a2) {
            const r2 = i2 === C && "" !== this.localIdeographFontFamily && this._charUsesLocalIdeographFontFamily(a2), o2 = r2 ? "ideographTinySDF" : "tinySDF";
            e2[o2] || (e2[o2] = this._createTinySDF(r2 ? this.localIdeographFontFamily : i2));
            const s2 = e2[o2].draw(String.fromCodePoint(a2));
            return { id: a2, bitmap: new t.r({ width: s2.width || 60, height: s2.height || 60 }, s2.data), metrics: { width: s2.glyphWidth / 2 || 24, height: s2.glyphHeight / 2 || 24, left: s2.glyphLeft / 2 + 0.5 || 0, top: s2.glyphTop / 2 - 27.5 || -8, advance: s2.glyphAdvance / 2 || 24, isDoubleResolution: true } };
          }
          _createTinySDF(e2) {
            const t2 = e2 ? e2.split(",") : [];
            t2.push("sans-serif");
            const i2 = t2.map((e3) => /[-\w]+/.test(e3) ? e3 : `'${CSS.escape(e3)}'`).join(",");
            return new M.TinySDF({ fontSize: 48, buffer: 6, radius: 16, cutoff: 0.25, fontFamily: i2, fontWeight: this._fontWeight(t2[0]), fontStyle: this._fontStyle(t2[0]), lang: this.lang });
          }
          _fontStyle(e2) {
            return /italic/i.test(e2) ? "italic" : /oblique/i.test(e2) ? "oblique" : "normal";
          }
          _fontWeight(e2) {
            const t2 = { thin: 100, hairline: 100, "extra light": 200, "ultra light": 200, light: 300, normal: 400, regular: 400, medium: 500, semibold: 600, demibold: 600, bold: 700, "extra bold": 800, "ultra bold": 800, black: 900, heavy: 900, "extra black": 950, "ultra black": 950 };
            let i2;
            for (const [a2, r2] of Object.entries(t2)) new RegExp(`\\b${a2}\\b`, "i").test(e2) && (i2 = `${r2}`);
            return i2;
          }
          destroy() {
            for (const e2 in this.entries) {
              const t2 = this.entries[e2];
              t2.tinySDF && (t2.tinySDF = null), t2.ideographTinySDF && (t2.ideographTinySDF = null), t2.glyphs = {}, t2.requests = {}, t2.ranges = {};
            }
            this.entries = {};
          }
        }
        M.loadGlyphRange = function(e2, i2, a2, r2) {
          return t._(this, void 0, void 0, function* () {
            const o2 = 256 * i2, s2 = o2 + 255, n2 = r2.transformRequest(a2.replace("{fontstack}", e2).replace("{range}", `${o2}-${s2}`), "Glyphs"), l2 = yield t.n(n2, new AbortController());
            if (!l2 || !l2.data) throw new Error(`Could not load glyph range. range: ${i2}, ${o2}-${s2}`);
            const c2 = {};
            for (const e3 of t.o(l2.data)) c2[e3.id] = e3;
            return c2;
          });
        }, M.TinySDF = class {
          constructor({ fontSize: e2 = 24, buffer: t2 = 3, radius: i2 = 8, cutoff: a2 = 0.25, fontFamily: r2 = "sans-serif", fontWeight: o2 = "normal", fontStyle: s2 = "normal", lang: n2 = null } = {}) {
            this.buffer = t2, this.cutoff = a2, this.radius = i2, this.lang = n2;
            const l2 = this.size = e2 + 4 * t2, c2 = this._createCanvas(l2), h2 = this.ctx = c2.getContext("2d", { willReadFrequently: true });
            h2.font = `${s2} ${o2} ${e2}px ${r2}`, h2.textBaseline = "alphabetic", h2.textAlign = "left", h2.fillStyle = "black", this.gridOuter = new Float64Array(l2 * l2), this.gridInner = new Float64Array(l2 * l2), this.f = new Float64Array(l2), this.z = new Float64Array(l2 + 1), this.v = new Uint16Array(l2);
          }
          _createCanvas(e2) {
            const t2 = document.createElement("canvas");
            return t2.width = t2.height = e2, t2;
          }
          draw(e2) {
            const { width: t2, actualBoundingBoxAscent: i2, actualBoundingBoxDescent: a2, actualBoundingBoxLeft: r2, actualBoundingBoxRight: o2 } = this.ctx.measureText(e2), s2 = Math.ceil(i2), n2 = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(o2 - r2))), l2 = Math.min(this.size - this.buffer, s2 + Math.ceil(a2)), c2 = n2 + 2 * this.buffer, h2 = l2 + 2 * this.buffer, u2 = Math.max(c2 * h2, 0), d2 = new Uint8ClampedArray(u2), _2 = { data: d2, width: c2, height: h2, glyphWidth: n2, glyphHeight: l2, glyphTop: s2, glyphLeft: 0, glyphAdvance: t2 };
            if (0 === n2 || 0 === l2) return _2;
            const { ctx: p2, buffer: m2, gridInner: f2, gridOuter: g2 } = this;
            this.lang && (p2.lang = this.lang), p2.clearRect(m2, m2, n2, l2), p2.fillText(e2, m2, m2 + s2);
            const v2 = p2.getImageData(m2, m2, n2, l2);
            g2.fill(T, 0, u2), f2.fill(0, 0, u2);
            for (let e3 = 0; e3 < l2; e3++) for (let t3 = 0; t3 < n2; t3++) {
              const i3 = v2.data[4 * (e3 * n2 + t3) + 3] / 255;
              if (0 === i3) continue;
              const a3 = (e3 + m2) * c2 + t3 + m2;
              if (1 === i3) g2[a3] = 0, f2[a3] = T;
              else {
                const e4 = 0.5 - i3;
                g2[a3] = e4 > 0 ? e4 * e4 : 0, f2[a3] = e4 < 0 ? e4 * e4 : 0;
              }
            }
            P(g2, 0, 0, c2, h2, c2, this.f, this.v, this.z), P(f2, m2, m2, n2, l2, c2, this.f, this.v, this.z);
            for (let e3 = 0; e3 < u2; e3++) {
              const t3 = Math.sqrt(g2[e3]) - Math.sqrt(f2[e3]);
              d2[e3] = Math.round(255 - 255 * (t3 / this.radius + this.cutoff));
            }
            return _2;
          }
        };
        class E {
          constructor() {
            this.specification = t.u.light.position;
          }
          possiblyEvaluate(e2, i2) {
            return t.F(e2.expression.evaluate(i2));
          }
          interpolate(e2, i2, a2) {
            return { x: t.G.number(e2.x, i2.x, a2), y: t.G.number(e2.y, i2.y, a2), z: t.G.number(e2.z, i2.z, a2) };
          }
        }
        let S;
        class R extends t.E {
          constructor(e2) {
            super(), S = S || new t.t({ anchor: new t.D(t.u.light.anchor), position: new E(), color: new t.D(t.u.light.color), intensity: new t.D(t.u.light.intensity) }), this._transitionable = new t.x(S, void 0), this.setLight(e2), this._transitioning = this._transitionable.untransitioned();
          }
          getLight() {
            return this._transitionable.serialize();
          }
          setLight(e2, i2 = {}) {
            if (!this._validate(t.y, e2, i2)) for (const i3 in e2) {
              const a2 = e2[i3];
              i3.endsWith(t.z) ? this._transitionable.setTransition(i3.slice(0, -t.z.length), a2) : this._transitionable.setValue(i3, a2);
            }
          }
          updateTransitions(e2) {
            this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
          }
          hasTransition() {
            return this._transitioning.hasTransition();
          }
          recalculate(e2) {
            this.properties = this._transitioning.possiblyEvaluate(e2);
          }
          _validate(e2, i2, a2) {
            return (!a2 || false !== a2.validate) && t.B(this, e2.call(t.C, { value: i2, style: { glyphs: true, sprite: true }, styleSpec: t.u }));
          }
        }
        const z = new t.t({ "sky-color": new t.D(t.u.sky["sky-color"]), "horizon-color": new t.D(t.u.sky["horizon-color"]), "fog-color": new t.D(t.u.sky["fog-color"]), "fog-ground-blend": new t.D(t.u.sky["fog-ground-blend"]), "horizon-fog-blend": new t.D(t.u.sky["horizon-fog-blend"]), "sky-horizon-blend": new t.D(t.u.sky["sky-horizon-blend"]), "atmosphere-blend": new t.D(t.u.sky["atmosphere-blend"]) });
        class D extends t.E {
          constructor(e2) {
            super(), this._transitionable = new t.x(z, void 0), this.setSky(e2), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new t.H(0));
          }
          setSky(e2, i2 = {}) {
            if (!this._validate(t.J, e2, i2)) {
              e2 || (e2 = { "sky-color": "transparent", "horizon-color": "transparent", "fog-color": "transparent", "fog-ground-blend": 1, "atmosphere-blend": 0 });
              for (const i3 in e2) {
                const a2 = e2[i3];
                i3.endsWith(t.z) ? this._transitionable.setTransition(i3.slice(0, -t.z.length), a2) : this._transitionable.setValue(i3, a2);
              }
            }
          }
          getSky() {
            return this._transitionable.serialize();
          }
          updateTransitions(e2) {
            this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
          }
          hasTransition() {
            return this._transitioning.hasTransition();
          }
          recalculate(e2) {
            this.properties = this._transitioning.possiblyEvaluate(e2);
          }
          _validate(e2, i2, a2 = {}) {
            return false !== (null == a2 ? void 0 : a2.validate) && t.B(this, e2.call(t.C, t.e({ value: i2, style: { glyphs: true, sprite: true }, styleSpec: t.u })));
          }
          calculateFogBlendOpacity(e2) {
            return e2 < 60 ? 0 : e2 < 70 ? (e2 - 60) / 10 : 1;
          }
        }
        class A {
          constructor(e2, t2) {
            this.width = e2, this.height = t2, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
          }
          getDash(e2, t2) {
            const i2 = e2.join(",") + String(t2);
            return this.dashEntry[i2] || (this.dashEntry[i2] = this.addDash(e2, t2)), this.dashEntry[i2];
          }
          getDashRanges(e2, t2, i2) {
            const a2 = [];
            let r2 = e2.length % 2 == 1 ? -e2[e2.length - 1] * i2 : 0, o2 = e2[0] * i2, s2 = true;
            a2.push({ left: r2, right: o2, isDash: s2, zeroLength: 0 === e2[0] });
            let n2 = e2[0];
            for (let t3 = 1; t3 < e2.length; t3++) {
              s2 = !s2;
              const l2 = e2[t3];
              r2 = n2 * i2, n2 += l2, o2 = n2 * i2, a2.push({ left: r2, right: o2, isDash: s2, zeroLength: 0 === l2 });
            }
            return a2;
          }
          addRoundDash(e2, t2, i2) {
            const a2 = t2 / 2;
            for (let t3 = -i2; t3 <= i2; t3++) {
              const r2 = this.width * (this.nextRow + i2 + t3);
              let o2 = 0, s2 = e2[o2];
              for (let n2 = 0; n2 < this.width; n2++) {
                n2 / s2.right > 1 && (s2 = e2[++o2]);
                const l2 = Math.abs(n2 - s2.left), c2 = Math.abs(n2 - s2.right), h2 = Math.min(l2, c2);
                let u2;
                const d2 = t3 / i2 * (a2 + 1);
                if (s2.isDash) {
                  const e3 = a2 - Math.abs(d2);
                  u2 = Math.sqrt(h2 * h2 + e3 * e3);
                } else u2 = a2 - Math.sqrt(h2 * h2 + d2 * d2);
                this.data[r2 + n2] = Math.max(0, Math.min(255, u2 + 128));
              }
            }
          }
          addRegularDash(e2) {
            for (let t3 = e2.length - 1; t3 >= 0; --t3) {
              const i3 = e2[t3], a3 = e2[t3 + 1];
              i3.zeroLength ? e2.splice(t3, 1) : a3 && a3.isDash === i3.isDash && (a3.left = i3.left, e2.splice(t3, 1));
            }
            const t2 = e2[0], i2 = e2[e2.length - 1];
            t2.isDash === i2.isDash && (t2.left = i2.left - this.width, i2.right = t2.right + this.width);
            const a2 = this.width * this.nextRow;
            let r2 = 0, o2 = e2[r2];
            for (let t3 = 0; t3 < this.width; t3++) {
              t3 / o2.right > 1 && (o2 = e2[++r2]);
              const i3 = Math.abs(t3 - o2.left), s2 = Math.abs(t3 - o2.right), n2 = Math.min(i3, s2);
              this.data[a2 + t3] = Math.max(0, Math.min(255, (o2.isDash ? n2 : -n2) + 128));
            }
          }
          addDash(e2, i2) {
            const a2 = i2 ? 7 : 0, r2 = 2 * a2 + 1;
            if (this.nextRow + r2 > this.height) return t.w("LineAtlas out of space"), null;
            let o2 = 0;
            for (let t2 = 0; t2 < e2.length; t2++) o2 += e2[t2];
            if (0 !== o2) {
              const t2 = this.width / o2, r3 = this.getDashRanges(e2, this.width, t2);
              i2 ? this.addRoundDash(r3, t2, a2) : this.addRegularDash(r3);
            }
            const s2 = { y: this.nextRow + a2, height: 2 * a2, width: o2 };
            return this.nextRow += r2, this.dirty = true, s2;
          }
          bind(e2) {
            const t2 = e2.gl;
            this.texture ? (t2.bindTexture(t2.TEXTURE_2D, this.texture), this.dirty && (this.dirty = false, t2.texSubImage2D(t2.TEXTURE_2D, 0, 0, 0, this.width, this.height, t2.ALPHA, t2.UNSIGNED_BYTE, this.data))) : (this.texture = t2.createTexture(), t2.bindTexture(t2.TEXTURE_2D, this.texture), t2.texParameteri(t2.TEXTURE_2D, t2.TEXTURE_WRAP_S, t2.REPEAT), t2.texParameteri(t2.TEXTURE_2D, t2.TEXTURE_WRAP_T, t2.REPEAT), t2.texParameteri(t2.TEXTURE_2D, t2.TEXTURE_MIN_FILTER, t2.LINEAR), t2.texParameteri(t2.TEXTURE_2D, t2.TEXTURE_MAG_FILTER, t2.LINEAR), t2.texImage2D(t2.TEXTURE_2D, 0, t2.ALPHA, this.width, this.height, 0, t2.ALPHA, t2.UNSIGNED_BYTE, this.data));
          }
        }
        const L2 = "maplibre_preloaded_worker_pool";
        class k {
          constructor() {
            this.active = {};
          }
          acquire(e2) {
            if (!this.workers) for (this.workers = []; this.workers.length < k.workerCount; ) this.workers.push(new Worker(t.c.WORKER_URL));
            return this.active[e2] = true, this.workers.slice();
          }
          release(e2) {
            delete this.active[e2], 0 === this.numActive() && (this.workers.forEach((e3) => {
              e3.terminate();
            }), this.workers = null);
          }
          isPreloaded() {
            return !!this.active[L2];
          }
          numActive() {
            return Object.keys(this.active).length;
          }
        }
        const F = Math.floor(n.hardwareConcurrency / 2);
        let B, O;
        function j() {
          return B || (B = new k()), B;
        }
        k.workerCount = t.K(globalThis) ? Math.max(Math.min(F, 3), 1) : 1;
        class N {
          constructor(e2, i2) {
            this.workerPool = e2, this.actors = [], this.currentActor = 0, this.id = i2;
            const a2 = this.workerPool.acquire(i2);
            for (let e3 = 0; e3 < a2.length; e3++) {
              const r2 = new t.L(a2[e3], i2);
              r2.name = `Worker ${e3}`, this.actors.push(r2);
            }
            if (!this.actors.length) throw new Error("No actors found");
          }
          broadcast(e2, t2) {
            const i2 = [];
            for (const a2 of this.actors) i2.push(a2.sendAsync({ type: e2, data: t2 }));
            return Promise.all(i2);
          }
          getActor() {
            return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
          }
          remove(e2 = true) {
            this.actors.forEach((e3) => {
              e3.remove();
            }), this.actors = [], e2 && this.workerPool.release(this.id);
          }
          registerMessageHandler(e2, t2) {
            for (const i2 of this.actors) i2.registerMessageHandler(e2, t2);
          }
          unregisterMessageHandler(e2) {
            for (const t2 of this.actors) t2.unregisterMessageHandler(e2);
          }
        }
        function Z() {
          return O || (O = new N(j(), t.M), O.registerMessageHandler("GR", (e2, i2, a2) => t.m(i2, a2))), O;
        }
        function G(e2, i2) {
          const a2 = t.N();
          return t.O(a2, a2, [1, 1, 0]), t.Q(a2, a2, [0.5 * e2.width, 0.5 * e2.height, 1]), e2.calculatePosMatrix ? t.S(a2, a2, e2.calculatePosMatrix(i2.toUnwrapped())) : a2;
        }
        function U(e2, t2, i2, a2, r2, o2, s2) {
          var n2;
          const l2 = function(e3, t3, i3) {
            if (e3) for (const a3 of e3) {
              const e4 = t3[a3];
              if (e4 && e4.source === i3 && "fill-extrusion" === e4.type) return true;
            }
            else for (const e4 in t3) {
              const a3 = t3[e4];
              if (a3.source === i3 && "fill-extrusion" === a3.type) return true;
            }
            return false;
          }(null !== (n2 = null == r2 ? void 0 : r2.layers) && void 0 !== n2 ? n2 : null, t2, e2.id), c2 = o2.maxPitchScaleFactor(), h2 = e2.tilesIn(a2, c2, l2);
          h2.sort(V);
          const u2 = [];
          for (const a3 of h2) u2.push({ wrappedTileID: a3.tileID.wrapped().key, queryResults: a3.tile.queryRenderedFeatures(t2, i2, e2.getState(), a3.queryGeometry, a3.cameraQueryGeometry, a3.scale, r2, o2, c2, G(o2, a3.tileID), s2 ? (e3, t3) => s2(a3.tileID, e3, t3) : void 0) });
          return function(e3, t3) {
            for (const i3 in e3) for (const a3 of e3[i3]) q(a3, t3);
            return e3;
          }(function(e3) {
            const t3 = {}, i3 = {};
            for (const a3 of e3) {
              const e4 = a3.queryResults, r3 = a3.wrappedTileID, o3 = i3[r3] = i3[r3] || {};
              for (const i4 in e4) {
                const a4 = e4[i4], r4 = o3[i4] = o3[i4] || {}, s3 = t3[i4] = t3[i4] || [];
                for (const e5 of a4) r4[e5.featureIndex] || (r4[e5.featureIndex] = true, s3.push(e5));
              }
            }
            return t3;
          }(u2), e2);
        }
        function V(e2, t2) {
          const i2 = e2.tileID, a2 = t2.tileID;
          return i2.overscaledZ - a2.overscaledZ || i2.canonical.y - a2.canonical.y || i2.wrap - a2.wrap || i2.canonical.x - a2.canonical.x;
        }
        function q(e2, t2) {
          const i2 = e2.feature, a2 = t2.getFeatureState(i2.layer["source-layer"], i2.id);
          i2.source = i2.layer.source, i2.layer["source-layer"] && (i2.sourceLayer = i2.layer["source-layer"]), i2.state = a2;
        }
        function W(e2, i2, a2) {
          return t._(this, void 0, void 0, function* () {
            let r2 = e2;
            if (e2.url ? r2 = (yield t.j(i2.transformRequest(e2.url, "Source"), a2)).data : yield n.frameAsync(a2), !r2) return null;
            const o2 = t.U(t.e(r2, e2), ["tiles", "minzoom", "maxzoom", "attribution", "bounds", "scheme", "tileSize", "encoding"]);
            return "vector_layers" in r2 && r2.vector_layers && (o2.vectorLayerIds = r2.vector_layers.map((e3) => e3.id)), o2;
          });
        }
        class $ {
          constructor(e2, t2) {
            e2 && (t2 ? this.setSouthWest(e2).setNorthEast(t2) : Array.isArray(e2) && (4 === e2.length ? this.setSouthWest([e2[0], e2[1]]).setNorthEast([e2[2], e2[3]]) : this.setSouthWest(e2[0]).setNorthEast(e2[1])));
          }
          setNorthEast(e2) {
            return this._ne = e2 instanceof t.V ? new t.V(e2.lng, e2.lat) : t.V.convert(e2), this;
          }
          setSouthWest(e2) {
            return this._sw = e2 instanceof t.V ? new t.V(e2.lng, e2.lat) : t.V.convert(e2), this;
          }
          extend(e2) {
            const i2 = this._sw, a2 = this._ne;
            let r2, o2;
            if (e2 instanceof t.V) r2 = e2, o2 = e2;
            else {
              if (!(e2 instanceof $)) return Array.isArray(e2) ? 4 === e2.length || e2.every(Array.isArray) ? this.extend($.convert(e2)) : this.extend(t.V.convert(e2)) : e2 && ("lng" in e2 || "lon" in e2) && "lat" in e2 ? this.extend(t.V.convert(e2)) : this;
              if (r2 = e2._sw, o2 = e2._ne, !r2 || !o2) return this;
            }
            return i2 || a2 ? (i2.lng = Math.min(r2.lng, i2.lng), i2.lat = Math.min(r2.lat, i2.lat), a2.lng = Math.max(o2.lng, a2.lng), a2.lat = Math.max(o2.lat, a2.lat)) : (this._sw = new t.V(r2.lng, r2.lat), this._ne = new t.V(o2.lng, o2.lat)), this;
          }
          getCenter() {
            return new t.V((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
          }
          getSouthWest() {
            return this._sw;
          }
          getNorthEast() {
            return this._ne;
          }
          getNorthWest() {
            return new t.V(this.getWest(), this.getNorth());
          }
          getSouthEast() {
            return new t.V(this.getEast(), this.getSouth());
          }
          getWest() {
            return this._sw.lng;
          }
          getSouth() {
            return this._sw.lat;
          }
          getEast() {
            return this._ne.lng;
          }
          getNorth() {
            return this._ne.lat;
          }
          toArray() {
            return [this._sw.toArray(), this._ne.toArray()];
          }
          toString() {
            return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
          }
          isEmpty() {
            return !(this._sw && this._ne);
          }
          contains(e2) {
            const { lng: i2, lat: a2 } = t.V.convert(e2);
            let r2 = this._sw.lng <= i2 && i2 <= this._ne.lng;
            return this._sw.lng > this._ne.lng && (r2 = this._sw.lng >= i2 && i2 >= this._ne.lng), this._sw.lat <= a2 && a2 <= this._ne.lat && r2;
          }
          intersects(e2) {
            if (!((e2 = $.convert(e2)).getNorth() >= this.getSouth() && e2.getSouth() <= this.getNorth())) return false;
            const i2 = t.W(this.getWest(), -180, 180), a2 = t.W(this.getEast(), -180, 180), r2 = t.W(e2.getWest(), -180, 180), o2 = t.W(e2.getEast(), -180, 180), s2 = i2 >= a2, n2 = r2 >= o2;
            return !(!s2 || !n2) || (s2 ? o2 >= i2 || r2 <= a2 : n2 ? a2 >= r2 || i2 <= o2 : r2 <= a2 && o2 >= i2);
          }
          static convert(e2) {
            return e2 instanceof $ ? e2 : e2 ? new $(e2) : e2;
          }
          static fromLngLat(e2, i2 = 0) {
            const a2 = 360 * i2 / 40075017, r2 = a2 / Math.cos(Math.PI / 180 * e2.lat);
            return new $(new t.V(e2.lng - r2, e2.lat - a2), new t.V(e2.lng + r2, e2.lat + a2));
          }
          adjustAntiMeridian() {
            const e2 = new t.V(this._sw.lng, this._sw.lat), i2 = new t.V(this._ne.lng, this._ne.lat);
            return new $(e2, e2.lng > i2.lng ? new t.V(i2.lng + 360, i2.lat) : i2);
          }
        }
        class H {
          constructor(e2, t2, i2) {
            this.bounds = $.convert(this.validateBounds(e2)), this.minzoom = t2 || 0, this.maxzoom = i2 || 24;
          }
          validateBounds(e2) {
            return Array.isArray(e2) && 4 === e2.length ? [Math.max(-180, e2[0]), Math.max(-90, e2[1]), Math.min(180, e2[2]), Math.min(90, e2[3])] : [-180, -90, 180, 90];
          }
          contains(e2) {
            const i2 = Math.pow(2, e2.z), a2 = Math.floor(t.Y(this.bounds.getWest()) * i2), r2 = Math.floor(t.X(this.bounds.getNorth()) * i2), o2 = Math.ceil(t.Y(this.bounds.getEast()) * i2), s2 = Math.ceil(t.X(this.bounds.getSouth()) * i2);
            return e2.x >= a2 && e2.x < o2 && e2.y >= r2 && e2.y < s2;
          }
        }
        class X extends t.E {
          constructor(e2, i2, a2, r2) {
            if (super(), this.id = e2, this.dispatcher = a2, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = true, this.isTileClipped = true, this._loaded = false, t.e(this, t.U(i2, ["url", "scheme", "tileSize", "promoteId", "encoding"])), this._options = t.e({ type: "vector" }, i2), this._collectResourceTiming = i2.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
            this.setEventedParent(r2);
          }
          load() {
            return t._(this, void 0, void 0, function* () {
              this._loaded = false, this.fire(new t.l("dataloading", { dataType: "source" })), this._tileJSONRequest = new AbortController();
              try {
                const e2 = yield W(this._options, this.map._requestManager, this._tileJSONRequest);
                this._tileJSONRequest = null, this._loaded = true, this.map.style.tileManagers[this.id].clearTiles(), e2 && (t.e(this, e2), e2.bounds && (this.tileBounds = new H(e2.bounds, this.minzoom, this.maxzoom)), this.fire(new t.l("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new t.l("data", { dataType: "source", sourceDataType: "content" })));
              } catch (e2) {
                this._tileJSONRequest = null, this._loaded = true, t.Z(e2) || this.fire(new t.k(e2));
              }
            });
          }
          loaded() {
            return this._loaded;
          }
          hasTile(e2) {
            return !this.tileBounds || this.tileBounds.contains(e2.canonical);
          }
          onAdd(e2) {
            this.map = e2, this.load();
          }
          setSourceProperty(e2) {
            this._tileJSONRequest && this._tileJSONRequest.abort(), e2(), this.load();
          }
          setTiles(e2) {
            return this.setSourceProperty(() => {
              this._options.tiles = e2;
            }), this;
          }
          setUrl(e2) {
            return this.setSourceProperty(() => {
              this.url = e2, this._options.url = e2;
            }), this;
          }
          onRemove() {
            this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
          }
          serialize() {
            return t.e({}, this._options);
          }
          loadTile(e2) {
            return t._(this, void 0, void 0, function* () {
              const t2 = e2.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), i2 = { request: this.map._requestManager.transformRequest(t2, "Tile"), uid: e2.uid, tileID: e2.tileID, zoom: e2.tileID.overscaledZ, tileSize: this.tileSize * e2.tileID.overscaleFactor(), type: this.type, source: this.id, pixelRatio: this.map.getPixelRatio(), showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId, subdivisionGranularity: this.map.style.projection.subdivisionGranularity, encoding: this.encoding, overzoomParameters: this._getOverzoomParameters(e2) };
              i2.request.collectResourceTiming = this._collectResourceTiming;
              let a2 = "RT";
              if (e2.actor && "expired" !== e2.state) {
                if ("loading" === e2.state) return new Promise((t3, i3) => {
                  e2.reloadPromise = { resolve: t3, reject: i3 };
                });
              } else e2.actor = this.dispatcher.getActor(), a2 = "LT";
              e2.abortController = new AbortController();
              try {
                const t3 = yield e2.actor.sendAsync({ type: a2, data: i2 }, e2.abortController);
                if (delete e2.abortController, e2.aborted) return;
                this._afterTileLoadWorkerResponse(e2, t3);
              } catch (t3) {
                if (delete e2.abortController, e2.aborted) return;
                if (t3 && 404 !== t3.status) throw t3;
                this._afterTileLoadWorkerResponse(e2, null);
              }
            });
          }
          _getOverzoomParameters(e2) {
            if (e2.tileID.canonical.z <= this.maxzoom) return;
            if (void 0 === this.map._zoomLevelsToOverscale) return;
            const t2 = e2.tileID.scaledTo(this.maxzoom).canonical, i2 = t2.url(this.tiles, this.map.getPixelRatio(), this.scheme);
            return { maxZoomTileID: t2, overzoomRequest: this.map._requestManager.transformRequest(i2, "Tile") };
          }
          _afterTileLoadWorkerResponse(e2, t2) {
            if (t2 && t2.resourceTiming && (e2.resourceTiming = t2.resourceTiming), t2 && this.map._refreshExpiredTiles && e2.setExpiryData(t2), e2.loadVectorData(t2, this.map.painter), e2.reloadPromise) {
              const t3 = e2.reloadPromise;
              e2.reloadPromise = null, this.loadTile(e2).then(t3.resolve).catch(t3.reject);
            }
          }
          abortTile(e2) {
            return t._(this, void 0, void 0, function* () {
              e2.abortController && (e2.abortController.abort(), delete e2.abortController), e2.actor && (yield e2.actor.sendAsync({ type: "AT", data: { uid: e2.uid, type: this.type, source: this.id } }));
            });
          }
          unloadTile(e2) {
            return t._(this, void 0, void 0, function* () {
              e2.unloadVectorData(), e2.actor && (yield e2.actor.sendAsync({ type: "RMT", data: { uid: e2.uid, type: this.type, source: this.id } }));
            });
          }
          hasTransition() {
            return false;
          }
        }
        class K extends t.E {
          constructor(e2, i2, a2, r2) {
            super(), this.id = e2, this.dispatcher = a2, this.setEventedParent(r2), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = true, this.scheme = "xyz", this.tileSize = 512, this._loaded = false, this._options = t.e({ type: "raster" }, i2), t.e(this, t.U(i2, ["url", "scheme", "tileSize"]));
          }
          load() {
            return t._(this, arguments, void 0, function* (e2 = false) {
              this._loaded = false, this.fire(new t.l("dataloading", { dataType: "source" })), this._tileJSONRequest = new AbortController();
              try {
                const i2 = yield W(this._options, this.map._requestManager, this._tileJSONRequest);
                this._tileJSONRequest = null, this._loaded = true, i2 && (t.e(this, i2), i2.bounds && (this.tileBounds = new H(i2.bounds, this.minzoom, this.maxzoom)), this.fire(new t.l("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new t.l("data", { dataType: "source", sourceDataType: "content", sourceDataChanged: e2 })));
              } catch (e3) {
                this._tileJSONRequest = null, this._loaded = true, t.Z(e3) || this.fire(new t.k(e3));
              }
            });
          }
          loaded() {
            return this._loaded;
          }
          onAdd(e2) {
            this.map = e2, this.load();
          }
          onRemove() {
            this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
          }
          setSourceProperty(e2) {
            this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null), e2(), this.load(true);
          }
          setTiles(e2) {
            return this.setSourceProperty(() => {
              this._options.tiles = e2;
            }), this;
          }
          setUrl(e2) {
            return this.setSourceProperty(() => {
              this.url = e2, this._options.url = e2;
            }), this;
          }
          serialize() {
            return t.e({}, this._options);
          }
          hasTile(e2) {
            return !this.tileBounds || this.tileBounds.contains(e2.canonical);
          }
          loadTile(e2) {
            return t._(this, void 0, void 0, function* () {
              const i2 = e2.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
              e2.abortController = new AbortController();
              try {
                const a2 = yield g.getImage(this.map._requestManager.transformRequest(i2, "Tile"), e2.abortController, this.map._refreshExpiredTiles);
                if (delete e2.abortController, e2.aborted) return void (e2.state = "unloaded");
                if (a2 && a2.data) {
                  this.map._refreshExpiredTiles && (a2.cacheControl || a2.expires) && e2.setExpiryData({ cacheControl: a2.cacheControl, expires: a2.expires });
                  const i3 = this.map.painter.context, r2 = i3.gl, o2 = a2.data;
                  e2.texture = this.map.painter.getTileTexture(o2.width), e2.texture ? e2.texture.update(o2, { useMipmap: true }) : (e2.texture = new t.T(i3, o2, r2.RGBA, { useMipmap: true }), e2.texture.bind(r2.LINEAR, r2.CLAMP_TO_EDGE, r2.LINEAR_MIPMAP_NEAREST)), e2.state = "loaded";
                }
              } catch (t2) {
                if (delete e2.abortController, e2.aborted) e2.state = "unloaded";
                else if (t2) throw e2.state = "errored", t2;
              }
            });
          }
          abortTile(e2) {
            return t._(this, void 0, void 0, function* () {
              e2.abortController && (e2.abortController.abort(), delete e2.abortController);
            });
          }
          unloadTile(e2) {
            return t._(this, void 0, void 0, function* () {
              e2.texture && this.map.painter.saveTileTexture(e2.texture);
            });
          }
          hasTransition() {
            return false;
          }
        }
        class Y extends K {
          constructor(e2, i2, a2, r2) {
            super(e2, i2, a2, r2), this.type = "raster-dem", this.maxzoom = 22, this._options = t.e({ type: "raster-dem" }, i2), this.encoding = i2.encoding || "mapbox", this.redFactor = i2.redFactor, this.greenFactor = i2.greenFactor, this.blueFactor = i2.blueFactor, this.baseShift = i2.baseShift;
          }
          loadTile(e2) {
            return t._(this, void 0, void 0, function* () {
              const i2 = e2.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), a2 = this.map._requestManager.transformRequest(i2, "Tile");
              e2.neighboringTiles = this._getNeighboringTiles(e2.tileID), e2.abortController = new AbortController();
              try {
                const i3 = yield g.getImage(a2, e2.abortController, this.map._refreshExpiredTiles);
                if (delete e2.abortController, e2.aborted) return void (e2.state = "unloaded");
                if (i3 && i3.data) {
                  const a3 = i3.data;
                  this.map._refreshExpiredTiles && (i3.cacheControl || i3.expires) && e2.setExpiryData({ cacheControl: i3.cacheControl, expires: i3.expires });
                  const r2 = t.b(a3) && t.$() ? a3 : yield this.readImageNow(a3), o2 = { type: this.type, uid: e2.uid, source: this.id, rawImageData: r2, encoding: this.encoding, redFactor: this.redFactor, greenFactor: this.greenFactor, blueFactor: this.blueFactor, baseShift: this.baseShift };
                  if (!e2.actor || "expired" === e2.state) {
                    e2.actor = this.dispatcher.getActor();
                    const t2 = yield e2.actor.sendAsync({ type: "LDT", data: o2 });
                    e2.dem = t2, e2.needsHillshadePrepare = true, e2.needsTerrainPrepare = true, e2.state = "loaded";
                  }
                }
              } catch (t2) {
                if (delete e2.abortController, e2.aborted) e2.state = "unloaded";
                else if (t2) throw e2.state = "errored", t2;
              }
            });
          }
          readImageNow(e2) {
            return t._(this, void 0, void 0, function* () {
              if ("undefined" != typeof VideoFrame && t.a0()) {
                const i2 = e2.width + 2, a2 = e2.height + 2;
                try {
                  return new t.R({ width: i2, height: a2 }, yield t.a1(e2, -1, -1, i2, a2));
                } catch (e3) {
                }
              }
              return n.getImageData(e2, 1);
            });
          }
          _getNeighboringTiles(e2) {
            const i2 = e2.canonical, a2 = Math.pow(2, i2.z), r2 = (i2.x - 1 + a2) % a2, o2 = 0 === i2.x ? e2.wrap - 1 : e2.wrap, s2 = (i2.x + 1 + a2) % a2, n2 = i2.x + 1 === a2 ? e2.wrap + 1 : e2.wrap, l2 = {};
            return l2[new t.a2(e2.overscaledZ, o2, i2.z, r2, i2.y).key] = { backfilled: false }, l2[new t.a2(e2.overscaledZ, n2, i2.z, s2, i2.y).key] = { backfilled: false }, i2.y > 0 && (l2[new t.a2(e2.overscaledZ, o2, i2.z, r2, i2.y - 1).key] = { backfilled: false }, l2[new t.a2(e2.overscaledZ, e2.wrap, i2.z, i2.x, i2.y - 1).key] = { backfilled: false }, l2[new t.a2(e2.overscaledZ, n2, i2.z, s2, i2.y - 1).key] = { backfilled: false }), i2.y + 1 < a2 && (l2[new t.a2(e2.overscaledZ, o2, i2.z, r2, i2.y + 1).key] = { backfilled: false }, l2[new t.a2(e2.overscaledZ, e2.wrap, i2.z, i2.x, i2.y + 1).key] = { backfilled: false }, l2[new t.a2(e2.overscaledZ, n2, i2.z, s2, i2.y + 1).key] = { backfilled: false }), l2;
          }
          unloadTile(e2) {
            return t._(this, void 0, void 0, function* () {
              e2.demTexture && this.map.painter.saveTileTexture(e2.demTexture), e2.fbo && (e2.fbo.destroy(), delete e2.fbo), e2.dem && delete e2.dem, delete e2.neighboringTiles, e2.state = "unloaded", e2.actor && (yield e2.actor.sendAsync({ type: "RDT", data: { type: this.type, uid: e2.uid, source: this.id } }));
            });
          }
        }
        function Q(e2) {
          return "GeometryCollection" === e2.type ? e2.geometries.map((e3) => e3.coordinates).flat(1 / 0) : e2.coordinates.flat(1 / 0);
        }
        function J(e2) {
          const t2 = new $();
          let i2;
          switch (e2.type) {
            case "FeatureCollection":
              i2 = e2.features.map((e3) => Q(e3.geometry)).flat(1 / 0);
              break;
            case "Feature":
              i2 = Q(e2.geometry);
              break;
            default:
              i2 = Q(e2);
          }
          if (0 == i2.length) return t2;
          for (let e3 = 0; e3 < i2.length - 1; e3 += 2) t2.extend([i2[e3], i2[e3 + 1]]);
          return t2;
        }
        class ee extends t.E {
          constructor(e2, i2, a2, r2) {
            super(), this.id = e2, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = true, this.reparseOverscaled = true, this._removed = false, this._isUpdatingWorker = false, this._pendingWorkerUpdate = { data: i2.data }, this.actor = a2.getActor(), this.setEventedParent(r2), this._data = "string" == typeof i2.data ? { url: i2.data } : { geojson: i2.data }, this._options = t.e({}, i2), this._collectResourceTiming = i2.collectResourceTiming, void 0 !== i2.maxzoom && (this.maxzoom = i2.maxzoom), i2.type && (this.type = i2.type), i2.attribution && (this.attribution = i2.attribution), this.promoteId = i2.promoteId, void 0 !== i2.clusterMaxZoom && this.maxzoom <= i2.clusterMaxZoom && t.w(`The maxzoom value "${this.maxzoom}" is expected to be greater than the clusterMaxZoom value "${i2.clusterMaxZoom}".`), this.workerOptions = t.e({ source: this.id, cluster: i2.cluster || false, geojsonVtOptions: { buffer: this._pixelsToTileUnits(void 0 !== i2.buffer ? i2.buffer : 128), tolerance: this._pixelsToTileUnits(void 0 !== i2.tolerance ? i2.tolerance : 0.375), extent: t.a5, maxZoom: this.maxzoom, lineMetrics: i2.lineMetrics || false, generateId: i2.generateId || false }, superclusterOptions: { maxZoom: this._getClusterMaxZoom(i2.clusterMaxZoom), minPoints: Math.max(2, i2.clusterMinPoints || 2), extent: t.a5, radius: this._pixelsToTileUnits(i2.clusterRadius || 50), log: false, generateId: i2.generateId || false }, clusterProperties: i2.clusterProperties, filter: i2.filter }, i2.workerOptions), "string" == typeof this.promoteId && (this.workerOptions.promoteId = this.promoteId);
          }
          _hasPendingWorkerUpdate() {
            return void 0 !== this._pendingWorkerUpdate.data || void 0 !== this._pendingWorkerUpdate.diff || this._pendingWorkerUpdate.optionsChanged;
          }
          _pixelsToTileUnits(e2) {
            return e2 * (t.a5 / this.tileSize);
          }
          _getClusterMaxZoom(e2) {
            const i2 = e2 ? Math.round(e2) : this.maxzoom - 1;
            return Number.isInteger(e2) || void 0 === e2 || t.w(`Integer expected for option 'clusterMaxZoom': provided value "${e2}" rounded to "${i2}"`), i2;
          }
          load() {
            return t._(this, void 0, void 0, function* () {
              yield this._updateWorkerData();
            });
          }
          onAdd(e2) {
            this.map = e2, this.load();
          }
          setData(e2, t2) {
            this._data = "string" == typeof e2 ? { url: e2 } : { geojson: e2 }, this._pendingWorkerUpdate = { data: e2 };
            const i2 = this._updateWorkerData();
            return t2 ? i2 : this;
          }
          updateData(e2, i2) {
            this._pendingWorkerUpdate.diff = t.a6(this._pendingWorkerUpdate.diff, e2);
            const a2 = this._updateWorkerData();
            return i2 ? a2 : this;
          }
          getData() {
            return t._(this, void 0, void 0, function* () {
              const e2 = t.e({ type: this.type }, this.workerOptions);
              return this.actor.sendAsync({ type: "GD", data: e2 });
            });
          }
          getBounds() {
            return t._(this, void 0, void 0, function* () {
              return J(yield this.getData());
            });
          }
          setClusterOptions(e2) {
            return this.workerOptions.cluster = e2.cluster, void 0 !== e2.clusterRadius && (this.workerOptions.superclusterOptions.radius = this._pixelsToTileUnits(e2.clusterRadius)), void 0 !== e2.clusterMaxZoom && (this.workerOptions.superclusterOptions.maxZoom = this._getClusterMaxZoom(e2.clusterMaxZoom)), this._pendingWorkerUpdate.optionsChanged = true, this._updateWorkerData(), this;
          }
          getClusterExpansionZoom(e2) {
            return this.actor.sendAsync({ type: "GCEZ", data: { type: this.type, clusterId: e2, source: this.id } });
          }
          getClusterChildren(e2) {
            return this.actor.sendAsync({ type: "GCC", data: { type: this.type, clusterId: e2, source: this.id } });
          }
          getClusterLeaves(e2, t2, i2) {
            return this.actor.sendAsync({ type: "GCL", data: { type: this.type, source: this.id, clusterId: e2, limit: t2, offset: i2 } });
          }
          _updateWorkerData() {
            return t._(this, void 0, void 0, function* () {
              if (this._isUpdatingWorker) return;
              if (!this._hasPendingWorkerUpdate()) return void t.w(`No pending worker updates for GeoJSONSource ${this.id}.`);
              const { data: e2, diff: i2 } = this._pendingWorkerUpdate, a2 = t.e({ type: this.type }, this.workerOptions);
              void 0 !== e2 ? ("string" == typeof e2 ? (a2.request = this.map._requestManager.transformRequest(n.resolveURL(e2), "Source"), a2.request.collectResourceTiming = this._collectResourceTiming) : a2.data = e2, this._pendingWorkerUpdate.data = void 0) : i2 && (a2.dataDiff = i2, this._pendingWorkerUpdate.diff = void 0), this._pendingWorkerUpdate.optionsChanged = void 0, this._isUpdatingWorker = true, this.fire(new t.l("dataloading", { dataType: "source" }));
              try {
                const e3 = yield this.actor.sendAsync({ type: "LD", data: a2 });
                if (this._isUpdatingWorker = false, this._removed || e3.abandoned) return void this.fire(new t.l("dataabort", { dataType: "source" }));
                i2 && this._applyDiff(i2);
                let r2 = null;
                e3.resourceTiming && e3.resourceTiming[this.id] && (r2 = e3.resourceTiming[this.id].slice(0));
                const o2 = { dataType: "source" };
                this._collectResourceTiming && r2 && r2.length > 0 && t.e(o2, { resourceTiming: r2 }), this.fire(new t.l("data", Object.assign(Object.assign({}, o2), { sourceDataType: "metadata" }))), this.fire(new t.l("data", Object.assign(Object.assign({}, o2), { sourceDataType: "content", shouldReloadTileOptions: this._getShouldReloadTileOptions(i2) })));
              } catch (e3) {
                if (this._isUpdatingWorker = false, this._removed) return void this.fire(new t.l("dataabort", { dataType: "source" }));
                this.fire(new t.k(e3));
              } finally {
                this._hasPendingWorkerUpdate() && this._updateWorkerData();
              }
            });
          }
          _applyDiff(e2) {
            const i2 = "string" == typeof this.promoteId ? this.promoteId : void 0;
            if (!this._data.url && !this._data.updateable) {
              if (!t.a7(this._data.geojson, i2)) throw new Error(`GeoJSONSource "${this.id}": GeoJSON data is not compatible with updateData`);
              this._data = { updateable: t.a8(this._data.geojson, i2) };
            }
            this._data.updateable && t.a9(this._data.updateable, e2, i2);
          }
          _getShouldReloadTileOptions(e2) {
            if (this._options.cluster || !e2 || e2.removeAll) return;
            const { add: i2 = [], update: a2 = [], remove: r2 = [] } = e2 || {}, o2 = /* @__PURE__ */ new Set([...a2.map((e3) => e3.id), ...r2]);
            for (const e3 of o2.values()) if ("number" != typeof e3 && null == this.promoteId) return void t.w(`GeoJSONSource "${this.id}": updateData is slower when using string GeoJSON feature IDs. Consider using promoteId or numeric IDs for better performance.`);
            return { nextBounds: [...a2.map((e3) => e3.newGeometry), ...i2.map((e3) => e3.geometry)].filter(Boolean).map((e3) => J(e3)), prevIds: o2 };
          }
          shouldReloadTile(e2, { nextBounds: i2, prevIds: a2 }) {
            if (!e2.latestFeatureIndex) return "unloaded" !== e2.state;
            const r2 = e2.latestFeatureIndex.loadVTLayers();
            for (let i3 = 0; i3 < e2.latestFeatureIndex.featureIndexArray.length; i3++) {
              const o3 = e2.latestFeatureIndex.featureIndexArray.get(i3), s3 = r2[t.aa].feature(o3.featureIndex), n3 = e2.latestFeatureIndex.getId(s3, t.aa);
              if (a2.has(n3)) return true;
            }
            const { buffer: o2, extent: s2 } = this.workerOptions.geojsonVtOptions, n2 = function({ x: e3, y: i3, z: a3 }, r3 = 0) {
              const o3 = t.a3((e3 - r3) / Math.pow(2, a3)), s3 = t.a4((i3 + 1 + r3) / Math.pow(2, a3)), n3 = t.a3((e3 + 1 + r3) / Math.pow(2, a3)), l2 = t.a4((i3 - r3) / Math.pow(2, a3));
              return new $([o3, s3], [n3, l2]);
            }(e2.tileID.canonical, o2 / s2);
            for (const e3 of i2) if (n2.intersects(e3)) return true;
            return false;
          }
          loaded() {
            return !this._isUpdatingWorker && !this._hasPendingWorkerUpdate();
          }
          loadTile(e2) {
            return t._(this, void 0, void 0, function* () {
              const t2 = e2.actor ? "RT" : "LT";
              e2.actor = this.actor;
              const i2 = { type: this.type, uid: e2.uid, tileID: e2.tileID, zoom: e2.tileID.overscaledZ, maxZoom: this.maxzoom, tileSize: this.tileSize, source: this.id, pixelRatio: this.map.getPixelRatio(), showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId, subdivisionGranularity: this.map.style.projection.subdivisionGranularity };
              e2.abortController = new AbortController();
              const a2 = yield this.actor.sendAsync({ type: t2, data: i2 }, e2.abortController);
              delete e2.abortController, e2.unloadVectorData(), e2.aborted || e2.loadVectorData(a2, this.map.painter, "RT" === t2);
            });
          }
          abortTile(e2) {
            return t._(this, void 0, void 0, function* () {
              e2.abortController && (e2.abortController.abort(), delete e2.abortController), e2.aborted = true;
            });
          }
          unloadTile(e2) {
            return t._(this, void 0, void 0, function* () {
              e2.unloadVectorData(), yield this.actor.sendAsync({ type: "RMT", data: { uid: e2.uid, type: this.type, source: this.id } });
            });
          }
          onRemove() {
            this._removed = true, this.actor.sendAsync({ type: "RS", data: { type: this.type, source: this.id } });
          }
          serialize() {
            return t.e({}, this._options, { type: this.type, data: this._data.updateable ? { type: "FeatureCollection", features: Array.from(this._data.updateable.values()) } : this._data.url || this._data.geojson });
          }
          hasTransition() {
            return false;
          }
        }
        class te extends t.E {
          constructor(e2, t2, i2, a2) {
            super(), this.flippedWindingOrder = false, this.id = e2, this.dispatcher = i2, this.coordinates = t2.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = false, this.setEventedParent(a2), this.options = t2;
          }
          load(e2) {
            return t._(this, void 0, void 0, function* () {
              this._loaded = false, this.fire(new t.l("dataloading", { dataType: "source" })), this.url = this.options.url, this._request = new AbortController();
              try {
                const t2 = yield g.getImage(this.map._requestManager.transformRequest(this.url, "Image"), this._request);
                this._request = null, this._loaded = true, t2 && t2.data && (this.image = t2.data, e2 && (this.coordinates = e2), this._finishLoading());
              } catch (e3) {
                this._request = null, this._loaded = true, t.Z(e3) || this.fire(new t.k(e3));
              }
            });
          }
          loaded() {
            return this._loaded;
          }
          updateImage(e2) {
            return e2.url ? (this._request && (this._request.abort(), this._request = null), this.options.url = e2.url, this.load(e2.coordinates).finally(() => {
              this.texture = null;
            }), this) : this;
          }
          _finishLoading() {
            this.map && (this.setCoordinates(this.coordinates), this.fire(new t.l("data", { dataType: "source", sourceDataType: "metadata" })));
          }
          onAdd(e2) {
            this.map = e2, this.load();
          }
          onRemove() {
            this._request && (this._request.abort(), this._request = null);
          }
          setCoordinates(e2) {
            this.coordinates = e2;
            const i2 = e2.map(t.ab.fromLngLat);
            var a2;
            return this.tileID = function(e3) {
              const i3 = t.ac.fromPoints(e3), a3 = i3.width(), r2 = i3.height(), o2 = Math.max(a3, r2), s2 = Math.max(0, Math.floor(-Math.log(o2) / Math.LN2)), n2 = Math.pow(2, s2);
              return new t.ae(s2, Math.floor((i3.minX + i3.maxX) / 2 * n2), Math.floor((i3.minY + i3.maxY) / 2 * n2));
            }(i2), this.terrainTileRanges = this._getOverlappingTileRanges(i2), this.minzoom = this.maxzoom = this.tileID.z, this.tileCoords = i2.map((e3) => this.tileID.getTilePoint(e3)._round()), this.flippedWindingOrder = ((a2 = this.tileCoords)[1].x - a2[0].x) * (a2[2].y - a2[0].y) - (a2[1].y - a2[0].y) * (a2[2].x - a2[0].x) < 0, this.fire(new t.l("data", { dataType: "source", sourceDataType: "content" })), this;
          }
          prepare() {
            if (0 === Object.keys(this.tiles).length || !this.image) return;
            const e2 = this.map.painter.context, i2 = e2.gl;
            this.texture || (this.texture = new t.T(e2, this.image, i2.RGBA), this.texture.bind(i2.LINEAR, i2.CLAMP_TO_EDGE));
            let a2 = false;
            for (const e3 in this.tiles) {
              const t2 = this.tiles[e3];
              "loaded" !== t2.state && (t2.state = "loaded", t2.texture = this.texture, a2 = true);
            }
            a2 && this.fire(new t.l("data", { dataType: "source", sourceDataType: "idle", sourceId: this.id }));
          }
          loadTile(e2) {
            return t._(this, void 0, void 0, function* () {
              this.tileID && this.tileID.equals(e2.tileID.canonical) ? (this.tiles[String(e2.tileID.wrap)] = e2, e2.buckets = {}) : e2.state = "errored";
            });
          }
          serialize() {
            return { type: "image", url: this.options.url, coordinates: this.coordinates };
          }
          hasTransition() {
            return false;
          }
          _getOverlappingTileRanges(e2) {
            const { minX: i2, minY: a2, maxX: r2, maxY: o2 } = t.ac.fromPoints(e2), s2 = {};
            for (let e3 = 0; e3 <= t.ad; e3++) {
              const t2 = Math.pow(2, e3), n2 = Math.floor(i2 * t2), l2 = Math.floor(a2 * t2), c2 = Math.floor(r2 * t2), h2 = Math.floor(o2 * t2);
              s2[e3] = { minTileX: n2, minTileY: l2, maxTileX: c2, maxTileY: h2 };
            }
            return s2;
          }
        }
        class ie extends te {
          constructor(e2, t2, i2, a2) {
            super(e2, t2, i2, a2), this.roundZoom = true, this.type = "video", this.options = t2;
          }
          load() {
            return t._(this, void 0, void 0, function* () {
              this._loaded = false;
              const e2 = this.options;
              this.urls = [];
              for (const t2 of e2.urls) this.urls.push(this.map._requestManager.transformRequest(t2, "Source").url);
              try {
                const e3 = yield t.af(this.urls);
                if (this._loaded = true, !e3) return;
                this.video = e3, this.video.loop = true, this.video.addEventListener("playing", () => {
                  this.map.triggerRepaint();
                }), this.map && this.video.play(), this._finishLoading();
              } catch (e3) {
                this.fire(new t.k(e3));
              }
            });
          }
          pause() {
            this.video && this.video.pause();
          }
          play() {
            this.video && this.video.play();
          }
          seek(e2) {
            if (this.video) {
              const i2 = this.video.seekable;
              e2 < i2.start(0) || e2 > i2.end(0) ? this.fire(new t.k(new t.ag(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i2.start(0)} and ${i2.end(0)}-second mark.`))) : this.video.currentTime = e2;
            }
          }
          getVideo() {
            return this.video;
          }
          onAdd(e2) {
            this.map || (this.map = e2, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
          }
          prepare() {
            if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
            const e2 = this.map.painter.context, i2 = e2.gl;
            this.texture ? this.video.paused || (this.texture.bind(i2.LINEAR, i2.CLAMP_TO_EDGE), i2.texSubImage2D(i2.TEXTURE_2D, 0, 0, 0, i2.RGBA, i2.UNSIGNED_BYTE, this.video)) : (this.texture = new t.T(e2, this.video, i2.RGBA), this.texture.bind(i2.LINEAR, i2.CLAMP_TO_EDGE));
            let a2 = false;
            for (const e3 in this.tiles) {
              const t2 = this.tiles[e3];
              "loaded" !== t2.state && (t2.state = "loaded", t2.texture = this.texture, a2 = true);
            }
            a2 && this.fire(new t.l("data", { dataType: "source", sourceDataType: "idle", sourceId: this.id }));
          }
          serialize() {
            return { type: "video", urls: this.urls, coordinates: this.coordinates };
          }
          hasTransition() {
            return this.video && !this.video.paused;
          }
        }
        class ae extends te {
          constructor(e2, i2, a2, r2) {
            super(e2, i2, a2, r2), i2.coordinates ? Array.isArray(i2.coordinates) && 4 === i2.coordinates.length && !i2.coordinates.some((e3) => !Array.isArray(e3) || 2 !== e3.length || e3.some((e4) => "number" != typeof e4)) || this.fire(new t.k(new t.ag(`sources.${e2}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t.k(new t.ag(`sources.${e2}`, null, 'missing required property "coordinates"'))), i2.animate && "boolean" != typeof i2.animate && this.fire(new t.k(new t.ag(`sources.${e2}`, null, 'optional "animate" property must be a boolean value'))), i2.canvas ? "string" == typeof i2.canvas || i2.canvas instanceof HTMLCanvasElement || this.fire(new t.k(new t.ag(`sources.${e2}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t.k(new t.ag(`sources.${e2}`, null, 'missing required property "canvas"'))), this.options = i2, this.animate = void 0 === i2.animate || i2.animate;
          }
          load() {
            return t._(this, void 0, void 0, function* () {
              this._loaded = true, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t.k(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                this._playing = true, this.map.triggerRepaint();
              }, this.pause = function() {
                this._playing && (this.prepare(), this._playing = false);
              }, this._finishLoading());
            });
          }
          getCanvas() {
            return this.canvas;
          }
          onAdd(e2) {
            this.map = e2, this.load(), this.canvas && this.animate && this.play();
          }
          onRemove() {
            this.pause();
          }
          prepare() {
            let e2 = false;
            if (this.canvas.width !== this.width && (this.width = this.canvas.width, e2 = true), this.canvas.height !== this.height && (this.height = this.canvas.height, e2 = true), this._hasInvalidDimensions()) return;
            if (0 === Object.keys(this.tiles).length) return;
            const i2 = this.map.painter.context, a2 = i2.gl;
            this.texture ? (e2 || this._playing) && this.texture.update(this.canvas, { premultiply: true }) : (this.texture = new t.T(i2, this.canvas, a2.RGBA, { premultiply: true }), this.texture.bind(a2.LINEAR, a2.CLAMP_TO_EDGE));
            let r2 = false;
            for (const e3 in this.tiles) {
              const t2 = this.tiles[e3];
              "loaded" !== t2.state && (t2.state = "loaded", t2.texture = this.texture, r2 = true);
            }
            r2 && this.fire(new t.l("data", { dataType: "source", sourceDataType: "idle", sourceId: this.id }));
          }
          serialize() {
            return { type: "canvas", animate: this.animate, canvas: this.options.canvas, coordinates: this.coordinates };
          }
          hasTransition() {
            return this._playing;
          }
          _hasInvalidDimensions() {
            for (const e2 of [this.canvas.width, this.canvas.height]) if (isNaN(e2) || e2 <= 0) return true;
            return false;
          }
        }
        const re = {}, oe = (e2) => {
          switch (e2) {
            case "geojson":
              return ee;
            case "image":
              return te;
            case "raster":
              return K;
            case "raster-dem":
              return Y;
            case "vector":
              return X;
            case "video":
              return ie;
            case "canvas":
              return ae;
          }
          return re[e2];
        }, se = "RTLPluginLoaded";
        class ne extends t.E {
          constructor() {
            super(...arguments), this.status = "unavailable", this.url = null, this.dispatcher = Z();
          }
          _syncState(e2) {
            return this.status = e2, this.dispatcher.broadcast("SRPS", { pluginStatus: e2, pluginURL: this.url }).catch((e3) => {
              throw this.status = "error", e3;
            });
          }
          getRTLTextPluginStatus() {
            return this.status;
          }
          clearRTLTextPlugin() {
            this.status = "unavailable", this.url = null;
          }
          setRTLTextPlugin(e2) {
            return t._(this, arguments, void 0, function* (e3, t2 = false) {
              if (this.url) throw new Error("setRTLTextPlugin cannot be called multiple times.");
              if (this.url = n.resolveURL(e3), !this.url) throw new Error(`requested url ${e3} is invalid`);
              if ("unavailable" === this.status) {
                if (!t2) return this._requestImport();
                this.status = "deferred", this._syncState(this.status);
              } else if ("requested" === this.status) return this._requestImport();
            });
          }
          _requestImport() {
            return t._(this, void 0, void 0, function* () {
              yield this._syncState("loading"), this.status = "loaded", this.fire(new t.l(se));
            });
          }
          lazyLoad() {
            "unavailable" === this.status ? this.status = "requested" : "deferred" === this.status && this._requestImport();
          }
        }
        let le = null;
        function ce() {
          return le || (le = new ne()), le;
        }
        var he, ue;
        !function(e2) {
          e2[e2.Base = 0] = "Base", e2[e2.Parent = 1] = "Parent";
        }(he || (he = {})), function(e2) {
          e2[e2.Departing = 0] = "Departing", e2[e2.Incoming = 1] = "Incoming";
        }(ue || (ue = {}));
        class de {
          constructor(e2, i2) {
            this.timeAdded = 0, this.fadeEndTime = 0, this.fadeOpacity = 1, this.tileID = e2, this.uid = t.ah(), this.uses = 0, this.tileSize = i2, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = false, this.hasRTLText = false, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
          }
          isRenderable(e2) {
            return this.hasData() && (!this.fadeEndTime || this.fadeOpacity > 0) && (e2 || !this.holdingForSymbolFade());
          }
          setCrossFadeLogic({ fadingRole: e2, fadingDirection: t2, fadingParentID: i2, fadeEndTime: a2 }) {
            this.resetFadeLogic(), this.fadingRole = e2, this.fadingDirection = t2, this.fadingParentID = i2, this.fadeEndTime = a2;
          }
          setSelfFadeLogic(e2) {
            this.resetFadeLogic(), this.selfFading = true, this.fadeEndTime = e2;
          }
          resetFadeLogic() {
            this.fadingRole = null, this.fadingDirection = null, this.fadingParentID = null, this.selfFading = false, this.timeAdded = c(), this.fadeEndTime = 0, this.fadeOpacity = 1;
          }
          wasRequested() {
            return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
          }
          clearTextures(e2) {
            this.demTexture && e2.saveTileTexture(this.demTexture), this.demTexture = null;
          }
          loadVectorData(e2, i2, a2) {
            if (this.hasData() && this.unloadVectorData(), this.state = "loaded", e2) {
              e2.featureIndex && (this.latestFeatureIndex = e2.featureIndex, e2.rawTileData ? (this.latestRawTileData = e2.rawTileData, this.latestFeatureIndex.rawTileData = e2.rawTileData, this.latestFeatureIndex.encoding = e2.encoding) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData, this.latestFeatureIndex.encoding = this.latestEncoding)), this.collisionBoxArray = e2.collisionBoxArray, this.buckets = function(e3, t2) {
                const i3 = {};
                if (!t2) return i3;
                for (const a3 of e3) {
                  const e4 = a3.layerIds.map((e5) => t2.getLayer(e5)).filter(Boolean);
                  if (0 !== e4.length) {
                    a3.layers = e4, a3.stateDependentLayerIds && (a3.stateDependentLayers = a3.stateDependentLayerIds.map((t3) => e4.filter((e5) => e5.id === t3)[0]));
                    for (const t3 of e4) i3[t3.id] = a3;
                  }
                }
                return i3;
              }(e2.buckets, null == i2 ? void 0 : i2.style), this.hasSymbolBuckets = false;
              for (const e3 in this.buckets) {
                const i3 = this.buckets[e3];
                if (i3 instanceof t.aj) {
                  if (this.hasSymbolBuckets = true, !a2) break;
                  i3.justReloaded = true;
                }
              }
              if (this.hasRTLText = false, this.hasSymbolBuckets) for (const e3 in this.buckets) {
                const i3 = this.buckets[e3];
                if (i3 instanceof t.aj && i3.hasRTLText) {
                  this.hasRTLText = true, ce().lazyLoad();
                  break;
                }
              }
              this.queryPadding = 0;
              for (const e3 in this.buckets) {
                const t2 = this.buckets[e3];
                this.queryPadding = Math.max(this.queryPadding, i2.style.getLayer(e3).queryRadius(t2));
              }
              e2.imageAtlas && (this.imageAtlas = e2.imageAtlas), e2.glyphAtlasImage && (this.glyphAtlasImage = e2.glyphAtlasImage), this.dashPositions = e2.dashPositions;
            } else this.collisionBoxArray = new t.ai();
          }
          unloadVectorData() {
            for (const e2 in this.buckets) this.buckets[e2].destroy();
            this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.dashPositions && (this.dashPositions = null), this.latestFeatureIndex = null, this.state = "unloaded";
          }
          getBucket(e2) {
            return this.buckets[e2.id];
          }
          upload(e2) {
            for (const t2 in this.buckets) {
              const i3 = this.buckets[t2];
              i3.uploadPending() && i3.upload(e2);
            }
            const i2 = e2.gl;
            this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new t.T(e2, this.imageAtlas.image, i2.RGBA), this.imageAtlas.uploaded = true), this.glyphAtlasImage && (this.glyphAtlasTexture = new t.T(e2, this.glyphAtlasImage, i2.ALPHA), this.glyphAtlasImage = null);
          }
          prepare(e2) {
            this.imageAtlas && this.imageAtlas.patchUpdatedImages(e2, this.imageAtlasTexture);
          }
          queryRenderedFeatures(e2, t2, i2, a2, r2, o2, s2, n2, l2, c2, h2) {
            return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({ queryGeometry: a2, cameraQueryGeometry: r2, scale: o2, tileSize: this.tileSize, pixelPosMatrix: c2, transform: n2, params: s2, queryPadding: this.queryPadding * l2, getElevation: h2 }, e2, t2, i2) : {};
          }
          querySourceFeatures(e2, i2) {
            const a2 = this.latestFeatureIndex;
            if (!a2 || !a2.rawTileData) return;
            const r2 = a2.loadVTLayers(), o2 = i2 && i2.sourceLayer ? i2.sourceLayer : "", s2 = r2[t.aa] || r2[o2];
            if (!s2) return;
            const n2 = t.ak(null == i2 ? void 0 : i2.filter, null == i2 ? void 0 : i2.globalState), { z: l2, x: c2, y: h2 } = this.tileID.canonical, u2 = { z: l2, x: c2, y: h2 };
            for (let i3 = 0; i3 < s2.length; i3++) {
              const r3 = s2.feature(i3);
              if (n2.needGeometry) {
                const e3 = t.al(r3, true);
                if (!n2.filter(new t.H(this.tileID.overscaledZ), e3, this.tileID.canonical)) continue;
              } else if (!n2.filter(new t.H(this.tileID.overscaledZ), r3)) continue;
              const d2 = a2.getId(r3, o2), _2 = new t.am(r3, l2, c2, h2, d2);
              _2.tile = u2, e2.push(_2);
            }
          }
          hasData() {
            return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
          }
          patternsLoaded() {
            return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
          }
          setExpiryData(e2) {
            const i2 = this.expirationTime;
            if (e2.cacheControl) {
              const i3 = t.an(e2.cacheControl);
              i3["max-age"] && (this.expirationTime = Date.now() + 1e3 * i3["max-age"]);
            } else e2.expires && (this.expirationTime = new Date(e2.expires).getTime());
            if (this.expirationTime) {
              const e3 = Date.now();
              let t2 = false;
              if (this.expirationTime > e3) t2 = false;
              else if (i2) if (this.expirationTime < i2) t2 = true;
              else {
                const a2 = this.expirationTime - i2;
                a2 ? this.expirationTime = e3 + Math.max(a2, 3e4) : t2 = true;
              }
              else t2 = true;
              t2 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
            }
          }
          getExpiryTimeout() {
            if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (/* @__PURE__ */ new Date()).getTime(), Math.pow(2, 31) - 1);
          }
          setFeatureState(e2, i2) {
            if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(e2).length) return;
            const a2 = this.latestFeatureIndex.loadVTLayers();
            for (const r2 in this.buckets) {
              if (!i2.style.hasLayer(r2)) continue;
              const o2 = this.buckets[r2], s2 = o2.layers[0].sourceLayer || t.aa, n2 = a2[s2], l2 = e2[s2];
              if (!n2 || !l2 || 0 === Object.keys(l2).length) continue;
              o2.update(l2, n2, this.imageAtlas && this.imageAtlas.patternPositions || {}, this.dashPositions || {});
              const c2 = i2 && i2.style && i2.style.getLayer(r2);
              c2 && (this.queryPadding = Math.max(this.queryPadding, c2.queryRadius(o2)));
            }
          }
          holdingForSymbolFade() {
            return void 0 !== this.symbolFadeHoldUntil;
          }
          symbolFadeFinished() {
            return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < c();
          }
          clearSymbolFadeHold() {
            this.symbolFadeHoldUntil = void 0;
          }
          setSymbolHoldDuration(e2) {
            this.symbolFadeHoldUntil = c() + e2;
          }
          setDependencies(e2, t2) {
            const i2 = {};
            for (const e3 of t2) i2[e3] = true;
            this.dependencies[e2] = i2;
          }
          hasDependency(e2, t2) {
            for (const i2 of e2) {
              const e3 = this.dependencies[i2];
              if (e3) {
                for (const i3 of t2) if (e3[i3]) return true;
              }
            }
            return false;
          }
        }
        class _e {
          constructor() {
            this.state = {}, this.stateChanges = {}, this.deletedStates = {};
          }
          updateState(e2, i2, a2) {
            const r2 = String(i2);
            if (this.stateChanges[e2] = this.stateChanges[e2] || {}, this.stateChanges[e2][r2] = this.stateChanges[e2][r2] || {}, t.e(this.stateChanges[e2][r2], a2), null === this.deletedStates[e2]) {
              this.deletedStates[e2] = {};
              for (const t2 in this.state[e2]) t2 !== r2 && (this.deletedStates[e2][t2] = null);
            } else if (this.deletedStates[e2] && null === this.deletedStates[e2][r2]) {
              this.deletedStates[e2][r2] = {};
              for (const t2 in this.state[e2][r2]) a2[t2] || (this.deletedStates[e2][r2][t2] = null);
            } else for (const t2 in a2) this.deletedStates[e2] && this.deletedStates[e2][r2] && null === this.deletedStates[e2][r2][t2] && delete this.deletedStates[e2][r2][t2];
          }
          removeFeatureState(e2, t2, i2) {
            if (null === this.deletedStates[e2]) return;
            const a2 = String(t2);
            if (this.deletedStates[e2] = this.deletedStates[e2] || {}, i2 && void 0 !== t2) null !== this.deletedStates[e2][a2] && (this.deletedStates[e2][a2] = this.deletedStates[e2][a2] || {}, this.deletedStates[e2][a2][i2] = null);
            else if (void 0 !== t2) if (this.stateChanges[e2] && this.stateChanges[e2][a2]) for (i2 in this.deletedStates[e2][a2] = {}, this.stateChanges[e2][a2]) this.deletedStates[e2][a2][i2] = null;
            else this.deletedStates[e2][a2] = null;
            else this.deletedStates[e2] = null;
          }
          getState(e2, i2) {
            const a2 = String(i2), r2 = t.e({}, (this.state[e2] || {})[a2], (this.stateChanges[e2] || {})[a2]);
            if (null === this.deletedStates[e2]) return {};
            if (this.deletedStates[e2]) {
              const t2 = this.deletedStates[e2][i2];
              if (null === t2) return {};
              for (const e3 in t2) delete r2[e3];
            }
            return r2;
          }
          initializeTileState(e2, t2) {
            e2.setFeatureState(this.state, t2);
          }
          coalesceChanges(e2, i2) {
            const a2 = {};
            for (const e3 in this.stateChanges) {
              this.state[e3] = this.state[e3] || {};
              const i3 = {};
              for (const a3 in this.stateChanges[e3]) this.state[e3][a3] || (this.state[e3][a3] = {}), t.e(this.state[e3][a3], this.stateChanges[e3][a3]), i3[a3] = this.state[e3][a3];
              a2[e3] = i3;
            }
            for (const e3 in this.deletedStates) {
              this.state[e3] = this.state[e3] || {};
              const i3 = {};
              if (null === this.deletedStates[e3]) for (const t2 in this.state[e3]) i3[t2] = {}, this.state[e3][t2] = {};
              else for (const t2 in this.deletedStates[e3]) {
                if (null === this.deletedStates[e3][t2]) this.state[e3][t2] = {};
                else for (const i4 of Object.keys(this.deletedStates[e3][t2])) delete this.state[e3][t2][i4];
                i3[t2] = this.state[e3][t2];
              }
              a2[e3] = a2[e3] || {}, t.e(a2[e3], i3);
            }
            this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(a2).length && e2.setFeatureState(a2, i2);
          }
        }
        const pe = 89.25;
        function me(e2, i2) {
          const a2 = t.ao(i2.lat, -t.ap, t.ap);
          return new t.P(t.Y(i2.lng) * e2, t.X(a2) * e2);
        }
        function fe(e2, i2) {
          return new t.ab(i2.x / e2, i2.y / e2).toLngLat();
        }
        function ge(e2) {
          return e2.cameraToCenterDistance * Math.min(0.85 * Math.tan(t.aq(90 - e2.pitch)), Math.tan(t.aq(pe - e2.pitch)));
        }
        function ve(e2, i2) {
          const a2 = e2.canonical, r2 = i2 / t.ar(a2.z), o2 = a2.x + Math.pow(2, a2.z) * e2.wrap, s2 = t.as(new Float64Array(16));
          return t.O(s2, s2, [o2 * r2, a2.y * r2, 0]), t.Q(s2, s2, [r2 / t.a5, r2 / t.a5, 1]), s2;
        }
        function xe(e2, i2, a2, r2, o2) {
          const s2 = t.ab.fromLngLat(e2, i2), n2 = o2 * t.at(1, e2.lat), { x: l2, y: c2, z: h2 } = be(a2, r2);
          return new t.ab(s2.x + n2 * -l2, s2.y + n2 * -c2, s2.z + n2 * -h2);
        }
        function be(e2, i2) {
          const a2 = t.aq(e2), r2 = t.aq(i2), o2 = Math.cos(-a2), s2 = Math.sin(a2);
          return { x: s2 * Math.sin(r2), y: -s2 * Math.cos(r2), z: o2 };
        }
        function ye(e2, t2, i2) {
          const a2 = t2.intersectsFrustum(e2);
          if (!i2 || 0 === a2) return a2;
          const r2 = t2.intersectsPlane(i2);
          return 0 === r2 ? 0 : 2 === a2 && 2 === r2 ? 2 : 1;
        }
        function we(e2, t2, i2) {
          let a2 = 0;
          const r2 = (i2 - t2) / 10;
          for (let o2 = 0; o2 < 10; o2++) a2 += r2 * Math.pow(Math.cos(t2 + (o2 + 0.5) / 10 * (i2 - t2)), e2);
          return a2;
        }
        function Te(e2, i2) {
          return function(a2, r2, o2, s2, n2) {
            const l2 = 2 * ((e2 - 1) / t.au(Math.cos(t.aq(pe - n2)) / Math.cos(t.aq(pe))) - 1), c2 = Math.acos(o2 / s2), h2 = 2 * we(l2 - 1, 0, t.aq(n2 / 2)), u2 = Math.min(t.aq(pe), c2 + t.aq(n2 / 2)), d2 = we(l2 - 1, Math.min(u2, c2 - t.aq(n2 / 2)), u2), _2 = Math.atan(r2 / o2), p2 = Math.hypot(r2, o2);
            let m2 = a2;
            return m2 += t.au(s2 / p2 / Math.max(0.5, Math.cos(t.aq(n2 / 2)))), m2 += l2 * t.au(Math.cos(_2)) / 2, m2 -= t.au(Math.max(1, d2 / h2 / i2)) / 2, m2;
          };
        }
        const Pe = Te(9.314, 3);
        function Ie(e2, i2) {
          const a2 = (i2.roundZoom ? Math.round : Math.floor)(e2.zoom + t.au(e2.tileSize / i2.tileSize));
          return Math.max(0, a2);
        }
        function Ce(e2, i2) {
          const a2 = e2.getCameraFrustum(), r2 = e2.getClippingPlane(), o2 = e2.screenPointToMercatorCoordinate(e2.getCameraPoint()), s2 = t.ab.fromLngLat(e2.center, e2.elevation);
          o2.z = s2.z + Math.cos(e2.pitchInRadians) * e2.cameraToCenterDistance / e2.worldSize;
          const n2 = e2.getCoveringTilesDetailsProvider(), l2 = n2.allowVariableZoom(e2, i2), c2 = Ie(e2, i2), h2 = i2.minzoom || 0, u2 = void 0 !== i2.maxzoom ? i2.maxzoom : e2.maxZoom, d2 = Math.min(Math.max(0, c2), u2), _2 = Math.pow(2, d2), p2 = [_2 * o2.x, _2 * o2.y, 0], m2 = [_2 * s2.x, _2 * s2.y, 0], f2 = Math.hypot(s2.x - o2.x, s2.y - o2.y), g2 = Math.abs(s2.z - o2.z), v2 = Math.hypot(f2, g2), x2 = (e3) => ({ zoom: 0, x: 0, y: 0, wrap: e3, fullyVisible: false }), b2 = [], y2 = [];
          if (e2.renderWorldCopies && n2.allowWorldCopies()) for (let e3 = 1; e3 <= 3; e3++) b2.push(x2(-e3)), b2.push(x2(e3));
          for (b2.push(x2(0)); b2.length > 0; ) {
            const _3 = b2.pop(), f3 = _3.x, x3 = _3.y;
            let w2 = _3.fullyVisible;
            const T2 = { x: f3, y: x3, z: _3.zoom }, P2 = n2.getTileBoundingVolume(T2, _3.wrap, e2.elevation, i2);
            if (!w2) {
              const e3 = ye(a2, P2, r2);
              if (0 === e3) continue;
              w2 = 2 === e3;
            }
            const I2 = n2.distanceToTile2d(o2.x, o2.y, T2, P2);
            let C2 = c2;
            l2 && (C2 = (i2.calculateTileZoom || Pe)(e2.zoom + t.au(e2.tileSize / i2.tileSize), I2, g2, v2, e2.fov)), C2 = (i2.roundZoom ? Math.round : Math.floor)(C2), C2 = Math.max(0, C2);
            const M2 = Math.min(C2, u2);
            if (_3.wrap = n2.getWrap(s2, T2, _3.wrap), _3.zoom >= M2) {
              if (_3.zoom < h2) continue;
              const e3 = d2 - _3.zoom, a3 = p2[0] - 0.5 - (f3 << e3), r3 = p2[1] - 0.5 - (x3 << e3), o3 = i2.reparseOverscaled ? Math.max(_3.zoom, C2) : _3.zoom;
              y2.push({ tileID: new t.a2(_3.zoom === u2 ? o3 : _3.zoom, _3.wrap, _3.zoom, f3, x3), distanceSq: t.av([m2[0] - 0.5 - f3, m2[1] - 0.5 - x3]), tileDistanceToCamera: Math.sqrt(a3 * a3 + r3 * r3) });
            } else for (let e3 = 0; e3 < 4; e3++) b2.push({ zoom: _3.zoom + 1, x: (f3 << 1) + e3 % 2, y: (x3 << 1) + (e3 >> 1), wrap: _3.wrap, fullyVisible: w2 });
          }
          return y2.sort((e3, t2) => e3.distanceSq - t2.distanceSq).map((e3) => e3.tileID);
        }
        const Me = t.ac.fromPoints([new t.P(0, 0), new t.P(t.a5, t.a5)]);
        function Ee(e2) {
          return "raster" === e2 || "image" === e2 || "video" === e2;
        }
        function Se(e2, t2, i2, a2, r2, o2, s2) {
          if (!t2.hasData()) return false;
          const { tileID: n2, fadingRole: l2, fadingDirection: c2, fadingParentID: h2 } = t2;
          if (l2 === he.Base && c2 === ue.Incoming && h2) return i2[h2.key] = h2, true;
          const u2 = Math.max(n2.overscaledZ - r2, o2);
          for (let r3 = n2.overscaledZ - 1; r3 >= u2; r3--) {
            const o3 = n2.scaledTo(r3), l3 = e2.getLoadedTile(o3);
            if (l3) return t2.setCrossFadeLogic({ fadingRole: he.Base, fadingDirection: ue.Incoming, fadingParentID: l3.tileID, fadeEndTime: a2 + s2 }), l3.setCrossFadeLogic({ fadingRole: he.Parent, fadingDirection: ue.Departing, fadeEndTime: a2 + s2 }), i2[o3.key] = o3, true;
          }
          return false;
        }
        function Re(e2, t2, i2, a2, r2, o2) {
          if (!t2.hasData()) return false;
          const s2 = t2.tileID.children(r2);
          let n2 = ze(e2, t2, s2, i2, a2, r2, o2);
          if (n2) return true;
          for (const l2 of s2) ze(e2, t2, l2.children(r2), i2, a2, r2, o2) && (n2 = true);
          return n2;
        }
        function ze(e2, t2, i2, a2, r2, o2, s2) {
          if (i2[0].overscaledZ >= o2) return false;
          let n2 = false;
          for (const o3 of i2) {
            const i3 = e2.getLoadedTile(o3);
            if (!i3) continue;
            const { fadingRole: l2, fadingDirection: c2, fadingParentID: h2 } = i3;
            l2 === he.Base && c2 === ue.Departing && h2 || (i3.setCrossFadeLogic({ fadingRole: he.Base, fadingDirection: ue.Departing, fadingParentID: t2.tileID, fadeEndTime: r2 + s2 }), t2.setCrossFadeLogic({ fadingRole: he.Parent, fadingDirection: ue.Incoming, fadeEndTime: r2 + s2 })), a2[o3.key] = o3, n2 = true;
          }
          return n2;
        }
        function De(e2, t2, i2, a2) {
          const r2 = e2.tileID;
          return !!e2.selfFading || !e2.hasData() && !!t2.has(r2) && (e2.setSelfFadeLogic(i2 + a2), true);
        }
        function Ae(e2, t2) {
          var i2;
          e2.needsHillshadePrepare = true, e2.needsTerrainPrepare = true;
          let a2 = t2.tileID.canonical.x - e2.tileID.canonical.x;
          const r2 = t2.tileID.canonical.y - e2.tileID.canonical.y, o2 = Math.pow(2, e2.tileID.canonical.z), s2 = t2.tileID.key;
          0 === a2 && 0 === r2 || Math.abs(r2) > 1 || (Math.abs(a2) > 1 && (1 === Math.abs(a2 + o2) ? a2 += o2 : 1 === Math.abs(a2 - o2) && (a2 -= o2)), t2.dem && e2.dem && (e2.dem.backfillBorder(t2.dem, a2, r2), (null === (i2 = e2.neighboringTiles) || void 0 === i2 ? void 0 : i2[s2]) && (e2.neighboringTiles[s2].backfilled = true)));
        }
        class Le {
          constructor() {
            this._tiles = {};
          }
          handleWrapJump(e2) {
            const t2 = {};
            for (const i2 in this._tiles) {
              const a2 = this._tiles[i2];
              a2.tileID = a2.tileID.unwrapTo(a2.tileID.wrap + e2), t2[a2.tileID.key] = a2;
            }
            this._tiles = t2;
          }
          setFeatureState(e2, t2) {
            for (const i2 in this._tiles) this._tiles[i2].setFeatureState(e2, t2);
          }
          getAllTiles() {
            return Object.values(this._tiles);
          }
          getAllIds(e2 = false) {
            return e2 ? Object.values(this._tiles).map((e3) => e3.tileID).sort(t.ax).map((e3) => e3.key) : Object.keys(this._tiles);
          }
          getTileById(e2) {
            return this._tiles[e2];
          }
          setTile(e2, t2) {
            this._tiles[e2] = t2;
          }
          deleteTileById(e2) {
            delete this._tiles[e2];
          }
          getLoadedTile(e2) {
            const t2 = this.getTileById(e2.key);
            return (null == t2 ? void 0 : t2.hasData()) ? t2 : null;
          }
          isIdRenderable(e2, t2 = false) {
            var i2;
            return null === (i2 = this.getTileById(e2)) || void 0 === i2 ? void 0 : i2.isRenderable(t2);
          }
          getRenderableIds(e2 = 0, i2) {
            const a2 = [];
            for (const e3 of this.getAllIds()) this.isIdRenderable(e3, i2) && a2.push(this.getTileById(e3));
            return i2 ? a2.sort((i3, a3) => {
              const r2 = i3.tileID, o2 = a3.tileID, s2 = new t.P(r2.canonical.x, r2.canonical.y)._rotate(-e2), n2 = new t.P(o2.canonical.x, o2.canonical.y)._rotate(-e2);
              return r2.overscaledZ - o2.overscaledZ || n2.y - s2.y || n2.x - s2.x;
            }).map((e3) => e3.tileID.key) : a2.map((e3) => e3.tileID).sort(t.ax).map((e3) => e3.key);
          }
        }
        class ke extends t.E {
          constructor(e2, i2, a2) {
            super(), this.id = e2, this.dispatcher = a2, this.on("data", (e3) => this._dataHandler(e3)), this.on("dataloading", () => {
              this._sourceErrored = false;
            }), this.on("error", () => {
              this._sourceErrored = this._source.loaded();
            }), this._source = ((e3, t2, i3, a3) => {
              const r2 = new (oe(t2.type))(e3, t2, i3, a3);
              if (r2.id !== e3) throw new Error(`Expected Source id to be ${e3} instead of ${r2.id}`);
              return r2;
            })(e2, i2, a2, this), this._inViewTiles = new Le(), this._outOfViewCache = new t.ay(0, (e3) => this._unloadTile(e3)), this._timers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._rasterFadeDuration = 0, this._maxFadingAncestorLevels = 5, this._state = new _e(), this._didEmitContent = false, this._updated = false;
          }
          onAdd(e2) {
            this.map = e2, this._maxTileCacheSize = e2 ? e2._maxTileCacheSize : null, this._maxTileCacheZoomLevels = e2 ? e2._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(e2);
          }
          onRemove(e2) {
            for (const e3 of this._inViewTiles.getAllTiles()) e3.unloadVectorData();
            this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(e2), this._inViewTiles = new Le();
          }
          loaded() {
            if (this._sourceErrored) return true;
            if (!this._sourceLoaded) return false;
            if (!this._source.loaded()) return false;
            if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return true;
            if (!this._updated) return false;
            for (const e2 of this._inViewTiles.getAllTiles()) if ("loaded" !== e2.state && "errored" !== e2.state) return false;
            return true;
          }
          getSource() {
            return this._source;
          }
          getState() {
            return this._state;
          }
          pause() {
            this._paused = true;
          }
          resume() {
            if (!this._paused) return;
            const e2 = this._shouldReloadOnResume;
            this._paused = false, this._shouldReloadOnResume = false, e2 && this.reload(), this.transform && this.update(this.transform, this.terrain);
          }
          _loadTile(e2, i2, a2) {
            return t._(this, void 0, void 0, function* () {
              try {
                yield this._source.loadTile(e2), this._tileLoaded(e2, i2, a2);
              } catch (i3) {
                e2.state = "errored", 404 !== i3.status ? this._source.fire(new t.k(i3, { tile: e2 })) : this.update(this.transform, this.terrain);
              }
            });
          }
          _unloadTile(e2) {
            this._source.unloadTile && this._source.unloadTile(e2);
          }
          _abortTile(e2) {
            this._source.abortTile && this._source.abortTile(e2), this._source.fire(new t.l("dataabort", { tile: e2, coord: e2.tileID, dataType: "source" }));
          }
          serialize() {
            return this._source.serialize();
          }
          prepare(e2) {
            this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._inViewTiles, this.map ? this.map.painter : null);
            for (const t2 of this._inViewTiles.getAllTiles()) t2.upload(e2), t2.prepare(this.map.style.imageManager);
          }
          getIds() {
            return this._inViewTiles.getAllIds(true);
          }
          getRenderableIds(e2) {
            var t2;
            return this._inViewTiles.getRenderableIds(null === (t2 = this.transform) || void 0 === t2 ? void 0 : t2.bearingInRadians, e2);
          }
          hasRenderableParent(e2) {
            const t2 = e2.overscaledZ - 1;
            if (t2 >= this._source.minzoom) {
              const i2 = this.getLoadedTile(e2.scaledTo(t2));
              if (i2) return this._inViewTiles.isIdRenderable(i2.tileID.key);
            }
            return false;
          }
          reload(e2, t2 = void 0) {
            if (this._paused) this._shouldReloadOnResume = true;
            else {
              this._outOfViewCache.reset();
              for (const i2 of this._inViewTiles.getAllIds()) {
                const a2 = this._inViewTiles.getTileById(i2);
                t2 && !this._source.shouldReloadTile(a2, t2) || (e2 ? this._reloadTile(i2, "expired") : "errored" !== a2.state && this._reloadTile(i2, "reloading"));
              }
            }
          }
          _reloadTile(e2, i2) {
            return t._(this, void 0, void 0, function* () {
              const t2 = this._inViewTiles.getTileById(e2);
              t2 && ("loading" !== t2.state && (t2.state = i2), yield this._loadTile(t2, e2, i2));
            });
          }
          _tileLoaded(e2, i2, a2) {
            e2.timeAdded = c(), e2.selfFading && (e2.fadeEndTime = e2.timeAdded + this._rasterFadeDuration), "expired" === a2 && (e2.refreshedUponExpiration = true), this._setTileReloadTimer(i2, e2), "raster-dem" === this.getSource().type && e2.dem && function(e3, t2) {
              var i3, a3;
              const r2 = t2.getRenderableIds();
              for (const o2 of r2) {
                if (!e3.neighboringTiles || !e3.neighboringTiles[o2]) continue;
                const r3 = t2.getTileById(o2);
                e3.neighboringTiles[o2].backfilled || Ae(e3, r3), (null === (a3 = null === (i3 = r3.neighboringTiles) || void 0 === i3 ? void 0 : i3[e3.tileID.key]) || void 0 === a3 ? void 0 : a3.backfilled) || Ae(r3, e3);
              }
            }(e2, this._inViewTiles), this._state.initializeTileState(e2, this.map ? this.map.painter : null), e2.aborted || this._source.fire(new t.l("data", { dataType: "source", tile: e2, coord: e2.tileID }));
          }
          getTile(e2) {
            return this.getTileByID(e2.key);
          }
          getTileByID(e2) {
            return this._inViewTiles.getTileById(e2);
          }
          _retainLoadedChildren(e2, t2) {
            const i2 = this._getLoadedDescendents(t2), a2 = /* @__PURE__ */ new Set();
            for (const r2 of t2) {
              const t3 = i2[r2.key];
              if (!(null == t3 ? void 0 : t3.length)) {
                a2.add(r2);
                continue;
              }
              const o2 = r2.overscaledZ + ke.maxOverzooming, s2 = t3.filter((e3) => e3.tileID.overscaledZ <= o2);
              if (!s2.length) {
                a2.add(r2);
                continue;
              }
              const n2 = Math.min(...s2.map((e3) => e3.tileID.overscaledZ)), l2 = s2.filter((e3) => e3.tileID.overscaledZ === n2).map((e3) => e3.tileID);
              for (const t4 of l2) e2[t4.key] = t4;
              this._areDescendentsComplete(l2, n2, r2.overscaledZ) || a2.add(r2);
            }
            return a2;
          }
          _getLoadedDescendents(e2) {
            var t2;
            const i2 = {};
            for (const a2 of this._inViewTiles.getAllTiles().filter((e3) => e3.hasData())) for (const r2 of e2) a2.tileID.isChildOf(r2) && (i2[t2 = r2.key] || (i2[t2] = [])).push(a2);
            return i2;
          }
          _areDescendentsComplete(e2, t2, i2) {
            return 1 === e2.length && e2[0].isOverscaled() ? e2[0].overscaledZ === t2 : Math.pow(4, t2 - i2) === e2.length;
          }
          getLoadedTile(e2) {
            return this._inViewTiles.getLoadedTile(e2);
          }
          updateCacheSize(e2) {
            const i2 = Math.ceil(e2.width / this._source.tileSize) + 1, a2 = Math.ceil(e2.height / this._source.tileSize) + 1, r2 = Math.floor(i2 * a2 * (null === this._maxTileCacheZoomLevels ? t.c.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), o2 = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, r2) : r2;
            this._outOfViewCache.setMaxSize(o2);
          }
          handleWrapJump(e2) {
            const t2 = Math.round((e2 - (void 0 === this._prevLng ? e2 : this._prevLng)) / 360);
            this._prevLng = e2, t2 && (this._inViewTiles.handleWrapJump(t2), this._resetTileReloadTimers());
          }
          update(e2, i2) {
            if (!this._sourceLoaded || this._paused) return;
            let a2;
            this.transform = e2, this.terrain = i2, this.updateCacheSize(e2), this.handleWrapJump(this.transform.center.lng), this.used || this.usedForTerrain ? this._source.tileID ? a2 = e2.getVisibleUnwrappedCoordinates(this._source.tileID).map((e3) => new t.a2(e3.canonical.z, e3.wrap, e3.canonical.z, e3.canonical.x, e3.canonical.y)) : (a2 = Ce(e2, { tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize, minzoom: this._source.minzoom, maxzoom: "vector" === this._source.type && void 0 !== this.map._zoomLevelsToOverscale ? e2.maxZoom - this.map._zoomLevelsToOverscale : this._source.maxzoom, roundZoom: !this.usedForTerrain && this._source.roundZoom, reparseOverscaled: this._source.reparseOverscaled, terrain: i2, calculateTileZoom: this._source.calculateTileZoom }), this._source.hasTile && (a2 = a2.filter((e3) => this._source.hasTile(e3)))) : a2 = [], this.usedForTerrain && (a2 = this._addTerrainIdealTiles(a2));
            const r2 = 0 === a2.length && !this._updated && this._didEmitContent;
            this._updated = true, r2 && this.fire(new t.l("data", { sourceDataType: "idle", dataType: "source", sourceId: this.id }));
            const o2 = Ie(e2, this._source), s2 = this._updateRetainedTiles(a2, o2), n2 = Ee(this._source.type);
            n2 && this._rasterFadeDuration > 0 && !i2 && function(e3, i3, a3, r3, o3, s3, n3) {
              const l2 = c(), h2 = t.aw(i3);
              for (const t2 of i3) {
                const i4 = e3.getTileById(t2.key);
                i4.fadingDirection !== ue.Departing && 0 !== i4.fadeOpacity || i4.resetFadeLogic(), Se(e3, i4, a3, l2, r3, o3, n3) || Re(e3, i4, a3, l2, s3, n3) || De(i4, h2, l2, n3) || i4.resetFadeLogic();
              }
            }(this._inViewTiles, a2, s2, this._maxFadingAncestorLevels, this._source.minzoom, this._source.maxzoom, this._rasterFadeDuration), n2 ? this._cleanUpRasterTiles(s2) : this._cleanUpVectorTiles(s2);
          }
          _cleanUpRasterTiles(e2) {
            for (const t2 of this._inViewTiles.getAllIds()) e2[t2] || this._removeTile(t2);
          }
          _cleanUpVectorTiles(e2) {
            for (const t2 of this._inViewTiles.getAllIds()) {
              const i2 = this._inViewTiles.getTileById(t2);
              e2[t2] ? i2.clearSymbolFadeHold() : i2.hasSymbolBuckets ? i2.holdingForSymbolFade() ? i2.symbolFadeFinished() && this._removeTile(t2) : i2.setSymbolHoldDuration(this.map._fadeDuration) : this._removeTile(t2);
            }
          }
          _addTerrainIdealTiles(e2) {
            const t2 = [];
            for (const i2 of e2) if (i2.canonical.z > this._source.minzoom) {
              const e3 = i2.scaledTo(i2.canonical.z - 1);
              t2.push(e3);
              const a2 = i2.scaledTo(Math.max(this._source.minzoom, Math.min(i2.canonical.z, 5)));
              t2.push(a2);
            }
            return e2.concat(t2);
          }
          releaseSymbolFadeTiles() {
            for (const e2 of this._inViewTiles.getAllIds()) this._inViewTiles.getTileById(e2).holdingForSymbolFade() && this._removeTile(e2);
          }
          _updateRetainedTiles(e2, t2) {
            var i2;
            const a2 = /* @__PURE__ */ new Set();
            for (const t3 of e2) this._addTile(t3).hasData() || a2.add(t3);
            const r2 = e2.reduce((e3, t3) => (e3[t3.key] = t3, e3), {}), o2 = this._retainLoadedChildren(r2, a2), s2 = {}, n2 = Math.max(t2 - ke.maxUnderzooming, this._source.minzoom);
            for (const e3 of o2) {
              let t3 = this._inViewTiles.getTileById(e3.key), a3 = null == t3 ? void 0 : t3.wasRequested();
              for (let o3 = e3.overscaledZ - 1; o3 >= n2; --o3) {
                const n3 = e3.scaledTo(o3);
                if (s2[n3.key]) break;
                if (s2[n3.key] = true, t3 = this.getTile(n3), !t3 && a3 && (t3 = this._addTile(n3)), t3) {
                  const e4 = t3.hasData();
                  if ((e4 || !(null === (i2 = this.map) || void 0 === i2 ? void 0 : i2.cancelPendingTileRequestsWhileZooming) || a3) && (r2[n3.key] = n3), a3 = t3.wasRequested(), e4) break;
                }
              }
            }
            return r2;
          }
          _addTile(e2) {
            let i2 = this._inViewTiles.getTileById(e2.key);
            if (i2) return i2;
            i2 = this._outOfViewCache.getAndRemove(e2), i2 && (i2.resetFadeLogic(), this._setTileReloadTimer(e2.key, i2), i2.tileID = e2, this._state.initializeTileState(i2, this.map ? this.map.painter : null));
            const a2 = i2;
            return i2 || (i2 = new de(e2, this._source.tileSize * e2.overscaleFactor()), this._loadTile(i2, e2.key, i2.state)), i2.uses++, this._inViewTiles.setTile(e2.key, i2), a2 || this._source.fire(new t.l("dataloading", { tile: i2, coord: i2.tileID, dataType: "source" })), i2;
          }
          _setTileReloadTimer(e2, t2) {
            this._clearTileReloadTimer(e2);
            const i2 = t2.getExpiryTimeout();
            i2 && (this._timers[e2] = setTimeout(() => {
              this._reloadTile(e2, "expired"), delete this._timers[e2];
            }, i2));
          }
          _clearTileReloadTimer(e2) {
            const t2 = this._timers[e2];
            t2 && (clearTimeout(t2), delete this._timers[e2]);
          }
          _resetTileReloadTimers() {
            for (const e2 in this._timers) clearTimeout(this._timers[e2]), delete this._timers[e2];
            for (const e2 of this._inViewTiles.getAllIds()) {
              const t2 = this._inViewTiles.getTileById(e2);
              this._setTileReloadTimer(e2, t2);
            }
          }
          refreshTiles(e2) {
            for (const t2 of this._inViewTiles.getAllIds()) {
              const i2 = this._inViewTiles.getTileById(t2);
              (this._inViewTiles.isIdRenderable(t2) || "errored" == i2.state) && e2.some((e3) => e3.equals(i2.tileID.canonical)) && this._reloadTile(t2, "expired");
            }
          }
          _removeTile(e2) {
            const t2 = this._inViewTiles.getTileById(e2);
            t2 && (t2.uses--, this._inViewTiles.deleteTileById(e2), this._clearTileReloadTimer(e2), t2.uses > 0 || (t2.hasData() && "reloading" !== t2.state ? this._outOfViewCache.add(t2.tileID, t2, t2.getExpiryTimeout()) : (t2.aborted = true, this._abortTile(t2), this._unloadTile(t2))));
          }
          _dataHandler(e2) {
            "source" === e2.dataType && ("metadata" !== e2.sourceDataType ? "content" === e2.sourceDataType && this._sourceLoaded && !this._paused && (this.reload(e2.sourceDataChanged, e2.shouldReloadTileOptions), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = true) : this._sourceLoaded = true);
          }
          clearTiles() {
            this._shouldReloadOnResume = false, this._paused = false;
            for (const e2 of this._inViewTiles.getAllIds()) this._removeTile(e2);
            this._outOfViewCache.reset();
          }
          tilesIn(e2, i2, a2) {
            const r2 = [], o2 = this.transform;
            if (!o2) return r2;
            const s2 = o2.getCoveringTilesDetailsProvider().allowWorldCopies(), n2 = a2 ? o2.getCameraQueryGeometry(e2) : e2, l2 = (e3) => o2.screenPointToMercatorCoordinate(e3, this.terrain), c2 = this.transformBbox(e2, l2, !s2), h2 = this.transformBbox(n2, l2, !s2), u2 = this.getIds(), d2 = t.ac.fromPoints(h2);
            for (let e3 = 0; e3 < u2.length; e3++) {
              const a3 = this._inViewTiles.getTileById(u2[e3]);
              if (a3.holdingForSymbolFade()) continue;
              const n3 = s2 ? [a3.tileID] : [a3.tileID.unwrapTo(-1), a3.tileID.unwrapTo(0)], l3 = Math.pow(2, o2.zoom - a3.tileID.overscaledZ), _2 = i2 * a3.queryPadding * t.a5 / a3.tileSize / l3;
              for (const e4 of n3) {
                const i3 = d2.map((i4) => e4.getTilePoint(new t.ab(i4.x, i4.y)));
                if (i3.expandBy(_2), i3.intersects(Me)) {
                  const t2 = c2.map((t3) => e4.getTilePoint(t3)), i4 = h2.map((t3) => e4.getTilePoint(t3));
                  r2.push({ tile: a3, tileID: s2 ? e4 : e4.unwrapTo(0), queryGeometry: t2, cameraQueryGeometry: i4, scale: l3 });
                }
              }
            }
            return r2;
          }
          transformBbox(e2, i2, a2) {
            let r2 = e2.map(i2);
            if (a2) {
              const a3 = t.ac.fromPoints(e2);
              a3.shrinkBy(1e-3 * Math.min(a3.width(), a3.height()));
              const o2 = a3.map(i2);
              t.ac.fromPoints(r2).covers(o2) || (r2 = r2.map((e3) => e3.x > 0.5 ? new t.ab(e3.x - 1, e3.y, e3.z) : e3));
            }
            return r2;
          }
          getVisibleCoordinates(e2) {
            const t2 = this.getRenderableIds(e2).map((e3) => this._inViewTiles.getTileById(e3).tileID);
            return this.transform && this.transform.populateCache(t2), t2;
          }
          hasTransition() {
            return !!this._source.hasTransition() || !(!Ee(this._source.type) || !function(e2, t2) {
              if (t2 <= 0) return false;
              const i2 = c();
              for (const t3 of e2.getAllTiles()) if (t3.fadeEndTime >= i2) return true;
              return false;
            }(this._inViewTiles, this._rasterFadeDuration));
          }
          setRasterFadeDuration(e2) {
            this._rasterFadeDuration = e2;
          }
          setFeatureState(e2, i2, a2) {
            this._state.updateState(e2 = e2 || t.aa, i2, a2);
          }
          removeFeatureState(e2, i2, a2) {
            this._state.removeFeatureState(e2 = e2 || t.aa, i2, a2);
          }
          getFeatureState(e2, i2) {
            return this._state.getState(e2 = e2 || t.aa, i2);
          }
          setDependencies(e2, t2, i2) {
            const a2 = this._inViewTiles.getTileById(e2);
            a2 && a2.setDependencies(t2, i2);
          }
          reloadTilesForDependencies(e2, t2) {
            for (const i2 of this._inViewTiles.getAllIds()) this._inViewTiles.getTileById(i2).hasDependency(e2, t2) && this._reloadTile(i2, "reloading");
            this._outOfViewCache.filter((i2) => !i2.hasDependency(e2, t2));
          }
          areTilesLoaded() {
            for (const e2 of this._inViewTiles.getAllTiles()) if ("loaded" !== e2.state && "errored" !== e2.state) return false;
            return true;
          }
        }
        ke.maxUnderzooming = 10, ke.maxOverzooming = 3;
        class Fe {
          constructor(e2, t2) {
            this.reset(e2, t2);
          }
          reset(e2, t2) {
            this.points = e2 || [], this._distances = [0];
            for (let e3 = 1; e3 < this.points.length; e3++) this._distances[e3] = this._distances[e3 - 1] + this.points[e3].dist(this.points[e3 - 1]);
            this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t2 || 0, 0.5 * this.length), this.paddedLength = this.length - 2 * this.padding;
          }
          lerp(e2) {
            if (1 === this.points.length) return this.points[0];
            e2 = t.ao(e2, 0, 1);
            let i2 = 1, a2 = this._distances[i2];
            const r2 = e2 * this.paddedLength + this.padding;
            for (; a2 < r2 && i2 < this._distances.length; ) a2 = this._distances[++i2];
            const o2 = i2 - 1, s2 = this._distances[o2], n2 = a2 - s2, l2 = n2 > 0 ? (r2 - s2) / n2 : 0;
            return this.points[o2].mult(1 - l2).add(this.points[i2].mult(l2));
          }
        }
        function Be(e2, t2) {
          let i2 = true;
          return "always" === e2 || "never" !== e2 && "never" !== t2 || (i2 = false), i2;
        }
        class Oe {
          constructor(e2, t2, i2) {
            const a2 = this.boxCells = [], r2 = this.circleCells = [];
            this.xCellCount = Math.ceil(e2 / i2), this.yCellCount = Math.ceil(t2 / i2);
            for (let e3 = 0; e3 < this.xCellCount * this.yCellCount; e3++) a2.push([]), r2.push([]);
            this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e2, this.height = t2, this.xScale = this.xCellCount / e2, this.yScale = this.yCellCount / t2, this.boxUid = 0, this.circleUid = 0;
          }
          keysLength() {
            return this.boxKeys.length + this.circleKeys.length;
          }
          insert(e2, t2, i2, a2, r2) {
            this._forEachCell(t2, i2, a2, r2, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e2), this.bboxes.push(t2), this.bboxes.push(i2), this.bboxes.push(a2), this.bboxes.push(r2);
          }
          insertCircle(e2, t2, i2, a2) {
            this._forEachCell(t2 - a2, i2 - a2, t2 + a2, i2 + a2, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e2), this.circles.push(t2), this.circles.push(i2), this.circles.push(a2);
          }
          _insertBoxCell(e2, t2, i2, a2, r2, o2) {
            this.boxCells[r2].push(o2);
          }
          _insertCircleCell(e2, t2, i2, a2, r2, o2) {
            this.circleCells[r2].push(o2);
          }
          _query(e2, t2, i2, a2, r2, o2, s2) {
            if (i2 < 0 || e2 > this.width || a2 < 0 || t2 > this.height) return [];
            const n2 = [];
            if (e2 <= 0 && t2 <= 0 && this.width <= i2 && this.height <= a2) {
              if (r2) return [{ key: null, x1: e2, y1: t2, x2: i2, y2: a2 }];
              for (let e3 = 0; e3 < this.boxKeys.length; e3++) n2.push({ key: this.boxKeys[e3], x1: this.bboxes[4 * e3], y1: this.bboxes[4 * e3 + 1], x2: this.bboxes[4 * e3 + 2], y2: this.bboxes[4 * e3 + 3] });
              for (let e3 = 0; e3 < this.circleKeys.length; e3++) {
                const t3 = this.circles[3 * e3], i3 = this.circles[3 * e3 + 1], a3 = this.circles[3 * e3 + 2];
                n2.push({ key: this.circleKeys[e3], x1: t3 - a3, y1: i3 - a3, x2: t3 + a3, y2: i3 + a3 });
              }
            } else this._forEachCell(e2, t2, i2, a2, this._queryCell, n2, { hitTest: r2, overlapMode: o2, seenUids: { box: {}, circle: {} } }, s2);
            return n2;
          }
          query(e2, t2, i2, a2) {
            return this._query(e2, t2, i2, a2, false, null);
          }
          hitTest(e2, t2, i2, a2, r2, o2) {
            return this._query(e2, t2, i2, a2, true, r2, o2).length > 0;
          }
          hitTestCircle(e2, t2, i2, a2, r2) {
            const o2 = e2 - i2, s2 = e2 + i2, n2 = t2 - i2, l2 = t2 + i2;
            if (s2 < 0 || o2 > this.width || l2 < 0 || n2 > this.height) return false;
            const c2 = [];
            return this._forEachCell(o2, n2, s2, l2, this._queryCellCircle, c2, { hitTest: true, overlapMode: a2, circle: { x: e2, y: t2, radius: i2 }, seenUids: { box: {}, circle: {} } }, r2), c2.length > 0;
          }
          _queryCell(e2, t2, i2, a2, r2, o2, s2, n2) {
            const { seenUids: l2, hitTest: c2, overlapMode: h2 } = s2, u2 = this.boxCells[r2];
            if (null !== u2) {
              const r3 = this.bboxes;
              for (const s3 of u2) if (!l2.box[s3]) {
                l2.box[s3] = true;
                const u3 = 4 * s3, d3 = this.boxKeys[s3];
                if (e2 <= r3[u3 + 2] && t2 <= r3[u3 + 3] && i2 >= r3[u3 + 0] && a2 >= r3[u3 + 1] && (!n2 || n2(d3)) && (!c2 || !Be(h2, d3.overlapMode)) && (o2.push({ key: d3, x1: r3[u3], y1: r3[u3 + 1], x2: r3[u3 + 2], y2: r3[u3 + 3] }), c2)) return true;
              }
            }
            const d2 = this.circleCells[r2];
            if (null !== d2) {
              const r3 = this.circles;
              for (const s3 of d2) if (!l2.circle[s3]) {
                l2.circle[s3] = true;
                const u3 = 3 * s3, d3 = this.circleKeys[s3];
                if (this._circleAndRectCollide(r3[u3], r3[u3 + 1], r3[u3 + 2], e2, t2, i2, a2) && (!n2 || n2(d3)) && (!c2 || !Be(h2, d3.overlapMode))) {
                  const e3 = r3[u3], t3 = r3[u3 + 1], i3 = r3[u3 + 2];
                  if (o2.push({ key: d3, x1: e3 - i3, y1: t3 - i3, x2: e3 + i3, y2: t3 + i3 }), c2) return true;
                }
              }
            }
            return false;
          }
          _queryCellCircle(e2, t2, i2, a2, r2, o2, s2, n2) {
            const { circle: l2, seenUids: c2, overlapMode: h2 } = s2, u2 = this.boxCells[r2];
            if (null !== u2) {
              const e3 = this.bboxes;
              for (const t3 of u2) if (!c2.box[t3]) {
                c2.box[t3] = true;
                const i3 = 4 * t3, a3 = this.boxKeys[t3];
                if (this._circleAndRectCollide(l2.x, l2.y, l2.radius, e3[i3 + 0], e3[i3 + 1], e3[i3 + 2], e3[i3 + 3]) && (!n2 || n2(a3)) && !Be(h2, a3.overlapMode)) return o2.push(true), true;
              }
            }
            const d2 = this.circleCells[r2];
            if (null !== d2) {
              const e3 = this.circles;
              for (const t3 of d2) if (!c2.circle[t3]) {
                c2.circle[t3] = true;
                const i3 = 3 * t3, a3 = this.circleKeys[t3];
                if (this._circlesCollide(e3[i3], e3[i3 + 1], e3[i3 + 2], l2.x, l2.y, l2.radius) && (!n2 || n2(a3)) && !Be(h2, a3.overlapMode)) return o2.push(true), true;
              }
            }
          }
          _forEachCell(e2, t2, i2, a2, r2, o2, s2, n2) {
            const l2 = this._convertToXCellCoord(e2), c2 = this._convertToYCellCoord(t2), h2 = this._convertToXCellCoord(i2), u2 = this._convertToYCellCoord(a2);
            for (let d2 = l2; d2 <= h2; d2++) for (let l3 = c2; l3 <= u2; l3++) if (r2.call(this, e2, t2, i2, a2, this.xCellCount * l3 + d2, o2, s2, n2)) return;
          }
          _convertToXCellCoord(e2) {
            return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e2 * this.xScale)));
          }
          _convertToYCellCoord(e2) {
            return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e2 * this.yScale)));
          }
          _circlesCollide(e2, t2, i2, a2, r2, o2) {
            const s2 = a2 - e2, n2 = r2 - t2, l2 = i2 + o2;
            return l2 * l2 > s2 * s2 + n2 * n2;
          }
          _circleAndRectCollide(e2, t2, i2, a2, r2, o2, s2) {
            const n2 = (o2 - a2) / 2, l2 = Math.abs(e2 - (a2 + n2));
            if (l2 > n2 + i2) return false;
            const c2 = (s2 - r2) / 2, h2 = Math.abs(t2 - (r2 + c2));
            if (h2 > c2 + i2) return false;
            if (l2 <= n2 || h2 <= c2) return true;
            const u2 = l2 - n2, d2 = h2 - c2;
            return u2 * u2 + d2 * d2 <= i2 * i2;
          }
        }
        function je(e2, i2, r2) {
          const o2 = t.N();
          if (!e2) {
            const { vecSouth: e3, vecEast: t2 } = Ze(i2), r3 = a();
            r3[0] = t2[0], r3[1] = t2[1], r3[2] = e3[0], r3[3] = e3[1], s2 = r3, (d2 = (l2 = (n2 = r3)[0]) * (u2 = n2[3]) - (h2 = n2[2]) * (c2 = n2[1])) && (s2[0] = u2 * (d2 = 1 / d2), s2[1] = -c2 * d2, s2[2] = -h2 * d2, s2[3] = l2 * d2), o2[0] = r3[0], o2[1] = r3[1], o2[4] = r3[2], o2[5] = r3[3];
          }
          var s2, n2, l2, c2, h2, u2, d2;
          return t.Q(o2, o2, [1 / r2, 1 / r2, 1]), o2;
        }
        function Ne(e2, i2, a2, r2) {
          if (e2) {
            const e3 = t.N();
            if (!i2) {
              const { vecSouth: t2, vecEast: i3 } = Ze(a2);
              e3[0] = i3[0], e3[1] = i3[1], e3[4] = t2[0], e3[5] = t2[1];
            }
            return t.Q(e3, e3, [r2, r2, 1]), e3;
          }
          return a2.pixelsToClipSpaceMatrix;
        }
        function Ze(e2) {
          const i2 = Math.cos(e2.rollInRadians), a2 = Math.sin(e2.rollInRadians), r2 = Math.cos(e2.pitchInRadians), o2 = Math.cos(e2.bearingInRadians), s2 = Math.sin(e2.bearingInRadians), n2 = t.aD();
          n2[0] = -o2 * r2 * a2 - s2 * i2, n2[1] = -s2 * r2 * a2 + o2 * i2;
          const l2 = t.aE(n2);
          l2 < 1e-9 ? t.aF(n2) : t.aG(n2, n2, 1 / l2);
          const c2 = t.aD();
          c2[0] = o2 * r2 * i2 - s2 * a2, c2[1] = s2 * r2 * i2 + o2 * a2;
          const h2 = t.aE(c2);
          return h2 < 1e-9 ? t.aF(c2) : t.aG(c2, c2, 1 / h2), { vecEast: c2, vecSouth: n2 };
        }
        function Ge(e2, i2, a2, r2) {
          let o2;
          r2 ? (o2 = [e2, i2, r2(e2, i2), 1], t.aI(o2, o2, a2)) : (o2 = [e2, i2, 0, 1], ot(o2, o2, a2));
          const s2 = o2[3];
          return { point: new t.P(o2[0] / s2, o2[1] / s2), signedDistanceFromCamera: s2, isOccluded: false };
        }
        function Ue(e2, t2) {
          return 0.5 + e2 / t2 * 0.5;
        }
        function Ve(e2, t2) {
          return e2.x >= -t2[0] && e2.x <= t2[0] && e2.y >= -t2[1] && e2.y <= t2[1];
        }
        function qe(e2, i2, a2, r2, o2, s2, n2, l2, c2, h2, u2, d2, _2) {
          const p2 = a2 ? e2.textSizeData : e2.iconSizeData, m2 = t.az(p2, i2.transform.zoom), f2 = [256 / i2.width * 2 + 1, 256 / i2.height * 2 + 1], g2 = a2 ? e2.text.dynamicLayoutVertexArray : e2.icon.dynamicLayoutVertexArray;
          g2.clear();
          const v2 = e2.lineVertexArray, x2 = a2 ? e2.text.placedSymbolArray : e2.icon.placedSymbolArray, b2 = i2.transform.width / i2.transform.height;
          let y2 = false;
          for (let a3 = 0; a3 < x2.length; a3++) {
            const w2 = x2.get(a3);
            if (w2.hidden || w2.writingMode === t.aA.vertical && !y2) {
              rt(w2.numGlyphs, g2);
              continue;
            }
            y2 = false;
            const T2 = new t.P(w2.anchorX, w2.anchorY), P2 = { getElevation: _2, pitchedLabelPlaneMatrix: r2, lineVertexArray: v2, pitchWithMap: s2, projectionCache: { projections: {}, offsets: {}, cachedAnchorPoint: void 0, anyProjectionOccluded: false }, transform: i2.transform, tileAnchorPoint: T2, unwrappedTileID: c2, width: h2, height: u2, translation: d2 }, I2 = Je(w2.anchorX, w2.anchorY, P2);
            if (!Ve(I2.point, f2)) {
              rt(w2.numGlyphs, g2);
              continue;
            }
            const C2 = Ue(i2.transform.cameraToCenterDistance, I2.signedDistanceFromCamera), M2 = t.aB(p2, m2, w2), E2 = s2 ? M2 * i2.transform.getPitchedTextCorrection(w2.anchorX, w2.anchorY, c2) / C2 : M2 * C2, S2 = He({ projectionContext: P2, pitchedLabelPlaneMatrixInverse: o2, symbol: w2, fontSize: E2, flip: false, keepUpright: n2, glyphOffsetArray: e2.glyphOffsetArray, dynamicLayoutVertexArray: g2, aspectRatio: b2, rotateToLine: l2 });
            y2 = S2.useVertical, (S2.notEnoughRoom || y2 || S2.needsFlipping && He({ projectionContext: P2, pitchedLabelPlaneMatrixInverse: o2, symbol: w2, fontSize: E2, flip: true, keepUpright: n2, glyphOffsetArray: e2.glyphOffsetArray, dynamicLayoutVertexArray: g2, aspectRatio: b2, rotateToLine: l2 }).notEnoughRoom) && rt(w2.numGlyphs, g2);
          }
          a2 ? e2.text.dynamicLayoutVertexBuffer.updateData(g2) : e2.icon.dynamicLayoutVertexBuffer.updateData(g2);
        }
        function We(e2, t2, i2, a2, r2, o2, s2, n2) {
          const l2 = o2.glyphStartIndex + o2.numGlyphs, c2 = o2.lineStartIndex, h2 = o2.lineStartIndex + o2.lineLength, u2 = t2.getoffsetX(o2.glyphStartIndex), d2 = t2.getoffsetX(l2 - 1), _2 = it(e2 * u2, i2, a2, r2, o2.segment, c2, h2, n2, s2);
          if (!_2) return null;
          const p2 = it(e2 * d2, i2, a2, r2, o2.segment, c2, h2, n2, s2);
          return p2 ? n2.projectionCache.anyProjectionOccluded ? null : { first: _2, last: p2 } : null;
        }
        function $e(e2, i2, a2, r2) {
          return e2 === t.aA.horizontal && Math.abs(a2.y - i2.y) > Math.abs(a2.x - i2.x) * r2 ? { useVertical: true } : (e2 === t.aA.vertical ? i2.y < a2.y : i2.x > a2.x) ? { needsFlipping: true } : null;
        }
        function He(e2) {
          const { projectionContext: i2, pitchedLabelPlaneMatrixInverse: a2, symbol: r2, fontSize: o2, flip: s2, keepUpright: n2, glyphOffsetArray: l2, dynamicLayoutVertexArray: c2, aspectRatio: h2, rotateToLine: u2 } = e2, d2 = o2 / 24, _2 = r2.lineOffsetX * d2, p2 = r2.lineOffsetY * d2;
          let m2;
          if (r2.numGlyphs > 1) {
            const e3 = r2.glyphStartIndex + r2.numGlyphs, t2 = r2.lineStartIndex, o3 = r2.lineStartIndex + r2.lineLength, c3 = We(d2, l2, _2, p2, s2, r2, u2, i2);
            if (!c3) return { notEnoughRoom: true };
            const f2 = Qe(c3.first.point.x, c3.first.point.y, i2, a2), g2 = Qe(c3.last.point.x, c3.last.point.y, i2, a2);
            if (n2 && !s2) {
              const e4 = $e(r2.writingMode, f2, g2, h2);
              if (e4) return e4;
            }
            m2 = [c3.first];
            for (let a3 = r2.glyphStartIndex + 1; a3 < e3 - 1; a3++) {
              const e4 = it(d2 * l2.getoffsetX(a3), _2, p2, s2, r2.segment, t2, o3, i2, u2);
              if (!e4) return { notEnoughRoom: true };
              m2.push(e4);
            }
            m2.push(c3.last);
          } else {
            if (n2 && !s2) {
              const e4 = Ye(i2.tileAnchorPoint.x, i2.tileAnchorPoint.y, i2).point, o3 = r2.lineStartIndex + r2.segment + 1, s3 = new t.P(i2.lineVertexArray.getx(o3), i2.lineVertexArray.gety(o3)), n3 = Ye(s3.x, s3.y, i2), l3 = n3.signedDistanceFromCamera > 0 ? n3.point : Xe(i2.tileAnchorPoint, s3, e4, 1, i2), c3 = Qe(e4.x, e4.y, i2, a2), u3 = Qe(l3.x, l3.y, i2, a2), d3 = $e(r2.writingMode, c3, u3, h2);
              if (d3) return d3;
            }
            const e3 = it(d2 * l2.getoffsetX(r2.glyphStartIndex), _2, p2, s2, r2.segment, r2.lineStartIndex, r2.lineStartIndex + r2.lineLength, i2, u2);
            if (!e3 || i2.projectionCache.anyProjectionOccluded) return { notEnoughRoom: true };
            m2 = [e3];
          }
          for (const e3 of m2) t.aH(c2, e3.point, e3.angle);
          return {};
        }
        function Xe(e2, t2, i2, a2, r2) {
          const o2 = e2.add(e2.sub(t2)._unit()), s2 = Ye(o2.x, o2.y, r2).point, n2 = i2.sub(s2);
          return i2.add(n2._mult(a2 / n2.mag()));
        }
        function Ke(e2, i2, a2) {
          const r2 = i2.projectionCache;
          if (r2.projections[e2]) return r2.projections[e2];
          const o2 = new t.P(i2.lineVertexArray.getx(e2), i2.lineVertexArray.gety(e2)), s2 = Ye(o2.x, o2.y, i2);
          if (s2.signedDistanceFromCamera > 0) return r2.projections[e2] = s2.point, r2.anyProjectionOccluded = r2.anyProjectionOccluded || s2.isOccluded, s2.point;
          const n2 = e2 - a2.direction;
          return Xe(0 === a2.distanceFromAnchor ? i2.tileAnchorPoint : new t.P(i2.lineVertexArray.getx(n2), i2.lineVertexArray.gety(n2)), o2, a2.previousVertex, a2.absOffsetX - a2.distanceFromAnchor + 1, i2);
        }
        function Ye(e2, t2, i2) {
          const a2 = e2 + i2.translation[0], r2 = t2 + i2.translation[1];
          let o2;
          return i2.pitchWithMap ? (o2 = Ge(a2, r2, i2.pitchedLabelPlaneMatrix, i2.getElevation), o2.isOccluded = false) : (o2 = i2.transform.projectTileCoordinates(a2, r2, i2.unwrappedTileID, i2.getElevation), o2.point.x = (0.5 * o2.point.x + 0.5) * i2.width, o2.point.y = (0.5 * -o2.point.y + 0.5) * i2.height), o2;
        }
        function Qe(e2, i2, a2, r2) {
          if (a2.pitchWithMap) {
            const o2 = [e2, i2, 0, 1];
            return t.aI(o2, o2, r2), a2.transform.projectTileCoordinates(o2[0] / o2[3], o2[1] / o2[3], a2.unwrappedTileID, a2.getElevation).point;
          }
          return { x: e2 / a2.width * 2 - 1, y: 1 - i2 / a2.height * 2 };
        }
        function Je(e2, t2, i2) {
          return i2.transform.projectTileCoordinates(e2, t2, i2.unwrappedTileID, i2.getElevation);
        }
        function et(e2, t2, i2) {
          return e2._unit()._perp()._mult(t2 * i2);
        }
        function tt(e2, i2, a2, r2, o2, s2, n2, l2, c2) {
          if (l2.projectionCache.offsets[e2]) return l2.projectionCache.offsets[e2];
          const h2 = a2.add(i2);
          if (e2 + c2.direction < r2 || e2 + c2.direction >= o2) return l2.projectionCache.offsets[e2] = h2, h2;
          const u2 = Ke(e2 + c2.direction, l2, c2), d2 = et(u2.sub(a2), n2, c2.direction), _2 = a2.add(d2), p2 = u2.add(d2);
          return l2.projectionCache.offsets[e2] = t.aJ(s2, h2, _2, p2) || h2, l2.projectionCache.offsets[e2];
        }
        function it(e2, t2, i2, a2, r2, o2, s2, n2, l2) {
          const c2 = a2 ? e2 - t2 : e2 + t2;
          let h2 = c2 > 0 ? 1 : -1, u2 = 0;
          a2 && (h2 *= -1, u2 = Math.PI), h2 < 0 && (u2 += Math.PI);
          let d2, _2 = h2 > 0 ? o2 + r2 : o2 + r2 + 1;
          n2.projectionCache.cachedAnchorPoint ? d2 = n2.projectionCache.cachedAnchorPoint : (d2 = Ye(n2.tileAnchorPoint.x, n2.tileAnchorPoint.y, n2).point, n2.projectionCache.cachedAnchorPoint = d2);
          let p2, m2, f2 = d2, g2 = d2, v2 = 0, x2 = 0;
          const b2 = Math.abs(c2), y2 = [];
          let w2;
          for (; v2 + x2 <= b2; ) {
            if (_2 += h2, _2 < o2 || _2 >= s2) return null;
            v2 += x2, g2 = f2, m2 = p2;
            const e3 = { absOffsetX: b2, direction: h2, distanceFromAnchor: v2, previousVertex: g2 };
            if (f2 = Ke(_2, n2, e3), 0 === i2) y2.push(g2), w2 = f2.sub(g2);
            else {
              let t3;
              const a3 = f2.sub(g2);
              t3 = 0 === a3.mag() ? et(Ke(_2 + h2, n2, e3).sub(f2), i2, h2) : et(a3, i2, h2), m2 || (m2 = g2.add(t3)), p2 = tt(_2, t3, f2, o2, s2, m2, i2, n2, e3), y2.push(m2), w2 = p2.sub(m2);
            }
            x2 = w2.mag();
          }
          const T2 = w2._mult((b2 - v2) / x2)._add(m2 || g2), P2 = u2 + Math.atan2(f2.y - g2.y, f2.x - g2.x);
          return y2.push(T2), { point: T2, angle: l2 ? P2 : 0, path: y2 };
        }
        const at = new Float32Array([-1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0]);
        function rt(e2, t2) {
          for (let i2 = 0; i2 < e2; i2++) {
            const e3 = t2.length;
            t2.resize(e3 + 4), t2.float32.set(at, 3 * e3);
          }
        }
        function ot(e2, t2, i2) {
          const a2 = t2[0], r2 = t2[1];
          return e2[0] = i2[0] * a2 + i2[4] * r2 + i2[12], e2[1] = i2[1] * a2 + i2[5] * r2 + i2[13], e2[3] = i2[3] * a2 + i2[7] * r2 + i2[15], e2;
        }
        const st = 100;
        class nt {
          constructor(e2, t2 = new Oe(e2.width + 200, e2.height + 200, 25), i2 = new Oe(e2.width + 200, e2.height + 200, 25)) {
            this.transform = e2, this.grid = t2, this.ignoredGrid = i2, this.pitchFactor = Math.cos(e2.pitch * Math.PI / 180) * e2.cameraToCenterDistance, this.screenRightBoundary = e2.width + st, this.screenBottomBoundary = e2.height + st, this.gridRightBoundary = e2.width + 200, this.gridBottomBoundary = e2.height + 200, this.perspectiveRatioCutoff = 0.6;
          }
          placeCollisionBox(e2, t2, i2, a2, r2, o2, s2, n2, l2, c2, h2, u2) {
            const d2 = this.projectAndGetPerspectiveRatio(e2.anchorPointX + n2[0], e2.anchorPointY + n2[1], r2, c2, u2), _2 = i2 * d2.perspectiveRatio;
            let p2;
            if (o2 || s2) p2 = this._projectCollisionBox(e2, _2, a2, r2, o2, s2, n2, d2, c2, h2, u2);
            else {
              const t3 = d2.x + (h2 ? h2.x * _2 : 0), i3 = d2.y + (h2 ? h2.y * _2 : 0);
              p2 = { allPointsOccluded: false, box: [t3 + e2.x1 * _2, i3 + e2.y1 * _2, t3 + e2.x2 * _2, i3 + e2.y2 * _2] };
            }
            const [m2, f2, g2, v2] = p2.box, x2 = o2 ? p2.allPointsOccluded : d2.isOccluded;
            let b2 = x2;
            return b2 || (b2 = d2.perspectiveRatio < this.perspectiveRatioCutoff), b2 || (b2 = !this.isInsideGrid(m2, f2, g2, v2)), b2 || "always" !== t2 && this.grid.hitTest(m2, f2, g2, v2, t2, l2) ? { box: [m2, f2, g2, v2], placeable: false, offscreen: false, occluded: x2 } : { box: [m2, f2, g2, v2], placeable: true, offscreen: this.isOffscreen(m2, f2, g2, v2), occluded: x2 };
          }
          placeCollisionCircles(e2, i2, a2, r2, o2, s2, n2, l2, c2, h2, u2, d2, _2, p2) {
            const m2 = [], f2 = new t.P(i2.anchorX, i2.anchorY), g2 = this.getPerspectiveRatio(f2.x, f2.y, s2, p2), v2 = (c2 ? o2 * this.transform.getPitchedTextCorrection(i2.anchorX, i2.anchorY, s2) / g2 : o2 * g2) / t.aN, x2 = { getElevation: p2, pitchedLabelPlaneMatrix: n2, lineVertexArray: a2, pitchWithMap: c2, projectionCache: { projections: {}, offsets: {}, cachedAnchorPoint: void 0, anyProjectionOccluded: false }, transform: this.transform, tileAnchorPoint: f2, unwrappedTileID: s2, width: this.transform.width, height: this.transform.height, translation: _2 }, b2 = We(v2, r2, i2.lineOffsetX * v2, i2.lineOffsetY * v2, false, i2, false, x2);
            let y2 = false, w2 = false, T2 = true;
            if (b2) {
              const i3 = 0.5 * u2 * g2 + d2, a3 = new t.P(-100, -100), r3 = new t.P(this.screenRightBoundary, this.screenBottomBoundary), o3 = new Fe(), s3 = b2.first, n3 = b2.last;
              let _3 = [];
              for (let e3 = s3.path.length - 1; e3 >= 1; e3--) _3.push(s3.path[e3]);
              for (let e3 = 1; e3 < n3.path.length; e3++) _3.push(n3.path[e3]);
              const p3 = 2.5 * i3;
              if (c2) {
                const e3 = this.projectPathToScreenSpace(_3, x2);
                _3 = e3.some((e4) => e4.signedDistanceFromCamera <= 0) ? [] : e3.map((e4) => e4.point);
              }
              let f3 = [];
              if (_3.length > 0) {
                const e3 = _3[0].clone(), i4 = _3[0].clone();
                for (let t2 = 1; t2 < _3.length; t2++) e3.x = Math.min(e3.x, _3[t2].x), e3.y = Math.min(e3.y, _3[t2].y), i4.x = Math.max(i4.x, _3[t2].x), i4.y = Math.max(i4.y, _3[t2].y);
                f3 = e3.x >= a3.x && i4.x <= r3.x && e3.y >= a3.y && i4.y <= r3.y ? [_3] : i4.x < a3.x || e3.x > r3.x || i4.y < a3.y || e3.y > r3.y ? [] : t.aK([_3], a3.x, a3.y, r3.x, r3.y);
              }
              for (const t2 of f3) {
                o3.reset(t2, 0.25 * i3);
                let a4 = 0;
                a4 = o3.length <= 0.5 * i3 ? 1 : Math.ceil(o3.paddedLength / p3) + 1;
                for (let t3 = 0; t3 < a4; t3++) {
                  const r4 = t3 / Math.max(a4 - 1, 1), s4 = o3.lerp(r4), n4 = s4.x + st, c3 = s4.y + st;
                  m2.push(n4, c3, i3, 0);
                  const u3 = n4 - i3, d3 = c3 - i3, _4 = n4 + i3, p4 = c3 + i3;
                  if (T2 = T2 && this.isOffscreen(u3, d3, _4, p4), w2 = w2 || this.isInsideGrid(u3, d3, _4, p4), "always" !== e2 && this.grid.hitTestCircle(n4, c3, i3, e2, h2) && (y2 = true, !l2)) return { circles: [], offscreen: false, collisionDetected: y2 };
                }
              }
            }
            return { circles: !l2 && y2 || !w2 || g2 < this.perspectiveRatioCutoff ? [] : m2, offscreen: T2, collisionDetected: y2 };
          }
          projectPathToScreenSpace(e2, i2) {
            const a2 = function(e3, i3) {
              const a3 = t.N();
              return t.aC(a3, i3.pitchedLabelPlaneMatrix), e3.map((e4) => {
                const t2 = Ge(e4.x, e4.y, a3, i3.getElevation), r2 = i3.transform.projectTileCoordinates(t2.point.x, t2.point.y, i3.unwrappedTileID, i3.getElevation);
                return r2.point.x = (0.5 * r2.point.x + 0.5) * i3.width, r2.point.y = (0.5 * -r2.point.y + 0.5) * i3.height, r2;
              });
            }(e2, i2);
            return function(e3) {
              let t2 = 0, i3 = 0, a3 = 0, r2 = 0;
              for (let o2 = 0; o2 < e3.length; o2++) e3[o2].isOccluded ? (a3 = o2 + 1, r2 = 0) : (r2++, r2 > i3 && (i3 = r2, t2 = a3));
              return e3.slice(t2, t2 + i3);
            }(a2);
          }
          queryRenderedSymbols(e2) {
            if (0 === e2.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
            const i2 = [], a2 = new t.ac();
            for (const r3 of e2) {
              const e3 = new t.P(r3.x + st, r3.y + st);
              a2.extend(e3), i2.push(e3);
            }
            const { minX: r2, minY: o2, maxX: s2, maxY: n2 } = a2, l2 = this.grid.query(r2, o2, s2, n2).concat(this.ignoredGrid.query(r2, o2, s2, n2)), c2 = {}, h2 = {};
            for (const e3 of l2) {
              const a3 = e3.key;
              if (void 0 === c2[a3.bucketInstanceId] && (c2[a3.bucketInstanceId] = {}), c2[a3.bucketInstanceId][a3.featureIndex]) continue;
              const r3 = [new t.P(e3.x1, e3.y1), new t.P(e3.x2, e3.y1), new t.P(e3.x2, e3.y2), new t.P(e3.x1, e3.y2)];
              t.aL(i2, r3) && (c2[a3.bucketInstanceId][a3.featureIndex] = true, void 0 === h2[a3.bucketInstanceId] && (h2[a3.bucketInstanceId] = []), h2[a3.bucketInstanceId].push(a3.featureIndex));
            }
            return h2;
          }
          insertCollisionBox(e2, t2, i2, a2, r2, o2) {
            (i2 ? this.ignoredGrid : this.grid).insert({ bucketInstanceId: a2, featureIndex: r2, collisionGroupID: o2, overlapMode: t2 }, e2[0], e2[1], e2[2], e2[3]);
          }
          insertCollisionCircles(e2, t2, i2, a2, r2, o2) {
            const s2 = i2 ? this.ignoredGrid : this.grid, n2 = { bucketInstanceId: a2, featureIndex: r2, collisionGroupID: o2, overlapMode: t2 };
            for (let t3 = 0; t3 < e2.length; t3 += 4) s2.insertCircle(n2, e2[t3], e2[t3 + 1], e2[t3 + 2]);
          }
          projectAndGetPerspectiveRatio(e2, i2, a2, r2, o2) {
            if (o2) {
              let a3;
              r2 ? (a3 = [e2, i2, r2(e2, i2), 1], t.aI(a3, a3, o2)) : (a3 = [e2, i2, 0, 1], ot(a3, a3, o2));
              const s2 = a3[3];
              return { x: (a3[0] / s2 + 1) / 2 * this.transform.width + st, y: (-a3[1] / s2 + 1) / 2 * this.transform.height + st, perspectiveRatio: 0.5 + this.transform.cameraToCenterDistance / s2 * 0.5, isOccluded: false, signedDistanceFromCamera: s2 };
            }
            {
              const t2 = this.transform.projectTileCoordinates(e2, i2, a2, r2);
              return { x: (t2.point.x + 1) / 2 * this.transform.width + st, y: (1 - t2.point.y) / 2 * this.transform.height + st, perspectiveRatio: 0.5 + this.transform.cameraToCenterDistance / t2.signedDistanceFromCamera * 0.5, isOccluded: t2.isOccluded, signedDistanceFromCamera: t2.signedDistanceFromCamera };
            }
          }
          getPerspectiveRatio(e2, t2, i2, a2) {
            const r2 = this.transform.projectTileCoordinates(e2, t2, i2, a2);
            return 0.5 + this.transform.cameraToCenterDistance / r2.signedDistanceFromCamera * 0.5;
          }
          isOffscreen(e2, t2, i2, a2) {
            return i2 < st || e2 >= this.screenRightBoundary || a2 < st || t2 > this.screenBottomBoundary;
          }
          isInsideGrid(e2, t2, i2, a2) {
            return i2 >= 0 && e2 < this.gridRightBoundary && a2 >= 0 && t2 < this.gridBottomBoundary;
          }
          getViewportMatrix() {
            const e2 = t.as([]);
            return t.O(e2, e2, [-100, -100, 0]), e2;
          }
          _projectCollisionBox(e2, i2, a2, r2, o2, s2, n2, l2, c2, h2, u2) {
            let d2 = 1, _2 = 0, p2 = 0, m2 = 1;
            const f2 = e2.anchorPointX + n2[0], g2 = e2.anchorPointY + n2[1];
            if (s2 && !o2) {
              const e3 = this.projectAndGetPerspectiveRatio(f2 + 1, g2, r2, c2, u2), t2 = e3.x - l2.x, i3 = Math.atan((e3.y - l2.y) / t2) + (t2 < 0 ? Math.PI : 0), a3 = Math.sin(i3), o3 = Math.cos(i3);
              d2 = o3, _2 = a3, p2 = -a3, m2 = o3;
            } else if (!s2 && o2) {
              const e3 = Ze(this.transform);
              d2 = e3.vecEast[0], _2 = e3.vecEast[1], p2 = e3.vecSouth[0], m2 = e3.vecSouth[1];
            }
            let v2 = l2.x, x2 = l2.y, b2 = i2;
            o2 && (v2 = f2, x2 = g2, b2 = Math.pow(2, -(this.transform.zoom - a2.overscaledZ)), b2 *= this.transform.getPitchedTextCorrection(f2, g2, r2), h2 || (b2 *= t.ao(0.5 + l2.signedDistanceFromCamera / this.transform.cameraToCenterDistance * 0.5, 0, 4))), h2 && (v2 += d2 * h2.x * b2 + p2 * h2.y * b2, x2 += _2 * h2.x * b2 + m2 * h2.y * b2);
            const y2 = e2.x1 * b2, w2 = e2.x2 * b2, T2 = (y2 + w2) / 2, P2 = e2.y1 * b2, I2 = e2.y2 * b2, C2 = (P2 + I2) / 2, M2 = [{ offsetX: y2, offsetY: P2 }, { offsetX: T2, offsetY: P2 }, { offsetX: w2, offsetY: P2 }, { offsetX: w2, offsetY: C2 }, { offsetX: w2, offsetY: I2 }, { offsetX: T2, offsetY: I2 }, { offsetX: y2, offsetY: I2 }, { offsetX: y2, offsetY: C2 }];
            let E2 = [];
            for (const { offsetX: e3, offsetY: i3 } of M2) E2.push(new t.P(v2 + d2 * e3 + p2 * i3, x2 + _2 * e3 + m2 * i3));
            let S2 = false;
            if (o2) {
              const e3 = E2.map((e4) => this.projectAndGetPerspectiveRatio(e4.x, e4.y, r2, c2, u2));
              S2 = e3.some((e4) => !e4.isOccluded), E2 = e3.map((e4) => new t.P(e4.x, e4.y));
            } else S2 = true;
            return { box: t.aM(E2), allPointsOccluded: !S2 };
          }
        }
        class lt {
          constructor(e2, t2, i2, a2) {
            this.opacity = e2 ? Math.max(0, Math.min(1, e2.opacity + (e2.placed ? t2 : -t2))) : a2 && i2 ? 1 : 0, this.placed = i2;
          }
          isHidden() {
            return 0 === this.opacity && !this.placed;
          }
        }
        class ct {
          constructor(e2, t2, i2, a2, r2) {
            this.text = new lt(e2 ? e2.text : null, t2, i2, r2), this.icon = new lt(e2 ? e2.icon : null, t2, a2, r2);
          }
          isHidden() {
            return this.text.isHidden() && this.icon.isHidden();
          }
        }
        class ht {
          constructor(e2, t2, i2) {
            this.text = e2, this.icon = t2, this.skipFade = i2;
          }
        }
        class ut {
          constructor(e2, t2, i2, a2, r2) {
            this.bucketInstanceId = e2, this.featureIndex = t2, this.sourceLayerIndex = i2, this.bucketIndex = a2, this.tileID = r2;
          }
        }
        class dt {
          constructor(e2) {
            this.crossSourceCollisions = e2, this.maxGroupID = 0, this.collisionGroups = {};
          }
          get(e2) {
            if (this.crossSourceCollisions) return { ID: 0, predicate: null };
            if (!this.collisionGroups[e2]) {
              const t2 = ++this.maxGroupID;
              this.collisionGroups[e2] = { ID: t2, predicate: (e3) => e3.collisionGroupID === t2 };
            }
            return this.collisionGroups[e2];
          }
        }
        function _t(e2, i2, a2, r2, o2) {
          const { horizontalAlign: s2, verticalAlign: n2 } = t.aT(e2);
          return new t.P(-(s2 - 0.5) * i2 + r2[0] * o2, -(n2 - 0.5) * a2 + r2[1] * o2);
        }
        class pt {
          constructor(e2, t2, i2, a2, r2) {
            this.transform = e2.clone(), this.terrain = t2, this.collisionIndex = new nt(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = false, this.commitTime = 0, this.fadeDuration = i2, this.retainedQueryData = {}, this.collisionGroups = new dt(a2), this.collisionCircleArrays = {}, this.collisionBoxArrays = /* @__PURE__ */ new Map(), this.prevPlacement = r2, r2 && (r2.prevPlacement = void 0), this.placedOrientations = {};
          }
          _getTerrainElevationFunc(e2) {
            const t2 = this.terrain;
            return t2 ? (i2, a2) => t2.getElevation(e2, i2, a2) : null;
          }
          getBucketParts(e2, i2, a2, r2) {
            const o2 = a2.getBucket(i2), s2 = a2.latestFeatureIndex;
            if (!o2 || !s2 || i2.id !== o2.layerIds[0]) return;
            const n2 = a2.collisionBoxArray, l2 = o2.layers[0].layout, c2 = o2.layers[0].paint, h2 = Math.pow(2, this.transform.zoom - a2.tileID.overscaledZ), u2 = a2.tileSize / t.a5, d2 = a2.tileID.toUnwrapped(), _2 = "map" === l2.get("text-rotation-alignment"), p2 = t.aO(a2, 1, this.transform.zoom), m2 = t.aP(this.collisionIndex.transform, a2, c2.get("text-translate"), c2.get("text-translate-anchor")), f2 = t.aP(this.collisionIndex.transform, a2, c2.get("icon-translate"), c2.get("icon-translate-anchor")), g2 = je(_2, this.transform, p2);
            this.retainedQueryData[o2.bucketInstanceId] = new ut(o2.bucketInstanceId, s2, o2.sourceLayerIndex, o2.index, a2.tileID);
            const v2 = { bucket: o2, layout: l2, translationText: m2, translationIcon: f2, unwrappedTileID: d2, pitchedLabelPlaneMatrix: g2, scale: h2, textPixelRatio: u2, holdingForFade: a2.holdingForSymbolFade(), collisionBoxArray: n2, partiallyEvaluatedTextSize: t.az(o2.textSizeData, this.transform.zoom), collisionGroup: this.collisionGroups.get(o2.sourceID) };
            if (r2) for (const t2 of o2.sortKeyRanges) {
              const { sortKey: i3, symbolInstanceStart: a3, symbolInstanceEnd: r3 } = t2;
              e2.push({ sortKey: i3, symbolInstanceStart: a3, symbolInstanceEnd: r3, parameters: v2 });
            }
            else e2.push({ symbolInstanceStart: 0, symbolInstanceEnd: o2.symbolInstances.length, parameters: v2 });
          }
          attemptAnchorPlacement(e2, i2, a2, r2, o2, s2, n2, l2, c2, h2, u2, d2, _2, p2, m2, f2, g2, v2, x2, b2) {
            const y2 = t.aQ[e2.textAnchor], w2 = [e2.textOffset0, e2.textOffset1], T2 = _t(y2, a2, r2, w2, o2), P2 = this.collisionIndex.placeCollisionBox(i2, d2, l2, c2, h2, n2, s2, f2, u2.predicate, x2, T2, b2);
            if ((!v2 || this.collisionIndex.placeCollisionBox(v2, d2, l2, c2, h2, n2, s2, g2, u2.predicate, x2, T2, b2).placeable) && P2.placeable) {
              let e3;
              if (this.prevPlacement && this.prevPlacement.variableOffsets[_2.crossTileID] && this.prevPlacement.placements[_2.crossTileID] && this.prevPlacement.placements[_2.crossTileID].text && (e3 = this.prevPlacement.variableOffsets[_2.crossTileID].anchor), 0 === _2.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
              return this.variableOffsets[_2.crossTileID] = { textOffset: w2, width: a2, height: r2, anchor: y2, textBoxScale: o2, prevAnchor: e3 }, this.markUsedJustification(p2, y2, _2, m2), p2.allowVerticalPlacement && (this.markUsedOrientation(p2, m2, _2), this.placedOrientations[_2.crossTileID] = m2), { shift: T2, placedGlyphBoxes: P2 };
            }
          }
          placeLayerBucketPart(e2, i2, a2) {
            const { bucket: r2, layout: o2, translationText: s2, translationIcon: n2, unwrappedTileID: l2, pitchedLabelPlaneMatrix: c2, textPixelRatio: h2, holdingForFade: u2, collisionBoxArray: d2, partiallyEvaluatedTextSize: _2, collisionGroup: p2 } = e2.parameters, m2 = o2.get("text-optional"), f2 = o2.get("icon-optional"), g2 = t.aR(o2, "text-overlap", "text-allow-overlap"), v2 = "always" === g2, x2 = t.aR(o2, "icon-overlap", "icon-allow-overlap"), b2 = "always" === x2, y2 = "map" === o2.get("text-rotation-alignment"), w2 = "map" === o2.get("text-pitch-alignment"), T2 = "none" !== o2.get("icon-text-fit"), P2 = "viewport-y" === o2.get("symbol-z-order"), I2 = v2 && (b2 || !r2.hasIconData() || f2), C2 = b2 && (v2 || !r2.hasTextData() || m2);
            !r2.collisionArrays && d2 && r2.deserializeCollisionBoxes(d2);
            const M2 = this.retainedQueryData[r2.bucketInstanceId].tileID, E2 = this._getTerrainElevationFunc(M2), S2 = this.transform.getFastPathSimpleProjectionMatrix(M2), R2 = (e3, d3, b3) => {
              var P3, R3;
              if (i2[e3.crossTileID]) return;
              if (u2) return void (this.placements[e3.crossTileID] = new ht(false, false, false));
              let z2 = false, D2 = false, A2 = true, L3 = null, k2 = { box: null, placeable: false, offscreen: null, occluded: false }, F2 = { placeable: false }, B2 = null, O2 = null, j2 = null, N2 = 0, Z2 = 0, G2 = 0;
              d3.textFeatureIndex ? N2 = d3.textFeatureIndex : e3.useRuntimeCollisionCircles && (N2 = e3.featureIndex), d3.verticalTextFeatureIndex && (Z2 = d3.verticalTextFeatureIndex);
              const U2 = d3.textBox;
              if (U2) {
                const i3 = (i4) => {
                  let a3 = t.aA.horizontal;
                  if (r2.allowVerticalPlacement && !i4 && this.prevPlacement) {
                    const t2 = this.prevPlacement.placedOrientations[e3.crossTileID];
                    t2 && (this.placedOrientations[e3.crossTileID] = t2, a3 = t2, this.markUsedOrientation(r2, a3, e3));
                  }
                  return a3;
                }, o3 = (i4, a3) => {
                  if (r2.allowVerticalPlacement && e3.numVerticalGlyphVertices > 0 && d3.verticalTextBox) {
                    for (const e4 of r2.writingModes) if (e4 === t.aA.vertical ? (k2 = a3(), F2 = k2) : k2 = i4(), k2 && k2.placeable) break;
                  } else k2 = i4();
                }, c3 = e3.textAnchorOffsetStartIndex, u3 = e3.textAnchorOffsetEndIndex;
                if (u3 === c3) {
                  const a3 = (t2, i4) => {
                    const a4 = this.collisionIndex.placeCollisionBox(t2, g2, h2, M2, l2, w2, y2, s2, p2.predicate, E2, void 0, S2);
                    return a4 && a4.placeable && (this.markUsedOrientation(r2, i4, e3), this.placedOrientations[e3.crossTileID] = i4), a4;
                  };
                  o3(() => a3(U2, t.aA.horizontal), () => {
                    const i4 = d3.verticalTextBox;
                    return r2.allowVerticalPlacement && e3.numVerticalGlyphVertices > 0 && i4 ? a3(i4, t.aA.vertical) : { box: null, offscreen: null };
                  }), i3(k2 && k2.placeable);
                } else {
                  let _3 = t.aQ[null === (R3 = null === (P3 = this.prevPlacement) || void 0 === P3 ? void 0 : P3.variableOffsets[e3.crossTileID]) || void 0 === R3 ? void 0 : R3.anchor];
                  const m3 = (t2, i4, o4) => {
                    const d4 = t2.x2 - t2.x1, m4 = t2.y2 - t2.y1, f4 = e3.textBoxScale, v3 = T2 && "never" === x2 ? i4 : null;
                    let b4 = null, P4 = "never" === g2 ? 1 : 2, I3 = "never";
                    _3 && P4++;
                    for (let i5 = 0; i5 < P4; i5++) {
                      for (let i6 = c3; i6 < u3; i6++) {
                        const a3 = r2.textAnchorOffsets.get(i6);
                        if (_3 && a3.textAnchor !== _3) continue;
                        const c4 = this.attemptAnchorPlacement(a3, t2, d4, m4, f4, y2, w2, h2, M2, l2, p2, I3, e3, r2, o4, s2, n2, v3, E2);
                        if (c4 && (b4 = c4.placedGlyphBoxes, b4 && b4.placeable)) return z2 = true, L3 = c4.shift, b4;
                      }
                      _3 ? _3 = null : I3 = g2;
                    }
                    return a2 && !b4 && (b4 = { box: this.collisionIndex.placeCollisionBox(U2, "always", h2, M2, l2, w2, y2, s2, p2.predicate, E2, void 0, S2).box, offscreen: false, placeable: false, occluded: false }), b4;
                  };
                  o3(() => m3(U2, d3.iconBox, t.aA.horizontal), () => {
                    const i4 = d3.verticalTextBox;
                    return r2.allowVerticalPlacement && (!k2 || !k2.placeable) && e3.numVerticalGlyphVertices > 0 && i4 ? m3(i4, d3.verticalIconBox, t.aA.vertical) : { box: null, occluded: true, offscreen: null };
                  }), k2 && (z2 = k2.placeable, A2 = k2.offscreen);
                  const f3 = i3(k2 && k2.placeable);
                  if (!z2 && this.prevPlacement) {
                    const t2 = this.prevPlacement.variableOffsets[e3.crossTileID];
                    t2 && (this.variableOffsets[e3.crossTileID] = t2, this.markUsedJustification(r2, t2.anchor, e3, f3));
                  }
                }
              }
              if (B2 = k2, z2 = B2 && B2.placeable, A2 = B2 && B2.offscreen, e3.useRuntimeCollisionCircles && e3.centerJustifiedTextSymbolIndex >= 0) {
                const i3 = r2.text.placedSymbolArray.get(e3.centerJustifiedTextSymbolIndex), n3 = t.aB(r2.textSizeData, _2, i3), h3 = o2.get("text-padding");
                O2 = this.collisionIndex.placeCollisionCircles(g2, i3, r2.lineVertexArray, r2.glyphOffsetArray, n3, l2, c2, a2, w2, p2.predicate, e3.collisionCircleDiameter, h3, s2, E2), O2.circles.length && O2.collisionDetected && !a2 && t.w("Collisions detected, but collision boxes are not shown"), z2 = v2 || O2.circles.length > 0 && !O2.collisionDetected, A2 = A2 && O2.offscreen;
              }
              if (d3.iconFeatureIndex && (G2 = d3.iconFeatureIndex), d3.iconBox) {
                const e4 = (e5) => this.collisionIndex.placeCollisionBox(e5, x2, h2, M2, l2, w2, y2, n2, p2.predicate, E2, T2 && L3 ? L3 : void 0, S2);
                F2 && F2.placeable && d3.verticalIconBox ? (j2 = e4(d3.verticalIconBox), D2 = j2.placeable) : (j2 = e4(d3.iconBox), D2 = j2.placeable), A2 = A2 && j2.offscreen;
              }
              const V2 = m2 || 0 === e3.numHorizontalGlyphVertices && 0 === e3.numVerticalGlyphVertices, q2 = f2 || 0 === e3.numIconVertices;
              V2 || q2 ? q2 ? V2 || (D2 = D2 && z2) : z2 = D2 && z2 : D2 = z2 = D2 && z2;
              const W2 = D2 && j2.placeable;
              if (z2 && B2.placeable && this.collisionIndex.insertCollisionBox(B2.box, g2, o2.get("text-ignore-placement"), r2.bucketInstanceId, F2 && F2.placeable && Z2 ? Z2 : N2, p2.ID), W2 && this.collisionIndex.insertCollisionBox(j2.box, x2, o2.get("icon-ignore-placement"), r2.bucketInstanceId, G2, p2.ID), O2 && z2 && this.collisionIndex.insertCollisionCircles(O2.circles, g2, o2.get("text-ignore-placement"), r2.bucketInstanceId, N2, p2.ID), a2 && this.storeCollisionData(r2.bucketInstanceId, b3, d3, B2, j2, O2), 0 === e3.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
              if (0 === r2.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
              this.placements[e3.crossTileID] = new ht((z2 || I2) && !(null == B2 ? void 0 : B2.occluded), (D2 || C2) && !(null == j2 ? void 0 : j2.occluded), A2 || r2.justReloaded), i2[e3.crossTileID] = true;
            };
            if (P2) {
              if (0 !== e2.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
              const t2 = r2.getSortedSymbolIndexes(-this.transform.bearingInRadians);
              for (let e3 = t2.length - 1; e3 >= 0; --e3) {
                const i3 = t2[e3];
                R2(r2.symbolInstances.get(i3), r2.collisionArrays[i3], i3);
              }
            } else for (let t2 = e2.symbolInstanceStart; t2 < e2.symbolInstanceEnd; t2++) R2(r2.symbolInstances.get(t2), r2.collisionArrays[t2], t2);
            r2.justReloaded = false;
          }
          storeCollisionData(e2, t2, i2, a2, r2, o2) {
            if (i2.textBox || i2.iconBox) {
              let o3, s2;
              this.collisionBoxArrays.has(e2) ? o3 = this.collisionBoxArrays.get(e2) : (o3 = /* @__PURE__ */ new Map(), this.collisionBoxArrays.set(e2, o3)), o3.has(t2) ? s2 = o3.get(t2) : (s2 = { text: null, icon: null }, o3.set(t2, s2)), i2.textBox && (s2.text = a2.box), i2.iconBox && (s2.icon = r2.box);
            }
            if (o2) {
              let t3 = this.collisionCircleArrays[e2];
              void 0 === t3 && (t3 = this.collisionCircleArrays[e2] = []);
              for (let e3 = 0; e3 < o2.circles.length; e3 += 4) t3.push(o2.circles[e3 + 0] - st), t3.push(o2.circles[e3 + 1] - st), t3.push(o2.circles[e3 + 2]), t3.push(o2.collisionDetected ? 1 : 0);
            }
          }
          markUsedJustification(e2, i2, a2, r2) {
            let o2;
            o2 = r2 === t.aA.vertical ? a2.verticalPlacedTextSymbolIndex : { left: a2.leftJustifiedTextSymbolIndex, center: a2.centerJustifiedTextSymbolIndex, right: a2.rightJustifiedTextSymbolIndex }[t.aS(i2)];
            const s2 = [a2.leftJustifiedTextSymbolIndex, a2.centerJustifiedTextSymbolIndex, a2.rightJustifiedTextSymbolIndex, a2.verticalPlacedTextSymbolIndex];
            for (const t2 of s2) t2 >= 0 && (e2.text.placedSymbolArray.get(t2).crossTileID = o2 >= 0 && t2 !== o2 ? 0 : a2.crossTileID);
          }
          markUsedOrientation(e2, i2, a2) {
            const r2 = i2 === t.aA.horizontal || i2 === t.aA.horizontalOnly ? i2 : 0, o2 = i2 === t.aA.vertical ? i2 : 0, s2 = [a2.leftJustifiedTextSymbolIndex, a2.centerJustifiedTextSymbolIndex, a2.rightJustifiedTextSymbolIndex];
            for (const t2 of s2) e2.text.placedSymbolArray.get(t2).placedOrientation = r2;
            a2.verticalPlacedTextSymbolIndex && (e2.text.placedSymbolArray.get(a2.verticalPlacedTextSymbolIndex).placedOrientation = o2);
          }
          commit(e2) {
            this.commitTime = e2, this.zoomAtLastRecencyCheck = this.transform.zoom;
            const t2 = this.prevPlacement;
            let i2 = false;
            this.prevZoomAdjustment = t2 ? t2.zoomAdjustment(this.transform.zoom) : 0;
            const a2 = t2 ? t2.symbolFadeChange(e2) : 1, r2 = t2 ? t2.opacities : {}, o2 = t2 ? t2.variableOffsets : {}, s2 = t2 ? t2.placedOrientations : {};
            for (const e3 in this.placements) {
              const t3 = this.placements[e3], o3 = r2[e3];
              o3 ? (this.opacities[e3] = new ct(o3, a2, t3.text, t3.icon), i2 = i2 || t3.text !== o3.text.placed || t3.icon !== o3.icon.placed) : (this.opacities[e3] = new ct(null, a2, t3.text, t3.icon, t3.skipFade), i2 = i2 || t3.text || t3.icon);
            }
            for (const e3 in r2) {
              const t3 = r2[e3];
              if (!this.opacities[e3]) {
                const r3 = new ct(t3, a2, false, false);
                r3.isHidden() || (this.opacities[e3] = r3, i2 = i2 || t3.text.placed || t3.icon.placed);
              }
            }
            for (const e3 in o2) this.variableOffsets[e3] || !this.opacities[e3] || this.opacities[e3].isHidden() || (this.variableOffsets[e3] = o2[e3]);
            for (const e3 in s2) this.placedOrientations[e3] || !this.opacities[e3] || this.opacities[e3].isHidden() || (this.placedOrientations[e3] = s2[e3]);
            if (t2 && void 0 === t2.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
            i2 ? this.lastPlacementChangeTime = e2 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t2 ? t2.lastPlacementChangeTime : e2);
          }
          updateLayerOpacities(e2, t2) {
            const i2 = {};
            for (const a2 of t2) {
              const t3 = a2.getBucket(e2);
              t3 && a2.latestFeatureIndex && e2.id === t3.layerIds[0] && this.updateBucketOpacities(t3, a2.tileID, i2, a2.collisionBoxArray);
            }
          }
          updateBucketOpacities(e2, i2, a2, r2) {
            e2.hasTextData() && (e2.text.opacityVertexArray.clear(), e2.text.hasVisibleVertices = false), e2.hasIconData() && (e2.icon.opacityVertexArray.clear(), e2.icon.hasVisibleVertices = false), e2.hasIconCollisionBoxData() && e2.iconCollisionBox.collisionVertexArray.clear(), e2.hasTextCollisionBoxData() && e2.textCollisionBox.collisionVertexArray.clear();
            const o2 = e2.layers[0], s2 = o2.layout, n2 = new ct(null, 0, false, false, true), l2 = s2.get("text-allow-overlap"), c2 = s2.get("icon-allow-overlap"), h2 = o2._unevaluatedLayout.hasValue("text-variable-anchor") || o2._unevaluatedLayout.hasValue("text-variable-anchor-offset"), u2 = "map" === s2.get("text-rotation-alignment"), d2 = "map" === s2.get("text-pitch-alignment"), _2 = "none" !== s2.get("icon-text-fit"), p2 = new ct(null, 0, l2 && (c2 || !e2.hasIconData() || s2.get("icon-optional")), c2 && (l2 || !e2.hasTextData() || s2.get("text-optional")), true);
            !e2.collisionArrays && r2 && (e2.hasIconCollisionBoxData() || e2.hasTextCollisionBoxData()) && e2.deserializeCollisionBoxes(r2);
            const m2 = (e3, t2, i3) => {
              for (let a3 = 0; a3 < t2 / 4; a3++) e3.opacityVertexArray.emplaceBack(i3);
              e3.hasVisibleVertices = e3.hasVisibleVertices || i3 !== Pt;
            }, f2 = this.collisionBoxArrays.get(e2.bucketInstanceId);
            for (let i3 = 0; i3 < e2.symbolInstances.length; i3++) {
              const r3 = e2.symbolInstances.get(i3), { numHorizontalGlyphVertices: o3, numVerticalGlyphVertices: s3, crossTileID: l3 } = r3;
              let c3 = this.opacities[l3];
              a2[l3] ? c3 = n2 : c3 || (c3 = p2, this.opacities[l3] = c3), a2[l3] = true;
              const g2 = r3.numIconVertices > 0, v2 = this.placedOrientations[r3.crossTileID], x2 = v2 === t.aA.vertical, b2 = v2 === t.aA.horizontal || v2 === t.aA.horizontalOnly;
              if (o3 > 0 || s3 > 0) {
                const t2 = Tt(c3.text);
                m2(e2.text, o3, x2 ? Pt : t2), m2(e2.text, s3, b2 ? Pt : t2);
                const i4 = c3.text.isHidden();
                [r3.rightJustifiedTextSymbolIndex, r3.centerJustifiedTextSymbolIndex, r3.leftJustifiedTextSymbolIndex].forEach((t3) => {
                  t3 >= 0 && (e2.text.placedSymbolArray.get(t3).hidden = i4 || x2 ? 1 : 0);
                }), r3.verticalPlacedTextSymbolIndex >= 0 && (e2.text.placedSymbolArray.get(r3.verticalPlacedTextSymbolIndex).hidden = i4 || b2 ? 1 : 0);
                const a3 = this.variableOffsets[r3.crossTileID];
                a3 && this.markUsedJustification(e2, a3.anchor, r3, v2);
                const n3 = this.placedOrientations[r3.crossTileID];
                n3 && (this.markUsedJustification(e2, "left", r3, n3), this.markUsedOrientation(e2, n3, r3));
              }
              if (g2) {
                const t2 = Tt(c3.icon), i4 = !(_2 && r3.verticalPlacedIconSymbolIndex && x2);
                r3.placedIconSymbolIndex >= 0 && (m2(e2.icon, r3.numIconVertices, i4 ? t2 : Pt), e2.icon.placedSymbolArray.get(r3.placedIconSymbolIndex).hidden = c3.icon.isHidden()), r3.verticalPlacedIconSymbolIndex >= 0 && (m2(e2.icon, r3.numVerticalIconVertices, i4 ? Pt : t2), e2.icon.placedSymbolArray.get(r3.verticalPlacedIconSymbolIndex).hidden = c3.icon.isHidden());
              }
              const y2 = f2 && f2.has(i3) ? f2.get(i3) : { text: null, icon: null };
              if (e2.hasIconCollisionBoxData() || e2.hasTextCollisionBoxData()) {
                const a3 = e2.collisionArrays[i3];
                if (a3) {
                  let i4 = new t.P(0, 0);
                  if (a3.textBox || a3.verticalTextBox) {
                    let t2 = true;
                    if (h2) {
                      const e3 = this.variableOffsets[l3];
                      e3 ? (i4 = _t(e3.anchor, e3.width, e3.height, e3.textOffset, e3.textBoxScale), u2 && i4._rotate(d2 ? -this.transform.bearingInRadians : this.transform.bearingInRadians)) : t2 = false;
                    }
                    if (a3.textBox || a3.verticalTextBox) {
                      let r4;
                      a3.textBox && (r4 = x2), a3.verticalTextBox && (r4 = b2), mt(e2.textCollisionBox.collisionVertexArray, c3.text.placed, !t2 || r4, y2.text, i4.x, i4.y);
                    }
                  }
                  if (a3.iconBox || a3.verticalIconBox) {
                    const t2 = Boolean(!b2 && a3.verticalIconBox);
                    let r4;
                    a3.iconBox && (r4 = t2), a3.verticalIconBox && (r4 = !t2), mt(e2.iconCollisionBox.collisionVertexArray, c3.icon.placed, r4, y2.icon, _2 ? i4.x : 0, _2 ? i4.y : 0);
                  }
                }
              }
            }
            if (e2.sortFeatures(-this.transform.bearingInRadians), this.retainedQueryData[e2.bucketInstanceId] && (this.retainedQueryData[e2.bucketInstanceId].featureSortOrder = e2.featureSortOrder), e2.hasTextData() && e2.text.opacityVertexBuffer && e2.text.opacityVertexBuffer.updateData(e2.text.opacityVertexArray), e2.hasIconData() && e2.icon.opacityVertexBuffer && e2.icon.opacityVertexBuffer.updateData(e2.icon.opacityVertexArray), e2.hasIconCollisionBoxData() && e2.iconCollisionBox.collisionVertexBuffer && e2.iconCollisionBox.collisionVertexBuffer.updateData(e2.iconCollisionBox.collisionVertexArray), e2.hasTextCollisionBoxData() && e2.textCollisionBox.collisionVertexBuffer && e2.textCollisionBox.collisionVertexBuffer.updateData(e2.textCollisionBox.collisionVertexArray), e2.text.opacityVertexArray.length !== e2.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${e2.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${e2.text.layoutVertexArray.length}) / 4`);
            if (e2.icon.opacityVertexArray.length !== e2.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${e2.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${e2.icon.layoutVertexArray.length}) / 4`);
            e2.bucketInstanceId in this.collisionCircleArrays && (e2.collisionCircleArray = this.collisionCircleArrays[e2.bucketInstanceId], delete this.collisionCircleArrays[e2.bucketInstanceId]);
          }
          symbolFadeChange(e2) {
            return 0 === this.fadeDuration ? 1 : (e2 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
          }
          zoomAdjustment(e2) {
            return Math.max(0, (this.transform.zoom - e2) / 1.5);
          }
          hasTransitions(e2) {
            return this.stale || e2 - this.lastPlacementChangeTime < this.fadeDuration;
          }
          stillRecent(e2, t2) {
            const i2 = this.zoomAtLastRecencyCheck === t2 ? 1 - this.zoomAdjustment(t2) : 1;
            return this.zoomAtLastRecencyCheck = t2, this.commitTime + this.fadeDuration * i2 > e2;
          }
          setStale() {
            this.stale = true;
          }
        }
        function mt(e2, t2, i2, a2, r2, o2) {
          a2 && 0 !== a2.length || (a2 = [0, 0, 0, 0]);
          const s2 = a2[0] - st, n2 = a2[1] - st, l2 = a2[2] - st, c2 = a2[3] - st;
          e2.emplaceBack(t2 ? 1 : 0, i2 ? 1 : 0, r2 || 0, o2 || 0, s2, n2), e2.emplaceBack(t2 ? 1 : 0, i2 ? 1 : 0, r2 || 0, o2 || 0, l2, n2), e2.emplaceBack(t2 ? 1 : 0, i2 ? 1 : 0, r2 || 0, o2 || 0, l2, c2), e2.emplaceBack(t2 ? 1 : 0, i2 ? 1 : 0, r2 || 0, o2 || 0, s2, c2);
        }
        const ft = Math.pow(2, 25), gt = Math.pow(2, 24), vt = Math.pow(2, 17), xt = Math.pow(2, 16), bt = Math.pow(2, 9), yt = Math.pow(2, 8), wt = Math.pow(2, 1);
        function Tt(e2) {
          if (0 === e2.opacity && !e2.placed) return 0;
          if (1 === e2.opacity && e2.placed) return 4294967295;
          const t2 = e2.placed ? 1 : 0, i2 = Math.floor(127 * e2.opacity);
          return i2 * ft + t2 * gt + i2 * vt + t2 * xt + i2 * bt + t2 * yt + i2 * wt + t2;
        }
        const Pt = 0;
        class It {
          constructor(e2) {
            this._sortAcrossTiles = "viewport-y" !== e2.layout.get("symbol-z-order") && !e2.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
          }
          continuePlacement(e2, t2, i2, a2, r2) {
            const o2 = this._bucketParts;
            for (; this._currentTileIndex < e2.length; ) if (t2.getBucketParts(o2, a2, e2[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, r2()) return true;
            for (this._sortAcrossTiles && (this._sortAcrossTiles = false, o2.sort((e3, t3) => e3.sortKey - t3.sortKey)); this._currentPartIndex < o2.length; ) if (t2.placeLayerBucketPart(o2[this._currentPartIndex], this._seenCrossTileIDs, i2), this._currentPartIndex++, r2()) return true;
            return false;
          }
        }
        class Ct {
          constructor(e2, t2, i2, a2, r2, o2, s2, n2) {
            this.placement = new pt(e2, t2, o2, s2, n2), this._currentPlacementIndex = i2.length - 1, this._forceFullPlacement = a2, this._showCollisionBoxes = r2, this._done = false;
          }
          isDone() {
            return this._done;
          }
          continuePlacement(e2, t2, i2) {
            const a2 = c(), r2 = () => !this._forceFullPlacement && c() - a2 > 2;
            for (; this._currentPlacementIndex >= 0; ) {
              const a3 = t2[e2[this._currentPlacementIndex]], o2 = this.placement.collisionIndex.transform.zoom;
              if ("symbol" === a3.type && (!a3.minzoom || a3.minzoom <= o2) && (!a3.maxzoom || a3.maxzoom > o2)) {
                if (this._inProgressLayer || (this._inProgressLayer = new It(a3)), this._inProgressLayer.continuePlacement(i2[a3.source], this.placement, this._showCollisionBoxes, a3, r2)) return;
                delete this._inProgressLayer;
              }
              this._currentPlacementIndex--;
            }
            this._done = true;
          }
          commit(e2) {
            return this.placement.commit(e2), this.placement;
          }
        }
        const Mt = 512 / t.a5 / 2;
        class Et {
          constructor(e2, i2, a2) {
            this.tileID = e2, this.bucketInstanceId = a2, this._symbolsByKey = {};
            const r2 = /* @__PURE__ */ new Map();
            for (let e3 = 0; e3 < i2.length; e3++) {
              const t2 = i2.get(e3), a3 = t2.key, o2 = r2.get(a3);
              o2 ? o2.push(t2) : r2.set(a3, [t2]);
            }
            for (const [e3, i3] of r2) {
              const a3 = { positions: i3.map((e4) => ({ x: Math.floor(e4.anchorX * Mt), y: Math.floor(e4.anchorY * Mt) })), crossTileIDs: i3.map((e4) => e4.crossTileID) };
              if (a3.positions.length > 128) {
                const e4 = new t.aU(a3.positions.length, 16, Uint16Array);
                for (const { x: t2, y: i4 } of a3.positions) e4.add(t2, i4);
                e4.finish(), delete a3.positions, a3.index = e4;
              }
              this._symbolsByKey[e3] = a3;
            }
          }
          getScaledCoordinates(e2, i2) {
            const { x: a2, y: r2, z: o2 } = this.tileID.canonical, { x: s2, y: n2, z: l2 } = i2.canonical, c2 = Mt / Math.pow(2, l2 - o2), h2 = (n2 * t.a5 + e2.anchorY) * c2, u2 = r2 * t.a5 * Mt;
            return { x: Math.floor((s2 * t.a5 + e2.anchorX) * c2 - a2 * t.a5 * Mt), y: Math.floor(h2 - u2) };
          }
          findMatches(e2, t2, i2) {
            const a2 = this.tileID.canonical.z < t2.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - t2.canonical.z);
            for (let r2 = 0; r2 < e2.length; r2++) {
              const o2 = e2.get(r2);
              if (o2.crossTileID) continue;
              const s2 = this._symbolsByKey[o2.key];
              if (!s2) continue;
              const n2 = this.getScaledCoordinates(o2, t2);
              if (s2.index) {
                const e3 = s2.index.range(n2.x - a2, n2.y - a2, n2.x + a2, n2.y + a2).sort();
                for (const t3 of e3) {
                  const e4 = s2.crossTileIDs[t3];
                  if (!i2[e4]) {
                    i2[e4] = true, o2.crossTileID = e4;
                    break;
                  }
                }
              } else if (s2.positions) for (let e3 = 0; e3 < s2.positions.length; e3++) {
                const t3 = s2.positions[e3], r3 = s2.crossTileIDs[e3];
                if (Math.abs(t3.x - n2.x) <= a2 && Math.abs(t3.y - n2.y) <= a2 && !i2[r3]) {
                  i2[r3] = true, o2.crossTileID = r3;
                  break;
                }
              }
            }
          }
          getCrossTileIDsLists() {
            return Object.values(this._symbolsByKey).map(({ crossTileIDs: e2 }) => e2);
          }
        }
        class St {
          constructor() {
            this.maxCrossTileID = 0;
          }
          generate() {
            return ++this.maxCrossTileID;
          }
        }
        class Rt {
          constructor() {
            this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
          }
          handleWrapJump(e2) {
            const t2 = Math.round((e2 - this.lng) / 360);
            if (0 !== t2) for (const e3 in this.indexes) {
              const i2 = this.indexes[e3], a2 = {};
              for (const e4 in i2) {
                const r2 = i2[e4];
                r2.tileID = r2.tileID.unwrapTo(r2.tileID.wrap + t2), a2[r2.tileID.key] = r2;
              }
              this.indexes[e3] = a2;
            }
            this.lng = e2;
          }
          addBucket(e2, t2, i2) {
            if (this.indexes[e2.overscaledZ] && this.indexes[e2.overscaledZ][e2.key]) {
              if (this.indexes[e2.overscaledZ][e2.key].bucketInstanceId === t2.bucketInstanceId) return false;
              this.removeBucketCrossTileIDs(e2.overscaledZ, this.indexes[e2.overscaledZ][e2.key]);
            }
            for (let e3 = 0; e3 < t2.symbolInstances.length; e3++) t2.symbolInstances.get(e3).crossTileID = 0;
            this.usedCrossTileIDs[e2.overscaledZ] || (this.usedCrossTileIDs[e2.overscaledZ] = {});
            const a2 = this.usedCrossTileIDs[e2.overscaledZ];
            for (const i3 in this.indexes) {
              const r2 = this.indexes[i3];
              if (Number(i3) > e2.overscaledZ) for (const i4 in r2) {
                const o2 = r2[i4];
                o2.tileID.isChildOf(e2) && o2.findMatches(t2.symbolInstances, e2, a2);
              }
              else {
                const o2 = r2[e2.scaledTo(Number(i3)).key];
                o2 && o2.findMatches(t2.symbolInstances, e2, a2);
              }
            }
            for (let e3 = 0; e3 < t2.symbolInstances.length; e3++) {
              const r2 = t2.symbolInstances.get(e3);
              r2.crossTileID || (r2.crossTileID = i2.generate(), a2[r2.crossTileID] = true);
            }
            return void 0 === this.indexes[e2.overscaledZ] && (this.indexes[e2.overscaledZ] = {}), this.indexes[e2.overscaledZ][e2.key] = new Et(e2, t2.symbolInstances, t2.bucketInstanceId), true;
          }
          removeBucketCrossTileIDs(e2, t2) {
            for (const i2 of t2.getCrossTileIDsLists()) for (const t3 of i2) delete this.usedCrossTileIDs[e2][t3];
          }
          removeStaleBuckets(e2) {
            let t2 = false;
            for (const i2 in this.indexes) {
              const a2 = this.indexes[i2];
              for (const r2 in a2) e2[a2[r2].bucketInstanceId] || (this.removeBucketCrossTileIDs(i2, a2[r2]), delete a2[r2], t2 = true);
            }
            return t2;
          }
        }
        class zt {
          constructor() {
            this.layerIndexes = {}, this.crossTileIDs = new St(), this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
          }
          addLayer(e2, t2, i2) {
            let a2 = this.layerIndexes[e2.id];
            void 0 === a2 && (a2 = this.layerIndexes[e2.id] = new Rt());
            let r2 = false;
            const o2 = {};
            a2.handleWrapJump(i2);
            for (const i3 of t2) {
              const t3 = i3.getBucket(e2);
              t3 && e2.id === t3.layerIds[0] && (t3.bucketInstanceId || (t3.bucketInstanceId = ++this.maxBucketInstanceId), a2.addBucket(i3.tileID, t3, this.crossTileIDs) && (r2 = true), o2[t3.bucketInstanceId] = true);
            }
            return a2.removeStaleBuckets(o2) && (r2 = true), r2;
          }
          pruneUnusedLayers(e2) {
            const t2 = {};
            e2.forEach((e3) => {
              t2[e3] = true;
            });
            for (const e3 in this.layerIndexes) t2[e3] || delete this.layerIndexes[e3];
          }
        }
        var Dt = "void main() {fragColor=vec4(1.0);}";
        const At = { prelude: Lt("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nout highp vec4 fragColor;", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}mat3 rotationMatrixFromAxisAngle(vec3 u,float angle) {float c=cos(angle);float s=sin(angle);float c2=1.0-c;return mat3(u.x*u.x*c2+      c,u.x*u.y*c2-u.z*s,u.x*u.z*c2+u.y*s,u.y*u.x*c2+u.z*s,u.y*u.y*c2+    c,u.y*u.z*c2-u.x*s,u.z*u.x*c2-u.y*s,u.z*u.y*c2+u.x*s,u.z*u.z*c2+    c\n);}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\n#ifdef GLOBE\nif ((pos.y <-32767.5) || (pos.y > 32766.5)) {return 0.0;}\n#endif\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}const float PI=3.141592653589793;uniform mat4 u_projection_matrix;"), projectionMercator: Lt("", "float projectLineThickness(float tileY) {return 1.0;}float projectCircleRadius(float tileY) {return 1.0;}vec4 projectTile(vec2 p) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);return result;}vec4 projectTile(vec2 p,vec2 rawPos) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);if (rawPos.y <-32767.5 || rawPos.y > 32766.5) {result.z=-10000000.0;}return result;}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_projection_matrix*vec4(posInTile,elevation,1.0);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {return projectTileWithElevation(posInTile,elevation);}"), projectionGlobe: Lt("", "#define GLOBE_RADIUS 6371008.8\nuniform highp vec4 u_projection_tile_mercator_coords;uniform highp vec4 u_projection_clipping_plane;uniform highp float u_projection_transition;uniform mat4 u_projection_fallback_matrix;vec3 globeRotateVector(vec3 vec,vec2 angles) {vec3 axisRight=vec3(vec.z,0.0,-vec.x);vec3 axisUp=cross(axisRight,vec);axisRight=normalize(axisRight);axisUp=normalize(axisUp);vec2 t=tan(angles);return normalize(vec+axisRight*t.x+axisUp*t.y);}mat3 globeGetRotationMatrix(vec3 spherePos) {vec3 axisRight=vec3(spherePos.z,0.0,-spherePos.x);vec3 axisDown=cross(axisRight,spherePos);axisRight=normalize(axisRight);axisDown=normalize(axisDown);return mat3(axisRight,axisDown,spherePos\n);}float circumferenceRatioAtTileY(float tileY) {float mercator_pos_y=u_projection_tile_mercator_coords.y+u_projection_tile_mercator_coords.w*tileY;float spherical_y=2.0*atan(exp(PI-(mercator_pos_y*PI*2.0)))-PI*0.5;return cos(spherical_y);}float projectLineThickness(float tileY) {float thickness=1.0/circumferenceRatioAtTileY(tileY); \nif (u_projection_transition < 0.999) {return mix(1.0,thickness,u_projection_transition);} else {return thickness;}}vec3 projectToSphere(vec2 translatedPos,vec2 rawPos) {vec2 mercator_pos=u_projection_tile_mercator_coords.xy+u_projection_tile_mercator_coords.zw*translatedPos;vec2 spherical;spherical.x=mercator_pos.x*PI*2.0+PI;spherical.y=2.0*atan(exp(PI-(mercator_pos.y*PI*2.0)))-PI*0.5;float len=cos(spherical.y);vec3 pos=vec3(sin(spherical.x)*len,sin(spherical.y),cos(spherical.x)*len\n);if (rawPos.y <-32767.5) {pos=vec3(0.0,1.0,0.0);}if (rawPos.y > 32766.5) {pos=vec3(0.0,-1.0,0.0);}return pos;}vec3 projectToSphere(vec2 posInTile) {return projectToSphere(posInTile,vec2(0.0,0.0));}float globeComputeClippingZ(vec3 spherePos) {return (1.0-(dot(spherePos,u_projection_clipping_plane.xyz)+u_projection_clipping_plane.w));}vec4 interpolateProjection(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);globePosition.z=globeComputeClippingZ(elevatedPos)*globePosition.w;if (u_projection_transition > 0.999) {return globePosition;}vec4 flatPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);const float z_globeness_threshold=0.2;vec4 result=globePosition;result.z=mix(0.0,globePosition.z,clamp((u_projection_transition-z_globeness_threshold)/(1.0-z_globeness_threshold),0.0,1.0));result.xyw=mix(flatPosition.xyw,globePosition.xyw,u_projection_transition);if ((posInTile.y <-32767.5) || (posInTile.y > 32766.5)) {result=globePosition;const float poles_hidden_anim_percentage=0.02;result.z=mix(globePosition.z,100.0,pow(max((1.0-u_projection_transition)/poles_hidden_anim_percentage,0.0),8.0));}return result;}vec4 interpolateProjectionFor3D(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);if (u_projection_transition > 0.999) {return globePosition;}vec4 fallbackPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);return mix(fallbackPosition,globePosition,u_projection_transition);}vec4 projectTile(vec2 posInTile) {return interpolateProjection(posInTile,projectToSphere(posInTile),0.0);}vec4 projectTile(vec2 posInTile,vec2 rawPos) {return interpolateProjection(posInTile,projectToSphere(posInTile,rawPos),0.0);}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return interpolateProjection(posInTile,projectToSphere(posInTile),elevation);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {vec3 spherePos=projectToSphere(posInTile,posInTile);return interpolateProjectionFor3D(posInTile,spherePos,elevation);}"), background: Lt("uniform vec4 u_color;uniform float u_opacity;void main() {fragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"), backgroundPattern: Lt("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;void main() {gl_Position=projectTile(a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"), circle: Lt("in vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);float antialiased_blur=v_data.z;float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));fragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);const float epsilon=0.5/255.0;if (fragColor.r < epsilon && fragColor.g < epsilon && fragColor.b < epsilon && fragColor.a < epsilon) {discard;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_globe_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;uniform vec2 u_translate;in vec2 a_pos;out vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 pos_raw=a_pos+32768.0;vec2 extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);vec2 circle_center=floor(pos_raw/8.0)+u_translate;float ele=get_elevation(circle_center);v_visibility=calculate_visibility(projectTileWithElevation(circle_center,ele));if (u_pitch_with_map) {\n#ifdef GLOBE\nvec3 center_vector=projectToSphere(circle_center);\n#endif\nfloat angle_scale=u_globe_extrude_scale;vec2 corner_position=circle_center;if (u_scale_with_map) {angle_scale*=(radius+stroke_width);corner_position+=extrude*u_extrude_scale*(radius+stroke_width);} else {\n#ifdef GLOBE\nvec4 projected_center=interpolateProjection(circle_center,center_vector,ele);\n#else\nvec4 projected_center=projectTileWithElevation(circle_center,ele);\n#endif\ncorner_position+=extrude*u_extrude_scale*(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);angle_scale*=(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);}\n#ifdef GLOBE\nvec2 angles=extrude*angle_scale;vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(corner_position,corner_vector,ele);\n#else\ngl_Position=projectTileWithElevation(corner_position,ele);\n#endif\n} else {gl_Position=projectTileWithElevation(circle_center,ele);if (gl_Position.z/gl_Position.w > 1.0) {gl_Position.xy=vec2(10000.0);}if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}float antialiasblur=-max(1.0/u_device_pixel_ratio/(radius+stroke_width),blur);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"), clippingMask: Lt(Dt, "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"), heatmap: Lt("uniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);fragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;uniform highp float u_globe_extrude_scale;in vec2 a_pos;out vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 pos_raw=a_pos+32768.0;vec2 unscaled_extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 circle_center=floor(pos_raw/8.0);\n#ifdef GLOBE\nvec2 angles=v_extrude*radius*u_globe_extrude_scale;vec3 center_vector=projectToSphere(circle_center);vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(circle_center+extrude,corner_vector,0.0);\n#else\ngl_Position=projectTileFor3D(circle_center+extrude,get_elevation(circle_center));\n#endif\n}"), heatmapTexture: Lt("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));fragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"), collisionBox: Lt("in float v_placed;in float v_notUsed;void main() {float alpha=0.5;fragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {fragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {fragColor*=.1;}}", "in vec2 a_anchor_pos;in vec2 a_placed;in vec2 a_box_real;uniform vec2 u_pixel_extrude_scale;out float v_placed;out float v_notUsed;void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}"), collisionCircle: Lt("in float v_radius;in vec2 v_extrude;in float v_collision;void main() {float alpha=0.5;float stroke_radius=0.9;float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);fragColor=color*alpha*opacity_t;}", "in vec2 a_pos;in float a_radius;in vec2 a_flags;uniform vec2 u_viewport_size;out float v_radius;out vec2 v_extrude;out float v_collision;void main() {float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_collision=collision;gl_Position=vec4((a_pos/u_viewport_size*2.0-1.0)*vec2(1.0,-1.0),0.0,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"), colorRelief: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;uniform vec4 u_unpack;uniform sampler2D u_elevation_stops;uniform sampler2D u_color_stops;uniform int u_color_ramp_size;uniform float u_opacity;in vec2 v_pos;float getElevation(vec2 coord) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}float getElevationStop(int stop) {float x=(float(stop)+0.5)/float(u_color_ramp_size);vec4 data=texture(u_elevation_stops,vec2(x,0))*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {float el=getElevation(v_pos);int r=(u_color_ramp_size-1);int l=0;float el_l=getElevationStop(l);float el_r=getElevationStop(r);while(r-l > 1){int m=(r+l)/2;float el_m=getElevationStop(m);if(el < el_m){r=m;el_r=el_m;}else\n{l=m;el_l=el_m;}}float x=(float(l)+(el-el_l)/(el_r-el_l)+0.5)/float(u_color_ramp_size);fragColor=u_opacity*texture(u_color_stops,vec2(x,0));\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_dimension;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_pos/8192.0)*scale+epsilon;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"), debug: Lt("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);fragColor=mix(u_color,overlay_color,overlay_color.a);}", "in vec2 a_pos;out vec2 v_uv;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=projectTileWithElevation(a_pos*u_overlay_scale,get_elevation(a_pos));}"), depth: Lt(Dt, "in vec2 a_pos;void main() {\n#ifdef GLOBE\ngl_Position=projectTileFor3D(a_pos,0.0);\n#else\ngl_Position=u_projection_matrix*vec4(a_pos,0.0,1.0);\n#endif\n}"), fill: Lt("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nfragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_fill_translate;in vec2 a_pos;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);}"), fillOutline: Lt("in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=outline_color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"), fillOutlinePattern: Lt("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;in vec2 v_pos_a;in vec2 v_pos_b;in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"), fillPattern: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"), fillExtrusion: Lt("in vec4 v_color;void main() {fragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\nout vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nfloat colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;vec3 normalForLighting=normal/16384.0;float directional=clamp(dot(normalForLighting,u_lightpos),0.0,1.0);\n#ifdef GLOBE\nmat3 rotMatrix=globeGetRotationMatrix(spherePos);normalForLighting=rotMatrix*normalForLighting;directional=mix(directional,clamp(dot(normalForLighting,u_lightpos_globe),0.0,1.0),u_projection_transition);\n#endif\ndirectional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"), fillExtrusionPattern: Lt("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;in vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);fragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\n#ifdef GLOBE\nout vec3 v_sphere_pos;\n#endif\nout vec2 v_pos_a;out vec2 v_pos_b;out vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);v_sphere_pos=elevatedPos;gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nvec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,elevation*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"), hillshadePrepare: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {vec2 epsilon=1.0/u_dimension;float tileSize=u_dimension.x-2.0;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))*tileSize/pow(2.0,exaggeration+(28.2562-u_zoom));fragColor=clamp(vec4(deriv.x/8.0+0.5,deriv.y/8.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"), hillshade: Lt("uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform float u_exaggeration;uniform vec4 u_accent;uniform int u_method;uniform float u_altitudes[NUM_ILLUMINATION_SOURCES];uniform float u_azimuths[NUM_ILLUMINATION_SOURCES];uniform vec4 u_shadows[NUM_ILLUMINATION_SOURCES];uniform vec4 u_highlights[NUM_ILLUMINATION_SOURCES];\n#define PI 3.141592653589793\n#define STANDARD 0\n#define COMBINED 1\n#define IGOR 2\n#define MULTIDIRECTIONAL 3\n#define BASIC 4\nfloat get_aspect(vec2 deriv){return deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);}void igor_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float aspect=get_aspect(deriv);float azimuth=u_azimuths[0]+PI;float slope_stength=atan(length(deriv))*2.0/PI;float aspect_strength=1.0-abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);float shadow_strength=slope_stength*aspect_strength;float highlight_strength=slope_stength*(1.0-aspect_strength);fragColor=u_shadows[0]*shadow_strength+u_highlights[0]*highlight_strength;}void standard_hillshade(vec2 deriv){float azimuth=u_azimuths[0]+PI;float slope=atan(0.625*length(deriv));float aspect=get_aspect(deriv);float intensity=u_exaggeration;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadows[0],u_highlights[0],shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);fragColor=accent_color*(1.0-shade_color.a)+shade_color;}void basic_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor=u_highlights[0]*(2.0*shade-1.0);}else\n{fragColor=u_shadows[0]*(1.0-2.0*shade);}}void multidirectional_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;fragColor=vec4(0,0,0,0);for(int i=0; i < NUM_ILLUMINATION_SOURCES; i++){float cos_alt=cos(u_altitudes[i]);float sin_alt=sin(u_altitudes[i]);float cos_az=-cos(u_azimuths[i]);float sin_az=-sin(u_azimuths[i]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor+=u_highlights[i]*(2.0*shade-1.0)/float(NUM_ILLUMINATION_SOURCES);}else\n{fragColor+=u_shadows[i]*(1.0-2.0*shade)/float(NUM_ILLUMINATION_SOURCES);}}}void combined_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=acos((sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv)));cang=clamp(cang,0.0,PI/2.0);float shade=cang*atan(length(deriv))*4.0/PI/PI;float highlight=(PI/2.0-cang)*atan(length(deriv))*4.0/PI/PI;fragColor=u_shadows[0]*shade+u_highlights[0]*highlight;}void main() {vec4 pixel=texture(u_image,v_pos);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));vec2 deriv=((pixel.rg*8.0)-4.0)/scaleFactor;if (u_method==BASIC) {basic_hillshade(deriv);} else if (u_method==COMBINED) {combined_hillshade(deriv);} else if (u_method==IGOR) {igor_hillshade(deriv);} else if (u_method==MULTIDIRECTIONAL) {multidirectional_hillshade(deriv);} else if (u_method==STANDARD) {standard_hillshade(deriv);} else {standard_hillshade(deriv);}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);v_pos=a_pos/8192.0;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"), line: Lt("uniform lowp float u_device_pixel_ratio;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp float v_linesofar;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"), lineGradient: Lt("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;in float a_uv_x;in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"), linePattern: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture(u_image,pos_a),texture(u_image,pos_b),u_fade);fragColor=color*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"), lineSDF: Lt("uniform lowp float u_device_pixel_ratio;uniform lowp float u_lineatlas_width;uniform sampler2D u_image;uniform float u_mix;in vec2 v_normal;in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture(u_image,v_tex_a).a;float sdfdist_b=texture(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0/u_device_pixel_ratio)/min(dasharray_from.w,dasharray_to.w);alpha*=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;out vec2 v_width2;out vec2 v_tex_a;out vec2 v_tex_b;out float v_gamma_scale;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nfloat u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}"), lineGradientSDF: Lt("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform sampler2D u_image_dash;uniform float u_mix;uniform lowp float u_lineatlas_width;in vec2 v_normal;in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);float sdfdist_a=texture(u_image_dash,v_tex_a).a;float sdfdist_b=texture(u_image_dash,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0)/min(dasharray_from.w,dasharray_to.w);float dash_alpha=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*dash_alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;in float a_uv_x;in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;out vec2 v_tex_a;out vec2 v_tex_b;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;float texel_height=1.0/u_image_height;float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nfloat u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}"), raster: Lt("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;in vec2 v_pos0;in vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture(u_image0,v_pos0);vec4 color1=texture(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);fragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;uniform vec4 u_coords_top;uniform vec4 u_coords_bottom;in vec2 a_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {vec2 fractionalPos=a_pos/8192.0;vec2 position=mix(mix(u_coords_top.xy,u_coords_top.zw,fractionalPos.x),mix(u_coords_bottom.xy,u_coords_bottom.zw,fractionalPos.x),fractionalPos.y);gl_Position=projectTile(position,position);v_pos0=((fractionalPos-0.5)/u_buffer_scale)+0.5;\n#ifdef GLOBE\nif (a_pos.y <-32767.5) {v_pos0.y=0.0;}if (a_pos.y > 32766.5) {v_pos0.y=1.0;}\n#endif\nv_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"), symbolIcon: Lt("uniform sampler2D u_texture;in vec2 v_tex;in float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;fragColor=texture(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_tex;out float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}"), symbolSDF: Lt("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;in vec2 v_data0;in vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);inner_edge=inner_edge+gamma*gamma_scale;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);if (u_is_halo) {lowp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha=min(smoothstep(halo_edge-gamma_scaled,halo_edge+gamma_scaled,dist),1.0-alpha);}fragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_data0;out vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"), symbolTextAndIcon: Lt("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;in vec4 v_data0;in vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;fragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);fragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec4 v_data0;out vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map && !u_is_along_line) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}"), terrain: Lt("uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;uniform bool u_is_globe_mode;in vec2 v_texture_pos;in float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture(u_texture,vec2(v_texture_pos.x,1.0-v_texture_pos.y));if (!u_is_globe_mode && v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);fragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {fragColor=surface_color;}}", "in vec3 a_pos3d;uniform mat4 u_fog_matrix;uniform float u_ele_delta;out vec2 v_texture_pos;out float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,get_elevation(a_pos3d.xy)-ele_delta);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}"), terrainDepth: Lt("in float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {fragColor=pack(v_depth);}", "in vec3 a_pos3d;uniform float u_ele_delta;out float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);v_depth=gl_Position.z/gl_Position.w;}"), terrainCoords: Lt("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;in vec2 v_texture_pos;void main() {vec4 rgba=texture(u_texture,v_texture_pos);fragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", "in vec3 a_pos3d;uniform float u_ele_delta;out vec2 v_texture_pos;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);}"), projectionErrorMeasurement: Lt("in vec4 v_output_error_encoded;void main() {fragColor=v_output_error_encoded;}", "in vec2 a_pos;uniform highp float u_input;uniform highp float u_output_expected;out vec4 v_output_error_encoded;void main() {float real_output=2.0*atan(exp(PI-(u_input*PI*2.0)))-PI*0.5;float error=real_output-u_output_expected;float abs_error=abs(error)*128.0;v_output_error_encoded.x=min(floor(abs_error*256.0),255.0)/255.0;abs_error-=v_output_error_encoded.x;v_output_error_encoded.y=min(floor(abs_error*65536.0),255.0)/255.0;abs_error-=v_output_error_encoded.x/255.0;v_output_error_encoded.z=min(floor(abs_error*16777216.0),255.0)/255.0;v_output_error_encoded.w=error >=0.0 ? 1.0 : 0.0;gl_Position=vec4(a_pos,0.0,1.0);}"), atmosphere: Lt("in vec3 view_direction;uniform vec3 u_sun_pos;uniform vec3 u_globe_position;uniform float u_globe_radius;uniform float u_atmosphere_blend;/**Shader use from https:*Made some change to adapt to MapLibre Globe geometry*/const float PI=3.141592653589793;const int iSteps=5;const int jSteps=3;/*radius of the planet*/const float EARTH_RADIUS=6371e3;/*radius of the atmosphere*/const float ATMOS_RADIUS=6471e3;vec2 rsi(vec3 r0,vec3 rd,float sr) {float a=dot(rd,rd);float b=2.0*dot(rd,r0);float c=dot(r0,r0)-(sr*sr);float d=(b*b)-4.0*a*c;if (d < 0.0) return vec2(1e5,-1e5);return vec2((-b-sqrt(d))/(2.0*a),(-b+sqrt(d))/(2.0*a));}vec4 atmosphere(vec3 r,vec3 r0,vec3 pSun,float iSun,float rPlanet,float rAtmos,vec3 kRlh,float kMie,float shRlh,float shMie,float g) {pSun=normalize(pSun);r=normalize(r);vec2 p=rsi(r0,r,rAtmos);if (p.x > p.y) {return vec4(0.0,0.0,0.0,1.0);}if (p.x < 0.0) {p.x=0.0;}vec3 pos=r0+r*p.x;vec2 p2=rsi(r0,r,rPlanet);if (p2.x <=p2.y && p2.x > 0.0) {p.y=min(p.y,p2.x);}float iStepSize=(p.y-p.x)/float(iSteps);float iTime=p.x+iStepSize*0.5;vec3 totalRlh=vec3(0,0,0);vec3 totalMie=vec3(0,0,0);float iOdRlh=0.0;float iOdMie=0.0;float mu=dot(r,pSun);float mumu=mu*mu;float gg=g*g;float pRlh=3.0/(16.0*PI)*(1.0+mumu);float pMie=3.0/(8.0*PI)*((1.0-gg)*(mumu+1.0))/(pow(1.0+gg-2.0*mu*g,1.5)*(2.0+gg));for (int i=0; i < iSteps; i++) {vec3 iPos=r0+r*iTime;float iHeight=length(iPos)-rPlanet;float odStepRlh=exp(-iHeight/shRlh)*iStepSize;float odStepMie=exp(-iHeight/shMie)*iStepSize;iOdRlh+=odStepRlh;iOdMie+=odStepMie;float jStepSize=rsi(iPos,pSun,rAtmos).y/float(jSteps);float jTime=jStepSize*0.5;float jOdRlh=0.0;float jOdMie=0.0;for (int j=0; j < jSteps; j++) {vec3 jPos=iPos+pSun*jTime;float jHeight=length(jPos)-rPlanet;jOdRlh+=exp(-jHeight/shRlh)*jStepSize;jOdMie+=exp(-jHeight/shMie)*jStepSize;jTime+=jStepSize;}vec3 attn=exp(-(kMie*(iOdMie+jOdMie)+kRlh*(iOdRlh+jOdRlh)));totalRlh+=odStepRlh*attn;totalMie+=odStepMie*attn;iTime+=iStepSize;}float opacity=exp(-(length(kRlh)*length(totalRlh)+kMie*length(totalMie)));vec3 color=iSun*(pRlh*kRlh*totalRlh+pMie*kMie*totalMie);return vec4(color,opacity);}void main() {vec3 scale_camera_pos=-u_globe_position*EARTH_RADIUS/u_globe_radius;vec4 color=atmosphere(normalize(view_direction),scale_camera_pos,u_sun_pos,22.0,EARTH_RADIUS,ATMOS_RADIUS,vec3(5.5e-6,13.0e-6,22.4e-6),21e-6,8e3,1.2e3,0.758\n);color.rgb=1.0-exp(-1.0*color.rgb);color=pow(color,vec4(1.0/2.2));fragColor=vec4(color.rgb,1.0-color.a)*u_atmosphere_blend;}", "in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 view_direction;void main() {view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,0.0,1.0);}"), sky: Lt("uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform vec2 u_horizon;uniform vec2 u_horizon_normal;uniform float u_sky_horizon_blend;uniform float u_sky_blend;void main() {float x=gl_FragCoord.x;float y=gl_FragCoord.y;float blend=(y-u_horizon.y)*u_horizon_normal.y+(x-u_horizon.x)*u_horizon_normal.x;if (blend > 0.0) {if (blend < u_sky_horizon_blend) {fragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {fragColor=u_sky_color;}}fragColor=mix(fragColor,vec4(vec3(0.0),0.0),u_sky_blend);}", "in vec2 a_pos;void main() {gl_Position=vec4(a_pos,1.0,1.0);}") };
        function Lt(e2, t2) {
          const i2 = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, a2 = t2.match(/in ([\w]+) ([\w]+)/g), r2 = e2.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), o2 = t2.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), s2 = o2 ? o2.concat(r2) : r2, n2 = {};
          return { fragmentSource: e2 = e2.replace(i2, (e3, t3, i3, a3, r3) => (n2[r3] = true, "define" === t3 ? `
#ifndef HAS_UNIFORM_u_${r3}
in ${i3} ${a3} ${r3};
#else
uniform ${i3} ${a3} u_${r3};
#endif
` : `
#ifdef HAS_UNIFORM_u_${r3}
    ${i3} ${a3} ${r3} = u_${r3};
#endif
`)), vertexSource: t2 = t2.replace(i2, (e3, t3, i3, a3, r3) => {
            const o3 = "float" === a3 ? "vec2" : "vec4", s3 = r3.match(/color/) ? "color" : o3;
            return n2[r3] ? "define" === t3 ? `
#ifndef HAS_UNIFORM_u_${r3}
uniform lowp float u_${r3}_t;
in ${i3} ${o3} a_${r3};
out ${i3} ${a3} ${r3};
#else
uniform ${i3} ${a3} u_${r3};
#endif
` : "vec4" === s3 ? `
#ifndef HAS_UNIFORM_u_${r3}
    ${r3} = a_${r3};
#else
    ${i3} ${a3} ${r3} = u_${r3};
#endif
` : `
#ifndef HAS_UNIFORM_u_${r3}
    ${r3} = unpack_mix_${s3}(a_${r3}, u_${r3}_t);
#else
    ${i3} ${a3} ${r3} = u_${r3};
#endif
` : "define" === t3 ? `
#ifndef HAS_UNIFORM_u_${r3}
uniform lowp float u_${r3}_t;
in ${i3} ${o3} a_${r3};
#else
uniform ${i3} ${a3} u_${r3};
#endif
` : "vec4" === s3 ? `
#ifndef HAS_UNIFORM_u_${r3}
    ${i3} ${a3} ${r3} = a_${r3};
#else
    ${i3} ${a3} ${r3} = u_${r3};
#endif
` : `
#ifndef HAS_UNIFORM_u_${r3}
    ${i3} ${a3} ${r3} = unpack_mix_${s3}(a_${r3}, u_${r3}_t);
#else
    ${i3} ${a3} ${r3} = u_${r3};
#endif
`;
          }), staticAttributes: a2, staticUniforms: s2 };
        }
        class kt {
          constructor(e2, t2, i2) {
            this.vertexBuffer = e2, this.indexBuffer = t2, this.segments = i2;
          }
          destroy() {
            this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
          }
        }
        var Ft = t.aV([{ name: "a_pos", type: "Int16", components: 2 }]);
        const Bt = "#define PROJECTION_MERCATOR", Ot = "mercator";
        class jt {
          constructor() {
            this._cachedMesh = null;
          }
          get name() {
            return "mercator";
          }
          get useSubdivision() {
            return false;
          }
          get shaderVariantName() {
            return Ot;
          }
          get shaderDefine() {
            return Bt;
          }
          get shaderPreludeCode() {
            return At.projectionMercator;
          }
          get vertexShaderPreludeCode() {
            return At.projectionMercator.vertexSource;
          }
          get subdivisionGranularity() {
            return t.aW.noSubdivision;
          }
          get useGlobeControls() {
            return false;
          }
          get transitionState() {
            return 0;
          }
          get latitudeErrorCorrectionRadians() {
            return 0;
          }
          destroy() {
          }
          updateGPUdependent(e2) {
          }
          getMeshFromTileID(e2, i2, a2, r2, o2) {
            if (this._cachedMesh) return this._cachedMesh;
            const s2 = new t.aX();
            s2.emplaceBack(0, 0), s2.emplaceBack(t.a5, 0), s2.emplaceBack(0, t.a5), s2.emplaceBack(t.a5, t.a5);
            const n2 = e2.createVertexBuffer(s2, Ft.members), l2 = t.aY.simpleSegment(0, 0, 4, 2), c2 = new t.aZ();
            c2.emplaceBack(1, 0, 2), c2.emplaceBack(1, 2, 3);
            const h2 = e2.createIndexBuffer(c2);
            return this._cachedMesh = new kt(n2, h2, l2), this._cachedMesh;
          }
          recalculate() {
          }
          hasTransition() {
            return false;
          }
          setErrorQueryLatitudeDegrees(e2) {
          }
        }
        class Nt {
          constructor(e2 = 0, t2 = 0, i2 = 0, a2 = 0) {
            if (isNaN(e2) || e2 < 0 || isNaN(t2) || t2 < 0 || isNaN(i2) || i2 < 0 || isNaN(a2) || a2 < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
            this.top = e2, this.bottom = t2, this.left = i2, this.right = a2;
          }
          interpolate(e2, i2, a2) {
            return null != i2.top && null != e2.top && (this.top = t.G.number(e2.top, i2.top, a2)), null != i2.bottom && null != e2.bottom && (this.bottom = t.G.number(e2.bottom, i2.bottom, a2)), null != i2.left && null != e2.left && (this.left = t.G.number(e2.left, i2.left, a2)), null != i2.right && null != e2.right && (this.right = t.G.number(e2.right, i2.right, a2)), this;
          }
          getCenter(e2, i2) {
            const a2 = t.ao((this.left + e2 - this.right) / 2, 0, e2), r2 = t.ao((this.top + i2 - this.bottom) / 2, 0, i2);
            return new t.P(a2, r2);
          }
          equals(e2) {
            return this.top === e2.top && this.bottom === e2.bottom && this.left === e2.left && this.right === e2.right;
          }
          clone() {
            return new Nt(this.top, this.bottom, this.left, this.right);
          }
          toJSON() {
            return { top: this.top, bottom: this.bottom, left: this.left, right: this.right };
          }
        }
        function Zt(e2, t2) {
          if (!e2.renderWorldCopies || e2.lngRange) return;
          const i2 = t2.lng - e2.center.lng;
          t2.lng += i2 > 180 ? -360 : i2 < -180 ? 360 : 0;
        }
        function Gt(e2) {
          return Math.max(0, Math.floor(e2));
        }
        class Ut {
          constructor(e2, i2) {
            var a2;
            this.applyConstrain = (e3, t2) => null !== this._constrainOverride ? this._constrainOverride(e3, t2) : this._callbacks.defaultConstrain(e3, t2), this._callbacks = e2, this._tileSize = 512, this._renderWorldCopies = void 0 === (null == i2 ? void 0 : i2.renderWorldCopies) || !!(null == i2 ? void 0 : i2.renderWorldCopies), this._minZoom = (null == i2 ? void 0 : i2.minZoom) || 0, this._maxZoom = (null == i2 ? void 0 : i2.maxZoom) || 22, this._minPitch = null == (null == i2 ? void 0 : i2.minPitch) ? 0 : null == i2 ? void 0 : i2.minPitch, this._maxPitch = null == (null == i2 ? void 0 : i2.maxPitch) ? 60 : null == i2 ? void 0 : i2.maxPitch, this._constrainOverride = null !== (a2 = null == i2 ? void 0 : i2.constrainOverride) && void 0 !== a2 ? a2 : null, this.setMaxBounds(), this._width = 0, this._height = 0, this._center = new t.V(0, 0), this._elevation = 0, this._zoom = 0, this._tileZoom = Gt(this._zoom), this._scale = t.ar(this._zoom), this._bearingInRadians = 0, this._fovInRadians = 0.6435011087932844, this._pitchInRadians = 0, this._rollInRadians = 0, this._unmodified = true, this._edgeInsets = new Nt(), this._minElevationForCurrentTile = 0, this._autoCalculateNearFarZ = true;
          }
          apply(e2, i2, a2) {
            this._constrainOverride = e2.constrainOverride, this._latRange = e2.latRange, this._lngRange = e2.lngRange, this._width = e2.width, this._height = e2.height, this._center = e2.center, this._elevation = e2.elevation, this._minElevationForCurrentTile = e2.minElevationForCurrentTile, this._zoom = e2.zoom, this._tileZoom = Gt(this._zoom), this._scale = t.ar(this._zoom), this._bearingInRadians = e2.bearingInRadians, this._fovInRadians = e2.fovInRadians, this._pitchInRadians = e2.pitchInRadians, this._rollInRadians = e2.rollInRadians, this._unmodified = e2.unmodified, this._edgeInsets = new Nt(e2.padding.top, e2.padding.bottom, e2.padding.left, e2.padding.right), this._minZoom = e2.minZoom, this._maxZoom = e2.maxZoom, this._minPitch = e2.minPitch, this._maxPitch = e2.maxPitch, this._renderWorldCopies = e2.renderWorldCopies, this._cameraToCenterDistance = e2.cameraToCenterDistance, this._nearZ = e2.nearZ, this._farZ = e2.farZ, this._autoCalculateNearFarZ = !a2 && e2.autoCalculateNearFarZ, i2 && this.constrainInternal(), this._calcMatrices();
          }
          get pixelsToClipSpaceMatrix() {
            return this._pixelsToClipSpaceMatrix;
          }
          get clipSpaceToPixelsMatrix() {
            return this._clipSpaceToPixelsMatrix;
          }
          get minElevationForCurrentTile() {
            return this._minElevationForCurrentTile;
          }
          setMinElevationForCurrentTile(e2) {
            this._minElevationForCurrentTile = e2;
          }
          get tileSize() {
            return this._tileSize;
          }
          get tileZoom() {
            return this._tileZoom;
          }
          get scale() {
            return this._scale;
          }
          get width() {
            return this._width;
          }
          get height() {
            return this._height;
          }
          get bearingInRadians() {
            return this._bearingInRadians;
          }
          get lngRange() {
            return this._lngRange;
          }
          get latRange() {
            return this._latRange;
          }
          get pixelsToGLUnits() {
            return this._pixelsToGLUnits;
          }
          get minZoom() {
            return this._minZoom;
          }
          setMinZoom(e2) {
            this._minZoom !== e2 && (this._minZoom = e2, this.setZoom(this.applyConstrain(this._center, this.zoom).zoom));
          }
          get maxZoom() {
            return this._maxZoom;
          }
          setMaxZoom(e2) {
            this._maxZoom !== e2 && (this._maxZoom = e2, this.setZoom(this.applyConstrain(this._center, this.zoom).zoom));
          }
          get minPitch() {
            return this._minPitch;
          }
          setMinPitch(e2) {
            this._minPitch !== e2 && (this._minPitch = e2, this.setPitch(Math.max(this.pitch, e2)));
          }
          get maxPitch() {
            return this._maxPitch;
          }
          setMaxPitch(e2) {
            this._maxPitch !== e2 && (this._maxPitch = e2, this.setPitch(Math.min(this.pitch, e2)));
          }
          get renderWorldCopies() {
            return this._renderWorldCopies;
          }
          setRenderWorldCopies(e2) {
            void 0 === e2 ? e2 = true : null === e2 && (e2 = false), this._renderWorldCopies = e2;
          }
          get constrainOverride() {
            return this._constrainOverride;
          }
          setConstrainOverride(e2) {
            void 0 === e2 && (e2 = null), this._constrainOverride !== e2 && (this._constrainOverride = e2, this.constrainInternal(), this._calcMatrices());
          }
          get worldSize() {
            return this._tileSize * this._scale;
          }
          get centerOffset() {
            return this.centerPoint._sub(this.size._div(2));
          }
          get size() {
            return new t.P(this._width, this._height);
          }
          get bearing() {
            return this._bearingInRadians / Math.PI * 180;
          }
          setBearing(e2) {
            const i2 = t.W(e2, -180, 180) * Math.PI / 180;
            var r2, o2, s2, n2, l2, c2, h2, u2, d2;
            this._bearingInRadians !== i2 && (this._unmodified = false, this._bearingInRadians = i2, this._calcMatrices(), this._rotationMatrix = a(), r2 = this._rotationMatrix, s2 = -this._bearingInRadians, n2 = (o2 = this._rotationMatrix)[0], l2 = o2[1], c2 = o2[2], h2 = o2[3], u2 = Math.sin(s2), d2 = Math.cos(s2), r2[0] = n2 * d2 + c2 * u2, r2[1] = l2 * d2 + h2 * u2, r2[2] = n2 * -u2 + c2 * d2, r2[3] = l2 * -u2 + h2 * d2);
          }
          get rotationMatrix() {
            return this._rotationMatrix;
          }
          get pitchInRadians() {
            return this._pitchInRadians;
          }
          get pitch() {
            return this._pitchInRadians / Math.PI * 180;
          }
          setPitch(e2) {
            const i2 = t.ao(e2, this.minPitch, this.maxPitch) / 180 * Math.PI;
            this._pitchInRadians !== i2 && (this._unmodified = false, this._pitchInRadians = i2, this._calcMatrices());
          }
          get rollInRadians() {
            return this._rollInRadians;
          }
          get roll() {
            return this._rollInRadians / Math.PI * 180;
          }
          setRoll(e2) {
            const t2 = e2 / 180 * Math.PI;
            this._rollInRadians !== t2 && (this._unmodified = false, this._rollInRadians = t2, this._calcMatrices());
          }
          get fovInRadians() {
            return this._fovInRadians;
          }
          get fov() {
            return t.a_(this._fovInRadians);
          }
          setFov(e2) {
            e2 = t.ao(e2, 0.1, 150), this.fov !== e2 && (this._unmodified = false, this._fovInRadians = t.aq(e2), this._calcMatrices());
          }
          get zoom() {
            return this._zoom;
          }
          setZoom(e2) {
            const i2 = this.applyConstrain(this._center, e2).zoom;
            this._zoom !== i2 && (this._unmodified = false, this._zoom = i2, this._tileZoom = Math.max(0, Math.floor(i2)), this._scale = t.ar(i2), this.constrainInternal(), this._calcMatrices());
          }
          get center() {
            return this._center;
          }
          setCenter(e2) {
            e2.lat === this._center.lat && e2.lng === this._center.lng || (this._unmodified = false, this._center = e2, this.constrainInternal(), this._calcMatrices());
          }
          get elevation() {
            return this._elevation;
          }
          setElevation(e2) {
            e2 !== this._elevation && (this._elevation = e2, this.constrainInternal(), this._calcMatrices());
          }
          get padding() {
            return this._edgeInsets.toJSON();
          }
          setPadding(e2) {
            this._edgeInsets.equals(e2) || (this._unmodified = false, this._edgeInsets.interpolate(this._edgeInsets, e2, 1), this._calcMatrices());
          }
          get centerPoint() {
            return this._edgeInsets.getCenter(this._width, this._height);
          }
          get pixelsPerMeter() {
            return this._pixelPerMeter;
          }
          get unmodified() {
            return this._unmodified;
          }
          get cameraToCenterDistance() {
            return this._cameraToCenterDistance;
          }
          get nearZ() {
            return this._nearZ;
          }
          get farZ() {
            return this._farZ;
          }
          get autoCalculateNearFarZ() {
            return this._autoCalculateNearFarZ;
          }
          overrideNearFarZ(e2, t2) {
            this._autoCalculateNearFarZ = false, this._nearZ = e2, this._farZ = t2, this._calcMatrices();
          }
          clearNearFarZOverride() {
            this._autoCalculateNearFarZ = true, this._calcMatrices();
          }
          isPaddingEqual(e2) {
            return this._edgeInsets.equals(e2);
          }
          interpolatePadding(e2, t2, i2) {
            this._unmodified = false, this._edgeInsets.interpolate(e2, t2, i2), this.constrainInternal(), this._calcMatrices();
          }
          resize(e2, t2, i2 = true) {
            this._width = e2, this._height = t2, i2 && this.constrainInternal(), this._calcMatrices();
          }
          getMaxBounds() {
            return this._latRange && 2 === this._latRange.length && this._lngRange && 2 === this._lngRange.length ? new $([this._lngRange[0], this._latRange[0]], [this._lngRange[1], this._latRange[1]]) : null;
          }
          setMaxBounds(e2) {
            e2 ? (this._lngRange = [e2.getWest(), e2.getEast()], this._latRange = [e2.getSouth(), e2.getNorth()], this.constrainInternal()) : (this._lngRange = null, this._latRange = [-t.ap, t.ap]);
          }
          getCameraQueryGeometry(e2, i2) {
            if (1 === i2.length) return [i2[0], e2];
            {
              const { minX: a2, minY: r2, maxX: o2, maxY: s2 } = t.ac.fromPoints(i2).extend(e2);
              return [new t.P(a2, r2), new t.P(o2, r2), new t.P(o2, s2), new t.P(a2, s2), new t.P(a2, r2)];
            }
          }
          constrainInternal() {
            if (!this.center || !this._width || !this._height || this._constraining) return;
            this._constraining = true;
            const e2 = this._unmodified, { center: t2, zoom: i2 } = this.applyConstrain(this.center, this.zoom);
            this.setCenter(t2), this.setZoom(i2), this._unmodified = e2, this._constraining = false;
          }
          _calcMatrices() {
            if (this._width && this._height) {
              this._pixelsToGLUnits = [2 / this._width, -2 / this._height];
              let e2 = t.as(new Float64Array(16));
              t.Q(e2, e2, [this._width / 2, -this._height / 2, 1]), t.O(e2, e2, [1, -1, 0]), this._clipSpaceToPixelsMatrix = e2, e2 = t.as(new Float64Array(16)), t.Q(e2, e2, [1, -1, 1]), t.O(e2, e2, [-1, -1, 0]), t.Q(e2, e2, [2 / this._width, 2 / this._height, 1]), this._pixelsToClipSpaceMatrix = e2, this._cameraToCenterDistance = 0.5 / Math.tan(this.fovInRadians / 2) * this._height;
            }
            this._callbacks.calcMatrices();
          }
          calculateCenterFromCameraLngLatAlt(e2, i2, a2, r2) {
            const o2 = void 0 !== a2 ? a2 : this.bearing, s2 = r2 = void 0 !== r2 ? r2 : this.pitch, { distanceToCenter: n2, clampedElevation: l2 } = this._distanceToCenterFromAltElevationPitch(i2, this.elevation, s2), { x: c2, y: h2 } = be(s2, o2), u2 = t.ab.fromLngLat(e2, i2);
            let d2, _2, p2 = t.a$(1, u2.y), m2 = 0;
            do {
              if (m2 += 1, m2 > 10) break;
              _2 = n2 / p2, d2 = new t.ab(u2.x + c2 * _2, u2.y + h2 * _2), p2 = 1 / d2.meterInMercatorCoordinateUnits();
            } while (Math.abs(n2 - _2 * p2) > 1e-12);
            return { center: d2.toLngLat(), elevation: l2, zoom: t.au(this.height / 2 / Math.tan(this.fovInRadians / 2) / _2 / this.tileSize) };
          }
          recalculateZoomAndCenter(e2) {
            if (this.elevation - e2 == 0) return;
            const i2 = 1 / this.worldSize, a2 = t.at(1, this.center.lat) * this.worldSize, r2 = t.ab.fromLngLat(this.center, this.elevation), o2 = r2.x / i2, s2 = r2.y / i2, n2 = r2.z / i2, l2 = this.pitch, c2 = this.bearing, { x: h2, y: u2, z: d2 } = be(l2, c2), _2 = this.cameraToCenterDistance, p2 = o2 + _2 * -h2, m2 = s2 + _2 * -u2, f2 = n2 + _2 * d2, { distanceToCenter: g2, clampedElevation: v2 } = this._distanceToCenterFromAltElevationPitch(f2 / a2, e2, l2), x2 = g2 * a2, b2 = new t.ab((p2 + h2 * x2) * i2, (m2 + u2 * x2) * i2, 0).toLngLat(), y2 = t.at(1, b2.lat), w2 = t.au(this.height / 2 / Math.tan(this.fovInRadians / 2) / g2 / y2 / this.tileSize);
            this._elevation = v2, this._center = b2, this.setZoom(w2);
          }
          _distanceToCenterFromAltElevationPitch(e2, i2, a2) {
            const r2 = -Math.cos(t.aq(a2)), o2 = e2 - i2;
            let s2, n2 = i2;
            return r2 * o2 >= 0 || Math.abs(r2) < 0.1 ? (s2 = 1e4, n2 = e2 + s2 * r2) : s2 = -o2 / r2, { distanceToCenter: s2, clampedElevation: n2 };
          }
          getCameraPoint() {
            const e2 = Math.tan(this.pitchInRadians) * (this.cameraToCenterDistance || 1);
            return this.centerPoint.add(new t.P(e2 * Math.sin(this.rollInRadians), e2 * Math.cos(this.rollInRadians)));
          }
          getCameraAltitude() {
            return Math.cos(this.pitchInRadians) * this._cameraToCenterDistance / this._pixelPerMeter + this.elevation;
          }
          getCameraLngLat() {
            const e2 = t.at(1, this.center.lat) * this.worldSize;
            return xe(this.center, this.elevation, this.pitch, this.bearing, this.cameraToCenterDistance / e2).toLngLat();
          }
          getMercatorTileCoordinates(e2) {
            if (!e2) return [0, 0, 1, 1];
            const i2 = e2.canonical.z >= 0 ? 1 << e2.canonical.z : Math.pow(2, e2.canonical.z);
            return [e2.canonical.x / i2, e2.canonical.y / i2, 1 / i2 / t.a5, 1 / i2 / t.a5];
          }
        }
        class Vt {
          constructor(e2, i2) {
            this.min = e2, this.max = i2, this.center = t.b0([], t.b1([], this.min, this.max), 0.5);
          }
          quadrant(e2) {
            const i2 = [e2 % 2 == 0, e2 < 2], a2 = t.b2(this.min), r2 = t.b2(this.max);
            for (let e3 = 0; e3 < i2.length; e3++) a2[e3] = i2[e3] ? this.min[e3] : this.center[e3], r2[e3] = i2[e3] ? this.center[e3] : this.max[e3];
            return r2[2] = this.max[2], new Vt(a2, r2);
          }
          distanceX(e2) {
            return Math.max(Math.min(this.max[0], e2[0]), this.min[0]) - e2[0];
          }
          distanceY(e2) {
            return Math.max(Math.min(this.max[1], e2[1]), this.min[1]) - e2[1];
          }
          intersectsFrustum(e2) {
            let t2 = true;
            for (let i2 = 0; i2 < e2.planes.length; i2++) {
              const a2 = this.intersectsPlane(e2.planes[i2]);
              if (0 === a2) return 0;
              1 === a2 && (t2 = false);
            }
            return t2 ? 2 : e2.aabb.min[0] > this.max[0] || e2.aabb.min[1] > this.max[1] || e2.aabb.min[2] > this.max[2] || e2.aabb.max[0] < this.min[0] || e2.aabb.max[1] < this.min[1] || e2.aabb.max[2] < this.min[2] ? 0 : 1;
          }
          intersectsPlane(e2) {
            let t2 = e2[3], i2 = e2[3];
            for (let a2 = 0; a2 < 3; a2++) e2[a2] > 0 ? (t2 += e2[a2] * this.min[a2], i2 += e2[a2] * this.max[a2]) : (i2 += e2[a2] * this.min[a2], t2 += e2[a2] * this.max[a2]);
            return t2 >= 0 ? 2 : i2 < 0 ? 0 : 1;
          }
        }
        class qt {
          distanceToTile2d(e2, t2, i2, a2) {
            const r2 = a2.distanceX([e2, t2]), o2 = a2.distanceY([e2, t2]);
            return Math.hypot(r2, o2);
          }
          getWrap(e2, t2, i2) {
            return i2;
          }
          getTileBoundingVolume(e2, i2, a2, r2) {
            var o2, s2;
            let n2 = 0, l2 = 0;
            if (null == r2 ? void 0 : r2.terrain) {
              const c3 = new t.a2(e2.z, i2, e2.z, e2.x, e2.y), h2 = r2.terrain.getMinMaxElevation(c3);
              n2 = null !== (o2 = h2.minElevation) && void 0 !== o2 ? o2 : Math.min(0, a2), l2 = null !== (s2 = h2.maxElevation) && void 0 !== s2 ? s2 : Math.max(0, a2);
            }
            const c2 = 1 << e2.z;
            return new Vt([i2 + e2.x / c2, e2.y / c2, n2], [i2 + (e2.x + 1) / c2, (e2.y + 1) / c2, l2]);
          }
          allowVariableZoom(e2, i2) {
            const a2 = e2.fov * (Math.abs(Math.cos(e2.rollInRadians)) * e2.height + Math.abs(Math.sin(e2.rollInRadians)) * e2.width) / e2.height, r2 = t.ao(78.5 - a2 / 2, 0, 60);
            return !!i2.terrain || e2.pitch > r2;
          }
          allowWorldCopies() {
            return true;
          }
          prepareNextFrame() {
          }
        }
        class Wt {
          constructor(e2, t2, i2) {
            this.points = e2, this.planes = t2, this.aabb = i2;
          }
          static fromInvProjectionMatrix(e2, i2 = 1, a2 = 0, r2, o2) {
            const s2 = o2 ? [[6, 5, 4], [0, 1, 2], [0, 3, 7], [2, 1, 5], [3, 2, 6], [0, 4, 5]] : [[0, 1, 2], [6, 5, 4], [0, 3, 7], [2, 1, 5], [3, 2, 6], [0, 4, 5]], n2 = Math.pow(2, a2), l2 = [[-1, 1, -1, 1], [1, 1, -1, 1], [1, -1, -1, 1], [-1, -1, -1, 1], [-1, 1, 1, 1], [1, 1, 1, 1], [1, -1, 1, 1], [-1, -1, 1, 1]].map((a3) => function(e3, i3, a4, r3) {
              const o3 = t.aI([], e3, i3), s3 = 1 / o3[3] / a4 * r3;
              return t.b7(o3, o3, [s3, s3, 1 / o3[3], s3]);
            }(a3, e2, i2, n2));
            r2 && function(e3, i3, a3, r3) {
              const o3 = r3 ? 4 : 0, s3 = r3 ? 0 : 4;
              let n3 = 0;
              const l3 = [], c3 = [];
              for (let i4 = 0; i4 < 4; i4++) {
                const a4 = t.b3([], e3[i4 + s3], e3[i4 + o3]), r4 = t.b8(a4);
                t.b0(a4, a4, 1 / r4), l3.push(r4), c3.push(a4);
              }
              for (let i4 = 0; i4 < 4; i4++) {
                const r4 = t.b9(e3[i4 + o3], c3[i4], a3);
                n3 = null !== r4 && r4 >= 0 ? Math.max(n3, r4) : Math.max(n3, l3[i4]);
              }
              const h3 = function(e4, i4) {
                const a4 = t.b3([], e4[i4[0]], e4[i4[1]]), r4 = t.b3([], e4[i4[2]], e4[i4[1]]), o4 = [0, 0, 0, 0];
                return t.b4(o4, t.b5([], a4, r4)), o4[3] = -t.b6(o4, e4[i4[0]]), o4;
              }(e3, i3), u3 = function(e4, i4) {
                const a4 = t.ba(e4), r4 = t.bb([], e4, 1 / a4), o4 = t.b3([], i4, t.b0([], r4, t.b6(i4, r4))), s4 = t.ba(o4);
                if (s4 > 0) {
                  const e5 = Math.sqrt(1 - r4[3] * r4[3]), a5 = t.b0([], r4, -r4[3]), n4 = t.b1([], a5, t.b0([], o4, e5 / s4));
                  return t.bc(i4, n4);
                }
                return null;
              }(a3, h3);
              if (null !== u3) {
                const e4 = u3 / t.b6(c3[0], h3);
                n3 = Math.min(n3, e4);
              }
              for (let t2 = 0; t2 < 4; t2++) {
                const i4 = Math.min(n3, l3[t2]);
                e3[t2 + s3] = [e3[t2 + o3][0] + c3[t2][0] * i4, e3[t2 + o3][1] + c3[t2][1] * i4, e3[t2 + o3][2] + c3[t2][2] * i4, 1];
              }
            }(l2, s2[0], r2, o2);
            const c2 = s2.map((e3) => {
              const i3 = t.b3([], l2[e3[0]], l2[e3[1]]), a3 = t.b3([], l2[e3[2]], l2[e3[1]]), r3 = t.b4([], t.b5([], i3, a3)), o3 = -t.b6(r3, l2[e3[1]]);
              return r3.concat(o3);
            }), h2 = [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY], u2 = [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY];
            for (const e3 of l2) for (let t2 = 0; t2 < 3; t2++) h2[t2] = Math.min(h2[t2], e3[t2]), u2[t2] = Math.max(u2[t2], e3[t2]);
            return new Wt(l2, c2, new Vt(h2, u2));
          }
        }
        class $t {
          get pixelsToClipSpaceMatrix() {
            return this._helper.pixelsToClipSpaceMatrix;
          }
          get clipSpaceToPixelsMatrix() {
            return this._helper.clipSpaceToPixelsMatrix;
          }
          get pixelsToGLUnits() {
            return this._helper.pixelsToGLUnits;
          }
          get centerOffset() {
            return this._helper.centerOffset;
          }
          get size() {
            return this._helper.size;
          }
          get rotationMatrix() {
            return this._helper.rotationMatrix;
          }
          get centerPoint() {
            return this._helper.centerPoint;
          }
          get pixelsPerMeter() {
            return this._helper.pixelsPerMeter;
          }
          setMinZoom(e2) {
            this._helper.setMinZoom(e2);
          }
          setMaxZoom(e2) {
            this._helper.setMaxZoom(e2);
          }
          setMinPitch(e2) {
            this._helper.setMinPitch(e2);
          }
          setMaxPitch(e2) {
            this._helper.setMaxPitch(e2);
          }
          setRenderWorldCopies(e2) {
            this._helper.setRenderWorldCopies(e2);
          }
          setBearing(e2) {
            this._helper.setBearing(e2);
          }
          setPitch(e2) {
            this._helper.setPitch(e2);
          }
          setRoll(e2) {
            this._helper.setRoll(e2);
          }
          setFov(e2) {
            this._helper.setFov(e2);
          }
          setZoom(e2) {
            this._helper.setZoom(e2);
          }
          setCenter(e2) {
            this._helper.setCenter(e2);
          }
          setElevation(e2) {
            this._helper.setElevation(e2);
          }
          setMinElevationForCurrentTile(e2) {
            this._helper.setMinElevationForCurrentTile(e2);
          }
          setPadding(e2) {
            this._helper.setPadding(e2);
          }
          interpolatePadding(e2, t2, i2) {
            return this._helper.interpolatePadding(e2, t2, i2);
          }
          isPaddingEqual(e2) {
            return this._helper.isPaddingEqual(e2);
          }
          resize(e2, t2, i2 = true) {
            this._helper.resize(e2, t2, i2);
          }
          getMaxBounds() {
            return this._helper.getMaxBounds();
          }
          setMaxBounds(e2) {
            this._helper.setMaxBounds(e2);
          }
          setConstrainOverride(e2) {
            this._helper.setConstrainOverride(e2);
          }
          overrideNearFarZ(e2, t2) {
            this._helper.overrideNearFarZ(e2, t2);
          }
          clearNearFarZOverride() {
            this._helper.clearNearFarZOverride();
          }
          getCameraQueryGeometry(e2) {
            return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e2);
          }
          get tileSize() {
            return this._helper.tileSize;
          }
          get tileZoom() {
            return this._helper.tileZoom;
          }
          get scale() {
            return this._helper.scale;
          }
          get worldSize() {
            return this._helper.worldSize;
          }
          get width() {
            return this._helper.width;
          }
          get height() {
            return this._helper.height;
          }
          get lngRange() {
            return this._helper.lngRange;
          }
          get latRange() {
            return this._helper.latRange;
          }
          get minZoom() {
            return this._helper.minZoom;
          }
          get maxZoom() {
            return this._helper.maxZoom;
          }
          get zoom() {
            return this._helper.zoom;
          }
          get center() {
            return this._helper.center;
          }
          get minPitch() {
            return this._helper.minPitch;
          }
          get maxPitch() {
            return this._helper.maxPitch;
          }
          get pitch() {
            return this._helper.pitch;
          }
          get pitchInRadians() {
            return this._helper.pitchInRadians;
          }
          get roll() {
            return this._helper.roll;
          }
          get rollInRadians() {
            return this._helper.rollInRadians;
          }
          get bearing() {
            return this._helper.bearing;
          }
          get bearingInRadians() {
            return this._helper.bearingInRadians;
          }
          get fov() {
            return this._helper.fov;
          }
          get fovInRadians() {
            return this._helper.fovInRadians;
          }
          get elevation() {
            return this._helper.elevation;
          }
          get minElevationForCurrentTile() {
            return this._helper.minElevationForCurrentTile;
          }
          get padding() {
            return this._helper.padding;
          }
          get unmodified() {
            return this._helper.unmodified;
          }
          get renderWorldCopies() {
            return this._helper.renderWorldCopies;
          }
          get cameraToCenterDistance() {
            return this._helper.cameraToCenterDistance;
          }
          get constrainOverride() {
            return this._helper.constrainOverride;
          }
          get nearZ() {
            return this._helper.nearZ;
          }
          get farZ() {
            return this._helper.farZ;
          }
          get autoCalculateNearFarZ() {
            return this._helper.autoCalculateNearFarZ;
          }
          setTransitionState(e2, t2) {
          }
          constructor(e2) {
            this._posMatrixCache = /* @__PURE__ */ new Map(), this._alignedPosMatrixCache = /* @__PURE__ */ new Map(), this._fogMatrixCacheF32 = /* @__PURE__ */ new Map(), this.defaultConstrain = (e3, i2) => {
              i2 = t.ao(+i2, this.minZoom, this.maxZoom);
              const a2 = { center: new t.V(e3.lng, e3.lat), zoom: i2 };
              let r2 = this._helper._lngRange;
              if (!this._helper._renderWorldCopies && null === r2) {
                const e4 = 180 - 1e-10;
                r2 = [-179.9999999999, e4];
              }
              const o2 = this.tileSize * t.ar(a2.zoom);
              let s2 = 0, n2 = o2, l2 = 0, c2 = o2, h2 = 0, u2 = 0;
              const { x: d2, y: _2 } = this.size;
              if (this._helper._latRange) {
                const e4 = this._helper._latRange;
                s2 = t.X(e4[1]) * o2, n2 = t.X(e4[0]) * o2, n2 - s2 < _2 && (h2 = _2 / (n2 - s2));
              }
              r2 && (l2 = t.W(t.Y(r2[0]) * o2, 0, o2), c2 = t.W(t.Y(r2[1]) * o2, 0, o2), c2 < l2 && (c2 += o2), c2 - l2 < d2 && (u2 = d2 / (c2 - l2)));
              const { x: p2, y: m2 } = me(o2, e3);
              let f2, g2;
              const v2 = Math.max(u2 || 0, h2 || 0);
              if (v2) {
                const e4 = new t.P(u2 ? (c2 + l2) / 2 : p2, h2 ? (n2 + s2) / 2 : m2);
                return a2.center = fe(o2, e4).wrap(), a2.zoom += t.au(v2), a2;
              }
              if (this._helper._latRange) {
                const e4 = _2 / 2;
                m2 - e4 < s2 && (g2 = s2 + e4), m2 + e4 > n2 && (g2 = n2 - e4);
              }
              if (r2) {
                const e4 = (l2 + c2) / 2;
                let i3 = p2;
                this._helper._renderWorldCopies && (i3 = t.W(p2, e4 - o2 / 2, e4 + o2 / 2));
                const a3 = d2 / 2;
                i3 - a3 < l2 && (f2 = l2 + a3), i3 + a3 > c2 && (f2 = c2 - a3);
              }
              if (void 0 !== f2 || void 0 !== g2) {
                const e4 = new t.P(null != f2 ? f2 : p2, null != g2 ? g2 : m2);
                a2.center = fe(o2, e4).wrap();
              }
              return a2;
            }, this.applyConstrain = (e3, t2) => this._helper.applyConstrain(e3, t2), this._helper = new Ut({ calcMatrices: () => {
              this._calcMatrices();
            }, defaultConstrain: (e3, t2) => this.defaultConstrain(e3, t2) }, e2), this._coveringTilesDetailsProvider = new qt();
          }
          clone() {
            const e2 = new $t();
            return e2.apply(this), e2;
          }
          apply(e2, t2, i2) {
            this._helper.apply(e2, t2, i2);
          }
          get cameraPosition() {
            return this._cameraPosition;
          }
          get projectionMatrix() {
            return this._projectionMatrix;
          }
          get modelViewProjectionMatrix() {
            return this._viewProjMatrix;
          }
          get inverseProjectionMatrix() {
            return this._invProjMatrix;
          }
          get mercatorMatrix() {
            return this._mercatorMatrix;
          }
          getVisibleUnwrappedCoordinates(e2) {
            const i2 = [new t.bd(0, e2)];
            if (this._helper._renderWorldCopies) {
              const a2 = this.screenPointToMercatorCoordinate(new t.P(0, 0)), r2 = this.screenPointToMercatorCoordinate(new t.P(this._helper._width, 0)), o2 = this.screenPointToMercatorCoordinate(new t.P(this._helper._width, this._helper._height)), s2 = this.screenPointToMercatorCoordinate(new t.P(0, this._helper._height)), n2 = Math.floor(Math.min(a2.x, r2.x, o2.x, s2.x)), l2 = Math.floor(Math.max(a2.x, r2.x, o2.x, s2.x)), c2 = 1;
              for (let a3 = n2 - c2; a3 <= l2 + c2; a3++) 0 !== a3 && i2.push(new t.bd(a3, e2));
            }
            return i2;
          }
          getCameraFrustum() {
            return Wt.fromInvProjectionMatrix(this._invViewProjMatrix, this.worldSize);
          }
          getClippingPlane() {
            return null;
          }
          getCoveringTilesDetailsProvider() {
            return this._coveringTilesDetailsProvider;
          }
          recalculateZoomAndCenter(e2) {
            const t2 = this.screenPointToLocation(this.centerPoint, e2), i2 = e2 ? e2.getElevationForLngLatZoom(t2, this._helper._tileZoom) : 0;
            this._helper.recalculateZoomAndCenter(i2);
          }
          setLocationAtPoint(e2, i2) {
            const a2 = t.at(this.elevation, this.center.lat), r2 = this.screenPointToMercatorCoordinateAtZ(i2, a2), o2 = this.screenPointToMercatorCoordinateAtZ(this.centerPoint, a2), s2 = t.ab.fromLngLat(e2), n2 = new t.ab(s2.x - (r2.x - o2.x), s2.y - (r2.y - o2.y));
            this.setCenter(null == n2 ? void 0 : n2.toLngLat()), this._helper._renderWorldCopies && this.setCenter(this.center.wrap());
          }
          locationToScreenPoint(e2, i2) {
            return i2 ? this.coordinatePoint(t.ab.fromLngLat(e2), i2.getElevationForLngLat(e2), this._pixelMatrix3D) : this.coordinatePoint(t.ab.fromLngLat(e2));
          }
          screenPointToLocation(e2, t2) {
            var i2;
            return null === (i2 = this.screenPointToMercatorCoordinate(e2, t2)) || void 0 === i2 ? void 0 : i2.toLngLat();
          }
          screenPointToMercatorCoordinate(e2, t2) {
            if (t2) {
              const i2 = t2.pointCoordinate(e2);
              if (null != i2) return i2;
            }
            return this.screenPointToMercatorCoordinateAtZ(e2);
          }
          screenPointToMercatorCoordinateAtZ(e2, i2) {
            const a2 = i2 || 0, r2 = [e2.x, e2.y, 0, 1], o2 = [e2.x, e2.y, 1, 1];
            t.aI(r2, r2, this._pixelMatrixInverse), t.aI(o2, o2, this._pixelMatrixInverse);
            const s2 = r2[3], n2 = o2[3], l2 = r2[1] / s2, c2 = o2[1] / n2, h2 = r2[2] / s2, u2 = o2[2] / n2, d2 = h2 === u2 ? 0 : (a2 - h2) / (u2 - h2);
            return new t.ab(t.G.number(r2[0] / s2, o2[0] / n2, d2) / this.worldSize, t.G.number(l2, c2, d2) / this.worldSize, a2);
          }
          coordinatePoint(e2, i2 = 0, a2 = this._pixelMatrix) {
            const r2 = [e2.x * this.worldSize, e2.y * this.worldSize, i2, 1];
            return t.aI(r2, r2, a2), new t.P(r2[0] / r2[3], r2[1] / r2[3]);
          }
          getBounds() {
            const e2 = Math.max(0, this._helper._height / 2 - ge(this));
            return new $().extend(this.screenPointToLocation(new t.P(0, e2))).extend(this.screenPointToLocation(new t.P(this._helper._width, e2))).extend(this.screenPointToLocation(new t.P(this._helper._width, this._helper._height))).extend(this.screenPointToLocation(new t.P(0, this._helper._height)));
          }
          isPointOnMapSurface(e2, t2) {
            return t2 ? null != t2.pointCoordinate(e2) : e2.y > this.height / 2 - ge(this);
          }
          calculatePosMatrix(e2, i2 = false, a2) {
            var r2;
            const o2 = null !== (r2 = e2.key) && void 0 !== r2 ? r2 : t.be(e2.wrap, e2.canonical.z, e2.canonical.z, e2.canonical.x, e2.canonical.y), s2 = i2 ? this._alignedPosMatrixCache : this._posMatrixCache;
            if (s2.has(o2)) {
              const e3 = s2.get(o2);
              return a2 ? e3.f32 : e3.f64;
            }
            const n2 = ve(e2, this.worldSize);
            t.S(n2, i2 ? this._alignedProjMatrix : this._viewProjMatrix, n2);
            const l2 = { f64: n2, f32: new Float32Array(n2) };
            return s2.set(o2, l2), a2 ? l2.f32 : l2.f64;
          }
          calculateFogMatrix(e2) {
            const i2 = e2.key, a2 = this._fogMatrixCacheF32;
            if (a2.has(i2)) return a2.get(i2);
            const r2 = ve(e2, this.worldSize);
            return t.S(r2, this._fogMatrix, r2), a2.set(i2, new Float32Array(r2)), a2.get(i2);
          }
          calculateCenterFromCameraLngLatAlt(e2, t2, i2, a2) {
            return this._helper.calculateCenterFromCameraLngLatAlt(e2, t2, i2, a2);
          }
          _calculateNearFarZIfNeeded(e2, i2, a2) {
            if (!this._helper.autoCalculateNearFarZ) return;
            const r2 = Math.min(this.elevation, this.minElevationForCurrentTile, this.getCameraAltitude() - 100), o2 = e2 - r2 * this._helper._pixelPerMeter / Math.cos(i2), s2 = r2 < 0 ? o2 : e2, n2 = Math.PI / 2 + this.pitchInRadians, l2 = t.aq(this.fov) * (Math.abs(Math.cos(t.aq(this.roll))) * this.height + Math.abs(Math.sin(t.aq(this.roll))) * this.width) / this.height * (0.5 + a2.y / this.height), c2 = Math.sin(l2) * s2 / Math.sin(t.ao(Math.PI - n2 - l2, 0.01, Math.PI - 0.01)), h2 = ge(this), u2 = Math.atan(h2 / this._helper.cameraToCenterDistance), d2 = t.aq(0.75), _2 = u2 > d2 ? 2 * u2 * (0.5 + a2.y / (2 * h2)) : d2, p2 = Math.sin(_2) * s2 / Math.sin(t.ao(Math.PI - n2 - _2, 0.01, Math.PI - 0.01)), m2 = Math.min(c2, p2);
            this._helper._farZ = 1.01 * (Math.cos(Math.PI / 2 - i2) * m2 + s2), this._helper._nearZ = this._helper._height / 50;
          }
          _calcMatrices() {
            if (!this._helper._height) return;
            const e2 = this.centerOffset, i2 = me(this.worldSize, this.center), a2 = i2.x, r2 = i2.y;
            this._helper._pixelPerMeter = t.at(1, this.center.lat) * this.worldSize;
            const o2 = t.aq(Math.min(this.pitch, pe)), s2 = Math.max(this._helper.cameraToCenterDistance / 2, this._helper.cameraToCenterDistance + this._helper._elevation * this._helper._pixelPerMeter / Math.cos(o2));
            let n2;
            this._calculateNearFarZIfNeeded(s2, o2, e2), n2 = new Float64Array(16), t.bf(n2, this.fovInRadians, this._helper._width / this._helper._height, this._helper._nearZ, this._helper._farZ), this._invProjMatrix = new Float64Array(16), t.aC(this._invProjMatrix, n2), n2[8] = 2 * -e2.x / this._helper._width, n2[9] = 2 * e2.y / this._helper._height, this._projectionMatrix = t.bg(n2), t.Q(n2, n2, [1, -1, 1]), t.O(n2, n2, [0, 0, -this._helper.cameraToCenterDistance]), t.bh(n2, n2, -this.rollInRadians), t.bi(n2, n2, this.pitchInRadians), t.bh(n2, n2, -this.bearingInRadians), t.O(n2, n2, [-a2, -r2, 0]), this._mercatorMatrix = t.Q([], n2, [this.worldSize, this.worldSize, this.worldSize]), t.Q(n2, n2, [1, 1, this._helper._pixelPerMeter]), this._pixelMatrix = t.S(new Float64Array(16), this.clipSpaceToPixelsMatrix, n2), t.O(n2, n2, [0, 0, -this.elevation]), this._viewProjMatrix = n2, this._invViewProjMatrix = t.aC([], n2);
            const l2 = [0, 0, -1, 1];
            t.aI(l2, l2, this._invViewProjMatrix), this._cameraPosition = [l2[0] / l2[3], l2[1] / l2[3], l2[2] / l2[3]], this._fogMatrix = new Float64Array(16), t.bf(this._fogMatrix, this.fovInRadians, this.width / this.height, s2, this._helper._farZ), this._fogMatrix[8] = 2 * -e2.x / this.width, this._fogMatrix[9] = 2 * e2.y / this.height, t.Q(this._fogMatrix, this._fogMatrix, [1, -1, 1]), t.O(this._fogMatrix, this._fogMatrix, [0, 0, -this.cameraToCenterDistance]), t.bh(this._fogMatrix, this._fogMatrix, -this.rollInRadians), t.bi(this._fogMatrix, this._fogMatrix, this.pitchInRadians), t.bh(this._fogMatrix, this._fogMatrix, -this.bearingInRadians), t.O(this._fogMatrix, this._fogMatrix, [-a2, -r2, 0]), t.Q(this._fogMatrix, this._fogMatrix, [1, 1, this._helper._pixelPerMeter]), t.O(this._fogMatrix, this._fogMatrix, [0, 0, -this.elevation]), this._pixelMatrix3D = t.S(new Float64Array(16), this.clipSpaceToPixelsMatrix, n2);
            const c2 = this._helper._width % 2 / 2, h2 = this._helper._height % 2 / 2, u2 = Math.cos(this.bearingInRadians), d2 = Math.sin(-this.bearingInRadians), _2 = a2 - Math.round(a2) + u2 * c2 + d2 * h2, p2 = r2 - Math.round(r2) + u2 * h2 + d2 * c2, m2 = new Float64Array(n2);
            if (t.O(m2, m2, [_2 > 0.5 ? _2 - 1 : _2, p2 > 0.5 ? p2 - 1 : p2, 0]), this._alignedProjMatrix = m2, n2 = t.aC(new Float64Array(16), this._pixelMatrix), !n2) throw new Error("failed to invert matrix");
            this._pixelMatrixInverse = n2, this._clearMatrixCaches();
          }
          _clearMatrixCaches() {
            this._posMatrixCache.clear(), this._alignedPosMatrixCache.clear(), this._fogMatrixCacheF32.clear();
          }
          maxPitchScaleFactor() {
            if (!this._pixelMatrixInverse) return 1;
            const e2 = this.screenPointToMercatorCoordinate(new t.P(0, 0)), i2 = [e2.x * this.worldSize, e2.y * this.worldSize, 0, 1];
            return t.aI(i2, i2, this._pixelMatrix)[3] / this._helper.cameraToCenterDistance;
          }
          getCameraPoint() {
            return this._helper.getCameraPoint();
          }
          getCameraAltitude() {
            return this._helper.getCameraAltitude();
          }
          getCameraLngLat() {
            const e2 = t.at(1, this.center.lat) * this.worldSize;
            return xe(this.center, this.elevation, this.pitch, this.bearing, this._helper.cameraToCenterDistance / e2).toLngLat();
          }
          lngLatToCameraDepth(e2, i2) {
            const a2 = t.ab.fromLngLat(e2), r2 = [a2.x * this.worldSize, a2.y * this.worldSize, i2, 1];
            return t.aI(r2, r2, this._viewProjMatrix), r2[2] / r2[3];
          }
          getProjectionData(e2) {
            const { overscaledTileID: i2, aligned: a2, applyTerrainMatrix: r2 } = e2, o2 = this._helper.getMercatorTileCoordinates(i2), s2 = i2 ? this.calculatePosMatrix(i2, a2, true) : null;
            let n2;
            return n2 = i2 && i2.terrainRttPosMatrix32f && r2 ? i2.terrainRttPosMatrix32f : s2 || t.bj(), { mainMatrix: n2, tileMercatorCoords: o2, clippingPlane: [0, 0, 0, 0], projectionTransition: 0, fallbackMatrix: n2 };
          }
          isLocationOccluded(e2) {
            return false;
          }
          getPixelScale() {
            return 1;
          }
          getCircleRadiusCorrection() {
            return 1;
          }
          getPitchedTextCorrection(e2, t2, i2) {
            return 1;
          }
          transformLightDirection(e2) {
            return t.b2(e2);
          }
          getRayDirectionFromPixel(e2) {
            throw new Error("Not implemented.");
          }
          projectTileCoordinates(e2, i2, a2, r2) {
            const o2 = this.calculatePosMatrix(a2);
            let s2;
            r2 ? (s2 = [e2, i2, r2(e2, i2), 1], t.aI(s2, s2, o2)) : (s2 = [e2, i2, 0, 1], ot(s2, s2, o2));
            const n2 = s2[3];
            return { point: new t.P(s2[0] / n2, s2[1] / n2), signedDistanceFromCamera: n2, isOccluded: false };
          }
          populateCache(e2) {
            for (const t2 of e2) this.calculatePosMatrix(t2);
          }
          getMatrixForModel(e2, i2) {
            const a2 = t.ab.fromLngLat(e2, i2), r2 = a2.meterInMercatorCoordinateUnits(), o2 = t.bk();
            return t.O(o2, o2, [a2.x, a2.y, a2.z]), t.bh(o2, o2, Math.PI), t.bi(o2, o2, Math.PI / 2), t.Q(o2, o2, [-r2, r2, r2]), o2;
          }
          getProjectionDataForCustomLayer(e2 = true) {
            const i2 = new t.a2(0, 0, 0, 0, 0), a2 = this.getProjectionData({ overscaledTileID: i2, applyGlobeMatrix: e2 }), r2 = ve(i2, this.worldSize);
            t.S(r2, this._viewProjMatrix, r2), a2.tileMercatorCoords = [0, 0, 1, 1];
            const o2 = [t.a5, t.a5, this.worldSize / this._helper.pixelsPerMeter], s2 = t.bl();
            return t.Q(s2, r2, o2), a2.fallbackMatrix = s2, a2.mainMatrix = s2, a2;
          }
          getFastPathSimpleProjectionMatrix(e2) {
            return this.calculatePosMatrix(e2);
          }
        }
        function Ht() {
          t.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
        }
        function Xt(e2) {
          if (e2.useSlerp) if (e2.k < 1) {
            const i2 = t.bm(e2.startEulerAngles.roll, e2.startEulerAngles.pitch, e2.startEulerAngles.bearing), a2 = t.bm(e2.endEulerAngles.roll, e2.endEulerAngles.pitch, e2.endEulerAngles.bearing), r2 = new Float64Array(4);
            t.bn(r2, i2, a2, e2.k);
            const o2 = t.bo(r2);
            e2.tr.setRoll(o2.roll), e2.tr.setPitch(o2.pitch), e2.tr.setBearing(o2.bearing);
          } else e2.tr.setRoll(e2.endEulerAngles.roll), e2.tr.setPitch(e2.endEulerAngles.pitch), e2.tr.setBearing(e2.endEulerAngles.bearing);
          else e2.tr.setRoll(t.G.number(e2.startEulerAngles.roll, e2.endEulerAngles.roll, e2.k)), e2.tr.setPitch(t.G.number(e2.startEulerAngles.pitch, e2.endEulerAngles.pitch, e2.k)), e2.tr.setBearing(t.G.number(e2.startEulerAngles.bearing, e2.endEulerAngles.bearing, e2.k));
        }
        function Kt(e2, i2, a2, r2, o2) {
          const s2 = o2.padding, n2 = me(o2.worldSize, a2.getNorthWest()), l2 = me(o2.worldSize, a2.getNorthEast()), c2 = me(o2.worldSize, a2.getSouthEast()), h2 = me(o2.worldSize, a2.getSouthWest()), u2 = t.aq(-r2), d2 = n2.rotate(u2), _2 = l2.rotate(u2), p2 = c2.rotate(u2), m2 = h2.rotate(u2), f2 = new t.P(Math.max(d2.x, _2.x, m2.x, p2.x), Math.max(d2.y, _2.y, m2.y, p2.y)), g2 = new t.P(Math.min(d2.x, _2.x, m2.x, p2.x), Math.min(d2.y, _2.y, m2.y, p2.y)), v2 = f2.sub(g2), x2 = (o2.width - (s2.left + s2.right + i2.left + i2.right)) / v2.x, b2 = (o2.height - (s2.top + s2.bottom + i2.top + i2.bottom)) / v2.y;
          if (b2 < 0 || x2 < 0) return void Ht();
          const y2 = Math.min(t.au(o2.scale * Math.min(x2, b2)), e2.maxZoom), w2 = t.P.convert(e2.offset), T2 = new t.P((i2.left - i2.right) / 2, (i2.top - i2.bottom) / 2).rotate(t.aq(r2)), P2 = w2.add(T2).mult(o2.scale / t.ar(y2));
          return { center: fe(o2.worldSize, n2.add(c2).div(2).sub(P2)), zoom: y2, bearing: r2 };
        }
        class Yt {
          get useGlobeControls() {
            return false;
          }
          handlePanInertia(e2, t2) {
            const i2 = e2.mag(), a2 = Math.abs(ge(t2));
            return { easingOffset: e2.mult(Math.min(0.75 * a2 / i2, 1)), easingCenter: t2.center };
          }
          handleMapControlsRollPitchBearingZoom(e2, t2) {
            e2.bearingDelta && t2.setBearing(t2.bearing + e2.bearingDelta), e2.pitchDelta && t2.setPitch(t2.pitch + e2.pitchDelta), e2.rollDelta && t2.setRoll(t2.roll + e2.rollDelta), e2.zoomDelta && t2.setZoom(t2.zoom + e2.zoomDelta);
          }
          handleMapControlsPan(e2, t2, i2) {
            e2.around.distSqr(t2.centerPoint) < 0.01 || t2.setLocationAtPoint(i2, e2.around);
          }
          cameraForBoxAndBearing(e2, t2, i2, a2, r2) {
            return Kt(e2, t2, i2, a2, r2);
          }
          handleJumpToCenterZoom(e2, i2) {
            e2.zoom !== (void 0 !== i2.zoom ? +i2.zoom : e2.zoom) && e2.setZoom(+i2.zoom), void 0 !== i2.center && e2.setCenter(t.V.convert(i2.center));
          }
          handleEaseTo(e2, i2) {
            const a2 = e2.zoom, r2 = e2.padding, o2 = { roll: e2.roll, pitch: e2.pitch, bearing: e2.bearing }, s2 = { roll: void 0 === i2.roll ? e2.roll : i2.roll, pitch: void 0 === i2.pitch ? e2.pitch : i2.pitch, bearing: void 0 === i2.bearing ? e2.bearing : i2.bearing }, n2 = void 0 !== i2.zoom, l2 = !e2.isPaddingEqual(i2.padding);
            let c2 = false;
            const h2 = n2 ? +i2.zoom : e2.zoom;
            let u2 = e2.centerPoint.add(i2.offsetAsPoint);
            const d2 = e2.screenPointToLocation(u2), { center: _2, zoom: p2 } = e2.applyConstrain(t.V.convert(i2.center || d2), null != h2 ? h2 : a2);
            Zt(e2, _2);
            const m2 = me(e2.worldSize, d2), f2 = me(e2.worldSize, _2).sub(m2), g2 = t.ar(p2 - a2);
            return c2 = p2 !== a2, { easeFunc: (n3) => {
              if (c2 && e2.setZoom(t.G.number(a2, p2, n3)), t.bp(o2, s2) || Xt({ startEulerAngles: o2, endEulerAngles: s2, tr: e2, k: n3, useSlerp: o2.roll != s2.roll }), l2 && (e2.interpolatePadding(r2, i2.padding, n3), u2 = e2.centerPoint.add(i2.offsetAsPoint)), i2.around) e2.setLocationAtPoint(i2.around, i2.aroundPoint);
              else {
                const i3 = t.ar(e2.zoom - a2), r3 = p2 > a2 ? Math.min(2, g2) : Math.max(0.5, g2), o3 = Math.pow(r3, 1 - n3), s3 = fe(e2.worldSize, m2.add(f2.mult(n3 * o3)).mult(i3));
                e2.setLocationAtPoint(e2.renderWorldCopies ? s3.wrap() : s3, u2);
              }
            }, isZooming: c2, elevationCenter: _2 };
          }
          handleFlyTo(e2, i2) {
            const a2 = void 0 !== i2.zoom, r2 = e2.zoom, o2 = e2.applyConstrain(t.V.convert(i2.center || i2.locationAtOffset), a2 ? +i2.zoom : r2), s2 = o2.center, n2 = o2.zoom;
            Zt(e2, s2);
            const l2 = me(e2.worldSize, i2.locationAtOffset), c2 = me(e2.worldSize, s2).sub(l2), h2 = c2.mag(), u2 = t.ar(n2 - r2);
            let d2;
            if (void 0 !== i2.minZoom) {
              const a3 = Math.min(+i2.minZoom, r2, n2), o3 = e2.applyConstrain(s2, a3).zoom;
              d2 = t.ar(o3 - r2);
            }
            return { easeFunc: (i3, a3, o3, h3) => {
              e2.setZoom(1 === i3 ? n2 : r2 + t.au(a3));
              const u3 = 1 === i3 ? s2 : fe(e2.worldSize, l2.add(c2.mult(o3)).mult(a3));
              e2.setLocationAtPoint(e2.renderWorldCopies ? u3.wrap() : u3, h3);
            }, scaleOfZoom: u2, targetCenter: s2, scaleOfMinZoom: d2, pixelPathLength: h2 };
          }
        }
        class Qt {
          constructor(e2, t2, i2) {
            this.blendFunction = e2, this.blendColor = t2, this.mask = i2;
          }
        }
        Qt.Replace = [1, 0], Qt.disabled = new Qt(Qt.Replace, t.bq.transparent, [false, false, false, false]), Qt.unblended = new Qt(Qt.Replace, t.bq.transparent, [true, true, true, true]), Qt.alphaBlended = new Qt([1, 771], t.bq.transparent, [true, true, true, true]);
        const Jt = 2305;
        class ei {
          constructor(e2, t2, i2) {
            this.enable = e2, this.mode = t2, this.frontFace = i2;
          }
        }
        ei.disabled = new ei(false, 1029, Jt), ei.backCCW = new ei(true, 1029, Jt), ei.frontCCW = new ei(true, 1028, Jt);
        class ti {
          constructor(e2, t2, i2) {
            this.func = e2, this.mask = t2, this.range = i2;
          }
        }
        ti.ReadOnly = false, ti.ReadWrite = true, ti.disabled = new ti(519, ti.ReadOnly, [0, 1]);
        const ii = 7680;
        class ai {
          constructor(e2, t2, i2, a2, r2, o2) {
            this.test = e2, this.ref = t2, this.mask = i2, this.fail = a2, this.depthFail = r2, this.pass = o2;
          }
        }
        ai.disabled = new ai({ func: 519, mask: 0 }, 0, 0, ii, ii, ii);
        const ri = /* @__PURE__ */ new WeakMap();
        function oi(e2) {
          var t2;
          if (ri.has(e2)) return ri.get(e2);
          {
            const i2 = null === (t2 = e2.getParameter(e2.VERSION)) || void 0 === t2 ? void 0 : t2.startsWith("WebGL 2.0");
            return ri.set(e2, i2), i2;
          }
        }
        class si {
          get awaitingQuery() {
            return !!this._readbackQueue;
          }
          constructor(e2) {
            this._readbackWaitFrames = 4, this._measureWaitFrames = 6, this._texWidth = 1, this._texHeight = 1, this._measuredError = 0, this._updateCount = 0, this._lastReadbackFrame = -1e3, this._readbackQueue = null, this._cachedRenderContext = e2;
            const i2 = e2.context, a2 = i2.gl;
            this._texFormat = a2.RGBA, this._texType = a2.UNSIGNED_BYTE;
            const r2 = new t.aX();
            r2.emplaceBack(-1, -1), r2.emplaceBack(2, -1), r2.emplaceBack(-1, 2);
            const o2 = new t.aZ();
            o2.emplaceBack(0, 1, 2), this._fullscreenTriangle = new kt(i2.createVertexBuffer(r2, Ft.members), i2.createIndexBuffer(o2), t.aY.simpleSegment(0, 0, r2.length, o2.length)), this._resultBuffer = new Uint8Array(4), i2.activeTexture.set(a2.TEXTURE1);
            const s2 = a2.createTexture();
            a2.bindTexture(a2.TEXTURE_2D, s2), a2.texParameteri(a2.TEXTURE_2D, a2.TEXTURE_WRAP_S, a2.CLAMP_TO_EDGE), a2.texParameteri(a2.TEXTURE_2D, a2.TEXTURE_WRAP_T, a2.CLAMP_TO_EDGE), a2.texParameteri(a2.TEXTURE_2D, a2.TEXTURE_MIN_FILTER, a2.NEAREST), a2.texParameteri(a2.TEXTURE_2D, a2.TEXTURE_MAG_FILTER, a2.NEAREST), a2.texImage2D(a2.TEXTURE_2D, 0, this._texFormat, this._texWidth, this._texHeight, 0, this._texFormat, this._texType, null), this._fbo = i2.createFramebuffer(this._texWidth, this._texHeight, false, false), this._fbo.colorAttachment.set(s2), oi(a2) && (this._pbo = a2.createBuffer(), a2.bindBuffer(a2.PIXEL_PACK_BUFFER, this._pbo), a2.bufferData(a2.PIXEL_PACK_BUFFER, 4, a2.STREAM_READ), a2.bindBuffer(a2.PIXEL_PACK_BUFFER, null));
          }
          destroy() {
            const e2 = this._cachedRenderContext.context.gl;
            this._fullscreenTriangle.destroy(), this._fbo.destroy(), e2.deleteBuffer(this._pbo), this._fullscreenTriangle = null, this._fbo = null, this._pbo = null, this._resultBuffer = null;
          }
          updateErrorLoop(e2, t2) {
            const i2 = this._updateCount;
            return this._readbackQueue ? i2 >= this._readbackQueue.frameNumberIssued + this._readbackWaitFrames && this._tryReadback() : i2 >= this._lastReadbackFrame + this._measureWaitFrames && this._renderErrorTexture(e2, t2), this._updateCount++, this._measuredError;
          }
          _bindFramebuffer() {
            const e2 = this._cachedRenderContext.context, t2 = e2.gl;
            e2.activeTexture.set(t2.TEXTURE1), t2.bindTexture(t2.TEXTURE_2D, this._fbo.colorAttachment.get()), e2.bindFramebuffer.set(this._fbo.framebuffer);
          }
          _renderErrorTexture(e2, i2) {
            const a2 = this._cachedRenderContext.context, r2 = a2.gl;
            if (this._bindFramebuffer(), a2.viewport.set([0, 0, this._texWidth, this._texHeight]), a2.clear({ color: t.bq.transparent }), this._cachedRenderContext.useProgram("projectionErrorMeasurement").draw(a2, r2.TRIANGLES, ti.disabled, ai.disabled, Qt.unblended, ei.disabled, /* @__PURE__ */ ((e3, t2) => ({ u_input: e3, u_output_expected: t2 }))(e2, i2), null, null, "$clipping", this._fullscreenTriangle.vertexBuffer, this._fullscreenTriangle.indexBuffer, this._fullscreenTriangle.segments), this._pbo && oi(r2)) {
              r2.bindBuffer(r2.PIXEL_PACK_BUFFER, this._pbo), r2.readBuffer(r2.COLOR_ATTACHMENT0), r2.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, 0), r2.bindBuffer(r2.PIXEL_PACK_BUFFER, null);
              const e3 = r2.fenceSync(r2.SYNC_GPU_COMMANDS_COMPLETE, 0);
              r2.flush(), this._readbackQueue = { frameNumberIssued: this._updateCount, sync: e3 };
            } else this._readbackQueue = { frameNumberIssued: this._updateCount, sync: null };
          }
          _tryReadback() {
            const e2 = this._cachedRenderContext.context.gl;
            if (this._pbo && this._readbackQueue && oi(e2)) {
              const i2 = e2.clientWaitSync(this._readbackQueue.sync, 0, 0);
              if (i2 === e2.WAIT_FAILED) return t.w("WebGL2 clientWaitSync failed."), this._readbackQueue = null, void (this._lastReadbackFrame = this._updateCount);
              if (i2 === e2.TIMEOUT_EXPIRED) return;
              e2.bindBuffer(e2.PIXEL_PACK_BUFFER, this._pbo), e2.getBufferSubData(e2.PIXEL_PACK_BUFFER, 0, this._resultBuffer, 0, 4), e2.bindBuffer(e2.PIXEL_PACK_BUFFER, null);
            } else this._bindFramebuffer(), e2.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, this._resultBuffer);
            this._readbackQueue = null, this._measuredError = si._parseRGBA8float(this._resultBuffer), this._lastReadbackFrame = this._updateCount;
          }
          static _parseRGBA8float(e2) {
            let t2 = 0;
            return t2 += e2[0] / 256, t2 += e2[1] / 65536, t2 += e2[2] / 16777216, e2[3] < 127 && (t2 = -t2), t2 / 128;
          }
        }
        const ni = t.a5 / 128;
        function li(e2, i2) {
          const a2 = void 0 !== e2.granularity ? Math.max(e2.granularity, 1) : 1, r2 = a2 + (e2.generateBorders ? 2 : 0), o2 = a2 + (e2.extendToNorthPole || e2.generateBorders ? 1 : 0) + (e2.extendToSouthPole || e2.generateBorders ? 1 : 0), s2 = r2 + 1, n2 = o2 + 1, l2 = e2.generateBorders ? -1 : 0, c2 = e2.generateBorders || e2.extendToNorthPole ? -1 : 0, h2 = a2 + (e2.generateBorders ? 1 : 0), u2 = a2 + (e2.generateBorders || e2.extendToSouthPole ? 1 : 0), d2 = s2 * n2, _2 = r2 * o2 * 6, p2 = s2 * n2 > 65536;
          if (p2 && "16bit" === i2) throw new Error("Granularity is too large and meshes would not fit inside 16 bit vertex indices.");
          const m2 = p2 || "32bit" === i2, f2 = new Int16Array(2 * d2);
          let g2 = 0;
          for (let i3 = c2; i3 <= u2; i3++) for (let r3 = l2; r3 <= h2; r3++) {
            let o3 = r3 / a2 * t.a5;
            -1 === r3 && (o3 = -ni), r3 === a2 + 1 && (o3 = t.a5 + ni);
            let s3 = i3 / a2 * t.a5;
            -1 === i3 && (s3 = e2.extendToNorthPole ? t.bs : -ni), i3 === a2 + 1 && (s3 = e2.extendToSouthPole ? t.bt : t.a5 + ni), f2[g2++] = o3, f2[g2++] = s3;
          }
          const v2 = m2 ? new Uint32Array(_2) : new Uint16Array(_2);
          let x2 = 0;
          for (let e3 = 0; e3 < o2; e3++) for (let t2 = 0; t2 < r2; t2++) {
            const i3 = t2 + 1 + e3 * s2, a3 = t2 + (e3 + 1) * s2, r3 = t2 + 1 + (e3 + 1) * s2;
            v2[x2++] = t2 + e3 * s2, v2[x2++] = a3, v2[x2++] = i3, v2[x2++] = i3, v2[x2++] = a3, v2[x2++] = r3;
          }
          return { vertices: f2.buffer.slice(0), indices: v2.buffer.slice(0), uses32bitIndices: m2 };
        }
        const ci = new t.aW({ fill: new t.bu(128, 2), line: new t.bu(512, 0), tile: new t.bu(128, 32), stencil: new t.bu(128, 1), circle: 3 });
        class hi {
          constructor() {
            this._tileMeshCache = {}, this._errorCorrectionUsable = 0, this._errorMeasurementLastValue = 0, this._errorCorrectionPreviousValue = 0, this._errorMeasurementLastChangeTime = -1e3;
          }
          get name() {
            return "vertical-perspective";
          }
          get transitionState() {
            return 1;
          }
          get useSubdivision() {
            return true;
          }
          get shaderVariantName() {
            return "globe";
          }
          get shaderDefine() {
            return "#define GLOBE";
          }
          get shaderPreludeCode() {
            return At.projectionGlobe;
          }
          get vertexShaderPreludeCode() {
            return At.projectionMercator.vertexSource;
          }
          get subdivisionGranularity() {
            return ci;
          }
          get useGlobeControls() {
            return true;
          }
          get latitudeErrorCorrectionRadians() {
            return this._errorCorrectionUsable;
          }
          destroy() {
            this._errorMeasurement && this._errorMeasurement.destroy();
          }
          updateGPUdependent(e2) {
            this._errorMeasurement || (this._errorMeasurement = new si(e2));
            const i2 = t.X(this._errorQueryLatitudeDegrees), a2 = 2 * Math.atan(Math.exp(Math.PI - i2 * Math.PI * 2)) - 0.5 * Math.PI, r2 = this._errorMeasurement.updateErrorLoop(i2, a2), o2 = c();
            r2 !== this._errorMeasurementLastValue && (this._errorCorrectionPreviousValue = this._errorCorrectionUsable, this._errorMeasurementLastValue = r2, this._errorMeasurementLastChangeTime = o2);
            const s2 = Math.min(Math.max((o2 - this._errorMeasurementLastChangeTime) / 1e3 / 0.5, 0), 1);
            this._errorCorrectionUsable = t.bv(this._errorCorrectionPreviousValue, -this._errorMeasurementLastValue, t.bw(s2));
          }
          _getMeshKey(e2) {
            return `${e2.granularity.toString(36)}_${e2.generateBorders ? "b" : ""}${e2.extendToNorthPole ? "n" : ""}${e2.extendToSouthPole ? "s" : ""}`;
          }
          getMeshFromTileID(e2, t2, i2, a2, r2) {
            const o2 = ("stencil" === r2 ? ci.stencil : ci.tile).getGranularityForZoomLevel(t2.z);
            return this._getMesh(e2, { granularity: o2, generateBorders: i2, extendToNorthPole: 0 === t2.y && a2, extendToSouthPole: t2.y === (1 << t2.z) - 1 && a2 });
          }
          _getMesh(e2, i2) {
            const a2 = this._getMeshKey(i2);
            if (a2 in this._tileMeshCache) return this._tileMeshCache[a2];
            const r2 = function(e3, i3) {
              const a3 = li(i3, "16bit"), r3 = t.aX.deserialize({ arrayBuffer: a3.vertices, length: a3.vertices.byteLength / 2 / 2 }), o2 = t.aZ.deserialize({ arrayBuffer: a3.indices, length: a3.indices.byteLength / 2 / 3 });
              return new kt(e3.createVertexBuffer(r3, Ft.members), e3.createIndexBuffer(o2), t.aY.simpleSegment(0, 0, r3.length, o2.length));
            }(e2, i2);
            return this._tileMeshCache[a2] = r2, r2;
          }
          recalculate(e2) {
          }
          hasTransition() {
            const e2 = c();
            let t2 = false;
            return t2 = t2 || (e2 - this._errorMeasurementLastChangeTime) / 1e3 < 0.7, t2 = t2 || this._errorMeasurement && this._errorMeasurement.awaitingQuery, t2;
          }
          setErrorQueryLatitudeDegrees(e2) {
            this._errorQueryLatitudeDegrees = e2;
          }
        }
        const ui = new t.t({ type: new t.D(t.u.projection.type) });
        class di extends t.E {
          constructor(e2) {
            super(), this._transitionable = new t.x(ui, void 0), this.setProjection(e2), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new t.H(0)), this._mercatorProjection = new jt(), this._verticalPerspectiveProjection = new hi();
          }
          get transitionState() {
            const e2 = this.properties.get("type");
            if ("string" == typeof e2 && "mercator" === e2) return 0;
            if ("string" == typeof e2 && "vertical-perspective" === e2) return 1;
            if (e2 instanceof t.bx) {
              if ("vertical-perspective" === e2.from && "mercator" === e2.to) return 1 - e2.transition;
              if ("mercator" === e2.from && "vertical-perspective" === e2.to) return e2.transition;
            }
            return 1;
          }
          get useGlobeRendering() {
            return this.transitionState > 0;
          }
          get latitudeErrorCorrectionRadians() {
            return this._verticalPerspectiveProjection.latitudeErrorCorrectionRadians;
          }
          get currentProjection() {
            return this.useGlobeRendering ? this._verticalPerspectiveProjection : this._mercatorProjection;
          }
          get name() {
            return "globe";
          }
          get useSubdivision() {
            return this.currentProjection.useSubdivision;
          }
          get shaderVariantName() {
            return this.currentProjection.shaderVariantName;
          }
          get shaderDefine() {
            return this.currentProjection.shaderDefine;
          }
          get shaderPreludeCode() {
            return this.currentProjection.shaderPreludeCode;
          }
          get vertexShaderPreludeCode() {
            return this.currentProjection.vertexShaderPreludeCode;
          }
          get subdivisionGranularity() {
            return this.currentProjection.subdivisionGranularity;
          }
          get useGlobeControls() {
            return this.transitionState > 0;
          }
          destroy() {
            this._mercatorProjection.destroy(), this._verticalPerspectiveProjection.destroy();
          }
          updateGPUdependent(e2) {
            this._mercatorProjection.updateGPUdependent(e2), this._verticalPerspectiveProjection.updateGPUdependent(e2);
          }
          getMeshFromTileID(e2, t2, i2, a2, r2) {
            return this.currentProjection.getMeshFromTileID(e2, t2, i2, a2, r2);
          }
          setProjection(e2) {
            this._transitionable.setValue("type", (null == e2 ? void 0 : e2.type) || "mercator");
          }
          updateTransitions(e2) {
            this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
          }
          hasTransition() {
            return this._transitioning.hasTransition() || this.currentProjection.hasTransition();
          }
          recalculate(e2) {
            this.properties = this._transitioning.possiblyEvaluate(e2);
          }
          setErrorQueryLatitudeDegrees(e2) {
            this._verticalPerspectiveProjection.setErrorQueryLatitudeDegrees(e2), this._mercatorProjection.setErrorQueryLatitudeDegrees(e2);
          }
        }
        function _i(e2) {
          const t2 = fi(e2.worldSize, e2.center.lat);
          return 2 * Math.PI * t2;
        }
        function pi(e2, i2, a2, r2, o2) {
          const s2 = 1 / (1 << o2), n2 = i2 / t.a5 * s2 + r2 * s2, l2 = t.bz((e2 / t.a5 * s2 + a2 * s2) * Math.PI * 2 + Math.PI, 2 * Math.PI), c2 = 2 * Math.atan(Math.exp(Math.PI - n2 * Math.PI * 2)) - 0.5 * Math.PI, h2 = Math.cos(c2), u2 = new Float64Array(3);
          return u2[0] = Math.sin(l2) * h2, u2[1] = Math.sin(c2), u2[2] = Math.cos(l2) * h2, u2;
        }
        function mi(e2) {
          return function(e3, t2) {
            const i2 = Math.cos(t2), a2 = new Float64Array(3);
            return a2[0] = Math.sin(e3) * i2, a2[1] = Math.sin(t2), a2[2] = Math.cos(e3) * i2, a2;
          }(e2.lng * Math.PI / 180, e2.lat * Math.PI / 180);
        }
        function fi(e2, t2) {
          return e2 / (2 * Math.PI) / Math.cos(t2 * Math.PI / 180);
        }
        function gi(e2) {
          const i2 = Math.asin(e2[1]) / Math.PI * 180, a2 = Math.sqrt(e2[0] * e2[0] + e2[2] * e2[2]);
          if (a2 > 1e-6) {
            const r2 = e2[0] / a2, o2 = Math.acos(e2[2] / a2), s2 = (r2 > 0 ? o2 : -o2) / Math.PI * 180;
            return new t.V(t.W(s2, -180, 180), i2);
          }
          return new t.V(0, i2);
        }
        function vi(e2) {
          return Math.cos(e2 * Math.PI / 180);
        }
        function xi(e2, i2) {
          const a2 = vi(e2), r2 = vi(i2);
          return t.au(r2 / a2);
        }
        function bi(e2, i2) {
          const a2 = e2.rotate(i2.bearingInRadians), r2 = i2.zoom + xi(i2.center.lat, 0), o2 = t.bv(1 / vi(i2.center.lat), 1 / vi(Math.min(Math.abs(i2.center.lat), 60)), t.by(r2, 7, 3, 0, 1)), s2 = 360 / _i({ worldSize: i2.worldSize, center: { lat: i2.center.lat } });
          return new t.V(i2.center.lng - a2.x * s2 * o2, t.ao(i2.center.lat + a2.y * s2, -t.ap, t.ap));
        }
        function yi(e2) {
          const t2 = 0.5 * e2, i2 = Math.sin(t2), a2 = Math.cos(t2);
          return Math.log(i2 + a2) - Math.log(a2 - i2);
        }
        function wi(e2, i2, a2, r2) {
          const o2 = e2.lat + a2 * r2;
          if (Math.abs(a2) > 1) {
            const s2 = (Math.sign(e2.lat + a2) !== Math.sign(e2.lat) ? -Math.abs(e2.lat) : Math.abs(e2.lat)) * Math.PI / 180, n2 = Math.abs(e2.lat + a2) * Math.PI / 180, l2 = yi(s2 + r2 * (n2 - s2)), c2 = yi(s2), h2 = yi(n2);
            return new t.V(e2.lng + i2 * ((l2 - c2) / (h2 - c2)), o2);
          }
          return new t.V(e2.lng + i2 * r2, o2);
        }
        class Ti {
          constructor(e2) {
            this._cachePrevious = /* @__PURE__ */ new Map(), this._cache = /* @__PURE__ */ new Map(), this._hadAnyChanges = false, this._boundingVolumeFactory = e2;
          }
          swapBuffers() {
            if (!this._hadAnyChanges) return;
            const e2 = this._cachePrevious;
            this._cachePrevious = this._cache, this._cache = e2, this._cache.clear(), this._hadAnyChanges = false;
          }
          getTileBoundingVolume(e2, t2, i2, a2) {
            const r2 = `${e2.z}_${e2.x}_${e2.y}_${(null == a2 ? void 0 : a2.terrain) ? "t" : ""}`, o2 = this._cache.get(r2);
            if (o2) return o2;
            const s2 = this._cachePrevious.get(r2);
            if (s2) return this._cache.set(r2, s2), s2;
            const n2 = this._boundingVolumeFactory(e2, t2, i2, a2);
            return this._cache.set(r2, n2), this._hadAnyChanges = true, n2;
          }
        }
        class Pi {
          constructor(e2, t2, i2, a2) {
            this.min = i2, this.max = a2, this.points = e2, this.planes = t2;
          }
          static fromAabb(e2, t2) {
            const i2 = [];
            for (let a2 = 0; a2 < 8; a2++) i2.push([1 & ~a2 ? e2[0] : t2[0], 1 == (a2 >> 1 & 1) ? t2[1] : e2[1], 1 == (a2 >> 2 & 1) ? t2[2] : e2[2]]);
            return new Pi(i2, [[-1, 0, 0, t2[0]], [1, 0, 0, -e2[0]], [0, -1, 0, t2[1]], [0, 1, 0, -e2[1]], [0, 0, -1, t2[2]], [0, 0, 1, -e2[2]]], e2, t2);
          }
          static fromCenterSizeAngles(e2, i2, a2) {
            const r2 = t.bC([], a2[0], a2[1], a2[2]), o2 = t.bD([], [i2[0], 0, 0], r2), s2 = t.bD([], [0, i2[1], 0], r2), n2 = t.bD([], [0, 0, i2[2]], r2), l2 = [...e2], c2 = [...e2];
            for (let t2 = 0; t2 < 8; t2++) for (let i3 = 0; i3 < 3; i3++) {
              const a3 = e2[i3] + o2[i3] * (1 & ~t2 ? -1 : 1) + s2[i3] * (1 == (t2 >> 1 & 1) ? 1 : -1) + n2[i3] * (1 == (t2 >> 2 & 1) ? 1 : -1);
              l2[i3] = Math.min(l2[i3], a3), c2[i3] = Math.max(c2[i3], a3);
            }
            const h2 = [];
            for (let i3 = 0; i3 < 8; i3++) {
              const a3 = [...e2];
              t.b1(a3, a3, t.b0([], o2, 1 & ~i3 ? -1 : 1)), t.b1(a3, a3, t.b0([], s2, 1 == (i3 >> 1 & 1) ? 1 : -1)), t.b1(a3, a3, t.b0([], n2, 1 == (i3 >> 2 & 1) ? 1 : -1)), h2.push(a3);
            }
            return new Pi(h2, [[...o2, -t.b6(o2, h2[0])], [...s2, -t.b6(s2, h2[0])], [...n2, -t.b6(n2, h2[0])], [-o2[0], -o2[1], -o2[2], -t.b6(o2, h2[7])], [-s2[0], -s2[1], -s2[2], -t.b6(s2, h2[7])], [-n2[0], -n2[1], -n2[2], -t.b6(n2, h2[7])]], l2, c2);
          }
          intersectsFrustum(e2) {
            let t2 = true;
            const i2 = this.points.length, a2 = this.planes.length, r2 = e2.planes.length, o2 = e2.points.length;
            for (let a3 = 0; a3 < r2; a3++) {
              const r3 = e2.planes[a3];
              let o3 = 0;
              for (let e3 = 0; e3 < i2; e3++) {
                const t3 = this.points[e3];
                r3[0] * t3[0] + r3[1] * t3[1] + r3[2] * t3[2] + r3[3] >= 0 && o3++;
              }
              if (0 === o3) return 0;
              o3 < i2 && (t2 = false);
            }
            if (t2) return 2;
            for (let t3 = 0; t3 < a2; t3++) {
              const i3 = this.planes[t3];
              let a3 = 0;
              for (let t4 = 0; t4 < o2; t4++) {
                const r3 = e2.points[t4];
                i3[0] * r3[0] + i3[1] * r3[1] + i3[2] * r3[2] + i3[3] >= 0 && a3++;
              }
              if (0 === a3) return 0;
            }
            return 1;
          }
          intersectsPlane(e2) {
            const t2 = this.points.length;
            let i2 = 0;
            for (let a2 = 0; a2 < t2; a2++) {
              const t3 = this.points[a2];
              e2[0] * t3[0] + e2[1] * t3[1] + e2[2] * t3[2] + e2[3] >= 0 && i2++;
            }
            return i2 === t2 ? 2 : 0 === i2 ? 0 : 1;
          }
        }
        function Ii(e2, t2, i2) {
          const a2 = e2 - t2;
          return a2 < 0 ? -a2 : Math.max(0, a2 - i2);
        }
        function Ci(e2, t2, i2, a2, r2) {
          const o2 = e2 - i2;
          let s2;
          return s2 = o2 < 0 ? Math.min(-o2, 1 + o2 - r2) : o2 > 1 ? Math.min(Math.max(o2 - r2, 0), 1 - o2) : 0, Math.max(s2, Ii(t2, a2, r2));
        }
        class Mi {
          constructor() {
            this._boundingVolumeCache = new Ti(this._computeTileBoundingVolume);
          }
          prepareNextFrame() {
            this._boundingVolumeCache.swapBuffers();
          }
          distanceToTile2d(e2, t2, i2, a2) {
            const r2 = 1 << i2.z, o2 = 1 / r2, s2 = i2.x / r2, n2 = i2.y / r2;
            let l2 = 2;
            return l2 = Math.min(l2, Ci(e2, t2, s2, n2, o2)), l2 = Math.min(l2, Ci(e2, t2, s2 + 0.5, -n2 - o2, o2)), l2 = Math.min(l2, Ci(e2, t2, s2 + 0.5, 2 - n2 - o2, o2)), l2;
          }
          getWrap(e2, t2, i2) {
            const a2 = 1 << t2.z, r2 = 1 / a2, o2 = t2.x / a2, s2 = Ii(e2.x, o2, r2), n2 = Ii(e2.x, o2 - 1, r2), l2 = Ii(e2.x, o2 + 1, r2), c2 = Math.min(s2, n2, l2);
            return c2 === l2 ? 1 : c2 === n2 ? -1 : 0;
          }
          allowVariableZoom(e2, t2) {
            return Ie(e2, t2) > 4;
          }
          allowWorldCopies() {
            return false;
          }
          getTileBoundingVolume(e2, t2, i2, a2) {
            return this._boundingVolumeCache.getTileBoundingVolume(e2, t2, i2, a2);
          }
          _computeTileBoundingVolume(e2, i2, a2, r2) {
            var o2, s2;
            let n2 = 0, l2 = 0;
            if (null == r2 ? void 0 : r2.terrain) {
              const c2 = new t.a2(e2.z, i2, e2.z, e2.x, e2.y), h2 = r2.terrain.getMinMaxElevation(c2);
              n2 = null !== (o2 = h2.minElevation) && void 0 !== o2 ? o2 : Math.min(0, a2), l2 = null !== (s2 = h2.maxElevation) && void 0 !== s2 ? s2 : Math.max(0, a2);
            }
            if (n2 /= t.bF, l2 /= t.bF, n2 += 1, l2 += 1, e2.z <= 0) return Pi.fromAabb([-l2, -l2, -l2], [l2, l2, l2]);
            if (1 === e2.z) return Pi.fromAabb([0 === e2.x ? -l2 : 0, 0 === e2.y ? 0 : -l2, -l2], [0 === e2.x ? 0 : l2, 0 === e2.y ? l2 : 0, l2]);
            {
              const i3 = [pi(0, 0, e2.x, e2.y, e2.z), pi(t.a5, 0, e2.x, e2.y, e2.z), pi(t.a5, t.a5, e2.x, e2.y, e2.z), pi(0, t.a5, e2.x, e2.y, e2.z)], a3 = [];
              for (const e3 of i3) a3.push(t.b0([], e3, l2));
              if (l2 !== n2) for (const e3 of i3) a3.push(t.b0([], e3, n2));
              0 === e2.y && a3.push([0, 1, 0]), e2.y === (1 << e2.z) - 1 && a3.push([0, -1, 0]);
              const r3 = [1, 1, 1], o3 = [-1, -1, -1];
              for (const e3 of a3) for (let t2 = 0; t2 < 3; t2++) r3[t2] = Math.min(r3[t2], e3[t2]), o3[t2] = Math.max(o3[t2], e3[t2]);
              const s3 = pi(t.a5 / 2, t.a5 / 2, e2.x, e2.y, e2.z), c2 = t.b5([], [0, 1, 0], s3);
              t.b4(c2, c2);
              const h2 = t.b5([], s3, c2);
              t.b4(h2, h2);
              const u2 = t.b5([], i3[2], i3[1]);
              t.b4(u2, u2);
              const d2 = t.b5([], i3[0], i3[3]);
              t.b4(d2, d2), a3.push(t.b0([], s3, l2)), e2.y >= (1 << e2.z) / 2 && a3.push(t.b0([], pi(t.a5 / 2, 0, e2.x, e2.y, e2.z), l2)), e2.y < (1 << e2.z) / 2 && a3.push(t.b0([], pi(t.a5 / 2, t.a5, e2.x, e2.y, e2.z), l2));
              const _2 = Ei(s3, a3), p2 = Ei(h2, a3), m2 = [-s3[0], -s3[1], -s3[2], _2.max], f2 = [s3[0], s3[1], s3[2], -_2.min], g2 = [-h2[0], -h2[1], -h2[2], p2.max], v2 = [h2[0], h2[1], h2[2], -p2.min], x2 = [...u2, 0], b2 = [...d2, 0], y2 = [];
              return 0 === e2.y ? y2.push(t.bE(b2, x2, m2), t.bE(b2, x2, f2)) : y2.push(t.bE(g2, x2, m2), t.bE(g2, x2, f2), t.bE(g2, b2, m2), t.bE(g2, b2, f2)), e2.y === (1 << e2.z) - 1 ? y2.push(t.bE(b2, x2, m2), t.bE(b2, x2, f2)) : y2.push(t.bE(v2, x2, m2), t.bE(v2, x2, f2), t.bE(v2, b2, m2), t.bE(v2, b2, f2)), new Pi(y2, [m2, f2, g2, v2, x2, b2], r3, o3);
            }
          }
        }
        function Ei(e2, i2) {
          let a2 = 1 / 0, r2 = -1 / 0;
          for (const o2 of i2) {
            const i3 = t.b6(e2, o2);
            a2 = Math.min(a2, i3), r2 = Math.max(r2, i3);
          }
          return { min: a2, max: r2 };
        }
        class Si {
          get pixelsToClipSpaceMatrix() {
            return this._helper.pixelsToClipSpaceMatrix;
          }
          get clipSpaceToPixelsMatrix() {
            return this._helper.clipSpaceToPixelsMatrix;
          }
          get pixelsToGLUnits() {
            return this._helper.pixelsToGLUnits;
          }
          get centerOffset() {
            return this._helper.centerOffset;
          }
          get size() {
            return this._helper.size;
          }
          get rotationMatrix() {
            return this._helper.rotationMatrix;
          }
          get centerPoint() {
            return this._helper.centerPoint;
          }
          get pixelsPerMeter() {
            return this._helper.pixelsPerMeter;
          }
          setMinZoom(e2) {
            this._helper.setMinZoom(e2);
          }
          setMaxZoom(e2) {
            this._helper.setMaxZoom(e2);
          }
          setMinPitch(e2) {
            this._helper.setMinPitch(e2);
          }
          setMaxPitch(e2) {
            this._helper.setMaxPitch(e2);
          }
          setRenderWorldCopies(e2) {
            this._helper.setRenderWorldCopies(e2);
          }
          setBearing(e2) {
            this._helper.setBearing(e2);
          }
          setPitch(e2) {
            this._helper.setPitch(e2);
          }
          setRoll(e2) {
            this._helper.setRoll(e2);
          }
          setFov(e2) {
            this._helper.setFov(e2);
          }
          setZoom(e2) {
            this._helper.setZoom(e2);
          }
          setCenter(e2) {
            this._helper.setCenter(e2);
          }
          setElevation(e2) {
            this._helper.setElevation(e2);
          }
          setMinElevationForCurrentTile(e2) {
            this._helper.setMinElevationForCurrentTile(e2);
          }
          setPadding(e2) {
            this._helper.setPadding(e2);
          }
          interpolatePadding(e2, t2, i2) {
            return this._helper.interpolatePadding(e2, t2, i2);
          }
          isPaddingEqual(e2) {
            return this._helper.isPaddingEqual(e2);
          }
          resize(e2, t2) {
            this._helper.resize(e2, t2);
          }
          getMaxBounds() {
            return this._helper.getMaxBounds();
          }
          setMaxBounds(e2) {
            this._helper.setMaxBounds(e2);
          }
          setConstrainOverride(e2) {
            this._helper.setConstrainOverride(e2);
          }
          overrideNearFarZ(e2, t2) {
            this._helper.overrideNearFarZ(e2, t2);
          }
          clearNearFarZOverride() {
            this._helper.clearNearFarZOverride();
          }
          getCameraQueryGeometry(e2) {
            return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e2);
          }
          get tileSize() {
            return this._helper.tileSize;
          }
          get tileZoom() {
            return this._helper.tileZoom;
          }
          get scale() {
            return this._helper.scale;
          }
          get worldSize() {
            return this._helper.worldSize;
          }
          get width() {
            return this._helper.width;
          }
          get height() {
            return this._helper.height;
          }
          get lngRange() {
            return this._helper.lngRange;
          }
          get latRange() {
            return this._helper.latRange;
          }
          get minZoom() {
            return this._helper.minZoom;
          }
          get maxZoom() {
            return this._helper.maxZoom;
          }
          get zoom() {
            return this._helper.zoom;
          }
          get center() {
            return this._helper.center;
          }
          get minPitch() {
            return this._helper.minPitch;
          }
          get maxPitch() {
            return this._helper.maxPitch;
          }
          get pitch() {
            return this._helper.pitch;
          }
          get pitchInRadians() {
            return this._helper.pitchInRadians;
          }
          get roll() {
            return this._helper.roll;
          }
          get rollInRadians() {
            return this._helper.rollInRadians;
          }
          get bearing() {
            return this._helper.bearing;
          }
          get bearingInRadians() {
            return this._helper.bearingInRadians;
          }
          get fov() {
            return this._helper.fov;
          }
          get fovInRadians() {
            return this._helper.fovInRadians;
          }
          get elevation() {
            return this._helper.elevation;
          }
          get minElevationForCurrentTile() {
            return this._helper.minElevationForCurrentTile;
          }
          get padding() {
            return this._helper.padding;
          }
          get unmodified() {
            return this._helper.unmodified;
          }
          get renderWorldCopies() {
            return this._helper.renderWorldCopies;
          }
          get constrainOverride() {
            return this._helper.constrainOverride;
          }
          get nearZ() {
            return this._helper.nearZ;
          }
          get farZ() {
            return this._helper.farZ;
          }
          get autoCalculateNearFarZ() {
            return this._helper.autoCalculateNearFarZ;
          }
          setTransitionState(e2) {
          }
          constructor(e2) {
            this._cachedClippingPlane = t.bG(), this._projectionMatrix = t.bk(), this._globeViewProjMatrix32f = t.bj(), this._globeViewProjMatrixNoCorrection = t.bk(), this._globeViewProjMatrixNoCorrectionInverted = t.bk(), this._globeProjMatrixInverted = t.bk(), this._cameraPosition = t.bA(), this._globeLatitudeErrorCorrectionRadians = 0, this.defaultConstrain = (e3, i2) => {
              const a2 = t.ao(e3.lat, -t.ap, t.ap), r2 = t.ao(+i2, this.minZoom + xi(0, a2), this.maxZoom);
              return { center: new t.V(e3.lng, a2), zoom: r2 };
            }, this.applyConstrain = (e3, t2) => this._helper.applyConstrain(e3, t2), this._helper = new Ut({ calcMatrices: () => {
              this._calcMatrices();
            }, defaultConstrain: (e3, t2) => this.defaultConstrain(e3, t2) }, e2), this._coveringTilesDetailsProvider = new Mi();
          }
          clone() {
            const e2 = new Si();
            return e2.apply(this), e2;
          }
          apply(e2, t2) {
            this._globeLatitudeErrorCorrectionRadians = t2 || 0, this._helper.apply(e2);
          }
          get projectionMatrix() {
            return this._projectionMatrix;
          }
          get modelViewProjectionMatrix() {
            return this._globeViewProjMatrixNoCorrection;
          }
          get inverseProjectionMatrix() {
            return this._globeProjMatrixInverted;
          }
          get cameraPosition() {
            const e2 = t.bA();
            return e2[0] = this._cameraPosition[0], e2[1] = this._cameraPosition[1], e2[2] = this._cameraPosition[2], e2;
          }
          get cameraToCenterDistance() {
            return this._helper.cameraToCenterDistance;
          }
          getProjectionData(e2) {
            const { overscaledTileID: t2, applyGlobeMatrix: i2 } = e2, a2 = this._helper.getMercatorTileCoordinates(t2);
            return { mainMatrix: this._globeViewProjMatrix32f, tileMercatorCoords: a2, clippingPlane: this._cachedClippingPlane, projectionTransition: i2 ? 1 : 0, fallbackMatrix: this._globeViewProjMatrix32f };
          }
          _computeClippingPlane(e2) {
            const i2 = this.pitchInRadians, a2 = this.cameraToCenterDistance / e2, r2 = Math.sin(i2) * a2, o2 = Math.cos(i2) * a2 + 1, s2 = 1 / Math.sqrt(r2 * r2 + o2 * o2) * 1;
            let n2 = -r2, l2 = o2;
            const c2 = Math.sqrt(n2 * n2 + l2 * l2);
            n2 /= c2, l2 /= c2;
            const h2 = [0, n2, l2];
            t.bH(h2, h2, [0, 0, 0], -this.bearingInRadians), t.bI(h2, h2, [0, 0, 0], -1 * this.center.lat * Math.PI / 180), t.bJ(h2, h2, [0, 0, 0], this.center.lng * Math.PI / 180);
            const u2 = 1 / t.b8(h2);
            return t.b0(h2, h2, u2), [...h2, -s2 * u2];
          }
          isLocationOccluded(e2) {
            return !this.isSurfacePointVisible(mi(e2));
          }
          transformLightDirection(e2) {
            const i2 = this._helper._center.lng * Math.PI / 180, a2 = this._helper._center.lat * Math.PI / 180, r2 = Math.cos(a2), o2 = [Math.sin(i2) * r2, Math.sin(a2), Math.cos(i2) * r2], s2 = [o2[2], 0, -o2[0]], n2 = [0, 0, 0];
            t.b5(n2, s2, o2), t.b4(s2, s2), t.b4(n2, n2);
            const l2 = [0, 0, 0];
            return t.b4(l2, [s2[0] * e2[0] + n2[0] * e2[1] + o2[0] * e2[2], s2[1] * e2[0] + n2[1] * e2[1] + o2[1] * e2[2], s2[2] * e2[0] + n2[2] * e2[1] + o2[2] * e2[2]]), l2;
          }
          getPixelScale() {
            return 1 / Math.cos(this._helper._center.lat * Math.PI / 180);
          }
          getCircleRadiusCorrection() {
            return Math.cos(this._helper._center.lat * Math.PI / 180);
          }
          getPitchedTextCorrection(e2, i2, a2) {
            const r2 = function(e3, i3, a3) {
              const r3 = 1 / (1 << a3.z);
              return new t.ab(e3 / t.a5 * r3 + a3.x * r3, i3 / t.a5 * r3 + a3.y * r3);
            }(e2, i2, a2.canonical), o2 = (s2 = r2.y, [t.bz(r2.x * Math.PI * 2 + Math.PI, 2 * Math.PI), 2 * Math.atan(Math.exp(Math.PI - s2 * Math.PI * 2)) - 0.5 * Math.PI]);
            var s2;
            return this.getCircleRadiusCorrection() / Math.cos(o2[1]);
          }
          projectTileCoordinates(e2, i2, a2, r2) {
            const o2 = a2.canonical, s2 = pi(e2, i2, o2.x, o2.y, o2.z), n2 = 1 + (r2 ? r2(e2, i2) : 0) / t.bF, l2 = [s2[0] * n2, s2[1] * n2, s2[2] * n2, 1];
            t.aI(l2, l2, this._globeViewProjMatrixNoCorrection);
            const c2 = this._cachedClippingPlane, h2 = c2[0] * s2[0] + c2[1] * s2[1] + c2[2] * s2[2] + c2[3] < 0;
            return { point: new t.P(l2[0] / l2[3], l2[1] / l2[3]), signedDistanceFromCamera: l2[3], isOccluded: h2 };
          }
          _calcMatrices() {
            if (!this._helper._width || !this._helper._height) return;
            const e2 = fi(this.worldSize, this.center.lat), i2 = t.bl(), a2 = t.bl();
            this._helper.autoCalculateNearFarZ && (this._helper._nearZ = 0.5, this._helper._farZ = this.cameraToCenterDistance + 2 * e2), t.bf(i2, this.fovInRadians, this.width / this.height, this._helper._nearZ, this._helper._farZ);
            const r2 = this.centerOffset;
            i2[8] = 2 * -r2.x / this._helper._width, i2[9] = 2 * r2.y / this._helper._height, this._projectionMatrix = t.bg(i2), this._globeProjMatrixInverted = t.bl(), t.aC(this._globeProjMatrixInverted, i2), t.O(i2, i2, [0, 0, -this.cameraToCenterDistance]), t.bh(i2, i2, this.rollInRadians), t.bi(i2, i2, -this.pitchInRadians), t.bh(i2, i2, this.bearingInRadians), t.O(i2, i2, [0, 0, -e2]);
            const o2 = t.bA();
            o2[0] = e2, o2[1] = e2, o2[2] = e2, t.bi(a2, i2, this.center.lat * Math.PI / 180), t.bK(a2, a2, -this.center.lng * Math.PI / 180), t.Q(a2, a2, o2), this._globeViewProjMatrixNoCorrection = a2, t.bi(i2, i2, this.center.lat * Math.PI / 180 - this._globeLatitudeErrorCorrectionRadians), t.bK(i2, i2, -this.center.lng * Math.PI / 180), t.Q(i2, i2, o2), this._globeViewProjMatrix32f = new Float32Array(i2), this._globeViewProjMatrixNoCorrectionInverted = t.bl(), t.aC(this._globeViewProjMatrixNoCorrectionInverted, a2);
            const s2 = t.bA();
            this._cameraPosition = t.bA(), this._cameraPosition[2] = this.cameraToCenterDistance / e2, t.bH(this._cameraPosition, this._cameraPosition, s2, -this.rollInRadians), t.bI(this._cameraPosition, this._cameraPosition, s2, this.pitchInRadians), t.bH(this._cameraPosition, this._cameraPosition, s2, -this.bearingInRadians), t.b1(this._cameraPosition, this._cameraPosition, [0, 0, 1]), t.bI(this._cameraPosition, this._cameraPosition, s2, -this.center.lat * Math.PI / 180), t.bJ(this._cameraPosition, this._cameraPosition, s2, this.center.lng * Math.PI / 180), this._cachedClippingPlane = this._computeClippingPlane(e2);
            const n2 = t.bg(this._globeViewProjMatrixNoCorrectionInverted);
            t.Q(n2, n2, [1, 1, -1]), this._cachedFrustum = Wt.fromInvProjectionMatrix(n2, 1, 0, this._cachedClippingPlane, true);
          }
          calculateFogMatrix(e2) {
            t.w("calculateFogMatrix is not supported on globe projection.");
            const i2 = t.bl();
            return t.as(i2), i2;
          }
          getVisibleUnwrappedCoordinates(e2) {
            return [new t.bd(0, e2)];
          }
          getCameraFrustum() {
            return this._cachedFrustum;
          }
          getClippingPlane() {
            return this._cachedClippingPlane;
          }
          getCoveringTilesDetailsProvider() {
            return this._coveringTilesDetailsProvider;
          }
          recalculateZoomAndCenter(e2) {
            e2 && t.w("terrain is not fully supported on vertical perspective projection."), this._helper.recalculateZoomAndCenter(0);
          }
          maxPitchScaleFactor() {
            return 1;
          }
          getCameraPoint() {
            return this._helper.getCameraPoint();
          }
          getCameraAltitude() {
            return this._helper.getCameraAltitude();
          }
          getCameraLngLat() {
            return this._helper.getCameraLngLat();
          }
          lngLatToCameraDepth(e2, i2) {
            if (!this._globeViewProjMatrixNoCorrection) return 1;
            const a2 = mi(e2);
            t.b0(a2, a2, 1 + i2 / t.bF);
            const r2 = t.bG();
            return t.aI(r2, [a2[0], a2[1], a2[2], 1], this._globeViewProjMatrixNoCorrection), r2[2] / r2[3];
          }
          populateCache(e2) {
          }
          getBounds() {
            const e2 = 0.5 * this.width, i2 = 0.5 * this.height, a2 = [new t.P(0, 0), new t.P(e2, 0), new t.P(this.width, 0), new t.P(this.width, i2), new t.P(this.width, this.height), new t.P(e2, this.height), new t.P(0, this.height), new t.P(0, i2)], r2 = [];
            for (const e3 of a2) r2.push(this.unprojectScreenPoint(e3));
            let o2 = 0, s2 = 0, n2 = 0, l2 = 0;
            const c2 = this.center;
            for (const e3 of r2) {
              const i3 = t.bL(c2.lng, e3.lng), a3 = t.bL(c2.lat, e3.lat);
              i3 < s2 && (s2 = i3), i3 > o2 && (o2 = i3), a3 < l2 && (l2 = a3), a3 > n2 && (n2 = a3);
            }
            const h2 = [c2.lng + s2, c2.lat + l2, c2.lng + o2, c2.lat + n2];
            return this.isSurfacePointOnScreen([0, 1, 0]) && (h2[3] = 90, h2[0] = -180, h2[2] = 180), this.isSurfacePointOnScreen([0, -1, 0]) && (h2[1] = -90, h2[0] = -180, h2[2] = 180), new $(h2);
          }
          calculateCenterFromCameraLngLatAlt(e2, t2, i2, a2) {
            return this._helper.calculateCenterFromCameraLngLatAlt(e2, t2, i2, a2);
          }
          setLocationAtPoint(e2, i2) {
            const a2 = mi(this.unprojectScreenPoint(i2)), r2 = mi(e2), o2 = t.bA();
            t.bM(o2);
            const s2 = t.bA();
            t.bJ(s2, a2, o2, -this.center.lng * Math.PI / 180), t.bI(s2, s2, o2, this.center.lat * Math.PI / 180);
            const n2 = r2[0] * r2[0] + r2[2] * r2[2], l2 = s2[0] * s2[0];
            if (n2 < l2) return;
            const c2 = Math.sqrt(n2 - l2), h2 = -c2, u2 = t.bN(r2[0], r2[2], s2[0], c2), d2 = t.bN(r2[0], r2[2], s2[0], h2), _2 = t.bA();
            t.bJ(_2, r2, o2, -u2);
            const p2 = t.bN(_2[1], _2[2], s2[1], s2[2]), m2 = t.bA();
            t.bJ(m2, r2, o2, -d2);
            const f2 = t.bN(m2[1], m2[2], s2[1], s2[2]), g2 = 0.5 * Math.PI, v2 = p2 >= -g2 && p2 <= g2, x2 = f2 >= -g2 && f2 <= g2;
            let b2, y2;
            if (v2 && x2) {
              const e3 = this.center.lng * Math.PI / 180, i3 = this.center.lat * Math.PI / 180;
              t.bO(u2, e3) + t.bO(p2, i3) < t.bO(d2, e3) + t.bO(f2, i3) ? (b2 = u2, y2 = p2) : (b2 = d2, y2 = f2);
            } else if (v2) b2 = u2, y2 = p2;
            else {
              if (!x2) return;
              b2 = d2, y2 = f2;
            }
            const w2 = b2 / Math.PI * 180, T2 = y2 / Math.PI * 180, P2 = this.center.lat;
            this.setCenter(new t.V(w2, t.ao(T2, -90, 90))), this.setZoom(this.zoom + xi(P2, this.center.lat));
          }
          locationToScreenPoint(e2, i2) {
            const a2 = mi(e2);
            if (i2) {
              const r2 = i2.getElevationForLngLatZoom(e2, this._helper._tileZoom);
              t.b0(a2, a2, 1 + r2 / t.bF);
            }
            return this._projectSurfacePointToScreen(a2);
          }
          _projectSurfacePointToScreen(e2) {
            const i2 = t.bG();
            return t.aI(i2, [...e2, 1], this._globeViewProjMatrixNoCorrection), i2[0] /= i2[3], i2[1] /= i2[3], new t.P((0.5 * i2[0] + 0.5) * this.width, (0.5 * -i2[1] + 0.5) * this.height);
          }
          screenPointToMercatorCoordinate(e2, i2) {
            if (i2) {
              const t2 = i2.pointCoordinate(e2);
              if (t2) return t2;
            }
            return t.ab.fromLngLat(this.unprojectScreenPoint(e2));
          }
          screenPointToLocation(e2, t2) {
            var i2;
            return null === (i2 = this.screenPointToMercatorCoordinate(e2, t2)) || void 0 === i2 ? void 0 : i2.toLngLat();
          }
          isPointOnMapSurface(e2, t2) {
            const i2 = this._cameraPosition, a2 = this.getRayDirectionFromPixel(e2);
            return !!this.rayPlanetIntersection(i2, a2);
          }
          getRayDirectionFromPixel(e2) {
            const i2 = t.bG();
            i2[0] = e2.x / this.width * 2 - 1, i2[1] = -1 * (e2.y / this.height * 2 - 1), i2[2] = 1, i2[3] = 1, t.aI(i2, i2, this._globeViewProjMatrixNoCorrectionInverted), i2[0] /= i2[3], i2[1] /= i2[3], i2[2] /= i2[3];
            const a2 = t.bA();
            a2[0] = i2[0] - this._cameraPosition[0], a2[1] = i2[1] - this._cameraPosition[1], a2[2] = i2[2] - this._cameraPosition[2];
            const r2 = t.bA();
            return t.b4(r2, a2), r2;
          }
          isSurfacePointVisible(e2) {
            const t2 = this._cachedClippingPlane;
            return t2[0] * e2[0] + t2[1] * e2[1] + t2[2] * e2[2] + t2[3] >= 0;
          }
          isSurfacePointOnScreen(e2) {
            if (!this.isSurfacePointVisible(e2)) return false;
            const i2 = t.bG();
            return t.aI(i2, [...e2, 1], this._globeViewProjMatrixNoCorrection), i2[0] /= i2[3], i2[1] /= i2[3], i2[2] /= i2[3], i2[0] > -1 && i2[0] < 1 && i2[1] > -1 && i2[1] < 1 && i2[2] > -1 && i2[2] < 1;
          }
          rayPlanetIntersection(e2, i2) {
            const a2 = t.b6(e2, i2), r2 = t.bA(), o2 = t.bA();
            t.b0(o2, i2, a2), t.b3(r2, e2, o2);
            const s2 = 1 - t.b6(r2, r2);
            if (s2 < 0) return null;
            const n2 = t.b6(e2, e2) - 1, l2 = -a2 + (a2 < 0 ? 1 : -1) * Math.sqrt(s2), c2 = n2 / l2, h2 = l2;
            return { tMin: Math.min(c2, h2), tMax: Math.max(c2, h2) };
          }
          unprojectScreenPoint(e2) {
            const i2 = this._cameraPosition, a2 = this.getRayDirectionFromPixel(e2), r2 = this.rayPlanetIntersection(i2, a2);
            if (r2) {
              const e3 = t.bA();
              t.b1(e3, i2, [a2[0] * r2.tMin, a2[1] * r2.tMin, a2[2] * r2.tMin]);
              const o3 = t.bA();
              return t.b4(o3, e3), gi(o3);
            }
            const o2 = this._cachedClippingPlane, s2 = o2[0] * a2[0] + o2[1] * a2[1] + o2[2] * a2[2], n2 = -t.bc(o2, i2) / s2, l2 = t.bA();
            if (n2 > 0) t.b1(l2, i2, [a2[0] * n2, a2[1] * n2, a2[2] * n2]);
            else {
              const e3 = t.bA();
              t.b1(e3, i2, [2 * a2[0], 2 * a2[1], 2 * a2[2]]);
              const r3 = t.bc(this._cachedClippingPlane, e3);
              t.b3(l2, e3, [this._cachedClippingPlane[0] * r3, this._cachedClippingPlane[1] * r3, this._cachedClippingPlane[2] * r3]);
            }
            const c2 = function(e3) {
              const i3 = t.bA();
              return i3[0] = e3[0] * -e3[3], i3[1] = e3[1] * -e3[3], i3[2] = e3[2] * -e3[3], { center: i3, radius: Math.sqrt(1 - e3[3] * e3[3]) };
            }(o2);
            return gi(function(e3, i3, a3) {
              const r3 = t.bA();
              t.b3(r3, a3, e3);
              const o3 = t.bA();
              return t.bB(o3, e3, r3, i3 / t.ba(r3)), o3;
            }(c2.center, c2.radius, l2));
          }
          getMatrixForModel(e2, i2) {
            const a2 = t.V.convert(e2), r2 = 1 / t.bF, o2 = t.bk();
            return t.bK(o2, o2, a2.lng / 180 * Math.PI), t.bi(o2, o2, -a2.lat / 180 * Math.PI), t.O(o2, o2, [0, 0, 1 + i2 / t.bF]), t.bi(o2, o2, 0.5 * Math.PI), t.Q(o2, o2, [r2, r2, r2]), o2;
          }
          getProjectionDataForCustomLayer(e2 = true) {
            const i2 = this.getProjectionData({ overscaledTileID: new t.a2(0, 0, 0, 0, 0), applyGlobeMatrix: e2 });
            return i2.tileMercatorCoords = [0, 0, 1, 1], i2;
          }
          getFastPathSimpleProjectionMatrix(e2) {
          }
        }
        class Ri {
          get pixelsToClipSpaceMatrix() {
            return this._helper.pixelsToClipSpaceMatrix;
          }
          get clipSpaceToPixelsMatrix() {
            return this._helper.clipSpaceToPixelsMatrix;
          }
          get pixelsToGLUnits() {
            return this._helper.pixelsToGLUnits;
          }
          get centerOffset() {
            return this._helper.centerOffset;
          }
          get size() {
            return this._helper.size;
          }
          get rotationMatrix() {
            return this._helper.rotationMatrix;
          }
          get centerPoint() {
            return this._helper.centerPoint;
          }
          get pixelsPerMeter() {
            return this._helper.pixelsPerMeter;
          }
          setMinZoom(e2) {
            this._helper.setMinZoom(e2);
          }
          setMaxZoom(e2) {
            this._helper.setMaxZoom(e2);
          }
          setMinPitch(e2) {
            this._helper.setMinPitch(e2);
          }
          setMaxPitch(e2) {
            this._helper.setMaxPitch(e2);
          }
          setRenderWorldCopies(e2) {
            this._helper.setRenderWorldCopies(e2);
          }
          setBearing(e2) {
            this._helper.setBearing(e2);
          }
          setPitch(e2) {
            this._helper.setPitch(e2);
          }
          setRoll(e2) {
            this._helper.setRoll(e2);
          }
          setFov(e2) {
            this._helper.setFov(e2);
          }
          setZoom(e2) {
            this._helper.setZoom(e2);
          }
          setCenter(e2) {
            this._helper.setCenter(e2);
          }
          setElevation(e2) {
            this._helper.setElevation(e2);
          }
          setMinElevationForCurrentTile(e2) {
            this._helper.setMinElevationForCurrentTile(e2);
          }
          setPadding(e2) {
            this._helper.setPadding(e2);
          }
          interpolatePadding(e2, t2, i2) {
            return this._helper.interpolatePadding(e2, t2, i2);
          }
          isPaddingEqual(e2) {
            return this._helper.isPaddingEqual(e2);
          }
          resize(e2, t2, i2 = true) {
            this._helper.resize(e2, t2, i2);
          }
          getMaxBounds() {
            return this._helper.getMaxBounds();
          }
          setMaxBounds(e2) {
            this._helper.setMaxBounds(e2);
          }
          setConstrainOverride(e2) {
            this._helper.setConstrainOverride(e2);
          }
          overrideNearFarZ(e2, t2) {
            this._helper.overrideNearFarZ(e2, t2);
          }
          clearNearFarZOverride() {
            this._helper.clearNearFarZOverride();
          }
          getCameraQueryGeometry(e2) {
            return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e2);
          }
          get tileSize() {
            return this._helper.tileSize;
          }
          get tileZoom() {
            return this._helper.tileZoom;
          }
          get scale() {
            return this._helper.scale;
          }
          get worldSize() {
            return this._helper.worldSize;
          }
          get width() {
            return this._helper.width;
          }
          get height() {
            return this._helper.height;
          }
          get lngRange() {
            return this._helper.lngRange;
          }
          get latRange() {
            return this._helper.latRange;
          }
          get minZoom() {
            return this._helper.minZoom;
          }
          get maxZoom() {
            return this._helper.maxZoom;
          }
          get zoom() {
            return this._helper.zoom;
          }
          get center() {
            return this._helper.center;
          }
          get minPitch() {
            return this._helper.minPitch;
          }
          get maxPitch() {
            return this._helper.maxPitch;
          }
          get pitch() {
            return this._helper.pitch;
          }
          get pitchInRadians() {
            return this._helper.pitchInRadians;
          }
          get roll() {
            return this._helper.roll;
          }
          get rollInRadians() {
            return this._helper.rollInRadians;
          }
          get bearing() {
            return this._helper.bearing;
          }
          get bearingInRadians() {
            return this._helper.bearingInRadians;
          }
          get fov() {
            return this._helper.fov;
          }
          get fovInRadians() {
            return this._helper.fovInRadians;
          }
          get elevation() {
            return this._helper.elevation;
          }
          get minElevationForCurrentTile() {
            return this._helper.minElevationForCurrentTile;
          }
          get padding() {
            return this._helper.padding;
          }
          get unmodified() {
            return this._helper.unmodified;
          }
          get renderWorldCopies() {
            return this._helper.renderWorldCopies;
          }
          get cameraToCenterDistance() {
            return this._helper.cameraToCenterDistance;
          }
          get constrainOverride() {
            return this._helper.constrainOverride;
          }
          get nearZ() {
            return this._helper.nearZ;
          }
          get farZ() {
            return this._helper.farZ;
          }
          get autoCalculateNearFarZ() {
            return this._helper.autoCalculateNearFarZ;
          }
          get isGlobeRendering() {
            return this._globeness > 0;
          }
          setTransitionState(e2, t2) {
            this._globeness = e2, this._globeLatitudeErrorCorrectionRadians = t2, this._calcMatrices(), this._verticalPerspectiveTransform.getCoveringTilesDetailsProvider().prepareNextFrame(), this._mercatorTransform.getCoveringTilesDetailsProvider().prepareNextFrame();
          }
          get currentTransform() {
            return this.isGlobeRendering ? this._verticalPerspectiveTransform : this._mercatorTransform;
          }
          constructor(e2) {
            this._globeLatitudeErrorCorrectionRadians = 0, this._globeness = 1, this.defaultConstrain = (e3, t2) => this.currentTransform.defaultConstrain(e3, t2), this.applyConstrain = (e3, t2) => this._helper.applyConstrain(e3, t2), this._helper = new Ut({ calcMatrices: () => {
              this._calcMatrices();
            }, defaultConstrain: (e3, t2) => this.defaultConstrain(e3, t2) }, e2), this._globeness = 1, this._mercatorTransform = new $t(), this._verticalPerspectiveTransform = new Si();
          }
          clone() {
            const e2 = new Ri();
            return e2._globeness = this._globeness, e2._globeLatitudeErrorCorrectionRadians = this._globeLatitudeErrorCorrectionRadians, e2.apply(this), e2;
          }
          apply(e2) {
            this._helper.apply(e2), this._mercatorTransform.apply(this), this._verticalPerspectiveTransform.apply(this, this._globeLatitudeErrorCorrectionRadians);
          }
          get projectionMatrix() {
            return this.currentTransform.projectionMatrix;
          }
          get modelViewProjectionMatrix() {
            return this.currentTransform.modelViewProjectionMatrix;
          }
          get inverseProjectionMatrix() {
            return this.currentTransform.inverseProjectionMatrix;
          }
          get cameraPosition() {
            return this.currentTransform.cameraPosition;
          }
          getProjectionData(e2) {
            const t2 = this._mercatorTransform.getProjectionData(e2), i2 = this._verticalPerspectiveTransform.getProjectionData(e2);
            return { mainMatrix: this.isGlobeRendering ? i2.mainMatrix : t2.mainMatrix, clippingPlane: i2.clippingPlane, tileMercatorCoords: i2.tileMercatorCoords, projectionTransition: e2.applyGlobeMatrix ? this._globeness : 0, fallbackMatrix: t2.fallbackMatrix };
          }
          isLocationOccluded(e2) {
            return this.currentTransform.isLocationOccluded(e2);
          }
          transformLightDirection(e2) {
            return this.currentTransform.transformLightDirection(e2);
          }
          getPixelScale() {
            return t.bv(this._mercatorTransform.getPixelScale(), this._verticalPerspectiveTransform.getPixelScale(), this._globeness);
          }
          getCircleRadiusCorrection() {
            return t.bv(this._mercatorTransform.getCircleRadiusCorrection(), this._verticalPerspectiveTransform.getCircleRadiusCorrection(), this._globeness);
          }
          getPitchedTextCorrection(e2, i2, a2) {
            const r2 = this._mercatorTransform.getPitchedTextCorrection(e2, i2, a2), o2 = this._verticalPerspectiveTransform.getPitchedTextCorrection(e2, i2, a2);
            return t.bv(r2, o2, this._globeness);
          }
          projectTileCoordinates(e2, t2, i2, a2) {
            return this.currentTransform.projectTileCoordinates(e2, t2, i2, a2);
          }
          _calcMatrices() {
            this._helper._width && this._helper._height && (this._verticalPerspectiveTransform.apply(this, this._globeLatitudeErrorCorrectionRadians), this._helper._nearZ = this._verticalPerspectiveTransform.nearZ, this._helper._farZ = this._verticalPerspectiveTransform.farZ, this._mercatorTransform.apply(this, true, this.isGlobeRendering), this._helper._nearZ = this._mercatorTransform.nearZ, this._helper._farZ = this._mercatorTransform.farZ);
          }
          calculateFogMatrix(e2) {
            return this.currentTransform.calculateFogMatrix(e2);
          }
          getVisibleUnwrappedCoordinates(e2) {
            return this.currentTransform.getVisibleUnwrappedCoordinates(e2);
          }
          getCameraFrustum() {
            return this.currentTransform.getCameraFrustum();
          }
          getClippingPlane() {
            return this.currentTransform.getClippingPlane();
          }
          getCoveringTilesDetailsProvider() {
            return this.currentTransform.getCoveringTilesDetailsProvider();
          }
          recalculateZoomAndCenter(e2) {
            this._mercatorTransform.recalculateZoomAndCenter(e2), this._verticalPerspectiveTransform.recalculateZoomAndCenter(e2);
          }
          maxPitchScaleFactor() {
            return this._mercatorTransform.maxPitchScaleFactor();
          }
          getCameraPoint() {
            return this._helper.getCameraPoint();
          }
          getCameraAltitude() {
            return this._helper.getCameraAltitude();
          }
          getCameraLngLat() {
            return this._helper.getCameraLngLat();
          }
          lngLatToCameraDepth(e2, t2) {
            return this.currentTransform.lngLatToCameraDepth(e2, t2);
          }
          populateCache(e2) {
            this._mercatorTransform.populateCache(e2), this._verticalPerspectiveTransform.populateCache(e2);
          }
          getBounds() {
            return this.currentTransform.getBounds();
          }
          calculateCenterFromCameraLngLatAlt(e2, t2, i2, a2) {
            return this._helper.calculateCenterFromCameraLngLatAlt(e2, t2, i2, a2);
          }
          setLocationAtPoint(e2, t2) {
            if (!this.isGlobeRendering) return this._mercatorTransform.setLocationAtPoint(e2, t2), void this.apply(this._mercatorTransform);
            this._verticalPerspectiveTransform.setLocationAtPoint(e2, t2), this.apply(this._verticalPerspectiveTransform);
          }
          locationToScreenPoint(e2, t2) {
            return this.currentTransform.locationToScreenPoint(e2, t2);
          }
          screenPointToMercatorCoordinate(e2, t2) {
            return this.currentTransform.screenPointToMercatorCoordinate(e2, t2);
          }
          screenPointToLocation(e2, t2) {
            return this.currentTransform.screenPointToLocation(e2, t2);
          }
          isPointOnMapSurface(e2, t2) {
            return this.currentTransform.isPointOnMapSurface(e2, t2);
          }
          getRayDirectionFromPixel(e2) {
            return this._verticalPerspectiveTransform.getRayDirectionFromPixel(e2);
          }
          getMatrixForModel(e2, t2) {
            return this.currentTransform.getMatrixForModel(e2, t2);
          }
          getProjectionDataForCustomLayer(e2 = true) {
            const t2 = this._mercatorTransform.getProjectionDataForCustomLayer(e2);
            if (!this.isGlobeRendering) return t2;
            const i2 = this._verticalPerspectiveTransform.getProjectionDataForCustomLayer(e2);
            return i2.fallbackMatrix = t2.mainMatrix, i2;
          }
          getFastPathSimpleProjectionMatrix(e2) {
            return this.currentTransform.getFastPathSimpleProjectionMatrix(e2);
          }
        }
        class zi {
          get useGlobeControls() {
            return true;
          }
          handlePanInertia(e2, i2) {
            const a2 = bi(e2, i2);
            return Math.abs(a2.lng - i2.center.lng) > 180 && (a2.lng = i2.center.lng + 179.5 * Math.sign(a2.lng - i2.center.lng)), { easingCenter: a2, easingOffset: new t.P(0, 0) };
          }
          handleMapControlsRollPitchBearingZoom(e2, i2) {
            const a2 = e2.around, r2 = i2.screenPointToLocation(a2);
            e2.bearingDelta && i2.setBearing(i2.bearing + e2.bearingDelta), e2.pitchDelta && i2.setPitch(i2.pitch + e2.pitchDelta), e2.rollDelta && i2.setRoll(i2.roll + e2.rollDelta);
            const o2 = i2.zoom;
            e2.zoomDelta && i2.setZoom(i2.zoom + e2.zoomDelta);
            const s2 = i2.zoom - o2;
            if (0 === s2) return;
            const n2 = t.bL(i2.center.lng, r2.lng), l2 = n2 / (Math.abs(n2 / 180) + 1), c2 = t.bL(i2.center.lat, r2.lat), h2 = i2.getRayDirectionFromPixel(a2), u2 = i2.cameraPosition, d2 = -1 * t.b6(u2, h2), _2 = t.bA();
            t.b1(_2, u2, [h2[0] * d2, h2[1] * d2, h2[2] * d2]);
            const p2 = t.b8(_2) - 1, m2 = Math.exp(0.5 * -Math.max(p2 - 0.3, 0)), f2 = fi(i2.worldSize, i2.center.lat) / Math.min(i2.width, i2.height), g2 = t.by(f2, 0.9, 0.5, 1, 0.25), v2 = (1 - t.ar(-s2)) * Math.min(m2, g2), x2 = i2.center.lat, b2 = i2.zoom, y2 = new t.V(i2.center.lng + l2 * v2, t.ao(i2.center.lat + c2 * v2, -t.ap, t.ap));
            i2.setLocationAtPoint(r2, a2);
            const w2 = i2.center, T2 = t.by(Math.abs(n2), 45, 85, 0, 1), P2 = t.by(f2, 0.75, 0.35, 0, 1), I2 = Math.pow(Math.max(T2, P2), 0.25), C2 = t.bL(w2.lng, y2.lng), M2 = t.bL(w2.lat, y2.lat);
            i2.setCenter(new t.V(w2.lng + C2 * I2, w2.lat + M2 * I2).wrap()), i2.setZoom(b2 + xi(x2, i2.center.lat));
          }
          handleMapControlsPan(e2, t2, i2) {
            if (!e2.panDelta) return;
            const a2 = t2.center.lat, r2 = t2.zoom;
            t2.setCenter(bi(e2.panDelta, t2).wrap()), t2.setZoom(r2 + xi(a2, t2.center.lat));
          }
          cameraForBoxAndBearing(e2, i2, a2, r2, o2) {
            const s2 = Kt(e2, i2, a2, r2, o2), n2 = i2.left / o2.width * 2 - 1, l2 = (o2.width - i2.right) / o2.width * 2 - 1, c2 = i2.top / o2.height * -2 + 1, h2 = (o2.height - i2.bottom) / o2.height * -2 + 1, u2 = t.bL(a2.getWest(), a2.getEast()) < 0, d2 = u2 ? a2.getEast() : a2.getWest(), _2 = u2 ? a2.getWest() : a2.getEast(), p2 = Math.max(a2.getNorth(), a2.getSouth()), m2 = Math.min(a2.getNorth(), a2.getSouth()), f2 = d2 + 0.5 * t.bL(d2, _2), g2 = p2 + 0.5 * t.bL(p2, m2), v2 = o2.clone();
            v2.setCenter(s2.center), v2.setBearing(s2.bearing), v2.setPitch(0), v2.setRoll(0), v2.setZoom(s2.zoom);
            const x2 = v2.modelViewProjectionMatrix, b2 = [mi(a2.getNorthWest()), mi(a2.getNorthEast()), mi(a2.getSouthWest()), mi(a2.getSouthEast()), mi(new t.V(_2, g2)), mi(new t.V(d2, g2)), mi(new t.V(f2, p2)), mi(new t.V(f2, m2))], y2 = mi(s2.center);
            let w2 = Number.POSITIVE_INFINITY;
            for (const e3 of b2) n2 < 0 && (w2 = zi.getLesserNonNegativeNonNull(w2, zi.solveVectorScale(e3, y2, x2, "x", n2))), l2 > 0 && (w2 = zi.getLesserNonNegativeNonNull(w2, zi.solveVectorScale(e3, y2, x2, "x", l2))), c2 > 0 && (w2 = zi.getLesserNonNegativeNonNull(w2, zi.solveVectorScale(e3, y2, x2, "y", c2))), h2 < 0 && (w2 = zi.getLesserNonNegativeNonNull(w2, zi.solveVectorScale(e3, y2, x2, "y", h2)));
            if (Number.isFinite(w2) && 0 !== w2) return s2.zoom = v2.zoom + t.au(w2), s2;
            Ht();
          }
          handleJumpToCenterZoom(e2, i2) {
            const a2 = e2.center.lat, r2 = e2.applyConstrain(i2.center ? t.V.convert(i2.center) : e2.center, e2.zoom).center;
            e2.setCenter(r2.wrap());
            const o2 = void 0 !== i2.zoom ? +i2.zoom : e2.zoom + xi(a2, r2.lat);
            e2.zoom !== o2 && e2.setZoom(o2);
          }
          handleEaseTo(e2, i2) {
            const a2 = e2.zoom, r2 = e2.center, o2 = e2.padding, s2 = { roll: e2.roll, pitch: e2.pitch, bearing: e2.bearing }, n2 = { roll: void 0 === i2.roll ? e2.roll : i2.roll, pitch: void 0 === i2.pitch ? e2.pitch : i2.pitch, bearing: void 0 === i2.bearing ? e2.bearing : i2.bearing }, l2 = void 0 !== i2.zoom, c2 = !e2.isPaddingEqual(i2.padding);
            let h2 = false;
            const u2 = i2.center ? t.V.convert(i2.center) : r2, d2 = e2.applyConstrain(u2, a2).center;
            Zt(e2, d2);
            const _2 = e2.clone();
            _2.setCenter(d2), _2.setZoom(l2 ? +i2.zoom : a2 + xi(r2.lat, u2.lat)), _2.setBearing(i2.bearing);
            const p2 = new t.P(t.ao(e2.centerPoint.x + i2.offsetAsPoint.x, 0, e2.width), t.ao(e2.centerPoint.y + i2.offsetAsPoint.y, 0, e2.height));
            _2.setLocationAtPoint(d2, p2);
            const m2 = (i2.offset && i2.offsetAsPoint.mag()) > 0 ? _2.center : d2, f2 = l2 ? +i2.zoom : a2 + xi(r2.lat, m2.lat), g2 = a2 + xi(r2.lat, 0), v2 = f2 + xi(m2.lat, 0), x2 = t.bL(r2.lng, m2.lng), b2 = t.bL(r2.lat, m2.lat), y2 = t.ar(v2 - g2);
            return h2 = f2 !== a2, { easeFunc: (a3) => {
              if (t.bp(s2, n2) || Xt({ startEulerAngles: s2, endEulerAngles: n2, tr: e2, k: a3, useSlerp: s2.roll != n2.roll }), c2 && e2.interpolatePadding(o2, i2.padding, a3), i2.around) t.w("Easing around a point is not supported under globe projection."), e2.setLocationAtPoint(i2.around, i2.aroundPoint);
              else {
                const t2 = v2 > g2 ? Math.min(2, y2) : Math.max(0.5, y2), i3 = Math.pow(t2, 1 - a3), o3 = wi(r2, x2, b2, a3 * i3);
                e2.setCenter(o3.wrap());
              }
              if (h2) {
                const i3 = t.G.number(g2, v2, a3) + xi(0, e2.center.lat);
                e2.setZoom(i3);
              }
            }, isZooming: h2, elevationCenter: m2 };
          }
          handleFlyTo(e2, i2) {
            const a2 = void 0 !== i2.zoom, r2 = e2.center, o2 = e2.zoom, s2 = e2.padding, n2 = !e2.isPaddingEqual(i2.padding), l2 = e2.applyConstrain(t.V.convert(i2.center || i2.locationAtOffset), o2).center, c2 = a2 ? +i2.zoom : e2.zoom + xi(e2.center.lat, l2.lat), h2 = e2.clone();
            h2.setCenter(l2), h2.setZoom(c2), h2.setBearing(i2.bearing);
            const u2 = new t.P(t.ao(e2.centerPoint.x + i2.offsetAsPoint.x, 0, e2.width), t.ao(e2.centerPoint.y + i2.offsetAsPoint.y, 0, e2.height));
            h2.setLocationAtPoint(l2, u2);
            const d2 = h2.center;
            Zt(e2, d2);
            const _2 = function(e3, i3, a3) {
              const r3 = mi(i3), o3 = mi(a3), s3 = t.b6(r3, o3), n3 = Math.acos(s3), l3 = _i(e3);
              return n3 / (2 * Math.PI) * l3;
            }(e2, r2, d2), p2 = o2 + xi(r2.lat, 0), m2 = c2 + xi(d2.lat, 0), f2 = t.ar(m2 - p2);
            let g2;
            if ("number" == typeof i2.minZoom) {
              const a3 = +i2.minZoom + xi(d2.lat, 0), r3 = Math.min(a3, p2, m2) + xi(0, d2.lat), o3 = e2.applyConstrain(d2, r3).zoom + xi(d2.lat, 0);
              g2 = t.ar(o3 - p2);
            }
            const v2 = t.bL(r2.lng, d2.lng), x2 = t.bL(r2.lat, d2.lat);
            return { easeFunc: (a3, o3, l3, h3) => {
              const u3 = wi(r2, v2, x2, l3);
              n2 && e2.interpolatePadding(s2, i2.padding, a3);
              const _3 = 1 === a3 ? d2 : u3;
              e2.setCenter(_3.wrap());
              const m3 = p2 + t.au(o3);
              e2.setZoom(1 === a3 ? c2 : m3 + xi(0, _3.lat));
            }, scaleOfZoom: f2, targetCenter: d2, scaleOfMinZoom: g2, pixelPathLength: _2 };
          }
          static solveVectorScale(e2, t2, i2, a2, r2) {
            const o2 = "x" === a2 ? [i2[0], i2[4], i2[8], i2[12]] : [i2[1], i2[5], i2[9], i2[13]], s2 = [i2[3], i2[7], i2[11], i2[15]], n2 = e2[0] * o2[0] + e2[1] * o2[1] + e2[2] * o2[2], l2 = e2[0] * s2[0] + e2[1] * s2[1] + e2[2] * s2[2], c2 = t2[0] * o2[0] + t2[1] * o2[1] + t2[2] * o2[2], h2 = t2[0] * s2[0] + t2[1] * s2[1] + t2[2] * s2[2];
            return c2 + r2 * l2 === n2 + r2 * h2 || s2[3] * (n2 - c2) + o2[3] * (h2 - l2) + n2 * h2 == c2 * l2 ? null : (c2 + o2[3] - r2 * h2 - r2 * s2[3]) / (c2 - n2 - r2 * h2 + r2 * l2);
          }
          static getLesserNonNegativeNonNull(e2, t2) {
            return null !== t2 && t2 >= 0 && t2 < e2 ? t2 : e2;
          }
        }
        class Di {
          constructor(e2) {
            this._globe = e2, this._mercatorCameraHelper = new Yt(), this._verticalPerspectiveCameraHelper = new zi();
          }
          get useGlobeControls() {
            return this._globe.useGlobeRendering;
          }
          get currentHelper() {
            return this.useGlobeControls ? this._verticalPerspectiveCameraHelper : this._mercatorCameraHelper;
          }
          handlePanInertia(e2, t2) {
            return this.currentHelper.handlePanInertia(e2, t2);
          }
          handleMapControlsRollPitchBearingZoom(e2, t2) {
            return this.currentHelper.handleMapControlsRollPitchBearingZoom(e2, t2);
          }
          handleMapControlsPan(e2, t2, i2) {
            this.currentHelper.handleMapControlsPan(e2, t2, i2);
          }
          cameraForBoxAndBearing(e2, t2, i2, a2, r2) {
            return this.currentHelper.cameraForBoxAndBearing(e2, t2, i2, a2, r2);
          }
          handleJumpToCenterZoom(e2, t2) {
            this.currentHelper.handleJumpToCenterZoom(e2, t2);
          }
          handleEaseTo(e2, t2) {
            return this.currentHelper.handleEaseTo(e2, t2);
          }
          handleFlyTo(e2, t2) {
            return this.currentHelper.handleFlyTo(e2, t2);
          }
        }
        const Ai = (e2, i2) => t.B(e2, i2 && i2.filter((e3) => "source.canvas" !== e3.identifier)), Li = t.bP();
        class ki extends t.E {
          constructor(e2, i2 = {}) {
            var a2, r2;
            super(), this._rtlPluginLoaded = () => {
              for (const e3 in this.tileManagers) {
                const t2 = this.tileManagers[e3].getSource().type;
                "vector" !== t2 && "geojson" !== t2 || this.tileManagers[e3].reload();
              }
            }, this.map = e2, this.dispatcher = new N(j(), e2._getMapId()), this.dispatcher.registerMessageHandler("GG", (e3, t2) => this.getGlyphs(e3, t2)), this.dispatcher.registerMessageHandler("GI", (e3, t2) => this.getImages(e3, t2)), this.dispatcher.registerMessageHandler("GDA", (e3, t2) => this.getDashes(e3, t2)), this.imageManager = new w(), this.imageManager.setEventedParent(this);
            const o2 = (null === (a2 = e2._container) || void 0 === a2 ? void 0 : a2.lang) || "undefined" != typeof document && (null === (r2 = document.documentElement) || void 0 === r2 ? void 0 : r2.lang) || void 0;
            this.glyphManager = new M(e2._requestManager, i2.localIdeographFontFamily, o2), this.lineAtlas = new A(256, 512), this.crossTileSymbolIndex = new zt(), this._setInitialValues(), this._resetUpdates(), this.dispatcher.broadcast("SR", t.bQ()), ce().on(se, this._rtlPluginLoaded), this.on("data", (e3) => {
              if ("source" !== e3.dataType || "metadata" !== e3.sourceDataType) return;
              const t2 = this.tileManagers[e3.sourceId];
              if (!t2) return;
              const i3 = t2.getSource();
              if (i3 && i3.vectorLayerIds) for (const e4 in this._layers) {
                const t3 = this._layers[e4];
                t3.source === i3.id && this._validateLayer(t3);
              }
            });
          }
          _setInitialValues() {
            var e2;
            this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.tileManagers = {}, this.zoomHistory = new t.bR(), this._availableImages = [], this._globalState = {}, this._serializedLayers = {}, this.stylesheet = null, this.light = null, this.sky = null, this.projection && (this.projection.destroy(), delete this.projection), this._loaded = false, this._changed = false, this._updatedLayers = {}, this._updatedSources = {}, this._changedImages = {}, this._glyphsDidChange = false, this._updatedPaintProps = {}, this._layerOrderChanged = false, this.crossTileSymbolIndex = new ((null === (e2 = this.crossTileSymbolIndex) || void 0 === e2 ? void 0 : e2.constructor) || Object)(), this.pauseablePlacement = void 0, this.placement = void 0, this.z = 0;
          }
          setGlobalStateProperty(e2, i2) {
            var a2, r2, o2;
            this._checkLoaded();
            const s2 = null === i2 ? null !== (o2 = null === (r2 = null === (a2 = this.stylesheet.state) || void 0 === a2 ? void 0 : a2[e2]) || void 0 === r2 ? void 0 : r2.default) && void 0 !== o2 ? o2 : null : i2;
            if (t.bS(s2, this._globalState[e2])) return this;
            this._globalState[e2] = s2, this._applyGlobalStateChanges([e2]);
          }
          getGlobalState() {
            return this._globalState;
          }
          setGlobalState(e2) {
            this._checkLoaded();
            const i2 = [];
            for (const a2 in e2) !t.bS(this._globalState[a2], e2[a2].default) && (i2.push(a2), this._globalState[a2] = e2[a2].default);
            this._applyGlobalStateChanges(i2);
          }
          _applyGlobalStateChanges(e2) {
            if (0 === e2.length) return;
            const t2 = /* @__PURE__ */ new Set(), i2 = {};
            for (const a2 of e2) {
              i2[a2] = this._globalState[a2];
              for (const e3 in this._layers) {
                const i3 = this._layers[e3], r2 = i3.getLayoutAffectingGlobalStateRefs(), o2 = i3.getPaintAffectingGlobalStateRefs();
                if (r2.has(a2) && t2.add(i3.source), o2.has(a2)) for (const { name: e4, value: t3 } of o2.get(a2)) this._updatePaintProperty(i3, e4, t3);
              }
            }
            this.dispatcher.broadcast("UGS", i2);
            for (const e3 in this.tileManagers) t2.has(e3) && (this._reloadSource(e3), this._changed = true);
          }
          loadURL(e2, i2 = {}, a2) {
            this.fire(new t.l("dataloading", { dataType: "style" })), i2.validate = "boolean" != typeof i2.validate || i2.validate;
            const r2 = this.map._requestManager.transformRequest(e2, "Style");
            this._loadStyleRequest = new AbortController();
            const o2 = this._loadStyleRequest;
            t.j(r2, this._loadStyleRequest).then((e3) => {
              this._loadStyleRequest = null, this._load(e3.data, i2, a2);
            }).catch((e3) => {
              this._loadStyleRequest = null, e3 && !o2.signal.aborted && this.fire(new t.k(e3));
            });
          }
          loadJSON(e2, i2 = {}, a2) {
            this.fire(new t.l("dataloading", { dataType: "style" })), this._frameRequest = new AbortController(), n.frameAsync(this._frameRequest).then(() => {
              this._frameRequest = null, i2.validate = false !== i2.validate, this._load(e2, i2, a2);
            }).catch(() => {
            });
          }
          loadEmpty() {
            this.fire(new t.l("dataloading", { dataType: "style" })), this._load(Li, { validate: false });
          }
          _load(e2, i2, a2) {
            var r2, o2;
            let s2 = i2.transformStyle ? i2.transformStyle(a2, e2) : e2;
            if (!i2.validate || !Ai(this, t.C(s2))) {
              s2 = Object.assign({}, s2), this._loaded = true, this.stylesheet = s2;
              for (const e3 in s2.sources) this.addSource(e3, s2.sources[e3], { validate: false });
              s2.sprite ? this._loadSprite(s2.sprite) : this.imageManager.setLoaded(true), this.glyphManager.setURL(s2.glyphs), this._createLayers(), this.light = new R(this.stylesheet.light), this._setProjectionInternal((null === (r2 = this.stylesheet.projection) || void 0 === r2 ? void 0 : r2.type) || "mercator"), this.sky = new D(this.stylesheet.sky), this.map.setTerrain(null !== (o2 = this.stylesheet.terrain) && void 0 !== o2 ? o2 : null), this.fire(new t.l("data", { dataType: "style" })), this.fire(new t.l("style.load"));
            }
          }
          _createLayers() {
            var e2, i2, a2;
            const r2 = t.bT(this.stylesheet.layers);
            this.setGlobalState(null !== (e2 = this.stylesheet.state) && void 0 !== e2 ? e2 : null), this.dispatcher.broadcast("SL", r2), this._order = r2.map((e3) => e3.id), this._layers = {}, this._serializedLayers = null;
            for (const e3 of r2) {
              const r3 = t.bU(e3, this._globalState);
              if (r3.setEventedParent(this, { layer: { id: e3.id } }), this._layers[e3.id] = r3, t.bV(r3) && this.tileManagers[r3.source]) {
                const t2 = null !== (a2 = null === (i2 = e3.paint) || void 0 === i2 ? void 0 : i2["raster-fade-duration"]) && void 0 !== a2 ? a2 : r3.paint.get("raster-fade-duration");
                this.tileManagers[r3.source].setRasterFadeDuration(t2);
              }
            }
          }
          _loadSprite(e2, i2 = false, a2 = void 0) {
            this.imageManager.setLoaded(false);
            const r2 = new AbortController();
            let o2;
            this._spriteRequest = r2, function(e3, i3, a3, r3) {
              return t._(this, void 0, void 0, function* () {
                const o3 = x(e3), s2 = a3 > 1 ? "@2x" : "", l2 = {}, c2 = {};
                for (const { id: e4, url: a4 } of o3) {
                  const o4 = i3.transformRequest(b(a4, s2, ".json"), "SpriteJSON");
                  l2[e4] = t.j(o4, r3);
                  const n2 = i3.transformRequest(b(a4, s2, ".png"), "SpriteImage");
                  c2[e4] = g.getImage(n2, r3);
                }
                return yield Promise.all([...Object.values(l2), ...Object.values(c2)]), function(e4, i4) {
                  return t._(this, void 0, void 0, function* () {
                    const t2 = {};
                    for (const a4 in e4) {
                      t2[a4] = {};
                      const r4 = n.getImageCanvasContext((yield i4[a4]).data), o4 = (yield e4[a4]).data;
                      for (const e5 in o4) {
                        const { width: i5, height: s3, x: n2, y: l3, sdf: c3, pixelRatio: h2, stretchX: u2, stretchY: d2, content: _2, textFitWidth: p2, textFitHeight: m2 } = o4[e5];
                        t2[a4][e5] = { data: null, pixelRatio: h2, sdf: c3, stretchX: u2, stretchY: d2, content: _2, textFitWidth: p2, textFitHeight: m2, spriteData: { width: i5, height: s3, x: n2, y: l3, context: r4 } };
                      }
                    }
                    return t2;
                  });
                }(l2, c2);
              });
            }(e2, this.map._requestManager, this.map.getPixelRatio(), this._spriteRequest).then((e3) => {
              if (this._spriteRequest = null, e3) for (const t2 in e3) {
                this._spritesImagesIds[t2] = [];
                const a3 = this._spritesImagesIds[t2] ? this._spritesImagesIds[t2].filter((t3) => !(t3 in e3)) : [];
                for (const e4 of a3) this.imageManager.removeImage(e4), this._changedImages[e4] = true;
                for (const a4 in e3[t2]) {
                  const r3 = "default" === t2 ? a4 : `${t2}:${a4}`;
                  this._spritesImagesIds[t2].push(r3), r3 in this.imageManager.images ? this.imageManager.updateImage(r3, e3[t2][a4], false) : this.imageManager.addImage(r3, e3[t2][a4]), i2 && (this._changedImages[r3] = true);
                }
              }
            }).catch((e3) => {
              this._spriteRequest = null, o2 = e3, r2.signal.aborted || this.fire(new t.k(o2));
            }).finally(() => {
              this.imageManager.setLoaded(true), this._availableImages = this.imageManager.listImages(), i2 && (this._changed = true), this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", { dataType: "style" })), a2 && a2(o2);
            });
          }
          _unloadSprite() {
            for (const e2 of Object.values(this._spritesImagesIds).flat()) this.imageManager.removeImage(e2), this._changedImages[e2] = true;
            this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = true, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", { dataType: "style" }));
          }
          _validateLayer(e2) {
            const i2 = this.tileManagers[e2.source];
            if (!i2) return;
            const a2 = e2.sourceLayer;
            if (!a2) return;
            const r2 = i2.getSource();
            ("geojson" === r2.type || r2.vectorLayerIds && -1 === r2.vectorLayerIds.indexOf(a2)) && this.fire(new t.k(new Error(`Source layer "${a2}" does not exist on source "${r2.id}" as specified by style layer "${e2.id}".`)));
          }
          loaded() {
            if (!this._loaded) return false;
            if (Object.keys(this._updatedSources).length) return false;
            for (const e2 in this.tileManagers) if (!this.tileManagers[e2].loaded()) return false;
            return !!this.imageManager.isLoaded();
          }
          _serializeByIds(e2, i2 = false) {
            const a2 = this._serializedAllLayers();
            if (!e2 || 0 === e2.length) return Object.values(i2 ? t.bW(a2) : a2);
            const r2 = [];
            for (const o2 of e2) if (a2[o2]) {
              const e3 = i2 ? t.bW(a2[o2]) : a2[o2];
              r2.push(e3);
            }
            return r2;
          }
          _serializedAllLayers() {
            let e2 = this._serializedLayers;
            if (e2) return e2;
            e2 = this._serializedLayers = {};
            const t2 = Object.keys(this._layers);
            for (const i2 of t2) {
              const t3 = this._layers[i2];
              "custom" !== t3.type && (e2[i2] = t3.serialize());
            }
            return e2;
          }
          hasTransitions() {
            var e2, t2, i2;
            if (null === (e2 = this.light) || void 0 === e2 ? void 0 : e2.hasTransition()) return true;
            if (null === (t2 = this.sky) || void 0 === t2 ? void 0 : t2.hasTransition()) return true;
            if (null === (i2 = this.projection) || void 0 === i2 ? void 0 : i2.hasTransition()) return true;
            for (const e3 in this.tileManagers) if (this.tileManagers[e3].hasTransition()) return true;
            for (const e3 in this._layers) if (this._layers[e3].hasTransition()) return true;
            return false;
          }
          _checkLoaded() {
            if (!this._loaded) throw new Error("Style is not done loading.");
          }
          update(e2) {
            if (!this._loaded) return;
            const i2 = this._changed;
            if (i2) {
              const t2 = Object.keys(this._updatedLayers), i3 = Object.keys(this._removedLayers);
              (t2.length || i3.length) && this._updateWorkerLayers(t2, i3);
              for (const e3 in this._updatedSources) {
                const t3 = this._updatedSources[e3];
                if ("reload" === t3) this._reloadSource(e3);
                else {
                  if ("clear" !== t3) throw new Error(`Invalid action ${t3}`);
                  this._clearSource(e3);
                }
              }
              this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
              for (const t3 in this._updatedPaintProps) this._layers[t3].updateTransitions(e2);
              this.light.updateTransitions(e2), this.sky.updateTransitions(e2), this._resetUpdates();
            }
            const a2 = {};
            for (const e3 in this.tileManagers) {
              const t2 = this.tileManagers[e3];
              a2[e3] = t2.used, t2.used = false;
            }
            for (const t2 of this._order) {
              const i3 = this._layers[t2];
              i3.recalculate(e2, this._availableImages), !i3.isHidden(e2.zoom) && i3.source && (this.tileManagers[i3.source].used = true);
            }
            for (const e3 in a2) {
              const i3 = this.tileManagers[e3];
              !!a2[e3] != !!i3.used && i3.fire(new t.l("data", { sourceDataType: "visibility", dataType: "source", sourceId: e3 }));
            }
            this.light.recalculate(e2), this.sky.recalculate(e2), this.projection.recalculate(e2), this.z = e2.zoom, i2 && this.fire(new t.l("data", { dataType: "style" }));
          }
          _updateTilesForChangedImages() {
            const e2 = Object.keys(this._changedImages);
            if (e2.length) {
              for (const t2 in this.tileManagers) this.tileManagers[t2].reloadTilesForDependencies(["icons", "patterns"], e2);
              this._changedImages = {};
            }
          }
          _updateTilesForChangedGlyphs() {
            if (this._glyphsDidChange) {
              for (const e2 in this.tileManagers) this.tileManagers[e2].reloadTilesForDependencies(["glyphs"], [""]);
              this._glyphsDidChange = false;
            }
          }
          _updateWorkerLayers(e2, t2) {
            this.dispatcher.broadcast("UL", { layers: this._serializeByIds(e2, false), removedIds: t2 });
          }
          _resetUpdates() {
            this._changed = false, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = false;
          }
          setState(e2, i2 = {}) {
            var a2;
            this._checkLoaded();
            const r2 = this.serialize();
            if (e2 = i2.transformStyle ? i2.transformStyle(r2, e2) : e2, (null === (a2 = i2.validate) || void 0 === a2 || a2) && Ai(this, t.C(e2))) return false;
            (e2 = t.bW(e2)).layers = t.bT(e2.layers);
            const o2 = t.bX(r2, e2), s2 = this._getOperationsToPerform(o2);
            if (s2.unimplemented.length > 0) throw new Error(`Unimplemented: ${s2.unimplemented.join(", ")}.`);
            if (0 === s2.operations.length) return false;
            for (const e3 of s2.operations) e3();
            return this.stylesheet = e2, this._serializedLayers = null, true;
          }
          _getOperationsToPerform(e2) {
            const t2 = [], i2 = [];
            for (const a2 of e2) switch (a2.command) {
              case "setCenter":
              case "setZoom":
              case "setBearing":
              case "setPitch":
              case "setRoll":
                continue;
              case "addLayer":
                t2.push(() => this.addLayer.apply(this, a2.args));
                break;
              case "removeLayer":
                t2.push(() => this.removeLayer.apply(this, a2.args));
                break;
              case "setPaintProperty":
                t2.push(() => this.setPaintProperty.apply(this, a2.args));
                break;
              case "setLayoutProperty":
                t2.push(() => this.setLayoutProperty.apply(this, a2.args));
                break;
              case "setFilter":
                t2.push(() => this.setFilter.apply(this, a2.args));
                break;
              case "addSource":
                t2.push(() => this.addSource.apply(this, a2.args));
                break;
              case "removeSource":
                t2.push(() => this.removeSource.apply(this, a2.args));
                break;
              case "setLayerZoomRange":
                t2.push(() => this.setLayerZoomRange.apply(this, a2.args));
                break;
              case "setLight":
                t2.push(() => this.setLight.apply(this, a2.args));
                break;
              case "setGeoJSONSourceData":
                t2.push(() => this.setGeoJSONSourceData.apply(this, a2.args));
                break;
              case "setGlyphs":
                t2.push(() => this.setGlyphs.apply(this, a2.args));
                break;
              case "setSprite":
                t2.push(() => this.setSprite.apply(this, a2.args));
                break;
              case "setTerrain":
                t2.push(() => this.map.setTerrain.apply(this, a2.args));
                break;
              case "setSky":
                t2.push(() => this.setSky.apply(this, a2.args));
                break;
              case "setProjection":
                this.setProjection.apply(this, a2.args);
                break;
              case "setGlobalState":
                t2.push(() => this.setGlobalState.apply(this, a2.args));
                break;
              case "setTransition":
                t2.push(() => {
                });
                break;
              default:
                i2.push(a2.command);
            }
            return { operations: t2, unimplemented: i2 };
          }
          addImage(e2, i2) {
            if (this.getImage(e2)) return this.fire(new t.k(new Error(`An image named "${e2}" already exists.`)));
            this.imageManager.addImage(e2, i2), this._afterImageUpdated(e2);
          }
          updateImage(e2, t2) {
            this.imageManager.updateImage(e2, t2);
          }
          getImage(e2) {
            return this.imageManager.getImage(e2);
          }
          removeImage(e2) {
            if (!this.getImage(e2)) return this.fire(new t.k(new Error(`An image named "${e2}" does not exist.`)));
            this.imageManager.removeImage(e2), this._afterImageUpdated(e2);
          }
          _afterImageUpdated(e2) {
            this._availableImages = this.imageManager.listImages(), this._changedImages[e2] = true, this._changed = true, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", { dataType: "style" }));
          }
          listImages() {
            return this._checkLoaded(), this.imageManager.listImages();
          }
          addSource(e2, i2, a2 = {}) {
            if (this._checkLoaded(), void 0 !== this.tileManagers[e2]) throw new Error(`Source "${e2}" already exists.`);
            if (!i2.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i2).join(", ")}.`);
            if (["vector", "raster", "geojson", "video", "image"].indexOf(i2.type) >= 0 && this._validate(t.C.source, `sources.${e2}`, i2, null, a2)) return;
            this.map && this.map._collectResourceTiming && (i2.collectResourceTiming = true);
            const r2 = this.tileManagers[e2] = new ke(e2, i2, this.dispatcher);
            r2.style = this, r2.setEventedParent(this, () => ({ isSourceLoaded: r2.loaded(), source: r2.serialize(), sourceId: e2 })), r2.onAdd(this.map), this._changed = true;
          }
          removeSource(e2) {
            if (this._checkLoaded(), void 0 === this.tileManagers[e2]) throw new Error("There is no source with this ID");
            for (const i3 in this._layers) if (this._layers[i3].source === e2) return this.fire(new t.k(new Error(`Source "${e2}" cannot be removed while layer "${i3}" is using it.`)));
            const i2 = this.tileManagers[e2];
            delete this.tileManagers[e2], delete this._updatedSources[e2], i2.fire(new t.l("data", { sourceDataType: "metadata", dataType: "source", sourceId: e2 })), i2.setEventedParent(null), i2.onRemove(this.map), this._changed = true;
          }
          setGeoJSONSourceData(e2, t2) {
            if (this._checkLoaded(), void 0 === this.tileManagers[e2]) throw new Error(`There is no source with this ID=${e2}`);
            const i2 = this.tileManagers[e2].getSource();
            if ("geojson" !== i2.type) throw new Error(`geojsonSource.type is ${i2.type}, which is !== 'geojson`);
            i2.setData(t2), this._changed = true;
          }
          getSource(e2) {
            return this.tileManagers[e2] && this.tileManagers[e2].getSource();
          }
          addLayer(e2, i2, a2 = {}) {
            this._checkLoaded();
            const r2 = e2.id;
            if (this.getLayer(r2)) return void this.fire(new t.k(new Error(`Layer "${r2}" already exists on this map.`)));
            let o2;
            if ("custom" === e2.type) {
              if (Ai(this, t.bY(e2))) return;
              o2 = t.bU(e2, this._globalState);
            } else {
              if ("source" in e2 && "object" == typeof e2.source && (this.addSource(r2, e2.source), e2 = t.bW(e2), e2 = t.e(e2, { source: r2 })), this._validate(t.C.layer, `layers.${r2}`, e2, { arrayIndex: -1 }, a2)) return;
              o2 = t.bU(e2, this._globalState), this._validateLayer(o2), o2.setEventedParent(this, { layer: { id: r2 } });
            }
            const s2 = i2 ? this._order.indexOf(i2) : this._order.length;
            if (i2 && -1 === s2) this.fire(new t.k(new Error(`Cannot add layer "${r2}" before non-existing layer "${i2}".`)));
            else {
              if (this._order.splice(s2, 0, r2), this._layerOrderChanged = true, this._layers[r2] = o2, this._removedLayers[r2] && o2.source && "custom" !== o2.type) {
                const e3 = this._removedLayers[r2];
                delete this._removedLayers[r2], e3.type !== o2.type ? this._updatedSources[o2.source] = "clear" : (this._updatedSources[o2.source] = "reload", this.tileManagers[o2.source].pause());
              }
              this._updateLayer(o2), o2.onAdd && o2.onAdd(this.map);
            }
          }
          moveLayer(e2, i2) {
            if (this._checkLoaded(), this._changed = true, !this._layers[e2]) return void this.fire(new t.k(new Error(`The layer '${e2}' does not exist in the map's style and cannot be moved.`)));
            if (e2 === i2) return;
            const a2 = this._order.indexOf(e2);
            this._order.splice(a2, 1);
            const r2 = i2 ? this._order.indexOf(i2) : this._order.length;
            i2 && -1 === r2 ? this.fire(new t.k(new Error(`Cannot move layer "${e2}" before non-existing layer "${i2}".`))) : (this._order.splice(r2, 0, e2), this._layerOrderChanged = true);
          }
          removeLayer(e2) {
            this._checkLoaded();
            const i2 = this._layers[e2];
            if (!i2) return void this.fire(new t.k(new Error(`Cannot remove non-existing layer "${e2}".`)));
            i2.setEventedParent(null);
            const a2 = this._order.indexOf(e2);
            this._order.splice(a2, 1), this._layerOrderChanged = true, this._changed = true, this._removedLayers[e2] = i2, delete this._layers[e2], this._serializedLayers && delete this._serializedLayers[e2], delete this._updatedLayers[e2], delete this._updatedPaintProps[e2], i2.onRemove && i2.onRemove(this.map);
          }
          getLayer(e2) {
            return this._layers[e2];
          }
          getLayersOrder() {
            return [...this._order];
          }
          hasLayer(e2) {
            return e2 in this._layers;
          }
          setLayerZoomRange(e2, i2, a2) {
            this._checkLoaded();
            const r2 = this.getLayer(e2);
            r2 ? r2.minzoom === i2 && r2.maxzoom === a2 || (null != i2 && (r2.minzoom = i2), null != a2 && (r2.maxzoom = a2), this._updateLayer(r2)) : this.fire(new t.k(new Error(`Cannot set the zoom range of non-existing layer "${e2}".`)));
          }
          setFilter(e2, i2, a2 = {}) {
            this._checkLoaded();
            const r2 = this.getLayer(e2);
            if (r2) {
              if (!t.bS(r2.filter, i2)) return null == i2 ? (r2.setFilter(void 0), void this._updateLayer(r2)) : void (this._validate(t.C.filter, `layers.${r2.id}.filter`, i2, null, a2) || (r2.setFilter(t.bW(i2)), this._updateLayer(r2)));
            } else this.fire(new t.k(new Error(`Cannot filter non-existing layer "${e2}".`)));
          }
          getFilter(e2) {
            return t.bW(this.getLayer(e2).filter);
          }
          setLayoutProperty(e2, i2, a2, r2 = {}) {
            this._checkLoaded();
            const o2 = this.getLayer(e2);
            o2 ? t.bS(o2.getLayoutProperty(i2), a2) || (o2.setLayoutProperty(i2, a2, r2), this._updateLayer(o2)) : this.fire(new t.k(new Error(`Cannot style non-existing layer "${e2}".`)));
          }
          getLayoutProperty(e2, i2) {
            const a2 = this.getLayer(e2);
            if (a2) return a2.getLayoutProperty(i2);
            this.fire(new t.k(new Error(`Cannot get style of non-existing layer "${e2}".`)));
          }
          setPaintProperty(e2, i2, a2, r2 = {}) {
            this._checkLoaded();
            const o2 = this.getLayer(e2);
            o2 ? t.bS(o2.getPaintProperty(i2), a2) || this._updatePaintProperty(o2, i2, a2, r2) : this.fire(new t.k(new Error(`Cannot style non-existing layer "${e2}".`)));
          }
          _updatePaintProperty(e2, i2, a2, r2 = {}) {
            e2.setPaintProperty(i2, a2, r2) && this._updateLayer(e2), t.bV(e2) && "raster-fade-duration" === i2 && this.tileManagers[e2.source].setRasterFadeDuration(a2), this._changed = true, this._updatedPaintProps[e2.id] = true, this._serializedLayers = null;
          }
          getPaintProperty(e2, t2) {
            return this.getLayer(e2).getPaintProperty(t2);
          }
          setFeatureState(e2, i2) {
            this._checkLoaded();
            const a2 = e2.source, r2 = e2.sourceLayer, o2 = this.tileManagers[a2];
            if (void 0 === o2) return void this.fire(new t.k(new Error(`The source '${a2}' does not exist in the map's style.`)));
            const s2 = o2.getSource().type;
            "geojson" === s2 && r2 ? this.fire(new t.k(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== s2 || r2 ? (void 0 === e2.id && this.fire(new t.k(new Error("The feature id parameter must be provided."))), o2.setFeatureState(r2, e2.id, i2)) : this.fire(new t.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
          }
          removeFeatureState(e2, i2) {
            this._checkLoaded();
            const a2 = e2.source, r2 = this.tileManagers[a2];
            if (void 0 === r2) return void this.fire(new t.k(new Error(`The source '${a2}' does not exist in the map's style.`)));
            const o2 = r2.getSource().type, s2 = "vector" === o2 ? e2.sourceLayer : void 0;
            "vector" !== o2 || s2 ? i2 && "string" != typeof e2.id && "number" != typeof e2.id ? this.fire(new t.k(new Error("A feature id is required to remove its specific state property."))) : r2.removeFeatureState(s2, e2.id, i2) : this.fire(new t.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
          }
          getFeatureState(e2) {
            this._checkLoaded();
            const i2 = e2.source, a2 = e2.sourceLayer, r2 = this.tileManagers[i2];
            if (void 0 !== r2) return "vector" !== r2.getSource().type || a2 ? (void 0 === e2.id && this.fire(new t.k(new Error("The feature id parameter must be provided."))), r2.getFeatureState(a2, e2.id)) : void this.fire(new t.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
            this.fire(new t.k(new Error(`The source '${i2}' does not exist in the map's style.`)));
          }
          getTransition() {
            return t.e({ duration: 300, delay: 0 }, this.stylesheet && this.stylesheet.transition);
          }
          serialize() {
            if (!this._loaded) return;
            const e2 = t.bZ(this.tileManagers, (e3) => e3.serialize()), i2 = this._serializeByIds(this._order, true), a2 = this.map.getTerrain() || void 0, r2 = this.stylesheet;
            return t.b_({ version: r2.version, name: r2.name, metadata: r2.metadata, light: r2.light, sky: r2.sky, center: r2.center, zoom: r2.zoom, bearing: r2.bearing, pitch: r2.pitch, sprite: r2.sprite, glyphs: r2.glyphs, transition: r2.transition, projection: r2.projection, sources: e2, layers: i2, terrain: a2 }, (e3) => void 0 !== e3);
          }
          _updateLayer(e2) {
            this._updatedLayers[e2.id] = true, e2.source && !this._updatedSources[e2.source] && "raster" !== this.tileManagers[e2.source].getSource().type && (this._updatedSources[e2.source] = "reload", this.tileManagers[e2.source].pause()), this._serializedLayers = null, this._changed = true;
          }
          _flattenAndSortRenderedFeatures(e2) {
            const t2 = (e3) => "fill-extrusion" === this._layers[e3].type, i2 = {}, a2 = [];
            for (let r3 = this._order.length - 1; r3 >= 0; r3--) {
              const o2 = this._order[r3];
              if (t2(o2)) {
                i2[o2] = r3;
                for (const t3 of e2) {
                  const e3 = t3[o2];
                  if (e3) for (const t4 of e3) a2.push(t4);
                }
              }
            }
            a2.sort((e3, t3) => t3.intersectionZ - e3.intersectionZ);
            const r2 = [];
            for (let o2 = this._order.length - 1; o2 >= 0; o2--) {
              const s2 = this._order[o2];
              if (t2(s2)) for (let e3 = a2.length - 1; e3 >= 0; e3--) {
                const t3 = a2[e3].feature;
                if (i2[t3.layer.id] < o2) break;
                r2.push(t3), a2.pop();
              }
              else for (const t3 of e2) {
                const e3 = t3[s2];
                if (e3) for (const t4 of e3) r2.push(t4.feature);
              }
            }
            return r2;
          }
          queryRenderedFeatures(e2, i2, a2) {
            i2 && i2.filter && this._validate(t.C.filter, "queryRenderedFeatures.filter", i2.filter, null, i2);
            const r2 = {};
            if (i2 && i2.layers) {
              if (!(Array.isArray(i2.layers) || i2.layers instanceof Set)) return this.fire(new t.k(new Error("parameters.layers must be an Array or a Set of strings"))), [];
              for (const e3 of i2.layers) {
                const i3 = this._layers[e3];
                if (!i3) return this.fire(new t.k(new Error(`The layer '${e3}' does not exist in the map's style and cannot be queried for features.`))), [];
                r2[i3.source] = true;
              }
            }
            const o2 = [];
            i2.availableImages = this._availableImages;
            const s2 = this._serializedAllLayers(), n2 = i2.layers instanceof Set ? i2.layers : Array.isArray(i2.layers) ? new Set(i2.layers) : null, l2 = Object.assign(Object.assign({}, i2), { layers: n2, globalState: this._globalState });
            for (const t2 in this.tileManagers) i2.layers && !r2[t2] || o2.push(U(this.tileManagers[t2], this._layers, s2, e2, l2, a2, this.map.terrain ? (e3, t3, i3) => this.map.terrain.getElevation(e3, t3, i3) : void 0));
            return this.placement && o2.push(function(e3, t2, i3, a3, r3, o3, s3) {
              const n3 = {}, l3 = o3.queryRenderedSymbols(a3), c2 = [];
              for (const e4 of Object.keys(l3).map(Number)) c2.push(s3[e4]);
              c2.sort(V);
              for (const i4 of c2) {
                const a4 = i4.featureIndex.lookupSymbolFeatures(l3[i4.bucketInstanceId], t2, i4.bucketIndex, i4.sourceLayerIndex, { filterSpec: r3.filter, globalState: r3.globalState }, r3.layers, r3.availableImages, e3);
                for (const e4 in a4) {
                  const t3 = n3[e4] = n3[e4] || [], r4 = a4[e4];
                  r4.sort((e5, t4) => {
                    const a5 = i4.featureSortOrder;
                    if (a5) {
                      const i5 = a5.indexOf(e5.featureIndex);
                      return a5.indexOf(t4.featureIndex) - i5;
                    }
                    return t4.featureIndex - e5.featureIndex;
                  });
                  for (const e5 of r4) t3.push(e5);
                }
              }
              return function(e4, t3, i4) {
                for (const a4 in e4) for (const r4 of e4[a4]) q(r4, i4[t3[a4].source]);
                return e4;
              }(n3, e3, i3);
            }(this._layers, s2, this.tileManagers, e2, l2, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(o2);
          }
          querySourceFeatures(e2, i2) {
            (null == i2 ? void 0 : i2.filter) && this._validate(t.C.filter, "querySourceFeatures.filter", i2.filter, null, i2);
            const a2 = this.tileManagers[e2];
            return a2 ? function(e3, t2) {
              const i3 = e3.getRenderableIds().map((t3) => e3.getTileByID(t3)), a3 = [], r2 = {};
              for (let e4 = 0; e4 < i3.length; e4++) {
                const o2 = i3[e4], s2 = o2.tileID.canonical.key;
                r2[s2] || (r2[s2] = true, o2.querySourceFeatures(a3, t2));
              }
              return a3;
            }(a2, i2 ? Object.assign(Object.assign({}, i2), { globalState: this._globalState }) : { globalState: this._globalState }) : [];
          }
          getLight() {
            return this.light.getLight();
          }
          setLight(e2, i2 = {}) {
            this._checkLoaded();
            const a2 = this.light.getLight();
            let r2 = false;
            for (const i3 in e2) if (!t.bS(e2[i3], a2[i3])) {
              r2 = true;
              break;
            }
            if (!r2) return;
            const o2 = { now: c(), transition: t.e({ duration: 300, delay: 0 }, this.stylesheet.transition) };
            this.light.setLight(e2, i2), this.light.updateTransitions(o2);
          }
          getProjection() {
            var e2;
            return null === (e2 = this.stylesheet) || void 0 === e2 ? void 0 : e2.projection;
          }
          setProjection(e2) {
            if (this._checkLoaded(), this.projection) {
              if (this.projection.name === e2.type) return;
              this.projection.destroy(), delete this.projection;
            }
            this.stylesheet.projection = e2, this._setProjectionInternal(e2.type);
          }
          getSky() {
            var e2;
            return null === (e2 = this.stylesheet) || void 0 === e2 ? void 0 : e2.sky;
          }
          setSky(e2, i2 = {}) {
            this._checkLoaded();
            const a2 = this.getSky();
            let r2 = false;
            if (!e2 && !a2) return;
            if (e2 && !a2) r2 = true;
            else if (!e2 && a2) r2 = true;
            else for (const i3 in e2) if (!t.bS(e2[i3], a2[i3])) {
              r2 = true;
              break;
            }
            if (!r2) return;
            const o2 = { now: c(), transition: t.e({ duration: 300, delay: 0 }, this.stylesheet.transition) };
            this.stylesheet.sky = e2, this.sky.setSky(e2, i2), this.sky.updateTransitions(o2);
          }
          _setProjectionInternal(e2) {
            const i2 = function(e3, i3) {
              const a2 = { constrainOverride: i3 };
              if (Array.isArray(e3)) {
                const t2 = new di({ type: e3 });
                return { projection: t2, transform: new Ri(a2), cameraHelper: new Di(t2) };
              }
              switch (e3) {
                case "mercator":
                  return { projection: new jt(), transform: new $t(a2), cameraHelper: new Yt() };
                case "globe": {
                  const e4 = new di({ type: ["interpolate", ["linear"], ["zoom"], 11, "vertical-perspective", 12, "mercator"] });
                  return { projection: e4, transform: new Ri(a2), cameraHelper: new Di(e4) };
                }
                case "vertical-perspective":
                  return { projection: new hi(), transform: new Si(a2), cameraHelper: new zi() };
                default:
                  return t.w(`Unknown projection name: ${e3}. Falling back to mercator projection.`), { projection: new jt(), transform: new $t(a2), cameraHelper: new Yt() };
              }
            }(e2, this.map.transformConstrain);
            this.projection = i2.projection, this.map.migrateProjection(i2.transform, i2.cameraHelper);
            for (const e3 in this.tileManagers) this.tileManagers[e3].reload();
          }
          _validate(e2, i2, a2, r2, o2 = {}) {
            return (!o2 || false !== o2.validate) && Ai(this, e2.call(t.C, t.e({ key: i2, style: this.serialize(), value: a2, styleSpec: t.u }, r2)));
          }
          _remove(e2 = true) {
            this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null), ce().off(se, this._rtlPluginLoaded);
            for (const e3 in this._layers) this._layers[e3].setEventedParent(null);
            for (const e3 in this.tileManagers) {
              const t2 = this.tileManagers[e3];
              t2.setEventedParent(null), t2.onRemove(this.map);
            }
            this.imageManager.setEventedParent(null), this.setEventedParent(null), e2 && this.dispatcher.broadcast("RM", void 0), this.dispatcher.remove(e2);
          }
          _clearSource(e2) {
            this.tileManagers[e2].clearTiles();
          }
          _reloadSource(e2) {
            this.tileManagers[e2].resume(), this.tileManagers[e2].reload();
          }
          _updateSources(e2) {
            for (const t2 in this.tileManagers) this.tileManagers[t2].update(e2, this.map.terrain);
          }
          _generateCollisionBoxes() {
            for (const e2 in this.tileManagers) this._reloadSource(e2);
          }
          _updatePlacement(e2, t2, i2, a2, r2 = false) {
            let o2 = false, s2 = false;
            const n2 = {};
            for (const t3 of this._order) {
              const i3 = this._layers[t3];
              if ("symbol" !== i3.type) continue;
              if (!n2[i3.source]) {
                const e3 = this.tileManagers[i3.source];
                n2[i3.source] = e3.getRenderableIds(true).map((t4) => e3.getTileByID(t4)).sort((e4, t4) => t4.tileID.overscaledZ - e4.tileID.overscaledZ || (e4.tileID.isLessThan(t4.tileID) ? -1 : 1));
              }
              const a3 = this.crossTileSymbolIndex.addLayer(i3, n2[i3.source], e2.center.lng);
              o2 = o2 || a3;
            }
            if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((r2 = r2 || this._layerOrderChanged || 0 === i2) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(c(), e2.zoom)) && (this.pauseablePlacement = new Ct(e2, this.map.terrain, this._order, r2, t2, i2, a2, this.placement), this._layerOrderChanged = false), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, n2), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(c()), s2 = true), o2 && this.pauseablePlacement.placement.setStale()), s2 || o2) for (const e3 of this._order) {
              const t3 = this._layers[e3];
              "symbol" === t3.type && this.placement.updateLayerOpacities(t3, n2[t3.source]);
            }
            return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(c());
          }
          _releaseSymbolFadeTiles() {
            for (const e2 in this.tileManagers) this.tileManagers[e2].releaseSymbolFadeTiles();
          }
          getImages(e2, i2) {
            return t._(this, void 0, void 0, function* () {
              const e3 = yield this.imageManager.getImages(i2.icons);
              this._updateTilesForChangedImages();
              const t2 = this.tileManagers[i2.source];
              return t2 && t2.setDependencies(i2.tileID.key, i2.type, i2.icons), e3;
            });
          }
          getGlyphs(e2, i2) {
            return t._(this, void 0, void 0, function* () {
              const e3 = yield this.glyphManager.getGlyphs(i2.stacks), t2 = this.tileManagers[i2.source];
              return t2 && t2.setDependencies(i2.tileID.key, i2.type, [""]), e3;
            });
          }
          getGlyphsUrl() {
            return this.stylesheet.glyphs || null;
          }
          setGlyphs(e2, i2 = {}) {
            this._checkLoaded(), e2 && this._validate(t.C.glyphs, "glyphs", e2, null, i2) || (this._glyphsDidChange = true, this.stylesheet.glyphs = e2, this.glyphManager.entries = {}, this.glyphManager.setURL(e2));
          }
          getDashes(e2, i2) {
            return t._(this, void 0, void 0, function* () {
              const e3 = {};
              for (const [t2, a2] of Object.entries(i2.dashes)) e3[t2] = this.lineAtlas.getDash(a2.dasharray, a2.round);
              return e3;
            });
          }
          addSprite(e2, i2, a2 = {}, r2) {
            this._checkLoaded();
            const o2 = [{ id: e2, url: i2 }], s2 = [...x(this.stylesheet.sprite), ...o2];
            this._validate(t.C.sprite, "sprite", s2, null, a2) || (this.stylesheet.sprite = s2, this._loadSprite(o2, true, r2));
          }
          removeSprite(e2) {
            this._checkLoaded();
            const i2 = x(this.stylesheet.sprite);
            if (i2.find((t2) => t2.id === e2)) {
              if (this._spritesImagesIds[e2]) for (const t2 of this._spritesImagesIds[e2]) this.imageManager.removeImage(t2), this._changedImages[t2] = true;
              i2.splice(i2.findIndex((t2) => t2.id === e2), 1), this.stylesheet.sprite = i2.length > 0 ? i2 : void 0, delete this._spritesImagesIds[e2], this._availableImages = this.imageManager.listImages(), this._changed = true, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", { dataType: "style" }));
            } else this.fire(new t.k(new Error(`Sprite "${e2}" doesn't exists on this map.`)));
          }
          getSprite() {
            return x(this.stylesheet.sprite);
          }
          setSprite(e2, i2 = {}, a2) {
            this._checkLoaded(), e2 && this._validate(t.C.sprite, "sprite", e2, null, i2) || (this.stylesheet.sprite = e2, e2 ? this._loadSprite(e2, true, a2) : (this._unloadSprite(), a2 && a2(null)));
          }
          destroy() {
            this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null);
            for (const e2 in this.tileManagers) {
              const t2 = this.tileManagers[e2];
              t2.setEventedParent(null), t2.onRemove(this.map);
            }
            this.tileManagers = {}, this.imageManager && (this.imageManager.setEventedParent(null), this.imageManager.destroy(), this._availableImages = [], this._spritesImagesIds = {}), this.glyphManager && this.glyphManager.destroy();
            for (const e2 in this._layers) {
              const t2 = this._layers[e2];
              t2.setEventedParent(null), t2.onRemove && t2.onRemove(this.map);
            }
            this._setInitialValues(), this.setEventedParent(null), this.dispatcher.unregisterMessageHandler("GG"), this.dispatcher.unregisterMessageHandler("GI"), this.dispatcher.unregisterMessageHandler("GDA"), this.dispatcher.remove(true), this._listeners = {}, this._oneTimeListeners = {};
          }
        }
        var Fi = t.aV([{ name: "a_pos", type: "Int16", components: 2 }, { name: "a_texture_pos", type: "Int16", components: 2 }]);
        class Bi {
          constructor() {
            this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
          }
          bind(e2, t2, i2, a2, r2, o2, s2, n2, l2) {
            this.context = e2;
            let c2 = this.boundPaintVertexBuffers.length !== a2.length;
            for (let e3 = 0; !c2 && e3 < a2.length; e3++) this.boundPaintVertexBuffers[e3] !== a2[e3] && (c2 = true);
            !this.vao || this.boundProgram !== t2 || this.boundLayoutVertexBuffer !== i2 || c2 || this.boundIndexBuffer !== r2 || this.boundVertexOffset !== o2 || this.boundDynamicVertexBuffer !== s2 || this.boundDynamicVertexBuffer2 !== n2 || this.boundDynamicVertexBuffer3 !== l2 ? this.freshBind(t2, i2, a2, r2, o2, s2, n2, l2) : (e2.bindVertexArray.set(this.vao), s2 && s2.bind(), r2 && r2.dynamicDraw && r2.bind(), n2 && n2.bind(), l2 && l2.bind());
          }
          freshBind(e2, t2, i2, a2, r2, o2, s2, n2) {
            const l2 = e2.numAttributes, c2 = this.context, h2 = c2.gl;
            this.vao && this.destroy(), this.vao = c2.createVertexArray(), c2.bindVertexArray.set(this.vao), this.boundProgram = e2, this.boundLayoutVertexBuffer = t2, this.boundPaintVertexBuffers = i2, this.boundIndexBuffer = a2, this.boundVertexOffset = r2, this.boundDynamicVertexBuffer = o2, this.boundDynamicVertexBuffer2 = s2, this.boundDynamicVertexBuffer3 = n2, t2.enableAttributes(h2, e2);
            for (const t3 of i2) t3.enableAttributes(h2, e2);
            o2 && o2.enableAttributes(h2, e2), s2 && s2.enableAttributes(h2, e2), n2 && n2.enableAttributes(h2, e2), t2.bind(), t2.setVertexAttribPointers(h2, e2, r2);
            for (const t3 of i2) t3.bind(), t3.setVertexAttribPointers(h2, e2, r2);
            o2 && (o2.bind(), o2.setVertexAttribPointers(h2, e2, r2)), a2 && a2.bind(), s2 && (s2.bind(), s2.setVertexAttribPointers(h2, e2, r2)), n2 && (n2.bind(), n2.setVertexAttribPointers(h2, e2, r2)), c2.currentNumAttributes = l2;
          }
          destroy() {
            this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
          }
        }
        const Oi = (e2, i2, a2, r2, o2) => ({ u_texture: 0, u_ele_delta: e2, u_fog_matrix: i2, u_fog_color: a2 ? a2.properties.get("fog-color") : t.bq.white, u_fog_ground_blend: a2 ? a2.properties.get("fog-ground-blend") : 1, u_fog_ground_blend_opacity: o2 ? 0 : a2 ? a2.calculateFogBlendOpacity(r2) : 0, u_horizon_color: a2 ? a2.properties.get("horizon-color") : t.bq.white, u_horizon_fog_blend: a2 ? a2.properties.get("horizon-fog-blend") : 1, u_is_globe_mode: o2 ? 1 : 0 }), ji = { mainMatrix: "u_projection_matrix", tileMercatorCoords: "u_projection_tile_mercator_coords", clippingPlane: "u_projection_clipping_plane", projectionTransition: "u_projection_transition", fallbackMatrix: "u_projection_fallback_matrix" };
        function Ni(e2) {
          const t2 = [];
          for (let i2 = 0; i2 < e2.length; i2++) {
            if (null === e2[i2]) continue;
            const a2 = e2[i2].split(" ");
            t2.push(a2.pop());
          }
          return t2;
        }
        class Zi {
          constructor(e2, i2, a2, r2, o2, s2, n2, l2, c2 = []) {
            const h2 = e2.gl;
            this.program = h2.createProgram();
            const u2 = Ni(i2.staticAttributes), d2 = a2 ? a2.getBinderAttributes() : [], _2 = u2.concat(d2), p2 = At.prelude.staticUniforms ? Ni(At.prelude.staticUniforms) : [], m2 = n2.staticUniforms ? Ni(n2.staticUniforms) : [], f2 = i2.staticUniforms ? Ni(i2.staticUniforms) : [], g2 = a2 ? a2.getBinderUniforms() : [], v2 = p2.concat(m2).concat(f2).concat(g2), x2 = [];
            for (const e3 of v2) x2.indexOf(e3) < 0 && x2.push(e3);
            const b2 = a2 ? a2.defines() : [];
            oi(h2) && b2.unshift("#version 300 es"), o2 && b2.push("#define OVERDRAW_INSPECTOR;"), s2 && b2.push("#define TERRAIN3D;"), l2 && b2.push(l2), c2 && b2.push(...c2);
            let y2 = b2.concat(At.prelude.fragmentSource, n2.fragmentSource, i2.fragmentSource).join("\n"), w2 = b2.concat(At.prelude.vertexSource, n2.vertexSource, i2.vertexSource).join("\n");
            oi(h2) || (y2 = function(e3) {
              return e3.replace(/\bin\s/g, "varying ").replace("out highp vec4 fragColor;", "").replace(/fragColor/g, "gl_FragColor").replace(/texture\(/g, "texture2D(");
            }(y2), w2 = function(e3) {
              return e3.replace(/\bin\s/g, "attribute ").replace(/\bout\s/g, "varying ").replace(/texture\(/g, "texture2D(");
            }(w2));
            const T2 = h2.createShader(h2.FRAGMENT_SHADER);
            if (h2.isContextLost()) return void (this.failedToCreate = true);
            if (h2.shaderSource(T2, y2), h2.compileShader(T2), !h2.getShaderParameter(T2, h2.COMPILE_STATUS)) throw new Error(`Could not compile fragment shader: ${h2.getShaderInfoLog(T2)}`);
            h2.attachShader(this.program, T2);
            const P2 = h2.createShader(h2.VERTEX_SHADER);
            if (h2.isContextLost()) return void (this.failedToCreate = true);
            if (h2.shaderSource(P2, w2), h2.compileShader(P2), !h2.getShaderParameter(P2, h2.COMPILE_STATUS)) throw new Error(`Could not compile vertex shader: ${h2.getShaderInfoLog(P2)}`);
            h2.attachShader(this.program, P2), this.attributes = {};
            const I2 = {};
            this.numAttributes = _2.length;
            for (let e3 = 0; e3 < this.numAttributes; e3++) _2[e3] && (h2.bindAttribLocation(this.program, e3, _2[e3]), this.attributes[_2[e3]] = e3);
            if (h2.linkProgram(this.program), !h2.getProgramParameter(this.program, h2.LINK_STATUS)) throw new Error(`Program failed to link: ${h2.getProgramInfoLog(this.program)}`);
            h2.deleteShader(P2), h2.deleteShader(T2);
            for (let e3 = 0; e3 < x2.length; e3++) {
              const t2 = x2[e3];
              if (t2 && !I2[t2]) {
                const e4 = h2.getUniformLocation(this.program, t2);
                e4 && (I2[t2] = e4);
              }
            }
            this.fixedUniforms = r2(e2, I2), this.terrainUniforms = ((e3, i3) => ({ u_depth: new t.b$(e3, i3.u_depth), u_terrain: new t.b$(e3, i3.u_terrain), u_terrain_dim: new t.br(e3, i3.u_terrain_dim), u_terrain_matrix: new t.c1(e3, i3.u_terrain_matrix), u_terrain_unpack: new t.c2(e3, i3.u_terrain_unpack), u_terrain_exaggeration: new t.br(e3, i3.u_terrain_exaggeration) }))(e2, I2), this.projectionUniforms = ((e3, i3) => ({ u_projection_matrix: new t.c1(e3, i3.u_projection_matrix), u_projection_tile_mercator_coords: new t.c2(e3, i3.u_projection_tile_mercator_coords), u_projection_clipping_plane: new t.c2(e3, i3.u_projection_clipping_plane), u_projection_transition: new t.br(e3, i3.u_projection_transition), u_projection_fallback_matrix: new t.c1(e3, i3.u_projection_fallback_matrix) }))(e2, I2), this.binderUniforms = a2 ? a2.getUniforms(e2, I2) : [];
          }
          draw(e2, t2, i2, a2, r2, o2, s2, n2, l2, c2, h2, u2, d2, _2, p2, m2, f2, g2, v2) {
            const x2 = e2.gl;
            if (this.failedToCreate) return;
            if (e2.program.set(this.program), e2.setDepthMode(i2), e2.setStencilMode(a2), e2.setColorMode(r2), e2.setCullFace(o2), n2) {
              e2.activeTexture.set(x2.TEXTURE2), x2.bindTexture(x2.TEXTURE_2D, n2.depthTexture), e2.activeTexture.set(x2.TEXTURE3), x2.bindTexture(x2.TEXTURE_2D, n2.texture);
              for (const e3 in this.terrainUniforms) this.terrainUniforms[e3].set(n2[e3]);
            }
            if (l2) for (const e3 in l2) this.projectionUniforms[ji[e3]].set(l2[e3]);
            if (s2) for (const e3 in this.fixedUniforms) this.fixedUniforms[e3].set(s2[e3]);
            m2 && m2.setUniforms(e2, this.binderUniforms, _2, { zoom: p2 });
            let b2 = 0;
            switch (t2) {
              case x2.LINES:
                b2 = 2;
                break;
              case x2.TRIANGLES:
                b2 = 3;
                break;
              case x2.LINE_STRIP:
                b2 = 1;
            }
            for (const i3 of d2.get()) {
              const a3 = i3.vaos || (i3.vaos = {});
              (a3[c2] || (a3[c2] = new Bi())).bind(e2, this, h2, m2 ? m2.getPaintVertexBuffers() : [], u2, i3.vertexOffset, f2, g2, v2), x2.drawElements(t2, i3.primitiveLength * b2, x2.UNSIGNED_SHORT, i3.primitiveOffset * b2 * 2);
            }
          }
        }
        function Gi(e2, i2, a2) {
          const r2 = 1 / t.aO(a2, 1, i2.transform.tileZoom), o2 = Math.pow(2, a2.tileID.overscaledZ), s2 = a2.tileSize * Math.pow(2, i2.transform.tileZoom) / o2, n2 = s2 * (a2.tileID.canonical.x + a2.tileID.wrap * o2), l2 = s2 * a2.tileID.canonical.y;
          return { u_image: 0, u_texsize: a2.imageAtlasTexture.size, u_scale: [r2, e2.fromScale, e2.toScale], u_fade: e2.t, u_pixel_coord_upper: [n2 >> 16, l2 >> 16], u_pixel_coord_lower: [65535 & n2, 65535 & l2] };
        }
        const Ui = (e2, i2, a2, r2) => {
          const o2 = e2.style.light, s2 = o2.properties.get("position"), n2 = [s2.x, s2.y, s2.z], l2 = t.c5();
          "viewport" === o2.properties.get("anchor") && t.c6(l2, e2.transform.bearingInRadians), t.c7(n2, n2, l2);
          const c2 = e2.transform.transformLightDirection(n2), h2 = o2.properties.get("color");
          return { u_lightpos: n2, u_lightpos_globe: c2, u_lightintensity: o2.properties.get("intensity"), u_lightcolor: [h2.r, h2.g, h2.b], u_vertical_gradient: +i2, u_opacity: a2, u_fill_translate: r2 };
        }, Vi = (e2, i2, a2, r2, o2, s2, n2) => t.e(Ui(e2, i2, a2, r2), Gi(s2, e2, n2), { u_height_factor: -Math.pow(2, o2.overscaledZ) / n2.tileSize / 8 }), qi = (e2, i2, a2, r2) => t.e(Gi(i2, e2, a2), { u_fill_translate: r2 }), Wi = (e2, t2) => ({ u_world: e2, u_fill_translate: t2 }), $i = (e2, i2, a2, r2, o2) => t.e(qi(e2, i2, a2, o2), { u_world: r2 }), Hi = (e2, i2, a2, r2, o2) => {
          const s2 = e2.transform;
          let n2, l2, c2 = 0;
          if ("map" === a2.paint.get("circle-pitch-alignment")) {
            const e3 = t.aO(i2, 1, s2.zoom);
            n2 = true, l2 = [e3, e3], c2 = e3 / (t.a5 * Math.pow(2, i2.tileID.overscaledZ)) * 2 * Math.PI * o2;
          } else n2 = false, l2 = s2.pixelsToGLUnits;
          return { u_camera_to_center_distance: s2.cameraToCenterDistance, u_scale_with_map: +("map" === a2.paint.get("circle-pitch-scale")), u_pitch_with_map: +n2, u_device_pixel_ratio: e2.pixelRatio, u_extrude_scale: l2, u_globe_extrude_scale: c2, u_translate: r2 };
        }, Xi = (e2) => ({ u_pixel_extrude_scale: [1 / e2.width, 1 / e2.height] }), Ki = (e2) => ({ u_viewport_size: [e2.width, e2.height] }), Yi = (e2, t2 = 1) => ({ u_color: e2, u_overlay: 0, u_overlay_scale: t2 }), Qi = (e2, i2, a2, r2) => {
          const o2 = t.aO(e2, 1, i2) / (t.a5 * Math.pow(2, e2.tileID.overscaledZ)) * 2 * Math.PI * r2;
          return { u_extrude_scale: t.aO(e2, 1, i2), u_intensity: a2, u_globe_extrude_scale: o2 };
        }, Ji = (e2, i2, a2, r2) => {
          const o2 = t.N();
          t.c8(o2, 0, e2.width, e2.height, 0, 0, 1);
          const s2 = e2.context.gl;
          return { u_matrix: o2, u_world: [s2.drawingBufferWidth, s2.drawingBufferHeight], u_image: a2, u_color_ramp: r2, u_opacity: i2.paint.get("heatmap-opacity") };
        }, ea = (e2, t2, i2) => {
          const a2 = i2.paint.get("hillshade-accent-color");
          let r2;
          switch (i2.paint.get("hillshade-method")) {
            case "basic":
              r2 = 4;
              break;
            case "combined":
              r2 = 1;
              break;
            case "igor":
              r2 = 2;
              break;
            case "multidirectional":
              r2 = 3;
              break;
            default:
              r2 = 0;
          }
          const o2 = i2.getIlluminationProperties();
          for (let t3 = 0; t3 < o2.directionRadians.length; t3++) "viewport" === i2.paint.get("hillshade-illumination-anchor") && (o2.directionRadians[t3] += e2.transform.bearingInRadians);
          return { u_image: 0, u_latrange: ia(0, t2.tileID), u_exaggeration: i2.paint.get("hillshade-exaggeration"), u_altitudes: o2.altitudeRadians, u_azimuths: o2.directionRadians, u_accent: a2, u_method: r2, u_highlights: o2.highlightColor, u_shadows: o2.shadowColor };
        }, ta = (e2, i2) => {
          const a2 = i2.stride, r2 = t.N();
          return t.c8(r2, 0, t.a5, -t.a5, 0, 0, 1), t.O(r2, r2, [0, -t.a5, 0]), { u_matrix: r2, u_image: 1, u_dimension: [a2, a2], u_zoom: e2.overscaledZ, u_unpack: i2.getUnpackVector() };
        };
        function ia(e2, i2) {
          const a2 = Math.pow(2, i2.canonical.z), r2 = i2.canonical.y;
          return [new t.ab(0, r2 / a2).toLngLat().lat, new t.ab(0, (r2 + 1) / a2).toLngLat().lat];
        }
        const aa = (e2, t2, i2 = 0) => ({ u_image: 0, u_unpack: t2.getUnpackVector(), u_dimension: [t2.stride, t2.stride], u_elevation_stops: 1, u_color_stops: 4, u_color_ramp_size: i2, u_opacity: e2.paint.get("color-relief-opacity") }), ra = (e2, i2, a2, r2) => {
          const o2 = e2.transform;
          return { u_translation: ha(e2, i2, a2), u_ratio: r2 / t.aO(i2, 1, o2.zoom), u_device_pixel_ratio: e2.pixelRatio, u_units_to_pixels: [1 / o2.pixelsToGLUnits[0], 1 / o2.pixelsToGLUnits[1]] };
        }, oa = (e2, i2, a2, r2, o2) => t.e(ra(e2, i2, a2, r2), { u_image: 0, u_image_height: o2 }), sa = (e2, i2, a2, r2, o2) => {
          const s2 = e2.transform, n2 = ca(i2, s2);
          return { u_translation: ha(e2, i2, a2), u_texsize: i2.imageAtlasTexture.size, u_ratio: r2 / t.aO(i2, 1, s2.zoom), u_device_pixel_ratio: e2.pixelRatio, u_image: 0, u_scale: [n2, o2.fromScale, o2.toScale], u_fade: o2.t, u_units_to_pixels: [1 / s2.pixelsToGLUnits[0], 1 / s2.pixelsToGLUnits[1]] };
        }, na = (e2, i2, a2, r2, o2) => {
          const s2 = ca(i2, e2.transform);
          return t.e(ra(e2, i2, a2, r2), { u_tileratio: s2, u_crossfade_from: o2.fromScale, u_crossfade_to: o2.toScale, u_image: 0, u_mix: o2.t, u_lineatlas_width: e2.lineAtlas.width, u_lineatlas_height: e2.lineAtlas.height });
        }, la = (e2, i2, a2, r2, o2, s2) => {
          const n2 = ca(i2, e2.transform);
          return t.e(ra(e2, i2, a2, r2), { u_image: 0, u_image_height: s2, u_tileratio: n2, u_crossfade_from: o2.fromScale, u_crossfade_to: o2.toScale, u_image_dash: 1, u_mix: o2.t, u_lineatlas_width: e2.lineAtlas.width, u_lineatlas_height: e2.lineAtlas.height });
        };
        function ca(e2, i2) {
          return 1 / t.aO(e2, 1, i2.tileZoom);
        }
        function ha(e2, i2, a2) {
          return t.aP(e2.transform, i2, a2.paint.get("line-translate"), a2.paint.get("line-translate-anchor"));
        }
        const ua = (e2, t2, i2, a2, r2) => {
          return { u_tl_parent: e2, u_scale_parent: t2, u_buffer_scale: 1, u_fade_t: i2.mix, u_opacity: i2.opacity * a2.paint.get("raster-opacity"), u_image0: 0, u_image1: 1, u_brightness_low: a2.paint.get("raster-brightness-min"), u_brightness_high: a2.paint.get("raster-brightness-max"), u_saturation_factor: (s2 = a2.paint.get("raster-saturation"), s2 > 0 ? 1 - 1 / (1.001 - s2) : -s2), u_contrast_factor: (o2 = a2.paint.get("raster-contrast"), o2 > 0 ? 1 / (1 - o2) : 1 + o2), u_spin_weights: da(a2.paint.get("raster-hue-rotate")), u_coords_top: [r2[0].x, r2[0].y, r2[1].x, r2[1].y], u_coords_bottom: [r2[3].x, r2[3].y, r2[2].x, r2[2].y] };
          var o2, s2;
        };
        function da(e2) {
          e2 *= Math.PI / 180;
          const t2 = Math.sin(e2), i2 = Math.cos(e2);
          return [(2 * i2 + 1) / 3, (-Math.sqrt(3) * t2 - i2 + 1) / 3, (Math.sqrt(3) * t2 - i2 + 1) / 3];
        }
        const _a = (e2, t2, i2, a2, r2, o2, s2, n2, l2, c2, h2, u2, d2) => {
          const _2 = s2.transform;
          return { u_is_size_zoom_constant: +("constant" === e2 || "source" === e2), u_is_size_feature_constant: +("constant" === e2 || "camera" === e2), u_size_t: t2 ? t2.uSizeT : 0, u_size: t2 ? t2.uSize : 0, u_camera_to_center_distance: _2.cameraToCenterDistance, u_pitch: _2.pitch / 360 * 2 * Math.PI, u_rotate_symbol: +i2, u_aspect_ratio: _2.width / _2.height, u_fade_change: s2.options.fadeDuration ? s2.symbolFadeChange : 1, u_label_plane_matrix: n2, u_coord_matrix: l2, u_is_text: +h2, u_pitch_with_map: +a2, u_is_along_line: r2, u_is_variable_anchor: o2, u_texsize: u2, u_texture: 0, u_translation: c2, u_pitched_scale: d2 };
        }, pa = (e2, i2, a2, r2, o2, s2, n2, l2, c2, h2, u2, d2, _2, p2) => {
          const m2 = n2.transform;
          return t.e(_a(e2, i2, a2, r2, o2, s2, n2, l2, c2, h2, u2, d2, p2), { u_gamma_scale: r2 ? Math.cos(m2.pitch * Math.PI / 180) * m2.cameraToCenterDistance : 1, u_device_pixel_ratio: n2.pixelRatio, u_is_halo: 1 });
        }, ma = (e2, i2, a2, r2, o2, s2, n2, l2, c2, h2, u2, d2, _2) => t.e(pa(e2, i2, a2, r2, o2, s2, n2, l2, c2, h2, true, u2, 0, _2), { u_texsize_icon: d2, u_texture_icon: 1 }), fa = (e2, t2) => ({ u_opacity: e2, u_color: t2 }), ga = (e2, i2, a2, r2, o2) => t.e(function(e3, i3, a3, r3) {
          const o3 = a3.imageManager.getPattern(e3.from.toString()), s2 = a3.imageManager.getPattern(e3.to.toString()), { width: n2, height: l2 } = a3.imageManager.getPixelSize(), c2 = Math.pow(2, r3.tileID.overscaledZ), h2 = r3.tileSize * Math.pow(2, a3.transform.tileZoom) / c2, u2 = h2 * (r3.tileID.canonical.x + r3.tileID.wrap * c2), d2 = h2 * r3.tileID.canonical.y;
          return { u_image: 0, u_pattern_tl_a: o3.tl, u_pattern_br_a: o3.br, u_pattern_tl_b: s2.tl, u_pattern_br_b: s2.br, u_texsize: [n2, l2], u_mix: i3.t, u_pattern_size_a: o3.displaySize, u_pattern_size_b: s2.displaySize, u_scale_a: i3.fromScale, u_scale_b: i3.toScale, u_tile_units_to_pixels: 1 / t.aO(r3, 1, a3.transform.tileZoom), u_pixel_coord_upper: [u2 >> 16, d2 >> 16], u_pixel_coord_lower: [65535 & u2, 65535 & d2] };
        }(a2, o2, i2, r2), { u_opacity: e2 }), va = (e2, t2) => {
        }, xa = { fillExtrusion: (e2, i2) => ({ u_lightpos: new t.c3(e2, i2.u_lightpos), u_lightpos_globe: new t.c3(e2, i2.u_lightpos_globe), u_lightintensity: new t.br(e2, i2.u_lightintensity), u_lightcolor: new t.c3(e2, i2.u_lightcolor), u_vertical_gradient: new t.br(e2, i2.u_vertical_gradient), u_opacity: new t.br(e2, i2.u_opacity), u_fill_translate: new t.c4(e2, i2.u_fill_translate) }), fillExtrusionPattern: (e2, i2) => ({ u_lightpos: new t.c3(e2, i2.u_lightpos), u_lightpos_globe: new t.c3(e2, i2.u_lightpos_globe), u_lightintensity: new t.br(e2, i2.u_lightintensity), u_lightcolor: new t.c3(e2, i2.u_lightcolor), u_vertical_gradient: new t.br(e2, i2.u_vertical_gradient), u_height_factor: new t.br(e2, i2.u_height_factor), u_opacity: new t.br(e2, i2.u_opacity), u_fill_translate: new t.c4(e2, i2.u_fill_translate), u_image: new t.b$(e2, i2.u_image), u_texsize: new t.c4(e2, i2.u_texsize), u_pixel_coord_upper: new t.c4(e2, i2.u_pixel_coord_upper), u_pixel_coord_lower: new t.c4(e2, i2.u_pixel_coord_lower), u_scale: new t.c3(e2, i2.u_scale), u_fade: new t.br(e2, i2.u_fade) }), fill: (e2, i2) => ({ u_fill_translate: new t.c4(e2, i2.u_fill_translate) }), fillPattern: (e2, i2) => ({ u_image: new t.b$(e2, i2.u_image), u_texsize: new t.c4(e2, i2.u_texsize), u_pixel_coord_upper: new t.c4(e2, i2.u_pixel_coord_upper), u_pixel_coord_lower: new t.c4(e2, i2.u_pixel_coord_lower), u_scale: new t.c3(e2, i2.u_scale), u_fade: new t.br(e2, i2.u_fade), u_fill_translate: new t.c4(e2, i2.u_fill_translate) }), fillOutline: (e2, i2) => ({ u_world: new t.c4(e2, i2.u_world), u_fill_translate: new t.c4(e2, i2.u_fill_translate) }), fillOutlinePattern: (e2, i2) => ({ u_world: new t.c4(e2, i2.u_world), u_image: new t.b$(e2, i2.u_image), u_texsize: new t.c4(e2, i2.u_texsize), u_pixel_coord_upper: new t.c4(e2, i2.u_pixel_coord_upper), u_pixel_coord_lower: new t.c4(e2, i2.u_pixel_coord_lower), u_scale: new t.c3(e2, i2.u_scale), u_fade: new t.br(e2, i2.u_fade), u_fill_translate: new t.c4(e2, i2.u_fill_translate) }), circle: (e2, i2) => ({ u_camera_to_center_distance: new t.br(e2, i2.u_camera_to_center_distance), u_scale_with_map: new t.b$(e2, i2.u_scale_with_map), u_pitch_with_map: new t.b$(e2, i2.u_pitch_with_map), u_extrude_scale: new t.c4(e2, i2.u_extrude_scale), u_device_pixel_ratio: new t.br(e2, i2.u_device_pixel_ratio), u_globe_extrude_scale: new t.br(e2, i2.u_globe_extrude_scale), u_translate: new t.c4(e2, i2.u_translate) }), collisionBox: (e2, i2) => ({ u_pixel_extrude_scale: new t.c4(e2, i2.u_pixel_extrude_scale) }), collisionCircle: (e2, i2) => ({ u_viewport_size: new t.c4(e2, i2.u_viewport_size) }), debug: (e2, i2) => ({ u_color: new t.c0(e2, i2.u_color), u_overlay: new t.b$(e2, i2.u_overlay), u_overlay_scale: new t.br(e2, i2.u_overlay_scale) }), depth: va, clippingMask: va, heatmap: (e2, i2) => ({ u_extrude_scale: new t.br(e2, i2.u_extrude_scale), u_intensity: new t.br(e2, i2.u_intensity), u_globe_extrude_scale: new t.br(e2, i2.u_globe_extrude_scale) }), heatmapTexture: (e2, i2) => ({ u_matrix: new t.c1(e2, i2.u_matrix), u_world: new t.c4(e2, i2.u_world), u_image: new t.b$(e2, i2.u_image), u_color_ramp: new t.b$(e2, i2.u_color_ramp), u_opacity: new t.br(e2, i2.u_opacity) }), hillshade: (e2, i2) => ({ u_image: new t.b$(e2, i2.u_image), u_latrange: new t.c4(e2, i2.u_latrange), u_exaggeration: new t.br(e2, i2.u_exaggeration), u_altitudes: new t.ca(e2, i2.u_altitudes), u_azimuths: new t.ca(e2, i2.u_azimuths), u_accent: new t.c0(e2, i2.u_accent), u_method: new t.b$(e2, i2.u_method), u_shadows: new t.c9(e2, i2.u_shadows), u_highlights: new t.c9(e2, i2.u_highlights) }), hillshadePrepare: (e2, i2) => ({ u_matrix: new t.c1(e2, i2.u_matrix), u_image: new t.b$(e2, i2.u_image), u_dimension: new t.c4(e2, i2.u_dimension), u_zoom: new t.br(e2, i2.u_zoom), u_unpack: new t.c2(e2, i2.u_unpack) }), colorRelief: (e2, i2) => ({ u_image: new t.b$(e2, i2.u_image), u_unpack: new t.c2(e2, i2.u_unpack), u_dimension: new t.c4(e2, i2.u_dimension), u_elevation_stops: new t.b$(e2, i2.u_elevation_stops), u_color_stops: new t.b$(e2, i2.u_color_stops), u_color_ramp_size: new t.b$(e2, i2.u_color_ramp_size), u_opacity: new t.br(e2, i2.u_opacity) }), line: (e2, i2) => ({ u_translation: new t.c4(e2, i2.u_translation), u_ratio: new t.br(e2, i2.u_ratio), u_device_pixel_ratio: new t.br(e2, i2.u_device_pixel_ratio), u_units_to_pixels: new t.c4(e2, i2.u_units_to_pixels) }), lineGradient: (e2, i2) => ({ u_translation: new t.c4(e2, i2.u_translation), u_ratio: new t.br(e2, i2.u_ratio), u_device_pixel_ratio: new t.br(e2, i2.u_device_pixel_ratio), u_units_to_pixels: new t.c4(e2, i2.u_units_to_pixels), u_image: new t.b$(e2, i2.u_image), u_image_height: new t.br(e2, i2.u_image_height) }), linePattern: (e2, i2) => ({ u_translation: new t.c4(e2, i2.u_translation), u_texsize: new t.c4(e2, i2.u_texsize), u_ratio: new t.br(e2, i2.u_ratio), u_device_pixel_ratio: new t.br(e2, i2.u_device_pixel_ratio), u_image: new t.b$(e2, i2.u_image), u_units_to_pixels: new t.c4(e2, i2.u_units_to_pixels), u_scale: new t.c3(e2, i2.u_scale), u_fade: new t.br(e2, i2.u_fade) }), lineSDF: (e2, i2) => ({ u_translation: new t.c4(e2, i2.u_translation), u_ratio: new t.br(e2, i2.u_ratio), u_device_pixel_ratio: new t.br(e2, i2.u_device_pixel_ratio), u_units_to_pixels: new t.c4(e2, i2.u_units_to_pixels), u_image: new t.b$(e2, i2.u_image), u_mix: new t.br(e2, i2.u_mix), u_tileratio: new t.br(e2, i2.u_tileratio), u_crossfade_from: new t.br(e2, i2.u_crossfade_from), u_crossfade_to: new t.br(e2, i2.u_crossfade_to), u_lineatlas_width: new t.br(e2, i2.u_lineatlas_width), u_lineatlas_height: new t.br(e2, i2.u_lineatlas_height) }), lineGradientSDF: (e2, i2) => ({ u_translation: new t.c4(e2, i2.u_translation), u_ratio: new t.br(e2, i2.u_ratio), u_device_pixel_ratio: new t.br(e2, i2.u_device_pixel_ratio), u_units_to_pixels: new t.c4(e2, i2.u_units_to_pixels), u_image: new t.b$(e2, i2.u_image), u_image_height: new t.br(e2, i2.u_image_height), u_tileratio: new t.br(e2, i2.u_tileratio), u_crossfade_from: new t.br(e2, i2.u_crossfade_from), u_crossfade_to: new t.br(e2, i2.u_crossfade_to), u_image_dash: new t.b$(e2, i2.u_image_dash), u_mix: new t.br(e2, i2.u_mix), u_lineatlas_width: new t.br(e2, i2.u_lineatlas_width), u_lineatlas_height: new t.br(e2, i2.u_lineatlas_height) }), raster: (e2, i2) => ({ u_tl_parent: new t.c4(e2, i2.u_tl_parent), u_scale_parent: new t.br(e2, i2.u_scale_parent), u_buffer_scale: new t.br(e2, i2.u_buffer_scale), u_fade_t: new t.br(e2, i2.u_fade_t), u_opacity: new t.br(e2, i2.u_opacity), u_image0: new t.b$(e2, i2.u_image0), u_image1: new t.b$(e2, i2.u_image1), u_brightness_low: new t.br(e2, i2.u_brightness_low), u_brightness_high: new t.br(e2, i2.u_brightness_high), u_saturation_factor: new t.br(e2, i2.u_saturation_factor), u_contrast_factor: new t.br(e2, i2.u_contrast_factor), u_spin_weights: new t.c3(e2, i2.u_spin_weights), u_coords_top: new t.c2(e2, i2.u_coords_top), u_coords_bottom: new t.c2(e2, i2.u_coords_bottom) }), symbolIcon: (e2, i2) => ({ u_is_size_zoom_constant: new t.b$(e2, i2.u_is_size_zoom_constant), u_is_size_feature_constant: new t.b$(e2, i2.u_is_size_feature_constant), u_size_t: new t.br(e2, i2.u_size_t), u_size: new t.br(e2, i2.u_size), u_camera_to_center_distance: new t.br(e2, i2.u_camera_to_center_distance), u_pitch: new t.br(e2, i2.u_pitch), u_rotate_symbol: new t.b$(e2, i2.u_rotate_symbol), u_aspect_ratio: new t.br(e2, i2.u_aspect_ratio), u_fade_change: new t.br(e2, i2.u_fade_change), u_label_plane_matrix: new t.c1(e2, i2.u_label_plane_matrix), u_coord_matrix: new t.c1(e2, i2.u_coord_matrix), u_is_text: new t.b$(e2, i2.u_is_text), u_pitch_with_map: new t.b$(e2, i2.u_pitch_with_map), u_is_along_line: new t.b$(e2, i2.u_is_along_line), u_is_variable_anchor: new t.b$(e2, i2.u_is_variable_anchor), u_texsize: new t.c4(e2, i2.u_texsize), u_texture: new t.b$(e2, i2.u_texture), u_translation: new t.c4(e2, i2.u_translation), u_pitched_scale: new t.br(e2, i2.u_pitched_scale) }), symbolSDF: (e2, i2) => ({ u_is_size_zoom_constant: new t.b$(e2, i2.u_is_size_zoom_constant), u_is_size_feature_constant: new t.b$(e2, i2.u_is_size_feature_constant), u_size_t: new t.br(e2, i2.u_size_t), u_size: new t.br(e2, i2.u_size), u_camera_to_center_distance: new t.br(e2, i2.u_camera_to_center_distance), u_pitch: new t.br(e2, i2.u_pitch), u_rotate_symbol: new t.b$(e2, i2.u_rotate_symbol), u_aspect_ratio: new t.br(e2, i2.u_aspect_ratio), u_fade_change: new t.br(e2, i2.u_fade_change), u_label_plane_matrix: new t.c1(e2, i2.u_label_plane_matrix), u_coord_matrix: new t.c1(e2, i2.u_coord_matrix), u_is_text: new t.b$(e2, i2.u_is_text), u_pitch_with_map: new t.b$(e2, i2.u_pitch_with_map), u_is_along_line: new t.b$(e2, i2.u_is_along_line), u_is_variable_anchor: new t.b$(e2, i2.u_is_variable_anchor), u_texsize: new t.c4(e2, i2.u_texsize), u_texture: new t.b$(e2, i2.u_texture), u_gamma_scale: new t.br(e2, i2.u_gamma_scale), u_device_pixel_ratio: new t.br(e2, i2.u_device_pixel_ratio), u_is_halo: new t.b$(e2, i2.u_is_halo), u_translation: new t.c4(e2, i2.u_translation), u_pitched_scale: new t.br(e2, i2.u_pitched_scale) }), symbolTextAndIcon: (e2, i2) => ({ u_is_size_zoom_constant: new t.b$(e2, i2.u_is_size_zoom_constant), u_is_size_feature_constant: new t.b$(e2, i2.u_is_size_feature_constant), u_size_t: new t.br(e2, i2.u_size_t), u_size: new t.br(e2, i2.u_size), u_camera_to_center_distance: new t.br(e2, i2.u_camera_to_center_distance), u_pitch: new t.br(e2, i2.u_pitch), u_rotate_symbol: new t.b$(e2, i2.u_rotate_symbol), u_aspect_ratio: new t.br(e2, i2.u_aspect_ratio), u_fade_change: new t.br(e2, i2.u_fade_change), u_label_plane_matrix: new t.c1(e2, i2.u_label_plane_matrix), u_coord_matrix: new t.c1(e2, i2.u_coord_matrix), u_is_text: new t.b$(e2, i2.u_is_text), u_pitch_with_map: new t.b$(e2, i2.u_pitch_with_map), u_is_along_line: new t.b$(e2, i2.u_is_along_line), u_is_variable_anchor: new t.b$(e2, i2.u_is_variable_anchor), u_texsize: new t.c4(e2, i2.u_texsize), u_texsize_icon: new t.c4(e2, i2.u_texsize_icon), u_texture: new t.b$(e2, i2.u_texture), u_texture_icon: new t.b$(e2, i2.u_texture_icon), u_gamma_scale: new t.br(e2, i2.u_gamma_scale), u_device_pixel_ratio: new t.br(e2, i2.u_device_pixel_ratio), u_is_halo: new t.b$(e2, i2.u_is_halo), u_translation: new t.c4(e2, i2.u_translation), u_pitched_scale: new t.br(e2, i2.u_pitched_scale) }), background: (e2, i2) => ({ u_opacity: new t.br(e2, i2.u_opacity), u_color: new t.c0(e2, i2.u_color) }), backgroundPattern: (e2, i2) => ({ u_opacity: new t.br(e2, i2.u_opacity), u_image: new t.b$(e2, i2.u_image), u_pattern_tl_a: new t.c4(e2, i2.u_pattern_tl_a), u_pattern_br_a: new t.c4(e2, i2.u_pattern_br_a), u_pattern_tl_b: new t.c4(e2, i2.u_pattern_tl_b), u_pattern_br_b: new t.c4(e2, i2.u_pattern_br_b), u_texsize: new t.c4(e2, i2.u_texsize), u_mix: new t.br(e2, i2.u_mix), u_pattern_size_a: new t.c4(e2, i2.u_pattern_size_a), u_pattern_size_b: new t.c4(e2, i2.u_pattern_size_b), u_scale_a: new t.br(e2, i2.u_scale_a), u_scale_b: new t.br(e2, i2.u_scale_b), u_pixel_coord_upper: new t.c4(e2, i2.u_pixel_coord_upper), u_pixel_coord_lower: new t.c4(e2, i2.u_pixel_coord_lower), u_tile_units_to_pixels: new t.br(e2, i2.u_tile_units_to_pixels) }), terrain: (e2, i2) => ({ u_texture: new t.b$(e2, i2.u_texture), u_ele_delta: new t.br(e2, i2.u_ele_delta), u_fog_matrix: new t.c1(e2, i2.u_fog_matrix), u_fog_color: new t.c0(e2, i2.u_fog_color), u_fog_ground_blend: new t.br(e2, i2.u_fog_ground_blend), u_fog_ground_blend_opacity: new t.br(e2, i2.u_fog_ground_blend_opacity), u_horizon_color: new t.c0(e2, i2.u_horizon_color), u_horizon_fog_blend: new t.br(e2, i2.u_horizon_fog_blend), u_is_globe_mode: new t.br(e2, i2.u_is_globe_mode) }), terrainDepth: (e2, i2) => ({ u_ele_delta: new t.br(e2, i2.u_ele_delta) }), terrainCoords: (e2, i2) => ({ u_texture: new t.b$(e2, i2.u_texture), u_terrain_coords_id: new t.br(e2, i2.u_terrain_coords_id), u_ele_delta: new t.br(e2, i2.u_ele_delta) }), projectionErrorMeasurement: (e2, i2) => ({ u_input: new t.br(e2, i2.u_input), u_output_expected: new t.br(e2, i2.u_output_expected) }), atmosphere: (e2, i2) => ({ u_sun_pos: new t.c3(e2, i2.u_sun_pos), u_atmosphere_blend: new t.br(e2, i2.u_atmosphere_blend), u_globe_position: new t.c3(e2, i2.u_globe_position), u_globe_radius: new t.br(e2, i2.u_globe_radius), u_inv_proj_matrix: new t.c1(e2, i2.u_inv_proj_matrix) }), sky: (e2, i2) => ({ u_sky_color: new t.c0(e2, i2.u_sky_color), u_horizon_color: new t.c0(e2, i2.u_horizon_color), u_horizon: new t.c4(e2, i2.u_horizon), u_horizon_normal: new t.c4(e2, i2.u_horizon_normal), u_sky_horizon_blend: new t.br(e2, i2.u_sky_horizon_blend), u_sky_blend: new t.br(e2, i2.u_sky_blend) }) };
        class ba {
          constructor(e2, t2, i2) {
            this.context = e2;
            const a2 = e2.gl;
            this.buffer = a2.createBuffer(), this.dynamicDraw = Boolean(i2), this.context.unbindVAO(), e2.bindElementBuffer.set(this.buffer), a2.bufferData(a2.ELEMENT_ARRAY_BUFFER, t2.arrayBuffer, this.dynamicDraw ? a2.DYNAMIC_DRAW : a2.STATIC_DRAW), this.dynamicDraw || delete t2.arrayBuffer;
          }
          bind() {
            this.context.bindElementBuffer.set(this.buffer);
          }
          updateData(e2) {
            const t2 = this.context.gl;
            if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
            this.context.unbindVAO(), this.bind(), t2.bufferSubData(t2.ELEMENT_ARRAY_BUFFER, 0, e2.arrayBuffer);
          }
          destroy() {
            this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
          }
        }
        const ya = { Int8: "BYTE", Uint8: "UNSIGNED_BYTE", Int16: "SHORT", Uint16: "UNSIGNED_SHORT", Int32: "INT", Uint32: "UNSIGNED_INT", Float32: "FLOAT" };
        class wa {
          constructor(e2, t2, i2, a2) {
            this.length = t2.length, this.attributes = i2, this.itemSize = t2.bytesPerElement, this.dynamicDraw = a2, this.context = e2;
            const r2 = e2.gl;
            this.buffer = r2.createBuffer(), e2.bindVertexBuffer.set(this.buffer), r2.bufferData(r2.ARRAY_BUFFER, t2.arrayBuffer, this.dynamicDraw ? r2.DYNAMIC_DRAW : r2.STATIC_DRAW), this.dynamicDraw || delete t2.arrayBuffer;
          }
          bind() {
            this.context.bindVertexBuffer.set(this.buffer);
          }
          updateData(e2) {
            if (e2.length !== this.length) throw new Error(`Length of new data is ${e2.length}, which doesn't match current length of ${this.length}`);
            const t2 = this.context.gl;
            this.bind(), t2.bufferSubData(t2.ARRAY_BUFFER, 0, e2.arrayBuffer);
          }
          enableAttributes(e2, t2) {
            for (let i2 = 0; i2 < this.attributes.length; i2++) {
              const a2 = t2.attributes[this.attributes[i2].name];
              void 0 !== a2 && e2.enableVertexAttribArray(a2);
            }
          }
          setVertexAttribPointers(e2, t2, i2) {
            for (let a2 = 0; a2 < this.attributes.length; a2++) {
              const r2 = this.attributes[a2], o2 = t2.attributes[r2.name];
              void 0 !== o2 && e2.vertexAttribPointer(o2, r2.components, e2[ya[r2.type]], false, this.itemSize, r2.offset + this.itemSize * (i2 || 0));
            }
          }
          destroy() {
            this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
          }
        }
        class Ta {
          constructor(e2) {
            this.gl = e2.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = false;
          }
          get() {
            return this.current;
          }
          set(e2) {
          }
          getDefault() {
            return this.default;
          }
          setDefault() {
            this.set(this.default);
          }
        }
        class Pa extends Ta {
          getDefault() {
            return t.bq.transparent;
          }
          set(e2) {
            const t2 = this.current;
            (e2.r !== t2.r || e2.g !== t2.g || e2.b !== t2.b || e2.a !== t2.a || this.dirty) && (this.gl.clearColor(e2.r, e2.g, e2.b, e2.a), this.current = e2, this.dirty = false);
          }
        }
        class Ia extends Ta {
          getDefault() {
            return 1;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.clearDepth(e2), this.current = e2, this.dirty = false);
          }
        }
        class Ca extends Ta {
          getDefault() {
            return 0;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.clearStencil(e2), this.current = e2, this.dirty = false);
          }
        }
        class Ma extends Ta {
          getDefault() {
            return [true, true, true, true];
          }
          set(e2) {
            const t2 = this.current;
            (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || e2[3] !== t2[3] || this.dirty) && (this.gl.colorMask(e2[0], e2[1], e2[2], e2[3]), this.current = e2, this.dirty = false);
          }
        }
        class Ea extends Ta {
          getDefault() {
            return true;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.depthMask(e2), this.current = e2, this.dirty = false);
          }
        }
        class Sa extends Ta {
          getDefault() {
            return 255;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.stencilMask(e2), this.current = e2, this.dirty = false);
          }
        }
        class Ra extends Ta {
          getDefault() {
            return { func: this.gl.ALWAYS, ref: 0, mask: 255 };
          }
          set(e2) {
            const t2 = this.current;
            (e2.func !== t2.func || e2.ref !== t2.ref || e2.mask !== t2.mask || this.dirty) && (this.gl.stencilFunc(e2.func, e2.ref, e2.mask), this.current = e2, this.dirty = false);
          }
        }
        class za extends Ta {
          getDefault() {
            const e2 = this.gl;
            return [e2.KEEP, e2.KEEP, e2.KEEP];
          }
          set(e2) {
            const t2 = this.current;
            (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || this.dirty) && (this.gl.stencilOp(e2[0], e2[1], e2[2]), this.current = e2, this.dirty = false);
          }
        }
        class Da extends Ta {
          getDefault() {
            return false;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            const t2 = this.gl;
            e2 ? t2.enable(t2.STENCIL_TEST) : t2.disable(t2.STENCIL_TEST), this.current = e2, this.dirty = false;
          }
        }
        class Aa extends Ta {
          getDefault() {
            return [0, 1];
          }
          set(e2) {
            const t2 = this.current;
            (e2[0] !== t2[0] || e2[1] !== t2[1] || this.dirty) && (this.gl.depthRange(e2[0], e2[1]), this.current = e2, this.dirty = false);
          }
        }
        class La extends Ta {
          getDefault() {
            return false;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            const t2 = this.gl;
            e2 ? t2.enable(t2.DEPTH_TEST) : t2.disable(t2.DEPTH_TEST), this.current = e2, this.dirty = false;
          }
        }
        class ka extends Ta {
          getDefault() {
            return this.gl.LESS;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.depthFunc(e2), this.current = e2, this.dirty = false);
          }
        }
        class Fa extends Ta {
          getDefault() {
            return false;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            const t2 = this.gl;
            e2 ? t2.enable(t2.BLEND) : t2.disable(t2.BLEND), this.current = e2, this.dirty = false;
          }
        }
        class Ba extends Ta {
          getDefault() {
            const e2 = this.gl;
            return [e2.ONE, e2.ZERO];
          }
          set(e2) {
            const t2 = this.current;
            (e2[0] !== t2[0] || e2[1] !== t2[1] || this.dirty) && (this.gl.blendFunc(e2[0], e2[1]), this.current = e2, this.dirty = false);
          }
        }
        class Oa extends Ta {
          getDefault() {
            return t.bq.transparent;
          }
          set(e2) {
            const t2 = this.current;
            (e2.r !== t2.r || e2.g !== t2.g || e2.b !== t2.b || e2.a !== t2.a || this.dirty) && (this.gl.blendColor(e2.r, e2.g, e2.b, e2.a), this.current = e2, this.dirty = false);
          }
        }
        class ja extends Ta {
          getDefault() {
            return this.gl.FUNC_ADD;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.blendEquation(e2), this.current = e2, this.dirty = false);
          }
        }
        class Na extends Ta {
          getDefault() {
            return false;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            const t2 = this.gl;
            e2 ? t2.enable(t2.CULL_FACE) : t2.disable(t2.CULL_FACE), this.current = e2, this.dirty = false;
          }
        }
        class Za extends Ta {
          getDefault() {
            return this.gl.BACK;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.cullFace(e2), this.current = e2, this.dirty = false);
          }
        }
        class Ga extends Ta {
          getDefault() {
            return this.gl.CCW;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.frontFace(e2), this.current = e2, this.dirty = false);
          }
        }
        class Ua extends Ta {
          getDefault() {
            return null;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.useProgram(e2), this.current = e2, this.dirty = false);
          }
        }
        class Va extends Ta {
          getDefault() {
            return this.gl.TEXTURE0;
          }
          set(e2) {
            (e2 !== this.current || this.dirty) && (this.gl.activeTexture(e2), this.current = e2, this.dirty = false);
          }
        }
        class qa extends Ta {
          getDefault() {
            const e2 = this.gl;
            return [0, 0, e2.drawingBufferWidth, e2.drawingBufferHeight];
          }
          set(e2) {
            const t2 = this.current;
            (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || e2[3] !== t2[3] || this.dirty) && (this.gl.viewport(e2[0], e2[1], e2[2], e2[3]), this.current = e2, this.dirty = false);
          }
        }
        class Wa extends Ta {
          getDefault() {
            return null;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            const t2 = this.gl;
            t2.bindFramebuffer(t2.FRAMEBUFFER, e2), this.current = e2, this.dirty = false;
          }
        }
        class $a extends Ta {
          getDefault() {
            return null;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            const t2 = this.gl;
            t2.bindRenderbuffer(t2.RENDERBUFFER, e2), this.current = e2, this.dirty = false;
          }
        }
        class Ha extends Ta {
          getDefault() {
            return null;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            const t2 = this.gl;
            t2.bindTexture(t2.TEXTURE_2D, e2), this.current = e2, this.dirty = false;
          }
        }
        class Xa extends Ta {
          getDefault() {
            return null;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            const t2 = this.gl;
            t2.bindBuffer(t2.ARRAY_BUFFER, e2), this.current = e2, this.dirty = false;
          }
        }
        class Ka extends Ta {
          getDefault() {
            return null;
          }
          set(e2) {
            const t2 = this.gl;
            t2.bindBuffer(t2.ELEMENT_ARRAY_BUFFER, e2), this.current = e2, this.dirty = false;
          }
        }
        class Ya extends Ta {
          getDefault() {
            return null;
          }
          set(e2) {
            var t2;
            if (e2 === this.current && !this.dirty) return;
            const i2 = this.gl;
            oi(i2) ? i2.bindVertexArray(e2) : null === (t2 = i2.getExtension("OES_vertex_array_object")) || void 0 === t2 || t2.bindVertexArrayOES(e2), this.current = e2, this.dirty = false;
          }
        }
        class Qa extends Ta {
          getDefault() {
            return 4;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            const t2 = this.gl;
            t2.pixelStorei(t2.UNPACK_ALIGNMENT, e2), this.current = e2, this.dirty = false;
          }
        }
        class Ja extends Ta {
          getDefault() {
            return false;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            const t2 = this.gl;
            t2.pixelStorei(t2.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e2), this.current = e2, this.dirty = false;
          }
        }
        class er extends Ta {
          getDefault() {
            return false;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            const t2 = this.gl;
            t2.pixelStorei(t2.UNPACK_FLIP_Y_WEBGL, e2), this.current = e2, this.dirty = false;
          }
        }
        class tr extends Ta {
          constructor(e2, t2) {
            super(e2), this.context = e2, this.parent = t2;
          }
          getDefault() {
            return null;
          }
        }
        class ir extends tr {
          setDirty() {
            this.dirty = true;
          }
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            this.context.bindFramebuffer.set(this.parent);
            const t2 = this.gl;
            t2.framebufferTexture2D(t2.FRAMEBUFFER, t2.COLOR_ATTACHMENT0, t2.TEXTURE_2D, e2, 0), this.current = e2, this.dirty = false;
          }
        }
        class ar extends tr {
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            this.context.bindFramebuffer.set(this.parent);
            const t2 = this.gl;
            t2.framebufferRenderbuffer(t2.FRAMEBUFFER, t2.DEPTH_ATTACHMENT, t2.RENDERBUFFER, e2), this.current = e2, this.dirty = false;
          }
        }
        class rr extends tr {
          set(e2) {
            if (e2 === this.current && !this.dirty) return;
            this.context.bindFramebuffer.set(this.parent);
            const t2 = this.gl;
            t2.framebufferRenderbuffer(t2.FRAMEBUFFER, t2.DEPTH_STENCIL_ATTACHMENT, t2.RENDERBUFFER, e2), this.current = e2, this.dirty = false;
          }
        }
        const or = "Framebuffer is not complete";
        class sr {
          constructor(e2, t2, i2, a2, r2) {
            this.context = e2, this.width = t2, this.height = i2;
            const o2 = e2.gl, s2 = this.framebuffer = o2.createFramebuffer();
            if (this.colorAttachment = new ir(e2, s2), a2) this.depthAttachment = r2 ? new rr(e2, s2) : new ar(e2, s2);
            else if (r2) throw new Error("Stencil cannot be set without depth");
            if (o2.checkFramebufferStatus(o2.FRAMEBUFFER) !== o2.FRAMEBUFFER_COMPLETE) throw new Error(or);
          }
          destroy() {
            const e2 = this.context.gl, t2 = this.colorAttachment.get();
            if (t2 && e2.deleteTexture(t2), this.depthAttachment) {
              const t3 = this.depthAttachment.get();
              t3 && e2.deleteRenderbuffer(t3);
            }
            e2.deleteFramebuffer(this.framebuffer);
          }
        }
        class nr {
          constructor(e2) {
            var t2, i2;
            if (this.gl = e2, this.clearColor = new Pa(this), this.clearDepth = new Ia(this), this.clearStencil = new Ca(this), this.colorMask = new Ma(this), this.depthMask = new Ea(this), this.stencilMask = new Sa(this), this.stencilFunc = new Ra(this), this.stencilOp = new za(this), this.stencilTest = new Da(this), this.depthRange = new Aa(this), this.depthTest = new La(this), this.depthFunc = new ka(this), this.blend = new Fa(this), this.blendFunc = new Ba(this), this.blendColor = new Oa(this), this.blendEquation = new ja(this), this.cullFace = new Na(this), this.cullFaceSide = new Za(this), this.frontFace = new Ga(this), this.program = new Ua(this), this.activeTexture = new Va(this), this.viewport = new qa(this), this.bindFramebuffer = new Wa(this), this.bindRenderbuffer = new $a(this), this.bindTexture = new Ha(this), this.bindVertexBuffer = new Xa(this), this.bindElementBuffer = new Ka(this), this.bindVertexArray = new Ya(this), this.pixelStoreUnpack = new Qa(this), this.pixelStoreUnpackPremultiplyAlpha = new Ja(this), this.pixelStoreUnpackFlipY = new er(this), this.extTextureFilterAnisotropic = e2.getExtension("EXT_texture_filter_anisotropic") || e2.getExtension("MOZ_EXT_texture_filter_anisotropic") || e2.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e2.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = e2.getParameter(e2.MAX_TEXTURE_SIZE), oi(e2)) {
              this.HALF_FLOAT = e2.HALF_FLOAT;
              const a2 = e2.getExtension("EXT_color_buffer_half_float");
              this.RGBA16F = null !== (t2 = e2.RGBA16F) && void 0 !== t2 ? t2 : null == a2 ? void 0 : a2.RGBA16F_EXT, this.RGB16F = null !== (i2 = e2.RGB16F) && void 0 !== i2 ? i2 : null == a2 ? void 0 : a2.RGB16F_EXT, e2.getExtension("EXT_color_buffer_float");
            } else {
              e2.getExtension("EXT_color_buffer_half_float"), e2.getExtension("OES_texture_half_float_linear");
              const t3 = e2.getExtension("OES_texture_half_float");
              this.HALF_FLOAT = null == t3 ? void 0 : t3.HALF_FLOAT_OES;
            }
          }
          setDefault() {
            this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
          }
          setDirty() {
            this.clearColor.dirty = true, this.clearDepth.dirty = true, this.clearStencil.dirty = true, this.colorMask.dirty = true, this.depthMask.dirty = true, this.stencilMask.dirty = true, this.stencilFunc.dirty = true, this.stencilOp.dirty = true, this.stencilTest.dirty = true, this.depthRange.dirty = true, this.depthTest.dirty = true, this.depthFunc.dirty = true, this.blend.dirty = true, this.blendFunc.dirty = true, this.blendColor.dirty = true, this.blendEquation.dirty = true, this.cullFace.dirty = true, this.cullFaceSide.dirty = true, this.frontFace.dirty = true, this.program.dirty = true, this.activeTexture.dirty = true, this.viewport.dirty = true, this.bindFramebuffer.dirty = true, this.bindRenderbuffer.dirty = true, this.bindTexture.dirty = true, this.bindVertexBuffer.dirty = true, this.bindElementBuffer.dirty = true, this.bindVertexArray.dirty = true, this.pixelStoreUnpack.dirty = true, this.pixelStoreUnpackPremultiplyAlpha.dirty = true, this.pixelStoreUnpackFlipY.dirty = true;
          }
          createIndexBuffer(e2, t2) {
            return new ba(this, e2, t2);
          }
          createVertexBuffer(e2, t2, i2) {
            return new wa(this, e2, t2, i2);
          }
          createRenderbuffer(e2, t2, i2) {
            const a2 = this.gl, r2 = a2.createRenderbuffer();
            return this.bindRenderbuffer.set(r2), a2.renderbufferStorage(a2.RENDERBUFFER, e2, t2, i2), this.bindRenderbuffer.set(null), r2;
          }
          createFramebuffer(e2, t2, i2, a2) {
            return new sr(this, e2, t2, i2, a2);
          }
          clear({ color: e2, depth: t2, stencil: i2 }) {
            const a2 = this.gl;
            let r2 = 0;
            e2 && (r2 |= a2.COLOR_BUFFER_BIT, this.clearColor.set(e2), this.colorMask.set([true, true, true, true])), void 0 !== t2 && (r2 |= a2.DEPTH_BUFFER_BIT, this.depthRange.set([0, 1]), this.clearDepth.set(t2), this.depthMask.set(true)), void 0 !== i2 && (r2 |= a2.STENCIL_BUFFER_BIT, this.clearStencil.set(i2), this.stencilMask.set(255)), a2.clear(r2);
          }
          setCullFace(e2) {
            false === e2.enable ? this.cullFace.set(false) : (this.cullFace.set(true), this.cullFaceSide.set(e2.mode), this.frontFace.set(e2.frontFace));
          }
          setDepthMode(e2) {
            e2.func !== this.gl.ALWAYS || e2.mask ? (this.depthTest.set(true), this.depthFunc.set(e2.func), this.depthMask.set(e2.mask), this.depthRange.set(e2.range)) : this.depthTest.set(false);
          }
          setStencilMode(e2) {
            e2.test.func !== this.gl.ALWAYS || e2.mask ? (this.stencilTest.set(true), this.stencilMask.set(e2.mask), this.stencilOp.set([e2.fail, e2.depthFail, e2.pass]), this.stencilFunc.set({ func: e2.test.func, ref: e2.ref, mask: e2.test.mask })) : this.stencilTest.set(false);
          }
          setColorMode(e2) {
            t.bS(e2.blendFunction, Qt.Replace) ? this.blend.set(false) : (this.blend.set(true), this.blendFunc.set(e2.blendFunction), this.blendColor.set(e2.blendColor)), this.colorMask.set(e2.mask);
          }
          createVertexArray() {
            var e2;
            return oi(this.gl) ? this.gl.createVertexArray() : null === (e2 = this.gl.getExtension("OES_vertex_array_object")) || void 0 === e2 ? void 0 : e2.createVertexArrayOES();
          }
          deleteVertexArray(e2) {
            var t2;
            return oi(this.gl) ? this.gl.deleteVertexArray(e2) : null === (t2 = this.gl.getExtension("OES_vertex_array_object")) || void 0 === t2 ? void 0 : t2.deleteVertexArrayOES(e2);
          }
          unbindVAO() {
            this.bindVertexArray.set(null);
          }
        }
        let lr;
        function cr(e2, i2, a2, r2, o2) {
          const s2 = e2.context, n2 = e2.transform, l2 = s2.gl, c2 = e2.useProgram("collisionBox"), h2 = [];
          let u2 = 0, d2 = 0;
          for (let t2 = 0; t2 < r2.length; t2++) {
            const _3 = r2[t2], p3 = i2.getTile(_3).getBucket(a2);
            if (!p3) continue;
            const m3 = o2 ? p3.textCollisionBox : p3.iconCollisionBox, f3 = p3.collisionCircleArray;
            f3.length > 0 && (h2.push({ circleArray: f3, circleOffset: d2, coord: _3 }), u2 += f3.length / 4, d2 = u2), m3 && c2.draw(s2, l2.LINES, ti.disabled, ai.disabled, e2.colorModeForRenderPass(), ei.disabled, Xi(e2.transform), e2.style.map.terrain && e2.style.map.terrain.getTerrainData(_3), n2.getProjectionData({ overscaledTileID: _3, applyGlobeMatrix: true, applyTerrainMatrix: true }), a2.id, m3.layoutVertexBuffer, m3.indexBuffer, m3.segments, null, e2.transform.zoom, null, null, m3.collisionVertexBuffer);
          }
          if (!o2 || !h2.length) return;
          const _2 = e2.useProgram("collisionCircle"), p2 = new t.cb();
          p2.resize(4 * u2), p2._trim();
          let m2 = 0;
          for (const e3 of h2) for (let t2 = 0; t2 < e3.circleArray.length / 4; t2++) {
            const i3 = 4 * t2, a3 = e3.circleArray[i3 + 0], r3 = e3.circleArray[i3 + 1], o3 = e3.circleArray[i3 + 2], s3 = e3.circleArray[i3 + 3];
            p2.emplace(m2++, a3, r3, o3, s3, 0), p2.emplace(m2++, a3, r3, o3, s3, 1), p2.emplace(m2++, a3, r3, o3, s3, 2), p2.emplace(m2++, a3, r3, o3, s3, 3);
          }
          (!lr || lr.length < 2 * u2) && (lr = function(e3) {
            const i3 = 2 * e3, a3 = new t.cd();
            a3.resize(i3), a3._trim();
            for (let e4 = 0; e4 < i3; e4++) {
              const t2 = 6 * e4;
              a3.uint16[t2 + 0] = 4 * e4 + 0, a3.uint16[t2 + 1] = 4 * e4 + 1, a3.uint16[t2 + 2] = 4 * e4 + 2, a3.uint16[t2 + 3] = 4 * e4 + 2, a3.uint16[t2 + 4] = 4 * e4 + 3, a3.uint16[t2 + 5] = 4 * e4 + 0;
            }
            return a3;
          }(u2));
          const f2 = s2.createIndexBuffer(lr, true), g2 = s2.createVertexBuffer(p2, t.cc.members, true);
          for (const i3 of h2) {
            const r3 = Ki(e2.transform);
            _2.draw(s2, l2.TRIANGLES, ti.disabled, ai.disabled, e2.colorModeForRenderPass(), ei.disabled, r3, e2.style.map.terrain && e2.style.map.terrain.getTerrainData(i3.coord), null, a2.id, g2, f2, t.aY.simpleSegment(0, 2 * i3.circleOffset, i3.circleArray.length, i3.circleArray.length / 2), null, e2.transform.zoom, null, null, null);
          }
          g2.destroy(), f2.destroy();
        }
        const hr = t.as(new Float32Array(16));
        function ur(e2, i2, a2, r2, o2, s2) {
          const { horizontalAlign: n2, verticalAlign: l2 } = t.aT(e2);
          return new t.P((-(n2 - 0.5) * i2 / o2 + r2[0]) * s2, (-(l2 - 0.5) * a2 / o2 + r2[1]) * s2);
        }
        function dr(e2, i2, a2, r2, o2, s2) {
          const n2 = i2.tileAnchorPoint.add(new t.P(i2.translation[0], i2.translation[1]));
          if (i2.pitchWithMap) {
            let e3 = r2.mult(s2);
            a2 || (e3 = e3.rotate(-o2));
            const t2 = n2.add(e3);
            return Ge(t2.x, t2.y, i2.pitchedLabelPlaneMatrix, i2.getElevation).point;
          }
          if (a2) {
            const t2 = Ye(i2.tileAnchorPoint.x + 1, i2.tileAnchorPoint.y, i2).point.sub(e2), a3 = Math.atan(t2.y / t2.x) + (t2.x < 0 ? Math.PI : 0);
            return e2.add(r2.rotate(a3));
          }
          return e2.add(r2);
        }
        function _r(e2, i2, a2, r2, o2, s2, n2, l2, c2, h2, u2, d2) {
          const _2 = e2.text.placedSymbolArray, p2 = e2.text.dynamicLayoutVertexArray, m2 = e2.icon.dynamicLayoutVertexArray, f2 = {};
          p2.clear();
          for (let m3 = 0; m3 < _2.length; m3++) {
            const g2 = _2.get(m3), v2 = g2.hidden || !g2.crossTileID || e2.allowVerticalPlacement && !g2.placedOrientation ? null : r2[g2.crossTileID];
            if (v2) {
              const r3 = new t.P(g2.anchorX, g2.anchorY), _3 = { getElevation: d2, width: o2.width, height: o2.height, pitchedLabelPlaneMatrix: s2, pitchWithMap: a2, transform: o2, tileAnchorPoint: r3, translation: h2, unwrappedTileID: u2 }, m4 = a2 ? Je(r3.x, r3.y, _3) : Ye(r3.x, r3.y, _3), x2 = Ue(o2.cameraToCenterDistance, m4.signedDistanceFromCamera);
              let b2 = t.aB(e2.textSizeData, l2, g2) * x2 / t.aN;
              a2 && (b2 *= e2.tilePixelRatio / n2);
              const { width: y2, height: w2, anchor: T2, textOffset: P2, textBoxScale: I2 } = v2, C2 = ur(T2, y2, w2, P2, I2, b2), M2 = o2.getPitchedTextCorrection(r3.x + h2[0], r3.y + h2[1], u2), E2 = dr(m4.point, _3, i2, C2, -o2.bearingInRadians, M2), S2 = e2.allowVerticalPlacement && g2.placedOrientation === t.aA.vertical ? Math.PI / 2 : 0;
              for (let e3 = 0; e3 < g2.numGlyphs; e3++) t.aH(p2, E2, S2);
              c2 && g2.associatedIconIndex >= 0 && (f2[g2.associatedIconIndex] = { shiftedAnchor: E2, angle: S2 });
            } else rt(g2.numGlyphs, p2);
          }
          if (c2) {
            m2.clear();
            const i3 = e2.icon.placedSymbolArray;
            for (let e3 = 0; e3 < i3.length; e3++) {
              const a3 = i3.get(e3);
              if (a3.hidden) rt(a3.numGlyphs, m2);
              else {
                const i4 = f2[e3];
                if (i4) for (let e4 = 0; e4 < a3.numGlyphs; e4++) t.aH(m2, i4.shiftedAnchor, i4.angle);
                else rt(a3.numGlyphs, m2);
              }
            }
            e2.icon.dynamicLayoutVertexBuffer.updateData(m2);
          }
          e2.text.dynamicLayoutVertexBuffer.updateData(p2);
        }
        function pr(e2, t2, i2) {
          return i2.iconsInText && t2 ? "symbolTextAndIcon" : e2 ? "symbolSDF" : "symbolIcon";
        }
        function mr(e2, i2, a2, r2, o2, s2, n2, l2, c2, h2, u2, d2, _2) {
          const p2 = e2.context, m2 = p2.gl, f2 = e2.transform, g2 = "map" === l2, v2 = "map" === c2, x2 = "viewport" !== l2 && "point" !== a2.layout.get("symbol-placement"), b2 = g2 && !v2 && !x2, y2 = !a2.layout.get("symbol-sort-key").isConstant();
          let w2 = false;
          const T2 = e2.getDepthModeForSublayer(0, ti.ReadOnly), P2 = a2._unevaluatedLayout.hasValue("text-variable-anchor") || a2._unevaluatedLayout.hasValue("text-variable-anchor-offset"), I2 = [], C2 = f2.getCircleRadiusCorrection();
          for (const l3 of r2) {
            const r3 = i2.getTile(l3), c3 = r3.getBucket(a2);
            if (!c3) continue;
            const u3 = o2 ? c3.text : c3.icon;
            if (!u3 || !u3.segments.get().length || !u3.hasVisibleVertices) continue;
            const d3 = u3.programConfigurations.get(a2.id), p3 = o2 || c3.sdfIcons, T3 = o2 ? c3.textSizeData : c3.iconSizeData, M2 = v2 || 0 !== f2.pitch, E2 = e2.useProgram(pr(p3, o2, c3), d3), S2 = t.az(T3, f2.zoom), R2 = e2.style.map.terrain && e2.style.map.terrain.getTerrainData(l3);
            let z2, D2, A2, L3, k2 = [0, 0], F2 = null;
            if (o2) D2 = r3.glyphAtlasTexture, A2 = m2.LINEAR, z2 = r3.glyphAtlasTexture.size, c3.iconsInText && (k2 = r3.imageAtlasTexture.size, F2 = r3.imageAtlasTexture, L3 = M2 || e2.options.rotating || e2.options.zooming || "composite" === T3.kind || "camera" === T3.kind ? m2.LINEAR : m2.NEAREST);
            else {
              const t2 = 1 !== a2.layout.get("icon-size").constantOr(0) || c3.iconsNeedLinear;
              D2 = r3.imageAtlasTexture, A2 = p3 || e2.options.rotating || e2.options.zooming || t2 || M2 ? m2.LINEAR : m2.NEAREST, z2 = r3.imageAtlasTexture.size;
            }
            const B2 = t.aO(r3, 1, e2.transform.zoom), O2 = je(g2, e2.transform, B2), j2 = t.N();
            t.aC(j2, O2);
            const N2 = Ne(v2, g2, e2.transform, B2), Z2 = t.aP(f2, r3, s2, n2), G2 = f2.getProjectionData({ overscaledTileID: l3, applyGlobeMatrix: !_2, applyTerrainMatrix: true }), U2 = P2 && c3.hasTextData(), V2 = "none" !== a2.layout.get("icon-text-fit") && U2 && c3.hasIconData();
            if (x2) {
              const t2 = e2.style.map.terrain ? (t3, i4) => e2.style.map.terrain.getElevation(l3, t3, i4) : null, i3 = "map" === a2.layout.get("text-rotation-alignment");
              qe(c3, e2, o2, O2, j2, v2, h2, i3, l3.toUnwrapped(), f2.width, f2.height, Z2, t2);
            }
            const q2 = o2 && P2 || V2, W2 = x2 || q2 ? hr : v2 ? O2 : e2.transform.clipSpaceToPixelsMatrix, $2 = p3 && 0 !== a2.paint.get(o2 ? "text-halo-width" : "icon-halo-width").constantOr(1);
            let H2;
            H2 = p3 ? c3.iconsInText ? ma(T3.kind, S2, b2, v2, x2, q2, e2, W2, N2, Z2, z2, k2, C2) : pa(T3.kind, S2, b2, v2, x2, q2, e2, W2, N2, Z2, o2, z2, 0, C2) : _a(T3.kind, S2, b2, v2, x2, q2, e2, W2, N2, Z2, o2, z2, C2);
            const X2 = { program: E2, buffers: u3, uniformValues: H2, projectionData: G2, atlasTexture: D2, atlasTextureIcon: F2, atlasInterpolation: A2, atlasInterpolationIcon: L3, isSDF: p3, hasHalo: $2 };
            if (y2 && c3.canOverlap) {
              w2 = true;
              const e3 = u3.segments.get();
              for (const i3 of e3) I2.push({ segments: new t.aY([i3]), sortKey: i3.sortKey, state: X2, terrainData: R2 });
            } else I2.push({ segments: u3.segments, sortKey: 0, state: X2, terrainData: R2 });
          }
          w2 && I2.sort((e3, t2) => e3.sortKey - t2.sortKey);
          for (const t2 of I2) {
            const i3 = t2.state;
            if (p2.activeTexture.set(m2.TEXTURE0), i3.atlasTexture.bind(i3.atlasInterpolation, m2.CLAMP_TO_EDGE), i3.atlasTextureIcon && (p2.activeTexture.set(m2.TEXTURE1), i3.atlasTextureIcon && i3.atlasTextureIcon.bind(i3.atlasInterpolationIcon, m2.CLAMP_TO_EDGE)), i3.isSDF) {
              const r3 = i3.uniformValues;
              i3.hasHalo && (r3.u_is_halo = 1, fr(i3.buffers, t2.segments, a2, e2, i3.program, T2, u2, d2, r3, i3.projectionData, t2.terrainData)), r3.u_is_halo = 0;
            }
            fr(i3.buffers, t2.segments, a2, e2, i3.program, T2, u2, d2, i3.uniformValues, i3.projectionData, t2.terrainData);
          }
        }
        function fr(e2, t2, i2, a2, r2, o2, s2, n2, l2, c2, h2) {
          const u2 = a2.context;
          r2.draw(u2, u2.gl.TRIANGLES, o2, s2, n2, ei.backCCW, l2, h2, c2, i2.id, e2.layoutVertexBuffer, e2.indexBuffer, t2, i2.paint, a2.transform.zoom, e2.programConfigurations.get(i2.id), e2.dynamicLayoutVertexBuffer, e2.opacityVertexBuffer);
        }
        function gr(e2, i2, a2, r2, o2) {
          const s2 = e2.context, n2 = s2.gl, l2 = ai.disabled, c2 = new Qt([n2.ONE, n2.ONE], t.bq.transparent, [true, true, true, true]), h2 = i2.getBucket(a2);
          if (!h2) return;
          const u2 = r2.key;
          let d2 = a2.heatmapFbos.get(u2);
          d2 || (d2 = xr(s2, i2.tileSize, i2.tileSize), a2.heatmapFbos.set(u2, d2)), s2.bindFramebuffer.set(d2.framebuffer), s2.viewport.set([0, 0, i2.tileSize, i2.tileSize]), s2.clear({ color: t.bq.transparent });
          const _2 = h2.programConfigurations.get(a2.id), p2 = e2.useProgram("heatmap", _2, !o2), m2 = e2.transform.getProjectionData({ overscaledTileID: i2.tileID, applyGlobeMatrix: true, applyTerrainMatrix: true }), f2 = e2.style.map.terrain.getTerrainData(r2);
          p2.draw(s2, n2.TRIANGLES, ti.disabled, l2, c2, ei.disabled, Qi(i2, e2.transform.zoom, a2.paint.get("heatmap-intensity"), 1), f2, m2, a2.id, h2.layoutVertexBuffer, h2.indexBuffer, h2.segments, a2.paint, e2.transform.zoom, _2);
        }
        function vr(e2, t2, i2, a2, r2) {
          const o2 = e2.context, s2 = o2.gl, n2 = e2.transform;
          o2.setColorMode(e2.colorModeForRenderPass());
          const l2 = br(o2, t2), c2 = i2.key, h2 = t2.heatmapFbos.get(c2);
          if (!h2) return;
          o2.activeTexture.set(s2.TEXTURE0), s2.bindTexture(s2.TEXTURE_2D, h2.colorAttachment.get()), o2.activeTexture.set(s2.TEXTURE1), l2.bind(s2.LINEAR, s2.CLAMP_TO_EDGE);
          const u2 = n2.getProjectionData({ overscaledTileID: i2, applyTerrainMatrix: r2, applyGlobeMatrix: !a2 });
          e2.useProgram("heatmapTexture").draw(o2, s2.TRIANGLES, ti.disabled, ai.disabled, e2.colorModeForRenderPass(), ei.disabled, Ji(e2, t2, 0, 1), null, u2, t2.id, e2.rasterBoundsBuffer, e2.quadTriangleIndexBuffer, e2.rasterBoundsSegments, t2.paint, n2.zoom), h2.destroy(), t2.heatmapFbos.delete(c2);
        }
        function xr(e2, t2, i2) {
          var a2, r2;
          const o2 = e2.gl, s2 = o2.createTexture();
          o2.bindTexture(o2.TEXTURE_2D, s2), o2.texParameteri(o2.TEXTURE_2D, o2.TEXTURE_WRAP_S, o2.CLAMP_TO_EDGE), o2.texParameteri(o2.TEXTURE_2D, o2.TEXTURE_WRAP_T, o2.CLAMP_TO_EDGE), o2.texParameteri(o2.TEXTURE_2D, o2.TEXTURE_MIN_FILTER, o2.LINEAR), o2.texParameteri(o2.TEXTURE_2D, o2.TEXTURE_MAG_FILTER, o2.LINEAR);
          const n2 = null !== (a2 = e2.HALF_FLOAT) && void 0 !== a2 ? a2 : o2.UNSIGNED_BYTE, l2 = null !== (r2 = e2.RGBA16F) && void 0 !== r2 ? r2 : o2.RGBA;
          o2.texImage2D(o2.TEXTURE_2D, 0, l2, t2, i2, 0, o2.RGBA, n2, null);
          const c2 = e2.createFramebuffer(t2, i2, false, false);
          return c2.colorAttachment.set(s2), c2;
        }
        function br(e2, i2) {
          return i2.colorRampTexture || (i2.colorRampTexture = new t.T(e2, i2.colorRamp, e2.gl.RGBA)), i2.colorRampTexture;
        }
        function yr(e2, i2, a2, r2, o2, s2, n2, l2) {
          let c2 = 256;
          if (o2.stepInterpolant) {
            const r3 = i2.getSource().maxzoom, o3 = n2.canonical.z === r3 ? Math.ceil(1 << e2.transform.maxZoom - n2.canonical.z) : 1;
            c2 = t.ao(t.cf(s2.maxLineLength / t.a5 * 1024 * o3), 256, a2.maxTextureSize);
          }
          return l2.gradient = t.cg({ expression: o2.gradientExpression(), evaluationKey: "lineProgress", resolution: c2, image: l2.gradient || void 0, clips: s2.lineClipsArray }), l2.texture ? l2.texture.update(l2.gradient) : l2.texture = new t.T(a2, l2.gradient, r2.RGBA), l2.version = o2.gradientVersion, l2.texture;
        }
        function wr(e2, t2, i2, a2, r2) {
          e2.activeTexture.set(t2.TEXTURE0), i2.imageAtlasTexture.bind(t2.LINEAR, t2.CLAMP_TO_EDGE), a2.updatePaintBuffers(r2);
        }
        function Tr(e2, t2, i2, a2, r2, o2) {
          (r2 || e2.lineAtlas.dirty) && (t2.activeTexture.set(i2.TEXTURE0), e2.lineAtlas.bind(t2)), a2.updatePaintBuffers(o2);
        }
        function Pr(e2, t2, i2, a2, r2, o2, s2) {
          const n2 = o2.gradients[r2.id];
          let l2 = n2.texture;
          r2.gradientVersion !== n2.version && (l2 = yr(e2, t2, i2, a2, r2, o2, s2, n2)), i2.activeTexture.set(a2.TEXTURE0), l2.bind(r2.stepInterpolant ? a2.NEAREST : a2.LINEAR, a2.CLAMP_TO_EDGE);
        }
        function Ir(e2, t2, i2, a2, r2, o2, s2, n2, l2) {
          const c2 = o2.gradients[r2.id];
          let h2 = c2.texture;
          r2.gradientVersion !== c2.version && (h2 = yr(e2, t2, i2, a2, r2, o2, s2, c2)), i2.activeTexture.set(a2.TEXTURE0), h2.bind(r2.stepInterpolant ? a2.NEAREST : a2.LINEAR, a2.CLAMP_TO_EDGE), i2.activeTexture.set(a2.TEXTURE1), e2.lineAtlas.bind(i2), n2.updatePaintBuffers(l2);
        }
        function Cr(e2, t2, i2, a2, r2) {
          if (!i2 || !a2 || !a2.imageAtlas) return;
          const o2 = a2.imageAtlas.patternPositions;
          let s2 = o2[i2.to.toString()], n2 = o2[i2.from.toString()];
          if (!s2 && n2 && (s2 = n2), !n2 && s2 && (n2 = s2), !s2 || !n2) {
            const e3 = r2.getPaintProperty(t2);
            s2 = o2[e3], n2 = o2[e3];
          }
          s2 && n2 && e2.setConstantPatternPositions(s2, n2);
        }
        function Mr(e2, i2, a2, r2, o2, s2, n2, l2) {
          const c2 = e2.context.gl, h2 = "fill-pattern", u2 = a2.paint.get(h2), d2 = u2 && u2.constantOr(1), _2 = a2.getCrossfadeParameters();
          let p2, m2, f2, g2, v2;
          const x2 = e2.transform, b2 = a2.paint.get("fill-translate"), y2 = a2.paint.get("fill-translate-anchor");
          n2 ? (m2 = d2 && !a2.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", p2 = c2.LINES) : (m2 = d2 ? "fillPattern" : "fill", p2 = c2.TRIANGLES);
          const w2 = u2.constantOr(null);
          for (const u3 of r2) {
            const r3 = i2.getTile(u3);
            if (d2 && !r3.patternsLoaded()) continue;
            const T2 = r3.getBucket(a2);
            if (!T2) continue;
            const P2 = T2.programConfigurations.get(a2.id), I2 = e2.useProgram(m2, P2), C2 = e2.style.map.terrain && e2.style.map.terrain.getTerrainData(u3);
            d2 && (e2.context.activeTexture.set(c2.TEXTURE0), r3.imageAtlasTexture.bind(c2.LINEAR, c2.CLAMP_TO_EDGE), P2.updatePaintBuffers(_2)), Cr(P2, h2, w2, r3, a2);
            const M2 = x2.getProjectionData({ overscaledTileID: u3, applyGlobeMatrix: !l2, applyTerrainMatrix: true }), E2 = t.aP(x2, r3, b2, y2);
            if (n2) {
              g2 = T2.indexBuffer2, v2 = T2.segments2;
              const t2 = [c2.drawingBufferWidth, c2.drawingBufferHeight];
              f2 = "fillOutlinePattern" === m2 && d2 ? $i(e2, _2, r3, t2, E2) : Wi(t2, E2);
            } else g2 = T2.indexBuffer, v2 = T2.segments, f2 = d2 ? qi(e2, _2, r3, E2) : { u_fill_translate: E2 };
            const S2 = e2.stencilModeForClipping(u3);
            I2.draw(e2.context, p2, o2, S2, s2, ei.backCCW, f2, C2, M2, a2.id, T2.layoutVertexBuffer, g2, v2, a2.paint, e2.transform.zoom, P2);
          }
        }
        function Er(e2, i2, a2, r2, o2, s2, n2, l2) {
          const c2 = e2.context, h2 = c2.gl, u2 = "fill-extrusion-pattern", d2 = a2.paint.get(u2), _2 = d2.constantOr(1), p2 = a2.getCrossfadeParameters(), m2 = a2.paint.get("fill-extrusion-opacity"), f2 = d2.constantOr(null), g2 = e2.transform;
          for (const d3 of r2) {
            const r3 = i2.getTile(d3), v2 = r3.getBucket(a2);
            if (!v2) continue;
            const x2 = e2.style.map.terrain && e2.style.map.terrain.getTerrainData(d3), b2 = v2.programConfigurations.get(a2.id), y2 = e2.useProgram(_2 ? "fillExtrusionPattern" : "fillExtrusion", b2);
            _2 && (e2.context.activeTexture.set(h2.TEXTURE0), r3.imageAtlasTexture.bind(h2.LINEAR, h2.CLAMP_TO_EDGE), b2.updatePaintBuffers(p2));
            const w2 = g2.getProjectionData({ overscaledTileID: d3, applyGlobeMatrix: !l2, applyTerrainMatrix: true });
            Cr(b2, u2, f2, r3, a2);
            const T2 = t.aP(g2, r3, a2.paint.get("fill-extrusion-translate"), a2.paint.get("fill-extrusion-translate-anchor")), P2 = a2.paint.get("fill-extrusion-vertical-gradient"), I2 = _2 ? Vi(e2, P2, m2, T2, d3, p2, r3) : Ui(e2, P2, m2, T2);
            y2.draw(c2, c2.gl.TRIANGLES, o2, s2, n2, ei.backCCW, I2, x2, w2, a2.id, v2.layoutVertexBuffer, v2.indexBuffer, v2.segments, a2.paint, e2.transform.zoom, b2, e2.style.map.terrain && v2.centroidVertexBuffer);
          }
        }
        function Sr(e2, t2, i2, a2, r2, o2, s2, n2, l2) {
          var c2;
          const h2 = e2.style.projection, u2 = e2.context, d2 = e2.transform, _2 = u2.gl, p2 = [`#define NUM_ILLUMINATION_SOURCES ${i2.paint.get("hillshade-highlight-color").values.length}`], m2 = e2.useProgram("hillshade", null, false, p2), f2 = !e2.options.moving;
          for (const p3 of a2) {
            const a3 = t2.getTile(p3), g2 = a3.fbo;
            if (!g2) continue;
            const v2 = h2.getMeshFromTileID(u2, p3.canonical, n2, true, "raster"), x2 = null === (c2 = e2.style.map.terrain) || void 0 === c2 ? void 0 : c2.getTerrainData(p3);
            u2.activeTexture.set(_2.TEXTURE0), _2.bindTexture(_2.TEXTURE_2D, g2.colorAttachment.get());
            const b2 = d2.getProjectionData({ overscaledTileID: p3, aligned: f2, applyGlobeMatrix: !l2, applyTerrainMatrix: true });
            m2.draw(u2, _2.TRIANGLES, o2, r2[p3.overscaledZ], s2, ei.backCCW, ea(e2, a3, i2), x2, b2, i2.id, v2.vertexBuffer, v2.indexBuffer, v2.segments);
          }
        }
        function Rr(e2, i2, a2, r2, o2, s2, n2, l2, c2) {
          var h2;
          const u2 = e2.style.projection, d2 = e2.context, _2 = e2.transform, p2 = d2.gl, m2 = e2.useProgram("colorRelief"), f2 = !e2.options.moving;
          let g2 = true, v2 = 0;
          for (const x2 of r2) {
            const r3 = i2.getTile(x2), b2 = r3.dem;
            if (g2) {
              const e3 = p2.getParameter(p2.MAX_TEXTURE_SIZE), { elevationTexture: t2, colorTexture: i3 } = a2.getColorRampTextures(d2, e3, b2.getUnpackVector());
              d2.activeTexture.set(p2.TEXTURE1), t2.bind(p2.NEAREST, p2.CLAMP_TO_EDGE), d2.activeTexture.set(p2.TEXTURE4), i3.bind(p2.LINEAR, p2.CLAMP_TO_EDGE), g2 = false, v2 = t2.size[0];
            }
            if (!b2 || !b2.data) continue;
            const y2 = b2.stride, w2 = b2.getPixels();
            if (d2.activeTexture.set(p2.TEXTURE0), d2.pixelStoreUnpackPremultiplyAlpha.set(false), r3.demTexture = r3.demTexture || e2.getTileTexture(y2), r3.demTexture) {
              const e3 = r3.demTexture;
              e3.update(w2, { premultiply: false }), e3.bind(p2.LINEAR, p2.CLAMP_TO_EDGE);
            } else r3.demTexture = new t.T(d2, w2, p2.RGBA, { premultiply: false }), r3.demTexture.bind(p2.LINEAR, p2.CLAMP_TO_EDGE);
            const T2 = u2.getMeshFromTileID(d2, x2.canonical, l2, true, "raster"), P2 = null === (h2 = e2.style.map.terrain) || void 0 === h2 ? void 0 : h2.getTerrainData(x2), I2 = _2.getProjectionData({ overscaledTileID: x2, aligned: f2, applyGlobeMatrix: !c2, applyTerrainMatrix: true });
            m2.draw(d2, p2.TRIANGLES, s2, o2[x2.overscaledZ], n2, ei.backCCW, aa(a2, r3.dem, v2), P2, I2, a2.id, T2.vertexBuffer, T2.indexBuffer, T2.segments);
          }
        }
        const zr = [new t.P(0, 0), new t.P(t.a5, 0), new t.P(t.a5, t.a5), new t.P(0, t.a5)];
        function Dr(e2, t2, i2, a2, r2, o2, s2, n2, l2 = false, c2 = false) {
          const h2 = a2[a2.length - 1].overscaledZ, u2 = e2.context, d2 = u2.gl, _2 = e2.useProgram("raster"), p2 = e2.transform, m2 = e2.style.projection, f2 = e2.colorModeForRenderPass(), g2 = !e2.options.moving, v2 = i2.paint.get("raster-opacity"), x2 = i2.paint.get("raster-resampling"), b2 = i2.paint.get("raster-fade-duration"), y2 = !!e2.style.map.terrain;
          for (const w2 of a2) {
            const a3 = e2.getDepthModeForSublayer(w2.overscaledZ - h2, 1 === v2 ? ti.ReadWrite : ti.ReadOnly, d2.LESS), T2 = t2.getTile(w2), P2 = "nearest" === x2 ? d2.NEAREST : d2.LINEAR;
            u2.activeTexture.set(d2.TEXTURE0), T2.texture.bind(P2, d2.CLAMP_TO_EDGE, d2.LINEAR_MIPMAP_NEAREST), u2.activeTexture.set(d2.TEXTURE1);
            const { parentTile: I2, parentScaleBy: C2, parentTopLeft: M2, fadeValues: E2 } = Ar(T2, t2, b2, y2);
            T2.fadeOpacity = E2.tileOpacity, I2 ? (I2.fadeOpacity = E2.parentTileOpacity, I2.texture.bind(P2, d2.CLAMP_TO_EDGE, d2.LINEAR_MIPMAP_NEAREST)) : T2.texture.bind(P2, d2.CLAMP_TO_EDGE, d2.LINEAR_MIPMAP_NEAREST), T2.texture.useMipmap && u2.extTextureFilterAnisotropic && e2.transform.pitch > 20 && d2.texParameterf(d2.TEXTURE_2D, u2.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, u2.extTextureFilterAnisotropicMax);
            const S2 = e2.style.map.terrain && e2.style.map.terrain.getTerrainData(w2), R2 = p2.getProjectionData({ overscaledTileID: w2, aligned: g2, applyGlobeMatrix: !c2, applyTerrainMatrix: true }), z2 = ua(M2, C2, E2.fadeMix, i2, n2), D2 = m2.getMeshFromTileID(u2, w2.canonical, o2, s2, "raster");
            _2.draw(u2, d2.TRIANGLES, a3, r2 ? r2[w2.overscaledZ] : ai.disabled, f2, l2 ? ei.frontCCW : ei.backCCW, z2, S2, R2, i2.id, D2.vertexBuffer, D2.indexBuffer, D2.segments);
          }
        }
        function Ar(e2, i2, a2, r2) {
          const o2 = { parentTile: null, parentScaleBy: 1, parentTopLeft: [0, 0], fadeValues: { tileOpacity: 1, parentTileOpacity: 1, fadeMix: { opacity: 1, mix: 0 } } };
          if (0 === a2 || r2) return o2;
          if (e2.fadingParentID) {
            const r3 = i2.getLoadedTile(e2.fadingParentID);
            if (!r3) return o2;
            const s2 = Math.pow(2, r3.tileID.overscaledZ - e2.tileID.overscaledZ), n2 = [e2.tileID.canonical.x * s2 % 1, e2.tileID.canonical.y * s2 % 1], l2 = function(e3, i3, a3) {
              const r4 = c(), o3 = (r4 - i3.timeAdded) / a3, s3 = e3.fadingDirection === ue.Incoming, n3 = t.ao((r4 - e3.timeAdded) / a3, 0, 1), l3 = t.ao(1 - o3, 0, 1), h2 = s3 ? n3 : l3;
              return { tileOpacity: h2, parentTileOpacity: s3 ? l3 : n3, fadeMix: { opacity: 1, mix: 1 - h2 } };
            }(e2, r3, a2);
            return { parentTile: r3, parentScaleBy: s2, parentTopLeft: n2, fadeValues: l2 };
          }
          if (e2.selfFading) {
            const i3 = function(e3, i4) {
              const a3 = (c() - e3.timeAdded) / i4, r3 = t.ao(a3, 0, 1);
              return { tileOpacity: r3, fadeMix: { opacity: r3, mix: 0 } };
            }(e2, a2);
            return { parentTile: null, parentScaleBy: 1, parentTopLeft: [0, 0], fadeValues: i3 };
          }
          return o2;
        }
        const Lr = new t.bq(1, 0, 0, 1), kr = new t.bq(0, 1, 0, 1), Fr = new t.bq(0, 0, 1, 1), Br = new t.bq(1, 0, 1, 1), Or = new t.bq(0, 1, 1, 1);
        function jr(e2, t2, i2, a2) {
          Zr(e2, 0, t2 + i2 / 2, e2.transform.width, i2, a2);
        }
        function Nr(e2, t2, i2, a2) {
          Zr(e2, t2 - i2 / 2, 0, i2, e2.transform.height, a2);
        }
        function Zr(e2, t2, i2, a2, r2, o2) {
          const s2 = e2.context, n2 = s2.gl;
          n2.enable(n2.SCISSOR_TEST), n2.scissor(t2 * e2.pixelRatio, i2 * e2.pixelRatio, a2 * e2.pixelRatio, r2 * e2.pixelRatio), s2.clear({ color: o2 }), n2.disable(n2.SCISSOR_TEST);
        }
        function Gr(e2, i2, a2) {
          const r2 = e2.context, o2 = r2.gl, s2 = e2.useProgram("debug"), n2 = ti.disabled, l2 = ai.disabled, c2 = e2.colorModeForRenderPass(), h2 = "$debug", u2 = e2.style.map.terrain && e2.style.map.terrain.getTerrainData(a2);
          r2.activeTexture.set(o2.TEXTURE0);
          const d2 = i2.getTileByID(a2.key).latestRawTileData, _2 = Math.floor((d2 && d2.byteLength || 0) / 1024), p2 = i2.getTile(a2).tileSize, m2 = 512 / Math.min(p2, 512) * (a2.overscaledZ / e2.transform.zoom) * 0.5;
          let f2 = a2.canonical.toString();
          a2.overscaledZ !== a2.canonical.z && (f2 += ` => ${a2.overscaledZ}`), function(e3, t2) {
            e3.initDebugOverlayCanvas();
            const i3 = e3.debugOverlayCanvas, a3 = e3.context.gl, r3 = e3.debugOverlayCanvas.getContext("2d");
            r3.clearRect(0, 0, i3.width, i3.height), r3.shadowColor = "white", r3.shadowBlur = 2, r3.lineWidth = 1.5, r3.strokeStyle = "white", r3.textBaseline = "top", r3.font = "bold 36px Open Sans, sans-serif", r3.fillText(t2, 5, 5), r3.strokeText(t2, 5, 5), e3.debugOverlayTexture.update(i3), e3.debugOverlayTexture.bind(a3.LINEAR, a3.CLAMP_TO_EDGE);
          }(e2, `${f2} ${_2}kB`);
          const g2 = e2.transform.getProjectionData({ overscaledTileID: a2, applyGlobeMatrix: true, applyTerrainMatrix: true });
          s2.draw(r2, o2.TRIANGLES, n2, l2, Qt.alphaBlended, ei.disabled, Yi(t.bq.transparent, m2), null, g2, h2, e2.debugBuffer, e2.quadTriangleIndexBuffer, e2.debugSegments), s2.draw(r2, o2.LINE_STRIP, n2, l2, c2, ei.disabled, Yi(t.bq.red), u2, g2, h2, e2.debugBuffer, e2.tileBorderIndexBuffer, e2.debugSegments);
        }
        function Ur(e2, t2, i2, a2) {
          const { isRenderingGlobe: r2 } = a2, o2 = e2.context, s2 = o2.gl, n2 = e2.transform, l2 = e2.colorModeForRenderPass(), c2 = e2.getDepthModeFor3D(), h2 = e2.useProgram("terrain");
          o2.bindFramebuffer.set(null), o2.viewport.set([0, 0, e2.width, e2.height]);
          for (const a3 of i2) {
            const i3 = t2.getTerrainMesh(a3.tileID), u2 = e2.renderToTexture.getTexture(a3), d2 = t2.getTerrainData(a3.tileID);
            o2.activeTexture.set(s2.TEXTURE0), s2.bindTexture(s2.TEXTURE_2D, u2.texture);
            const _2 = t2.getMeshFrameDelta(n2.zoom), p2 = n2.calculateFogMatrix(a3.tileID.toUnwrapped()), m2 = Oi(_2, p2, e2.style.sky, n2.pitch, r2), f2 = n2.getProjectionData({ overscaledTileID: a3.tileID, applyTerrainMatrix: false, applyGlobeMatrix: true });
            h2.draw(o2, s2.TRIANGLES, c2, ai.disabled, l2, ei.backCCW, m2, d2, f2, "terrain", i3.vertexBuffer, i3.indexBuffer, i3.segments);
          }
        }
        function Vr(e2, i2) {
          if (!i2.mesh) {
            const a2 = new t.aX();
            a2.emplaceBack(-1, -1), a2.emplaceBack(1, -1), a2.emplaceBack(1, 1), a2.emplaceBack(-1, 1);
            const r2 = new t.aZ();
            r2.emplaceBack(0, 1, 2), r2.emplaceBack(0, 2, 3), i2.mesh = new kt(e2.createVertexBuffer(a2, Ft.members), e2.createIndexBuffer(r2), t.aY.simpleSegment(0, 0, a2.length, r2.length));
          }
          return i2.mesh;
        }
        class qr {
          constructor(e2, i2) {
            this.context = new nr(e2), this.transform = i2, this._tileTextures = {}, this.terrainFacilitator = { dirty: true, matrix: t.as(new Float64Array(16)), renderTime: 0 }, this.setup(), this.numSublayers = ke.maxOverzooming + ke.maxUnderzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new zt();
          }
          resize(e2, t2, i2) {
            if (this.width = Math.floor(e2 * i2), this.height = Math.floor(t2 * i2), this.pixelRatio = i2, this.context.viewport.set([0, 0, this.width, this.height]), this.style) for (const e3 of this.style._order) this.style._layers[e3].resize();
          }
          setup() {
            const e2 = this.context, i2 = new t.aX();
            i2.emplaceBack(0, 0), i2.emplaceBack(t.a5, 0), i2.emplaceBack(0, t.a5), i2.emplaceBack(t.a5, t.a5), this.tileExtentBuffer = e2.createVertexBuffer(i2, Ft.members), this.tileExtentSegments = t.aY.simpleSegment(0, 0, 4, 2);
            const a2 = new t.aX();
            a2.emplaceBack(0, 0), a2.emplaceBack(t.a5, 0), a2.emplaceBack(0, t.a5), a2.emplaceBack(t.a5, t.a5), this.debugBuffer = e2.createVertexBuffer(a2, Ft.members), this.debugSegments = t.aY.simpleSegment(0, 0, 4, 5);
            const r2 = new t.ci();
            r2.emplaceBack(0, 0, 0, 0), r2.emplaceBack(t.a5, 0, t.a5, 0), r2.emplaceBack(0, t.a5, 0, t.a5), r2.emplaceBack(t.a5, t.a5, t.a5, t.a5), this.rasterBoundsBuffer = e2.createVertexBuffer(r2, Fi.members), this.rasterBoundsSegments = t.aY.simpleSegment(0, 0, 4, 2);
            const o2 = new t.aX();
            o2.emplaceBack(0, 0), o2.emplaceBack(t.a5, 0), o2.emplaceBack(0, t.a5), o2.emplaceBack(t.a5, t.a5), this.rasterBoundsBufferPosOnly = e2.createVertexBuffer(o2, Ft.members), this.rasterBoundsSegmentsPosOnly = t.aY.simpleSegment(0, 0, 4, 5);
            const s2 = new t.aX();
            s2.emplaceBack(0, 0), s2.emplaceBack(1, 0), s2.emplaceBack(0, 1), s2.emplaceBack(1, 1), this.viewportBuffer = e2.createVertexBuffer(s2, Ft.members), this.viewportSegments = t.aY.simpleSegment(0, 0, 4, 2);
            const n2 = new t.cj();
            n2.emplaceBack(0), n2.emplaceBack(1), n2.emplaceBack(3), n2.emplaceBack(2), n2.emplaceBack(0), this.tileBorderIndexBuffer = e2.createIndexBuffer(n2);
            const l2 = new t.aZ();
            l2.emplaceBack(1, 0, 2), l2.emplaceBack(1, 2, 3), this.quadTriangleIndexBuffer = e2.createIndexBuffer(l2);
            const c2 = this.context.gl;
            this.stencilClearMode = new ai({ func: c2.ALWAYS, mask: 0 }, 0, 255, c2.ZERO, c2.ZERO, c2.ZERO), this.tileExtentMesh = new kt(this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
          }
          clearStencil() {
            const e2 = this.context, i2 = e2.gl;
            this.nextStencilID = 1, this.currentStencilSource = void 0;
            const a2 = t.N();
            t.c8(a2, 0, this.width, this.height, 0, 0, 1), t.Q(a2, a2, [i2.drawingBufferWidth, i2.drawingBufferHeight, 0]);
            const r2 = { mainMatrix: a2, tileMercatorCoords: [0, 0, 1, 1], clippingPlane: [0, 0, 0, 0], projectionTransition: 0, fallbackMatrix: a2 };
            this.useProgram("clippingMask", null, true).draw(e2, i2.TRIANGLES, ti.disabled, this.stencilClearMode, Qt.disabled, ei.disabled, null, null, r2, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
          }
          _renderTileClippingMasks(e2, t2, i2) {
            if (this.currentStencilSource === e2.source || !e2.isTileClipped() || !t2 || !t2.length) return;
            this.currentStencilSource = e2.source, this.nextStencilID + t2.length > 256 && this.clearStencil();
            const a2 = this.context;
            a2.setColorMode(Qt.disabled), a2.setDepthMode(ti.disabled);
            const r2 = {};
            for (const e3 of t2) r2[e3.key] = this.nextStencilID++;
            this._renderTileMasks(r2, t2, i2, true), this._renderTileMasks(r2, t2, i2, false), this._tileClippingMaskIDs = r2;
          }
          _renderTileMasks(e2, t2, i2, a2) {
            const r2 = this.context, o2 = r2.gl, s2 = this.style.projection, n2 = this.transform, l2 = this.useProgram("clippingMask");
            for (const c2 of t2) {
              const t3 = e2[c2.key], h2 = this.style.map.terrain && this.style.map.terrain.getTerrainData(c2), u2 = s2.getMeshFromTileID(this.context, c2.canonical, a2, true, "stencil"), d2 = n2.getProjectionData({ overscaledTileID: c2, applyGlobeMatrix: !i2, applyTerrainMatrix: true });
              l2.draw(r2, o2.TRIANGLES, ti.disabled, new ai({ func: o2.ALWAYS, mask: 0 }, t3, 255, o2.KEEP, o2.KEEP, o2.REPLACE), Qt.disabled, i2 ? ei.disabled : ei.backCCW, null, h2, d2, "$clipping", u2.vertexBuffer, u2.indexBuffer, u2.segments);
            }
          }
          _renderTilesDepthBuffer() {
            const e2 = this.context, t2 = e2.gl, i2 = this.style.projection, a2 = this.transform, r2 = this.useProgram("depth"), o2 = this.getDepthModeFor3D(), s2 = Ce(a2, { tileSize: a2.tileSize });
            for (const n2 of s2) {
              const s3 = this.style.map.terrain && this.style.map.terrain.getTerrainData(n2), l2 = i2.getMeshFromTileID(this.context, n2.canonical, true, true, "raster"), c2 = a2.getProjectionData({ overscaledTileID: n2, applyGlobeMatrix: true, applyTerrainMatrix: true });
              r2.draw(e2, t2.TRIANGLES, o2, ai.disabled, Qt.disabled, ei.backCCW, null, s3, c2, "$clipping", l2.vertexBuffer, l2.indexBuffer, l2.segments);
            }
          }
          stencilModeFor3D() {
            this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
            const e2 = this.nextStencilID++, t2 = this.context.gl;
            return new ai({ func: t2.NOTEQUAL, mask: 255 }, e2, 255, t2.KEEP, t2.KEEP, t2.REPLACE);
          }
          stencilModeForClipping(e2) {
            const t2 = this.context.gl;
            return new ai({ func: t2.EQUAL, mask: 255 }, this._tileClippingMaskIDs[e2.key], 0, t2.KEEP, t2.KEEP, t2.REPLACE);
          }
          getStencilConfigForOverlapAndUpdateStencilID(e2) {
            const t2 = this.context.gl, i2 = e2.sort((e3, t3) => t3.overscaledZ - e3.overscaledZ), a2 = i2[i2.length - 1].overscaledZ, r2 = i2[0].overscaledZ - a2 + 1;
            if (r2 > 1) {
              this.currentStencilSource = void 0, this.nextStencilID + r2 > 256 && this.clearStencil();
              const e3 = {};
              for (let i3 = 0; i3 < r2; i3++) e3[i3 + a2] = new ai({ func: t2.GEQUAL, mask: 255 }, i3 + this.nextStencilID, 255, t2.KEEP, t2.KEEP, t2.REPLACE);
              return this.nextStencilID += r2, [e3, i2];
            }
            return [{ [a2]: ai.disabled }, i2];
          }
          stencilConfigForOverlapTwoPass(e2) {
            const t2 = this.context.gl, i2 = e2.sort((e3, t3) => t3.overscaledZ - e3.overscaledZ), a2 = i2[i2.length - 1].overscaledZ, r2 = i2[0].overscaledZ - a2 + 1;
            if (this.clearStencil(), r2 > 1) {
              const e3 = {}, o2 = {};
              for (let i3 = 0; i3 < r2; i3++) e3[i3 + a2] = new ai({ func: t2.GREATER, mask: 255 }, r2 + 1 + i3, 255, t2.KEEP, t2.KEEP, t2.REPLACE), o2[i3 + a2] = new ai({ func: t2.GREATER, mask: 255 }, 1 + i3, 255, t2.KEEP, t2.KEEP, t2.REPLACE);
              return this.nextStencilID = 2 * r2 + 1, [e3, o2, i2];
            }
            return this.nextStencilID = 3, [{ [a2]: new ai({ func: t2.GREATER, mask: 255 }, 2, 255, t2.KEEP, t2.KEEP, t2.REPLACE) }, { [a2]: new ai({ func: t2.GREATER, mask: 255 }, 1, 255, t2.KEEP, t2.KEEP, t2.REPLACE) }, i2];
          }
          colorModeForRenderPass() {
            const e2 = this.context.gl;
            if (this._showOverdrawInspector) {
              const i2 = 1 / 8;
              return new Qt([e2.CONSTANT_COLOR, e2.ONE], new t.bq(i2, i2, i2, 0), [true, true, true, true]);
            }
            return "opaque" === this.renderPass ? Qt.unblended : Qt.alphaBlended;
          }
          getDepthModeForSublayer(e2, t2, i2) {
            if (!this.opaquePassEnabledForLayer()) return ti.disabled;
            const a2 = 1 - ((1 + this.currentLayer) * this.numSublayers + e2) * this.depthEpsilon;
            return new ti(i2 || this.context.gl.LEQUAL, t2, [a2, a2]);
          }
          getDepthModeFor3D() {
            return new ti(this.context.gl.LEQUAL, ti.ReadWrite, this.depthRangeFor3D);
          }
          opaquePassEnabledForLayer() {
            return this.currentLayer < this.opaquePassCutoff;
          }
          render(e2, i2) {
            var a2, r2;
            this.style = e2, this.options = i2, this.lineAtlas = e2.lineAtlas, this.imageManager = e2.imageManager, this.glyphManager = e2.glyphManager, this.symbolFadeChange = e2.placement.symbolFadeChange(c()), this.imageManager.beginFrame();
            const o2 = this.style._order, s2 = this.style.tileManagers, n2 = {}, l2 = {}, h2 = {}, u2 = { isRenderingToTexture: false, isRenderingGlobe: (null === (a2 = e2.projection) || void 0 === a2 ? void 0 : a2.transitionState) > 0 };
            for (const e3 in s2) {
              const t2 = s2[e3];
              t2.used && t2.prepare(this.context), n2[e3] = t2.getVisibleCoordinates(false), l2[e3] = n2[e3].slice().reverse(), h2[e3] = t2.getVisibleCoordinates(true).reverse();
            }
            this.opaquePassCutoff = 1 / 0;
            for (let e3 = 0; e3 < o2.length; e3++) if (this.style._layers[o2[e3]].is3D()) {
              this.opaquePassCutoff = e3;
              break;
            }
            this.maybeDrawDepthAndCoords(false), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0), this.renderPass = "offscreen";
            for (const e3 of o2) {
              const t2 = this.style._layers[e3];
              if (!t2.hasOffscreenPass() || t2.isHidden(this.transform.zoom)) continue;
              const i3 = l2[t2.source];
              ("custom" === t2.type || i3.length) && this.renderLayer(this, s2[t2.source], t2, i3, u2);
            }
            if (null === (r2 = this.style.projection) || void 0 === r2 || r2.updateGPUdependent({ context: this.context, useProgram: (e3) => this.useProgram(e3) }), this.context.viewport.set([0, 0, this.width, this.height]), this.context.bindFramebuffer.set(null), this.context.clear({ color: i2.showOverdrawInspector ? t.bq.black : t.bq.transparent, depth: 1 }), this.clearStencil(), this.style.sky && function(e3, t2) {
              const i3 = e3.context, a3 = i3.gl, r3 = ((e4, t3, i4) => {
                const a4 = Math.cos(t3.rollInRadians), r4 = Math.sin(t3.rollInRadians), o4 = ge(t3), s4 = t3.getProjectionData({ overscaledTileID: null, applyGlobeMatrix: true, applyTerrainMatrix: true }).projectionTransition;
                return { u_sky_color: e4.properties.get("sky-color"), u_horizon_color: e4.properties.get("horizon-color"), u_horizon: [(t3.width / 2 - o4 * r4) * i4, (t3.height / 2 + o4 * a4) * i4], u_horizon_normal: [-r4, a4], u_sky_horizon_blend: e4.properties.get("sky-horizon-blend") * t3.height / 2 * i4, u_sky_blend: s4 };
              })(t2, e3.style.map.transform, e3.pixelRatio), o3 = new ti(a3.LEQUAL, ti.ReadWrite, [0, 1]), s3 = ai.disabled, n3 = e3.colorModeForRenderPass(), l3 = e3.useProgram("sky"), c2 = Vr(i3, t2);
              l3.draw(i3, a3.TRIANGLES, o3, s3, n3, ei.disabled, r3, null, void 0, "sky", c2.vertexBuffer, c2.indexBuffer, c2.segments);
            }(this, this.style.sky), this._showOverdrawInspector = i2.showOverdrawInspector, this.depthRangeFor3D = [0, 1 - (e2._order.length + 2) * this.numSublayers * this.depthEpsilon], !this.renderToTexture) for (this.renderPass = "opaque", this.currentLayer = o2.length - 1; this.currentLayer >= 0; this.currentLayer--) {
              const e3 = this.style._layers[o2[this.currentLayer]], t2 = s2[e3.source], i3 = n2[e3.source];
              this._renderTileClippingMasks(e3, i3, false), this.renderLayer(this, t2, e3, i3, u2);
            }
            this.renderPass = "translucent";
            let d2 = false;
            for (this.currentLayer = 0; this.currentLayer < o2.length; this.currentLayer++) {
              const e3 = this.style._layers[o2[this.currentLayer]], t2 = s2[e3.source];
              if (this.renderToTexture && this.renderToTexture.renderLayer(e3, u2)) continue;
              this.opaquePassEnabledForLayer() || d2 || (d2 = true, u2.isRenderingGlobe && !this.style.map.terrain && this._renderTilesDepthBuffer());
              const i3 = ("symbol" === e3.type ? h2 : l2)[e3.source];
              this._renderTileClippingMasks(e3, n2[e3.source], !!this.renderToTexture), this.renderLayer(this, t2, e3, i3, u2);
            }
            if (u2.isRenderingGlobe && function(e3, i3, a3) {
              const r3 = e3.context, o3 = r3.gl, s3 = e3.useProgram("atmosphere"), n3 = new ti(o3.LEQUAL, ti.ReadOnly, [0, 1]), l3 = e3.transform, c2 = function(e4, i4) {
                const a4 = e4.properties.get("position"), r4 = [-a4.x, -a4.y, -a4.z], o4 = t.as(new Float64Array(16));
                return "map" === e4.properties.get("anchor") && (t.bh(o4, o4, i4.rollInRadians), t.bi(o4, o4, -i4.pitchInRadians), t.bh(o4, o4, i4.bearingInRadians), t.bi(o4, o4, i4.center.lat * Math.PI / 180), t.bK(o4, o4, -i4.center.lng * Math.PI / 180)), t.ch(r4, r4, o4), r4;
              }(a3, e3.transform), h3 = l3.getProjectionData({ overscaledTileID: null, applyGlobeMatrix: true, applyTerrainMatrix: true }), u3 = i3.properties.get("atmosphere-blend") * h3.projectionTransition;
              if (0 === u3) return;
              const d3 = fi(l3.worldSize, l3.center.lat), _2 = l3.inverseProjectionMatrix, p2 = new Float64Array(4);
              p2[3] = 1, t.aI(p2, p2, l3.modelViewProjectionMatrix), p2[0] /= p2[3], p2[1] /= p2[3], p2[2] /= p2[3], p2[3] = 1, t.aI(p2, p2, _2), p2[0] /= p2[3], p2[1] /= p2[3], p2[2] /= p2[3], p2[3] = 1;
              const m2 = /* @__PURE__ */ ((e4, t2, i4, a4, r4) => ({ u_sun_pos: e4, u_atmosphere_blend: t2, u_globe_position: i4, u_globe_radius: a4, u_inv_proj_matrix: r4 }))(c2, u3, [p2[0], p2[1], p2[2]], d3, _2), f2 = Vr(r3, i3);
              s3.draw(r3, o3.TRIANGLES, n3, ai.disabled, Qt.alphaBlended, ei.disabled, m2, null, null, "atmosphere", f2.vertexBuffer, f2.indexBuffer, f2.segments);
            }(this, this.style.sky, this.style.light), this.options.showTileBoundaries) {
              const e3 = function(e4, t2) {
                let i3 = null;
                const a3 = Object.values(e4._layers).flatMap((i4) => i4.source && !i4.isHidden(t2) ? [e4.tileManagers[i4.source]] : []), r3 = a3.filter((e5) => "vector" === e5.getSource().type), o3 = a3.filter((e5) => "vector" !== e5.getSource().type), s3 = (e5) => {
                  (!i3 || i3.getSource().maxzoom < e5.getSource().maxzoom) && (i3 = e5);
                };
                return r3.forEach((e5) => s3(e5)), i3 || o3.forEach((e5) => s3(e5)), i3;
              }(this.style, this.transform.zoom);
              e3 && function(e4, t2, i3) {
                for (let a3 = 0; a3 < i3.length; a3++) Gr(e4, t2, i3[a3]);
              }(this, e3, e3.getVisibleCoordinates());
            }
            this.options.showPadding && function(e3) {
              const t2 = e3.transform.padding;
              jr(e3, e3.transform.height - (t2.top || 0), 3, Lr), jr(e3, t2.bottom || 0, 3, kr), Nr(e3, t2.left || 0, 3, Fr), Nr(e3, e3.transform.width - (t2.right || 0), 3, Br);
              const i3 = e3.transform.centerPoint;
              !function(e4, t3, i4, a3) {
                Zr(e4, t3 - 1, i4 - 10, 2, 20, a3), Zr(e4, t3 - 10, i4 - 1, 20, 2, a3);
              }(e3, i3.x, e3.transform.height - i3.y, Or);
            }(this), this.context.setDefault();
          }
          maybeDrawDepthAndCoords(e2) {
            if (!this.style || !this.style.map || !this.style.map.terrain) return;
            const i2 = this.terrainFacilitator.matrix, a2 = this.transform.modelViewProjectionMatrix;
            let r2 = this.terrainFacilitator.dirty;
            r2 || (r2 = e2 ? !t.ck(i2, a2) : !t.cl(i2, a2)), r2 || (r2 = this.style.map.terrain.tileManager.anyTilesAfterTime(this.terrainFacilitator.renderTime)), r2 && (t.cm(i2, a2), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = false, function(e3, i3) {
              const a3 = e3.context, r3 = a3.gl, o2 = e3.transform, s2 = Qt.unblended, n2 = new ti(r3.LEQUAL, ti.ReadWrite, [0, 1]), l2 = i3.tileManager.getRenderableTiles(), c2 = e3.useProgram("terrainDepth");
              a3.bindFramebuffer.set(i3.getFramebuffer("depth").framebuffer), a3.viewport.set([0, 0, e3.width / devicePixelRatio, e3.height / devicePixelRatio]), a3.clear({ color: t.bq.transparent, depth: 1 });
              for (const e4 of l2) {
                const t2 = i3.getTerrainMesh(e4.tileID), l3 = i3.getTerrainData(e4.tileID), h2 = o2.getProjectionData({ overscaledTileID: e4.tileID, applyTerrainMatrix: false, applyGlobeMatrix: true }), u2 = { u_ele_delta: i3.getMeshFrameDelta(o2.zoom) };
                c2.draw(a3, r3.TRIANGLES, n2, ai.disabled, s2, ei.backCCW, u2, l3, h2, "terrain", t2.vertexBuffer, t2.indexBuffer, t2.segments);
              }
              a3.bindFramebuffer.set(null), a3.viewport.set([0, 0, e3.width, e3.height]);
            }(this, this.style.map.terrain), function(e3, i3) {
              const a3 = e3.context, r3 = a3.gl, o2 = e3.transform, s2 = Qt.unblended, n2 = new ti(r3.LEQUAL, ti.ReadWrite, [0, 1]), l2 = i3.getCoordsTexture(), c2 = i3.tileManager.getRenderableTiles(), h2 = e3.useProgram("terrainCoords");
              a3.bindFramebuffer.set(i3.getFramebuffer("coords").framebuffer), a3.viewport.set([0, 0, e3.width / devicePixelRatio, e3.height / devicePixelRatio]), a3.clear({ color: t.bq.transparent, depth: 1 }), i3.coordsIndex = [];
              for (const e4 of c2) {
                const t2 = i3.getTerrainMesh(e4.tileID), c3 = i3.getTerrainData(e4.tileID);
                a3.activeTexture.set(r3.TEXTURE0), r3.bindTexture(r3.TEXTURE_2D, l2.texture);
                const u2 = { u_terrain_coords_id: (255 - i3.coordsIndex.length) / 255, u_texture: 0, u_ele_delta: i3.getMeshFrameDelta(o2.zoom) }, d2 = o2.getProjectionData({ overscaledTileID: e4.tileID, applyTerrainMatrix: false, applyGlobeMatrix: true });
                h2.draw(a3, r3.TRIANGLES, n2, ai.disabled, s2, ei.backCCW, u2, c3, d2, "terrain", t2.vertexBuffer, t2.indexBuffer, t2.segments), i3.coordsIndex.push(e4.tileID.key);
              }
              a3.bindFramebuffer.set(null), a3.viewport.set([0, 0, e3.width, e3.height]);
            }(this, this.style.map.terrain));
          }
          renderLayer(e2, i2, a2, r2, o2) {
            a2.isHidden(this.transform.zoom) || ("background" === a2.type || "custom" === a2.type || (r2 || []).length) && (this.id = a2.id, t.cn(a2) ? function(e3, i3, a3, r3, o3, s2) {
              if ("translucent" !== e3.renderPass) return;
              const { isRenderingToTexture: n2 } = s2, l2 = ai.disabled, c2 = e3.colorModeForRenderPass();
              (a3._unevaluatedLayout.hasValue("text-variable-anchor") || a3._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(e4, i4, a4, r4, o4, s3, n3, l3, c3) {
                const h2 = i4.transform, u2 = i4.style.map.terrain, d2 = "map" === o4, _2 = "map" === s3;
                for (const o5 of e4) {
                  const e5 = r4.getTile(o5), s4 = e5.getBucket(a4);
                  if (!s4 || !s4.text || !s4.text.segments.get().length) continue;
                  const p2 = t.az(s4.textSizeData, h2.zoom), m2 = t.aO(e5, 1, i4.transform.zoom), f2 = je(d2, i4.transform, m2), g2 = "none" !== a4.layout.get("icon-text-fit") && s4.hasIconData();
                  if (p2) {
                    const i5 = Math.pow(2, h2.zoom - e5.tileID.overscaledZ), a5 = u2 ? (e6, t2) => u2.getElevation(o5, e6, t2) : null;
                    _r(s4, d2, _2, c3, h2, f2, i5, p2, g2, t.aP(h2, e5, n3, l3), o5.toUnwrapped(), a5);
                  }
                }
              }(r3, e3, a3, i3, a3.layout.get("text-rotation-alignment"), a3.layout.get("text-pitch-alignment"), a3.paint.get("text-translate"), a3.paint.get("text-translate-anchor"), o3), 0 !== a3.paint.get("icon-opacity").constantOr(1) && mr(e3, i3, a3, r3, false, a3.paint.get("icon-translate"), a3.paint.get("icon-translate-anchor"), a3.layout.get("icon-rotation-alignment"), a3.layout.get("icon-pitch-alignment"), a3.layout.get("icon-keep-upright"), l2, c2, n2), 0 !== a3.paint.get("text-opacity").constantOr(1) && mr(e3, i3, a3, r3, true, a3.paint.get("text-translate"), a3.paint.get("text-translate-anchor"), a3.layout.get("text-rotation-alignment"), a3.layout.get("text-pitch-alignment"), a3.layout.get("text-keep-upright"), l2, c2, n2), i3.map.showCollisionBoxes && (cr(e3, i3, a3, r3, true), cr(e3, i3, a3, r3, false));
            }(e2, i2, a2, r2, this.style.placement.variableOffsets, o2) : t.co(a2) ? function(e3, i3, a3, r3, o3) {
              if ("translucent" !== e3.renderPass) return;
              const { isRenderingToTexture: s2 } = o3, n2 = a3.paint.get("circle-opacity"), l2 = a3.paint.get("circle-stroke-width"), c2 = a3.paint.get("circle-stroke-opacity"), h2 = !a3.layout.get("circle-sort-key").isConstant();
              if (0 === n2.constantOr(1) && (0 === l2.constantOr(1) || 0 === c2.constantOr(1))) return;
              const u2 = e3.context, d2 = u2.gl, _2 = e3.transform, p2 = e3.getDepthModeForSublayer(0, ti.ReadOnly), m2 = ai.disabled, f2 = e3.colorModeForRenderPass(), g2 = [], v2 = _2.getCircleRadiusCorrection();
              for (let o4 = 0; o4 < r3.length; o4++) {
                const n3 = r3[o4], l3 = i3.getTile(n3), c3 = l3.getBucket(a3);
                if (!c3) continue;
                const u3 = a3.paint.get("circle-translate"), d3 = a3.paint.get("circle-translate-anchor"), p3 = t.aP(_2, l3, u3, d3), m3 = c3.programConfigurations.get(a3.id), f3 = e3.useProgram("circle", m3), x2 = c3.layoutVertexBuffer, b2 = c3.indexBuffer, y2 = e3.style.map.terrain && e3.style.map.terrain.getTerrainData(n3), w2 = { programConfiguration: m3, program: f3, layoutVertexBuffer: x2, indexBuffer: b2, uniformValues: Hi(e3, l3, a3, p3, v2), terrainData: y2, projectionData: _2.getProjectionData({ overscaledTileID: n3, applyGlobeMatrix: !s2, applyTerrainMatrix: true }) };
                if (h2) {
                  const e4 = c3.segments.get();
                  for (const i4 of e4) g2.push({ segments: new t.aY([i4]), sortKey: i4.sortKey, state: w2 });
                } else g2.push({ segments: c3.segments, sortKey: 0, state: w2 });
              }
              h2 && g2.sort((e4, t2) => e4.sortKey - t2.sortKey);
              for (const t2 of g2) {
                const { programConfiguration: i4, program: r4, layoutVertexBuffer: o4, indexBuffer: s3, uniformValues: n3, terrainData: l3, projectionData: c3 } = t2.state;
                r4.draw(u2, d2.TRIANGLES, p2, m2, f2, ei.backCCW, n3, l3, c3, a3.id, o4, s3, t2.segments, a3.paint, e3.transform.zoom, i4);
              }
            }(e2, i2, a2, r2, o2) : t.cp(a2) ? function(e3, i3, a3, r3, o3) {
              if (0 === a3.paint.get("heatmap-opacity")) return;
              const s2 = e3.context, { isRenderingToTexture: n2, isRenderingGlobe: l2 } = o3;
              if (e3.style.map.terrain) {
                for (const t2 of r3) {
                  const r4 = i3.getTile(t2);
                  i3.hasRenderableParent(t2) || ("offscreen" === e3.renderPass ? gr(e3, r4, a3, t2, l2) : "translucent" === e3.renderPass && vr(e3, a3, t2, n2, l2));
                }
                s2.viewport.set([0, 0, e3.width, e3.height]);
              } else "offscreen" === e3.renderPass ? function(e4, i4, a4, r4) {
                const o4 = e4.context, s3 = o4.gl, n3 = e4.transform, l3 = ai.disabled, c2 = new Qt([s3.ONE, s3.ONE], t.bq.transparent, [true, true, true, true]);
                (function(e5, i5, a5) {
                  const r5 = e5.gl;
                  e5.activeTexture.set(r5.TEXTURE1), e5.viewport.set([0, 0, i5.width / 4, i5.height / 4]);
                  let o5 = a5.heatmapFbos.get(t.ce);
                  o5 ? (r5.bindTexture(r5.TEXTURE_2D, o5.colorAttachment.get()), e5.bindFramebuffer.set(o5.framebuffer)) : (o5 = xr(e5, i5.width / 4, i5.height / 4), a5.heatmapFbos.set(t.ce, o5));
                })(o4, e4, a4), o4.clear({ color: t.bq.transparent });
                for (let t2 = 0; t2 < r4.length; t2++) {
                  const h2 = r4[t2];
                  if (i4.hasRenderableParent(h2)) continue;
                  const u2 = i4.getTile(h2), d2 = u2.getBucket(a4);
                  if (!d2) continue;
                  const _2 = d2.programConfigurations.get(a4.id), p2 = e4.useProgram("heatmap", _2), m2 = n3.getProjectionData({ overscaledTileID: h2, applyGlobeMatrix: true, applyTerrainMatrix: false }), f2 = n3.getCircleRadiusCorrection();
                  p2.draw(o4, s3.TRIANGLES, ti.disabled, l3, c2, ei.backCCW, Qi(u2, n3.zoom, a4.paint.get("heatmap-intensity"), f2), null, m2, a4.id, d2.layoutVertexBuffer, d2.indexBuffer, d2.segments, a4.paint, n3.zoom, _2);
                }
                o4.viewport.set([0, 0, e4.width, e4.height]);
              }(e3, i3, a3, r3) : "translucent" === e3.renderPass && function(e4, i4) {
                const a4 = e4.context, r4 = a4.gl;
                a4.setColorMode(e4.colorModeForRenderPass());
                const o4 = i4.heatmapFbos.get(t.ce);
                o4 && (a4.activeTexture.set(r4.TEXTURE0), r4.bindTexture(r4.TEXTURE_2D, o4.colorAttachment.get()), a4.activeTexture.set(r4.TEXTURE1), br(a4, i4).bind(r4.LINEAR, r4.CLAMP_TO_EDGE), e4.useProgram("heatmapTexture").draw(a4, r4.TRIANGLES, ti.disabled, ai.disabled, e4.colorModeForRenderPass(), ei.disabled, Ji(e4, i4, 0, 1), null, null, i4.id, e4.viewportBuffer, e4.quadTriangleIndexBuffer, e4.viewportSegments, i4.paint, e4.transform.zoom));
              }(e3, a3);
            }(e2, i2, a2, r2, o2) : t.cq(a2) ? function(e3, t2, i3, a3, r3) {
              if ("translucent" !== e3.renderPass) return;
              const { isRenderingToTexture: o3 } = r3, s2 = i3.paint.get("line-opacity"), n2 = i3.paint.get("line-width");
              if (0 === s2.constantOr(1) || 0 === n2.constantOr(1)) return;
              const l2 = e3.getDepthModeForSublayer(0, ti.ReadOnly), c2 = e3.colorModeForRenderPass(), h2 = i3.paint.get("line-dasharray"), u2 = h2.constantOr(1), d2 = i3.paint.get("line-pattern"), _2 = d2.constantOr(1), p2 = i3.paint.get("line-gradient"), m2 = i3.getCrossfadeParameters();
              let f2;
              f2 = _2 ? "linePattern" : u2 && p2 ? "lineGradientSDF" : u2 ? "lineSDF" : p2 ? "lineGradient" : "line";
              const g2 = e3.context, v2 = g2.gl, x2 = e3.transform;
              let b2 = true;
              for (const r4 of a3) {
                const a4 = t2.getTile(r4);
                if (_2 && !a4.patternsLoaded()) continue;
                const s3 = a4.getBucket(i3);
                if (!s3) continue;
                const n3 = s3.programConfigurations.get(i3.id), y2 = e3.context.program.get(), w2 = e3.useProgram(f2, n3), T2 = b2 || w2.program !== y2, P2 = e3.style.map.terrain && e3.style.map.terrain.getTerrainData(r4), I2 = d2.constantOr(null), C2 = h2 && h2.constantOr(null);
                if (I2 && a4.imageAtlas) {
                  const e4 = a4.imageAtlas, t3 = e4.patternPositions[I2.to.toString()], i4 = e4.patternPositions[I2.from.toString()];
                  t3 && i4 && n3.setConstantPatternPositions(t3, i4);
                } else if (C2) {
                  const t3 = "round" === i3.layout.get("line-cap"), a5 = e3.lineAtlas.getDash(C2.to, t3), r5 = e3.lineAtlas.getDash(C2.from, t3);
                  n3.setConstantDashPositions(a5, r5);
                }
                const M2 = x2.getProjectionData({ overscaledTileID: r4, applyGlobeMatrix: !o3, applyTerrainMatrix: true }), E2 = x2.getPixelScale();
                let S2;
                _2 ? (S2 = sa(e3, a4, i3, E2, m2), wr(g2, v2, a4, n3, m2)) : u2 && p2 ? (S2 = la(e3, a4, i3, E2, m2, s3.lineClipsArray.length), Ir(e3, t2, g2, v2, i3, s3, r4, n3, m2)) : u2 ? (S2 = na(e3, a4, i3, E2, m2), Tr(e3, g2, v2, n3, T2, m2)) : p2 ? (S2 = oa(e3, a4, i3, E2, s3.lineClipsArray.length), Pr(e3, t2, g2, v2, i3, s3, r4)) : S2 = ra(e3, a4, i3, E2);
                const R2 = e3.stencilModeForClipping(r4);
                w2.draw(g2, v2.TRIANGLES, l2, R2, c2, ei.disabled, S2, P2, M2, i3.id, s3.layoutVertexBuffer, s3.indexBuffer, s3.segments, i3.paint, e3.transform.zoom, n3, s3.layoutVertexBuffer2), b2 = false;
              }
            }(e2, i2, a2, r2, o2) : t.cr(a2) ? function(e3, i3, a3, r3, o3) {
              const s2 = a3.paint.get("fill-color"), n2 = a3.paint.get("fill-opacity");
              if (0 === n2.constantOr(1)) return;
              const { isRenderingToTexture: l2 } = o3, c2 = e3.colorModeForRenderPass(), h2 = a3.paint.get("fill-pattern"), u2 = e3.opaquePassEnabledForLayer() && !h2.constantOr(1) && 1 === s2.constantOr(t.bq.transparent).a && 1 === n2.constantOr(0) ? "opaque" : "translucent";
              if (e3.renderPass === u2) {
                const t2 = e3.getDepthModeForSublayer(1, "opaque" === e3.renderPass ? ti.ReadWrite : ti.ReadOnly);
                Mr(e3, i3, a3, r3, t2, c2, false, l2);
              }
              if ("translucent" === e3.renderPass && a3.paint.get("fill-antialias")) {
                const t2 = e3.getDepthModeForSublayer(a3.getPaintProperty("fill-outline-color") ? 2 : 0, ti.ReadOnly);
                Mr(e3, i3, a3, r3, t2, c2, true, l2);
              }
            }(e2, i2, a2, r2, o2) : t.cs(a2) ? function(e3, t2, i3, a3, r3) {
              const o3 = i3.paint.get("fill-extrusion-opacity");
              if (0 === o3) return;
              const { isRenderingToTexture: s2 } = r3;
              if ("translucent" === e3.renderPass) {
                const r4 = new ti(e3.context.gl.LEQUAL, ti.ReadWrite, e3.depthRangeFor3D);
                if (1 !== o3 || i3.paint.get("fill-extrusion-pattern").constantOr(1)) Er(e3, t2, i3, a3, r4, ai.disabled, Qt.disabled, s2), Er(e3, t2, i3, a3, r4, e3.stencilModeFor3D(), e3.colorModeForRenderPass(), s2);
                else {
                  const o4 = e3.colorModeForRenderPass();
                  Er(e3, t2, i3, a3, r4, ai.disabled, o4, s2);
                }
              }
            }(e2, i2, a2, r2, o2) : t.ct(a2) ? function(e3, i3, a3, r3, o3) {
              if ("offscreen" !== e3.renderPass && "translucent" !== e3.renderPass) return;
              const { isRenderingToTexture: s2 } = o3, n2 = e3.context, l2 = e3.style.projection.useSubdivision, c2 = e3.getDepthModeForSublayer(0, ti.ReadOnly), h2 = e3.colorModeForRenderPass();
              if ("offscreen" === e3.renderPass) !function(e4, i4, a4, r4, o4, s3, n3) {
                const l3 = e4.context, c3 = l3.gl;
                for (const h3 of a4) {
                  const a5 = i4.getTile(h3), u2 = a5.dem;
                  if (!u2 || !u2.data) continue;
                  if (!a5.needsHillshadePrepare) continue;
                  const d2 = u2.dim, _2 = u2.stride, p2 = u2.getPixels();
                  if (l3.activeTexture.set(c3.TEXTURE1), l3.pixelStoreUnpackPremultiplyAlpha.set(false), a5.demTexture = a5.demTexture || e4.getTileTexture(_2), a5.demTexture) {
                    const e5 = a5.demTexture;
                    e5.update(p2, { premultiply: false }), e5.bind(c3.NEAREST, c3.CLAMP_TO_EDGE);
                  } else a5.demTexture = new t.T(l3, p2, c3.RGBA, { premultiply: false }), a5.demTexture.bind(c3.NEAREST, c3.CLAMP_TO_EDGE);
                  l3.activeTexture.set(c3.TEXTURE0);
                  let m2 = a5.fbo;
                  if (!m2) {
                    const e5 = new t.T(l3, { width: d2, height: d2, data: null }, c3.RGBA);
                    e5.bind(c3.LINEAR, c3.CLAMP_TO_EDGE), m2 = a5.fbo = l3.createFramebuffer(d2, d2, true, false), m2.colorAttachment.set(e5.texture);
                  }
                  l3.bindFramebuffer.set(m2.framebuffer), l3.viewport.set([0, 0, d2, d2]), e4.useProgram("hillshadePrepare").draw(l3, c3.TRIANGLES, o4, s3, n3, ei.disabled, ta(a5.tileID, u2), null, null, r4.id, e4.rasterBoundsBuffer, e4.quadTriangleIndexBuffer, e4.rasterBoundsSegments), a5.needsHillshadePrepare = false;
                }
              }(e3, i3, r3, a3, c2, ai.disabled, h2), n2.viewport.set([0, 0, e3.width, e3.height]);
              else if ("translucent" === e3.renderPass) if (l2) {
                const [t2, o4, n3] = e3.stencilConfigForOverlapTwoPass(r3);
                Sr(e3, i3, a3, n3, t2, c2, h2, false, s2), Sr(e3, i3, a3, n3, o4, c2, h2, true, s2);
              } else {
                const [t2, o4] = e3.getStencilConfigForOverlapAndUpdateStencilID(r3);
                Sr(e3, i3, a3, o4, t2, c2, h2, false, s2);
              }
            }(e2, i2, a2, r2, o2) : t.cu(a2) ? function(e3, t2, i3, a3, r3) {
              if ("translucent" !== e3.renderPass) return;
              if (!a3.length) return;
              const { isRenderingToTexture: o3 } = r3, s2 = e3.style.projection.useSubdivision, n2 = e3.getDepthModeForSublayer(0, ti.ReadOnly), l2 = e3.colorModeForRenderPass();
              if (s2) {
                const [r4, s3, c2] = e3.stencilConfigForOverlapTwoPass(a3);
                Rr(e3, t2, i3, c2, r4, n2, l2, false, o3), Rr(e3, t2, i3, c2, s3, n2, l2, true, o3);
              } else {
                const [r4, s3] = e3.getStencilConfigForOverlapAndUpdateStencilID(a3);
                Rr(e3, t2, i3, s3, r4, n2, l2, false, o3);
              }
            }(e2, i2, a2, r2, o2) : t.bV(a2) ? function(e3, t2, i3, a3, r3) {
              if ("translucent" !== e3.renderPass) return;
              if (0 === i3.paint.get("raster-opacity")) return;
              if (!a3.length) return;
              const { isRenderingToTexture: o3 } = r3, s2 = t2.getSource(), n2 = e3.style.projection.useSubdivision;
              if (s2 instanceof te) Dr(e3, t2, i3, a3, null, false, false, s2.tileCoords, s2.flippedWindingOrder, o3);
              else if (n2) {
                const [r4, s3, n3] = e3.stencilConfigForOverlapTwoPass(a3);
                Dr(e3, t2, i3, n3, r4, false, true, zr, false, o3), Dr(e3, t2, i3, n3, s3, true, true, zr, false, o3);
              } else {
                const [r4, s3] = e3.getStencilConfigForOverlapAndUpdateStencilID(a3);
                Dr(e3, t2, i3, s3, r4, false, true, zr, false, o3);
              }
            }(e2, i2, a2, r2, o2) : t.cv(a2) ? function(e3, t2, i3, a3, r3) {
              const o3 = i3.paint.get("background-color"), s2 = i3.paint.get("background-opacity");
              if (0 === s2) return;
              const { isRenderingToTexture: n2 } = r3, l2 = e3.context, c2 = l2.gl, h2 = e3.style.projection, u2 = e3.transform, d2 = u2.tileSize, _2 = i3.paint.get("background-pattern");
              if (e3.isPatternMissing(_2)) return;
              const p2 = !_2 && 1 === o3.a && 1 === s2 && e3.opaquePassEnabledForLayer() ? "opaque" : "translucent";
              if (e3.renderPass !== p2) return;
              const m2 = ai.disabled, f2 = e3.getDepthModeForSublayer(0, "opaque" === p2 ? ti.ReadWrite : ti.ReadOnly), g2 = e3.colorModeForRenderPass(), v2 = e3.useProgram(_2 ? "backgroundPattern" : "background"), x2 = a3 || Ce(u2, { tileSize: d2, terrain: e3.style.map.terrain });
              _2 && (l2.activeTexture.set(c2.TEXTURE0), e3.imageManager.bind(e3.context));
              const b2 = i3.getCrossfadeParameters();
              for (const t3 of x2) {
                const a4 = u2.getProjectionData({ overscaledTileID: t3, applyGlobeMatrix: !n2, applyTerrainMatrix: true }), r4 = _2 ? ga(s2, e3, _2, { tileID: t3, tileSize: d2 }, b2) : fa(s2, o3), p3 = e3.style.map.terrain && e3.style.map.terrain.getTerrainData(t3), x3 = h2.getMeshFromTileID(l2, t3.canonical, false, true, "raster");
                v2.draw(l2, c2.TRIANGLES, f2, m2, g2, ei.backCCW, r4, p3, a4, i3.id, x3.vertexBuffer, x3.indexBuffer, x3.segments);
              }
            }(e2, 0, a2, r2, o2) : t.cw(a2) && function(e3, t2, i3, a3) {
              const { isRenderingGlobe: r3 } = a3, o3 = e3.context, s2 = i3.implementation, n2 = e3.style.projection, l2 = e3.transform, c2 = l2.getProjectionDataForCustomLayer(r3), h2 = { farZ: l2.farZ, nearZ: l2.nearZ, fov: l2.fov * Math.PI / 180, modelViewProjectionMatrix: l2.modelViewProjectionMatrix, projectionMatrix: l2.projectionMatrix, shaderData: { variantName: n2.shaderVariantName, vertexShaderPrelude: `const float PI = 3.141592653589793;
uniform mat4 u_projection_matrix;
${n2.shaderPreludeCode.vertexSource}`, define: n2.shaderDefine }, defaultProjectionData: c2 }, u2 = s2.renderingMode ? s2.renderingMode : "2d";
              if ("offscreen" === e3.renderPass) {
                const t3 = s2.prerender;
                t3 && (e3.setCustomLayerDefaults(), o3.setColorMode(e3.colorModeForRenderPass()), t3.call(s2, o3.gl, h2), o3.setDirty(), e3.setBaseState());
              } else if ("translucent" === e3.renderPass) {
                e3.setCustomLayerDefaults(), o3.setColorMode(e3.colorModeForRenderPass()), o3.setStencilMode(ai.disabled);
                const t3 = "3d" === u2 ? e3.getDepthModeFor3D() : e3.getDepthModeForSublayer(0, ti.ReadOnly);
                o3.setDepthMode(t3), s2.render(o3.gl, h2), o3.setDirty(), e3.setBaseState(), o3.bindFramebuffer.set(null);
              }
            }(e2, 0, a2, o2));
          }
          saveTileTexture(e2) {
            const t2 = this._tileTextures[e2.size[0]];
            t2 ? t2.push(e2) : this._tileTextures[e2.size[0]] = [e2];
          }
          getTileTexture(e2) {
            const t2 = this._tileTextures[e2];
            return t2 && t2.length > 0 ? t2.pop() : null;
          }
          isPatternMissing(e2) {
            if (!e2) return false;
            if (!e2.from || !e2.to) return true;
            const t2 = this.imageManager.getPattern(e2.from.toString()), i2 = this.imageManager.getPattern(e2.to.toString());
            return !t2 || !i2;
          }
          useProgram(e2, t2, i2 = false, a2 = []) {
            this.cache = this.cache || {};
            const r2 = !!this.style.map.terrain, o2 = this.style.projection, s2 = i2 ? At.projectionMercator : o2.shaderPreludeCode, n2 = i2 ? Bt : o2.shaderDefine, l2 = e2 + (t2 ? t2.cacheKey : "") + `/${i2 ? Ot : o2.shaderVariantName}` + (this._showOverdrawInspector ? "/overdraw" : "") + (r2 ? "/terrain" : "") + (a2 ? `/${a2.join("/")}` : "");
            return this.cache[l2] || (this.cache[l2] = new Zi(this.context, At[e2], t2, xa[e2], this._showOverdrawInspector, r2, s2, n2, a2)), this.cache[l2];
          }
          setCustomLayerDefaults() {
            this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
          }
          setBaseState() {
            const e2 = this.context.gl;
            this.context.cullFace.set(false), this.context.viewport.set([0, 0, this.width, this.height]), this.context.blendEquation.set(e2.FUNC_ADD);
          }
          initDebugOverlayCanvas() {
            null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new t.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
          }
          destroy() {
            var e2, t2;
            if (this._tileTextures) {
              for (const e3 in this._tileTextures) {
                const t3 = this._tileTextures[e3];
                if (t3) for (const e4 of t3) e4.destroy();
              }
              this._tileTextures = {};
            }
            if (this.tileExtentBuffer && this.tileExtentBuffer.destroy(), this.debugBuffer && this.debugBuffer.destroy(), this.rasterBoundsBuffer && this.rasterBoundsBuffer.destroy(), this.rasterBoundsBufferPosOnly && this.rasterBoundsBufferPosOnly.destroy(), this.viewportBuffer && this.viewportBuffer.destroy(), this.tileBorderIndexBuffer && this.tileBorderIndexBuffer.destroy(), this.quadTriangleIndexBuffer && this.quadTriangleIndexBuffer.destroy(), this.tileExtentMesh && (null === (e2 = this.tileExtentMesh.vertexBuffer) || void 0 === e2 || e2.destroy()), this.tileExtentMesh && (null === (t2 = this.tileExtentMesh.indexBuffer) || void 0 === t2 || t2.destroy()), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this.cache) {
              for (const e3 in this.cache) {
                const t3 = this.cache[e3];
                t3 && t3.program && this.context.gl.deleteProgram(t3.program);
              }
              this.cache = {};
            }
            this.context && this.context.setDefault();
          }
          overLimit() {
            const { drawingBufferWidth: e2, drawingBufferHeight: t2 } = this.context.gl;
            return this.width !== e2 || this.height !== t2;
          }
        }
        function Wr(e2, t2) {
          let i2, a2 = false, r2 = null, o2 = null;
          const s2 = () => {
            r2 = null, a2 && (e2.apply(o2, i2), r2 = setTimeout(s2, t2), a2 = false);
          };
          return (...e3) => (a2 = true, o2 = this, i2 = e3, r2 || s2(), r2);
        }
        class $r {
          constructor(e2) {
            this._getCurrentHash = () => {
              const e3 = window.location.hash.replace("#", "");
              if (this._hashName) {
                let t2;
                return e3.split("&").map((e4) => e4.split("=")).forEach((e4) => {
                  e4[0] === this._hashName && (t2 = e4);
                }), (t2 && t2[1] || "").split("/");
              }
              return e3.split("/");
            }, this._onHashChange = () => {
              const e3 = this._getCurrentHash();
              if (!this._isValidHash(e3)) return false;
              const t2 = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(e3[3] || 0) : this._map.getBearing();
              return this._map.jumpTo({ center: [+e3[2], +e3[1]], zoom: +e3[0], bearing: t2, pitch: +(e3[4] || 0) }), true;
            }, this._updateHashUnthrottled = () => {
              const e3 = window.location.href.replace(/(#.*)?$/, this.getHashString());
              window.history.replaceState(window.history.state, null, e3);
            }, this._removeHash = () => {
              const e3 = this._getCurrentHash();
              if (0 === e3.length) return;
              const t2 = e3.join("/");
              let i2 = t2;
              i2.split("&").length > 0 && (i2 = i2.split("&")[0]), this._hashName && (i2 = `${this._hashName}=${t2}`);
              let a2 = window.location.hash.replace(i2, "");
              a2.startsWith("#&") ? a2 = a2.slice(0, 1) + a2.slice(2) : "#" === a2 && (a2 = "");
              let r2 = window.location.href.replace(/(#.+)?$/, a2);
              r2 = r2.replace("&&", "&"), window.history.replaceState(window.history.state, null, r2);
            }, this._updateHash = Wr(this._updateHashUnthrottled, 300), this._hashName = e2 && encodeURIComponent(e2);
          }
          addTo(e2) {
            return this._map = e2, addEventListener("hashchange", this._onHashChange, false), this._map.on("moveend", this._updateHash), this;
          }
          remove() {
            return removeEventListener("hashchange", this._onHashChange, false), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
          }
          getHashString(e2) {
            const t2 = this._map.getCenter(), i2 = Math.round(100 * this._map.getZoom()) / 100, a2 = Math.ceil((i2 * Math.LN2 + Math.log(512 / 360 / 0.5)) / Math.LN10), r2 = Math.pow(10, a2), o2 = Math.round(t2.lng * r2) / r2, s2 = Math.round(t2.lat * r2) / r2, n2 = this._map.getBearing(), l2 = this._map.getPitch();
            let c2 = "";
            if (c2 += e2 ? `/${o2}/${s2}/${i2}` : `${i2}/${s2}/${o2}`, (n2 || l2) && (c2 += "/" + Math.round(10 * n2) / 10), l2 && (c2 += `/${Math.round(l2)}`), this._hashName) {
              const e3 = this._hashName;
              let t3 = false;
              const i3 = window.location.hash.slice(1).split("&").map((i4) => {
                const a3 = i4.split("=")[0];
                return a3 === e3 ? (t3 = true, `${a3}=${c2}`) : i4;
              }).filter((e4) => e4);
              return t3 || i3.push(`${e3}=${c2}`), `#${i3.join("&")}`;
            }
            return `#${c2}`;
          }
          _isValidHash(e2) {
            if (e2.length < 3 || e2.some(isNaN)) return false;
            try {
              new t.V(+e2[2], +e2[1]);
            } catch (e3) {
              return false;
            }
            const i2 = +e2[0], a2 = +(e2[3] || 0), r2 = +(e2[4] || 0);
            return i2 >= this._map.getMinZoom() && i2 <= this._map.getMaxZoom() && a2 >= -180 && a2 <= 180 && r2 >= this._map.getMinPitch() && r2 <= this._map.getMaxPitch();
          }
        }
        const Hr = { linearity: 0.3, easing: t.cx(0, 0, 0.3, 1) }, Xr = t.e({ deceleration: 2500, maxSpeed: 1400 }, Hr), Kr = t.e({ deceleration: 20, maxSpeed: 1400 }, Hr), Yr = t.e({ deceleration: 1e3, maxSpeed: 360 }, Hr), Qr = t.e({ deceleration: 1e3, maxSpeed: 90 }, Hr), Jr = t.e({ deceleration: 1e3, maxSpeed: 360 }, Hr);
        class eo {
          constructor(e2) {
            this._map = e2, this.clear();
          }
          clear() {
            this._inertiaBuffer = [];
          }
          record(e2) {
            this._drainInertiaBuffer(), this._inertiaBuffer.push({ time: c(), settings: e2 });
          }
          _drainInertiaBuffer() {
            const e2 = this._inertiaBuffer, t2 = c();
            for (; e2.length > 0 && t2 - e2[0].time > 160; ) e2.shift();
          }
          _onMoveEnd(e2) {
            if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
            const i2 = { zoom: 0, bearing: 0, pitch: 0, roll: 0, pan: new t.P(0, 0), pinchAround: void 0, around: void 0 };
            for (const { settings: e3 } of this._inertiaBuffer) i2.zoom += e3.zoomDelta || 0, i2.bearing += e3.bearingDelta || 0, i2.pitch += e3.pitchDelta || 0, i2.roll += e3.rollDelta || 0, e3.panDelta && i2.pan._add(e3.panDelta), e3.around && (i2.around = e3.around), e3.pinchAround && (i2.pinchAround = e3.pinchAround);
            const a2 = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, r2 = {};
            if (i2.pan.mag()) {
              const o2 = io(i2.pan.mag(), a2, t.e({}, Xr, e2 || {})), s2 = i2.pan.mult(o2.amount / i2.pan.mag()), n2 = this._map.cameraHelper.handlePanInertia(s2, this._map.transform);
              r2.center = n2.easingCenter, r2.offset = n2.easingOffset, to(r2, o2);
            }
            if (i2.zoom) {
              const e3 = io(i2.zoom, a2, Kr);
              r2.zoom = this._map.transform.zoom + e3.amount, to(r2, e3);
            }
            if (i2.bearing) {
              const e3 = io(i2.bearing, a2, Yr);
              r2.bearing = this._map.transform.bearing + t.ao(e3.amount, -179, 179), to(r2, e3);
            }
            if (i2.pitch) {
              const e3 = io(i2.pitch, a2, Qr);
              r2.pitch = this._map.transform.pitch + e3.amount, to(r2, e3);
            }
            if (i2.roll) {
              const e3 = io(i2.roll, a2, Jr);
              r2.roll = this._map.transform.roll + t.ao(e3.amount, -179, 179), to(r2, e3);
            }
            if (r2.zoom || r2.bearing) {
              const e3 = void 0 === i2.pinchAround ? i2.around : i2.pinchAround;
              r2.around = e3 ? this._map.unproject(e3) : this._map.getCenter();
            }
            return this.clear(), t.e(r2, { noMoveStart: true });
          }
        }
        function to(e2, t2) {
          (!e2.duration || e2.duration < t2.duration) && (e2.duration = t2.duration, e2.easing = t2.easing);
        }
        function io(e2, i2, a2) {
          const { maxSpeed: r2, linearity: o2, deceleration: s2 } = a2, n2 = t.ao(e2 * o2 / (i2 / 1e3), -r2, r2), l2 = Math.abs(n2) / (s2 * o2);
          return { easing: a2.easing, duration: 1e3 * l2, amount: n2 * (l2 / 2) };
        }
        class ao extends t.l {
          preventDefault() {
            this._defaultPrevented = true;
          }
          get defaultPrevented() {
            return this._defaultPrevented;
          }
          constructor(e2, i2, a2, r2 = {}) {
            a2 = a2 instanceof MouseEvent ? a2 : new MouseEvent(e2, a2);
            const o2 = h.mousePos(i2.getCanvas(), a2), s2 = i2.unproject(o2);
            super(e2, t.e({ point: o2, lngLat: s2, originalEvent: a2 }, r2)), this._defaultPrevented = false, this.target = i2;
          }
        }
        class ro extends t.l {
          preventDefault() {
            this._defaultPrevented = true;
          }
          get defaultPrevented() {
            return this._defaultPrevented;
          }
          constructor(e2, i2, a2) {
            const r2 = "touchend" === e2 ? a2.changedTouches : a2.touches, o2 = h.touchPos(i2.getCanvasContainer(), r2), s2 = o2.map((e3) => i2.unproject(e3)), n2 = o2.reduce((e3, t2, i3, a3) => e3.add(t2.div(a3.length)), new t.P(0, 0));
            super(e2, { points: o2, point: n2, lngLats: s2, lngLat: i2.unproject(n2), originalEvent: a2 }), this._defaultPrevented = false;
          }
        }
        class oo extends t.l {
          preventDefault() {
            this._defaultPrevented = true;
          }
          get defaultPrevented() {
            return this._defaultPrevented;
          }
          constructor(e2, t2, i2) {
            super(e2, { originalEvent: i2 }), this._defaultPrevented = false;
          }
        }
        class so {
          constructor(e2, t2) {
            this._map = e2, this._clickTolerance = t2.clickTolerance;
          }
          reset() {
            delete this._mousedownPos;
          }
          wheel(e2) {
            return this._firePreventable(new oo(e2.type, this._map, e2));
          }
          mousedown(e2, t2) {
            return this._mousedownPos = t2, this._firePreventable(new ao(e2.type, this._map, e2));
          }
          mouseup(e2) {
            this._map.fire(new ao(e2.type, this._map, e2));
          }
          click(e2, t2) {
            this._mousedownPos && this._mousedownPos.dist(t2) >= this._clickTolerance || this._map.fire(new ao(e2.type, this._map, e2));
          }
          dblclick(e2) {
            return this._firePreventable(new ao(e2.type, this._map, e2));
          }
          mouseover(e2) {
            this._map.fire(new ao(e2.type, this._map, e2));
          }
          mouseout(e2) {
            this._map.fire(new ao(e2.type, this._map, e2));
          }
          touchstart(e2) {
            return this._firePreventable(new ro(e2.type, this._map, e2));
          }
          touchmove(e2) {
            this._map.fire(new ro(e2.type, this._map, e2));
          }
          touchend(e2) {
            this._map.fire(new ro(e2.type, this._map, e2));
          }
          touchcancel(e2) {
            this._map.fire(new ro(e2.type, this._map, e2));
          }
          _firePreventable(e2) {
            if (this._map.fire(e2), e2.defaultPrevented) return {};
          }
          isEnabled() {
            return true;
          }
          isActive() {
            return false;
          }
          enable() {
          }
          disable() {
          }
        }
        class no {
          constructor(e2) {
            this._map = e2;
          }
          reset() {
            this._delayContextMenu = false, this._ignoreContextMenu = true, delete this._contextMenuEvent;
          }
          mousemove(e2) {
            this._map.fire(new ao(e2.type, this._map, e2));
          }
          mousedown() {
            this._delayContextMenu = true, this._ignoreContextMenu = false;
          }
          mouseup() {
            this._delayContextMenu = false, this._contextMenuEvent && (this._map.fire(new ao("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
          }
          contextmenu(e2) {
            this._delayContextMenu ? this._contextMenuEvent = e2 : this._ignoreContextMenu || this._map.fire(new ao(e2.type, this._map, e2)), this._map.listens("contextmenu") && e2.preventDefault();
          }
          isEnabled() {
            return true;
          }
          isActive() {
            return false;
          }
          enable() {
          }
          disable() {
          }
        }
        class lo {
          constructor(e2) {
            this._map = e2;
          }
          get transform() {
            return this._map._requestedCameraState || this._map.transform;
          }
          get center() {
            return { lng: this.transform.center.lng, lat: this.transform.center.lat };
          }
          get zoom() {
            return this.transform.zoom;
          }
          get pitch() {
            return this.transform.pitch;
          }
          get bearing() {
            return this.transform.bearing;
          }
          unproject(e2) {
            return this.transform.screenPointToLocation(t.P.convert(e2), this._map.terrain);
          }
        }
        class co {
          constructor(e2, t2) {
            this._map = e2, this._tr = new lo(e2), this._el = e2.getCanvasContainer(), this._container = e2.getContainer(), this._clickTolerance = t2.clickTolerance || 1;
          }
          isEnabled() {
            return !!this._enabled;
          }
          isActive() {
            return !!this._active;
          }
          enable() {
            this.isEnabled() || (this._enabled = true);
          }
          disable() {
            this.isEnabled() && (this._enabled = false);
          }
          mousedown(e2, t2) {
            this.isEnabled() && e2.shiftKey && 0 === e2.button && (h.disableDrag(), this._startPos = this._lastPos = t2, this._active = true);
          }
          mousemoveWindow(e2, t2) {
            if (!this._active) return;
            const i2 = t2;
            if (this._lastPos.equals(i2) || !this._box && i2.dist(this._startPos) < this._clickTolerance) return;
            const a2 = this._startPos;
            this._lastPos = i2, this._box || (this._box = h.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", e2));
            const r2 = Math.min(a2.x, i2.x), o2 = Math.max(a2.x, i2.x), s2 = Math.min(a2.y, i2.y), n2 = Math.max(a2.y, i2.y);
            h.setTransform(this._box, `translate(${r2}px,${s2}px)`), this._box.style.width = o2 - r2 + "px", this._box.style.height = n2 - s2 + "px";
          }
          mouseupWindow(e2, i2) {
            if (!this._active) return;
            if (0 !== e2.button) return;
            const a2 = this._startPos, r2 = i2;
            if (this.reset(), h.suppressClick(), a2.x !== r2.x || a2.y !== r2.y) return this._map.fire(new t.l("boxzoomend", { originalEvent: e2 })), { cameraAnimation: (e3) => e3.fitScreenCoordinates(a2, r2, this._tr.bearing, { linear: true }) };
            this._fireEvent("boxzoomcancel", e2);
          }
          keydown(e2) {
            this._active && 27 === e2.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e2));
          }
          reset() {
            this._active = false, this._container.classList.remove("maplibregl-crosshair"), this._box && (h.remove(this._box), this._box = null), h.enableDrag(), delete this._startPos, delete this._lastPos;
          }
          _fireEvent(e2, i2) {
            return this._map.fire(new t.l(e2, { originalEvent: i2 }));
          }
        }
        function ho(e2, t2) {
          if (e2.length !== t2.length) throw new Error(`The number of touches and points are not equal - touches ${e2.length}, points ${t2.length}`);
          const i2 = {};
          for (let a2 = 0; a2 < e2.length; a2++) i2[e2[a2].identifier] = t2[a2];
          return i2;
        }
        class uo {
          constructor(e2) {
            this.reset(), this.numTouches = e2.numTouches;
          }
          reset() {
            delete this.centroid, delete this.startTime, delete this.touches, this.aborted = false;
          }
          touchstart(e2, i2, a2) {
            (this.centroid || a2.length > this.numTouches) && (this.aborted = true), this.aborted || (void 0 === this.startTime && (this.startTime = e2.timeStamp), a2.length === this.numTouches && (this.centroid = function(e3) {
              const i3 = new t.P(0, 0);
              for (const t2 of e3) i3._add(t2);
              return i3.div(e3.length);
            }(i2), this.touches = ho(a2, i2)));
          }
          touchmove(e2, t2, i2) {
            if (this.aborted || !this.centroid) return;
            const a2 = ho(i2, t2);
            for (const e3 in this.touches) {
              const t3 = a2[e3];
              (!t3 || t3.dist(this.touches[e3]) > 30) && (this.aborted = true);
            }
          }
          touchend(e2, t2, i2) {
            if ((!this.centroid || e2.timeStamp - this.startTime > 500) && (this.aborted = true), 0 === i2.length) {
              const e3 = !this.aborted && this.centroid;
              if (this.reset(), e3) return e3;
            }
          }
        }
        class _o {
          constructor(e2) {
            this.singleTap = new uo(e2), this.numTaps = e2.numTaps, this.reset();
          }
          reset() {
            this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
          }
          touchstart(e2, t2, i2) {
            this.singleTap.touchstart(e2, t2, i2);
          }
          touchmove(e2, t2, i2) {
            this.singleTap.touchmove(e2, t2, i2);
          }
          touchend(e2, t2, i2) {
            const a2 = this.singleTap.touchend(e2, t2, i2);
            if (a2) {
              const t3 = e2.timeStamp - this.lastTime < 500, i3 = !this.lastTap || this.lastTap.dist(a2) < 30;
              if (t3 && i3 || this.reset(), this.count++, this.lastTime = e2.timeStamp, this.lastTap = a2, this.count === this.numTaps) return this.reset(), a2;
            }
          }
        }
        class po {
          constructor(e2) {
            this._tr = new lo(e2), this._zoomIn = new _o({ numTouches: 1, numTaps: 2 }), this._zoomOut = new _o({ numTouches: 2, numTaps: 1 }), this.reset();
          }
          reset() {
            this._active = false, this._zoomIn.reset(), this._zoomOut.reset();
          }
          touchstart(e2, t2, i2) {
            this._zoomIn.touchstart(e2, t2, i2), this._zoomOut.touchstart(e2, t2, i2);
          }
          touchmove(e2, t2, i2) {
            this._zoomIn.touchmove(e2, t2, i2), this._zoomOut.touchmove(e2, t2, i2);
          }
          touchend(e2, t2, i2) {
            const a2 = this._zoomIn.touchend(e2, t2, i2), r2 = this._zoomOut.touchend(e2, t2, i2), o2 = this._tr;
            return a2 ? (this._active = true, e2.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (t3) => t3.easeTo({ duration: 300, zoom: o2.zoom + 1, around: o2.unproject(a2) }, { originalEvent: e2 }) }) : r2 ? (this._active = true, e2.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (t3) => t3.easeTo({ duration: 300, zoom: o2.zoom - 1, around: o2.unproject(r2) }, { originalEvent: e2 }) }) : void 0;
          }
          touchcancel() {
            this.reset();
          }
          enable() {
            this._enabled = true;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return this._enabled;
          }
          isActive() {
            return this._active;
          }
        }
        class mo {
          constructor(e2) {
            this._enabled = !!e2.enable, this._moveStateManager = e2.moveStateManager, this._clickTolerance = e2.clickTolerance || 1, this._moveFunction = e2.move, this._activateOnStart = !!e2.activateOnStart, e2.assignEvents(this), this.reset();
          }
          reset(e2) {
            this._active = false, this._moved = false, delete this._lastPoint, this._moveStateManager.endMove(e2);
          }
          _move(...e2) {
            const t2 = this._moveFunction(...e2);
            if (t2.bearingDelta || t2.pitchDelta || t2.rollDelta || t2.around || t2.panDelta) return this._active = true, t2;
          }
          dragStart(e2, t2) {
            this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(e2) && (this._moveStateManager.startMove(e2), this._lastPoint = Array.isArray(t2) ? t2[0] : t2, this._activateOnStart && this._lastPoint && (this._active = true));
          }
          dragMove(e2, t2) {
            if (!this.isEnabled()) return;
            const i2 = this._lastPoint;
            if (!i2) return;
            if (e2.preventDefault(), !this._moveStateManager.isValidMoveEvent(e2)) return void this.reset(e2);
            const a2 = Array.isArray(t2) ? t2[0] : t2;
            return !this._moved && a2.dist(i2) < this._clickTolerance ? void 0 : (this._moved = true, this._lastPoint = a2, this._move(i2, a2));
          }
          dragEnd(e2) {
            this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(e2) && (this._moved && h.suppressClick(), this.reset(e2));
          }
          enable() {
            this._enabled = true;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return this._enabled;
          }
          isActive() {
            return this._active;
          }
          getClickTolerance() {
            return this._clickTolerance;
          }
        }
        const fo = 0, go = 2, vo = { [fo]: 1, [go]: 2 };
        class xo {
          constructor(e2) {
            this._correctEvent = e2.checkCorrectEvent;
          }
          startMove(e2) {
            const t2 = h.mouseButton(e2);
            this._eventButton = t2;
          }
          endMove(e2) {
            delete this._eventButton;
          }
          isValidStartEvent(e2) {
            return this._correctEvent(e2);
          }
          isValidMoveEvent(e2) {
            return !function(e3, t2) {
              const i2 = vo[t2];
              return void 0 === e3.buttons || (e3.buttons & i2) !== i2;
            }(e2, this._eventButton);
          }
          isValidEndEvent(e2) {
            return h.mouseButton(e2) === this._eventButton;
          }
        }
        class bo {
          constructor() {
            this._firstTouch = void 0;
          }
          _isOneFingerTouch(e2) {
            return 1 === e2.targetTouches.length;
          }
          _isSameTouchEvent(e2) {
            return e2.targetTouches[0].identifier === this._firstTouch;
          }
          startMove(e2) {
            this._firstTouch = e2.targetTouches[0].identifier;
          }
          endMove(e2) {
            delete this._firstTouch;
          }
          isValidStartEvent(e2) {
            return this._isOneFingerTouch(e2);
          }
          isValidMoveEvent(e2) {
            return this._isOneFingerTouch(e2) && this._isSameTouchEvent(e2);
          }
          isValidEndEvent(e2) {
            return this._isOneFingerTouch(e2) && this._isSameTouchEvent(e2);
          }
        }
        class yo {
          constructor(e2 = new xo({ checkCorrectEvent: () => true }), t2 = new bo()) {
            this.mouseMoveStateManager = e2, this.oneFingerTouchMoveStateManager = t2;
          }
          _executeRelevantHandler(e2, t2, i2) {
            return e2 instanceof MouseEvent ? t2(e2) : "undefined" != typeof TouchEvent && e2 instanceof TouchEvent ? i2(e2) : void 0;
          }
          startMove(e2) {
            this._executeRelevantHandler(e2, (e3) => this.mouseMoveStateManager.startMove(e3), (e3) => this.oneFingerTouchMoveStateManager.startMove(e3));
          }
          endMove(e2) {
            this._executeRelevantHandler(e2, (e3) => this.mouseMoveStateManager.endMove(e3), (e3) => this.oneFingerTouchMoveStateManager.endMove(e3));
          }
          isValidStartEvent(e2) {
            return this._executeRelevantHandler(e2, (e3) => this.mouseMoveStateManager.isValidStartEvent(e3), (e3) => this.oneFingerTouchMoveStateManager.isValidStartEvent(e3));
          }
          isValidMoveEvent(e2) {
            return this._executeRelevantHandler(e2, (e3) => this.mouseMoveStateManager.isValidMoveEvent(e3), (e3) => this.oneFingerTouchMoveStateManager.isValidMoveEvent(e3));
          }
          isValidEndEvent(e2) {
            return this._executeRelevantHandler(e2, (e3) => this.mouseMoveStateManager.isValidEndEvent(e3), (e3) => this.oneFingerTouchMoveStateManager.isValidEndEvent(e3));
          }
        }
        const wo = (e2) => {
          e2.mousedown = e2.dragStart, e2.mousemoveWindow = e2.dragMove, e2.mouseup = e2.dragEnd, e2.contextmenu = (e3) => {
            e3.preventDefault();
          };
        };
        class To {
          constructor(e2, t2) {
            this._clickTolerance = e2.clickTolerance || 1, this._map = t2, this.reset();
          }
          reset() {
            this._active = false, this._touches = {}, this._sum = new t.P(0, 0);
          }
          _shouldBePrevented(e2) {
            return e2 < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
          }
          touchstart(e2, t2, i2) {
            return this._calculateTransform(e2, t2, i2);
          }
          touchmove(e2, t2, i2) {
            if (this._active) {
              if (!this._shouldBePrevented(i2.length)) return e2.preventDefault(), this._calculateTransform(e2, t2, i2);
              this._map.cooperativeGestures.notifyGestureBlocked("touch_pan", e2);
            }
          }
          touchend(e2, t2, i2) {
            this._calculateTransform(e2, t2, i2), this._active && this._shouldBePrevented(i2.length) && this.reset();
          }
          touchcancel() {
            this.reset();
          }
          _calculateTransform(e2, i2, a2) {
            a2.length > 0 && (this._active = true);
            const r2 = ho(a2, i2), o2 = new t.P(0, 0), s2 = new t.P(0, 0);
            let n2 = 0;
            for (const e3 in r2) {
              const t2 = r2[e3], i3 = this._touches[e3];
              i3 && (o2._add(t2), s2._add(t2.sub(i3)), n2++, r2[e3] = t2);
            }
            if (this._touches = r2, this._shouldBePrevented(n2) || !s2.mag()) return;
            const l2 = s2.div(n2);
            return this._sum._add(l2), this._sum.mag() < this._clickTolerance ? void 0 : { around: o2.div(n2), panDelta: l2 };
          }
          enable() {
            this._enabled = true;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return this._enabled;
          }
          isActive() {
            return this._active;
          }
        }
        class Po {
          constructor() {
            this.reset();
          }
          reset() {
            this._active = false, delete this._firstTwoTouches;
          }
          touchstart(e2, t2, i2) {
            this._firstTwoTouches || i2.length < 2 || (this._firstTwoTouches = [i2[0].identifier, i2[1].identifier], this._start([t2[0], t2[1]]));
          }
          touchmove(e2, t2, i2) {
            if (!this._firstTwoTouches) return;
            e2.preventDefault();
            const [a2, r2] = this._firstTwoTouches, o2 = Io(i2, t2, a2), s2 = Io(i2, t2, r2);
            if (!o2 || !s2) return;
            const n2 = this._aroundCenter ? null : o2.add(s2).div(2);
            return this._move([o2, s2], n2, e2);
          }
          touchend(e2, t2, i2) {
            if (!this._firstTwoTouches) return;
            const [a2, r2] = this._firstTwoTouches, o2 = Io(i2, t2, a2), s2 = Io(i2, t2, r2);
            o2 && s2 || (this._active && h.suppressClick(), this.reset());
          }
          touchcancel() {
            this.reset();
          }
          enable(e2) {
            this._enabled = true, this._aroundCenter = !!e2 && "center" === e2.around;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return !!this._enabled;
          }
          isActive() {
            return !!this._active;
          }
        }
        function Io(e2, t2, i2) {
          for (let a2 = 0; a2 < e2.length; a2++) if (e2[a2].identifier === i2) return t2[a2];
        }
        function Co(e2, t2) {
          return Math.log(e2 / t2) / Math.LN2;
        }
        class Mo extends Po {
          reset() {
            super.reset(), delete this._distance, delete this._startDistance;
          }
          _start(e2) {
            this._startDistance = this._distance = e2[0].dist(e2[1]);
          }
          _move(e2, t2) {
            const i2 = this._distance;
            if (this._distance = e2[0].dist(e2[1]), this._active || !(Math.abs(Co(this._distance, this._startDistance)) < 0.1)) return this._active = true, { zoomDelta: Co(this._distance, i2), pinchAround: t2 };
          }
        }
        function Eo(e2, t2) {
          return 180 * e2.angleWith(t2) / Math.PI;
        }
        class So extends Po {
          reset() {
            super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
          }
          _start(e2) {
            this._startVector = this._vector = e2[0].sub(e2[1]), this._minDiameter = e2[0].dist(e2[1]);
          }
          _move(e2, t2, i2) {
            const a2 = this._vector;
            if (this._vector = e2[0].sub(e2[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = true, { bearingDelta: Eo(this._vector, a2), pinchAround: t2 };
          }
          _isBelowThreshold(e2) {
            this._minDiameter = Math.min(this._minDiameter, e2.mag());
            const t2 = 25 / (Math.PI * this._minDiameter) * 360, i2 = Eo(e2, this._startVector);
            return Math.abs(i2) < t2;
          }
        }
        function Ro(e2) {
          return Math.abs(e2.y) > Math.abs(e2.x);
        }
        class zo extends Po {
          constructor(e2) {
            super(), this._currentTouchCount = 0, this._map = e2;
          }
          reset() {
            super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
          }
          touchstart(e2, t2, i2) {
            super.touchstart(e2, t2, i2), this._currentTouchCount = i2.length;
          }
          _start(e2) {
            this._lastPoints = e2, Ro(e2[0].sub(e2[1])) && (this._valid = false);
          }
          _move(e2, t2, i2) {
            if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
            const a2 = e2[0].sub(this._lastPoints[0]), r2 = e2[1].sub(this._lastPoints[1]);
            return this._valid = this.gestureBeginsVertically(a2, r2, i2.timeStamp), this._valid ? (this._lastPoints = e2, this._active = true, { pitchDelta: (a2.y + r2.y) / 2 * -0.5 }) : void 0;
          }
          gestureBeginsVertically(e2, t2, i2) {
            if (void 0 !== this._valid) return this._valid;
            const a2 = e2.mag() >= 2, r2 = t2.mag() >= 2;
            if (!a2 && !r2) return;
            if (!a2 || !r2) return void 0 === this._firstMove && (this._firstMove = i2), i2 - this._firstMove < 100 && void 0;
            const o2 = e2.y > 0 == t2.y > 0;
            return Ro(e2) && Ro(t2) && o2;
          }
        }
        const Do = { panStep: 100, bearingStep: 15, pitchStep: 10 };
        class Ao {
          constructor(e2) {
            this._tr = new lo(e2);
            const t2 = Do;
            this._panStep = t2.panStep, this._bearingStep = t2.bearingStep, this._pitchStep = t2.pitchStep, this._rotationDisabled = false;
          }
          reset() {
            this._active = false;
          }
          keydown(e2) {
            if (e2.altKey || e2.ctrlKey || e2.metaKey) return;
            let t2 = 0, i2 = 0, a2 = 0, r2 = 0, o2 = 0;
            switch (e2.keyCode) {
              case 61:
              case 107:
              case 171:
              case 187:
                t2 = 1;
                break;
              case 189:
              case 109:
              case 173:
                t2 = -1;
                break;
              case 37:
                e2.shiftKey ? i2 = -1 : (e2.preventDefault(), r2 = -1);
                break;
              case 39:
                e2.shiftKey ? i2 = 1 : (e2.preventDefault(), r2 = 1);
                break;
              case 38:
                e2.shiftKey ? a2 = 1 : (e2.preventDefault(), o2 = -1);
                break;
              case 40:
                e2.shiftKey ? a2 = -1 : (e2.preventDefault(), o2 = 1);
                break;
              default:
                return;
            }
            return this._rotationDisabled && (i2 = 0, a2 = 0), { cameraAnimation: (s2) => {
              const n2 = this._tr;
              s2.easeTo({ duration: 300, easeId: "keyboardHandler", easing: Lo, zoom: t2 ? Math.round(n2.zoom) + t2 * (e2.shiftKey ? 2 : 1) : n2.zoom, bearing: n2.bearing + i2 * this._bearingStep, pitch: n2.pitch + a2 * this._pitchStep, offset: [-r2 * this._panStep, -o2 * this._panStep], center: n2.center }, { originalEvent: e2 });
            } };
          }
          enable() {
            this._enabled = true;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return this._enabled;
          }
          isActive() {
            return this._active;
          }
          disableRotation() {
            this._rotationDisabled = true;
          }
          enableRotation() {
            this._rotationDisabled = false;
          }
        }
        function Lo(e2) {
          return e2 * (2 - e2);
        }
        const ko = 4.000244140625, Fo = 1 / 450;
        class Bo {
          constructor(e2, t2) {
            this._onTimeout = (e3) => {
              this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e3);
            }, this._map = e2, this._tr = new lo(e2), this._triggerRenderFrame = t2, this._delta = 0, this._defaultZoomRate = 0.01, this._wheelZoomRate = Fo;
          }
          setZoomRate(e2) {
            this._defaultZoomRate = e2;
          }
          setWheelZoomRate(e2) {
            this._wheelZoomRate = e2;
          }
          isEnabled() {
            return !!this._enabled;
          }
          isActive() {
            return !!this._active || void 0 !== this._finishTimeout;
          }
          isZooming() {
            return !!this._zooming;
          }
          enable(e2) {
            this.isEnabled() || (this._enabled = true, this._aroundCenter = !!e2 && "center" === e2.around);
          }
          disable() {
            this.isEnabled() && (this._enabled = false);
          }
          _shouldBePrevented(e2) {
            return !!this._map.cooperativeGestures.isEnabled() && !(e2.ctrlKey || this._map.cooperativeGestures.isBypassed(e2));
          }
          wheel(e2) {
            if (!this.isEnabled()) return;
            if (this._shouldBePrevented(e2)) return void this._map.cooperativeGestures.notifyGestureBlocked("wheel_zoom", e2);
            let t2 = e2.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * e2.deltaY : e2.deltaY;
            const i2 = c(), a2 = i2 - (this._lastWheelEventTime || 0);
            this._lastWheelEventTime = i2, 0 !== t2 && t2 % ko == 0 ? this._type = "wheel" : 0 !== t2 && Math.abs(t2) < 4 ? this._type = "trackpad" : a2 > 400 ? (this._type = null, this._lastValue = t2, this._timeout = setTimeout(this._onTimeout, 40, e2)) : this._type || (this._type = Math.abs(a2 * t2) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, t2 += this._lastValue)), e2.shiftKey && t2 && (t2 /= 4), this._type && (this._lastWheelEvent = e2, this._delta -= t2, this._active || this._start(e2)), e2.preventDefault();
          }
          _start(e2) {
            if (!this._delta) return;
            this._frameId && (this._frameId = null), this._active = true, this.isZooming() || (this._zooming = true), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
            const i2 = h.mousePos(this._map.getCanvas(), e2), a2 = this._tr;
            this._aroundPoint = this._aroundCenter ? a2.transform.locationToScreenPoint(t.V.convert(a2.center)) : i2, this._frameId || (this._frameId = true, this._triggerRenderFrame());
          }
          renderFrame() {
            if (!this._frameId) return;
            if (this._frameId = null, !this.isActive()) return;
            const e2 = this._tr.transform;
            if ("number" == typeof this._lastExpectedZoom) {
              const t2 = e2.zoom - this._lastExpectedZoom;
              "number" == typeof this._startZoom && (this._startZoom += t2), "number" == typeof this._targetZoom && (this._targetZoom += t2);
            }
            if (0 !== this._delta) {
              const i3 = "wheel" === this._type && Math.abs(this._delta) > ko ? this._wheelZoomRate : this._defaultZoomRate;
              let a3 = 2 / (1 + Math.exp(-Math.abs(this._delta * i3)));
              this._delta < 0 && 0 !== a3 && (a3 = 1 / a3);
              const r3 = "number" != typeof this._targetZoom ? e2.scale : t.ar(this._targetZoom);
              this._targetZoom = e2.applyConstrain(e2.getCameraLngLat(), t.au(r3 * a3)).zoom, "wheel" === this._type && (this._startZoom = e2.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
            }
            const i2 = "number" != typeof this._targetZoom ? e2.zoom : this._targetZoom, a2 = this._startZoom, r2 = this._easing;
            let o2, s2 = false;
            if ("wheel" === this._type && a2 && r2) {
              const e3 = c() - this._lastWheelEventTime, n2 = Math.min((e3 + 5) / 200, 1), l2 = r2(n2);
              o2 = t.G.number(a2, i2, l2), n2 < 1 ? this._frameId || (this._frameId = true) : s2 = true;
            } else o2 = i2, s2 = true;
            return this._active = true, s2 && (this._active = false, this._finishTimeout = setTimeout(() => {
              this._zooming = false, this._triggerRenderFrame(), delete this._targetZoom, delete this._lastExpectedZoom, delete this._finishTimeout;
            }, 200)), this._lastExpectedZoom = o2, { noInertia: true, needsRenderFrame: !s2, zoomDelta: o2 - e2.zoom, around: this._aroundPoint, originalEvent: this._lastWheelEvent };
          }
          _smoothOutEasing(e2) {
            let i2 = t.cz;
            if (this._prevEase) {
              const e3 = this._prevEase, a2 = (c() - e3.start) / e3.duration, r2 = e3.easing(a2 + 0.01) - e3.easing(a2), o2 = 0.27 / Math.sqrt(r2 * r2 + 1e-4) * 0.01, s2 = Math.sqrt(0.0729 - o2 * o2);
              i2 = t.cx(o2, s2, 0.25, 1);
            }
            return this._prevEase = { start: c(), duration: e2, easing: i2 }, i2;
          }
          reset() {
            this._active = false, this._zooming = false, delete this._targetZoom, delete this._lastExpectedZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
          }
        }
        class Oo {
          constructor(e2, t2) {
            this._clickZoom = e2, this._tapZoom = t2;
          }
          enable() {
            this._clickZoom.enable(), this._tapZoom.enable();
          }
          disable() {
            this._clickZoom.disable(), this._tapZoom.disable();
          }
          isEnabled() {
            return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
          }
          isActive() {
            return this._clickZoom.isActive() || this._tapZoom.isActive();
          }
        }
        class jo {
          constructor(e2) {
            this._tr = new lo(e2), this.reset();
          }
          reset() {
            this._active = false;
          }
          dblclick(e2, t2) {
            return e2.preventDefault(), { cameraAnimation: (i2) => {
              i2.easeTo({ duration: 300, zoom: this._tr.zoom + (e2.shiftKey ? -1 : 1), around: this._tr.unproject(t2) }, { originalEvent: e2 });
            } };
          }
          enable() {
            this._enabled = true;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return this._enabled;
          }
          isActive() {
            return this._active;
          }
        }
        class No {
          constructor() {
            this._tap = new _o({ numTouches: 1, numTaps: 1 }), this.reset();
          }
          reset() {
            this._active = false, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
          }
          touchstart(e2, t2, i2) {
            if (!this._swipePoint) if (this._tapTime) {
              const a2 = t2[0], r2 = e2.timeStamp - this._tapTime < 500, o2 = this._tapPoint.dist(a2) < 30;
              r2 && o2 ? i2.length > 0 && (this._swipePoint = a2, this._swipeTouch = i2[0].identifier) : this.reset();
            } else this._tap.touchstart(e2, t2, i2);
          }
          touchmove(e2, t2, i2) {
            if (this._tapTime) {
              if (this._swipePoint) {
                if (i2[0].identifier !== this._swipeTouch) return;
                const a2 = t2[0], r2 = a2.y - this._swipePoint.y;
                return this._swipePoint = a2, e2.preventDefault(), this._active = true, { zoomDelta: r2 / 128 };
              }
            } else this._tap.touchmove(e2, t2, i2);
          }
          touchend(e2, t2, i2) {
            if (this._tapTime) this._swipePoint && 0 === i2.length && this.reset();
            else {
              const a2 = this._tap.touchend(e2, t2, i2);
              a2 && (this._tapTime = e2.timeStamp, this._tapPoint = a2);
            }
          }
          touchcancel() {
            this.reset();
          }
          enable() {
            this._enabled = true;
          }
          disable() {
            this._enabled = false, this.reset();
          }
          isEnabled() {
            return this._enabled;
          }
          isActive() {
            return this._active;
          }
        }
        class Zo {
          constructor(e2, t2, i2) {
            this._el = e2, this._mousePan = t2, this._touchPan = i2;
          }
          enable(e2) {
            this._inertiaOptions = e2 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
          }
          disable() {
            this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
          }
          isEnabled() {
            return this._mousePan.isEnabled() && this._touchPan.isEnabled();
          }
          isActive() {
            return this._mousePan.isActive() || this._touchPan.isActive();
          }
        }
        class Go {
          constructor(e2, t2, i2, a2) {
            this._pitchWithRotate = e2.pitchWithRotate, this._rollEnabled = e2.rollEnabled, this._mouseRotate = t2, this._mousePitch = i2, this._mouseRoll = a2;
          }
          enable() {
            this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable(), this._rollEnabled && this._mouseRoll.enable();
          }
          disable() {
            this._mouseRotate.disable(), this._mousePitch.disable(), this._mouseRoll.disable();
          }
          isEnabled() {
            return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled()) && (!this._rollEnabled || this._mouseRoll.isEnabled());
          }
          isActive() {
            return this._mouseRotate.isActive() || this._mousePitch.isActive() || this._mouseRoll.isActive();
          }
        }
        class Uo {
          constructor(e2, t2, i2, a2) {
            this._el = e2, this._touchZoom = t2, this._touchRotate = i2, this._tapDragZoom = a2, this._rotationDisabled = false, this._enabled = true;
          }
          enable(e2) {
            this._touchZoom.enable(e2), this._rotationDisabled || this._touchRotate.enable(e2), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
          }
          disable() {
            this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
          }
          isEnabled() {
            return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
          }
          isActive() {
            return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
          }
          disableRotation() {
            this._rotationDisabled = true, this._touchRotate.disable();
          }
          enableRotation() {
            this._rotationDisabled = false, this._touchZoom.isEnabled() && this._touchRotate.enable();
          }
        }
        class Vo {
          constructor(e2, t2) {
            this._bypassKey = -1 !== navigator.userAgent.indexOf("Mac") ? "metaKey" : "ctrlKey", this._map = e2, this._options = t2, this._enabled = false;
          }
          isActive() {
            return false;
          }
          reset() {
          }
          _setupUI() {
            if (this._container) return;
            const e2 = this._map.getCanvasContainer();
            e2.classList.add("maplibregl-cooperative-gestures"), this._container = h.create("div", "maplibregl-cooperative-gesture-screen", e2);
            let t2 = this._map._getUIString("CooperativeGesturesHandler.WindowsHelpText");
            "metaKey" === this._bypassKey && (t2 = this._map._getUIString("CooperativeGesturesHandler.MacHelpText"));
            const i2 = this._map._getUIString("CooperativeGesturesHandler.MobileHelpText"), a2 = document.createElement("div");
            a2.className = "maplibregl-desktop-message", a2.textContent = t2, this._container.appendChild(a2);
            const r2 = document.createElement("div");
            r2.className = "maplibregl-mobile-message", r2.textContent = i2, this._container.appendChild(r2), this._container.setAttribute("aria-hidden", "true");
          }
          _destroyUI() {
            this._container && (h.remove(this._container), this._map.getCanvasContainer().classList.remove("maplibregl-cooperative-gestures")), delete this._container;
          }
          enable() {
            this._setupUI(), this._enabled = true;
          }
          disable() {
            this._enabled = false, this._destroyUI();
          }
          isEnabled() {
            return this._enabled;
          }
          isBypassed(e2) {
            return e2[this._bypassKey];
          }
          notifyGestureBlocked(e2, i2) {
            this._enabled && (this._map.fire(new t.l("cooperativegestureprevented", { gestureType: e2, originalEvent: i2 })), this._container.classList.add("maplibregl-show"), setTimeout(() => {
              this._container.classList.remove("maplibregl-show");
            }, 100));
          }
        }
        const qo = (e2) => e2.zoom || e2.drag || e2.roll || e2.pitch || e2.rotate;
        class Wo extends t.l {
        }
        function $o(e2) {
          return e2.panDelta && e2.panDelta.mag() || e2.zoomDelta || e2.bearingDelta || e2.pitchDelta || e2.rollDelta;
        }
        class Ho {
          constructor(e2, i2) {
            this.handleWindowEvent = (e3) => {
              this.handleEvent(e3, `${e3.type}Window`);
            }, this.handleEvent = (e3, i3) => {
              if ("blur" === e3.type) return void this.stop(true);
              this._updatingCamera = true;
              const a3 = "renderFrame" === e3.type ? void 0 : e3, r2 = { needsRenderFrame: false }, o2 = {}, s2 = {};
              for (const { handlerName: n3, handler: l3, allowed: c2 } of this._handlers) {
                if (!l3.isEnabled()) continue;
                let u2;
                if (this._blockedByActive(s2, c2, n3)) l3.reset();
                else if (l3[i3 || e3.type]) {
                  if (t.cA(e3, i3 || e3.type)) {
                    const t2 = h.mousePos(this._map.getCanvas(), e3);
                    u2 = l3[i3 || e3.type](e3, t2);
                  } else if (t.cB(e3, i3 || e3.type)) {
                    const t2 = this._getMapTouches(e3.touches), a4 = h.touchPos(this._map.getCanvas(), t2);
                    u2 = l3[i3 || e3.type](e3, a4, t2);
                  } else t.cC(i3 || e3.type) || (u2 = l3[i3 || e3.type](e3));
                  this.mergeHandlerResult(r2, o2, u2, n3, a3), u2 && u2.needsRenderFrame && this._triggerRenderFrame();
                }
                (u2 || l3.isActive()) && (s2[n3] = l3);
              }
              const n2 = {};
              for (const e4 in this._previousActiveHandlers) s2[e4] || (n2[e4] = a3);
              this._previousActiveHandlers = s2, (Object.keys(n2).length || $o(r2)) && (this._changes.push([r2, o2, n2]), this._triggerRenderFrame()), (Object.keys(s2).length || $o(r2)) && this._map._stop(true), this._updatingCamera = false;
              const { cameraAnimation: l2 } = r2;
              l2 && (this._inertia.clear(), this._fireEvents({}, {}, true), this._changes = [], l2(this._map));
            }, this._map = e2, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new eo(e2), this._bearingSnap = i2.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(i2);
            const a2 = this._el;
            this._listeners = [[a2, "touchstart", { passive: true }], [a2, "touchmove", { passive: false }], [a2, "touchend", void 0], [a2, "touchcancel", void 0], [a2, "mousedown", void 0], [a2, "mousemove", void 0], [a2, "mouseup", void 0], [document, "mousemove", { capture: true }], [document, "mouseup", void 0], [a2, "mouseover", void 0], [a2, "mouseout", void 0], [a2, "dblclick", void 0], [a2, "click", void 0], [a2, "keydown", { capture: false }], [a2, "keyup", void 0], [a2, "wheel", { passive: false }], [a2, "contextmenu", void 0], [window, "blur", void 0]];
            for (const [e3, t2, i3] of this._listeners) h.addEventListener(e3, t2, e3 === document ? this.handleWindowEvent : this.handleEvent, i3);
          }
          destroy() {
            for (const [e2, t2, i2] of this._listeners) h.removeEventListener(e2, t2, e2 === document ? this.handleWindowEvent : this.handleEvent, i2);
          }
          _addDefaultHandlers(e2) {
            const i2 = this._map, a2 = i2.getCanvasContainer();
            this._add("mapEvent", new so(i2, e2));
            const r2 = i2.boxZoom = new co(i2, e2);
            this._add("boxZoom", r2), e2.interactive && e2.boxZoom && r2.enable();
            const o2 = i2.cooperativeGestures = new Vo(i2, e2.cooperativeGestures);
            this._add("cooperativeGestures", o2), e2.cooperativeGestures && o2.enable();
            const s2 = new po(i2), n2 = new jo(i2);
            i2.doubleClickZoom = new Oo(n2, s2), this._add("tapZoom", s2), this._add("clickZoom", n2), e2.interactive && e2.doubleClickZoom && i2.doubleClickZoom.enable();
            const l2 = new No();
            this._add("tapDragZoom", l2);
            const c2 = i2.touchPitch = new zo(i2);
            this._add("touchPitch", c2), e2.interactive && e2.touchPitch && i2.touchPitch.enable(e2.touchPitch);
            const u2 = () => i2.project(i2.getCenter()), d2 = function({ enable: e3, clickTolerance: i3, aroundCenter: a3 = true, minPixelCenterThreshold: r3 = 100, rotateDegreesPerPixelMoved: o3 = 0.8 }, s3) {
              const n3 = new xo({ checkCorrectEvent: (e4) => 0 === h.mouseButton(e4) && e4.ctrlKey || 2 === h.mouseButton(e4) && !e4.ctrlKey });
              return new mo({ clickTolerance: i3, move: (e4, i4) => {
                const n4 = s3();
                if (a3 && Math.abs(n4.y - e4.y) > r3) return { bearingDelta: t.cy(new t.P(e4.x, i4.y), i4, n4) };
                let l3 = (i4.x - e4.x) * o3;
                return a3 && i4.y < n4.y && (l3 = -l3), { bearingDelta: l3 };
              }, moveStateManager: n3, enable: e3, assignEvents: wo });
            }(e2, u2), _2 = function({ enable: e3, clickTolerance: t2, pitchDegreesPerPixelMoved: i3 = -0.5 }) {
              const a3 = new xo({ checkCorrectEvent: (e4) => 0 === h.mouseButton(e4) && e4.ctrlKey || 2 === h.mouseButton(e4) });
              return new mo({ clickTolerance: t2, move: (e4, t3) => ({ pitchDelta: (t3.y - e4.y) * i3 }), moveStateManager: a3, enable: e3, assignEvents: wo });
            }(e2), p2 = function({ enable: e3, clickTolerance: t2, rollDegreesPerPixelMoved: i3 = 0.3 }, a3) {
              const r3 = new xo({ checkCorrectEvent: (e4) => 2 === h.mouseButton(e4) && e4.ctrlKey });
              return new mo({ clickTolerance: t2, move: (e4, t3) => {
                const r4 = a3();
                let o3 = (t3.x - e4.x) * i3;
                return t3.y < r4.y && (o3 = -o3), { rollDelta: o3 };
              }, moveStateManager: r3, enable: e3, assignEvents: wo });
            }(e2, u2);
            i2.dragRotate = new Go(e2, d2, _2, p2), this._add("mouseRotate", d2, ["mousePitch"]), this._add("mousePitch", _2, ["mouseRotate", "mouseRoll"]), this._add("mouseRoll", p2, ["mousePitch"]), e2.interactive && e2.dragRotate && i2.dragRotate.enable();
            const m2 = function({ enable: e3, clickTolerance: t2 }) {
              const i3 = new xo({ checkCorrectEvent: (e4) => 0 === h.mouseButton(e4) && !e4.ctrlKey });
              return new mo({ clickTolerance: t2, move: (e4, t3) => ({ around: t3, panDelta: t3.sub(e4) }), activateOnStart: true, moveStateManager: i3, enable: e3, assignEvents: wo });
            }(e2), f2 = new To(e2, i2);
            i2.dragPan = new Zo(a2, m2, f2), this._add("mousePan", m2), this._add("touchPan", f2, ["touchZoom", "touchRotate"]), e2.interactive && e2.dragPan && i2.dragPan.enable(e2.dragPan);
            const g2 = new So(), v2 = new Mo();
            i2.touchZoomRotate = new Uo(a2, v2, g2, l2), this._add("touchRotate", g2, ["touchPan", "touchZoom"]), this._add("touchZoom", v2, ["touchPan", "touchRotate"]), e2.interactive && e2.touchZoomRotate && i2.touchZoomRotate.enable(e2.touchZoomRotate), this._add("blockableMapEvent", new no(i2));
            const x2 = i2.scrollZoom = new Bo(i2, () => this._triggerRenderFrame());
            this._add("scrollZoom", x2, ["mousePan"]), e2.interactive && e2.scrollZoom && i2.scrollZoom.enable(e2.scrollZoom);
            const b2 = i2.keyboard = new Ao(i2);
            this._add("keyboard", b2), e2.interactive && e2.keyboard && i2.keyboard.enable();
          }
          _add(e2, t2, i2) {
            this._handlers.push({ handlerName: e2, handler: t2, allowed: i2 }), this._handlersById[e2] = t2;
          }
          stop(e2) {
            if (!this._updatingCamera) {
              for (const { handler: e3 } of this._handlers) e3.reset();
              this._inertia.clear(), this._fireEvents({}, {}, e2), this._changes = [];
            }
          }
          isActive() {
            for (const { handler: e2 } of this._handlers) if (e2.isActive()) return true;
            return false;
          }
          isZooming() {
            return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
          }
          isRotating() {
            return !!this._eventsInProgress.rotate;
          }
          isMoving() {
            return Boolean(qo(this._eventsInProgress)) || this.isZooming();
          }
          _blockedByActive(e2, t2, i2) {
            for (const a2 in e2) if (a2 !== i2 && (!t2 || t2.indexOf(a2) < 0)) return true;
            return false;
          }
          _getMapTouches(e2) {
            const t2 = [];
            for (const i2 of e2) this._el.contains(i2.target) && t2.push(i2);
            return t2;
          }
          mergeHandlerResult(e2, i2, a2, r2, o2) {
            if (!a2) return;
            t.e(e2, a2);
            const s2 = { handlerName: r2, originalEvent: a2.originalEvent || o2 };
            void 0 !== a2.zoomDelta && (i2.zoom = s2), void 0 !== a2.panDelta && (i2.drag = s2), void 0 !== a2.rollDelta && (i2.roll = s2), void 0 !== a2.pitchDelta && (i2.pitch = s2), void 0 !== a2.bearingDelta && (i2.rotate = s2);
          }
          _applyChanges() {
            const e2 = {}, i2 = {}, a2 = {};
            for (const [r2, o2, s2] of this._changes) r2.panDelta && (e2.panDelta = (e2.panDelta || new t.P(0, 0))._add(r2.panDelta)), r2.zoomDelta && (e2.zoomDelta = (e2.zoomDelta || 0) + r2.zoomDelta), r2.bearingDelta && (e2.bearingDelta = (e2.bearingDelta || 0) + r2.bearingDelta), r2.pitchDelta && (e2.pitchDelta = (e2.pitchDelta || 0) + r2.pitchDelta), r2.rollDelta && (e2.rollDelta = (e2.rollDelta || 0) + r2.rollDelta), void 0 !== r2.around && (e2.around = r2.around), void 0 !== r2.pinchAround && (e2.pinchAround = r2.pinchAround), r2.noInertia && (e2.noInertia = r2.noInertia), t.e(i2, o2), t.e(a2, s2);
            this._updateMapTransform(e2, i2, a2), this._changes = [];
          }
          _updateMapTransform(e2, t2, i2) {
            const a2 = this._map, r2 = a2._getTransformForUpdate(), o2 = a2.terrain;
            if (!($o(e2) || o2 && this._terrainMovement)) return this._fireEvents(t2, i2, true);
            a2._stop(true);
            let { panDelta: s2, zoomDelta: n2, bearingDelta: l2, pitchDelta: c2, rollDelta: h2, around: u2, pinchAround: d2 } = e2;
            void 0 !== d2 && (u2 = d2), u2 = u2 || a2.transform.centerPoint, o2 && !r2.isPointOnMapSurface(u2) && (u2 = r2.centerPoint);
            const _2 = { panDelta: s2, zoomDelta: n2, rollDelta: h2, pitchDelta: c2, bearingDelta: l2, around: u2 };
            this._map.cameraHelper.useGlobeControls && !r2.isPointOnMapSurface(u2) && (u2 = r2.centerPoint);
            const p2 = u2.distSqr(r2.centerPoint) < 0.01 ? r2.center : r2.screenPointToLocation(s2 ? u2.sub(s2) : u2);
            this._handleMapControls({ terrain: o2, tr: r2, deltasForHelper: _2, preZoomAroundLoc: p2, combinedEventsInProgress: t2, panDelta: s2 }), a2._applyUpdatedTransform(r2), this._map._update(), e2.noInertia || this._inertia.record(e2), this._fireEvents(t2, i2, true);
          }
          _handleMapControls({ terrain: e2, tr: t2, deltasForHelper: i2, preZoomAroundLoc: a2, combinedEventsInProgress: r2, panDelta: o2 }) {
            const s2 = this._map.cameraHelper;
            if (s2.handleMapControlsRollPitchBearingZoom(i2, t2), e2) return s2.useGlobeControls ? (this._terrainMovement || !r2.drag && !r2.zoom || (this._terrainMovement = true, this._map._elevationFreeze = true), void s2.handleMapControlsPan(i2, t2, a2)) : this._terrainMovement || !r2.drag && !r2.zoom ? void (r2.drag && this._terrainMovement && o2 ? t2.setCenter(t2.screenPointToLocation(t2.centerPoint.sub(o2))) : s2.handleMapControlsPan(i2, t2, a2)) : (this._terrainMovement = true, this._map._elevationFreeze = true, void s2.handleMapControlsPan(i2, t2, a2));
            s2.handleMapControlsPan(i2, t2, a2);
          }
          _fireEvents(e2, i2, a2) {
            const r2 = qo(this._eventsInProgress), o2 = qo(e2), s2 = {};
            for (const t2 in e2) {
              const { originalEvent: i3 } = e2[t2];
              this._eventsInProgress[t2] || (s2[`${t2}start`] = i3), this._eventsInProgress[t2] = e2[t2];
            }
            !r2 && o2 && this._fireEvent("movestart", o2.originalEvent);
            for (const e3 in s2) this._fireEvent(e3, s2[e3]);
            o2 && this._fireEvent("move", o2.originalEvent);
            for (const t2 in e2) {
              const { originalEvent: i3 } = e2[t2];
              this._fireEvent(t2, i3);
            }
            const l2 = {};
            let c2;
            for (const e3 in this._eventsInProgress) {
              const { handlerName: t2, originalEvent: a3 } = this._eventsInProgress[e3];
              this._handlersById[t2].isActive() || (delete this._eventsInProgress[e3], c2 = i2[t2] || a3, l2[`${e3}end`] = c2);
            }
            for (const e3 in l2) this._fireEvent(e3, l2[e3]);
            const h2 = qo(this._eventsInProgress), u2 = (r2 || o2) && !h2;
            if (u2 && this._terrainMovement) {
              this._map._elevationFreeze = false, this._terrainMovement = false;
              const e3 = this._map._getTransformForUpdate();
              this._map.getCenterClampedToGround() && e3.recalculateZoomAndCenter(this._map.terrain), this._map._applyUpdatedTransform(e3);
            }
            if (a2 && u2) {
              this._updatingCamera = true;
              const e3 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i3 = (e4) => 0 !== e4 && -this._bearingSnap < e4 && e4 < this._bearingSnap;
              !e3 || !e3.essential && n.prefersReducedMotion ? (this._map.fire(new t.l("moveend", { originalEvent: c2 })), i3(this._map.getBearing()) && this._map.resetNorth()) : (i3(e3.bearing || this._map.getBearing()) && (e3.bearing = 0), e3.freezeElevation = true, this._map.easeTo(e3, { originalEvent: c2 })), this._updatingCamera = false;
            }
          }
          _fireEvent(e2, i2) {
            this._map.fire(new t.l(e2, i2 ? { originalEvent: i2 } : {}));
          }
          _requestFrame() {
            return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e2) => {
              delete this._frameId, this.handleEvent(new Wo("renderFrame", { timeStamp: e2 })), this._applyChanges();
            });
          }
          _triggerRenderFrame() {
            void 0 === this._frameId && (this._frameId = this._requestFrame());
          }
        }
        class Xo extends t.E {
          constructor(e2, t2, i2) {
            super(), this._renderFrameCallback = () => {
              const e3 = Math.min((c() - this._easeStart) / this._easeOptions.duration, 1);
              this._onEaseFrame(this._easeOptions.easing(e3)), e3 < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }, this._moving = false, this._zooming = false, this.transform = e2, this._bearingSnap = i2.bearingSnap, this.cameraHelper = t2, this.on("moveend", () => {
              delete this._requestedCameraState;
            });
          }
          migrateProjection(e2, t2) {
            e2.apply(this.transform), this.transform = e2, this.cameraHelper = t2;
          }
          getCenter() {
            return new t.V(this.transform.center.lng, this.transform.center.lat);
          }
          setCenter(e2, t2) {
            return this.jumpTo({ center: e2 }, t2);
          }
          getCenterElevation() {
            return this.transform.elevation;
          }
          setCenterElevation(e2, t2) {
            return this.jumpTo({ elevation: e2 }, t2), this;
          }
          getCenterClampedToGround() {
            return this._centerClampedToGround;
          }
          setCenterClampedToGround(e2) {
            this._centerClampedToGround = e2;
          }
          panBy(e2, i2, a2) {
            return e2 = t.P.convert(e2).mult(-1), this.panTo(this.transform.center, t.e({ offset: e2 }, i2), a2);
          }
          panTo(e2, i2, a2) {
            return this.easeTo(t.e({ center: e2 }, i2), a2);
          }
          getZoom() {
            return this.transform.zoom;
          }
          setZoom(e2, t2) {
            return this.jumpTo({ zoom: e2 }, t2), this;
          }
          zoomTo(e2, i2, a2) {
            return this.easeTo(t.e({ zoom: e2 }, i2), a2);
          }
          zoomIn(e2, t2) {
            return this.zoomTo(this.getZoom() + 1, e2, t2), this;
          }
          zoomOut(e2, t2) {
            return this.zoomTo(this.getZoom() - 1, e2, t2), this;
          }
          getVerticalFieldOfView() {
            return this.transform.fov;
          }
          setVerticalFieldOfView(e2, i2) {
            return e2 != this.transform.fov && (this.transform.setFov(e2), this.fire(new t.l("movestart", i2)).fire(new t.l("move", i2)).fire(new t.l("moveend", i2))), this;
          }
          getBearing() {
            return this.transform.bearing;
          }
          setBearing(e2, t2) {
            return this.jumpTo({ bearing: e2 }, t2), this;
          }
          getPadding() {
            return this.transform.padding;
          }
          setPadding(e2, t2) {
            return this.jumpTo({ padding: e2 }, t2), this;
          }
          rotateTo(e2, i2, a2) {
            return this.easeTo(t.e({ bearing: e2 }, i2), a2);
          }
          resetNorth(e2, i2) {
            return this.rotateTo(0, t.e({ duration: 1e3 }, e2), i2), this;
          }
          resetNorthPitch(e2, i2) {
            return this.easeTo(t.e({ bearing: 0, pitch: 0, roll: 0, duration: 1e3 }, e2), i2), this;
          }
          snapToNorth(e2, t2) {
            return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e2, t2) : this;
          }
          getPitch() {
            return this.transform.pitch;
          }
          setPitch(e2, t2) {
            return this.jumpTo({ pitch: e2 }, t2), this;
          }
          getRoll() {
            return this.transform.roll;
          }
          setRoll(e2, t2) {
            return this.jumpTo({ roll: e2 }, t2), this;
          }
          cameraForBounds(e2, t2) {
            e2 = $.convert(e2).adjustAntiMeridian();
            const i2 = t2 && t2.bearing || 0;
            return this._cameraForBoxAndBearing(e2.getNorthWest(), e2.getSouthEast(), i2, t2);
          }
          _cameraForBoxAndBearing(e2, i2, a2, r2) {
            const o2 = { top: 0, bottom: 0, right: 0, left: 0 };
            if ("number" == typeof (r2 = t.e({ padding: o2, offset: [0, 0], maxZoom: this.transform.maxZoom }, r2)).padding) {
              const e3 = r2.padding;
              r2.padding = { top: e3, bottom: e3, right: e3, left: e3 };
            }
            const s2 = t.e(o2, r2.padding);
            r2.padding = s2;
            const n2 = this.transform, l2 = new $(e2, i2);
            return this.cameraHelper.cameraForBoxAndBearing(r2, s2, l2, a2, n2);
          }
          fitBounds(e2, t2, i2) {
            return this._fitInternal(this.cameraForBounds(e2, t2), t2, i2);
          }
          fitScreenCoordinates(e2, i2, a2, r2, o2) {
            return this._fitInternal(this._cameraForBoxAndBearing(this.transform.screenPointToLocation(t.P.convert(e2)), this.transform.screenPointToLocation(t.P.convert(i2)), a2, r2), r2, o2);
          }
          _fitInternal(e2, i2, a2) {
            return e2 ? (delete (i2 = t.e(e2, i2)).padding, i2.linear ? this.easeTo(i2, a2) : this.flyTo(i2, a2)) : this;
          }
          jumpTo(e2, i2) {
            this.stop();
            const a2 = this._getTransformForUpdate();
            let r2 = false, o2 = false, s2 = false;
            const n2 = a2.zoom;
            this.cameraHelper.handleJumpToCenterZoom(a2, e2);
            const l2 = a2.zoom !== n2;
            return "elevation" in e2 && a2.elevation !== +e2.elevation && a2.setElevation(+e2.elevation), "bearing" in e2 && a2.bearing !== +e2.bearing && (r2 = true, a2.setBearing(+e2.bearing)), "pitch" in e2 && a2.pitch !== +e2.pitch && (o2 = true, a2.setPitch(+e2.pitch)), "roll" in e2 && a2.roll !== +e2.roll && (s2 = true, a2.setRoll(+e2.roll)), null == e2.padding || a2.isPaddingEqual(e2.padding) || a2.setPadding(e2.padding), this._applyUpdatedTransform(a2), this.fire(new t.l("movestart", i2)).fire(new t.l("move", i2)), l2 && this.fire(new t.l("zoomstart", i2)).fire(new t.l("zoom", i2)).fire(new t.l("zoomend", i2)), r2 && this.fire(new t.l("rotatestart", i2)).fire(new t.l("rotate", i2)).fire(new t.l("rotateend", i2)), o2 && this.fire(new t.l("pitchstart", i2)).fire(new t.l("pitch", i2)).fire(new t.l("pitchend", i2)), s2 && this.fire(new t.l("rollstart", i2)).fire(new t.l("roll", i2)).fire(new t.l("rollend", i2)), this.fire(new t.l("moveend", i2));
          }
          calculateCameraOptionsFromTo(e2, i2, a2, r2 = 0) {
            const o2 = t.ab.fromLngLat(e2, i2), s2 = t.ab.fromLngLat(a2, r2), n2 = s2.x - o2.x, l2 = s2.y - o2.y, c2 = s2.z - o2.z, h2 = Math.hypot(n2, l2, c2);
            if (0 === h2) throw new Error("Can't calculate camera options with same From and To");
            const u2 = Math.hypot(n2, l2), d2 = t.au(this.transform.cameraToCenterDistance / h2 / this.transform.tileSize), _2 = 180 * Math.atan2(n2, -l2) / Math.PI;
            let p2 = 180 * Math.acos(u2 / h2) / Math.PI;
            return p2 = c2 < 0 ? 90 - p2 : 90 + p2, { center: s2.toLngLat(), elevation: r2, zoom: d2, pitch: p2, bearing: _2 };
          }
          calculateCameraOptionsFromCameraLngLatAltRotation(e2, t2, i2, a2, r2) {
            const o2 = this.transform.calculateCenterFromCameraLngLatAlt(e2, t2, i2, a2);
            return { center: o2.center, elevation: o2.elevation, zoom: o2.zoom, bearing: i2, pitch: a2, roll: r2 };
          }
          easeTo(e2, i2) {
            this._stop(false, e2.easeId), (false === (e2 = t.e({ offset: [0, 0], duration: 500, easing: t.cz }, e2)).animate || !e2.essential && n.prefersReducedMotion) && (e2.duration = 0);
            const a2 = this._getTransformForUpdate(), r2 = this.getBearing(), o2 = a2.pitch, s2 = a2.roll, l2 = "bearing" in e2 ? this._normalizeBearing(e2.bearing, r2) : r2, c2 = "pitch" in e2 ? +e2.pitch : o2, h2 = "roll" in e2 ? this._normalizeBearing(e2.roll, s2) : s2, u2 = "padding" in e2 ? e2.padding : a2.padding, d2 = t.P.convert(e2.offset);
            let _2, p2;
            e2.around && (_2 = t.V.convert(e2.around), p2 = a2.locationToScreenPoint(_2));
            const m2 = { moving: this._moving, zooming: this._zooming, rotating: this._rotating, pitching: this._pitching, rolling: this._rolling }, f2 = this.cameraHelper.handleEaseTo(a2, { bearing: l2, pitch: c2, roll: h2, padding: u2, around: _2, aroundPoint: p2, offsetAsPoint: d2, offset: e2.offset, zoom: e2.zoom, center: e2.center });
            return this._rotating = this._rotating || r2 !== l2, this._pitching = this._pitching || c2 !== o2, this._rolling = this._rolling || h2 !== s2, this._padding = !a2.isPaddingEqual(u2), this._zooming = this._zooming || f2.isZooming, this._easeId = e2.easeId, this._prepareEase(i2, e2.noMoveStart, m2), this.terrain && this._prepareElevation(f2.elevationCenter), this._ease((t2) => {
              f2.easeFunc(t2), this.terrain && !e2.freezeElevation && this._updateElevation(t2), this._applyUpdatedTransform(a2), this._fireMoveEvents(i2);
            }, (t2) => {
              this.terrain && e2.freezeElevation && this._finalizeElevation(), this._afterEase(i2, t2);
            }, e2), this;
          }
          _prepareEase(e2, i2, a2 = {}) {
            this._moving = true, i2 || a2.moving || this.fire(new t.l("movestart", e2)), this._zooming && !a2.zooming && this.fire(new t.l("zoomstart", e2)), this._rotating && !a2.rotating && this.fire(new t.l("rotatestart", e2)), this._pitching && !a2.pitching && this.fire(new t.l("pitchstart", e2)), this._rolling && !a2.rolling && this.fire(new t.l("rollstart", e2));
          }
          _prepareElevation(e2) {
            this._elevationCenter = e2, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(e2, this.transform.tileZoom), this._elevationFreeze = true;
          }
          _updateElevation(e2) {
            void 0 !== this._elevationStart && void 0 !== this._elevationCenter || this._prepareElevation(this.transform.center), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom));
            const i2 = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
            if (e2 < 1 && i2 !== this._elevationTarget) {
              const t2 = this._elevationTarget - this._elevationStart;
              this._elevationStart += e2 * (t2 - (i2 - (t2 * e2 + this._elevationStart)) / (1 - e2)), this._elevationTarget = i2;
            }
            this.transform.setElevation(t.G.number(this._elevationStart, this._elevationTarget, e2));
          }
          _finalizeElevation() {
            this._elevationFreeze = false, this.getCenterClampedToGround() && this.transform.recalculateZoomAndCenter(this.terrain);
          }
          _getTransformForUpdate() {
            return this.transformCameraUpdate || this.terrain ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
          }
          _elevateCameraIfInsideTerrain(e2) {
            if (!this.terrain && e2.elevation >= 0 && e2.pitch <= 90) return {};
            const t2 = e2.getCameraLngLat(), i2 = e2.getCameraAltitude(), a2 = this.terrain ? this.terrain.getElevationForLngLatZoom(t2, e2.zoom) : 0;
            if (i2 < a2) {
              const i3 = this.calculateCameraOptionsFromTo(t2, a2, e2.center, e2.elevation);
              return { pitch: i3.pitch, zoom: i3.zoom };
            }
            return {};
          }
          _applyUpdatedTransform(e2) {
            const t2 = [];
            if (t2.push((e3) => this._elevateCameraIfInsideTerrain(e3)), this.transformCameraUpdate && t2.push((e3) => this.transformCameraUpdate(e3)), !t2.length) return;
            const i2 = e2.clone();
            for (const e3 of t2) {
              const t3 = i2.clone(), { center: a2, zoom: r2, roll: o2, pitch: s2, bearing: n2, elevation: l2 } = e3(t3);
              a2 && t3.setCenter(a2), void 0 !== l2 && t3.setElevation(l2), void 0 !== r2 && t3.setZoom(r2), void 0 !== o2 && t3.setRoll(o2), void 0 !== s2 && t3.setPitch(s2), void 0 !== n2 && t3.setBearing(n2), i2.apply(t3);
            }
            this.transform.apply(i2);
          }
          _fireMoveEvents(e2) {
            this.fire(new t.l("move", e2)), this._zooming && this.fire(new t.l("zoom", e2)), this._rotating && this.fire(new t.l("rotate", e2)), this._pitching && this.fire(new t.l("pitch", e2)), this._rolling && this.fire(new t.l("roll", e2));
          }
          _afterEase(e2, i2) {
            if (this._easeId && i2 && this._easeId === i2) return;
            delete this._easeId;
            const a2 = this._zooming, r2 = this._rotating, o2 = this._pitching, s2 = this._rolling;
            this._moving = false, this._zooming = false, this._rotating = false, this._pitching = false, this._rolling = false, this._padding = false, a2 && this.fire(new t.l("zoomend", e2)), r2 && this.fire(new t.l("rotateend", e2)), o2 && this.fire(new t.l("pitchend", e2)), s2 && this.fire(new t.l("rollend", e2)), this.fire(new t.l("moveend", e2));
          }
          flyTo(e2, i2) {
            if (!e2.essential && n.prefersReducedMotion) {
              const a3 = t.U(e2, ["center", "zoom", "bearing", "pitch", "roll", "elevation", "padding"]);
              return this.jumpTo(a3, i2);
            }
            this.stop(), e2 = t.e({ offset: [0, 0], speed: 1.2, curve: 1.42, easing: t.cz }, e2);
            const a2 = this._getTransformForUpdate(), r2 = a2.bearing, o2 = a2.pitch, s2 = a2.roll, l2 = a2.padding, c2 = "bearing" in e2 ? this._normalizeBearing(e2.bearing, r2) : r2, h2 = "pitch" in e2 ? +e2.pitch : o2, u2 = "roll" in e2 ? this._normalizeBearing(e2.roll, s2) : s2, d2 = "padding" in e2 ? e2.padding : a2.padding, _2 = t.P.convert(e2.offset);
            let p2 = a2.centerPoint.add(_2);
            const m2 = a2.screenPointToLocation(p2), f2 = this.cameraHelper.handleFlyTo(a2, { bearing: c2, pitch: h2, roll: u2, padding: d2, locationAtOffset: m2, offsetAsPoint: _2, center: e2.center, minZoom: e2.minZoom, zoom: e2.zoom });
            let g2 = e2.curve;
            const v2 = Math.max(a2.width, a2.height), x2 = v2 / f2.scaleOfZoom, b2 = f2.pixelPathLength;
            "number" == typeof f2.scaleOfMinZoom && (g2 = Math.sqrt(v2 / f2.scaleOfMinZoom / b2 * 2));
            const y2 = g2 * g2;
            function w2(e3) {
              const t2 = (x2 * x2 - v2 * v2 + (e3 ? -1 : 1) * y2 * y2 * b2 * b2) / (2 * (e3 ? x2 : v2) * y2 * b2);
              return Math.log(Math.sqrt(t2 * t2 + 1) - t2);
            }
            function T2(e3) {
              return (Math.exp(e3) - Math.exp(-e3)) / 2;
            }
            function P2(e3) {
              return (Math.exp(e3) + Math.exp(-e3)) / 2;
            }
            const I2 = w2(false);
            let C2 = function(e3) {
              return P2(I2) / P2(I2 + g2 * e3);
            }, M2 = function(e3) {
              return v2 * ((P2(I2) * (T2(t2 = I2 + g2 * e3) / P2(t2)) - T2(I2)) / y2) / b2;
              var t2;
            }, E2 = (w2(true) - I2) / g2;
            if (Math.abs(b2) < 2e-6 || !isFinite(E2)) {
              if (Math.abs(v2 - x2) < 1e-6) return this.easeTo(e2, i2);
              const t2 = x2 < v2 ? -1 : 1;
              E2 = Math.abs(Math.log(x2 / v2)) / g2, M2 = () => 0, C2 = (e3) => Math.exp(t2 * g2 * e3);
            }
            return e2.duration = "duration" in e2 ? +e2.duration : 1e3 * E2 / ("screenSpeed" in e2 ? +e2.screenSpeed / g2 : +e2.speed), e2.maxDuration && e2.duration > e2.maxDuration && (e2.duration = 0), this._zooming = true, this._rotating = r2 !== c2, this._pitching = h2 !== o2, this._rolling = u2 !== s2, this._padding = !a2.isPaddingEqual(d2), this._prepareEase(i2, false), this.terrain && this._prepareElevation(f2.targetCenter), this._ease((n2) => {
              const m3 = n2 * E2, g3 = 1 / C2(m3), v3 = M2(m3);
              this._rotating && a2.setBearing(t.G.number(r2, c2, n2)), this._pitching && a2.setPitch(t.G.number(o2, h2, n2)), this._rolling && a2.setRoll(t.G.number(s2, u2, n2)), this._padding && (a2.interpolatePadding(l2, d2, n2), p2 = a2.centerPoint.add(_2)), f2.easeFunc(n2, g3, v3, p2), this.terrain && !e2.freezeElevation && this._updateElevation(n2), this._applyUpdatedTransform(a2), this._fireMoveEvents(i2);
            }, () => {
              this.terrain && e2.freezeElevation && this._finalizeElevation(), this._afterEase(i2);
            }, e2), this;
          }
          isEasing() {
            return !!this._easeFrameId;
          }
          stop() {
            return this._stop();
          }
          _stop(e2, t2) {
            var i2;
            if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
              const e3 = this._onEaseEnd;
              delete this._onEaseEnd, e3.call(this, t2);
            }
            return e2 || null === (i2 = this.handlers) || void 0 === i2 || i2.stop(false), this;
          }
          _ease(e2, t2, i2) {
            false === i2.animate || 0 === i2.duration ? (e2(1), t2()) : (this._easeStart = c(), this._easeOptions = i2, this._onEaseFrame = e2, this._onEaseEnd = t2, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
          }
          _normalizeBearing(e2, i2) {
            e2 = t.W(e2, -180, 180);
            const a2 = Math.abs(e2 - i2);
            return Math.abs(e2 - 360 - i2) < a2 && (e2 -= 360), Math.abs(e2 + 360 - i2) < a2 && (e2 += 360), e2;
          }
          queryTerrainElevation(e2) {
            return this.terrain ? this.terrain.getElevationForLngLat(t.V.convert(e2)) : null;
          }
        }
        const Ko = { compact: true, customAttribution: '<a href="https://maplibre.org/" target="_blank">MapLibre</a>' };
        class Yo {
          constructor(e2 = Ko) {
            this._toggleAttribution = () => {
              this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
            }, this._updateData = (e3) => {
              !e3 || "metadata" !== e3.sourceDataType && "visibility" !== e3.sourceDataType && "style" !== e3.dataType && "terrain" !== e3.type || this._updateAttributions();
            }, this._updateCompact = () => {
              this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? false === this._compact ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
            }, this._updateCompactMinimize = () => {
              this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
            }, this.options = e2;
          }
          getDefaultPosition() {
            return "bottom-right";
          }
          onAdd(e2) {
            return this._map = e2, this._compact = this.options.compact, this._container = h.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = h.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = h.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
          }
          onRemove() {
            h.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
          }
          _setElementTitle(e2, t2) {
            const i2 = this._map._getUIString(`AttributionControl.${t2}`);
            e2.title = i2, e2.setAttribute("aria-label", i2);
          }
          _updateAttributions() {
            if (!this._map.style) return;
            let e2 = [];
            if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e2 = e2.concat(this.options.customAttribution.map((e3) => "string" != typeof e3 ? "" : e3)) : "string" == typeof this.options.customAttribution && e2.push(this.options.customAttribution)), this._map.style.stylesheet) {
              const e3 = this._map.style.stylesheet;
              this.styleOwner = e3.owner, this.styleId = e3.id;
            }
            const t2 = this._map.style.tileManagers;
            for (const i3 in t2) {
              const a2 = t2[i3];
              if (a2.used || a2.usedForTerrain) {
                const t3 = a2.getSource();
                t3.attribution && e2.indexOf(t3.attribution) < 0 && e2.push(t3.attribution);
              }
            }
            e2 = e2.filter((e3) => String(e3).trim()), e2.sort((e3, t3) => e3.length - t3.length), e2 = e2.filter((t3, i3) => {
              for (let a2 = i3 + 1; a2 < e2.length; a2++) if (e2[a2].indexOf(t3) >= 0) return false;
              return true;
            });
            const i2 = e2.join(" | ");
            i2 !== this._attribHTML && (this._attribHTML = i2, e2.length ? (this._innerContainer.innerHTML = h.sanitize(i2), this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
          }
        }
        class Qo {
          constructor(e2 = {}) {
            this._updateCompact = () => {
              const e3 = this._container.children;
              if (e3.length) {
                const t2 = e3[0];
                this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? false !== this._compact && t2.classList.add("maplibregl-compact") : t2.classList.remove("maplibregl-compact");
              }
            }, this.options = e2;
          }
          getDefaultPosition() {
            return "bottom-left";
          }
          onAdd(e2) {
            this._map = e2, this._compact = this.options && this.options.compact, this._container = h.create("div", "maplibregl-ctrl");
            const t2 = h.create("a", "maplibregl-ctrl-logo");
            return t2.target = "_blank", t2.rel = "noopener nofollow", t2.href = "https://maplibre.org/", t2.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t2.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t2), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
          }
          onRemove() {
            h.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
          }
        }
        class Jo {
          constructor() {
            this._queue = [], this._id = 0, this._cleared = false, this._currentlyRunning = false;
          }
          add(e2) {
            const t2 = ++this._id;
            return this._queue.push({ callback: e2, id: t2, cancelled: false }), t2;
          }
          remove(e2) {
            const t2 = this._currentlyRunning, i2 = t2 ? this._queue.concat(t2) : this._queue;
            for (const t3 of i2) if (t3.id === e2) return void (t3.cancelled = true);
          }
          run(e2 = 0) {
            if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
            const t2 = this._currentlyRunning = this._queue;
            this._queue = [];
            for (const i2 of t2) if (!i2.cancelled && (i2.callback(e2), this._cleared)) break;
            this._cleared = false, this._currentlyRunning = false;
          }
          clear() {
            this._currentlyRunning && (this._cleared = true), this._queue = [];
          }
        }
        var es = t.aV([{ name: "a_pos3d", type: "Int16", components: 3 }]);
        class ts extends t.E {
          constructor(e2) {
            super(), this._lastTilesetChange = c(), this.tileManager = e2, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.deltaZoom = 1, this.tileSize = e2._source.tileSize * 2 ** this.deltaZoom, e2.usedForTerrain = true, e2.tileSize = this.tileSize;
          }
          destruct() {
            this.tileManager.usedForTerrain = false, this.tileManager.tileSize = null;
          }
          getSource() {
            return this.tileManager._source;
          }
          update(e2, i2) {
            this.tileManager.update(e2, i2), this._renderableTilesKeys = [];
            const a2 = {};
            for (const r2 of Ce(e2, { tileSize: this.tileSize, minzoom: this.minzoom, maxzoom: this.maxzoom, reparseOverscaled: false, terrain: i2, calculateTileZoom: this.tileManager._source.calculateTileZoom })) a2[r2.key] = true, this._renderableTilesKeys.push(r2.key), this._tiles[r2.key] || (r2.terrainRttPosMatrix32f = new Float64Array(16), t.c8(r2.terrainRttPosMatrix32f, 0, t.a5, t.a5, 0, 0, 1), this._tiles[r2.key] = new de(r2, this.tileSize), this._lastTilesetChange = c());
            for (const e3 in this._tiles) a2[e3] || delete this._tiles[e3];
          }
          freeRtt(e2) {
            for (const t2 in this._tiles) {
              const i2 = this._tiles[t2];
              (!e2 || i2.tileID.equals(e2) || i2.tileID.isChildOf(e2) || e2.isChildOf(i2.tileID)) && (i2.rtt = []);
            }
          }
          getRenderableTiles() {
            return this._renderableTilesKeys.map((e2) => this.getTileByID(e2));
          }
          getTileByID(e2) {
            return this._tiles[e2];
          }
          getTerrainCoords(e2, t2) {
            return t2 ? this._getTerrainCoordsForTileRanges(e2, t2) : this._getTerrainCoordsForRegularTile(e2);
          }
          _getTerrainCoordsForRegularTile(e2) {
            const i2 = {};
            for (const a2 of this._renderableTilesKeys) {
              const r2 = this._tiles[a2].tileID, o2 = e2.clone(), s2 = t.bl();
              if (r2.canonical.equals(e2.canonical)) t.c8(s2, 0, t.a5, t.a5, 0, 0, 1);
              else if (r2.canonical.isChildOf(e2.canonical)) {
                const i3 = r2.canonical.z - e2.canonical.z, a3 = r2.canonical.x - (r2.canonical.x >> i3 << i3), o3 = r2.canonical.y - (r2.canonical.y >> i3 << i3), n2 = t.a5 >> i3;
                t.c8(s2, 0, n2, n2, 0, 0, 1), t.O(s2, s2, [-a3 * n2, -o3 * n2, 0]);
              } else {
                if (!e2.canonical.isChildOf(r2.canonical)) continue;
                {
                  const i3 = e2.canonical.z - r2.canonical.z, a3 = e2.canonical.x - (e2.canonical.x >> i3 << i3), o3 = e2.canonical.y - (e2.canonical.y >> i3 << i3), n2 = t.a5 >> i3;
                  t.c8(s2, 0, t.a5, t.a5, 0, 0, 1), t.O(s2, s2, [a3 * n2, o3 * n2, 0]), t.Q(s2, s2, [1 / 2 ** i3, 1 / 2 ** i3, 0]);
                }
              }
              o2.terrainRttPosMatrix32f = new Float32Array(s2), i2[a2] = o2;
            }
            return i2;
          }
          _getTerrainCoordsForTileRanges(e2, i2) {
            const a2 = {};
            for (const r2 of this._renderableTilesKeys) {
              const o2 = this._tiles[r2].tileID;
              if (!this._isWithinTileRanges(o2, i2)) continue;
              const s2 = e2.clone(), n2 = t.bl();
              if (o2.canonical.z === e2.canonical.z) {
                const i3 = e2.canonical.x - o2.canonical.x, a3 = e2.canonical.y - o2.canonical.y;
                t.c8(n2, 0, t.a5, t.a5, 0, 0, 1), t.O(n2, n2, [i3 * t.a5, a3 * t.a5, 0]);
              } else if (o2.canonical.z > e2.canonical.z) {
                const i3 = o2.canonical.z - e2.canonical.z, a3 = o2.canonical.x - (o2.canonical.x >> i3 << i3), r3 = o2.canonical.y - (o2.canonical.y >> i3 << i3), s3 = e2.canonical.x - (o2.canonical.x >> i3), l2 = e2.canonical.y - (o2.canonical.y >> i3), c2 = t.a5 >> i3;
                t.c8(n2, 0, c2, c2, 0, 0, 1), t.O(n2, n2, [-a3 * c2 + s3 * t.a5, -r3 * c2 + l2 * t.a5, 0]);
              } else {
                const i3 = e2.canonical.z - o2.canonical.z, a3 = e2.canonical.x - (e2.canonical.x >> i3 << i3), r3 = e2.canonical.y - (e2.canonical.y >> i3 << i3), s3 = (e2.canonical.x >> i3) - o2.canonical.x, l2 = (e2.canonical.y >> i3) - o2.canonical.y, c2 = t.a5 << i3;
                t.c8(n2, 0, c2, c2, 0, 0, 1), t.O(n2, n2, [a3 * t.a5 + s3 * c2, r3 * t.a5 + l2 * c2, 0]);
              }
              s2.terrainRttPosMatrix32f = new Float32Array(n2), a2[r2] = s2;
            }
            return a2;
          }
          getSourceTile(e2, t2) {
            const i2 = this.tileManager._source;
            let a2 = e2.overscaledZ - this.deltaZoom;
            if (a2 > i2.maxzoom && (a2 = i2.maxzoom), a2 < i2.minzoom) return;
            this._sourceTileCache[e2.key] || (this._sourceTileCache[e2.key] = e2.scaledTo(a2).key);
            let r2 = this.findTileInCaches(this._sourceTileCache[e2.key]);
            if (!(null == r2 ? void 0 : r2.dem) && t2) for (; a2 >= i2.minzoom && !(null == r2 ? void 0 : r2.dem); ) r2 = this.findTileInCaches(e2.scaledTo(a2--).key);
            return r2;
          }
          findTileInCaches(e2) {
            let t2 = this.tileManager.getTileByID(e2);
            return t2 || (t2 = this.tileManager._outOfViewCache.getByKey(e2), t2);
          }
          anyTilesAfterTime(e2 = Date.now()) {
            return this._lastTilesetChange >= e2;
          }
          _isWithinTileRanges(e2, t2) {
            return t2[e2.canonical.z] && e2.canonical.x >= t2[e2.canonical.z].minTileX && e2.canonical.x <= t2[e2.canonical.z].maxTileX && e2.canonical.y >= t2[e2.canonical.z].minTileY && e2.canonical.y <= t2[e2.canonical.z].maxTileY;
          }
        }
        class is {
          constructor(e2, t2, i2) {
            this._meshCache = {}, this.painter = e2, this.tileManager = new ts(t2), this.options = i2, this.exaggeration = "number" == typeof i2.exaggeration ? i2.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
          }
          getDEMElevation(e2, i2, a2, r2 = t.a5) {
            var o2;
            if (!(i2 >= 0 && i2 < r2 && a2 >= 0 && a2 < r2)) return 0;
            const s2 = this.getTerrainData(e2), n2 = null === (o2 = s2.tile) || void 0 === o2 ? void 0 : o2.dem;
            if (!n2) return 0;
            const l2 = t.cD([], [i2 / r2 * t.a5, a2 / r2 * t.a5], s2.u_terrain_matrix), c2 = [l2[0] * n2.dim, l2[1] * n2.dim], h2 = Math.floor(c2[0]), u2 = Math.floor(c2[1]), d2 = c2[0] - h2, _2 = c2[1] - u2;
            return n2.get(h2, u2) * (1 - d2) * (1 - _2) + n2.get(h2 + 1, u2) * d2 * (1 - _2) + n2.get(h2, u2 + 1) * (1 - d2) * _2 + n2.get(h2 + 1, u2 + 1) * d2 * _2;
          }
          getElevationForLngLatZoom(e2, i2) {
            if (!t.cE(i2, e2.wrap())) return 0;
            const { tileID: a2, mercatorX: r2, mercatorY: o2 } = this._getOverscaledTileIDFromLngLatZoom(e2, i2);
            return this.getElevation(a2, r2 % t.a5, o2 % t.a5, t.a5);
          }
          getElevationForLngLat(e2) {
            return this.getElevationForLngLatZoom(e2, this.tileManager.maxzoom);
          }
          getElevation(e2, i2, a2, r2 = t.a5) {
            return this.getDEMElevation(e2, i2, a2, r2) * this.exaggeration;
          }
          getTerrainData(e2) {
            if (!this._emptyDemTexture) {
              const e3 = this.painter.context, i3 = new t.R({ width: 1, height: 1 }, new Uint8Array(4));
              this._emptyDepthTexture = new t.T(e3, i3, e3.gl.RGBA, { premultiply: false }), this._emptyDemUnpack = [0, 0, 0, 0], this._emptyDemTexture = new t.T(e3, new t.R({ width: 1, height: 1 }), e3.gl.RGBA, { premultiply: false }), this._emptyDemTexture.bind(e3.gl.NEAREST, e3.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = t.as([]);
            }
            const i2 = this.tileManager.getSourceTile(e2, true);
            if (i2 && i2.dem && (!i2.demTexture || i2.needsTerrainPrepare)) {
              const e3 = this.painter.context;
              i2.demTexture = this.painter.getTileTexture(i2.dem.stride), i2.demTexture ? i2.demTexture.update(i2.dem.getPixels(), { premultiply: false }) : i2.demTexture = new t.T(e3, i2.dem.getPixels(), e3.gl.RGBA, { premultiply: false }), i2.demTexture.bind(e3.gl.NEAREST, e3.gl.CLAMP_TO_EDGE), i2.needsTerrainPrepare = false;
            }
            const a2 = i2 && i2 + i2.tileID.key + e2.key;
            if (a2 && !this._demMatrixCache[a2]) {
              const a3 = this.tileManager.getSource().maxzoom;
              let r2 = e2.canonical.z - i2.tileID.canonical.z;
              e2.overscaledZ > e2.canonical.z && (e2.canonical.z >= a3 ? r2 = e2.canonical.z - a3 : t.w("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
              const o2 = e2.canonical.x - (e2.canonical.x >> r2 << r2), s2 = e2.canonical.y - (e2.canonical.y >> r2 << r2), n2 = t.cF(new Float64Array(16), [1 / (t.a5 << r2), 1 / (t.a5 << r2), 0]);
              t.O(n2, n2, [o2 * t.a5, s2 * t.a5, 0]), this._demMatrixCache[e2.key] = { matrix: n2, coord: e2 };
            }
            return { u_depth: 2, u_terrain: 3, u_terrain_dim: i2 && i2.dem && i2.dem.dim || 1, u_terrain_matrix: a2 ? this._demMatrixCache[e2.key].matrix : this._emptyDemMatrix, u_terrain_unpack: i2 && i2.dem && i2.dem.getUnpackVector() || this._emptyDemUnpack, u_terrain_exaggeration: this.exaggeration, texture: (i2 && i2.demTexture || this._emptyDemTexture).texture, depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture, tile: i2 };
          }
          getFramebuffer(e2) {
            const i2 = this.painter, a2 = i2.width / devicePixelRatio, r2 = i2.height / devicePixelRatio;
            return !this._fbo || this._fbo.width === a2 && this._fbo.height === r2 || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new t.T(i2.context, { width: a2, height: r2, data: null }, i2.context.gl.RGBA, { premultiply: false }), this._fboCoordsTexture.bind(i2.context.gl.NEAREST, i2.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new t.T(i2.context, { width: a2, height: r2, data: null }, i2.context.gl.RGBA, { premultiply: false }), this._fboDepthTexture.bind(i2.context.gl.NEAREST, i2.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = i2.context.createFramebuffer(a2, r2, true, false), this._fbo.depthAttachment.set(i2.context.createRenderbuffer(i2.context.gl.DEPTH_COMPONENT16, a2, r2))), this._fbo.colorAttachment.set("coords" === e2 ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
          }
          getCoordsTexture() {
            const e2 = this.painter.context;
            if (this._coordsTexture) return this._coordsTexture;
            const i2 = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
            for (let e3 = 0, t2 = 0; e3 < this._coordsTextureSize; e3++) for (let a3 = 0; a3 < this._coordsTextureSize; a3++, t2 += 4) i2[t2 + 0] = 255 & a3, i2[t2 + 1] = 255 & e3, i2[t2 + 2] = a3 >> 8 << 4 | e3 >> 8, i2[t2 + 3] = 0;
            const a2 = new t.R({ width: this._coordsTextureSize, height: this._coordsTextureSize }, new Uint8Array(i2.buffer)), r2 = new t.T(e2, a2, e2.gl.RGBA, { premultiply: false });
            return r2.bind(e2.gl.NEAREST, e2.gl.CLAMP_TO_EDGE), this._coordsTexture = r2, r2;
          }
          pointCoordinate(e2) {
            this.painter.maybeDrawDepthAndCoords(true);
            const i2 = new Uint8Array(4), a2 = this.painter.context, r2 = a2.gl, o2 = Math.round(e2.x * this.painter.pixelRatio / devicePixelRatio), s2 = Math.round(e2.y * this.painter.pixelRatio / devicePixelRatio), n2 = Math.round(this.painter.height / devicePixelRatio);
            a2.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), r2.readPixels(o2, n2 - s2 - 1, 1, 1, r2.RGBA, r2.UNSIGNED_BYTE, i2), a2.bindFramebuffer.set(null);
            const l2 = i2[0] + (i2[2] >> 4 << 8), c2 = i2[1] + ((15 & i2[2]) << 8), h2 = this.coordsIndex[255 - i2[3]], u2 = h2 && this.tileManager.getTileByID(h2);
            if (!u2) return null;
            const d2 = this._coordsTextureSize, _2 = (1 << u2.tileID.canonical.z) * d2;
            return new t.ab((u2.tileID.canonical.x * d2 + l2) / _2 + u2.tileID.wrap, (u2.tileID.canonical.y * d2 + c2) / _2, this.getElevation(u2.tileID, l2, c2, d2));
          }
          depthAtPoint(e2) {
            const t2 = new Uint8Array(4), i2 = this.painter.context, a2 = i2.gl;
            return i2.bindFramebuffer.set(this.getFramebuffer("depth").framebuffer), a2.readPixels(e2.x, this.painter.height / devicePixelRatio - e2.y - 1, 1, 1, a2.RGBA, a2.UNSIGNED_BYTE, t2), i2.bindFramebuffer.set(null), (t2[0] / 16777216 + t2[1] / 65536 + t2[2] / 256 + t2[3]) / 256;
          }
          getTerrainMesh(e2) {
            var i2;
            const a2 = (null === (i2 = this.painter.style.projection) || void 0 === i2 ? void 0 : i2.transitionState) > 0, r2 = a2 && 0 === e2.canonical.y, o2 = a2 && e2.canonical.y === (1 << e2.canonical.z) - 1, s2 = `m_${r2 ? "n" : ""}_${o2 ? "s" : ""}`;
            if (this._meshCache[s2]) return this._meshCache[s2];
            const n2 = this.painter.context, l2 = new t.cG(), c2 = new t.aZ(), h2 = this.meshSize, u2 = t.a5 / h2, d2 = h2 * h2;
            for (let e3 = 0; e3 <= h2; e3++) for (let t2 = 0; t2 <= h2; t2++) l2.emplaceBack(t2 * u2, e3 * u2, 0);
            for (let e3 = 0; e3 < d2; e3 += h2 + 1) for (let t2 = 0; t2 < h2; t2++) c2.emplaceBack(t2 + e3, h2 + t2 + e3 + 1, h2 + t2 + e3 + 2), c2.emplaceBack(t2 + e3, h2 + t2 + e3 + 2, t2 + e3 + 1);
            const _2 = l2.length, p2 = _2 + (h2 + 1), m2 = (h2 + 1) * h2, f2 = r2 ? t.bs : 0, g2 = r2 ? 0 : 1, v2 = o2 ? t.bt : t.a5, x2 = o2 ? 0 : 1;
            for (let e3 = 0; e3 <= h2; e3++) l2.emplaceBack(e3 * u2, f2, g2);
            for (let e3 = 0; e3 <= h2; e3++) l2.emplaceBack(e3 * u2, v2, x2);
            for (let e3 = 0; e3 < h2; e3++) c2.emplaceBack(m2 + e3, p2 + e3, p2 + e3 + 1), c2.emplaceBack(m2 + e3, p2 + e3 + 1, m2 + e3 + 1), c2.emplaceBack(0 + e3, _2 + e3 + 1, _2 + e3), c2.emplaceBack(0 + e3, 0 + e3 + 1, _2 + e3 + 1);
            const b2 = l2.length, y2 = b2 + 2 * (h2 + 1);
            for (const e3 of [0, 1]) for (let i3 = 0; i3 <= h2; i3++) for (const a3 of [0, 1]) l2.emplaceBack(e3 * t.a5, i3 * u2, a3);
            for (let e3 = 0; e3 < 2 * h2; e3 += 2) c2.emplaceBack(b2 + e3, b2 + e3 + 1, b2 + e3 + 3), c2.emplaceBack(b2 + e3, b2 + e3 + 3, b2 + e3 + 2), c2.emplaceBack(y2 + e3, y2 + e3 + 3, y2 + e3 + 1), c2.emplaceBack(y2 + e3, y2 + e3 + 2, y2 + e3 + 3);
            const w2 = new kt(n2.createVertexBuffer(l2, es.members), n2.createIndexBuffer(c2), t.aY.simpleSegment(0, 0, l2.length, c2.length));
            return this._meshCache[s2] = w2, w2;
          }
          getMeshFrameDelta(e2) {
            return 2 * Math.PI * t.bF / Math.pow(2, Math.max(e2, 0)) / 5;
          }
          getMinTileElevationForLngLatZoom(e2, i2) {
            var a2;
            if (!t.cE(i2, e2.wrap())) return 0;
            const { tileID: r2 } = this._getOverscaledTileIDFromLngLatZoom(e2, i2);
            return null !== (a2 = this.getMinMaxElevation(r2).minElevation) && void 0 !== a2 ? a2 : 0;
          }
          getMinMaxElevation(e2) {
            const t2 = this.getTerrainData(e2).tile, i2 = { minElevation: null, maxElevation: null };
            return t2 && t2.dem && (i2.minElevation = t2.dem.min * this.exaggeration, i2.maxElevation = t2.dem.max * this.exaggeration), i2;
          }
          _getOverscaledTileIDFromLngLatZoom(e2, i2) {
            const a2 = t.ab.fromLngLat(e2.wrap()), r2 = (1 << i2) * t.a5, o2 = a2.x * r2, s2 = a2.y * r2, n2 = Math.floor(o2 / t.a5), l2 = Math.floor(s2 / t.a5);
            return { tileID: new t.a2(i2, 0, i2, n2, l2), mercatorX: o2, mercatorY: s2 };
          }
        }
        class as {
          constructor(e2, t2, i2) {
            this._context = e2, this._size = t2, this._tileSize = i2, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
          }
          destruct() {
            for (const e2 of this._objects) e2.texture.destroy(), e2.fbo.destroy();
          }
          _createObject(e2) {
            const i2 = this._context.createFramebuffer(this._tileSize, this._tileSize, true, true), a2 = new t.T(this._context, { width: this._tileSize, height: this._tileSize, data: null }, this._context.gl.RGBA);
            return a2.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), this._context.extTextureFilterAnisotropic && this._context.gl.texParameterf(this._context.gl.TEXTURE_2D, this._context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this._context.extTextureFilterAnisotropicMax), i2.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), i2.colorAttachment.set(a2.texture), { id: e2, fbo: i2, texture: a2, stamp: -1, inUse: false };
          }
          getObjectForId(e2) {
            return this._objects[e2];
          }
          useObject(e2) {
            e2.inUse = true, this._recentlyUsed = this._recentlyUsed.filter((t2) => e2.id !== t2), this._recentlyUsed.push(e2.id);
          }
          stampObject(e2) {
            e2.stamp = ++this._stamp;
          }
          getOrCreateFreeObject() {
            for (const e3 of this._recentlyUsed) if (!this._objects[e3].inUse) return this._objects[e3];
            if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
            const e2 = this._createObject(this._objects.length);
            return this._objects.push(e2), e2;
          }
          freeObject(e2) {
            e2.inUse = false;
          }
          freeAllObjects() {
            for (const e2 of this._objects) this.freeObject(e2);
          }
          isFull() {
            return !(this._objects.length < this._size) && false === this._objects.some((e2) => !e2.inUse);
          }
        }
        const rs = { background: true, fill: true, line: true, raster: true, hillshade: true, "color-relief": true };
        class os {
          constructor(e2, t2) {
            this.painter = e2, this.terrain = t2, this.pool = new as(e2.context, 30, t2.tileManager.tileSize * t2.qualityFactor);
          }
          destruct() {
            this.pool.destruct();
          }
          getTexture(e2) {
            return this.pool.getObjectForId(e2.rtt[this._stacks.length - 1].id).texture;
          }
          prepareForRender(e2, t2) {
            this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.tileManager.getRenderableTiles(), this._renderableLayerIds = e2._order.filter((i2) => !e2._layers[i2].isHidden(t2)), this._coordsAscending = {};
            for (const t3 in e2.tileManagers) {
              this._coordsAscending[t3] = {};
              const i2 = e2.tileManagers[t3].getVisibleCoordinates(), a2 = e2.tileManagers[t3].getSource(), r2 = a2 instanceof te ? a2.terrainTileRanges : null;
              for (const e3 of i2) {
                const i3 = this.terrain.tileManager.getTerrainCoords(e3, r2);
                for (const e4 in i3) this._coordsAscending[t3][e4] || (this._coordsAscending[t3][e4] = []), this._coordsAscending[t3][e4].push(i3[e4]);
              }
            }
            this._coordsAscendingStr = {};
            for (const t3 of e2._order) {
              const i2 = e2._layers[t3], a2 = i2.source;
              if (rs[i2.type] && !this._coordsAscendingStr[a2]) {
                this._coordsAscendingStr[a2] = {};
                for (const e3 in this._coordsAscending[a2]) this._coordsAscendingStr[a2][e3] = this._coordsAscending[a2][e3].map((e4) => e4.key).sort().join();
              }
            }
            for (const e3 of this._renderableTiles) for (const t3 in this._coordsAscendingStr) {
              const i2 = this._coordsAscendingStr[t3][e3.tileID.key];
              i2 && i2 !== e3.rttCoords[t3] && (e3.rtt = []);
            }
          }
          renderLayer(e2, i2) {
            if (e2.isHidden(this.painter.transform.zoom)) return false;
            const a2 = Object.assign(Object.assign({}, i2), { isRenderingToTexture: true }), r2 = e2.type, o2 = this.painter, s2 = this._renderableLayerIds[this._renderableLayerIds.length - 1] === e2.id;
            if (rs[r2] && (this._prevType && rs[this._prevType] || this._stacks.push([]), this._prevType = r2, this._stacks[this._stacks.length - 1].push(e2.id), !s2)) return true;
            if (rs[this._prevType] || rs[r2] && s2) {
              this._prevType = r2;
              const e3 = this._stacks.length - 1, i3 = this._stacks[e3] || [];
              for (const r3 of this._renderableTiles) {
                if (this.pool.isFull() && (Ur(this.painter, this.terrain, this._rttTiles, a2), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(r3), r3.rtt[e3]) {
                  const t2 = this.pool.getObjectForId(r3.rtt[e3].id);
                  if (t2.stamp === r3.rtt[e3].stamp) {
                    this.pool.useObject(t2);
                    continue;
                  }
                }
                const s3 = this.pool.getOrCreateFreeObject();
                this.pool.useObject(s3), this.pool.stampObject(s3), r3.rtt[e3] = { id: s3.id, stamp: s3.stamp }, o2.context.bindFramebuffer.set(s3.fbo.framebuffer), o2.context.clear({ color: t.bq.transparent, stencil: 0 }), o2.currentStencilSource = void 0;
                for (let e4 = 0; e4 < i3.length; e4++) {
                  const t2 = o2.style._layers[i3[e4]], n2 = t2.source ? this._coordsAscending[t2.source][r3.tileID.key] : [r3.tileID];
                  o2.context.viewport.set([0, 0, s3.fbo.width, s3.fbo.height]), o2._renderTileClippingMasks(t2, n2, true), o2.renderLayer(o2, o2.style.tileManagers[t2.source], t2, n2, a2), t2.source && (r3.rttCoords[t2.source] = this._coordsAscendingStr[t2.source][r3.tileID.key]);
                }
              }
              return Ur(this.painter, this.terrain, this._rttTiles, a2), this._rttTiles = [], this.pool.freeAllObjects(), rs[r2];
            }
            return false;
          }
        }
        const ss = { "AttributionControl.ToggleAttribution": "Toggle attribution", "AttributionControl.MapFeedback": "Map feedback", "FullscreenControl.Enter": "Enter fullscreen", "FullscreenControl.Exit": "Exit fullscreen", "GeolocateControl.FindMyLocation": "Find my location", "GeolocateControl.LocationNotAvailable": "Location not available", "LogoControl.Title": "MapLibre logo", "Map.Title": "Map", "Marker.Title": "Map marker", "NavigationControl.ResetBearing": "Reset bearing to north", "NavigationControl.ZoomIn": "Zoom in", "NavigationControl.ZoomOut": "Zoom out", "Popup.Close": "Close popup", "ScaleControl.Feet": "ft", "ScaleControl.Meters": "m", "ScaleControl.Kilometers": "km", "ScaleControl.Miles": "mi", "ScaleControl.NauticalMiles": "nm", "GlobeControl.Enable": "Enable globe", "GlobeControl.Disable": "Disable globe", "TerrainControl.Enable": "Enable terrain", "TerrainControl.Disable": "Disable terrain", "CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map", "CooperativeGesturesHandler.MacHelpText": "Use ⌘ + scroll to zoom the map", "CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map" }, ns = i, ls = { hash: false, interactive: true, bearingSnap: 7, attributionControl: Ko, maplibreLogo: false, refreshExpiredTiles: true, canvasContextAttributes: { antialias: false, preserveDrawingBuffer: false, powerPreference: "high-performance", failIfMajorPerformanceCaveat: false, desynchronized: false, contextType: void 0 }, scrollZoom: true, minZoom: -2, maxZoom: 22, minPitch: 0, maxPitch: 60, boxZoom: true, dragRotate: true, dragPan: true, keyboard: true, doubleClickZoom: true, touchZoomRotate: true, touchPitch: true, cooperativeGestures: false, trackResize: true, center: [0, 0], elevation: 0, zoom: 0, bearing: 0, pitch: 0, roll: 0, renderWorldCopies: true, maxTileCacheSize: null, maxTileCacheZoomLevels: t.c.MAX_TILE_CACHE_ZOOM_LEVELS, transformRequest: null, transformCameraUpdate: null, transformConstrain: null, fadeDuration: 300, crossSourceCollisions: true, clickTolerance: 3, localIdeographFontFamily: "sans-serif", pitchWithRotate: true, rollEnabled: false, reduceMotion: void 0, validateStyle: true, maxCanvasSize: [4096, 4096], cancelPendingTileRequestsWhileZooming: true, centerClampedToGround: true, experimentalZoomLevelsToOverscale: void 0 }, cs = { showCompass: true, showZoom: true, visualizePitch: false, visualizeRoll: true };
        class hs {
          constructor(e2, i2, a2 = false) {
            this.mousedown = (e3) => {
              this.startMove(e3, h.mousePos(this.element, e3)), h.addEventListener(window, "mousemove", this.mousemove), h.addEventListener(window, "mouseup", this.mouseup);
            }, this.mousemove = (e3) => {
              this.move(e3, h.mousePos(this.element, e3));
            }, this.mouseup = (e3) => {
              this._rotatePitchHandler.dragEnd(e3), this.offTemp();
            }, this.touchstart = (e3) => {
              1 !== e3.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = h.touchPos(this.element, e3.targetTouches)[0], this.startMove(e3, this._startPos), h.addEventListener(window, "touchmove", this.touchmove, { passive: false }), h.addEventListener(window, "touchend", this.touchend));
            }, this.touchmove = (e3) => {
              1 !== e3.targetTouches.length ? this.reset() : (this._lastPos = h.touchPos(this.element, e3.targetTouches)[0], this.move(e3, this._lastPos));
            }, this.touchend = (e3) => {
              0 === e3.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
            }, this.reset = () => {
              this._rotatePitchHandler.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }, this._clickTolerance = 10, this.element = i2;
            const r2 = new yo();
            this._rotatePitchHandler = new mo({ clickTolerance: 3, move: (e3, r3) => {
              const o2 = i2.getBoundingClientRect(), s2 = new t.P((o2.bottom - o2.top) / 2, (o2.right - o2.left) / 2);
              return { bearingDelta: t.cy(new t.P(e3.x, r3.y), r3, s2), pitchDelta: a2 ? -0.5 * (r3.y - e3.y) : void 0 };
            }, moveStateManager: r2, enable: true, assignEvents: () => {
            } }), this.map = e2, h.addEventListener(i2, "mousedown", this.mousedown), h.addEventListener(i2, "touchstart", this.touchstart, { passive: false }), h.addEventListener(i2, "touchcancel", this.reset);
          }
          startMove(e2, t2) {
            this._rotatePitchHandler.dragStart(e2, t2), h.disableDrag();
          }
          move(e2, t2) {
            const i2 = this.map, { bearingDelta: a2, pitchDelta: r2 } = this._rotatePitchHandler.dragMove(e2, t2) || {};
            a2 && i2.setBearing(i2.getBearing() + a2), r2 && i2.setPitch(i2.getPitch() + r2);
          }
          off() {
            const e2 = this.element;
            h.removeEventListener(e2, "mousedown", this.mousedown), h.removeEventListener(e2, "touchstart", this.touchstart, { passive: false }), h.removeEventListener(window, "touchmove", this.touchmove, { passive: false }), h.removeEventListener(window, "touchend", this.touchend), h.removeEventListener(e2, "touchcancel", this.reset), this.offTemp();
          }
          offTemp() {
            h.enableDrag(), h.removeEventListener(window, "mousemove", this.mousemove), h.removeEventListener(window, "mouseup", this.mouseup), h.removeEventListener(window, "touchmove", this.touchmove, { passive: false }), h.removeEventListener(window, "touchend", this.touchend);
          }
        }
        let us;
        function ds(e2, i2, a2, r2 = false) {
          if (r2 || !a2.getCoveringTilesDetailsProvider().allowWorldCopies()) return null == e2 ? void 0 : e2.wrap();
          const o2 = new t.V(e2.lng, e2.lat);
          if (e2 = new t.V(e2.lng, e2.lat), i2) {
            const r3 = new t.V(e2.lng - 360, e2.lat), o3 = new t.V(e2.lng + 360, e2.lat), s2 = a2.locationToScreenPoint(e2).distSqr(i2);
            a2.locationToScreenPoint(r3).distSqr(i2) < s2 ? e2 = r3 : a2.locationToScreenPoint(o3).distSqr(i2) < s2 && (e2 = o3);
          }
          for (; Math.abs(e2.lng - a2.center.lng) > 180; ) {
            const t2 = a2.locationToScreenPoint(e2);
            if (t2.x >= 0 && t2.y >= 0 && t2.x <= a2.width && t2.y <= a2.height) break;
            e2.lng > a2.center.lng ? e2.lng -= 360 : e2.lng += 360;
          }
          return e2.lng !== o2.lng && a2.isPointOnMapSurface(a2.locationToScreenPoint(e2)) ? e2 : o2;
        }
        const _s = { center: "translate(-50%,-50%)", top: "translate(-50%,0)", "top-left": "translate(0,0)", "top-right": "translate(-100%,0)", bottom: "translate(-50%,-100%)", "bottom-left": "translate(0,-100%)", "bottom-right": "translate(-100%,-100%)", left: "translate(0,-50%)", right: "translate(-100%,-50%)" };
        function ps(e2, t2, i2) {
          const a2 = e2.classList;
          for (const e3 in _s) a2.remove(`maplibregl-${i2}-anchor-${e3}`);
          a2.add(`maplibregl-${i2}-anchor-${t2}`);
        }
        class ms extends t.E {
          constructor(e2) {
            if (super(), this._onKeyPress = (e3) => {
              const t2 = e3.code, i2 = e3.charCode || e3.keyCode;
              "Space" !== t2 && "Enter" !== t2 && 32 !== i2 && 13 !== i2 || this.togglePopup();
            }, this._onMapClick = (e3) => {
              const t2 = e3.originalEvent.target, i2 = this._element;
              this._popup && (t2 === i2 || i2.contains(t2)) && this.togglePopup();
            }, this._update = (e3) => {
              if (!this._map) return;
              const t2 = this._map.loaded() && !this._map.isMoving();
              ("terrain" === (null == e3 ? void 0 : e3.type) || "render" === (null == e3 ? void 0 : e3.type) && !t2) && this._map.once("render", this._update), this._lngLat = ds(this._lngLat, this._flatPos, this._map.transform), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map.transform.locationToScreenPoint(this._lngLat)._add(this._offset));
              let i2 = "";
              "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? i2 = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (i2 = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
              let a2 = "";
              "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? a2 = "rotateX(0deg)" : "map" === this._pitchAlignment && (a2 = `rotateX(${this._map.getPitch()}deg)`), this._subpixelPositioning || e3 && "moveend" !== e3.type || (this._pos = this._pos.round()), h.setTransform(this._element, `${_s[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${a2} ${i2}`), n.frameAsync(new AbortController()).then(() => {
                this._updateOpacity(e3 && "moveend" === e3.type);
              }).catch(() => {
              });
            }, this._onMove = (e3) => {
              if (!this._isDragging) {
                const t2 = this._clickTolerance || this._map._clickTolerance;
                this._isDragging = e3.point.dist(this._pointerdownPos) >= t2;
              }
              this._isDragging && (this._pos = e3.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t.l("dragstart"))), this.fire(new t.l("drag")));
            }, this._onUp = () => {
              this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = false, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t.l("dragend")), this._state = "inactive";
            }, this._addDragHandler = (e3) => {
              this._element.contains(e3.originalEvent.target) && (e3.preventDefault(), this._positionDelta = e3.point.sub(this._pos).add(this._offset), this._pointerdownPos = e3.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
            }, this._anchor = e2 && e2.anchor || "center", this._color = e2 && e2.color || "#3FB1CE", this._scale = e2 && e2.scale || 1, this._draggable = e2 && e2.draggable || false, this._clickTolerance = e2 && e2.clickTolerance || 0, this._subpixelPositioning = e2 && e2.subpixelPositioning || false, this._isDragging = false, this._state = "inactive", this._rotation = e2 && e2.rotation || 0, this._rotationAlignment = e2 && e2.rotationAlignment || "auto", this._pitchAlignment = e2 && e2.pitchAlignment && "auto" !== e2.pitchAlignment ? e2.pitchAlignment : this._rotationAlignment, this.setOpacity(null == e2 ? void 0 : e2.opacity, null == e2 ? void 0 : e2.opacityWhenCovered), e2 && e2.element) this._element = e2.element, this._offset = t.P.convert(e2 && e2.offset || [0, 0]);
            else {
              this._defaultMarker = true, this._element = h.create("div");
              const i2 = h.createNS("http://www.w3.org/2000/svg", "svg"), a2 = 41, r2 = 27;
              i2.setAttributeNS(null, "display", "block"), i2.setAttributeNS(null, "height", `${a2}px`), i2.setAttributeNS(null, "width", `${r2}px`), i2.setAttributeNS(null, "viewBox", `0 0 ${r2} ${a2}`);
              const o2 = h.createNS("http://www.w3.org/2000/svg", "g");
              o2.setAttributeNS(null, "stroke", "none"), o2.setAttributeNS(null, "stroke-width", "1"), o2.setAttributeNS(null, "fill", "none"), o2.setAttributeNS(null, "fill-rule", "evenodd");
              const s2 = h.createNS("http://www.w3.org/2000/svg", "g");
              s2.setAttributeNS(null, "fill-rule", "nonzero");
              const n2 = h.createNS("http://www.w3.org/2000/svg", "g");
              n2.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), n2.setAttributeNS(null, "fill", "#000000");
              const l2 = [{ rx: "10.5", ry: "5.25002273" }, { rx: "10.5", ry: "5.25002273" }, { rx: "9.5", ry: "4.77275007" }, { rx: "8.5", ry: "4.29549936" }, { rx: "7.5", ry: "3.81822308" }, { rx: "6.5", ry: "3.34094679" }, { rx: "5.5", ry: "2.86367051" }, { rx: "4.5", ry: "2.38636864" }];
              for (const e3 of l2) {
                const t2 = h.createNS("http://www.w3.org/2000/svg", "ellipse");
                t2.setAttributeNS(null, "opacity", "0.04"), t2.setAttributeNS(null, "cx", "10.5"), t2.setAttributeNS(null, "cy", "5.80029008"), t2.setAttributeNS(null, "rx", e3.rx), t2.setAttributeNS(null, "ry", e3.ry), n2.appendChild(t2);
              }
              const c2 = h.createNS("http://www.w3.org/2000/svg", "g");
              c2.setAttributeNS(null, "fill", this._color);
              const u2 = h.createNS("http://www.w3.org/2000/svg", "path");
              u2.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), c2.appendChild(u2);
              const d2 = h.createNS("http://www.w3.org/2000/svg", "g");
              d2.setAttributeNS(null, "opacity", "0.25"), d2.setAttributeNS(null, "fill", "#000000");
              const _2 = h.createNS("http://www.w3.org/2000/svg", "path");
              _2.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), d2.appendChild(_2);
              const p2 = h.createNS("http://www.w3.org/2000/svg", "g");
              p2.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), p2.setAttributeNS(null, "fill", "#FFFFFF");
              const m2 = h.createNS("http://www.w3.org/2000/svg", "g");
              m2.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
              const f2 = h.createNS("http://www.w3.org/2000/svg", "circle");
              f2.setAttributeNS(null, "fill", "#000000"), f2.setAttributeNS(null, "opacity", "0.25"), f2.setAttributeNS(null, "cx", "5.5"), f2.setAttributeNS(null, "cy", "5.5"), f2.setAttributeNS(null, "r", "5.4999962");
              const g2 = h.createNS("http://www.w3.org/2000/svg", "circle");
              g2.setAttributeNS(null, "fill", "#FFFFFF"), g2.setAttributeNS(null, "cx", "5.5"), g2.setAttributeNS(null, "cy", "5.5"), g2.setAttributeNS(null, "r", "5.4999962"), m2.appendChild(f2), m2.appendChild(g2), s2.appendChild(n2), s2.appendChild(c2), s2.appendChild(d2), s2.appendChild(p2), s2.appendChild(m2), i2.appendChild(s2), i2.setAttributeNS(null, "height", a2 * this._scale + "px"), i2.setAttributeNS(null, "width", r2 * this._scale + "px"), this._element.appendChild(i2), this._offset = t.P.convert(e2 && e2.offset || [0, -14]);
            }
            if (this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (e3) => {
              e3.preventDefault();
            }), this._element.addEventListener("mousedown", (e3) => {
              e3.preventDefault();
            }), ps(this._element, this._anchor, "marker"), e2 && e2.className) for (const t2 of e2.className.split(" ")) this._element.classList.add(t2);
            this._popup = null;
          }
          addTo(e2) {
            return this.remove(), this._map = e2, this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", e2._getUIString("Marker.Title")), this._element.hasAttribute("role") || this._element.setAttribute("role", "button"), e2.getCanvasContainer().appendChild(this._element), e2.on("move", this._update), e2.on("moveend", this._update), e2.on("terrain", this._update), e2.on("projectiontransition", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
          }
          remove() {
            return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("terrain", this._update), this._map.off("projectiontransition", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), h.remove(this._element), this._popup && this._popup.remove(), this;
          }
          getLngLat() {
            return this._lngLat;
          }
          setLngLat(e2) {
            return this._lngLat = t.V.convert(e2), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
          }
          getElement() {
            return this._element;
          }
          setPopup(e2) {
            if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e2) {
              if (!("offset" in e2.options)) {
                const t2 = 38.1, i2 = 13.5, a2 = Math.abs(i2) / Math.SQRT2;
                e2.options.offset = this._defaultMarker ? { top: [0, 0], "top-left": [0, 0], "top-right": [0, 0], bottom: [0, -38.1], "bottom-left": [a2, -1 * (t2 - i2 + a2)], "bottom-right": [-a2, -1 * (t2 - i2 + a2)], left: [i2, -1 * (t2 - i2)], right: [-13.5, -1 * (t2 - i2)] } : this._offset;
              }
              this._popup = e2, this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
            }
            return this;
          }
          setSubpixelPositioning(e2) {
            return this._subpixelPositioning = e2, this;
          }
          getPopup() {
            return this._popup;
          }
          togglePopup() {
            const e2 = this._popup;
            return this._element.style.opacity === this._opacityWhenCovered ? this : e2 ? (e2.isOpen() ? e2.remove() : (e2.setLngLat(this._lngLat), e2.addTo(this._map)), this) : this;
          }
          _updateOpacity(e2 = false) {
            var i2, a2;
            const r2 = null === (i2 = this._map) || void 0 === i2 ? void 0 : i2.terrain, o2 = this._map.transform.isLocationOccluded(this._lngLat);
            if (!r2 || o2) {
              const e3 = o2 ? this._opacityWhenCovered : this._opacity;
              return void (this._element.style.opacity !== e3 && (this._element.style.opacity = e3));
            }
            if (e2) this._opacityTimeout = null;
            else {
              if (this._opacityTimeout) return;
              this._opacityTimeout = setTimeout(() => {
                this._opacityTimeout = null;
              }, 100);
            }
            const s2 = this._map, n2 = s2.terrain.depthAtPoint(this._pos), l2 = s2.terrain.getElevationForLngLat(this._lngLat);
            if (s2.transform.lngLatToCameraDepth(this._lngLat, l2) - n2 < 6e-3) return void (this._element.style.opacity = this._opacity);
            const c2 = -this._offset.y / s2.transform.pixelsPerMeter, h2 = Math.sin(s2.getPitch() * Math.PI / 180) * c2, u2 = s2.terrain.depthAtPoint(new t.P(this._pos.x, this._pos.y - this._offset.y)), d2 = s2.transform.lngLatToCameraDepth(this._lngLat, l2 + h2) - u2 > 6e-3;
            (null === (a2 = this._popup) || void 0 === a2 ? void 0 : a2.isOpen()) && d2 && this._popup.remove(), this._element.style.opacity = d2 ? this._opacityWhenCovered : this._opacity;
          }
          getOffset() {
            return this._offset;
          }
          setOffset(e2) {
            return this._offset = t.P.convert(e2), this._update(), this;
          }
          addClassName(e2) {
            this._element.classList.add(e2);
          }
          removeClassName(e2) {
            this._element.classList.remove(e2);
          }
          toggleClassName(e2) {
            return this._element.classList.toggle(e2);
          }
          setDraggable(e2) {
            return this._draggable = !!e2, this._map && (e2 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
          }
          isDraggable() {
            return this._draggable;
          }
          setRotation(e2) {
            return this._rotation = e2 || 0, this._update(), this;
          }
          getRotation() {
            return this._rotation;
          }
          setRotationAlignment(e2) {
            return this._rotationAlignment = e2 || "auto", this._update(), this;
          }
          getRotationAlignment() {
            return this._rotationAlignment;
          }
          setPitchAlignment(e2) {
            return this._pitchAlignment = e2 && "auto" !== e2 ? e2 : this._rotationAlignment, this._update(), this;
          }
          getPitchAlignment() {
            return this._pitchAlignment;
          }
          setOpacity(e2, t2) {
            return (void 0 === this._opacity || void 0 === e2 && void 0 === t2) && (this._opacity = "1", this._opacityWhenCovered = "0.2"), void 0 !== e2 && (this._opacity = e2), void 0 !== t2 && (this._opacityWhenCovered = t2), this._map && this._updateOpacity(true), this;
          }
        }
        const fs = { positionOptions: { enableHighAccuracy: false, maximumAge: 0, timeout: 6e3 }, fitBoundsOptions: { maxZoom: 15 }, trackUserLocation: false, showAccuracyCircle: true, showUserLocation: true };
        let gs = 0, vs = false;
        const xs = { maxWidth: 100, unit: "metric" };
        function bs(e2, t2, i2) {
          const a2 = i2 && i2.maxWidth || 100, r2 = e2._container.clientHeight / 2, o2 = e2._container.clientWidth / 2, s2 = e2.unproject([o2 - a2 / 2, r2]), n2 = e2.unproject([o2 + a2 / 2, r2]), l2 = Math.round(e2.project(n2).x - e2.project(s2).x), c2 = Math.min(a2, l2, e2._container.clientWidth), h2 = s2.distanceTo(n2);
          if (i2 && "imperial" === i2.unit) {
            const i3 = 3.2808 * h2;
            i3 > 5280 ? ys(t2, c2, i3 / 5280, e2._getUIString("ScaleControl.Miles")) : ys(t2, c2, i3, e2._getUIString("ScaleControl.Feet"));
          } else i2 && "nautical" === i2.unit ? ys(t2, c2, h2 / 1852, e2._getUIString("ScaleControl.NauticalMiles")) : h2 >= 1e3 ? ys(t2, c2, h2 / 1e3, e2._getUIString("ScaleControl.Kilometers")) : ys(t2, c2, h2, e2._getUIString("ScaleControl.Meters"));
        }
        function ys(e2, t2, i2, a2) {
          const r2 = function(e3) {
            const t3 = Math.pow(10, `${Math.floor(e3)}`.length - 1);
            let i3 = e3 / t3;
            return i3 = i3 >= 10 ? 10 : i3 >= 5 ? 5 : i3 >= 3 ? 3 : i3 >= 2 ? 2 : i3 >= 1 ? 1 : function(e4) {
              const t4 = Math.pow(10, Math.ceil(-Math.log(e4) / Math.LN10));
              return Math.round(e4 * t4) / t4;
            }(i3), t3 * i3;
          }(i2);
          e2.style.width = t2 * (r2 / i2) + "px", e2.innerHTML = `${r2}&nbsp;${a2}`;
        }
        const ws = { closeButton: true, closeOnClick: true, focusAfterOpen: true, className: "", maxWidth: "240px", subpixelPositioning: false, locationOccludedOpacity: void 0 }, Ts = ["a[href]", "[tabindex]:not([tabindex='-1'])", "[contenteditable]:not([contenteditable='false'])", "button:not([disabled])", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].join(", ");
        function Ps(e2) {
          if (e2) {
            if ("number" == typeof e2) {
              const i2 = Math.round(Math.abs(e2) / Math.SQRT2);
              return { center: new t.P(0, 0), top: new t.P(0, e2), "top-left": new t.P(i2, i2), "top-right": new t.P(-i2, i2), bottom: new t.P(0, -e2), "bottom-left": new t.P(i2, -i2), "bottom-right": new t.P(-i2, -i2), left: new t.P(e2, 0), right: new t.P(-e2, 0) };
            }
            if (e2 instanceof t.P || Array.isArray(e2)) {
              const i2 = t.P.convert(e2);
              return { center: i2, top: i2, "top-left": i2, "top-right": i2, bottom: i2, "bottom-left": i2, "bottom-right": i2, left: i2, right: i2 };
            }
            return { center: t.P.convert(e2.center || [0, 0]), top: t.P.convert(e2.top || [0, 0]), "top-left": t.P.convert(e2["top-left"] || [0, 0]), "top-right": t.P.convert(e2["top-right"] || [0, 0]), bottom: t.P.convert(e2.bottom || [0, 0]), "bottom-left": t.P.convert(e2["bottom-left"] || [0, 0]), "bottom-right": t.P.convert(e2["bottom-right"] || [0, 0]), left: t.P.convert(e2.left || [0, 0]), right: t.P.convert(e2.right || [0, 0]) };
          }
          return Ps(new t.P(0, 0));
        }
        const Is = i;
        e.AJAXError = t.cJ, e.Event = t.l, e.Evented = t.E, e.LngLat = t.V, e.MercatorCoordinate = t.ab, e.Point = t.P, e.addProtocol = t.cK, e.config = t.c, e.removeProtocol = t.cL, e.AttributionControl = Yo, e.BoxZoomHandler = co, e.CanvasSource = ae, e.CooperativeGesturesHandler = Vo, e.DoubleClickZoomHandler = Oo, e.DragPanHandler = Zo, e.DragRotateHandler = Go, e.EdgeInsets = Nt, e.FullscreenControl = class extends t.E {
          constructor(e2 = {}) {
            super(), this._onFullscreenChange = () => {
              var e3;
              let t2 = window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement;
              for (; null === (e3 = null == t2 ? void 0 : t2.shadowRoot) || void 0 === e3 ? void 0 : e3.fullscreenElement; ) t2 = t2.shadowRoot.fullscreenElement;
              t2 === this._container !== this._fullscreen && this._handleFullscreenChange();
            }, this._onClickFullscreen = () => {
              this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
            }, this._fullscreen = false, e2 && e2.container && (e2.container instanceof HTMLElement ? this._container = e2.container : t.w("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
          }
          onAdd(e2) {
            return this._map = e2, this._container || (this._container = this._map.getContainer()), this._controlContainer = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
          }
          onRemove() {
            h.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
          }
          _setupUI() {
            const e2 = this._fullscreenButton = h.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
            h.create("span", "maplibregl-ctrl-icon", e2).setAttribute("aria-hidden", "true"), e2.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
          }
          _updateTitle() {
            const e2 = this._getTitle();
            this._fullscreenButton.setAttribute("aria-label", e2), this._fullscreenButton.title = e2;
          }
          _getTitle() {
            return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
          }
          _isFullscreen() {
            return this._fullscreen;
          }
          _handleFullscreenChange() {
            this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new t.l("fullscreenstart")), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new t.l("fullscreenend")), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
          }
          _exitFullscreen() {
            window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
          }
          _requestFullscreen() {
            this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
          }
          _togglePseudoFullScreen() {
            this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
          }
        }, e.GeoJSONSource = ee, e.GeolocateControl = class extends t.E {
          constructor(e2) {
            super(), this._onSuccess = (e3) => {
              if (this._map) {
                if (this._isOutOfMapMaxBounds(e3)) return this._setErrorState(), this.fire(new t.l("outofmaxbounds", e3)), this._updateMarker(), void this._finish();
                if (this.options.trackUserLocation) switch (this._lastKnownPosition = e3, this._watchState) {
                  case "WAITING_ACTIVE":
                  case "ACTIVE_LOCK":
                  case "ACTIVE_ERROR":
                    this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                    break;
                  case "BACKGROUND":
                  case "BACKGROUND_ERROR":
                    this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                    break;
                  default:
                    throw new Error(`Unexpected watchState ${this._watchState}`);
                }
                this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e3), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e3), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new t.l("geolocate", e3)), this._finish();
              }
            }, this._updateCamera = (e3) => {
              const i2 = new t.V(e3.coords.longitude, e3.coords.latitude), a2 = e3.coords.accuracy, r2 = this._map.getBearing(), o2 = t.e({ bearing: r2 }, this.options.fitBoundsOptions), s2 = $.fromLngLat(i2, a2);
              this._map.fitBounds(s2, o2, { geolocateSource: true });
            }, this._updateMarker = (e3) => {
              if (e3) {
                const i2 = new t.V(e3.coords.longitude, e3.coords.latitude);
                this._accuracyCircleMarker.setLngLat(i2).addTo(this._map), this._userLocationDotMarker.setLngLat(i2).addTo(this._map), this._accuracy = e3.coords.accuracy, this._updateCircleRadiusIfNeeded();
              } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
            }, this._onUpdate = () => {
              this._updateCircleRadiusIfNeeded();
            }, this._onError = (e3) => {
              if (this._map) {
                if (1 === e3.code) {
                  this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = true;
                  const e4 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                  this._geolocateButton.title = e4, this._geolocateButton.setAttribute("aria-label", e4), void 0 !== this._geolocationWatchID && this._clearWatch();
                } else {
                  if (3 === e3.code && vs) return;
                  this._setErrorState();
                }
                "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new t.l("error", e3)), this._finish();
              }
            }, this._finish = () => {
              this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
            }, this._setupUI = () => {
              this._map && (this._container.addEventListener("contextmenu", (e3) => e3.preventDefault()), this._geolocateButton = h.create("button", "maplibregl-ctrl-geolocate", this._container), h.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", this._geolocateButton.disabled = true);
            }, this._finishSetupUI = (e3) => {
              if (this._map) {
                if (false === e3) {
                  t.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                  const e4 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                  this._geolocateButton.disabled = true, this._geolocateButton.title = e4, this._geolocateButton.setAttribute("aria-label", e4);
                } else {
                  const e4 = this._map._getUIString("GeolocateControl.FindMyLocation");
                  this._geolocateButton.disabled = false, this._geolocateButton.title = e4, this._geolocateButton.setAttribute("aria-label", e4);
                }
                this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = h.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new ms({ element: this._dotElement }), this._circleElement = h.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new ms({ element: this._circleElement, pitchAlignment: "map" }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onUpdate), this._map.on("move", this._onUpdate), this._map.on("rotate", this._onUpdate), this._map.on("pitch", this._onUpdate)), this._geolocateButton.addEventListener("click", () => this.trigger()), this._setup = true, this.options.trackUserLocation && this._map.on("movestart", (e4) => {
                  const i2 = (null == e4 ? void 0 : e4[0]) instanceof ResizeObserverEntry;
                  e4.geolocateSource || "ACTIVE_LOCK" !== this._watchState || i2 || this._map.isZooming() || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new t.l("trackuserlocationend")), this.fire(new t.l("userlocationlostfocus")));
                });
              }
            }, this.options = t.e({}, fs, e2);
          }
          onAdd(e2) {
            return this._map = e2, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), function() {
              return t._(this, arguments, void 0, function* (e3 = false) {
                if (void 0 !== us && !e3) return us;
                if (void 0 === window.navigator.permissions) return us = !!window.navigator.geolocation, us;
                try {
                  const e4 = yield window.navigator.permissions.query({ name: "geolocation" });
                  us = "denied" !== e4.state;
                } catch (e4) {
                  us = !!window.navigator.geolocation;
                }
                return us;
              });
            }().then((e3) => this._finishSetupUI(e3)), this._container;
          }
          onRemove() {
            void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), h.remove(this._container), this._map.off("zoom", this._onUpdate), this._map.off("move", this._onUpdate), this._map.off("rotate", this._onUpdate), this._map.off("pitch", this._onUpdate), this._map = void 0, gs = 0, vs = false;
          }
          _isOutOfMapMaxBounds(e2) {
            const t2 = this._map.getMaxBounds(), i2 = e2.coords;
            return t2 && (i2.longitude < t2.getWest() || i2.longitude > t2.getEast() || i2.latitude < t2.getSouth() || i2.latitude > t2.getNorth());
          }
          _setErrorState() {
            switch (this._watchState) {
              case "WAITING_ACTIVE":
                this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                break;
              case "ACTIVE_LOCK":
                this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                break;
              case "BACKGROUND":
                this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                break;
              case "ACTIVE_ERROR":
              case "BACKGROUND_ERROR":
              case "OFF":
              case void 0:
                break;
              default:
                throw new Error(`Unexpected watchState ${this._watchState}`);
            }
          }
          _updateCircleRadiusIfNeeded() {
            const e2 = this._userLocationDotMarker.getLngLat();
            if (!(this.options.showUserLocation && this.options.showAccuracyCircle && this._accuracy && e2)) return;
            const t2 = this._map.project(e2), i2 = this._map.unproject([t2.x + 100, t2.y]), a2 = e2.distanceTo(i2) / 100, r2 = 2 * this._accuracy / a2;
            this._circleElement.style.width = `${r2.toFixed(2)}px`, this._circleElement.style.height = `${r2.toFixed(2)}px`;
          }
          trigger() {
            if (!this._setup) return t.w("Geolocate control triggered before added to a map"), false;
            if (this.options.trackUserLocation) {
              switch (this._watchState) {
                case "OFF":
                  this._watchState = "WAITING_ACTIVE", this.fire(new t.l("trackuserlocationstart"));
                  break;
                case "WAITING_ACTIVE":
                case "ACTIVE_LOCK":
                case "ACTIVE_ERROR":
                case "BACKGROUND_ERROR":
                  gs--, vs = false, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new t.l("trackuserlocationend"));
                  break;
                case "BACKGROUND":
                  this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t.l("trackuserlocationstart")), this.fire(new t.l("userlocationfocus"));
                  break;
                default:
                  throw new Error(`Unexpected watchState ${this._watchState}`);
              }
              switch (this._watchState) {
                case "WAITING_ACTIVE":
                  this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                  break;
                case "ACTIVE_LOCK":
                  this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                  break;
                case "OFF":
                  break;
                default:
                  throw new Error(`Unexpected watchState ${this._watchState}`);
              }
              if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
              else if (void 0 === this._geolocationWatchID) {
                let e2;
                this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), gs++, gs > 1 ? (e2 = { maximumAge: 6e5, timeout: 0 }, vs = true) : (e2 = this.options.positionOptions, vs = false), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e2);
              }
            } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
            return true;
          }
          _clearWatch() {
            window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
          }
        }, e.GlobeControl = class {
          constructor() {
            this._toggleProjection = () => {
              var e2;
              const t2 = null === (e2 = this._map.getProjection()) || void 0 === e2 ? void 0 : e2.type;
              this._map.setProjection("mercator" !== t2 && t2 ? { type: "mercator" } : { type: "globe" }), this._updateGlobeIcon();
            }, this._updateGlobeIcon = () => {
              var e2;
              this._globeButton.classList.remove("maplibregl-ctrl-globe"), this._globeButton.classList.remove("maplibregl-ctrl-globe-enabled"), "globe" === (null === (e2 = this._map.getProjection()) || void 0 === e2 ? void 0 : e2.type) ? (this._globeButton.classList.add("maplibregl-ctrl-globe-enabled"), this._globeButton.title = this._map._getUIString("GlobeControl.Disable")) : (this._globeButton.classList.add("maplibregl-ctrl-globe"), this._globeButton.title = this._map._getUIString("GlobeControl.Enable"));
            };
          }
          onAdd(e2) {
            return this._map = e2, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._globeButton = h.create("button", "maplibregl-ctrl-globe", this._container), h.create("span", "maplibregl-ctrl-icon", this._globeButton).setAttribute("aria-hidden", "true"), this._globeButton.type = "button", this._globeButton.addEventListener("click", this._toggleProjection), this._updateGlobeIcon(), this._map.on("styledata", this._updateGlobeIcon), this._container;
          }
          onRemove() {
            h.remove(this._container), this._map.off("styledata", this._updateGlobeIcon), this._globeButton.removeEventListener("click", this._toggleProjection), this._map = void 0;
          }
        }, e.Hash = $r, e.ImageSource = te, e.KeyboardHandler = Ao, e.LngLatBounds = $, e.LogoControl = Qo, e.Map = class extends Xo {
          constructor(e2) {
            var i2, a2;
            t.cH.mark(t.cI.create);
            const r2 = Object.assign(Object.assign(Object.assign({}, ls), e2), { canvasContextAttributes: Object.assign(Object.assign({}, ls.canvasContextAttributes), e2.canvasContextAttributes) });
            if (null != r2.minZoom && null != r2.maxZoom && r2.minZoom > r2.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
            if (null != r2.minPitch && null != r2.maxPitch && r2.minPitch > r2.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
            if (null != r2.minPitch && r2.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
            if (null != r2.maxPitch && r2.maxPitch > 180) throw new Error("maxPitch must be less than or equal to 180");
            const o2 = new $t(), s2 = new Yt();
            if (void 0 !== r2.minZoom && o2.setMinZoom(r2.minZoom), void 0 !== r2.maxZoom && o2.setMaxZoom(r2.maxZoom), void 0 !== r2.minPitch && o2.setMinPitch(r2.minPitch), void 0 !== r2.maxPitch && o2.setMaxPitch(r2.maxPitch), void 0 !== r2.renderWorldCopies && o2.setRenderWorldCopies(r2.renderWorldCopies), null !== r2.transformConstrain && o2.setConstrainOverride(r2.transformConstrain), super(o2, s2, { bearingSnap: r2.bearingSnap }), this._idleTriggered = false, this._crossFadingFactor = 1, this._renderTaskQueue = new Jo(), this._controls = [], this._mapId = t.ah(), this._lostContextStyle = { style: null, images: null }, this._contextLost = (e3) => {
              e3.preventDefault(), this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this.painter.destroy();
              for (const e4 of Object.values(this.style._layers)) if ("custom" === e4.type && console.warn(`Custom layer with id '${e4.id}' cannot be restored after WebGL context loss. You will need to re-add it manually after context restoration.`), e4._listeners) for (const [t2] of Object.entries(e4._listeners)) console.warn(`Custom layer with id '${e4.id}' had event listeners for event '${t2}' which cannot be restored after WebGL context loss. You will need to re-add them manually after context restoration.`);
              this._lostContextStyle = this._getStyleAndImages(), this.style.destroy(), this.style = null, this.fire(new t.l("webglcontextlost", { originalEvent: e3 }));
            }, this._contextRestored = (e3) => {
              this._lostContextStyle.style && this.setStyle(this._lostContextStyle.style, { diff: false }), this._lostContextStyle.images && (this.style.imageManager.images = this._lostContextStyle.images), this._setupPainter(), this.resize(), this._update(), this.fire(new t.l("webglcontextrestored", { originalEvent: e3 }));
            }, this._onMapScroll = (e3) => {
              if (e3.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, false;
            }, this._onWindowOnline = () => {
              this._update();
            }, this._interactive = r2.interactive, this._maxTileCacheSize = r2.maxTileCacheSize, this._maxTileCacheZoomLevels = r2.maxTileCacheZoomLevels, this._canvasContextAttributes = Object.assign({}, r2.canvasContextAttributes), this._trackResize = true === r2.trackResize, this._bearingSnap = r2.bearingSnap, this._centerClampedToGround = r2.centerClampedToGround, this._refreshExpiredTiles = true === r2.refreshExpiredTiles, this._fadeDuration = r2.fadeDuration, this._crossSourceCollisions = true === r2.crossSourceCollisions, this._collectResourceTiming = true === r2.collectResourceTiming, this._locale = Object.assign(Object.assign({}, ss), r2.locale), this._clickTolerance = r2.clickTolerance, this._overridePixelRatio = r2.pixelRatio, this._maxCanvasSize = r2.maxCanvasSize, this._zoomLevelsToOverscale = r2.experimentalZoomLevelsToOverscale, this.transformCameraUpdate = r2.transformCameraUpdate, this.transformConstrain = r2.transformConstrain, this.cancelPendingTileRequestsWhileZooming = true === r2.cancelPendingTileRequestsWhileZooming, void 0 !== r2.reduceMotion && (n.prefersReducedMotion = r2.reduceMotion), this._imageQueueHandle = g.addThrottleControl(() => this.isMoving()), this._requestManager = new v(r2.transformRequest), "string" == typeof r2.container) {
              if (this._container = document.getElementById(r2.container), !this._container) throw new Error(`Container '${r2.container}' not found.`);
            } else {
              if (!(r2.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
              this._container = r2.container;
            }
            if (r2.maxBounds && this.setMaxBounds(r2.maxBounds), this._setupContainer(), this._setupPainter(), this.on("move", () => this._update(false)), this.on("moveend", () => this._update(false)), this.on("zoom", () => this._update(true)), this.on("terrain", () => {
              this.painter.terrainFacilitator.dirty = true, this._update(true);
            }), this.once("idle", () => {
              this._idleTriggered = true;
            }), "undefined" != typeof window) {
              addEventListener("online", this._onWindowOnline, false);
              let e3 = false;
              const t2 = Wr((e4) => {
                this._trackResize && !this._removed && (this.resize(e4), this.redraw());
              }, 50);
              this._resizeObserver = new ResizeObserver((i3) => {
                e3 ? t2(i3) : e3 = true;
              }), this._resizeObserver.observe(this._container);
            }
            this.handlers = new Ho(this, r2), this._hash = r2.hash && new $r("string" == typeof r2.hash && r2.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({ center: r2.center, elevation: r2.elevation, zoom: r2.zoom, bearing: r2.bearing, pitch: r2.pitch, roll: r2.roll }), r2.bounds && (this.resize(), this.fitBounds(r2.bounds, t.e({}, r2.fitBoundsOptions, { duration: 0 }))));
            const l2 = "string" == typeof r2.style || !("globe" === (null === (a2 = null === (i2 = r2.style) || void 0 === i2 ? void 0 : i2.projection) || void 0 === a2 ? void 0 : a2.type));
            this.resize(null, l2), this._localIdeographFontFamily = r2.localIdeographFontFamily, this._validateStyle = r2.validateStyle, r2.style && this.setStyle(r2.style, { localIdeographFontFamily: r2.localIdeographFontFamily }), r2.attributionControl && this.addControl(new Yo("boolean" == typeof r2.attributionControl ? void 0 : r2.attributionControl)), r2.maplibreLogo && this.addControl(new Qo(), r2.logoPosition), this.on("style.load", () => {
              if (l2 || this._resizeTransform(), this.transform.unmodified) {
                const e3 = t.U(this.style.stylesheet, ["center", "zoom", "bearing", "pitch", "roll"]);
                this.jumpTo(e3);
              }
            }), this.on("data", (e3) => {
              this._update("style" === e3.dataType), this.fire(new t.l(`${e3.dataType}data`, e3));
            }), this.on("dataloading", (e3) => {
              this.fire(new t.l(`${e3.dataType}dataloading`, e3));
            }), this.on("dataabort", (e3) => {
              this.fire(new t.l("sourcedataabort", e3));
            });
          }
          _getMapId() {
            return this._mapId;
          }
          setGlobalStateProperty(e2, t2) {
            return this.style.setGlobalStateProperty(e2, t2), this._update(true);
          }
          getGlobalState() {
            return this.style.getGlobalState();
          }
          addControl(e2, i2) {
            if (void 0 === i2 && (i2 = e2.getDefaultPosition ? e2.getDefaultPosition() : "top-right"), !e2 || !e2.onAdd) return this.fire(new t.k(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
            const a2 = e2.onAdd(this);
            this._controls.push(e2);
            const r2 = this._controlPositions[i2];
            return -1 !== i2.indexOf("bottom") ? r2.insertBefore(a2, r2.firstChild) : r2.appendChild(a2), this;
          }
          removeControl(e2) {
            if (!e2 || !e2.onRemove) return this.fire(new t.k(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
            const i2 = this._controls.indexOf(e2);
            return i2 > -1 && this._controls.splice(i2, 1), e2.onRemove(this), this;
          }
          hasControl(e2) {
            return this._controls.indexOf(e2) > -1;
          }
          coveringTiles(e2) {
            return Ce(this.transform, e2);
          }
          calculateCameraOptionsFromTo(e2, t2, i2, a2) {
            return null == a2 && this.terrain && (a2 = this.terrain.getElevationForLngLat(i2)), super.calculateCameraOptionsFromTo(e2, t2, i2, a2);
          }
          resize(e2, i2 = true) {
            const [a2, r2] = this._containerDimensions(), o2 = this._getClampedPixelRatio(a2, r2);
            if (this._resizeCanvas(a2, r2, o2), this.painter.resize(a2, r2, o2), this.painter.overLimit()) {
              const e3 = this.painter.context.gl;
              this._maxCanvasSize = [e3.drawingBufferWidth, e3.drawingBufferHeight];
              const t2 = this._getClampedPixelRatio(a2, r2);
              this._resizeCanvas(a2, r2, t2), this.painter.resize(a2, r2, t2);
            }
            this._resizeTransform(i2);
            const s2 = !this._moving;
            return s2 && (this.stop(), this.fire(new t.l("movestart", e2)).fire(new t.l("move", e2))), this.fire(new t.l("resize", e2)), s2 && this.fire(new t.l("moveend", e2)), this;
          }
          _resizeTransform(e2 = true) {
            var t2;
            const [i2, a2] = this._containerDimensions();
            this.transform.resize(i2, a2, e2), null === (t2 = this._requestedCameraState) || void 0 === t2 || t2.resize(i2, a2, e2);
          }
          _getClampedPixelRatio(e2, t2) {
            const { 0: i2, 1: a2 } = this._maxCanvasSize, r2 = this.getPixelRatio(), o2 = e2 * r2, s2 = t2 * r2;
            return Math.min(o2 > i2 ? i2 / o2 : 1, s2 > a2 ? a2 / s2 : 1) * r2;
          }
          getPixelRatio() {
            var e2;
            return null !== (e2 = this._overridePixelRatio) && void 0 !== e2 ? e2 : devicePixelRatio;
          }
          setPixelRatio(e2) {
            this._overridePixelRatio = e2, this.resize();
          }
          getBounds() {
            return this.transform.getBounds();
          }
          getMaxBounds() {
            return this.transform.getMaxBounds();
          }
          setMaxBounds(e2) {
            return this.transform.setMaxBounds($.convert(e2)), this._update();
          }
          setMinZoom(e2) {
            if ((e2 = null == e2 ? -2 : e2) >= -2 && e2 <= this.transform.maxZoom) return this.transform.setMinZoom(e2), this._update(), this.getZoom() < e2 && this.setZoom(e2), this;
            throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
          }
          getMinZoom() {
            return this.transform.minZoom;
          }
          setMaxZoom(e2) {
            if ((e2 = null == e2 ? 22 : e2) >= this.transform.minZoom) return this.transform.setMaxZoom(e2), this._update(), this.getZoom() > e2 && this.setZoom(e2), this;
            throw new Error("maxZoom must be greater than the current minZoom");
          }
          getMaxZoom() {
            return this.transform.maxZoom;
          }
          setMinPitch(e2) {
            if ((e2 = null == e2 ? 0 : e2) < 0) throw new Error("minPitch must be greater than or equal to 0");
            if (e2 >= 0 && e2 <= this.transform.maxPitch) return this.transform.setMinPitch(e2), this._update(), this.getPitch() < e2 && this.setPitch(e2), this;
            throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
          }
          getMinPitch() {
            return this.transform.minPitch;
          }
          setMaxPitch(e2) {
            if ((e2 = null == e2 ? 60 : e2) > 180) throw new Error("maxPitch must be less than or equal to 180");
            if (e2 >= this.transform.minPitch) return this.transform.setMaxPitch(e2), this._update(), this.getPitch() > e2 && this.setPitch(e2), this;
            throw new Error("maxPitch must be greater than the current minPitch");
          }
          getMaxPitch() {
            return this.transform.maxPitch;
          }
          getRenderWorldCopies() {
            return this.transform.renderWorldCopies;
          }
          setRenderWorldCopies(e2) {
            return this.transform.setRenderWorldCopies(e2), this._update();
          }
          setTransformConstrain(e2) {
            return this.transform.setConstrainOverride(e2), this._update();
          }
          project(e2) {
            return this.transform.locationToScreenPoint(t.V.convert(e2), this.style && this.terrain);
          }
          unproject(e2) {
            return this.transform.screenPointToLocation(t.P.convert(e2), this.terrain);
          }
          isMoving() {
            var e2;
            return this._moving || (null === (e2 = this.handlers) || void 0 === e2 ? void 0 : e2.isMoving());
          }
          isZooming() {
            var e2;
            return this._zooming || (null === (e2 = this.handlers) || void 0 === e2 ? void 0 : e2.isZooming());
          }
          isRotating() {
            var e2;
            return this._rotating || (null === (e2 = this.handlers) || void 0 === e2 ? void 0 : e2.isRotating());
          }
          _createDelegatedListener(e2, t2, i2) {
            if ("mouseenter" === e2 || "mouseover" === e2) {
              let a2 = false;
              const r2 = (r3) => {
                const o2 = t2.filter((e3) => this.getLayer(e3)), s2 = 0 !== o2.length ? this.queryRenderedFeatures(r3.point, { layers: o2 }) : [];
                s2.length ? a2 || (a2 = true, i2.call(this, new ao(e2, this, r3.originalEvent, { features: s2 }))) : a2 = false;
              };
              return { layers: t2, listener: i2, delegates: { mousemove: r2, mouseout: () => {
                a2 = false;
              } } };
            }
            if ("mouseleave" === e2 || "mouseout" === e2) {
              let a2 = false;
              const r2 = (r3) => {
                const o3 = t2.filter((e3) => this.getLayer(e3));
                (0 !== o3.length ? this.queryRenderedFeatures(r3.point, { layers: o3 }) : []).length ? a2 = true : a2 && (a2 = false, i2.call(this, new ao(e2, this, r3.originalEvent)));
              }, o2 = (t3) => {
                a2 && (a2 = false, i2.call(this, new ao(e2, this, t3.originalEvent)));
              };
              return { layers: t2, listener: i2, delegates: { mousemove: r2, mouseout: o2 } };
            }
            {
              const a2 = (e3) => {
                const a3 = t2.filter((e4) => this.getLayer(e4)), r2 = 0 !== a3.length ? this.queryRenderedFeatures(e3.point, { layers: a3 }) : [];
                r2.length && (e3.features = r2, i2.call(this, e3), delete e3.features);
              };
              return { layers: t2, listener: i2, delegates: { [e2]: a2 } };
            }
          }
          _saveDelegatedListener(e2, t2) {
            this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e2] = this._delegatedListeners[e2] || [], this._delegatedListeners[e2].push(t2);
          }
          _removeDelegatedListener(e2, t2, i2) {
            if (!this._delegatedListeners || !this._delegatedListeners[e2]) return;
            const a2 = this._delegatedListeners[e2];
            for (let e3 = 0; e3 < a2.length; e3++) {
              const r2 = a2[e3];
              if (r2.listener === i2 && r2.layers.length === t2.length && r2.layers.every((e4) => t2.includes(e4))) {
                for (const e4 in r2.delegates) this.off(e4, r2.delegates[e4]);
                return void a2.splice(e3, 1);
              }
            }
          }
          on(e2, t2, i2) {
            if (void 0 === i2) return super.on(e2, t2);
            const a2 = "string" == typeof t2 ? [t2] : t2, r2 = this._createDelegatedListener(e2, a2, i2);
            this._saveDelegatedListener(e2, r2);
            for (const e3 in r2.delegates) this.on(e3, r2.delegates[e3]);
            return { unsubscribe: () => {
              this._removeDelegatedListener(e2, a2, i2);
            } };
          }
          once(e2, t2, i2) {
            if (void 0 === i2) return super.once(e2, t2);
            const a2 = "string" == typeof t2 ? [t2] : t2, r2 = this._createDelegatedListener(e2, a2, i2);
            for (const t3 in r2.delegates) {
              const o2 = r2.delegates[t3];
              r2.delegates[t3] = (...t4) => {
                this._removeDelegatedListener(e2, a2, i2), o2(...t4);
              };
            }
            this._saveDelegatedListener(e2, r2);
            for (const e3 in r2.delegates) this.once(e3, r2.delegates[e3]);
            return this;
          }
          off(e2, t2, i2) {
            return void 0 === i2 ? super.off(e2, t2) : (this._removeDelegatedListener(e2, "string" == typeof t2 ? [t2] : t2, i2), this);
          }
          queryRenderedFeatures(e2, i2) {
            if (!this.style) return [];
            let a2;
            const r2 = e2 instanceof t.P || Array.isArray(e2), o2 = r2 ? e2 : [[0, 0], [this.transform.width, this.transform.height]];
            if (i2 = i2 || (r2 ? {} : e2) || {}, o2 instanceof t.P || "number" == typeof o2[0]) a2 = [t.P.convert(o2)];
            else {
              const e3 = t.P.convert(o2[0]), i3 = t.P.convert(o2[1]);
              a2 = [e3, new t.P(i3.x, e3.y), i3, new t.P(e3.x, i3.y), e3];
            }
            return this.style.queryRenderedFeatures(a2, i2, this.transform);
          }
          querySourceFeatures(e2, t2) {
            return this.style.querySourceFeatures(e2, t2);
          }
          setStyle(e2, i2) {
            return false !== (i2 = t.e({}, { localIdeographFontFamily: this._localIdeographFontFamily, validate: this._validateStyle }, i2)).diff && i2.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e2 ? (this._diffStyle(e2, i2), this) : (this._localIdeographFontFamily = i2.localIdeographFontFamily, this._updateStyle(e2, i2));
          }
          setTransformRequest(e2) {
            return this._requestManager.setTransformRequest(e2), this;
          }
          _getUIString(e2) {
            const t2 = this._locale[e2];
            if (null == t2) throw new Error(`Missing UI string '${e2}'`);
            return t2;
          }
          _updateStyle(e2, t2) {
            var i2, a2;
            if (t2.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", () => this._updateStyle(e2, t2));
            const r2 = this.style && t2.transformStyle ? this.style.serialize() : void 0;
            return this.style && (this.style.setEventedParent(null), this.style._remove(!e2)), e2 ? (this.style = new ki(this, t2 || {}), this.style.setEventedParent(this, { style: this.style }), "string" == typeof e2 ? this.style.loadURL(e2, t2, r2) : this.style.loadJSON(e2, t2, r2), this) : (null === (a2 = null === (i2 = this.style) || void 0 === i2 ? void 0 : i2.projection) || void 0 === a2 || a2.destroy(), delete this.style, this);
          }
          _lazyInitEmptyStyle() {
            this.style || (this.style = new ki(this, {}), this.style.setEventedParent(this, { style: this.style }), this.style.loadEmpty());
          }
          _diffStyle(e2, i2) {
            if ("string" == typeof e2) {
              const a2 = this._requestManager.transformRequest(e2, "Style");
              t.j(a2, new AbortController()).then((e3) => {
                this._updateDiff(e3.data, i2);
              }).catch((e3) => {
                e3 && this.fire(new t.k(e3));
              });
            } else "object" == typeof e2 && this._updateDiff(e2, i2);
          }
          _updateDiff(e2, i2) {
            try {
              this.style.setState(e2, i2) && this._update(true);
            } catch (a2) {
              t.w(`Unable to perform style diff: ${a2.message || a2.error || a2}.  Rebuilding the style from scratch.`), this._updateStyle(e2, i2);
            }
          }
          getStyle() {
            if (this.style) return this.style.serialize();
          }
          _getStyleAndImages() {
            return this.style ? { style: this.style.serialize(), images: this.style.imageManager.cloneImages() } : { style: null, images: {} };
          }
          isStyleLoaded() {
            return this.style ? this.style.loaded() : t.w("There is no style added to the map.");
          }
          addSource(e2, t2) {
            return this._lazyInitEmptyStyle(), this.style.addSource(e2, t2), this._update(true);
          }
          isSourceLoaded(e2) {
            const i2 = this.style && this.style.tileManagers[e2];
            if (void 0 !== i2) return i2.loaded();
            this.fire(new t.k(new Error(`There is no tile manager with ID '${e2}'`)));
          }
          setTerrain(e2) {
            if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), e2) {
              const i2 = this.style.tileManagers[e2.source];
              if (!i2) throw new Error(`cannot load terrain, because there exists no source with ID: ${e2.source}`);
              null === this.terrain && i2.reload();
              for (const i3 in this.style._layers) {
                const a2 = this.style._layers[i3];
                "hillshade" === a2.type && a2.source === e2.source && t.w("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality."), "color-relief" === a2.type && a2.source === e2.source && t.w("You are using the same source for a color-relief layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
              }
              this.terrain = new is(this.painter, i2, e2), this.painter.renderToTexture = new os(this.painter, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._terrainDataCallback = (t2) => {
                var i3;
                "style" === t2.dataType ? this.terrain.tileManager.freeRtt() : "source" === t2.dataType && t2.tile && (t2.sourceId !== e2.source || this._elevationFreeze || (this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))), "image" === (null === (i3 = t2.source) || void 0 === i3 ? void 0 : i3.type) ? this.terrain.tileManager.freeRtt() : this.terrain.tileManager.freeRtt(t2.tile.tileID));
              }, this.style.on("data", this._terrainDataCallback);
            } else this.terrain && this.terrain.tileManager.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0);
            return this.fire(new t.l("terrain", { terrain: e2 })), this;
          }
          getTerrain() {
            var e2, t2;
            return null !== (t2 = null === (e2 = this.terrain) || void 0 === e2 ? void 0 : e2.options) && void 0 !== t2 ? t2 : null;
          }
          areTilesLoaded() {
            const e2 = this.style && this.style.tileManagers;
            for (const t2 of Object.values(e2)) if (!t2.areTilesLoaded()) return false;
            return true;
          }
          removeSource(e2) {
            return this.style.removeSource(e2), this._update(true);
          }
          getSource(e2) {
            return this.style.getSource(e2);
          }
          setSourceTileLodParams(e2, t2, i2) {
            if (i2) {
              const a2 = this.getSource(i2);
              if (!a2) throw new Error(`There is no source with ID "${i2}", cannot set LOD parameters`);
              a2.calculateTileZoom = Te(Math.max(1, e2), Math.max(1, t2));
            } else for (const i3 in this.style.tileManagers) this.style.tileManagers[i3].getSource().calculateTileZoom = Te(Math.max(1, e2), Math.max(1, t2));
            return this._update(true), this;
          }
          refreshTiles(e2, i2) {
            const a2 = this.style.tileManagers[e2];
            if (!a2) throw new Error(`There is no tile manager with ID "${e2}", cannot refresh tile`);
            void 0 === i2 ? a2.reload(true) : a2.refreshTiles(i2.map((e3) => new t.ae(e3.z, e3.x, e3.y)));
          }
          addImage(e2, i2, a2 = {}) {
            const { pixelRatio: r2 = 1, sdf: o2 = false, stretchX: s2, stretchY: l2, content: c2, textFitWidth: h2, textFitHeight: u2 } = a2;
            if (this._lazyInitEmptyStyle(), !(i2 instanceof HTMLImageElement || t.b(i2))) {
              if (void 0 === i2.width || void 0 === i2.height) return this.fire(new t.k(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
              {
                const { width: a3, height: n2, data: d2 } = i2, _2 = i2;
                return this.style.addImage(e2, { data: new t.R({ width: a3, height: n2 }, new Uint8Array(d2)), pixelRatio: r2, stretchX: s2, stretchY: l2, content: c2, textFitWidth: h2, textFitHeight: u2, sdf: o2, version: 0, userImage: _2 }), _2.onAdd && _2.onAdd(this, e2), this;
              }
            }
            {
              const { width: a3, height: d2, data: _2 } = n.getImageData(i2);
              this.style.addImage(e2, { data: new t.R({ width: a3, height: d2 }, _2), pixelRatio: r2, stretchX: s2, stretchY: l2, content: c2, textFitWidth: h2, textFitHeight: u2, sdf: o2, version: 0 });
            }
          }
          updateImage(e2, i2) {
            const a2 = this.style.getImage(e2);
            if (!a2) return this.fire(new t.k(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
            const r2 = i2 instanceof HTMLImageElement || t.b(i2) ? n.getImageData(i2) : i2, { width: o2, height: s2, data: l2 } = r2;
            if (void 0 === o2 || void 0 === s2) return this.fire(new t.k(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
            if (o2 !== a2.data.width || s2 !== a2.data.height) return this.fire(new t.k(new Error("The width and height of the updated image must be that same as the previous version of the image")));
            const c2 = !(i2 instanceof HTMLImageElement || t.b(i2));
            return a2.data.replace(l2, c2), this.style.updateImage(e2, a2), this;
          }
          getImage(e2) {
            return this.style.getImage(e2);
          }
          hasImage(e2) {
            return e2 ? !!this.style.getImage(e2) : (this.fire(new t.k(new Error("Missing required image id"))), false);
          }
          removeImage(e2) {
            this.style.removeImage(e2);
          }
          loadImage(e2) {
            return g.getImage(this._requestManager.transformRequest(e2, "Image"), new AbortController());
          }
          listImages() {
            return this.style.listImages();
          }
          addLayer(e2, t2) {
            return this._lazyInitEmptyStyle(), this.style.addLayer(e2, t2), this._update(true);
          }
          moveLayer(e2, t2) {
            return this.style.moveLayer(e2, t2), this._update(true);
          }
          removeLayer(e2) {
            return this.style.removeLayer(e2), this._update(true);
          }
          getLayer(e2) {
            return this.style.getLayer(e2);
          }
          getLayersOrder() {
            return this.style.getLayersOrder();
          }
          setLayerZoomRange(e2, t2, i2) {
            return this.style.setLayerZoomRange(e2, t2, i2), this._update(true);
          }
          setFilter(e2, t2, i2 = {}) {
            return this.style.setFilter(e2, t2, i2), this._update(true);
          }
          getFilter(e2) {
            return this.style.getFilter(e2);
          }
          setPaintProperty(e2, t2, i2, a2 = {}) {
            return this.style.setPaintProperty(e2, t2, i2, a2), this._update(true);
          }
          getPaintProperty(e2, t2) {
            return this.style.getPaintProperty(e2, t2);
          }
          setLayoutProperty(e2, t2, i2, a2 = {}) {
            return this.style.setLayoutProperty(e2, t2, i2, a2), this._update(true);
          }
          getLayoutProperty(e2, t2) {
            return this.style.getLayoutProperty(e2, t2);
          }
          setGlyphs(e2, t2 = {}) {
            return this._lazyInitEmptyStyle(), this.style.setGlyphs(e2, t2), this._update(true);
          }
          getGlyphs() {
            return this.style.getGlyphsUrl();
          }
          addSprite(e2, t2, i2 = {}) {
            return this._lazyInitEmptyStyle(), this.style.addSprite(e2, t2, i2, (e3) => {
              e3 || this._update(true);
            }), this;
          }
          removeSprite(e2) {
            return this._lazyInitEmptyStyle(), this.style.removeSprite(e2), this._update(true);
          }
          getSprite() {
            return this.style.getSprite();
          }
          setSprite(e2, t2 = {}) {
            return this._lazyInitEmptyStyle(), this.style.setSprite(e2, t2, (e3) => {
              e3 || this._update(true);
            }), this;
          }
          setLight(e2, t2 = {}) {
            return this._lazyInitEmptyStyle(), this.style.setLight(e2, t2), this._update(true);
          }
          getLight() {
            return this.style.getLight();
          }
          setSky(e2, t2 = {}) {
            return this._lazyInitEmptyStyle(), this.style.setSky(e2, t2), this._update(true);
          }
          getSky() {
            return this.style.getSky();
          }
          setFeatureState(e2, t2) {
            return this.style.setFeatureState(e2, t2), this._update();
          }
          removeFeatureState(e2, t2) {
            return this.style.removeFeatureState(e2, t2), this._update();
          }
          getFeatureState(e2) {
            return this.style.getFeatureState(e2);
          }
          getContainer() {
            return this._container;
          }
          getCanvasContainer() {
            return this._canvasContainer;
          }
          getCanvas() {
            return this._canvas;
          }
          _containerDimensions() {
            let e2 = 0, t2 = 0;
            return this._container && (e2 = this._container.clientWidth || 400, t2 = this._container.clientHeight || 300), [e2, t2];
          }
          _setupContainer() {
            const e2 = this._container;
            e2.classList.add("maplibregl-map");
            const t2 = this._canvasContainer = h.create("div", "maplibregl-canvas-container", e2);
            this._interactive && t2.classList.add("maplibregl-interactive"), this._canvas = h.create("canvas", "maplibregl-canvas", t2), this._canvas.addEventListener("webglcontextlost", this._contextLost, false), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, false), this._canvas.setAttribute("tabindex", this._interactive ? "0" : "-1"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region");
            const i2 = this._containerDimensions(), a2 = this._getClampedPixelRatio(i2[0], i2[1]);
            this._resizeCanvas(i2[0], i2[1], a2);
            const r2 = this._controlContainer = h.create("div", "maplibregl-control-container", e2), o2 = this._controlPositions = {};
            ["top-left", "top-right", "bottom-left", "bottom-right"].forEach((e3) => {
              o2[e3] = h.create("div", `maplibregl-ctrl-${e3} `, r2);
            }), this._container.addEventListener("scroll", this._onMapScroll, false);
          }
          _resizeCanvas(e2, t2, i2) {
            this._canvas.width = Math.floor(i2 * e2), this._canvas.height = Math.floor(i2 * t2), this._canvas.style.width = `${e2}px`, this._canvas.style.height = `${t2}px`;
          }
          _setupPainter() {
            const e2 = Object.assign(Object.assign({}, this._canvasContextAttributes), { alpha: true, depth: true, stencil: true, premultipliedAlpha: true });
            let t2 = null;
            this._canvas.addEventListener("webglcontextcreationerror", (i3) => {
              t2 = { requestedAttributes: e2 }, i3 && (t2.statusMessage = i3.statusMessage, t2.type = i3.type);
            }, { once: true });
            let i2 = null;
            if (i2 = this._canvasContextAttributes.contextType ? this._canvas.getContext(this._canvasContextAttributes.contextType, e2) : this._canvas.getContext("webgl2", e2) || this._canvas.getContext("webgl", e2), !i2) {
              const e3 = "Failed to initialize WebGL";
              throw t2 ? (t2.message = e3, new Error(JSON.stringify(t2))) : new Error(e3);
            }
            this.painter = new qr(i2, this.transform), u.testSupport(i2);
          }
          migrateProjection(e2, i2) {
            super.migrateProjection(e2, i2), this.painter.transform = e2, this.fire(new t.l("projectiontransition", { newProjection: this.style.projection.name }));
          }
          loaded() {
            return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
          }
          _update(e2) {
            return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || e2, this._sourcesDirty = true, this.triggerRepaint(), this) : this;
          }
          _requestRenderFrame(e2) {
            return this._update(), this._renderTaskQueue.add(e2);
          }
          _cancelRenderFrame(e2) {
            this._renderTaskQueue.remove(e2);
          }
          _render(e2) {
            var i2, a2, r2, o2, s2;
            const n2 = this._idleTriggered ? this._fadeDuration : 0, l2 = (null === (i2 = this.style.projection) || void 0 === i2 ? void 0 : i2.transitionState) > 0;
            if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e2), this._removed) return;
            let h2 = false;
            if (this.style && this._styleDirty) {
              this._styleDirty = false;
              const e3 = this.transform.zoom, i3 = c();
              this.style.zoomHistory.update(e3, i3);
              const a3 = new t.H(e3, { now: i3, fadeDuration: n2, zoomHistory: this.style.zoomHistory, transition: this.style.getTransition() }), r3 = a3.crossFadingFactor();
              1 === r3 && r3 === this._crossFadingFactor || (h2 = true, this._crossFadingFactor = r3), this.style.update(a3);
            }
            const u2 = (null === (a2 = this.style.projection) || void 0 === a2 ? void 0 : a2.transitionState) > 0 !== l2;
            null === (r2 = this.style.projection) || void 0 === r2 || r2.setErrorQueryLatitudeDegrees(this.transform.center.lat), this.transform.setTransitionState(null === (o2 = this.style.projection) || void 0 === o2 ? void 0 : o2.transitionState, null === (s2 = this.style.projection) || void 0 === s2 ? void 0 : s2.latitudeErrorCorrectionRadians), this.style && (this._sourcesDirty || u2) && (this._sourcesDirty = false, this.style._updateSources(this.transform)), this.terrain ? (this.terrain.tileManager.update(this.transform, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), !this._elevationFreeze && this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))) : (this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0)), this._placementDirty = this.style && this.style._updatePlacement(this.transform, this.showCollisionBoxes, n2, this._crossSourceCollisions, u2), this.painter.render(this.style, { showTileBoundaries: this.showTileBoundaries, showOverdrawInspector: this._showOverdrawInspector, rotating: this.isRotating(), zooming: this.isZooming(), moving: this.isMoving(), fadeDuration: n2, showPadding: this.showPadding }), this.fire(new t.l("render")), this.loaded() && !this._loaded && (this._loaded = true, t.cH.mark(t.cI.load), this.fire(new t.l("load"))), this.style && (this.style.hasTransitions() || h2) && (this._styleDirty = true), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
            const d2 = this._sourcesDirty || this._styleDirty || this._placementDirty;
            return d2 || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new t.l("idle")), !this._loaded || this._fullyLoaded || d2 || (this._fullyLoaded = true, t.cH.mark(t.cI.fullLoad)), this;
          }
          redraw() {
            return this.style && (this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._render(0)), this;
          }
          remove() {
            var e2;
            this._hash && this._hash.remove();
            for (const e3 of this._controls) e3.onRemove(this);
            this._controls = [], this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && removeEventListener("online", this._onWindowOnline, false), g.removeThrottleControl(this._imageQueueHandle), null === (e2 = this._resizeObserver) || void 0 === e2 || e2.disconnect();
            const i2 = this.painter.context.gl.getExtension("WEBGL_lose_context");
            (null == i2 ? void 0 : i2.loseContext) && i2.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, false), this._canvas.removeEventListener("webglcontextlost", this._contextLost, false), h.remove(this._canvasContainer), h.remove(this._controlContainer), this._container.removeEventListener("scroll", this._onMapScroll, false), this._container.classList.remove("maplibregl-map"), t.cH.clearMetrics(), this._removed = true, this.fire(new t.l("remove"));
          }
          triggerRepaint() {
            this.style && !this._frameRequest && (this._frameRequest = new AbortController(), n.frame(this._frameRequest, (e2) => {
              t.cH.frame(e2), this._frameRequest = null;
              try {
                this._render(e2);
              } catch (e3) {
                if (!t.Z(e3) && !function(e4) {
                  return e4.message === or;
                }(e3)) throw e3;
              }
            }, () => {
            }));
          }
          get showTileBoundaries() {
            return !!this._showTileBoundaries;
          }
          set showTileBoundaries(e2) {
            this._showTileBoundaries !== e2 && (this._showTileBoundaries = e2, this._update());
          }
          get showPadding() {
            return !!this._showPadding;
          }
          set showPadding(e2) {
            this._showPadding !== e2 && (this._showPadding = e2, this._update());
          }
          get showCollisionBoxes() {
            return !!this._showCollisionBoxes;
          }
          set showCollisionBoxes(e2) {
            this._showCollisionBoxes !== e2 && (this._showCollisionBoxes = e2, e2 ? this.style._generateCollisionBoxes() : this._update());
          }
          get showOverdrawInspector() {
            return !!this._showOverdrawInspector;
          }
          set showOverdrawInspector(e2) {
            this._showOverdrawInspector !== e2 && (this._showOverdrawInspector = e2, this._update());
          }
          get repaint() {
            return !!this._repaint;
          }
          set repaint(e2) {
            this._repaint !== e2 && (this._repaint = e2, this.triggerRepaint());
          }
          get vertices() {
            return !!this._vertices;
          }
          set vertices(e2) {
            this._vertices = e2, this._update();
          }
          get version() {
            return ns;
          }
          getCameraTargetElevation() {
            return this.transform.elevation;
          }
          getProjection() {
            return this.style.getProjection();
          }
          setProjection(e2) {
            return this._lazyInitEmptyStyle(), this.style.setProjection(e2), this._update(true);
          }
        }, e.MapMouseEvent = ao, e.MapTouchEvent = ro, e.MapWheelEvent = oo, e.Marker = ms, e.NavigationControl = class {
          constructor(e2) {
            this._updateZoomButtons = () => {
              const e3 = this._map.getZoom(), t2 = e3 === this._map.getMaxZoom(), i2 = e3 === this._map.getMinZoom();
              this._zoomInButton.disabled = t2, this._zoomOutButton.disabled = i2, this._zoomInButton.setAttribute("aria-disabled", t2.toString()), this._zoomOutButton.setAttribute("aria-disabled", i2.toString());
            }, this._rotateCompassArrow = () => {
              this._compassIcon.style.transform = this.options.visualizePitch && this.options.visualizeRoll ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitchInRadians), 0.5)}) rotateZ(${-this._map.transform.roll}deg) rotateX(${this._map.transform.pitch}deg) rotateZ(${-this._map.transform.bearing}deg)` : this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitchInRadians), 0.5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${-this._map.transform.bearing}deg)` : this.options.visualizeRoll ? `rotate(${-this._map.transform.bearing - this._map.transform.roll}deg)` : `rotate(${-this._map.transform.bearing}deg)`;
            }, this._setButtonTitle = (e3, t2) => {
              const i2 = this._map._getUIString(`NavigationControl.${t2}`);
              e3.title = i2, e3.setAttribute("aria-label", i2);
            }, this.options = t.e({}, cs, e2), this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (e3) => e3.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (e3) => this._map.zoomIn({}, { originalEvent: e3 })), h.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (e3) => this._map.zoomOut({}, { originalEvent: e3 })), h.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", (e3) => {
              this.options.visualizePitch ? this._map.resetNorthPitch({}, { originalEvent: e3 }) : this._map.resetNorth({}, { originalEvent: e3 });
            }), this._compassIcon = h.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
          }
          onAdd(e2) {
            return this._map = e2, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.on("roll", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new hs(this._map, this._compass, this.options.visualizePitch)), this._container;
          }
          onRemove() {
            h.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.off("roll", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
          }
          _createButton(e2, t2) {
            const i2 = h.create("button", e2, this._container);
            return i2.type = "button", i2.addEventListener("click", t2), i2;
          }
        }, e.Popup = class extends t.E {
          constructor(e2) {
            super(), this._updateOpacity = () => {
              void 0 !== this.options.locationOccludedOpacity && (this._container.style.opacity = this._map.transform.isLocationOccluded(this.getLngLat()) ? `${this.options.locationOccludedOpacity}` : "");
            }, this.remove = () => (this._content && h.remove(this._content), this._container && (h.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), this._map._canvasContainer.classList.remove("maplibregl-track-pointer"), delete this._map, this.fire(new t.l("close"))), this), this._onMouseUp = (e3) => {
              this._update(e3.point);
            }, this._onMouseMove = (e3) => {
              this._update(e3.point);
            }, this._onDrag = (e3) => {
              this._update(e3.point);
            }, this._update = (e3) => {
              if (!this._map || !this._lngLat && !this._trackPointer || !this._content) return;
              if (!this._container) {
                if (this._container = h.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = h.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className) for (const e4 of this.options.className.split(" ")) this._container.classList.add(e4);
                this._closeButton && this._closeButton.setAttribute("aria-label", this._map._getUIString("Popup.Close")), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer");
              }
              if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._lngLat = ds(this._lngLat, this._flatPos, this._map.transform, this._trackPointer), this._trackPointer && !e3) return;
              const t2 = this._flatPos = this._pos = this._trackPointer && e3 ? e3 : this._map.project(this._lngLat);
              this._map.terrain && (this._flatPos = this._trackPointer && e3 ? e3 : this._map.transform.locationToScreenPoint(this._lngLat));
              let i2 = this.options.anchor;
              const a2 = Ps(this.options.offset);
              if (!i2) {
                const e4 = this._container.offsetWidth, r3 = this._container.offsetHeight;
                let o2;
                o2 = t2.y + a2.bottom.y < r3 ? ["top"] : t2.y > this._map.transform.height - r3 ? ["bottom"] : [], t2.x < e4 / 2 ? o2.push("left") : t2.x > this._map.transform.width - e4 / 2 && o2.push("right"), i2 = 0 === o2.length ? "bottom" : o2.join("-");
              }
              let r2 = t2.add(a2[i2]);
              this.options.subpixelPositioning || (r2 = r2.round()), h.setTransform(this._container, `${_s[i2]} translate(${r2.x}px,${r2.y}px)`), ps(this._container, i2, "popup"), this._updateOpacity();
            }, this._onClose = () => {
              this.remove();
            }, this.options = t.e(Object.create(ws), e2);
          }
          addTo(e2) {
            return this._map && this.remove(), this._map = e2, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new t.l("open")), this;
          }
          isOpen() {
            return !!this._map;
          }
          getLngLat() {
            return this._lngLat;
          }
          setLngLat(e2) {
            return this._lngLat = t.V.convert(e2), this._pos = null, this._flatPos = null, this._trackPointer = false, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
          }
          trackPointer() {
            return this._trackPointer = true, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
          }
          getElement() {
            return this._container;
          }
          setText(e2) {
            return this.setDOMContent(document.createTextNode(e2));
          }
          setHTML(e2) {
            const t2 = document.createDocumentFragment(), i2 = document.createElement("body");
            let a2;
            for (i2.innerHTML = e2; a2 = i2.firstChild, a2; ) t2.appendChild(a2);
            return this.setDOMContent(t2);
          }
          getMaxWidth() {
            var e2;
            return null === (e2 = this._container) || void 0 === e2 ? void 0 : e2.style.maxWidth;
          }
          setMaxWidth(e2) {
            return this.options.maxWidth = e2, this._update(), this;
          }
          setDOMContent(e2) {
            if (this._content) for (; this._content.hasChildNodes(); ) this._content.firstChild && this._content.removeChild(this._content.firstChild);
            else this._content = h.create("div", "maplibregl-popup-content", this._container);
            return this._content.appendChild(e2), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
          }
          addClassName(e2) {
            return this._container && this._container.classList.add(e2), this;
          }
          removeClassName(e2) {
            return this._container && this._container.classList.remove(e2), this;
          }
          setOffset(e2) {
            return this.options.offset = e2, this._update(), this;
          }
          toggleClassName(e2) {
            if (this._container) return this._container.classList.toggle(e2);
          }
          setSubpixelPositioning(e2) {
            this.options.subpixelPositioning = e2;
          }
          _createCloseButton() {
            this.options.closeButton && (this._closeButton = h.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
          }
          _focusFirstElement() {
            if (!this.options.focusAfterOpen || !this._container) return;
            const e2 = this._container.querySelector(Ts);
            e2 && e2.focus();
          }
        }, e.RasterDEMTileSource = Y, e.RasterTileSource = K, e.ScaleControl = class {
          constructor(e2) {
            this._onMove = () => {
              bs(this._map, this._container, this.options);
            }, this.setUnit = (e3) => {
              this.options.unit = e3, bs(this._map, this._container, this.options);
            }, this.options = Object.assign(Object.assign({}, xs), e2);
          }
          getDefaultPosition() {
            return "bottom-left";
          }
          onAdd(e2) {
            return this._map = e2, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", e2.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
          }
          onRemove() {
            h.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
          }
        }, e.ScrollZoomHandler = Bo, e.Style = ki, e.TerrainControl = class {
          constructor(e2) {
            this._toggleTerrain = () => {
              this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
            }, this._updateTerrainIcon = () => {
              this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.Disable")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.Enable"));
            }, this.options = e2;
          }
          onAdd(e2) {
            return this._map = e2, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = h.create("button", "maplibregl-ctrl-terrain", this._container), h.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
          }
          onRemove() {
            h.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
          }
        }, e.TwoFingersTouchPitchHandler = zo, e.TwoFingersTouchRotateHandler = So, e.TwoFingersTouchZoomHandler = Mo, e.TwoFingersTouchZoomRotateHandler = Uo, e.VectorTileSource = X, e.VideoSource = ie, e.addSourceType = (e2, i2) => t._(void 0, void 0, void 0, function* () {
          if (oe(e2)) throw new Error(`A source type called "${e2}" already exists.`);
          ((e3, t2) => {
            re[e3] = t2;
          })(e2, i2);
        }), e.clearPrewarmedResources = function() {
          const e2 = B;
          e2 && (e2.isPreloaded() && 1 === e2.numActive() ? (e2.release(L2), B = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, e.createTileMesh = li, e.getMaxParallelImageRequests = function() {
          return t.c.MAX_PARALLEL_IMAGE_REQUESTS;
        }, e.getRTLTextPluginStatus = function() {
          return ce().getRTLTextPluginStatus();
        }, e.getVersion = function() {
          return Is;
        }, e.getWorkerCount = function() {
          return k.workerCount;
        }, e.getWorkerUrl = function() {
          return t.c.WORKER_URL;
        }, e.importScriptInWorkers = function(e2) {
          return Z().broadcast("IS", e2);
        }, e.isTimeFrozen = function() {
          return l.isFrozen();
        }, e.now = c, e.prewarm = function() {
          j().acquire(L2);
        }, e.restoreNow = function() {
          l.restoreNow();
        }, e.setMaxParallelImageRequests = function(e2) {
          t.c.MAX_PARALLEL_IMAGE_REQUESTS = e2;
        }, e.setNow = function(e2) {
          l.setNow(e2);
        }, e.setRTLTextPlugin = function(e2, t2) {
          return ce().setRTLTextPlugin(e2, t2);
        }, e.setWorkerCount = function(e2) {
          k.workerCount = e2;
        }, e.setWorkerUrl = function(e2) {
          t.c.WORKER_URL = e2;
        };
      });
      var maplibregl$1 = maplibregl;
      return maplibregl$1;
    });
  })(maplibreGl$1);
  return maplibreGl$1.exports;
}
requireMaplibreGl();
var leafletMaplibreGl$1 = { exports: {} };
var leafletMaplibreGl = leafletMaplibreGl$1.exports;
var hasRequiredLeafletMaplibreGl;
function requireLeafletMaplibreGl() {
  if (hasRequiredLeafletMaplibreGl) return leafletMaplibreGl$1.exports;
  hasRequiredLeafletMaplibreGl = 1;
  (function(module, exports) {
    (function(root, factory) {
      {
        module.exports = factory(requireLeafletSrc(), requireMaplibreGl());
      }
    })(typeof globalThis !== "undefined" ? globalThis : leafletMaplibreGl || self, function(L2, maplibregl) {
      L2.MaplibreGL = L2.Layer.extend({
        options: {
          updateInterval: 32,
          // How much to extend the overlay view (relative to map size)
          // e.g. 0.1 would be 10% of map view in each direction
          padding: 0.1,
          // whether or not to register the mouse and keyboard
          // events on the maplibre overlay
          interactive: false,
          // set the tilepane as the default pane to draw gl tiles
          pane: "tilePane"
        },
        initialize: function(options) {
          L2.setOptions(this, options);
          this._throttledUpdate = L2.Util.throttle(this._update, this.options.updateInterval, this);
        },
        onAdd: function(map) {
          if (!this._container) {
            this._initContainer();
          }
          var paneName = this.getPaneName();
          map.getPane(paneName).appendChild(this._container);
          this._initGL();
          this._offset = this._map.containerPointToLayerPoint([0, 0]);
          if (map.options.zoomAnimation) {
            L2.DomEvent.on(map._proxy, L2.DomUtil.TRANSITION_END, this._transitionEnd, this);
          }
        },
        onRemove: function(map) {
          if (this._map._proxy && this._map.options.zoomAnimation) {
            L2.DomEvent.off(this._map._proxy, L2.DomUtil.TRANSITION_END, this._transitionEnd, this);
          }
          var paneName = this.getPaneName();
          map.getPane(paneName).removeChild(this._container);
          this._glMap.remove();
          this._glMap = null;
        },
        getEvents: function() {
          return {
            move: this._throttledUpdate,
            // sensibly throttle updating while panning
            zoomanim: this._animateZoom,
            // applys the zoom animation to the <canvas>
            zoom: this._pinchZoom,
            // animate every zoom event for smoother pinch-zooming
            zoomstart: this._zoomStart,
            // flag starting a zoom to disable panning
            zoomend: this._zoomEnd,
            resize: this._resize
          };
        },
        // https://leafletjs.com/reference.html#layer-getattribution
        getAttribution: function() {
          if (this.options.attributionControl) {
            return this.options.attributionControl.customAttribution;
          }
          var map = this._glMap;
          if (map && this.options.attributionControl !== false) {
            var style = map.getStyle();
            if (style && style.sources) {
              return Object.keys(style.sources).map(function(sourceId) {
                var source = map.getSource(sourceId);
                return source && typeof source.attribution === "string" ? source.attribution.trim() : null;
              }).filter(Boolean).join(", ");
            }
          }
          return "";
        },
        getMaplibreMap: function() {
          return this._glMap;
        },
        getCanvas: function() {
          return this._glMap.getCanvas();
        },
        getSize: function() {
          return this._map.getSize().multiplyBy(1 + this.options.padding * 2);
        },
        getBounds: function() {
          var halfSize = this.getSize().multiplyBy(0.5);
          var center = this._map.latLngToContainerPoint(this._map.getCenter());
          return L2.latLngBounds(
            this._map.containerPointToLatLng(center.subtract(halfSize)),
            this._map.containerPointToLatLng(center.add(halfSize))
          );
        },
        getContainer: function() {
          return this._container;
        },
        // returns the pane name set in options if it is a valid pane, defaults to tilePane
        getPaneName: function() {
          return this._map.getPane(this.options.pane) ? this.options.pane : "tilePane";
        },
        _roundPoint: function(p) {
          return { x: Math.round(p.x), y: Math.round(p.y) };
        },
        _initContainer: function() {
          var container = this._container = L2.DomUtil.create("div", "leaflet-gl-layer");
          this._resizeContainer();
          var offset = this._map.getSize().multiplyBy(this.options.padding);
          var topLeft = this._map.containerPointToLayerPoint([0, 0]).subtract(offset);
          L2.DomUtil.setPosition(container, this._roundPoint(topLeft));
        },
        _resizeContainer: function() {
          var size = this.getSize();
          this._container.style.width = size.x + "px";
          this._container.style.height = size.y + "px";
        },
        _initGL: function() {
          var center = this._map.getCenter();
          var options = L2.extend({}, this.options, {
            container: this._container,
            center: [center.lng, center.lat],
            zoom: this._map.getZoom() - 1,
            attributionControl: false
          });
          this._glMap = new maplibregl.Map(options);
          var _map = this._map;
          var _currentAttribution = this.getAttribution();
          var _getAttribution = this.getAttribution.bind(this);
          this._glMap.on("load", function() {
            if (_map && _map.attributionControl) {
              _map.attributionControl.removeAttribution(_currentAttribution);
              _map.attributionControl.addAttribution(_getAttribution());
            }
          });
          var transformProto = Object.getPrototypeOf(this._glMap.transform);
          var latRangeDescriptor = Object.getOwnPropertyDescriptor(transformProto, "latRange");
          if (!latRangeDescriptor || latRangeDescriptor.set || latRangeDescriptor.writable) {
            this._glMap.transform.latRange = null;
          }
          var maxValidLatitudeDescriptor = Object.getOwnPropertyDescriptor(transformProto, "maxValidLatitude");
          if (!maxValidLatitudeDescriptor || maxValidLatitudeDescriptor.set || maxValidLatitudeDescriptor.writable) {
            this._glMap.transform.maxValidLatitude = Infinity;
          }
          if (this._glMap.transform._helper && this._glMap.transform._helper._latRange) {
            this._glMap.transform._helper._latRange = [-Infinity, Infinity];
          }
          this._transformGL(this._glMap);
          if (this._glMap._canvas.canvas) {
            this._glMap._actualCanvas = this._glMap._canvas.canvas;
          } else {
            this._glMap._actualCanvas = this._glMap._canvas;
          }
          var canvas = this._glMap._actualCanvas;
          L2.DomUtil.addClass(canvas, "leaflet-image-layer");
          L2.DomUtil.addClass(canvas, "leaflet-zoom-animated");
          if (this.options.interactive) {
            L2.DomUtil.addClass(canvas, "leaflet-interactive");
          }
          if (this.options.className) {
            L2.DomUtil.addClass(canvas, this.options.className);
          }
        },
        _update: function(e) {
          if (!this._map) {
            return;
          }
          this._offset = this._map.containerPointToLayerPoint([0, 0]);
          if (this._zooming) {
            return;
          }
          var container = this._container, gl = this._glMap, offset = this._map.getSize().multiplyBy(this.options.padding), topLeft = this._map.containerPointToLayerPoint([0, 0]).subtract(offset);
          L2.DomUtil.setPosition(container, this._roundPoint(topLeft));
          this._transformGL(gl);
        },
        _transformGL: function(gl) {
          var center = this._map.getCenter();
          var tr = gl._getTransformForUpdate();
          if (tr.setCenter) {
            tr.setCenter(maplibregl.LngLat.convert([center.lng, center.lat]));
            tr.setZoom(this._map.getZoom() - 1);
            gl.transform.apply(tr);
          } else {
            tr = gl.transform;
            tr.center = maplibregl.LngLat.convert([center.lng, center.lat]);
            tr.zoom = this._map.getZoom() - 1;
          }
          gl._fireMoveEvents();
        },
        // update the map constantly during a pinch zoom
        _pinchZoom: function(e) {
          this._glMap.jumpTo({
            zoom: this._map.getZoom() - 1,
            center: this._map.getCenter()
          });
        },
        // borrowed from L.ImageOverlay
        // https://github.com/Leaflet/Leaflet/blob/master/src/layer/ImageOverlay.js#L139-L144
        _animateZoom: function(e) {
          var scale = this._map.getZoomScale(e.zoom);
          var padding = this._map.getSize().multiplyBy(this.options.padding * scale);
          var viewHalf = this.getSize()._divideBy(2);
          var topLeft = this._map.project(e.center, e.zoom)._subtract(viewHalf)._add(this._map._getMapPanePos().add(padding))._round();
          var offset = this._map.project(this._map.getBounds().getNorthWest(), e.zoom)._subtract(topLeft);
          L2.DomUtil.setTransform(
            this._glMap._actualCanvas,
            offset.subtract(this._offset),
            scale
          );
        },
        _zoomStart: function(e) {
          this._zooming = true;
        },
        _zoomEnd: function() {
          var scale = this._map.getZoomScale(this._map.getZoom());
          L2.DomUtil.setTransform(
            this._glMap._actualCanvas,
            // https://github.com/mapbox/mapbox-gl-leaflet/pull/130
            null,
            scale
          );
          this._zooming = false;
          this._update();
        },
        _transitionEnd: function(e) {
          L2.Util.requestAnimFrame(function() {
            var zoom = this._map.getZoom();
            var center = this._map.getCenter();
            var offset = this._map.latLngToContainerPoint(
              this._map.getBounds().getNorthWest()
            );
            this._resizeContainer();
            L2.DomUtil.setTransform(this._glMap._actualCanvas, offset, 1);
            this._glMap.once("moveend", L2.Util.bind(function() {
              this._zoomEnd();
            }, this));
            this._glMap.jumpTo({
              center,
              zoom: zoom - 1
            });
          }, this);
        },
        _resize: function(e) {
          this._transitionEnd(e);
        }
      });
      L2.maplibreGL = function(options) {
        return new L2.MaplibreGL(options);
      };
    });
  })(leafletMaplibreGl$1);
  return leafletMaplibreGl$1.exports;
}
requireLeafletMaplibreGl();
const BASEURL = "https://ehirroizlluemlumrcec.supabase.co/functions/v1/";
function useCustomerData() {
  const [data, setData] = reactExports.useState([]);
  const [hasFetched, setHasFetched] = reactExports.useState(false);
  const [currentOrder, setCurrentOrder] = reactExports.useState(null);
  reactExports.useEffect(() => {
    const abortController = new AbortController();
    fetchData(abortController.signal);
    return () => {
      abortController.abort("Component unloaded");
    };
  }, []);
  return {
    currentOrder,
    data,
    hasFetched
  };
  async function fetchData(signal) {
    const currentUrl = new URL(location);
    const query = currentUrl.searchParams;
    const token = await getNewToken(signal);
    let data2 = [];
    let resDataCount = 0;
    let offset = 0;
    const step = 100 * 1e3;
    if (!token) {
      setHasFetched(true);
      return;
    }
    const url = BASEURL + "regioned-customer-data";
    const currentOrderId = query.get("order_id") || query.get("anon_oid");
    if (currentOrderId) {
      const options = {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "authorization": "Bearer " + token
        },
        body: JSON.stringify({
          order_id: currentOrderId
        }),
        "signal": signal
      };
      const res = await fetch(url, options);
      const resJson = await res.json();
      if (resJson[0]) {
        setCurrentOrder(resJson[0]);
      }
      if ((resJson == null ? void 0 : resJson.length) > 0) {
        data2 = data2.concat(resJson);
      }
    }
    try {
      do {
        const bodyObj = {
          offset,
          version: "2"
        };
        const options = {
          method: "POST",
          headers: {
            "content-type": "application/json",
            "authorization": "Bearer " + token
          },
          body: JSON.stringify(bodyObj),
          "signal": signal
        };
        const res = await fetch(url, options);
        const resJson = await res.json();
        resDataCount = resJson.length;
        data2 = data2.concat(resJson);
        offset += resDataCount;
      } while (resDataCount === step && !signal.aborted);
    } catch (err) {
      console.error("Failed to fetch data", err);
    }
    if (signal.aborted) {
      return;
    }
    setHasFetched(true);
    setData(data2);
  }
}
async function getNewToken(signal) {
  if (!window.Shopify) {
    throw new Error("Cannot get customer token if not on Shopify store");
  }
  const url = new URL(location.origin + "/apps/ordermap-create-customer");
  const locationSearchParams = new URLSearchParams(location.search);
  const keys = ["anon_id", "anon_oid", "anon_sig"];
  keys.forEach((key) => {
    const value = locationSearchParams.get(key);
    if (value) {
      url.searchParams.set(key, value);
    }
  });
  const options = {
    "headers": {
      "content-type": "application/json",
      "authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVoaXJyb2l6bGx1ZW1sdW1yY2VjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE3OTIzNTAsImV4cCI6MjA1NzM2ODM1MH0.5ztakU-QvAcfYKl8P9vON_yzwr8k3DCKOVCL54sk4QU"
    },
    "signal": signal
  };
  console.log({ url });
  const res = await fetch(url, options);
  const json = await res.json();
  if (json.error) {
    console.error(Error("Customer id didn't match logged in customer"));
    return false;
  }
  return json.token;
}
async function fetchRecentData(signal) {
  const token = await getNewToken(signal);
  let data = [];
  let resDataCount = 0;
  let offset = 0;
  const step = 100 * 1e3;
  const url = BASEURL + "regioned-customer-data";
  try {
    do {
      const bodyObj = {
        offset,
        version: "2"
      };
      const options = {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "authorization": "Bearer " + token
        },
        body: JSON.stringify(bodyObj),
        "signal": signal
      };
      const res = await fetch(url, options);
      const resJson = await res.json();
      resDataCount = resJson.length;
      data = data.concat(resJson);
      offset += resDataCount;
    } while (resDataCount === step && !signal.aborted);
  } catch (err) {
    console.error("Failed to fetch data", err);
  }
  if (signal.aborted) {
    return false;
  }
  return data;
}
const markersContext = reactExports.createContext();
function MarkersContextProvider({ children, setLoading, loading }) {
  const [markers, setMarkers] = reactExports.useState([]);
  const [clustering, setClustering] = reactExports.useState(true);
  const [_hasFetched, set_HasFetched] = reactExports.useState(false);
  const [activeTimelapse, setActiveTimelapse] = reactExports.useState(false);
  const [showTimelaseControls, setShowTimelaseControls] = reactExports.useState(false);
  const { data, hasFetched, currentOrder } = useCustomerData();
  const dataTime = (/* @__PURE__ */ new Date()).valueOf();
  const url = new URL(location);
  const query = url.searchParams;
  const currentOrderId = query.get("order_id") || query.get("anon_oid");
  reactExports.useEffect(() => {
    console.log("updateing markers");
    setLoading(true);
    requestAnimationFrame(() => {
      setClustering(true);
      setMarkers(data);
      set_HasFetched(hasFetched);
    });
  }, [data.length, hasFetched]);
  reactExports.useEffect(() => {
    const abort = new AbortController();
    let timeoutId;
    const intervalId = setInterval(async () => {
      const recentData = await fetchRecentData(abort.signal);
      if (recentData) {
        if (currentOrder && !recentData.find((x) => x.order_id && x.order_id == currentOrder.id)) {
          recentData.push(currentOrder);
        }
        setLoading(true);
        if (markers.length == recentData.length) {
          timeoutId = setTimeout(() => {
            setLoading(false);
          }, 1 * 1e3);
        }
        setMarkers(recentData);
      }
    }, 5 * 60 * 1e3);
    return () => {
      abort.abort();
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [markers.length, currentOrder]);
  const mapTiles = [
    {
      isLeafletTile: false,
      style: "https://tiles.openfreemap.org/styles/positron"
    }
  ];
  const [mapTile, setMapTile] = reactExports.useState(mapTiles[0]);
  const handleToggleClustering = (ev) => {
    ev.preventDefault();
    setLoading(true);
    requestAnimationFrame(() => {
      setClustering((clustering2) => !clustering2);
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(markersContext.Provider, { value: {
    dataTime,
    markers,
    setMarkers,
    clustering,
    setClustering,
    setLoading,
    loading,
    mapTile,
    handleToggleClustering,
    currentOrderId,
    hasFetched: _hasFetched,
    activeTimelapse,
    setActiveTimelapse,
    showTimelaseControls,
    setShowTimelaseControls
  }, children });
}
function useMarkersContext() {
  const context = reactExports.useContext(markersContext);
  if (!context) {
    throw new Error("useMarkersContext must be used within a MarkersContextProvider");
  }
  return context;
}
var leaflet_markerclusterSrc$1 = { exports: {} };
var leaflet_markerclusterSrc = leaflet_markerclusterSrc$1.exports;
var hasRequiredLeaflet_markerclusterSrc;
function requireLeaflet_markerclusterSrc() {
  if (hasRequiredLeaflet_markerclusterSrc) return leaflet_markerclusterSrc$1.exports;
  hasRequiredLeaflet_markerclusterSrc = 1;
  (function(module, exports) {
    (function(global, factory) {
      factory(exports);
    })(leaflet_markerclusterSrc, function(exports2) {
      var MarkerClusterGroup = L.MarkerClusterGroup = L.FeatureGroup.extend({
        options: {
          maxClusterRadius: 80,
          //A cluster will cover at most this many pixels from its center
          iconCreateFunction: null,
          clusterPane: L.Marker.prototype.options.pane,
          spiderfyOnEveryZoom: false,
          spiderfyOnMaxZoom: true,
          showCoverageOnHover: true,
          zoomToBoundsOnClick: true,
          singleMarkerMode: false,
          disableClusteringAtZoom: null,
          // Setting this to false prevents the removal of any clusters outside of the viewpoint, which
          // is the default behaviour for performance reasons.
          removeOutsideVisibleBounds: true,
          // Set to false to disable all animations (zoom and spiderfy).
          // If false, option animateAddingMarkers below has no effect.
          // If L.DomUtil.TRANSITION is falsy, this option has no effect.
          animate: true,
          //Whether to animate adding markers after adding the MarkerClusterGroup to the map
          // If you are adding individual markers set to true, if adding bulk markers leave false for massive performance gains.
          animateAddingMarkers: false,
          // Make it possible to provide custom function to calculate spiderfy shape positions
          spiderfyShapePositions: null,
          //Increase to increase the distance away that spiderfied markers appear from the center
          spiderfyDistanceMultiplier: 1,
          // Make it possible to specify a polyline options on a spider leg
          spiderLegPolylineOptions: { weight: 1.5, color: "#222", opacity: 0.5 },
          // When bulk adding layers, adds markers in chunks. Means addLayers may not add all the layers in the call, others will be loaded during setTimeouts
          chunkedLoading: false,
          chunkInterval: 200,
          // process markers for a maximum of ~ n milliseconds (then trigger the chunkProgress callback)
          chunkDelay: 50,
          // at the end of each interval, give n milliseconds back to system/browser
          chunkProgress: null,
          // progress callback: function(processed, total, elapsed) (e.g. for a progress indicator)
          //Options to pass to the L.Polygon constructor
          polygonOptions: {}
        },
        initialize: function(options) {
          L.Util.setOptions(this, options);
          if (!this.options.iconCreateFunction) {
            this.options.iconCreateFunction = this._defaultIconCreateFunction;
          }
          this._featureGroup = L.featureGroup();
          this._featureGroup.addEventParent(this);
          this._nonPointGroup = L.featureGroup();
          this._nonPointGroup.addEventParent(this);
          this._inZoomAnimation = 0;
          this._needsClustering = [];
          this._needsRemoving = [];
          this._currentShownBounds = null;
          this._queue = [];
          this._childMarkerEventHandlers = {
            "dragstart": this._childMarkerDragStart,
            "move": this._childMarkerMoved,
            "dragend": this._childMarkerDragEnd
          };
          var animate = L.DomUtil.TRANSITION && this.options.animate;
          L.extend(this, animate ? this._withAnimation : this._noAnimation);
          this._markerCluster = animate ? L.MarkerCluster : L.MarkerClusterNonAnimated;
        },
        addLayer: function(layer) {
          if (layer instanceof L.LayerGroup) {
            return this.addLayers([layer]);
          }
          if (!layer.getLatLng) {
            this._nonPointGroup.addLayer(layer);
            this.fire("layeradd", { layer });
            return this;
          }
          if (!this._map) {
            this._needsClustering.push(layer);
            this.fire("layeradd", { layer });
            return this;
          }
          if (this.hasLayer(layer)) {
            return this;
          }
          if (this._unspiderfy) {
            this._unspiderfy();
          }
          this._addLayer(layer, this._maxZoom);
          this.fire("layeradd", { layer });
          this._topClusterLevel._recalculateBounds();
          this._refreshClustersIcons();
          var visibleLayer = layer, currentZoom = this._zoom;
          if (layer.__parent) {
            while (visibleLayer.__parent._zoom >= currentZoom) {
              visibleLayer = visibleLayer.__parent;
            }
          }
          if (this._currentShownBounds.contains(visibleLayer.getLatLng())) {
            if (this.options.animateAddingMarkers) {
              this._animationAddLayer(layer, visibleLayer);
            } else {
              this._animationAddLayerNonAnimated(layer, visibleLayer);
            }
          }
          return this;
        },
        removeLayer: function(layer) {
          if (layer instanceof L.LayerGroup) {
            return this.removeLayers([layer]);
          }
          if (!layer.getLatLng) {
            this._nonPointGroup.removeLayer(layer);
            this.fire("layerremove", { layer });
            return this;
          }
          if (!this._map) {
            if (!this._arraySplice(this._needsClustering, layer) && this.hasLayer(layer)) {
              this._needsRemoving.push({ layer, latlng: layer._latlng });
            }
            this.fire("layerremove", { layer });
            return this;
          }
          if (!layer.__parent) {
            return this;
          }
          if (this._unspiderfy) {
            this._unspiderfy();
            this._unspiderfyLayer(layer);
          }
          this._removeLayer(layer, true);
          this.fire("layerremove", { layer });
          this._topClusterLevel._recalculateBounds();
          this._refreshClustersIcons();
          layer.off(this._childMarkerEventHandlers, this);
          if (this._featureGroup.hasLayer(layer)) {
            this._featureGroup.removeLayer(layer);
            if (layer.clusterShow) {
              layer.clusterShow();
            }
          }
          return this;
        },
        //Takes an array of markers and adds them in bulk
        addLayers: function(layersArray, skipLayerAddEvent) {
          if (!L.Util.isArray(layersArray)) {
            return this.addLayer(layersArray);
          }
          var fg = this._featureGroup, npg = this._nonPointGroup, chunked = this.options.chunkedLoading, chunkInterval = this.options.chunkInterval, chunkProgress = this.options.chunkProgress, l = layersArray.length, offset = 0, originalArray = true, m;
          if (this._map) {
            var started = (/* @__PURE__ */ new Date()).getTime();
            var process2 = L.bind(function() {
              var start = (/* @__PURE__ */ new Date()).getTime();
              if (this._map && this._unspiderfy) {
                this._unspiderfy();
              }
              for (; offset < l; offset++) {
                if (chunked && offset % 200 === 0) {
                  var elapsed = (/* @__PURE__ */ new Date()).getTime() - start;
                  if (elapsed > chunkInterval) {
                    break;
                  }
                }
                m = layersArray[offset];
                if (m instanceof L.LayerGroup) {
                  if (originalArray) {
                    layersArray = layersArray.slice();
                    originalArray = false;
                  }
                  this._extractNonGroupLayers(m, layersArray);
                  l = layersArray.length;
                  continue;
                }
                if (!m.getLatLng) {
                  npg.addLayer(m);
                  if (!skipLayerAddEvent) {
                    this.fire("layeradd", { layer: m });
                  }
                  continue;
                }
                if (this.hasLayer(m)) {
                  continue;
                }
                this._addLayer(m, this._maxZoom);
                if (!skipLayerAddEvent) {
                  this.fire("layeradd", { layer: m });
                }
                if (m.__parent) {
                  if (m.__parent.getChildCount() === 2) {
                    var markers = m.__parent.getAllChildMarkers(), otherMarker = markers[0] === m ? markers[1] : markers[0];
                    fg.removeLayer(otherMarker);
                  }
                }
              }
              if (chunkProgress) {
                chunkProgress(offset, l, (/* @__PURE__ */ new Date()).getTime() - started);
              }
              if (offset === l) {
                this._topClusterLevel._recalculateBounds();
                this._refreshClustersIcons();
                this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
              } else {
                setTimeout(process2, this.options.chunkDelay);
              }
            }, this);
            process2();
          } else {
            var needsClustering = this._needsClustering;
            for (; offset < l; offset++) {
              m = layersArray[offset];
              if (m instanceof L.LayerGroup) {
                if (originalArray) {
                  layersArray = layersArray.slice();
                  originalArray = false;
                }
                this._extractNonGroupLayers(m, layersArray);
                l = layersArray.length;
                continue;
              }
              if (!m.getLatLng) {
                npg.addLayer(m);
                continue;
              }
              if (this.hasLayer(m)) {
                continue;
              }
              needsClustering.push(m);
            }
          }
          return this;
        },
        //Takes an array of markers and removes them in bulk
        removeLayers: function(layersArray) {
          var i, m, l = layersArray.length, fg = this._featureGroup, npg = this._nonPointGroup, originalArray = true;
          if (!this._map) {
            for (i = 0; i < l; i++) {
              m = layersArray[i];
              if (m instanceof L.LayerGroup) {
                if (originalArray) {
                  layersArray = layersArray.slice();
                  originalArray = false;
                }
                this._extractNonGroupLayers(m, layersArray);
                l = layersArray.length;
                continue;
              }
              this._arraySplice(this._needsClustering, m);
              npg.removeLayer(m);
              if (this.hasLayer(m)) {
                this._needsRemoving.push({ layer: m, latlng: m._latlng });
              }
              this.fire("layerremove", { layer: m });
            }
            return this;
          }
          if (this._unspiderfy) {
            this._unspiderfy();
            var layersArray2 = layersArray.slice(), l2 = l;
            for (i = 0; i < l2; i++) {
              m = layersArray2[i];
              if (m instanceof L.LayerGroup) {
                this._extractNonGroupLayers(m, layersArray2);
                l2 = layersArray2.length;
                continue;
              }
              this._unspiderfyLayer(m);
            }
          }
          for (i = 0; i < l; i++) {
            m = layersArray[i];
            if (m instanceof L.LayerGroup) {
              if (originalArray) {
                layersArray = layersArray.slice();
                originalArray = false;
              }
              this._extractNonGroupLayers(m, layersArray);
              l = layersArray.length;
              continue;
            }
            if (!m.__parent) {
              npg.removeLayer(m);
              this.fire("layerremove", { layer: m });
              continue;
            }
            this._removeLayer(m, true, true);
            this.fire("layerremove", { layer: m });
            if (fg.hasLayer(m)) {
              fg.removeLayer(m);
              if (m.clusterShow) {
                m.clusterShow();
              }
            }
          }
          this._topClusterLevel._recalculateBounds();
          this._refreshClustersIcons();
          this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
          return this;
        },
        //Removes all layers from the MarkerClusterGroup
        clearLayers: function() {
          if (!this._map) {
            this._needsClustering = [];
            this._needsRemoving = [];
            delete this._gridClusters;
            delete this._gridUnclustered;
          }
          if (this._noanimationUnspiderfy) {
            this._noanimationUnspiderfy();
          }
          this._featureGroup.clearLayers();
          this._nonPointGroup.clearLayers();
          this.eachLayer(function(marker) {
            marker.off(this._childMarkerEventHandlers, this);
            delete marker.__parent;
          }, this);
          if (this._map) {
            this._generateInitialClusters();
          }
          return this;
        },
        //Override FeatureGroup.getBounds as it doesn't work
        getBounds: function() {
          var bounds = new L.LatLngBounds();
          if (this._topClusterLevel) {
            bounds.extend(this._topClusterLevel._bounds);
          }
          for (var i = this._needsClustering.length - 1; i >= 0; i--) {
            bounds.extend(this._needsClustering[i].getLatLng());
          }
          bounds.extend(this._nonPointGroup.getBounds());
          return bounds;
        },
        //Overrides LayerGroup.eachLayer
        eachLayer: function(method, context) {
          var markers = this._needsClustering.slice(), needsRemoving = this._needsRemoving, thisNeedsRemoving, i, j;
          if (this._topClusterLevel) {
            this._topClusterLevel.getAllChildMarkers(markers);
          }
          for (i = markers.length - 1; i >= 0; i--) {
            thisNeedsRemoving = true;
            for (j = needsRemoving.length - 1; j >= 0; j--) {
              if (needsRemoving[j].layer === markers[i]) {
                thisNeedsRemoving = false;
                break;
              }
            }
            if (thisNeedsRemoving) {
              method.call(context, markers[i]);
            }
          }
          this._nonPointGroup.eachLayer(method, context);
        },
        //Overrides LayerGroup.getLayers
        getLayers: function() {
          var layers = [];
          this.eachLayer(function(l) {
            layers.push(l);
          });
          return layers;
        },
        //Overrides LayerGroup.getLayer, WARNING: Really bad performance
        getLayer: function(id) {
          var result = null;
          id = parseInt(id, 10);
          this.eachLayer(function(l) {
            if (L.stamp(l) === id) {
              result = l;
            }
          });
          return result;
        },
        //Returns true if the given layer is in this MarkerClusterGroup
        hasLayer: function(layer) {
          if (!layer) {
            return false;
          }
          var i, anArray = this._needsClustering;
          for (i = anArray.length - 1; i >= 0; i--) {
            if (anArray[i] === layer) {
              return true;
            }
          }
          anArray = this._needsRemoving;
          for (i = anArray.length - 1; i >= 0; i--) {
            if (anArray[i].layer === layer) {
              return false;
            }
          }
          return !!(layer.__parent && layer.__parent._group === this) || this._nonPointGroup.hasLayer(layer);
        },
        //Zoom down to show the given layer (spiderfying if necessary) then calls the callback
        zoomToShowLayer: function(layer, callback) {
          var map = this._map;
          if (typeof callback !== "function") {
            callback = function() {
            };
          }
          var showMarker = function() {
            if ((map.hasLayer(layer) || map.hasLayer(layer.__parent)) && !this._inZoomAnimation) {
              this._map.off("moveend", showMarker, this);
              this.off("animationend", showMarker, this);
              if (map.hasLayer(layer)) {
                callback();
              } else if (layer.__parent._icon) {
                this.once("spiderfied", callback, this);
                layer.__parent.spiderfy();
              }
            }
          };
          if (layer._icon && this._map.getBounds().contains(layer.getLatLng())) {
            callback();
          } else if (layer.__parent._zoom < Math.round(this._map._zoom)) {
            this._map.on("moveend", showMarker, this);
            this._map.panTo(layer.getLatLng());
          } else {
            this._map.on("moveend", showMarker, this);
            this.on("animationend", showMarker, this);
            layer.__parent.zoomToBounds();
          }
        },
        //Overrides FeatureGroup.onAdd
        onAdd: function(map) {
          this._map = map;
          var i, l, layer;
          if (!isFinite(this._map.getMaxZoom())) {
            throw "Map has no maxZoom specified";
          }
          this._featureGroup.addTo(map);
          this._nonPointGroup.addTo(map);
          if (!this._gridClusters) {
            this._generateInitialClusters();
          }
          this._maxLat = map.options.crs.projection.MAX_LATITUDE;
          for (i = 0, l = this._needsRemoving.length; i < l; i++) {
            layer = this._needsRemoving[i];
            layer.newlatlng = layer.layer._latlng;
            layer.layer._latlng = layer.latlng;
          }
          for (i = 0, l = this._needsRemoving.length; i < l; i++) {
            layer = this._needsRemoving[i];
            this._removeLayer(layer.layer, true);
            layer.layer._latlng = layer.newlatlng;
          }
          this._needsRemoving = [];
          this._zoom = Math.round(this._map._zoom);
          this._currentShownBounds = this._getExpandedVisibleBounds();
          this._map.on("zoomend", this._zoomEnd, this);
          this._map.on("moveend", this._moveEnd, this);
          if (this._spiderfierOnAdd) {
            this._spiderfierOnAdd();
          }
          this._bindEvents();
          l = this._needsClustering;
          this._needsClustering = [];
          this.addLayers(l, true);
        },
        //Overrides FeatureGroup.onRemove
        onRemove: function(map) {
          map.off("zoomend", this._zoomEnd, this);
          map.off("moveend", this._moveEnd, this);
          this._unbindEvents();
          this._map._mapPane.className = this._map._mapPane.className.replace(" leaflet-cluster-anim", "");
          if (this._spiderfierOnRemove) {
            this._spiderfierOnRemove();
          }
          delete this._maxLat;
          this._hideCoverage();
          this._featureGroup.remove();
          this._nonPointGroup.remove();
          this._featureGroup.clearLayers();
          this._map = null;
        },
        getVisibleParent: function(marker) {
          var vMarker = marker;
          while (vMarker && !vMarker._icon) {
            vMarker = vMarker.__parent;
          }
          return vMarker || null;
        },
        //Remove the given object from the given array
        _arraySplice: function(anArray, obj) {
          for (var i = anArray.length - 1; i >= 0; i--) {
            if (anArray[i] === obj) {
              anArray.splice(i, 1);
              return true;
            }
          }
        },
        /**
         * Removes a marker from all _gridUnclustered zoom levels, starting at the supplied zoom.
         * @param marker to be removed from _gridUnclustered.
         * @param z integer bottom start zoom level (included)
         * @private
         */
        _removeFromGridUnclustered: function(marker, z) {
          var map = this._map, gridUnclustered = this._gridUnclustered, minZoom = Math.floor(this._map.getMinZoom());
          for (; z >= minZoom; z--) {
            if (!gridUnclustered[z].removeObject(marker, map.project(marker.getLatLng(), z))) {
              break;
            }
          }
        },
        _childMarkerDragStart: function(e) {
          e.target.__dragStart = e.target._latlng;
        },
        _childMarkerMoved: function(e) {
          if (!this._ignoreMove && !e.target.__dragStart) {
            var isPopupOpen = e.target._popup && e.target._popup.isOpen();
            this._moveChild(e.target, e.oldLatLng, e.latlng);
            if (isPopupOpen) {
              e.target.openPopup();
            }
          }
        },
        _moveChild: function(layer, from, to) {
          layer._latlng = from;
          this.removeLayer(layer);
          layer._latlng = to;
          this.addLayer(layer);
        },
        _childMarkerDragEnd: function(e) {
          var dragStart = e.target.__dragStart;
          delete e.target.__dragStart;
          if (dragStart) {
            this._moveChild(e.target, dragStart, e.target._latlng);
          }
        },
        //Internal function for removing a marker from everything.
        //dontUpdateMap: set to true if you will handle updating the map manually (for bulk functions)
        _removeLayer: function(marker, removeFromDistanceGrid, dontUpdateMap) {
          var gridClusters = this._gridClusters, gridUnclustered = this._gridUnclustered, fg = this._featureGroup, map = this._map, minZoom = Math.floor(this._map.getMinZoom());
          if (removeFromDistanceGrid) {
            this._removeFromGridUnclustered(marker, this._maxZoom);
          }
          var cluster = marker.__parent, markers = cluster._markers, otherMarker;
          this._arraySplice(markers, marker);
          while (cluster) {
            cluster._childCount--;
            cluster._boundsNeedUpdate = true;
            if (cluster._zoom < minZoom) {
              break;
            } else if (removeFromDistanceGrid && cluster._childCount <= 1) {
              otherMarker = cluster._markers[0] === marker ? cluster._markers[1] : cluster._markers[0];
              gridClusters[cluster._zoom].removeObject(cluster, map.project(cluster._cLatLng, cluster._zoom));
              gridUnclustered[cluster._zoom].addObject(otherMarker, map.project(otherMarker.getLatLng(), cluster._zoom));
              this._arraySplice(cluster.__parent._childClusters, cluster);
              cluster.__parent._markers.push(otherMarker);
              otherMarker.__parent = cluster.__parent;
              if (cluster._icon) {
                fg.removeLayer(cluster);
                if (!dontUpdateMap) {
                  fg.addLayer(otherMarker);
                }
              }
            } else {
              cluster._iconNeedsUpdate = true;
            }
            cluster = cluster.__parent;
          }
          delete marker.__parent;
        },
        _isOrIsParent: function(el, oel) {
          while (oel) {
            if (el === oel) {
              return true;
            }
            oel = oel.parentNode;
          }
          return false;
        },
        //Override L.Evented.fire
        fire: function(type, data, propagate) {
          if (data && data.layer instanceof L.MarkerCluster) {
            if (data.originalEvent && this._isOrIsParent(data.layer._icon, data.originalEvent.relatedTarget)) {
              return;
            }
            type = "cluster" + type;
          }
          L.FeatureGroup.prototype.fire.call(this, type, data, propagate);
        },
        //Override L.Evented.listens
        listens: function(type, propagate) {
          return L.FeatureGroup.prototype.listens.call(this, type, propagate) || L.FeatureGroup.prototype.listens.call(this, "cluster" + type, propagate);
        },
        //Default functionality
        _defaultIconCreateFunction: function(cluster) {
          var childCount = cluster.getChildCount();
          var c = " marker-cluster-";
          if (childCount < 10) {
            c += "small";
          } else if (childCount < 100) {
            c += "medium";
          } else {
            c += "large";
          }
          return new L.DivIcon({ html: "<div><span>" + childCount + "</span></div>", className: "marker-cluster" + c, iconSize: new L.Point(40, 40) });
        },
        _bindEvents: function() {
          var map = this._map, spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom, showCoverageOnHover = this.options.showCoverageOnHover, zoomToBoundsOnClick = this.options.zoomToBoundsOnClick, spiderfyOnEveryZoom = this.options.spiderfyOnEveryZoom;
          if (spiderfyOnMaxZoom || zoomToBoundsOnClick || spiderfyOnEveryZoom) {
            this.on("clusterclick clusterkeypress", this._zoomOrSpiderfy, this);
          }
          if (showCoverageOnHover) {
            this.on("clustermouseover", this._showCoverage, this);
            this.on("clustermouseout", this._hideCoverage, this);
            map.on("zoomend", this._hideCoverage, this);
          }
        },
        _zoomOrSpiderfy: function(e) {
          var cluster = e.layer, bottomCluster = cluster;
          if (e.type === "clusterkeypress" && e.originalEvent && e.originalEvent.keyCode !== 13) {
            return;
          }
          while (bottomCluster._childClusters.length === 1) {
            bottomCluster = bottomCluster._childClusters[0];
          }
          if (bottomCluster._zoom === this._maxZoom && bottomCluster._childCount === cluster._childCount && this.options.spiderfyOnMaxZoom) {
            cluster.spiderfy();
          } else if (this.options.zoomToBoundsOnClick) {
            cluster.zoomToBounds();
          }
          if (this.options.spiderfyOnEveryZoom) {
            cluster.spiderfy();
          }
          if (e.originalEvent && e.originalEvent.keyCode === 13) {
            this._map._container.focus();
          }
        },
        _showCoverage: function(e) {
          var map = this._map;
          if (this._inZoomAnimation) {
            return;
          }
          if (this._shownPolygon) {
            map.removeLayer(this._shownPolygon);
          }
          if (e.layer.getChildCount() > 2 && e.layer !== this._spiderfied) {
            this._shownPolygon = new L.Polygon(e.layer.getConvexHull(), this.options.polygonOptions);
            map.addLayer(this._shownPolygon);
          }
        },
        _hideCoverage: function() {
          if (this._shownPolygon) {
            this._map.removeLayer(this._shownPolygon);
            this._shownPolygon = null;
          }
        },
        _unbindEvents: function() {
          var spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom, showCoverageOnHover = this.options.showCoverageOnHover, zoomToBoundsOnClick = this.options.zoomToBoundsOnClick, spiderfyOnEveryZoom = this.options.spiderfyOnEveryZoom, map = this._map;
          if (spiderfyOnMaxZoom || zoomToBoundsOnClick || spiderfyOnEveryZoom) {
            this.off("clusterclick clusterkeypress", this._zoomOrSpiderfy, this);
          }
          if (showCoverageOnHover) {
            this.off("clustermouseover", this._showCoverage, this);
            this.off("clustermouseout", this._hideCoverage, this);
            map.off("zoomend", this._hideCoverage, this);
          }
        },
        _zoomEnd: function() {
          if (!this._map) {
            return;
          }
          this._mergeSplitClusters();
          this._zoom = Math.round(this._map._zoom);
          this._currentShownBounds = this._getExpandedVisibleBounds();
        },
        _moveEnd: function() {
          if (this._inZoomAnimation) {
            return;
          }
          var newBounds = this._getExpandedVisibleBounds();
          this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, newBounds);
          this._topClusterLevel._recursivelyAddChildrenToMap(null, Math.round(this._map._zoom), newBounds);
          this._currentShownBounds = newBounds;
          return;
        },
        _generateInitialClusters: function() {
          var maxZoom = Math.ceil(this._map.getMaxZoom()), minZoom = Math.floor(this._map.getMinZoom()), radius = this.options.maxClusterRadius, radiusFn = radius;
          if (typeof radius !== "function") {
            radiusFn = function() {
              return radius;
            };
          }
          if (this.options.disableClusteringAtZoom !== null) {
            maxZoom = this.options.disableClusteringAtZoom - 1;
          }
          this._maxZoom = maxZoom;
          this._gridClusters = {};
          this._gridUnclustered = {};
          for (var zoom = maxZoom; zoom >= minZoom; zoom--) {
            this._gridClusters[zoom] = new L.DistanceGrid(radiusFn(zoom));
            this._gridUnclustered[zoom] = new L.DistanceGrid(radiusFn(zoom));
          }
          this._topClusterLevel = new this._markerCluster(this, minZoom - 1);
        },
        //Zoom: Zoom to start adding at (Pass this._maxZoom to start at the bottom)
        _addLayer: function(layer, zoom) {
          var gridClusters = this._gridClusters, gridUnclustered = this._gridUnclustered, minZoom = Math.floor(this._map.getMinZoom()), markerPoint, z;
          if (this.options.singleMarkerMode) {
            this._overrideMarkerIcon(layer);
          }
          layer.on(this._childMarkerEventHandlers, this);
          for (; zoom >= minZoom; zoom--) {
            markerPoint = this._map.project(layer.getLatLng(), zoom);
            var closest = gridClusters[zoom].getNearObject(markerPoint);
            if (closest) {
              closest._addChild(layer);
              layer.__parent = closest;
              return;
            }
            closest = gridUnclustered[zoom].getNearObject(markerPoint);
            if (closest) {
              var parent = closest.__parent;
              if (parent) {
                this._removeLayer(closest, false);
              }
              var newCluster = new this._markerCluster(this, zoom, closest, layer);
              gridClusters[zoom].addObject(newCluster, this._map.project(newCluster._cLatLng, zoom));
              closest.__parent = newCluster;
              layer.__parent = newCluster;
              var lastParent = newCluster;
              for (z = zoom - 1; z > parent._zoom; z--) {
                lastParent = new this._markerCluster(this, z, lastParent);
                gridClusters[z].addObject(lastParent, this._map.project(closest.getLatLng(), z));
              }
              parent._addChild(lastParent);
              this._removeFromGridUnclustered(closest, zoom);
              return;
            }
            gridUnclustered[zoom].addObject(layer, markerPoint);
          }
          this._topClusterLevel._addChild(layer);
          layer.__parent = this._topClusterLevel;
          return;
        },
        /**
         * Refreshes the icon of all "dirty" visible clusters.
         * Non-visible "dirty" clusters will be updated when they are added to the map.
         * @private
         */
        _refreshClustersIcons: function() {
          this._featureGroup.eachLayer(function(c) {
            if (c instanceof L.MarkerCluster && c._iconNeedsUpdate) {
              c._updateIcon();
            }
          });
        },
        //Enqueue code to fire after the marker expand/contract has happened
        _enqueue: function(fn) {
          this._queue.push(fn);
          if (!this._queueTimeout) {
            this._queueTimeout = setTimeout(L.bind(this._processQueue, this), 300);
          }
        },
        _processQueue: function() {
          for (var i = 0; i < this._queue.length; i++) {
            this._queue[i].call(this);
          }
          this._queue.length = 0;
          clearTimeout(this._queueTimeout);
          this._queueTimeout = null;
        },
        //Merge and split any existing clusters that are too big or small
        _mergeSplitClusters: function() {
          var mapZoom = Math.round(this._map._zoom);
          this._processQueue();
          if (this._zoom < mapZoom && this._currentShownBounds.intersects(this._getExpandedVisibleBounds())) {
            this._animationStart();
            this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, this._getExpandedVisibleBounds());
            this._animationZoomIn(this._zoom, mapZoom);
          } else if (this._zoom > mapZoom) {
            this._animationStart();
            this._animationZoomOut(this._zoom, mapZoom);
          } else {
            this._moveEnd();
          }
        },
        //Gets the maps visible bounds expanded in each direction by the size of the screen (so the user cannot see an area we do not cover in one pan)
        _getExpandedVisibleBounds: function() {
          if (!this.options.removeOutsideVisibleBounds) {
            return this._mapBoundsInfinite;
          } else if (L.Browser.mobile) {
            return this._checkBoundsMaxLat(this._map.getBounds());
          }
          return this._checkBoundsMaxLat(this._map.getBounds().pad(1));
        },
        /**
         * Expands the latitude to Infinity (or -Infinity) if the input bounds reach the map projection maximum defined latitude
         * (in the case of Web/Spherical Mercator, it is 85.0511287798 / see https://en.wikipedia.org/wiki/Web_Mercator#Formulas).
         * Otherwise, the removeOutsideVisibleBounds option will remove markers beyond that limit, whereas the same markers without
         * this option (or outside MCG) will have their position floored (ceiled) by the projection and rendered at that limit,
         * making the user think that MCG "eats" them and never displays them again.
         * @param bounds L.LatLngBounds
         * @returns {L.LatLngBounds}
         * @private
         */
        _checkBoundsMaxLat: function(bounds) {
          var maxLat = this._maxLat;
          if (maxLat !== void 0) {
            if (bounds.getNorth() >= maxLat) {
              bounds._northEast.lat = Infinity;
            }
            if (bounds.getSouth() <= -maxLat) {
              bounds._southWest.lat = -Infinity;
            }
          }
          return bounds;
        },
        //Shared animation code
        _animationAddLayerNonAnimated: function(layer, newCluster) {
          if (newCluster === layer) {
            this._featureGroup.addLayer(layer);
          } else if (newCluster._childCount === 2) {
            newCluster._addToMap();
            var markers = newCluster.getAllChildMarkers();
            this._featureGroup.removeLayer(markers[0]);
            this._featureGroup.removeLayer(markers[1]);
          } else {
            newCluster._updateIcon();
          }
        },
        /**
         * Extracts individual (i.e. non-group) layers from a Layer Group.
         * @param group to extract layers from.
         * @param output {Array} in which to store the extracted layers.
         * @returns {*|Array}
         * @private
         */
        _extractNonGroupLayers: function(group, output) {
          var layers = group.getLayers(), i = 0, layer;
          output = output || [];
          for (; i < layers.length; i++) {
            layer = layers[i];
            if (layer instanceof L.LayerGroup) {
              this._extractNonGroupLayers(layer, output);
              continue;
            }
            output.push(layer);
          }
          return output;
        },
        /**
         * Implements the singleMarkerMode option.
         * @param layer Marker to re-style using the Clusters iconCreateFunction.
         * @returns {L.Icon} The newly created icon.
         * @private
         */
        _overrideMarkerIcon: function(layer) {
          var icon = layer.options.icon = this.options.iconCreateFunction({
            getChildCount: function() {
              return 1;
            },
            getAllChildMarkers: function() {
              return [layer];
            }
          });
          return icon;
        }
      });
      L.MarkerClusterGroup.include({
        _mapBoundsInfinite: new L.LatLngBounds(new L.LatLng(-Infinity, -Infinity), new L.LatLng(Infinity, Infinity))
      });
      L.MarkerClusterGroup.include({
        _noAnimation: {
          //Non Animated versions of everything
          _animationStart: function() {
          },
          _animationZoomIn: function(previousZoomLevel, newZoomLevel) {
            this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel);
            this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
            this.fire("animationend");
          },
          _animationZoomOut: function(previousZoomLevel, newZoomLevel) {
            this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel);
            this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
            this.fire("animationend");
          },
          _animationAddLayer: function(layer, newCluster) {
            this._animationAddLayerNonAnimated(layer, newCluster);
          }
        },
        _withAnimation: {
          //Animated versions here
          _animationStart: function() {
            this._map._mapPane.className += " leaflet-cluster-anim";
            this._inZoomAnimation++;
          },
          _animationZoomIn: function(previousZoomLevel, newZoomLevel) {
            var bounds = this._getExpandedVisibleBounds(), fg = this._featureGroup, minZoom = Math.floor(this._map.getMinZoom()), i;
            this._ignoreMove = true;
            this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function(c) {
              var startPos = c._latlng, markers = c._markers, m;
              if (!bounds.contains(startPos)) {
                startPos = null;
              }
              if (c._isSingleParent() && previousZoomLevel + 1 === newZoomLevel) {
                fg.removeLayer(c);
                c._recursivelyAddChildrenToMap(null, newZoomLevel, bounds);
              } else {
                c.clusterHide();
                c._recursivelyAddChildrenToMap(startPos, newZoomLevel, bounds);
              }
              for (i = markers.length - 1; i >= 0; i--) {
                m = markers[i];
                if (!bounds.contains(m._latlng)) {
                  fg.removeLayer(m);
                }
              }
            });
            this._forceLayout();
            this._topClusterLevel._recursivelyBecomeVisible(bounds, newZoomLevel);
            fg.eachLayer(function(n) {
              if (!(n instanceof L.MarkerCluster) && n._icon) {
                n.clusterShow();
              }
            });
            this._topClusterLevel._recursively(bounds, previousZoomLevel, newZoomLevel, function(c) {
              c._recursivelyRestoreChildPositions(newZoomLevel);
            });
            this._ignoreMove = false;
            this._enqueue(function() {
              this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function(c) {
                fg.removeLayer(c);
                c.clusterShow();
              });
              this._animationEnd();
            });
          },
          _animationZoomOut: function(previousZoomLevel, newZoomLevel) {
            this._animationZoomOutSingle(this._topClusterLevel, previousZoomLevel - 1, newZoomLevel);
            this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
            this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel, this._getExpandedVisibleBounds());
          },
          _animationAddLayer: function(layer, newCluster) {
            var me = this, fg = this._featureGroup;
            fg.addLayer(layer);
            if (newCluster !== layer) {
              if (newCluster._childCount > 2) {
                newCluster._updateIcon();
                this._forceLayout();
                this._animationStart();
                layer._setPos(this._map.latLngToLayerPoint(newCluster.getLatLng()));
                layer.clusterHide();
                this._enqueue(function() {
                  fg.removeLayer(layer);
                  layer.clusterShow();
                  me._animationEnd();
                });
              } else {
                this._forceLayout();
                me._animationStart();
                me._animationZoomOutSingle(newCluster, this._map.getMaxZoom(), this._zoom);
              }
            }
          }
        },
        // Private methods for animated versions.
        _animationZoomOutSingle: function(cluster, previousZoomLevel, newZoomLevel) {
          var bounds = this._getExpandedVisibleBounds(), minZoom = Math.floor(this._map.getMinZoom());
          cluster._recursivelyAnimateChildrenInAndAddSelfToMap(bounds, minZoom, previousZoomLevel + 1, newZoomLevel);
          var me = this;
          this._forceLayout();
          cluster._recursivelyBecomeVisible(bounds, newZoomLevel);
          this._enqueue(function() {
            if (cluster._childCount === 1) {
              var m = cluster._markers[0];
              this._ignoreMove = true;
              m.setLatLng(m.getLatLng());
              this._ignoreMove = false;
              if (m.clusterShow) {
                m.clusterShow();
              }
            } else {
              cluster._recursively(bounds, newZoomLevel, minZoom, function(c) {
                c._recursivelyRemoveChildrenFromMap(bounds, minZoom, previousZoomLevel + 1);
              });
            }
            me._animationEnd();
          });
        },
        _animationEnd: function() {
          if (this._map) {
            this._map._mapPane.className = this._map._mapPane.className.replace(" leaflet-cluster-anim", "");
          }
          this._inZoomAnimation--;
          this.fire("animationend");
        },
        //Force a browser layout of stuff in the map
        // Should apply the current opacity and location to all elements so we can update them again for an animation
        _forceLayout: function() {
          L.Util.falseFn(document.body.offsetWidth);
        }
      });
      L.markerClusterGroup = function(options) {
        return new L.MarkerClusterGroup(options);
      };
      var MarkerCluster2 = L.MarkerCluster = L.Marker.extend({
        options: L.Icon.prototype.options,
        initialize: function(group, zoom, a, b) {
          L.Marker.prototype.initialize.call(
            this,
            a ? a._cLatLng || a.getLatLng() : new L.LatLng(0, 0),
            { icon: this, pane: group.options.clusterPane }
          );
          this._group = group;
          this._zoom = zoom;
          this._markers = [];
          this._childClusters = [];
          this._childCount = 0;
          this._iconNeedsUpdate = true;
          this._boundsNeedUpdate = true;
          this._bounds = new L.LatLngBounds();
          if (a) {
            this._addChild(a);
          }
          if (b) {
            this._addChild(b);
          }
        },
        //Recursively retrieve all child markers of this cluster
        getAllChildMarkers: function(storageArray, ignoreDraggedMarker) {
          storageArray = storageArray || [];
          for (var i = this._childClusters.length - 1; i >= 0; i--) {
            this._childClusters[i].getAllChildMarkers(storageArray, ignoreDraggedMarker);
          }
          for (var j = this._markers.length - 1; j >= 0; j--) {
            if (ignoreDraggedMarker && this._markers[j].__dragStart) {
              continue;
            }
            storageArray.push(this._markers[j]);
          }
          return storageArray;
        },
        //Returns the count of how many child markers we have
        getChildCount: function() {
          return this._childCount;
        },
        //Zoom to the minimum of showing all of the child markers, or the extents of this cluster
        zoomToBounds: function(fitBoundsOptions) {
          var childClusters = this._childClusters.slice(), map = this._group._map, boundsZoom = map.getBoundsZoom(this._bounds), zoom = this._zoom + 1, mapZoom = map.getZoom(), i;
          while (childClusters.length > 0 && boundsZoom > zoom) {
            zoom++;
            var newClusters = [];
            for (i = 0; i < childClusters.length; i++) {
              newClusters = newClusters.concat(childClusters[i]._childClusters);
            }
            childClusters = newClusters;
          }
          if (boundsZoom > zoom) {
            this._group._map.setView(this._latlng, zoom);
          } else if (boundsZoom <= mapZoom) {
            this._group._map.setView(this._latlng, mapZoom + 1);
          } else {
            this._group._map.fitBounds(this._bounds, fitBoundsOptions);
          }
        },
        getBounds: function() {
          var bounds = new L.LatLngBounds();
          bounds.extend(this._bounds);
          return bounds;
        },
        _updateIcon: function() {
          this._iconNeedsUpdate = true;
          if (this._icon) {
            this.setIcon(this);
          }
        },
        //Cludge for Icon, we pretend to be an icon for performance
        createIcon: function() {
          if (this._iconNeedsUpdate) {
            this._iconObj = this._group.options.iconCreateFunction(this);
            this._iconNeedsUpdate = false;
          }
          return this._iconObj.createIcon();
        },
        createShadow: function() {
          return this._iconObj.createShadow();
        },
        _addChild: function(new1, isNotificationFromChild) {
          this._iconNeedsUpdate = true;
          this._boundsNeedUpdate = true;
          this._setClusterCenter(new1);
          if (new1 instanceof L.MarkerCluster) {
            if (!isNotificationFromChild) {
              this._childClusters.push(new1);
              new1.__parent = this;
            }
            this._childCount += new1._childCount;
          } else {
            if (!isNotificationFromChild) {
              this._markers.push(new1);
            }
            this._childCount++;
          }
          if (this.__parent) {
            this.__parent._addChild(new1, true);
          }
        },
        /**
         * Makes sure the cluster center is set. If not, uses the child center if it is a cluster, or the marker position.
         * @param child L.MarkerCluster|L.Marker that will be used as cluster center if not defined yet.
         * @private
         */
        _setClusterCenter: function(child) {
          if (!this._cLatLng) {
            this._cLatLng = child._cLatLng || child._latlng;
          }
        },
        /**
         * Assigns impossible bounding values so that the next extend entirely determines the new bounds.
         * This method avoids having to trash the previous L.LatLngBounds object and to create a new one, which is much slower for this class.
         * As long as the bounds are not extended, most other methods would probably fail, as they would with bounds initialized but not extended.
         * @private
         */
        _resetBounds: function() {
          var bounds = this._bounds;
          if (bounds._southWest) {
            bounds._southWest.lat = Infinity;
            bounds._southWest.lng = Infinity;
          }
          if (bounds._northEast) {
            bounds._northEast.lat = -Infinity;
            bounds._northEast.lng = -Infinity;
          }
        },
        _recalculateBounds: function() {
          var markers = this._markers, childClusters = this._childClusters, latSum = 0, lngSum = 0, totalCount = this._childCount, i, child, childLatLng, childCount;
          if (totalCount === 0) {
            return;
          }
          this._resetBounds();
          for (i = 0; i < markers.length; i++) {
            childLatLng = markers[i]._latlng;
            this._bounds.extend(childLatLng);
            latSum += childLatLng.lat;
            lngSum += childLatLng.lng;
          }
          for (i = 0; i < childClusters.length; i++) {
            child = childClusters[i];
            if (child._boundsNeedUpdate) {
              child._recalculateBounds();
            }
            this._bounds.extend(child._bounds);
            childLatLng = child._wLatLng;
            childCount = child._childCount;
            latSum += childLatLng.lat * childCount;
            lngSum += childLatLng.lng * childCount;
          }
          this._latlng = this._wLatLng = new L.LatLng(latSum / totalCount, lngSum / totalCount);
          this._boundsNeedUpdate = false;
        },
        //Set our markers position as given and add it to the map
        _addToMap: function(startPos) {
          if (startPos) {
            this._backupLatlng = this._latlng;
            this.setLatLng(startPos);
          }
          this._group._featureGroup.addLayer(this);
        },
        _recursivelyAnimateChildrenIn: function(bounds, center, maxZoom) {
          this._recursively(
            bounds,
            this._group._map.getMinZoom(),
            maxZoom - 1,
            function(c) {
              var markers = c._markers, i, m;
              for (i = markers.length - 1; i >= 0; i--) {
                m = markers[i];
                if (m._icon) {
                  m._setPos(center);
                  m.clusterHide();
                }
              }
            },
            function(c) {
              var childClusters = c._childClusters, j, cm;
              for (j = childClusters.length - 1; j >= 0; j--) {
                cm = childClusters[j];
                if (cm._icon) {
                  cm._setPos(center);
                  cm.clusterHide();
                }
              }
            }
          );
        },
        _recursivelyAnimateChildrenInAndAddSelfToMap: function(bounds, mapMinZoom, previousZoomLevel, newZoomLevel) {
          this._recursively(
            bounds,
            newZoomLevel,
            mapMinZoom,
            function(c) {
              c._recursivelyAnimateChildrenIn(bounds, c._group._map.latLngToLayerPoint(c.getLatLng()).round(), previousZoomLevel);
              if (c._isSingleParent() && previousZoomLevel - 1 === newZoomLevel) {
                c.clusterShow();
                c._recursivelyRemoveChildrenFromMap(bounds, mapMinZoom, previousZoomLevel);
              } else {
                c.clusterHide();
              }
              c._addToMap();
            }
          );
        },
        _recursivelyBecomeVisible: function(bounds, zoomLevel) {
          this._recursively(bounds, this._group._map.getMinZoom(), zoomLevel, null, function(c) {
            c.clusterShow();
          });
        },
        _recursivelyAddChildrenToMap: function(startPos, zoomLevel, bounds) {
          this._recursively(
            bounds,
            this._group._map.getMinZoom() - 1,
            zoomLevel,
            function(c) {
              if (zoomLevel === c._zoom) {
                return;
              }
              for (var i = c._markers.length - 1; i >= 0; i--) {
                var nm = c._markers[i];
                if (!bounds.contains(nm._latlng)) {
                  continue;
                }
                if (startPos) {
                  nm._backupLatlng = nm.getLatLng();
                  nm.setLatLng(startPos);
                  if (nm.clusterHide) {
                    nm.clusterHide();
                  }
                }
                c._group._featureGroup.addLayer(nm);
              }
            },
            function(c) {
              c._addToMap(startPos);
            }
          );
        },
        _recursivelyRestoreChildPositions: function(zoomLevel) {
          for (var i = this._markers.length - 1; i >= 0; i--) {
            var nm = this._markers[i];
            if (nm._backupLatlng) {
              nm.setLatLng(nm._backupLatlng);
              delete nm._backupLatlng;
            }
          }
          if (zoomLevel - 1 === this._zoom) {
            for (var j = this._childClusters.length - 1; j >= 0; j--) {
              this._childClusters[j]._restorePosition();
            }
          } else {
            for (var k = this._childClusters.length - 1; k >= 0; k--) {
              this._childClusters[k]._recursivelyRestoreChildPositions(zoomLevel);
            }
          }
        },
        _restorePosition: function() {
          if (this._backupLatlng) {
            this.setLatLng(this._backupLatlng);
            delete this._backupLatlng;
          }
        },
        //exceptBounds: If set, don't remove any markers/clusters in it
        _recursivelyRemoveChildrenFromMap: function(previousBounds, mapMinZoom, zoomLevel, exceptBounds) {
          var m, i;
          this._recursively(
            previousBounds,
            mapMinZoom - 1,
            zoomLevel - 1,
            function(c) {
              for (i = c._markers.length - 1; i >= 0; i--) {
                m = c._markers[i];
                if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
                  c._group._featureGroup.removeLayer(m);
                  if (m.clusterShow) {
                    m.clusterShow();
                  }
                }
              }
            },
            function(c) {
              for (i = c._childClusters.length - 1; i >= 0; i--) {
                m = c._childClusters[i];
                if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
                  c._group._featureGroup.removeLayer(m);
                  if (m.clusterShow) {
                    m.clusterShow();
                  }
                }
              }
            }
          );
        },
        //Run the given functions recursively to this and child clusters
        // boundsToApplyTo: a L.LatLngBounds representing the bounds of what clusters to recurse in to
        // zoomLevelToStart: zoom level to start running functions (inclusive)
        // zoomLevelToStop: zoom level to stop running functions (inclusive)
        // runAtEveryLevel: function that takes an L.MarkerCluster as an argument that should be applied on every level
        // runAtBottomLevel: function that takes an L.MarkerCluster as an argument that should be applied at only the bottom level
        _recursively: function(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel) {
          var childClusters = this._childClusters, zoom = this._zoom, i, c;
          if (zoomLevelToStart <= zoom) {
            if (runAtEveryLevel) {
              runAtEveryLevel(this);
            }
            if (runAtBottomLevel && zoom === zoomLevelToStop) {
              runAtBottomLevel(this);
            }
          }
          if (zoom < zoomLevelToStart || zoom < zoomLevelToStop) {
            for (i = childClusters.length - 1; i >= 0; i--) {
              c = childClusters[i];
              if (c._boundsNeedUpdate) {
                c._recalculateBounds();
              }
              if (boundsToApplyTo.intersects(c._bounds)) {
                c._recursively(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel);
              }
            }
          }
        },
        //Returns true if we are the parent of only one cluster and that cluster is the same as us
        _isSingleParent: function() {
          return this._childClusters.length > 0 && this._childClusters[0]._childCount === this._childCount;
        }
      });
      L.Marker.include({
        clusterHide: function() {
          var backup = this.options.opacity;
          this.setOpacity(0);
          this.options.opacity = backup;
          return this;
        },
        clusterShow: function() {
          return this.setOpacity(this.options.opacity);
        }
      });
      L.DistanceGrid = function(cellSize) {
        this._cellSize = cellSize;
        this._sqCellSize = cellSize * cellSize;
        this._grid = {};
        this._objectPoint = {};
      };
      L.DistanceGrid.prototype = {
        addObject: function(obj, point) {
          var x = this._getCoord(point.x), y = this._getCoord(point.y), grid = this._grid, row = grid[y] = grid[y] || {}, cell = row[x] = row[x] || [], stamp = L.Util.stamp(obj);
          this._objectPoint[stamp] = point;
          cell.push(obj);
        },
        updateObject: function(obj, point) {
          this.removeObject(obj);
          this.addObject(obj, point);
        },
        //Returns true if the object was found
        removeObject: function(obj, point) {
          var x = this._getCoord(point.x), y = this._getCoord(point.y), grid = this._grid, row = grid[y] = grid[y] || {}, cell = row[x] = row[x] || [], i, len;
          delete this._objectPoint[L.Util.stamp(obj)];
          for (i = 0, len = cell.length; i < len; i++) {
            if (cell[i] === obj) {
              cell.splice(i, 1);
              if (len === 1) {
                delete row[x];
              }
              return true;
            }
          }
        },
        eachObject: function(fn, context) {
          var i, j, k, len, row, cell, removed, grid = this._grid;
          for (i in grid) {
            row = grid[i];
            for (j in row) {
              cell = row[j];
              for (k = 0, len = cell.length; k < len; k++) {
                removed = fn.call(context, cell[k]);
                if (removed) {
                  k--;
                  len--;
                }
              }
            }
          }
        },
        getNearObject: function(point) {
          var x = this._getCoord(point.x), y = this._getCoord(point.y), i, j, k, row, cell, len, obj, dist, objectPoint = this._objectPoint, closestDistSq = this._sqCellSize, closest = null;
          for (i = y - 1; i <= y + 1; i++) {
            row = this._grid[i];
            if (row) {
              for (j = x - 1; j <= x + 1; j++) {
                cell = row[j];
                if (cell) {
                  for (k = 0, len = cell.length; k < len; k++) {
                    obj = cell[k];
                    dist = this._sqDist(objectPoint[L.Util.stamp(obj)], point);
                    if (dist < closestDistSq || dist <= closestDistSq && closest === null) {
                      closestDistSq = dist;
                      closest = obj;
                    }
                  }
                }
              }
            }
          }
          return closest;
        },
        _getCoord: function(x) {
          var coord = Math.floor(x / this._cellSize);
          return isFinite(coord) ? coord : x;
        },
        _sqDist: function(p, p2) {
          var dx = p2.x - p.x, dy = p2.y - p.y;
          return dx * dx + dy * dy;
        }
      };
      (function() {
        L.QuickHull = {
          /*
           * @param {Object} cpt a point to be measured from the baseline
           * @param {Array} bl the baseline, as represented by a two-element
           *   array of latlng objects.
           * @returns {Number} an approximate distance measure
           */
          getDistant: function(cpt, bl) {
            var vY = bl[1].lat - bl[0].lat, vX = bl[0].lng - bl[1].lng;
            return vX * (cpt.lat - bl[0].lat) + vY * (cpt.lng - bl[0].lng);
          },
          /*
           * @param {Array} baseLine a two-element array of latlng objects
           *   representing the baseline to project from
           * @param {Array} latLngs an array of latlng objects
           * @returns {Object} the maximum point and all new points to stay
           *   in consideration for the hull.
           */
          findMostDistantPointFromBaseLine: function(baseLine, latLngs) {
            var maxD = 0, maxPt = null, newPoints = [], i, pt, d;
            for (i = latLngs.length - 1; i >= 0; i--) {
              pt = latLngs[i];
              d = this.getDistant(pt, baseLine);
              if (d > 0) {
                newPoints.push(pt);
              } else {
                continue;
              }
              if (d > maxD) {
                maxD = d;
                maxPt = pt;
              }
            }
            return { maxPoint: maxPt, newPoints };
          },
          /*
           * Given a baseline, compute the convex hull of latLngs as an array
           * of latLngs.
           *
           * @param {Array} latLngs
           * @returns {Array}
           */
          buildConvexHull: function(baseLine, latLngs) {
            var convexHullBaseLines = [], t = this.findMostDistantPointFromBaseLine(baseLine, latLngs);
            if (t.maxPoint) {
              convexHullBaseLines = convexHullBaseLines.concat(
                this.buildConvexHull([baseLine[0], t.maxPoint], t.newPoints)
              );
              convexHullBaseLines = convexHullBaseLines.concat(
                this.buildConvexHull([t.maxPoint, baseLine[1]], t.newPoints)
              );
              return convexHullBaseLines;
            } else {
              return [baseLine[0]];
            }
          },
          /*
           * Given an array of latlngs, compute a convex hull as an array
           * of latlngs
           *
           * @param {Array} latLngs
           * @returns {Array}
           */
          getConvexHull: function(latLngs) {
            var maxLat = false, minLat = false, maxLng = false, minLng = false, maxLatPt = null, minLatPt = null, maxLngPt = null, minLngPt = null, maxPt = null, minPt = null, i;
            for (i = latLngs.length - 1; i >= 0; i--) {
              var pt = latLngs[i];
              if (maxLat === false || pt.lat > maxLat) {
                maxLatPt = pt;
                maxLat = pt.lat;
              }
              if (minLat === false || pt.lat < minLat) {
                minLatPt = pt;
                minLat = pt.lat;
              }
              if (maxLng === false || pt.lng > maxLng) {
                maxLngPt = pt;
                maxLng = pt.lng;
              }
              if (minLng === false || pt.lng < minLng) {
                minLngPt = pt;
                minLng = pt.lng;
              }
            }
            if (minLat !== maxLat) {
              minPt = minLatPt;
              maxPt = maxLatPt;
            } else {
              minPt = minLngPt;
              maxPt = maxLngPt;
            }
            var ch = [].concat(
              this.buildConvexHull([minPt, maxPt], latLngs),
              this.buildConvexHull([maxPt, minPt], latLngs)
            );
            return ch;
          }
        };
      })();
      L.MarkerCluster.include({
        getConvexHull: function() {
          var childMarkers = this.getAllChildMarkers(), points = [], p, i;
          for (i = childMarkers.length - 1; i >= 0; i--) {
            p = childMarkers[i].getLatLng();
            points.push(p);
          }
          return L.QuickHull.getConvexHull(points);
        }
      });
      L.MarkerCluster.include({
        _2PI: Math.PI * 2,
        _circleFootSeparation: 25,
        //related to circumference of circle
        _circleStartAngle: 0,
        _spiralFootSeparation: 28,
        //related to size of spiral (experiment!)
        _spiralLengthStart: 11,
        _spiralLengthFactor: 5,
        _circleSpiralSwitchover: 9,
        //show spiral instead of circle from this marker count upwards.
        // 0 -> always spiral; Infinity -> always circle
        spiderfy: function() {
          if (this._group._spiderfied === this || this._group._inZoomAnimation) {
            return;
          }
          var childMarkers = this.getAllChildMarkers(null, true), group = this._group, map = group._map, center = map.latLngToLayerPoint(this._latlng), positions;
          this._group._unspiderfy();
          this._group._spiderfied = this;
          if (this._group.options.spiderfyShapePositions) {
            positions = this._group.options.spiderfyShapePositions(childMarkers.length, center);
          } else if (childMarkers.length >= this._circleSpiralSwitchover) {
            positions = this._generatePointsSpiral(childMarkers.length, center);
          } else {
            center.y += 10;
            positions = this._generatePointsCircle(childMarkers.length, center);
          }
          this._animationSpiderfy(childMarkers, positions);
        },
        unspiderfy: function(zoomDetails) {
          if (this._group._inZoomAnimation) {
            return;
          }
          this._animationUnspiderfy(zoomDetails);
          this._group._spiderfied = null;
        },
        _generatePointsCircle: function(count, centerPt) {
          var circumference = this._group.options.spiderfyDistanceMultiplier * this._circleFootSeparation * (2 + count), legLength = circumference / this._2PI, angleStep = this._2PI / count, res = [], i, angle;
          legLength = Math.max(legLength, 35);
          res.length = count;
          for (i = 0; i < count; i++) {
            angle = this._circleStartAngle + i * angleStep;
            res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
          }
          return res;
        },
        _generatePointsSpiral: function(count, centerPt) {
          var spiderfyDistanceMultiplier = this._group.options.spiderfyDistanceMultiplier, legLength = spiderfyDistanceMultiplier * this._spiralLengthStart, separation = spiderfyDistanceMultiplier * this._spiralFootSeparation, lengthFactor = spiderfyDistanceMultiplier * this._spiralLengthFactor * this._2PI, angle = 0, res = [], i;
          res.length = count;
          for (i = count; i >= 0; i--) {
            if (i < count) {
              res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
            }
            angle += separation / legLength + i * 5e-4;
            legLength += lengthFactor / angle;
          }
          return res;
        },
        _noanimationUnspiderfy: function() {
          var group = this._group, map = group._map, fg = group._featureGroup, childMarkers = this.getAllChildMarkers(null, true), m, i;
          group._ignoreMove = true;
          this.setOpacity(1);
          for (i = childMarkers.length - 1; i >= 0; i--) {
            m = childMarkers[i];
            fg.removeLayer(m);
            if (m._preSpiderfyLatlng) {
              m.setLatLng(m._preSpiderfyLatlng);
              delete m._preSpiderfyLatlng;
            }
            if (m.setZIndexOffset) {
              m.setZIndexOffset(0);
            }
            if (m._spiderLeg) {
              map.removeLayer(m._spiderLeg);
              delete m._spiderLeg;
            }
          }
          group.fire("unspiderfied", {
            cluster: this,
            markers: childMarkers
          });
          group._ignoreMove = false;
          group._spiderfied = null;
        }
      });
      L.MarkerClusterNonAnimated = L.MarkerCluster.extend({
        _animationSpiderfy: function(childMarkers, positions) {
          var group = this._group, map = group._map, fg = group._featureGroup, legOptions = this._group.options.spiderLegPolylineOptions, i, m, leg, newPos;
          group._ignoreMove = true;
          for (i = 0; i < childMarkers.length; i++) {
            newPos = map.layerPointToLatLng(positions[i]);
            m = childMarkers[i];
            leg = new L.Polyline([this._latlng, newPos], legOptions);
            map.addLayer(leg);
            m._spiderLeg = leg;
            m._preSpiderfyLatlng = m._latlng;
            m.setLatLng(newPos);
            if (m.setZIndexOffset) {
              m.setZIndexOffset(1e6);
            }
            fg.addLayer(m);
          }
          this.setOpacity(0.3);
          group._ignoreMove = false;
          group.fire("spiderfied", {
            cluster: this,
            markers: childMarkers
          });
        },
        _animationUnspiderfy: function() {
          this._noanimationUnspiderfy();
        }
      });
      L.MarkerCluster.include({
        _animationSpiderfy: function(childMarkers, positions) {
          var me = this, group = this._group, map = group._map, fg = group._featureGroup, thisLayerLatLng = this._latlng, thisLayerPos = map.latLngToLayerPoint(thisLayerLatLng), svg = L.Path.SVG, legOptions = L.extend({}, this._group.options.spiderLegPolylineOptions), finalLegOpacity = legOptions.opacity, i, m, leg, legPath, legLength, newPos;
          if (finalLegOpacity === void 0) {
            finalLegOpacity = L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity;
          }
          if (svg) {
            legOptions.opacity = 0;
            legOptions.className = (legOptions.className || "") + " leaflet-cluster-spider-leg";
          } else {
            legOptions.opacity = finalLegOpacity;
          }
          group._ignoreMove = true;
          for (i = 0; i < childMarkers.length; i++) {
            m = childMarkers[i];
            newPos = map.layerPointToLatLng(positions[i]);
            leg = new L.Polyline([thisLayerLatLng, newPos], legOptions);
            map.addLayer(leg);
            m._spiderLeg = leg;
            if (svg) {
              legPath = leg._path;
              legLength = legPath.getTotalLength() + 0.1;
              legPath.style.strokeDasharray = legLength;
              legPath.style.strokeDashoffset = legLength;
            }
            if (m.setZIndexOffset) {
              m.setZIndexOffset(1e6);
            }
            if (m.clusterHide) {
              m.clusterHide();
            }
            fg.addLayer(m);
            if (m._setPos) {
              m._setPos(thisLayerPos);
            }
          }
          group._forceLayout();
          group._animationStart();
          for (i = childMarkers.length - 1; i >= 0; i--) {
            newPos = map.layerPointToLatLng(positions[i]);
            m = childMarkers[i];
            m._preSpiderfyLatlng = m._latlng;
            m.setLatLng(newPos);
            if (m.clusterShow) {
              m.clusterShow();
            }
            if (svg) {
              leg = m._spiderLeg;
              legPath = leg._path;
              legPath.style.strokeDashoffset = 0;
              leg.setStyle({ opacity: finalLegOpacity });
            }
          }
          this.setOpacity(0.3);
          group._ignoreMove = false;
          setTimeout(function() {
            group._animationEnd();
            group.fire("spiderfied", {
              cluster: me,
              markers: childMarkers
            });
          }, 200);
        },
        _animationUnspiderfy: function(zoomDetails) {
          var me = this, group = this._group, map = group._map, fg = group._featureGroup, thisLayerPos = zoomDetails ? map._latLngToNewLayerPoint(this._latlng, zoomDetails.zoom, zoomDetails.center) : map.latLngToLayerPoint(this._latlng), childMarkers = this.getAllChildMarkers(null, true), svg = L.Path.SVG, m, i, leg, legPath, legLength, nonAnimatable;
          group._ignoreMove = true;
          group._animationStart();
          this.setOpacity(1);
          for (i = childMarkers.length - 1; i >= 0; i--) {
            m = childMarkers[i];
            if (!m._preSpiderfyLatlng) {
              continue;
            }
            m.closePopup();
            m.setLatLng(m._preSpiderfyLatlng);
            delete m._preSpiderfyLatlng;
            nonAnimatable = true;
            if (m._setPos) {
              m._setPos(thisLayerPos);
              nonAnimatable = false;
            }
            if (m.clusterHide) {
              m.clusterHide();
              nonAnimatable = false;
            }
            if (nonAnimatable) {
              fg.removeLayer(m);
            }
            if (svg) {
              leg = m._spiderLeg;
              legPath = leg._path;
              legLength = legPath.getTotalLength() + 0.1;
              legPath.style.strokeDashoffset = legLength;
              leg.setStyle({ opacity: 0 });
            }
          }
          group._ignoreMove = false;
          setTimeout(function() {
            var stillThereChildCount = 0;
            for (i = childMarkers.length - 1; i >= 0; i--) {
              m = childMarkers[i];
              if (m._spiderLeg) {
                stillThereChildCount++;
              }
            }
            for (i = childMarkers.length - 1; i >= 0; i--) {
              m = childMarkers[i];
              if (!m._spiderLeg) {
                continue;
              }
              if (m.clusterShow) {
                m.clusterShow();
              }
              if (m.setZIndexOffset) {
                m.setZIndexOffset(0);
              }
              if (stillThereChildCount > 1) {
                fg.removeLayer(m);
              }
              map.removeLayer(m._spiderLeg);
              delete m._spiderLeg;
            }
            group._animationEnd();
            group.fire("unspiderfied", {
              cluster: me,
              markers: childMarkers
            });
          }, 200);
        }
      });
      L.MarkerClusterGroup.include({
        //The MarkerCluster currently spiderfied (if any)
        _spiderfied: null,
        unspiderfy: function() {
          this._unspiderfy.apply(this, arguments);
        },
        _spiderfierOnAdd: function() {
          this._map.on("click", this._unspiderfyWrapper, this);
          if (this._map.options.zoomAnimation) {
            this._map.on("zoomstart", this._unspiderfyZoomStart, this);
          }
          this._map.on("zoomend", this._noanimationUnspiderfy, this);
          if (!L.Browser.touch) {
            this._map.getRenderer(this);
          }
        },
        _spiderfierOnRemove: function() {
          this._map.off("click", this._unspiderfyWrapper, this);
          this._map.off("zoomstart", this._unspiderfyZoomStart, this);
          this._map.off("zoomanim", this._unspiderfyZoomAnim, this);
          this._map.off("zoomend", this._noanimationUnspiderfy, this);
          this._noanimationUnspiderfy();
        },
        //On zoom start we add a zoomanim handler so that we are guaranteed to be last (after markers are animated)
        //This means we can define the animation they do rather than Markers doing an animation to their actual location
        _unspiderfyZoomStart: function() {
          if (!this._map) {
            return;
          }
          this._map.on("zoomanim", this._unspiderfyZoomAnim, this);
        },
        _unspiderfyZoomAnim: function(zoomDetails) {
          if (L.DomUtil.hasClass(this._map._mapPane, "leaflet-touching")) {
            return;
          }
          this._map.off("zoomanim", this._unspiderfyZoomAnim, this);
          this._unspiderfy(zoomDetails);
        },
        _unspiderfyWrapper: function() {
          this._unspiderfy();
        },
        _unspiderfy: function(zoomDetails) {
          if (this._spiderfied) {
            this._spiderfied.unspiderfy(zoomDetails);
          }
        },
        _noanimationUnspiderfy: function() {
          if (this._spiderfied) {
            this._spiderfied._noanimationUnspiderfy();
          }
        },
        //If the given layer is currently being spiderfied then we unspiderfy it so it isn't on the map anymore etc
        _unspiderfyLayer: function(layer) {
          if (layer._spiderLeg) {
            this._featureGroup.removeLayer(layer);
            if (layer.clusterShow) {
              layer.clusterShow();
            }
            if (layer.setZIndexOffset) {
              layer.setZIndexOffset(0);
            }
            this._map.removeLayer(layer._spiderLeg);
            delete layer._spiderLeg;
          }
        }
      });
      L.MarkerClusterGroup.include({
        /**
         * Updates the icon of all clusters which are parents of the given marker(s).
         * In singleMarkerMode, also updates the given marker(s) icon.
         * @param layers L.MarkerClusterGroup|L.LayerGroup|Array(L.Marker)|Map(L.Marker)|
         * L.MarkerCluster|L.Marker (optional) list of markers (or single marker) whose parent
         * clusters need to be updated. If not provided, retrieves all child markers of this.
         * @returns {L.MarkerClusterGroup}
         */
        refreshClusters: function(layers) {
          if (!layers) {
            layers = this._topClusterLevel.getAllChildMarkers();
          } else if (layers instanceof L.MarkerClusterGroup) {
            layers = layers._topClusterLevel.getAllChildMarkers();
          } else if (layers instanceof L.LayerGroup) {
            layers = layers._layers;
          } else if (layers instanceof L.MarkerCluster) {
            layers = layers.getAllChildMarkers();
          } else if (layers instanceof L.Marker) {
            layers = [layers];
          }
          this._flagParentsIconsNeedUpdate(layers);
          this._refreshClustersIcons();
          if (this.options.singleMarkerMode) {
            this._refreshSingleMarkerModeMarkers(layers);
          }
          return this;
        },
        /**
         * Simply flags all parent clusters of the given markers as having a "dirty" icon.
         * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
         * @private
         */
        _flagParentsIconsNeedUpdate: function(layers) {
          var id, parent;
          for (id in layers) {
            parent = layers[id].__parent;
            while (parent) {
              parent._iconNeedsUpdate = true;
              parent = parent.__parent;
            }
          }
        },
        /**
         * Re-draws the icon of the supplied markers.
         * To be used in singleMarkerMode only.
         * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
         * @private
         */
        _refreshSingleMarkerModeMarkers: function(layers) {
          var id, layer;
          for (id in layers) {
            layer = layers[id];
            if (this.hasLayer(layer)) {
              layer.setIcon(this._overrideMarkerIcon(layer));
            }
          }
        }
      });
      L.Marker.include({
        /**
         * Updates the given options in the marker's icon and refreshes the marker.
         * @param options map object of icon options.
         * @param directlyRefreshClusters boolean (optional) true to trigger
         * MCG.refreshClustersOf() right away with this single marker.
         * @returns {L.Marker}
         */
        refreshIconOptions: function(options, directlyRefreshClusters) {
          var icon = this.options.icon;
          L.setOptions(icon, options);
          this.setIcon(icon);
          if (directlyRefreshClusters && this.__parent) {
            this.__parent._group.refreshClusters(this);
          }
          return this;
        }
      });
      exports2.MarkerClusterGroup = MarkerClusterGroup;
      exports2.MarkerCluster = MarkerCluster2;
      Object.defineProperty(exports2, "__esModule", { value: true });
    });
  })(leaflet_markerclusterSrc$1, leaflet_markerclusterSrc$1.exports);
  return leaflet_markerclusterSrc$1.exports;
}
requireLeaflet_markerclusterSrc();
const markerObjs = {
  default: {
    name: "all_orders",
    iconConfig: {
      html: "",
      className: "custom-cluster-icon cluster-small",
      iconSize: leafletSrcExports.point(15, 15),
      iconAnchor: [15, 15]
    }
  },
  currentOrder: {
    name: "current_order",
    iconConfig: {
      iconUrl: "CurrentOrderImage",
      // Path to the custom URL marker image
      iconSize: [64, 64],
      // Size of the URL marker
      iconAnchor: [32, 64],
      // Position of the anchor point
      popupAnchor: [0, -58]
      // Popup anchor position
    }
  },
  recent: {
    name: "recent_orders",
    iconConfig: {
      iconUrl: "RecentOrderImage",
      // Path to the recent marker image
      iconSize: [24, 24],
      // Size of the recent marker
      iconAnchor: [10, 10],
      // Position of the anchor point
      popupAnchor: [2, -12]
      // Popup anchor position
    }
  },
  cluster_small: {
    name: "small_cluster",
    iconConfig: {
      html: "",
      className: "custom-cluster-icon cluster-small",
      iconSize: leafletSrcExports.point(15, 15),
      iconAnchor: [15, 15]
    }
  },
  cluster_medium: {
    name: "medium_cluster",
    iconConfig: {
      html: "",
      className: "custom-cluster-icon cluster-medium",
      iconSize: leafletSrcExports.point(20, 20),
      iconAnchor: [15, 15]
    }
  },
  cluster_large: {
    name: "large_cluster",
    iconConfig: {
      html: "",
      className: "custom-cluster-icon cluster-large",
      iconSize: leafletSrcExports.point(25, 25),
      iconAnchor: [15, 15]
    }
  }
};
var server_browser = {};
var reactDomServerLegacy_browser_production = {};
/**
 * @license React
 * react-dom-server-legacy.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDomServerLegacy_browser_production;
function requireReactDomServerLegacy_browser_production() {
  if (hasRequiredReactDomServerLegacy_browser_production) return reactDomServerLegacy_browser_production;
  hasRequiredReactDomServerLegacy_browser_production = 1;
  var React2 = requireReact(), ReactDOM = requireReactDom();
  function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
      url += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var i = 2; i < arguments.length; i++)
        url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_SCOPE_TYPE = Symbol.for("react.scope"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden"), REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, isArrayImpl = Array.isArray;
  function murmurhash3_32_gc(key, seed) {
    var remainder = key.length & 3;
    var bytes = key.length - remainder;
    var h1 = seed;
    for (seed = 0; seed < bytes; ) {
      var k1 = key.charCodeAt(seed) & 255 | (key.charCodeAt(++seed) & 255) << 8 | (key.charCodeAt(++seed) & 255) << 16 | (key.charCodeAt(++seed) & 255) << 24;
      ++seed;
      k1 = 3432918353 * (k1 & 65535) + ((3432918353 * (k1 >>> 16) & 65535) << 16) & 4294967295;
      k1 = k1 << 15 | k1 >>> 17;
      k1 = 461845907 * (k1 & 65535) + ((461845907 * (k1 >>> 16) & 65535) << 16) & 4294967295;
      h1 ^= k1;
      h1 = h1 << 13 | h1 >>> 19;
      h1 = 5 * (h1 & 65535) + ((5 * (h1 >>> 16) & 65535) << 16) & 4294967295;
      h1 = (h1 & 65535) + 27492 + (((h1 >>> 16) + 58964 & 65535) << 16);
    }
    k1 = 0;
    switch (remainder) {
      case 3:
        k1 ^= (key.charCodeAt(seed + 2) & 255) << 16;
      case 2:
        k1 ^= (key.charCodeAt(seed + 1) & 255) << 8;
      case 1:
        k1 ^= key.charCodeAt(seed) & 255, k1 = 3432918353 * (k1 & 65535) + ((3432918353 * (k1 >>> 16) & 65535) << 16) & 4294967295, k1 = k1 << 15 | k1 >>> 17, h1 ^= 461845907 * (k1 & 65535) + ((461845907 * (k1 >>> 16) & 65535) << 16) & 4294967295;
    }
    h1 ^= key.length;
    h1 ^= h1 >>> 16;
    h1 = 2246822507 * (h1 & 65535) + ((2246822507 * (h1 >>> 16) & 65535) << 16) & 4294967295;
    h1 ^= h1 >>> 13;
    h1 = 3266489909 * (h1 & 65535) + ((3266489909 * (h1 >>> 16) & 65535) << 16) & 4294967295;
    return (h1 ^ h1 >>> 16) >>> 0;
  }
  var assign = Object.assign, hasOwnProperty = Object.prototype.hasOwnProperty, VALID_ATTRIBUTE_NAME_REGEX = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
  function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName))
      return true;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName))
      return validatedAttributeNameCache[attributeName] = true;
    illegalAttributeNameCache[attributeName] = true;
    return false;
  }
  var unitlessNumbers = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  ), aliases = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), matchHtmlRegExp = /["'&<>]/;
  function escapeTextForBrowser(text) {
    if ("boolean" === typeof text || "number" === typeof text || "bigint" === typeof text)
      return "" + text;
    text = "" + text;
    var match = matchHtmlRegExp.exec(text);
    if (match) {
      var html = "", index, lastIndex = 0;
      for (index = match.index; index < text.length; index++) {
        switch (text.charCodeAt(index)) {
          case 34:
            match = "&quot;";
            break;
          case 38:
            match = "&amp;";
            break;
          case 39:
            match = "&#x27;";
            break;
          case 60:
            match = "&lt;";
            break;
          case 62:
            match = "&gt;";
            break;
          default:
            continue;
        }
        lastIndex !== index && (html += text.slice(lastIndex, index));
        lastIndex = index + 1;
        html += match;
      }
      text = lastIndex !== index ? html + text.slice(lastIndex, index) : html;
    }
    return text;
  }
  var uppercasePattern = /([A-Z])/g, msPattern = /^ms-/, isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
  }
  var ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: false,
    data: null,
    method: null,
    action: null
  }, previousDispatcher = ReactDOMSharedInternals.d;
  ReactDOMSharedInternals.d = {
    f: previousDispatcher.f,
    r: previousDispatcher.r,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
  };
  var PRELOAD_NO_CREDS = [], scriptRegex = /(<\/|<)(s)(cript)/gi;
  function scriptReplacer(match, prefix2, s, suffix2) {
    return "" + prefix2 + ("s" === s ? "\\u0073" : "\\u0053") + suffix2;
  }
  function createResumableState(identifierPrefix, externalRuntimeConfig, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
    return {
      idPrefix: void 0 === identifierPrefix ? "" : identifierPrefix,
      nextFormID: 0,
      streamingFormat: 0,
      bootstrapScriptContent,
      bootstrapScripts,
      bootstrapModules,
      instructions: 0,
      hasBody: false,
      hasHtml: false,
      unknownResources: {},
      dnsResources: {},
      connectResources: { default: {}, anonymous: {}, credentials: {} },
      imageResources: {},
      styleResources: {},
      scriptResources: {},
      moduleUnknownResources: {},
      moduleScriptResources: {}
    };
  }
  function createPreambleState() {
    return {
      htmlChunks: null,
      headChunks: null,
      bodyChunks: null,
      contribution: 0
    };
  }
  function createFormatContext(insertionMode, selectedValue, tagScope) {
    return {
      insertionMode,
      selectedValue,
      tagScope
    };
  }
  function getChildFormatContext(parentContext, type, props) {
    switch (type) {
      case "noscript":
        return createFormatContext(2, null, parentContext.tagScope | 1);
      case "select":
        return createFormatContext(
          2,
          null != props.value ? props.value : props.defaultValue,
          parentContext.tagScope
        );
      case "svg":
        return createFormatContext(4, null, parentContext.tagScope);
      case "picture":
        return createFormatContext(2, null, parentContext.tagScope | 2);
      case "math":
        return createFormatContext(5, null, parentContext.tagScope);
      case "foreignObject":
        return createFormatContext(2, null, parentContext.tagScope);
      case "table":
        return createFormatContext(6, null, parentContext.tagScope);
      case "thead":
      case "tbody":
      case "tfoot":
        return createFormatContext(7, null, parentContext.tagScope);
      case "colgroup":
        return createFormatContext(9, null, parentContext.tagScope);
      case "tr":
        return createFormatContext(8, null, parentContext.tagScope);
      case "head":
        if (2 > parentContext.insertionMode)
          return createFormatContext(3, null, parentContext.tagScope);
        break;
      case "html":
        if (0 === parentContext.insertionMode)
          return createFormatContext(1, null, parentContext.tagScope);
    }
    return 6 <= parentContext.insertionMode || 2 > parentContext.insertionMode ? createFormatContext(2, null, parentContext.tagScope) : parentContext;
  }
  var styleNameCache = /* @__PURE__ */ new Map();
  function pushStyleAttribute(target, style) {
    if ("object" !== typeof style) throw Error(formatProdErrorMessage(62));
    var isFirst = true, styleName;
    for (styleName in style)
      if (hasOwnProperty.call(style, styleName)) {
        var styleValue = style[styleName];
        if (null != styleValue && "boolean" !== typeof styleValue && "" !== styleValue) {
          if (0 === styleName.indexOf("--")) {
            var nameChunk = escapeTextForBrowser(styleName);
            styleValue = escapeTextForBrowser(("" + styleValue).trim());
          } else
            nameChunk = styleNameCache.get(styleName), void 0 === nameChunk && (nameChunk = escapeTextForBrowser(
              styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-")
            ), styleNameCache.set(styleName, nameChunk)), styleValue = "number" === typeof styleValue ? 0 === styleValue || unitlessNumbers.has(styleName) ? "" + styleValue : styleValue + "px" : escapeTextForBrowser(("" + styleValue).trim());
          isFirst ? (isFirst = false, target.push(' style="', nameChunk, ":", styleValue)) : target.push(";", nameChunk, ":", styleValue);
        }
      }
    isFirst || target.push('"');
  }
  function pushBooleanAttribute(target, name, value) {
    value && "function" !== typeof value && "symbol" !== typeof value && target.push(" ", name, '=""');
  }
  function pushStringAttribute(target, name, value) {
    "function" !== typeof value && "symbol" !== typeof value && "boolean" !== typeof value && target.push(" ", name, '="', escapeTextForBrowser(value), '"');
  }
  var actionJavaScriptURL = escapeTextForBrowser(
    "javascript:throw new Error('React form unexpectedly submitted.')"
  );
  function pushAdditionalFormField(value, key) {
    this.push('<input type="hidden"');
    validateAdditionalFormField(value);
    pushStringAttribute(this, "name", key);
    pushStringAttribute(this, "value", value);
    this.push("/>");
  }
  function validateAdditionalFormField(value) {
    if ("string" !== typeof value) throw Error(formatProdErrorMessage(480));
  }
  function getCustomFormFields(resumableState, formAction) {
    if ("function" === typeof formAction.$$FORM_ACTION) {
      var id = resumableState.nextFormID++;
      resumableState = resumableState.idPrefix + id;
      try {
        var customFields = formAction.$$FORM_ACTION(resumableState);
        if (customFields) {
          var formData = customFields.data;
          null != formData && formData.forEach(validateAdditionalFormField);
        }
        return customFields;
      } catch (x) {
        if ("object" === typeof x && null !== x && "function" === typeof x.then)
          throw x;
      }
    }
    return null;
  }
  function pushFormActionAttribute(target, resumableState, renderState, formAction, formEncType, formMethod, formTarget, name) {
    var formData = null;
    if ("function" === typeof formAction) {
      var customFields = getCustomFormFields(resumableState, formAction);
      null !== customFields ? (name = customFields.name, formAction = customFields.action || "", formEncType = customFields.encType, formMethod = customFields.method, formTarget = customFields.target, formData = customFields.data) : (target.push(" ", "formAction", '="', actionJavaScriptURL, '"'), formTarget = formMethod = formEncType = formAction = name = null, injectFormReplayingRuntime(resumableState, renderState));
    }
    null != name && pushAttribute(target, "name", name);
    null != formAction && pushAttribute(target, "formAction", formAction);
    null != formEncType && pushAttribute(target, "formEncType", formEncType);
    null != formMethod && pushAttribute(target, "formMethod", formMethod);
    null != formTarget && pushAttribute(target, "formTarget", formTarget);
    return formData;
  }
  function pushAttribute(target, name, value) {
    switch (name) {
      case "className":
        pushStringAttribute(target, "class", value);
        break;
      case "tabIndex":
        pushStringAttribute(target, "tabindex", value);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        pushStringAttribute(target, name, value);
        break;
      case "style":
        pushStyleAttribute(target, value);
        break;
      case "src":
      case "href":
        if ("" === value) break;
      case "action":
      case "formAction":
        if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value)
          break;
        value = sanitizeURL("" + value);
        target.push(" ", name, '="', escapeTextForBrowser(value), '"');
        break;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "ref":
        break;
      case "autoFocus":
      case "multiple":
      case "muted":
        pushBooleanAttribute(target, name.toLowerCase(), value);
        break;
      case "xlinkHref":
        if ("function" === typeof value || "symbol" === typeof value || "boolean" === typeof value)
          break;
        value = sanitizeURL("" + value);
        target.push(" ", "xlink:href", '="', escapeTextForBrowser(value), '"');
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        "function" !== typeof value && "symbol" !== typeof value && target.push(" ", name, '="', escapeTextForBrowser(value), '"');
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        value && "function" !== typeof value && "symbol" !== typeof value && target.push(" ", name, '=""');
        break;
      case "capture":
      case "download":
        true === value ? target.push(" ", name, '=""') : false !== value && "function" !== typeof value && "symbol" !== typeof value && target.push(" ", name, '="', escapeTextForBrowser(value), '"');
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value && target.push(" ", name, '="', escapeTextForBrowser(value), '"');
        break;
      case "rowSpan":
      case "start":
        "function" === typeof value || "symbol" === typeof value || isNaN(value) || target.push(" ", name, '="', escapeTextForBrowser(value), '"');
        break;
      case "xlinkActuate":
        pushStringAttribute(target, "xlink:actuate", value);
        break;
      case "xlinkArcrole":
        pushStringAttribute(target, "xlink:arcrole", value);
        break;
      case "xlinkRole":
        pushStringAttribute(target, "xlink:role", value);
        break;
      case "xlinkShow":
        pushStringAttribute(target, "xlink:show", value);
        break;
      case "xlinkTitle":
        pushStringAttribute(target, "xlink:title", value);
        break;
      case "xlinkType":
        pushStringAttribute(target, "xlink:type", value);
        break;
      case "xmlBase":
        pushStringAttribute(target, "xml:base", value);
        break;
      case "xmlLang":
        pushStringAttribute(target, "xml:lang", value);
        break;
      case "xmlSpace":
        pushStringAttribute(target, "xml:space", value);
        break;
      default:
        if (!(2 < name.length) || "o" !== name[0] && "O" !== name[0] || "n" !== name[1] && "N" !== name[1]) {
          if (name = aliases.get(name) || name, isAttributeNameSafe(name)) {
            switch (typeof value) {
              case "function":
              case "symbol":
                return;
              case "boolean":
                var prefix$8 = name.toLowerCase().slice(0, 5);
                if ("data-" !== prefix$8 && "aria-" !== prefix$8) return;
            }
            target.push(" ", name, '="', escapeTextForBrowser(value), '"');
          }
        }
    }
  }
  function pushInnerHTML(target, innerHTML, children) {
    if (null != innerHTML) {
      if (null != children) throw Error(formatProdErrorMessage(60));
      if ("object" !== typeof innerHTML || !("__html" in innerHTML))
        throw Error(formatProdErrorMessage(61));
      innerHTML = innerHTML.__html;
      null !== innerHTML && void 0 !== innerHTML && target.push("" + innerHTML);
    }
  }
  function flattenOptionChildren(children) {
    var content = "";
    React2.Children.forEach(children, function(child) {
      null != child && (content += child);
    });
    return content;
  }
  function injectFormReplayingRuntime(resumableState, renderState) {
    0 === (resumableState.instructions & 16) && (resumableState.instructions |= 16, renderState.bootstrapChunks.unshift(
      renderState.startInlineScript,
      `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`,
      "<\/script>"
    ));
  }
  function pushLinkImpl(target, props) {
    target.push(startChunkForTag("link"));
    for (var propKey in props)
      if (hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue)
          switch (propKey) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(formatProdErrorMessage(399, "link"));
            default:
              pushAttribute(target, propKey, propValue);
          }
      }
    target.push("/>");
    return null;
  }
  var styleRegex = /(<\/|<)(s)(tyle)/gi;
  function styleReplacer(match, prefix2, s, suffix2) {
    return "" + prefix2 + ("s" === s ? "\\73 " : "\\53 ") + suffix2;
  }
  function pushSelfClosing(target, props, tag) {
    target.push(startChunkForTag(tag));
    for (var propKey in props)
      if (hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue)
          switch (propKey) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(formatProdErrorMessage(399, tag));
            default:
              pushAttribute(target, propKey, propValue);
          }
      }
    target.push("/>");
    return null;
  }
  function pushTitleImpl(target, props) {
    target.push(startChunkForTag("title"));
    var children = null, innerHTML = null, propKey;
    for (propKey in props)
      if (hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue)
          switch (propKey) {
            case "children":
              children = propValue;
              break;
            case "dangerouslySetInnerHTML":
              innerHTML = propValue;
              break;
            default:
              pushAttribute(target, propKey, propValue);
          }
      }
    target.push(">");
    props = Array.isArray(children) ? 2 > children.length ? children[0] : null : children;
    "function" !== typeof props && "symbol" !== typeof props && null !== props && void 0 !== props && target.push(escapeTextForBrowser("" + props));
    pushInnerHTML(target, innerHTML, children);
    target.push(endChunkForTag("title"));
    return null;
  }
  function pushScriptImpl(target, props) {
    target.push(startChunkForTag("script"));
    var children = null, innerHTML = null, propKey;
    for (propKey in props)
      if (hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue)
          switch (propKey) {
            case "children":
              children = propValue;
              break;
            case "dangerouslySetInnerHTML":
              innerHTML = propValue;
              break;
            default:
              pushAttribute(target, propKey, propValue);
          }
      }
    target.push(">");
    pushInnerHTML(target, innerHTML, children);
    "string" === typeof children && target.push(("" + children).replace(scriptRegex, scriptReplacer));
    target.push(endChunkForTag("script"));
    return null;
  }
  function pushStartSingletonElement(target, props, tag) {
    target.push(startChunkForTag(tag));
    var innerHTML = tag = null, propKey;
    for (propKey in props)
      if (hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue)
          switch (propKey) {
            case "children":
              tag = propValue;
              break;
            case "dangerouslySetInnerHTML":
              innerHTML = propValue;
              break;
            default:
              pushAttribute(target, propKey, propValue);
          }
      }
    target.push(">");
    pushInnerHTML(target, innerHTML, tag);
    return tag;
  }
  function pushStartGenericElement(target, props, tag) {
    target.push(startChunkForTag(tag));
    var innerHTML = tag = null, propKey;
    for (propKey in props)
      if (hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue)
          switch (propKey) {
            case "children":
              tag = propValue;
              break;
            case "dangerouslySetInnerHTML":
              innerHTML = propValue;
              break;
            default:
              pushAttribute(target, propKey, propValue);
          }
      }
    target.push(">");
    pushInnerHTML(target, innerHTML, tag);
    return "string" === typeof tag ? (target.push(escapeTextForBrowser(tag)), null) : tag;
  }
  var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, validatedTagCache = /* @__PURE__ */ new Map();
  function startChunkForTag(tag) {
    var tagStartChunk = validatedTagCache.get(tag);
    if (void 0 === tagStartChunk) {
      if (!VALID_TAG_REGEX.test(tag))
        throw Error(formatProdErrorMessage(65, tag));
      tagStartChunk = "<" + tag;
      validatedTagCache.set(tag, tagStartChunk);
    }
    return tagStartChunk;
  }
  function pushStartInstance(target$jscomp$0, type, props, resumableState, renderState, preambleState, hoistableState, formatContext, textEmbedded, isFallback) {
    switch (type) {
      case "div":
      case "span":
      case "svg":
      case "path":
        break;
      case "a":
        target$jscomp$0.push(startChunkForTag("a"));
        var children = null, innerHTML = null, propKey;
        for (propKey in props)
          if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (null != propValue)
              switch (propKey) {
                case "children":
                  children = propValue;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML = propValue;
                  break;
                case "href":
                  "" === propValue ? pushStringAttribute(target$jscomp$0, "href", "") : pushAttribute(target$jscomp$0, propKey, propValue);
                  break;
                default:
                  pushAttribute(target$jscomp$0, propKey, propValue);
              }
          }
        target$jscomp$0.push(">");
        pushInnerHTML(target$jscomp$0, innerHTML, children);
        if ("string" === typeof children) {
          target$jscomp$0.push(escapeTextForBrowser(children));
          var JSCompiler_inline_result = null;
        } else JSCompiler_inline_result = children;
        return JSCompiler_inline_result;
      case "g":
      case "p":
      case "li":
        break;
      case "select":
        target$jscomp$0.push(startChunkForTag("select"));
        var children$jscomp$0 = null, innerHTML$jscomp$0 = null, propKey$jscomp$0;
        for (propKey$jscomp$0 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$0)) {
            var propValue$jscomp$0 = props[propKey$jscomp$0];
            if (null != propValue$jscomp$0)
              switch (propKey$jscomp$0) {
                case "children":
                  children$jscomp$0 = propValue$jscomp$0;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML$jscomp$0 = propValue$jscomp$0;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$0,
                    propValue$jscomp$0
                  );
              }
          }
        target$jscomp$0.push(">");
        pushInnerHTML(target$jscomp$0, innerHTML$jscomp$0, children$jscomp$0);
        return children$jscomp$0;
      case "option":
        var selectedValue = formatContext.selectedValue;
        target$jscomp$0.push(startChunkForTag("option"));
        var children$jscomp$1 = null, value = null, selected = null, innerHTML$jscomp$1 = null, propKey$jscomp$1;
        for (propKey$jscomp$1 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$1)) {
            var propValue$jscomp$1 = props[propKey$jscomp$1];
            if (null != propValue$jscomp$1)
              switch (propKey$jscomp$1) {
                case "children":
                  children$jscomp$1 = propValue$jscomp$1;
                  break;
                case "selected":
                  selected = propValue$jscomp$1;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML$jscomp$1 = propValue$jscomp$1;
                  break;
                case "value":
                  value = propValue$jscomp$1;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$1,
                    propValue$jscomp$1
                  );
              }
          }
        if (null != selectedValue) {
          var stringValue = null !== value ? "" + value : flattenOptionChildren(children$jscomp$1);
          if (isArrayImpl(selectedValue))
            for (var i = 0; i < selectedValue.length; i++) {
              if ("" + selectedValue[i] === stringValue) {
                target$jscomp$0.push(' selected=""');
                break;
              }
            }
          else
            "" + selectedValue === stringValue && target$jscomp$0.push(' selected=""');
        } else selected && target$jscomp$0.push(' selected=""');
        target$jscomp$0.push(">");
        pushInnerHTML(target$jscomp$0, innerHTML$jscomp$1, children$jscomp$1);
        return children$jscomp$1;
      case "textarea":
        target$jscomp$0.push(startChunkForTag("textarea"));
        var value$jscomp$0 = null, defaultValue = null, children$jscomp$2 = null, propKey$jscomp$2;
        for (propKey$jscomp$2 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$2)) {
            var propValue$jscomp$2 = props[propKey$jscomp$2];
            if (null != propValue$jscomp$2)
              switch (propKey$jscomp$2) {
                case "children":
                  children$jscomp$2 = propValue$jscomp$2;
                  break;
                case "value":
                  value$jscomp$0 = propValue$jscomp$2;
                  break;
                case "defaultValue":
                  defaultValue = propValue$jscomp$2;
                  break;
                case "dangerouslySetInnerHTML":
                  throw Error(formatProdErrorMessage(91));
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$2,
                    propValue$jscomp$2
                  );
              }
          }
        null === value$jscomp$0 && null !== defaultValue && (value$jscomp$0 = defaultValue);
        target$jscomp$0.push(">");
        if (null != children$jscomp$2) {
          if (null != value$jscomp$0) throw Error(formatProdErrorMessage(92));
          if (isArrayImpl(children$jscomp$2)) {
            if (1 < children$jscomp$2.length)
              throw Error(formatProdErrorMessage(93));
            value$jscomp$0 = "" + children$jscomp$2[0];
          }
          value$jscomp$0 = "" + children$jscomp$2;
        }
        "string" === typeof value$jscomp$0 && "\n" === value$jscomp$0[0] && target$jscomp$0.push("\n");
        null !== value$jscomp$0 && target$jscomp$0.push(escapeTextForBrowser("" + value$jscomp$0));
        return null;
      case "input":
        target$jscomp$0.push(startChunkForTag("input"));
        var name = null, formAction = null, formEncType = null, formMethod = null, formTarget = null, value$jscomp$1 = null, defaultValue$jscomp$0 = null, checked = null, defaultChecked = null, propKey$jscomp$3;
        for (propKey$jscomp$3 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$3)) {
            var propValue$jscomp$3 = props[propKey$jscomp$3];
            if (null != propValue$jscomp$3)
              switch (propKey$jscomp$3) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(formatProdErrorMessage(399, "input"));
                case "name":
                  name = propValue$jscomp$3;
                  break;
                case "formAction":
                  formAction = propValue$jscomp$3;
                  break;
                case "formEncType":
                  formEncType = propValue$jscomp$3;
                  break;
                case "formMethod":
                  formMethod = propValue$jscomp$3;
                  break;
                case "formTarget":
                  formTarget = propValue$jscomp$3;
                  break;
                case "defaultChecked":
                  defaultChecked = propValue$jscomp$3;
                  break;
                case "defaultValue":
                  defaultValue$jscomp$0 = propValue$jscomp$3;
                  break;
                case "checked":
                  checked = propValue$jscomp$3;
                  break;
                case "value":
                  value$jscomp$1 = propValue$jscomp$3;
                  break;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$3,
                    propValue$jscomp$3
                  );
              }
          }
        var formData = pushFormActionAttribute(
          target$jscomp$0,
          resumableState,
          renderState,
          formAction,
          formEncType,
          formMethod,
          formTarget,
          name
        );
        null !== checked ? pushBooleanAttribute(target$jscomp$0, "checked", checked) : null !== defaultChecked && pushBooleanAttribute(target$jscomp$0, "checked", defaultChecked);
        null !== value$jscomp$1 ? pushAttribute(target$jscomp$0, "value", value$jscomp$1) : null !== defaultValue$jscomp$0 && pushAttribute(target$jscomp$0, "value", defaultValue$jscomp$0);
        target$jscomp$0.push("/>");
        null != formData && formData.forEach(pushAdditionalFormField, target$jscomp$0);
        return null;
      case "button":
        target$jscomp$0.push(startChunkForTag("button"));
        var children$jscomp$3 = null, innerHTML$jscomp$2 = null, name$jscomp$0 = null, formAction$jscomp$0 = null, formEncType$jscomp$0 = null, formMethod$jscomp$0 = null, formTarget$jscomp$0 = null, propKey$jscomp$4;
        for (propKey$jscomp$4 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$4)) {
            var propValue$jscomp$4 = props[propKey$jscomp$4];
            if (null != propValue$jscomp$4)
              switch (propKey$jscomp$4) {
                case "children":
                  children$jscomp$3 = propValue$jscomp$4;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML$jscomp$2 = propValue$jscomp$4;
                  break;
                case "name":
                  name$jscomp$0 = propValue$jscomp$4;
                  break;
                case "formAction":
                  formAction$jscomp$0 = propValue$jscomp$4;
                  break;
                case "formEncType":
                  formEncType$jscomp$0 = propValue$jscomp$4;
                  break;
                case "formMethod":
                  formMethod$jscomp$0 = propValue$jscomp$4;
                  break;
                case "formTarget":
                  formTarget$jscomp$0 = propValue$jscomp$4;
                  break;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$4,
                    propValue$jscomp$4
                  );
              }
          }
        var formData$jscomp$0 = pushFormActionAttribute(
          target$jscomp$0,
          resumableState,
          renderState,
          formAction$jscomp$0,
          formEncType$jscomp$0,
          formMethod$jscomp$0,
          formTarget$jscomp$0,
          name$jscomp$0
        );
        target$jscomp$0.push(">");
        null != formData$jscomp$0 && formData$jscomp$0.forEach(pushAdditionalFormField, target$jscomp$0);
        pushInnerHTML(target$jscomp$0, innerHTML$jscomp$2, children$jscomp$3);
        if ("string" === typeof children$jscomp$3) {
          target$jscomp$0.push(escapeTextForBrowser(children$jscomp$3));
          var JSCompiler_inline_result$jscomp$0 = null;
        } else JSCompiler_inline_result$jscomp$0 = children$jscomp$3;
        return JSCompiler_inline_result$jscomp$0;
      case "form":
        target$jscomp$0.push(startChunkForTag("form"));
        var children$jscomp$4 = null, innerHTML$jscomp$3 = null, formAction$jscomp$1 = null, formEncType$jscomp$1 = null, formMethod$jscomp$1 = null, formTarget$jscomp$1 = null, propKey$jscomp$5;
        for (propKey$jscomp$5 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$5)) {
            var propValue$jscomp$5 = props[propKey$jscomp$5];
            if (null != propValue$jscomp$5)
              switch (propKey$jscomp$5) {
                case "children":
                  children$jscomp$4 = propValue$jscomp$5;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML$jscomp$3 = propValue$jscomp$5;
                  break;
                case "action":
                  formAction$jscomp$1 = propValue$jscomp$5;
                  break;
                case "encType":
                  formEncType$jscomp$1 = propValue$jscomp$5;
                  break;
                case "method":
                  formMethod$jscomp$1 = propValue$jscomp$5;
                  break;
                case "target":
                  formTarget$jscomp$1 = propValue$jscomp$5;
                  break;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$5,
                    propValue$jscomp$5
                  );
              }
          }
        var formData$jscomp$1 = null, formActionName = null;
        if ("function" === typeof formAction$jscomp$1) {
          var customFields = getCustomFormFields(
            resumableState,
            formAction$jscomp$1
          );
          null !== customFields ? (formAction$jscomp$1 = customFields.action || "", formEncType$jscomp$1 = customFields.encType, formMethod$jscomp$1 = customFields.method, formTarget$jscomp$1 = customFields.target, formData$jscomp$1 = customFields.data, formActionName = customFields.name) : (target$jscomp$0.push(
            " ",
            "action",
            '="',
            actionJavaScriptURL,
            '"'
          ), formTarget$jscomp$1 = formMethod$jscomp$1 = formEncType$jscomp$1 = formAction$jscomp$1 = null, injectFormReplayingRuntime(resumableState, renderState));
        }
        null != formAction$jscomp$1 && pushAttribute(target$jscomp$0, "action", formAction$jscomp$1);
        null != formEncType$jscomp$1 && pushAttribute(target$jscomp$0, "encType", formEncType$jscomp$1);
        null != formMethod$jscomp$1 && pushAttribute(target$jscomp$0, "method", formMethod$jscomp$1);
        null != formTarget$jscomp$1 && pushAttribute(target$jscomp$0, "target", formTarget$jscomp$1);
        target$jscomp$0.push(">");
        null !== formActionName && (target$jscomp$0.push('<input type="hidden"'), pushStringAttribute(target$jscomp$0, "name", formActionName), target$jscomp$0.push("/>"), null != formData$jscomp$1 && formData$jscomp$1.forEach(pushAdditionalFormField, target$jscomp$0));
        pushInnerHTML(target$jscomp$0, innerHTML$jscomp$3, children$jscomp$4);
        if ("string" === typeof children$jscomp$4) {
          target$jscomp$0.push(escapeTextForBrowser(children$jscomp$4));
          var JSCompiler_inline_result$jscomp$1 = null;
        } else JSCompiler_inline_result$jscomp$1 = children$jscomp$4;
        return JSCompiler_inline_result$jscomp$1;
      case "menuitem":
        target$jscomp$0.push(startChunkForTag("menuitem"));
        for (var propKey$jscomp$6 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$6)) {
            var propValue$jscomp$6 = props[propKey$jscomp$6];
            if (null != propValue$jscomp$6)
              switch (propKey$jscomp$6) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(formatProdErrorMessage(400));
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$6,
                    propValue$jscomp$6
                  );
              }
          }
        target$jscomp$0.push(">");
        return null;
      case "object":
        target$jscomp$0.push(startChunkForTag("object"));
        var children$jscomp$5 = null, innerHTML$jscomp$4 = null, propKey$jscomp$7;
        for (propKey$jscomp$7 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$7)) {
            var propValue$jscomp$7 = props[propKey$jscomp$7];
            if (null != propValue$jscomp$7)
              switch (propKey$jscomp$7) {
                case "children":
                  children$jscomp$5 = propValue$jscomp$7;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML$jscomp$4 = propValue$jscomp$7;
                  break;
                case "data":
                  var sanitizedValue = sanitizeURL("" + propValue$jscomp$7);
                  if ("" === sanitizedValue) break;
                  target$jscomp$0.push(
                    " ",
                    "data",
                    '="',
                    escapeTextForBrowser(sanitizedValue),
                    '"'
                  );
                  break;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$7,
                    propValue$jscomp$7
                  );
              }
          }
        target$jscomp$0.push(">");
        pushInnerHTML(target$jscomp$0, innerHTML$jscomp$4, children$jscomp$5);
        if ("string" === typeof children$jscomp$5) {
          target$jscomp$0.push(escapeTextForBrowser(children$jscomp$5));
          var JSCompiler_inline_result$jscomp$2 = null;
        } else JSCompiler_inline_result$jscomp$2 = children$jscomp$5;
        return JSCompiler_inline_result$jscomp$2;
      case "title":
        if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp)
          var JSCompiler_inline_result$jscomp$3 = pushTitleImpl(
            target$jscomp$0,
            props
          );
        else
          isFallback ? JSCompiler_inline_result$jscomp$3 = null : (pushTitleImpl(renderState.hoistableChunks, props), JSCompiler_inline_result$jscomp$3 = void 0);
        return JSCompiler_inline_result$jscomp$3;
      case "link":
        var rel = props.rel, href = props.href, precedence = props.precedence;
        if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp || "string" !== typeof rel || "string" !== typeof href || "" === href) {
          pushLinkImpl(target$jscomp$0, props);
          var JSCompiler_inline_result$jscomp$4 = null;
        } else if ("stylesheet" === props.rel)
          if ("string" !== typeof precedence || null != props.disabled || props.onLoad || props.onError)
            JSCompiler_inline_result$jscomp$4 = pushLinkImpl(
              target$jscomp$0,
              props
            );
          else {
            var styleQueue = renderState.styles.get(precedence), resourceState = resumableState.styleResources.hasOwnProperty(href) ? resumableState.styleResources[href] : void 0;
            if (null !== resourceState) {
              resumableState.styleResources[href] = null;
              styleQueue || (styleQueue = {
                precedence: escapeTextForBrowser(precedence),
                rules: [],
                hrefs: [],
                sheets: /* @__PURE__ */ new Map()
              }, renderState.styles.set(precedence, styleQueue));
              var resource = {
                state: 0,
                props: assign({}, props, {
                  "data-precedence": props.precedence,
                  precedence: null
                })
              };
              if (resourceState) {
                2 === resourceState.length && adoptPreloadCredentials(resource.props, resourceState);
                var preloadResource = renderState.preloads.stylesheets.get(href);
                preloadResource && 0 < preloadResource.length ? preloadResource.length = 0 : resource.state = 1;
              }
              styleQueue.sheets.set(href, resource);
              hoistableState && hoistableState.stylesheets.add(resource);
            } else if (styleQueue) {
              var resource$9 = styleQueue.sheets.get(href);
              resource$9 && hoistableState && hoistableState.stylesheets.add(resource$9);
            }
            textEmbedded && target$jscomp$0.push("<!-- -->");
            JSCompiler_inline_result$jscomp$4 = null;
          }
        else
          props.onLoad || props.onError ? JSCompiler_inline_result$jscomp$4 = pushLinkImpl(
            target$jscomp$0,
            props
          ) : (textEmbedded && target$jscomp$0.push("<!-- -->"), JSCompiler_inline_result$jscomp$4 = isFallback ? null : pushLinkImpl(renderState.hoistableChunks, props));
        return JSCompiler_inline_result$jscomp$4;
      case "script":
        var asyncProp = props.async;
        if ("string" !== typeof props.src || !props.src || !asyncProp || "function" === typeof asyncProp || "symbol" === typeof asyncProp || props.onLoad || props.onError || 4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp)
          var JSCompiler_inline_result$jscomp$5 = pushScriptImpl(
            target$jscomp$0,
            props
          );
        else {
          var key = props.src;
          if ("module" === props.type) {
            var resources = resumableState.moduleScriptResources;
            var preloads = renderState.preloads.moduleScripts;
          } else
            resources = resumableState.scriptResources, preloads = renderState.preloads.scripts;
          var resourceState$jscomp$0 = resources.hasOwnProperty(key) ? resources[key] : void 0;
          if (null !== resourceState$jscomp$0) {
            resources[key] = null;
            var scriptProps = props;
            if (resourceState$jscomp$0) {
              2 === resourceState$jscomp$0.length && (scriptProps = assign({}, props), adoptPreloadCredentials(scriptProps, resourceState$jscomp$0));
              var preloadResource$jscomp$0 = preloads.get(key);
              preloadResource$jscomp$0 && (preloadResource$jscomp$0.length = 0);
            }
            var resource$jscomp$0 = [];
            renderState.scripts.add(resource$jscomp$0);
            pushScriptImpl(resource$jscomp$0, scriptProps);
          }
          textEmbedded && target$jscomp$0.push("<!-- -->");
          JSCompiler_inline_result$jscomp$5 = null;
        }
        return JSCompiler_inline_result$jscomp$5;
      case "style":
        var precedence$jscomp$0 = props.precedence, href$jscomp$0 = props.href;
        if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp || "string" !== typeof precedence$jscomp$0 || "string" !== typeof href$jscomp$0 || "" === href$jscomp$0) {
          target$jscomp$0.push(startChunkForTag("style"));
          var children$jscomp$6 = null, innerHTML$jscomp$5 = null, propKey$jscomp$8;
          for (propKey$jscomp$8 in props)
            if (hasOwnProperty.call(props, propKey$jscomp$8)) {
              var propValue$jscomp$8 = props[propKey$jscomp$8];
              if (null != propValue$jscomp$8)
                switch (propKey$jscomp$8) {
                  case "children":
                    children$jscomp$6 = propValue$jscomp$8;
                    break;
                  case "dangerouslySetInnerHTML":
                    innerHTML$jscomp$5 = propValue$jscomp$8;
                    break;
                  default:
                    pushAttribute(
                      target$jscomp$0,
                      propKey$jscomp$8,
                      propValue$jscomp$8
                    );
                }
            }
          target$jscomp$0.push(">");
          var child = Array.isArray(children$jscomp$6) ? 2 > children$jscomp$6.length ? children$jscomp$6[0] : null : children$jscomp$6;
          "function" !== typeof child && "symbol" !== typeof child && null !== child && void 0 !== child && target$jscomp$0.push(("" + child).replace(styleRegex, styleReplacer));
          pushInnerHTML(target$jscomp$0, innerHTML$jscomp$5, children$jscomp$6);
          target$jscomp$0.push(endChunkForTag("style"));
          var JSCompiler_inline_result$jscomp$6 = null;
        } else {
          var styleQueue$jscomp$0 = renderState.styles.get(precedence$jscomp$0);
          if (null !== (resumableState.styleResources.hasOwnProperty(href$jscomp$0) ? resumableState.styleResources[href$jscomp$0] : void 0)) {
            resumableState.styleResources[href$jscomp$0] = null;
            styleQueue$jscomp$0 ? styleQueue$jscomp$0.hrefs.push(
              escapeTextForBrowser(href$jscomp$0)
            ) : (styleQueue$jscomp$0 = {
              precedence: escapeTextForBrowser(precedence$jscomp$0),
              rules: [],
              hrefs: [escapeTextForBrowser(href$jscomp$0)],
              sheets: /* @__PURE__ */ new Map()
            }, renderState.styles.set(precedence$jscomp$0, styleQueue$jscomp$0));
            var target = styleQueue$jscomp$0.rules, children$jscomp$7 = null, innerHTML$jscomp$6 = null, propKey$jscomp$9;
            for (propKey$jscomp$9 in props)
              if (hasOwnProperty.call(props, propKey$jscomp$9)) {
                var propValue$jscomp$9 = props[propKey$jscomp$9];
                if (null != propValue$jscomp$9)
                  switch (propKey$jscomp$9) {
                    case "children":
                      children$jscomp$7 = propValue$jscomp$9;
                      break;
                    case "dangerouslySetInnerHTML":
                      innerHTML$jscomp$6 = propValue$jscomp$9;
                  }
              }
            var child$jscomp$0 = Array.isArray(children$jscomp$7) ? 2 > children$jscomp$7.length ? children$jscomp$7[0] : null : children$jscomp$7;
            "function" !== typeof child$jscomp$0 && "symbol" !== typeof child$jscomp$0 && null !== child$jscomp$0 && void 0 !== child$jscomp$0 && target.push(
              ("" + child$jscomp$0).replace(styleRegex, styleReplacer)
            );
            pushInnerHTML(target, innerHTML$jscomp$6, children$jscomp$7);
          }
          styleQueue$jscomp$0 && hoistableState && hoistableState.styles.add(styleQueue$jscomp$0);
          textEmbedded && target$jscomp$0.push("<!-- -->");
          JSCompiler_inline_result$jscomp$6 = void 0;
        }
        return JSCompiler_inline_result$jscomp$6;
      case "meta":
        if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp)
          var JSCompiler_inline_result$jscomp$7 = pushSelfClosing(
            target$jscomp$0,
            props,
            "meta"
          );
        else
          textEmbedded && target$jscomp$0.push("<!-- -->"), JSCompiler_inline_result$jscomp$7 = isFallback ? null : "string" === typeof props.charSet ? pushSelfClosing(renderState.charsetChunks, props, "meta") : "viewport" === props.name ? pushSelfClosing(renderState.viewportChunks, props, "meta") : pushSelfClosing(renderState.hoistableChunks, props, "meta");
        return JSCompiler_inline_result$jscomp$7;
      case "listing":
      case "pre":
        target$jscomp$0.push(startChunkForTag(type));
        var children$jscomp$8 = null, innerHTML$jscomp$7 = null, propKey$jscomp$10;
        for (propKey$jscomp$10 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$10)) {
            var propValue$jscomp$10 = props[propKey$jscomp$10];
            if (null != propValue$jscomp$10)
              switch (propKey$jscomp$10) {
                case "children":
                  children$jscomp$8 = propValue$jscomp$10;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML$jscomp$7 = propValue$jscomp$10;
                  break;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$10,
                    propValue$jscomp$10
                  );
              }
          }
        target$jscomp$0.push(">");
        if (null != innerHTML$jscomp$7) {
          if (null != children$jscomp$8) throw Error(formatProdErrorMessage(60));
          if ("object" !== typeof innerHTML$jscomp$7 || !("__html" in innerHTML$jscomp$7))
            throw Error(formatProdErrorMessage(61));
          var html = innerHTML$jscomp$7.__html;
          null !== html && void 0 !== html && ("string" === typeof html && 0 < html.length && "\n" === html[0] ? target$jscomp$0.push("\n", html) : target$jscomp$0.push("" + html));
        }
        "string" === typeof children$jscomp$8 && "\n" === children$jscomp$8[0] && target$jscomp$0.push("\n");
        return children$jscomp$8;
      case "img":
        var src = props.src, srcSet = props.srcSet;
        if (!("lazy" === props.loading || !src && !srcSet || "string" !== typeof src && null != src || "string" !== typeof srcSet && null != srcSet) && "low" !== props.fetchPriority && false === !!(formatContext.tagScope & 3) && ("string" !== typeof src || ":" !== src[4] || "d" !== src[0] && "D" !== src[0] || "a" !== src[1] && "A" !== src[1] || "t" !== src[2] && "T" !== src[2] || "a" !== src[3] && "A" !== src[3]) && ("string" !== typeof srcSet || ":" !== srcSet[4] || "d" !== srcSet[0] && "D" !== srcSet[0] || "a" !== srcSet[1] && "A" !== srcSet[1] || "t" !== srcSet[2] && "T" !== srcSet[2] || "a" !== srcSet[3] && "A" !== srcSet[3])) {
          var sizes = "string" === typeof props.sizes ? props.sizes : void 0, key$jscomp$0 = srcSet ? srcSet + "\n" + (sizes || "") : src, promotablePreloads = renderState.preloads.images, resource$jscomp$1 = promotablePreloads.get(key$jscomp$0);
          if (resource$jscomp$1) {
            if ("high" === props.fetchPriority || 10 > renderState.highImagePreloads.size)
              promotablePreloads.delete(key$jscomp$0), renderState.highImagePreloads.add(resource$jscomp$1);
          } else if (!resumableState.imageResources.hasOwnProperty(key$jscomp$0)) {
            resumableState.imageResources[key$jscomp$0] = PRELOAD_NO_CREDS;
            var input = props.crossOrigin;
            var JSCompiler_inline_result$jscomp$8 = "string" === typeof input ? "use-credentials" === input ? input : "" : void 0;
            var headers = renderState.headers, header;
            headers && 0 < headers.remainingCapacity && "string" !== typeof props.srcSet && ("high" === props.fetchPriority || 500 > headers.highImagePreloads.length) && (header = getPreloadAsHeader(src, "image", {
              imageSrcSet: props.srcSet,
              imageSizes: props.sizes,
              crossOrigin: JSCompiler_inline_result$jscomp$8,
              integrity: props.integrity,
              nonce: props.nonce,
              type: props.type,
              fetchPriority: props.fetchPriority,
              referrerPolicy: props.refererPolicy
            }), 0 <= (headers.remainingCapacity -= header.length + 2)) ? (renderState.resets.image[key$jscomp$0] = PRELOAD_NO_CREDS, headers.highImagePreloads && (headers.highImagePreloads += ", "), headers.highImagePreloads += header) : (resource$jscomp$1 = [], pushLinkImpl(resource$jscomp$1, {
              rel: "preload",
              as: "image",
              href: srcSet ? void 0 : src,
              imageSrcSet: srcSet,
              imageSizes: sizes,
              crossOrigin: JSCompiler_inline_result$jscomp$8,
              integrity: props.integrity,
              type: props.type,
              fetchPriority: props.fetchPriority,
              referrerPolicy: props.referrerPolicy
            }), "high" === props.fetchPriority || 10 > renderState.highImagePreloads.size ? renderState.highImagePreloads.add(resource$jscomp$1) : (renderState.bulkPreloads.add(resource$jscomp$1), promotablePreloads.set(key$jscomp$0, resource$jscomp$1)));
          }
        }
        return pushSelfClosing(target$jscomp$0, props, "img");
      case "base":
      case "area":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "param":
      case "source":
      case "track":
      case "wbr":
        return pushSelfClosing(target$jscomp$0, props, type);
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        break;
      case "head":
        if (2 > formatContext.insertionMode) {
          var preamble = preambleState || renderState.preamble;
          if (preamble.headChunks)
            throw Error(formatProdErrorMessage(545, "`<head>`"));
          preamble.headChunks = [];
          var JSCompiler_inline_result$jscomp$9 = pushStartSingletonElement(
            preamble.headChunks,
            props,
            "head"
          );
        } else
          JSCompiler_inline_result$jscomp$9 = pushStartGenericElement(
            target$jscomp$0,
            props,
            "head"
          );
        return JSCompiler_inline_result$jscomp$9;
      case "body":
        if (2 > formatContext.insertionMode) {
          var preamble$jscomp$0 = preambleState || renderState.preamble;
          if (preamble$jscomp$0.bodyChunks)
            throw Error(formatProdErrorMessage(545, "`<body>`"));
          preamble$jscomp$0.bodyChunks = [];
          var JSCompiler_inline_result$jscomp$10 = pushStartSingletonElement(
            preamble$jscomp$0.bodyChunks,
            props,
            "body"
          );
        } else
          JSCompiler_inline_result$jscomp$10 = pushStartGenericElement(
            target$jscomp$0,
            props,
            "body"
          );
        return JSCompiler_inline_result$jscomp$10;
      case "html":
        if (0 === formatContext.insertionMode) {
          var preamble$jscomp$1 = preambleState || renderState.preamble;
          if (preamble$jscomp$1.htmlChunks)
            throw Error(formatProdErrorMessage(545, "`<html>`"));
          preamble$jscomp$1.htmlChunks = [""];
          var JSCompiler_inline_result$jscomp$11 = pushStartSingletonElement(
            preamble$jscomp$1.htmlChunks,
            props,
            "html"
          );
        } else
          JSCompiler_inline_result$jscomp$11 = pushStartGenericElement(
            target$jscomp$0,
            props,
            "html"
          );
        return JSCompiler_inline_result$jscomp$11;
      default:
        if (-1 !== type.indexOf("-")) {
          target$jscomp$0.push(startChunkForTag(type));
          var children$jscomp$9 = null, innerHTML$jscomp$8 = null, propKey$jscomp$11;
          for (propKey$jscomp$11 in props)
            if (hasOwnProperty.call(props, propKey$jscomp$11)) {
              var propValue$jscomp$11 = props[propKey$jscomp$11];
              if (null != propValue$jscomp$11) {
                var attributeName = propKey$jscomp$11;
                switch (propKey$jscomp$11) {
                  case "children":
                    children$jscomp$9 = propValue$jscomp$11;
                    break;
                  case "dangerouslySetInnerHTML":
                    innerHTML$jscomp$8 = propValue$jscomp$11;
                    break;
                  case "style":
                    pushStyleAttribute(target$jscomp$0, propValue$jscomp$11);
                    break;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "ref":
                    break;
                  case "className":
                    attributeName = "class";
                  default:
                    if (isAttributeNameSafe(propKey$jscomp$11) && "function" !== typeof propValue$jscomp$11 && "symbol" !== typeof propValue$jscomp$11 && false !== propValue$jscomp$11) {
                      if (true === propValue$jscomp$11) propValue$jscomp$11 = "";
                      else if ("object" === typeof propValue$jscomp$11) continue;
                      target$jscomp$0.push(
                        " ",
                        attributeName,
                        '="',
                        escapeTextForBrowser(propValue$jscomp$11),
                        '"'
                      );
                    }
                }
              }
            }
          target$jscomp$0.push(">");
          pushInnerHTML(target$jscomp$0, innerHTML$jscomp$8, children$jscomp$9);
          return children$jscomp$9;
        }
    }
    return pushStartGenericElement(target$jscomp$0, props, type);
  }
  var endTagCache = /* @__PURE__ */ new Map();
  function endChunkForTag(tag) {
    var chunk = endTagCache.get(tag);
    void 0 === chunk && (chunk = "</" + tag + ">", endTagCache.set(tag, chunk));
    return chunk;
  }
  function hoistPreambleState(renderState, preambleState) {
    renderState = renderState.preamble;
    null === renderState.htmlChunks && preambleState.htmlChunks && (renderState.htmlChunks = preambleState.htmlChunks, preambleState.contribution |= 1);
    null === renderState.headChunks && preambleState.headChunks && (renderState.headChunks = preambleState.headChunks, preambleState.contribution |= 4);
    null === renderState.bodyChunks && preambleState.bodyChunks && (renderState.bodyChunks = preambleState.bodyChunks, preambleState.contribution |= 2);
  }
  function writeBootstrap(destination, renderState) {
    renderState = renderState.bootstrapChunks;
    for (var i = 0; i < renderState.length - 1; i++)
      destination.push(renderState[i]);
    return i < renderState.length ? (i = renderState[i], renderState.length = 0, destination.push(i)) : true;
  }
  function writeStartPendingSuspenseBoundary(destination, renderState, id) {
    destination.push('<!--$?--><template id="');
    if (null === id) throw Error(formatProdErrorMessage(395));
    destination.push(renderState.boundaryPrefix);
    renderState = id.toString(16);
    destination.push(renderState);
    return destination.push('"></template>');
  }
  function writePreambleContribution(destination, preambleState) {
    preambleState = preambleState.contribution;
    0 !== preambleState && (destination.push("<!--"), destination.push("" + preambleState), destination.push("-->"));
  }
  function writeStartSegment(destination, renderState, formatContext, id) {
    switch (formatContext.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return destination.push('<div hidden id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
      case 4:
        return destination.push('<svg aria-hidden="true" style="display:none" id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
      case 5:
        return destination.push('<math aria-hidden="true" style="display:none" id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
      case 6:
        return destination.push('<table hidden id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
      case 7:
        return destination.push('<table hidden><tbody id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
      case 8:
        return destination.push('<table hidden><tr id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
      case 9:
        return destination.push('<table hidden><colgroup id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
      default:
        throw Error(formatProdErrorMessage(397));
    }
  }
  function writeEndSegment(destination, formatContext) {
    switch (formatContext.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return destination.push("</div>");
      case 4:
        return destination.push("</svg>");
      case 5:
        return destination.push("</math>");
      case 6:
        return destination.push("</table>");
      case 7:
        return destination.push("</tbody></table>");
      case 8:
        return destination.push("</tr></table>");
      case 9:
        return destination.push("</colgroup></table>");
      default:
        throw Error(formatProdErrorMessage(397));
    }
  }
  var regexForJSStringsInInstructionScripts = /[<\u2028\u2029]/g;
  function escapeJSStringsForInstructionScripts(input) {
    return JSON.stringify(input).replace(
      regexForJSStringsInInstructionScripts,
      function(match) {
        switch (match) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var regexForJSStringsInScripts = /[&><\u2028\u2029]/g;
  function escapeJSObjectForInstructionScripts(input) {
    return JSON.stringify(input).replace(
      regexForJSStringsInScripts,
      function(match) {
        switch (match) {
          case "&":
            return "\\u0026";
          case ">":
            return "\\u003e";
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var currentlyRenderingBoundaryHasStylesToHoist = false, destinationHasCapacity = true;
  function flushStyleTagsLateForBoundary(styleQueue) {
    var rules = styleQueue.rules, hrefs = styleQueue.hrefs, i = 0;
    if (hrefs.length) {
      this.push('<style media="not all" data-precedence="');
      this.push(styleQueue.precedence);
      for (this.push('" data-href="'); i < hrefs.length - 1; i++)
        this.push(hrefs[i]), this.push(" ");
      this.push(hrefs[i]);
      this.push('">');
      for (i = 0; i < rules.length; i++) this.push(rules[i]);
      destinationHasCapacity = this.push("</style>");
      currentlyRenderingBoundaryHasStylesToHoist = true;
      rules.length = 0;
      hrefs.length = 0;
    }
  }
  function hasStylesToHoist(stylesheet) {
    return 2 !== stylesheet.state ? currentlyRenderingBoundaryHasStylesToHoist = true : false;
  }
  function writeHoistablesForBoundary(destination, hoistableState, renderState) {
    currentlyRenderingBoundaryHasStylesToHoist = false;
    destinationHasCapacity = true;
    hoistableState.styles.forEach(flushStyleTagsLateForBoundary, destination);
    hoistableState.stylesheets.forEach(hasStylesToHoist);
    currentlyRenderingBoundaryHasStylesToHoist && (renderState.stylesToHoist = true);
    return destinationHasCapacity;
  }
  function flushResource(resource) {
    for (var i = 0; i < resource.length; i++) this.push(resource[i]);
    resource.length = 0;
  }
  var stylesheetFlushingQueue = [];
  function flushStyleInPreamble(stylesheet) {
    pushLinkImpl(stylesheetFlushingQueue, stylesheet.props);
    for (var i = 0; i < stylesheetFlushingQueue.length; i++)
      this.push(stylesheetFlushingQueue[i]);
    stylesheetFlushingQueue.length = 0;
    stylesheet.state = 2;
  }
  function flushStylesInPreamble(styleQueue) {
    var hasStylesheets = 0 < styleQueue.sheets.size;
    styleQueue.sheets.forEach(flushStyleInPreamble, this);
    styleQueue.sheets.clear();
    var rules = styleQueue.rules, hrefs = styleQueue.hrefs;
    if (!hasStylesheets || hrefs.length) {
      this.push('<style data-precedence="');
      this.push(styleQueue.precedence);
      styleQueue = 0;
      if (hrefs.length) {
        for (this.push('" data-href="'); styleQueue < hrefs.length - 1; styleQueue++)
          this.push(hrefs[styleQueue]), this.push(" ");
        this.push(hrefs[styleQueue]);
      }
      this.push('">');
      for (styleQueue = 0; styleQueue < rules.length; styleQueue++)
        this.push(rules[styleQueue]);
      this.push("</style>");
      rules.length = 0;
      hrefs.length = 0;
    }
  }
  function preloadLateStyle(stylesheet) {
    if (0 === stylesheet.state) {
      stylesheet.state = 1;
      var props = stylesheet.props;
      pushLinkImpl(stylesheetFlushingQueue, {
        rel: "preload",
        as: "style",
        href: stylesheet.props.href,
        crossOrigin: props.crossOrigin,
        fetchPriority: props.fetchPriority,
        integrity: props.integrity,
        media: props.media,
        hrefLang: props.hrefLang,
        referrerPolicy: props.referrerPolicy
      });
      for (stylesheet = 0; stylesheet < stylesheetFlushingQueue.length; stylesheet++)
        this.push(stylesheetFlushingQueue[stylesheet]);
      stylesheetFlushingQueue.length = 0;
    }
  }
  function preloadLateStyles(styleQueue) {
    styleQueue.sheets.forEach(preloadLateStyle, this);
    styleQueue.sheets.clear();
  }
  function writeStyleResourceDependenciesInJS(destination, hoistableState) {
    destination.push("[");
    var nextArrayOpenBrackChunk = "[";
    hoistableState.stylesheets.forEach(function(resource) {
      if (2 !== resource.state)
        if (3 === resource.state)
          destination.push(nextArrayOpenBrackChunk), resource = escapeJSObjectForInstructionScripts(
            "" + resource.props.href
          ), destination.push(resource), destination.push("]"), nextArrayOpenBrackChunk = ",[";
        else {
          destination.push(nextArrayOpenBrackChunk);
          var precedence = resource.props["data-precedence"], props = resource.props, coercedHref = sanitizeURL("" + resource.props.href);
          coercedHref = escapeJSObjectForInstructionScripts(coercedHref);
          destination.push(coercedHref);
          precedence = "" + precedence;
          destination.push(",");
          precedence = escapeJSObjectForInstructionScripts(precedence);
          destination.push(precedence);
          for (var propKey in props)
            if (hasOwnProperty.call(props, propKey) && (precedence = props[propKey], null != precedence))
              switch (propKey) {
                case "href":
                case "rel":
                case "precedence":
                case "data-precedence":
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(formatProdErrorMessage(399, "link"));
                default:
                  writeStyleResourceAttributeInJS(
                    destination,
                    propKey,
                    precedence
                  );
              }
          destination.push("]");
          nextArrayOpenBrackChunk = ",[";
          resource.state = 3;
        }
    });
    destination.push("]");
  }
  function writeStyleResourceAttributeInJS(destination, name, value) {
    var attributeName = name.toLowerCase();
    switch (typeof value) {
      case "function":
      case "symbol":
        return;
    }
    switch (name) {
      case "innerHTML":
      case "dangerouslySetInnerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "style":
      case "ref":
        return;
      case "className":
        attributeName = "class";
        name = "" + value;
        break;
      case "hidden":
        if (false === value) return;
        name = "";
        break;
      case "src":
      case "href":
        value = sanitizeURL(value);
        name = "" + value;
        break;
      default:
        if (2 < name.length && ("o" === name[0] || "O" === name[0]) && ("n" === name[1] || "N" === name[1]) || !isAttributeNameSafe(name))
          return;
        name = "" + value;
    }
    destination.push(",");
    attributeName = escapeJSObjectForInstructionScripts(attributeName);
    destination.push(attributeName);
    destination.push(",");
    attributeName = escapeJSObjectForInstructionScripts(name);
    destination.push(attributeName);
  }
  function createHoistableState() {
    return { styles: /* @__PURE__ */ new Set(), stylesheets: /* @__PURE__ */ new Set() };
  }
  function prefetchDNS(href) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if ("string" === typeof href && href) {
        if (!resumableState.dnsResources.hasOwnProperty(href)) {
          resumableState.dnsResources[href] = null;
          resumableState = renderState.headers;
          var header, JSCompiler_temp;
          if (JSCompiler_temp = resumableState && 0 < resumableState.remainingCapacity)
            JSCompiler_temp = (header = "<" + ("" + href).replace(
              regexForHrefInLinkHeaderURLContext,
              escapeHrefForLinkHeaderURLContextReplacer
            ) + ">; rel=dns-prefetch", 0 <= (resumableState.remainingCapacity -= header.length + 2));
          JSCompiler_temp ? (renderState.resets.dns[href] = null, resumableState.preconnects && (resumableState.preconnects += ", "), resumableState.preconnects += header) : (header = [], pushLinkImpl(header, { href, rel: "dns-prefetch" }), renderState.preconnects.add(header));
        }
        enqueueFlush(request);
      }
    } else previousDispatcher.D(href);
  }
  function preconnect(href, crossOrigin) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if ("string" === typeof href && href) {
        var bucket = "use-credentials" === crossOrigin ? "credentials" : "string" === typeof crossOrigin ? "anonymous" : "default";
        if (!resumableState.connectResources[bucket].hasOwnProperty(href)) {
          resumableState.connectResources[bucket][href] = null;
          resumableState = renderState.headers;
          var header, JSCompiler_temp;
          if (JSCompiler_temp = resumableState && 0 < resumableState.remainingCapacity) {
            JSCompiler_temp = "<" + ("" + href).replace(
              regexForHrefInLinkHeaderURLContext,
              escapeHrefForLinkHeaderURLContextReplacer
            ) + ">; rel=preconnect";
            if ("string" === typeof crossOrigin) {
              var escapedCrossOrigin = ("" + crossOrigin).replace(
                regexForLinkHeaderQuotedParamValueContext,
                escapeStringForLinkHeaderQuotedParamValueContextReplacer
              );
              JSCompiler_temp += '; crossorigin="' + escapedCrossOrigin + '"';
            }
            JSCompiler_temp = (header = JSCompiler_temp, 0 <= (resumableState.remainingCapacity -= header.length + 2));
          }
          JSCompiler_temp ? (renderState.resets.connect[bucket][href] = null, resumableState.preconnects && (resumableState.preconnects += ", "), resumableState.preconnects += header) : (bucket = [], pushLinkImpl(bucket, {
            rel: "preconnect",
            href,
            crossOrigin
          }), renderState.preconnects.add(bucket));
        }
        enqueueFlush(request);
      }
    } else previousDispatcher.C(href, crossOrigin);
  }
  function preload(href, as, options) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if (as && href) {
        switch (as) {
          case "image":
            if (options) {
              var imageSrcSet = options.imageSrcSet;
              var imageSizes = options.imageSizes;
              var fetchPriority = options.fetchPriority;
            }
            var key = imageSrcSet ? imageSrcSet + "\n" + (imageSizes || "") : href;
            if (resumableState.imageResources.hasOwnProperty(key)) return;
            resumableState.imageResources[key] = PRELOAD_NO_CREDS;
            resumableState = renderState.headers;
            var header;
            resumableState && 0 < resumableState.remainingCapacity && "string" !== typeof imageSrcSet && "high" === fetchPriority && (header = getPreloadAsHeader(href, as, options), 0 <= (resumableState.remainingCapacity -= header.length + 2)) ? (renderState.resets.image[key] = PRELOAD_NO_CREDS, resumableState.highImagePreloads && (resumableState.highImagePreloads += ", "), resumableState.highImagePreloads += header) : (resumableState = [], pushLinkImpl(
              resumableState,
              assign(
                { rel: "preload", href: imageSrcSet ? void 0 : href, as },
                options
              )
            ), "high" === fetchPriority ? renderState.highImagePreloads.add(resumableState) : (renderState.bulkPreloads.add(resumableState), renderState.preloads.images.set(key, resumableState)));
            break;
          case "style":
            if (resumableState.styleResources.hasOwnProperty(href)) return;
            imageSrcSet = [];
            pushLinkImpl(
              imageSrcSet,
              assign({ rel: "preload", href, as }, options)
            );
            resumableState.styleResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? PRELOAD_NO_CREDS : [options.crossOrigin, options.integrity];
            renderState.preloads.stylesheets.set(href, imageSrcSet);
            renderState.bulkPreloads.add(imageSrcSet);
            break;
          case "script":
            if (resumableState.scriptResources.hasOwnProperty(href)) return;
            imageSrcSet = [];
            renderState.preloads.scripts.set(href, imageSrcSet);
            renderState.bulkPreloads.add(imageSrcSet);
            pushLinkImpl(
              imageSrcSet,
              assign({ rel: "preload", href, as }, options)
            );
            resumableState.scriptResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? PRELOAD_NO_CREDS : [options.crossOrigin, options.integrity];
            break;
          default:
            if (resumableState.unknownResources.hasOwnProperty(as)) {
              if (imageSrcSet = resumableState.unknownResources[as], imageSrcSet.hasOwnProperty(href))
                return;
            } else
              imageSrcSet = {}, resumableState.unknownResources[as] = imageSrcSet;
            imageSrcSet[href] = PRELOAD_NO_CREDS;
            if ((resumableState = renderState.headers) && 0 < resumableState.remainingCapacity && "font" === as && (key = getPreloadAsHeader(href, as, options), 0 <= (resumableState.remainingCapacity -= key.length + 2)))
              renderState.resets.font[href] = PRELOAD_NO_CREDS, resumableState.fontPreloads && (resumableState.fontPreloads += ", "), resumableState.fontPreloads += key;
            else
              switch (resumableState = [], href = assign({ rel: "preload", href, as }, options), pushLinkImpl(resumableState, href), as) {
                case "font":
                  renderState.fontPreloads.add(resumableState);
                  break;
                default:
                  renderState.bulkPreloads.add(resumableState);
              }
        }
        enqueueFlush(request);
      }
    } else previousDispatcher.L(href, as, options);
  }
  function preloadModule(href, options) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if (href) {
        var as = options && "string" === typeof options.as ? options.as : "script";
        switch (as) {
          case "script":
            if (resumableState.moduleScriptResources.hasOwnProperty(href)) return;
            as = [];
            resumableState.moduleScriptResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? PRELOAD_NO_CREDS : [options.crossOrigin, options.integrity];
            renderState.preloads.moduleScripts.set(href, as);
            break;
          default:
            if (resumableState.moduleUnknownResources.hasOwnProperty(as)) {
              var resources = resumableState.unknownResources[as];
              if (resources.hasOwnProperty(href)) return;
            } else
              resources = {}, resumableState.moduleUnknownResources[as] = resources;
            as = [];
            resources[href] = PRELOAD_NO_CREDS;
        }
        pushLinkImpl(as, assign({ rel: "modulepreload", href }, options));
        renderState.bulkPreloads.add(as);
        enqueueFlush(request);
      }
    } else previousDispatcher.m(href, options);
  }
  function preinitStyle(href, precedence, options) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if (href) {
        precedence = precedence || "default";
        var styleQueue = renderState.styles.get(precedence), resourceState = resumableState.styleResources.hasOwnProperty(href) ? resumableState.styleResources[href] : void 0;
        null !== resourceState && (resumableState.styleResources[href] = null, styleQueue || (styleQueue = {
          precedence: escapeTextForBrowser(precedence),
          rules: [],
          hrefs: [],
          sheets: /* @__PURE__ */ new Map()
        }, renderState.styles.set(precedence, styleQueue)), precedence = {
          state: 0,
          props: assign(
            { rel: "stylesheet", href, "data-precedence": precedence },
            options
          )
        }, resourceState && (2 === resourceState.length && adoptPreloadCredentials(precedence.props, resourceState), (renderState = renderState.preloads.stylesheets.get(href)) && 0 < renderState.length ? renderState.length = 0 : precedence.state = 1), styleQueue.sheets.set(href, precedence), enqueueFlush(request));
      }
    } else previousDispatcher.S(href, precedence, options);
  }
  function preinitScript(src, options) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if (src) {
        var resourceState = resumableState.scriptResources.hasOwnProperty(src) ? resumableState.scriptResources[src] : void 0;
        null !== resourceState && (resumableState.scriptResources[src] = null, options = assign({ src, async: true }, options), resourceState && (2 === resourceState.length && adoptPreloadCredentials(options, resourceState), src = renderState.preloads.scripts.get(src)) && (src.length = 0), src = [], renderState.scripts.add(src), pushScriptImpl(src, options), enqueueFlush(request));
      }
    } else previousDispatcher.X(src, options);
  }
  function preinitModuleScript(src, options) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if (src) {
        var resourceState = resumableState.moduleScriptResources.hasOwnProperty(
          src
        ) ? resumableState.moduleScriptResources[src] : void 0;
        null !== resourceState && (resumableState.moduleScriptResources[src] = null, options = assign({ src, type: "module", async: true }, options), resourceState && (2 === resourceState.length && adoptPreloadCredentials(options, resourceState), src = renderState.preloads.moduleScripts.get(src)) && (src.length = 0), src = [], renderState.scripts.add(src), pushScriptImpl(src, options), enqueueFlush(request));
      }
    } else previousDispatcher.M(src, options);
  }
  function adoptPreloadCredentials(target, preloadState) {
    null == target.crossOrigin && (target.crossOrigin = preloadState[0]);
    null == target.integrity && (target.integrity = preloadState[1]);
  }
  function getPreloadAsHeader(href, as, params) {
    href = ("" + href).replace(
      regexForHrefInLinkHeaderURLContext,
      escapeHrefForLinkHeaderURLContextReplacer
    );
    as = ("" + as).replace(
      regexForLinkHeaderQuotedParamValueContext,
      escapeStringForLinkHeaderQuotedParamValueContextReplacer
    );
    as = "<" + href + '>; rel=preload; as="' + as + '"';
    for (var paramName in params)
      hasOwnProperty.call(params, paramName) && (href = params[paramName], "string" === typeof href && (as += "; " + paramName.toLowerCase() + '="' + ("" + href).replace(
        regexForLinkHeaderQuotedParamValueContext,
        escapeStringForLinkHeaderQuotedParamValueContextReplacer
      ) + '"'));
    return as;
  }
  var regexForHrefInLinkHeaderURLContext = /[<>\r\n]/g;
  function escapeHrefForLinkHeaderURLContextReplacer(match) {
    switch (match) {
      case "<":
        return "%3C";
      case ">":
        return "%3E";
      case "\n":
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  var regexForLinkHeaderQuotedParamValueContext = /["';,\r\n]/g;
  function escapeStringForLinkHeaderQuotedParamValueContextReplacer(match) {
    switch (match) {
      case '"':
        return "%22";
      case "'":
        return "%27";
      case ";":
        return "%3B";
      case ",":
        return "%2C";
      case "\n":
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  function hoistStyleQueueDependency(styleQueue) {
    this.styles.add(styleQueue);
  }
  function hoistStylesheetDependency(stylesheet) {
    this.stylesheets.add(stylesheet);
  }
  function createRenderState(resumableState, generateStaticMarkup) {
    var idPrefix = resumableState.idPrefix, bootstrapChunks = [], bootstrapScriptContent = resumableState.bootstrapScriptContent, bootstrapScripts = resumableState.bootstrapScripts, bootstrapModules = resumableState.bootstrapModules;
    void 0 !== bootstrapScriptContent && bootstrapChunks.push(
      "<script>",
      ("" + bootstrapScriptContent).replace(scriptRegex, scriptReplacer),
      "<\/script>"
    );
    bootstrapScriptContent = idPrefix + "P:";
    var JSCompiler_object_inline_segmentPrefix_1542 = idPrefix + "S:";
    idPrefix += "B:";
    var JSCompiler_object_inline_preamble_1545 = createPreambleState(), JSCompiler_object_inline_preconnects_1555 = /* @__PURE__ */ new Set(), JSCompiler_object_inline_fontPreloads_1556 = /* @__PURE__ */ new Set(), JSCompiler_object_inline_highImagePreloads_1557 = /* @__PURE__ */ new Set(), JSCompiler_object_inline_styles_1558 = /* @__PURE__ */ new Map(), JSCompiler_object_inline_bootstrapScripts_1559 = /* @__PURE__ */ new Set(), JSCompiler_object_inline_scripts_1560 = /* @__PURE__ */ new Set(), JSCompiler_object_inline_bulkPreloads_1561 = /* @__PURE__ */ new Set(), JSCompiler_object_inline_preloads_1562 = {
      images: /* @__PURE__ */ new Map(),
      stylesheets: /* @__PURE__ */ new Map(),
      scripts: /* @__PURE__ */ new Map(),
      moduleScripts: /* @__PURE__ */ new Map()
    };
    if (void 0 !== bootstrapScripts)
      for (var i = 0; i < bootstrapScripts.length; i++) {
        var scriptConfig = bootstrapScripts[i], src, crossOrigin = void 0, integrity = void 0, props = {
          rel: "preload",
          as: "script",
          fetchPriority: "low",
          nonce: void 0
        };
        "string" === typeof scriptConfig ? props.href = src = scriptConfig : (props.href = src = scriptConfig.src, props.integrity = integrity = "string" === typeof scriptConfig.integrity ? scriptConfig.integrity : void 0, props.crossOrigin = crossOrigin = "string" === typeof scriptConfig || null == scriptConfig.crossOrigin ? void 0 : "use-credentials" === scriptConfig.crossOrigin ? "use-credentials" : "");
        scriptConfig = resumableState;
        var href = src;
        scriptConfig.scriptResources[href] = null;
        scriptConfig.moduleScriptResources[href] = null;
        scriptConfig = [];
        pushLinkImpl(scriptConfig, props);
        JSCompiler_object_inline_bootstrapScripts_1559.add(scriptConfig);
        bootstrapChunks.push('<script src="', escapeTextForBrowser(src));
        "string" === typeof integrity && bootstrapChunks.push('" integrity="', escapeTextForBrowser(integrity));
        "string" === typeof crossOrigin && bootstrapChunks.push(
          '" crossorigin="',
          escapeTextForBrowser(crossOrigin)
        );
        bootstrapChunks.push('" async=""><\/script>');
      }
    if (void 0 !== bootstrapModules)
      for (bootstrapScripts = 0; bootstrapScripts < bootstrapModules.length; bootstrapScripts++)
        props = bootstrapModules[bootstrapScripts], crossOrigin = src = void 0, integrity = {
          rel: "modulepreload",
          fetchPriority: "low",
          nonce: void 0
        }, "string" === typeof props ? integrity.href = i = props : (integrity.href = i = props.src, integrity.integrity = crossOrigin = "string" === typeof props.integrity ? props.integrity : void 0, integrity.crossOrigin = src = "string" === typeof props || null == props.crossOrigin ? void 0 : "use-credentials" === props.crossOrigin ? "use-credentials" : ""), props = resumableState, scriptConfig = i, props.scriptResources[scriptConfig] = null, props.moduleScriptResources[scriptConfig] = null, props = [], pushLinkImpl(props, integrity), JSCompiler_object_inline_bootstrapScripts_1559.add(props), bootstrapChunks.push(
          '<script type="module" src="',
          escapeTextForBrowser(i)
        ), "string" === typeof crossOrigin && bootstrapChunks.push(
          '" integrity="',
          escapeTextForBrowser(crossOrigin)
        ), "string" === typeof src && bootstrapChunks.push('" crossorigin="', escapeTextForBrowser(src)), bootstrapChunks.push('" async=""><\/script>');
    return {
      placeholderPrefix: bootstrapScriptContent,
      segmentPrefix: JSCompiler_object_inline_segmentPrefix_1542,
      boundaryPrefix: idPrefix,
      startInlineScript: "<script>",
      preamble: JSCompiler_object_inline_preamble_1545,
      externalRuntimeScript: null,
      bootstrapChunks,
      importMapChunks: [],
      onHeaders: void 0,
      headers: null,
      resets: {
        font: {},
        dns: {},
        connect: { default: {}, anonymous: {}, credentials: {} },
        image: {},
        style: {}
      },
      charsetChunks: [],
      viewportChunks: [],
      hoistableChunks: [],
      preconnects: JSCompiler_object_inline_preconnects_1555,
      fontPreloads: JSCompiler_object_inline_fontPreloads_1556,
      highImagePreloads: JSCompiler_object_inline_highImagePreloads_1557,
      styles: JSCompiler_object_inline_styles_1558,
      bootstrapScripts: JSCompiler_object_inline_bootstrapScripts_1559,
      scripts: JSCompiler_object_inline_scripts_1560,
      bulkPreloads: JSCompiler_object_inline_bulkPreloads_1561,
      preloads: JSCompiler_object_inline_preloads_1562,
      stylesToHoist: false,
      generateStaticMarkup
    };
  }
  function pushTextInstance(target, text, renderState, textEmbedded) {
    if (renderState.generateStaticMarkup)
      return target.push(escapeTextForBrowser(text)), false;
    "" === text ? target = textEmbedded : (textEmbedded && target.push("<!-- -->"), target.push(escapeTextForBrowser(text)), target = true);
    return target;
  }
  function pushSegmentFinale(target, renderState, lastPushedText, textEmbedded) {
    renderState.generateStaticMarkup || lastPushedText && textEmbedded && target.push("<!-- -->");
  }
  var bind = Function.prototype.bind, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
  function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type)
      return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch (type) {
      case REACT_FRAGMENT_TYPE:
        return "Fragment";
      case REACT_PROFILER_TYPE:
        return "Profiler";
      case REACT_STRICT_MODE_TYPE:
        return "StrictMode";
      case REACT_SUSPENSE_TYPE:
        return "Suspense";
      case REACT_SUSPENSE_LIST_TYPE:
        return "SuspenseList";
      case REACT_ACTIVITY_TYPE:
        return "Activity";
    }
    if ("object" === typeof type)
      switch (type.$$typeof) {
        case REACT_PORTAL_TYPE:
          return "Portal";
        case REACT_CONTEXT_TYPE:
          return (type.displayName || "Context") + ".Provider";
        case REACT_CONSUMER_TYPE:
          return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
          var innerType = type.render;
          type = type.displayName;
          type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
          return type;
        case REACT_MEMO_TYPE:
          return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
          innerType = type._payload;
          type = type._init;
          try {
            return getComponentNameFromType(type(innerType));
          } catch (x) {
          }
      }
    return null;
  }
  var emptyContextObject = {}, currentActiveSnapshot = null;
  function popToNearestCommonAncestor(prev, next) {
    if (prev !== next) {
      prev.context._currentValue2 = prev.parentValue;
      prev = prev.parent;
      var parentNext = next.parent;
      if (null === prev) {
        if (null !== parentNext) throw Error(formatProdErrorMessage(401));
      } else {
        if (null === parentNext) throw Error(formatProdErrorMessage(401));
        popToNearestCommonAncestor(prev, parentNext);
      }
      next.context._currentValue2 = next.value;
    }
  }
  function popAllPrevious(prev) {
    prev.context._currentValue2 = prev.parentValue;
    prev = prev.parent;
    null !== prev && popAllPrevious(prev);
  }
  function pushAllNext(next) {
    var parentNext = next.parent;
    null !== parentNext && pushAllNext(parentNext);
    next.context._currentValue2 = next.value;
  }
  function popPreviousToCommonLevel(prev, next) {
    prev.context._currentValue2 = prev.parentValue;
    prev = prev.parent;
    if (null === prev) throw Error(formatProdErrorMessage(402));
    prev.depth === next.depth ? popToNearestCommonAncestor(prev, next) : popPreviousToCommonLevel(prev, next);
  }
  function popNextToCommonLevel(prev, next) {
    var parentNext = next.parent;
    if (null === parentNext) throw Error(formatProdErrorMessage(402));
    prev.depth === parentNext.depth ? popToNearestCommonAncestor(prev, parentNext) : popNextToCommonLevel(prev, parentNext);
    next.context._currentValue2 = next.value;
  }
  function switchContext(newSnapshot) {
    var prev = currentActiveSnapshot;
    prev !== newSnapshot && (null === prev ? pushAllNext(newSnapshot) : null === newSnapshot ? popAllPrevious(prev) : prev.depth === newSnapshot.depth ? popToNearestCommonAncestor(prev, newSnapshot) : prev.depth > newSnapshot.depth ? popPreviousToCommonLevel(prev, newSnapshot) : popNextToCommonLevel(prev, newSnapshot), currentActiveSnapshot = newSnapshot);
  }
  var classComponentUpdater = {
    enqueueSetState: function(inst, payload) {
      inst = inst._reactInternals;
      null !== inst.queue && inst.queue.push(payload);
    },
    enqueueReplaceState: function(inst, payload) {
      inst = inst._reactInternals;
      inst.replace = true;
      inst.queue = [payload];
    },
    enqueueForceUpdate: function() {
    }
  }, emptyTreeContext = { id: 1, overflow: "" };
  function pushTreeContext(baseContext, totalChildren, index) {
    var baseIdWithLeadingBit = baseContext.id;
    baseContext = baseContext.overflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
      var numberOfOverflowBits = baseLength - baseLength % 5;
      length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
      baseIdWithLeadingBit >>= numberOfOverflowBits;
      baseLength -= numberOfOverflowBits;
      return {
        id: 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit,
        overflow: length + baseContext
      };
    }
    return {
      id: 1 << length | index << baseLength | baseIdWithLeadingBit,
      overflow: baseContext
    };
  }
  var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
  function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
  }
  var SuspenseException = Error(formatProdErrorMessage(460));
  function noop$2() {
  }
  function trackUsedThenable(thenableState2, thenable, index) {
    index = thenableState2[index];
    void 0 === index ? thenableState2.push(thenable) : index !== thenable && (thenable.then(noop$2, noop$2), thenable = index);
    switch (thenable.status) {
      case "fulfilled":
        return thenable.value;
      case "rejected":
        throw thenable.reason;
      default:
        "string" === typeof thenable.status ? thenable.then(noop$2, noop$2) : (thenableState2 = thenable, thenableState2.status = "pending", thenableState2.then(
          function(fulfilledValue) {
            if ("pending" === thenable.status) {
              var fulfilledThenable = thenable;
              fulfilledThenable.status = "fulfilled";
              fulfilledThenable.value = fulfilledValue;
            }
          },
          function(error) {
            if ("pending" === thenable.status) {
              var rejectedThenable = thenable;
              rejectedThenable.status = "rejected";
              rejectedThenable.reason = error;
            }
          }
        ));
        switch (thenable.status) {
          case "fulfilled":
            return thenable.value;
          case "rejected":
            throw thenable.reason;
        }
        suspendedThenable = thenable;
        throw SuspenseException;
    }
  }
  var suspendedThenable = null;
  function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
  }
  function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is, currentlyRenderingComponent = null, currentlyRenderingTask = null, currentlyRenderingRequest = null, currentlyRenderingKeyPath = null, firstWorkInProgressHook = null, workInProgressHook = null, isReRender = false, didScheduleRenderPhaseUpdate = false, localIdCounter = 0, actionStateCounter = 0, actionStateMatchingIndex = -1, thenableIndexCounter = 0, thenableState = null, renderPhaseUpdates = null, numberOfReRenders = 0;
  function resolveCurrentlyRenderingComponent() {
    if (null === currentlyRenderingComponent)
      throw Error(formatProdErrorMessage(321));
    return currentlyRenderingComponent;
  }
  function createHook() {
    if (0 < numberOfReRenders) throw Error(formatProdErrorMessage(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function createWorkInProgressHook() {
    null === workInProgressHook ? null === firstWorkInProgressHook ? (isReRender = false, firstWorkInProgressHook = workInProgressHook = createHook()) : (isReRender = true, workInProgressHook = firstWorkInProgressHook) : null === workInProgressHook.next ? (isReRender = false, workInProgressHook = workInProgressHook.next = createHook()) : (isReRender = true, workInProgressHook = workInProgressHook.next);
    return workInProgressHook;
  }
  function getThenableStateAfterSuspending() {
    var state = thenableState;
    thenableState = null;
    return state;
  }
  function resetHooksState() {
    currentlyRenderingKeyPath = currentlyRenderingRequest = currentlyRenderingTask = currentlyRenderingComponent = null;
    didScheduleRenderPhaseUpdate = false;
    firstWorkInProgressHook = null;
    numberOfReRenders = 0;
    workInProgressHook = renderPhaseUpdates = null;
  }
  function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
  }
  function useReducer(reducer, initialArg, init) {
    currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
    workInProgressHook = createWorkInProgressHook();
    if (isReRender) {
      var queue = workInProgressHook.queue;
      initialArg = queue.dispatch;
      if (null !== renderPhaseUpdates && (init = renderPhaseUpdates.get(queue), void 0 !== init)) {
        renderPhaseUpdates.delete(queue);
        queue = workInProgressHook.memoizedState;
        do
          queue = reducer(queue, init.action), init = init.next;
        while (null !== init);
        workInProgressHook.memoizedState = queue;
        return [queue, initialArg];
      }
      return [workInProgressHook.memoizedState, initialArg];
    }
    reducer = reducer === basicStateReducer ? "function" === typeof initialArg ? initialArg() : initialArg : void 0 !== init ? init(initialArg) : initialArg;
    workInProgressHook.memoizedState = reducer;
    reducer = workInProgressHook.queue = { last: null, dispatch: null };
    reducer = reducer.dispatch = dispatchAction.bind(
      null,
      currentlyRenderingComponent,
      reducer
    );
    return [workInProgressHook.memoizedState, reducer];
  }
  function useMemo(nextCreate, deps) {
    currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
    workInProgressHook = createWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    if (null !== workInProgressHook) {
      var prevState = workInProgressHook.memoizedState;
      if (null !== prevState && null !== deps) {
        var prevDeps = prevState[1];
        a: if (null === prevDeps) prevDeps = false;
        else {
          for (var i = 0; i < prevDeps.length && i < deps.length; i++)
            if (!objectIs(deps[i], prevDeps[i])) {
              prevDeps = false;
              break a;
            }
          prevDeps = true;
        }
        if (prevDeps) return prevState[0];
      }
    }
    nextCreate = nextCreate();
    workInProgressHook.memoizedState = [nextCreate, deps];
    return nextCreate;
  }
  function dispatchAction(componentIdentity, queue, action) {
    if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
    if (componentIdentity === currentlyRenderingComponent)
      if (didScheduleRenderPhaseUpdate = true, componentIdentity = { action, next: null }, null === renderPhaseUpdates && (renderPhaseUpdates = /* @__PURE__ */ new Map()), action = renderPhaseUpdates.get(queue), void 0 === action)
        renderPhaseUpdates.set(queue, componentIdentity);
      else {
        for (queue = action; null !== queue.next; ) queue = queue.next;
        queue.next = componentIdentity;
      }
  }
  function unsupportedStartTransition() {
    throw Error(formatProdErrorMessage(394));
  }
  function unsupportedSetOptimisticState() {
    throw Error(formatProdErrorMessage(479));
  }
  function useActionState(action, initialState, permalink) {
    resolveCurrentlyRenderingComponent();
    var actionStateHookIndex = actionStateCounter++, request = currentlyRenderingRequest;
    if ("function" === typeof action.$$FORM_ACTION) {
      var nextPostbackStateKey = null, componentKeyPath = currentlyRenderingKeyPath;
      request = request.formState;
      var isSignatureEqual = action.$$IS_SIGNATURE_EQUAL;
      if (null !== request && "function" === typeof isSignatureEqual) {
        var postbackKey = request[1];
        isSignatureEqual.call(action, request[2], request[3]) && (nextPostbackStateKey = void 0 !== permalink ? "p" + permalink : "k" + murmurhash3_32_gc(
          JSON.stringify([componentKeyPath, null, actionStateHookIndex]),
          0
        ), postbackKey === nextPostbackStateKey && (actionStateMatchingIndex = actionStateHookIndex, initialState = request[0]));
      }
      var boundAction = action.bind(null, initialState);
      action = function(payload) {
        boundAction(payload);
      };
      "function" === typeof boundAction.$$FORM_ACTION && (action.$$FORM_ACTION = function(prefix2) {
        prefix2 = boundAction.$$FORM_ACTION(prefix2);
        void 0 !== permalink && (permalink += "", prefix2.action = permalink);
        var formData = prefix2.data;
        formData && (null === nextPostbackStateKey && (nextPostbackStateKey = void 0 !== permalink ? "p" + permalink : "k" + murmurhash3_32_gc(
          JSON.stringify([
            componentKeyPath,
            null,
            actionStateHookIndex
          ]),
          0
        )), formData.append("$ACTION_KEY", nextPostbackStateKey));
        return prefix2;
      });
      return [initialState, action, false];
    }
    var boundAction$22 = action.bind(null, initialState);
    return [
      initialState,
      function(payload) {
        boundAction$22(payload);
      },
      false
    ];
  }
  function unwrapThenable(thenable) {
    var index = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    return trackUsedThenable(thenableState, thenable, index);
  }
  function unsupportedRefresh() {
    throw Error(formatProdErrorMessage(393));
  }
  function noop$1() {
  }
  var HooksDispatcher = {
    readContext: function(context) {
      return context._currentValue2;
    },
    use: function(usable) {
      if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return unwrapThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE)
          return usable._currentValue2;
      }
      throw Error(formatProdErrorMessage(438, String(usable)));
    },
    useContext: function(context) {
      resolveCurrentlyRenderingComponent();
      return context._currentValue2;
    },
    useMemo,
    useReducer,
    useRef: function(initialValue) {
      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
      workInProgressHook = createWorkInProgressHook();
      var previousRef = workInProgressHook.memoizedState;
      return null === previousRef ? (initialValue = { current: initialValue }, workInProgressHook.memoizedState = initialValue) : previousRef;
    },
    useState: function(initialState) {
      return useReducer(basicStateReducer, initialState);
    },
    useInsertionEffect: noop$1,
    useLayoutEffect: noop$1,
    useCallback: function(callback, deps) {
      return useMemo(function() {
        return callback;
      }, deps);
    },
    useImperativeHandle: noop$1,
    useEffect: noop$1,
    useDebugValue: noop$1,
    useDeferredValue: function(value, initialValue) {
      resolveCurrentlyRenderingComponent();
      return void 0 !== initialValue ? initialValue : value;
    },
    useTransition: function() {
      resolveCurrentlyRenderingComponent();
      return [false, unsupportedStartTransition];
    },
    useId: function() {
      var JSCompiler_inline_result = currentlyRenderingTask.treeContext;
      var overflow = JSCompiler_inline_result.overflow;
      JSCompiler_inline_result = JSCompiler_inline_result.id;
      JSCompiler_inline_result = (JSCompiler_inline_result & ~(1 << 32 - clz32(JSCompiler_inline_result) - 1)).toString(32) + overflow;
      var resumableState = currentResumableState;
      if (null === resumableState) throw Error(formatProdErrorMessage(404));
      overflow = localIdCounter++;
      JSCompiler_inline_result = "«" + resumableState.idPrefix + "R" + JSCompiler_inline_result;
      0 < overflow && (JSCompiler_inline_result += "H" + overflow.toString(32));
      return JSCompiler_inline_result + "»";
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
      if (void 0 === getServerSnapshot)
        throw Error(formatProdErrorMessage(407));
      return getServerSnapshot();
    },
    useOptimistic: function(passthrough) {
      resolveCurrentlyRenderingComponent();
      return [passthrough, unsupportedSetOptimisticState];
    },
    useActionState,
    useFormState: useActionState,
    useHostTransitionStatus: function() {
      resolveCurrentlyRenderingComponent();
      return sharedNotPendingObject;
    },
    useMemoCache: function(size) {
      for (var data = Array(size), i = 0; i < size; i++)
        data[i] = REACT_MEMO_CACHE_SENTINEL;
      return data;
    },
    useCacheRefresh: function() {
      return unsupportedRefresh;
    }
  }, currentResumableState = null, DefaultAsyncDispatcher = {
    getCacheForType: function() {
      throw Error(formatProdErrorMessage(248));
    }
  }, prefix, suffix;
  function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix)
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return "\n" + prefix + name + suffix;
  }
  var reentry = false;
  function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = true;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var RunInRootFrame = {
        DetermineComponentFrameRoot: function() {
          try {
            if (construct) {
              var Fake = function() {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function() {
                  throw Error();
                }
              });
              if ("object" === typeof Reflect && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x) {
                  var control = x;
                }
                Reflect.construct(fn, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x$24) {
                  control = x$24;
                }
                fn.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x$25) {
                control = x$25;
              }
              (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {
              });
            }
          } catch (sample) {
            if (sample && control && "string" === typeof sample.stack)
              return [sample.stack, control.stack];
          }
          return [null, null];
        }
      };
      RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var namePropDescriptor = Object.getOwnPropertyDescriptor(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name"
      );
      namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
      if (sampleStack && controlStack) {
        var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
        for (namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot"); )
          RunInRootFrame++;
        for (; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes(
          "DetermineComponentFrameRoot"
        ); )
          namePropDescriptor++;
        if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length)
          for (RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]; )
            namePropDescriptor--;
        for (; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)
          if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
            if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
              do
                if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                  var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                  fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                  return frame;
                }
              while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
            }
            break;
          }
      }
    } finally {
      reentry = false, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
  }
  function describeComponentStackByType(type) {
    if ("string" === typeof type) return describeBuiltInComponentFrame(type);
    if ("function" === typeof type)
      return type.prototype && type.prototype.isReactComponent ? describeNativeComponentFrame(type, true) : describeNativeComponentFrame(type, false);
    if ("object" === typeof type && null !== type) {
      switch (type.$$typeof) {
        case REACT_FORWARD_REF_TYPE:
          return describeNativeComponentFrame(type.render, false);
        case REACT_MEMO_TYPE:
          return describeNativeComponentFrame(type.type, false);
        case REACT_LAZY_TYPE:
          var lazyComponent = type, payload = lazyComponent._payload;
          lazyComponent = lazyComponent._init;
          try {
            type = lazyComponent(payload);
          } catch (x) {
            return describeBuiltInComponentFrame("Lazy");
          }
          return describeComponentStackByType(type);
      }
      if ("string" === typeof type.name)
        return payload = type.env, describeBuiltInComponentFrame(
          type.name + (payload ? " [" + payload + "]" : "")
        );
    }
    switch (type) {
      case REACT_SUSPENSE_LIST_TYPE:
        return describeBuiltInComponentFrame("SuspenseList");
      case REACT_SUSPENSE_TYPE:
        return describeBuiltInComponentFrame("Suspense");
    }
    return "";
  }
  function defaultErrorHandler(error) {
    if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
      var JSCompiler_inline_result = error.environmentName;
      error = [error].slice(0);
      "string" === typeof error[0] ? error.splice(
        0,
        1,
        "[%s] " + error[0],
        " " + JSCompiler_inline_result + " "
      ) : error.splice(0, 0, "[%s] ", " " + JSCompiler_inline_result + " ");
      error.unshift(console);
      JSCompiler_inline_result = bind.apply(console.error, error);
      JSCompiler_inline_result();
    } else console.error(error);
    return null;
  }
  function noop() {
  }
  function RequestInstance(resumableState, renderState, rootFormatContext, progressiveChunkSize, onError2, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState) {
    var abortSet = /* @__PURE__ */ new Set();
    this.destination = null;
    this.flushScheduled = false;
    this.resumableState = resumableState;
    this.renderState = renderState;
    this.rootFormatContext = rootFormatContext;
    this.progressiveChunkSize = void 0 === progressiveChunkSize ? 12800 : progressiveChunkSize;
    this.status = 10;
    this.fatalError = null;
    this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0;
    this.completedPreambleSegments = this.completedRootSegment = null;
    this.abortableTasks = abortSet;
    this.pingedTasks = [];
    this.clientRenderedBoundaries = [];
    this.completedBoundaries = [];
    this.partialBoundaries = [];
    this.trackedPostpones = null;
    this.onError = void 0 === onError2 ? defaultErrorHandler : onError2;
    this.onPostpone = void 0 === onPostpone ? noop : onPostpone;
    this.onAllReady = void 0 === onAllReady ? noop : onAllReady;
    this.onShellReady = void 0 === onShellReady ? noop : onShellReady;
    this.onShellError = void 0 === onShellError ? noop : onShellError;
    this.onFatalError = void 0 === onFatalError ? noop : onFatalError;
    this.formState = void 0 === formState ? null : formState;
  }
  function createRequest(children, resumableState, renderState, rootFormatContext, progressiveChunkSize, onError2, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState) {
    resumableState = new RequestInstance(
      resumableState,
      renderState,
      rootFormatContext,
      progressiveChunkSize,
      onError2,
      onAllReady,
      onShellReady,
      onShellError,
      onFatalError,
      onPostpone,
      formState
    );
    renderState = createPendingSegment(
      resumableState,
      0,
      null,
      rootFormatContext,
      false,
      false
    );
    renderState.parentFlushed = true;
    children = createRenderTask(
      resumableState,
      null,
      children,
      -1,
      null,
      renderState,
      null,
      null,
      resumableState.abortableTasks,
      null,
      rootFormatContext,
      null,
      emptyTreeContext,
      null,
      false
    );
    pushComponentStack(children);
    resumableState.pingedTasks.push(children);
    return resumableState;
  }
  var currentRequest = null;
  function pingTask(request, task) {
    request.pingedTasks.push(task);
    1 === request.pingedTasks.length && (request.flushScheduled = null !== request.destination, performWork(request));
  }
  function createSuspenseBoundary(request, fallbackAbortableTasks, contentPreamble, fallbackPreamble) {
    return {
      status: 0,
      rootSegmentID: -1,
      parentFlushed: false,
      pendingTasks: 0,
      completedSegments: [],
      byteSize: 0,
      fallbackAbortableTasks,
      errorDigest: null,
      contentState: createHoistableState(),
      fallbackState: createHoistableState(),
      contentPreamble,
      fallbackPreamble,
      trackedContentKeyPath: null,
      trackedFallbackNode: null
    };
  }
  function createRenderTask(request, thenableState2, node, childIndex, blockedBoundary, blockedSegment, blockedPreamble, hoistableState, abortSet, keyPath, formatContext, context, treeContext, componentStack, isFallback) {
    request.allPendingTasks++;
    null === blockedBoundary ? request.pendingRootTasks++ : blockedBoundary.pendingTasks++;
    var task = {
      replay: null,
      node,
      childIndex,
      ping: function() {
        return pingTask(request, task);
      },
      blockedBoundary,
      blockedSegment,
      blockedPreamble,
      hoistableState,
      abortSet,
      keyPath,
      formatContext,
      context,
      treeContext,
      componentStack,
      thenableState: thenableState2,
      isFallback
    };
    abortSet.add(task);
    return task;
  }
  function createReplayTask(request, thenableState2, replay, node, childIndex, blockedBoundary, hoistableState, abortSet, keyPath, formatContext, context, treeContext, componentStack, isFallback) {
    request.allPendingTasks++;
    null === blockedBoundary ? request.pendingRootTasks++ : blockedBoundary.pendingTasks++;
    replay.pendingTasks++;
    var task = {
      replay,
      node,
      childIndex,
      ping: function() {
        return pingTask(request, task);
      },
      blockedBoundary,
      blockedSegment: null,
      blockedPreamble: null,
      hoistableState,
      abortSet,
      keyPath,
      formatContext,
      context,
      treeContext,
      componentStack,
      thenableState: thenableState2,
      isFallback
    };
    abortSet.add(task);
    return task;
  }
  function createPendingSegment(request, index, boundary, parentFormatContext, lastPushedText, textEmbedded) {
    return {
      status: 0,
      parentFlushed: false,
      id: -1,
      index,
      chunks: [],
      children: [],
      preambleChildren: [],
      parentFormatContext,
      boundary,
      lastPushedText,
      textEmbedded
    };
  }
  function pushComponentStack(task) {
    var node = task.node;
    if ("object" === typeof node && null !== node)
      switch (node.$$typeof) {
        case REACT_ELEMENT_TYPE:
          task.componentStack = { parent: task.componentStack, type: node.type };
      }
  }
  function getThrownInfo(node$jscomp$0) {
    var errorInfo = {};
    node$jscomp$0 && Object.defineProperty(errorInfo, "componentStack", {
      configurable: true,
      enumerable: true,
      get: function() {
        try {
          var info = "", node = node$jscomp$0;
          do
            info += describeComponentStackByType(node.type), node = node.parent;
          while (node);
          var JSCompiler_inline_result = info;
        } catch (x) {
          JSCompiler_inline_result = "\nError generating stack: " + x.message + "\n" + x.stack;
        }
        Object.defineProperty(errorInfo, "componentStack", {
          value: JSCompiler_inline_result
        });
        return JSCompiler_inline_result;
      }
    });
    return errorInfo;
  }
  function logRecoverableError(request, error, errorInfo) {
    request = request.onError;
    error = request(error, errorInfo);
    if (null == error || "string" === typeof error) return error;
  }
  function fatalError(request, error) {
    var onShellError = request.onShellError, onFatalError = request.onFatalError;
    onShellError(error);
    onFatalError(error);
    null !== request.destination ? (request.status = 14, request.destination.destroy(error)) : (request.status = 13, request.fatalError = error);
  }
  function renderWithHooks(request, task, keyPath, Component, props, secondArg) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    currentlyRenderingComponent = {};
    currentlyRenderingTask = task;
    currentlyRenderingRequest = request;
    currentlyRenderingKeyPath = keyPath;
    actionStateCounter = localIdCounter = 0;
    actionStateMatchingIndex = -1;
    thenableIndexCounter = 0;
    thenableState = prevThenableState;
    for (request = Component(props, secondArg); didScheduleRenderPhaseUpdate; )
      didScheduleRenderPhaseUpdate = false, actionStateCounter = localIdCounter = 0, actionStateMatchingIndex = -1, thenableIndexCounter = 0, numberOfReRenders += 1, workInProgressHook = null, request = Component(props, secondArg);
    resetHooksState();
    return request;
  }
  function finishFunctionComponent(request, task, keyPath, children, hasId, actionStateCount, actionStateMatchingIndex2) {
    var didEmitActionStateMarkers = false;
    if (0 !== actionStateCount && null !== request.formState) {
      var segment = task.blockedSegment;
      if (null !== segment) {
        didEmitActionStateMarkers = true;
        segment = segment.chunks;
        for (var i = 0; i < actionStateCount; i++)
          i === actionStateMatchingIndex2 ? segment.push("<!--F!-->") : segment.push("<!--F-->");
      }
    }
    actionStateCount = task.keyPath;
    task.keyPath = keyPath;
    hasId ? (keyPath = task.treeContext, task.treeContext = pushTreeContext(keyPath, 1, 0), renderNode(request, task, children, -1), task.treeContext = keyPath) : didEmitActionStateMarkers ? renderNode(request, task, children, -1) : renderNodeDestructive(request, task, children, -1);
    task.keyPath = actionStateCount;
  }
  function renderElement(request, task, keyPath, type, props, ref) {
    if ("function" === typeof type)
      if (type.prototype && type.prototype.isReactComponent) {
        var newProps = props;
        if ("ref" in props) {
          newProps = {};
          for (var propName in props)
            "ref" !== propName && (newProps[propName] = props[propName]);
        }
        var defaultProps = type.defaultProps;
        if (defaultProps) {
          newProps === props && (newProps = assign({}, newProps, props));
          for (var propName$33 in defaultProps)
            void 0 === newProps[propName$33] && (newProps[propName$33] = defaultProps[propName$33]);
        }
        props = newProps;
        newProps = emptyContextObject;
        defaultProps = type.contextType;
        "object" === typeof defaultProps && null !== defaultProps && (newProps = defaultProps._currentValue2);
        newProps = new type(props, newProps);
        var initialState = void 0 !== newProps.state ? newProps.state : null;
        newProps.updater = classComponentUpdater;
        newProps.props = props;
        newProps.state = initialState;
        defaultProps = { queue: [], replace: false };
        newProps._reactInternals = defaultProps;
        ref = type.contextType;
        newProps.context = "object" === typeof ref && null !== ref ? ref._currentValue2 : emptyContextObject;
        ref = type.getDerivedStateFromProps;
        "function" === typeof ref && (ref = ref(props, initialState), initialState = null === ref || void 0 === ref ? initialState : assign({}, initialState, ref), newProps.state = initialState);
        if ("function" !== typeof type.getDerivedStateFromProps && "function" !== typeof newProps.getSnapshotBeforeUpdate && ("function" === typeof newProps.UNSAFE_componentWillMount || "function" === typeof newProps.componentWillMount))
          if (type = newProps.state, "function" === typeof newProps.componentWillMount && newProps.componentWillMount(), "function" === typeof newProps.UNSAFE_componentWillMount && newProps.UNSAFE_componentWillMount(), type !== newProps.state && classComponentUpdater.enqueueReplaceState(
            newProps,
            newProps.state,
            null
          ), null !== defaultProps.queue && 0 < defaultProps.queue.length)
            if (type = defaultProps.queue, ref = defaultProps.replace, defaultProps.queue = null, defaultProps.replace = false, ref && 1 === type.length)
              newProps.state = type[0];
            else {
              defaultProps = ref ? type[0] : newProps.state;
              initialState = true;
              for (ref = ref ? 1 : 0; ref < type.length; ref++)
                propName$33 = type[ref], propName$33 = "function" === typeof propName$33 ? propName$33.call(newProps, defaultProps, props, void 0) : propName$33, null != propName$33 && (initialState ? (initialState = false, defaultProps = assign({}, defaultProps, propName$33)) : assign(defaultProps, propName$33));
              newProps.state = defaultProps;
            }
          else defaultProps.queue = null;
        type = newProps.render();
        if (12 === request.status) throw null;
        props = task.keyPath;
        task.keyPath = keyPath;
        renderNodeDestructive(request, task, type, -1);
        task.keyPath = props;
      } else {
        type = renderWithHooks(request, task, keyPath, type, props, void 0);
        if (12 === request.status) throw null;
        finishFunctionComponent(
          request,
          task,
          keyPath,
          type,
          0 !== localIdCounter,
          actionStateCounter,
          actionStateMatchingIndex
        );
      }
    else if ("string" === typeof type)
      if (newProps = task.blockedSegment, null === newProps)
        newProps = props.children, defaultProps = task.formatContext, initialState = task.keyPath, task.formatContext = getChildFormatContext(defaultProps, type, props), task.keyPath = keyPath, renderNode(request, task, newProps, -1), task.formatContext = defaultProps, task.keyPath = initialState;
      else {
        ref = pushStartInstance(
          newProps.chunks,
          type,
          props,
          request.resumableState,
          request.renderState,
          task.blockedPreamble,
          task.hoistableState,
          task.formatContext,
          newProps.lastPushedText,
          task.isFallback
        );
        newProps.lastPushedText = false;
        defaultProps = task.formatContext;
        initialState = task.keyPath;
        task.keyPath = keyPath;
        3 === (task.formatContext = getChildFormatContext(defaultProps, type, props)).insertionMode ? (keyPath = createPendingSegment(
          request,
          0,
          null,
          task.formatContext,
          false,
          false
        ), newProps.preambleChildren.push(keyPath), keyPath = createRenderTask(
          request,
          null,
          ref,
          -1,
          task.blockedBoundary,
          keyPath,
          task.blockedPreamble,
          task.hoistableState,
          request.abortableTasks,
          task.keyPath,
          task.formatContext,
          task.context,
          task.treeContext,
          task.componentStack,
          task.isFallback
        ), pushComponentStack(keyPath), request.pingedTasks.push(keyPath)) : renderNode(request, task, ref, -1);
        task.formatContext = defaultProps;
        task.keyPath = initialState;
        a: {
          task = newProps.chunks;
          request = request.resumableState;
          switch (type) {
            case "title":
            case "style":
            case "script":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
              break a;
            case "body":
              if (1 >= defaultProps.insertionMode) {
                request.hasBody = true;
                break a;
              }
              break;
            case "html":
              if (0 === defaultProps.insertionMode) {
                request.hasHtml = true;
                break a;
              }
              break;
            case "head":
              if (1 >= defaultProps.insertionMode) break a;
          }
          task.push(endChunkForTag(type));
        }
        newProps.lastPushedText = false;
      }
    else {
      switch (type) {
        case REACT_LEGACY_HIDDEN_TYPE:
        case REACT_STRICT_MODE_TYPE:
        case REACT_PROFILER_TYPE:
        case REACT_FRAGMENT_TYPE:
          type = task.keyPath;
          task.keyPath = keyPath;
          renderNodeDestructive(request, task, props.children, -1);
          task.keyPath = type;
          return;
        case REACT_ACTIVITY_TYPE:
          "hidden" !== props.mode && (type = task.keyPath, task.keyPath = keyPath, renderNodeDestructive(request, task, props.children, -1), task.keyPath = type);
          return;
        case REACT_SUSPENSE_LIST_TYPE:
          type = task.keyPath;
          task.keyPath = keyPath;
          renderNodeDestructive(request, task, props.children, -1);
          task.keyPath = type;
          return;
        case REACT_VIEW_TRANSITION_TYPE:
        case REACT_SCOPE_TYPE:
          throw Error(formatProdErrorMessage(343));
        case REACT_SUSPENSE_TYPE:
          a: if (null !== task.replay) {
            type = task.keyPath;
            task.keyPath = keyPath;
            keyPath = props.children;
            try {
              renderNode(request, task, keyPath, -1);
            } finally {
              task.keyPath = type;
            }
          } else {
            type = task.keyPath;
            var parentBoundary = task.blockedBoundary;
            ref = task.blockedPreamble;
            var parentHoistableState = task.hoistableState;
            propName$33 = task.blockedSegment;
            propName = props.fallback;
            props = props.children;
            var fallbackAbortSet = /* @__PURE__ */ new Set();
            var newBoundary = 2 > task.formatContext.insertionMode ? createSuspenseBoundary(
              request,
              fallbackAbortSet,
              createPreambleState(),
              createPreambleState()
            ) : createSuspenseBoundary(request, fallbackAbortSet, null, null);
            null !== request.trackedPostpones && (newBoundary.trackedContentKeyPath = keyPath);
            var boundarySegment = createPendingSegment(
              request,
              propName$33.chunks.length,
              newBoundary,
              task.formatContext,
              false,
              false
            );
            propName$33.children.push(boundarySegment);
            propName$33.lastPushedText = false;
            var contentRootSegment = createPendingSegment(
              request,
              0,
              null,
              task.formatContext,
              false,
              false
            );
            contentRootSegment.parentFlushed = true;
            if (null !== request.trackedPostpones) {
              newProps = [keyPath[0], "Suspense Fallback", keyPath[2]];
              defaultProps = [newProps[1], newProps[2], [], null];
              request.trackedPostpones.workingMap.set(newProps, defaultProps);
              newBoundary.trackedFallbackNode = defaultProps;
              task.blockedSegment = boundarySegment;
              task.blockedPreamble = newBoundary.fallbackPreamble;
              task.keyPath = newProps;
              boundarySegment.status = 6;
              try {
                renderNode(request, task, propName, -1), pushSegmentFinale(
                  boundarySegment.chunks,
                  request.renderState,
                  boundarySegment.lastPushedText,
                  boundarySegment.textEmbedded
                ), boundarySegment.status = 1;
              } catch (thrownValue) {
                throw boundarySegment.status = 12 === request.status ? 3 : 4, thrownValue;
              } finally {
                task.blockedSegment = propName$33, task.blockedPreamble = ref, task.keyPath = type;
              }
              task = createRenderTask(
                request,
                null,
                props,
                -1,
                newBoundary,
                contentRootSegment,
                newBoundary.contentPreamble,
                newBoundary.contentState,
                task.abortSet,
                keyPath,
                task.formatContext,
                task.context,
                task.treeContext,
                task.componentStack,
                task.isFallback
              );
              pushComponentStack(task);
              request.pingedTasks.push(task);
            } else {
              task.blockedBoundary = newBoundary;
              task.blockedPreamble = newBoundary.contentPreamble;
              task.hoistableState = newBoundary.contentState;
              task.blockedSegment = contentRootSegment;
              task.keyPath = keyPath;
              contentRootSegment.status = 6;
              try {
                if (renderNode(request, task, props, -1), pushSegmentFinale(
                  contentRootSegment.chunks,
                  request.renderState,
                  contentRootSegment.lastPushedText,
                  contentRootSegment.textEmbedded
                ), contentRootSegment.status = 1, queueCompletedSegment(newBoundary, contentRootSegment), 0 === newBoundary.pendingTasks && 0 === newBoundary.status) {
                  newBoundary.status = 1;
                  0 === request.pendingRootTasks && task.blockedPreamble && preparePreamble(request);
                  break a;
                }
              } catch (thrownValue$28) {
                newBoundary.status = 4, 12 === request.status ? (contentRootSegment.status = 3, newProps = request.fatalError) : (contentRootSegment.status = 4, newProps = thrownValue$28), defaultProps = getThrownInfo(task.componentStack), initialState = logRecoverableError(
                  request,
                  newProps,
                  defaultProps
                ), newBoundary.errorDigest = initialState, untrackBoundary(request, newBoundary);
              } finally {
                task.blockedBoundary = parentBoundary, task.blockedPreamble = ref, task.hoistableState = parentHoistableState, task.blockedSegment = propName$33, task.keyPath = type;
              }
              task = createRenderTask(
                request,
                null,
                propName,
                -1,
                parentBoundary,
                boundarySegment,
                newBoundary.fallbackPreamble,
                newBoundary.fallbackState,
                fallbackAbortSet,
                [keyPath[0], "Suspense Fallback", keyPath[2]],
                task.formatContext,
                task.context,
                task.treeContext,
                task.componentStack,
                true
              );
              pushComponentStack(task);
              request.pingedTasks.push(task);
            }
          }
          return;
      }
      if ("object" === typeof type && null !== type)
        switch (type.$$typeof) {
          case REACT_FORWARD_REF_TYPE:
            if ("ref" in props)
              for (newBoundary in newProps = {}, props)
                "ref" !== newBoundary && (newProps[newBoundary] = props[newBoundary]);
            else newProps = props;
            type = renderWithHooks(
              request,
              task,
              keyPath,
              type.render,
              newProps,
              ref
            );
            finishFunctionComponent(
              request,
              task,
              keyPath,
              type,
              0 !== localIdCounter,
              actionStateCounter,
              actionStateMatchingIndex
            );
            return;
          case REACT_MEMO_TYPE:
            renderElement(request, task, keyPath, type.type, props, ref);
            return;
          case REACT_PROVIDER_TYPE:
          case REACT_CONTEXT_TYPE:
            defaultProps = props.children;
            newProps = task.keyPath;
            props = props.value;
            initialState = type._currentValue2;
            type._currentValue2 = props;
            ref = currentActiveSnapshot;
            currentActiveSnapshot = type = {
              parent: ref,
              depth: null === ref ? 0 : ref.depth + 1,
              context: type,
              parentValue: initialState,
              value: props
            };
            task.context = type;
            task.keyPath = keyPath;
            renderNodeDestructive(request, task, defaultProps, -1);
            request = currentActiveSnapshot;
            if (null === request) throw Error(formatProdErrorMessage(403));
            request.context._currentValue2 = request.parentValue;
            request = currentActiveSnapshot = request.parent;
            task.context = request;
            task.keyPath = newProps;
            return;
          case REACT_CONSUMER_TYPE:
            props = props.children;
            type = props(type._context._currentValue2);
            props = task.keyPath;
            task.keyPath = keyPath;
            renderNodeDestructive(request, task, type, -1);
            task.keyPath = props;
            return;
          case REACT_LAZY_TYPE:
            newProps = type._init;
            type = newProps(type._payload);
            if (12 === request.status) throw null;
            renderElement(request, task, keyPath, type, props, ref);
            return;
        }
      throw Error(
        formatProdErrorMessage(130, null == type ? type : typeof type, "")
      );
    }
  }
  function resumeNode(request, task, segmentId, node, childIndex) {
    var prevReplay = task.replay, blockedBoundary = task.blockedBoundary, resumedSegment = createPendingSegment(
      request,
      0,
      null,
      task.formatContext,
      false,
      false
    );
    resumedSegment.id = segmentId;
    resumedSegment.parentFlushed = true;
    try {
      task.replay = null, task.blockedSegment = resumedSegment, renderNode(request, task, node, childIndex), resumedSegment.status = 1, null === blockedBoundary ? request.completedRootSegment = resumedSegment : (queueCompletedSegment(blockedBoundary, resumedSegment), blockedBoundary.parentFlushed && request.partialBoundaries.push(blockedBoundary));
    } finally {
      task.replay = prevReplay, task.blockedSegment = null;
    }
  }
  function renderNodeDestructive(request, task, node, childIndex) {
    null !== task.replay && "number" === typeof task.replay.slots ? resumeNode(request, task, task.replay.slots, node, childIndex) : (task.node = node, task.childIndex = childIndex, node = task.componentStack, pushComponentStack(task), retryNode(request, task), task.componentStack = node);
  }
  function retryNode(request, task) {
    var node = task.node, childIndex = task.childIndex;
    if (null !== node) {
      if ("object" === typeof node) {
        switch (node.$$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = node.type, key = node.key, props = node.props;
            node = props.ref;
            var ref = void 0 !== node ? node : null, name = getComponentNameFromType(type), keyOrIndex = null == key ? -1 === childIndex ? 0 : childIndex : key;
            key = [task.keyPath, name, keyOrIndex];
            if (null !== task.replay)
              a: {
                var replay = task.replay;
                childIndex = replay.nodes;
                for (node = 0; node < childIndex.length; node++) {
                  var node$jscomp$0 = childIndex[node];
                  if (keyOrIndex === node$jscomp$0[1]) {
                    if (4 === node$jscomp$0.length) {
                      if (null !== name && name !== node$jscomp$0[0])
                        throw Error(
                          formatProdErrorMessage(490, node$jscomp$0[0], name)
                        );
                      var childNodes = node$jscomp$0[2];
                      name = node$jscomp$0[3];
                      keyOrIndex = task.node;
                      task.replay = {
                        nodes: childNodes,
                        slots: name,
                        pendingTasks: 1
                      };
                      try {
                        renderElement(request, task, key, type, props, ref);
                        if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length)
                          throw Error(formatProdErrorMessage(488));
                        task.replay.pendingTasks--;
                      } catch (x) {
                        if ("object" === typeof x && null !== x && (x === SuspenseException || "function" === typeof x.then))
                          throw task.node === keyOrIndex && (task.replay = replay), x;
                        task.replay.pendingTasks--;
                        props = getThrownInfo(task.componentStack);
                        key = task.blockedBoundary;
                        type = x;
                        props = logRecoverableError(request, type, props);
                        abortRemainingReplayNodes(
                          request,
                          key,
                          childNodes,
                          name,
                          type,
                          props
                        );
                      }
                      task.replay = replay;
                    } else {
                      if (type !== REACT_SUSPENSE_TYPE)
                        throw Error(
                          formatProdErrorMessage(
                            490,
                            "Suspense",
                            getComponentNameFromType(type) || "Unknown"
                          )
                        );
                      b: {
                        replay = void 0;
                        type = node$jscomp$0[5];
                        ref = node$jscomp$0[2];
                        name = node$jscomp$0[3];
                        keyOrIndex = null === node$jscomp$0[4] ? [] : node$jscomp$0[4][2];
                        node$jscomp$0 = null === node$jscomp$0[4] ? null : node$jscomp$0[4][3];
                        var prevKeyPath = task.keyPath, previousReplaySet = task.replay, parentBoundary = task.blockedBoundary, parentHoistableState = task.hoistableState, content = props.children, fallback = props.fallback, fallbackAbortSet = /* @__PURE__ */ new Set();
                        props = 2 > task.formatContext.insertionMode ? createSuspenseBoundary(
                          request,
                          fallbackAbortSet,
                          createPreambleState(),
                          createPreambleState()
                        ) : createSuspenseBoundary(
                          request,
                          fallbackAbortSet,
                          null,
                          null
                        );
                        props.parentFlushed = true;
                        props.rootSegmentID = type;
                        task.blockedBoundary = props;
                        task.hoistableState = props.contentState;
                        task.keyPath = key;
                        task.replay = {
                          nodes: ref,
                          slots: name,
                          pendingTasks: 1
                        };
                        try {
                          renderNode(request, task, content, -1);
                          if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length)
                            throw Error(formatProdErrorMessage(488));
                          task.replay.pendingTasks--;
                          if (0 === props.pendingTasks && 0 === props.status) {
                            props.status = 1;
                            request.completedBoundaries.push(props);
                            break b;
                          }
                        } catch (error) {
                          props.status = 4, childNodes = getThrownInfo(task.componentStack), replay = logRecoverableError(
                            request,
                            error,
                            childNodes
                          ), props.errorDigest = replay, task.replay.pendingTasks--, request.clientRenderedBoundaries.push(props);
                        } finally {
                          task.blockedBoundary = parentBoundary, task.hoistableState = parentHoistableState, task.replay = previousReplaySet, task.keyPath = prevKeyPath;
                        }
                        task = createReplayTask(
                          request,
                          null,
                          {
                            nodes: keyOrIndex,
                            slots: node$jscomp$0,
                            pendingTasks: 0
                          },
                          fallback,
                          -1,
                          parentBoundary,
                          props.fallbackState,
                          fallbackAbortSet,
                          [key[0], "Suspense Fallback", key[2]],
                          task.formatContext,
                          task.context,
                          task.treeContext,
                          task.componentStack,
                          true
                        );
                        pushComponentStack(task);
                        request.pingedTasks.push(task);
                      }
                    }
                    childIndex.splice(node, 1);
                    break a;
                  }
                }
              }
            else renderElement(request, task, key, type, props, ref);
            return;
          case REACT_PORTAL_TYPE:
            throw Error(formatProdErrorMessage(257));
          case REACT_LAZY_TYPE:
            childNodes = node._init;
            node = childNodes(node._payload);
            if (12 === request.status) throw null;
            renderNodeDestructive(request, task, node, childIndex);
            return;
        }
        if (isArrayImpl(node)) {
          renderChildrenArray(request, task, node, childIndex);
          return;
        }
        null === node || "object" !== typeof node ? childNodes = null : (childNodes = MAYBE_ITERATOR_SYMBOL && node[MAYBE_ITERATOR_SYMBOL] || node["@@iterator"], childNodes = "function" === typeof childNodes ? childNodes : null);
        if (childNodes && (childNodes = childNodes.call(node))) {
          node = childNodes.next();
          if (!node.done) {
            props = [];
            do
              props.push(node.value), node = childNodes.next();
            while (!node.done);
            renderChildrenArray(request, task, props, childIndex);
          }
          return;
        }
        if ("function" === typeof node.then)
          return task.thenableState = null, renderNodeDestructive(request, task, unwrapThenable(node), childIndex);
        if (node.$$typeof === REACT_CONTEXT_TYPE)
          return renderNodeDestructive(
            request,
            task,
            node._currentValue2,
            childIndex
          );
        childIndex = Object.prototype.toString.call(node);
        throw Error(
          formatProdErrorMessage(
            31,
            "[object Object]" === childIndex ? "object with keys {" + Object.keys(node).join(", ") + "}" : childIndex
          )
        );
      }
      if ("string" === typeof node)
        childIndex = task.blockedSegment, null !== childIndex && (childIndex.lastPushedText = pushTextInstance(
          childIndex.chunks,
          node,
          request.renderState,
          childIndex.lastPushedText
        ));
      else if ("number" === typeof node || "bigint" === typeof node)
        childIndex = task.blockedSegment, null !== childIndex && (childIndex.lastPushedText = pushTextInstance(
          childIndex.chunks,
          "" + node,
          request.renderState,
          childIndex.lastPushedText
        ));
    }
  }
  function renderChildrenArray(request, task, children, childIndex) {
    var prevKeyPath = task.keyPath;
    if (-1 !== childIndex && (task.keyPath = [task.keyPath, "Fragment", childIndex], null !== task.replay)) {
      for (var replay = task.replay, replayNodes = replay.nodes, j = 0; j < replayNodes.length; j++) {
        var node = replayNodes[j];
        if (node[1] === childIndex) {
          childIndex = node[2];
          node = node[3];
          task.replay = { nodes: childIndex, slots: node, pendingTasks: 1 };
          try {
            renderChildrenArray(request, task, children, -1);
            if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length)
              throw Error(formatProdErrorMessage(488));
            task.replay.pendingTasks--;
          } catch (x) {
            if ("object" === typeof x && null !== x && (x === SuspenseException || "function" === typeof x.then))
              throw x;
            task.replay.pendingTasks--;
            children = getThrownInfo(task.componentStack);
            var boundary = task.blockedBoundary, error = x;
            children = logRecoverableError(request, error, children);
            abortRemainingReplayNodes(
              request,
              boundary,
              childIndex,
              node,
              error,
              children
            );
          }
          task.replay = replay;
          replayNodes.splice(j, 1);
          break;
        }
      }
      task.keyPath = prevKeyPath;
      return;
    }
    replay = task.treeContext;
    replayNodes = children.length;
    if (null !== task.replay && (j = task.replay.slots, null !== j && "object" === typeof j)) {
      for (childIndex = 0; childIndex < replayNodes; childIndex++)
        node = children[childIndex], task.treeContext = pushTreeContext(replay, replayNodes, childIndex), boundary = j[childIndex], "number" === typeof boundary ? (resumeNode(request, task, boundary, node, childIndex), delete j[childIndex]) : renderNode(request, task, node, childIndex);
      task.treeContext = replay;
      task.keyPath = prevKeyPath;
      return;
    }
    for (j = 0; j < replayNodes; j++)
      childIndex = children[j], task.treeContext = pushTreeContext(replay, replayNodes, j), renderNode(request, task, childIndex, j);
    task.treeContext = replay;
    task.keyPath = prevKeyPath;
  }
  function untrackBoundary(request, boundary) {
    request = request.trackedPostpones;
    null !== request && (boundary = boundary.trackedContentKeyPath, null !== boundary && (boundary = request.workingMap.get(boundary), void 0 !== boundary && (boundary.length = 4, boundary[2] = [], boundary[3] = null)));
  }
  function spawnNewSuspendedReplayTask(request, task, thenableState2) {
    return createReplayTask(
      request,
      thenableState2,
      task.replay,
      task.node,
      task.childIndex,
      task.blockedBoundary,
      task.hoistableState,
      task.abortSet,
      task.keyPath,
      task.formatContext,
      task.context,
      task.treeContext,
      task.componentStack,
      task.isFallback
    );
  }
  function spawnNewSuspendedRenderTask(request, task, thenableState2) {
    var segment = task.blockedSegment, newSegment = createPendingSegment(
      request,
      segment.chunks.length,
      null,
      task.formatContext,
      segment.lastPushedText,
      true
    );
    segment.children.push(newSegment);
    segment.lastPushedText = false;
    return createRenderTask(
      request,
      thenableState2,
      task.node,
      task.childIndex,
      task.blockedBoundary,
      newSegment,
      task.blockedPreamble,
      task.hoistableState,
      task.abortSet,
      task.keyPath,
      task.formatContext,
      task.context,
      task.treeContext,
      task.componentStack,
      task.isFallback
    );
  }
  function renderNode(request, task, node, childIndex) {
    var previousFormatContext = task.formatContext, previousContext = task.context, previousKeyPath = task.keyPath, previousTreeContext = task.treeContext, previousComponentStack = task.componentStack, segment = task.blockedSegment;
    if (null === segment)
      try {
        return renderNodeDestructive(request, task, node, childIndex);
      } catch (thrownValue) {
        if (resetHooksState(), node = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue, "object" === typeof node && null !== node) {
          if ("function" === typeof node.then) {
            childIndex = getThenableStateAfterSuspending();
            request = spawnNewSuspendedReplayTask(request, task, childIndex).ping;
            node.then(request, request);
            task.formatContext = previousFormatContext;
            task.context = previousContext;
            task.keyPath = previousKeyPath;
            task.treeContext = previousTreeContext;
            task.componentStack = previousComponentStack;
            switchContext(previousContext);
            return;
          }
          if ("Maximum call stack size exceeded" === node.message) {
            node = getThenableStateAfterSuspending();
            node = spawnNewSuspendedReplayTask(request, task, node);
            request.pingedTasks.push(node);
            task.formatContext = previousFormatContext;
            task.context = previousContext;
            task.keyPath = previousKeyPath;
            task.treeContext = previousTreeContext;
            task.componentStack = previousComponentStack;
            switchContext(previousContext);
            return;
          }
        }
      }
    else {
      var childrenLength = segment.children.length, chunkLength = segment.chunks.length;
      try {
        return renderNodeDestructive(request, task, node, childIndex);
      } catch (thrownValue$48) {
        if (resetHooksState(), segment.children.length = childrenLength, segment.chunks.length = chunkLength, node = thrownValue$48 === SuspenseException ? getSuspendedThenable() : thrownValue$48, "object" === typeof node && null !== node) {
          if ("function" === typeof node.then) {
            childIndex = getThenableStateAfterSuspending();
            request = spawnNewSuspendedRenderTask(request, task, childIndex).ping;
            node.then(request, request);
            task.formatContext = previousFormatContext;
            task.context = previousContext;
            task.keyPath = previousKeyPath;
            task.treeContext = previousTreeContext;
            task.componentStack = previousComponentStack;
            switchContext(previousContext);
            return;
          }
          if ("Maximum call stack size exceeded" === node.message) {
            node = getThenableStateAfterSuspending();
            node = spawnNewSuspendedRenderTask(request, task, node);
            request.pingedTasks.push(node);
            task.formatContext = previousFormatContext;
            task.context = previousContext;
            task.keyPath = previousKeyPath;
            task.treeContext = previousTreeContext;
            task.componentStack = previousComponentStack;
            switchContext(previousContext);
            return;
          }
        }
      }
    }
    task.formatContext = previousFormatContext;
    task.context = previousContext;
    task.keyPath = previousKeyPath;
    task.treeContext = previousTreeContext;
    switchContext(previousContext);
    throw node;
  }
  function abortTaskSoft(task) {
    var boundary = task.blockedBoundary;
    task = task.blockedSegment;
    null !== task && (task.status = 3, finishedTask(this, boundary, task));
  }
  function abortRemainingReplayNodes(request$jscomp$0, boundary, nodes, slots, error, errorDigest$jscomp$0) {
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (4 === node.length)
        abortRemainingReplayNodes(
          request$jscomp$0,
          boundary,
          node[2],
          node[3],
          error,
          errorDigest$jscomp$0
        );
      else {
        node = node[5];
        var request = request$jscomp$0, errorDigest = errorDigest$jscomp$0, resumedBoundary = createSuspenseBoundary(
          request,
          /* @__PURE__ */ new Set(),
          null,
          null
        );
        resumedBoundary.parentFlushed = true;
        resumedBoundary.rootSegmentID = node;
        resumedBoundary.status = 4;
        resumedBoundary.errorDigest = errorDigest;
        resumedBoundary.parentFlushed && request.clientRenderedBoundaries.push(resumedBoundary);
      }
    }
    nodes.length = 0;
    if (null !== slots) {
      if (null === boundary) throw Error(formatProdErrorMessage(487));
      4 !== boundary.status && (boundary.status = 4, boundary.errorDigest = errorDigest$jscomp$0, boundary.parentFlushed && request$jscomp$0.clientRenderedBoundaries.push(boundary));
      if ("object" === typeof slots) for (var index in slots) delete slots[index];
    }
  }
  function abortTask(task, request, error) {
    var boundary = task.blockedBoundary, segment = task.blockedSegment;
    if (null !== segment) {
      if (6 === segment.status) return;
      segment.status = 3;
    }
    segment = getThrownInfo(task.componentStack);
    if (null === boundary) {
      if (13 !== request.status && 14 !== request.status) {
        boundary = task.replay;
        if (null === boundary) {
          logRecoverableError(request, error, segment);
          fatalError(request, error);
          return;
        }
        boundary.pendingTasks--;
        0 === boundary.pendingTasks && 0 < boundary.nodes.length && (task = logRecoverableError(request, error, segment), abortRemainingReplayNodes(
          request,
          null,
          boundary.nodes,
          boundary.slots,
          error,
          task
        ));
        request.pendingRootTasks--;
        0 === request.pendingRootTasks && completeShell(request);
      }
    } else
      boundary.pendingTasks--, 4 !== boundary.status && (boundary.status = 4, task = logRecoverableError(request, error, segment), boundary.status = 4, boundary.errorDigest = task, untrackBoundary(request, boundary), boundary.parentFlushed && request.clientRenderedBoundaries.push(boundary)), boundary.fallbackAbortableTasks.forEach(function(fallbackTask) {
        return abortTask(fallbackTask, request, error);
      }), boundary.fallbackAbortableTasks.clear();
    request.allPendingTasks--;
    0 === request.allPendingTasks && completeAll(request);
  }
  function safelyEmitEarlyPreloads(request, shellComplete) {
    try {
      var renderState = request.renderState, onHeaders = renderState.onHeaders;
      if (onHeaders) {
        var headers = renderState.headers;
        if (headers) {
          renderState.headers = null;
          var linkHeader = headers.preconnects;
          headers.fontPreloads && (linkHeader && (linkHeader += ", "), linkHeader += headers.fontPreloads);
          headers.highImagePreloads && (linkHeader && (linkHeader += ", "), linkHeader += headers.highImagePreloads);
          if (!shellComplete) {
            var queueIter = renderState.styles.values(), queueStep = queueIter.next();
            b: for (; 0 < headers.remainingCapacity && !queueStep.done; queueStep = queueIter.next())
              for (var sheetIter = queueStep.value.sheets.values(), sheetStep = sheetIter.next(); 0 < headers.remainingCapacity && !sheetStep.done; sheetStep = sheetIter.next()) {
                var sheet = sheetStep.value, props = sheet.props, key = props.href, props$jscomp$0 = sheet.props, header = getPreloadAsHeader(props$jscomp$0.href, "style", {
                  crossOrigin: props$jscomp$0.crossOrigin,
                  integrity: props$jscomp$0.integrity,
                  nonce: props$jscomp$0.nonce,
                  type: props$jscomp$0.type,
                  fetchPriority: props$jscomp$0.fetchPriority,
                  referrerPolicy: props$jscomp$0.referrerPolicy,
                  media: props$jscomp$0.media
                });
                if (0 <= (headers.remainingCapacity -= header.length + 2))
                  renderState.resets.style[key] = PRELOAD_NO_CREDS, linkHeader && (linkHeader += ", "), linkHeader += header, renderState.resets.style[key] = "string" === typeof props.crossOrigin || "string" === typeof props.integrity ? [props.crossOrigin, props.integrity] : PRELOAD_NO_CREDS;
                else break b;
              }
          }
          linkHeader ? onHeaders({ Link: linkHeader }) : onHeaders({});
        }
      }
    } catch (error) {
      logRecoverableError(request, error, {});
    }
  }
  function completeShell(request) {
    null === request.trackedPostpones && safelyEmitEarlyPreloads(request, true);
    null === request.trackedPostpones && preparePreamble(request);
    request.onShellError = noop;
    request = request.onShellReady;
    request();
  }
  function completeAll(request) {
    safelyEmitEarlyPreloads(
      request,
      null === request.trackedPostpones ? true : null === request.completedRootSegment || 5 !== request.completedRootSegment.status
    );
    preparePreamble(request);
    request = request.onAllReady;
    request();
  }
  function queueCompletedSegment(boundary, segment) {
    if (0 === segment.chunks.length && 1 === segment.children.length && null === segment.children[0].boundary && -1 === segment.children[0].id) {
      var childSegment = segment.children[0];
      childSegment.id = segment.id;
      childSegment.parentFlushed = true;
      1 === childSegment.status && queueCompletedSegment(boundary, childSegment);
    } else boundary.completedSegments.push(segment);
  }
  function finishedTask(request, boundary, segment) {
    if (null === boundary) {
      if (null !== segment && segment.parentFlushed) {
        if (null !== request.completedRootSegment)
          throw Error(formatProdErrorMessage(389));
        request.completedRootSegment = segment;
      }
      request.pendingRootTasks--;
      0 === request.pendingRootTasks && completeShell(request);
    } else
      boundary.pendingTasks--, 4 !== boundary.status && (0 === boundary.pendingTasks ? (0 === boundary.status && (boundary.status = 1), null !== segment && segment.parentFlushed && 1 === segment.status && queueCompletedSegment(boundary, segment), boundary.parentFlushed && request.completedBoundaries.push(boundary), 1 === boundary.status && (boundary.fallbackAbortableTasks.forEach(abortTaskSoft, request), boundary.fallbackAbortableTasks.clear(), 0 === request.pendingRootTasks && null === request.trackedPostpones && null !== boundary.contentPreamble && preparePreamble(request))) : null !== segment && segment.parentFlushed && 1 === segment.status && (queueCompletedSegment(boundary, segment), 1 === boundary.completedSegments.length && boundary.parentFlushed && request.partialBoundaries.push(boundary)));
    request.allPendingTasks--;
    0 === request.allPendingTasks && completeAll(request);
  }
  function performWork(request$jscomp$2) {
    if (14 !== request$jscomp$2.status && 13 !== request$jscomp$2.status) {
      var prevContext = currentActiveSnapshot, prevDispatcher = ReactSharedInternals.H;
      ReactSharedInternals.H = HooksDispatcher;
      var prevAsyncDispatcher = ReactSharedInternals.A;
      ReactSharedInternals.A = DefaultAsyncDispatcher;
      var prevRequest = currentRequest;
      currentRequest = request$jscomp$2;
      var prevResumableState = currentResumableState;
      currentResumableState = request$jscomp$2.resumableState;
      try {
        var pingedTasks = request$jscomp$2.pingedTasks, i;
        for (i = 0; i < pingedTasks.length; i++) {
          var task = pingedTasks[i], request = request$jscomp$2, segment = task.blockedSegment;
          if (null === segment) {
            var request$jscomp$0 = request;
            if (0 !== task.replay.pendingTasks) {
              switchContext(task.context);
              try {
                "number" === typeof task.replay.slots ? resumeNode(
                  request$jscomp$0,
                  task,
                  task.replay.slots,
                  task.node,
                  task.childIndex
                ) : retryNode(request$jscomp$0, task);
                if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length)
                  throw Error(formatProdErrorMessage(488));
                task.replay.pendingTasks--;
                task.abortSet.delete(task);
                finishedTask(request$jscomp$0, task.blockedBoundary, null);
              } catch (thrownValue) {
                resetHooksState();
                var x = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue;
                if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                  var ping = task.ping;
                  x.then(ping, ping);
                  task.thenableState = getThenableStateAfterSuspending();
                } else {
                  task.replay.pendingTasks--;
                  task.abortSet.delete(task);
                  var errorInfo = getThrownInfo(task.componentStack);
                  request = void 0;
                  var request$jscomp$1 = request$jscomp$0, boundary = task.blockedBoundary, error$jscomp$0 = 12 === request$jscomp$0.status ? request$jscomp$0.fatalError : x, replayNodes = task.replay.nodes, resumeSlots = task.replay.slots;
                  request = logRecoverableError(
                    request$jscomp$1,
                    error$jscomp$0,
                    errorInfo
                  );
                  abortRemainingReplayNodes(
                    request$jscomp$1,
                    boundary,
                    replayNodes,
                    resumeSlots,
                    error$jscomp$0,
                    request
                  );
                  request$jscomp$0.pendingRootTasks--;
                  0 === request$jscomp$0.pendingRootTasks && completeShell(request$jscomp$0);
                  request$jscomp$0.allPendingTasks--;
                  0 === request$jscomp$0.allPendingTasks && completeAll(request$jscomp$0);
                }
              } finally {
              }
            }
          } else if (request$jscomp$0 = void 0, request$jscomp$1 = segment, 0 === request$jscomp$1.status) {
            request$jscomp$1.status = 6;
            switchContext(task.context);
            var childrenLength = request$jscomp$1.children.length, chunkLength = request$jscomp$1.chunks.length;
            try {
              retryNode(request, task), pushSegmentFinale(
                request$jscomp$1.chunks,
                request.renderState,
                request$jscomp$1.lastPushedText,
                request$jscomp$1.textEmbedded
              ), task.abortSet.delete(task), request$jscomp$1.status = 1, finishedTask(request, task.blockedBoundary, request$jscomp$1);
            } catch (thrownValue) {
              resetHooksState();
              request$jscomp$1.children.length = childrenLength;
              request$jscomp$1.chunks.length = chunkLength;
              var x$jscomp$0 = thrownValue === SuspenseException ? getSuspendedThenable() : 12 === request.status ? request.fatalError : thrownValue;
              if ("object" === typeof x$jscomp$0 && null !== x$jscomp$0 && "function" === typeof x$jscomp$0.then) {
                request$jscomp$1.status = 0;
                task.thenableState = getThenableStateAfterSuspending();
                var ping$jscomp$0 = task.ping;
                x$jscomp$0.then(ping$jscomp$0, ping$jscomp$0);
              } else {
                var errorInfo$jscomp$0 = getThrownInfo(task.componentStack);
                task.abortSet.delete(task);
                request$jscomp$1.status = 4;
                var boundary$jscomp$0 = task.blockedBoundary;
                request$jscomp$0 = logRecoverableError(
                  request,
                  x$jscomp$0,
                  errorInfo$jscomp$0
                );
                null === boundary$jscomp$0 ? fatalError(request, x$jscomp$0) : (boundary$jscomp$0.pendingTasks--, 4 !== boundary$jscomp$0.status && (boundary$jscomp$0.status = 4, boundary$jscomp$0.errorDigest = request$jscomp$0, untrackBoundary(request, boundary$jscomp$0), boundary$jscomp$0.parentFlushed && request.clientRenderedBoundaries.push(boundary$jscomp$0), 0 === request.pendingRootTasks && null === request.trackedPostpones && null !== boundary$jscomp$0.contentPreamble && preparePreamble(request)));
                request.allPendingTasks--;
                0 === request.allPendingTasks && completeAll(request);
              }
            } finally {
            }
          }
        }
        pingedTasks.splice(0, i);
        null !== request$jscomp$2.destination && flushCompletedQueues(request$jscomp$2, request$jscomp$2.destination);
      } catch (error) {
        logRecoverableError(request$jscomp$2, error, {}), fatalError(request$jscomp$2, error);
      } finally {
        currentResumableState = prevResumableState, ReactSharedInternals.H = prevDispatcher, ReactSharedInternals.A = prevAsyncDispatcher, prevDispatcher === HooksDispatcher && switchContext(prevContext), currentRequest = prevRequest;
      }
    }
  }
  function preparePreambleFromSubtree(request, segment, collectedPreambleSegments) {
    segment.preambleChildren.length && collectedPreambleSegments.push(segment.preambleChildren);
    for (var pendingPreambles = false, i = 0; i < segment.children.length; i++)
      pendingPreambles = preparePreambleFromSegment(
        request,
        segment.children[i],
        collectedPreambleSegments
      ) || pendingPreambles;
    return pendingPreambles;
  }
  function preparePreambleFromSegment(request, segment, collectedPreambleSegments) {
    var boundary = segment.boundary;
    if (null === boundary)
      return preparePreambleFromSubtree(
        request,
        segment,
        collectedPreambleSegments
      );
    var preamble = boundary.contentPreamble, fallbackPreamble = boundary.fallbackPreamble;
    if (null === preamble || null === fallbackPreamble) return false;
    switch (boundary.status) {
      case 1:
        hoistPreambleState(request.renderState, preamble);
        segment = boundary.completedSegments[0];
        if (!segment) throw Error(formatProdErrorMessage(391));
        return preparePreambleFromSubtree(
          request,
          segment,
          collectedPreambleSegments
        );
      case 5:
        if (null !== request.trackedPostpones) return true;
      case 4:
        if (1 === segment.status)
          return hoistPreambleState(request.renderState, fallbackPreamble), preparePreambleFromSubtree(
            request,
            segment,
            collectedPreambleSegments
          );
      default:
        return true;
    }
  }
  function preparePreamble(request) {
    if (request.completedRootSegment && null === request.completedPreambleSegments) {
      var collectedPreambleSegments = [], hasPendingPreambles = preparePreambleFromSegment(
        request,
        request.completedRootSegment,
        collectedPreambleSegments
      ), preamble = request.renderState.preamble;
      if (false === hasPendingPreambles || preamble.headChunks && preamble.bodyChunks)
        request.completedPreambleSegments = collectedPreambleSegments;
    }
  }
  function flushSubtree(request, destination, segment, hoistableState) {
    segment.parentFlushed = true;
    switch (segment.status) {
      case 0:
        segment.id = request.nextSegmentId++;
      case 5:
        return hoistableState = segment.id, segment.lastPushedText = false, segment.textEmbedded = false, request = request.renderState, destination.push('<template id="'), destination.push(request.placeholderPrefix), request = hoistableState.toString(16), destination.push(request), destination.push('"></template>');
      case 1:
        segment.status = 2;
        var r = true, chunks = segment.chunks, chunkIdx = 0;
        segment = segment.children;
        for (var childIdx = 0; childIdx < segment.length; childIdx++) {
          for (r = segment[childIdx]; chunkIdx < r.index; chunkIdx++)
            destination.push(chunks[chunkIdx]);
          r = flushSegment(request, destination, r, hoistableState);
        }
        for (; chunkIdx < chunks.length - 1; chunkIdx++)
          destination.push(chunks[chunkIdx]);
        chunkIdx < chunks.length && (r = destination.push(chunks[chunkIdx]));
        return r;
      default:
        throw Error(formatProdErrorMessage(390));
    }
  }
  function flushSegment(request, destination, segment, hoistableState) {
    var boundary = segment.boundary;
    if (null === boundary)
      return flushSubtree(request, destination, segment, hoistableState);
    boundary.parentFlushed = true;
    if (4 === boundary.status) {
      if (!request.renderState.generateStaticMarkup) {
        var errorDigest = boundary.errorDigest;
        destination.push("<!--$!-->");
        destination.push("<template");
        errorDigest && (destination.push(' data-dgst="'), errorDigest = escapeTextForBrowser(errorDigest), destination.push(errorDigest), destination.push('"'));
        destination.push("></template>");
      }
      flushSubtree(request, destination, segment, hoistableState);
      request.renderState.generateStaticMarkup ? destination = true : ((request = boundary.fallbackPreamble) && writePreambleContribution(destination, request), destination = destination.push("<!--/$-->"));
      return destination;
    }
    if (1 !== boundary.status)
      return 0 === boundary.status && (boundary.rootSegmentID = request.nextSegmentId++), 0 < boundary.completedSegments.length && request.partialBoundaries.push(boundary), writeStartPendingSuspenseBoundary(
        destination,
        request.renderState,
        boundary.rootSegmentID
      ), hoistableState && (boundary = boundary.fallbackState, boundary.styles.forEach(hoistStyleQueueDependency, hoistableState), boundary.stylesheets.forEach(
        hoistStylesheetDependency,
        hoistableState
      )), flushSubtree(request, destination, segment, hoistableState), destination.push("<!--/$-->");
    if (boundary.byteSize > request.progressiveChunkSize)
      return boundary.rootSegmentID = request.nextSegmentId++, request.completedBoundaries.push(boundary), writeStartPendingSuspenseBoundary(
        destination,
        request.renderState,
        boundary.rootSegmentID
      ), flushSubtree(request, destination, segment, hoistableState), destination.push("<!--/$-->");
    hoistableState && (segment = boundary.contentState, segment.styles.forEach(hoistStyleQueueDependency, hoistableState), segment.stylesheets.forEach(hoistStylesheetDependency, hoistableState));
    request.renderState.generateStaticMarkup || destination.push("<!--$-->");
    segment = boundary.completedSegments;
    if (1 !== segment.length) throw Error(formatProdErrorMessage(391));
    flushSegment(request, destination, segment[0], hoistableState);
    request.renderState.generateStaticMarkup ? destination = true : ((request = boundary.contentPreamble) && writePreambleContribution(destination, request), destination = destination.push("<!--/$-->"));
    return destination;
  }
  function flushSegmentContainer(request, destination, segment, hoistableState) {
    writeStartSegment(
      destination,
      request.renderState,
      segment.parentFormatContext,
      segment.id
    );
    flushSegment(request, destination, segment, hoistableState);
    return writeEndSegment(destination, segment.parentFormatContext);
  }
  function flushCompletedBoundary(request, destination, boundary) {
    for (var completedSegments = boundary.completedSegments, i = 0; i < completedSegments.length; i++)
      flushPartiallyCompletedSegment(
        request,
        destination,
        boundary,
        completedSegments[i]
      );
    completedSegments.length = 0;
    writeHoistablesForBoundary(
      destination,
      boundary.contentState,
      request.renderState
    );
    completedSegments = request.resumableState;
    request = request.renderState;
    i = boundary.rootSegmentID;
    boundary = boundary.contentState;
    var requiresStyleInsertion = request.stylesToHoist;
    request.stylesToHoist = false;
    destination.push(request.startInlineScript);
    requiresStyleInsertion ? 0 === (completedSegments.instructions & 2) ? (completedSegments.instructions |= 10, destination.push(
      '$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RM=new Map;\n$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=\nd;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,\nt,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("'
    )) : 0 === (completedSegments.instructions & 8) ? (completedSegments.instructions |= 8, destination.push(
      '$RM=new Map;\n$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=\nd;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,\nt,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("'
    )) : destination.push('$RR("') : 0 === (completedSegments.instructions & 2) ? (completedSegments.instructions |= 2, destination.push(
      '$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RC("'
    )) : destination.push('$RC("');
    completedSegments = i.toString(16);
    destination.push(request.boundaryPrefix);
    destination.push(completedSegments);
    destination.push('","');
    destination.push(request.segmentPrefix);
    destination.push(completedSegments);
    requiresStyleInsertion ? (destination.push('",'), writeStyleResourceDependenciesInJS(destination, boundary)) : destination.push('"');
    boundary = destination.push(")<\/script>");
    return writeBootstrap(destination, request) && boundary;
  }
  function flushPartiallyCompletedSegment(request, destination, boundary, segment) {
    if (2 === segment.status) return true;
    var hoistableState = boundary.contentState, segmentID = segment.id;
    if (-1 === segmentID) {
      if (-1 === (segment.id = boundary.rootSegmentID))
        throw Error(formatProdErrorMessage(392));
      return flushSegmentContainer(request, destination, segment, hoistableState);
    }
    if (segmentID === boundary.rootSegmentID)
      return flushSegmentContainer(request, destination, segment, hoistableState);
    flushSegmentContainer(request, destination, segment, hoistableState);
    boundary = request.resumableState;
    request = request.renderState;
    destination.push(request.startInlineScript);
    0 === (boundary.instructions & 1) ? (boundary.instructions |= 1, destination.push(
      '$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'
    )) : destination.push('$RS("');
    destination.push(request.segmentPrefix);
    segmentID = segmentID.toString(16);
    destination.push(segmentID);
    destination.push('","');
    destination.push(request.placeholderPrefix);
    destination.push(segmentID);
    destination = destination.push('")<\/script>');
    return destination;
  }
  function flushCompletedQueues(request, destination) {
    try {
      if (!(0 < request.pendingRootTasks)) {
        var i, completedRootSegment = request.completedRootSegment;
        if (null !== completedRootSegment) {
          if (5 === completedRootSegment.status) return;
          var completedPreambleSegments = request.completedPreambleSegments;
          if (null === completedPreambleSegments) return;
          var renderState = request.renderState, preamble = renderState.preamble, htmlChunks = preamble.htmlChunks, headChunks = preamble.headChunks, i$jscomp$0;
          if (htmlChunks) {
            for (i$jscomp$0 = 0; i$jscomp$0 < htmlChunks.length; i$jscomp$0++)
              destination.push(htmlChunks[i$jscomp$0]);
            if (headChunks)
              for (i$jscomp$0 = 0; i$jscomp$0 < headChunks.length; i$jscomp$0++)
                destination.push(headChunks[i$jscomp$0]);
            else {
              var chunk = startChunkForTag("head");
              destination.push(chunk);
              destination.push(">");
            }
          } else if (headChunks)
            for (i$jscomp$0 = 0; i$jscomp$0 < headChunks.length; i$jscomp$0++)
              destination.push(headChunks[i$jscomp$0]);
          var charsetChunks = renderState.charsetChunks;
          for (i$jscomp$0 = 0; i$jscomp$0 < charsetChunks.length; i$jscomp$0++)
            destination.push(charsetChunks[i$jscomp$0]);
          charsetChunks.length = 0;
          renderState.preconnects.forEach(flushResource, destination);
          renderState.preconnects.clear();
          var viewportChunks = renderState.viewportChunks;
          for (i$jscomp$0 = 0; i$jscomp$0 < viewportChunks.length; i$jscomp$0++)
            destination.push(viewportChunks[i$jscomp$0]);
          viewportChunks.length = 0;
          renderState.fontPreloads.forEach(flushResource, destination);
          renderState.fontPreloads.clear();
          renderState.highImagePreloads.forEach(flushResource, destination);
          renderState.highImagePreloads.clear();
          renderState.styles.forEach(flushStylesInPreamble, destination);
          var importMapChunks = renderState.importMapChunks;
          for (i$jscomp$0 = 0; i$jscomp$0 < importMapChunks.length; i$jscomp$0++)
            destination.push(importMapChunks[i$jscomp$0]);
          importMapChunks.length = 0;
          renderState.bootstrapScripts.forEach(flushResource, destination);
          renderState.scripts.forEach(flushResource, destination);
          renderState.scripts.clear();
          renderState.bulkPreloads.forEach(flushResource, destination);
          renderState.bulkPreloads.clear();
          var hoistableChunks = renderState.hoistableChunks;
          for (i$jscomp$0 = 0; i$jscomp$0 < hoistableChunks.length; i$jscomp$0++)
            destination.push(hoistableChunks[i$jscomp$0]);
          for (renderState = hoistableChunks.length = 0; renderState < completedPreambleSegments.length; renderState++) {
            var segments = completedPreambleSegments[renderState];
            for (preamble = 0; preamble < segments.length; preamble++)
              flushSegment(request, destination, segments[preamble], null);
          }
          var preamble$jscomp$0 = request.renderState.preamble, headChunks$jscomp$0 = preamble$jscomp$0.headChunks;
          if (preamble$jscomp$0.htmlChunks || headChunks$jscomp$0) {
            var chunk$jscomp$0 = endChunkForTag("head");
            destination.push(chunk$jscomp$0);
          }
          var bodyChunks = preamble$jscomp$0.bodyChunks;
          if (bodyChunks)
            for (completedPreambleSegments = 0; completedPreambleSegments < bodyChunks.length; completedPreambleSegments++)
              destination.push(bodyChunks[completedPreambleSegments]);
          flushSegment(request, destination, completedRootSegment, null);
          request.completedRootSegment = null;
          writeBootstrap(destination, request.renderState);
        }
        var renderState$jscomp$0 = request.renderState;
        completedRootSegment = 0;
        var viewportChunks$jscomp$0 = renderState$jscomp$0.viewportChunks;
        for (completedRootSegment = 0; completedRootSegment < viewportChunks$jscomp$0.length; completedRootSegment++)
          destination.push(viewportChunks$jscomp$0[completedRootSegment]);
        viewportChunks$jscomp$0.length = 0;
        renderState$jscomp$0.preconnects.forEach(flushResource, destination);
        renderState$jscomp$0.preconnects.clear();
        renderState$jscomp$0.fontPreloads.forEach(flushResource, destination);
        renderState$jscomp$0.fontPreloads.clear();
        renderState$jscomp$0.highImagePreloads.forEach(
          flushResource,
          destination
        );
        renderState$jscomp$0.highImagePreloads.clear();
        renderState$jscomp$0.styles.forEach(preloadLateStyles, destination);
        renderState$jscomp$0.scripts.forEach(flushResource, destination);
        renderState$jscomp$0.scripts.clear();
        renderState$jscomp$0.bulkPreloads.forEach(flushResource, destination);
        renderState$jscomp$0.bulkPreloads.clear();
        var hoistableChunks$jscomp$0 = renderState$jscomp$0.hoistableChunks;
        for (completedRootSegment = 0; completedRootSegment < hoistableChunks$jscomp$0.length; completedRootSegment++)
          destination.push(hoistableChunks$jscomp$0[completedRootSegment]);
        hoistableChunks$jscomp$0.length = 0;
        var clientRenderedBoundaries = request.clientRenderedBoundaries;
        for (i = 0; i < clientRenderedBoundaries.length; i++) {
          var boundary = clientRenderedBoundaries[i];
          renderState$jscomp$0 = destination;
          var resumableState = request.resumableState, renderState$jscomp$1 = request.renderState, id = boundary.rootSegmentID, errorDigest = boundary.errorDigest;
          renderState$jscomp$0.push(renderState$jscomp$1.startInlineScript);
          0 === (resumableState.instructions & 4) ? (resumableState.instructions |= 4, renderState$jscomp$0.push(
            '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'
          )) : renderState$jscomp$0.push('$RX("');
          renderState$jscomp$0.push(renderState$jscomp$1.boundaryPrefix);
          var chunk$jscomp$1 = id.toString(16);
          renderState$jscomp$0.push(chunk$jscomp$1);
          renderState$jscomp$0.push('"');
          if (errorDigest) {
            renderState$jscomp$0.push(",");
            var chunk$jscomp$2 = escapeJSStringsForInstructionScripts(
              errorDigest || ""
            );
            renderState$jscomp$0.push(chunk$jscomp$2);
          }
          var JSCompiler_inline_result = renderState$jscomp$0.push(")<\/script>");
          if (!JSCompiler_inline_result) {
            request.destination = null;
            i++;
            clientRenderedBoundaries.splice(0, i);
            return;
          }
        }
        clientRenderedBoundaries.splice(0, i);
        var completedBoundaries = request.completedBoundaries;
        for (i = 0; i < completedBoundaries.length; i++)
          if (!flushCompletedBoundary(request, destination, completedBoundaries[i])) {
            request.destination = null;
            i++;
            completedBoundaries.splice(0, i);
            return;
          }
        completedBoundaries.splice(0, i);
        var partialBoundaries = request.partialBoundaries;
        for (i = 0; i < partialBoundaries.length; i++) {
          var boundary$51 = partialBoundaries[i];
          a: {
            clientRenderedBoundaries = request;
            boundary = destination;
            var completedSegments = boundary$51.completedSegments;
            for (JSCompiler_inline_result = 0; JSCompiler_inline_result < completedSegments.length; JSCompiler_inline_result++)
              if (!flushPartiallyCompletedSegment(
                clientRenderedBoundaries,
                boundary,
                boundary$51,
                completedSegments[JSCompiler_inline_result]
              )) {
                JSCompiler_inline_result++;
                completedSegments.splice(0, JSCompiler_inline_result);
                var JSCompiler_inline_result$jscomp$0 = false;
                break a;
              }
            completedSegments.splice(0, JSCompiler_inline_result);
            JSCompiler_inline_result$jscomp$0 = writeHoistablesForBoundary(
              boundary,
              boundary$51.contentState,
              clientRenderedBoundaries.renderState
            );
          }
          if (!JSCompiler_inline_result$jscomp$0) {
            request.destination = null;
            i++;
            partialBoundaries.splice(0, i);
            return;
          }
        }
        partialBoundaries.splice(0, i);
        var largeBoundaries = request.completedBoundaries;
        for (i = 0; i < largeBoundaries.length; i++)
          if (!flushCompletedBoundary(request, destination, largeBoundaries[i])) {
            request.destination = null;
            i++;
            largeBoundaries.splice(0, i);
            return;
          }
        largeBoundaries.splice(0, i);
      }
    } finally {
      0 === request.allPendingTasks && 0 === request.pingedTasks.length && 0 === request.clientRenderedBoundaries.length && 0 === request.completedBoundaries.length && (request.flushScheduled = false, i = request.resumableState, i.hasBody && (partialBoundaries = endChunkForTag("body"), destination.push(partialBoundaries)), i.hasHtml && (i = endChunkForTag("html"), destination.push(i)), request.status = 14, destination.push(null), request.destination = null);
    }
  }
  function enqueueFlush(request) {
    if (false === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination) {
      request.flushScheduled = true;
      var destination = request.destination;
      destination ? flushCompletedQueues(request, destination) : request.flushScheduled = false;
    }
  }
  function startFlowing(request, destination) {
    if (13 === request.status)
      request.status = 14, destination.destroy(request.fatalError);
    else if (14 !== request.status && null === request.destination) {
      request.destination = destination;
      try {
        flushCompletedQueues(request, destination);
      } catch (error) {
        logRecoverableError(request, error, {}), fatalError(request, error);
      }
    }
  }
  function abort(request, reason) {
    if (11 === request.status || 10 === request.status) request.status = 12;
    try {
      var abortableTasks = request.abortableTasks;
      if (0 < abortableTasks.size) {
        var error = void 0 === reason ? Error(formatProdErrorMessage(432)) : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error(formatProdErrorMessage(530)) : reason;
        request.fatalError = error;
        abortableTasks.forEach(function(task) {
          return abortTask(task, request, error);
        });
        abortableTasks.clear();
      }
      null !== request.destination && flushCompletedQueues(request, request.destination);
    } catch (error$53) {
      logRecoverableError(request, error$53, {}), fatalError(request, error$53);
    }
  }
  function onError() {
  }
  function renderToStringImpl(children, options, generateStaticMarkup, abortReason) {
    var didFatal = false, fatalError2 = null, result = "", readyToStream = false;
    options = createResumableState(options ? options.identifierPrefix : void 0);
    children = createRequest(
      children,
      options,
      createRenderState(options, generateStaticMarkup),
      createFormatContext(0, null, 0),
      Infinity,
      onError,
      void 0,
      function() {
        readyToStream = true;
      },
      void 0,
      void 0,
      void 0
    );
    children.flushScheduled = null !== children.destination;
    performWork(children);
    10 === children.status && (children.status = 11);
    null === children.trackedPostpones && safelyEmitEarlyPreloads(children, 0 === children.pendingRootTasks);
    abort(children, abortReason);
    startFlowing(children, {
      push: function(chunk) {
        null !== chunk && (result += chunk);
        return true;
      },
      destroy: function(error) {
        didFatal = true;
        fatalError2 = error;
      }
    });
    if (didFatal && fatalError2 !== abortReason) throw fatalError2;
    if (!readyToStream) throw Error(formatProdErrorMessage(426));
    return result;
  }
  reactDomServerLegacy_browser_production.renderToStaticMarkup = function(children, options) {
    return renderToStringImpl(
      children,
      options,
      true,
      'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server'
    );
  };
  reactDomServerLegacy_browser_production.renderToString = function(children, options) {
    return renderToStringImpl(
      children,
      options,
      false,
      'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server'
    );
  };
  reactDomServerLegacy_browser_production.version = "19.1.0";
  return reactDomServerLegacy_browser_production;
}
var reactDomServer_browser_production = {};
/**
 * @license React
 * react-dom-server.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactDomServer_browser_production;
function requireReactDomServer_browser_production() {
  if (hasRequiredReactDomServer_browser_production) return reactDomServer_browser_production;
  hasRequiredReactDomServer_browser_production = 1;
  var React2 = requireReact(), ReactDOM = requireReactDom();
  function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
      url += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var i = 2; i < arguments.length; i++)
        url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_SCOPE_TYPE = Symbol.for("react.scope"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden"), REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, isArrayImpl = Array.isArray;
  function murmurhash3_32_gc(key, seed) {
    var remainder = key.length & 3;
    var bytes = key.length - remainder;
    var h1 = seed;
    for (seed = 0; seed < bytes; ) {
      var k1 = key.charCodeAt(seed) & 255 | (key.charCodeAt(++seed) & 255) << 8 | (key.charCodeAt(++seed) & 255) << 16 | (key.charCodeAt(++seed) & 255) << 24;
      ++seed;
      k1 = 3432918353 * (k1 & 65535) + ((3432918353 * (k1 >>> 16) & 65535) << 16) & 4294967295;
      k1 = k1 << 15 | k1 >>> 17;
      k1 = 461845907 * (k1 & 65535) + ((461845907 * (k1 >>> 16) & 65535) << 16) & 4294967295;
      h1 ^= k1;
      h1 = h1 << 13 | h1 >>> 19;
      h1 = 5 * (h1 & 65535) + ((5 * (h1 >>> 16) & 65535) << 16) & 4294967295;
      h1 = (h1 & 65535) + 27492 + (((h1 >>> 16) + 58964 & 65535) << 16);
    }
    k1 = 0;
    switch (remainder) {
      case 3:
        k1 ^= (key.charCodeAt(seed + 2) & 255) << 16;
      case 2:
        k1 ^= (key.charCodeAt(seed + 1) & 255) << 8;
      case 1:
        k1 ^= key.charCodeAt(seed) & 255, k1 = 3432918353 * (k1 & 65535) + ((3432918353 * (k1 >>> 16) & 65535) << 16) & 4294967295, k1 = k1 << 15 | k1 >>> 17, h1 ^= 461845907 * (k1 & 65535) + ((461845907 * (k1 >>> 16) & 65535) << 16) & 4294967295;
    }
    h1 ^= key.length;
    h1 ^= h1 >>> 16;
    h1 = 2246822507 * (h1 & 65535) + ((2246822507 * (h1 >>> 16) & 65535) << 16) & 4294967295;
    h1 ^= h1 >>> 13;
    h1 = 3266489909 * (h1 & 65535) + ((3266489909 * (h1 >>> 16) & 65535) << 16) & 4294967295;
    return (h1 ^ h1 >>> 16) >>> 0;
  }
  var channel = new MessageChannel(), taskQueue = [];
  channel.port1.onmessage = function() {
    var task = taskQueue.shift();
    task && task();
  };
  function scheduleWork(callback) {
    taskQueue.push(callback);
    channel.port2.postMessage(null);
  }
  function handleErrorInNextTick(error) {
    setTimeout(function() {
      throw error;
    });
  }
  var LocalPromise = Promise, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    LocalPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
  }, currentView = null, writtenBytes = 0;
  function writeChunk(destination, chunk) {
    if (0 !== chunk.byteLength)
      if (2048 < chunk.byteLength)
        0 < writtenBytes && (destination.enqueue(
          new Uint8Array(currentView.buffer, 0, writtenBytes)
        ), currentView = new Uint8Array(2048), writtenBytes = 0), destination.enqueue(chunk);
      else {
        var allowableBytes = currentView.length - writtenBytes;
        allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue(currentView) : (currentView.set(chunk.subarray(0, allowableBytes), writtenBytes), destination.enqueue(currentView), chunk = chunk.subarray(allowableBytes)), currentView = new Uint8Array(2048), writtenBytes = 0);
        currentView.set(chunk, writtenBytes);
        writtenBytes += chunk.byteLength;
      }
  }
  function writeChunkAndReturn(destination, chunk) {
    writeChunk(destination, chunk);
    return true;
  }
  function completeWriting(destination) {
    currentView && 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = null, writtenBytes = 0);
  }
  var textEncoder = new TextEncoder();
  function stringToChunk(content) {
    return textEncoder.encode(content);
  }
  function stringToPrecomputedChunk(content) {
    return textEncoder.encode(content);
  }
  function closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
  }
  var assign = Object.assign, hasOwnProperty = Object.prototype.hasOwnProperty, VALID_ATTRIBUTE_NAME_REGEX = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
  function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName))
      return true;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName))
      return validatedAttributeNameCache[attributeName] = true;
    illegalAttributeNameCache[attributeName] = true;
    return false;
  }
  var unitlessNumbers = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  ), aliases = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), matchHtmlRegExp = /["'&<>]/;
  function escapeTextForBrowser(text) {
    if ("boolean" === typeof text || "number" === typeof text || "bigint" === typeof text)
      return "" + text;
    text = "" + text;
    var match = matchHtmlRegExp.exec(text);
    if (match) {
      var html = "", index, lastIndex = 0;
      for (index = match.index; index < text.length; index++) {
        switch (text.charCodeAt(index)) {
          case 34:
            match = "&quot;";
            break;
          case 38:
            match = "&amp;";
            break;
          case 39:
            match = "&#x27;";
            break;
          case 60:
            match = "&lt;";
            break;
          case 62:
            match = "&gt;";
            break;
          default:
            continue;
        }
        lastIndex !== index && (html += text.slice(lastIndex, index));
        lastIndex = index + 1;
        html += match;
      }
      text = lastIndex !== index ? html + text.slice(lastIndex, index) : html;
    }
    return text;
  }
  var uppercasePattern = /([A-Z])/g, msPattern = /^ms-/, isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
  }
  var ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: false,
    data: null,
    method: null,
    action: null
  }, previousDispatcher = ReactDOMSharedInternals.d;
  ReactDOMSharedInternals.d = {
    f: previousDispatcher.f,
    r: previousDispatcher.r,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
  };
  var PRELOAD_NO_CREDS = [];
  stringToPrecomputedChunk('"></template>');
  var startInlineScript = stringToPrecomputedChunk("<script>"), endInlineScript = stringToPrecomputedChunk("<\/script>"), startScriptSrc = stringToPrecomputedChunk('<script src="'), startModuleSrc = stringToPrecomputedChunk('<script type="module" src="'), scriptNonce = stringToPrecomputedChunk('" nonce="'), scriptIntegirty = stringToPrecomputedChunk('" integrity="'), scriptCrossOrigin = stringToPrecomputedChunk('" crossorigin="'), endAsyncScript = stringToPrecomputedChunk('" async=""><\/script>'), scriptRegex = /(<\/|<)(s)(cript)/gi;
  function scriptReplacer(match, prefix2, s, suffix2) {
    return "" + prefix2 + ("s" === s ? "\\u0073" : "\\u0053") + suffix2;
  }
  var importMapScriptStart = stringToPrecomputedChunk(
    '<script type="importmap">'
  ), importMapScriptEnd = stringToPrecomputedChunk("<\/script>");
  function createRenderState(resumableState, nonce, externalRuntimeConfig, importMap, onHeaders, maxHeadersLength) {
    var inlineScriptWithNonce = void 0 === nonce ? startInlineScript : stringToPrecomputedChunk(
      '<script nonce="' + escapeTextForBrowser(nonce) + '">'
    ), idPrefix = resumableState.idPrefix;
    externalRuntimeConfig = [];
    var bootstrapScriptContent = resumableState.bootstrapScriptContent, bootstrapScripts = resumableState.bootstrapScripts, bootstrapModules = resumableState.bootstrapModules;
    void 0 !== bootstrapScriptContent && externalRuntimeConfig.push(
      inlineScriptWithNonce,
      stringToChunk(
        ("" + bootstrapScriptContent).replace(scriptRegex, scriptReplacer)
      ),
      endInlineScript
    );
    bootstrapScriptContent = [];
    void 0 !== importMap && (bootstrapScriptContent.push(importMapScriptStart), bootstrapScriptContent.push(
      stringToChunk(
        ("" + JSON.stringify(importMap)).replace(scriptRegex, scriptReplacer)
      )
    ), bootstrapScriptContent.push(importMapScriptEnd));
    importMap = onHeaders ? {
      preconnects: "",
      fontPreloads: "",
      highImagePreloads: "",
      remainingCapacity: 2 + ("number" === typeof maxHeadersLength ? maxHeadersLength : 2e3)
    } : null;
    onHeaders = {
      placeholderPrefix: stringToPrecomputedChunk(idPrefix + "P:"),
      segmentPrefix: stringToPrecomputedChunk(idPrefix + "S:"),
      boundaryPrefix: stringToPrecomputedChunk(idPrefix + "B:"),
      startInlineScript: inlineScriptWithNonce,
      preamble: createPreambleState(),
      externalRuntimeScript: null,
      bootstrapChunks: externalRuntimeConfig,
      importMapChunks: bootstrapScriptContent,
      onHeaders,
      headers: importMap,
      resets: {
        font: {},
        dns: {},
        connect: { default: {}, anonymous: {}, credentials: {} },
        image: {},
        style: {}
      },
      charsetChunks: [],
      viewportChunks: [],
      hoistableChunks: [],
      preconnects: /* @__PURE__ */ new Set(),
      fontPreloads: /* @__PURE__ */ new Set(),
      highImagePreloads: /* @__PURE__ */ new Set(),
      styles: /* @__PURE__ */ new Map(),
      bootstrapScripts: /* @__PURE__ */ new Set(),
      scripts: /* @__PURE__ */ new Set(),
      bulkPreloads: /* @__PURE__ */ new Set(),
      preloads: {
        images: /* @__PURE__ */ new Map(),
        stylesheets: /* @__PURE__ */ new Map(),
        scripts: /* @__PURE__ */ new Map(),
        moduleScripts: /* @__PURE__ */ new Map()
      },
      nonce,
      hoistableState: null,
      stylesToHoist: false
    };
    if (void 0 !== bootstrapScripts)
      for (importMap = 0; importMap < bootstrapScripts.length; importMap++) {
        var scriptConfig = bootstrapScripts[importMap];
        idPrefix = inlineScriptWithNonce = void 0;
        bootstrapScriptContent = {
          rel: "preload",
          as: "script",
          fetchPriority: "low",
          nonce
        };
        "string" === typeof scriptConfig ? bootstrapScriptContent.href = maxHeadersLength = scriptConfig : (bootstrapScriptContent.href = maxHeadersLength = scriptConfig.src, bootstrapScriptContent.integrity = idPrefix = "string" === typeof scriptConfig.integrity ? scriptConfig.integrity : void 0, bootstrapScriptContent.crossOrigin = inlineScriptWithNonce = "string" === typeof scriptConfig || null == scriptConfig.crossOrigin ? void 0 : "use-credentials" === scriptConfig.crossOrigin ? "use-credentials" : "");
        scriptConfig = resumableState;
        var href = maxHeadersLength;
        scriptConfig.scriptResources[href] = null;
        scriptConfig.moduleScriptResources[href] = null;
        scriptConfig = [];
        pushLinkImpl(scriptConfig, bootstrapScriptContent);
        onHeaders.bootstrapScripts.add(scriptConfig);
        externalRuntimeConfig.push(
          startScriptSrc,
          stringToChunk(escapeTextForBrowser(maxHeadersLength))
        );
        nonce && externalRuntimeConfig.push(
          scriptNonce,
          stringToChunk(escapeTextForBrowser(nonce))
        );
        "string" === typeof idPrefix && externalRuntimeConfig.push(
          scriptIntegirty,
          stringToChunk(escapeTextForBrowser(idPrefix))
        );
        "string" === typeof inlineScriptWithNonce && externalRuntimeConfig.push(
          scriptCrossOrigin,
          stringToChunk(escapeTextForBrowser(inlineScriptWithNonce))
        );
        externalRuntimeConfig.push(endAsyncScript);
      }
    if (void 0 !== bootstrapModules)
      for (bootstrapScripts = 0; bootstrapScripts < bootstrapModules.length; bootstrapScripts++)
        bootstrapScriptContent = bootstrapModules[bootstrapScripts], inlineScriptWithNonce = maxHeadersLength = void 0, idPrefix = {
          rel: "modulepreload",
          fetchPriority: "low",
          nonce
        }, "string" === typeof bootstrapScriptContent ? idPrefix.href = importMap = bootstrapScriptContent : (idPrefix.href = importMap = bootstrapScriptContent.src, idPrefix.integrity = inlineScriptWithNonce = "string" === typeof bootstrapScriptContent.integrity ? bootstrapScriptContent.integrity : void 0, idPrefix.crossOrigin = maxHeadersLength = "string" === typeof bootstrapScriptContent || null == bootstrapScriptContent.crossOrigin ? void 0 : "use-credentials" === bootstrapScriptContent.crossOrigin ? "use-credentials" : ""), bootstrapScriptContent = resumableState, scriptConfig = importMap, bootstrapScriptContent.scriptResources[scriptConfig] = null, bootstrapScriptContent.moduleScriptResources[scriptConfig] = null, bootstrapScriptContent = [], pushLinkImpl(bootstrapScriptContent, idPrefix), onHeaders.bootstrapScripts.add(bootstrapScriptContent), externalRuntimeConfig.push(
          startModuleSrc,
          stringToChunk(escapeTextForBrowser(importMap))
        ), nonce && externalRuntimeConfig.push(
          scriptNonce,
          stringToChunk(escapeTextForBrowser(nonce))
        ), "string" === typeof inlineScriptWithNonce && externalRuntimeConfig.push(
          scriptIntegirty,
          stringToChunk(escapeTextForBrowser(inlineScriptWithNonce))
        ), "string" === typeof maxHeadersLength && externalRuntimeConfig.push(
          scriptCrossOrigin,
          stringToChunk(escapeTextForBrowser(maxHeadersLength))
        ), externalRuntimeConfig.push(endAsyncScript);
    return onHeaders;
  }
  function createResumableState(identifierPrefix, externalRuntimeConfig, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
    return {
      idPrefix: void 0 === identifierPrefix ? "" : identifierPrefix,
      nextFormID: 0,
      streamingFormat: 0,
      bootstrapScriptContent,
      bootstrapScripts,
      bootstrapModules,
      instructions: 0,
      hasBody: false,
      hasHtml: false,
      unknownResources: {},
      dnsResources: {},
      connectResources: { default: {}, anonymous: {}, credentials: {} },
      imageResources: {},
      styleResources: {},
      scriptResources: {},
      moduleUnknownResources: {},
      moduleScriptResources: {}
    };
  }
  function createPreambleState() {
    return {
      htmlChunks: null,
      headChunks: null,
      bodyChunks: null,
      contribution: 0
    };
  }
  function createFormatContext(insertionMode, selectedValue, tagScope) {
    return {
      insertionMode,
      selectedValue,
      tagScope
    };
  }
  function createRootFormatContext(namespaceURI) {
    return createFormatContext(
      "http://www.w3.org/2000/svg" === namespaceURI ? 4 : "http://www.w3.org/1998/Math/MathML" === namespaceURI ? 5 : 0,
      null,
      0
    );
  }
  function getChildFormatContext(parentContext, type, props) {
    switch (type) {
      case "noscript":
        return createFormatContext(2, null, parentContext.tagScope | 1);
      case "select":
        return createFormatContext(
          2,
          null != props.value ? props.value : props.defaultValue,
          parentContext.tagScope
        );
      case "svg":
        return createFormatContext(4, null, parentContext.tagScope);
      case "picture":
        return createFormatContext(2, null, parentContext.tagScope | 2);
      case "math":
        return createFormatContext(5, null, parentContext.tagScope);
      case "foreignObject":
        return createFormatContext(2, null, parentContext.tagScope);
      case "table":
        return createFormatContext(6, null, parentContext.tagScope);
      case "thead":
      case "tbody":
      case "tfoot":
        return createFormatContext(7, null, parentContext.tagScope);
      case "colgroup":
        return createFormatContext(9, null, parentContext.tagScope);
      case "tr":
        return createFormatContext(8, null, parentContext.tagScope);
      case "head":
        if (2 > parentContext.insertionMode)
          return createFormatContext(3, null, parentContext.tagScope);
        break;
      case "html":
        if (0 === parentContext.insertionMode)
          return createFormatContext(1, null, parentContext.tagScope);
    }
    return 6 <= parentContext.insertionMode || 2 > parentContext.insertionMode ? createFormatContext(2, null, parentContext.tagScope) : parentContext;
  }
  var textSeparator = stringToPrecomputedChunk("<!-- -->");
  function pushTextInstance(target, text, renderState, textEmbedded) {
    if ("" === text) return textEmbedded;
    textEmbedded && target.push(textSeparator);
    target.push(stringToChunk(escapeTextForBrowser(text)));
    return true;
  }
  var styleNameCache = /* @__PURE__ */ new Map(), styleAttributeStart = stringToPrecomputedChunk(' style="'), styleAssign = stringToPrecomputedChunk(":"), styleSeparator = stringToPrecomputedChunk(";");
  function pushStyleAttribute(target, style) {
    if ("object" !== typeof style) throw Error(formatProdErrorMessage(62));
    var isFirst = true, styleName;
    for (styleName in style)
      if (hasOwnProperty.call(style, styleName)) {
        var styleValue = style[styleName];
        if (null != styleValue && "boolean" !== typeof styleValue && "" !== styleValue) {
          if (0 === styleName.indexOf("--")) {
            var nameChunk = stringToChunk(escapeTextForBrowser(styleName));
            styleValue = stringToChunk(
              escapeTextForBrowser(("" + styleValue).trim())
            );
          } else
            nameChunk = styleNameCache.get(styleName), void 0 === nameChunk && (nameChunk = stringToPrecomputedChunk(
              escapeTextForBrowser(
                styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-")
              )
            ), styleNameCache.set(styleName, nameChunk)), styleValue = "number" === typeof styleValue ? 0 === styleValue || unitlessNumbers.has(styleName) ? stringToChunk("" + styleValue) : stringToChunk(styleValue + "px") : stringToChunk(
              escapeTextForBrowser(("" + styleValue).trim())
            );
          isFirst ? (isFirst = false, target.push(
            styleAttributeStart,
            nameChunk,
            styleAssign,
            styleValue
          )) : target.push(styleSeparator, nameChunk, styleAssign, styleValue);
        }
      }
    isFirst || target.push(attributeEnd);
  }
  var attributeSeparator = stringToPrecomputedChunk(" "), attributeAssign = stringToPrecomputedChunk('="'), attributeEnd = stringToPrecomputedChunk('"'), attributeEmptyString = stringToPrecomputedChunk('=""');
  function pushBooleanAttribute(target, name, value) {
    value && "function" !== typeof value && "symbol" !== typeof value && target.push(attributeSeparator, stringToChunk(name), attributeEmptyString);
  }
  function pushStringAttribute(target, name, value) {
    "function" !== typeof value && "symbol" !== typeof value && "boolean" !== typeof value && target.push(
      attributeSeparator,
      stringToChunk(name),
      attributeAssign,
      stringToChunk(escapeTextForBrowser(value)),
      attributeEnd
    );
  }
  var actionJavaScriptURL = stringToPrecomputedChunk(
    escapeTextForBrowser(
      "javascript:throw new Error('React form unexpectedly submitted.')"
    )
  ), startHiddenInputChunk = stringToPrecomputedChunk('<input type="hidden"');
  function pushAdditionalFormField(value, key) {
    this.push(startHiddenInputChunk);
    validateAdditionalFormField(value);
    pushStringAttribute(this, "name", key);
    pushStringAttribute(this, "value", value);
    this.push(endOfStartTagSelfClosing);
  }
  function validateAdditionalFormField(value) {
    if ("string" !== typeof value) throw Error(formatProdErrorMessage(480));
  }
  function getCustomFormFields(resumableState, formAction) {
    if ("function" === typeof formAction.$$FORM_ACTION) {
      var id = resumableState.nextFormID++;
      resumableState = resumableState.idPrefix + id;
      try {
        var customFields = formAction.$$FORM_ACTION(resumableState);
        if (customFields) {
          var formData = customFields.data;
          null != formData && formData.forEach(validateAdditionalFormField);
        }
        return customFields;
      } catch (x) {
        if ("object" === typeof x && null !== x && "function" === typeof x.then)
          throw x;
      }
    }
    return null;
  }
  function pushFormActionAttribute(target, resumableState, renderState, formAction, formEncType, formMethod, formTarget, name) {
    var formData = null;
    if ("function" === typeof formAction) {
      var customFields = getCustomFormFields(resumableState, formAction);
      null !== customFields ? (name = customFields.name, formAction = customFields.action || "", formEncType = customFields.encType, formMethod = customFields.method, formTarget = customFields.target, formData = customFields.data) : (target.push(
        attributeSeparator,
        stringToChunk("formAction"),
        attributeAssign,
        actionJavaScriptURL,
        attributeEnd
      ), formTarget = formMethod = formEncType = formAction = name = null, injectFormReplayingRuntime(resumableState, renderState));
    }
    null != name && pushAttribute(target, "name", name);
    null != formAction && pushAttribute(target, "formAction", formAction);
    null != formEncType && pushAttribute(target, "formEncType", formEncType);
    null != formMethod && pushAttribute(target, "formMethod", formMethod);
    null != formTarget && pushAttribute(target, "formTarget", formTarget);
    return formData;
  }
  function pushAttribute(target, name, value) {
    switch (name) {
      case "className":
        pushStringAttribute(target, "class", value);
        break;
      case "tabIndex":
        pushStringAttribute(target, "tabindex", value);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        pushStringAttribute(target, name, value);
        break;
      case "style":
        pushStyleAttribute(target, value);
        break;
      case "src":
      case "href":
        if ("" === value) break;
      case "action":
      case "formAction":
        if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value)
          break;
        value = sanitizeURL("" + value);
        target.push(
          attributeSeparator,
          stringToChunk(name),
          attributeAssign,
          stringToChunk(escapeTextForBrowser(value)),
          attributeEnd
        );
        break;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "ref":
        break;
      case "autoFocus":
      case "multiple":
      case "muted":
        pushBooleanAttribute(target, name.toLowerCase(), value);
        break;
      case "xlinkHref":
        if ("function" === typeof value || "symbol" === typeof value || "boolean" === typeof value)
          break;
        value = sanitizeURL("" + value);
        target.push(
          attributeSeparator,
          stringToChunk("xlink:href"),
          attributeAssign,
          stringToChunk(escapeTextForBrowser(value)),
          attributeEnd
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        "function" !== typeof value && "symbol" !== typeof value && target.push(
          attributeSeparator,
          stringToChunk(name),
          attributeAssign,
          stringToChunk(escapeTextForBrowser(value)),
          attributeEnd
        );
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        value && "function" !== typeof value && "symbol" !== typeof value && target.push(
          attributeSeparator,
          stringToChunk(name),
          attributeEmptyString
        );
        break;
      case "capture":
      case "download":
        true === value ? target.push(
          attributeSeparator,
          stringToChunk(name),
          attributeEmptyString
        ) : false !== value && "function" !== typeof value && "symbol" !== typeof value && target.push(
          attributeSeparator,
          stringToChunk(name),
          attributeAssign,
          stringToChunk(escapeTextForBrowser(value)),
          attributeEnd
        );
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value && target.push(
          attributeSeparator,
          stringToChunk(name),
          attributeAssign,
          stringToChunk(escapeTextForBrowser(value)),
          attributeEnd
        );
        break;
      case "rowSpan":
      case "start":
        "function" === typeof value || "symbol" === typeof value || isNaN(value) || target.push(
          attributeSeparator,
          stringToChunk(name),
          attributeAssign,
          stringToChunk(escapeTextForBrowser(value)),
          attributeEnd
        );
        break;
      case "xlinkActuate":
        pushStringAttribute(target, "xlink:actuate", value);
        break;
      case "xlinkArcrole":
        pushStringAttribute(target, "xlink:arcrole", value);
        break;
      case "xlinkRole":
        pushStringAttribute(target, "xlink:role", value);
        break;
      case "xlinkShow":
        pushStringAttribute(target, "xlink:show", value);
        break;
      case "xlinkTitle":
        pushStringAttribute(target, "xlink:title", value);
        break;
      case "xlinkType":
        pushStringAttribute(target, "xlink:type", value);
        break;
      case "xmlBase":
        pushStringAttribute(target, "xml:base", value);
        break;
      case "xmlLang":
        pushStringAttribute(target, "xml:lang", value);
        break;
      case "xmlSpace":
        pushStringAttribute(target, "xml:space", value);
        break;
      default:
        if (!(2 < name.length) || "o" !== name[0] && "O" !== name[0] || "n" !== name[1] && "N" !== name[1]) {
          if (name = aliases.get(name) || name, isAttributeNameSafe(name)) {
            switch (typeof value) {
              case "function":
              case "symbol":
                return;
              case "boolean":
                var prefix$8 = name.toLowerCase().slice(0, 5);
                if ("data-" !== prefix$8 && "aria-" !== prefix$8) return;
            }
            target.push(
              attributeSeparator,
              stringToChunk(name),
              attributeAssign,
              stringToChunk(escapeTextForBrowser(value)),
              attributeEnd
            );
          }
        }
    }
  }
  var endOfStartTag = stringToPrecomputedChunk(">"), endOfStartTagSelfClosing = stringToPrecomputedChunk("/>");
  function pushInnerHTML(target, innerHTML, children) {
    if (null != innerHTML) {
      if (null != children) throw Error(formatProdErrorMessage(60));
      if ("object" !== typeof innerHTML || !("__html" in innerHTML))
        throw Error(formatProdErrorMessage(61));
      innerHTML = innerHTML.__html;
      null !== innerHTML && void 0 !== innerHTML && target.push(stringToChunk("" + innerHTML));
    }
  }
  function flattenOptionChildren(children) {
    var content = "";
    React2.Children.forEach(children, function(child) {
      null != child && (content += child);
    });
    return content;
  }
  var selectedMarkerAttribute = stringToPrecomputedChunk(' selected=""'), formReplayingRuntimeScript = stringToPrecomputedChunk(
    `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`
  );
  function injectFormReplayingRuntime(resumableState, renderState) {
    0 === (resumableState.instructions & 16) && (resumableState.instructions |= 16, renderState.bootstrapChunks.unshift(
      renderState.startInlineScript,
      formReplayingRuntimeScript,
      endInlineScript
    ));
  }
  var formStateMarkerIsMatching = stringToPrecomputedChunk("<!--F!-->"), formStateMarkerIsNotMatching = stringToPrecomputedChunk("<!--F-->");
  function pushLinkImpl(target, props) {
    target.push(startChunkForTag("link"));
    for (var propKey in props)
      if (hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue)
          switch (propKey) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(formatProdErrorMessage(399, "link"));
            default:
              pushAttribute(target, propKey, propValue);
          }
      }
    target.push(endOfStartTagSelfClosing);
    return null;
  }
  var styleRegex = /(<\/|<)(s)(tyle)/gi;
  function styleReplacer(match, prefix2, s, suffix2) {
    return "" + prefix2 + ("s" === s ? "\\73 " : "\\53 ") + suffix2;
  }
  function pushSelfClosing(target, props, tag) {
    target.push(startChunkForTag(tag));
    for (var propKey in props)
      if (hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue)
          switch (propKey) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(formatProdErrorMessage(399, tag));
            default:
              pushAttribute(target, propKey, propValue);
          }
      }
    target.push(endOfStartTagSelfClosing);
    return null;
  }
  function pushTitleImpl(target, props) {
    target.push(startChunkForTag("title"));
    var children = null, innerHTML = null, propKey;
    for (propKey in props)
      if (hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue)
          switch (propKey) {
            case "children":
              children = propValue;
              break;
            case "dangerouslySetInnerHTML":
              innerHTML = propValue;
              break;
            default:
              pushAttribute(target, propKey, propValue);
          }
      }
    target.push(endOfStartTag);
    props = Array.isArray(children) ? 2 > children.length ? children[0] : null : children;
    "function" !== typeof props && "symbol" !== typeof props && null !== props && void 0 !== props && target.push(stringToChunk(escapeTextForBrowser("" + props)));
    pushInnerHTML(target, innerHTML, children);
    target.push(endChunkForTag("title"));
    return null;
  }
  function pushScriptImpl(target, props) {
    target.push(startChunkForTag("script"));
    var children = null, innerHTML = null, propKey;
    for (propKey in props)
      if (hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue)
          switch (propKey) {
            case "children":
              children = propValue;
              break;
            case "dangerouslySetInnerHTML":
              innerHTML = propValue;
              break;
            default:
              pushAttribute(target, propKey, propValue);
          }
      }
    target.push(endOfStartTag);
    pushInnerHTML(target, innerHTML, children);
    "string" === typeof children && target.push(
      stringToChunk(("" + children).replace(scriptRegex, scriptReplacer))
    );
    target.push(endChunkForTag("script"));
    return null;
  }
  function pushStartSingletonElement(target, props, tag) {
    target.push(startChunkForTag(tag));
    var innerHTML = tag = null, propKey;
    for (propKey in props)
      if (hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue)
          switch (propKey) {
            case "children":
              tag = propValue;
              break;
            case "dangerouslySetInnerHTML":
              innerHTML = propValue;
              break;
            default:
              pushAttribute(target, propKey, propValue);
          }
      }
    target.push(endOfStartTag);
    pushInnerHTML(target, innerHTML, tag);
    return tag;
  }
  function pushStartGenericElement(target, props, tag) {
    target.push(startChunkForTag(tag));
    var innerHTML = tag = null, propKey;
    for (propKey in props)
      if (hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue)
          switch (propKey) {
            case "children":
              tag = propValue;
              break;
            case "dangerouslySetInnerHTML":
              innerHTML = propValue;
              break;
            default:
              pushAttribute(target, propKey, propValue);
          }
      }
    target.push(endOfStartTag);
    pushInnerHTML(target, innerHTML, tag);
    return "string" === typeof tag ? (target.push(stringToChunk(escapeTextForBrowser(tag))), null) : tag;
  }
  var leadingNewline = stringToPrecomputedChunk("\n"), VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, validatedTagCache = /* @__PURE__ */ new Map();
  function startChunkForTag(tag) {
    var tagStartChunk = validatedTagCache.get(tag);
    if (void 0 === tagStartChunk) {
      if (!VALID_TAG_REGEX.test(tag))
        throw Error(formatProdErrorMessage(65, tag));
      tagStartChunk = stringToPrecomputedChunk("<" + tag);
      validatedTagCache.set(tag, tagStartChunk);
    }
    return tagStartChunk;
  }
  var doctypeChunk = stringToPrecomputedChunk("<!DOCTYPE html>");
  function pushStartInstance(target$jscomp$0, type, props, resumableState, renderState, preambleState, hoistableState, formatContext, textEmbedded, isFallback) {
    switch (type) {
      case "div":
      case "span":
      case "svg":
      case "path":
        break;
      case "a":
        target$jscomp$0.push(startChunkForTag("a"));
        var children = null, innerHTML = null, propKey;
        for (propKey in props)
          if (hasOwnProperty.call(props, propKey)) {
            var propValue = props[propKey];
            if (null != propValue)
              switch (propKey) {
                case "children":
                  children = propValue;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML = propValue;
                  break;
                case "href":
                  "" === propValue ? pushStringAttribute(target$jscomp$0, "href", "") : pushAttribute(target$jscomp$0, propKey, propValue);
                  break;
                default:
                  pushAttribute(target$jscomp$0, propKey, propValue);
              }
          }
        target$jscomp$0.push(endOfStartTag);
        pushInnerHTML(target$jscomp$0, innerHTML, children);
        if ("string" === typeof children) {
          target$jscomp$0.push(stringToChunk(escapeTextForBrowser(children)));
          var JSCompiler_inline_result = null;
        } else JSCompiler_inline_result = children;
        return JSCompiler_inline_result;
      case "g":
      case "p":
      case "li":
        break;
      case "select":
        target$jscomp$0.push(startChunkForTag("select"));
        var children$jscomp$0 = null, innerHTML$jscomp$0 = null, propKey$jscomp$0;
        for (propKey$jscomp$0 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$0)) {
            var propValue$jscomp$0 = props[propKey$jscomp$0];
            if (null != propValue$jscomp$0)
              switch (propKey$jscomp$0) {
                case "children":
                  children$jscomp$0 = propValue$jscomp$0;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML$jscomp$0 = propValue$jscomp$0;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$0,
                    propValue$jscomp$0
                  );
              }
          }
        target$jscomp$0.push(endOfStartTag);
        pushInnerHTML(target$jscomp$0, innerHTML$jscomp$0, children$jscomp$0);
        return children$jscomp$0;
      case "option":
        var selectedValue = formatContext.selectedValue;
        target$jscomp$0.push(startChunkForTag("option"));
        var children$jscomp$1 = null, value = null, selected = null, innerHTML$jscomp$1 = null, propKey$jscomp$1;
        for (propKey$jscomp$1 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$1)) {
            var propValue$jscomp$1 = props[propKey$jscomp$1];
            if (null != propValue$jscomp$1)
              switch (propKey$jscomp$1) {
                case "children":
                  children$jscomp$1 = propValue$jscomp$1;
                  break;
                case "selected":
                  selected = propValue$jscomp$1;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML$jscomp$1 = propValue$jscomp$1;
                  break;
                case "value":
                  value = propValue$jscomp$1;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$1,
                    propValue$jscomp$1
                  );
              }
          }
        if (null != selectedValue) {
          var stringValue = null !== value ? "" + value : flattenOptionChildren(children$jscomp$1);
          if (isArrayImpl(selectedValue))
            for (var i = 0; i < selectedValue.length; i++) {
              if ("" + selectedValue[i] === stringValue) {
                target$jscomp$0.push(selectedMarkerAttribute);
                break;
              }
            }
          else
            "" + selectedValue === stringValue && target$jscomp$0.push(selectedMarkerAttribute);
        } else selected && target$jscomp$0.push(selectedMarkerAttribute);
        target$jscomp$0.push(endOfStartTag);
        pushInnerHTML(target$jscomp$0, innerHTML$jscomp$1, children$jscomp$1);
        return children$jscomp$1;
      case "textarea":
        target$jscomp$0.push(startChunkForTag("textarea"));
        var value$jscomp$0 = null, defaultValue = null, children$jscomp$2 = null, propKey$jscomp$2;
        for (propKey$jscomp$2 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$2)) {
            var propValue$jscomp$2 = props[propKey$jscomp$2];
            if (null != propValue$jscomp$2)
              switch (propKey$jscomp$2) {
                case "children":
                  children$jscomp$2 = propValue$jscomp$2;
                  break;
                case "value":
                  value$jscomp$0 = propValue$jscomp$2;
                  break;
                case "defaultValue":
                  defaultValue = propValue$jscomp$2;
                  break;
                case "dangerouslySetInnerHTML":
                  throw Error(formatProdErrorMessage(91));
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$2,
                    propValue$jscomp$2
                  );
              }
          }
        null === value$jscomp$0 && null !== defaultValue && (value$jscomp$0 = defaultValue);
        target$jscomp$0.push(endOfStartTag);
        if (null != children$jscomp$2) {
          if (null != value$jscomp$0) throw Error(formatProdErrorMessage(92));
          if (isArrayImpl(children$jscomp$2)) {
            if (1 < children$jscomp$2.length)
              throw Error(formatProdErrorMessage(93));
            value$jscomp$0 = "" + children$jscomp$2[0];
          }
          value$jscomp$0 = "" + children$jscomp$2;
        }
        "string" === typeof value$jscomp$0 && "\n" === value$jscomp$0[0] && target$jscomp$0.push(leadingNewline);
        null !== value$jscomp$0 && target$jscomp$0.push(
          stringToChunk(escapeTextForBrowser("" + value$jscomp$0))
        );
        return null;
      case "input":
        target$jscomp$0.push(startChunkForTag("input"));
        var name = null, formAction = null, formEncType = null, formMethod = null, formTarget = null, value$jscomp$1 = null, defaultValue$jscomp$0 = null, checked = null, defaultChecked = null, propKey$jscomp$3;
        for (propKey$jscomp$3 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$3)) {
            var propValue$jscomp$3 = props[propKey$jscomp$3];
            if (null != propValue$jscomp$3)
              switch (propKey$jscomp$3) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(formatProdErrorMessage(399, "input"));
                case "name":
                  name = propValue$jscomp$3;
                  break;
                case "formAction":
                  formAction = propValue$jscomp$3;
                  break;
                case "formEncType":
                  formEncType = propValue$jscomp$3;
                  break;
                case "formMethod":
                  formMethod = propValue$jscomp$3;
                  break;
                case "formTarget":
                  formTarget = propValue$jscomp$3;
                  break;
                case "defaultChecked":
                  defaultChecked = propValue$jscomp$3;
                  break;
                case "defaultValue":
                  defaultValue$jscomp$0 = propValue$jscomp$3;
                  break;
                case "checked":
                  checked = propValue$jscomp$3;
                  break;
                case "value":
                  value$jscomp$1 = propValue$jscomp$3;
                  break;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$3,
                    propValue$jscomp$3
                  );
              }
          }
        var formData = pushFormActionAttribute(
          target$jscomp$0,
          resumableState,
          renderState,
          formAction,
          formEncType,
          formMethod,
          formTarget,
          name
        );
        null !== checked ? pushBooleanAttribute(target$jscomp$0, "checked", checked) : null !== defaultChecked && pushBooleanAttribute(target$jscomp$0, "checked", defaultChecked);
        null !== value$jscomp$1 ? pushAttribute(target$jscomp$0, "value", value$jscomp$1) : null !== defaultValue$jscomp$0 && pushAttribute(target$jscomp$0, "value", defaultValue$jscomp$0);
        target$jscomp$0.push(endOfStartTagSelfClosing);
        null != formData && formData.forEach(pushAdditionalFormField, target$jscomp$0);
        return null;
      case "button":
        target$jscomp$0.push(startChunkForTag("button"));
        var children$jscomp$3 = null, innerHTML$jscomp$2 = null, name$jscomp$0 = null, formAction$jscomp$0 = null, formEncType$jscomp$0 = null, formMethod$jscomp$0 = null, formTarget$jscomp$0 = null, propKey$jscomp$4;
        for (propKey$jscomp$4 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$4)) {
            var propValue$jscomp$4 = props[propKey$jscomp$4];
            if (null != propValue$jscomp$4)
              switch (propKey$jscomp$4) {
                case "children":
                  children$jscomp$3 = propValue$jscomp$4;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML$jscomp$2 = propValue$jscomp$4;
                  break;
                case "name":
                  name$jscomp$0 = propValue$jscomp$4;
                  break;
                case "formAction":
                  formAction$jscomp$0 = propValue$jscomp$4;
                  break;
                case "formEncType":
                  formEncType$jscomp$0 = propValue$jscomp$4;
                  break;
                case "formMethod":
                  formMethod$jscomp$0 = propValue$jscomp$4;
                  break;
                case "formTarget":
                  formTarget$jscomp$0 = propValue$jscomp$4;
                  break;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$4,
                    propValue$jscomp$4
                  );
              }
          }
        var formData$jscomp$0 = pushFormActionAttribute(
          target$jscomp$0,
          resumableState,
          renderState,
          formAction$jscomp$0,
          formEncType$jscomp$0,
          formMethod$jscomp$0,
          formTarget$jscomp$0,
          name$jscomp$0
        );
        target$jscomp$0.push(endOfStartTag);
        null != formData$jscomp$0 && formData$jscomp$0.forEach(pushAdditionalFormField, target$jscomp$0);
        pushInnerHTML(target$jscomp$0, innerHTML$jscomp$2, children$jscomp$3);
        if ("string" === typeof children$jscomp$3) {
          target$jscomp$0.push(
            stringToChunk(escapeTextForBrowser(children$jscomp$3))
          );
          var JSCompiler_inline_result$jscomp$0 = null;
        } else JSCompiler_inline_result$jscomp$0 = children$jscomp$3;
        return JSCompiler_inline_result$jscomp$0;
      case "form":
        target$jscomp$0.push(startChunkForTag("form"));
        var children$jscomp$4 = null, innerHTML$jscomp$3 = null, formAction$jscomp$1 = null, formEncType$jscomp$1 = null, formMethod$jscomp$1 = null, formTarget$jscomp$1 = null, propKey$jscomp$5;
        for (propKey$jscomp$5 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$5)) {
            var propValue$jscomp$5 = props[propKey$jscomp$5];
            if (null != propValue$jscomp$5)
              switch (propKey$jscomp$5) {
                case "children":
                  children$jscomp$4 = propValue$jscomp$5;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML$jscomp$3 = propValue$jscomp$5;
                  break;
                case "action":
                  formAction$jscomp$1 = propValue$jscomp$5;
                  break;
                case "encType":
                  formEncType$jscomp$1 = propValue$jscomp$5;
                  break;
                case "method":
                  formMethod$jscomp$1 = propValue$jscomp$5;
                  break;
                case "target":
                  formTarget$jscomp$1 = propValue$jscomp$5;
                  break;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$5,
                    propValue$jscomp$5
                  );
              }
          }
        var formData$jscomp$1 = null, formActionName = null;
        if ("function" === typeof formAction$jscomp$1) {
          var customFields = getCustomFormFields(
            resumableState,
            formAction$jscomp$1
          );
          null !== customFields ? (formAction$jscomp$1 = customFields.action || "", formEncType$jscomp$1 = customFields.encType, formMethod$jscomp$1 = customFields.method, formTarget$jscomp$1 = customFields.target, formData$jscomp$1 = customFields.data, formActionName = customFields.name) : (target$jscomp$0.push(
            attributeSeparator,
            stringToChunk("action"),
            attributeAssign,
            actionJavaScriptURL,
            attributeEnd
          ), formTarget$jscomp$1 = formMethod$jscomp$1 = formEncType$jscomp$1 = formAction$jscomp$1 = null, injectFormReplayingRuntime(resumableState, renderState));
        }
        null != formAction$jscomp$1 && pushAttribute(target$jscomp$0, "action", formAction$jscomp$1);
        null != formEncType$jscomp$1 && pushAttribute(target$jscomp$0, "encType", formEncType$jscomp$1);
        null != formMethod$jscomp$1 && pushAttribute(target$jscomp$0, "method", formMethod$jscomp$1);
        null != formTarget$jscomp$1 && pushAttribute(target$jscomp$0, "target", formTarget$jscomp$1);
        target$jscomp$0.push(endOfStartTag);
        null !== formActionName && (target$jscomp$0.push(startHiddenInputChunk), pushStringAttribute(target$jscomp$0, "name", formActionName), target$jscomp$0.push(endOfStartTagSelfClosing), null != formData$jscomp$1 && formData$jscomp$1.forEach(pushAdditionalFormField, target$jscomp$0));
        pushInnerHTML(target$jscomp$0, innerHTML$jscomp$3, children$jscomp$4);
        if ("string" === typeof children$jscomp$4) {
          target$jscomp$0.push(
            stringToChunk(escapeTextForBrowser(children$jscomp$4))
          );
          var JSCompiler_inline_result$jscomp$1 = null;
        } else JSCompiler_inline_result$jscomp$1 = children$jscomp$4;
        return JSCompiler_inline_result$jscomp$1;
      case "menuitem":
        target$jscomp$0.push(startChunkForTag("menuitem"));
        for (var propKey$jscomp$6 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$6)) {
            var propValue$jscomp$6 = props[propKey$jscomp$6];
            if (null != propValue$jscomp$6)
              switch (propKey$jscomp$6) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(formatProdErrorMessage(400));
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$6,
                    propValue$jscomp$6
                  );
              }
          }
        target$jscomp$0.push(endOfStartTag);
        return null;
      case "object":
        target$jscomp$0.push(startChunkForTag("object"));
        var children$jscomp$5 = null, innerHTML$jscomp$4 = null, propKey$jscomp$7;
        for (propKey$jscomp$7 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$7)) {
            var propValue$jscomp$7 = props[propKey$jscomp$7];
            if (null != propValue$jscomp$7)
              switch (propKey$jscomp$7) {
                case "children":
                  children$jscomp$5 = propValue$jscomp$7;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML$jscomp$4 = propValue$jscomp$7;
                  break;
                case "data":
                  var sanitizedValue = sanitizeURL("" + propValue$jscomp$7);
                  if ("" === sanitizedValue) break;
                  target$jscomp$0.push(
                    attributeSeparator,
                    stringToChunk("data"),
                    attributeAssign,
                    stringToChunk(escapeTextForBrowser(sanitizedValue)),
                    attributeEnd
                  );
                  break;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$7,
                    propValue$jscomp$7
                  );
              }
          }
        target$jscomp$0.push(endOfStartTag);
        pushInnerHTML(target$jscomp$0, innerHTML$jscomp$4, children$jscomp$5);
        if ("string" === typeof children$jscomp$5) {
          target$jscomp$0.push(
            stringToChunk(escapeTextForBrowser(children$jscomp$5))
          );
          var JSCompiler_inline_result$jscomp$2 = null;
        } else JSCompiler_inline_result$jscomp$2 = children$jscomp$5;
        return JSCompiler_inline_result$jscomp$2;
      case "title":
        if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp)
          var JSCompiler_inline_result$jscomp$3 = pushTitleImpl(
            target$jscomp$0,
            props
          );
        else
          isFallback ? JSCompiler_inline_result$jscomp$3 = null : (pushTitleImpl(renderState.hoistableChunks, props), JSCompiler_inline_result$jscomp$3 = void 0);
        return JSCompiler_inline_result$jscomp$3;
      case "link":
        var rel = props.rel, href = props.href, precedence = props.precedence;
        if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp || "string" !== typeof rel || "string" !== typeof href || "" === href) {
          pushLinkImpl(target$jscomp$0, props);
          var JSCompiler_inline_result$jscomp$4 = null;
        } else if ("stylesheet" === props.rel)
          if ("string" !== typeof precedence || null != props.disabled || props.onLoad || props.onError)
            JSCompiler_inline_result$jscomp$4 = pushLinkImpl(
              target$jscomp$0,
              props
            );
          else {
            var styleQueue = renderState.styles.get(precedence), resourceState = resumableState.styleResources.hasOwnProperty(href) ? resumableState.styleResources[href] : void 0;
            if (null !== resourceState) {
              resumableState.styleResources[href] = null;
              styleQueue || (styleQueue = {
                precedence: stringToChunk(escapeTextForBrowser(precedence)),
                rules: [],
                hrefs: [],
                sheets: /* @__PURE__ */ new Map()
              }, renderState.styles.set(precedence, styleQueue));
              var resource = {
                state: 0,
                props: assign({}, props, {
                  "data-precedence": props.precedence,
                  precedence: null
                })
              };
              if (resourceState) {
                2 === resourceState.length && adoptPreloadCredentials(resource.props, resourceState);
                var preloadResource = renderState.preloads.stylesheets.get(href);
                preloadResource && 0 < preloadResource.length ? preloadResource.length = 0 : resource.state = 1;
              }
              styleQueue.sheets.set(href, resource);
              hoistableState && hoistableState.stylesheets.add(resource);
            } else if (styleQueue) {
              var resource$9 = styleQueue.sheets.get(href);
              resource$9 && hoistableState && hoistableState.stylesheets.add(resource$9);
            }
            textEmbedded && target$jscomp$0.push(textSeparator);
            JSCompiler_inline_result$jscomp$4 = null;
          }
        else
          props.onLoad || props.onError ? JSCompiler_inline_result$jscomp$4 = pushLinkImpl(
            target$jscomp$0,
            props
          ) : (textEmbedded && target$jscomp$0.push(textSeparator), JSCompiler_inline_result$jscomp$4 = isFallback ? null : pushLinkImpl(renderState.hoistableChunks, props));
        return JSCompiler_inline_result$jscomp$4;
      case "script":
        var asyncProp = props.async;
        if ("string" !== typeof props.src || !props.src || !asyncProp || "function" === typeof asyncProp || "symbol" === typeof asyncProp || props.onLoad || props.onError || 4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp)
          var JSCompiler_inline_result$jscomp$5 = pushScriptImpl(
            target$jscomp$0,
            props
          );
        else {
          var key = props.src;
          if ("module" === props.type) {
            var resources = resumableState.moduleScriptResources;
            var preloads = renderState.preloads.moduleScripts;
          } else
            resources = resumableState.scriptResources, preloads = renderState.preloads.scripts;
          var resourceState$jscomp$0 = resources.hasOwnProperty(key) ? resources[key] : void 0;
          if (null !== resourceState$jscomp$0) {
            resources[key] = null;
            var scriptProps = props;
            if (resourceState$jscomp$0) {
              2 === resourceState$jscomp$0.length && (scriptProps = assign({}, props), adoptPreloadCredentials(scriptProps, resourceState$jscomp$0));
              var preloadResource$jscomp$0 = preloads.get(key);
              preloadResource$jscomp$0 && (preloadResource$jscomp$0.length = 0);
            }
            var resource$jscomp$0 = [];
            renderState.scripts.add(resource$jscomp$0);
            pushScriptImpl(resource$jscomp$0, scriptProps);
          }
          textEmbedded && target$jscomp$0.push(textSeparator);
          JSCompiler_inline_result$jscomp$5 = null;
        }
        return JSCompiler_inline_result$jscomp$5;
      case "style":
        var precedence$jscomp$0 = props.precedence, href$jscomp$0 = props.href;
        if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp || "string" !== typeof precedence$jscomp$0 || "string" !== typeof href$jscomp$0 || "" === href$jscomp$0) {
          target$jscomp$0.push(startChunkForTag("style"));
          var children$jscomp$6 = null, innerHTML$jscomp$5 = null, propKey$jscomp$8;
          for (propKey$jscomp$8 in props)
            if (hasOwnProperty.call(props, propKey$jscomp$8)) {
              var propValue$jscomp$8 = props[propKey$jscomp$8];
              if (null != propValue$jscomp$8)
                switch (propKey$jscomp$8) {
                  case "children":
                    children$jscomp$6 = propValue$jscomp$8;
                    break;
                  case "dangerouslySetInnerHTML":
                    innerHTML$jscomp$5 = propValue$jscomp$8;
                    break;
                  default:
                    pushAttribute(
                      target$jscomp$0,
                      propKey$jscomp$8,
                      propValue$jscomp$8
                    );
                }
            }
          target$jscomp$0.push(endOfStartTag);
          var child = Array.isArray(children$jscomp$6) ? 2 > children$jscomp$6.length ? children$jscomp$6[0] : null : children$jscomp$6;
          "function" !== typeof child && "symbol" !== typeof child && null !== child && void 0 !== child && target$jscomp$0.push(
            stringToChunk(("" + child).replace(styleRegex, styleReplacer))
          );
          pushInnerHTML(target$jscomp$0, innerHTML$jscomp$5, children$jscomp$6);
          target$jscomp$0.push(endChunkForTag("style"));
          var JSCompiler_inline_result$jscomp$6 = null;
        } else {
          var styleQueue$jscomp$0 = renderState.styles.get(precedence$jscomp$0);
          if (null !== (resumableState.styleResources.hasOwnProperty(href$jscomp$0) ? resumableState.styleResources[href$jscomp$0] : void 0)) {
            resumableState.styleResources[href$jscomp$0] = null;
            styleQueue$jscomp$0 ? styleQueue$jscomp$0.hrefs.push(
              stringToChunk(escapeTextForBrowser(href$jscomp$0))
            ) : (styleQueue$jscomp$0 = {
              precedence: stringToChunk(
                escapeTextForBrowser(precedence$jscomp$0)
              ),
              rules: [],
              hrefs: [stringToChunk(escapeTextForBrowser(href$jscomp$0))],
              sheets: /* @__PURE__ */ new Map()
            }, renderState.styles.set(precedence$jscomp$0, styleQueue$jscomp$0));
            var target = styleQueue$jscomp$0.rules, children$jscomp$7 = null, innerHTML$jscomp$6 = null, propKey$jscomp$9;
            for (propKey$jscomp$9 in props)
              if (hasOwnProperty.call(props, propKey$jscomp$9)) {
                var propValue$jscomp$9 = props[propKey$jscomp$9];
                if (null != propValue$jscomp$9)
                  switch (propKey$jscomp$9) {
                    case "children":
                      children$jscomp$7 = propValue$jscomp$9;
                      break;
                    case "dangerouslySetInnerHTML":
                      innerHTML$jscomp$6 = propValue$jscomp$9;
                  }
              }
            var child$jscomp$0 = Array.isArray(children$jscomp$7) ? 2 > children$jscomp$7.length ? children$jscomp$7[0] : null : children$jscomp$7;
            "function" !== typeof child$jscomp$0 && "symbol" !== typeof child$jscomp$0 && null !== child$jscomp$0 && void 0 !== child$jscomp$0 && target.push(
              stringToChunk(
                ("" + child$jscomp$0).replace(styleRegex, styleReplacer)
              )
            );
            pushInnerHTML(target, innerHTML$jscomp$6, children$jscomp$7);
          }
          styleQueue$jscomp$0 && hoistableState && hoistableState.styles.add(styleQueue$jscomp$0);
          textEmbedded && target$jscomp$0.push(textSeparator);
          JSCompiler_inline_result$jscomp$6 = void 0;
        }
        return JSCompiler_inline_result$jscomp$6;
      case "meta":
        if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp)
          var JSCompiler_inline_result$jscomp$7 = pushSelfClosing(
            target$jscomp$0,
            props,
            "meta"
          );
        else
          textEmbedded && target$jscomp$0.push(textSeparator), JSCompiler_inline_result$jscomp$7 = isFallback ? null : "string" === typeof props.charSet ? pushSelfClosing(renderState.charsetChunks, props, "meta") : "viewport" === props.name ? pushSelfClosing(renderState.viewportChunks, props, "meta") : pushSelfClosing(renderState.hoistableChunks, props, "meta");
        return JSCompiler_inline_result$jscomp$7;
      case "listing":
      case "pre":
        target$jscomp$0.push(startChunkForTag(type));
        var children$jscomp$8 = null, innerHTML$jscomp$7 = null, propKey$jscomp$10;
        for (propKey$jscomp$10 in props)
          if (hasOwnProperty.call(props, propKey$jscomp$10)) {
            var propValue$jscomp$10 = props[propKey$jscomp$10];
            if (null != propValue$jscomp$10)
              switch (propKey$jscomp$10) {
                case "children":
                  children$jscomp$8 = propValue$jscomp$10;
                  break;
                case "dangerouslySetInnerHTML":
                  innerHTML$jscomp$7 = propValue$jscomp$10;
                  break;
                default:
                  pushAttribute(
                    target$jscomp$0,
                    propKey$jscomp$10,
                    propValue$jscomp$10
                  );
              }
          }
        target$jscomp$0.push(endOfStartTag);
        if (null != innerHTML$jscomp$7) {
          if (null != children$jscomp$8) throw Error(formatProdErrorMessage(60));
          if ("object" !== typeof innerHTML$jscomp$7 || !("__html" in innerHTML$jscomp$7))
            throw Error(formatProdErrorMessage(61));
          var html = innerHTML$jscomp$7.__html;
          null !== html && void 0 !== html && ("string" === typeof html && 0 < html.length && "\n" === html[0] ? target$jscomp$0.push(leadingNewline, stringToChunk(html)) : target$jscomp$0.push(stringToChunk("" + html)));
        }
        "string" === typeof children$jscomp$8 && "\n" === children$jscomp$8[0] && target$jscomp$0.push(leadingNewline);
        return children$jscomp$8;
      case "img":
        var src = props.src, srcSet = props.srcSet;
        if (!("lazy" === props.loading || !src && !srcSet || "string" !== typeof src && null != src || "string" !== typeof srcSet && null != srcSet) && "low" !== props.fetchPriority && false === !!(formatContext.tagScope & 3) && ("string" !== typeof src || ":" !== src[4] || "d" !== src[0] && "D" !== src[0] || "a" !== src[1] && "A" !== src[1] || "t" !== src[2] && "T" !== src[2] || "a" !== src[3] && "A" !== src[3]) && ("string" !== typeof srcSet || ":" !== srcSet[4] || "d" !== srcSet[0] && "D" !== srcSet[0] || "a" !== srcSet[1] && "A" !== srcSet[1] || "t" !== srcSet[2] && "T" !== srcSet[2] || "a" !== srcSet[3] && "A" !== srcSet[3])) {
          var sizes = "string" === typeof props.sizes ? props.sizes : void 0, key$jscomp$0 = srcSet ? srcSet + "\n" + (sizes || "") : src, promotablePreloads = renderState.preloads.images, resource$jscomp$1 = promotablePreloads.get(key$jscomp$0);
          if (resource$jscomp$1) {
            if ("high" === props.fetchPriority || 10 > renderState.highImagePreloads.size)
              promotablePreloads.delete(key$jscomp$0), renderState.highImagePreloads.add(resource$jscomp$1);
          } else if (!resumableState.imageResources.hasOwnProperty(key$jscomp$0)) {
            resumableState.imageResources[key$jscomp$0] = PRELOAD_NO_CREDS;
            var input = props.crossOrigin;
            var JSCompiler_inline_result$jscomp$8 = "string" === typeof input ? "use-credentials" === input ? input : "" : void 0;
            var headers = renderState.headers, header;
            headers && 0 < headers.remainingCapacity && "string" !== typeof props.srcSet && ("high" === props.fetchPriority || 500 > headers.highImagePreloads.length) && (header = getPreloadAsHeader(src, "image", {
              imageSrcSet: props.srcSet,
              imageSizes: props.sizes,
              crossOrigin: JSCompiler_inline_result$jscomp$8,
              integrity: props.integrity,
              nonce: props.nonce,
              type: props.type,
              fetchPriority: props.fetchPriority,
              referrerPolicy: props.refererPolicy
            }), 0 <= (headers.remainingCapacity -= header.length + 2)) ? (renderState.resets.image[key$jscomp$0] = PRELOAD_NO_CREDS, headers.highImagePreloads && (headers.highImagePreloads += ", "), headers.highImagePreloads += header) : (resource$jscomp$1 = [], pushLinkImpl(resource$jscomp$1, {
              rel: "preload",
              as: "image",
              href: srcSet ? void 0 : src,
              imageSrcSet: srcSet,
              imageSizes: sizes,
              crossOrigin: JSCompiler_inline_result$jscomp$8,
              integrity: props.integrity,
              type: props.type,
              fetchPriority: props.fetchPriority,
              referrerPolicy: props.referrerPolicy
            }), "high" === props.fetchPriority || 10 > renderState.highImagePreloads.size ? renderState.highImagePreloads.add(resource$jscomp$1) : (renderState.bulkPreloads.add(resource$jscomp$1), promotablePreloads.set(key$jscomp$0, resource$jscomp$1)));
          }
        }
        return pushSelfClosing(target$jscomp$0, props, "img");
      case "base":
      case "area":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "param":
      case "source":
      case "track":
      case "wbr":
        return pushSelfClosing(target$jscomp$0, props, type);
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        break;
      case "head":
        if (2 > formatContext.insertionMode) {
          var preamble = preambleState || renderState.preamble;
          if (preamble.headChunks)
            throw Error(formatProdErrorMessage(545, "`<head>`"));
          preamble.headChunks = [];
          var JSCompiler_inline_result$jscomp$9 = pushStartSingletonElement(
            preamble.headChunks,
            props,
            "head"
          );
        } else
          JSCompiler_inline_result$jscomp$9 = pushStartGenericElement(
            target$jscomp$0,
            props,
            "head"
          );
        return JSCompiler_inline_result$jscomp$9;
      case "body":
        if (2 > formatContext.insertionMode) {
          var preamble$jscomp$0 = preambleState || renderState.preamble;
          if (preamble$jscomp$0.bodyChunks)
            throw Error(formatProdErrorMessage(545, "`<body>`"));
          preamble$jscomp$0.bodyChunks = [];
          var JSCompiler_inline_result$jscomp$10 = pushStartSingletonElement(
            preamble$jscomp$0.bodyChunks,
            props,
            "body"
          );
        } else
          JSCompiler_inline_result$jscomp$10 = pushStartGenericElement(
            target$jscomp$0,
            props,
            "body"
          );
        return JSCompiler_inline_result$jscomp$10;
      case "html":
        if (0 === formatContext.insertionMode) {
          var preamble$jscomp$1 = preambleState || renderState.preamble;
          if (preamble$jscomp$1.htmlChunks)
            throw Error(formatProdErrorMessage(545, "`<html>`"));
          preamble$jscomp$1.htmlChunks = [doctypeChunk];
          var JSCompiler_inline_result$jscomp$11 = pushStartSingletonElement(
            preamble$jscomp$1.htmlChunks,
            props,
            "html"
          );
        } else
          JSCompiler_inline_result$jscomp$11 = pushStartGenericElement(
            target$jscomp$0,
            props,
            "html"
          );
        return JSCompiler_inline_result$jscomp$11;
      default:
        if (-1 !== type.indexOf("-")) {
          target$jscomp$0.push(startChunkForTag(type));
          var children$jscomp$9 = null, innerHTML$jscomp$8 = null, propKey$jscomp$11;
          for (propKey$jscomp$11 in props)
            if (hasOwnProperty.call(props, propKey$jscomp$11)) {
              var propValue$jscomp$11 = props[propKey$jscomp$11];
              if (null != propValue$jscomp$11) {
                var attributeName = propKey$jscomp$11;
                switch (propKey$jscomp$11) {
                  case "children":
                    children$jscomp$9 = propValue$jscomp$11;
                    break;
                  case "dangerouslySetInnerHTML":
                    innerHTML$jscomp$8 = propValue$jscomp$11;
                    break;
                  case "style":
                    pushStyleAttribute(target$jscomp$0, propValue$jscomp$11);
                    break;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "ref":
                    break;
                  case "className":
                    attributeName = "class";
                  default:
                    if (isAttributeNameSafe(propKey$jscomp$11) && "function" !== typeof propValue$jscomp$11 && "symbol" !== typeof propValue$jscomp$11 && false !== propValue$jscomp$11) {
                      if (true === propValue$jscomp$11) propValue$jscomp$11 = "";
                      else if ("object" === typeof propValue$jscomp$11) continue;
                      target$jscomp$0.push(
                        attributeSeparator,
                        stringToChunk(attributeName),
                        attributeAssign,
                        stringToChunk(escapeTextForBrowser(propValue$jscomp$11)),
                        attributeEnd
                      );
                    }
                }
              }
            }
          target$jscomp$0.push(endOfStartTag);
          pushInnerHTML(target$jscomp$0, innerHTML$jscomp$8, children$jscomp$9);
          return children$jscomp$9;
        }
    }
    return pushStartGenericElement(target$jscomp$0, props, type);
  }
  var endTagCache = /* @__PURE__ */ new Map();
  function endChunkForTag(tag) {
    var chunk = endTagCache.get(tag);
    void 0 === chunk && (chunk = stringToPrecomputedChunk("</" + tag + ">"), endTagCache.set(tag, chunk));
    return chunk;
  }
  function hoistPreambleState(renderState, preambleState) {
    renderState = renderState.preamble;
    null === renderState.htmlChunks && preambleState.htmlChunks && (renderState.htmlChunks = preambleState.htmlChunks, preambleState.contribution |= 1);
    null === renderState.headChunks && preambleState.headChunks && (renderState.headChunks = preambleState.headChunks, preambleState.contribution |= 4);
    null === renderState.bodyChunks && preambleState.bodyChunks && (renderState.bodyChunks = preambleState.bodyChunks, preambleState.contribution |= 2);
  }
  function writeBootstrap(destination, renderState) {
    renderState = renderState.bootstrapChunks;
    for (var i = 0; i < renderState.length - 1; i++)
      writeChunk(destination, renderState[i]);
    return i < renderState.length ? (i = renderState[i], renderState.length = 0, writeChunkAndReturn(destination, i)) : true;
  }
  var placeholder1 = stringToPrecomputedChunk('<template id="'), placeholder2 = stringToPrecomputedChunk('"></template>'), startCompletedSuspenseBoundary = stringToPrecomputedChunk("<!--$-->"), startPendingSuspenseBoundary1 = stringToPrecomputedChunk(
    '<!--$?--><template id="'
  ), startPendingSuspenseBoundary2 = stringToPrecomputedChunk('"></template>'), startClientRenderedSuspenseBoundary = stringToPrecomputedChunk("<!--$!-->"), endSuspenseBoundary = stringToPrecomputedChunk("<!--/$-->"), clientRenderedSuspenseBoundaryError1 = stringToPrecomputedChunk("<template"), clientRenderedSuspenseBoundaryErrorAttrInterstitial = stringToPrecomputedChunk('"'), clientRenderedSuspenseBoundaryError1A = stringToPrecomputedChunk(' data-dgst="');
  stringToPrecomputedChunk(' data-msg="');
  stringToPrecomputedChunk(' data-stck="');
  stringToPrecomputedChunk(' data-cstck="');
  var clientRenderedSuspenseBoundaryError2 = stringToPrecomputedChunk("></template>");
  function writeStartPendingSuspenseBoundary(destination, renderState, id) {
    writeChunk(destination, startPendingSuspenseBoundary1);
    if (null === id) throw Error(formatProdErrorMessage(395));
    writeChunk(destination, renderState.boundaryPrefix);
    writeChunk(destination, stringToChunk(id.toString(16)));
    return writeChunkAndReturn(destination, startPendingSuspenseBoundary2);
  }
  var boundaryPreambleContributionChunkStart = stringToPrecomputedChunk("<!--"), boundaryPreambleContributionChunkEnd = stringToPrecomputedChunk("-->");
  function writePreambleContribution(destination, preambleState) {
    preambleState = preambleState.contribution;
    0 !== preambleState && (writeChunk(destination, boundaryPreambleContributionChunkStart), writeChunk(destination, stringToChunk("" + preambleState)), writeChunk(destination, boundaryPreambleContributionChunkEnd));
  }
  var startSegmentHTML = stringToPrecomputedChunk('<div hidden id="'), startSegmentHTML2 = stringToPrecomputedChunk('">'), endSegmentHTML = stringToPrecomputedChunk("</div>"), startSegmentSVG = stringToPrecomputedChunk(
    '<svg aria-hidden="true" style="display:none" id="'
  ), startSegmentSVG2 = stringToPrecomputedChunk('">'), endSegmentSVG = stringToPrecomputedChunk("</svg>"), startSegmentMathML = stringToPrecomputedChunk(
    '<math aria-hidden="true" style="display:none" id="'
  ), startSegmentMathML2 = stringToPrecomputedChunk('">'), endSegmentMathML = stringToPrecomputedChunk("</math>"), startSegmentTable = stringToPrecomputedChunk('<table hidden id="'), startSegmentTable2 = stringToPrecomputedChunk('">'), endSegmentTable = stringToPrecomputedChunk("</table>"), startSegmentTableBody = stringToPrecomputedChunk('<table hidden><tbody id="'), startSegmentTableBody2 = stringToPrecomputedChunk('">'), endSegmentTableBody = stringToPrecomputedChunk("</tbody></table>"), startSegmentTableRow = stringToPrecomputedChunk('<table hidden><tr id="'), startSegmentTableRow2 = stringToPrecomputedChunk('">'), endSegmentTableRow = stringToPrecomputedChunk("</tr></table>"), startSegmentColGroup = stringToPrecomputedChunk(
    '<table hidden><colgroup id="'
  ), startSegmentColGroup2 = stringToPrecomputedChunk('">'), endSegmentColGroup = stringToPrecomputedChunk("</colgroup></table>");
  function writeStartSegment(destination, renderState, formatContext, id) {
    switch (formatContext.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return writeChunk(destination, startSegmentHTML), writeChunk(destination, renderState.segmentPrefix), writeChunk(destination, stringToChunk(id.toString(16))), writeChunkAndReturn(destination, startSegmentHTML2);
      case 4:
        return writeChunk(destination, startSegmentSVG), writeChunk(destination, renderState.segmentPrefix), writeChunk(destination, stringToChunk(id.toString(16))), writeChunkAndReturn(destination, startSegmentSVG2);
      case 5:
        return writeChunk(destination, startSegmentMathML), writeChunk(destination, renderState.segmentPrefix), writeChunk(destination, stringToChunk(id.toString(16))), writeChunkAndReturn(destination, startSegmentMathML2);
      case 6:
        return writeChunk(destination, startSegmentTable), writeChunk(destination, renderState.segmentPrefix), writeChunk(destination, stringToChunk(id.toString(16))), writeChunkAndReturn(destination, startSegmentTable2);
      case 7:
        return writeChunk(destination, startSegmentTableBody), writeChunk(destination, renderState.segmentPrefix), writeChunk(destination, stringToChunk(id.toString(16))), writeChunkAndReturn(destination, startSegmentTableBody2);
      case 8:
        return writeChunk(destination, startSegmentTableRow), writeChunk(destination, renderState.segmentPrefix), writeChunk(destination, stringToChunk(id.toString(16))), writeChunkAndReturn(destination, startSegmentTableRow2);
      case 9:
        return writeChunk(destination, startSegmentColGroup), writeChunk(destination, renderState.segmentPrefix), writeChunk(destination, stringToChunk(id.toString(16))), writeChunkAndReturn(destination, startSegmentColGroup2);
      default:
        throw Error(formatProdErrorMessage(397));
    }
  }
  function writeEndSegment(destination, formatContext) {
    switch (formatContext.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return writeChunkAndReturn(destination, endSegmentHTML);
      case 4:
        return writeChunkAndReturn(destination, endSegmentSVG);
      case 5:
        return writeChunkAndReturn(destination, endSegmentMathML);
      case 6:
        return writeChunkAndReturn(destination, endSegmentTable);
      case 7:
        return writeChunkAndReturn(destination, endSegmentTableBody);
      case 8:
        return writeChunkAndReturn(destination, endSegmentTableRow);
      case 9:
        return writeChunkAndReturn(destination, endSegmentColGroup);
      default:
        throw Error(formatProdErrorMessage(397));
    }
  }
  var completeSegmentScript1Full = stringToPrecomputedChunk(
    '$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'
  ), completeSegmentScript1Partial = stringToPrecomputedChunk('$RS("'), completeSegmentScript2 = stringToPrecomputedChunk('","'), completeSegmentScriptEnd = stringToPrecomputedChunk('")<\/script>');
  stringToPrecomputedChunk('<template data-rsi="" data-sid="');
  stringToPrecomputedChunk('" data-pid="');
  var completeBoundaryScript1Full = stringToPrecomputedChunk(
    '$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RC("'
  ), completeBoundaryScript1Partial = stringToPrecomputedChunk('$RC("'), completeBoundaryWithStylesScript1FullBoth = stringToPrecomputedChunk(
    '$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RM=new Map;\n$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=\nd;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,\nt,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("'
  ), completeBoundaryWithStylesScript1FullPartial = stringToPrecomputedChunk(
    '$RM=new Map;\n$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=\nd;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,\nt,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("'
  ), completeBoundaryWithStylesScript1Partial = stringToPrecomputedChunk('$RR("'), completeBoundaryScript2 = stringToPrecomputedChunk('","'), completeBoundaryScript3a = stringToPrecomputedChunk('",'), completeBoundaryScript3b = stringToPrecomputedChunk('"'), completeBoundaryScriptEnd = stringToPrecomputedChunk(")<\/script>");
  stringToPrecomputedChunk('<template data-rci="" data-bid="');
  stringToPrecomputedChunk('<template data-rri="" data-bid="');
  stringToPrecomputedChunk('" data-sid="');
  stringToPrecomputedChunk('" data-sty="');
  var clientRenderScript1Full = stringToPrecomputedChunk(
    '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'
  ), clientRenderScript1Partial = stringToPrecomputedChunk('$RX("'), clientRenderScript1A = stringToPrecomputedChunk('"'), clientRenderErrorScriptArgInterstitial = stringToPrecomputedChunk(","), clientRenderScriptEnd = stringToPrecomputedChunk(")<\/script>");
  stringToPrecomputedChunk('<template data-rxi="" data-bid="');
  stringToPrecomputedChunk('" data-dgst="');
  stringToPrecomputedChunk('" data-msg="');
  stringToPrecomputedChunk('" data-stck="');
  stringToPrecomputedChunk('" data-cstck="');
  var regexForJSStringsInInstructionScripts = /[<\u2028\u2029]/g;
  function escapeJSStringsForInstructionScripts(input) {
    return JSON.stringify(input).replace(
      regexForJSStringsInInstructionScripts,
      function(match) {
        switch (match) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var regexForJSStringsInScripts = /[&><\u2028\u2029]/g;
  function escapeJSObjectForInstructionScripts(input) {
    return JSON.stringify(input).replace(
      regexForJSStringsInScripts,
      function(match) {
        switch (match) {
          case "&":
            return "\\u0026";
          case ">":
            return "\\u003e";
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var lateStyleTagResourceOpen1 = stringToPrecomputedChunk(
    '<style media="not all" data-precedence="'
  ), lateStyleTagResourceOpen2 = stringToPrecomputedChunk('" data-href="'), lateStyleTagResourceOpen3 = stringToPrecomputedChunk('">'), lateStyleTagTemplateClose = stringToPrecomputedChunk("</style>"), currentlyRenderingBoundaryHasStylesToHoist = false, destinationHasCapacity = true;
  function flushStyleTagsLateForBoundary(styleQueue) {
    var rules = styleQueue.rules, hrefs = styleQueue.hrefs, i = 0;
    if (hrefs.length) {
      writeChunk(this, lateStyleTagResourceOpen1);
      writeChunk(this, styleQueue.precedence);
      for (writeChunk(this, lateStyleTagResourceOpen2); i < hrefs.length - 1; i++)
        writeChunk(this, hrefs[i]), writeChunk(this, spaceSeparator);
      writeChunk(this, hrefs[i]);
      writeChunk(this, lateStyleTagResourceOpen3);
      for (i = 0; i < rules.length; i++) writeChunk(this, rules[i]);
      destinationHasCapacity = writeChunkAndReturn(
        this,
        lateStyleTagTemplateClose
      );
      currentlyRenderingBoundaryHasStylesToHoist = true;
      rules.length = 0;
      hrefs.length = 0;
    }
  }
  function hasStylesToHoist(stylesheet) {
    return 2 !== stylesheet.state ? currentlyRenderingBoundaryHasStylesToHoist = true : false;
  }
  function writeHoistablesForBoundary(destination, hoistableState, renderState) {
    currentlyRenderingBoundaryHasStylesToHoist = false;
    destinationHasCapacity = true;
    hoistableState.styles.forEach(flushStyleTagsLateForBoundary, destination);
    hoistableState.stylesheets.forEach(hasStylesToHoist);
    currentlyRenderingBoundaryHasStylesToHoist && (renderState.stylesToHoist = true);
    return destinationHasCapacity;
  }
  function flushResource(resource) {
    for (var i = 0; i < resource.length; i++) writeChunk(this, resource[i]);
    resource.length = 0;
  }
  var stylesheetFlushingQueue = [];
  function flushStyleInPreamble(stylesheet) {
    pushLinkImpl(stylesheetFlushingQueue, stylesheet.props);
    for (var i = 0; i < stylesheetFlushingQueue.length; i++)
      writeChunk(this, stylesheetFlushingQueue[i]);
    stylesheetFlushingQueue.length = 0;
    stylesheet.state = 2;
  }
  var styleTagResourceOpen1 = stringToPrecomputedChunk(
    '<style data-precedence="'
  ), styleTagResourceOpen2 = stringToPrecomputedChunk('" data-href="'), spaceSeparator = stringToPrecomputedChunk(" "), styleTagResourceOpen3 = stringToPrecomputedChunk('">'), styleTagResourceClose = stringToPrecomputedChunk("</style>");
  function flushStylesInPreamble(styleQueue) {
    var hasStylesheets = 0 < styleQueue.sheets.size;
    styleQueue.sheets.forEach(flushStyleInPreamble, this);
    styleQueue.sheets.clear();
    var rules = styleQueue.rules, hrefs = styleQueue.hrefs;
    if (!hasStylesheets || hrefs.length) {
      writeChunk(this, styleTagResourceOpen1);
      writeChunk(this, styleQueue.precedence);
      styleQueue = 0;
      if (hrefs.length) {
        for (writeChunk(this, styleTagResourceOpen2); styleQueue < hrefs.length - 1; styleQueue++)
          writeChunk(this, hrefs[styleQueue]), writeChunk(this, spaceSeparator);
        writeChunk(this, hrefs[styleQueue]);
      }
      writeChunk(this, styleTagResourceOpen3);
      for (styleQueue = 0; styleQueue < rules.length; styleQueue++)
        writeChunk(this, rules[styleQueue]);
      writeChunk(this, styleTagResourceClose);
      rules.length = 0;
      hrefs.length = 0;
    }
  }
  function preloadLateStyle(stylesheet) {
    if (0 === stylesheet.state) {
      stylesheet.state = 1;
      var props = stylesheet.props;
      pushLinkImpl(stylesheetFlushingQueue, {
        rel: "preload",
        as: "style",
        href: stylesheet.props.href,
        crossOrigin: props.crossOrigin,
        fetchPriority: props.fetchPriority,
        integrity: props.integrity,
        media: props.media,
        hrefLang: props.hrefLang,
        referrerPolicy: props.referrerPolicy
      });
      for (stylesheet = 0; stylesheet < stylesheetFlushingQueue.length; stylesheet++)
        writeChunk(this, stylesheetFlushingQueue[stylesheet]);
      stylesheetFlushingQueue.length = 0;
    }
  }
  function preloadLateStyles(styleQueue) {
    styleQueue.sheets.forEach(preloadLateStyle, this);
    styleQueue.sheets.clear();
  }
  var arrayFirstOpenBracket = stringToPrecomputedChunk("["), arraySubsequentOpenBracket = stringToPrecomputedChunk(",["), arrayInterstitial = stringToPrecomputedChunk(","), arrayCloseBracket = stringToPrecomputedChunk("]");
  function writeStyleResourceDependenciesInJS(destination, hoistableState) {
    writeChunk(destination, arrayFirstOpenBracket);
    var nextArrayOpenBrackChunk = arrayFirstOpenBracket;
    hoistableState.stylesheets.forEach(function(resource) {
      if (2 !== resource.state)
        if (3 === resource.state)
          writeChunk(destination, nextArrayOpenBrackChunk), writeChunk(
            destination,
            stringToChunk(
              escapeJSObjectForInstructionScripts("" + resource.props.href)
            )
          ), writeChunk(destination, arrayCloseBracket), nextArrayOpenBrackChunk = arraySubsequentOpenBracket;
        else {
          writeChunk(destination, nextArrayOpenBrackChunk);
          var precedence = resource.props["data-precedence"], props = resource.props, coercedHref = sanitizeURL("" + resource.props.href);
          writeChunk(
            destination,
            stringToChunk(escapeJSObjectForInstructionScripts(coercedHref))
          );
          precedence = "" + precedence;
          writeChunk(destination, arrayInterstitial);
          writeChunk(
            destination,
            stringToChunk(escapeJSObjectForInstructionScripts(precedence))
          );
          for (var propKey in props)
            if (hasOwnProperty.call(props, propKey) && (precedence = props[propKey], null != precedence))
              switch (propKey) {
                case "href":
                case "rel":
                case "precedence":
                case "data-precedence":
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(formatProdErrorMessage(399, "link"));
                default:
                  writeStyleResourceAttributeInJS(
                    destination,
                    propKey,
                    precedence
                  );
              }
          writeChunk(destination, arrayCloseBracket);
          nextArrayOpenBrackChunk = arraySubsequentOpenBracket;
          resource.state = 3;
        }
    });
    writeChunk(destination, arrayCloseBracket);
  }
  function writeStyleResourceAttributeInJS(destination, name, value) {
    var attributeName = name.toLowerCase();
    switch (typeof value) {
      case "function":
      case "symbol":
        return;
    }
    switch (name) {
      case "innerHTML":
      case "dangerouslySetInnerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "style":
      case "ref":
        return;
      case "className":
        attributeName = "class";
        name = "" + value;
        break;
      case "hidden":
        if (false === value) return;
        name = "";
        break;
      case "src":
      case "href":
        value = sanitizeURL(value);
        name = "" + value;
        break;
      default:
        if (2 < name.length && ("o" === name[0] || "O" === name[0]) && ("n" === name[1] || "N" === name[1]) || !isAttributeNameSafe(name))
          return;
        name = "" + value;
    }
    writeChunk(destination, arrayInterstitial);
    writeChunk(
      destination,
      stringToChunk(escapeJSObjectForInstructionScripts(attributeName))
    );
    writeChunk(destination, arrayInterstitial);
    writeChunk(
      destination,
      stringToChunk(escapeJSObjectForInstructionScripts(name))
    );
  }
  function createHoistableState() {
    return { styles: /* @__PURE__ */ new Set(), stylesheets: /* @__PURE__ */ new Set() };
  }
  function prefetchDNS(href) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if ("string" === typeof href && href) {
        if (!resumableState.dnsResources.hasOwnProperty(href)) {
          resumableState.dnsResources[href] = null;
          resumableState = renderState.headers;
          var header, JSCompiler_temp;
          if (JSCompiler_temp = resumableState && 0 < resumableState.remainingCapacity)
            JSCompiler_temp = (header = "<" + ("" + href).replace(
              regexForHrefInLinkHeaderURLContext,
              escapeHrefForLinkHeaderURLContextReplacer
            ) + ">; rel=dns-prefetch", 0 <= (resumableState.remainingCapacity -= header.length + 2));
          JSCompiler_temp ? (renderState.resets.dns[href] = null, resumableState.preconnects && (resumableState.preconnects += ", "), resumableState.preconnects += header) : (header = [], pushLinkImpl(header, { href, rel: "dns-prefetch" }), renderState.preconnects.add(header));
        }
        enqueueFlush(request);
      }
    } else previousDispatcher.D(href);
  }
  function preconnect(href, crossOrigin) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if ("string" === typeof href && href) {
        var bucket = "use-credentials" === crossOrigin ? "credentials" : "string" === typeof crossOrigin ? "anonymous" : "default";
        if (!resumableState.connectResources[bucket].hasOwnProperty(href)) {
          resumableState.connectResources[bucket][href] = null;
          resumableState = renderState.headers;
          var header, JSCompiler_temp;
          if (JSCompiler_temp = resumableState && 0 < resumableState.remainingCapacity) {
            JSCompiler_temp = "<" + ("" + href).replace(
              regexForHrefInLinkHeaderURLContext,
              escapeHrefForLinkHeaderURLContextReplacer
            ) + ">; rel=preconnect";
            if ("string" === typeof crossOrigin) {
              var escapedCrossOrigin = ("" + crossOrigin).replace(
                regexForLinkHeaderQuotedParamValueContext,
                escapeStringForLinkHeaderQuotedParamValueContextReplacer
              );
              JSCompiler_temp += '; crossorigin="' + escapedCrossOrigin + '"';
            }
            JSCompiler_temp = (header = JSCompiler_temp, 0 <= (resumableState.remainingCapacity -= header.length + 2));
          }
          JSCompiler_temp ? (renderState.resets.connect[bucket][href] = null, resumableState.preconnects && (resumableState.preconnects += ", "), resumableState.preconnects += header) : (bucket = [], pushLinkImpl(bucket, {
            rel: "preconnect",
            href,
            crossOrigin
          }), renderState.preconnects.add(bucket));
        }
        enqueueFlush(request);
      }
    } else previousDispatcher.C(href, crossOrigin);
  }
  function preload(href, as, options) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if (as && href) {
        switch (as) {
          case "image":
            if (options) {
              var imageSrcSet = options.imageSrcSet;
              var imageSizes = options.imageSizes;
              var fetchPriority = options.fetchPriority;
            }
            var key = imageSrcSet ? imageSrcSet + "\n" + (imageSizes || "") : href;
            if (resumableState.imageResources.hasOwnProperty(key)) return;
            resumableState.imageResources[key] = PRELOAD_NO_CREDS;
            resumableState = renderState.headers;
            var header;
            resumableState && 0 < resumableState.remainingCapacity && "string" !== typeof imageSrcSet && "high" === fetchPriority && (header = getPreloadAsHeader(href, as, options), 0 <= (resumableState.remainingCapacity -= header.length + 2)) ? (renderState.resets.image[key] = PRELOAD_NO_CREDS, resumableState.highImagePreloads && (resumableState.highImagePreloads += ", "), resumableState.highImagePreloads += header) : (resumableState = [], pushLinkImpl(
              resumableState,
              assign(
                { rel: "preload", href: imageSrcSet ? void 0 : href, as },
                options
              )
            ), "high" === fetchPriority ? renderState.highImagePreloads.add(resumableState) : (renderState.bulkPreloads.add(resumableState), renderState.preloads.images.set(key, resumableState)));
            break;
          case "style":
            if (resumableState.styleResources.hasOwnProperty(href)) return;
            imageSrcSet = [];
            pushLinkImpl(
              imageSrcSet,
              assign({ rel: "preload", href, as }, options)
            );
            resumableState.styleResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? PRELOAD_NO_CREDS : [options.crossOrigin, options.integrity];
            renderState.preloads.stylesheets.set(href, imageSrcSet);
            renderState.bulkPreloads.add(imageSrcSet);
            break;
          case "script":
            if (resumableState.scriptResources.hasOwnProperty(href)) return;
            imageSrcSet = [];
            renderState.preloads.scripts.set(href, imageSrcSet);
            renderState.bulkPreloads.add(imageSrcSet);
            pushLinkImpl(
              imageSrcSet,
              assign({ rel: "preload", href, as }, options)
            );
            resumableState.scriptResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? PRELOAD_NO_CREDS : [options.crossOrigin, options.integrity];
            break;
          default:
            if (resumableState.unknownResources.hasOwnProperty(as)) {
              if (imageSrcSet = resumableState.unknownResources[as], imageSrcSet.hasOwnProperty(href))
                return;
            } else
              imageSrcSet = {}, resumableState.unknownResources[as] = imageSrcSet;
            imageSrcSet[href] = PRELOAD_NO_CREDS;
            if ((resumableState = renderState.headers) && 0 < resumableState.remainingCapacity && "font" === as && (key = getPreloadAsHeader(href, as, options), 0 <= (resumableState.remainingCapacity -= key.length + 2)))
              renderState.resets.font[href] = PRELOAD_NO_CREDS, resumableState.fontPreloads && (resumableState.fontPreloads += ", "), resumableState.fontPreloads += key;
            else
              switch (resumableState = [], href = assign({ rel: "preload", href, as }, options), pushLinkImpl(resumableState, href), as) {
                case "font":
                  renderState.fontPreloads.add(resumableState);
                  break;
                default:
                  renderState.bulkPreloads.add(resumableState);
              }
        }
        enqueueFlush(request);
      }
    } else previousDispatcher.L(href, as, options);
  }
  function preloadModule(href, options) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if (href) {
        var as = options && "string" === typeof options.as ? options.as : "script";
        switch (as) {
          case "script":
            if (resumableState.moduleScriptResources.hasOwnProperty(href)) return;
            as = [];
            resumableState.moduleScriptResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? PRELOAD_NO_CREDS : [options.crossOrigin, options.integrity];
            renderState.preloads.moduleScripts.set(href, as);
            break;
          default:
            if (resumableState.moduleUnknownResources.hasOwnProperty(as)) {
              var resources = resumableState.unknownResources[as];
              if (resources.hasOwnProperty(href)) return;
            } else
              resources = {}, resumableState.moduleUnknownResources[as] = resources;
            as = [];
            resources[href] = PRELOAD_NO_CREDS;
        }
        pushLinkImpl(as, assign({ rel: "modulepreload", href }, options));
        renderState.bulkPreloads.add(as);
        enqueueFlush(request);
      }
    } else previousDispatcher.m(href, options);
  }
  function preinitStyle(href, precedence, options) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if (href) {
        precedence = precedence || "default";
        var styleQueue = renderState.styles.get(precedence), resourceState = resumableState.styleResources.hasOwnProperty(href) ? resumableState.styleResources[href] : void 0;
        null !== resourceState && (resumableState.styleResources[href] = null, styleQueue || (styleQueue = {
          precedence: stringToChunk(escapeTextForBrowser(precedence)),
          rules: [],
          hrefs: [],
          sheets: /* @__PURE__ */ new Map()
        }, renderState.styles.set(precedence, styleQueue)), precedence = {
          state: 0,
          props: assign(
            { rel: "stylesheet", href, "data-precedence": precedence },
            options
          )
        }, resourceState && (2 === resourceState.length && adoptPreloadCredentials(precedence.props, resourceState), (renderState = renderState.preloads.stylesheets.get(href)) && 0 < renderState.length ? renderState.length = 0 : precedence.state = 1), styleQueue.sheets.set(href, precedence), enqueueFlush(request));
      }
    } else previousDispatcher.S(href, precedence, options);
  }
  function preinitScript(src, options) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if (src) {
        var resourceState = resumableState.scriptResources.hasOwnProperty(src) ? resumableState.scriptResources[src] : void 0;
        null !== resourceState && (resumableState.scriptResources[src] = null, options = assign({ src, async: true }, options), resourceState && (2 === resourceState.length && adoptPreloadCredentials(options, resourceState), src = renderState.preloads.scripts.get(src)) && (src.length = 0), src = [], renderState.scripts.add(src), pushScriptImpl(src, options), enqueueFlush(request));
      }
    } else previousDispatcher.X(src, options);
  }
  function preinitModuleScript(src, options) {
    var request = currentRequest ? currentRequest : null;
    if (request) {
      var resumableState = request.resumableState, renderState = request.renderState;
      if (src) {
        var resourceState = resumableState.moduleScriptResources.hasOwnProperty(
          src
        ) ? resumableState.moduleScriptResources[src] : void 0;
        null !== resourceState && (resumableState.moduleScriptResources[src] = null, options = assign({ src, type: "module", async: true }, options), resourceState && (2 === resourceState.length && adoptPreloadCredentials(options, resourceState), src = renderState.preloads.moduleScripts.get(src)) && (src.length = 0), src = [], renderState.scripts.add(src), pushScriptImpl(src, options), enqueueFlush(request));
      }
    } else previousDispatcher.M(src, options);
  }
  function adoptPreloadCredentials(target, preloadState) {
    null == target.crossOrigin && (target.crossOrigin = preloadState[0]);
    null == target.integrity && (target.integrity = preloadState[1]);
  }
  function getPreloadAsHeader(href, as, params) {
    href = ("" + href).replace(
      regexForHrefInLinkHeaderURLContext,
      escapeHrefForLinkHeaderURLContextReplacer
    );
    as = ("" + as).replace(
      regexForLinkHeaderQuotedParamValueContext,
      escapeStringForLinkHeaderQuotedParamValueContextReplacer
    );
    as = "<" + href + '>; rel=preload; as="' + as + '"';
    for (var paramName in params)
      hasOwnProperty.call(params, paramName) && (href = params[paramName], "string" === typeof href && (as += "; " + paramName.toLowerCase() + '="' + ("" + href).replace(
        regexForLinkHeaderQuotedParamValueContext,
        escapeStringForLinkHeaderQuotedParamValueContextReplacer
      ) + '"'));
    return as;
  }
  var regexForHrefInLinkHeaderURLContext = /[<>\r\n]/g;
  function escapeHrefForLinkHeaderURLContextReplacer(match) {
    switch (match) {
      case "<":
        return "%3C";
      case ">":
        return "%3E";
      case "\n":
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  var regexForLinkHeaderQuotedParamValueContext = /["';,\r\n]/g;
  function escapeStringForLinkHeaderQuotedParamValueContextReplacer(match) {
    switch (match) {
      case '"':
        return "%22";
      case "'":
        return "%27";
      case ";":
        return "%3B";
      case ",":
        return "%2C";
      case "\n":
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  function hoistStyleQueueDependency(styleQueue) {
    this.styles.add(styleQueue);
  }
  function hoistStylesheetDependency(stylesheet) {
    this.stylesheets.add(stylesheet);
  }
  var bind = Function.prototype.bind, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
  function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type)
      return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch (type) {
      case REACT_FRAGMENT_TYPE:
        return "Fragment";
      case REACT_PROFILER_TYPE:
        return "Profiler";
      case REACT_STRICT_MODE_TYPE:
        return "StrictMode";
      case REACT_SUSPENSE_TYPE:
        return "Suspense";
      case REACT_SUSPENSE_LIST_TYPE:
        return "SuspenseList";
      case REACT_ACTIVITY_TYPE:
        return "Activity";
    }
    if ("object" === typeof type)
      switch (type.$$typeof) {
        case REACT_PORTAL_TYPE:
          return "Portal";
        case REACT_CONTEXT_TYPE:
          return (type.displayName || "Context") + ".Provider";
        case REACT_CONSUMER_TYPE:
          return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
          var innerType = type.render;
          type = type.displayName;
          type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
          return type;
        case REACT_MEMO_TYPE:
          return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
          innerType = type._payload;
          type = type._init;
          try {
            return getComponentNameFromType(type(innerType));
          } catch (x) {
          }
      }
    return null;
  }
  var emptyContextObject = {}, currentActiveSnapshot = null;
  function popToNearestCommonAncestor(prev, next) {
    if (prev !== next) {
      prev.context._currentValue = prev.parentValue;
      prev = prev.parent;
      var parentNext = next.parent;
      if (null === prev) {
        if (null !== parentNext) throw Error(formatProdErrorMessage(401));
      } else {
        if (null === parentNext) throw Error(formatProdErrorMessage(401));
        popToNearestCommonAncestor(prev, parentNext);
      }
      next.context._currentValue = next.value;
    }
  }
  function popAllPrevious(prev) {
    prev.context._currentValue = prev.parentValue;
    prev = prev.parent;
    null !== prev && popAllPrevious(prev);
  }
  function pushAllNext(next) {
    var parentNext = next.parent;
    null !== parentNext && pushAllNext(parentNext);
    next.context._currentValue = next.value;
  }
  function popPreviousToCommonLevel(prev, next) {
    prev.context._currentValue = prev.parentValue;
    prev = prev.parent;
    if (null === prev) throw Error(formatProdErrorMessage(402));
    prev.depth === next.depth ? popToNearestCommonAncestor(prev, next) : popPreviousToCommonLevel(prev, next);
  }
  function popNextToCommonLevel(prev, next) {
    var parentNext = next.parent;
    if (null === parentNext) throw Error(formatProdErrorMessage(402));
    prev.depth === parentNext.depth ? popToNearestCommonAncestor(prev, parentNext) : popNextToCommonLevel(prev, parentNext);
    next.context._currentValue = next.value;
  }
  function switchContext(newSnapshot) {
    var prev = currentActiveSnapshot;
    prev !== newSnapshot && (null === prev ? pushAllNext(newSnapshot) : null === newSnapshot ? popAllPrevious(prev) : prev.depth === newSnapshot.depth ? popToNearestCommonAncestor(prev, newSnapshot) : prev.depth > newSnapshot.depth ? popPreviousToCommonLevel(prev, newSnapshot) : popNextToCommonLevel(prev, newSnapshot), currentActiveSnapshot = newSnapshot);
  }
  var classComponentUpdater = {
    enqueueSetState: function(inst, payload) {
      inst = inst._reactInternals;
      null !== inst.queue && inst.queue.push(payload);
    },
    enqueueReplaceState: function(inst, payload) {
      inst = inst._reactInternals;
      inst.replace = true;
      inst.queue = [payload];
    },
    enqueueForceUpdate: function() {
    }
  }, emptyTreeContext = { id: 1, overflow: "" };
  function pushTreeContext(baseContext, totalChildren, index) {
    var baseIdWithLeadingBit = baseContext.id;
    baseContext = baseContext.overflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
      var numberOfOverflowBits = baseLength - baseLength % 5;
      length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
      baseIdWithLeadingBit >>= numberOfOverflowBits;
      baseLength -= numberOfOverflowBits;
      return {
        id: 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit,
        overflow: length + baseContext
      };
    }
    return {
      id: 1 << length | index << baseLength | baseIdWithLeadingBit,
      overflow: baseContext
    };
  }
  var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
  function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
  }
  var SuspenseException = Error(formatProdErrorMessage(460));
  function noop$2() {
  }
  function trackUsedThenable(thenableState2, thenable, index) {
    index = thenableState2[index];
    void 0 === index ? thenableState2.push(thenable) : index !== thenable && (thenable.then(noop$2, noop$2), thenable = index);
    switch (thenable.status) {
      case "fulfilled":
        return thenable.value;
      case "rejected":
        throw thenable.reason;
      default:
        "string" === typeof thenable.status ? thenable.then(noop$2, noop$2) : (thenableState2 = thenable, thenableState2.status = "pending", thenableState2.then(
          function(fulfilledValue) {
            if ("pending" === thenable.status) {
              var fulfilledThenable = thenable;
              fulfilledThenable.status = "fulfilled";
              fulfilledThenable.value = fulfilledValue;
            }
          },
          function(error) {
            if ("pending" === thenable.status) {
              var rejectedThenable = thenable;
              rejectedThenable.status = "rejected";
              rejectedThenable.reason = error;
            }
          }
        ));
        switch (thenable.status) {
          case "fulfilled":
            return thenable.value;
          case "rejected":
            throw thenable.reason;
        }
        suspendedThenable = thenable;
        throw SuspenseException;
    }
  }
  var suspendedThenable = null;
  function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
  }
  function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is, currentlyRenderingComponent = null, currentlyRenderingTask = null, currentlyRenderingRequest = null, currentlyRenderingKeyPath = null, firstWorkInProgressHook = null, workInProgressHook = null, isReRender = false, didScheduleRenderPhaseUpdate = false, localIdCounter = 0, actionStateCounter = 0, actionStateMatchingIndex = -1, thenableIndexCounter = 0, thenableState = null, renderPhaseUpdates = null, numberOfReRenders = 0;
  function resolveCurrentlyRenderingComponent() {
    if (null === currentlyRenderingComponent)
      throw Error(formatProdErrorMessage(321));
    return currentlyRenderingComponent;
  }
  function createHook() {
    if (0 < numberOfReRenders) throw Error(formatProdErrorMessage(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function createWorkInProgressHook() {
    null === workInProgressHook ? null === firstWorkInProgressHook ? (isReRender = false, firstWorkInProgressHook = workInProgressHook = createHook()) : (isReRender = true, workInProgressHook = firstWorkInProgressHook) : null === workInProgressHook.next ? (isReRender = false, workInProgressHook = workInProgressHook.next = createHook()) : (isReRender = true, workInProgressHook = workInProgressHook.next);
    return workInProgressHook;
  }
  function getThenableStateAfterSuspending() {
    var state = thenableState;
    thenableState = null;
    return state;
  }
  function resetHooksState() {
    currentlyRenderingKeyPath = currentlyRenderingRequest = currentlyRenderingTask = currentlyRenderingComponent = null;
    didScheduleRenderPhaseUpdate = false;
    firstWorkInProgressHook = null;
    numberOfReRenders = 0;
    workInProgressHook = renderPhaseUpdates = null;
  }
  function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
  }
  function useReducer(reducer, initialArg, init) {
    currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
    workInProgressHook = createWorkInProgressHook();
    if (isReRender) {
      var queue = workInProgressHook.queue;
      initialArg = queue.dispatch;
      if (null !== renderPhaseUpdates && (init = renderPhaseUpdates.get(queue), void 0 !== init)) {
        renderPhaseUpdates.delete(queue);
        queue = workInProgressHook.memoizedState;
        do
          queue = reducer(queue, init.action), init = init.next;
        while (null !== init);
        workInProgressHook.memoizedState = queue;
        return [queue, initialArg];
      }
      return [workInProgressHook.memoizedState, initialArg];
    }
    reducer = reducer === basicStateReducer ? "function" === typeof initialArg ? initialArg() : initialArg : void 0 !== init ? init(initialArg) : initialArg;
    workInProgressHook.memoizedState = reducer;
    reducer = workInProgressHook.queue = { last: null, dispatch: null };
    reducer = reducer.dispatch = dispatchAction.bind(
      null,
      currentlyRenderingComponent,
      reducer
    );
    return [workInProgressHook.memoizedState, reducer];
  }
  function useMemo(nextCreate, deps) {
    currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
    workInProgressHook = createWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    if (null !== workInProgressHook) {
      var prevState = workInProgressHook.memoizedState;
      if (null !== prevState && null !== deps) {
        var prevDeps = prevState[1];
        a: if (null === prevDeps) prevDeps = false;
        else {
          for (var i = 0; i < prevDeps.length && i < deps.length; i++)
            if (!objectIs(deps[i], prevDeps[i])) {
              prevDeps = false;
              break a;
            }
          prevDeps = true;
        }
        if (prevDeps) return prevState[0];
      }
    }
    nextCreate = nextCreate();
    workInProgressHook.memoizedState = [nextCreate, deps];
    return nextCreate;
  }
  function dispatchAction(componentIdentity, queue, action) {
    if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
    if (componentIdentity === currentlyRenderingComponent)
      if (didScheduleRenderPhaseUpdate = true, componentIdentity = { action, next: null }, null === renderPhaseUpdates && (renderPhaseUpdates = /* @__PURE__ */ new Map()), action = renderPhaseUpdates.get(queue), void 0 === action)
        renderPhaseUpdates.set(queue, componentIdentity);
      else {
        for (queue = action; null !== queue.next; ) queue = queue.next;
        queue.next = componentIdentity;
      }
  }
  function unsupportedStartTransition() {
    throw Error(formatProdErrorMessage(394));
  }
  function unsupportedSetOptimisticState() {
    throw Error(formatProdErrorMessage(479));
  }
  function useActionState(action, initialState, permalink) {
    resolveCurrentlyRenderingComponent();
    var actionStateHookIndex = actionStateCounter++, request = currentlyRenderingRequest;
    if ("function" === typeof action.$$FORM_ACTION) {
      var nextPostbackStateKey = null, componentKeyPath = currentlyRenderingKeyPath;
      request = request.formState;
      var isSignatureEqual = action.$$IS_SIGNATURE_EQUAL;
      if (null !== request && "function" === typeof isSignatureEqual) {
        var postbackKey = request[1];
        isSignatureEqual.call(action, request[2], request[3]) && (nextPostbackStateKey = void 0 !== permalink ? "p" + permalink : "k" + murmurhash3_32_gc(
          JSON.stringify([componentKeyPath, null, actionStateHookIndex]),
          0
        ), postbackKey === nextPostbackStateKey && (actionStateMatchingIndex = actionStateHookIndex, initialState = request[0]));
      }
      var boundAction = action.bind(null, initialState);
      action = function(payload) {
        boundAction(payload);
      };
      "function" === typeof boundAction.$$FORM_ACTION && (action.$$FORM_ACTION = function(prefix2) {
        prefix2 = boundAction.$$FORM_ACTION(prefix2);
        void 0 !== permalink && (permalink += "", prefix2.action = permalink);
        var formData = prefix2.data;
        formData && (null === nextPostbackStateKey && (nextPostbackStateKey = void 0 !== permalink ? "p" + permalink : "k" + murmurhash3_32_gc(
          JSON.stringify([
            componentKeyPath,
            null,
            actionStateHookIndex
          ]),
          0
        )), formData.append("$ACTION_KEY", nextPostbackStateKey));
        return prefix2;
      });
      return [initialState, action, false];
    }
    var boundAction$22 = action.bind(null, initialState);
    return [
      initialState,
      function(payload) {
        boundAction$22(payload);
      },
      false
    ];
  }
  function unwrapThenable(thenable) {
    var index = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    return trackUsedThenable(thenableState, thenable, index);
  }
  function unsupportedRefresh() {
    throw Error(formatProdErrorMessage(393));
  }
  function noop$1() {
  }
  var HooksDispatcher = {
    readContext: function(context) {
      return context._currentValue;
    },
    use: function(usable) {
      if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return unwrapThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return usable._currentValue;
      }
      throw Error(formatProdErrorMessage(438, String(usable)));
    },
    useContext: function(context) {
      resolveCurrentlyRenderingComponent();
      return context._currentValue;
    },
    useMemo,
    useReducer,
    useRef: function(initialValue) {
      currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
      workInProgressHook = createWorkInProgressHook();
      var previousRef = workInProgressHook.memoizedState;
      return null === previousRef ? (initialValue = { current: initialValue }, workInProgressHook.memoizedState = initialValue) : previousRef;
    },
    useState: function(initialState) {
      return useReducer(basicStateReducer, initialState);
    },
    useInsertionEffect: noop$1,
    useLayoutEffect: noop$1,
    useCallback: function(callback, deps) {
      return useMemo(function() {
        return callback;
      }, deps);
    },
    useImperativeHandle: noop$1,
    useEffect: noop$1,
    useDebugValue: noop$1,
    useDeferredValue: function(value, initialValue) {
      resolveCurrentlyRenderingComponent();
      return void 0 !== initialValue ? initialValue : value;
    },
    useTransition: function() {
      resolveCurrentlyRenderingComponent();
      return [false, unsupportedStartTransition];
    },
    useId: function() {
      var JSCompiler_inline_result = currentlyRenderingTask.treeContext;
      var overflow = JSCompiler_inline_result.overflow;
      JSCompiler_inline_result = JSCompiler_inline_result.id;
      JSCompiler_inline_result = (JSCompiler_inline_result & ~(1 << 32 - clz32(JSCompiler_inline_result) - 1)).toString(32) + overflow;
      var resumableState = currentResumableState;
      if (null === resumableState) throw Error(formatProdErrorMessage(404));
      overflow = localIdCounter++;
      JSCompiler_inline_result = "«" + resumableState.idPrefix + "R" + JSCompiler_inline_result;
      0 < overflow && (JSCompiler_inline_result += "H" + overflow.toString(32));
      return JSCompiler_inline_result + "»";
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
      if (void 0 === getServerSnapshot)
        throw Error(formatProdErrorMessage(407));
      return getServerSnapshot();
    },
    useOptimistic: function(passthrough) {
      resolveCurrentlyRenderingComponent();
      return [passthrough, unsupportedSetOptimisticState];
    },
    useActionState,
    useFormState: useActionState,
    useHostTransitionStatus: function() {
      resolveCurrentlyRenderingComponent();
      return sharedNotPendingObject;
    },
    useMemoCache: function(size) {
      for (var data = Array(size), i = 0; i < size; i++)
        data[i] = REACT_MEMO_CACHE_SENTINEL;
      return data;
    },
    useCacheRefresh: function() {
      return unsupportedRefresh;
    }
  }, currentResumableState = null, DefaultAsyncDispatcher = {
    getCacheForType: function() {
      throw Error(formatProdErrorMessage(248));
    }
  }, prefix, suffix;
  function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix)
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return "\n" + prefix + name + suffix;
  }
  var reentry = false;
  function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = true;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var RunInRootFrame = {
        DetermineComponentFrameRoot: function() {
          try {
            if (construct) {
              var Fake = function() {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function() {
                  throw Error();
                }
              });
              if ("object" === typeof Reflect && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x) {
                  var control = x;
                }
                Reflect.construct(fn, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x$24) {
                  control = x$24;
                }
                fn.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x$25) {
                control = x$25;
              }
              (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {
              });
            }
          } catch (sample) {
            if (sample && control && "string" === typeof sample.stack)
              return [sample.stack, control.stack];
          }
          return [null, null];
        }
      };
      RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var namePropDescriptor = Object.getOwnPropertyDescriptor(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name"
      );
      namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
      if (sampleStack && controlStack) {
        var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
        for (namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot"); )
          RunInRootFrame++;
        for (; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes(
          "DetermineComponentFrameRoot"
        ); )
          namePropDescriptor++;
        if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length)
          for (RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]; )
            namePropDescriptor--;
        for (; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)
          if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
            if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
              do
                if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                  var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                  fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                  return frame;
                }
              while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
            }
            break;
          }
      }
    } finally {
      reentry = false, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
  }
  function describeComponentStackByType(type) {
    if ("string" === typeof type) return describeBuiltInComponentFrame(type);
    if ("function" === typeof type)
      return type.prototype && type.prototype.isReactComponent ? describeNativeComponentFrame(type, true) : describeNativeComponentFrame(type, false);
    if ("object" === typeof type && null !== type) {
      switch (type.$$typeof) {
        case REACT_FORWARD_REF_TYPE:
          return describeNativeComponentFrame(type.render, false);
        case REACT_MEMO_TYPE:
          return describeNativeComponentFrame(type.type, false);
        case REACT_LAZY_TYPE:
          var lazyComponent = type, payload = lazyComponent._payload;
          lazyComponent = lazyComponent._init;
          try {
            type = lazyComponent(payload);
          } catch (x) {
            return describeBuiltInComponentFrame("Lazy");
          }
          return describeComponentStackByType(type);
      }
      if ("string" === typeof type.name)
        return payload = type.env, describeBuiltInComponentFrame(
          type.name + (payload ? " [" + payload + "]" : "")
        );
    }
    switch (type) {
      case REACT_SUSPENSE_LIST_TYPE:
        return describeBuiltInComponentFrame("SuspenseList");
      case REACT_SUSPENSE_TYPE:
        return describeBuiltInComponentFrame("Suspense");
    }
    return "";
  }
  function defaultErrorHandler(error) {
    if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
      var JSCompiler_inline_result = error.environmentName;
      error = [error].slice(0);
      "string" === typeof error[0] ? error.splice(
        0,
        1,
        "%c%s%c " + error[0],
        "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px",
        " " + JSCompiler_inline_result + " ",
        ""
      ) : error.splice(
        0,
        0,
        "%c%s%c ",
        "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px",
        " " + JSCompiler_inline_result + " ",
        ""
      );
      error.unshift(console);
      JSCompiler_inline_result = bind.apply(console.error, error);
      JSCompiler_inline_result();
    } else console.error(error);
    return null;
  }
  function noop() {
  }
  function RequestInstance(resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState) {
    var abortSet = /* @__PURE__ */ new Set();
    this.destination = null;
    this.flushScheduled = false;
    this.resumableState = resumableState;
    this.renderState = renderState;
    this.rootFormatContext = rootFormatContext;
    this.progressiveChunkSize = void 0 === progressiveChunkSize ? 12800 : progressiveChunkSize;
    this.status = 10;
    this.fatalError = null;
    this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0;
    this.completedPreambleSegments = this.completedRootSegment = null;
    this.abortableTasks = abortSet;
    this.pingedTasks = [];
    this.clientRenderedBoundaries = [];
    this.completedBoundaries = [];
    this.partialBoundaries = [];
    this.trackedPostpones = null;
    this.onError = void 0 === onError ? defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? noop : onPostpone;
    this.onAllReady = void 0 === onAllReady ? noop : onAllReady;
    this.onShellReady = void 0 === onShellReady ? noop : onShellReady;
    this.onShellError = void 0 === onShellError ? noop : onShellError;
    this.onFatalError = void 0 === onFatalError ? noop : onFatalError;
    this.formState = void 0 === formState ? null : formState;
  }
  function createRequest(children, resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState) {
    resumableState = new RequestInstance(
      resumableState,
      renderState,
      rootFormatContext,
      progressiveChunkSize,
      onError,
      onAllReady,
      onShellReady,
      onShellError,
      onFatalError,
      onPostpone,
      formState
    );
    renderState = createPendingSegment(
      resumableState,
      0,
      null,
      rootFormatContext,
      false,
      false
    );
    renderState.parentFlushed = true;
    children = createRenderTask(
      resumableState,
      null,
      children,
      -1,
      null,
      renderState,
      null,
      null,
      resumableState.abortableTasks,
      null,
      rootFormatContext,
      null,
      emptyTreeContext,
      null,
      false
    );
    pushComponentStack(children);
    resumableState.pingedTasks.push(children);
    return resumableState;
  }
  function createPrerenderRequest(children, resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone) {
    children = createRequest(
      children,
      resumableState,
      renderState,
      rootFormatContext,
      progressiveChunkSize,
      onError,
      onAllReady,
      onShellReady,
      onShellError,
      onFatalError,
      onPostpone,
      void 0
    );
    children.trackedPostpones = {
      workingMap: /* @__PURE__ */ new Map(),
      rootNodes: [],
      rootSlots: null
    };
    return children;
  }
  var currentRequest = null;
  function pingTask(request, task) {
    request.pingedTasks.push(task);
    1 === request.pingedTasks.length && (request.flushScheduled = null !== request.destination, null !== request.trackedPostpones || 10 === request.status ? scheduleMicrotask(function() {
      return performWork(request);
    }) : scheduleWork(function() {
      return performWork(request);
    }));
  }
  function createSuspenseBoundary(request, fallbackAbortableTasks, contentPreamble, fallbackPreamble) {
    return {
      status: 0,
      rootSegmentID: -1,
      parentFlushed: false,
      pendingTasks: 0,
      completedSegments: [],
      byteSize: 0,
      fallbackAbortableTasks,
      errorDigest: null,
      contentState: createHoistableState(),
      fallbackState: createHoistableState(),
      contentPreamble,
      fallbackPreamble,
      trackedContentKeyPath: null,
      trackedFallbackNode: null
    };
  }
  function createRenderTask(request, thenableState2, node, childIndex, blockedBoundary, blockedSegment, blockedPreamble, hoistableState, abortSet, keyPath, formatContext, context, treeContext, componentStack, isFallback) {
    request.allPendingTasks++;
    null === blockedBoundary ? request.pendingRootTasks++ : blockedBoundary.pendingTasks++;
    var task = {
      replay: null,
      node,
      childIndex,
      ping: function() {
        return pingTask(request, task);
      },
      blockedBoundary,
      blockedSegment,
      blockedPreamble,
      hoistableState,
      abortSet,
      keyPath,
      formatContext,
      context,
      treeContext,
      componentStack,
      thenableState: thenableState2,
      isFallback
    };
    abortSet.add(task);
    return task;
  }
  function createReplayTask(request, thenableState2, replay, node, childIndex, blockedBoundary, hoistableState, abortSet, keyPath, formatContext, context, treeContext, componentStack, isFallback) {
    request.allPendingTasks++;
    null === blockedBoundary ? request.pendingRootTasks++ : blockedBoundary.pendingTasks++;
    replay.pendingTasks++;
    var task = {
      replay,
      node,
      childIndex,
      ping: function() {
        return pingTask(request, task);
      },
      blockedBoundary,
      blockedSegment: null,
      blockedPreamble: null,
      hoistableState,
      abortSet,
      keyPath,
      formatContext,
      context,
      treeContext,
      componentStack,
      thenableState: thenableState2,
      isFallback
    };
    abortSet.add(task);
    return task;
  }
  function createPendingSegment(request, index, boundary, parentFormatContext, lastPushedText, textEmbedded) {
    return {
      status: 0,
      parentFlushed: false,
      id: -1,
      index,
      chunks: [],
      children: [],
      preambleChildren: [],
      parentFormatContext,
      boundary,
      lastPushedText,
      textEmbedded
    };
  }
  function pushComponentStack(task) {
    var node = task.node;
    if ("object" === typeof node && null !== node)
      switch (node.$$typeof) {
        case REACT_ELEMENT_TYPE:
          task.componentStack = { parent: task.componentStack, type: node.type };
      }
  }
  function getThrownInfo(node$jscomp$0) {
    var errorInfo = {};
    node$jscomp$0 && Object.defineProperty(errorInfo, "componentStack", {
      configurable: true,
      enumerable: true,
      get: function() {
        try {
          var info = "", node = node$jscomp$0;
          do
            info += describeComponentStackByType(node.type), node = node.parent;
          while (node);
          var JSCompiler_inline_result = info;
        } catch (x) {
          JSCompiler_inline_result = "\nError generating stack: " + x.message + "\n" + x.stack;
        }
        Object.defineProperty(errorInfo, "componentStack", {
          value: JSCompiler_inline_result
        });
        return JSCompiler_inline_result;
      }
    });
    return errorInfo;
  }
  function logRecoverableError(request, error, errorInfo) {
    request = request.onError;
    error = request(error, errorInfo);
    if (null == error || "string" === typeof error) return error;
  }
  function fatalError(request, error) {
    var onShellError = request.onShellError, onFatalError = request.onFatalError;
    onShellError(error);
    onFatalError(error);
    null !== request.destination ? (request.status = 14, closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
  }
  function renderWithHooks(request, task, keyPath, Component, props, secondArg) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    currentlyRenderingComponent = {};
    currentlyRenderingTask = task;
    currentlyRenderingRequest = request;
    currentlyRenderingKeyPath = keyPath;
    actionStateCounter = localIdCounter = 0;
    actionStateMatchingIndex = -1;
    thenableIndexCounter = 0;
    thenableState = prevThenableState;
    for (request = Component(props, secondArg); didScheduleRenderPhaseUpdate; )
      didScheduleRenderPhaseUpdate = false, actionStateCounter = localIdCounter = 0, actionStateMatchingIndex = -1, thenableIndexCounter = 0, numberOfReRenders += 1, workInProgressHook = null, request = Component(props, secondArg);
    resetHooksState();
    return request;
  }
  function finishFunctionComponent(request, task, keyPath, children, hasId, actionStateCount, actionStateMatchingIndex2) {
    var didEmitActionStateMarkers = false;
    if (0 !== actionStateCount && null !== request.formState) {
      var segment = task.blockedSegment;
      if (null !== segment) {
        didEmitActionStateMarkers = true;
        segment = segment.chunks;
        for (var i = 0; i < actionStateCount; i++)
          i === actionStateMatchingIndex2 ? segment.push(formStateMarkerIsMatching) : segment.push(formStateMarkerIsNotMatching);
      }
    }
    actionStateCount = task.keyPath;
    task.keyPath = keyPath;
    hasId ? (keyPath = task.treeContext, task.treeContext = pushTreeContext(keyPath, 1, 0), renderNode(request, task, children, -1), task.treeContext = keyPath) : didEmitActionStateMarkers ? renderNode(request, task, children, -1) : renderNodeDestructive(request, task, children, -1);
    task.keyPath = actionStateCount;
  }
  function renderElement(request, task, keyPath, type, props, ref) {
    if ("function" === typeof type)
      if (type.prototype && type.prototype.isReactComponent) {
        var newProps = props;
        if ("ref" in props) {
          newProps = {};
          for (var propName in props)
            "ref" !== propName && (newProps[propName] = props[propName]);
        }
        var defaultProps = type.defaultProps;
        if (defaultProps) {
          newProps === props && (newProps = assign({}, newProps, props));
          for (var propName$33 in defaultProps)
            void 0 === newProps[propName$33] && (newProps[propName$33] = defaultProps[propName$33]);
        }
        props = newProps;
        newProps = emptyContextObject;
        defaultProps = type.contextType;
        "object" === typeof defaultProps && null !== defaultProps && (newProps = defaultProps._currentValue);
        newProps = new type(props, newProps);
        var initialState = void 0 !== newProps.state ? newProps.state : null;
        newProps.updater = classComponentUpdater;
        newProps.props = props;
        newProps.state = initialState;
        defaultProps = { queue: [], replace: false };
        newProps._reactInternals = defaultProps;
        ref = type.contextType;
        newProps.context = "object" === typeof ref && null !== ref ? ref._currentValue : emptyContextObject;
        ref = type.getDerivedStateFromProps;
        "function" === typeof ref && (ref = ref(props, initialState), initialState = null === ref || void 0 === ref ? initialState : assign({}, initialState, ref), newProps.state = initialState);
        if ("function" !== typeof type.getDerivedStateFromProps && "function" !== typeof newProps.getSnapshotBeforeUpdate && ("function" === typeof newProps.UNSAFE_componentWillMount || "function" === typeof newProps.componentWillMount))
          if (type = newProps.state, "function" === typeof newProps.componentWillMount && newProps.componentWillMount(), "function" === typeof newProps.UNSAFE_componentWillMount && newProps.UNSAFE_componentWillMount(), type !== newProps.state && classComponentUpdater.enqueueReplaceState(
            newProps,
            newProps.state,
            null
          ), null !== defaultProps.queue && 0 < defaultProps.queue.length)
            if (type = defaultProps.queue, ref = defaultProps.replace, defaultProps.queue = null, defaultProps.replace = false, ref && 1 === type.length)
              newProps.state = type[0];
            else {
              defaultProps = ref ? type[0] : newProps.state;
              initialState = true;
              for (ref = ref ? 1 : 0; ref < type.length; ref++)
                propName$33 = type[ref], propName$33 = "function" === typeof propName$33 ? propName$33.call(newProps, defaultProps, props, void 0) : propName$33, null != propName$33 && (initialState ? (initialState = false, defaultProps = assign({}, defaultProps, propName$33)) : assign(defaultProps, propName$33));
              newProps.state = defaultProps;
            }
          else defaultProps.queue = null;
        type = newProps.render();
        if (12 === request.status) throw null;
        props = task.keyPath;
        task.keyPath = keyPath;
        renderNodeDestructive(request, task, type, -1);
        task.keyPath = props;
      } else {
        type = renderWithHooks(request, task, keyPath, type, props, void 0);
        if (12 === request.status) throw null;
        finishFunctionComponent(
          request,
          task,
          keyPath,
          type,
          0 !== localIdCounter,
          actionStateCounter,
          actionStateMatchingIndex
        );
      }
    else if ("string" === typeof type)
      if (newProps = task.blockedSegment, null === newProps)
        newProps = props.children, defaultProps = task.formatContext, initialState = task.keyPath, task.formatContext = getChildFormatContext(defaultProps, type, props), task.keyPath = keyPath, renderNode(request, task, newProps, -1), task.formatContext = defaultProps, task.keyPath = initialState;
      else {
        ref = pushStartInstance(
          newProps.chunks,
          type,
          props,
          request.resumableState,
          request.renderState,
          task.blockedPreamble,
          task.hoistableState,
          task.formatContext,
          newProps.lastPushedText,
          task.isFallback
        );
        newProps.lastPushedText = false;
        defaultProps = task.formatContext;
        initialState = task.keyPath;
        task.keyPath = keyPath;
        3 === (task.formatContext = getChildFormatContext(defaultProps, type, props)).insertionMode ? (keyPath = createPendingSegment(
          request,
          0,
          null,
          task.formatContext,
          false,
          false
        ), newProps.preambleChildren.push(keyPath), keyPath = createRenderTask(
          request,
          null,
          ref,
          -1,
          task.blockedBoundary,
          keyPath,
          task.blockedPreamble,
          task.hoistableState,
          request.abortableTasks,
          task.keyPath,
          task.formatContext,
          task.context,
          task.treeContext,
          task.componentStack,
          task.isFallback
        ), pushComponentStack(keyPath), request.pingedTasks.push(keyPath)) : renderNode(request, task, ref, -1);
        task.formatContext = defaultProps;
        task.keyPath = initialState;
        a: {
          task = newProps.chunks;
          request = request.resumableState;
          switch (type) {
            case "title":
            case "style":
            case "script":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
              break a;
            case "body":
              if (1 >= defaultProps.insertionMode) {
                request.hasBody = true;
                break a;
              }
              break;
            case "html":
              if (0 === defaultProps.insertionMode) {
                request.hasHtml = true;
                break a;
              }
              break;
            case "head":
              if (1 >= defaultProps.insertionMode) break a;
          }
          task.push(endChunkForTag(type));
        }
        newProps.lastPushedText = false;
      }
    else {
      switch (type) {
        case REACT_LEGACY_HIDDEN_TYPE:
        case REACT_STRICT_MODE_TYPE:
        case REACT_PROFILER_TYPE:
        case REACT_FRAGMENT_TYPE:
          type = task.keyPath;
          task.keyPath = keyPath;
          renderNodeDestructive(request, task, props.children, -1);
          task.keyPath = type;
          return;
        case REACT_ACTIVITY_TYPE:
          "hidden" !== props.mode && (type = task.keyPath, task.keyPath = keyPath, renderNodeDestructive(request, task, props.children, -1), task.keyPath = type);
          return;
        case REACT_SUSPENSE_LIST_TYPE:
          type = task.keyPath;
          task.keyPath = keyPath;
          renderNodeDestructive(request, task, props.children, -1);
          task.keyPath = type;
          return;
        case REACT_VIEW_TRANSITION_TYPE:
        case REACT_SCOPE_TYPE:
          throw Error(formatProdErrorMessage(343));
        case REACT_SUSPENSE_TYPE:
          a: if (null !== task.replay) {
            type = task.keyPath;
            task.keyPath = keyPath;
            keyPath = props.children;
            try {
              renderNode(request, task, keyPath, -1);
            } finally {
              task.keyPath = type;
            }
          } else {
            type = task.keyPath;
            var parentBoundary = task.blockedBoundary;
            ref = task.blockedPreamble;
            var parentHoistableState = task.hoistableState;
            propName$33 = task.blockedSegment;
            propName = props.fallback;
            props = props.children;
            var fallbackAbortSet = /* @__PURE__ */ new Set();
            var newBoundary = 2 > task.formatContext.insertionMode ? createSuspenseBoundary(
              request,
              fallbackAbortSet,
              createPreambleState(),
              createPreambleState()
            ) : createSuspenseBoundary(request, fallbackAbortSet, null, null);
            null !== request.trackedPostpones && (newBoundary.trackedContentKeyPath = keyPath);
            var boundarySegment = createPendingSegment(
              request,
              propName$33.chunks.length,
              newBoundary,
              task.formatContext,
              false,
              false
            );
            propName$33.children.push(boundarySegment);
            propName$33.lastPushedText = false;
            var contentRootSegment = createPendingSegment(
              request,
              0,
              null,
              task.formatContext,
              false,
              false
            );
            contentRootSegment.parentFlushed = true;
            if (null !== request.trackedPostpones) {
              newProps = [keyPath[0], "Suspense Fallback", keyPath[2]];
              defaultProps = [newProps[1], newProps[2], [], null];
              request.trackedPostpones.workingMap.set(newProps, defaultProps);
              newBoundary.trackedFallbackNode = defaultProps;
              task.blockedSegment = boundarySegment;
              task.blockedPreamble = newBoundary.fallbackPreamble;
              task.keyPath = newProps;
              boundarySegment.status = 6;
              try {
                renderNode(request, task, propName, -1), boundarySegment.lastPushedText && boundarySegment.textEmbedded && boundarySegment.chunks.push(textSeparator), boundarySegment.status = 1;
              } catch (thrownValue) {
                throw boundarySegment.status = 12 === request.status ? 3 : 4, thrownValue;
              } finally {
                task.blockedSegment = propName$33, task.blockedPreamble = ref, task.keyPath = type;
              }
              task = createRenderTask(
                request,
                null,
                props,
                -1,
                newBoundary,
                contentRootSegment,
                newBoundary.contentPreamble,
                newBoundary.contentState,
                task.abortSet,
                keyPath,
                task.formatContext,
                task.context,
                task.treeContext,
                task.componentStack,
                task.isFallback
              );
              pushComponentStack(task);
              request.pingedTasks.push(task);
            } else {
              task.blockedBoundary = newBoundary;
              task.blockedPreamble = newBoundary.contentPreamble;
              task.hoistableState = newBoundary.contentState;
              task.blockedSegment = contentRootSegment;
              task.keyPath = keyPath;
              contentRootSegment.status = 6;
              try {
                if (renderNode(request, task, props, -1), contentRootSegment.lastPushedText && contentRootSegment.textEmbedded && contentRootSegment.chunks.push(textSeparator), contentRootSegment.status = 1, queueCompletedSegment(newBoundary, contentRootSegment), 0 === newBoundary.pendingTasks && 0 === newBoundary.status) {
                  newBoundary.status = 1;
                  0 === request.pendingRootTasks && task.blockedPreamble && preparePreamble(request);
                  break a;
                }
              } catch (thrownValue$28) {
                newBoundary.status = 4, 12 === request.status ? (contentRootSegment.status = 3, newProps = request.fatalError) : (contentRootSegment.status = 4, newProps = thrownValue$28), defaultProps = getThrownInfo(task.componentStack), initialState = logRecoverableError(
                  request,
                  newProps,
                  defaultProps
                ), newBoundary.errorDigest = initialState, untrackBoundary(request, newBoundary);
              } finally {
                task.blockedBoundary = parentBoundary, task.blockedPreamble = ref, task.hoistableState = parentHoistableState, task.blockedSegment = propName$33, task.keyPath = type;
              }
              task = createRenderTask(
                request,
                null,
                propName,
                -1,
                parentBoundary,
                boundarySegment,
                newBoundary.fallbackPreamble,
                newBoundary.fallbackState,
                fallbackAbortSet,
                [keyPath[0], "Suspense Fallback", keyPath[2]],
                task.formatContext,
                task.context,
                task.treeContext,
                task.componentStack,
                true
              );
              pushComponentStack(task);
              request.pingedTasks.push(task);
            }
          }
          return;
      }
      if ("object" === typeof type && null !== type)
        switch (type.$$typeof) {
          case REACT_FORWARD_REF_TYPE:
            if ("ref" in props)
              for (newBoundary in newProps = {}, props)
                "ref" !== newBoundary && (newProps[newBoundary] = props[newBoundary]);
            else newProps = props;
            type = renderWithHooks(
              request,
              task,
              keyPath,
              type.render,
              newProps,
              ref
            );
            finishFunctionComponent(
              request,
              task,
              keyPath,
              type,
              0 !== localIdCounter,
              actionStateCounter,
              actionStateMatchingIndex
            );
            return;
          case REACT_MEMO_TYPE:
            renderElement(request, task, keyPath, type.type, props, ref);
            return;
          case REACT_PROVIDER_TYPE:
          case REACT_CONTEXT_TYPE:
            defaultProps = props.children;
            newProps = task.keyPath;
            props = props.value;
            initialState = type._currentValue;
            type._currentValue = props;
            ref = currentActiveSnapshot;
            currentActiveSnapshot = type = {
              parent: ref,
              depth: null === ref ? 0 : ref.depth + 1,
              context: type,
              parentValue: initialState,
              value: props
            };
            task.context = type;
            task.keyPath = keyPath;
            renderNodeDestructive(request, task, defaultProps, -1);
            request = currentActiveSnapshot;
            if (null === request) throw Error(formatProdErrorMessage(403));
            request.context._currentValue = request.parentValue;
            request = currentActiveSnapshot = request.parent;
            task.context = request;
            task.keyPath = newProps;
            return;
          case REACT_CONSUMER_TYPE:
            props = props.children;
            type = props(type._context._currentValue);
            props = task.keyPath;
            task.keyPath = keyPath;
            renderNodeDestructive(request, task, type, -1);
            task.keyPath = props;
            return;
          case REACT_LAZY_TYPE:
            newProps = type._init;
            type = newProps(type._payload);
            if (12 === request.status) throw null;
            renderElement(request, task, keyPath, type, props, ref);
            return;
        }
      throw Error(
        formatProdErrorMessage(130, null == type ? type : typeof type, "")
      );
    }
  }
  function resumeNode(request, task, segmentId, node, childIndex) {
    var prevReplay = task.replay, blockedBoundary = task.blockedBoundary, resumedSegment = createPendingSegment(
      request,
      0,
      null,
      task.formatContext,
      false,
      false
    );
    resumedSegment.id = segmentId;
    resumedSegment.parentFlushed = true;
    try {
      task.replay = null, task.blockedSegment = resumedSegment, renderNode(request, task, node, childIndex), resumedSegment.status = 1, null === blockedBoundary ? request.completedRootSegment = resumedSegment : (queueCompletedSegment(blockedBoundary, resumedSegment), blockedBoundary.parentFlushed && request.partialBoundaries.push(blockedBoundary));
    } finally {
      task.replay = prevReplay, task.blockedSegment = null;
    }
  }
  function renderNodeDestructive(request, task, node, childIndex) {
    null !== task.replay && "number" === typeof task.replay.slots ? resumeNode(request, task, task.replay.slots, node, childIndex) : (task.node = node, task.childIndex = childIndex, node = task.componentStack, pushComponentStack(task), retryNode(request, task), task.componentStack = node);
  }
  function retryNode(request, task) {
    var node = task.node, childIndex = task.childIndex;
    if (null !== node) {
      if ("object" === typeof node) {
        switch (node.$$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = node.type, key = node.key, props = node.props;
            node = props.ref;
            var ref = void 0 !== node ? node : null, name = getComponentNameFromType(type), keyOrIndex = null == key ? -1 === childIndex ? 0 : childIndex : key;
            key = [task.keyPath, name, keyOrIndex];
            if (null !== task.replay)
              a: {
                var replay = task.replay;
                childIndex = replay.nodes;
                for (node = 0; node < childIndex.length; node++) {
                  var node$jscomp$0 = childIndex[node];
                  if (keyOrIndex === node$jscomp$0[1]) {
                    if (4 === node$jscomp$0.length) {
                      if (null !== name && name !== node$jscomp$0[0])
                        throw Error(
                          formatProdErrorMessage(490, node$jscomp$0[0], name)
                        );
                      var childNodes = node$jscomp$0[2];
                      name = node$jscomp$0[3];
                      keyOrIndex = task.node;
                      task.replay = {
                        nodes: childNodes,
                        slots: name,
                        pendingTasks: 1
                      };
                      try {
                        renderElement(request, task, key, type, props, ref);
                        if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length)
                          throw Error(formatProdErrorMessage(488));
                        task.replay.pendingTasks--;
                      } catch (x) {
                        if ("object" === typeof x && null !== x && (x === SuspenseException || "function" === typeof x.then))
                          throw task.node === keyOrIndex && (task.replay = replay), x;
                        task.replay.pendingTasks--;
                        props = getThrownInfo(task.componentStack);
                        key = task.blockedBoundary;
                        type = x;
                        props = logRecoverableError(request, type, props);
                        abortRemainingReplayNodes(
                          request,
                          key,
                          childNodes,
                          name,
                          type,
                          props
                        );
                      }
                      task.replay = replay;
                    } else {
                      if (type !== REACT_SUSPENSE_TYPE)
                        throw Error(
                          formatProdErrorMessage(
                            490,
                            "Suspense",
                            getComponentNameFromType(type) || "Unknown"
                          )
                        );
                      b: {
                        replay = void 0;
                        type = node$jscomp$0[5];
                        ref = node$jscomp$0[2];
                        name = node$jscomp$0[3];
                        keyOrIndex = null === node$jscomp$0[4] ? [] : node$jscomp$0[4][2];
                        node$jscomp$0 = null === node$jscomp$0[4] ? null : node$jscomp$0[4][3];
                        var prevKeyPath = task.keyPath, previousReplaySet = task.replay, parentBoundary = task.blockedBoundary, parentHoistableState = task.hoistableState, content = props.children, fallback = props.fallback, fallbackAbortSet = /* @__PURE__ */ new Set();
                        props = 2 > task.formatContext.insertionMode ? createSuspenseBoundary(
                          request,
                          fallbackAbortSet,
                          createPreambleState(),
                          createPreambleState()
                        ) : createSuspenseBoundary(
                          request,
                          fallbackAbortSet,
                          null,
                          null
                        );
                        props.parentFlushed = true;
                        props.rootSegmentID = type;
                        task.blockedBoundary = props;
                        task.hoistableState = props.contentState;
                        task.keyPath = key;
                        task.replay = {
                          nodes: ref,
                          slots: name,
                          pendingTasks: 1
                        };
                        try {
                          renderNode(request, task, content, -1);
                          if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length)
                            throw Error(formatProdErrorMessage(488));
                          task.replay.pendingTasks--;
                          if (0 === props.pendingTasks && 0 === props.status) {
                            props.status = 1;
                            request.completedBoundaries.push(props);
                            break b;
                          }
                        } catch (error) {
                          props.status = 4, childNodes = getThrownInfo(task.componentStack), replay = logRecoverableError(
                            request,
                            error,
                            childNodes
                          ), props.errorDigest = replay, task.replay.pendingTasks--, request.clientRenderedBoundaries.push(props);
                        } finally {
                          task.blockedBoundary = parentBoundary, task.hoistableState = parentHoistableState, task.replay = previousReplaySet, task.keyPath = prevKeyPath;
                        }
                        task = createReplayTask(
                          request,
                          null,
                          {
                            nodes: keyOrIndex,
                            slots: node$jscomp$0,
                            pendingTasks: 0
                          },
                          fallback,
                          -1,
                          parentBoundary,
                          props.fallbackState,
                          fallbackAbortSet,
                          [key[0], "Suspense Fallback", key[2]],
                          task.formatContext,
                          task.context,
                          task.treeContext,
                          task.componentStack,
                          true
                        );
                        pushComponentStack(task);
                        request.pingedTasks.push(task);
                      }
                    }
                    childIndex.splice(node, 1);
                    break a;
                  }
                }
              }
            else renderElement(request, task, key, type, props, ref);
            return;
          case REACT_PORTAL_TYPE:
            throw Error(formatProdErrorMessage(257));
          case REACT_LAZY_TYPE:
            childNodes = node._init;
            node = childNodes(node._payload);
            if (12 === request.status) throw null;
            renderNodeDestructive(request, task, node, childIndex);
            return;
        }
        if (isArrayImpl(node)) {
          renderChildrenArray(request, task, node, childIndex);
          return;
        }
        null === node || "object" !== typeof node ? childNodes = null : (childNodes = MAYBE_ITERATOR_SYMBOL && node[MAYBE_ITERATOR_SYMBOL] || node["@@iterator"], childNodes = "function" === typeof childNodes ? childNodes : null);
        if (childNodes && (childNodes = childNodes.call(node))) {
          node = childNodes.next();
          if (!node.done) {
            props = [];
            do
              props.push(node.value), node = childNodes.next();
            while (!node.done);
            renderChildrenArray(request, task, props, childIndex);
          }
          return;
        }
        if ("function" === typeof node.then)
          return task.thenableState = null, renderNodeDestructive(request, task, unwrapThenable(node), childIndex);
        if (node.$$typeof === REACT_CONTEXT_TYPE)
          return renderNodeDestructive(
            request,
            task,
            node._currentValue,
            childIndex
          );
        childIndex = Object.prototype.toString.call(node);
        throw Error(
          formatProdErrorMessage(
            31,
            "[object Object]" === childIndex ? "object with keys {" + Object.keys(node).join(", ") + "}" : childIndex
          )
        );
      }
      if ("string" === typeof node)
        childIndex = task.blockedSegment, null !== childIndex && (childIndex.lastPushedText = pushTextInstance(
          childIndex.chunks,
          node,
          request.renderState,
          childIndex.lastPushedText
        ));
      else if ("number" === typeof node || "bigint" === typeof node)
        childIndex = task.blockedSegment, null !== childIndex && (childIndex.lastPushedText = pushTextInstance(
          childIndex.chunks,
          "" + node,
          request.renderState,
          childIndex.lastPushedText
        ));
    }
  }
  function renderChildrenArray(request, task, children, childIndex) {
    var prevKeyPath = task.keyPath;
    if (-1 !== childIndex && (task.keyPath = [task.keyPath, "Fragment", childIndex], null !== task.replay)) {
      for (var replay = task.replay, replayNodes = replay.nodes, j = 0; j < replayNodes.length; j++) {
        var node = replayNodes[j];
        if (node[1] === childIndex) {
          childIndex = node[2];
          node = node[3];
          task.replay = { nodes: childIndex, slots: node, pendingTasks: 1 };
          try {
            renderChildrenArray(request, task, children, -1);
            if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length)
              throw Error(formatProdErrorMessage(488));
            task.replay.pendingTasks--;
          } catch (x) {
            if ("object" === typeof x && null !== x && (x === SuspenseException || "function" === typeof x.then))
              throw x;
            task.replay.pendingTasks--;
            children = getThrownInfo(task.componentStack);
            var boundary = task.blockedBoundary, error = x;
            children = logRecoverableError(request, error, children);
            abortRemainingReplayNodes(
              request,
              boundary,
              childIndex,
              node,
              error,
              children
            );
          }
          task.replay = replay;
          replayNodes.splice(j, 1);
          break;
        }
      }
      task.keyPath = prevKeyPath;
      return;
    }
    replay = task.treeContext;
    replayNodes = children.length;
    if (null !== task.replay && (j = task.replay.slots, null !== j && "object" === typeof j)) {
      for (childIndex = 0; childIndex < replayNodes; childIndex++)
        node = children[childIndex], task.treeContext = pushTreeContext(replay, replayNodes, childIndex), boundary = j[childIndex], "number" === typeof boundary ? (resumeNode(request, task, boundary, node, childIndex), delete j[childIndex]) : renderNode(request, task, node, childIndex);
      task.treeContext = replay;
      task.keyPath = prevKeyPath;
      return;
    }
    for (j = 0; j < replayNodes; j++)
      childIndex = children[j], task.treeContext = pushTreeContext(replay, replayNodes, j), renderNode(request, task, childIndex, j);
    task.treeContext = replay;
    task.keyPath = prevKeyPath;
  }
  function untrackBoundary(request, boundary) {
    request = request.trackedPostpones;
    null !== request && (boundary = boundary.trackedContentKeyPath, null !== boundary && (boundary = request.workingMap.get(boundary), void 0 !== boundary && (boundary.length = 4, boundary[2] = [], boundary[3] = null)));
  }
  function spawnNewSuspendedReplayTask(request, task, thenableState2) {
    return createReplayTask(
      request,
      thenableState2,
      task.replay,
      task.node,
      task.childIndex,
      task.blockedBoundary,
      task.hoistableState,
      task.abortSet,
      task.keyPath,
      task.formatContext,
      task.context,
      task.treeContext,
      task.componentStack,
      task.isFallback
    );
  }
  function spawnNewSuspendedRenderTask(request, task, thenableState2) {
    var segment = task.blockedSegment, newSegment = createPendingSegment(
      request,
      segment.chunks.length,
      null,
      task.formatContext,
      segment.lastPushedText,
      true
    );
    segment.children.push(newSegment);
    segment.lastPushedText = false;
    return createRenderTask(
      request,
      thenableState2,
      task.node,
      task.childIndex,
      task.blockedBoundary,
      newSegment,
      task.blockedPreamble,
      task.hoistableState,
      task.abortSet,
      task.keyPath,
      task.formatContext,
      task.context,
      task.treeContext,
      task.componentStack,
      task.isFallback
    );
  }
  function renderNode(request, task, node, childIndex) {
    var previousFormatContext = task.formatContext, previousContext = task.context, previousKeyPath = task.keyPath, previousTreeContext = task.treeContext, previousComponentStack = task.componentStack, segment = task.blockedSegment;
    if (null === segment)
      try {
        return renderNodeDestructive(request, task, node, childIndex);
      } catch (thrownValue) {
        if (resetHooksState(), node = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue, "object" === typeof node && null !== node) {
          if ("function" === typeof node.then) {
            childIndex = getThenableStateAfterSuspending();
            request = spawnNewSuspendedReplayTask(request, task, childIndex).ping;
            node.then(request, request);
            task.formatContext = previousFormatContext;
            task.context = previousContext;
            task.keyPath = previousKeyPath;
            task.treeContext = previousTreeContext;
            task.componentStack = previousComponentStack;
            switchContext(previousContext);
            return;
          }
          if ("Maximum call stack size exceeded" === node.message) {
            node = getThenableStateAfterSuspending();
            node = spawnNewSuspendedReplayTask(request, task, node);
            request.pingedTasks.push(node);
            task.formatContext = previousFormatContext;
            task.context = previousContext;
            task.keyPath = previousKeyPath;
            task.treeContext = previousTreeContext;
            task.componentStack = previousComponentStack;
            switchContext(previousContext);
            return;
          }
        }
      }
    else {
      var childrenLength = segment.children.length, chunkLength = segment.chunks.length;
      try {
        return renderNodeDestructive(request, task, node, childIndex);
      } catch (thrownValue$48) {
        if (resetHooksState(), segment.children.length = childrenLength, segment.chunks.length = chunkLength, node = thrownValue$48 === SuspenseException ? getSuspendedThenable() : thrownValue$48, "object" === typeof node && null !== node) {
          if ("function" === typeof node.then) {
            childIndex = getThenableStateAfterSuspending();
            request = spawnNewSuspendedRenderTask(request, task, childIndex).ping;
            node.then(request, request);
            task.formatContext = previousFormatContext;
            task.context = previousContext;
            task.keyPath = previousKeyPath;
            task.treeContext = previousTreeContext;
            task.componentStack = previousComponentStack;
            switchContext(previousContext);
            return;
          }
          if ("Maximum call stack size exceeded" === node.message) {
            node = getThenableStateAfterSuspending();
            node = spawnNewSuspendedRenderTask(request, task, node);
            request.pingedTasks.push(node);
            task.formatContext = previousFormatContext;
            task.context = previousContext;
            task.keyPath = previousKeyPath;
            task.treeContext = previousTreeContext;
            task.componentStack = previousComponentStack;
            switchContext(previousContext);
            return;
          }
        }
      }
    }
    task.formatContext = previousFormatContext;
    task.context = previousContext;
    task.keyPath = previousKeyPath;
    task.treeContext = previousTreeContext;
    switchContext(previousContext);
    throw node;
  }
  function abortTaskSoft(task) {
    var boundary = task.blockedBoundary;
    task = task.blockedSegment;
    null !== task && (task.status = 3, finishedTask(this, boundary, task));
  }
  function abortRemainingReplayNodes(request$jscomp$0, boundary, nodes, slots, error, errorDigest$jscomp$0) {
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (4 === node.length)
        abortRemainingReplayNodes(
          request$jscomp$0,
          boundary,
          node[2],
          node[3],
          error,
          errorDigest$jscomp$0
        );
      else {
        node = node[5];
        var request = request$jscomp$0, errorDigest = errorDigest$jscomp$0, resumedBoundary = createSuspenseBoundary(
          request,
          /* @__PURE__ */ new Set(),
          null,
          null
        );
        resumedBoundary.parentFlushed = true;
        resumedBoundary.rootSegmentID = node;
        resumedBoundary.status = 4;
        resumedBoundary.errorDigest = errorDigest;
        resumedBoundary.parentFlushed && request.clientRenderedBoundaries.push(resumedBoundary);
      }
    }
    nodes.length = 0;
    if (null !== slots) {
      if (null === boundary) throw Error(formatProdErrorMessage(487));
      4 !== boundary.status && (boundary.status = 4, boundary.errorDigest = errorDigest$jscomp$0, boundary.parentFlushed && request$jscomp$0.clientRenderedBoundaries.push(boundary));
      if ("object" === typeof slots) for (var index in slots) delete slots[index];
    }
  }
  function abortTask(task, request, error) {
    var boundary = task.blockedBoundary, segment = task.blockedSegment;
    if (null !== segment) {
      if (6 === segment.status) return;
      segment.status = 3;
    }
    segment = getThrownInfo(task.componentStack);
    if (null === boundary) {
      if (13 !== request.status && 14 !== request.status) {
        boundary = task.replay;
        if (null === boundary) {
          logRecoverableError(request, error, segment);
          fatalError(request, error);
          return;
        }
        boundary.pendingTasks--;
        0 === boundary.pendingTasks && 0 < boundary.nodes.length && (task = logRecoverableError(request, error, segment), abortRemainingReplayNodes(
          request,
          null,
          boundary.nodes,
          boundary.slots,
          error,
          task
        ));
        request.pendingRootTasks--;
        0 === request.pendingRootTasks && completeShell(request);
      }
    } else
      boundary.pendingTasks--, 4 !== boundary.status && (boundary.status = 4, task = logRecoverableError(request, error, segment), boundary.status = 4, boundary.errorDigest = task, untrackBoundary(request, boundary), boundary.parentFlushed && request.clientRenderedBoundaries.push(boundary)), boundary.fallbackAbortableTasks.forEach(function(fallbackTask) {
        return abortTask(fallbackTask, request, error);
      }), boundary.fallbackAbortableTasks.clear();
    request.allPendingTasks--;
    0 === request.allPendingTasks && completeAll(request);
  }
  function safelyEmitEarlyPreloads(request, shellComplete) {
    try {
      var renderState = request.renderState, onHeaders = renderState.onHeaders;
      if (onHeaders) {
        var headers = renderState.headers;
        if (headers) {
          renderState.headers = null;
          var linkHeader = headers.preconnects;
          headers.fontPreloads && (linkHeader && (linkHeader += ", "), linkHeader += headers.fontPreloads);
          headers.highImagePreloads && (linkHeader && (linkHeader += ", "), linkHeader += headers.highImagePreloads);
          if (!shellComplete) {
            var queueIter = renderState.styles.values(), queueStep = queueIter.next();
            b: for (; 0 < headers.remainingCapacity && !queueStep.done; queueStep = queueIter.next())
              for (var sheetIter = queueStep.value.sheets.values(), sheetStep = sheetIter.next(); 0 < headers.remainingCapacity && !sheetStep.done; sheetStep = sheetIter.next()) {
                var sheet = sheetStep.value, props = sheet.props, key = props.href, props$jscomp$0 = sheet.props, header = getPreloadAsHeader(props$jscomp$0.href, "style", {
                  crossOrigin: props$jscomp$0.crossOrigin,
                  integrity: props$jscomp$0.integrity,
                  nonce: props$jscomp$0.nonce,
                  type: props$jscomp$0.type,
                  fetchPriority: props$jscomp$0.fetchPriority,
                  referrerPolicy: props$jscomp$0.referrerPolicy,
                  media: props$jscomp$0.media
                });
                if (0 <= (headers.remainingCapacity -= header.length + 2))
                  renderState.resets.style[key] = PRELOAD_NO_CREDS, linkHeader && (linkHeader += ", "), linkHeader += header, renderState.resets.style[key] = "string" === typeof props.crossOrigin || "string" === typeof props.integrity ? [props.crossOrigin, props.integrity] : PRELOAD_NO_CREDS;
                else break b;
              }
          }
          linkHeader ? onHeaders({ Link: linkHeader }) : onHeaders({});
        }
      }
    } catch (error) {
      logRecoverableError(request, error, {});
    }
  }
  function completeShell(request) {
    null === request.trackedPostpones && safelyEmitEarlyPreloads(request, true);
    null === request.trackedPostpones && preparePreamble(request);
    request.onShellError = noop;
    request = request.onShellReady;
    request();
  }
  function completeAll(request) {
    safelyEmitEarlyPreloads(
      request,
      null === request.trackedPostpones ? true : null === request.completedRootSegment || 5 !== request.completedRootSegment.status
    );
    preparePreamble(request);
    request = request.onAllReady;
    request();
  }
  function queueCompletedSegment(boundary, segment) {
    if (0 === segment.chunks.length && 1 === segment.children.length && null === segment.children[0].boundary && -1 === segment.children[0].id) {
      var childSegment = segment.children[0];
      childSegment.id = segment.id;
      childSegment.parentFlushed = true;
      1 === childSegment.status && queueCompletedSegment(boundary, childSegment);
    } else boundary.completedSegments.push(segment);
  }
  function finishedTask(request, boundary, segment) {
    if (null === boundary) {
      if (null !== segment && segment.parentFlushed) {
        if (null !== request.completedRootSegment)
          throw Error(formatProdErrorMessage(389));
        request.completedRootSegment = segment;
      }
      request.pendingRootTasks--;
      0 === request.pendingRootTasks && completeShell(request);
    } else
      boundary.pendingTasks--, 4 !== boundary.status && (0 === boundary.pendingTasks ? (0 === boundary.status && (boundary.status = 1), null !== segment && segment.parentFlushed && 1 === segment.status && queueCompletedSegment(boundary, segment), boundary.parentFlushed && request.completedBoundaries.push(boundary), 1 === boundary.status && (boundary.fallbackAbortableTasks.forEach(abortTaskSoft, request), boundary.fallbackAbortableTasks.clear(), 0 === request.pendingRootTasks && null === request.trackedPostpones && null !== boundary.contentPreamble && preparePreamble(request))) : null !== segment && segment.parentFlushed && 1 === segment.status && (queueCompletedSegment(boundary, segment), 1 === boundary.completedSegments.length && boundary.parentFlushed && request.partialBoundaries.push(boundary)));
    request.allPendingTasks--;
    0 === request.allPendingTasks && completeAll(request);
  }
  function performWork(request$jscomp$2) {
    if (14 !== request$jscomp$2.status && 13 !== request$jscomp$2.status) {
      var prevContext = currentActiveSnapshot, prevDispatcher = ReactSharedInternals.H;
      ReactSharedInternals.H = HooksDispatcher;
      var prevAsyncDispatcher = ReactSharedInternals.A;
      ReactSharedInternals.A = DefaultAsyncDispatcher;
      var prevRequest = currentRequest;
      currentRequest = request$jscomp$2;
      var prevResumableState = currentResumableState;
      currentResumableState = request$jscomp$2.resumableState;
      try {
        var pingedTasks = request$jscomp$2.pingedTasks, i;
        for (i = 0; i < pingedTasks.length; i++) {
          var task = pingedTasks[i], request = request$jscomp$2, segment = task.blockedSegment;
          if (null === segment) {
            var request$jscomp$0 = request;
            if (0 !== task.replay.pendingTasks) {
              switchContext(task.context);
              try {
                "number" === typeof task.replay.slots ? resumeNode(
                  request$jscomp$0,
                  task,
                  task.replay.slots,
                  task.node,
                  task.childIndex
                ) : retryNode(request$jscomp$0, task);
                if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length)
                  throw Error(formatProdErrorMessage(488));
                task.replay.pendingTasks--;
                task.abortSet.delete(task);
                finishedTask(request$jscomp$0, task.blockedBoundary, null);
              } catch (thrownValue) {
                resetHooksState();
                var x = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue;
                if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                  var ping = task.ping;
                  x.then(ping, ping);
                  task.thenableState = getThenableStateAfterSuspending();
                } else {
                  task.replay.pendingTasks--;
                  task.abortSet.delete(task);
                  var errorInfo = getThrownInfo(task.componentStack);
                  request = void 0;
                  var request$jscomp$1 = request$jscomp$0, boundary = task.blockedBoundary, error$jscomp$0 = 12 === request$jscomp$0.status ? request$jscomp$0.fatalError : x, replayNodes = task.replay.nodes, resumeSlots = task.replay.slots;
                  request = logRecoverableError(
                    request$jscomp$1,
                    error$jscomp$0,
                    errorInfo
                  );
                  abortRemainingReplayNodes(
                    request$jscomp$1,
                    boundary,
                    replayNodes,
                    resumeSlots,
                    error$jscomp$0,
                    request
                  );
                  request$jscomp$0.pendingRootTasks--;
                  0 === request$jscomp$0.pendingRootTasks && completeShell(request$jscomp$0);
                  request$jscomp$0.allPendingTasks--;
                  0 === request$jscomp$0.allPendingTasks && completeAll(request$jscomp$0);
                }
              } finally {
              }
            }
          } else if (request$jscomp$0 = void 0, request$jscomp$1 = segment, 0 === request$jscomp$1.status) {
            request$jscomp$1.status = 6;
            switchContext(task.context);
            var childrenLength = request$jscomp$1.children.length, chunkLength = request$jscomp$1.chunks.length;
            try {
              retryNode(request, task), request$jscomp$1.lastPushedText && request$jscomp$1.textEmbedded && request$jscomp$1.chunks.push(textSeparator), task.abortSet.delete(task), request$jscomp$1.status = 1, finishedTask(request, task.blockedBoundary, request$jscomp$1);
            } catch (thrownValue) {
              resetHooksState();
              request$jscomp$1.children.length = childrenLength;
              request$jscomp$1.chunks.length = chunkLength;
              var x$jscomp$0 = thrownValue === SuspenseException ? getSuspendedThenable() : 12 === request.status ? request.fatalError : thrownValue;
              if ("object" === typeof x$jscomp$0 && null !== x$jscomp$0 && "function" === typeof x$jscomp$0.then) {
                request$jscomp$1.status = 0;
                task.thenableState = getThenableStateAfterSuspending();
                var ping$jscomp$0 = task.ping;
                x$jscomp$0.then(ping$jscomp$0, ping$jscomp$0);
              } else {
                var errorInfo$jscomp$0 = getThrownInfo(task.componentStack);
                task.abortSet.delete(task);
                request$jscomp$1.status = 4;
                var boundary$jscomp$0 = task.blockedBoundary;
                request$jscomp$0 = logRecoverableError(
                  request,
                  x$jscomp$0,
                  errorInfo$jscomp$0
                );
                null === boundary$jscomp$0 ? fatalError(request, x$jscomp$0) : (boundary$jscomp$0.pendingTasks--, 4 !== boundary$jscomp$0.status && (boundary$jscomp$0.status = 4, boundary$jscomp$0.errorDigest = request$jscomp$0, untrackBoundary(request, boundary$jscomp$0), boundary$jscomp$0.parentFlushed && request.clientRenderedBoundaries.push(boundary$jscomp$0), 0 === request.pendingRootTasks && null === request.trackedPostpones && null !== boundary$jscomp$0.contentPreamble && preparePreamble(request)));
                request.allPendingTasks--;
                0 === request.allPendingTasks && completeAll(request);
              }
            } finally {
            }
          }
        }
        pingedTasks.splice(0, i);
        null !== request$jscomp$2.destination && flushCompletedQueues(request$jscomp$2, request$jscomp$2.destination);
      } catch (error) {
        logRecoverableError(request$jscomp$2, error, {}), fatalError(request$jscomp$2, error);
      } finally {
        currentResumableState = prevResumableState, ReactSharedInternals.H = prevDispatcher, ReactSharedInternals.A = prevAsyncDispatcher, prevDispatcher === HooksDispatcher && switchContext(prevContext), currentRequest = prevRequest;
      }
    }
  }
  function preparePreambleFromSubtree(request, segment, collectedPreambleSegments) {
    segment.preambleChildren.length && collectedPreambleSegments.push(segment.preambleChildren);
    for (var pendingPreambles = false, i = 0; i < segment.children.length; i++)
      pendingPreambles = preparePreambleFromSegment(
        request,
        segment.children[i],
        collectedPreambleSegments
      ) || pendingPreambles;
    return pendingPreambles;
  }
  function preparePreambleFromSegment(request, segment, collectedPreambleSegments) {
    var boundary = segment.boundary;
    if (null === boundary)
      return preparePreambleFromSubtree(
        request,
        segment,
        collectedPreambleSegments
      );
    var preamble = boundary.contentPreamble, fallbackPreamble = boundary.fallbackPreamble;
    if (null === preamble || null === fallbackPreamble) return false;
    switch (boundary.status) {
      case 1:
        hoistPreambleState(request.renderState, preamble);
        segment = boundary.completedSegments[0];
        if (!segment) throw Error(formatProdErrorMessage(391));
        return preparePreambleFromSubtree(
          request,
          segment,
          collectedPreambleSegments
        );
      case 5:
        if (null !== request.trackedPostpones) return true;
      case 4:
        if (1 === segment.status)
          return hoistPreambleState(request.renderState, fallbackPreamble), preparePreambleFromSubtree(
            request,
            segment,
            collectedPreambleSegments
          );
      default:
        return true;
    }
  }
  function preparePreamble(request) {
    if (request.completedRootSegment && null === request.completedPreambleSegments) {
      var collectedPreambleSegments = [], hasPendingPreambles = preparePreambleFromSegment(
        request,
        request.completedRootSegment,
        collectedPreambleSegments
      ), preamble = request.renderState.preamble;
      if (false === hasPendingPreambles || preamble.headChunks && preamble.bodyChunks)
        request.completedPreambleSegments = collectedPreambleSegments;
    }
  }
  function flushSubtree(request, destination, segment, hoistableState) {
    segment.parentFlushed = true;
    switch (segment.status) {
      case 0:
        segment.id = request.nextSegmentId++;
      case 5:
        return hoistableState = segment.id, segment.lastPushedText = false, segment.textEmbedded = false, request = request.renderState, writeChunk(destination, placeholder1), writeChunk(destination, request.placeholderPrefix), request = stringToChunk(hoistableState.toString(16)), writeChunk(destination, request), writeChunkAndReturn(destination, placeholder2);
      case 1:
        segment.status = 2;
        var r = true, chunks = segment.chunks, chunkIdx = 0;
        segment = segment.children;
        for (var childIdx = 0; childIdx < segment.length; childIdx++) {
          for (r = segment[childIdx]; chunkIdx < r.index; chunkIdx++)
            writeChunk(destination, chunks[chunkIdx]);
          r = flushSegment(request, destination, r, hoistableState);
        }
        for (; chunkIdx < chunks.length - 1; chunkIdx++)
          writeChunk(destination, chunks[chunkIdx]);
        chunkIdx < chunks.length && (r = writeChunkAndReturn(destination, chunks[chunkIdx]));
        return r;
      default:
        throw Error(formatProdErrorMessage(390));
    }
  }
  function flushSegment(request, destination, segment, hoistableState) {
    var boundary = segment.boundary;
    if (null === boundary)
      return flushSubtree(request, destination, segment, hoistableState);
    boundary.parentFlushed = true;
    if (4 === boundary.status) {
      var errorDigest = boundary.errorDigest;
      writeChunkAndReturn(destination, startClientRenderedSuspenseBoundary);
      writeChunk(destination, clientRenderedSuspenseBoundaryError1);
      errorDigest && (writeChunk(destination, clientRenderedSuspenseBoundaryError1A), writeChunk(destination, stringToChunk(escapeTextForBrowser(errorDigest))), writeChunk(
        destination,
        clientRenderedSuspenseBoundaryErrorAttrInterstitial
      ));
      writeChunkAndReturn(destination, clientRenderedSuspenseBoundaryError2);
      flushSubtree(request, destination, segment, hoistableState);
      (request = boundary.fallbackPreamble) && writePreambleContribution(destination, request);
      return writeChunkAndReturn(destination, endSuspenseBoundary);
    }
    if (1 !== boundary.status)
      return 0 === boundary.status && (boundary.rootSegmentID = request.nextSegmentId++), 0 < boundary.completedSegments.length && request.partialBoundaries.push(boundary), writeStartPendingSuspenseBoundary(
        destination,
        request.renderState,
        boundary.rootSegmentID
      ), hoistableState && (boundary = boundary.fallbackState, boundary.styles.forEach(hoistStyleQueueDependency, hoistableState), boundary.stylesheets.forEach(
        hoistStylesheetDependency,
        hoistableState
      )), flushSubtree(request, destination, segment, hoistableState), writeChunkAndReturn(destination, endSuspenseBoundary);
    if (boundary.byteSize > request.progressiveChunkSize)
      return boundary.rootSegmentID = request.nextSegmentId++, request.completedBoundaries.push(boundary), writeStartPendingSuspenseBoundary(
        destination,
        request.renderState,
        boundary.rootSegmentID
      ), flushSubtree(request, destination, segment, hoistableState), writeChunkAndReturn(destination, endSuspenseBoundary);
    hoistableState && (segment = boundary.contentState, segment.styles.forEach(hoistStyleQueueDependency, hoistableState), segment.stylesheets.forEach(hoistStylesheetDependency, hoistableState));
    writeChunkAndReturn(destination, startCompletedSuspenseBoundary);
    segment = boundary.completedSegments;
    if (1 !== segment.length) throw Error(formatProdErrorMessage(391));
    flushSegment(request, destination, segment[0], hoistableState);
    (request = boundary.contentPreamble) && writePreambleContribution(destination, request);
    return writeChunkAndReturn(destination, endSuspenseBoundary);
  }
  function flushSegmentContainer(request, destination, segment, hoistableState) {
    writeStartSegment(
      destination,
      request.renderState,
      segment.parentFormatContext,
      segment.id
    );
    flushSegment(request, destination, segment, hoistableState);
    return writeEndSegment(destination, segment.parentFormatContext);
  }
  function flushCompletedBoundary(request, destination, boundary) {
    for (var completedSegments = boundary.completedSegments, i = 0; i < completedSegments.length; i++)
      flushPartiallyCompletedSegment(
        request,
        destination,
        boundary,
        completedSegments[i]
      );
    completedSegments.length = 0;
    writeHoistablesForBoundary(
      destination,
      boundary.contentState,
      request.renderState
    );
    completedSegments = request.resumableState;
    request = request.renderState;
    i = boundary.rootSegmentID;
    boundary = boundary.contentState;
    var requiresStyleInsertion = request.stylesToHoist;
    request.stylesToHoist = false;
    writeChunk(destination, request.startInlineScript);
    requiresStyleInsertion ? 0 === (completedSegments.instructions & 2) ? (completedSegments.instructions |= 10, writeChunk(destination, completeBoundaryWithStylesScript1FullBoth)) : 0 === (completedSegments.instructions & 8) ? (completedSegments.instructions |= 8, writeChunk(destination, completeBoundaryWithStylesScript1FullPartial)) : writeChunk(destination, completeBoundaryWithStylesScript1Partial) : 0 === (completedSegments.instructions & 2) ? (completedSegments.instructions |= 2, writeChunk(destination, completeBoundaryScript1Full)) : writeChunk(destination, completeBoundaryScript1Partial);
    completedSegments = stringToChunk(i.toString(16));
    writeChunk(destination, request.boundaryPrefix);
    writeChunk(destination, completedSegments);
    writeChunk(destination, completeBoundaryScript2);
    writeChunk(destination, request.segmentPrefix);
    writeChunk(destination, completedSegments);
    requiresStyleInsertion ? (writeChunk(destination, completeBoundaryScript3a), writeStyleResourceDependenciesInJS(destination, boundary)) : writeChunk(destination, completeBoundaryScript3b);
    boundary = writeChunkAndReturn(destination, completeBoundaryScriptEnd);
    return writeBootstrap(destination, request) && boundary;
  }
  function flushPartiallyCompletedSegment(request, destination, boundary, segment) {
    if (2 === segment.status) return true;
    var hoistableState = boundary.contentState, segmentID = segment.id;
    if (-1 === segmentID) {
      if (-1 === (segment.id = boundary.rootSegmentID))
        throw Error(formatProdErrorMessage(392));
      return flushSegmentContainer(request, destination, segment, hoistableState);
    }
    if (segmentID === boundary.rootSegmentID)
      return flushSegmentContainer(request, destination, segment, hoistableState);
    flushSegmentContainer(request, destination, segment, hoistableState);
    boundary = request.resumableState;
    request = request.renderState;
    writeChunk(destination, request.startInlineScript);
    0 === (boundary.instructions & 1) ? (boundary.instructions |= 1, writeChunk(destination, completeSegmentScript1Full)) : writeChunk(destination, completeSegmentScript1Partial);
    writeChunk(destination, request.segmentPrefix);
    segmentID = stringToChunk(segmentID.toString(16));
    writeChunk(destination, segmentID);
    writeChunk(destination, completeSegmentScript2);
    writeChunk(destination, request.placeholderPrefix);
    writeChunk(destination, segmentID);
    destination = writeChunkAndReturn(destination, completeSegmentScriptEnd);
    return destination;
  }
  function flushCompletedQueues(request, destination) {
    currentView = new Uint8Array(2048);
    writtenBytes = 0;
    try {
      if (!(0 < request.pendingRootTasks)) {
        var i, completedRootSegment = request.completedRootSegment;
        if (null !== completedRootSegment) {
          if (5 === completedRootSegment.status) return;
          var completedPreambleSegments = request.completedPreambleSegments;
          if (null === completedPreambleSegments) return;
          var renderState = request.renderState, preamble = renderState.preamble, htmlChunks = preamble.htmlChunks, headChunks = preamble.headChunks, i$jscomp$0;
          if (htmlChunks) {
            for (i$jscomp$0 = 0; i$jscomp$0 < htmlChunks.length; i$jscomp$0++)
              writeChunk(destination, htmlChunks[i$jscomp$0]);
            if (headChunks)
              for (i$jscomp$0 = 0; i$jscomp$0 < headChunks.length; i$jscomp$0++)
                writeChunk(destination, headChunks[i$jscomp$0]);
            else
              writeChunk(destination, startChunkForTag("head")), writeChunk(destination, endOfStartTag);
          } else if (headChunks)
            for (i$jscomp$0 = 0; i$jscomp$0 < headChunks.length; i$jscomp$0++)
              writeChunk(destination, headChunks[i$jscomp$0]);
          var charsetChunks = renderState.charsetChunks;
          for (i$jscomp$0 = 0; i$jscomp$0 < charsetChunks.length; i$jscomp$0++)
            writeChunk(destination, charsetChunks[i$jscomp$0]);
          charsetChunks.length = 0;
          renderState.preconnects.forEach(flushResource, destination);
          renderState.preconnects.clear();
          var viewportChunks = renderState.viewportChunks;
          for (i$jscomp$0 = 0; i$jscomp$0 < viewportChunks.length; i$jscomp$0++)
            writeChunk(destination, viewportChunks[i$jscomp$0]);
          viewportChunks.length = 0;
          renderState.fontPreloads.forEach(flushResource, destination);
          renderState.fontPreloads.clear();
          renderState.highImagePreloads.forEach(flushResource, destination);
          renderState.highImagePreloads.clear();
          renderState.styles.forEach(flushStylesInPreamble, destination);
          var importMapChunks = renderState.importMapChunks;
          for (i$jscomp$0 = 0; i$jscomp$0 < importMapChunks.length; i$jscomp$0++)
            writeChunk(destination, importMapChunks[i$jscomp$0]);
          importMapChunks.length = 0;
          renderState.bootstrapScripts.forEach(flushResource, destination);
          renderState.scripts.forEach(flushResource, destination);
          renderState.scripts.clear();
          renderState.bulkPreloads.forEach(flushResource, destination);
          renderState.bulkPreloads.clear();
          var hoistableChunks = renderState.hoistableChunks;
          for (i$jscomp$0 = 0; i$jscomp$0 < hoistableChunks.length; i$jscomp$0++)
            writeChunk(destination, hoistableChunks[i$jscomp$0]);
          for (renderState = hoistableChunks.length = 0; renderState < completedPreambleSegments.length; renderState++) {
            var segments = completedPreambleSegments[renderState];
            for (preamble = 0; preamble < segments.length; preamble++)
              flushSegment(request, destination, segments[preamble], null);
          }
          var preamble$jscomp$0 = request.renderState.preamble, headChunks$jscomp$0 = preamble$jscomp$0.headChunks;
          (preamble$jscomp$0.htmlChunks || headChunks$jscomp$0) && writeChunk(destination, endChunkForTag("head"));
          var bodyChunks = preamble$jscomp$0.bodyChunks;
          if (bodyChunks)
            for (completedPreambleSegments = 0; completedPreambleSegments < bodyChunks.length; completedPreambleSegments++)
              writeChunk(destination, bodyChunks[completedPreambleSegments]);
          flushSegment(request, destination, completedRootSegment, null);
          request.completedRootSegment = null;
          writeBootstrap(destination, request.renderState);
        }
        var renderState$jscomp$0 = request.renderState;
        completedRootSegment = 0;
        var viewportChunks$jscomp$0 = renderState$jscomp$0.viewportChunks;
        for (completedRootSegment = 0; completedRootSegment < viewportChunks$jscomp$0.length; completedRootSegment++)
          writeChunk(destination, viewportChunks$jscomp$0[completedRootSegment]);
        viewportChunks$jscomp$0.length = 0;
        renderState$jscomp$0.preconnects.forEach(flushResource, destination);
        renderState$jscomp$0.preconnects.clear();
        renderState$jscomp$0.fontPreloads.forEach(flushResource, destination);
        renderState$jscomp$0.fontPreloads.clear();
        renderState$jscomp$0.highImagePreloads.forEach(
          flushResource,
          destination
        );
        renderState$jscomp$0.highImagePreloads.clear();
        renderState$jscomp$0.styles.forEach(preloadLateStyles, destination);
        renderState$jscomp$0.scripts.forEach(flushResource, destination);
        renderState$jscomp$0.scripts.clear();
        renderState$jscomp$0.bulkPreloads.forEach(flushResource, destination);
        renderState$jscomp$0.bulkPreloads.clear();
        var hoistableChunks$jscomp$0 = renderState$jscomp$0.hoistableChunks;
        for (completedRootSegment = 0; completedRootSegment < hoistableChunks$jscomp$0.length; completedRootSegment++)
          writeChunk(destination, hoistableChunks$jscomp$0[completedRootSegment]);
        hoistableChunks$jscomp$0.length = 0;
        var clientRenderedBoundaries = request.clientRenderedBoundaries;
        for (i = 0; i < clientRenderedBoundaries.length; i++) {
          var boundary = clientRenderedBoundaries[i];
          renderState$jscomp$0 = destination;
          var resumableState = request.resumableState, renderState$jscomp$1 = request.renderState, id = boundary.rootSegmentID, errorDigest = boundary.errorDigest;
          writeChunk(
            renderState$jscomp$0,
            renderState$jscomp$1.startInlineScript
          );
          0 === (resumableState.instructions & 4) ? (resumableState.instructions |= 4, writeChunk(renderState$jscomp$0, clientRenderScript1Full)) : writeChunk(renderState$jscomp$0, clientRenderScript1Partial);
          writeChunk(renderState$jscomp$0, renderState$jscomp$1.boundaryPrefix);
          writeChunk(renderState$jscomp$0, stringToChunk(id.toString(16)));
          writeChunk(renderState$jscomp$0, clientRenderScript1A);
          errorDigest && (writeChunk(
            renderState$jscomp$0,
            clientRenderErrorScriptArgInterstitial
          ), writeChunk(
            renderState$jscomp$0,
            stringToChunk(
              escapeJSStringsForInstructionScripts(errorDigest || "")
            )
          ));
          var JSCompiler_inline_result = writeChunkAndReturn(
            renderState$jscomp$0,
            clientRenderScriptEnd
          );
          if (!JSCompiler_inline_result) {
            request.destination = null;
            i++;
            clientRenderedBoundaries.splice(0, i);
            return;
          }
        }
        clientRenderedBoundaries.splice(0, i);
        var completedBoundaries = request.completedBoundaries;
        for (i = 0; i < completedBoundaries.length; i++)
          if (!flushCompletedBoundary(request, destination, completedBoundaries[i])) {
            request.destination = null;
            i++;
            completedBoundaries.splice(0, i);
            return;
          }
        completedBoundaries.splice(0, i);
        completeWriting(destination);
        currentView = new Uint8Array(2048);
        writtenBytes = 0;
        var partialBoundaries = request.partialBoundaries;
        for (i = 0; i < partialBoundaries.length; i++) {
          var boundary$51 = partialBoundaries[i];
          a: {
            clientRenderedBoundaries = request;
            boundary = destination;
            var completedSegments = boundary$51.completedSegments;
            for (JSCompiler_inline_result = 0; JSCompiler_inline_result < completedSegments.length; JSCompiler_inline_result++)
              if (!flushPartiallyCompletedSegment(
                clientRenderedBoundaries,
                boundary,
                boundary$51,
                completedSegments[JSCompiler_inline_result]
              )) {
                JSCompiler_inline_result++;
                completedSegments.splice(0, JSCompiler_inline_result);
                var JSCompiler_inline_result$jscomp$0 = false;
                break a;
              }
            completedSegments.splice(0, JSCompiler_inline_result);
            JSCompiler_inline_result$jscomp$0 = writeHoistablesForBoundary(
              boundary,
              boundary$51.contentState,
              clientRenderedBoundaries.renderState
            );
          }
          if (!JSCompiler_inline_result$jscomp$0) {
            request.destination = null;
            i++;
            partialBoundaries.splice(0, i);
            return;
          }
        }
        partialBoundaries.splice(0, i);
        var largeBoundaries = request.completedBoundaries;
        for (i = 0; i < largeBoundaries.length; i++)
          if (!flushCompletedBoundary(request, destination, largeBoundaries[i])) {
            request.destination = null;
            i++;
            largeBoundaries.splice(0, i);
            return;
          }
        largeBoundaries.splice(0, i);
      }
    } finally {
      0 === request.allPendingTasks && 0 === request.pingedTasks.length && 0 === request.clientRenderedBoundaries.length && 0 === request.completedBoundaries.length ? (request.flushScheduled = false, i = request.resumableState, i.hasBody && writeChunk(destination, endChunkForTag("body")), i.hasHtml && writeChunk(destination, endChunkForTag("html")), completeWriting(destination), request.status = 14, destination.close(), request.destination = null) : completeWriting(destination);
    }
  }
  function startWork(request) {
    request.flushScheduled = null !== request.destination;
    scheduleMicrotask(function() {
      return performWork(request);
    });
    scheduleWork(function() {
      10 === request.status && (request.status = 11);
      null === request.trackedPostpones && safelyEmitEarlyPreloads(request, 0 === request.pendingRootTasks);
    });
  }
  function enqueueFlush(request) {
    false === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = true, scheduleWork(function() {
      var destination = request.destination;
      destination ? flushCompletedQueues(request, destination) : request.flushScheduled = false;
    }));
  }
  function startFlowing(request, destination) {
    if (13 === request.status)
      request.status = 14, closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
      request.destination = destination;
      try {
        flushCompletedQueues(request, destination);
      } catch (error) {
        logRecoverableError(request, error, {}), fatalError(request, error);
      }
    }
  }
  function abort(request, reason) {
    if (11 === request.status || 10 === request.status) request.status = 12;
    try {
      var abortableTasks = request.abortableTasks;
      if (0 < abortableTasks.size) {
        var error = void 0 === reason ? Error(formatProdErrorMessage(432)) : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error(formatProdErrorMessage(530)) : reason;
        request.fatalError = error;
        abortableTasks.forEach(function(task) {
          return abortTask(task, request, error);
        });
        abortableTasks.clear();
      }
      null !== request.destination && flushCompletedQueues(request, request.destination);
    } catch (error$53) {
      logRecoverableError(request, error$53, {}), fatalError(request, error$53);
    }
  }
  function ensureCorrectIsomorphicReactVersion() {
    var isomorphicReactPackageVersion = React2.version;
    if ("19.1.0" !== isomorphicReactPackageVersion)
      throw Error(
        formatProdErrorMessage(
          527,
          isomorphicReactPackageVersion,
          "19.1.0"
        )
      );
  }
  ensureCorrectIsomorphicReactVersion();
  ensureCorrectIsomorphicReactVersion();
  reactDomServer_browser_production.prerender = function(children, options) {
    return new Promise(function(resolve, reject) {
      var onHeaders = options ? options.onHeaders : void 0, onHeadersImpl;
      onHeaders && (onHeadersImpl = function(headersDescriptor) {
        onHeaders(new Headers(headersDescriptor));
      });
      var resources = createResumableState(
        options ? options.identifierPrefix : void 0,
        options ? options.unstable_externalRuntimeSrc : void 0,
        options ? options.bootstrapScriptContent : void 0,
        options ? options.bootstrapScripts : void 0,
        options ? options.bootstrapModules : void 0
      ), request = createPrerenderRequest(
        children,
        resources,
        createRenderState(
          resources,
          void 0,
          options ? options.unstable_externalRuntimeSrc : void 0,
          options ? options.importMap : void 0,
          onHeadersImpl,
          options ? options.maxHeadersLength : void 0
        ),
        createRootFormatContext(options ? options.namespaceURI : void 0),
        options ? options.progressiveChunkSize : void 0,
        options ? options.onError : void 0,
        function() {
          var result = {
            prelude: new ReadableStream(
              {
                type: "bytes",
                pull: function(controller) {
                  startFlowing(request, controller);
                },
                cancel: function(reason) {
                  request.destination = null;
                  abort(request, reason);
                }
              },
              { highWaterMark: 0 }
            )
          };
          resolve(result);
        },
        void 0,
        void 0,
        reject,
        options ? options.onPostpone : void 0
      );
      if (options && options.signal) {
        var signal = options.signal;
        if (signal.aborted) abort(request, signal.reason);
        else {
          var listener = function() {
            abort(request, signal.reason);
            signal.removeEventListener("abort", listener);
          };
          signal.addEventListener("abort", listener);
        }
      }
      startWork(request);
    });
  };
  reactDomServer_browser_production.renderToReadableStream = function(children, options) {
    return new Promise(function(resolve, reject) {
      var onFatalError, onAllReady, allReady = new Promise(function(res, rej) {
        onAllReady = res;
        onFatalError = rej;
      }), onHeaders = options ? options.onHeaders : void 0, onHeadersImpl;
      onHeaders && (onHeadersImpl = function(headersDescriptor) {
        onHeaders(new Headers(headersDescriptor));
      });
      var resumableState = createResumableState(
        options ? options.identifierPrefix : void 0,
        options ? options.unstable_externalRuntimeSrc : void 0,
        options ? options.bootstrapScriptContent : void 0,
        options ? options.bootstrapScripts : void 0,
        options ? options.bootstrapModules : void 0
      ), request = createRequest(
        children,
        resumableState,
        createRenderState(
          resumableState,
          options ? options.nonce : void 0,
          options ? options.unstable_externalRuntimeSrc : void 0,
          options ? options.importMap : void 0,
          onHeadersImpl,
          options ? options.maxHeadersLength : void 0
        ),
        createRootFormatContext(options ? options.namespaceURI : void 0),
        options ? options.progressiveChunkSize : void 0,
        options ? options.onError : void 0,
        onAllReady,
        function() {
          var stream = new ReadableStream(
            {
              type: "bytes",
              pull: function(controller) {
                startFlowing(request, controller);
              },
              cancel: function(reason) {
                request.destination = null;
                abort(request, reason);
              }
            },
            { highWaterMark: 0 }
          );
          stream.allReady = allReady;
          resolve(stream);
        },
        function(error) {
          allReady.catch(function() {
          });
          reject(error);
        },
        onFatalError,
        options ? options.onPostpone : void 0,
        options ? options.formState : void 0
      );
      if (options && options.signal) {
        var signal = options.signal;
        if (signal.aborted) abort(request, signal.reason);
        else {
          var listener = function() {
            abort(request, signal.reason);
            signal.removeEventListener("abort", listener);
          };
          signal.addEventListener("abort", listener);
        }
      }
      startWork(request);
    });
  };
  reactDomServer_browser_production.version = "19.1.0";
  return reactDomServer_browser_production;
}
var hasRequiredServer_browser;
function requireServer_browser() {
  if (hasRequiredServer_browser) return server_browser;
  hasRequiredServer_browser = 1;
  var l, s;
  {
    l = requireReactDomServerLegacy_browser_production();
    s = requireReactDomServer_browser_production();
  }
  server_browser.version = l.version;
  server_browser.renderToString = l.renderToString;
  server_browser.renderToStaticMarkup = l.renderToStaticMarkup;
  server_browser.renderToReadableStream = s.renderToReadableStream;
  if (s.resume) {
    server_browser.resume = s.resume;
  }
  return server_browser;
}
var server_browserExports = requireServer_browser();
const MarkerImage = "/assets/Marker.png";
const CurrentOrderImage = "/assets/Current-order-star.gif";
const RecentOrderImage = "/assets/RecentMarker.gif";
const DaysoftLogoImage = "/assets/daysoft-logo.png";
const CloseMenuIcon = "/assets/Close-menu.svg";
const OpenMenuIcon = "/assets/Open-menu.svg";
const staticContext = reactExports.createContext();
function StaticContextProvider({ children }) {
  let data;
  if (window == null ? void 0 : window.Shopify) {
    const ele = document.querySelector("#map-static-data");
    data = JSON.parse(ele.textContent);
  } else {
    data = {
      MarkerImage,
      CurrentOrderImage,
      RecentOrderImage,
      DaysoftLogoImage,
      CloseMenuIcon,
      OpenMenuIcon
    };
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(staticContext.Provider, { value: data, children });
}
function useStaticContext() {
  const context = reactExports.useContext(staticContext);
  if (!context) {
    throw new Error("useMarkersContext must be used within a MarkersContextProvider");
  }
  return context;
}
class TranslationMissing extends Error {
  constructor(message = "", ...args) {
    super(message, ...args);
    this.name = "Translation Missing";
    this.message = `${message} is missing from the translation`;
  }
}
function Translator(translations) {
  return (translationKey, replaces) => {
    let translation = "";
    if (translations) {
      if (translationKey.includes(".")) {
        const splitKey = translationKey.split(".");
        translation = splitKey.reduce((prev, cur) => {
          var _a;
          let item = prev[cur];
          if (!item || ((_a = Object.keys(item)) == null ? void 0 : _a.length) == 0) {
            item = "";
          }
          return item;
        }, translations);
      } else {
        translation = translations[translationKey];
      }
      if (replaces && translation.length > 0) {
        Object.entries(replaces).forEach(([replaceStr, value]) => {
          translation = translation.replaceAll(`##${replaceStr}##`, value);
        });
      }
      if (translation == null ? void 0 : translation.includes("&")) {
        translation = decodeXML(translation);
      }
    }
    if (translation || (translation == null ? void 0 : translation.length) > 0) {
      return translation;
    } else {
      console.error(new TranslationMissing(translationKey));
    }
  };
}
function decodeXML(inputStr) {
  let items = [
    { search: "&quot;", replace: '"' },
    { search: "&amp;", replace: "&" },
    { search: "&gt;", replace: ">" },
    { search: "&lt;", replace: "<" },
    { search: "&#39;", replace: "'" }
  ];
  let outputStr = inputStr;
  items.forEach((item) => {
    outputStr = outputStr.replaceAll(item.search, item.replace);
  });
  return outputStr;
}
const translationContext = reactExports.createContext();
function TranslationContextProvider({ children }) {
  const ele = document.querySelector("#map-translation-data");
  let decodedTranslations = ele.textContent.trim().replaceAll("\\u0026", "&").replace(/&quot;/g, '"').replace(/=&gt;/g, ":").replace(/&#39;/g, "'");
  decodedTranslations = decodedTranslations.substr(1, decodedTranslations.length - 2);
  const translations = JSON.parse(decodedTranslations);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(translationContext.Provider, { value: {
    getTranslation: Translator(translations),
    translations
  }, children });
}
function useTranslationContext() {
  const context = reactExports.useContext(translationContext);
  if (!context) {
    throw new Error("useMarkersContext must be used within a MarkersContextProvider");
  }
  return context;
}
const createClusterCustomIcon = (cluster) => {
  const markerCount = cluster.getAllChildMarkers().reduce((acc, cur) => {
    var _a;
    acc += ((_a = cur.options) == null ? void 0 : _a.pointCount) || 1;
    return acc;
  }, 0);
  let clusterClass;
  let iconConfig;
  if (markerCount >= 100) {
    clusterClass = "cluster-large";
    iconConfig = markerObjs["cluster_large"].iconConfig;
  } else {
    clusterClass = "cluster-small";
    iconConfig = markerObjs["cluster_small"].iconConfig;
  }
  return leafletSrcExports.divIcon({
    html: `<span style="font-size: 11px; font-weight: 700;"></span>`,
    className: "custom-cluster-icon " + clusterClass,
    iconSize: iconConfig.iconSize,
    iconAnchor: iconConfig.iconAnchor
  });
};
const mcg = new L$1.MarkerClusterGroup({ chunkedLoading: true, maxClusterRadius: 10, iconCreateFunction: createClusterCustomIcon, spiderfyOnMaxZoom: false });
const markersLayer = new L$1.LayerGroup();
const MarkerCluster = () => {
  const { clustering, markers, setLoading, hasFetched, dataTime } = useMarkersContext();
  const staticData = useStaticContext();
  const { getTranslation } = useTranslationContext();
  const map = useMap();
  const url = new URL(location);
  const params = Object.fromEntries(url.searchParams.entries());
  performance.mark("MarkerCluster|Start");
  reactExports.useEffect(() => {
    console.log("MarkerCluster Loaded");
    return () => {
      console.log("MarkerCluster Unloaded");
    };
  }, []);
  function openCurrentOrder(item, ev, abort) {
    if (abort.signal.aborted || !(item == null ? void 0 : item.order_id)) {
      return;
    }
    if ((item == null ? void 0 : item.order_id) === params.order_id || (item == null ? void 0 : item.order_id) === params.anon_oid) {
      map.setView(ev.sourceTarget._latlng, 5);
      map.openPopup(ev.sourceTarget._popup, ev.sourceTarget._latlng);
    }
  }
  reactExports.useEffect(() => {
    console.log({ markers });
    mcg.clearLayers();
    markersLayer.clearLayers();
    const abort = new AbortController();
    if (clustering) {
      const filteredMarkers = [];
      const recentMarkers = [];
      markers.forEach((item) => {
        const mark = Marker(item, params, staticData, getTranslation).on("add", (ev) => {
          openCurrentOrder(item, ev, abort);
          setLoading(false);
        });
        if (item.recent == true || item.order_id) {
          recentMarkers.push(mark);
        } else {
          filteredMarkers.push(mark);
        }
      });
      mcg.addLayers(filteredMarkers);
      recentMarkers.forEach((item) => {
        item.addTo(markersLayer);
      });
    } else {
      markers.forEach((item) => {
        Marker(item, params, staticData, getTranslation).on("add", (ev) => {
          openCurrentOrder(item, ev, abort);
          setLoading(false);
        }).addTo(markersLayer);
      });
    }
    map.addLayer(mcg);
    map.addLayer(markersLayer);
    let nocontentTimeout;
    nocontentTimeout = setTimeout(() => {
      if (markers.length == 0 && hasFetched) {
        console.log("cluster rendered");
        let iconConfig = { ...markerObjs.default.iconConfig };
        iconConfig.iconUrl = staticData[iconConfig.iconUrl];
        iconConfig = leafletSrcExports.icon(iconConfig);
        L$1.marker(map.getCenter(), { icon: iconConfig }).bindPopup(noContentPopup(getTranslation)).on("add", (ev) => {
          if (abort.signal.aborted) {
            return;
          }
          map.setView(ev.sourceTarget._latlng, 5);
          map.openPopup(ev.sourceTarget._popup, ev.sourceTarget._latlng);
          setLoading(false);
        }).addTo(markersLayer).addTo(mcg);
      }
    }, 1e3);
    return () => {
      mcg.clearLayers();
      markersLayer.clearLayers();
      setLoading(true);
      clearTimeout(nocontentTimeout);
    };
  }, [map, clustering, hasFetched, markers.length, dataTime]);
  return "";
};
function Marker(item, params, staticData, getTranslation) {
  let markerZIndex = 0;
  let iconConfig = { ...markerObjs.default.iconConfig };
  if (iconConfig.iconUrl) {
    iconConfig.iconUrl = staticData[iconConfig.iconUrl];
  }
  iconConfig = leafletSrcExports.divIcon(iconConfig);
  if (item.pointCount >= 100) {
    iconConfig = { ...markerObjs.cluster_large.iconConfig };
    if (iconConfig.iconUrl) {
      iconConfig.iconUrl = staticData[iconConfig.iconUrl];
    }
    iconConfig = leafletSrcExports.divIcon(iconConfig);
  }
  if (item.recent == true) {
    iconConfig = { ...markerObjs.recent.iconConfig };
    iconConfig.iconUrl = staticData[iconConfig.iconUrl];
    markerZIndex = 1e3;
    iconConfig = leafletSrcExports.icon(iconConfig);
  }
  if (item.order_id) {
    item.currentOrder = true;
    iconConfig = { ...markerObjs.currentOrder.iconConfig };
    iconConfig.iconUrl = staticData[iconConfig.iconUrl];
    markerZIndex = 1e3;
    iconConfig = leafletSrcExports.icon(iconConfig);
  }
  const outputMarker = L$1.marker(new L$1.latLng(item.latitude, item.longitude), { icon: iconConfig, zIndexOffset: markerZIndex, color: (item == null ? void 0 : item.color) || "green", pointCount: item.pointCount });
  const popup = popupContent(item, getTranslation);
  if (popup !== "") {
    outputMarker.bindPopup(popup);
  }
  return outputMarker;
}
function noContentPopup(getTranslation) {
  return server_browserExports.renderToString(
    /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: getTranslation("no_order_message") }) }) })
  );
}
function popupContent(item, getTranslation) {
  if (!(item == null ? void 0 : item.order_id)) {
    return "";
  }
  const orderDate = item.order_date && new Date(item.order_date) || "";
  const localString = orderDate && orderDate.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true
    // Show time in 12-hour format
  });
  return server_browserExports.renderToString(
    /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: item == null ? void 0 : item.order_id }) }),
      orderDate && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: getTranslation("order_date") }),
        " ",
        localString,
        " "
      ] })
    ] })
  );
}
function classNames(...classes) {
  const classObj = classes.reduce((prev, cur) => {
    if (typeof cur === "array") {
      prev = {
        ...prev,
        ...cur.map((item) => {
          return true;
        })
      };
    }
    if (typeof cur === "string") {
      prev[cur] = true;
    }
    if (typeof cur === "object") {
      prev = { ...prev, ...cur };
    }
    return prev;
  }, {});
  return Object.entries(classObj).reduce((prev, [key, enabled]) => {
    if (enabled) {
      prev.push(key);
    }
    return prev;
  }, []).join(" ");
}
function MapOverlays() {
  const { getTranslation } = useTranslationContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ZoomControl, { position: "topleft" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(MapLegend, { className: "map-overlay map-overlay--bottom-left", title: getTranslation("map_legend_title_attr") }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(MapAttribution, { linkUrl: "/pages/terms-conditions#help-anchor-links:~:text=Acknowledgements", linkText: getTranslation("map_attribution_text") })
  ] });
}
function MapLegend({ className, title, ...props }) {
  const { getTranslation } = useTranslationContext();
  const { currentOrderId } = useMarkersContext();
  const staticData = useStaticContext();
  const [legendOpen, setLegendOpen] = reactExports.useState(true);
  const state = legendOpen ? getTranslation("hide_state") || "hide" : getTranslation("show_state") || "show";
  const classes = classNames(
    "map-legend",
    { "map-legend--open": legendOpen },
    className
  );
  function ClusterPoint({ iconConfig }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: classNames(
          "map-legend__marker__icon",
          iconConfig.className
        ),
        style: {
          outlineStyle: "none"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {
          fontSize: 11,
          fontWeight: 700,
          color: "black"
        }, children: iconConfig.html })
      }
    );
  }
  function handleToggleOpen() {
    setLegendOpen((bool) => !bool);
  }
  function OpenToggleButton({ ...options }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("button", { title: title.replace("#state#", state), className: "map-legend__open-toggle", type: "button", onClick: handleToggleOpen, children: [
      !legendOpen && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: staticData["OpenMenuIcon"] }),
      legendOpen && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: staticData["CloseMenuIcon"] })
    ] });
  }
  function LegendOpenContent({ ...options }) {
    const legendEntries = Object.entries(markerObjs).map(([key, obj], idx) => {
      var _a, _b;
      if (["default", "cluster_medium"].includes(key)) {
        return "";
      }
      if (key == "currentOrder" && !currentOrderId) {
        return "";
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `map-legend__marker map-legend__marker--${key.toLowerCase()}`, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "map-legend__legent-icon-wrapper", children: [
          ((_a = obj.iconConfig) == null ? void 0 : _a.iconUrl) && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "map-legend__marker__icon", src: staticData[obj.iconConfig.iconUrl] }),
          !((_b = obj.iconConfig) == null ? void 0 : _b.iconUrl) && /* @__PURE__ */ jsxRuntimeExports.jsx(ClusterPoint, { iconConfig: obj.iconConfig })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "map-legend__marker__name", children: getTranslation(obj.name) })
      ] }, idx);
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "map-legend__title-container", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "map-legend__title", children: getTranslation("map_legend_title") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(OpenToggleButton, {})
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "map-legend__legend-content", children: legendEntries })
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classes, children: !legendOpen ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "map-legend__title-container", children: /* @__PURE__ */ jsxRuntimeExports.jsx(OpenToggleButton, {}) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(LegendOpenContent, {}) }) });
}
function MapAttribution({ linkText, linkUrl }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: linkText && linkUrl && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "map-overlay map-overlay--attribution-position", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "map-overlay__attribution", children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: linkUrl, rel: "noopener", target: "_blank", children: linkText }) }) }) });
}
const mobileBreakpoint = 768;
function Map$1({ ...options }) {
  const { mapTile, loading } = useMarkersContext();
  const mapCenter = options.center || window.innerWidth < mobileBreakpoint ? [48.13833724118372, 6.020507812500001] : [21.965073979103778, 8.798147435924752];
  const mapZoom = 3;
  const orderNumber = options.orderNumber || false;
  const maxZoom = orderNumber ? 13 : 6;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    MapContainer,
    {
      center: mapCenter,
      zoomControl: false,
      zoom: mapZoom,
      minZoom: 3,
      maxZoom,
      attributionControl: false,
      maxBoundsViscosity: 1,
      maxBounds: [
        [90, -180],
        [-90, 180]
      ],
      style: {
        minHeight: 300,
        height: "100%",
        width: "100%"
      },
      children: [
        loading && /* @__PURE__ */ jsxRuntimeExports.jsx(Loading, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(MapReactUtils, {}),
        mapTile.isLeafletTile ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          TileLayer,
          {
            attribution: mapTile.attribution,
            url: mapTile.url
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(MapLibreGL, { style: mapTile.style }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(MapOverlays, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(MarkerCluster, {})
      ]
    }
  );
}
function MapLibreGL({ style } = { style: "https://tiles.openfreemap.org/styles/liberty" }) {
  const map = useMap();
  reactExports.useEffect(() => {
    const mapTile = L.maplibreGL({
      style
    });
    mapTile.addTo(map);
    return () => {
      map.removeLayer(mapTile);
    };
  }, []);
  return "";
}
function MapReactUtils() {
  const map = useMap();
  reactExports.useEffect(() => {
    resizeFunc();
    window.addEventListener("resize", resizeFunc);
    return () => {
      window.removeEventListener("resize", resizeFunc);
    };
  }, []);
  let timeoutID;
  const resizeFunc = () => {
    const mapContainer = map.getContainer();
    if (mapContainer.parentElement) {
      mapContainer.style.height = "";
      requestAnimationFrame(() => {
        let headerHeight = 0;
        if (mapContainer.style.height <= 600) {
          headerHeight = Array.from(document.querySelectorAll("#shopify-section-announcement-bar, #shopify-section-header")).reduce((prev, cur) => {
            return prev + cur.getBoundingClientRect().height;
          }, 0);
          console.log({ headerHeight });
        }
        mapContainer.style.height = window.innerHeight - headerHeight * 2 + "px";
      });
    }
    timeoutID = setTimeout(() => {
      map.invalidateSize();
      clearTimeout(timeoutID);
    }, 100);
  };
  return null;
}
function App() {
  const [loading, setLoading] = reactExports.useState(true);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TranslationContextProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StaticContextProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(MarkersContextProvider, { loading, setLoading, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Map$1, {}) }) }) });
}
function Loading() {
  const LoadingImage = "data:image/gif;base64,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";
  const { getTranslation } = useTranslationContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "loading-screen", style: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(0, 0, 0, 0.3)",
    zIndex: 800
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: LoadingImage, style: { width: 100, height: 100 } }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { opacity: 0, position: "absolute" }, children: getTranslation("loading_message") })
  ] }) });
}
clientExports.createRoot(document.getElementById("map-root")).render(
  /* @__PURE__ */ jsxRuntimeExports.jsx(reactExports.StrictMode, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(App, {}) })
);
